
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("79vw2", function(module, exports) {

var $99WQy = parcelRequire("99WQy");
const $e4034aced29ead60$export$e1226a5e0bbbf862 = (jsonLd)=>{
    if (jsonLd['schema:dateCreated']) return jsonLd['schema:dateCreated'];
    return undefined;
};


var $dsdUb = parcelRequire("dsdUb");

var $l6lJr = parcelRequire("l6lJr");

var $9WUug = parcelRequire("9WUug");

var $4sK6R = parcelRequire("4sK6R");

var $ccQw1 = parcelRequire("ccQw1");

var $hUifo = parcelRequire("hUifo");


var $9JHBV = parcelRequire("9JHBV");


var $lyclm = parcelRequire("lyclm");

const $56d3cb5a2f4b0466$export$3eda18658b66108 = (response, removeTextHighlightingFromTitle)=>{
    if ((0, $lyclm.isEntityPresent)(response)) return (0, $lyclm.extractEntity)(response)?.displayName;
    return (0, $hUifo.extractTitle)(response?.data, removeTextHighlightingFromTitle);
};
const $56d3cb5a2f4b0466$export$7ba9b12c6a1b73de = (response)=>{
    if ((0, $lyclm.isEntityPresent)(response)) return (0, $lyclm.extractEntity)(response)?.url;
    return (0, $l6lJr.extractLink)(response?.data);
};
const $56d3cb5a2f4b0466$export$16b02be3e2bb31ad = (response)=>{
    if ((0, $lyclm.isEntityPresent)(response)) return (0, $lyclm.extractEntity)(response)?.ari || (0, $lyclm.extractEntity)(response)?.thirdPartyAri;
    const data = response?.data;
    return (0, $99WQy.extractAri)(data);
};
const $56d3cb5a2f4b0466$export$864b719baf5d744d = (response, iframeUrlType)=>{
    if ((0, $lyclm.isEntityPresent)(response)) {
        // TODO: Missing iframeUrlType
        const embedUrl = (0, $lyclm.extractEntityEmbedUrl)(response);
        return embedUrl ? {
            src: embedUrl
        } : undefined;
    }
    return (0, $9JHBV.extractPreview)(response?.data, 'web', iframeUrlType);
};
const $56d3cb5a2f4b0466$export$ff753ed519e96e9e = (response)=>{
    if ((0, $lyclm.isEntityPresent)(response)) return (0, $lyclm.extractEntityProvider)(response);
    return response?.data && (0, $ccQw1.extractProvider)(response?.data);
};
const $56d3cb5a2f4b0466$export$7a685df468cbf38f = (response)=>{
    if ((0, $lyclm.isEntityPresent)(response)) return (0, $lyclm.extractEntity)(response)?.createdAt;
    return response?.data && (0, $e4034aced29ead60$export$e1226a5e0bbbf862)(response.data);
};
const $56d3cb5a2f4b0466$export$75047940e157fd1f = (response)=>{
    if ((0, $lyclm.isEntityPresent)(response)) return (0, $lyclm.extractEntity)(response)?.lastUpdatedAt;
    return response?.data && (0, $dsdUb.extractDateUpdated)(response.data);
};
const $56d3cb5a2f4b0466$export$242875b46118beb2 = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $lyclm.isEntityPresent)(response)) return (0, $lyclm.extractEntity)(response)?.createdBy?.displayName;
    const persons = (0, $9WUug.extractPersonCreatedBy)(response.data);
    return !!persons?.length ? persons[0].name : undefined;
};
const $56d3cb5a2f4b0466$export$41fc716e1bc2dc90 = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $lyclm.isEntityPresent)(response)) {
        const entity = (0, $lyclm.extractEntity)(response);
        const owners = entity?.owners;
        if (owners) return owners.map((owner)=>({
                name: owner.displayName,
                src: owner.picture
            })).filter((item)=>!!item);
    }
    return (0, $9WUug.extractPersonCreatedBy)(response.data);
};
const $56d3cb5a2f4b0466$export$7f099a839071a190 = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $lyclm.isEntityPresent)(response)) return (0, $lyclm.extractEntity)(response)?.lastUpdatedBy?.displayName;
    const person = (0, $4sK6R.extractPersonUpdatedBy)(response.data);
    return person ? person.name : undefined;
};
const $56d3cb5a2f4b0466$export$96ed4c1b14ac210a = (response)=>{
    if ((0, $lyclm.isEntityPresent)(response)) {
        const entity = (0, $lyclm.extractEntity)(response);
        return entity && 'exportLinks' in entity && Array.isArray(entity.exportLinks) && entity.exportLinks.length > 0 ? entity?.exportLinks?.[0].url : undefined;
    }
    return response?.data?.['atlassian:downloadUrl'];
};
module.exports["extractSmartLinkTitle"] = $56d3cb5a2f4b0466$export$3eda18658b66108;
module.exports["extractSmartLinkUrl"] = $56d3cb5a2f4b0466$export$7ba9b12c6a1b73de;
module.exports["extractSmartLinkAri"] = $56d3cb5a2f4b0466$export$16b02be3e2bb31ad;
module.exports["extractSmartLinkEmbed"] = $56d3cb5a2f4b0466$export$864b719baf5d744d;
module.exports["extractSmartLinkProvider"] = $56d3cb5a2f4b0466$export$ff753ed519e96e9e;
module.exports["extractSmartLinkCreatedOn"] = $56d3cb5a2f4b0466$export$7a685df468cbf38f;
module.exports["extractSmartLinkModifiedOn"] = $56d3cb5a2f4b0466$export$75047940e157fd1f;
module.exports["extractSmartLinkCreatedBy"] = $56d3cb5a2f4b0466$export$242875b46118beb2;
module.exports["extractSmartLinkAuthorGroup"] = $56d3cb5a2f4b0466$export$41fc716e1bc2dc90;
module.exports["extractSmartLinkModifiedBy"] = $56d3cb5a2f4b0466$export$7f099a839071a190;
module.exports["extractSmartLinkDownloadUrl"] = $56d3cb5a2f4b0466$export$96ed4c1b14ac210a;

});

parcelRegister("99WQy", function(module, exports) {
const $7b9cf113c389991e$export$be18a6294fd426ec = (jsonLd)=>{
    if (jsonLd['atlassian:ari']) return jsonLd['atlassian:ari'];
    return undefined;
};
module.exports["extractAri"] = $7b9cf113c389991e$export$be18a6294fd426ec;

});

parcelRegister("dsdUb", function(module, exports) {
const $d35ebe54446110dc$export$7fc2f5e6f9d22ae7 = (jsonLd)=>{
    if (jsonLd.updated) return jsonLd.updated;
    return undefined;
};
module.exports["extractDateUpdated"] = $d35ebe54446110dc$export$7fc2f5e6f9d22ae7;

});

parcelRegister("l6lJr", function(module, exports) {

var $kzBLz = parcelRequire("kzBLz");

const $d3adf1d8ff29df55$export$63f54cf4c5883620 = (jsonLd)=>{
    const url = jsonLd?.url;
    if (url) {
        if (typeof url === 'string') return url;
        else return (0, $kzBLz.extractUrlFromLinkJsonLd)(url);
    }
    return undefined;
};
module.exports["extractLink"] = $d3adf1d8ff29df55$export$63f54cf4c5883620;

});

parcelRegister("kzBLz", function(module, exports) {
const $8554b737f5c5cb14$export$396ba4ef2e37dc65 = (link)=>{
    if (typeof link === 'string') return link;
    else if (Array.isArray(link)) {
        if (link.length > 0) return $8554b737f5c5cb14$export$396ba4ef2e37dc65(link[0]);
    } else return link.href;
    return undefined;
};
module.exports["extractUrlFromLinkJsonLd"] = $8554b737f5c5cb14$export$396ba4ef2e37dc65;

});

parcelRegister("9WUug", function(module, exports) {

var $kzSaQ = parcelRequire("kzSaQ");

const $7710b1270e0d3189$export$a66235cba0c9d11a = (jsonLd)=>{
    const attributedTo = jsonLd.attributedTo;
    if (attributedTo) {
        if (Array.isArray(attributedTo)) return attributedTo.map((0, $kzSaQ.extractPersonFromJsonLd)).filter((item)=>!!item);
        else {
            const item = (0, $kzSaQ.extractPersonFromJsonLd)(attributedTo);
            if (item) return [
                item
            ];
        }
    }
    return undefined;
};
module.exports["extractPersonCreatedBy"] = $7710b1270e0d3189$export$a66235cba0c9d11a;

});

parcelRegister("kzSaQ", function(module, exports) {

var $8hlRK = parcelRequire("8hlRK");

const $141d786062a33a3a$export$c471ae5fddcf1392 = (person)=>{
    if (typeof person === 'string') throw Error('Link.person needs to be an object.');
    else if (person['@type'] === 'Link') {
        if (person.name) return {
            name: person.name
        };
    } else {
        if (person.name) return {
            name: person.name,
            src: person.icon && (0, $8hlRK.extractUrlFromIconJsonLd)(person.icon)
        };
    }
    return undefined;
};
module.exports["extractPersonFromJsonLd"] = $141d786062a33a3a$export$c471ae5fddcf1392;

});

parcelRegister("8hlRK", function(module, exports) {

var $kzBLz = parcelRequire("kzBLz");

const $15c3e8c19f3e9f93$export$67f3d92c824fd850 = (icon)=>{
    if (typeof icon === 'string') return icon;
    else if (icon['@type'] === 'Link') return (0, $kzBLz.extractUrlFromLinkJsonLd)(icon);
    else {
        if (icon.url) return (0, $kzBLz.extractUrlFromLinkJsonLd)(icon.url);
    }
    return undefined;
};
module.exports["extractUrlFromIconJsonLd"] = $15c3e8c19f3e9f93$export$67f3d92c824fd850;

});

parcelRegister("4sK6R", function(module, exports) {

var $kzSaQ = parcelRequire("kzSaQ");

const $120900a6e202ebd4$export$8a2d1ed7e6f336f0 = (jsonLd)=>{
    const updatedBy = jsonLd['atlassian:updatedBy'];
    if (updatedBy) return (0, $kzSaQ.extractPersonFromJsonLd)(updatedBy);
    return undefined;
};
module.exports["extractPersonUpdatedBy"] = $120900a6e202ebd4$export$8a2d1ed7e6f336f0;

});

parcelRegister("ccQw1", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $lAFHW = parcelRequire("lAFHW");





var $dh538 = parcelRequire("dh538");


var $3fvfu = parcelRequire("3fvfu");


var $8hlRK = parcelRequire("8hlRK");

var $kzBLz = parcelRequire("kzBLz");

const $56eab8749893649b$export$a832871718466647 = (jsonLd)=>{
    const generator = jsonLd.generator;
    if (generator) {
        if (typeof generator === 'string') throw Error('Link.generator requires a name and icon.');
        else if (generator['@type'] === 'Link') {
            if (generator.name) return {
                text: generator.name
            };
        } else if (generator.name) {
            const id = generator['@id'];
            return {
                text: generator.name,
                icon: $56eab8749893649b$export$6fb636a2ac885215(generator.icon, id),
                id: id,
                image: $56eab8749893649b$var$extractProviderImage(generator.image)
            };
        }
    }
    return undefined;
};
const $56eab8749893649b$export$6fb636a2ac885215 = (icon, id)=>{
    if (id) {
        if (id === (0, $3fvfu.CONFLUENCE_GENERATOR_ID)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.ConfluenceIcon), {
            appearance: "brand",
            size: "xxsmall",
            ...(0, $dh538.fg)('navx-1895-new-logo-design') ? {
                shouldUseNewLogoDesign: true
            } : undefined
        });
        else if (id === (0, $3fvfu.JIRA_GENERATOR_ID)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.JiraIcon), {
            appearance: "brand",
            size: "xxsmall",
            ...(0, $dh538.fg)('navx-1895-new-logo-design') ? {
                shouldUseNewLogoDesign: true
            } : undefined
        });
    }
    if (icon) return (0, $8hlRK.extractUrlFromIconJsonLd)(icon);
    return undefined;
};
const $56eab8749893649b$var$extractProviderImage = (image)=>{
    if (image) {
        if (typeof image === 'string') return image;
        else if (image['@type'] === 'Link') return (0, $kzBLz.extractUrlFromLinkJsonLd)(image);
        else if (image['@type'] === 'Image') {
            if (image.url) return (0, $kzBLz.extractUrlFromLinkJsonLd)(image.url);
        }
    }
    return undefined;
};
const $56eab8749893649b$export$38df542ff03a4183 = (id)=>{
    return id === (0, $3fvfu.CONFLUENCE_GENERATOR_ID);
};
module.exports["extractProvider"] = $56eab8749893649b$export$a832871718466647;
module.exports["extractProviderIcon"] = $56eab8749893649b$export$6fb636a2ac885215;
module.exports["isConfluenceGenerator"] = $56eab8749893649b$export$38df542ff03a4183;

});

parcelRegister("hUifo", function(module, exports) {

var $aliCf = parcelRequire("aliCf");


var $8hlRK = parcelRequire("8hlRK");

const $1aa29b094fdafad8$export$efdbd45f3e77a161 = (jsonLd)=>{
    const context = jsonLd.context;
    if (context) {
        if (typeof context === 'string') return {
            name: context
        };
        else if (context['@type'] === 'Link') {
            if (context.name) return {
                name: context.name
            };
        } else {
            if (context.name) return {
                name: context.name,
                icon: context.icon && (0, $8hlRK.extractUrlFromIconJsonLd)(context.icon),
                type: (0, $aliCf.extractType)(context)
            };
        }
    }
    return undefined;
};





const $ca558e6955be7d7f$export$b05803156e5015b6 = (jsonLd, removeTextHighlightingFromTitle)=>{
    if (!jsonLd) return undefined;
    const name = jsonLd.name?.replace(/[\r\n]+/g, '');
    const id = jsonLd['@id'] || '';
    // Check if this is a reference to something _inside_ a Repository.
    // We format these titles to represent more metadata.
    const context = (0, $1aa29b094fdafad8$export$efdbd45f3e77a161)(jsonLd);
    const type = (0, $aliCf.extractType)(jsonLd);
    const hasContextType = context && context.type;
    const hasContextRepo = hasContextType && context.type.includes('atlassian:SourceCodeRepository');
    if (hasContextRepo && type) {
        const contextName = context.name && `${context.name}: ` || '';
        // COMMIT: `repo-name: abf137c title of commit message`
        if (type.includes('atlassian:SourceCodeCommit')) {
            const [, hashContent] = id.split(':');
            const hash = hashContent && `${hashContent.substring(0, 8)} `;
            return contextName + (hash || '') + name;
        }
        // PR: `repo-name: #42 title of pull request`
        if (type.includes('atlassian:SourceCodePullRequest')) {
            const pullRequest = jsonLd;
            const internalId = pullRequest['atlassian:internalId'];
            const internalIdRef = internalId && `#${internalId} `;
            return contextName + (internalIdRef || '') + name;
        }
        // BRANCH: `repo-name/branch-name`
        if (type.includes('atlassian:SourceCodeReference')) return contextName + name;
        // FILE: `repo-name: filepath`
        if (type.includes('schema:DigitalDocument')) return contextName + name;
    }
    if (removeTextHighlightingFromTitle) {
        const textFragmentRegex = new RegExp(' \\| :~:text=.*', 'g');
        const truncated = name?.replace(textFragmentRegex, '');
        return truncated;
    }
    return name;
};
module.exports["extractTitle"] = $ca558e6955be7d7f$export$b05803156e5015b6;

});

parcelRegister("aliCf", function(module, exports) {
const $b71c91ab48ca7fcb$export$2e9ae379995d99e3 = (jsonLd)=>{
    const type = jsonLd['@type'];
    if (type) {
        if (Array.isArray(jsonLd['@type'])) return type;
        else return [
            type
        ];
    }
    return undefined;
};
module.exports["extractType"] = $b71c91ab48ca7fcb$export$2e9ae379995d99e3;

});

parcelRegister("9JHBV", function(module, exports) {
const $0d1a0b98f1eafbac$export$3e8ad908070b68b2 = (preview, platform)=>{
    if (preview) {
        // By default, we support previews everywhere.
        if (typeof preview === 'string') return true;
        else {
            const supportedPlatforms = preview['atlassian:supportedPlatforms'];
            if (supportedPlatforms) {
                const isWeb = platform === 'web';
                return isWeb && supportedPlatforms.includes('web') || !isWeb && supportedPlatforms.includes('mobile');
            }
            // No supported platforms - assume they are all supported.
            return true;
        }
    }
    // No preview, don't try and render it on any platforms.
    return false;
};



var $kzBLz = parcelRequire("kzBLz");

const $619c28d037f806e9$export$4b0d98b1b7f6d115 = (jsonLd, platform, iframeUrlType)=>{
    const preview = jsonLd?.preview;
    const isSupported = (0, $0d1a0b98f1eafbac$export$3e8ad908070b68b2)(preview, platform);
    if (preview && isSupported) {
        if (typeof preview === 'string') return {
            src: preview
        };
        else if (preview['@type'] === 'Link' && iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
            src: preview.interactiveHref,
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else if (preview['@type'] === 'Link') return {
            src: (0, $kzBLz.extractUrlFromLinkJsonLd)(preview),
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else {
            // TODO, EDM-565: Remove this once the typings for Dropbox and Jira have been patched up.
            if (preview.url || preview.href) {
                if (iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
                    src: preview.interactiveHref,
                    aspectRatio: preview['atlassian:aspectRatio']
                };
                return {
                    src: (0, $kzBLz.extractUrlFromLinkJsonLd)(preview.url || preview.href),
                    aspectRatio: preview['atlassian:aspectRatio']
                };
            } else if (preview.content) return {
                content: preview.content
            };
        }
    }
    return undefined;
};
module.exports["extractPreview"] = $619c28d037f806e9$export$4b0d98b1b7f6d115;

});

parcelRegister("lyclm", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $lAFHW = parcelRequire("lAFHW");





var $dh538 = parcelRequire("dh538");


var $3fvfu = parcelRequire("3fvfu");

const $fe608b0eca8c0821$export$8beff7405d020ddf = (response)=>response?.entityData;
const $fe608b0eca8c0821$export$c7168210b81d9383 = (response)=>Boolean($fe608b0eca8c0821$export$8beff7405d020ddf(response));
const $fe608b0eca8c0821$export$f97663ee76ac5b24 = (response)=>{
    const entity = $fe608b0eca8c0821$export$8beff7405d020ddf(response);
    return entity && 'liveEmbedUrl' in entity && typeof entity?.liveEmbedUrl === 'string' ? entity?.liveEmbedUrl : undefined;
};
const $fe608b0eca8c0821$export$ad879f2c9d5100a0 = (response)=>{
    if (!response?.meta?.generator) return undefined;
    const { icon: icon, id: id, image: image, name: name } = response.meta.generator;
    if (!name || !icon) throw Error('Link.generator requires a name and icon.');
    let providerIcon;
    switch(id){
        case 0, $3fvfu.CONFLUENCE_GENERATOR_ID:
            providerIcon = /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.ConfluenceIcon), {
                appearance: "brand",
                ...(0, $dh538.fg)('navx-1895-new-logo-design') ? {
                    shouldUseNewLogoDesign: true
                } : undefined,
                size: "xxsmall"
            });
            break;
        case 0, $3fvfu.JIRA_GENERATOR_ID:
            providerIcon = /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.JiraIcon), {
                appearance: "brand",
                ...(0, $dh538.fg)('navx-1895-new-logo-design') ? {
                    shouldUseNewLogoDesign: true
                } : undefined,
                size: "xxsmall"
            });
            break;
        default:
            providerIcon = icon.url;
    }
    return {
        text: name,
        icon: providerIcon,
        id: id,
        image: image ? image : icon.url
    };
};
const $fe608b0eca8c0821$export$19346520e937a99f = (response)=>{
    const entity = $fe608b0eca8c0821$export$8beff7405d020ddf(response);
    let url;
    if (entity) url = 'iconUrl' in entity && typeof entity?.iconUrl === 'string' ? entity.iconUrl : response?.meta.generator?.icon?.url;
    return {
        url: url,
        label: entity?.displayName
    };
};
module.exports["extractEntity"] = $fe608b0eca8c0821$export$8beff7405d020ddf;
module.exports["isEntityPresent"] = $fe608b0eca8c0821$export$c7168210b81d9383;
module.exports["extractEntityEmbedUrl"] = $fe608b0eca8c0821$export$f97663ee76ac5b24;
module.exports["extractEntityProvider"] = $fe608b0eca8c0821$export$ad879f2c9d5100a0;
module.exports["extractEntityIcon"] = $fe608b0eca8c0821$export$19346520e937a99f;

});

parcelRegister("btw9C", function(module, exports) {
const $2b201a7ae9d0ebd0$var$getStatusForNotFoundVisibility = (meta)=>{
    const accessType = meta.requestAccess?.accessType;
    if (!accessType || accessType === 'ACCESS_EXISTS') return 'not_found';
    // for the rest of the accessTypes we will return forbidden,see https://product-fabric.atlassian.net/browse/EDM-7125
    return 'forbidden';
};
const $2b201a7ae9d0ebd0$export$b70265791d2079d4 = ({ meta: meta })=>{
    const { access: access, visibility: visibility } = meta;
    switch(access){
        case 'forbidden':
            if (visibility === 'not_found') return $2b201a7ae9d0ebd0$var$getStatusForNotFoundVisibility(meta);
            else return 'forbidden';
        case 'unauthorized':
            return 'unauthorized';
        default:
            return 'resolved';
    }
};
module.exports["getStatus"] = $2b201a7ae9d0ebd0$export$b70265791d2079d4;

});

parcelRegister("jHnts", function(module, exports) {
class $65b10cace4bd92e7$export$3e5b797e39668f84 extends Error {
    constructor(kind, hostname, message, type, extensionKey){
        super(`${kind}: ${message}`), this.kind = kind, this.hostname = hostname, this.message = message, this.type = type, this.extensionKey = extensionKey;
        this.name = 'APIError';
        // The error type received from the server.
        this.type = type;
        // The kind mapped to on the client.
        this.kind = kind;
        // The message received from the server.
        this.message = message;
        // The hostname of the URL which failed - do NOT log this (contains PII/UGC).
        this.hostname = hostname;
        // The extensionKey passed from the error response from ORS
        this.extensionKey = extensionKey;
    }
}
module.exports["APIError"] = $65b10cace4bd92e7$export$3e5b797e39668f84;

});

parcelRegister("k8ulM", function(module, exports) {
(function webpackUniversalModuleDefinition(root, factory) {
    module.exports = factory();
})(typeof self !== 'undefined' ? self : module.exports, function() {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.l = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function(exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                /******/ configurable: false,
                /******/ enumerable: true,
                /******/ get: getter
            });
        /******/ };
        /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function(module1) {
            /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                return module1['default'];
            } : /******/ function getModuleExports() {
                return module1;
            };
            /******/ __webpack_require__.d(getter, 'a', getter);
            /******/ return getter;
        /******/ };
        /******/ /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/ /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = 3);
    /******/ }([
        /* 0 */ /***/ function(module1, exports, __webpack_require__) {
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            /* eslint-env commonjs, browser */ var RushaCore = __webpack_require__(5);
            var _require = __webpack_require__(1), toHex = _require.toHex, ceilHeapSize = _require.ceilHeapSize;
            var conv = __webpack_require__(6);
            // Calculate the length of buffer that the sha1 routine uses
            // including the padding.
            var padlen = function(len) {
                for(len += 9; len % 64 > 0; len += 1);
                return len;
            };
            var padZeroes = function(bin, len) {
                var h8 = new Uint8Array(bin.buffer);
                var om = len % 4, align = len - om;
                switch(om){
                    case 0:
                        h8[align + 3] = 0;
                    case 1:
                        h8[align + 2] = 0;
                    case 2:
                        h8[align + 1] = 0;
                    case 3:
                        h8[align + 0] = 0;
                }
                for(var i = (len >> 2) + 1; i < bin.length; i++)bin[i] = 0;
            };
            var padData = function(bin, chunkLen, msgLen) {
                bin[chunkLen >> 2] |= 0x80 << 24 - (chunkLen % 4 << 3);
                // To support msgLen >= 2 GiB, use a float division when computing the
                // high 32-bits of the big-endian message length in bits.
                bin[((chunkLen >> 2) + 2 & -16) + 14] = msgLen / 536870912 | 0;
                bin[((chunkLen >> 2) + 2 & -16) + 15] = msgLen << 3;
            };
            var getRawDigest = function(heap, padMaxChunkLen) {
                var io = new Int32Array(heap, padMaxChunkLen + 320, 5);
                var out = new Int32Array(5);
                var arr = new DataView(out.buffer);
                arr.setInt32(0, io[0], false);
                arr.setInt32(4, io[1], false);
                arr.setInt32(8, io[2], false);
                arr.setInt32(12, io[3], false);
                arr.setInt32(16, io[4], false);
                return out;
            };
            var Rusha = function() {
                function Rusha(chunkSize) {
                    _classCallCheck(this, Rusha);
                    chunkSize = chunkSize || 65536;
                    if (chunkSize % 64 > 0) throw new Error('Chunk size must be a multiple of 128 bit');
                    this._offset = 0;
                    this._maxChunkLen = chunkSize;
                    this._padMaxChunkLen = padlen(chunkSize);
                    // The size of the heap is the sum of:
                    // 1. The padded input message size
                    // 2. The extended space the algorithm needs (320 byte)
                    // 3. The 160 bit state the algoritm uses
                    this._heap = new ArrayBuffer(ceilHeapSize(this._padMaxChunkLen + 320 + 20));
                    this._h32 = new Int32Array(this._heap);
                    this._h8 = new Int8Array(this._heap);
                    this._core = new RushaCore({
                        Int32Array: Int32Array
                    }, {}, this._heap);
                }
                Rusha.prototype._initState = function _initState(heap, padMsgLen) {
                    this._offset = 0;
                    var io = new Int32Array(heap, padMsgLen + 320, 5);
                    io[0] = 1732584193;
                    io[1] = -271733879;
                    io[2] = -1732584194;
                    io[3] = 271733878;
                    io[4] = -1009589776;
                };
                Rusha.prototype._padChunk = function _padChunk(chunkLen, msgLen) {
                    var padChunkLen = padlen(chunkLen);
                    var view = new Int32Array(this._heap, 0, padChunkLen >> 2);
                    padZeroes(view, chunkLen);
                    padData(view, chunkLen, msgLen);
                    return padChunkLen;
                };
                Rusha.prototype._write = function _write(data, chunkOffset, chunkLen, off) {
                    conv(data, this._h8, this._h32, chunkOffset, chunkLen, off || 0);
                };
                Rusha.prototype._coreCall = function _coreCall(data, chunkOffset, chunkLen, msgLen, finalize) {
                    var padChunkLen = chunkLen;
                    this._write(data, chunkOffset, chunkLen);
                    if (finalize) padChunkLen = this._padChunk(chunkLen, msgLen);
                    this._core.hash(padChunkLen, this._padMaxChunkLen);
                };
                Rusha.prototype.rawDigest = function rawDigest(str) {
                    var msgLen = str.byteLength || str.length || str.size || 0;
                    this._initState(this._heap, this._padMaxChunkLen);
                    var chunkOffset = 0, chunkLen = this._maxChunkLen;
                    for(chunkOffset = 0; msgLen > chunkOffset + chunkLen; chunkOffset += chunkLen)this._coreCall(str, chunkOffset, chunkLen, msgLen, false);
                    this._coreCall(str, chunkOffset, msgLen - chunkOffset, msgLen, true);
                    return getRawDigest(this._heap, this._padMaxChunkLen);
                };
                Rusha.prototype.digest = function digest(str) {
                    return toHex(this.rawDigest(str).buffer);
                };
                Rusha.prototype.digestFromString = function digestFromString(str) {
                    return this.digest(str);
                };
                Rusha.prototype.digestFromBuffer = function digestFromBuffer(str) {
                    return this.digest(str);
                };
                Rusha.prototype.digestFromArrayBuffer = function digestFromArrayBuffer(str) {
                    return this.digest(str);
                };
                Rusha.prototype.resetState = function resetState() {
                    this._initState(this._heap, this._padMaxChunkLen);
                    return this;
                };
                Rusha.prototype.append = function append(chunk) {
                    var chunkOffset = 0;
                    var chunkLen = chunk.byteLength || chunk.length || chunk.size || 0;
                    var turnOffset = this._offset % this._maxChunkLen;
                    var inputLen = void 0;
                    this._offset += chunkLen;
                    while(chunkOffset < chunkLen){
                        inputLen = Math.min(chunkLen - chunkOffset, this._maxChunkLen - turnOffset);
                        this._write(chunk, chunkOffset, inputLen, turnOffset);
                        turnOffset += inputLen;
                        chunkOffset += inputLen;
                        if (turnOffset === this._maxChunkLen) {
                            this._core.hash(this._maxChunkLen, this._padMaxChunkLen);
                            turnOffset = 0;
                        }
                    }
                    return this;
                };
                Rusha.prototype.getState = function getState() {
                    var turnOffset = this._offset % this._maxChunkLen;
                    var heap = void 0;
                    if (!turnOffset) {
                        var io = new Int32Array(this._heap, this._padMaxChunkLen + 320, 5);
                        heap = io.buffer.slice(io.byteOffset, io.byteOffset + io.byteLength);
                    } else heap = this._heap.slice(0);
                    return {
                        offset: this._offset,
                        heap: heap
                    };
                };
                Rusha.prototype.setState = function setState(state) {
                    this._offset = state.offset;
                    if (state.heap.byteLength === 20) {
                        var io = new Int32Array(this._heap, this._padMaxChunkLen + 320, 5);
                        io.set(new Int32Array(state.heap));
                    } else this._h32.set(new Int32Array(state.heap));
                    return this;
                };
                Rusha.prototype.rawEnd = function rawEnd() {
                    var msgLen = this._offset;
                    var chunkLen = msgLen % this._maxChunkLen;
                    var padChunkLen = this._padChunk(chunkLen, msgLen);
                    this._core.hash(padChunkLen, this._padMaxChunkLen);
                    var result = getRawDigest(this._heap, this._padMaxChunkLen);
                    this._initState(this._heap, this._padMaxChunkLen);
                    return result;
                };
                Rusha.prototype.end = function end() {
                    return toHex(this.rawEnd().buffer);
                };
                return Rusha;
            }();
            module1.exports = Rusha;
            module1.exports._core = RushaCore;
        /***/ },
        /* 1 */ /***/ function(module1, exports) {
            /* eslint-env commonjs, browser */ //
            // toHex
            //
            var precomputedHex = new Array(256);
            for(var i = 0; i < 256; i++)precomputedHex[i] = (i < 0x10 ? '0' : '') + i.toString(16);
            module1.exports.toHex = function(arrayBuffer) {
                var binarray = new Uint8Array(arrayBuffer);
                var res = new Array(arrayBuffer.byteLength);
                for(var _i = 0; _i < res.length; _i++)res[_i] = precomputedHex[binarray[_i]];
                return res.join('');
            };
            //
            // ceilHeapSize
            //
            module1.exports.ceilHeapSize = function(v) {
                // The asm.js spec says:
                // The heap object's byteLength must be either
                // 2^n for n in [12, 24) or 2^24 * n for n ≥ 1.
                // Also, byteLengths smaller than 2^16 are deprecated.
                var p = 0;
                // If v is smaller than 2^16, the smallest possible solution
                // is 2^16.
                if (v <= 65536) return 65536;
                // If v < 2^24, we round up to 2^n,
                // otherwise we round up to 2^24 * n.
                if (v < 16777216) {
                    for(p = 1; p < v; p = p << 1);
                } else {
                    for(p = 16777216; p < v; p += 16777216);
                }
                return p;
            };
            //
            // isDedicatedWorkerScope
            //
            module1.exports.isDedicatedWorkerScope = function(self1) {
                var isRunningInWorker = 'WorkerGlobalScope' in self1 && self1 instanceof self1.WorkerGlobalScope;
                var isRunningInSharedWorker = 'SharedWorkerGlobalScope' in self1 && self1 instanceof self1.SharedWorkerGlobalScope;
                var isRunningInServiceWorker = 'ServiceWorkerGlobalScope' in self1 && self1 instanceof self1.ServiceWorkerGlobalScope;
                // Detects whether we run inside a dedicated worker or not.
                //
                // We can't just check for `DedicatedWorkerGlobalScope`, since IE11
                // has a bug where it only supports `WorkerGlobalScope`.
                //
                // Therefore, we consider us as running inside a dedicated worker
                // when we are running inside a worker, but not in a shared or service worker.
                //
                // When new types of workers are introduced, we will need to adjust this code.
                return isRunningInWorker && !isRunningInSharedWorker && !isRunningInServiceWorker;
            };
        /***/ },
        /* 2 */ /***/ function(module1, exports, __webpack_require__) {
            /* eslint-env commonjs, worker */ module1.exports = function() {
                var Rusha = __webpack_require__(0);
                var hashData = function(hasher, data, cb) {
                    try {
                        return cb(null, hasher.digest(data));
                    } catch (e) {
                        return cb(e);
                    }
                };
                var hashFile = function(hasher, readTotal, blockSize, file, cb) {
                    var reader = new self.FileReader();
                    reader.onloadend = function onloadend() {
                        if (reader.error) return cb(reader.error);
                        var buffer = reader.result;
                        readTotal += reader.result.byteLength;
                        try {
                            hasher.append(buffer);
                        } catch (e) {
                            cb(e);
                            return;
                        }
                        if (readTotal < file.size) hashFile(hasher, readTotal, blockSize, file, cb);
                        else cb(null, hasher.end());
                    };
                    reader.readAsArrayBuffer(file.slice(readTotal, readTotal + blockSize));
                };
                var workerBehaviourEnabled = true;
                self.onmessage = function(event) {
                    if (!workerBehaviourEnabled) return;
                    var data = event.data.data, file = event.data.file, id = event.data.id;
                    if (typeof id === 'undefined') return;
                    if (!file && !data) return;
                    var blockSize = event.data.blockSize || 4194304;
                    var hasher = new Rusha(blockSize);
                    hasher.resetState();
                    var done = function(err, hash) {
                        if (!err) self.postMessage({
                            id: id,
                            hash: hash
                        });
                        else self.postMessage({
                            id: id,
                            error: err.name
                        });
                    };
                    if (data) hashData(hasher, data, done);
                    if (file) hashFile(hasher, 0, blockSize, file, done);
                };
                return function() {
                    workerBehaviourEnabled = false;
                };
            };
        /***/ },
        /* 3 */ /***/ function(module1, exports, __webpack_require__) {
            /* eslint-env commonjs, browser */ var work = __webpack_require__(4);
            var Rusha = __webpack_require__(0);
            var createHash = __webpack_require__(7);
            var runWorker = __webpack_require__(2);
            var _require = __webpack_require__(1), isDedicatedWorkerScope = _require.isDedicatedWorkerScope;
            var isRunningInDedicatedWorker = typeof self !== 'undefined' && isDedicatedWorkerScope(self);
            Rusha.disableWorkerBehaviour = isRunningInDedicatedWorker ? runWorker() : function() {};
            Rusha.createWorker = function() {
                var worker = work(/*require.resolve*/ 2);
                var terminate = worker.terminate;
                worker.terminate = function() {
                    URL.revokeObjectURL(worker.objectURL);
                    terminate.call(worker);
                };
                return worker;
            };
            Rusha.createHash = createHash;
            module1.exports = Rusha;
        /***/ },
        /* 4 */ /***/ function(module1, exports, __webpack_require__) {
            function webpackBootstrapFunc(modules) {
                /******/ // The module cache
                /******/ var installedModules = {};
                /******/ // The require function
                /******/ function __webpack_require__(moduleId) {
                    /******/ // Check if module is in cache
                    /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
                    /******/ // Create a new module (and put it into the cache)
                    /******/ var module1 = installedModules[moduleId] = {
                        /******/ i: moduleId,
                        /******/ l: false,
                        /******/ exports: {}
                    };
                    /******/ // Execute the module function
                    /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
                    /******/ // Flag the module as loaded
                    /******/ module1.l = true;
                    /******/ // Return the exports of the module
                    /******/ return module1.exports;
                /******/ }
                /******/ // expose the modules object (__webpack_modules__)
                /******/ __webpack_require__.m = modules;
                /******/ // expose the module cache
                /******/ __webpack_require__.c = installedModules;
                /******/ // identity function for calling harmony imports with the correct context
                /******/ __webpack_require__.i = function(value) {
                    return value;
                };
                /******/ // define getter function for harmony exports
                /******/ __webpack_require__.d = function(exports, name, getter) {
                    /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                        /******/ configurable: false,
                        /******/ enumerable: true,
                        /******/ get: getter
                    });
                /******/ };
                /******/ // define __esModule on exports
                /******/ __webpack_require__.r = function(exports) {
                    /******/ Object.defineProperty(exports, '__esModule', {
                        value: true
                    });
                /******/ };
                /******/ // getDefaultExport function for compatibility with non-harmony modules
                /******/ __webpack_require__.n = function(module1) {
                    /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                        return module1['default'];
                    } : /******/ function getModuleExports() {
                        return module1;
                    };
                    /******/ __webpack_require__.d(getter, 'a', getter);
                    /******/ return getter;
                /******/ };
                /******/ // Object.prototype.hasOwnProperty.call
                /******/ __webpack_require__.o = function(object, property) {
                    return Object.prototype.hasOwnProperty.call(object, property);
                };
                /******/ // __webpack_public_path__
                /******/ __webpack_require__.p = "/";
                /******/ // on error function for async loading
                /******/ __webpack_require__.oe = function(err) {
                    console.error(err);
                    throw err;
                };
                var f = __webpack_require__(__webpack_require__.s = ENTRY_MODULE);
                return f.default || f // try to call default if defined to also support babel esmodule exports
                ;
            }
            var moduleNameReqExp = '[\\.|\\-|\\+|\\w|\/|@]+';
            var dependencyRegExp = '\\((\/\\*.*?\\*\/)?\s?.*?(' + moduleNameReqExp + ').*?\\)' // additional chars when output.pathinfo is true
            ;
            // http://stackoverflow.com/a/2593661/130442
            function quoteRegExp(str) {
                return (str + '').replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
            }
            function getModuleDependencies(sources, module1, queueName) {
                var retval = {};
                retval[queueName] = [];
                var fnString = module1.toString();
                var wrapperSignature = fnString.match(/^function\s?\(\w+,\s*\w+,\s*(\w+)\)/);
                if (!wrapperSignature) return retval;
                var webpackRequireName = wrapperSignature[1];
                // main bundle deps
                var re = new RegExp('(\\\\n|\\W)' + quoteRegExp(webpackRequireName) + dependencyRegExp, 'g');
                var match;
                while(match = re.exec(fnString)){
                    if (match[3] === 'dll-reference') continue;
                    retval[queueName].push(match[3]);
                }
                // dll deps
                re = new RegExp('\\(' + quoteRegExp(webpackRequireName) + '\\("(dll-reference\\s(' + moduleNameReqExp + '))"\\)\\)' + dependencyRegExp, 'g');
                while(match = re.exec(fnString)){
                    if (!sources[match[2]]) {
                        retval[queueName].push(match[1]);
                        sources[match[2]] = __webpack_require__(match[1]).m;
                    }
                    retval[match[2]] = retval[match[2]] || [];
                    retval[match[2]].push(match[4]);
                }
                return retval;
            }
            function hasValuesInQueues(queues) {
                var keys = Object.keys(queues);
                return keys.reduce(function(hasValues, key) {
                    return hasValues || queues[key].length > 0;
                }, false);
            }
            function getRequiredModules(sources, moduleId) {
                var modulesQueue = {
                    main: [
                        moduleId
                    ]
                };
                var requiredModules = {
                    main: []
                };
                var seenModules = {
                    main: {}
                };
                while(hasValuesInQueues(modulesQueue)){
                    var queues = Object.keys(modulesQueue);
                    for(var i = 0; i < queues.length; i++){
                        var queueName = queues[i];
                        var queue = modulesQueue[queueName];
                        var moduleToCheck = queue.pop();
                        seenModules[queueName] = seenModules[queueName] || {};
                        if (seenModules[queueName][moduleToCheck] || !sources[queueName][moduleToCheck]) continue;
                        seenModules[queueName][moduleToCheck] = true;
                        requiredModules[queueName] = requiredModules[queueName] || [];
                        requiredModules[queueName].push(moduleToCheck);
                        var newModules = getModuleDependencies(sources, sources[queueName][moduleToCheck], queueName);
                        var newModulesKeys = Object.keys(newModules);
                        for(var j = 0; j < newModulesKeys.length; j++){
                            modulesQueue[newModulesKeys[j]] = modulesQueue[newModulesKeys[j]] || [];
                            modulesQueue[newModulesKeys[j]] = modulesQueue[newModulesKeys[j]].concat(newModules[newModulesKeys[j]]);
                        }
                    }
                }
                return requiredModules;
            }
            module1.exports = function(moduleId, options) {
                options = options || {};
                var sources = {
                    main: __webpack_require__.m
                };
                var requiredModules = options.all ? {
                    main: Object.keys(sources)
                } : getRequiredModules(sources, moduleId);
                var src = '';
                Object.keys(requiredModules).filter(function(m) {
                    return m !== 'main';
                }).forEach(function(module1) {
                    var entryModule = 0;
                    while(requiredModules[module1][entryModule])entryModule++;
                    requiredModules[module1].push(entryModule);
                    sources[module1][entryModule] = '(function(module, exports, __webpack_require__) { module.exports = __webpack_require__; })';
                    src = src + 'var ' + module1 + ' = (' + webpackBootstrapFunc.toString().replace('ENTRY_MODULE', JSON.stringify(entryModule)) + ')({' + requiredModules[module1].map(function(id) {
                        return '' + JSON.stringify(id) + ': ' + sources[module1][id].toString();
                    }).join(',') + '});\n';
                });
                src = src + '(' + webpackBootstrapFunc.toString().replace('ENTRY_MODULE', JSON.stringify(moduleId)) + ')({' + requiredModules.main.map(function(id) {
                    return '' + JSON.stringify(id) + ': ' + sources.main[id].toString();
                }).join(',') + '})(self);';
                var blob = new window.Blob([
                    src
                ], {
                    type: 'text/javascript'
                });
                if (options.bare) return blob;
                var URL1 = window.URL || window.webkitURL || window.mozURL || window.msURL;
                var workerUrl = URL1.createObjectURL(blob);
                var worker = new window.Worker(workerUrl);
                worker.objectURL = workerUrl;
                return worker;
            };
        /***/ },
        /* 5 */ /***/ function(module1, exports) {
            // The low-level RushCore module provides the heart of Rusha,
            // a high-speed sha1 implementation working on an Int32Array heap.
            // At first glance, the implementation seems complicated, however
            // with the SHA1 spec at hand, it is obvious this almost a textbook
            // implementation that has a few functions hand-inlined and a few loops
            // hand-unrolled.
            module1.exports = function RushaCore(stdlib$840, foreign$841, heap$842) {
                'use asm';
                var H$843 = new stdlib$840.Int32Array(heap$842);
                function hash$844(k$845, x$846) {
                    // k in bytes
                    k$845 = k$845 | 0;
                    x$846 = x$846 | 0;
                    var i$847 = 0, j$848 = 0, y0$849 = 0, z0$850 = 0, y1$851 = 0, z1$852 = 0, y2$853 = 0, z2$854 = 0, y3$855 = 0, z3$856 = 0, y4$857 = 0, z4$858 = 0, t0$859 = 0, t1$860 = 0;
                    y0$849 = H$843[x$846 + 320 >> 2] | 0;
                    y1$851 = H$843[x$846 + 324 >> 2] | 0;
                    y2$853 = H$843[x$846 + 328 >> 2] | 0;
                    y3$855 = H$843[x$846 + 332 >> 2] | 0;
                    y4$857 = H$843[x$846 + 336 >> 2] | 0;
                    for(i$847 = 0; (i$847 | 0) < (k$845 | 0); i$847 = i$847 + 64 | 0){
                        z0$850 = y0$849;
                        z1$852 = y1$851;
                        z2$854 = y2$853;
                        z3$856 = y3$855;
                        z4$858 = y4$857;
                        for(j$848 = 0; (j$848 | 0) < 64; j$848 = j$848 + 4 | 0){
                            t1$860 = H$843[i$847 + j$848 >> 2] | 0;
                            t0$859 = ((y0$849 << 5 | y0$849 >>> 27) + (y1$851 & y2$853 | ~y1$851 & y3$855) | 0) + ((t1$860 + y4$857 | 0) + 1518500249 | 0) | 0;
                            y4$857 = y3$855;
                            y3$855 = y2$853;
                            y2$853 = y1$851 << 30 | y1$851 >>> 2;
                            y1$851 = y0$849;
                            y0$849 = t0$859;
                            H$843[k$845 + j$848 >> 2] = t1$860;
                        }
                        for(j$848 = k$845 + 64 | 0; (j$848 | 0) < (k$845 + 80 | 0); j$848 = j$848 + 4 | 0){
                            t1$860 = (H$843[j$848 - 12 >> 2] ^ H$843[j$848 - 32 >> 2] ^ H$843[j$848 - 56 >> 2] ^ H$843[j$848 - 64 >> 2]) << 1 | (H$843[j$848 - 12 >> 2] ^ H$843[j$848 - 32 >> 2] ^ H$843[j$848 - 56 >> 2] ^ H$843[j$848 - 64 >> 2]) >>> 31;
                            t0$859 = ((y0$849 << 5 | y0$849 >>> 27) + (y1$851 & y2$853 | ~y1$851 & y3$855) | 0) + ((t1$860 + y4$857 | 0) + 1518500249 | 0) | 0;
                            y4$857 = y3$855;
                            y3$855 = y2$853;
                            y2$853 = y1$851 << 30 | y1$851 >>> 2;
                            y1$851 = y0$849;
                            y0$849 = t0$859;
                            H$843[j$848 >> 2] = t1$860;
                        }
                        for(j$848 = k$845 + 80 | 0; (j$848 | 0) < (k$845 + 160 | 0); j$848 = j$848 + 4 | 0){
                            t1$860 = (H$843[j$848 - 12 >> 2] ^ H$843[j$848 - 32 >> 2] ^ H$843[j$848 - 56 >> 2] ^ H$843[j$848 - 64 >> 2]) << 1 | (H$843[j$848 - 12 >> 2] ^ H$843[j$848 - 32 >> 2] ^ H$843[j$848 - 56 >> 2] ^ H$843[j$848 - 64 >> 2]) >>> 31;
                            t0$859 = ((y0$849 << 5 | y0$849 >>> 27) + (y1$851 ^ y2$853 ^ y3$855) | 0) + ((t1$860 + y4$857 | 0) + 1859775393 | 0) | 0;
                            y4$857 = y3$855;
                            y3$855 = y2$853;
                            y2$853 = y1$851 << 30 | y1$851 >>> 2;
                            y1$851 = y0$849;
                            y0$849 = t0$859;
                            H$843[j$848 >> 2] = t1$860;
                        }
                        for(j$848 = k$845 + 160 | 0; (j$848 | 0) < (k$845 + 240 | 0); j$848 = j$848 + 4 | 0){
                            t1$860 = (H$843[j$848 - 12 >> 2] ^ H$843[j$848 - 32 >> 2] ^ H$843[j$848 - 56 >> 2] ^ H$843[j$848 - 64 >> 2]) << 1 | (H$843[j$848 - 12 >> 2] ^ H$843[j$848 - 32 >> 2] ^ H$843[j$848 - 56 >> 2] ^ H$843[j$848 - 64 >> 2]) >>> 31;
                            t0$859 = ((y0$849 << 5 | y0$849 >>> 27) + (y1$851 & y2$853 | y1$851 & y3$855 | y2$853 & y3$855) | 0) + ((t1$860 + y4$857 | 0) - 1894007588 | 0) | 0;
                            y4$857 = y3$855;
                            y3$855 = y2$853;
                            y2$853 = y1$851 << 30 | y1$851 >>> 2;
                            y1$851 = y0$849;
                            y0$849 = t0$859;
                            H$843[j$848 >> 2] = t1$860;
                        }
                        for(j$848 = k$845 + 240 | 0; (j$848 | 0) < (k$845 + 320 | 0); j$848 = j$848 + 4 | 0){
                            t1$860 = (H$843[j$848 - 12 >> 2] ^ H$843[j$848 - 32 >> 2] ^ H$843[j$848 - 56 >> 2] ^ H$843[j$848 - 64 >> 2]) << 1 | (H$843[j$848 - 12 >> 2] ^ H$843[j$848 - 32 >> 2] ^ H$843[j$848 - 56 >> 2] ^ H$843[j$848 - 64 >> 2]) >>> 31;
                            t0$859 = ((y0$849 << 5 | y0$849 >>> 27) + (y1$851 ^ y2$853 ^ y3$855) | 0) + ((t1$860 + y4$857 | 0) - 899497514 | 0) | 0;
                            y4$857 = y3$855;
                            y3$855 = y2$853;
                            y2$853 = y1$851 << 30 | y1$851 >>> 2;
                            y1$851 = y0$849;
                            y0$849 = t0$859;
                            H$843[j$848 >> 2] = t1$860;
                        }
                        y0$849 = y0$849 + z0$850 | 0;
                        y1$851 = y1$851 + z1$852 | 0;
                        y2$853 = y2$853 + z2$854 | 0;
                        y3$855 = y3$855 + z3$856 | 0;
                        y4$857 = y4$857 + z4$858 | 0;
                    }
                    H$843[x$846 + 320 >> 2] = y0$849;
                    H$843[x$846 + 324 >> 2] = y1$851;
                    H$843[x$846 + 328 >> 2] = y2$853;
                    H$843[x$846 + 332 >> 2] = y3$855;
                    H$843[x$846 + 336 >> 2] = y4$857;
                }
                return {
                    hash: hash$844
                };
            };
        /***/ },
        /* 6 */ /***/ function(module1, exports) {
            var _this = this;
            /* eslint-env commonjs, browser */ var reader = void 0;
            if (typeof self !== 'undefined' && typeof self.FileReaderSync !== 'undefined') reader = new self.FileReaderSync();
            // Convert a binary string and write it to the heap.
            // A binary string is expected to only contain char codes < 256.
            var convStr = function(str, H8, H32, start, len, off) {
                var i = void 0, om = off % 4, lm = (len + om) % 4, j = len - lm;
                switch(om){
                    case 0:
                        H8[off] = str.charCodeAt(start + 3);
                    case 1:
                        H8[off + 1 - (om << 1) | 0] = str.charCodeAt(start + 2);
                    case 2:
                        H8[off + 2 - (om << 1) | 0] = str.charCodeAt(start + 1);
                    case 3:
                        H8[off + 3 - (om << 1) | 0] = str.charCodeAt(start);
                }
                if (len < lm + (4 - om)) return;
                for(i = 4 - om; i < j; i = i + 4 | 0)H32[off + i >> 2] = str.charCodeAt(start + i) << 24 | str.charCodeAt(start + i + 1) << 16 | str.charCodeAt(start + i + 2) << 8 | str.charCodeAt(start + i + 3);
                switch(lm){
                    case 3:
                        H8[off + j + 1 | 0] = str.charCodeAt(start + j + 2);
                    case 2:
                        H8[off + j + 2 | 0] = str.charCodeAt(start + j + 1);
                    case 1:
                        H8[off + j + 3 | 0] = str.charCodeAt(start + j);
                }
            };
            // Convert a buffer or array and write it to the heap.
            // The buffer or array is expected to only contain elements < 256.
            var convBuf = function(buf, H8, H32, start, len, off) {
                var i = void 0, om = off % 4, lm = (len + om) % 4, j = len - lm;
                switch(om){
                    case 0:
                        H8[off] = buf[start + 3];
                    case 1:
                        H8[off + 1 - (om << 1) | 0] = buf[start + 2];
                    case 2:
                        H8[off + 2 - (om << 1) | 0] = buf[start + 1];
                    case 3:
                        H8[off + 3 - (om << 1) | 0] = buf[start];
                }
                if (len < lm + (4 - om)) return;
                for(i = 4 - om; i < j; i = i + 4 | 0)H32[off + i >> 2 | 0] = buf[start + i] << 24 | buf[start + i + 1] << 16 | buf[start + i + 2] << 8 | buf[start + i + 3];
                switch(lm){
                    case 3:
                        H8[off + j + 1 | 0] = buf[start + j + 2];
                    case 2:
                        H8[off + j + 2 | 0] = buf[start + j + 1];
                    case 1:
                        H8[off + j + 3 | 0] = buf[start + j];
                }
            };
            var convBlob = function(blob, H8, H32, start, len, off) {
                var i = void 0, om = off % 4, lm = (len + om) % 4, j = len - lm;
                var buf = new Uint8Array(reader.readAsArrayBuffer(blob.slice(start, start + len)));
                switch(om){
                    case 0:
                        H8[off] = buf[3];
                    case 1:
                        H8[off + 1 - (om << 1) | 0] = buf[2];
                    case 2:
                        H8[off + 2 - (om << 1) | 0] = buf[1];
                    case 3:
                        H8[off + 3 - (om << 1) | 0] = buf[0];
                }
                if (len < lm + (4 - om)) return;
                for(i = 4 - om; i < j; i = i + 4 | 0)H32[off + i >> 2 | 0] = buf[i] << 24 | buf[i + 1] << 16 | buf[i + 2] << 8 | buf[i + 3];
                switch(lm){
                    case 3:
                        H8[off + j + 1 | 0] = buf[j + 2];
                    case 2:
                        H8[off + j + 2 | 0] = buf[j + 1];
                    case 1:
                        H8[off + j + 3 | 0] = buf[j];
                }
            };
            module1.exports = function(data, H8, H32, start, len, off) {
                if (typeof data === 'string') return convStr(data, H8, H32, start, len, off);
                if (data instanceof Array) return convBuf(data, H8, H32, start, len, off);
                // Safely doing a Buffer check using "this" to avoid Buffer polyfill to be included in the dist
                if (_this && _this.Buffer && _this.Buffer.isBuffer(data)) return convBuf(data, H8, H32, start, len, off);
                if (data instanceof ArrayBuffer) return convBuf(new Uint8Array(data), H8, H32, start, len, off);
                if (data.buffer instanceof ArrayBuffer) return convBuf(new Uint8Array(data.buffer, data.byteOffset, data.byteLength), H8, H32, start, len, off);
                if (data instanceof Blob) return convBlob(data, H8, H32, start, len, off);
                throw new Error('Unsupported data type.');
            };
        /***/ },
        /* 7 */ /***/ function(module1, exports, __webpack_require__) {
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            /* eslint-env commonjs, browser */ var Rusha = __webpack_require__(0);
            var _require = __webpack_require__(1), toHex = _require.toHex;
            var Hash = function() {
                function Hash() {
                    _classCallCheck(this, Hash);
                    this._rusha = new Rusha();
                    this._rusha.resetState();
                }
                Hash.prototype.update = function update(data) {
                    this._rusha.append(data);
                    return this;
                };
                Hash.prototype.digest = function digest(encoding) {
                    var digest = this._rusha.rawEnd().buffer;
                    if (!encoding) return digest;
                    if (encoding === 'hex') return toHex(digest);
                    throw new Error('unsupported digest encoding');
                };
                _createClass(Hash, [
                    {
                        key: 'state',
                        get: function() {
                            return this._rusha.getState();
                        },
                        set: function(state) {
                            this._rusha.setState(state);
                        }
                    }
                ]);
                return Hash;
            }();
            module1.exports = function() {
                return new Hash();
            };
        /***/ }
    ]);
});

});

parcelRegister("6jPem", function(module, exports) {
function $a49fd3f268c80639$export$735cfea22ce30f58(_visitors) {
    return true;
}
function $a49fd3f268c80639$export$df3f009e3d155b20(adf, visitors) {
    if (!$a49fd3f268c80639$export$735cfea22ce30f58(visitors)) throw new Error(`Visitors are not valid: "${Object.keys(visitors).join(', ')}"`);
    return $a49fd3f268c80639$var$traverseNode(adf, {
        node: undefined
    }, visitors, 0, 0);
}
function $a49fd3f268c80639$var$traverseNode(adfNode, parent, visitors, index, depth) {
    const visitor = visitors[adfNode.type] || visitors['any'];
    let newNode = {
        ...adfNode
    };
    if (visitor) {
        const processedNode = visitor({
            ...newNode
        }, parent, index, depth);
        if (processedNode === false) return false;
        newNode = processedNode || adfNode;
    }
    if (newNode.content) newNode.content = newNode.content.reduce((acc, node, idx)=>{
        if (!node) return acc;
        const processedNode = $a49fd3f268c80639$var$traverseNode(node, {
            node: newNode,
            parent: parent
        }, visitors, idx, depth + 1);
        if (processedNode !== false) acc.push(processedNode);
        return acc;
    }, []);
    return newNode;
}
module.exports["traverse"] = $a49fd3f268c80639$export$df3f009e3d155b20;

});

parcelRegister("bSXAs", function(module, exports) {

var $ajtLB = parcelRequire("ajtLB");
var $d746fbe276da0c26$exports = {};
$parcel$export($d746fbe276da0c26$exports, "expandWithNestedExpand", () => (parcelRequire("6vky0")).expandWithNestedExpand);
$parcel$export($d746fbe276da0c26$exports, "expandWithNestedExpandLocalId", () => (parcelRequire("6vky0")).expandWithNestedExpandLocalId);
$parcel$export($d746fbe276da0c26$exports, "expandToJSON", () => (parcelRequire("6vky0")).toJSON);
$parcel$export($d746fbe276da0c26$exports, "confluenceJiraIssue", () => (parcelRequire("iAg3T")).confluenceJiraIssue);
$parcel$export($d746fbe276da0c26$exports, "confluenceUnsupportedBlock", () => (parcelRequire("8C6Yu")).confluenceUnsupportedBlock);
$parcel$export($d746fbe276da0c26$exports, "confluenceUnsupportedInline", () => (parcelRequire("l0xmR")).confluenceUnsupportedInline);
$parcel$export($d746fbe276da0c26$exports, "doc", () => (parcelRequire("5Tpzn")).doc);
$parcel$export($d746fbe276da0c26$exports, "blockquote", () => (parcelRequire("6D9dG")).blockquote);
$parcel$export($d746fbe276da0c26$exports, "extendedBlockquote", () => (parcelRequire("6D9dG")).extendedBlockquote);
$parcel$export($d746fbe276da0c26$exports, "extendedBlockquoteWithLocalId", () => (parcelRequire("6D9dG")).extendedBlockquoteWithLocalId);
$parcel$export($d746fbe276da0c26$exports, "bulletList", () => (parcelRequire("76Qef")).bulletList);
$parcel$export($d746fbe276da0c26$exports, "bulletListSelector", () => (parcelRequire("76Qef")).bulletListSelector);
$parcel$export($d746fbe276da0c26$exports, "bulletListWithLocalId", () => (parcelRequire("76Qef")).bulletListWithLocalId);
$parcel$export($d746fbe276da0c26$exports, "codeBlock", () => (parcelRequire("7tm9l")).codeBlock);
$parcel$export($d746fbe276da0c26$exports, "codeBlockWithLocalId", () => (parcelRequire("7tm9l")).codeBlockWithLocalId);
$parcel$export($d746fbe276da0c26$exports, "codeBlockToJSON", () => (parcelRequire("7tm9l")).toJSON);
$parcel$export($d746fbe276da0c26$exports, "hardBreak", () => (parcelRequire("lrauW")).hardBreak);
$parcel$export($d746fbe276da0c26$exports, "heading", () => (parcelRequire("1kn6Y")).heading);
$parcel$export($d746fbe276da0c26$exports, "rule", () => (parcelRequire("d5tvP")).rule);
$parcel$export($d746fbe276da0c26$exports, "ruleWithLocalId", () => (parcelRequire("d5tvP")).ruleWithLocalId);
$parcel$export($d746fbe276da0c26$exports, "orderedList", () => (parcelRequire("bOKwh")).orderedList);
$parcel$export($d746fbe276da0c26$exports, "orderedListSelector", () => (parcelRequire("bOKwh")).orderedListSelector);
$parcel$export($d746fbe276da0c26$exports, "orderedListWithLocalId", () => (parcelRequire("bOKwh")).orderedListWithLocalId);
$parcel$export($d746fbe276da0c26$exports, "orderedListWithOrder", () => (parcelRequire("bOKwh")).orderedListWithOrder);
$parcel$export($d746fbe276da0c26$exports, "orderedListWithOrderAndLocalId", () => (parcelRequire("bOKwh")).orderedListWithOrderAndLocalId);
$parcel$export($d746fbe276da0c26$exports, "paragraph", () => (parcelRequire("k9bwp")).paragraph);
$parcel$export($d746fbe276da0c26$exports, "emoji", () => (parcelRequire("86xUj")).emoji);
$parcel$export($d746fbe276da0c26$exports, "emojiWithLocalId", () => (parcelRequire("86xUj")).emojiWithLocalId);
$parcel$export($d746fbe276da0c26$exports, "image", () => (parcelRequire("hOedk")).image);
$parcel$export($d746fbe276da0c26$exports, "mention", () => (parcelRequire("8cHA0")).mention);
$parcel$export($d746fbe276da0c26$exports, "mentionToJSON", () => (parcelRequire("8cHA0")).toJSON);
$parcel$export($d746fbe276da0c26$exports, "listItem", () => (parcelRequire("7uqCm")).listItem);
$parcel$export($d746fbe276da0c26$exports, "listItemWithDecisionStage0", () => (parcelRequire("7uqCm")).listItemWithDecisionStage0);
$parcel$export($d746fbe276da0c26$exports, "listItemWithLocalId", () => (parcelRequire("7uqCm")).listItemWithLocalId);
$parcel$export($d746fbe276da0c26$exports, "extendedPanel", () => (parcelRequire("0pwCz")).extendedPanel);
$parcel$export($d746fbe276da0c26$exports, "extendedPanelWithLocalId", () => (parcelRequire("0pwCz")).extendedPanelWithLocalId);
$parcel$export($d746fbe276da0c26$exports, "PanelType", () => (parcelRequire("0pwCz")).PanelType);
$parcel$export($d746fbe276da0c26$exports, "text", () => (parcelRequire("lJq4s")).text);
$parcel$export($d746fbe276da0c26$exports, "unknownBlock", () => (parcelRequire("9bakv")).default);
$parcel$export($d746fbe276da0c26$exports, "caption", () => (parcelRequire("8Dbmz")).caption);
$parcel$export($d746fbe276da0c26$exports, "captionWithLocalId", () => (parcelRequire("8Dbmz")).captionWithLocalId);
$parcel$export($d746fbe276da0c26$exports, "media", () => (parcelRequire("53bvm")).media);
$parcel$export($d746fbe276da0c26$exports, "copyPrivateMediaAttributes", () => (parcelRequire("53bvm")).copyPrivateAttributes);
$parcel$export($d746fbe276da0c26$exports, "mediaToJSON", () => (parcelRequire("53bvm")).toJSON);
$parcel$export($d746fbe276da0c26$exports, "mediaGroup", () => (parcelRequire("cJm3M")).mediaGroup);
$parcel$export($d746fbe276da0c26$exports, "mediaInline", () => (parcelRequire("6CTq8")).mediaInline);
$parcel$export($d746fbe276da0c26$exports, "mediaSingle", () => (parcelRequire("gbkVM")).mediaSingle);
$parcel$export($d746fbe276da0c26$exports, "mediaSingleSpec", () => (parcelRequire("gbkVM")).mediaSingleSpec);
$parcel$export($d746fbe276da0c26$exports, "mediaSingleWithCaption", () => (parcelRequire("gbkVM")).mediaSingleWithCaption);
$parcel$export($d746fbe276da0c26$exports, "mediaSingleWithWidthType", () => (parcelRequire("gbkVM")).mediaSingleWithWidthType);
$parcel$export($d746fbe276da0c26$exports, "mediaSingleFull", () => (parcelRequire("gbkVM")).mediaSingleFull);
$parcel$export($d746fbe276da0c26$exports, "mediaSingleFullWithLocalId", () => (parcelRequire("gbkVM")).mediaSingleFullWithLocalId);
$parcel$export($d746fbe276da0c26$exports, "mediaSingleToJSON", () => (parcelRequire("gbkVM")).toJSON);
$parcel$export($d746fbe276da0c26$exports, "table", () => (parcelRequire("ivrsj")).table);
$parcel$export($d746fbe276da0c26$exports, "tableWithNestedTable", () => (parcelRequire("ivrsj")).tableWithNestedTable);
$parcel$export($d746fbe276da0c26$exports, "tableRowWithNestedTable", () => (parcelRequire("ivrsj")).tableRowWithNestedTable);
$parcel$export($d746fbe276da0c26$exports, "tableCellWithNestedTable", () => (parcelRequire("ivrsj")).tableCellWithNestedTable);
$parcel$export($d746fbe276da0c26$exports, "tableHeaderWithNestedTable", () => (parcelRequire("ivrsj")).tableHeaderWithNestedTable);
$parcel$export($d746fbe276da0c26$exports, "tableRowWithLocalId", () => (parcelRequire("ivrsj")).tableRowWithLocalId);
$parcel$export($d746fbe276da0c26$exports, "tableCellWithLocalId", () => (parcelRequire("ivrsj")).tableCellWithLocalId);
$parcel$export($d746fbe276da0c26$exports, "tableHeaderWithLocalId", () => (parcelRequire("ivrsj")).tableHeaderWithLocalId);
$parcel$export($d746fbe276da0c26$exports, "tableRowWithNestedTableWithLocalId", () => (parcelRequire("ivrsj")).tableRowWithNestedTableWithLocalId);
$parcel$export($d746fbe276da0c26$exports, "tableCellWithNestedTableWithLocalId", () => (parcelRequire("ivrsj")).tableCellWithNestedTableWithLocalId);
$parcel$export($d746fbe276da0c26$exports, "tableHeaderWithNestedTableWithLocalId", () => (parcelRequire("ivrsj")).tableHeaderWithNestedTableWithLocalId);
$parcel$export($d746fbe276da0c26$exports, "tableStage0", () => (parcelRequire("ivrsj")).tableStage0);
$parcel$export($d746fbe276da0c26$exports, "tableWithCustomWidth", () => (parcelRequire("ivrsj")).tableWithCustomWidth);
$parcel$export($d746fbe276da0c26$exports, "tableToJSON", () => (parcelRequire("ivrsj")).tableToJSON);
$parcel$export($d746fbe276da0c26$exports, "tableCell", () => (parcelRequire("ivrsj")).tableCell);
$parcel$export($d746fbe276da0c26$exports, "toJSONTableCell", () => (parcelRequire("ivrsj")).toJSONTableCell);
$parcel$export($d746fbe276da0c26$exports, "tableHeader", () => (parcelRequire("ivrsj")).tableHeader);
$parcel$export($d746fbe276da0c26$exports, "toJSONTableHeader", () => (parcelRequire("ivrsj")).toJSONTableHeader);
$parcel$export($d746fbe276da0c26$exports, "tableRow", () => (parcelRequire("ivrsj")).tableRow);
$parcel$export($d746fbe276da0c26$exports, "tableBackgroundColorPalette", () => (parcelRequire("ivrsj")).tableBackgroundColorPalette);
$parcel$export($d746fbe276da0c26$exports, "tableBackgroundBorderColor", () => (parcelRequire("ivrsj")).tableBackgroundBorderColor);
$parcel$export($d746fbe276da0c26$exports, "tableBackgroundColorNames", () => (parcelRequire("ivrsj")).tableBackgroundColorNames);
$parcel$export($d746fbe276da0c26$exports, "getCellAttrs", () => (parcelRequire("ivrsj")).getCellAttrs);
$parcel$export($d746fbe276da0c26$exports, "getCellDomAttrs", () => (parcelRequire("ivrsj")).getCellDomAttrs);
$parcel$export($d746fbe276da0c26$exports, "tablePrefixSelector", () => (parcelRequire("ivrsj")).tablePrefixSelector);
$parcel$export($d746fbe276da0c26$exports, "tableCellSelector", () => (parcelRequire("ivrsj")).tableCellSelector);
$parcel$export($d746fbe276da0c26$exports, "tableHeaderSelector", () => (parcelRequire("ivrsj")).tableHeaderSelector);
$parcel$export($d746fbe276da0c26$exports, "tableCellContentWrapperSelector", () => (parcelRequire("ivrsj")).tableCellContentWrapperSelector);
$parcel$export($d746fbe276da0c26$exports, "tableCellContentDomSelector", () => (parcelRequire("ivrsj")).tableCellContentDomSelector);
$parcel$export($d746fbe276da0c26$exports, "decisionList", () => (parcelRequire("frYg8")).decisionList);
$parcel$export($d746fbe276da0c26$exports, "decisionListSelector", () => (parcelRequire("frYg8")).decisionListSelector);
$parcel$export($d746fbe276da0c26$exports, "decisionItem", () => (parcelRequire("5lAbC")).decisionItem);
$parcel$export($d746fbe276da0c26$exports, "taskList", () => (parcelRequire("bc9VB")).taskList);
$parcel$export($d746fbe276da0c26$exports, "taskListSelector", () => (parcelRequire("bc9VB")).taskListSelector);
$parcel$export($d746fbe276da0c26$exports, "taskItem", () => (parcelRequire("3GSVg")).taskItem);
$parcel$export($d746fbe276da0c26$exports, "blockTaskItem", () => (parcelRequire("3GSVg")).blockTaskItem);
$parcel$export($d746fbe276da0c26$exports, "date", () => (parcelRequire("hw68I")).date);
$parcel$export($d746fbe276da0c26$exports, "dateWithLocalId", () => (parcelRequire("hw68I")).dateWithLocalId);
$parcel$export($d746fbe276da0c26$exports, "placeholder", () => (parcelRequire("l8Svu")).placeholder);
$parcel$export($d746fbe276da0c26$exports, "placeholderWithLocalId", () => (parcelRequire("l8Svu")).placeholderWithLocalId);
$parcel$export($d746fbe276da0c26$exports, "layoutSection", () => (parcelRequire("liMLZ")).layoutSection);
$parcel$export($d746fbe276da0c26$exports, "layoutSectionWithLocalId", () => (parcelRequire("liMLZ")).layoutSectionWithLocalId);
$parcel$export($d746fbe276da0c26$exports, "layoutSectionWithSingleColumn", () => (parcelRequire("liMLZ")).layoutSectionWithSingleColumn);
$parcel$export($d746fbe276da0c26$exports, "layoutSectionWithSingleColumnLocalId", () => (parcelRequire("liMLZ")).layoutSectionWithSingleColumnLocalId);
$parcel$export($d746fbe276da0c26$exports, "layoutColumn", () => (parcelRequire("1BLdm")).layoutColumn);
$parcel$export($d746fbe276da0c26$exports, "layoutColumnWithLocalId", () => (parcelRequire("1BLdm")).layoutColumnWithLocalId);
$parcel$export($d746fbe276da0c26$exports, "inlineCard", () => (parcelRequire("fLuch")).inlineCard);
$parcel$export($d746fbe276da0c26$exports, "inlineCardWithLocalId", () => (parcelRequire("fLuch")).inlineCardWithLocalId);
$parcel$export($d746fbe276da0c26$exports, "blockCard", () => (parcelRequire("5vHpv")).blockCard);
$parcel$export($d746fbe276da0c26$exports, "blockCardWithLocalId", () => (parcelRequire("5vHpv")).blockCardWithLocalId);
$parcel$export($d746fbe276da0c26$exports, "unsupportedBlock", () => (parcelRequire("8oL6j")).unsupportedBlock);
$parcel$export($d746fbe276da0c26$exports, "unsupportedInline", () => (parcelRequire("8fWld")).unsupportedInline);
$parcel$export($d746fbe276da0c26$exports, "status", () => (parcelRequire("8W1Po")).status);
$parcel$export($d746fbe276da0c26$exports, "nestedExpand", () => (parcelRequire("3x4Nz")).nestedExpand);
$parcel$export($d746fbe276da0c26$exports, "nestedExpandWithLocalId", () => (parcelRequire("3x4Nz")).nestedExpandWithLocalId);
$parcel$export($d746fbe276da0c26$exports, "embedCard", () => (parcelRequire("7r9po")).embedCard);
$parcel$export($d746fbe276da0c26$exports, "embedCardWithLocalId", () => (parcelRequire("7r9po")).embedCardWithLocalId);
$parcel$export($d746fbe276da0c26$exports, "extension", () => (parcelRequire("dmAsx")).extension);
$parcel$export($d746fbe276da0c26$exports, "inlineExtension", () => (parcelRequire("2JFVM")).inlineExtension);
$parcel$export($d746fbe276da0c26$exports, "bodiedExtension", () => (parcelRequire("cZjaR")).bodiedExtension);
$parcel$export($d746fbe276da0c26$exports, "extensionFrame", () => (parcelRequire("kRLUJ")).extensionFrame);
$parcel$export($d746fbe276da0c26$exports, "multiBodiedExtension", () => (parcelRequire("kRLUJ")).multiBodiedExtension);
$parcel$export($d746fbe276da0c26$exports, "syncBlock", () => (parcelRequire("3ZA5r")).syncBlock);
$parcel$export($d746fbe276da0c26$exports, "bodiedSyncBlock", () => (parcelRequire("ceXmR")).bodiedSyncBlock);

var $6vky0 = parcelRequire("6vky0");


var $iAg3T = parcelRequire("iAg3T");


var $8C6Yu = parcelRequire("8C6Yu");


var $l0xmR = parcelRequire("l0xmR");


var $5Tpzn = parcelRequire("5Tpzn");


var $6D9dG = parcelRequire("6D9dG");


var $76Qef = parcelRequire("76Qef");


var $7tm9l = parcelRequire("7tm9l");


var $lrauW = parcelRequire("lrauW");


var $1kn6Y = parcelRequire("1kn6Y");


var $d5tvP = parcelRequire("d5tvP");


var $bOKwh = parcelRequire("bOKwh");


var $k9bwp = parcelRequire("k9bwp");


var $86xUj = parcelRequire("86xUj");


var $hOedk = parcelRequire("hOedk");


var $8cHA0 = parcelRequire("8cHA0");


var $7uqCm = parcelRequire("7uqCm");


var $0pwCz = parcelRequire("0pwCz");


var $lJq4s = parcelRequire("lJq4s");


var $9bakv = parcelRequire("9bakv");


var $8Dbmz = parcelRequire("8Dbmz");


var $53bvm = parcelRequire("53bvm");


var $cJm3M = parcelRequire("cJm3M");


var $6CTq8 = parcelRequire("6CTq8");


var $gbkVM = parcelRequire("gbkVM");


var $ivrsj = parcelRequire("ivrsj");


var $frYg8 = parcelRequire("frYg8");


var $5lAbC = parcelRequire("5lAbC");


var $bc9VB = parcelRequire("bc9VB");


var $3GSVg = parcelRequire("3GSVg");


var $hw68I = parcelRequire("hw68I");


var $l8Svu = parcelRequire("l8Svu");


var $liMLZ = parcelRequire("liMLZ");


var $1BLdm = parcelRequire("1BLdm");


var $fLuch = parcelRequire("fLuch");


var $5vHpv = parcelRequire("5vHpv");


var $8oL6j = parcelRequire("8oL6j");


var $8fWld = parcelRequire("8fWld");


var $8W1Po = parcelRequire("8W1Po");


var $3x4Nz = parcelRequire("3x4Nz");


var $7r9po = parcelRequire("7r9po");


var $dmAsx = parcelRequire("dmAsx");


var $2JFVM = parcelRequire("2JFVM");


var $cZjaR = parcelRequire("cZjaR");


var $kRLUJ = parcelRequire("kRLUJ");


var $3ZA5r = parcelRequire("3ZA5r");


var $ceXmR = parcelRequire("ceXmR");



const $4b239387f2ba4f20$var$typedNodes = $d746fbe276da0c26$exports;
const $4b239387f2ba4f20$export$b1f729c6af6f2a6e = new Set(Object.keys($4b239387f2ba4f20$var$typedNodes).filter((key)=>$4b239387f2ba4f20$var$typedNodes[key] && $4b239387f2ba4f20$var$typedNodes[key].group === 'inline'));


var $jBbIP = parcelRequire("jBbIP");




var $1UrkW = parcelRequire("1UrkW");


var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");

const $b807d28bb87bffcf$export$3b94ef2190b2d585 = {
    FINAL: 'final',
    STAGE_0: 'stage0'
};
const $b807d28bb87bffcf$export$62d5811a2955c1d8 = [
    'fragment',
    'link',
    'em',
    'strong',
    'textColor',
    'backgroundColor',
    'strike',
    'subsup',
    'underline',
    'code',
    'confluenceInlineComment',
    'annotation',
    'dataConsumer'
];
const $b807d28bb87bffcf$export$30f8aa4cc1f8c1cb = (type)=>{
    return type === 'sub' || type === 'sup';
};
const $b807d28bb87bffcf$export$99a33ed044c278ae = (marks)=>{
    return [
        ...marks
    ].sort((a, b)=>$b807d28bb87bffcf$export$62d5811a2955c1d8.indexOf(a.type.name) - $b807d28bb87bffcf$export$62d5811a2955c1d8.indexOf(b.type.name));
};
const $b807d28bb87bffcf$export$b1304404bdc42b7a = (mark, otherMark)=>{
    if (!mark || !otherMark) return false;
    return mark.eq(otherMark);
};
const $b807d28bb87bffcf$export$fb80336a7e408cb3 = (doc, schema = (0, $1UrkW.defaultSchema), adfStage = 'final')=>{
    const node = $b807d28bb87bffcf$export$81b20b6c83a56bd(doc, schema, adfStage);
    if (node.type === 'doc') {
        node.content = $b807d28bb87bffcf$var$wrapInlineNodes(node.content);
        return node;
    }
    return null;
};
const $b807d28bb87bffcf$var$wrapInlineNodes = (nodes = [])=>{
    return nodes.map((node)=>(0, $4b239387f2ba4f20$export$b1f729c6af6f2a6e).has(node.type) ? {
            type: 'paragraph',
            content: [
                node
            ]
        } : node);
};
const $b807d28bb87bffcf$export$fafd4f799ee68da0 = (content, schema = (0, $1UrkW.defaultSchema), adfStage = 'final')=>{
    return content.map((node)=>$b807d28bb87bffcf$export$81b20b6c83a56bd(node, schema, adfStage));
};
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $b807d28bb87bffcf$var$TEXT_COLOR_PATTERN = /^#[0-9a-fA-F]{6}$/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $b807d28bb87bffcf$var$RELATIVE_LINK = /^\//;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $b807d28bb87bffcf$var$ANCHOR_LINK = /^#/;
const $b807d28bb87bffcf$var$flattenUnknownBlockTree = (node, schema = (0, $1UrkW.defaultSchema), adfStage = 'final')=>{
    const output = [];
    let isPrevLeafNode = false;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    for(let i = 0; i < node.content.length; i++){
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const childNode = node.content[i];
        const isLeafNode = !(childNode.content && childNode.content.length);
        if (i > 0) {
            if (isPrevLeafNode) output.push({
                type: 'text',
                text: ' '
            });
            else output.push({
                type: 'hardBreak'
            });
        }
        if (isLeafNode) output.push($b807d28bb87bffcf$export$81b20b6c83a56bd(childNode, schema, adfStage));
        else output.push(...$b807d28bb87bffcf$var$flattenUnknownBlockTree(childNode, schema, adfStage));
        isPrevLeafNode = isLeafNode;
    }
    return output;
};
const $b807d28bb87bffcf$export$b9908ef75cad1e0e = (node)=>{
    const { attrs: attrs = {}, content: content, text: text, type: type } = node;
    if (!content || !content.length) {
        const unknownInlineNode = {
            type: 'text',
            text: text || attrs.text || `[${type}]`
        };
        const { textUrl: textUrl } = attrs;
        if (textUrl && (0, $jBbIP.isSafeUrl)(textUrl)) unknownInlineNode.marks = [
            {
                type: 'link',
                attrs: {
                    href: textUrl
                }
            }
        ];
        return unknownInlineNode;
    }
    /*
	 * Find leaf nodes and join them. If leaf nodes' parent node is the same node
	 * join with a blank space, otherwise they are children of different branches, i.e.
	 * we need to join them with a hardBreak node
	 */ return {
        type: 'unknownBlock',
        content: $b807d28bb87bffcf$var$flattenUnknownBlockTree(node)
    };
};
const $b807d28bb87bffcf$var$getValidMarks = (marks, adfStage = 'final')=>{
    if (marks && marks.length > 0) return marks.reduce((acc, mark)=>{
        const validMark = $b807d28bb87bffcf$export$87c6d4a6ebb7d9e9(mark, adfStage);
        if (validMark) acc.push(validMark);
        return acc;
    }, []);
    return marks;
};
const $b807d28bb87bffcf$export$81b20b6c83a56bd = (originalNode, schema = (0, $1UrkW.defaultSchema), adfStage = 'final')=>{
    const { attrs: attrs, marks: marks, text: text, type: type } = originalNode;
    let { content: content } = originalNode;
    const node = {
        attrs: attrs,
        marks: marks,
        text: text,
        type: type
    };
    if (content) node.content = content = $b807d28bb87bffcf$export$fafd4f799ee68da0(content, schema, adfStage);
    // If node type doesn't exist in schema, make it an unknown node
    if (!schema.nodes[type]) return $b807d28bb87bffcf$export$b9908ef75cad1e0e(node);
    if (type) switch(type){
        case 'doc':
            {
                const { version: version } = originalNode;
                if (version && content && content.length) return {
                    type: type,
                    content: content
                };
                break;
            }
        case 'codeBlock':
            if (content) content = content.reduce((acc, val)=>{
                if (val.type === 'text') acc.push({
                    type: val.type,
                    text: val.text
                });
                return acc;
            }, []);
            if (attrs && attrs.language) return {
                type: type,
                attrs: attrs,
                content: content,
                marks: marks
            };
            return {
                type: type,
                content: content,
                marks: marks
            };
        case 'date':
            if (attrs && attrs.timestamp) return {
                type: type,
                attrs: attrs,
                ...(0, $dh538.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'status':
            if (attrs && attrs.text && attrs.color) return {
                type: type,
                attrs: attrs,
                ...(0, $dh538.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'emoji':
            if (attrs && attrs.shortName) return {
                type: type,
                attrs: attrs,
                ...(0, $dh538.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'inlineExtension':
        case 'extension':
            if (attrs && attrs.extensionType && attrs.extensionKey) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'inlineCard':
            if (attrs && (attrs.datasource && !attrs.url || attrs.url && (0, $jBbIP.isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, $jBbIP.isSafeUrl)(attrs.data.url))) return {
                type: type,
                attrs: attrs,
                ...(0, $dh538.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'blockCard':
            if (attrs && (attrs.datasource && !attrs.url || attrs.url && (0, $jBbIP.isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, $jBbIP.isSafeUrl)(attrs.data.url))) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'embedCard':
            if (attrs && (attrs.url && (0, $jBbIP.isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, $jBbIP.isSafeUrl)(attrs.data.url)) && attrs.layout) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'bodiedExtension':
            if (attrs && attrs.extensionType && attrs.extensionKey && content) return {
                type: type,
                attrs: attrs,
                content: content
            };
            break;
        case 'multiBodiedExtension':
            if (attrs && attrs.extensionType && attrs.extensionKey && content) return {
                type: type,
                attrs: attrs,
                content: content
            };
            break;
        case 'extensionFrame':
            if (content) return {
                type: type,
                attrs: attrs,
                content: content
            };
            break;
        case 'hardBreak':
            return {
                type: type
            };
        case 'caption':
            if (content) return {
                type: type,
                content: content
            };
            break;
        case 'mediaInline':
            {
                let mediaId = '';
                let mediaCollection = [];
                if (attrs) {
                    const { id: id, collection: collection } = attrs;
                    mediaId = id;
                    mediaCollection = collection;
                }
                if (mediaId && mediaCollection) return {
                    type: type,
                    attrs: attrs,
                    marks: marks
                };
                break;
            }
        case 'media':
            {
                let mediaId = '';
                let mediaType = '';
                let mediaCollection = [];
                let mediaUrl = '';
                if (attrs) {
                    const { id: id, collection: collection, type: type, url: url } = attrs;
                    mediaId = id;
                    mediaType = type;
                    mediaCollection = collection;
                    mediaUrl = url;
                }
                if (mediaType === 'external' && !!mediaUrl) {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const mediaAttrs = {
                        type: mediaType,
                        url: mediaUrl,
                        width: attrs.width,
                        height: attrs.height
                    };
                    if (attrs.alt) mediaAttrs.alt = attrs.alt;
                    const getMarks = $b807d28bb87bffcf$var$getValidMarks(marks, adfStage);
                    return getMarks ? {
                        type: type,
                        attrs: mediaAttrs,
                        marks: getMarks
                    } : {
                        type: type,
                        attrs: mediaAttrs
                    };
                } else if (mediaId && mediaType) {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const mediaAttrs = {
                        type: mediaType,
                        id: mediaId,
                        collection: mediaCollection
                    };
                    if (attrs.width) mediaAttrs.width = attrs.width;
                    if (attrs.height) mediaAttrs.height = attrs.height;
                    if (attrs.alt) mediaAttrs.alt = attrs.alt;
                    const getMarks = $b807d28bb87bffcf$var$getValidMarks(marks, adfStage);
                    return getMarks ? {
                        type: type,
                        attrs: mediaAttrs,
                        marks: getMarks
                    } : {
                        type: type,
                        attrs: mediaAttrs
                    };
                }
                break;
            }
        case 'mediaGroup':
            if (Array.isArray(content) && !content.some((e)=>e.type !== 'media')) return {
                type: type,
                content: content
            };
            break;
        case 'mediaSingle':
            {
                const containsJustMedia = Array.isArray(content) && content.length === 1 && content[0].type === 'media';
                const containsMediaAndCaption = Array.isArray(content) && content.length === 2 && content[0].type === 'media' && content[1].type === 'caption';
                if (containsJustMedia || containsMediaAndCaption) return {
                    type: type,
                    attrs: attrs,
                    content: content,
                    marks: $b807d28bb87bffcf$var$getValidMarks(marks, adfStage)
                };
                break;
            }
        case 'mention':
            {
                let mentionText = '';
                let mentionId;
                let mentionAccess;
                if (attrs) {
                    const { text: text, displayName: displayName, id: id, accessLevel: accessLevel } = attrs;
                    mentionText = text || displayName;
                    mentionId = id;
                    mentionAccess = accessLevel;
                }
                if (!mentionText) mentionText = text || '@unknown';
                if (mentionText && mentionId) {
                    const mentionNode = {
                        type: type,
                        attrs: {
                            id: mentionId,
                            text: mentionText,
                            accessLevel: ''
                        },
                        ...(0, $dh538.fg)('editor_inline_comments_on_inline_nodes') ? {
                            marks: marks
                        } : {}
                    };
                    if (mentionAccess) mentionNode.attrs.accessLevel = mentionAccess;
                    return mentionNode;
                }
                break;
            }
        case 'paragraph':
            if (adfStage === 'stage0') {
                const paragraphNode = {
                    type: type,
                    content: content || []
                };
                if (attrs && attrs.localId) paragraphNode.attrs = {
                    localId: attrs.localId
                };
                if (marks) paragraphNode.marks = [
                    ...marks
                ];
                return paragraphNode;
            }
            return marks ? {
                type: type,
                content: content || [],
                marks: marks
            } : {
                type: type,
                content: content || []
            };
        case 'rule':
            return {
                type: type
            };
        case 'text':
            {
                const { marks: marks } = node;
                if (text) return marks ? {
                    type: type,
                    text: text,
                    marks: $b807d28bb87bffcf$var$getValidMarks(marks, adfStage)
                } : {
                    type: type,
                    text: text
                };
                break;
            }
        case 'heading':
            if (attrs) {
                const { level: level } = attrs;
                const between = (x, a, b)=>x >= a && x <= b;
                if (level && between(level, 1, 6)) {
                    if (adfStage === 'stage0') {
                        const headingNode = {
                            type: type,
                            content: content,
                            attrs: {
                                level: level
                            }
                        };
                        if (attrs.localId) headingNode.attrs.localId = attrs.localId;
                        if (marks) headingNode.marks = [
                            ...marks
                        ];
                        return headingNode;
                    }
                    return marks ? {
                        type: type,
                        content: content,
                        marks: marks,
                        attrs: {
                            level: level
                        }
                    } : {
                        type: type,
                        content: content,
                        attrs: {
                            level: level
                        }
                    };
                }
            }
            break;
        case 'bulletList':
            if (content) return {
                type: type,
                content: content
            };
            break;
        case 'orderedList':
            if (content) return {
                type: type,
                content: content,
                attrs: {
                    order: attrs && attrs.order
                }
            };
            break;
        case 'listItem':
            if (content) return {
                type: type,
                content: $b807d28bb87bffcf$var$wrapInlineNodes(content)
            };
            break;
        case 'blockquote':
            if (content) return {
                type: type,
                content: content
            };
            break;
        case 'panel':
            if (attrs && content) {
                const { panelType: panelType } = attrs;
                if (Object.values((0, $0pwCz.PanelType)).includes(panelType)) return {
                    type: type,
                    attrs: attrs,
                    content: content
                };
            }
            break;
        case 'layoutSection':
            if (content) return {
                type: type,
                marks: marks,
                content: content
            };
            break;
        case 'layoutColumn':
            if (attrs && content) {
                if (attrs.width > 0 && attrs.width <= 100) return {
                    type: type,
                    content: content,
                    attrs: attrs
                };
            }
            break;
        case 'decisionList':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $ajtLB.generateUuid)()
                }
            };
        case 'decisionItem':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $ajtLB.generateUuid)(),
                    state: attrs && attrs.state || 'DECIDED'
                }
            };
        case 'taskList':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $ajtLB.generateUuid)()
                }
            };
        case 'taskItem':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $ajtLB.generateUuid)(),
                    state: attrs && attrs.state || 'TODO'
                }
            };
        case 'blockTaskItem':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $ajtLB.generateUuid)(),
                    state: attrs && attrs.state || 'TODO'
                }
            };
        case 'table':
            if (Array.isArray(content) && content.length > 0 && !content.some((e)=>e.type !== 'tableRow')) {
                if (adfStage === 'stage0') return {
                    type: type,
                    content: content,
                    attrs: {
                        ...attrs,
                        localId: attrs?.localId || (0, $ajtLB.generateUuid)(),
                        width: attrs?.width || null
                    }
                };
                return {
                    type: type,
                    content: content,
                    attrs: attrs
                };
            }
            break;
        case 'tableRow':
            if (Array.isArray(content) && content.length > 0 && !content.some((e)=>e.type !== 'tableCell' && e.type !== 'tableHeader')) return {
                type: type,
                content: content
            };
            break;
        case 'tableCell':
        case 'tableHeader':
            if (content) {
                const cellAttrs = {};
                if (attrs) {
                    if (attrs.colspan && attrs.colspan > 1) cellAttrs.colspan = attrs.colspan;
                    if (attrs.rowspan && attrs.rowspan > 1) cellAttrs.rowspan = attrs.rowspan;
                    if (attrs.background) cellAttrs.background = attrs.background;
                    if (attrs.colwidth && Array.isArray(attrs.colwidth)) cellAttrs.colwidth = attrs.colwidth;
                }
                return {
                    type: type,
                    content: $b807d28bb87bffcf$var$wrapInlineNodes(content),
                    attrs: attrs ? cellAttrs : undefined
                };
            }
            break;
        case 'image':
            if (attrs && attrs.src) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'placeholder':
            if (attrs && typeof attrs.text !== 'undefined') return {
                type: type,
                attrs: attrs
            };
            break;
        case 'expand':
        case 'nestedExpand':
            return {
                type: type,
                attrs: attrs,
                content: content,
                marks: marks
            };
        case 'syncBlock':
            if (adfStage === 'stage0' && (0, $1oCLl.expValEquals)('platform_synced_block', 'isEnabled', true)) return {
                type: type,
                attrs: attrs,
                marks: marks
            };
            else return $b807d28bb87bffcf$export$b9908ef75cad1e0e(node);
        case 'bodiedSyncBlock':
            if (adfStage === 'stage0' && attrs && Array.isArray(content) && content.length > 0 && (0, $1oCLl.expValEquals)('platform_synced_block', 'isEnabled', true)) return {
                type: type,
                attrs: attrs,
                marks: marks,
                content: content
            };
            else return $b807d28bb87bffcf$export$b9908ef75cad1e0e(node);
    }
    return $b807d28bb87bffcf$export$b9908ef75cad1e0e(node);
};
const $b807d28bb87bffcf$export$87c6d4a6ebb7d9e9 = (mark, adfStage = 'final')=>{
    const { attrs: attrs, type: type } = mark;
    if (type) switch(type){
        case 'code':
            return {
                type: type
            };
        case 'em':
            return {
                type: type
            };
        case 'link':
            if (attrs) {
                const { href: href, url: url, __confluenceMetadata: __confluenceMetadata } = attrs;
                let linkHref = href || url;
                if (linkHref && linkHref.indexOf(':') === -1 && !$b807d28bb87bffcf$var$RELATIVE_LINK.test(linkHref) && !$b807d28bb87bffcf$var$ANCHOR_LINK.test(linkHref)) linkHref = `http://${linkHref}`;
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const linkAttrs = {
                    href: linkHref
                };
                if (__confluenceMetadata) linkAttrs.__confluenceMetadata = __confluenceMetadata;
                if (linkHref && (0, $jBbIP.isSafeUrl)(linkHref)) return {
                    type: type,
                    attrs: linkAttrs
                };
            }
            break;
        case 'strike':
            return {
                type: type
            };
        case 'strong':
            return {
                type: type
            };
        case 'subsup':
            if (attrs && attrs['type']) {
                const subSupType = attrs['type'];
                if ($b807d28bb87bffcf$export$30f8aa4cc1f8c1cb(subSupType)) return {
                    type: type,
                    attrs: {
                        type: subSupType
                    }
                };
            }
            break;
        case 'textColor':
            if (attrs && $b807d28bb87bffcf$var$TEXT_COLOR_PATTERN.test(attrs.color)) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'underline':
            return {
                type: type
            };
        case 'annotation':
            return {
                type: type,
                attrs: attrs
            };
        case 'border':
            return {
                type: type,
                attrs: attrs
            };
        case 'backgroundColor':
            if (attrs && $b807d28bb87bffcf$var$TEXT_COLOR_PATTERN.test(attrs.color)) return {
                type: type,
                attrs: attrs
            };
            break;
    }
    if (adfStage === 'stage0') switch(type){
        case 'confluenceInlineComment':
            return {
                type: type,
                attrs: attrs
            };
        case 'dataConsumer':
            return {
                type: type,
                attrs: attrs
            };
        case 'fragment':
            return {
                type: type,
                attrs: attrs
            };
        case 'border':
            return {
                type: type,
                attrs: attrs
            };
    }
    return null;
};
module.exports["ADFStages"] = $b807d28bb87bffcf$export$3b94ef2190b2d585;
module.exports["getMarksByOrder"] = $b807d28bb87bffcf$export$99a33ed044c278ae;
module.exports["isSameMark"] = $b807d28bb87bffcf$export$b1304404bdc42b7a;
module.exports["getValidDocument"] = $b807d28bb87bffcf$export$fb80336a7e408cb3;
module.exports["getValidNode"] = $b807d28bb87bffcf$export$81b20b6c83a56bd;

});

parcelRegister("6vky0", function(module, exports) {

var $bCTuz = parcelRequire("bCTuz");


var $ajtLB = parcelRequire("ajtLB");

/**
 * @name expand_node
 */ /**
 * @name expand_with_no_mark_node
 */ /**
 * @name expand_root_only_node
 */ function $4bc593a5d7fe59bd$var$getExpandAttrs(domNode) {
    const dom = domNode;
    return {
        title: dom.getAttribute('data-title'),
        __expanded: true
    };
}
const $4bc593a5d7fe59bd$var$nodeSpecOptions = {
    parseDOM: [
        {
            context: 'table//',
            tag: 'div[data-node-type="expand"]',
            getAttrs: $4bc593a5d7fe59bd$var$getExpandAttrs
        },
        {
            context: 'expand//',
            tag: '[data-node-type="expand"]',
            getAttrs: $4bc593a5d7fe59bd$var$getExpandAttrs
        },
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="expand"]',
            getAttrs: $4bc593a5d7fe59bd$var$getExpandAttrs
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="expand"]',
            getAttrs: $4bc593a5d7fe59bd$var$getExpandAttrs
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'expand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
const $4bc593a5d7fe59bd$export$7b80cba28d10b2c1 = (0, $bCTuz.expand)($4bc593a5d7fe59bd$var$nodeSpecOptions);
const $4bc593a5d7fe59bd$export$2ae5e7565ff9ffa6 = (0, $bCTuz.expand)({
    parseDOM: [
        {
            context: 'table//',
            tag: 'div[data-node-type="expand"]',
            getAttrs: (dom)=>{
                const attrs = $4bc593a5d7fe59bd$var$getExpandAttrs(dom);
                return {
                    ...attrs,
                    localId: (0, $ajtLB.uuid).generate()
                };
            }
        },
        {
            context: 'expand//',
            tag: '[data-node-type="expand"]',
            getAttrs: (dom)=>{
                const attrs = $4bc593a5d7fe59bd$var$getExpandAttrs(dom);
                return {
                    ...attrs,
                    localId: (0, $ajtLB.uuid).generate()
                };
            }
        },
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="expand"]',
            getAttrs: (dom)=>{
                const attrs = $4bc593a5d7fe59bd$var$getExpandAttrs(dom);
                return {
                    ...attrs,
                    localId: (0, $ajtLB.uuid).generate()
                };
            }
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="expand"]',
            getAttrs: (dom)=>{
                const attrs = $4bc593a5d7fe59bd$var$getExpandAttrs(dom);
                return {
                    ...attrs,
                    localId: (0, $ajtLB.uuid).generate()
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const attrs = {
            'data-node-type': 'expand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded,
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $4bc593a5d7fe59bd$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).filter((key)=>!key.startsWith('__')).reduce((obj, key)=>{
            return {
                ...obj,
                [key]: node.attrs[key]
            };
        }, {})
    });
module.exports["expandWithNestedExpand"] = $4bc593a5d7fe59bd$export$7b80cba28d10b2c1;
module.exports["expandWithNestedExpandLocalId"] = $4bc593a5d7fe59bd$export$2ae5e7565ff9ffa6;
module.exports["toJSON"] = $4bc593a5d7fe59bd$export$54fd2c36b5cc6731;

});

parcelRegister("8C6Yu", function(module, exports) {

var $bCTuz = parcelRequire("bCTuz");

const $6457485796c31a84$var$name = 'confluenceUnsupportedBlock';
const $6457485796c31a84$export$e6e4878f43c27cab = (0, $bCTuz.confluenceUnsupportedBlock)({
    toDOM (node) {
        // NOTE: This node cannot be "contenteditable: false". If it's the only node in a document, PM throws an error because there's nowhere to put the cursor.
        const attrs = {
            'data-node-type': $6457485796c31a84$var$name,
            'data-confluence-unsupported': 'block',
            'data-confluence-unsupported-block-cxhtml': node.attrs['cxhtml']
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    },
    parseDOM: [
        {
            tag: `div[data-node-type="${$6457485796c31a84$var$name}"]`,
            getAttrs (dom) {
                return {
                    cxhtml: dom.getAttribute('data-confluence-unsupported-block-cxhtml')
                };
            }
        }
    ]
});
module.exports["confluenceUnsupportedBlock"] = $6457485796c31a84$export$e6e4878f43c27cab;

});

parcelRegister("l0xmR", function(module, exports) {

var $bCTuz = parcelRequire("bCTuz");

const $f4b37b31b0f6870a$var$name = 'confluenceUnsupportedInline';
const $f4b37b31b0f6870a$export$3e6d667072febc87 = (0, $bCTuz.confluenceUnsupportedInline)({
    toDOM (node) {
        const attrs = {
            'data-node-type': $f4b37b31b0f6870a$var$name,
            'data-confluence-unsupported': 'inline',
            'data-confluence-unsupported-inline-cxhtml': node.attrs['cxhtml']
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    },
    parseDOM: [
        {
            tag: `div[data-node-type="${$f4b37b31b0f6870a$var$name}"]`,
            getAttrs (dom) {
                return {
                    cxhtml: dom.getAttribute('data-confluence-unsupported-inline-cxhtml')
                };
            }
        }
    ]
});
module.exports["confluenceUnsupportedInline"] = $f4b37b31b0f6870a$export$3e6d667072febc87;

});

parcelRegister("5Tpzn", function(module, exports) {

var $bCTuz = parcelRequire("bCTuz");

const $44a5ec69314afb43$export$2a111da947c407d2 = (0, $bCTuz.doc)({});
module.exports["doc"] = $44a5ec69314afb43$export$2a111da947c407d2;

});

parcelRegister("6D9dG", function(module, exports) {

var $bCTuz = parcelRequire("bCTuz");


var $ajtLB = parcelRequire("ajtLB");

/**
 * @name blockquote_node
 */ const $4d3d8973328b48e3$var$nodeSpecOptions = {
    parseDOM: [
        {
            tag: 'blockquote'
        }
    ],
    toDOM () {
        return [
            'blockquote',
            0
        ];
    }
};
const $4d3d8973328b48e3$export$67dc04e652a298ca = (0, $bCTuz.blockquoteLegacy)($4d3d8973328b48e3$var$nodeSpecOptions);
const $4d3d8973328b48e3$export$70a64939da3e8455 = (0, $bCTuz.blockquote)($4d3d8973328b48e3$var$nodeSpecOptions);
const $4d3d8973328b48e3$var$nodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: 'blockquote',
            getAttrs: ()=>{
                return {
                    localId: (0, $ajtLB.uuid).generate()
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        return [
            'blockquote',
            {
                'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
            },
            0
        ];
    }
};
const $4d3d8973328b48e3$export$950ebf43f3364a0f = (0, $bCTuz.blockquote)($4d3d8973328b48e3$var$nodeSpecOptionsWithLocalId);
module.exports["blockquote"] = $4d3d8973328b48e3$export$67dc04e652a298ca;
module.exports["extendedBlockquote"] = $4d3d8973328b48e3$export$70a64939da3e8455;
module.exports["extendedBlockquoteWithLocalId"] = $4d3d8973328b48e3$export$950ebf43f3364a0f;

});

parcelRegister("76Qef", function(module, exports) {

var $ajtLB = parcelRequire("ajtLB");


var $bCTuz = parcelRequire("bCTuz");

const $52d19b79c909d76e$export$5f25a39efab3b58b = '.ak-ul';
const $52d19b79c909d76e$export$a140c94e5ea26bee = (0, $bCTuz.bulletList)({
    parseDOM: [
        {
            tag: 'ul'
        }
    ],
    toDOM () {
        const attrs = {
            class: $52d19b79c909d76e$export$5f25a39efab3b58b.substr(1)
        };
        return [
            'ul',
            attrs,
            0
        ];
    }
});
const $52d19b79c909d76e$export$dfd406053b2bab40 = (0, $bCTuz.bulletList)({
    parseDOM: [
        {
            tag: 'ul',
            getAttrs: ()=>{
                return {
                    localId: (0, $ajtLB.uuid).generate()
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const attrs = {
            class: $52d19b79c909d76e$export$5f25a39efab3b58b.substr(1),
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'ul',
            attrs,
            0
        ];
    }
});
module.exports["bulletListSelector"] = $52d19b79c909d76e$export$5f25a39efab3b58b;
module.exports["bulletList"] = $52d19b79c909d76e$export$a140c94e5ea26bee;
module.exports["bulletListWithLocalId"] = $52d19b79c909d76e$export$dfd406053b2bab40;

});

parcelRegister("7tm9l", function(module, exports) {

var $5SAOw = parcelRequire("5SAOw");


var $bCTuz = parcelRequire("bCTuz");


var $ajtLB = parcelRequire("ajtLB");

/**
 * @name codeBlock_with_no_marks_node
 */ /**
 * @name codeBlock_node
 */ const $570c6c4ed2eae7f1$var$getLanguageFromEditorStyle = (dom)=>{
    return dom.getAttribute('data-language') || undefined;
};
// example of BB style:
// <div class="codehilite language-javascript"><pre><span>hello world</span><span>\n</span></pre></div>
const $570c6c4ed2eae7f1$var$getLanguageFromBitbucketStyle = (dom)=>{
    if (dom && dom.classList.contains('codehilite')) // code block html from Bitbucket always contains an extra new line
    return $570c6c4ed2eae7f1$var$extractLanguageFromClass(dom.className);
    return;
};
// If there is a child code element, check that for data-language
const $570c6c4ed2eae7f1$var$getLanguageFromCode = (dom)=>{
    const firstChild = dom.firstElementChild;
    if (firstChild && firstChild.nodeName === 'CODE') return firstChild.getAttribute('data-language') || undefined;
};
const $570c6c4ed2eae7f1$var$extractLanguageFromClass = (className)=>{
    const languageRegex = /(?:^|\s)language-([^\s]+)/;
    const result = languageRegex.exec(className);
    if (result && result[1]) return result[1];
    return;
};
const $570c6c4ed2eae7f1$var$removeLastNewLine = (dom)=>{
    const parent = dom && dom.parentElement;
    if (parent && parent.classList.contains('codehilite')) dom.textContent = dom.textContent.replace(/\n$/, '');
    return dom;
};
function $570c6c4ed2eae7f1$var$parseCodeFromHtml(node) {
    let code = '';
    node.childNodes.forEach((child)=>{
        if (child.nodeType === Node.TEXT_NODE) // append text
        code += child.nodeValue;
        else if (child.nodeType === Node.ELEMENT_NODE && child instanceof Element) {
            const tagName = child.tagName.toLowerCase();
            if (tagName === 'div' || tagName === 'p') // add a newline before its content, unless it's the first child to avoid leading newlines
            {
                if (child.previousElementSibling !== null) code += '\n';
            }
            if (tagName === 'br') code += '\n';
            else code += $570c6c4ed2eae7f1$var$parseCodeFromHtml(child);
        }
    });
    return code;
}
const $570c6c4ed2eae7f1$export$7bb0d5c671655cc4 = (0, $bCTuz.codeBlock)({
    parseDOM: [
        {
            tag: 'pre',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                let dom = domNode;
                const language = $570c6c4ed2eae7f1$var$getLanguageFromBitbucketStyle(dom.parentElement) || $570c6c4ed2eae7f1$var$getLanguageFromEditorStyle(dom.parentElement) || $570c6c4ed2eae7f1$var$getLanguageFromCode(dom) || dom.getAttribute('data-language');
                dom = $570c6c4ed2eae7f1$var$removeLastNewLine(dom);
                return {
                    language: language
                };
            }
        },
        // Handle VSCode, Android Studio paste
        // Checking `white-space: pre-wrap` is too aggressive @see ED-2627
        {
            tag: 'div[style]',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                const dom = domNode;
                if (dom.style.whiteSpace === 'pre' || dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') > -1) return {};
                return false;
            },
            getContent: (domNode, schema)=>{
                const code = $570c6c4ed2eae7f1$var$parseCodeFromHtml(domNode);
                return code ? (0, $5SAOw.Fragment).from(schema.text(code)) : (0, $5SAOw.Fragment).empty;
            }
        },
        // Handle GitHub/Gist paste
        {
            tag: 'table[style]',
            preserveWhitespace: 'full',
            getAttrs: (dom)=>{
                if (dom.querySelector('td[class*="blob-code"]')) return {};
                return false;
            }
        },
        {
            tag: 'div.code-block',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                const dom = domNode;
                // TODO: ED-5604 Fix it inside `react-syntax-highlighter`
                // Remove line numbers
                const lineNumber = dom.querySelectorAll('.react-syntax-highlighter-line-number');
                if (lineNumber.length > 0) // It's possible to copy without the line numbers too hence this
                // `react-syntax-highlighter-line-number` check, so that we don't remove real code
                lineNumber.forEach((line)=>line.remove());
                return {};
            }
        }
    ],
    toDOM (node) {
        return [
            'pre',
            [
                'code',
                {
                    'data-language': node.attrs.language
                },
                0
            ]
        ];
    }
});
const $570c6c4ed2eae7f1$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((memo, key)=>{
            if (key === 'uniqueId') return memo;
            if (key === 'language' && node.attrs.language === null) return memo;
            memo[key] = node.attrs[key];
            return memo;
        }, {})
    });
const $570c6c4ed2eae7f1$export$3f75de798a0b5356 = (0, $bCTuz.codeBlock)({
    parseDOM: [
        {
            tag: 'pre',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                let dom = domNode;
                const language = $570c6c4ed2eae7f1$var$getLanguageFromBitbucketStyle(dom.parentElement) || $570c6c4ed2eae7f1$var$getLanguageFromEditorStyle(dom.parentElement) || $570c6c4ed2eae7f1$var$getLanguageFromCode(dom) || dom.getAttribute('data-language');
                dom = $570c6c4ed2eae7f1$var$removeLastNewLine(dom);
                return {
                    language: language,
                    localId: (0, $ajtLB.uuid).generate()
                };
            }
        },
        // Handle VSCode, Android Studio paste
        // Checking `white-space: pre-wrap` is too aggressive @see ED-2627
        {
            tag: 'div[style]',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                const dom = domNode;
                if (dom.style.whiteSpace === 'pre' || dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') > -1) return {};
                return false;
            },
            getContent: (domNode, schema)=>{
                const code = $570c6c4ed2eae7f1$var$parseCodeFromHtml(domNode);
                return code ? (0, $5SAOw.Fragment).from(schema.text(code)) : (0, $5SAOw.Fragment).empty;
            }
        },
        // Handle GitHub/Gist paste
        {
            tag: 'table[style]',
            preserveWhitespace: 'full',
            getAttrs: (dom)=>{
                if (dom.querySelector('td[class*="blob-code"]')) return {};
                return false;
            }
        },
        {
            tag: 'div.code-block',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                const dom = domNode;
                // TODO: ED-5604 Fix it inside `react-syntax-highlighter`
                // Remove line numbers
                const lineNumber = dom.querySelectorAll('.react-syntax-highlighter-line-number');
                if (lineNumber.length > 0) // It's possible to copy without the line numbers too hence this
                // `react-syntax-highlighter-line-number` check, so that we don't remove real code
                lineNumber.forEach((line)=>line.remove());
                return {};
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const attrs = {
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'pre',
            attrs,
            [
                'code',
                {
                    'data-language': node.attrs.language
                },
                0
            ]
        ];
    }
});
module.exports["codeBlock"] = $570c6c4ed2eae7f1$export$7bb0d5c671655cc4;
module.exports["toJSON"] = $570c6c4ed2eae7f1$export$54fd2c36b5cc6731;
module.exports["codeBlockWithLocalId"] = $570c6c4ed2eae7f1$export$3f75de798a0b5356;

});

parcelRegister("lrauW", function(module, exports) {

var $bCTuz = parcelRequire("bCTuz");

const $f9b4434c75e34ca5$export$371da9dd35aba193 = (0, $bCTuz.hardBreak)({
    parseDOM: [
        {
            tag: 'br'
        }
    ],
    toDOM () {
        return [
            'br'
        ];
    }
});
module.exports["hardBreak"] = $f9b4434c75e34ca5$export$371da9dd35aba193;

});

parcelRegister("1kn6Y", function(module, exports) {

var $bCTuz = parcelRequire("bCTuz");

/**
 * @name heading_node
 */ /**
 * @name heading_with_no_marks_node
 */ // Check `paragraph` node for why we are doing things like this
/**
 * @name heading_with_alignment_node
 */ /**
 * @name heading_with_indentation_node
 */ const $0f79962412a97794$var$getAttrs = (level)=>(domNode)=>{
        var _heading$attrs, _heading$attrs$localI;
        return {
            level: level,
            localId: domNode.getAttribute('data-local-id') || ((_heading$attrs = $0f79962412a97794$export$46e4a324ac90507f.attrs) === null || _heading$attrs === void 0 ? void 0 : (_heading$attrs$localI = _heading$attrs.localId) === null || _heading$attrs$localI === void 0 ? void 0 : _heading$attrs$localI.default)
        };
    };
const $0f79962412a97794$export$46e4a324ac90507f = (0, $bCTuz.heading)({
    parseDOM: [
        {
            tag: 'h1',
            getAttrs: $0f79962412a97794$var$getAttrs(1)
        },
        {
            tag: 'h2',
            getAttrs: $0f79962412a97794$var$getAttrs(2)
        },
        {
            tag: 'h3',
            getAttrs: $0f79962412a97794$var$getAttrs(3)
        },
        {
            tag: 'h4',
            getAttrs: $0f79962412a97794$var$getAttrs(4)
        },
        {
            tag: 'h5',
            getAttrs: $0f79962412a97794$var$getAttrs(5)
        },
        {
            tag: 'h6',
            getAttrs: $0f79962412a97794$var$getAttrs(6)
        }
    ],
    toDOM (node) {
        const { level: level, localId: localId } = node.attrs;
        const name = 'h' + level;
        const attrs = localId !== undefined && localId !== null ? [
            {
                'data-local-id': localId
            }
        ] : [];
        return [
            name,
            ...attrs,
            0
        ];
    }
});
module.exports["heading"] = $0f79962412a97794$export$46e4a324ac90507f;

});

parcelRegister("d5tvP", function(module, exports) {

var $bCTuz = parcelRequire("bCTuz");


var $ajtLB = parcelRequire("ajtLB");

/**
 * @name rule_node
 */ const $9872a2871057beb6$var$hrDOM = [
    'hr'
];
const $9872a2871057beb6$export$fbeb3a3956e8a3c7 = (0, $bCTuz.rule)({
    parseDOM: [
        {
            tag: 'hr'
        }
    ],
    toDOM () {
        return $9872a2871057beb6$var$hrDOM;
    }
});
const $9872a2871057beb6$export$bf3ef6fb6ad90e7 = (0, $bCTuz.rule)({
    parseDOM: [
        {
            tag: 'hr',
            getAttrs: ()=>({
                    localId: (0, $ajtLB.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        var _node$attrs;
        return [
            'hr',
            {
                'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
            }
        ];
    }
});
module.exports["rule"] = $9872a2871057beb6$export$fbeb3a3956e8a3c7;
module.exports["ruleWithLocalId"] = $9872a2871057beb6$export$bf3ef6fb6ad90e7;

});

parcelRegister("bOKwh", function(module, exports) {

var $ajtLB = parcelRequire("ajtLB");


var $bCTuz = parcelRequire("bCTuz");

const $89a8731233c8b286$export$4e7125c7ff595be5 = '.ak-ol';
const $89a8731233c8b286$export$a5dc81035676e7a = (0, $bCTuz.orderedList)({
    parseDOM: [
        {
            tag: 'ol'
        }
    ],
    toDOM () {
        const attrs = {
            class: $89a8731233c8b286$export$4e7125c7ff595be5.substr(1)
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});
const $89a8731233c8b286$export$8157adc5747ec436 = (0, $bCTuz.orderedList)({
    parseDOM: [
        {
            tag: 'ol',
            getAttrs: ()=>({
                    localId: (0, $ajtLB.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const attrs = {
            class: $89a8731233c8b286$export$4e7125c7ff595be5.substr(1),
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});
// resolve "start" to a safe, 0+ integer, otherwise return undefined
// Note: Any changes to this function should also be made to "resolveOrder"
// in packages/editor/editor-common/src/utils/list.ts
const $89a8731233c8b286$var$resolveStart = (start)=>{
    const num = Number(start);
    if (Number.isNaN(num)) return;
    if (num < 0) return;
    return Math.floor(Math.max(num, 0));
};
const $89a8731233c8b286$export$b9ab759e8298198f = (0, $bCTuz.orderedList)({
    parseDOM: [
        {
            tag: 'ol',
            getAttrs: (domNode)=>{
                const dom = domNode;
                const startDOMAttr = dom.getAttribute('start');
                if (startDOMAttr) {
                    const start = $89a8731233c8b286$var$resolveStart(startDOMAttr);
                    if (typeof start === 'number') return {
                        order: start
                    };
                }
                return null;
            }
        }
    ],
    toDOM (node) {
        var _node$attrs2;
        const start = $89a8731233c8b286$var$resolveStart(node === null || node === void 0 ? void 0 : (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.order);
        const attrs = {
            start: typeof start === 'number' ? String(start) : undefined,
            class: $89a8731233c8b286$export$4e7125c7ff595be5.substr(1)
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});
const $89a8731233c8b286$export$2ea3505d41d7525d = (0, $bCTuz.orderedList)({
    parseDOM: [
        {
            tag: 'ol',
            getAttrs: (domNode)=>{
                const dom = domNode;
                const startDOMAttr = dom.getAttribute('start');
                const localId = (0, $ajtLB.uuid).generate();
                if (startDOMAttr) {
                    const start = $89a8731233c8b286$var$resolveStart(startDOMAttr);
                    if (typeof start === 'number') return {
                        order: start,
                        localId: localId
                    };
                }
                return {
                    localId: localId
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs3, _node$attrs4;
        const start = $89a8731233c8b286$var$resolveStart(node === null || node === void 0 ? void 0 : (_node$attrs3 = node.attrs) === null || _node$attrs3 === void 0 ? void 0 : _node$attrs3.order);
        const attrs = {
            start: typeof start === 'number' ? String(start) : undefined,
            class: $89a8731233c8b286$export$4e7125c7ff595be5.substr(1),
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs4 = node.attrs) === null || _node$attrs4 === void 0 ? void 0 : _node$attrs4.localId) || undefined
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});
module.exports["orderedListSelector"] = $89a8731233c8b286$export$4e7125c7ff595be5;
module.exports["orderedList"] = $89a8731233c8b286$export$a5dc81035676e7a;
module.exports["orderedListWithLocalId"] = $89a8731233c8b286$export$8157adc5747ec436;
module.exports["orderedListWithOrder"] = $89a8731233c8b286$export$b9ab759e8298198f;
module.exports["orderedListWithOrderAndLocalId"] = $89a8731233c8b286$export$2ea3505d41d7525d;

});

parcelRegister("k9bwp", function(module, exports) {

var $bCTuz = parcelRequire("bCTuz");

const $eaad95e74c0f31d5$export$9c206ddddb32a9b = (0, $bCTuz.paragraph)({
    parseDOM: [
        {
            tag: 'p',
            getAttrs: (domNode)=>{
                var _paragraph$attrs, _paragraph$attrs$loca;
                const dom = domNode;
                const attrs = {
                    localId: dom.getAttribute('data-local-id') || ((_paragraph$attrs = $eaad95e74c0f31d5$export$9c206ddddb32a9b.attrs) === null || _paragraph$attrs === void 0 ? void 0 : (_paragraph$attrs$loca = _paragraph$attrs.localId) === null || _paragraph$attrs$loca === void 0 ? void 0 : _paragraph$attrs$loca.default)
                };
                return attrs;
            }
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const name = 'p';
        const attrs = localId !== undefined && localId !== null ? [
            {
                'data-local-id': localId
            }
        ] : [];
        return [
            name,
            ...attrs,
            0
        ];
    }
});
module.exports["paragraph"] = $eaad95e74c0f31d5$export$9c206ddddb32a9b;

});

parcelRegister("8cHA0", function(module, exports) {

var $ajtLB = parcelRequire("ajtLB");


var $bCTuz = parcelRequire("bCTuz");

let $5f913fbe4a20c76a$export$abebb208988c258 = /*#__PURE__*/ function(USER_TYPES) {
    USER_TYPES["DEFAULT"] = "DEFAULT";
    USER_TYPES["SPECIAL"] = "SPECIAL";
    USER_TYPES["APP"] = "APP";
    return USER_TYPES;
}({});
const $5f913fbe4a20c76a$export$db83999c14438df4 = (0, $bCTuz.mention)({
    parseDOM: [
        {
            tag: 'span[data-mention-id]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                const attrs = {
                    id: dom.getAttribute('data-mention-id') || $5f913fbe4a20c76a$export$db83999c14438df4.attrs.id.default,
                    text: dom.textContent || $5f913fbe4a20c76a$export$db83999c14438df4.attrs.text.default,
                    accessLevel: dom.getAttribute('data-access-level') || $5f913fbe4a20c76a$export$db83999c14438df4.attrs.accessLevel.default,
                    localId: (0, $ajtLB.uuid).generate()
                };
                const userType = dom.getAttribute('data-user-type');
                if ($5f913fbe4a20c76a$export$abebb208988c258[userType]) attrs.userType = userType;
                return attrs;
            }
        }
    ],
    toDOM (node) {
        const { id: id, accessLevel: accessLevel, text: text, userType: userType, localId: localId } = node.attrs;
        const attrs = {
            'data-mention-id': id,
            'data-access-level': accessLevel,
            contenteditable: 'false'
        };
        if (localId) attrs['data-local-id'] = localId;
        if (userType) attrs['data-user-type'] = userType;
        return [
            'span',
            attrs,
            text
        ];
    }
});
const $5f913fbe4a20c76a$var$isOptional = (key)=>{
    return [
        'userType',
        'localId'
    ].indexOf(key) > -1;
};
const $5f913fbe4a20c76a$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((obj, key)=>{
            if ($5f913fbe4a20c76a$var$isOptional(key) && !node.attrs[key]) return obj;
            return {
                ...obj,
                [key]: node.attrs[key]
            };
        }, {})
    });
module.exports["mention"] = $5f913fbe4a20c76a$export$db83999c14438df4;
module.exports["toJSON"] = $5f913fbe4a20c76a$export$54fd2c36b5cc6731;

});

parcelRegister("7uqCm", function(module, exports) {

var $ajtLB = parcelRequire("ajtLB");


var $bCTuz = parcelRequire("bCTuz");

const $573ffb72a058930a$export$76c7e83ecc9cdf05 = (0, $bCTuz.listItem)({
    parseDOM: [
        {
            tag: 'li'
        }
    ],
    toDOM () {
        return [
            'li',
            0
        ];
    }
});
const $573ffb72a058930a$export$483d52f09158e61c = (0, $bCTuz.listItem)({
    parseDOM: [
        {
            tag: 'li',
            getAttrs: ()=>({
                    localId: (0, $ajtLB.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        var _node$attrs;
        return [
            'li',
            {
                'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
            },
            0
        ];
    }
});
const $573ffb72a058930a$export$b2cd54d5ce935ddb = (0, $bCTuz.listItemWithNestedDecisionStage0)({
    parseDOM: [
        {
            tag: 'li'
        }
    ],
    toDOM () {
        return [
            'li',
            0
        ];
    }
});
const $573ffb72a058930a$export$394466eb252d967a = (0, $bCTuz.listItemWithNestedDecisionStage0)({
    parseDOM: [
        {
            tag: 'li',
            getAttrs: ()=>({
                    localId: (0, $ajtLB.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        var _node$attrs2;
        return [
            'li',
            {
                'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.localId) || undefined
            },
            0
        ];
    }
});
module.exports["listItem"] = $573ffb72a058930a$export$76c7e83ecc9cdf05;
module.exports["listItemWithLocalId"] = $573ffb72a058930a$export$483d52f09158e61c;
module.exports["listItemWithDecisionStage0"] = $573ffb72a058930a$export$b2cd54d5ce935ddb;

});

parcelRegister("0pwCz", function(module, exports) {

var $bCTuz = parcelRequire("bCTuz");


var $ajtLB = parcelRequire("ajtLB");

let $0013ccf6ec03b3f5$export$969277cf61e5a7aa = /*#__PURE__*/ function(PanelType) {
    PanelType["INFO"] = "info";
    PanelType["NOTE"] = "note";
    PanelType["TIP"] = "tip";
    PanelType["WARNING"] = "warning";
    PanelType["ERROR"] = "error";
    PanelType["SUCCESS"] = "success";
    PanelType["CUSTOM"] = "custom";
    return PanelType;
}({});
/**
 * @name panel_node
 */ const $0013ccf6ec03b3f5$var$getDomAttrs = (nodeAttrs)=>{
    const attrs = {
        'data-panel-type': nodeAttrs.panelType,
        'data-panel-icon': nodeAttrs.panelIcon,
        'data-panel-icon-id': nodeAttrs.panelIconId,
        'data-panel-icon-text': nodeAttrs.panelIconText,
        'data-panel-color': nodeAttrs.panelColor,
        'data-local-id': (nodeAttrs === null || nodeAttrs === void 0 ? void 0 : nodeAttrs.localId) || undefined
    };
    return attrs;
};
const $0013ccf6ec03b3f5$var$getParseDOMAttrs = (allowCustomPanel, dom, generateLocalId)=>{
    let parseDOMAttrs = {
        panelType: dom.getAttribute('data-panel-type')
    };
    if (generateLocalId) parseDOMAttrs.localId = (0, $ajtLB.uuid).generate();
    if (allowCustomPanel) parseDOMAttrs = {
        ...parseDOMAttrs,
        panelIcon: dom.getAttribute('data-panel-icon'),
        panelIconId: dom.getAttribute('data-panel-icon-id'),
        panelIconText: dom.getAttribute('data-panel-icon-text'),
        panelColor: dom.getAttribute('data-panel-color')
    };
    else parseDOMAttrs.panelType = parseDOMAttrs.panelType === $0013ccf6ec03b3f5$export$969277cf61e5a7aa.CUSTOM ? $0013ccf6ec03b3f5$export$969277cf61e5a7aa.INFO : parseDOMAttrs.panelType;
    return parseDOMAttrs;
};
const $0013ccf6ec03b3f5$var$createPanelNodeSpecOptions = (allowCustomPanel, generateLocalId)=>({
        parseDOM: [
            {
                tag: 'div[data-panel-type]',
                getAttrs: (dom)=>$0013ccf6ec03b3f5$var$getParseDOMAttrs(allowCustomPanel, dom, generateLocalId)
            }
        ],
        toDOM (node) {
            const attrs = $0013ccf6ec03b3f5$var$getDomAttrs(node.attrs);
            const contentAttrs = {
                'data-panel-content': 'true'
            };
            return [
                'div',
                attrs,
                [
                    'div',
                    contentAttrs,
                    0
                ]
            ];
        }
    });
const $0013ccf6ec03b3f5$export$ce20b13564211141 = (allowCustomPanel)=>(0, $bCTuz.panel)($0013ccf6ec03b3f5$var$createPanelNodeSpecOptions(allowCustomPanel));
const $0013ccf6ec03b3f5$export$855c3c67c9c9ebaf = (allowCustomPanel)=>(0, $bCTuz.panel)($0013ccf6ec03b3f5$var$createPanelNodeSpecOptions(allowCustomPanel, true));
module.exports["PanelType"] = $0013ccf6ec03b3f5$export$969277cf61e5a7aa;
module.exports["extendedPanel"] = $0013ccf6ec03b3f5$export$ce20b13564211141;
module.exports["extendedPanelWithLocalId"] = $0013ccf6ec03b3f5$export$855c3c67c9c9ebaf;

});

parcelRegister("lJq4s", function(module, exports) {

var $bCTuz = parcelRequire("bCTuz");

const $fd22061423258a30$export$6f093cfa640b7166 = (0, $bCTuz.text)({
    toDebugString: ()=>'text_node'
});
module.exports["text"] = $fd22061423258a30$export$6f093cfa640b7166;

});

parcelRegister("8Dbmz", function(module, exports) {

var $bCTuz = parcelRequire("bCTuz");


var $ajtLB = parcelRequire("ajtLB");

const $648ac7b82504a6f4$export$8e3c2dfdc4f0453d = (0, $bCTuz.caption)({
    parseDOM: [
        {
            tag: 'figcaption[data-caption]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-caption': 'true'
        };
        return [
            'figcaption',
            attrs,
            0
        ];
    }
});
const $648ac7b82504a6f4$export$b5d01ee303c467aa = (0, $bCTuz.caption)({
    parseDOM: [
        {
            tag: 'figcaption[data-caption]',
            getAttrs: ()=>{
                return {
                    localId: (0, $ajtLB.uuid).generate()
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const attrs = {
            'data-caption': 'true',
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'figcaption',
            attrs,
            0
        ];
    }
});
module.exports["caption"] = $648ac7b82504a6f4$export$8e3c2dfdc4f0453d;
module.exports["captionWithLocalId"] = $648ac7b82504a6f4$export$b5d01ee303c467aa;

});

parcelRegister("53bvm", function(module, exports) {

var $eoZWa = parcelRequire("eoZWa");


var $bCTuz = parcelRequire("bCTuz");


var $ajtLB = parcelRequire("ajtLB");

const $3ad62828819b7911$export$bb3fe706be61f640 = (0, $bCTuz.media)({}).attrs;
const $3ad62828819b7911$export$35bdbf5bc8caa677 = (attributes, inline = false, generateLocalId = false)=>{
    const domNodeType = inline ? 'span' : 'div';
    const nodeName = inline ? 'mediaInline' : 'media';
    const parseDOM = [
        {
            tag: `${domNodeType}[data-node-type="${nodeName}"]`,
            getAttrs: (dom)=>{
                const attrs = {};
                if (attributes) Object.keys(attributes).forEach((k)=>{
                    const key = $3ad62828819b7911$export$f84fdfb973c05bd8(k).replace(/^__/, '');
                    const value = dom.getAttribute(`data-${key}`) || '';
                    if (value) attrs[k] = value;
                });
                // Need to do validation & type conversion manually
                if (attrs.__fileSize) attrs.__fileSize = +attrs.__fileSize;
                const width = Number(attrs.width);
                if (typeof width !== 'undefined' && !isNaN(width)) attrs.width = width;
                const height = Number(attrs.height);
                if (typeof height !== 'undefined' && !isNaN(height)) attrs.height = height;
                if (generateLocalId) attrs.localId = (0, $ajtLB.uuid).generate();
                return attrs;
            }
        },
        // Don't match data URI
        {
            tag: 'img[src^="data:image"]',
            ignore: true
        }
    ];
    const toDOM = (node)=>{
        const attrs = {
            'data-id': node.attrs.id,
            'data-node-type': `${nodeName}`,
            'data-type': node.attrs.type,
            'data-collection': node.attrs.collection,
            'data-occurrence-key': node.attrs.occurrenceKey,
            'data-width': node.attrs.width,
            'data-height': node.attrs.height,
            'data-url': node.attrs.url,
            'data-alt': node.attrs.alt,
            'data-local-id': node.attrs.localId || undefined,
            // toDOM is used for static rendering as well as editor rendering. This comes into play for
            // emails, copy/paste, etc, so the title and styling here *is* useful (despite a React-based
            // node view being used for editing).
            title: 'Attachment',
            // Manually kept in sync with the style of media cards. The goal is to render a plain gray
            // rectangle that provides an affordance for media.
            style: `display: inline-block; border-radius: 3px; background: ${(0, $eoZWa.N30)}; box-shadow: 0 1px 1px rgba(9, 30, 66, 0.2), 0 0 1px 0 rgba(9, 30, 66, 0.24);`
        };
        $3ad62828819b7911$export$111130fa8968d741(node.attrs, attrs, (key)=>`data-${$3ad62828819b7911$export$f84fdfb973c05bd8(key.slice(2))}`);
        return [
            `${domNodeType}`,
            attrs
        ];
    };
    if (inline) return (0, $bCTuz.mediaInline)({
        parseDOM: parseDOM,
        toDOM: toDOM
    });
    return (0, $bCTuz.media)({
        parseDOM: [
            ...parseDOM,
            {
                // media-inline.ts uses this same function to generate the nodespec
                // this ensures that we don't make a media inline out of a copied image
                // https://product-fabric.atlassian.net/browse/EDM-2996
                tag: 'img:not(.smart-link-icon)',
                getAttrs: (dom)=>{
                    const attrs = {
                        type: 'external',
                        url: dom.getAttribute('src') || '',
                        alt: dom.getAttribute('alt') || ''
                    };
                    if (generateLocalId) attrs.localId = (0, $ajtLB.uuid).generate();
                    return attrs;
                }
            }
        ],
        toDOM: toDOM
    });
};
const $3ad62828819b7911$export$987d49ffe1b0900f = $3ad62828819b7911$export$35bdbf5bc8caa677($3ad62828819b7911$export$bb3fe706be61f640, false, false);
const $3ad62828819b7911$export$8446e47a4c7fd000 = $3ad62828819b7911$export$35bdbf5bc8caa677({
    ...$3ad62828819b7911$export$bb3fe706be61f640,
    localId: {
        default: (0, $ajtLB.uuid).generate()
    }
}, false, true);
const $3ad62828819b7911$export$f84fdfb973c05bd8 = (str)=>str.replace(/([^A-Z]+)([A-Z])/g, (_, x, y)=>`${x}-${y.toLowerCase()}`);
const $3ad62828819b7911$export$111130fa8968d741 = (from, to, map)=>{
    if ($3ad62828819b7911$export$987d49ffe1b0900f.attrs) Object.keys($3ad62828819b7911$export$987d49ffe1b0900f.attrs).forEach((key)=>{
        if (key[0] === '_' && key[1] === '_' && from[key]) to[map ? map(key) : key] = from[key];
    });
};
/**
 * There's no concept of optional property in ProseMirror. It sets value as `null`
 * when there's no use of any property. We are filtering out all private & optional attrs here.
 */ const $3ad62828819b7911$var$optionalAttributes = [
    'occurrenceKey',
    'width',
    'height',
    'url',
    'alt',
    'localId'
];
const $3ad62828819b7911$var$externalOnlyAttributes = [
    'type',
    'url',
    'width',
    'height',
    'alt',
    'localId'
];
const $3ad62828819b7911$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs)// Strip private attributes e.g. __fileName, __fileSize, __fileMimeType, etc.
        .filter((key)=>!(key[0] === '_' && key[1] === '_')).reduce((obj, key)=>{
            if (node.attrs.type === 'external' && $3ad62828819b7911$var$externalOnlyAttributes.indexOf(key) === -1) return obj;
            if ($3ad62828819b7911$var$optionalAttributes.indexOf(key) > -1 && (node.attrs[key] === null || node.attrs[key] === '')) return obj;
            if ([
                'width',
                'height'
            ].indexOf(key) !== -1) {
                obj[key] = Number(node.attrs[key]);
                return obj;
            }
            obj[key] = node.attrs[key];
            return obj;
        }, {})
    });
module.exports["createMediaSpec"] = $3ad62828819b7911$export$35bdbf5bc8caa677;
module.exports["copyPrivateAttributes"] = $3ad62828819b7911$export$111130fa8968d741;
module.exports["media"] = $3ad62828819b7911$export$987d49ffe1b0900f;
module.exports["toJSON"] = $3ad62828819b7911$export$54fd2c36b5cc6731;

});

parcelRegister("eoZWa", function(module, exports) {
var $764b67d5f16b57c2$exports = {};
$764b67d5f16b57c2$exports = JSON.parse("{\"aliceblue\":\"#f0f8ff\",\"antiquewhite\":\"#faebd7\",\"aqua\":\"#00ffff\",\"aquamarine\":\"#7fffd4\",\"azure\":\"#f0ffff\",\"beige\":\"#f5f5dc\",\"bisque\":\"#ffe4c4\",\"black\":\"#000000\",\"blanchedalmond\":\"#ffebcd\",\"blue\":\"#0000ff\",\"blueviolet\":\"#8a2be2\",\"brown\":\"#a52a2a\",\"burlywood\":\"#deb887\",\"cadetblue\":\"#5f9ea0\",\"chartreuse\":\"#7fff00\",\"chocolate\":\"#d2691e\",\"coral\":\"#ff7f50\",\"cornflowerblue\":\"#6495ed\",\"cornsilk\":\"#fff8dc\",\"crimson\":\"#dc143c\",\"cyan\":\"#00ffff\",\"darkblue\":\"#00008b\",\"darkcyan\":\"#008b8b\",\"darkgoldenrod\":\"#b8860b\",\"darkgray\":\"#a9a9a9\",\"darkgreen\":\"#006400\",\"darkgrey\":\"#a9a9a9\",\"darkkhaki\":\"#bdb76b\",\"darkmagenta\":\"#8b008b\",\"darkolivegreen\":\"#556b2f\",\"darkorange\":\"#ff8c00\",\"darkorchid\":\"#9932cc\",\"darkred\":\"#8b0000\",\"darksalmon\":\"#e9967a\",\"darkseagreen\":\"#8fbc8f\",\"darkslateblue\":\"#483d8b\",\"darkslategray\":\"#2f4f4f\",\"darkslategrey\":\"#2f4f4f\",\"darkturquoise\":\"#00ced1\",\"darkviolet\":\"#9400d3\",\"deeppink\":\"#ff1493\",\"deepskyblue\":\"#00bfff\",\"dimgray\":\"#696969\",\"dimgrey\":\"#696969\",\"dodgerblue\":\"#1e90ff\",\"firebrick\":\"#b22222\",\"floralwhite\":\"#fffaf0\",\"forestgreen\":\"#228b22\",\"fuchsia\":\"#ff00ff\",\"gainsboro\":\"#dcdcdc\",\"ghostwhite\":\"#f8f8ff\",\"gold\":\"#ffd700\",\"goldenrod\":\"#daa520\",\"gray\":\"#808080\",\"green\":\"#008000\",\"greenyellow\":\"#adff2f\",\"grey\":\"#808080\",\"honeydew\":\"#f0fff0\",\"hotpink\":\"#ff69b4\",\"indianred\":\"#cd5c5c\",\"indigo\":\"#4b0082\",\"ivory\":\"#fffff0\",\"khaki\":\"#f0e68c\",\"lavender\":\"#e6e6fa\",\"lavenderblush\":\"#fff0f5\",\"lawngreen\":\"#7cfc00\",\"lemonchiffon\":\"#fffacd\",\"lightblue\":\"#add8e6\",\"lightcoral\":\"#f08080\",\"lightcyan\":\"#e0ffff\",\"lightgoldenrodyellow\":\"#fafad2\",\"lightgray\":\"#d3d3d3\",\"lightgreen\":\"#90ee90\",\"lightgrey\":\"#d3d3d3\",\"lightpink\":\"#ffb6c1\",\"lightsalmon\":\"#ffa07a\",\"lightseagreen\":\"#20b2aa\",\"lightskyblue\":\"#87cefa\",\"lightslategray\":\"#778899\",\"lightslategrey\":\"#778899\",\"lightsteelblue\":\"#b0c4de\",\"lightyellow\":\"#ffffe0\",\"lime\":\"#00ff00\",\"limegreen\":\"#32cd32\",\"linen\":\"#faf0e6\",\"magenta\":\"#ff00ff\",\"maroon\":\"#800000\",\"mediumaquamarine\":\"#66cdaa\",\"mediumblue\":\"#0000cd\",\"mediumorchid\":\"#ba55d3\",\"mediumpurple\":\"#9370db\",\"mediumseagreen\":\"#3cb371\",\"mediumslateblue\":\"#7b68ee\",\"mediumspringgreen\":\"#00fa9a\",\"mediumturquoise\":\"#48d1cc\",\"mediumvioletred\":\"#c71585\",\"midnightblue\":\"#191970\",\"mintcream\":\"#f5fffa\",\"mistyrose\":\"#ffe4e1\",\"moccasin\":\"#ffe4b5\",\"navajowhite\":\"#ffdead\",\"navy\":\"#000080\",\"oldlace\":\"#fdf5e6\",\"olive\":\"#808000\",\"olivedrab\":\"#6b8e23\",\"orange\":\"#ffa500\",\"orangered\":\"#ff4500\",\"orchid\":\"#da70d6\",\"palegoldenrod\":\"#eee8aa\",\"palegreen\":\"#98fb98\",\"paleturquoise\":\"#afeeee\",\"palevioletred\":\"#db7093\",\"papayawhip\":\"#ffefd5\",\"peachpuff\":\"#ffdab9\",\"peru\":\"#cd853f\",\"pink\":\"#ffc0cb\",\"plum\":\"#dda0dd\",\"powderblue\":\"#b0e0e6\",\"purple\":\"#800080\",\"rebeccapurple\":\"#663399\",\"red\":\"#ff0000\",\"rosybrown\":\"#bc8f8f\",\"royalblue\":\"#4169e1\",\"saddlebrown\":\"#8b4513\",\"salmon\":\"#fa8072\",\"sandybrown\":\"#f4a460\",\"seagreen\":\"#2e8b57\",\"seashell\":\"#fff5ee\",\"sienna\":\"#a0522d\",\"silver\":\"#c0c0c0\",\"skyblue\":\"#87ceeb\",\"slateblue\":\"#6a5acd\",\"slategray\":\"#708090\",\"slategrey\":\"#708090\",\"snow\":\"#fffafa\",\"springgreen\":\"#00ff7f\",\"steelblue\":\"#4682b4\",\"tan\":\"#d2b48c\",\"teal\":\"#008080\",\"thistle\":\"#d8bfd8\",\"tomato\":\"#ff6347\",\"turquoise\":\"#40e0d0\",\"violet\":\"#ee82ee\",\"wheat\":\"#f5deb3\",\"white\":\"#ffffff\",\"whitesmoke\":\"#f5f5f5\",\"yellow\":\"#ffff00\",\"yellowgreen\":\"#9acd32\"}");


const $a7c359fe6a2dff20$export$4b84fd0e2c617bd = '#FFEBE6';
const $a7c359fe6a2dff20$export$b34b069eff244586 = '#FFBDAD';
const $a7c359fe6a2dff20$export$be802dd0d8b57f35 = '#FF8F73';
const $a7c359fe6a2dff20$export$4a7404f376229999 = '#FF5630';
const $a7c359fe6a2dff20$export$2010d0fb4295b346 = '#DE350B';
const $a7c359fe6a2dff20$export$2837b5a1a71d5c02 = '#BF2600';
const $a7c359fe6a2dff20$export$8d9596b529bbb9cf = '#FFFAE6';
const $a7c359fe6a2dff20$export$41060a744ab0b7ae = '#FFF0B3';
const $a7c359fe6a2dff20$export$5aae31392d72caaa = '#FFC400';
const $a7c359fe6a2dff20$export$fc857b6f8771648a = '#F8E6A0';
const $a7c359fe6a2dff20$export$59619663aa6500fb = '#FF991F';
const $a7c359fe6a2dff20$export$874739ea9e379ab6 = '#FF8B00';
const $a7c359fe6a2dff20$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $a7c359fe6a2dff20$export$69a3bf21b9686c2b = '#ABF5D1';
const $a7c359fe6a2dff20$export$747d86715d4175de = '#57D9A3';
const $a7c359fe6a2dff20$export$940e1f69e873f202 = '#36B37E';
const $a7c359fe6a2dff20$export$a49394138f7b8e85 = '#00875A';
const $a7c359fe6a2dff20$export$6fa04827ac68a4fb = '#006644';
const $a7c359fe6a2dff20$export$226de0355ed012f8 = '#DEEBFF';
const $a7c359fe6a2dff20$export$8c13c2ee36917869 = '#B3D4FF';
const $a7c359fe6a2dff20$export$ecfc1dff386a3e7a = '#4C9AFF';
const $a7c359fe6a2dff20$export$b3de0ae08da2ce64 = '#0052CC';
const $a7c359fe6a2dff20$export$a6ee3d71bc067634 = '#0747A6';
const $a7c359fe6a2dff20$export$f72948ef771f6f15 = '#D3F1A7';
const $a7c359fe6a2dff20$export$29a4f05edc054374 = '#FFFFFF';
const $a7c359fe6a2dff20$export$9fdfb749e33cdf97 = '#F4F5F7';
const $a7c359fe6a2dff20$export$3e51e8f1440314ba = '#EBECF0';
const $a7c359fe6a2dff20$export$1ce2d1575d444ceb = '#DFE1E6';
const $a7c359fe6a2dff20$export$8754fc7e6d8b3000 = '#C1C7D0';
const $a7c359fe6a2dff20$export$c2e91cbeada39b8b = '#B3BAC5';
const $a7c359fe6a2dff20$export$eaa8c8a70ac22806 = '#97A0AF';
const $a7c359fe6a2dff20$export$7c87d337fb91a97d = '#8993A4';
const $a7c359fe6a2dff20$export$f563ee71e9ee74cd = '#6B778C';
const $a7c359fe6a2dff20$export$e2ef2124cf4024b1 = '#5E6C84';
const $a7c359fe6a2dff20$export$1ae1cebe22dcedb4 = '#DCDFE4';
const $a7c359fe6a2dff20$export$13609db0e6812ab8 = '#091E4224';
const $a7c359fe6a2dff20$export$c39c0fe0f26207ae = '#42526E';
const $a7c359fe6a2dff20$export$7090862dc3038a9f = '#758195';
const $a7c359fe6a2dff20$export$7d61b15e0da132af = '#172B4D';
const $a7c359fe6a2dff20$export$f78789c8b01753cd = '#172B4D';
const $a7c359fe6a2dff20$export$a19f0c33186f7767 = '#FDD0EC';
const $a7c359fe6a2dff20$export$51716a84e62e022c = '#FEDEC8';
const $a7c359fe6a2dff20$export$363e4475840015bb = '#EAE6FF';
const $a7c359fe6a2dff20$export$4b0a4417ed59760f = '#C0B6F2';
const $a7c359fe6a2dff20$export$6011520a64d9a187 = '#998DD9';
const $a7c359fe6a2dff20$export$a7175d4e9206bc80 = '#DFD8FD';
const $a7c359fe6a2dff20$export$b48405b95304b5a1 = '#6554C0';
const $a7c359fe6a2dff20$export$c71e4279dd54a18d = '#5243AA';
const $a7c359fe6a2dff20$export$147899de772240ec = '#403294';
const $a7c359fe6a2dff20$export$2cf711fe14c66f06 = '#E6FCFF';
const $a7c359fe6a2dff20$export$7a8f4d33f6f9772c = '#B3F5FF';
const $a7c359fe6a2dff20$export$776c9c497ef08533 = '#79E2F2';
const $a7c359fe6a2dff20$export$69cb3ca10c1e330e = '#C6EDFB';
const $a7c359fe6a2dff20$export$9dc1ef0f3f48059b = '#00B8D9';
const $a7c359fe6a2dff20$export$6036577f95c3877e = '#008DA6';
function $a7c359fe6a2dff20$export$b61655071712e690(color, defaultColor) {
    if (!color) return null;
    // Normalize to hex
    color = color.trim().toLowerCase();
    if ($a7c359fe6a2dff20$export$8a9b6341a7c96bc(color)) // Normalize 3-hex to 6-hex colours
    {
        if (color.length === 4) color = color.split('').map((c)=>c === '#' ? '#' : `${c}${c}`).join('');
    } else if ($a7c359fe6a2dff20$export$e698776ec826343(color)) return $a7c359fe6a2dff20$export$34d09c4a771c46ef(color);
    else {
        // http://dev.w3.org/csswg/css-color/#named-colors
        if (color === 'default') return null;
        else if ($764b67d5f16b57c2$exports.default && $764b67d5f16b57c2$exports.default[color]) color = $764b67d5f16b57c2$exports.default[color];
        else if ($764b67d5f16b57c2$exports && $764b67d5f16b57c2$exports[color]) color = $764b67d5f16b57c2$exports[color];
        else return null;
    }
    if (color === defaultColor) return null;
    return color;
}
function $a7c359fe6a2dff20$export$5a544e13ad4e1fa5(color) {
    if (!$a7c359fe6a2dff20$export$8a9b6341a7c96bc(color)) return null;
    let colorBits = color.substring(1).split('');
    if (colorBits.length === 3) colorBits = [
        colorBits[0],
        colorBits[0],
        colorBits[1],
        colorBits[1],
        colorBits[2],
        colorBits[2]
    ];
    const rgb = Number(`0x${colorBits.join('')}`);
    // eslint-disable-next-line no-bitwise
    return `rgb(${rgb >> 16 & 255},${rgb >> 8 & 255},${rgb & 255})`;
}
function $a7c359fe6a2dff20$export$9665a07d9187b414(rawColor, alpha) {
    const color = $a7c359fe6a2dff20$export$b61655071712e690(rawColor);
    if (!color) return null;
    const hex2rgb = (color)=>color.match(/[a-z0-9]{2}/gi).map((hex)=>parseInt(hex, 16));
    return `rgba(${hex2rgb(color).concat(alpha).join(',')})`;
}
function $a7c359fe6a2dff20$export$34d09c4a771c46ef(value) {
    const matches = value.match(/(0?\.?\d{1,3})%?\b/g);
    if (matches && matches.length >= 3) {
        const [red, green, blue] = matches.map(Number);
        return '#' + (blue | green << 8 | red << 16 | 16777216).toString(16).slice(1) // eslint-disable-line no-bitwise
        ;
    }
    return null;
}
function $a7c359fe6a2dff20$export$e698776ec826343(color) {
    return /rgba?\(/.test(color);
}
function $a7c359fe6a2dff20$export$8a9b6341a7c96bc(color) {
    return /^#([A-Fa-f0-9]{3}){1,2}$/.test(color);
}
module.exports["R50"] = $a7c359fe6a2dff20$export$4b84fd0e2c617bd;
module.exports["R75"] = $a7c359fe6a2dff20$export$b34b069eff244586;
module.exports["R100"] = $a7c359fe6a2dff20$export$be802dd0d8b57f35;
module.exports["R300"] = $a7c359fe6a2dff20$export$4a7404f376229999;
module.exports["R500"] = $a7c359fe6a2dff20$export$2837b5a1a71d5c02;
module.exports["Y50"] = $a7c359fe6a2dff20$export$8d9596b529bbb9cf;
module.exports["Y75"] = $a7c359fe6a2dff20$export$41060a744ab0b7ae;
module.exports["Y200"] = $a7c359fe6a2dff20$export$5aae31392d72caaa;
module.exports["Yellow200"] = $a7c359fe6a2dff20$export$fc857b6f8771648a;
module.exports["Y400"] = $a7c359fe6a2dff20$export$59619663aa6500fb;
module.exports["G50"] = $a7c359fe6a2dff20$export$8a6341c32b6a3ee6;
module.exports["G75"] = $a7c359fe6a2dff20$export$69a3bf21b9686c2b;
module.exports["G200"] = $a7c359fe6a2dff20$export$747d86715d4175de;
module.exports["G300"] = $a7c359fe6a2dff20$export$940e1f69e873f202;
module.exports["G500"] = $a7c359fe6a2dff20$export$6fa04827ac68a4fb;
module.exports["B50"] = $a7c359fe6a2dff20$export$226de0355ed012f8;
module.exports["B75"] = $a7c359fe6a2dff20$export$8c13c2ee36917869;
module.exports["B100"] = $a7c359fe6a2dff20$export$ecfc1dff386a3e7a;
module.exports["B400"] = $a7c359fe6a2dff20$export$b3de0ae08da2ce64;
module.exports["B500"] = $a7c359fe6a2dff20$export$a6ee3d71bc067634;
module.exports["L200"] = $a7c359fe6a2dff20$export$f72948ef771f6f15;
module.exports["N0"] = $a7c359fe6a2dff20$export$29a4f05edc054374;
module.exports["N20"] = $a7c359fe6a2dff20$export$9fdfb749e33cdf97;
module.exports["N30"] = $a7c359fe6a2dff20$export$3e51e8f1440314ba;
module.exports["N60"] = $a7c359fe6a2dff20$export$c2e91cbeada39b8b;
module.exports["N80"] = $a7c359fe6a2dff20$export$eaa8c8a70ac22806;
module.exports["Neutral300"] = $a7c359fe6a2dff20$export$1ae1cebe22dcedb4;
module.exports["N300A"] = $a7c359fe6a2dff20$export$13609db0e6812ab8;
module.exports["N600"] = $a7c359fe6a2dff20$export$7090862dc3038a9f;
module.exports["N800"] = $a7c359fe6a2dff20$export$7d61b15e0da132af;
module.exports["N1000"] = $a7c359fe6a2dff20$export$f78789c8b01753cd;
module.exports["M200"] = $a7c359fe6a2dff20$export$a19f0c33186f7767;
module.exports["O200"] = $a7c359fe6a2dff20$export$51716a84e62e022c;
module.exports["P50"] = $a7c359fe6a2dff20$export$363e4475840015bb;
module.exports["P75"] = $a7c359fe6a2dff20$export$4b0a4417ed59760f;
module.exports["P100"] = $a7c359fe6a2dff20$export$6011520a64d9a187;
module.exports["P200"] = $a7c359fe6a2dff20$export$a7175d4e9206bc80;
module.exports["P300"] = $a7c359fe6a2dff20$export$b48405b95304b5a1;
module.exports["P500"] = $a7c359fe6a2dff20$export$147899de772240ec;
module.exports["T50"] = $a7c359fe6a2dff20$export$2cf711fe14c66f06;
module.exports["T75"] = $a7c359fe6a2dff20$export$7a8f4d33f6f9772c;
module.exports["T100"] = $a7c359fe6a2dff20$export$776c9c497ef08533;
module.exports["T200"] = $a7c359fe6a2dff20$export$69cb3ca10c1e330e;
module.exports["T300"] = $a7c359fe6a2dff20$export$9dc1ef0f3f48059b;
module.exports["T500"] = $a7c359fe6a2dff20$export$6036577f95c3877e;
module.exports["normalizeHexColor"] = $a7c359fe6a2dff20$export$b61655071712e690;
module.exports["isHex"] = $a7c359fe6a2dff20$export$8a9b6341a7c96bc;
module.exports["isRgb"] = $a7c359fe6a2dff20$export$e698776ec826343;
module.exports["rgbToHex"] = $a7c359fe6a2dff20$export$34d09c4a771c46ef;
module.exports["hexToRgb"] = $a7c359fe6a2dff20$export$5a544e13ad4e1fa5;
module.exports["hexToRgba"] = $a7c359fe6a2dff20$export$9665a07d9187b414;

});

parcelRegister("cJm3M", function(module, exports) {

var $bCTuz = parcelRequire("bCTuz");

const $944accadc956ed4a$export$2855e964765eac9 = (0, $bCTuz.mediaGroup)({
    parseDOM: [
        {
            tag: 'div[data-node-type="mediaGroup"]'
        },
        {
            tag: 'div[class="MediaGroup"]'
        }
    ],
    toDOM () {
        return [
            'div',
            {
                'data-node-type': 'mediaGroup'
            },
            0
        ];
    }
});
module.exports["mediaGroup"] = $944accadc956ed4a$export$2855e964765eac9;

});

parcelRegister("6CTq8", function(module, exports) {

var $53bvm = parcelRequire("53bvm");


var $ajtLB = parcelRequire("ajtLB");


var $bCTuz = parcelRequire("bCTuz");

const $4d31480c25d60381$export$38bab695e3f720f1 = (0, $53bvm.createMediaSpec)((0, $bCTuz.mediaInline)({}).attrs, true);
const $4d31480c25d60381$export$aea8e9c496505c61 = (0, $53bvm.createMediaSpec)({
    ...(0, $bCTuz.mediaInline)({}).attrs,
    localId: {
        default: (0, $ajtLB.uuid).generate()
    }
}, true, true);
module.exports["mediaInline"] = $4d31480c25d60381$export$38bab695e3f720f1;

});

parcelRegister("gbkVM", function(module, exports) {
/**
 * @description The widthType attribute is used to support fixed with media single
 */ let $3e9ba7564d9febd1$export$4d41558722ac7eed = /*#__PURE__*/ function(WidthType) {
    WidthType["PIXEL"] = "pixel";
    WidthType["PERCENTAGE"] = "percentage";
    return WidthType;
}({});



var $filql = parcelRequire("filql");


var $bCTuz = parcelRequire("bCTuz");


var $ajtLB = parcelRequire("ajtLB");

const $bc7de8e5108cca26$export$bb3fe706be61f640 = {
    width: {
        default: null
    },
    // null makes small images to have original size by default
    layout: {
        default: 'center'
    }
};
const $bc7de8e5108cca26$export$5a1e124099b60c6b = ({ withCaption: withCaption = false, withExtendedWidthTypes: withExtendedWidthTypes = false, generateLocalId: generateLocalId = false })=>{
    const getAttrs = (dom)=>{
        if (!(0, $filql.isDOMElement)(dom)) // this should never happen
        return {
            layout: 'center'
        };
        const layout = dom.getAttribute('data-layout') || 'center';
        const width = Number(dom.getAttribute('data-width')) || null;
        const widthType = dom.getAttribute('data-width-type');
        if (generateLocalId) return {
            layout: layout,
            width: width,
            widthType: widthType,
            localId: (0, $ajtLB.uuid).generate()
        };
        if (withExtendedWidthTypes) return {
            layout: layout,
            width: width,
            widthType: widthType
        };
        else if (widthType === (0, $3e9ba7564d9febd1$export$4d41558722ac7eed).PIXEL) // if editor does not support widthType attribute.
        // We ignore width and widthType together.
        return {
            layout: layout
        };
        else return {
            layout: layout,
            width: width
        };
    };
    const getAttrsFromNode = (node)=>{
        const { layout: layout, width: width } = node.attrs;
        const attrs = {
            'data-node-type': 'mediaSingle',
            'data-layout': layout,
            'data-width': ''
        };
        if (generateLocalId) {
            var _node$attrs;
            attrs['data-local-id'] = (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined;
        }
        if (width) attrs['data-width'] = isFinite(width) && Math.floor(width) === width ? width : width.toFixed(2);
        if (withExtendedWidthTypes && node.attrs.widthType) {
            const { widthType: widthType } = node.attrs;
            return {
                ...attrs,
                'data-width-type': widthType || (0, $3e9ba7564d9febd1$export$4d41558722ac7eed).PERCENTAGE
            };
        }
        return attrs;
    };
    if (withExtendedWidthTypes && withCaption) return (0, $bCTuz.mediaSingleFull)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    if (withExtendedWidthTypes && !withCaption) return (0, $bCTuz.mediaSingleWidthType)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    if (!withExtendedWidthTypes && withCaption) return (0, $bCTuz.mediaSingleCaption)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    return (0, $bCTuz.mediaSingle)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
};
const $bc7de8e5108cca26$export$969fe3781ca15058 = $bc7de8e5108cca26$export$5a1e124099b60c6b({
    withCaption: false,
    withExtendedWidthTypes: false
});
const $bc7de8e5108cca26$export$d35e6c006d4abdfb = $bc7de8e5108cca26$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: false
});
const $bc7de8e5108cca26$export$9c58e19811ce4cf5 = $bc7de8e5108cca26$export$5a1e124099b60c6b({
    withCaption: false,
    withExtendedWidthTypes: true
});
const $bc7de8e5108cca26$export$7e767666f2ce108a = $bc7de8e5108cca26$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: true
});
const $bc7de8e5108cca26$export$75376a385837c942 = $bc7de8e5108cca26$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: true,
    generateLocalId: true
});
const $bc7de8e5108cca26$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((obj, key)=>{
            if (node.attrs[key] !== null) obj[key] = node.attrs[key];
            return obj;
        }, {})
    });
module.exports["mediaSingleSpec"] = $bc7de8e5108cca26$export$5a1e124099b60c6b;
module.exports["mediaSingle"] = $bc7de8e5108cca26$export$969fe3781ca15058;
module.exports["mediaSingleWithCaption"] = $bc7de8e5108cca26$export$d35e6c006d4abdfb;
module.exports["mediaSingleWithWidthType"] = $bc7de8e5108cca26$export$9c58e19811ce4cf5;
module.exports["mediaSingleFull"] = $bc7de8e5108cca26$export$7e767666f2ce108a;
module.exports["mediaSingleFullWithLocalId"] = $bc7de8e5108cca26$export$75376a385837c942;
module.exports["toJSON"] = $bc7de8e5108cca26$export$54fd2c36b5cc6731;

});

parcelRegister("ivrsj", function(module, exports) {

var $bxopY = parcelRequire("bxopY");


var $eoZWa = parcelRequire("eoZWa");


var $ajtLB = parcelRequire("ajtLB");


var $bAH9E = parcelRequire("bAH9E");


var $bCTuz = parcelRequire("bCTuz");

const $d7906b5f150ffb1c$export$9cfceb893b24742a = 'pm-table';
const $d7906b5f150ffb1c$export$69cb4c3f80383763 = `${$d7906b5f150ffb1c$export$9cfceb893b24742a}-cell-content-wrap`;
const $d7906b5f150ffb1c$export$7b07d37d879c957f = `${$d7906b5f150ffb1c$export$9cfceb893b24742a}-header-content-wrap`;
const $d7906b5f150ffb1c$export$8dd42a84cd52da07 = `${$d7906b5f150ffb1c$export$9cfceb893b24742a}-cell-nodeview-wrapper`;
const $d7906b5f150ffb1c$export$5e26a5c19f0865d8 = `${$d7906b5f150ffb1c$export$9cfceb893b24742a}-cell-nodeview-content-dom`;
const $d7906b5f150ffb1c$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND = (0, $eoZWa.N20).toLocaleLowerCase();
const $d7906b5f150ffb1c$export$43977bde391e007 = (dom, defaultValues = {})=>{
    const widthAttr = dom.getAttribute('data-colwidth');
    const width = widthAttr && /^\d+(,\d+)*$/.test(widthAttr) ? widthAttr.split(',').map((str)=>Number(str)) : null;
    const colspan = Number(dom.getAttribute('colspan') || 1);
    let { backgroundColor: backgroundColor } = dom.style;
    /**
   * We have pivoted to store background color information in
   *  data-cell-background.
   * We will have original hex code (which we map to DST token)
   *  stored in data-cell-background, use that.
   * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
   */ const dataCellBackground = dom.getAttribute('data-cell-background');
    const dataCellBackgroundHexCode = dataCellBackground && (0, $eoZWa.isHex)(dataCellBackground) ? dataCellBackground : undefined;
    // ignore setting background attr if ds neutral token is detected
    if (backgroundColor.includes('--ds-background-neutral')) backgroundColor = '';
    else if (backgroundColor && (0, $eoZWa.isRgb)(backgroundColor)) {
        const result = (0, $eoZWa.rgbToHex)(backgroundColor);
        if (result !== null) backgroundColor = result;
    }
    const backgroundHexCode = dataCellBackgroundHexCode || (backgroundColor && backgroundColor !== defaultValues['background'] ? backgroundColor : null);
    const localId = defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.localId;
    return {
        colspan: colspan,
        rowspan: Number(dom.getAttribute('rowspan') || 1),
        colwidth: width && width.length === colspan ? width : null,
        background: backgroundHexCode,
        ...localId && {
            localId: localId
        }
    };
};
// these are for test only
let $d7906b5f150ffb1c$var$testGlobalTheme;
const $d7906b5f150ffb1c$export$fd7e0dd2b74807f7 = (theme)=>{
    $d7906b5f150ffb1c$var$testGlobalTheme = theme;
};
// This is a minimal duplication of the method from @atlaskit/tokens
// to minimise the number of dependencies required as these changes are expected
// to be patched onto CR8.
const $d7906b5f150ffb1c$var$getGlobalTheme = ()=>{
    // This should only be hit during tests.
    //
    // At time of writing Jest mocks are not working in this repository.
    if ($d7906b5f150ffb1c$var$testGlobalTheme) return {
        colorMode: $d7906b5f150ffb1c$var$testGlobalTheme
    };
    const element = document.documentElement;
    const colorMode = element.getAttribute('data-color-mode') || '';
    return {
        colorMode: colorMode
    };
};
const $d7906b5f150ffb1c$var$cssVariablePattern = /^var\(--.*\)$/;
const $d7906b5f150ffb1c$export$363c8dda799bfe9c = (node)=>{
    var _node$attrs;
    const attrs = {};
    const nodeType = node.type.name;
    if (node.attrs.colspan !== 1) attrs.colspan = node.attrs.colspan;
    if (node.attrs.rowspan !== 1) attrs.rowspan = node.attrs.rowspan;
    if (node.attrs.colwidth) attrs['data-colwidth'] = node.attrs.colwidth.join(',');
    if (node.attrs.background) {
        const { background: background } = node.attrs;
        // to ensure that we don't overwrite product's style:
        // - it clears background color for <th> if its set to gray
        // - it clears background color for <td> if its set to white
        // - it clears background color for <th> if ds neutral token is detected
        const ignored = nodeType === 'tableHeader' && background === $d7906b5f150ffb1c$export$8cc2833b5b349a1e.get('light gray') || nodeType === 'tableCell' && background === $d7906b5f150ffb1c$export$8cc2833b5b349a1e.get('white') || nodeType === 'tableHeader' && background.includes('--ds-background-neutral');
        if (ignored) attrs.style = '';
        else {
            const color = (0, $eoZWa.isRgb)(background) && (0, $eoZWa.rgbToHex)(background) ? (0, $eoZWa.rgbToHex)(background) : background;
            /**
       * The Editor supports users pasting content from external sources with custom table cell backgrounds and having those
       * backgrounds persisted.
       *
       * This feature predates the introduction of dark mode.
       *
       * Without the inversion logic below, tokenised content (ie. text), can be hard to read when the user loads the page in dark mode.
       *
       * This introduces inversion of the presentation of the custom background color when the user is in dark mode.
       *
       * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
       * how we detect table cell background colors copied from external editor sources. Where we load the background color from a
       * seperate attribute (data-cell-background), instead of the inline style.
       *
       * See the following document for more details on this behaviour
       * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2892247168/Unsupported+custom+table+cell+background+colors+in+dark+theme+Editor+Job+Story
       */ const tokenColor = (0, $bxopY.hexToEditorBackgroundPaletteRawValue)(color);
            if (tokenColor) attrs.style = `background-color: ${tokenColor};`;
            else if (/**
       * There was previously a bug in dark mode where we would attempt to invert
       * a design token in `getDarkModeLCHColor` causing issues.
       * If it's a design token we should return it as is.
       */ $d7906b5f150ffb1c$var$cssVariablePattern.test(color)) attrs.style = `background-color: ${color};`;
            else // if we have a custom color, we need to check if we are in dark mode
            if ($d7906b5f150ffb1c$var$getGlobalTheme().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
            attrs.style = `background-color: ${(0, $bAH9E.getDarkModeLCHColor)(color)};`;
            else // if we are in light mode, we can just set the color
            attrs.style = `background-color: ${background};`;
            /**
       * Storing hex code in data-cell-background because
       *  we want to have DST token (css variable) or
       *  DST token value (value (hex code) of css variable) in
       *  inline style to correct render table cell background
       *  based on selected theme.
       * Currently we rely on background color hex code stored in
       *  inline style.
       * Because of that when we copy and paste table, we end up
       *  having DST token or DST token value in ADF instead of
       *  original hex code which we map to DST token.
       * So, introducing data-cell-background.
       * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
       */ if (color) attrs['data-cell-background'] = color;
            if (typeof color === 'string') attrs.colorname = $d7906b5f150ffb1c$export$219b7f492ad209f8.get(color.toLowerCase());
        }
    }
    if (nodeType === 'tableHeader') attrs.class = $d7906b5f150ffb1c$export$7b07d37d879c957f;
    else attrs.class = $d7906b5f150ffb1c$export$69cb4c3f80383763;
    if (node !== null && node !== void 0 && (_node$attrs = node.attrs) !== null && _node$attrs !== void 0 && _node$attrs.localId) attrs['data-local-id'] = node.attrs.localId;
    return attrs;
};
const $d7906b5f150ffb1c$export$219b7f492ad209f8 = new Map();
const $d7906b5f150ffb1c$export$95e9c925fbf01d1c = (0, $eoZWa.hexToRgba)((0, $eoZWa.N800), 0.12) || (0, $eoZWa.N0);
const $d7906b5f150ffb1c$export$8cc2833b5b349a1e = new Map();
[
    [
        (0, $eoZWa.N0),
        'White'
    ],
    [
        (0, $eoZWa.B50),
        'Light blue'
    ],
    [
        (0, $eoZWa.T50),
        'Light teal'
    ],
    [
        (0, $eoZWa.G50),
        'Light green'
    ],
    [
        (0, $eoZWa.Y50),
        'Light yellow'
    ],
    [
        (0, $eoZWa.R50),
        'Light red'
    ],
    [
        (0, $eoZWa.P50),
        'Light purple'
    ],
    [
        (0, $eoZWa.N20),
        'Light gray'
    ],
    [
        (0, $eoZWa.B75),
        'Blue'
    ],
    [
        (0, $eoZWa.T75),
        'Teal'
    ],
    [
        (0, $eoZWa.G75),
        'Green'
    ],
    [
        (0, $eoZWa.Y75),
        'Yellow'
    ],
    [
        (0, $eoZWa.R75),
        'Red'
    ],
    [
        (0, $eoZWa.P75),
        'Purple'
    ],
    [
        (0, $eoZWa.N60),
        'Gray'
    ],
    [
        (0, $eoZWa.B100),
        'Dark blue'
    ],
    [
        (0, $eoZWa.T100),
        'Dark teal'
    ],
    [
        (0, $eoZWa.G200),
        'Dark green'
    ],
    [
        (0, $eoZWa.Y200),
        'Dark yellow'
    ],
    [
        (0, $eoZWa.R100),
        'Dark red'
    ],
    [
        (0, $eoZWa.P100),
        'Dark purple'
    ]
].forEach(([colorValue, colorName])=>{
    $d7906b5f150ffb1c$export$219b7f492ad209f8.set(colorValue.toLowerCase(), colorName);
    $d7906b5f150ffb1c$export$8cc2833b5b349a1e.set(colorName.toLowerCase(), colorValue.toLowerCase());
});
/**
 * @name table_node
 */ /**
 * @name table_row_node
 */ /**
 * @name table_cell_content
 * @minItems 1
 * @allowUnsupportedBlock true
 */ /**
 * @name table_cell_node
 */ /**
 * @name table_header_node
 */ // table nodes with nested tables support
const $d7906b5f150ffb1c$var$tableNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'table',
            getAttrs: (node)=>{
                var _dom$parentElement;
                const dom = node;
                const breakoutWrapper = (_dom$parentElement = dom.parentElement) === null || _dom$parentElement === void 0 ? void 0 : _dom$parentElement.parentElement;
                return {
                    isNumberColumnEnabled: dom.getAttribute('data-number-column') === 'true',
                    layout: // copying from editor
                    dom.getAttribute('data-layout') || // copying from renderer
                    (breakoutWrapper === null || breakoutWrapper === void 0 ? void 0 : breakoutWrapper.getAttribute('data-layout')) || 'default',
                    __autoSize: dom.getAttribute('data-autosize') === 'true',
                    localId: dom.getAttribute('data-table-local-id') || (0, $ajtLB.uuid).generate(),
                    width: Number(dom.getAttribute('data-table-width')) || null,
                    displayMode: dom.getAttribute('data-table-display-mode') || null
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-number-column': node.attrs.isNumberColumnEnabled,
            'data-layout': node.attrs.layout,
            'data-autosize': node.attrs.__autoSize,
            'data-table-local-id': node.attrs.localId,
            'data-table-width': node.attrs.width,
            'data-table-display-mode': node.attrs.displayMode
        };
        return [
            'table',
            attrs,
            [
                'tbody',
                0
            ]
        ];
    }
};
// TODO: Fix any, potential issue. ED-5048
const $d7906b5f150ffb1c$var$createTableSpec = ()=>(0, $bCTuz.table)($d7906b5f150ffb1c$var$tableNodeSpecOptions);
const $d7906b5f150ffb1c$export$9852986a3ec5f6a0 = $d7906b5f150ffb1c$var$createTableSpec();
const $d7906b5f150ffb1c$export$90e634fbace1f0c4 = $d7906b5f150ffb1c$var$createTableSpec();
const $d7906b5f150ffb1c$export$3862de5c8c9098cf = $d7906b5f150ffb1c$var$createTableSpec();
const $d7906b5f150ffb1c$var$shouldIncludeAttribute = (key, value)=>!key.startsWith('__') && (key !== 'localId' || !!value);
const $d7906b5f150ffb1c$export$1f92a2f429e06fa8 = (node)=>({
        attrs: Object.keys(node.attrs).filter((key)=>$d7906b5f150ffb1c$var$shouldIncludeAttribute(key, node.attrs[key])).reduce((obj, key)=>{
            return {
                ...obj,
                [key]: node.attrs[key]
            };
        }, {})
    });
const $d7906b5f150ffb1c$var$tableRowNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'tr'
        }
    ],
    toDOM () {
        return [
            'tr',
            0
        ];
    }
};
const $d7906b5f150ffb1c$export$ce666bf02318c957 = (0, $bCTuz.tableRow)($d7906b5f150ffb1c$var$tableRowNodeSpecOptions);
const $d7906b5f150ffb1c$var$cellAttrs = {
    colspan: {
        default: 1
    },
    rowspan: {
        default: 1
    },
    colwidth: {
        default: null
    },
    background: {
        default: null
    },
    localId: {
        default: null,
        optional: true
    }
};
const $d7906b5f150ffb1c$var$tableCellNodeSpecOptions = {
    parseDOM: [
        // Ignore number cell copied from renderer
        {
            tag: '.ak-renderer-table-number-column',
            ignore: true
        },
        {
            tag: 'td',
            getAttrs: (dom)=>$d7906b5f150ffb1c$export$43977bde391e007(dom)
        }
    ],
    toDOM: (node)=>[
            'td',
            $d7906b5f150ffb1c$export$363c8dda799bfe9c(node),
            0
        ]
};
const $d7906b5f150ffb1c$export$e1e720e5f4603e6a = (0, $bCTuz.tableCell)($d7906b5f150ffb1c$var$tableCellNodeSpecOptions);
const $d7906b5f150ffb1c$export$2ac34c099660f1a8 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((obj, key)=>{
            // Only process keys that are defined in cellAttrs
            if ($d7906b5f150ffb1c$var$cellAttrs[key] && $d7906b5f150ffb1c$var$cellAttrs[key].default !== node.attrs[key]) obj[key] = node.attrs[key];
            return obj;
        }, {})
    });
const $d7906b5f150ffb1c$var$tableHeaderNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'th',
            getAttrs: (dom)=>$d7906b5f150ffb1c$export$43977bde391e007(dom, {
                    background: $d7906b5f150ffb1c$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND
                })
        }
    ],
    toDOM: (node)=>[
            'th',
            $d7906b5f150ffb1c$export$363c8dda799bfe9c(node),
            0
        ]
};
const $d7906b5f150ffb1c$export$48884d2a5190dc73 = (0, $bCTuz.tableHeader)($d7906b5f150ffb1c$var$tableHeaderNodeSpecOptions);
const $d7906b5f150ffb1c$export$2af48797a1010bb1 = $d7906b5f150ffb1c$export$2ac34c099660f1a8;
const $d7906b5f150ffb1c$export$ce086a560a1d05f5 = (0, $bCTuz.tableWithNestedTable)($d7906b5f150ffb1c$var$tableNodeSpecOptions);
const $d7906b5f150ffb1c$export$7d657479499397 = (0, $bCTuz.tableRowWithNestedTable)($d7906b5f150ffb1c$var$tableRowNodeSpecOptions);
const $d7906b5f150ffb1c$export$abf39ca178940ff3 = (0, $bCTuz.tableCellWithNestedTable)($d7906b5f150ffb1c$var$tableCellNodeSpecOptions);
const $d7906b5f150ffb1c$export$2a5a518232fa1a97 = (0, $bCTuz.tableHeaderWithNestedTable)($d7906b5f150ffb1c$var$tableHeaderNodeSpecOptions);
// table nodes with localId support
const $d7906b5f150ffb1c$var$tableRowNodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: 'tr',
            getAttrs: ()=>({
                    localId: (0, $ajtLB.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        var _node$attrs2;
        return [
            'tr',
            {
                'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.localId) || undefined
            },
            0
        ];
    }
};
const $d7906b5f150ffb1c$export$c8f0853ac97552c9 = (0, $bCTuz.tableRow)($d7906b5f150ffb1c$var$tableRowNodeSpecOptionsWithLocalId);
const $d7906b5f150ffb1c$var$tableCellNodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: 'td',
            getAttrs: (dom)=>$d7906b5f150ffb1c$export$43977bde391e007(dom, {
                    localId: (0, $ajtLB.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        return [
            'td',
            $d7906b5f150ffb1c$export$363c8dda799bfe9c(node),
            0
        ];
    }
};
const $d7906b5f150ffb1c$export$db76cfd28a574029 = (0, $bCTuz.tableCell)($d7906b5f150ffb1c$var$tableCellNodeSpecOptionsWithLocalId);
const $d7906b5f150ffb1c$var$tableHeaderNodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: 'th',
            getAttrs: (dom)=>$d7906b5f150ffb1c$export$43977bde391e007(dom, {
                    background: $d7906b5f150ffb1c$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND,
                    localId: (0, $ajtLB.uuid).generate()
                })
        }
    ],
    toDOM: (node)=>[
            'th',
            $d7906b5f150ffb1c$export$363c8dda799bfe9c(node),
            0
        ]
};
const $d7906b5f150ffb1c$export$b82d2b1d8824143d = (0, $bCTuz.tableHeader)($d7906b5f150ffb1c$var$tableHeaderNodeSpecOptionsWithLocalId);
const $d7906b5f150ffb1c$export$27926e30c8a74147 = (0, $bCTuz.tableRowWithNestedTable)($d7906b5f150ffb1c$var$tableRowNodeSpecOptionsWithLocalId);
const $d7906b5f150ffb1c$export$e9fd700fafee293a = (0, $bCTuz.tableCellWithNestedTable)($d7906b5f150ffb1c$var$tableCellNodeSpecOptionsWithLocalId);
const $d7906b5f150ffb1c$export$7928c3aeb4cd2213 = (0, $bCTuz.tableHeaderWithNestedTable)($d7906b5f150ffb1c$var$tableHeaderNodeSpecOptionsWithLocalId);
module.exports["tablePrefixSelector"] = $d7906b5f150ffb1c$export$9cfceb893b24742a;
module.exports["tableCellSelector"] = $d7906b5f150ffb1c$export$69cb4c3f80383763;
module.exports["tableHeaderSelector"] = $d7906b5f150ffb1c$export$7b07d37d879c957f;
module.exports["tableCellContentWrapperSelector"] = $d7906b5f150ffb1c$export$8dd42a84cd52da07;
module.exports["tableCellContentDomSelector"] = $d7906b5f150ffb1c$export$5e26a5c19f0865d8;
module.exports["getCellAttrs"] = $d7906b5f150ffb1c$export$43977bde391e007;
module.exports["getCellDomAttrs"] = $d7906b5f150ffb1c$export$363c8dda799bfe9c;
module.exports["tableBackgroundColorNames"] = $d7906b5f150ffb1c$export$8cc2833b5b349a1e;
module.exports["tableBackgroundColorPalette"] = $d7906b5f150ffb1c$export$219b7f492ad209f8;
module.exports["tableBackgroundBorderColor"] = $d7906b5f150ffb1c$export$95e9c925fbf01d1c;
module.exports["table"] = $d7906b5f150ffb1c$export$9852986a3ec5f6a0;
module.exports["tableWithCustomWidth"] = $d7906b5f150ffb1c$export$90e634fbace1f0c4;
module.exports["tableStage0"] = $d7906b5f150ffb1c$export$3862de5c8c9098cf;
module.exports["tableToJSON"] = $d7906b5f150ffb1c$export$1f92a2f429e06fa8;
module.exports["tableRow"] = $d7906b5f150ffb1c$export$ce666bf02318c957;
module.exports["tableCell"] = $d7906b5f150ffb1c$export$e1e720e5f4603e6a;
module.exports["toJSONTableCell"] = $d7906b5f150ffb1c$export$2ac34c099660f1a8;
module.exports["tableHeader"] = $d7906b5f150ffb1c$export$48884d2a5190dc73;
module.exports["toJSONTableHeader"] = $d7906b5f150ffb1c$export$2af48797a1010bb1;
module.exports["tableWithNestedTable"] = $d7906b5f150ffb1c$export$ce086a560a1d05f5;
module.exports["tableRowWithNestedTable"] = $d7906b5f150ffb1c$export$7d657479499397;
module.exports["tableCellWithNestedTable"] = $d7906b5f150ffb1c$export$abf39ca178940ff3;
module.exports["tableHeaderWithNestedTable"] = $d7906b5f150ffb1c$export$2a5a518232fa1a97;
module.exports["tableRowWithLocalId"] = $d7906b5f150ffb1c$export$c8f0853ac97552c9;
module.exports["tableCellWithLocalId"] = $d7906b5f150ffb1c$export$db76cfd28a574029;
module.exports["tableHeaderWithLocalId"] = $d7906b5f150ffb1c$export$b82d2b1d8824143d;
module.exports["tableRowWithNestedTableWithLocalId"] = $d7906b5f150ffb1c$export$27926e30c8a74147;
module.exports["tableCellWithNestedTableWithLocalId"] = $d7906b5f150ffb1c$export$e9fd700fafee293a;
module.exports["tableHeaderWithNestedTableWithLocalId"] = $d7906b5f150ffb1c$export$7928c3aeb4cd2213;

});

parcelRegister("frYg8", function(module, exports) {

var $ajtLB = parcelRequire("ajtLB");


var $bCTuz = parcelRequire("bCTuz");

/**
 * @name decisionList_node
 */ const $b3f81edfe3da1163$var$name = 'decisionList';
const $b3f81edfe3da1163$export$a5393ce68c2ff601 = `[data-node-type="${$b3f81edfe3da1163$var$name}"]`;
const $b3f81edfe3da1163$export$62d45a65fb43d95e = (0, $bCTuz.decisionList)({
    parseDOM: [
        {
            tag: `ol${$b3f81edfe3da1163$export$a5393ce68c2ff601}`,
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by ordered-list we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: ()=>({
                    localId: (0, $ajtLB.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const attrs = {
            'data-node-type': $b3f81edfe3da1163$var$name,
            'data-decision-list-local-id': localId || 'local-decision-list',
            style: 'list-style: none; padding-left: 0'
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});
module.exports["decisionListSelector"] = $b3f81edfe3da1163$export$a5393ce68c2ff601;
module.exports["decisionList"] = $b3f81edfe3da1163$export$62d45a65fb43d95e;

});

parcelRegister("5lAbC", function(module, exports) {

var $ajtLB = parcelRequire("ajtLB");


var $bCTuz = parcelRequire("bCTuz");

const $3e4afbc42b90af8a$export$6959e16eeff859b4 = (0, $bCTuz.decisionItem)({
    parseDOM: [
        {
            tag: 'li[data-decision-local-id]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: (dom)=>({
                    localId: (0, $ajtLB.uuid).generate(),
                    state: dom.getAttribute('data-decision-state')
                })
        }
    ],
    toDOM (node) {
        const { localId: localId, state: state } = node.attrs;
        const attrs = {
            'data-decision-local-id': localId || 'local-decision',
            'data-decision-state': state
        };
        return [
            'li',
            attrs,
            0
        ];
    }
});
module.exports["decisionItem"] = $3e4afbc42b90af8a$export$6959e16eeff859b4;

});

parcelRegister("bc9VB", function(module, exports) {

var $ajtLB = parcelRequire("ajtLB");


var $bCTuz = parcelRequire("bCTuz");

/**
 * @name taskList_node
 */ const $021a75bee3ff11f1$var$name = 'actionList';
const $021a75bee3ff11f1$export$c0ec71adb7a18fb2 = `[data-node-type="${$021a75bee3ff11f1$var$name}"]`;
const $021a75bee3ff11f1$export$375b6afcc5f4d291 = (0, $bCTuz.taskList)({
    parseDOM: [
        {
            tag: `div${$021a75bee3ff11f1$export$c0ec71adb7a18fb2}`,
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by ordered-list we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: ()=>({
                    localId: (0, $ajtLB.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const attrs = {
            'data-node-type': $021a75bee3ff11f1$var$name,
            'data-task-list-local-id': localId || 'local-task-list',
            style: 'list-style: none; padding-left: 0'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
module.exports["taskListSelector"] = $021a75bee3ff11f1$export$c0ec71adb7a18fb2;
module.exports["taskList"] = $021a75bee3ff11f1$export$375b6afcc5f4d291;

});

parcelRegister("3GSVg", function(module, exports) {

var $ajtLB = parcelRequire("ajtLB");


var $bCTuz = parcelRequire("bCTuz");

const $2affe5cf00f69d99$export$6d8b0ef52e2e6390 = (0, $bCTuz.taskItem)({
    parseDOM: [
        {
            tag: 'div[data-task-local-id]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: (dom)=>({
                    localId: (0, $ajtLB.uuid).generate(),
                    state: dom.getAttribute('data-task-state') || 'TODO'
                })
        }
    ],
    toDOM (node) {
        const { localId: localId, state: state } = node.attrs;
        const attrs = {
            'data-task-local-id': localId || 'local-task',
            'data-task-state': state || 'TODO'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $2affe5cf00f69d99$export$16018c61064a18df = (0, $bCTuz.blockTaskItem)({
    parseDOM: [
        {
            tag: 'div[data-task-is-block]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: (dom)=>({
                    localId: (0, $ajtLB.uuid).generate(),
                    state: dom.getAttribute('data-task-state') || 'TODO'
                })
        }
    ],
    toDOM (node) {
        const { localId: localId, state: state } = node.attrs;
        const attrs = {
            'data-task-local-id': localId || 'local-task',
            'data-task-state': state || 'TODO',
            'data-task-is-block': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
module.exports["taskItem"] = $2affe5cf00f69d99$export$6d8b0ef52e2e6390;
module.exports["blockTaskItem"] = $2affe5cf00f69d99$export$16018c61064a18df;

});

parcelRegister("hw68I", function(module, exports) {

var $bCTuz = parcelRequire("bCTuz");


var $ajtLB = parcelRequire("ajtLB");

const $cc0a2ffff5c0e6c5$export$324d90190a8b822a = (0, $bCTuz.date)({
    parseDOM: [
        {
            tag: 'span[data-node-type="date"]',
            getAttrs: (dom)=>({
                    timestamp: dom.getAttribute('data-timestamp')
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'date',
            'data-timestamp': node.attrs.timestamp
        };
        return [
            'span',
            attrs
        ];
    }
});
const $cc0a2ffff5c0e6c5$export$a6a035390e3921b2 = (0, $bCTuz.date)({
    parseDOM: [
        {
            tag: 'span[data-node-type="date"]',
            getAttrs: (dom)=>({
                    timestamp: dom.getAttribute('data-timestamp'),
                    localId: (0, $ajtLB.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const attrs = {
            'data-node-type': 'date',
            'data-timestamp': node.attrs.timestamp,
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'span',
            attrs
        ];
    }
});
module.exports["date"] = $cc0a2ffff5c0e6c5$export$324d90190a8b822a;
module.exports["dateWithLocalId"] = $cc0a2ffff5c0e6c5$export$a6a035390e3921b2;

});

parcelRegister("l8Svu", function(module, exports) {

var $bCTuz = parcelRequire("bCTuz");


var $ajtLB = parcelRequire("ajtLB");

const $f644a048c0557369$export$c7187bbd1a7a9244 = (0, $bCTuz.placeholder)({
    parseDOM: [
        {
            tag: 'span[data-placeholder]',
            getAttrs: (dom)=>({
                    text: dom.getAttribute('data-placeholder') || $f644a048c0557369$export$c7187bbd1a7a9244.attrs.text.default
                })
        }
    ],
    toDOM (node) {
        const { text: text } = node.attrs;
        const attrs = {
            'data-placeholder': text,
            // Needs to be edtiable for mobile to not close keyboard
            contenteditable: 'true'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});
const $f644a048c0557369$export$6205248609a8f7a0 = (0, $bCTuz.placeholder)({
    parseDOM: [
        {
            tag: 'span[data-placeholder]',
            getAttrs: (dom)=>({
                    text: dom.getAttribute('data-placeholder') || $f644a048c0557369$export$c7187bbd1a7a9244.attrs.text.default,
                    localId: (0, $ajtLB.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const { text: text } = node.attrs;
        const attrs = {
            'data-placeholder': text,
            // Needs to be edtiable for mobile to not close keyboard
            contenteditable: 'true',
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});
module.exports["placeholder"] = $f644a048c0557369$export$c7187bbd1a7a9244;
module.exports["placeholderWithLocalId"] = $f644a048c0557369$export$6205248609a8f7a0;

});

parcelRegister("liMLZ", function(module, exports) {

var $bCTuz = parcelRequire("bCTuz");


var $ajtLB = parcelRequire("ajtLB");

const $f8211cba11673188$export$b3b6a70a7fa4a5be = (0, $bCTuz.layoutSection)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-layout-section': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $f8211cba11673188$export$cdae19acb0a520fd = (0, $bCTuz.layoutSectionFull)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-layout-section': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $f8211cba11673188$export$4f9d8f623ff17117 = (0, $bCTuz.layoutSectionWithSingleColumnStage0)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]',
            getAttrs: (dom)=>{
                const columnRuleStyle = dom.getAttribute('data-column-rule-style');
                return columnRuleStyle ? {
                    columnRuleStyle: columnRuleStyle
                } : {};
            }
        }
    ],
    toDOM (node) {
        const { columnRuleStyle: columnRuleStyle } = node.attrs;
        const attrs = {
            'data-layout-section': 'true',
            'data-column-rule-style': columnRuleStyle || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $f8211cba11673188$export$d9d3c69a64270b13 = (0, $bCTuz.layoutSection)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]',
            getAttrs: ()=>{
                const localId = (0, $ajtLB.uuid).generate();
                return {
                    localId: localId
                };
            }
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const attrs = {
            'data-layout-section': 'true',
            'data-local-id': localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $f8211cba11673188$export$64facded20dfd85c = (0, $bCTuz.layoutSectionWithSingleColumnStage0)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]',
            getAttrs: (dom)=>{
                const columnRuleStyle = dom.getAttribute('data-column-rule-style');
                const localId = (0, $ajtLB.uuid).generate();
                return columnRuleStyle ? {
                    columnRuleStyle: columnRuleStyle,
                    localId: localId
                } : {
                    localId: localId
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const { columnRuleStyle: columnRuleStyle } = node.attrs;
        const attrs = {
            'data-layout-section': 'true',
            'data-column-rule-style': columnRuleStyle || undefined,
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
module.exports["layoutSection"] = $f8211cba11673188$export$b3b6a70a7fa4a5be;
module.exports["layoutSectionWithSingleColumn"] = $f8211cba11673188$export$4f9d8f623ff17117;
module.exports["layoutSectionWithLocalId"] = $f8211cba11673188$export$d9d3c69a64270b13;
module.exports["layoutSectionWithSingleColumnLocalId"] = $f8211cba11673188$export$64facded20dfd85c;

});

parcelRegister("1BLdm", function(module, exports) {

var $bCTuz = parcelRequire("bCTuz");


var $ajtLB = parcelRequire("ajtLB");

const $12bddefbe912d511$export$ab76e7c03cd6f650 = (0, $bCTuz.layoutColumn)({
    parseDOM: [
        {
            context: 'layoutColumn//',
            tag: 'div[data-layout-column]',
            skip: true
        },
        {
            tag: 'div[data-layout-column]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    width: Number(dom.getAttribute('data-column-width')) || undefined
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-layout-column': 'true'
        };
        const { width: width } = node.attrs;
        if (width) {
            attrs['style'] = `flex-basis: ${width}%`;
            attrs['data-column-width'] = `${width}`;
        }
        // We need to apply a attribute to the inner most child to help
        // ProseMirror identify its boundaries better.
        const contentAttrs = {
            'data-layout-content': 'true'
        };
        return [
            'div',
            attrs,
            [
                'div',
                contentAttrs,
                0
            ]
        ];
    }
});
const $12bddefbe912d511$export$b2e27d292505bac2 = (0, $bCTuz.layoutColumn)({
    parseDOM: [
        {
            context: 'layoutColumn//',
            tag: 'div[data-layout-column]',
            skip: true
        },
        {
            tag: 'div[data-layout-column]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    width: Number(dom.getAttribute('data-column-width')) || undefined,
                    localId: (0, $ajtLB.uuid).generate()
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const attrs = {
            'data-layout-column': 'true',
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        const { width: width } = node.attrs;
        if (width) {
            attrs['style'] = `flex-basis: ${width}%`;
            attrs['data-column-width'] = `${width}`;
        }
        // We need to apply a attribute to the inner most child to help
        // ProseMirror identify its boundaries better.
        const contentAttrs = {
            'data-layout-content': 'true'
        };
        return [
            'div',
            attrs,
            [
                'div',
                contentAttrs,
                0
            ]
        ];
    }
});
module.exports["layoutColumn"] = $12bddefbe912d511$export$ab76e7c03cd6f650;
module.exports["layoutColumnWithLocalId"] = $12bddefbe912d511$export$b2e27d292505bac2;

});

parcelRegister("fLuch", function(module, exports) {

var $bCTuz = parcelRequire("bCTuz");


var $ajtLB = parcelRequire("ajtLB");

const $b7a2ab500dc00d43$export$cbf8224b64e0d942 = (0, $bCTuz.inlineCard)({
    parseDOM: [
        {
            tag: 'a[data-inline-card], span[data-inline-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: (dom)=>{
                const anchor = dom;
                const data = anchor.getAttribute('data-card-data');
                /* Support attrs from Editor and Renderer */ return {
                    url: anchor.getAttribute('href') || anchor.getAttribute('data-card-url') || null,
                    data: data ? JSON.parse(data) : null
                };
            }
        },
        // for renderer
        {
            tag: 'div[data-inline-card]',
            getAttrs: (dom)=>{
                const anchor = dom;
                const data = anchor.getAttribute('data-card-data');
                return {
                    url: anchor.getAttribute('data-card-url'),
                    data: data ? JSON.parse(data) : null
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-inline-card': '',
            href: node.attrs.url || '',
            'data-card-data': node.attrs.data ? JSON.stringify(node.attrs.data) : ''
        };
        if (node.attrs.url) return [
            'a',
            attrs,
            node.attrs.url
        ];
        else return [
            'a',
            attrs
        ];
    }
});
const $b7a2ab500dc00d43$export$7ed775fc743eadd1 = (0, $bCTuz.inlineCard)({
    parseDOM: [
        {
            tag: 'a[data-inline-card], span[data-inline-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: (dom)=>{
                const anchor = dom;
                const data = anchor.getAttribute('data-card-data');
                /* Support attrs from Editor and Renderer */ return {
                    url: anchor.getAttribute('href') || anchor.getAttribute('data-card-url') || null,
                    data: data ? JSON.parse(data) : null,
                    localId: (0, $ajtLB.uuid).generate()
                };
            }
        },
        // for renderer
        {
            tag: 'div[data-inline-card]',
            getAttrs: (dom)=>{
                const anchor = dom;
                const data = anchor.getAttribute('data-card-data');
                return {
                    url: anchor.getAttribute('data-card-url'),
                    data: data ? JSON.parse(data) : null,
                    localId: (0, $ajtLB.uuid).generate()
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const attrs = {
            'data-inline-card': '',
            href: node.attrs.url || '',
            'data-card-data': node.attrs.data ? JSON.stringify(node.attrs.data) : '',
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        if (node.attrs.url) return [
            'a',
            attrs,
            node.attrs.url
        ];
        else return [
            'a',
            attrs
        ];
    }
});
module.exports["inlineCard"] = $b7a2ab500dc00d43$export$cbf8224b64e0d942;
module.exports["inlineCardWithLocalId"] = $b7a2ab500dc00d43$export$7ed775fc743eadd1;

});

parcelRegister("5vHpv", function(module, exports) {

var $bCTuz = parcelRequire("bCTuz");


var $ajtLB = parcelRequire("ajtLB");

/**
 * @name blockCard_node
 */ const $4031856cd3911b6c$var$getCommonAttributesFromDom = (dom)=>{
    const anchor = dom;
    const data = anchor.getAttribute('data-card-data');
    const datasource = anchor.getAttribute('data-datasource');
    return {
        data: data ? JSON.parse(data) : undefined,
        layout: datasource ? dom.getAttribute('data-layout') || undefined : undefined,
        width: Number(dom.getAttribute('data-width')) || undefined,
        datasource: datasource ? JSON.parse(datasource) : undefined
    };
};
const $4031856cd3911b6c$export$c4c2f833baaebdb8 = (0, $bCTuz.blockCard)({
    parseDOM: [
        {
            tag: 'a[data-block-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: (dom)=>{
                const anchor = dom;
                return {
                    url: anchor.getAttribute('href') || undefined,
                    ...$4031856cd3911b6c$var$getCommonAttributesFromDom(dom)
                };
            }
        },
        {
            tag: 'div[data-block-card]',
            getAttrs: (dom)=>{
                const anchor = dom;
                return {
                    url: anchor.getAttribute('data-card-url') || undefined,
                    ...$4031856cd3911b6c$var$getCommonAttributesFromDom(dom)
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const { url: url } = node.attrs;
        const { data: data } = node.attrs;
        const { layout: layout, width: width, datasource: datasource } = node.attrs;
        const attrs = {
            'data-block-card': '',
            href: url || '',
            'data-card-data': data ? JSON.stringify(data) : '',
            'data-datasource': datasource ? JSON.stringify(datasource) : '',
            'data-layout': layout,
            'data-width': `${width}`
        };
        return [
            'a',
            attrs,
            (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.url) || ' '
        ];
    }
});
const $4031856cd3911b6c$export$9894f24949f094e5 = (0, $bCTuz.blockCard)({
    parseDOM: [
        {
            tag: 'a[data-block-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: (dom)=>{
                const anchor = dom;
                return {
                    url: anchor.getAttribute('href') || undefined,
                    ...$4031856cd3911b6c$var$getCommonAttributesFromDom(dom),
                    localId: (0, $ajtLB.uuid).generate()
                };
            }
        },
        {
            tag: 'div[data-block-card]',
            getAttrs: (dom)=>{
                const anchor = dom;
                return {
                    url: anchor.getAttribute('data-card-url') || undefined,
                    ...$4031856cd3911b6c$var$getCommonAttributesFromDom(dom),
                    localId: (0, $ajtLB.uuid).generate()
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs2, _node$attrs3;
        const { url: url } = node.attrs;
        const { data: data } = node.attrs;
        const { layout: layout, width: width, datasource: datasource } = node.attrs;
        const attrs = {
            'data-block-card': '',
            href: url || '',
            'data-card-data': data ? JSON.stringify(data) : '',
            'data-datasource': datasource ? JSON.stringify(datasource) : '',
            'data-layout': layout,
            'data-width': `${width}`,
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.localId) || undefined
        };
        return [
            'a',
            attrs,
            (node === null || node === void 0 ? void 0 : (_node$attrs3 = node.attrs) === null || _node$attrs3 === void 0 ? void 0 : _node$attrs3.url) || ' '
        ];
    }
});
module.exports["blockCard"] = $4031856cd3911b6c$export$c4c2f833baaebdb8;
module.exports["blockCardWithLocalId"] = $4031856cd3911b6c$export$9894f24949f094e5;

});

parcelRegister("8oL6j", function(module, exports) {

var $bCTuz = parcelRequire("bCTuz");

const $61d519d83929aa00$export$44b79b0979d0f0f7 = (0, $bCTuz.unsupportedBlock)({
    parseDOM: [
        {
            tag: '[data-node-type="unsupportedBlock"]',
            getAttrs: (dom)=>({
                    originalValue: JSON.parse(dom.getAttribute('data-original-value') || '{}')
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'unsupportedBlock',
            'data-original-value': JSON.stringify(node.attrs.originalValue)
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    }
});
module.exports["unsupportedBlock"] = $61d519d83929aa00$export$44b79b0979d0f0f7;

});

parcelRegister("8fWld", function(module, exports) {

var $bCTuz = parcelRequire("bCTuz");

const $602cfad00e74dbe4$export$310ebe0d80122e9b = (0, $bCTuz.unsupportedInline)({
    parseDOM: [
        {
            tag: '[data-node-type="unsupportedInline"]',
            getAttrs: (dom)=>({
                    originalValue: JSON.parse(dom.getAttribute('data-original-value') || '{}')
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'unsupportedInline',
            'data-original-value': JSON.stringify(node.attrs.originalValue)
        };
        return [
            'span',
            attrs,
            'Unsupported content'
        ];
    }
});
module.exports["unsupportedInline"] = $602cfad00e74dbe4$export$310ebe0d80122e9b;

});

parcelRegister("8W1Po", function(module, exports) {

var $ajtLB = parcelRequire("ajtLB");


var $bCTuz = parcelRequire("bCTuz");

const $6815287c0e3cdad2$export$471f7ae5c4103ae1 = (0, $bCTuz.status)({
    parseDOM: [
        {
            tag: 'span[data-node-type="status"]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    text: dom.textContent.replace(/\n/, '').trim(),
                    color: dom.getAttribute('data-color'),
                    localId: (0, $ajtLB.uuid).generate(),
                    style: dom.getAttribute('data-style')
                };
            }
        }
    ],
    toDOM (node) {
        const { text: text, color: color, localId: localId, style: style } = node.attrs;
        const attrs = {
            'data-node-type': 'status',
            'data-color': color,
            'data-local-id': localId,
            'data-style': style,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});
module.exports["status"] = $6815287c0e3cdad2$export$471f7ae5c4103ae1;

});

parcelRegister("3x4Nz", function(module, exports) {

var $bCTuz = parcelRequire("bCTuz");


var $ajtLB = parcelRequire("ajtLB");

/**
 * @name nestedExpand_content
 * @minItems 1
 * @allowUnsupportedBlock true
 */ /**
 * @name nestedExpand_node
 */ /**
 * @name nestedExpand_with_no_marks_node
 */ function $29282d113e46f8c3$var$getExpandAttrs(domNode, generateLocalId) {
    const dom = domNode;
    return {
        title: dom.getAttribute('data-title'),
        __expanded: true,
        localId: generateLocalId ? (0, $ajtLB.uuid).generate() : undefined
    };
}
const $29282d113e46f8c3$var$nestedExpandFactoryOptions = {
    parseDOM: [
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: (domNode)=>$29282d113e46f8c3$var$getExpandAttrs(domNode, false)
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="nestedExpand"]',
            getAttrs: (domNode)=>$29282d113e46f8c3$var$getExpandAttrs(domNode, false)
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const attrs = {
            'data-node-type': 'nestedExpand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded,
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
const $29282d113e46f8c3$export$63cadbf5f4296627 = (0, $bCTuz.nestedExpand)($29282d113e46f8c3$var$nestedExpandFactoryOptions);
const $29282d113e46f8c3$export$b854197485aa1fa0 = (0, $bCTuz.nestedExpand)({
    ...$29282d113e46f8c3$var$nestedExpandFactoryOptions,
    parseDOM: [
        ...$29282d113e46f8c3$var$nestedExpandFactoryOptions.parseDOM,
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: (domNode)=>$29282d113e46f8c3$var$getExpandAttrs(domNode, true)
        },
        {
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: (domNode)=>$29282d113e46f8c3$var$getExpandAttrs(domNode, true)
        }
    ]
});
module.exports["nestedExpand"] = $29282d113e46f8c3$export$63cadbf5f4296627;
module.exports["nestedExpandWithLocalId"] = $29282d113e46f8c3$export$b854197485aa1fa0;

});

parcelRegister("7r9po", function(module, exports) {

var $bCTuz = parcelRequire("bCTuz");


var $ajtLB = parcelRequire("ajtLB");

const $56a25a621ef6a4af$export$be4283d9a1cb1ff6 = (0, $bCTuz.embedCard)({
    parseDOM: [
        {
            tag: 'div[data-embed-card]',
            getAttrs: (dom)=>({
                    url: dom.getAttribute('data-card-url'),
                    layout: dom.getAttribute('data-layout') || 'center',
                    width: Number(dom.getAttribute('data-width')) || null,
                    originalWidth: Number(dom.getAttribute('data-card-original-width')) || null,
                    originalHeight: Number(dom.getAttribute('data-card-original-height')) || null
                })
        }
    ],
    toDOM (node) {
        const { url: url, layout: layout, width: width, originalWidth: originalWidth, originalHeight: originalHeight } = node.attrs;
        const attrs = {
            'data-embed-card': '',
            'data-card-url': url,
            'data-layout': layout,
            'data-width': width,
            'data-original-width': originalWidth,
            'data-original-height': originalHeight
        };
        return [
            'div',
            attrs
        ];
    }
});
const $56a25a621ef6a4af$export$36734475a7f6fd3e = (0, $bCTuz.embedCard)({
    parseDOM: [
        {
            tag: 'div[data-embed-card]',
            getAttrs: (dom)=>({
                    url: dom.getAttribute('data-card-url'),
                    layout: dom.getAttribute('data-layout') || 'center',
                    width: Number(dom.getAttribute('data-width')) || null,
                    originalWidth: Number(dom.getAttribute('data-card-original-width')) || null,
                    originalHeight: Number(dom.getAttribute('data-card-original-height')) || null,
                    localId: (0, $ajtLB.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const { url: url, layout: layout, width: width, originalWidth: originalWidth, originalHeight: originalHeight } = node.attrs;
        const attrs = {
            'data-embed-card': '',
            'data-card-url': url,
            'data-layout': layout,
            'data-width': width,
            'data-original-width': originalWidth,
            'data-original-height': originalHeight,
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'div',
            attrs
        ];
    }
});
module.exports["embedCard"] = $56a25a621ef6a4af$export$be4283d9a1cb1ff6;
module.exports["embedCardWithLocalId"] = $56a25a621ef6a4af$export$36734475a7f6fd3e;

});

parcelRegister("dmAsx", function(module, exports) {

var $cHf7l = parcelRequire("cHf7l");


var $bCTuz = parcelRequire("bCTuz");

const $9ba99c7fe1f00603$export$1b45514b112dd749 = (0, $bCTuz.extension)({
    parseDOM: [
        {
            tag: '[data-node-type="extension"]',
            getAttrs: (domNode)=>(0, $cHf7l.getExtensionAttrs)(domNode)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs
        ];
    }
});
module.exports["extension"] = $9ba99c7fe1f00603$export$1b45514b112dd749;

});

parcelRegister("2JFVM", function(module, exports) {

var $cHf7l = parcelRequire("cHf7l");


var $bCTuz = parcelRequire("bCTuz");

const $1fe04f5f6fee9637$export$16b353b2649bd8d9 = (0, $bCTuz.inlineExtensionWithMarks)({
    parseDOM: [
        {
            tag: 'span[data-extension-type]',
            getAttrs: (domNode)=>(0, $cHf7l.getExtensionAttrs)(domNode, true)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-local-id:': node.attrs.localId,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs
        ];
    }
});
module.exports["inlineExtension"] = $1fe04f5f6fee9637$export$16b353b2649bd8d9;

});

parcelRegister("cZjaR", function(module, exports) {

var $cHf7l = parcelRequire("cHf7l");


var $bCTuz = parcelRequire("bCTuz");

const $974a0e240eab143a$export$27903d543b563e39 = (0, $bCTuz.bodiedExtension)({
    parseDOM: [
        {
            context: 'bodiedExtension//',
            tag: '[data-node-type="bodied-extension"]',
            skip: true
        },
        {
            tag: '[data-node-type="bodied-extension"]',
            getAttrs: (domNode)=>(0, $cHf7l.getExtensionAttrs)(domNode)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'bodied-extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
module.exports["bodiedExtension"] = $974a0e240eab143a$export$27903d543b563e39;

});

parcelRegister("kRLUJ", function(module, exports) {

var $cHf7l = parcelRequire("cHf7l");


var $bCTuz = parcelRequire("bCTuz");

const $03eb9455296293f8$export$4fdcae991fd743e7 = (0, $bCTuz.extensionFrameStage0)({
    parseDOM: [
        {
            context: 'extensionFrame//',
            tag: 'div[data-extension-frame]',
            skip: true
        },
        {
            tag: 'div[data-extension-frame]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-extension-frame': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $03eb9455296293f8$export$c3c04d555a8b9013 = (0, $bCTuz.multiBodiedExtensionStage0)({
    parseDOM: [
        {
            context: 'multiBodiedExtension//',
            tag: '[data-node-type="multi-bodied-extension"]',
            skip: true
        },
        {
            tag: '[data-node-type="multi-bodied-extension"]',
            getAttrs: (domNode)=>(0, $cHf7l.getExtensionAttrs)(domNode)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'multi-bodied-extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
module.exports["extensionFrame"] = $03eb9455296293f8$export$4fdcae991fd743e7;
module.exports["multiBodiedExtension"] = $03eb9455296293f8$export$c3c04d555a8b9013;

});

parcelRegister("3ZA5r", function(module, exports) {

var $bCTuz = parcelRequire("bCTuz");


var $ajtLB = parcelRequire("ajtLB");

const $2e830fa8df5f4e38$export$faab0ca9701d7048 = (0, $bCTuz.syncBlockStage0)({
    parseDOM: [
        {
            tag: 'div[data-sync-block]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                const attrs = {
                    localId: dom.getAttribute('data-local-id') || (0, $ajtLB.uuid).generate(),
                    resourceId: dom.getAttribute('data-resource-id') || ''
                };
                return attrs;
            }
        }
    ],
    toDOM (node) {
        const { localId: localId, resourceId: resourceId } = node.attrs;
        const name = 'div';
        const attrs = {
            'data-sync-block': '',
            'data-local-id': localId,
            'data-resource-id': resourceId
        };
        return [
            name,
            attrs
        ];
    }
});
module.exports["syncBlock"] = $2e830fa8df5f4e38$export$faab0ca9701d7048;

});

parcelRegister("ceXmR", function(module, exports) {

var $bCTuz = parcelRequire("bCTuz");


var $ajtLB = parcelRequire("ajtLB");

const $8e94d80a25bb9fd9$export$e92c7e4302dd4371 = (0, $bCTuz.bodiedSyncBlockStage0)({
    parseDOM: [
        {
            tag: 'div[data-bodied-sync-block]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                const attrs = {
                    localId: dom.getAttribute('data-local-id') || (0, $ajtLB.uuid).generate(),
                    resourceId: dom.getAttribute('data-resource-id') || ''
                };
                return attrs;
            }
        }
    ],
    toDOM (node) {
        const { localId: localId, resourceId: resourceId } = node.attrs;
        const name = 'div';
        const attrs = {
            'data-bodied-sync-block': '',
            'data-local-id': localId,
            'data-resource-id': resourceId
        };
        return [
            name,
            attrs,
            0
        ];
    }
});
module.exports["bodiedSyncBlock"] = $8e94d80a25bb9fd9$export$e92c7e4302dd4371;

});

parcelRegister("jBbIP", function(module, exports) {
/**
 * This file has been partially duplicated in packages/linking-platform/linking-common/src/url.ts
 * Any changes made here should be mirrored there.
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ var $d5cfdf20e068e5bf$exports = {};
'use strict';
////////////////////////////////////////////////////////////////////////////////
// Helpers
// Merge objects
//
function $d5cfdf20e068e5bf$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $d5cfdf20e068e5bf$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $d5cfdf20e068e5bf$var$isString(obj) {
    return $d5cfdf20e068e5bf$var$_class(obj) === '[object String]';
}
function $d5cfdf20e068e5bf$var$isObject(obj) {
    return $d5cfdf20e068e5bf$var$_class(obj) === '[object Object]';
}
function $d5cfdf20e068e5bf$var$isRegExp(obj) {
    return $d5cfdf20e068e5bf$var$_class(obj) === '[object RegExp]';
}
function $d5cfdf20e068e5bf$var$isFunction(obj) {
    return $d5cfdf20e068e5bf$var$_class(obj) === '[object Function]';
}
function $d5cfdf20e068e5bf$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
}
////////////////////////////////////////////////////////////////////////////////
var $d5cfdf20e068e5bf$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $d5cfdf20e068e5bf$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        return acc || $d5cfdf20e068e5bf$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
var $d5cfdf20e068e5bf$var$defaultSchemas = {
    'http:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp('^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i');
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    'https:': 'http:',
    'ftp:': 'http:',
    '//': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp('^' + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ':') return 0;
                if (pos >= 3 && text[pos - 3] === '/') return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    'mailto:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp('^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i');
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
/*eslint-disable max-len*/ // RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var $d5cfdf20e068e5bf$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var $d5cfdf20e068e5bf$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
/*eslint-enable max-len*/ ////////////////////////////////////////////////////////////////////////////////
function $d5cfdf20e068e5bf$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = '';
}
function $d5cfdf20e068e5bf$var$createValidator(re) {
    return function(text, pos) {
        var tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $d5cfdf20e068e5bf$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}

// Schemas compiler. Build regexps.
//
function $d5cfdf20e068e5bf$var$compile(self) {
    // Load & clone RE patterns.
    var re = self.re = (parcelRequire("jHxIB"))(self.__opts__);
    // Define dynamic patterns
    var tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($d5cfdf20e068e5bf$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join('|');
    function untpl(tpl) {
        return tpl.replace('%TLDS%', re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
    //
    // Compile each schema
    //
    var aliases = [];
    self.__compiled__ = {}; // Reset compiled data
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        var val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        var compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($d5cfdf20e068e5bf$var$isObject(val)) {
            if ($d5cfdf20e068e5bf$var$isRegExp(val.validate)) compiled.validate = $d5cfdf20e068e5bf$var$createValidator(val.validate);
            else if ($d5cfdf20e068e5bf$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($d5cfdf20e068e5bf$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $d5cfdf20e068e5bf$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($d5cfdf20e068e5bf$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[''] = {
        validate: null,
        normalize: $d5cfdf20e068e5bf$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    var slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($d5cfdf20e068e5bf$var$escapeRE).join('|');
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
    self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');
    self.re.pretest = RegExp('(' + self.re.schema_test.source + ')|(' + self.re.host_fuzzy_test.source + ')|@', 'i');
    //
    // Cleanup
    //
    $d5cfdf20e068e5bf$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $d5cfdf20e068e5bf$var$Match(self, shift) {
    var start = self.__index__, end = self.__last_index__, text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $d5cfdf20e068e5bf$var$createMatch(self, shift) {
    var match = new $d5cfdf20e068e5bf$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $d5cfdf20e068e5bf$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $d5cfdf20e068e5bf$var$LinkifyIt)) return new $d5cfdf20e068e5bf$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($d5cfdf20e068e5bf$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $d5cfdf20e068e5bf$var$assign({}, $d5cfdf20e068e5bf$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1; // Next scan position
    this.__schema__ = '';
    this.__text_cache__ = '';
    this.__schemas__ = $d5cfdf20e068e5bf$var$assign({}, $d5cfdf20e068e5bf$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $d5cfdf20e068e5bf$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $d5cfdf20e068e5bf$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $d5cfdf20e068e5bf$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $d5cfdf20e068e5bf$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $d5cfdf20e068e5bf$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $d5cfdf20e068e5bf$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $d5cfdf20e068e5bf$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    var m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = '';
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
        // guess schemaless emails
        at_pos = text.indexOf('@');
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = 'mailto:';
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $d5cfdf20e068e5bf$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $d5cfdf20e068e5bf$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $d5cfdf20e068e5bf$var$LinkifyIt.prototype.match = function match(text) {
    var shift = 0, result = [];
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($d5cfdf20e068e5bf$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    var tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($d5cfdf20e068e5bf$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $d5cfdf20e068e5bf$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $d5cfdf20e068e5bf$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $d5cfdf20e068e5bf$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $d5cfdf20e068e5bf$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = 'http://' + match.url;
    if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = 'mailto:' + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $d5cfdf20e068e5bf$var$LinkifyIt.prototype.onCompile = function onCompile() {};
$d5cfdf20e068e5bf$exports = $d5cfdf20e068e5bf$var$LinkifyIt;


const $e44a90c52f7abdca$var$whitelistedURLPatterns = [
    /^https?:\/\//im,
    /^ftps?:\/\//im,
    /^gopher:\/\//im,
    /^integrity:\/\//im,
    /^file:\/\//im,
    /^smb:\/\//im,
    /^dynamicsnav:\/\//im,
    /^jamfselfservice:\/\//im,
    /^\//im,
    /^mailto:/im,
    /^skype:/im,
    /^callto:/im,
    /^facetime:/im,
    /^git:/im,
    /^irc6?:/im,
    /^news:/im,
    /^nntp:/im,
    /^feed:/im,
    /^cvs:/im,
    /^svn:/im,
    /^mvn:/im,
    /^ssh:/im,
    /^scp:\/\//im,
    /^sftp:\/\//im,
    /^itms:/im,
    // This is not a valid notes link, but we support this pattern for backwards compatibility
    /^notes:/im,
    /^notes:\/\//im,
    /^hipchat:\/\//im,
    // This is not a valid sourcetree link, but we support this pattern for backwards compatibility
    /^sourcetree:/im,
    /^sourcetree:\/\//im,
    /^urn:/im,
    /^tel:/im,
    /^xmpp:/im,
    /^telnet:/im,
    /^vnc:/im,
    /^rdp:/im,
    /^whatsapp:/im,
    /^slack:/im,
    /^sips?:/im,
    /^magnet:/im,
    /^#/im
];
const $e44a90c52f7abdca$export$c9f92f5469372e0f = (url)=>{
    const urlTrimmed = url.trim();
    if (urlTrimmed.length === 0) return true;
    return $e44a90c52f7abdca$var$whitelistedURLPatterns.some((p)=>p.test(urlTrimmed));
};
const $e44a90c52f7abdca$export$8ccbde94d5c7f8e7 = (0, (/*@__PURE__*/$parcel$interopDefault($d5cfdf20e068e5bf$exports)))();
$e44a90c52f7abdca$export$8ccbde94d5c7f8e7.add('sourcetree:', 'http:');
$e44a90c52f7abdca$export$8ccbde94d5c7f8e7.add('jamfselfservice:', 'http:');
const $e44a90c52f7abdca$var$urlWithoutSpacesValidator = {
    validate: /[^\s]+/
};
// `tel:` URI spec is https://datatracker.ietf.org/doc/html/rfc3966
// We're not validating the phone number or separators - but if there's a space it definitely isn't a valid `tel:` URI
$e44a90c52f7abdca$export$8ccbde94d5c7f8e7.add('tel:', $e44a90c52f7abdca$var$urlWithoutSpacesValidator);
// https://datatracker.ietf.org/doc/html/rfc8089
$e44a90c52f7abdca$export$8ccbde94d5c7f8e7.add('file:', $e44a90c52f7abdca$var$urlWithoutSpacesValidator);
$e44a90c52f7abdca$export$8ccbde94d5c7f8e7.add('notes:', 'http:');
const $e44a90c52f7abdca$var$tlds = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
const $e44a90c52f7abdca$var$tlds2Char = 'a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
$e44a90c52f7abdca$var$tlds.push($e44a90c52f7abdca$var$tlds2Char);
$e44a90c52f7abdca$export$8ccbde94d5c7f8e7.tlds($e44a90c52f7abdca$var$tlds, false);
const $e44a90c52f7abdca$export$746d02eae03c72e1 = /(https?|ftp|jamfselfservice|gopher|dynamicsnav|integrity|file|smb):\/\/[^\s]+/;
const $e44a90c52f7abdca$export$6f7d7761b97f967 = (text)=>{
    if (!$e44a90c52f7abdca$export$746d02eae03c72e1.test(text)) return [];
    const matches = [];
    let startpos = 0;
    let substr;
    while(substr = text.substr(startpos)){
        const link = (substr.match($e44a90c52f7abdca$export$746d02eae03c72e1) || [
            ''
        ])[0];
        if (link) {
            const index = substr.search($e44a90c52f7abdca$export$746d02eae03c72e1);
            const start = index >= 0 ? index + startpos : index;
            const end = start + link.length;
            matches.push({
                index: start,
                lastIndex: end,
                raw: link,
                url: link,
                text: link,
                schema: ''
            });
            startpos += end;
        } else break;
    }
    return matches;
};
function $e44a90c52f7abdca$export$ce9ae45aed3e4ec(str) {
    if (!str) return null;
    // linkify-it mishandles closing braces on long urls, so we preference using our own regex first:
    // https://product-fabric.atlassian.net/browse/ED-13669
    let match = $e44a90c52f7abdca$export$6f7d7761b97f967(str);
    if (!match.length) match = $e44a90c52f7abdca$export$8ccbde94d5c7f8e7.match(str);
    return match && match[0];
}
function $e44a90c52f7abdca$export$6535eb414fa2c8b6(url) {
    const match = $e44a90c52f7abdca$export$ce9ae45aed3e4ec(url);
    return match && match.url || '';
}
function $e44a90c52f7abdca$export$23579274a7a24f7b(url) {
    // Support `#top` and `#` special references as per:
    // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#linking_to_an_element_on_the_same_page
    return url.startsWith('/') || url === '#top' || url === '#';
}
module.exports["isSafeUrl"] = $e44a90c52f7abdca$export$c9f92f5469372e0f;
module.exports["linkify"] = $e44a90c52f7abdca$export$8ccbde94d5c7f8e7;
module.exports["linkifyMatch"] = $e44a90c52f7abdca$export$6f7d7761b97f967;
module.exports["getLinkMatch"] = $e44a90c52f7abdca$export$ce9ae45aed3e4ec;
module.exports["normalizeUrl"] = $e44a90c52f7abdca$export$6535eb414fa2c8b6;
module.exports["isRootRelative"] = $e44a90c52f7abdca$export$23579274a7a24f7b;

});

parcelRegister("jHxIB", function(module, exports) {
'use strict';




module.exports = function(opts) {
    var re = {};
    // Use direct extract instead of `regenerate` to reduse browserified size
    re.src_Any = (parcelRequire("6gKKW")).source;
    re.src_Cc = (parcelRequire("7wkNx")).source;
    re.src_Z = (parcelRequire("4QTDX")).source;
    re.src_P = (parcelRequire("eSMp5")).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join('|');
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join('|');
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    var text_separators = '[><\uff5c]';
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    ////////////////////////////////////////////////////////////////////////////////
    re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';
    re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
    re.src_host_terminator = '(?=$|' + text_separators + '|' + re.src_ZPCc + ')(?!-|_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-]).|' + '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' + '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' + '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + '|[-]).|' + // allow `I'm_king` if no pair found
    '\\.{2,4}[a-zA-Z0-9%/]|' + // github has ... in commit range links,
    // google has .... in links (issue #66)
    // Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // until more examples found.
    '\\.(?!' + re.src_ZCc + '|[.]).|' + (opts && opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
     : '\\-+|') + '\\,(?!' + re.src_ZCc + ').|' + // allow `,,,` in paths
    '\\!(?!' + re.src_ZCc + '|[!]).|' + '\\?(?!' + re.src_ZCc + '|[?]).' + ')+' + '|\\/' + ')?';
    // Allow anything in markdown spec, forbid quote (") at the first position
    // because emails enclosed in quotes are far more common
    re.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*';
    re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    '(?:' + re.src_xn + '|' + re.src_pseudo_letter + '{1,63}' + ')';
    re.src_domain = '(?:' + re.src_xn + '|' + '(?:' + re.src_pseudo_letter + ')' + '|' + '(?:' + re.src_pseudo_letter + '(?:-|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' + ')';
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ')\\.)*' + re.src_domain /*_root*/  + ')' + ')';
    re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' + ')';
    re.tpl_host_no_ip_fuzzy = '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    ////////////////////////////////////////////////////////////////////////////////
    // Main rules
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = 'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
    re.tpl_email_fuzzy = '(^|' + text_separators + '|"|\\(|' + re.src_ZCc + ')' + '(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
    return re;
};

});

parcelRegister("6gKKW", function(module, exports) {
module.exports = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;

});

parcelRegister("7wkNx", function(module, exports) {
module.exports = /[\0-\x1F\x7F-\x9F]/;

});

parcelRegister("4QTDX", function(module, exports) {
module.exports = /[ \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/;

});

parcelRegister("eSMp5", function(module, exports) {
module.exports = /[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4E\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDF55-\uDF59]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD806[\uDC3B\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/;

});

parcelRegister("1UrkW", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $ceXmR = parcelRequire("ceXmR");

var $6vky0 = parcelRequire("6vky0");

var $kRLUJ = parcelRequire("kRLUJ");

var $liMLZ = parcelRequire("liMLZ");

var $7uqCm = parcelRequire("7uqCm");

var $3ZA5r = parcelRequire("3ZA5r");

var $ivrsj = parcelRequire("ivrsj");


var $g7UR5 = parcelRequire("g7UR5");

const $164039e7164c06a1$var$getDefaultSchemaConfig = ()=>{
    const defaultSchemaConfig = {
        nodes: [
            'doc',
            'paragraph',
            'text',
            'bulletList',
            'orderedList',
            'listItem',
            'heading',
            'blockquote',
            'codeBlock',
            'panel',
            'rule',
            'image',
            'caption',
            'mention',
            'media',
            'mediaGroup',
            'mediaSingle',
            'mediaInline',
            'confluenceUnsupportedBlock',
            'confluenceUnsupportedInline',
            'confluenceJiraIssue',
            'expand',
            'nestedExpand',
            'extension',
            'inlineExtension',
            'bodiedExtension',
            'hardBreak',
            'emoji',
            'table',
            'tableCell',
            'tableHeader',
            'tableRow',
            'decisionList',
            'decisionItem',
            'taskList',
            'taskItem',
            'blockTaskItem',
            'unknownBlock',
            'date',
            'status',
            'placeholder',
            'layoutSection',
            'layoutColumn',
            'inlineCard',
            'blockCard',
            'embedCard',
            'unsupportedBlock',
            'unsupportedInline'
        ],
        marks: [
            'link',
            'em',
            'strong',
            'strike',
            'subsup',
            'underline',
            'code',
            'textColor',
            'backgroundColor',
            'confluenceInlineComment',
            'breakout',
            'alignment',
            'indentation',
            'annotation',
            'dataConsumer',
            'border',
            'unsupportedMark',
            'unsupportedNodeAttribute',
            'typeAheadQuery',
            // https://product-fabric.atlassian.net/browse/ED-10214,
            'fragment'
        ]
    };
    return defaultSchemaConfig;
};
const $164039e7164c06a1$export$e4e3ac1fa64862db = $164039e7164c06a1$var$getDefaultSchemaConfig();
const $164039e7164c06a1$export$fd147e7d448dea03 = (0, $2XqLN.default)((stage = 'final')=>{
    const defaultSchemaConfig = $164039e7164c06a1$var$getDefaultSchemaConfig();
    if (stage === 'stage0') defaultSchemaConfig.customNodeSpecs = {
        layoutSection: (0, $liMLZ.layoutSectionWithSingleColumn),
        multiBodiedExtension: (0, $kRLUJ.multiBodiedExtension),
        extensionFrame: (0, $kRLUJ.extensionFrame),
        expand: (0, $6vky0.expandWithNestedExpand),
        listItem: (0, $7uqCm.listItemWithDecisionStage0),
        table: (0, $ivrsj.tableWithNestedTable),
        tableRow: (0, $ivrsj.tableRowWithNestedTable),
        tableCell: (0, $ivrsj.tableCellWithNestedTable),
        tableHeader: (0, $ivrsj.tableHeaderWithNestedTable),
        syncBlock: $3ZA5r.syncBlock,
        bodiedSyncBlock: $ceXmR.bodiedSyncBlock
    };
    return (0, $g7UR5.createSchema)(defaultSchemaConfig);
});
const $164039e7164c06a1$export$1db618b7b2275ea1 = $164039e7164c06a1$export$fd147e7d448dea03();
module.exports["defaultSchemaConfig"] = $164039e7164c06a1$export$e4e3ac1fa64862db;
module.exports["getSchemaBasedOnStage"] = $164039e7164c06a1$export$fd147e7d448dea03;
module.exports["defaultSchema"] = $164039e7164c06a1$export$1db618b7b2275ea1;

});

parcelRegister("g7UR5", function(module, exports) {

var $5SAOw = parcelRequire("5SAOw");

// # What do marks exist?
//
// Marks are categorised into different groups. One motivation for this was to allow the `code` mark
// to exclude other marks, without needing to explicitly name them. Explicit naming requires the
// named mark to exist in the schema. This is undesirable because we want to construct different
// schemas that have different sets of nodes/marks.
//
// Groups provide a level of indirection, and solve this problem. For the immediate use-case, one
// group called "not_code" would have sufficed, but this an ultra-specialised to code.
// Mark group for font styling (e.g. bold, italic, underline, superscript).
const $0d1ed54b3a13220b$export$4498a6080fed604c = 'fontStyle';
const $0d1ed54b3a13220b$export$f8e8a5f34f6ea725 = 'searchQuery';
const $0d1ed54b3a13220b$export$b395009ca7f092c7 = 'link';
const $0d1ed54b3a13220b$export$9b982809044276a6 = 'color';
const $0d1ed54b3a13220b$export$470d0905851e47a1 = 'alignment';
const $0d1ed54b3a13220b$export$bacb7f4b06a06b22 = 'indentation';



var $jQdRj = parcelRequire("jQdRj");


var $ecu6E = parcelRequire("ecu6E");

var $e3kjM = parcelRequire("e3kjM");

var $aptVT = parcelRequire("aptVT");

var $l3V9m = parcelRequire("l3V9m");

var $gatAV = parcelRequire("gatAV");

var $2HOBr = parcelRequire("2HOBr");

var $7ucde = parcelRequire("7ucde");

const $2fb8217c654649d1$export$f3b72f8fc4684ecd = (0, $7ucde.confluenceInlineComment)({
    parseDOM: [
        {
            tag: 'span[data-mark-type="confluenceInlineComment"]'
        }
    ],
    toDOM (node) {
        return [
            'span',
            {
                'data-mark-type': 'confluenceInlineComment',
                'data-reference': node.attrs.reference
            }
        ];
    }
});


var $lU6iV = parcelRequire("lU6iV");

var $1pifj = parcelRequire("1pifj");

var $lhEMc = parcelRequire("lhEMc");

var $5psdk = parcelRequire("5psdk");

var $nd92h = parcelRequire("nd92h");

var $6q8Jb = parcelRequire("6q8Jb");

var $dQvvU = parcelRequire("dQvvU");

var $8oCiy = parcelRequire("8oCiy");

var $6Hx3Z = parcelRequire("6Hx3Z");

var $iq4tW = parcelRequire("iq4tW");

var $8rCC1 = parcelRequire("8rCC1");

var $j1K1a = parcelRequire("j1K1a");

var $gWd3C = parcelRequire("gWd3C");


var $5vHpv = parcelRequire("5vHpv");

var $3GSVg = parcelRequire("3GSVg");

var $cZjaR = parcelRequire("cZjaR");

var $ceXmR = parcelRequire("ceXmR");

var $76Qef = parcelRequire("76Qef");

var $8Dbmz = parcelRequire("8Dbmz");

var $7tm9l = parcelRequire("7tm9l");

var $iAg3T = parcelRequire("iAg3T");

var $8C6Yu = parcelRequire("8C6Yu");

var $l0xmR = parcelRequire("l0xmR");

var $hw68I = parcelRequire("hw68I");

var $5lAbC = parcelRequire("5lAbC");

var $frYg8 = parcelRequire("frYg8");

var $5Tpzn = parcelRequire("5Tpzn");

var $7r9po = parcelRequire("7r9po");

var $86xUj = parcelRequire("86xUj");

var $6vky0 = parcelRequire("6vky0");

var $6D9dG = parcelRequire("6D9dG");

var $0pwCz = parcelRequire("0pwCz");

var $dmAsx = parcelRequire("dmAsx");

var $kRLUJ = parcelRequire("kRLUJ");

var $lrauW = parcelRequire("lrauW");

var $1kn6Y = parcelRequire("1kn6Y");

var $hOedk = parcelRequire("hOedk");

var $fLuch = parcelRequire("fLuch");

var $2JFVM = parcelRequire("2JFVM");

var $1BLdm = parcelRequire("1BLdm");

var $liMLZ = parcelRequire("liMLZ");

var $7uqCm = parcelRequire("7uqCm");

var $53bvm = parcelRequire("53bvm");

var $cJm3M = parcelRequire("cJm3M");

var $6CTq8 = parcelRequire("6CTq8");

var $gbkVM = parcelRequire("gbkVM");

var $8cHA0 = parcelRequire("8cHA0");

var $3x4Nz = parcelRequire("3x4Nz");

var $bOKwh = parcelRequire("bOKwh");

var $k9bwp = parcelRequire("k9bwp");

var $l8Svu = parcelRequire("l8Svu");

var $d5tvP = parcelRequire("d5tvP");

var $8W1Po = parcelRequire("8W1Po");

var $3ZA5r = parcelRequire("3ZA5r");

var $ivrsj = parcelRequire("ivrsj");

var $bc9VB = parcelRequire("bc9VB");

var $lJq4s = parcelRequire("lJq4s");

var $9bakv = parcelRequire("9bakv");

var $8oL6j = parcelRequire("8oL6j");

var $8fWld = parcelRequire("8fWld");

function $bbd967088d57b342$var$addItems(builtInItems, config, customSpecs = {}) {
    if (!config) return {};
    /**
   * Add built-in Node / Mark specs
   */ const items = builtInItems.reduce((items, { name: name, spec: spec })=>{
        if (config.indexOf(name) !== -1) items[name] = customSpecs[name] || spec;
        return items;
    }, {});
    /**
   * Add Custom Node / Mark specs
   */ return Object.keys(customSpecs).reduce((items, name)=>{
        if (items[name]) return items;
        items[name] = customSpecs[name];
        return items;
    }, items);
}
// We use groups to allow schemas to be constructed in different shapes without changing node/mark
// specs, but this means nodes/marks are defined with groups that might never be used in the schema.
// In this scenario ProseMirror will complain and prevent the schema from being constructed.
//
// To avoid the problem, we include items that serve to "declare" the groups in the schema. This
// approach unfortunately leaves unused items in the schema, but has the benefit of avoiding the
// need to manipulate `exclude` or content expression values for potentially every schema item.
function $bbd967088d57b342$var$groupDeclaration(name) {
    return {
        name: `__${name}GroupDeclaration`,
        spec: {
            group: name
        }
    };
}
const $bbd967088d57b342$var$markGroupDeclarations = [
    $bbd967088d57b342$var$groupDeclaration((0, $0d1ed54b3a13220b$export$9b982809044276a6)),
    $bbd967088d57b342$var$groupDeclaration((0, $0d1ed54b3a13220b$export$4498a6080fed604c)),
    $bbd967088d57b342$var$groupDeclaration((0, $0d1ed54b3a13220b$export$f8e8a5f34f6ea725)),
    $bbd967088d57b342$var$groupDeclaration((0, $0d1ed54b3a13220b$export$b395009ca7f092c7))
];
const $bbd967088d57b342$var$markGroupDeclarationsNames = $bbd967088d57b342$var$markGroupDeclarations.map((groupMark)=>groupMark.name);
const $bbd967088d57b342$var$nodesInOrder = [
    {
        name: 'doc',
        spec: (0, $5Tpzn.doc)
    },
    {
        name: 'paragraph',
        spec: (0, $k9bwp.paragraph)
    },
    {
        name: 'text',
        spec: (0, $lJq4s.text)
    },
    {
        name: 'bulletList',
        spec: (0, $76Qef.bulletList)
    },
    {
        name: 'orderedList',
        spec: (0, $bOKwh.orderedListWithOrder)
    },
    {
        name: 'listItem',
        spec: (0, $7uqCm.listItem)
    },
    {
        name: 'heading',
        spec: (0, $1kn6Y.heading)
    },
    {
        name: 'blockquote',
        spec: (0, $6D9dG.extendedBlockquote)
    },
    {
        name: 'codeBlock',
        spec: (0, $7tm9l.codeBlock)
    },
    {
        name: 'panel',
        spec: (0, $0pwCz.extendedPanel)(true)
    },
    {
        name: 'rule',
        spec: (0, $d5tvP.rule)
    },
    {
        name: 'image',
        spec: (0, $hOedk.image)
    },
    {
        name: 'mention',
        spec: (0, $8cHA0.mention)
    },
    {
        name: 'caption',
        spec: (0, $8Dbmz.caption)
    },
    {
        name: 'media',
        spec: (0, $53bvm.media)
    },
    {
        name: 'mediaGroup',
        spec: (0, $cJm3M.mediaGroup)
    },
    {
        name: 'mediaSingle',
        spec: (0, $gbkVM.mediaSingleFull)
    },
    {
        name: 'mediaInline',
        spec: (0, $6CTq8.mediaInline)
    },
    {
        name: 'placeholder',
        spec: (0, $l8Svu.placeholder)
    },
    {
        name: 'layoutSection',
        spec: (0, $liMLZ.layoutSection)
    },
    {
        name: 'layoutColumn',
        spec: (0, $1BLdm.layoutColumn)
    },
    {
        name: 'hardBreak',
        spec: (0, $lrauW.hardBreak)
    },
    {
        name: 'emoji',
        spec: (0, $86xUj.emoji)
    },
    {
        name: 'table',
        spec: (0, $ivrsj.table)
    },
    {
        name: 'tableCell',
        spec: (0, $ivrsj.tableCell)
    },
    {
        name: 'tableRow',
        spec: (0, $ivrsj.tableRow)
    },
    {
        name: 'tableHeader',
        spec: (0, $ivrsj.tableHeader)
    },
    {
        name: 'confluenceJiraIssue',
        spec: (0, $iAg3T.confluenceJiraIssue)
    },
    {
        name: 'confluenceUnsupportedInline',
        spec: (0, $l0xmR.confluenceUnsupportedInline)
    },
    {
        name: 'confluenceUnsupportedBlock',
        spec: (0, $8C6Yu.confluenceUnsupportedBlock)
    },
    {
        name: 'decisionList',
        spec: (0, $frYg8.decisionList)
    },
    {
        name: 'decisionItem',
        spec: (0, $5lAbC.decisionItem)
    },
    {
        name: 'taskList',
        spec: (0, $bc9VB.taskList)
    },
    {
        name: 'taskItem',
        spec: (0, $3GSVg.taskItem)
    },
    {
        name: 'blockTaskItem',
        spec: (0, $3GSVg.blockTaskItem)
    },
    {
        name: 'date',
        spec: (0, $hw68I.date)
    },
    {
        name: 'status',
        spec: (0, $8W1Po.status)
    },
    {
        name: 'expand',
        spec: (0, $6vky0.expandWithNestedExpand)
    },
    {
        name: 'nestedExpand',
        spec: (0, $3x4Nz.nestedExpand)
    },
    {
        name: 'extension',
        spec: (0, $dmAsx.extension)
    },
    {
        name: 'inlineExtension',
        spec: (0, $2JFVM.inlineExtension)
    },
    {
        name: 'bodiedExtension',
        spec: (0, $cZjaR.bodiedExtension)
    },
    {
        name: 'multiBodiedExtension',
        spec: (0, $kRLUJ.multiBodiedExtension)
    },
    {
        name: 'extensionFrame',
        spec: (0, $kRLUJ.extensionFrame)
    },
    {
        name: 'inlineCard',
        spec: (0, $fLuch.inlineCard)
    },
    {
        name: 'blockCard',
        spec: (0, $5vHpv.blockCard)
    },
    {
        name: 'embedCard',
        spec: (0, $7r9po.embedCard)
    },
    {
        name: 'syncBlock',
        spec: (0, $3ZA5r.syncBlock)
    },
    {
        name: 'bodiedSyncBlock',
        spec: (0, $ceXmR.bodiedSyncBlock)
    },
    {
        name: 'unknownBlock',
        spec: (0, $9bakv.default)
    },
    {
        name: 'unsupportedBlock',
        spec: (0, $8oL6j.unsupportedBlock)
    },
    {
        name: 'unsupportedInline',
        spec: (0, $8fWld.unsupportedInline)
    }
];
const $bbd967088d57b342$var$marksInOrder = [
    {
        name: 'link',
        spec: (0, $nd92h.link)
    },
    {
        name: 'em',
        spec: (0, $1pifj.em)
    },
    {
        name: 'strong',
        spec: (0, $dQvvU.strong)
    },
    {
        name: 'textColor',
        spec: (0, $6Hx3Z.textColor)
    },
    {
        name: 'backgroundColor',
        spec: (0, $aptVT.backgroundColor)
    },
    {
        name: 'strike',
        spec: (0, $6q8Jb.strike)
    },
    {
        name: 'subsup',
        spec: (0, $8oCiy.subsup)
    },
    {
        name: 'underline',
        spec: (0, $8rCC1.underline)
    },
    {
        name: 'code',
        spec: (0, $2HOBr.code)
    },
    {
        name: 'typeAheadQuery',
        spec: (0, $iq4tW.typeAheadQuery)
    },
    {
        name: 'alignment',
        spec: (0, $ecu6E.alignment)
    },
    {
        name: 'annotation',
        spec: (0, $e3kjM.annotation)
    },
    {
        name: 'confluenceInlineComment',
        spec: (0, $2fb8217c654649d1$export$f3b72f8fc4684ecd)
    },
    ...$bbd967088d57b342$var$markGroupDeclarations,
    {
        name: 'breakout',
        spec: (0, $gatAV.breakout)
    },
    {
        name: 'dataConsumer',
        spec: (0, $lU6iV.dataConsumer)
    },
    {
        name: 'fragment',
        spec: (0, $lhEMc.fragment)
    },
    {
        name: 'indentation',
        spec: (0, $5psdk.indentation)
    },
    {
        name: 'border',
        spec: (0, $l3V9m.border)
    },
    {
        name: 'unsupportedMark',
        spec: (0, $j1K1a.unsupportedMark)
    },
    {
        name: 'unsupportedNodeAttribute',
        spec: (0, $gWd3C.unsupportedNodeAttribute)
    }
];
function $bbd967088d57b342$export$2d0c32a809131488() {
    const nodes = $bbd967088d57b342$var$nodesInOrder.reduce((acc, { name: name, spec: spec })=>{
        // @ts-expect-error - Type for SchemaBuiltInItem is not correct
        acc[name] = spec;
        return acc;
    }, {});
    const marks = $bbd967088d57b342$var$marksInOrder.reduce((acc, { name: name, spec: spec })=>{
        // @ts-expect-error - Type for SchemaBuiltInItem is not correct
        acc[name] = spec;
        return acc;
    }, {});
    return {
        nodes: nodes,
        marks: marks
    };
}
function $bbd967088d57b342$export$5f4ce795563f4211(config) {
    const { customNodeSpecs: customNodeSpecs, customMarkSpecs: customMarkSpecs } = config;
    const nodesConfig = Object.keys(customNodeSpecs || {}).concat(config.nodes);
    const marksConfig = Object.keys(customMarkSpecs || {}).concat(config.marks || []).concat($bbd967088d57b342$var$markGroupDeclarationsNames);
    let nodes = $bbd967088d57b342$var$addItems($bbd967088d57b342$var$nodesInOrder, nodesConfig, customNodeSpecs);
    const marks = $bbd967088d57b342$var$addItems($bbd967088d57b342$var$marksInOrder, marksConfig, customMarkSpecs);
    nodes = (0, $jQdRj.sanitizeNodes)(nodes, marks);
    return new (0, $5SAOw.Schema)({
        nodes: nodes,
        marks: marks
    });
}
const $bbd967088d57b342$export$c77b6d30da5276a1 = true;
module.exports["createSchema"] = $bbd967088d57b342$export$5f4ce795563f4211;

});

parcelRegister("ecu6E", function(module, exports) {

var $7ucde = parcelRequire("7ucde");

const $a5698a2b9a7c8d6d$export$be9cf49015769bbd = {
    end: 'right',
    right: 'end',
    center: 'center'
};
const $a5698a2b9a7c8d6d$export$8e53000a4ec837 = (0, $7ucde.alignment)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-block-mark',
            getAttrs: (dom)=>{
                const align = dom.getAttribute('data-align');
                return align ? {
                    align: align
                } : false;
            }
        }
    ],
    toDOM (mark) {
        return [
            'div',
            {
                class: `fabric-editor-block-mark fabric-editor-alignment fabric-editor-align-${mark.attrs.align}`,
                'data-align': mark.attrs.align
            },
            0
        ];
    }
});
module.exports["alignmentPositionMap"] = $a5698a2b9a7c8d6d$export$be9cf49015769bbd;
module.exports["alignment"] = $a5698a2b9a7c8d6d$export$8e53000a4ec837;

});

parcelRegister("aptVT", function(module, exports) {

var $7ucde = parcelRequire("7ucde");


var $bxopY = parcelRequire("bxopY");


var $eoZWa = parcelRequire("eoZWa");


var $6Hx3Z = parcelRequire("6Hx3Z");


var $bAH9E = parcelRequire("bAH9E");

/**
 * @name backgroundColor_mark
 */ // Remove this when cleaning up platform_editor_add_orange_highlight_color
const $794375338e99e3d9$var$colorArrayPalette = [
    [
        (0, $eoZWa.Neutral300),
        'Gray'
    ],
    // token: color.background.accent.gray.subtler
    [
        (0, $eoZWa.T200),
        'Teal'
    ],
    // token: color.background.accent.teal.subtler
    [
        (0, $eoZWa.L200),
        'Lime'
    ],
    // token: color.background.accent.lime.subtler
    [
        (0, $eoZWa.O200),
        'Orange'
    ],
    // token: color.background.accent.orange.subtler
    [
        (0, $eoZWa.M200),
        'Magenta'
    ],
    // token: color.background.accent.magenta.subtler
    [
        (0, $eoZWa.P200),
        'Purple'
    ] // token: color.background.accent.purple.subtler
];
const $794375338e99e3d9$var$colorArrayPaletteNext = [
    [
        (0, $eoZWa.Neutral300),
        'Gray'
    ],
    // token: color.background.accent.gray.subtler
    [
        (0, $eoZWa.P200),
        'Purple'
    ],
    // token: color.background.accent.purple.subtler
    [
        (0, $eoZWa.M200),
        'Magenta'
    ],
    // token: color.background.accent.magenta.subtler
    [
        (0, $eoZWa.O200),
        'Orange'
    ],
    // token: color.background.accent.orange.subtler
    [
        (0, $eoZWa.Yellow200),
        'Yellow'
    ],
    // token: color.background.accent.yellow.subtler
    [
        (0, $eoZWa.L200),
        'Lime'
    ],
    // token: color.background.accent.lime.subtler
    [
        (0, $eoZWa.T200),
        'Teal'
    ] // token: color.background.accent.teal.subtler
];
const $794375338e99e3d9$export$14ec3f21a268e497 = new Map();
$794375338e99e3d9$var$colorArrayPalette.forEach(([color, label])=>$794375338e99e3d9$export$14ec3f21a268e497.set(color.toLowerCase(), label));
const $794375338e99e3d9$export$7ab6fa38cecaeee2 = new Map();
$794375338e99e3d9$var$colorArrayPaletteNext.forEach(([color, label])=>$794375338e99e3d9$export$7ab6fa38cecaeee2.set(color.toLowerCase(), label));
const $794375338e99e3d9$export$8c5a050822fd698c = (0, $7ucde.backgroundColor)({
    parseDOM: [
        {
            style: 'background-color',
            getAttrs: (maybeValue)=>{
                const value = maybeValue;
                let hexColor;
                if (value.match(/^rgb/i)) hexColor = (0, $eoZWa.rgbToHex)(value);
                else if (value[0] === '#') hexColor = value.toLowerCase();
                // else handle other colour formats
                return hexColor && $794375338e99e3d9$export$14ec3f21a268e497.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        },
        // This rule ensures when loading from a renderer or editor where the
        // presented text color does not match the stored hex color -- that the
        // text color is preserved.
        //
        // This is used to support the work-around that converts the hex color to
        // a design system token to enable light / dark mode (through a CSS variable --custom-palette-color)
        {
            tag: '.fabric-background-color-mark',
            getAttrs: (maybeElement)=>{
                if (!(maybeElement instanceof HTMLElement)) return false;
                const hexColor = maybeElement.dataset.backgroundCustomColor;
                return hexColor && $794375338e99e3d9$export$14ec3f21a268e497.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        }
    ],
    toDOM (mark) {
        let paletteColorValue;
        /**
     * Documents can contain custom colors when content has been migrated from the old editor, or created via APIs.
     *
     * This behaviour predates the introduction of dark mode.
     *
     * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect text colors copied from external editor sources. Where we load the background color from a
     * separate attribute (data-text-custom-color), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
     */ const tokenColor = (0, $bxopY.hexToEditorTextBackgroundPaletteColor)(mark.attrs.color);
        if (tokenColor) paletteColorValue = tokenColor;
        else if ((0, $6Hx3Z.getGlobalTheme)().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
        paletteColorValue = (0, $bAH9E.getDarkModeLCHColor)(mark.attrs.color);
        else // if we are in light mode, we can just set the color
        paletteColorValue = mark.attrs.color;
        return [
            'span',
            {
                class: 'fabric-background-color-mark',
                // Editor common has a common style which uses this css variable as the value for
                // the color property using the `fabric-text-background-color-mark` selector applied above.
                style: `--custom-palette-color: ${paletteColorValue}`,
                ['data-background-custom-color']: mark.attrs.color
            }
        ];
    }
});
module.exports["backgroundColorPalette"] = $794375338e99e3d9$export$14ec3f21a268e497;
module.exports["backgroundColorPaletteNext"] = $794375338e99e3d9$export$7ab6fa38cecaeee2;
module.exports["backgroundColor"] = $794375338e99e3d9$export$8c5a050822fd698c;

});

parcelRegister("6Hx3Z", function(module, exports) {

var $7ucde = parcelRequire("7ucde");


var $bxopY = parcelRequire("bxopY");


var $eoZWa = parcelRequire("eoZWa");


var $bAH9E = parcelRequire("bAH9E");

/**
 * @name textColor_mark
 */ // used for extended palette in text color picker
const $4e1067e5be16b22d$var$colorArrayPalette = [
    // default row - first color is added programatically
    // [N800, 'Squid ink'], // default dark gray
    [
        (0, $eoZWa.B500),
        'Dark blue'
    ],
    // Chore coat
    [
        (0, $eoZWa.T500),
        'Dark teal'
    ],
    // Shabby chic
    [
        (0, $eoZWa.G500),
        'Dark green'
    ],
    // Keen green
    [
        (0, $eoZWa.Y400),
        'Orange'
    ],
    // Cheezy blasters
    [
        (0, $eoZWa.R500),
        'Dark red'
    ],
    // Dragon's blood
    [
        (0, $eoZWa.P500),
        'Dark purple'
    ],
    // Prince
    // row 2
    [
        (0, $eoZWa.N80),
        'Light gray'
    ],
    // Spooky ghost
    [
        (0, $eoZWa.B100),
        'Blue'
    ],
    // Arvo breeze
    [
        (0, $eoZWa.T300),
        'Teal'
    ],
    // Tamarama
    [
        (0, $eoZWa.G300),
        'Green'
    ],
    // Fine pine
    [
        (0, $eoZWa.Y200),
        'Yellow'
    ],
    // Pub mix
    [
        (0, $eoZWa.R300),
        'Red'
    ],
    // Poppy surprise
    [
        (0, $eoZWa.P300),
        'Purple'
    ],
    // Da' juice
    // row 3
    [
        (0, $eoZWa.N0),
        'White'
    ],
    [
        (0, $eoZWa.B75),
        'Light blue'
    ],
    // Schwag
    [
        (0, $eoZWa.T75),
        'Light teal'
    ],
    // Arctic chill
    [
        (0, $eoZWa.G75),
        'Light green'
    ],
    // Mintie
    [
        (0, $eoZWa.Y75),
        'Light yellow'
    ],
    // Dandelion whisper
    [
        (0, $eoZWa.R75),
        'Light red'
    ],
    // Bondi sunburn
    [
        (0, $eoZWa.P50),
        'Light purple'
    ] // Lavender secret
];
const $4e1067e5be16b22d$export$569885e57444f84a = new Map();
const $4e1067e5be16b22d$export$81e5ed9e84fe2e28 = $4e1067e5be16b22d$export$569885e57444f84a;
$4e1067e5be16b22d$var$colorArrayPalette.forEach(([color, label])=>$4e1067e5be16b22d$export$569885e57444f84a.set(color.toLowerCase(), label));
// these are for test only
let $4e1067e5be16b22d$var$testGlobalTheme;
const $4e1067e5be16b22d$export$fd7e0dd2b74807f7 = (theme)=>{
    $4e1067e5be16b22d$var$testGlobalTheme = theme;
};
const $4e1067e5be16b22d$export$813ecdf77207a053 = ()=>{
    // This should only be hit during tests.
    //
    // At time of writing Jest mocks are not working in this repository.
    if ($4e1067e5be16b22d$var$testGlobalTheme) return {
        colorMode: $4e1067e5be16b22d$var$testGlobalTheme
    };
    const element = document.documentElement;
    const colorMode = element.getAttribute('data-color-mode') || '';
    return {
        colorMode: colorMode
    };
};
const $4e1067e5be16b22d$export$32f78bffcd82ff28 = (0, $7ucde.textColor)({
    parseDOM: [
        {
            style: 'color',
            getAttrs: (maybeValue)=>{
                const value = maybeValue;
                let hexColor;
                if (value.match(/^rgb/i)) hexColor = (0, $eoZWa.rgbToHex)(value);
                else if (value[0] === '#') hexColor = value.toLowerCase();
                // else handle other colour formats
                return hexColor && $4e1067e5be16b22d$export$569885e57444f84a.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        },
        // This rule ensures when loading from a renderer or editor where the
        // presented text color does not match the stored hex color -- that the
        // text color is preserved.
        //
        // This was initially introduced to ensure text-color marks were not lost
        // when text-color was used inside a link, and is now also used to support
        // where the hex color stored in ADF is used as an ID for a design system
        // token (and based on theme mode -- the presented color will change).
        {
            tag: '.fabric-text-color-mark',
            getAttrs: (maybeElement)=>{
                if (!(maybeElement instanceof HTMLElement)) return false;
                const hexColor = maybeElement.dataset.textCustomColor;
                return hexColor && $4e1067e5be16b22d$export$569885e57444f84a.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        }
    ],
    toDOM (mark) {
        let paletteColorValue;
        // Note -- while there is no way to create custom colors using default tooling
        // the editor does supported ad hoc color values -- and there may be content
        // which has been migrated or created via apis which use such values.
        /**
     * The Editor persists custom text colors when content has been migrated from the old editor, or created via
     * apis.
     *
     * This behaviour predates the introduction of dark mode.
     *
     * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect text colors copied from external editor sources. Where we load the background color from a
     * seperate attribute (data-text-custom-color), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
     */ const tokenColor = (0, $bxopY.hexToEditorTextPaletteColor)(mark.attrs.color);
        if (tokenColor) paletteColorValue = tokenColor;
        else if ($4e1067e5be16b22d$export$813ecdf77207a053().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
        paletteColorValue = (0, $bAH9E.getDarkModeLCHColor)(mark.attrs.color);
        else // if we are in light mode, we can just set the color
        paletteColorValue = mark.attrs.color;
        return [
            'span',
            {
                class: 'fabric-text-color-mark',
                // Editor common has a common style which uses this css variable as the value for
                // the color property using the `fabric-text-color-mark` selector applied above.
                style: `--custom-palette-color: ${paletteColorValue}`,
                ['data-text-custom-color']: mark.attrs.color
            }
        ];
    }
});
module.exports["colorPalette"] = $4e1067e5be16b22d$export$569885e57444f84a;
module.exports["getGlobalTheme"] = $4e1067e5be16b22d$export$813ecdf77207a053;
module.exports["textColor"] = $4e1067e5be16b22d$export$32f78bffcd82ff28;

});

parcelRegister("l3V9m", function(module, exports) {

var $7ucde = parcelRequire("7ucde");


var $bxopY = parcelRequire("bxopY");


var $eoZWa = parcelRequire("eoZWa");

/**
 * @name border_mark
 * @description This mark adds decoration to an element, and any element decorated with it will also have a border style.
 */ const $f556359b8703013e$var$borderColorArrayPalette = [
    [
        (0, $eoZWa.N300A),
        'Subtle gray'
    ],
    [
        (0, $eoZWa.N600),
        'Gray'
    ],
    [
        (0, $eoZWa.N1000),
        'Bold gray'
    ]
];
const $f556359b8703013e$export$e4e044c989c86ca7 = new Map();
$f556359b8703013e$var$borderColorArrayPalette.forEach(([color, label])=>$f556359b8703013e$export$e4e044c989c86ca7.set(color.toLowerCase(), label));
const $f556359b8703013e$export$1edee58a52776cd9 = (0, $7ucde.border)({
    parseDOM: [
        {
            tag: '[data-mark-type="border"]',
            getAttrs: (domNode)=>{
                var _dom$getAttribute, _dom$getAttribute2;
                const dom = domNode;
                const color = ((_dom$getAttribute = dom.getAttribute('data-color')) !== null && _dom$getAttribute !== void 0 ? _dom$getAttribute : '').toLowerCase();
                const size = +((_dom$getAttribute2 = dom.getAttribute('data-size')) !== null && _dom$getAttribute2 !== void 0 ? _dom$getAttribute2 : '0');
                return {
                    size: size > 3 ? 3 : size < 1 ? false : size,
                    color: $f556359b8703013e$export$e4e044c989c86ca7.has(color) ? color : false
                };
            }
        }
    ],
    toDOM (mark, isInline) {
        const wrapperStyle = isInline ? 'span' : 'div';
        // Note -- while there is no way to create custom colors using default tooling
        // the editor does supported ad hoc color values -- and there may be content
        // which has been migrated or created via apis which use such values.
        const paletteColorValue = (0, $bxopY.hexToEditorBorderPaletteColor)(mark.attrs.color) || mark.attrs.color;
        return [
            wrapperStyle,
            {
                'data-mark-type': 'border',
                'data-color': mark.attrs.color,
                'data-size': mark.attrs.size,
                style: `--custom-palette-color: ${paletteColorValue}`
            }
        ];
    }
});
module.exports["borderColorPalette"] = $f556359b8703013e$export$e4e044c989c86ca7;
module.exports["border"] = $f556359b8703013e$export$1edee58a52776cd9;

});

parcelRegister("gatAV", function(module, exports) {

var $7ucde = parcelRequire("7ucde");

const $bc54895d6308f4e9$var$allowedTypes = [
    'wide',
    'full-width'
];
const $bc54895d6308f4e9$export$89015c65f1c75e3f = (0, $7ucde.breakout)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-breakout-mark',
            getAttrs (dom) {
                const mode = dom.getAttribute('data-mode');
                const width = dom.getAttribute('data-width');
                return {
                    mode: $bc54895d6308f4e9$var$allowedTypes.indexOf(mode || '') === -1 ? 'wide' : mode,
                    width: width ? parseInt(width) : null
                };
            }
        }
    ],
    toDOM (mark) {
        var _mark$attrs;
        return [
            'div',
            {
                class: 'fabric-editor-breakout-mark',
                'data-mode': mark.attrs.mode,
                'data-width': (_mark$attrs = mark.attrs) === null || _mark$attrs === void 0 ? void 0 : _mark$attrs.width
            },
            0
        ];
    }
});
module.exports["breakout"] = $bc54895d6308f4e9$export$89015c65f1c75e3f;

});

parcelRegister("2HOBr", function(module, exports) {

var $7ucde = parcelRequire("7ucde");

const $1f86d99f84e1c430$export$6565f9f03506010b = (0, $7ucde.code)({
    parseDOM: [
        {
            tag: 'span.code',
            preserveWhitespace: true
        },
        {
            tag: 'code',
            preserveWhitespace: true
        },
        {
            tag: 'tt',
            preserveWhitespace: true
        },
        {
            tag: 'span',
            preserveWhitespace: true,
            getAttrs: (domNode)=>{
                const dom = domNode;
                if (dom.style.whiteSpace === 'pre') return {};
                if (dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') >= 0) return {};
                return false;
            }
        }
    ],
    toDOM () {
        return [
            'span',
            {
                class: 'code',
                spellcheck: 'false'
            }
        ];
    }
});
module.exports["code"] = $1f86d99f84e1c430$export$6565f9f03506010b;

});

parcelRegister("lU6iV", function(module, exports) {

var $7ucde = parcelRequire("7ucde");


var $filql = parcelRequire("filql");

/**
 * This annotation is purely for reference, & does _nothing_ given annotating
 * `minLength` on an array of strings is not supported with our schema+spec
 * generator.
 *
 * We're keeping it to signal that data consumer `sources` shouldn't be empty
 * strings
 *
 * // @minLength 1
 */ /**
 * @name dataConsumer_mark
 * @description This mark is used for metadata surrounding a node consuming data
 * from a given source node
 */ const $ff23b7d930bb16f4$var$parseDataConsumer = (maybeValue)=>{
    const sources = (0, $filql.isDOMElement)(maybeValue) && maybeValue.getAttribute('data-sources');
    try {
        return sources ? {
            sources: JSON.parse(sources)
        } : false;
    } catch  {
        return false;
    }
};
const $ff23b7d930bb16f4$export$3024f02c495408d6 = (0, $7ucde.dataConsumer)({
    parseDOM: [
        {
            tag: '[data-mark-type="dataConsumer"]',
            getAttrs: (maybeValue)=>$ff23b7d930bb16f4$var$parseDataConsumer(maybeValue)
        }
    ],
    toDOM (mark, inline) {
        const wrapperStyle = inline ? 'span' : 'div';
        return [
            wrapperStyle,
            {
                'data-mark-type': 'dataConsumer',
                'data-sources': JSON.stringify(mark.attrs.sources)
            }
        ];
    }
});
const $ff23b7d930bb16f4$export$54fd2c36b5cc6731 = (mark)=>{
    // // Remove intemediary state if we don't have any sources on data consumer
    // if (mark.attrs?.sources?.length < 1) {
    //   return null;
    // }
    return {
        type: mark.type.name,
        attrs: Object.keys(mark.attrs).filter((key)=>key === 'sources' && mark.attrs[key].length > 0 && mark.attrs[key] !== null).reduce((acc, key)=>{
            return {
                ...acc,
                [key]: mark.attrs[key]
            };
        }, {})
    };
};
module.exports["dataConsumer"] = $ff23b7d930bb16f4$export$3024f02c495408d6;
module.exports["toJSON"] = $ff23b7d930bb16f4$export$54fd2c36b5cc6731;

});

parcelRegister("1pifj", function(module, exports) {

var $7ucde = parcelRequire("7ucde");

/**
 * @name em_mark
 */ const $1066477fb13fa731$var$emDOM = [
    'em'
];
const $1066477fb13fa731$export$c63c6f932822f543 = (0, $7ucde.em)({
    parseDOM: [
        {
            tag: 'i'
        },
        {
            tag: 'em'
        },
        {
            style: 'font-style=italic'
        }
    ],
    toDOM () {
        return $1066477fb13fa731$var$emDOM;
    }
});
module.exports["em"] = $1066477fb13fa731$export$c63c6f932822f543;

});

parcelRegister("lhEMc", function(module, exports) {

var $7ucde = parcelRequire("7ucde");


var $filql = parcelRequire("filql");

/**
 * @name fragment_mark
 * @description Indicates that the elements decorated with this mark belong to a "fragment" entity, which represents a collection of ADF nodes.
 * This entity can be referred to later by its `localId` attribute.
 */ const $f7ead0dcd6123def$var$parseFragment = (maybeValue)=>{
    var _maybeValue$getAttrib;
    if (!(0, $filql.isDOMElement)(maybeValue)) return false;
    const name = (_maybeValue$getAttrib = maybeValue.getAttribute('data-name')) !== null && _maybeValue$getAttrib !== void 0 ? _maybeValue$getAttrib : undefined;
    const localId = maybeValue.getAttribute('data-localId');
    if (!localId) return false;
    return {
        localId: localId,
        name: name
    };
};
const $f7ead0dcd6123def$export$f00aeb236b6f05af = (0, $7ucde.fragment)({
    parseDOM: [
        {
            tag: '[data-mark-type="fragment"]',
            getAttrs: (maybeValue)=>$f7ead0dcd6123def$var$parseFragment(maybeValue)
        }
    ],
    toDOM (mark, inline) {
        const wrapperStyle = inline ? 'span' : 'div';
        return [
            wrapperStyle,
            {
                'data-mark-type': 'fragment',
                'data-name': mark.attrs.name,
                'data-localId': mark.attrs.localId
            }
        ];
    }
});
const $f7ead0dcd6123def$export$54fd2c36b5cc6731 = (mark)=>{
    return {
        type: mark.type.name,
        attrs: {
            localId: mark.attrs.localId,
            ...mark.attrs.name ? {
                name: mark.attrs.name
            } : {}
        }
    };
};
module.exports["fragment"] = $f7ead0dcd6123def$export$f00aeb236b6f05af;
module.exports["toJSON"] = $f7ead0dcd6123def$export$54fd2c36b5cc6731;

});

parcelRegister("5psdk", function(module, exports) {

var $7ucde = parcelRequire("7ucde");

const $3f052c485ec9aba4$export$480c699bd4ec0d86 = (0, $7ucde.indentation)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-indentation-mark',
            getAttrs (dom) {
                const level = +(dom.getAttribute('data-level') || '0');
                return {
                    level: level > 6 ? 6 : level < 1 ? false : level
                };
            }
        }
    ],
    toDOM (mark) {
        return [
            'div',
            {
                class: 'fabric-editor-block-mark fabric-editor-indentation-mark',
                'data-level': mark.attrs.level
            },
            0
        ];
    }
});
module.exports["indentation"] = $3f052c485ec9aba4$export$480c699bd4ec0d86;

});

parcelRegister("nd92h", function(module, exports) {

var $7ucde = parcelRequire("7ucde");


var $jBbIP = parcelRequire("jBbIP");

const $045c585e4167c6c7$export$b5f67017585d1431 = (attribute)=>(domNode)=>{
        const dom = domNode;
        const href = dom.getAttribute(attribute) || '';
        const attrs = {
            __confluenceMetadata: dom.hasAttribute('__confluenceMetadata') ? JSON.parse(dom.getAttribute('__confluenceMetadata') || '') : undefined
        };
        if (!(0, $jBbIP.isSafeUrl)(href)) return false;
        if ((0, $jBbIP.isRootRelative)(href)) {
            attrs.href = href;
            return attrs;
        }
        attrs.href = (0, $jBbIP.normalizeUrl)(href);
        return attrs;
    };
const $045c585e4167c6c7$export$9c30223ca0a664fb = (0, $7ucde.link)({
    parseDOM: [
        {
            tag: '[data-block-link]',
            getAttrs: $045c585e4167c6c7$export$b5f67017585d1431('data-block-link'),
            contentElement: (node)=>{
                const clone = node.cloneNode(true);
                clone.removeAttribute('data-block-link');
                clone.setAttribute('data-skip-paste', 'true');
                const wrapper = document.createElement('div');
                wrapper.appendChild(clone);
                return wrapper;
            }
        },
        {
            tag: 'a[href]',
            getAttrs: $045c585e4167c6c7$export$b5f67017585d1431('href')
        }
    ],
    toDOM (node, isInline) {
        const attrs = Object.keys(node.attrs).reduce((attrs, key)=>{
            if (key === '__confluenceMetadata') {
                if (node.attrs[key] !== null) attrs[key] = JSON.stringify(node.attrs[key]);
            } else if (key === 'href') attrs[key] = (0, $jBbIP.isSafeUrl)(node.attrs[key]) ? node.attrs[key] : undefined;
            else attrs[key] = node.attrs[key];
            return attrs;
        }, {});
        if (isInline) return [
            'a',
            attrs
        ];
        return [
            'a',
            {
                ...attrs,
                ['data-block-link']: 'true',
                class: 'blockLink'
            },
            0
        ];
    }
});
const $045c585e4167c6c7$var$OPTIONAL_ATTRS = [
    'title',
    'id',
    'collection',
    'occurrenceKey',
    '__confluenceMetadata'
];
const $045c585e4167c6c7$export$54fd2c36b5cc6731 = (mark)=>({
        type: mark.type.name,
        attrs: Object.keys(mark.attrs).reduce((attrs, key)=>{
            if ($045c585e4167c6c7$var$OPTIONAL_ATTRS.indexOf(key) === -1 || mark.attrs[key] !== null) attrs[key] = mark.attrs[key];
            return attrs;
        }, {})
    });
module.exports["link"] = $045c585e4167c6c7$export$9c30223ca0a664fb;
module.exports["toJSON"] = $045c585e4167c6c7$export$54fd2c36b5cc6731;

});

parcelRegister("6q8Jb", function(module, exports) {

var $7ucde = parcelRequire("7ucde");

const $4acbf0eb24f78faf$export$4899a95d70ec5056 = (0, $7ucde.strike)({
    parseDOM: [
        {
            tag: 'strike'
        },
        {
            tag: 's'
        },
        {
            tag: 'del'
        },
        {
            style: 'text-decoration',
            getAttrs: (value)=>value === 'line-through' && null
        }
    ],
    toDOM () {
        return [
            's'
        ];
    }
});
module.exports["strike"] = $4acbf0eb24f78faf$export$4899a95d70ec5056;

});

parcelRegister("dQvvU", function(module, exports) {

var $7ucde = parcelRequire("7ucde");

/**
 * @name strong_mark
 */ const $a14893a2e9360898$var$strongDOM = [
    'strong'
];
const $a14893a2e9360898$export$59ae2c325a998f89 = (0, $7ucde.strong)({
    parseDOM: [
        {
            tag: 'strong'
        },
        // This works around a Google Docs misbehavior where
        // pasted content will be inexplicably wrapped in `<b>`
        // tags with a font-weight normal.
        {
            tag: 'b',
            getAttrs (node) {
                const element = node;
                return element.style.fontWeight !== 'normal' && null;
            }
        },
        {
            tag: 'span',
            getAttrs (node) {
                const element = node;
                const { fontWeight: fontWeight } = element.style;
                return typeof fontWeight === 'string' && (fontWeight === 'bold' || fontWeight === 'bolder' || /^(bold(er)?|[5-9]\d{2,})$/.test(fontWeight)) && null;
            }
        }
    ],
    toDOM () {
        return $a14893a2e9360898$var$strongDOM;
    }
});
module.exports["strong"] = $a14893a2e9360898$export$59ae2c325a998f89;

});

parcelRegister("8oCiy", function(module, exports) {

var $7ucde = parcelRequire("7ucde");

/**
 * @name subsup_mark
 */ function $61ce45ddc092a427$var$getAttrFromVerticalAlign(node) {
    if (node === 'sub') return {
        type: 'sub'
    };
    if (node === 'super') return {
        type: 'sup'
    };
    return false;
}
const $61ce45ddc092a427$export$b3401ee80eb31041 = (0, $7ucde.subsup)({
    parseDOM: [
        {
            tag: 'sub',
            attrs: {
                type: 'sub'
            }
        },
        {
            tag: 'sup',
            attrs: {
                type: 'sup'
            }
        },
        {
            // Special case for pasting from Google Docs
            // Google Docs uses vertical align to denote subscript and super script
            style: 'vertical-align=super',
            getAttrs: (node)=>$61ce45ddc092a427$var$getAttrFromVerticalAlign(node)
        },
        {
            style: 'vertical-align=sub',
            getAttrs: (node)=>$61ce45ddc092a427$var$getAttrFromVerticalAlign(node)
        }
    ],
    toDOM (mark) {
        return [
            mark.attrs.type
        ];
    }
});
module.exports["subsup"] = $61ce45ddc092a427$export$b3401ee80eb31041;

});

parcelRegister("iq4tW", function(module, exports) {

var $7ucde = parcelRequire("7ucde");


var $eoZWa = parcelRequire("eoZWa");

const $d68e21b85ea0ff8f$export$20af3dabbb5538df = (0, $7ucde.typeAheadQuery)({
    parseDOM: [
        {
            tag: 'span[data-type-ahead-query]'
        }
    ],
    toDOM (node) {
        return [
            'span',
            {
                'data-type-ahead-query': 'true',
                'data-trigger': node.attrs.trigger,
                style: `color: ${(0, $eoZWa.B400)}`
            }
        ];
    }
});
module.exports["typeAheadQuery"] = $d68e21b85ea0ff8f$export$20af3dabbb5538df;

});

parcelRegister("8rCC1", function(module, exports) {

var $7ucde = parcelRequire("7ucde");

const $625ecbf4088cd3d5$export$425327af25286e5e = (0, $7ucde.underline)({
    parseDOM: [
        {
            tag: 'u'
        },
        {
            style: 'text-decoration',
            getAttrs: (value)=>value === 'underline' && null
        }
    ],
    toDOM () {
        return [
            'u'
        ];
    }
});
module.exports["underline"] = $625ecbf4088cd3d5$export$425327af25286e5e;

});

parcelRegister("j1K1a", function(module, exports) {

var $7ucde = parcelRequire("7ucde");

const $dda1ce7a586b9599$export$30d78d5eb6719bb8 = (0, $7ucde.unsupportedMark)({
    toDOM () {
        return [
            'span'
        ];
    }
});
module.exports["unsupportedMark"] = $dda1ce7a586b9599$export$30d78d5eb6719bb8;

});

parcelRegister("gWd3C", function(module, exports) {

var $7ucde = parcelRequire("7ucde");

const $c54c310d077aa7de$export$a316dc07ff5182a2 = (0, $7ucde.unsupportedNodeAttribute)({
    toDOM () {
        return [
            'span'
        ];
    }
});
module.exports["unsupportedNodeAttribute"] = $c54c310d077aa7de$export$a316dc07ff5182a2;

});

parcelRegister("6aq5c", function(module, exports) {

var $jqXx5 = parcelRequire("jqXx5");


var $d925B = parcelRequire("d925B");


var $juTiU = parcelRequire("juTiU");

const $a505c57fde83bb0c$export$8e7fd962b4d3895d = 'unsupportedNodeAttribute';
const $a505c57fde83bb0c$var$errorCallbackFor = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
marks, validate, dispatchAnalyticsEvent, validationOverrides)=>{
    return (entity, error, options)=>{
        return $a505c57fde83bb0c$export$468b008419c9a974(entity, error, {
            ...options,
            allowNestedTables: validationOverrides?.allowNestedTables
        }, marks, validate, dispatchAnalyticsEvent);
    };
};
const $a505c57fde83bb0c$export$468b008419c9a974 = (entity, error, options, marks, validate, dispatchAnalyticsEvent)=>{
    if (entity && entity.type === $a505c57fde83bb0c$export$8e7fd962b4d3895d) return entity;
    if (options.isMark) return $a505c57fde83bb0c$export$87b732fa69cdf16e(error.meta, 'mark');
    if (options.isNodeAttribute) {
        const entityType = entity && entity.type ? entity.type : undefined;
        return {
            type: $a505c57fde83bb0c$export$8e7fd962b4d3895d,
            attrs: {
                type: {
                    nodeType: entityType
                },
                unsupported: error.meta
            }
        };
    }
    if (entity && marks.indexOf(entity.type) > -1) return;
    /**
	 * There's a inconsistency between ProseMirror and ADF.
	 * `content` is actually optional in ProseMirror.
	 * And, also empty `text` node is not valid.
	 */ if (error.code === 'MISSING_PROPERTIES' && entity.type === 'paragraph') return {
        type: 'paragraph',
        content: []
    };
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: We can repair missing content like `panel` without a `paragraph`.
    if (error.code === 'INVALID_CONTENT_LENGTH') {
        if (error.meta && options.allowUnsupportedBlock && entity.content) return $a505c57fde83bb0c$var$getEntityForInvalidContentLength(error, entity, validate, marks, dispatchAnalyticsEvent);
        else // Can't fix it by wrapping
        if (dispatchAnalyticsEvent) $a505c57fde83bb0c$var$trackValidationError(dispatchAnalyticsEvent, error, entity);
    }
    // Nested tables don't actually exist in ADF. In ADF they are stored as an `extension` node with the nested table content serialized in a property of that extension.
    // Usually when we validate ADF we are validating this `extension` and then later transforming it into nested tables for usage by ProseMirror.
    // Under certain circumstances however, ADF validation is performed on this already transformed extension and since nested tables aren't allowed by ADF this
    // produces an error. For example, nested renderers in Confluence `bodiedExtension`'s. The nested renderer receives the already transformed nested tables that originated from the
    // `extension` node and validates it. This is invalid ADF so an error is thrown.
    // This override allows an exception to be made for nested tables in the validator in this circumstance.
    if (options.allowNestedTables) {
        const meta = error.meta;
        if (options.allowNestedTables && meta?.parentType && [
            'tableCell',
            'tableHeader'
        ].includes(meta?.parentType) && error.code === 'INVALID_CONTENT' && entity.type === 'table') return entity;
    }
    if (options.allowUnsupportedBlock) return $a505c57fde83bb0c$export$87b732fa69cdf16e(entity);
    if (options.allowUnsupportedInline) return $a505c57fde83bb0c$export$87b732fa69cdf16e(entity, 'inline');
    if (dispatchAnalyticsEvent) $a505c57fde83bb0c$var$trackValidationError(dispatchAnalyticsEvent, error, entity);
    return entity;
};
function $a505c57fde83bb0c$var$getEntityForInvalidContentLength(error, entity, validate, marks, dispatchAnalyticsEvent) {
    const meta = error.meta;
    if (meta.type === 'maximum') // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    entity.content = entity.content.filter((x)=>!!x).map((child, index)=>{
        return index >= meta.requiredLength && child.type !== 'unsupportedBlock' ? $a505c57fde83bb0c$export$87b732fa69cdf16e(child) : validate(child, $a505c57fde83bb0c$var$errorCallbackFor(marks, validate, dispatchAnalyticsEvent)).entity;
    });
    if (meta.type === 'minimum') {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (entity.content.length === 0) return $a505c57fde83bb0c$export$87b732fa69cdf16e(entity);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        entity.content = entity.content.filter((x)=>!!x).map((child)=>{
            return child.type !== 'unsupportedBlock' ? $a505c57fde83bb0c$export$87b732fa69cdf16e(child) : child;
        });
    }
    return entity;
}
function $a505c57fde83bb0c$var$trackValidationError(dispatchAnalyticsEvent, error, entity) {
    if (!dispatchAnalyticsEvent) return;
    (0, $juTiU.fireUnsupportedEvent)(dispatchAnalyticsEvent, (0, $d925B.ACTION_SUBJECT_ID).UNSUPPORTED_ERROR, {
        type: entity.type || '',
        ancestry: entity.ancestorHierarchy || '',
        parentType: entity.parentType || '',
        marks: entity.marks || [],
        attrs: entity.attrs || {}
    }, error.code);
}
const $a505c57fde83bb0c$export$884cfad20dece33e = (schema, node, dispatchAnalyticsEvent, validationOverrides)=>{
    const nodes = Object.keys(schema.nodes);
    const marks = Object.keys(schema.marks);
    const validate = (0, $jqXx5.validator)(nodes, marks, {
        allowPrivateAttributes: true
    });
    const emptyDoc = {
        type: 'doc',
        content: []
    };
    const { entity: entity = emptyDoc } = validate(node, $a505c57fde83bb0c$var$errorCallbackFor(marks, validate, dispatchAnalyticsEvent, validationOverrides));
    return entity;
};
function $a505c57fde83bb0c$export$87b732fa69cdf16e(originalValue, type = 'block') {
    let unsupportedNodeType;
    switch(type){
        case 'inline':
            unsupportedNodeType = 'unsupportedInline';
            break;
        case 'mark':
            unsupportedNodeType = 'unsupportedMark';
            break;
        default:
            unsupportedNodeType = 'unsupportedBlock';
    }
    return {
        type: unsupportedNodeType,
        attrs: {
            originalValue: originalValue
        }
    };
}
module.exports["validateADFEntity"] = $a505c57fde83bb0c$export$884cfad20dece33e;

});

parcelRegister("jqXx5", function(module, exports) {
// Ignored via go/ees005
// eslint-disable-next-line import/no-namespace
var $58b4146701b9e110$exports = {};
$parcel$export($58b4146701b9e110$exports, "alignment", () => (parcelRequire("fv6vq")).alignment);
$parcel$export($58b4146701b9e110$exports, "annotation", () => (parcelRequire("fv6vq")).annotation);
$parcel$export($58b4146701b9e110$exports, "backgroundColor", () => (parcelRequire("fv6vq")).backgroundColor);
$parcel$export($58b4146701b9e110$exports, "blockCard", () => (parcelRequire("fv6vq")).blockCard);
$parcel$export($58b4146701b9e110$exports, "block_content", () => (parcelRequire("fv6vq")).block_content);
$parcel$export($58b4146701b9e110$exports, "blockRootOnly", () => (parcelRequire("fv6vq")).blockRootOnly);
$parcel$export($58b4146701b9e110$exports, "blockquote", () => (parcelRequire("fv6vq")).blockquote);
$parcel$export($58b4146701b9e110$exports, "blockTaskItem", () => (parcelRequire("fv6vq")).blockTaskItem);
$parcel$export($58b4146701b9e110$exports, "bodiedExtension", () => (parcelRequire("fv6vq")).bodiedExtension);
$parcel$export($58b4146701b9e110$exports, "bodiedExtension_with_marks", () => (parcelRequire("fv6vq")).bodiedExtension_with_marks);
$parcel$export($58b4146701b9e110$exports, "border", () => (parcelRequire("fv6vq")).border);
$parcel$export($58b4146701b9e110$exports, "breakout", () => (parcelRequire("fv6vq")).breakout);
$parcel$export($58b4146701b9e110$exports, "bulletList", () => (parcelRequire("fv6vq")).bulletList);
$parcel$export($58b4146701b9e110$exports, "caption", () => (parcelRequire("fv6vq")).caption);
$parcel$export($58b4146701b9e110$exports, "code", () => (parcelRequire("fv6vq")).code);
$parcel$export($58b4146701b9e110$exports, "codeBlock", () => (parcelRequire("fv6vq")).codeBlock);
$parcel$export($58b4146701b9e110$exports, "codeBlock_root_only", () => (parcelRequire("fv6vq")).codeBlock_root_only);
$parcel$export($58b4146701b9e110$exports, "text_with_no_marks", () => (parcelRequire("fv6vq")).text_with_no_marks);
$parcel$export($58b4146701b9e110$exports, "confluenceInlineComment", () => (parcelRequire("fv6vq")).confluenceInlineComment);
$parcel$export($58b4146701b9e110$exports, "dataConsumer", () => (parcelRequire("fv6vq")).dataConsumer);
$parcel$export($58b4146701b9e110$exports, "date", () => (parcelRequire("fv6vq")).date);
$parcel$export($58b4146701b9e110$exports, "decisionItem", () => (parcelRequire("fv6vq")).decisionItem);
$parcel$export($58b4146701b9e110$exports, "decisionList", () => (parcelRequire("fv6vq")).decisionList);
$parcel$export($58b4146701b9e110$exports, "doc", () => (parcelRequire("fv6vq")).doc);
$parcel$export($58b4146701b9e110$exports, "em", () => (parcelRequire("fv6vq")).em);
$parcel$export($58b4146701b9e110$exports, "embedCard", () => (parcelRequire("fv6vq")).embedCard);
$parcel$export($58b4146701b9e110$exports, "emoji", () => (parcelRequire("fv6vq")).emoji);
$parcel$export($58b4146701b9e110$exports, "expand", () => (parcelRequire("fv6vq")).expand);
$parcel$export($58b4146701b9e110$exports, "expand_root_only", () => (parcelRequire("fv6vq")).expand_root_only);
$parcel$export($58b4146701b9e110$exports, "extension", () => (parcelRequire("fv6vq")).extension);
$parcel$export($58b4146701b9e110$exports, "extensionFrame", () => (parcelRequire("fv6vq")).extensionFrame);
$parcel$export($58b4146701b9e110$exports, "extension_with_marks", () => (parcelRequire("fv6vq")).extension_with_marks);
$parcel$export($58b4146701b9e110$exports, "fragment", () => (parcelRequire("fv6vq")).fragment);
$parcel$export($58b4146701b9e110$exports, "hardBreak", () => (parcelRequire("fv6vq")).hardBreak);
$parcel$export($58b4146701b9e110$exports, "heading", () => (parcelRequire("fv6vq")).heading);
$parcel$export($58b4146701b9e110$exports, "heading_with_alignment", () => (parcelRequire("fv6vq")).heading_with_alignment);
$parcel$export($58b4146701b9e110$exports, "heading_with_indentation", () => (parcelRequire("fv6vq")).heading_with_indentation);
$parcel$export($58b4146701b9e110$exports, "heading_with_no_marks", () => (parcelRequire("fv6vq")).heading_with_no_marks);
$parcel$export($58b4146701b9e110$exports, "indentation", () => (parcelRequire("fv6vq")).indentation);
$parcel$export($58b4146701b9e110$exports, "inlineCard", () => (parcelRequire("fv6vq")).inlineCard);
$parcel$export($58b4146701b9e110$exports, "inlineExtension", () => (parcelRequire("fv6vq")).inlineExtension);
$parcel$export($58b4146701b9e110$exports, "inlineExtension_with_marks", () => (parcelRequire("fv6vq")).inlineExtension_with_marks);
$parcel$export($58b4146701b9e110$exports, "inline_content", () => (parcelRequire("fv6vq")).inline_content);
$parcel$export($58b4146701b9e110$exports, "layoutColumn", () => (parcelRequire("fv6vq")).layoutColumn);
$parcel$export($58b4146701b9e110$exports, "layoutSection", () => (parcelRequire("fv6vq")).layoutSection);
$parcel$export($58b4146701b9e110$exports, "layoutSection_full", () => (parcelRequire("fv6vq")).layoutSection_full);
$parcel$export($58b4146701b9e110$exports, "layoutSection_with_single_column", () => (parcelRequire("fv6vq")).layoutSection_with_single_column);
$parcel$export($58b4146701b9e110$exports, "link", () => (parcelRequire("fv6vq")).link);
$parcel$export($58b4146701b9e110$exports, "listItem", () => (parcelRequire("fv6vq")).listItem);
$parcel$export($58b4146701b9e110$exports, "media", () => (parcelRequire("fv6vq")).media);
$parcel$export($58b4146701b9e110$exports, "mediaGroup", () => (parcelRequire("fv6vq")).mediaGroup);
$parcel$export($58b4146701b9e110$exports, "mediaInline", () => (parcelRequire("fv6vq")).mediaInline);
$parcel$export($58b4146701b9e110$exports, "mediaSingle", () => (parcelRequire("fv6vq")).mediaSingle);
$parcel$export($58b4146701b9e110$exports, "mediaSingle_caption", () => (parcelRequire("fv6vq")).mediaSingle_caption);
$parcel$export($58b4146701b9e110$exports, "mediaSingle_full", () => (parcelRequire("fv6vq")).mediaSingle_full);
$parcel$export($58b4146701b9e110$exports, "mention", () => (parcelRequire("fv6vq")).mention);
$parcel$export($58b4146701b9e110$exports, "multiBodiedExtension", () => (parcelRequire("fv6vq")).multiBodiedExtension);
$parcel$export($58b4146701b9e110$exports, "nestedExpand", () => (parcelRequire("fv6vq")).nestedExpand);
$parcel$export($58b4146701b9e110$exports, "nestedExpand_content", () => (parcelRequire("fv6vq")).nestedExpand_content);
$parcel$export($58b4146701b9e110$exports, "nestedExpand_with_no_marks", () => (parcelRequire("fv6vq")).nestedExpand_with_no_marks);
$parcel$export($58b4146701b9e110$exports, "non_nestable_block_content", () => (parcelRequire("fv6vq")).non_nestable_block_content);
$parcel$export($58b4146701b9e110$exports, "orderedList", () => (parcelRequire("fv6vq")).orderedList);
$parcel$export($58b4146701b9e110$exports, "panel", () => (parcelRequire("fv6vq")).panel);
$parcel$export($58b4146701b9e110$exports, "paragraph", () => (parcelRequire("fv6vq")).paragraph);
$parcel$export($58b4146701b9e110$exports, "paragraph_with_alignment", () => (parcelRequire("fv6vq")).paragraph_with_alignment);
$parcel$export($58b4146701b9e110$exports, "paragraph_with_indentation", () => (parcelRequire("fv6vq")).paragraph_with_indentation);
$parcel$export($58b4146701b9e110$exports, "paragraph_with_no_marks", () => (parcelRequire("fv6vq")).paragraph_with_no_marks);
$parcel$export($58b4146701b9e110$exports, "placeholder", () => (parcelRequire("fv6vq")).placeholder);
$parcel$export($58b4146701b9e110$exports, "rule", () => (parcelRequire("fv6vq")).rule);
$parcel$export($58b4146701b9e110$exports, "status", () => (parcelRequire("fv6vq")).status);
$parcel$export($58b4146701b9e110$exports, "strike", () => (parcelRequire("fv6vq")).strike);
$parcel$export($58b4146701b9e110$exports, "strong", () => (parcelRequire("fv6vq")).strong);
$parcel$export($58b4146701b9e110$exports, "subsup", () => (parcelRequire("fv6vq")).subsup);
$parcel$export($58b4146701b9e110$exports, "table", () => (parcelRequire("fv6vq")).table);
$parcel$export($58b4146701b9e110$exports, "tableCell", () => (parcelRequire("fv6vq")).tableCell);
$parcel$export($58b4146701b9e110$exports, "tableHeader", () => (parcelRequire("fv6vq")).tableHeader);
$parcel$export($58b4146701b9e110$exports, "tableRow", () => (parcelRequire("fv6vq")).tableRow);
$parcel$export($58b4146701b9e110$exports, "taskItem", () => (parcelRequire("fv6vq")).taskItem);
$parcel$export($58b4146701b9e110$exports, "taskList", () => (parcelRequire("fv6vq")).taskList);
$parcel$export($58b4146701b9e110$exports, "text", () => (parcelRequire("fv6vq")).text);
$parcel$export($58b4146701b9e110$exports, "textColor", () => (parcelRequire("fv6vq")).textColor);
$parcel$export($58b4146701b9e110$exports, "text_code_inline", () => (parcelRequire("fv6vq")).text_code_inline);
$parcel$export($58b4146701b9e110$exports, "text_formatted", () => (parcelRequire("fv6vq")).text_formatted);
$parcel$export($58b4146701b9e110$exports, "text_link_inline", () => (parcelRequire("fv6vq")).text_link_inline);
$parcel$export($58b4146701b9e110$exports, "underline", () => (parcelRequire("fv6vq")).underline);
$parcel$export($58b4146701b9e110$exports, "syncBlock", () => (parcelRequire("fv6vq")).syncBlock);
$parcel$export($58b4146701b9e110$exports, "bodiedSyncBlock", () => (parcelRequire("fv6vq")).bodiedSyncBlock);
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $fv6vq = parcelRequire("fv6vq");



const $b212eb2b08ba23cd$export$4e62c701997796c1 = (x)=>x != null;
const $b212eb2b08ba23cd$export$7e4aa119212bc614 = (x)=>typeof x === 'number' && !isNaN(x) && isFinite(x);
const $b212eb2b08ba23cd$export$a287f47fed4544b8 = (x)=>typeof x === 'number' && isFinite(x) && Math.floor(x) === x;
const $b212eb2b08ba23cd$export$f9ce7b637dfbe238 = (x)=>x === true || x === false || toString.call(x) === '[object Boolean]';
const $b212eb2b08ba23cd$export$844ec244b1367d54 = (s)=>typeof s === 'string' || s instanceof String;
const $b212eb2b08ba23cd$export$53b83ca8eaab0383 = (x)=>typeof x === 'object' && x !== null && !Array.isArray(x);
const $b212eb2b08ba23cd$export$784d13d8ee351f07 = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
source, dest, key)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    dest[key] = source[key];
    return dest;
};
const $b212eb2b08ba23cd$export$7b85fd78dd236198 = (maybeArray)=>Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];



var $jBbIP = parcelRequire("jBbIP");

const $7553da36add03409$export$d1b377ca77ac267d = {
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    safeUrl: (0, $jBbIP.isSafeUrl)
};


// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $5a24607d60a15c5e$var$mapMarksItems(spec, fn = (x)=>x) {
    if (spec.props && spec.props.marks) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const { items: items, ...rest } = spec.props.marks;
        return {
            ...spec,
            props: {
                ...spec.props,
                marks: {
                    ...rest,
                    /**
					 * `Text & MarksObject<Mark-1>` produces `items: ['mark-1']`
					 * `Text & MarksObject<Mark-1 | Mark-2>` produces `items: [['mark-1', 'mark-2']]`
					 */ items: items.length ? Array.isArray(items[0]) ? items.map(fn) : [
                        fn(items)
                    ] : [
                        []
                    ]
                }
            }
        };
    } else return spec;
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $5a24607d60a15c5e$var$partitionObject = (obj, predicate)=>Object.keys(obj).reduce((acc, key)=>{
        const result = predicate(key, obj[key], obj);
        acc[result ? 0 : 1].push(key);
        return acc;
    }, [
        [],
        []
    ]);
/**
 * Normalizes the structure of files imported from './specs'.
 * We denormalised the spec to save bundle size.
 */ function $5a24607d60a15c5e$var$createSpec(nodes, marks) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return Object.keys($58b4146701b9e110$exports).reduce((newSpecs, k)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const spec = {
            ...$58b4146701b9e110$exports[k]
        };
        if (spec.props) {
            spec.props = {
                ...spec.props
            };
            if (spec.props.content) {
                // 'tableCell_content' => { type: 'array', items: [ ... ] }
                if ((0, $b212eb2b08ba23cd$export$844ec244b1367d54)(spec.props.content)) // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                spec.props.content = $58b4146701b9e110$exports[spec.props.content];
                // ['inline', 'emoji']
                if (Array.isArray(spec.props.content)) /**
					 * Flatten
					 *
					 * Input:
					 * [ { type: 'array', items: [ 'tableHeader' ] }, { type: 'array', items: [ 'tableCell' ] } ]
					 *
					 * Output:
					 * { type: 'array', items: [ [ 'tableHeader' ], [ 'tableCell' ] ] }
					 */ spec.props.content = {
                    type: 'array',
                    items: (spec.props.content || []).map((arr)=>arr.items)
                };
                else spec.props.content = {
                    ...spec.props.content
                };
                spec.props.content.items = spec.props.content.items// ['inline'] => [['emoji', 'hr', ...]]
                // ['media'] => [['media']]
                .map((item)=>(0, $b212eb2b08ba23cd$export$844ec244b1367d54)(item) ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    Array.isArray($58b4146701b9e110$exports[item]) ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    $58b4146701b9e110$exports[item] : [
                        item
                    ] : item)// [['emoji', 'hr', 'inline_code']] => [['emoji', 'hr', ['text', { marks: {} }]]]
                .map((item)=>item.map((subItem)=>// Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        Array.isArray($58b4146701b9e110$exports[subItem]) ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        $58b4146701b9e110$exports[subItem] : (0, $b212eb2b08ba23cd$export$844ec244b1367d54)(subItem) ? subItem : [
                            'text',
                            subItem
                        ])// Remove unsupported nodes & marks
                    // Filter nodes
                    .filter((subItem)=>{
                        if (nodes) {
                            // Node with overrides
                            // ['mediaSingle', { props: { content: { items: [ 'media', 'caption' ] } }}]
                            if (Array.isArray(subItem)) {
                                const isMainNodeSupported = nodes.indexOf(subItem[0]) > -1;
                                if (isMainNodeSupported && subItem[1]?.props?.content?.items) return subItem[1].props.content.items.every((item)=>nodes.indexOf(item) > -1);
                                return isMainNodeSupported;
                            }
                            return nodes.indexOf(subItem) > -1;
                        }
                        return true;
                    })// Filter marks
                    .map((subItem)=>Array.isArray(subItem) && marks ? /**
										 * TODO: Probably try something like immer, but it's 3.3kb gzipped.
										 * Not worth it just for this.
										 */ [
                            subItem[0],
                            $5a24607d60a15c5e$var$mapMarksItems(subItem[1])
                        ] : subItem));
            }
        }
        newSpecs[k] = spec;
        return newSpecs;
    }, {});
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $5a24607d60a15c5e$var$getOptionsForType(type, list) {
    if (!list) return {};
    for(let i = 0, len = list.length; i < len; i++){
        const spec = list[i];
        let name = spec;
        let options = {};
        if (Array.isArray(spec)) [name, options] = spec;
        if (name === type) return options;
    }
    return false;
}
const $5a24607d60a15c5e$var$isValidatorSpecAttrs = (spec)=>{
    return !!spec.props;
};
function $5a24607d60a15c5e$export$66c739158ef99a42(spec, value) {
    if (!(0, $b212eb2b08ba23cd$export$4e62c701997796c1)(value)) return !!spec.optional;
    if ($5a24607d60a15c5e$var$isValidatorSpecAttrs(spec)) {
        // If spec has ".props" it is ValidatorSpecAttrs and need to pipe back in recursively
        const [_, invalidKeys] = $5a24607d60a15c5e$var$partitionObject(spec.props, (key, subSpec)=>// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            $5a24607d60a15c5e$export$66c739158ef99a42(subSpec, value[key]));
        return invalidKeys.length === 0;
    }
    // extension_node parameters has no type
    if (!(0, $b212eb2b08ba23cd$export$4e62c701997796c1)(spec.type)) return !!spec.optional;
    switch(spec.type){
        case 'boolean':
            return (0, $b212eb2b08ba23cd$export$f9ce7b637dfbe238)(value);
        case 'number':
            return (0, $b212eb2b08ba23cd$export$7e4aa119212bc614)(value) && ((0, $b212eb2b08ba23cd$export$4e62c701997796c1)(spec.minimum) ? spec.minimum <= value : true) && ((0, $b212eb2b08ba23cd$export$4e62c701997796c1)(spec.maximum) ? spec.maximum >= value : true);
        case 'integer':
            return (0, $b212eb2b08ba23cd$export$a287f47fed4544b8)(value) && ((0, $b212eb2b08ba23cd$export$4e62c701997796c1)(spec.minimum) ? spec.minimum <= value : true) && ((0, $b212eb2b08ba23cd$export$4e62c701997796c1)(spec.maximum) ? spec.maximum >= value : true);
        case 'string':
            const validatorFnPassed = (rule)=>typeof value === 'string' && (0, $b212eb2b08ba23cd$export$4e62c701997796c1)((0, $7553da36add03409$export$d1b377ca77ac267d)[rule]) && (0, $7553da36add03409$export$d1b377ca77ac267d)[rule](value);
            return (0, $b212eb2b08ba23cd$export$844ec244b1367d54)(value) && // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            ((0, $b212eb2b08ba23cd$export$4e62c701997796c1)(spec.minLength) ? spec.minLength <= value.length : true) && ((0, $b212eb2b08ba23cd$export$4e62c701997796c1)(spec.validatorFn) ? validatorFnPassed(spec.validatorFn) : true) && // Ignored via go/ees005
            // eslint-disable-next-line require-unicode-regexp
            (spec.pattern ? new RegExp(spec.pattern).test(value) : true);
        case 'object':
            return (0, $b212eb2b08ba23cd$export$53b83ca8eaab0383)(value);
        case 'array':
            if (Array.isArray(value)) {
                const isTuple = !!spec.isTupleLike;
                const { minItems: minItems, maxItems: maxItems } = spec;
                if (minItems !== undefined && value.length < minItems || maxItems !== undefined && value.length > maxItems) return false;
                if (isTuple) {
                    // If value has fewer items than tuple has specs - we are fine with that.
                    const numberOfItemsToCheck = Math.min(spec.items.length, value.length);
                    return Array(numberOfItemsToCheck).fill(null).every((_, i)=>$5a24607d60a15c5e$export$66c739158ef99a42(spec.items[i], value[i]));
                } else return value.every((valueItem)=>// We check that at least one of the specs in the list (spec.items) matches each value from
                    spec.items.some((itemSpec)=>$5a24607d60a15c5e$export$66c739158ef99a42(itemSpec, valueItem)));
            }
            return false;
        case 'enum':
            return (0, $b212eb2b08ba23cd$export$844ec244b1367d54)(value) && spec.values.indexOf(value) > -1;
    }
}
const $5a24607d60a15c5e$var$errorMessageFor = (type, message)=>`${type}: ${message}.`;
const $5a24607d60a15c5e$var$getUnsupportedOptions = (spec)=>{
    if (spec && spec.props && spec.props.content) {
        const { allowUnsupportedBlock: allowUnsupportedBlock, allowUnsupportedInline: allowUnsupportedInline } = spec.props.content;
        return {
            allowUnsupportedBlock: allowUnsupportedBlock,
            allowUnsupportedInline: allowUnsupportedInline
        };
    }
    return {};
};
const $5a24607d60a15c5e$var$invalidChildContent = (child, errorCallback, parentSpec)=>{
    const message = $5a24607d60a15c5e$var$errorMessageFor(child.type, 'invalid content');
    if (!errorCallback) throw new Error(message);
    else return errorCallback({
        ...child
    }, {
        code: 'INVALID_CONTENT',
        message: message,
        meta: {
            parentType: parentSpec?.props?.type?.values[0]
        }
    }, $5a24607d60a15c5e$var$getUnsupportedOptions(parentSpec));
};
const $5a24607d60a15c5e$var$unsupportedMarkContent = (errorCode, mark, errorCallback, errorMessage)=>{
    const message = errorMessage || $5a24607d60a15c5e$var$errorMessageFor(mark.type, 'unsupported mark');
    if (!errorCallback) throw new Error(message);
    else return errorCallback({
        ...mark
    }, {
        code: errorCode,
        message: message,
        meta: mark
    }, {
        allowUnsupportedBlock: false,
        allowUnsupportedInline: false,
        isMark: true
    });
};
const $5a24607d60a15c5e$var$unsupportedNodeAttributesContent = (entity, errorCode, invalidAttributes, message, errorCallback)=>{
    if (!errorCallback) throw new Error(message);
    else return errorCallback({
        type: entity.type
    }, {
        code: errorCode,
        message: message,
        meta: invalidAttributes
    }, {
        allowUnsupportedBlock: false,
        allowUnsupportedInline: false,
        isMark: false,
        isNodeAttribute: true
    });
};
function $5a24607d60a15c5e$export$956325f45c5d174a(nodes, marks, options) {
    const validatorSpecs = $5a24607d60a15c5e$var$createSpec(nodes, marks);
    const { mode: mode = 'strict', allowPrivateAttributes: allowPrivateAttributes = false } = options || {};
    const validate = (entity, errorCallback, allowed, parentSpec)=>{
        const validationResult = validateNode(entity, errorCallback, allowed, parentSpec);
        return {
            entity: validationResult.entity,
            valid: validationResult.valid
        };
    };
    const validateNode = (entity, errorCallback, allowed, parentSpec, isMark = false)=>{
        const { type: type } = entity;
        const newEntity = {
            ...entity
        };
        const err = (code, msg, meta)=>{
            const message = $5a24607d60a15c5e$var$errorMessageFor(type, msg);
            if (errorCallback) return {
                valid: false,
                entity: errorCallback(newEntity, {
                    code: code,
                    message: message,
                    meta: meta
                }, $5a24607d60a15c5e$var$getUnsupportedOptions(parentSpec))
            };
            else throw new Error(message);
        };
        if (type) {
            const typeOptions = $5a24607d60a15c5e$var$getOptionsForType(type, allowed);
            if (typeOptions === false) return isMark ? {
                valid: false
            } : err('INVALID_TYPE', 'type not allowed here');
            const spec = validatorSpecs[type];
            if (!spec) return err('INVALID_TYPE', `${type}: No validation spec found for type!`);
            const specBasedValidationResult = specBasedValidationFor(spec, typeOptions, entity, err, newEntity, type, errorCallback, isMark);
            if (specBasedValidationResult.hasValidated && specBasedValidationResult.result) return specBasedValidationResult.result;
        } else return err('INVALID_TYPE', 'ProseMirror Node/Mark should contain a `type`');
        return {
            valid: true,
            entity: newEntity
        };
    };
    return validate;
    function marksValidationFor(validator, entity, errorCallback, newEntity, err) {
        let validationResult;
        if (validator.props && validator.props.marks) {
            const marksSet = allowedMarksFor(validator);
            const marksValidationResult = marksAfterValidation(entity, errorCallback, marksSet, validator);
            validationResult = {
                valid: true,
                entity: newEntity,
                marksValidationOutput: marksValidationResult
            };
        } else validationResult = marksForEntitySpecNotSupportingMarks(entity, newEntity, errorCallback, err);
        return validationResult;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function validatorFor(spec, typeOptions) {
        return {
            ...spec,
            ...typeOptions,
            // options with props can override props of spec
            ...spec.props ? {
                props: {
                    ...spec.props,
                    ...typeOptions['props'] || {}
                }
            } : {}
        };
    }
    function marksAfterValidation(entity, errorCallback, marksSet, validator) {
        return entity.marks ? entity.marks.map((mark)=>{
            const isAKnownMark = marks ? marks.indexOf(mark.type) > -1 : true;
            if (mode === 'strict' && isAKnownMark) {
                const finalResult = validateNode(mark, errorCallback, marksSet, validator, true);
                const finalMark = finalResult.entity;
                if (finalMark) return {
                    valid: true,
                    originalMark: mark,
                    newMark: finalMark
                };
                else if (finalResult.marksValidationOutput && finalResult.marksValidationOutput.length) return {
                    valid: false,
                    originalMark: mark,
                    errorCode: finalResult.marksValidationOutput[0].errorCode,
                    message: finalResult.marksValidationOutput[0].message
                };
                else return {
                    valid: false,
                    originalMark: mark,
                    errorCode: 'INVALID_TYPE'
                };
            } else return {
                valid: false,
                originalMark: mark,
                errorCode: 'INVALID_CONTENT'
            };
        }) : [];
    }
    function allowedMarksFor(validator) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const { items: items } = validator.props.marks;
        const marksSet = items.length ? Array.isArray(items[0]) ? items[0] : items : [];
        return marksSet;
    }
    function marksForEntitySpecNotSupportingMarks(prevEntity, newEntity, errorCallback, err) {
        const errorCode = 'REDUNDANT_MARKS';
        const currentMarks = prevEntity.marks || [];
        const newMarks = currentMarks.map((mark)=>{
            const isUnsupportedNodeAttributeMark = mark.type === 'unsupportedNodeAttribute';
            if (isUnsupportedNodeAttributeMark) return mark;
            return $5a24607d60a15c5e$var$unsupportedMarkContent(errorCode, mark, errorCallback);
        });
        if (newMarks.length) {
            newEntity.marks = newMarks;
            return {
                valid: true,
                entity: newEntity
            };
        } else return err('REDUNDANT_MARKS', 'redundant marks', {
            marks: Object.keys(currentMarks)
        });
    }
    function requiredPropertyValidationFor(validatorSpec, prevEntity, err) {
        let result = {
            valid: true,
            entity: prevEntity
        };
        if (validatorSpec.required) {
            if (!validatorSpec.required.every((prop)=>(0, $b212eb2b08ba23cd$export$4e62c701997796c1)(prevEntity[prop]))) result = err('MISSING_PROPERTIES', 'required prop missing');
        }
        return result;
    }
    function textPropertyValidationFor(validatorSpec, prevEntity, err) {
        let result = {
            valid: true,
            entity: prevEntity
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (validatorSpec.props.text) {
            if ((0, $b212eb2b08ba23cd$export$4e62c701997796c1)(prevEntity.text) && // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            !$5a24607d60a15c5e$export$66c739158ef99a42(validatorSpec.props.text, prevEntity.text)) result = err('INVALID_TEXT', `'text' validation failed`);
        }
        return result;
    }
    function contentLengthValidationFor(validatorSpec, prevEntity, err) {
        let result = {
            valid: true,
            entity: prevEntity
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (validatorSpec.props.content && prevEntity.content) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const { minItems: minItems, maxItems: maxItems } = validatorSpec.props.content;
            const length = prevEntity.content.length;
            if ((0, $b212eb2b08ba23cd$export$4e62c701997796c1)(minItems) && minItems > length) result = err('INVALID_CONTENT_LENGTH', `'content' should have more than ${minItems} child`, {
                length: length,
                requiredLength: minItems,
                type: 'minimum'
            });
            else if ((0, $b212eb2b08ba23cd$export$4e62c701997796c1)(maxItems) && maxItems < length) result = err('INVALID_CONTENT_LENGTH', `'content' should have less than ${maxItems} child`, {
                length: length,
                requiredLength: maxItems,
                type: 'maximum'
            });
        }
        return result;
    }
    function invalidAttributesFor(validatorSpec, prevEntity) {
        let invalidAttrs = [];
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let validatorAttrs = {};
        if (validatorSpec.props && validatorSpec.props.attrs) {
            const attrOptions = (0, $b212eb2b08ba23cd$export$7b85fd78dd236198)(validatorSpec.props.attrs);
            /**
			 * Attrs can be union type so try each path
			 * attrs: [{ props: { url: { type: 'string' } } }, { props: { data: {} } }],
			 * Gotcha: It will always report the last failure.
			 */ for(let i = 0, length = attrOptions.length; i < length; ++i){
                const attrOption = attrOptions[i];
                if (attrOption && attrOption.props) [, invalidAttrs] = $5a24607d60a15c5e$var$partitionObject(attrOption.props, (key, spec)=>{
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const valueToValidate = prevEntity.attrs[key];
                    return $5a24607d60a15c5e$export$66c739158ef99a42(spec, valueToValidate);
                });
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                validatorAttrs = attrOption;
                if (!invalidAttrs.length) break;
            }
        }
        return {
            invalidAttrs: invalidAttrs,
            validatorAttrs: validatorAttrs
        };
    }
    function attributesValidationFor(validatorSpec, prevEntity, newEntity, isMark, errorCallback) {
        const validatorSpecAllowsAttributes = validatorSpec.props && validatorSpec.props.attrs;
        if (prevEntity.attrs) {
            if (!validatorSpecAllowsAttributes) {
                if (isMark) return handleNoAttibutesAllowedInSpecForMark(prevEntity, prevEntity.attrs);
                const attrs = Object.keys(prevEntity.attrs);
                return handleUnsupportedNodeAttributes(prevEntity, newEntity, [], attrs, errorCallback);
            }
            const { hasUnsupportedAttrs: hasUnsupportedAttrs, redundantAttrs: redundantAttrs, invalidAttrs: invalidAttrs } = validateAttributes(validatorSpec, prevEntity, prevEntity.attrs);
            if (hasUnsupportedAttrs) {
                if (isMark) return handleUnsupportedMarkAttributes(prevEntity, invalidAttrs, redundantAttrs);
                return handleUnsupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, redundantAttrs, errorCallback);
            }
        }
        return {
            valid: true,
            entity: prevEntity
        };
    }
    function validateAttributes(validatorSpec, prevEntity, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    attributes) {
        const invalidAttributesResult = invalidAttributesFor(validatorSpec, prevEntity);
        const { invalidAttrs: invalidAttrs } = invalidAttributesResult;
        const validatorAttrs = invalidAttributesResult.validatorAttrs;
        const attrs = Object.keys(attributes).filter((k)=>!(allowPrivateAttributes && k.startsWith('__')));
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const redundantAttrs = attrs.filter((a)=>!validatorAttrs.props[a]);
        const hasRedundantAttrs = redundantAttrs.length > 0;
        const hasUnsupportedAttrs = invalidAttrs.length || hasRedundantAttrs;
        return {
            hasUnsupportedAttrs: hasUnsupportedAttrs,
            invalidAttrs: invalidAttrs,
            redundantAttrs: redundantAttrs
        };
    }
    function handleUnsupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, redundantAttrs, errorCallback) {
        const attr = invalidAttrs.concat(redundantAttrs);
        let result = {
            valid: true,
            entity: prevEntity
        };
        const message = $5a24607d60a15c5e$var$errorMessageFor(prevEntity.type, `'attrs' validation failed`);
        const errorCode = 'UNSUPPORTED_ATTRIBUTES';
        newEntity.marks = wrapUnSupportedNodeAttributes(prevEntity, newEntity, attr, errorCode, message, errorCallback);
        result = {
            valid: true,
            entity: newEntity
        };
        return result;
    }
    function handleUnsupportedMarkAttributes(prevEntity, invalidAttrs, redundantAttrs) {
        let errorCode = 'INVALID_ATTRIBUTES';
        let message = $5a24607d60a15c5e$var$errorMessageFor(prevEntity.type, `'attrs' validation failed`);
        const hasRedundantAttrs = redundantAttrs.length;
        const hasBothInvalidAndRedundantAttrs = hasRedundantAttrs && invalidAttrs.length;
        if (!hasBothInvalidAndRedundantAttrs && hasRedundantAttrs) {
            errorCode = 'REDUNDANT_ATTRIBUTES';
            message = $5a24607d60a15c5e$var$errorMessageFor('redundant attributes found', redundantAttrs.join(', '));
        }
        const markValidationResult = {
            valid: true,
            originalMark: prevEntity,
            errorCode: errorCode,
            message: message
        };
        return {
            valid: false,
            marksValidationOutput: [
                markValidationResult
            ]
        };
    }
    function handleNoAttibutesAllowedInSpecForMark(prevEntity, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    attributes) {
        const message = $5a24607d60a15c5e$var$errorMessageFor('redundant attributes found', Object.keys(attributes).join(', '));
        const errorCode = 'REDUNDANT_ATTRIBUTES';
        const markValidationResult = {
            valid: true,
            originalMark: prevEntity,
            errorCode: errorCode,
            message: message
        };
        return {
            valid: false,
            marksValidationOutput: [
                markValidationResult
            ]
        };
    }
    function wrapUnSupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, errorCode, message, errorCallback) {
        const invalidValues = {};
        // eslint-disable-next-line guard-for-in
        for(const invalidAttr in invalidAttrs){
            invalidValues[invalidAttrs[invalidAttr]] = prevEntity.attrs && prevEntity.attrs[invalidAttrs[invalidAttr]];
            if (newEntity.attrs) delete newEntity.attrs[invalidAttrs[invalidAttr]];
        }
        const unsupportedNodeAttributeValues = $5a24607d60a15c5e$var$unsupportedNodeAttributesContent(prevEntity, errorCode, invalidValues, message, errorCallback);
        const finalEntity = {
            ...newEntity
        };
        if (finalEntity.marks) {
            if (!unsupportedNodeAttributeValues) return finalEntity.marks;
            // If there is an existing unsupported node attribute mark, overwrite it to avoid duplicate marks
            const existingMark = finalEntity.marks.find((mark)=>mark.type === unsupportedNodeAttributeValues.type);
            if (existingMark) existingMark.attrs = unsupportedNodeAttributeValues.attrs;
            else finalEntity.marks.push(unsupportedNodeAttributeValues);
            return finalEntity.marks;
        } else return [
            unsupportedNodeAttributeValues
        ];
    }
    function extraPropsValidationFor(validatorSpec, prevEntity, err, newEntity, type) {
        const result = {
            valid: true,
            entity: prevEntity
        };
        const [requiredProps, redundantProps] = $5a24607d60a15c5e$var$partitionObject(prevEntity, (k)=>// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $b212eb2b08ba23cd$export$4e62c701997796c1)(validatorSpec.props[k]));
        if (redundantProps.length) {
            if (mode === 'loose') {
                newEntity = {
                    type: type
                };
                requiredProps.reduce((acc, p)=>(0, $b212eb2b08ba23cd$export$784d13d8ee351f07)(prevEntity, acc, p), newEntity);
            } else {
                if (!((redundantProps.indexOf('marks') > -1 || redundantProps.indexOf('attrs') > -1) && redundantProps.length === 1)) return err('REDUNDANT_PROPERTIES', `redundant props found: ${redundantProps.join(', ')}`, {
                    props: redundantProps
                });
            }
        }
        return result;
    }
    function specBasedValidationFor(spec, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    typeOptions, prevEntity, err, newEntity, type, errorCallback, isMark) {
        const specBasedValidationResult = {
            hasValidated: false
        };
        const validatorSpec = validatorFor(spec, typeOptions);
        if (!validatorSpec) return specBasedValidationResult;
        // Required Props
        // For array format where `required` is an array
        const requiredPropertyValidatonResult = requiredPropertyValidationFor(validatorSpec, prevEntity, err);
        if (!requiredPropertyValidatonResult.valid) return {
            hasValidated: true,
            result: requiredPropertyValidatonResult
        };
        if (!validatorSpec.props) {
            const props = Object.keys(prevEntity);
            // If there's no validator.props then there shouldn't be any key except `type`
            if (props.length > 1) return {
                hasValidated: true,
                result: err('REDUNDANT_PROPERTIES', `redundant props found: ${Object.keys(prevEntity).join(', ')}`, {
                    props: props
                })
            };
            return specBasedValidationResult;
        }
        // Check text
        const textPropertyValidationResult = textPropertyValidationFor(validatorSpec, prevEntity, err);
        if (!textPropertyValidationResult.valid) return {
            hasValidated: true,
            result: textPropertyValidationResult
        };
        // Content Length
        const contentLengthValidationResult = contentLengthValidationFor(validatorSpec, prevEntity, err);
        if (!contentLengthValidationResult.valid) return {
            hasValidated: true,
            result: contentLengthValidationResult
        };
        // Required Props
        // For object format based on `optional` property
        const [, missingProps] = $5a24607d60a15c5e$var$partitionObject(validatorSpec.props, (k, v)=>{
            // if the validator is an array, then check
            // if the `required` field contains the key.
            const isOptional = Array.isArray(v) ? !validatorSpec.required?.includes(k) : typeof v === 'object' && v !== null && 'optional' in v ? v.optional : false;
            return isOptional || (0, $b212eb2b08ba23cd$export$4e62c701997796c1)(prevEntity[k]);
        });
        if (missingProps.length) return {
            hasValidated: true,
            result: err('MISSING_PROPERTIES', 'required prop missing', {
                props: missingProps
            })
        };
        const attributesValidationResult = attributesValidationFor(validatorSpec, prevEntity, newEntity, isMark, errorCallback);
        if (!attributesValidationResult.valid) return {
            hasValidated: true,
            result: attributesValidationResult
        };
        if (isMark && attributesValidationResult.valid) return {
            hasValidated: true,
            result: attributesValidationResult
        };
        const extraPropsValidationResult = extraPropsValidationFor(validatorSpec, prevEntity, err, newEntity, type);
        if (!extraPropsValidationResult.valid) return {
            hasValidated: true,
            result: extraPropsValidationResult
        };
        // Children
        if (validatorSpec.props.content) {
            const contentValidatorSpec = validatorSpec.props.content;
            if (prevEntity.content) {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const validateChildNode = (child, index)=>{
                    if (child === undefined) return child;
                    const validateChildMarks = (childEntity, marksValidationOutput, errorCallback, isLastValidationSpec, isParentTupleLike = false)=>{
                        let marksAreValid = true;
                        if (childEntity && childEntity.marks && marksValidationOutput) {
                            const validMarks = marksValidationOutput.filter((mark)=>mark.valid);
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            const finalMarks = marksValidationOutput.map((mr)=>{
                                if (mr.valid) return mr.newMark;
                                else {
                                    if (validMarks.length || isLastValidationSpec || isParentTupleLike || mr.errorCode === 'INVALID_TYPE' || mr.errorCode === 'INVALID_CONTENT' || mr.errorCode === 'REDUNDANT_ATTRIBUTES' || mr.errorCode === 'INVALID_ATTRIBUTES') return $5a24607d60a15c5e$var$unsupportedMarkContent(// Ignored via go/ees005
                                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                    mr.errorCode, mr.originalMark, errorCallback, mr.message);
                                    return;
                                }
                            }).filter(Boolean);
                            if (finalMarks.length) childEntity.marks = finalMarks;
                            else {
                                delete childEntity.marks;
                                marksAreValid = false;
                            }
                        }
                        return {
                            valid: marksAreValid,
                            entity: childEntity
                        };
                    };
                    const hasMultipleCombinationOfContentAllowed = !!contentValidatorSpec.isTupleLike;
                    if (hasMultipleCombinationOfContentAllowed) {
                        const { entity: newChildEntity, marksValidationOutput: marksValidationOutput } = validateNode(child, errorCallback, (0, $b212eb2b08ba23cd$export$7b85fd78dd236198)(contentValidatorSpec.items[index] || contentValidatorSpec.items[contentValidatorSpec.items.length - 1]), validatorSpec);
                        const { entity: entity } = validateChildMarks(newChildEntity, marksValidationOutput, errorCallback, false, true);
                        return entity;
                    }
                    // Only go inside valid branch
                    const allowedSpecsForEntity = contentValidatorSpec.items.filter((item)=>Array.isArray(item) ? item.some(// [p, hr, ...] or [p, [text, {}], ...]
                        (spec)=>(Array.isArray(spec) ? spec[0] : spec) === child.type) : true);
                    if (allowedSpecsForEntity.length) {
                        if (allowedSpecsForEntity.length > 1) throw new Error('Consider using Tuple instead!');
                        const maybeArray = (0, $b212eb2b08ba23cd$export$7b85fd78dd236198)(allowedSpecsForEntity[0]);
                        const allowedSpecsForChild = maybeArray.filter((item)=>(Array.isArray(item) ? item[0] : item) === child.type);
                        if (allowedSpecsForChild.length === 0) return $5a24607d60a15c5e$var$invalidChildContent(child, errorCallback, validatorSpec);
                        /**
						 * When there's multiple possible branches try all of them.
						 * If all of them fails, throw the first one.
						 * e.g.- [['text', { marks: ['a'] }], ['text', { marks: ['b'] }]]
						 */ let firstError;
                        let firstChild;
                        for(let i = 0, len = allowedSpecsForChild.length; i < len; i++)try {
                            const allowedValueForCurrentSpec = [
                                allowedSpecsForChild[i]
                            ];
                            const { valid: valid, entity: newChildEntity, marksValidationOutput: marksValidationOutput } = validateNode(child, errorCallback, allowedValueForCurrentSpec, validatorSpec);
                            if (valid) {
                                const isLastValidationSpec = i === allowedSpecsForChild.length - 1;
                                const { valid: marksAreValid, entity: entity } = validateChildMarks(newChildEntity, marksValidationOutput, errorCallback, isLastValidationSpec);
                                const unsupportedMarks = entity && entity.marks && entity.marks.filter((mark)=>mark.type === 'unsupportedMark') || [];
                                if (marksAreValid && !unsupportedMarks.length) return entity;
                                else firstChild = firstChild || newChildEntity;
                            } else firstChild = firstChild || newChildEntity;
                        } catch (error) {
                            firstError = firstError || error;
                        }
                        if (!errorCallback) throw firstError;
                        else return firstChild;
                    } else return $5a24607d60a15c5e$var$invalidChildContent(child, errorCallback, validatorSpec);
                };
                newEntity.content = prevEntity.content.map(validateChildNode).filter(Boolean);
            } else if (!contentValidatorSpec.optional) return {
                hasValidated: true,
                result: err('MISSING_PROPERTIES', 'missing `content` prop')
            };
        }
        // Marks
        if (prevEntity.marks) return {
            hasValidated: true,
            result: marksValidationFor(validatorSpec, prevEntity, errorCallback, newEntity, err)
        };
        return specBasedValidationResult;
    }
}
module.exports["validator"] = $5a24607d60a15c5e$export$956325f45c5d174a;

});

parcelRegister("fv6vq", function(module, exports) {
const $02e9876c0f622bf1$export$8e53000a4ec837 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'alignment'
            ]
        },
        attrs: {
            props: {
                align: {
                    type: 'enum',
                    values: [
                        'center',
                        'end'
                    ]
                }
            }
        }
    }
};
const $02e9876c0f622bf1$export$8512c9afa7b24c3b = {
    props: {
        type: {
            type: 'enum',
            values: [
                'annotation'
            ]
        },
        attrs: {
            props: {
                id: {
                    type: 'string'
                },
                annotationType: {
                    type: 'enum',
                    values: [
                        'inlineComment'
                    ]
                }
            }
        }
    }
};
const $02e9876c0f622bf1$export$8c5a050822fd698c = {
    props: {
        type: {
            type: 'enum',
            values: [
                'backgroundColor'
            ]
        },
        attrs: {
            props: {
                color: {
                    pattern: '^#[0-9a-fA-F]{6}$',
                    type: 'string'
                }
            }
        }
    }
};
const $02e9876c0f622bf1$export$a31afb40076fa18b = [
    'blockCard',
    'paragraph_with_no_marks',
    'paragraph_with_alignment',
    'paragraph_with_indentation',
    'mediaSingle_caption',
    'mediaSingle_full',
    'codeBlock',
    'taskList',
    'bulletList',
    'orderedList',
    'heading_with_no_marks',
    'heading_with_alignment',
    'heading_with_indentation',
    'mediaGroup',
    'decisionList',
    'rule',
    'panel',
    'blockquote',
    'extension_with_marks',
    'embedCard',
    'table',
    'expand',
    'bodiedExtension_with_marks'
];
const $02e9876c0f622bf1$export$c4c2f833baaebdb8 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'blockCard'
            ]
        },
        attrs: [
            {
                props: {
                    localId: {
                        type: 'string',
                        optional: true
                    },
                    url: {
                        type: 'string',
                        optional: true,
                        validatorFn: 'safeUrl'
                    },
                    datasource: {
                        props: {
                            id: {
                                type: 'string'
                            },
                            parameters: {
                                type: 'object'
                            },
                            views: {
                                items: [
                                    {
                                        props: {
                                            properties: {
                                                optional: true,
                                                type: 'object'
                                            },
                                            type: {
                                                type: 'string'
                                            }
                                        }
                                    }
                                ],
                                minItems: 1,
                                type: 'array'
                            }
                        }
                    },
                    width: {
                        type: 'number',
                        optional: true
                    },
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ],
                        optional: true
                    }
                }
            },
            {
                props: {
                    url: {
                        type: 'string',
                        validatorFn: 'safeUrl'
                    },
                    localId: {
                        type: 'string',
                        optional: true
                    }
                }
            },
            {
                props: {
                    data: {
                        type: 'object'
                    },
                    localId: {
                        type: 'string',
                        optional: true
                    }
                }
            }
        ]
    },
    required: [
        'attrs'
    ]
};
const $02e9876c0f622bf1$export$67dc04e652a298ca = {
    props: {
        type: {
            type: 'enum',
            values: [
                'blockquote'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'orderedList',
                    'bulletList',
                    'codeBlock',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaGroup',
                    'extension_with_marks'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $02e9876c0f622bf1$export$ebb5393736e9ba23 = [
    'multiBodiedExtension'
];
const $02e9876c0f622bf1$export$16018c61064a18df = {
    props: {
        type: {
            type: 'enum',
            values: [
                'blockTaskItem'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                },
                state: {
                    type: 'enum',
                    values: [
                        'TODO',
                        'DONE'
                    ]
                }
            }
        },
        content: {
            type: 'array',
            isTupleLike: true,
            items: [
                [
                    'paragraph_with_no_marks',
                    'extension_with_marks'
                ],
                [
                    'paragraph_with_no_marks',
                    'extension_with_marks'
                ]
            ],
            minItems: 1
        }
    }
};
const $02e9876c0f622bf1$export$27903d543b563e39 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'bodiedExtension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'default'
                    ],
                    optional: true
                },
                localId: {
                    minLength: 1,
                    type: 'string',
                    optional: true
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'non_nestable_block_content'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $02e9876c0f622bf1$export$ee052cc5b2356e83 = [
    'bodiedExtension',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ]
            }
        }
    }
];
const $02e9876c0f622bf1$export$e92c7e4302dd4371 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'bodiedSyncBlock'
            ]
        },
        attrs: {
            props: {
                resourceId: {
                    type: 'string'
                },
                localId: {
                    type: 'string'
                }
            }
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph',
                    'paragraph_with_alignment',
                    'paragraph_with_indentation',
                    'paragraph_with_no_marks',
                    'blockCard',
                    'blockquote',
                    'bulletList',
                    'codeBlock',
                    'decisionList',
                    'embedCard',
                    'expand',
                    'heading',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'heading_with_no_marks',
                    'layoutSection',
                    'mediaGroup',
                    'mediaSingle',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaSingle_width_type',
                    'orderedList',
                    'panel',
                    'rule',
                    'table',
                    'taskList'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'breakout'
            ]
        }
    }
};
const $02e9876c0f622bf1$export$1edee58a52776cd9 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'border'
            ]
        },
        attrs: {
            props: {
                size: {
                    type: 'number',
                    minimum: 1,
                    maximum: 3
                },
                color: {
                    pattern: '^#[0-9a-fA-F]{8}$|^#[0-9a-fA-F]{6}$',
                    type: 'string'
                }
            }
        }
    }
};
const $02e9876c0f622bf1$export$89015c65f1c75e3f = {
    props: {
        type: {
            type: 'enum',
            values: [
                'breakout'
            ]
        },
        attrs: {
            props: {
                mode: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width'
                    ]
                },
                width: {
                    type: 'number',
                    optional: true
                }
            }
        }
    }
};
const $02e9876c0f622bf1$export$a140c94e5ea26bee = {
    props: {
        type: {
            type: 'enum',
            values: [
                'bulletList'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'listItem',
                    'listItem_with_nested_decision'
                ]
            ],
            minItems: 1
        }
    }
};
const $02e9876c0f622bf1$export$8e3c2dfdc4f0453d = {
    props: {
        type: {
            type: 'enum',
            values: [
                'caption'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'hardBreak',
                    'mention',
                    'emoji',
                    'date',
                    'placeholder',
                    'inlineCard',
                    'status',
                    'text_formatted',
                    'text_code_inline'
                ]
            ],
            optional: true,
            allowUnsupportedInline: true
        }
    }
};
const $02e9876c0f622bf1$export$6565f9f03506010b = {
    props: {
        type: {
            type: 'enum',
            values: [
                'code'
            ]
        }
    }
};
const $02e9876c0f622bf1$export$7bb0d5c671655cc4 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'codeBlock'
            ]
        },
        attrs: {
            props: {
                language: {
                    type: 'string',
                    optional: true
                },
                uniqueId: {
                    type: 'string',
                    optional: true
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                'text_with_no_marks'
            ],
            optional: true,
            allowUnsupportedInline: true
        }
    }
};
const $02e9876c0f622bf1$export$38d90d1aac6883a3 = [
    'codeBlock',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'breakout'
                ]
            }
        }
    }
];
const $02e9876c0f622bf1$export$f3b72f8fc4684ecd = {
    props: {
        type: {
            type: 'enum',
            values: [
                'confluenceInlineComment'
            ]
        },
        attrs: {
            props: {
                reference: {
                    type: 'string'
                }
            }
        }
    }
};
const $02e9876c0f622bf1$export$3024f02c495408d6 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'dataConsumer'
            ]
        },
        attrs: {
            props: {
                sources: {
                    type: 'array',
                    items: [
                        {
                            type: 'string'
                        }
                    ],
                    minItems: 1
                }
            }
        }
    }
};
const $02e9876c0f622bf1$export$324d90190a8b822a = {
    props: {
        type: {
            type: 'enum',
            values: [
                'date'
            ]
        },
        attrs: {
            props: {
                timestamp: {
                    minLength: 1,
                    type: 'string'
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    }
};
const $02e9876c0f622bf1$export$6959e16eeff859b4 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'decisionItem'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                },
                state: {
                    type: 'string'
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'inline_content'
            ],
            optional: true,
            allowUnsupportedInline: true
        }
    }
};
const $02e9876c0f622bf1$export$62d45a65fb43d95e = {
    props: {
        type: {
            type: 'enum',
            values: [
                'decisionList'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'decisionItem'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $02e9876c0f622bf1$export$2a111da947c407d2 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'doc'
            ]
        },
        version: {
            type: 'enum',
            values: [
                1
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'blockCard',
                    'paragraph_with_no_marks',
                    'paragraph_with_alignment',
                    'paragraph_with_indentation',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'taskList',
                    'bulletList',
                    'orderedList',
                    'heading_with_no_marks',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'mediaGroup',
                    'decisionList',
                    'rule',
                    'panel',
                    'blockquote',
                    'extension_with_marks',
                    'embedCard',
                    'table',
                    'expand',
                    'bodiedExtension_with_marks',
                    'codeBlock_root_only',
                    'layoutSection_with_single_column',
                    'layoutSection_full',
                    'multiBodiedExtension',
                    'expand_root_only',
                    'syncBlock',
                    'bodiedSyncBlock'
                ]
            ],
            allowUnsupportedBlock: true
        }
    }
};
const $02e9876c0f622bf1$export$c63c6f932822f543 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'em'
            ]
        }
    }
};
const $02e9876c0f622bf1$export$be4283d9a1cb1ff6 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'embedCard'
            ]
        },
        attrs: {
            props: {
                url: {
                    type: 'string',
                    validatorFn: 'safeUrl'
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'center',
                        'wrap-right',
                        'wrap-left',
                        'align-end',
                        'align-start'
                    ]
                },
                width: {
                    type: 'number',
                    maximum: 100,
                    minimum: 0,
                    optional: true
                },
                originalHeight: {
                    type: 'number',
                    optional: true
                },
                originalWidth: {
                    type: 'number',
                    optional: true
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            }
        }
    }
};
const $02e9876c0f622bf1$export$a19185d1233fc4b2 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'emoji'
            ]
        },
        attrs: {
            props: {
                shortName: {
                    type: 'string'
                },
                id: {
                    type: 'string',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    }
};
const $02e9876c0f622bf1$export$9f77e0932fb78f72 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'expand'
            ]
        },
        attrs: {
            props: {
                title: {
                    type: 'string',
                    optional: true
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'codeBlock',
                    'mediaGroup',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'decisionList',
                    'taskList',
                    'table',
                    'blockCard',
                    'embedCard',
                    'extension_with_marks',
                    'nestedExpand_with_no_marks'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $02e9876c0f622bf1$export$b2817c6954dd6d2c = [
    'expand',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'breakout'
                ]
            }
        }
    }
];
const $02e9876c0f622bf1$export$1b45514b112dd749 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'extension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'default'
                    ],
                    optional: true
                },
                localId: {
                    minLength: 1,
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $02e9876c0f622bf1$export$15be7c145cec614a = [
    'extension',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ]
            }
        }
    }
];
const $02e9876c0f622bf1$export$4fdcae991fd743e7 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'extensionFrame'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'codeBlock',
                    'mediaGroup',
                    'mediaSingle_full',
                    'mediaSingle_caption',
                    'decisionList',
                    'taskList',
                    'table',
                    'extension_with_marks',
                    'bodiedExtension_with_marks',
                    'blockCard',
                    'embedCard'
                ]
            ],
            minItems: 1
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                [
                    'dataConsumer',
                    'fragment'
                ]
            ]
        }
    }
};
const $02e9876c0f622bf1$export$f00aeb236b6f05af = {
    props: {
        type: {
            type: 'enum',
            values: [
                'fragment'
            ]
        },
        attrs: {
            props: {
                localId: {
                    minLength: 1,
                    type: 'string'
                },
                name: {
                    type: 'string',
                    optional: true
                }
            }
        }
    }
};
const $02e9876c0f622bf1$export$371da9dd35aba193 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'hardBreak'
            ]
        },
        attrs: {
            props: {
                text: {
                    type: 'enum',
                    values: [
                        '\n'
                    ],
                    optional: true
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        }
    }
};
const $02e9876c0f622bf1$export$46e4a324ac90507f = {
    props: {
        type: {
            type: 'enum',
            values: [
                'heading'
            ]
        },
        attrs: {
            props: {
                level: {
                    type: 'number',
                    minimum: 1,
                    maximum: 6
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'inline_content'
            ],
            optional: true,
            allowUnsupportedInline: true
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $02e9876c0f622bf1$export$c17edf9af655deaf = [
    'heading',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'alignment'
                ]
            }
        }
    }
];
const $02e9876c0f622bf1$export$1902f9737466a0dc = [
    'heading',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'indentation'
                ]
            }
        }
    }
];
const $02e9876c0f622bf1$export$7b491e75f1be9278 = [
    'heading',
    {
        props: {
            marks: {
                type: 'array',
                maxItems: 0,
                items: [],
                optional: true
            }
        }
    }
];
const $02e9876c0f622bf1$export$480c699bd4ec0d86 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'indentation'
            ]
        },
        attrs: {
            props: {
                level: {
                    type: 'number',
                    minimum: 1,
                    maximum: 6
                }
            }
        }
    }
};
const $02e9876c0f622bf1$export$e23e6162adaa368d = [
    'text_formatted',
    'text_code_inline',
    'date',
    'emoji',
    'hardBreak',
    'inlineCard',
    'mention',
    'placeholder',
    'status',
    'inlineExtension_with_marks',
    'mediaInline'
];
const $02e9876c0f622bf1$export$cbf8224b64e0d942 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'inlineCard'
            ]
        },
        attrs: [
            {
                props: {
                    url: {
                        type: 'string',
                        validatorFn: 'safeUrl'
                    },
                    localId: {
                        type: 'string',
                        optional: true
                    }
                }
            },
            {
                props: {
                    data: {
                        type: 'object'
                    },
                    localId: {
                        type: 'string',
                        optional: true
                    }
                }
            }
        ],
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    },
    required: [
        'attrs'
    ]
};
const $02e9876c0f622bf1$export$16b353b2649bd8d9 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'inlineExtension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                localId: {
                    minLength: 1,
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $02e9876c0f622bf1$export$e37f10815f36843d = [
    'inlineExtension',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ]
            }
        }
    }
];
const $02e9876c0f622bf1$export$ab76e7c03cd6f650 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'layoutColumn'
            ]
        },
        attrs: {
            props: {
                width: {
                    type: 'number',
                    minimum: 0,
                    maximum: 100
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'block_content'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $02e9876c0f622bf1$export$b3b6a70a7fa4a5be = {
    props: {
        type: {
            type: 'enum',
            values: [
                'layoutSection'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                'layoutColumn'
            ],
            minItems: 1,
            maxItems: 3,
            allowUnsupportedBlock: true
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'breakout'
            ]
        }
    }
};
const $02e9876c0f622bf1$export$941b63fbd931e449 = [
    'layoutSection',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    'layoutColumn'
                ],
                minItems: 2,
                maxItems: 3,
                allowUnsupportedBlock: true
            },
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'breakout'
                ]
            }
        }
    }
];
const $02e9876c0f622bf1$export$e0e9834198e8601d = [
    'layoutSection',
    {
        props: {
            attrs: {
                props: {
                    columnRuleStyle: {
                        type: 'enum',
                        values: [
                            'solid'
                        ],
                        optional: true
                    },
                    localId: {
                        type: 'string',
                        optional: true
                    }
                },
                optional: true
            },
            content: {
                type: 'array',
                items: [
                    'layoutColumn'
                ],
                minItems: 1,
                maxItems: 5,
                allowUnsupportedBlock: true
            },
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'breakout'
                ]
            }
        }
    }
];
const $02e9876c0f622bf1$export$9c30223ca0a664fb = {
    props: {
        type: {
            type: 'enum',
            values: [
                'link'
            ]
        },
        attrs: {
            props: {
                href: {
                    type: 'string',
                    validatorFn: 'safeUrl'
                },
                title: {
                    type: 'string',
                    optional: true
                },
                id: {
                    type: 'string',
                    optional: true
                },
                collection: {
                    type: 'string',
                    optional: true
                },
                occurrenceKey: {
                    type: 'string',
                    optional: true
                }
            }
        }
    }
};
const $02e9876c0f622bf1$export$76c7e83ecc9cdf05 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'listItem'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            isTupleLike: true,
            items: [
                [
                    'paragraph_with_no_marks',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'extension_with_marks'
                ],
                [
                    'paragraph_with_no_marks',
                    'bulletList',
                    'orderedList',
                    'taskList',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'extension_with_marks'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $02e9876c0f622bf1$export$2b82905b9aebbab0 = [
    'listItem',
    {
        props: {
            content: {
                type: 'array',
                isTupleLike: true,
                items: [
                    [
                        'paragraph_with_no_marks',
                        'mediaSingle_caption',
                        'mediaSingle_full',
                        'codeBlock',
                        'decisionList',
                        'extension_with_marks'
                    ],
                    [
                        'paragraph_with_no_marks',
                        'bulletList',
                        'orderedList',
                        'taskList',
                        'mediaSingle_caption',
                        'mediaSingle_full',
                        'codeBlock',
                        'decisionList',
                        'extension_with_marks'
                    ]
                ],
                minItems: 1,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $02e9876c0f622bf1$export$987d49ffe1b0900f = {
    props: {
        type: {
            type: 'enum',
            values: [
                'media'
            ]
        },
        attrs: [
            {
                props: {
                    type: {
                        type: 'enum',
                        values: [
                            'link',
                            'file'
                        ]
                    },
                    localId: {
                        type: 'string',
                        optional: true
                    },
                    id: {
                        minLength: 1,
                        type: 'string'
                    },
                    alt: {
                        type: 'string',
                        optional: true
                    },
                    collection: {
                        type: 'string'
                    },
                    height: {
                        type: 'number',
                        optional: true
                    },
                    occurrenceKey: {
                        minLength: 1,
                        type: 'string',
                        optional: true
                    },
                    width: {
                        type: 'number',
                        optional: true
                    }
                }
            },
            {
                props: {
                    type: {
                        type: 'enum',
                        values: [
                            'external'
                        ]
                    },
                    localId: {
                        type: 'string',
                        optional: true
                    },
                    alt: {
                        type: 'string',
                        optional: true
                    },
                    height: {
                        type: 'number',
                        optional: true
                    },
                    width: {
                        type: 'number',
                        optional: true
                    },
                    url: {
                        type: 'string'
                    }
                }
            }
        ],
        marks: {
            type: 'array',
            optional: true,
            items: [
                [
                    'link',
                    'annotation',
                    'border'
                ]
            ]
        }
    },
    required: [
        'attrs'
    ]
};
const $02e9876c0f622bf1$export$2855e964765eac9 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mediaGroup'
            ]
        },
        content: {
            type: 'array',
            items: [
                'media'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $02e9876c0f622bf1$export$38bab695e3f720f1 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mediaInline'
            ]
        },
        attrs: {
            props: {
                type: {
                    type: 'enum',
                    values: [
                        'link',
                        'file',
                        'image'
                    ],
                    optional: true
                },
                localId: {
                    type: 'string',
                    optional: true
                },
                url: {
                    type: 'string',
                    optional: true
                },
                id: {
                    minLength: 1,
                    type: 'string'
                },
                alt: {
                    type: 'string',
                    optional: true
                },
                collection: {
                    type: 'string'
                },
                occurrenceKey: {
                    minLength: 1,
                    type: 'string',
                    optional: true
                },
                width: {
                    type: 'number',
                    optional: true
                },
                height: {
                    type: 'number',
                    optional: true
                },
                data: {
                    type: 'object',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                [
                    'link',
                    'annotation',
                    'border'
                ]
            ]
        }
    }
};
const $02e9876c0f622bf1$export$969fe3781ca15058 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mediaSingle'
            ]
        },
        attrs: [
            {
                props: {
                    localId: {
                        type: 'string',
                        optional: true
                    },
                    width: {
                        type: 'number',
                        minimum: 0,
                        maximum: 100,
                        optional: true
                    },
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ]
                    },
                    widthType: {
                        type: 'enum',
                        values: [
                            'percentage'
                        ],
                        optional: true
                    }
                }
            },
            {
                props: {
                    localId: {
                        type: 'string',
                        optional: true
                    },
                    width: {
                        type: 'number',
                        minimum: 0
                    },
                    widthType: {
                        type: 'enum',
                        values: [
                            'pixel'
                        ]
                    },
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ]
                    }
                }
            }
        ],
        marks: {
            type: 'array',
            optional: true,
            items: [
                'link'
            ]
        }
    }
};
const $02e9876c0f622bf1$export$68b0ead306f9670f = [
    'mediaSingle',
    {
        props: {
            content: {
                type: 'array',
                isTupleLike: true,
                items: [
                    'media',
                    'caption'
                ],
                minItems: 1,
                maxItems: 2,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $02e9876c0f622bf1$export$f7fd577406abd5f8 = [
    'mediaSingle',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    'media'
                ],
                minItems: 1,
                maxItems: 1,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $02e9876c0f622bf1$export$af10954ff7b86f88 = [
    'mediaSingle',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    'media'
                ],
                minItems: 1,
                maxItems: 1,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $02e9876c0f622bf1$export$db83999c14438df4 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mention'
            ]
        },
        attrs: {
            props: {
                id: {
                    type: 'string'
                },
                localId: {
                    type: 'string',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                accessLevel: {
                    type: 'string',
                    optional: true
                },
                userType: {
                    type: 'enum',
                    values: [
                        'DEFAULT',
                        'SPECIAL',
                        'APP'
                    ],
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    }
};
const $02e9876c0f622bf1$export$c3c04d555a8b9013 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'multiBodiedExtension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    type: 'string',
                    minLength: 1
                },
                extensionType: {
                    type: 'string',
                    minLength: 1
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'default',
                        'wide',
                        'full-width'
                    ],
                    optional: true
                },
                localId: {
                    type: 'string',
                    optional: true,
                    minLength: 1
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'extensionFrame'
            ]
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $02e9876c0f622bf1$export$63cadbf5f4296627 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'nestedExpand'
            ]
        },
        attrs: {
            props: {
                title: {
                    type: 'string',
                    optional: true
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            }
        },
        content: 'nestedExpand_content'
    },
    required: [
        'content'
    ]
};
const $02e9876c0f622bf1$export$9584f52f3ebd5d7e = {
    type: 'array',
    items: [
        [
            'paragraph_with_no_marks',
            'heading_with_no_marks',
            'mediaSingle_caption',
            'mediaSingle_full',
            'mediaGroup',
            'codeBlock',
            'bulletList',
            'orderedList',
            'taskList',
            'decisionList',
            'rule',
            'panel',
            'blockquote',
            'extension_with_marks'
        ]
    ],
    minItems: 1,
    allowUnsupportedBlock: true
};
const $02e9876c0f622bf1$export$b756fc994eb0bc4f = [
    'nestedExpand',
    {
        props: {
            marks: {
                type: 'array',
                maxItems: 0,
                items: [],
                optional: true
            }
        }
    }
];
const $02e9876c0f622bf1$export$ed866000601e7fa5 = [
    'paragraph_with_no_marks',
    'panel',
    'blockquote',
    'orderedList',
    'bulletList',
    'rule',
    'heading_with_no_marks',
    'codeBlock',
    'mediaGroup',
    'mediaSingle_caption',
    'mediaSingle_full',
    'decisionList',
    'taskList',
    'table',
    'blockCard',
    'embedCard',
    'extension_with_marks'
];
const $02e9876c0f622bf1$export$a5dc81035676e7a = {
    props: {
        type: {
            type: 'enum',
            values: [
                'orderedList'
            ]
        },
        attrs: {
            props: {
                order: {
                    type: 'number',
                    minimum: 0,
                    optional: true
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'listItem',
                    'listItem_with_nested_decision'
                ]
            ],
            minItems: 1
        }
    }
};
const $02e9876c0f622bf1$export$21f42ab9b6679f44 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'panel'
            ]
        },
        attrs: {
            props: {
                panelType: {
                    type: 'enum',
                    values: [
                        'info',
                        'note',
                        'tip',
                        'warning',
                        'error',
                        'success',
                        'custom'
                    ]
                },
                panelIcon: {
                    type: 'string',
                    optional: true
                },
                panelIconId: {
                    type: 'string',
                    optional: true
                },
                panelIconText: {
                    type: 'string',
                    optional: true
                },
                panelColor: {
                    type: 'string',
                    optional: true
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            }
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'heading_with_no_marks',
                    'bulletList',
                    'orderedList',
                    'blockCard',
                    'mediaGroup',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'taskList',
                    'rule',
                    'decisionList',
                    'extension_with_marks'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $02e9876c0f622bf1$export$9c206ddddb32a9b = {
    props: {
        type: {
            type: 'enum',
            values: [
                'paragraph'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                'inline_content'
            ],
            optional: true,
            allowUnsupportedInline: true
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $02e9876c0f622bf1$export$9ca11c06877e5c64 = [
    'paragraph',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'alignment'
                ]
            }
        }
    }
];
const $02e9876c0f622bf1$export$a3bd66932996fb7d = [
    'paragraph',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'indentation'
                ]
            }
        }
    }
];
const $02e9876c0f622bf1$export$f06f75eb1e56b0c5 = [
    'paragraph',
    {
        props: {
            marks: {
                type: 'array',
                maxItems: 0,
                items: [],
                optional: true
            }
        }
    }
];
const $02e9876c0f622bf1$export$c7187bbd1a7a9244 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'placeholder'
            ]
        },
        attrs: {
            props: {
                text: {
                    type: 'string'
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            }
        }
    }
};
const $02e9876c0f622bf1$export$fbeb3a3956e8a3c7 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'rule'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        }
    }
};
const $02e9876c0f622bf1$export$471f7ae5c4103ae1 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'status'
            ]
        },
        attrs: {
            props: {
                text: {
                    minLength: 1,
                    type: 'string'
                },
                color: {
                    type: 'enum',
                    values: [
                        'neutral',
                        'purple',
                        'blue',
                        'red',
                        'yellow',
                        'green'
                    ]
                },
                localId: {
                    type: 'string',
                    optional: true
                },
                style: {
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    }
};
const $02e9876c0f622bf1$export$4899a95d70ec5056 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'strike'
            ]
        }
    }
};
const $02e9876c0f622bf1$export$59ae2c325a998f89 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'strong'
            ]
        }
    }
};
const $02e9876c0f622bf1$export$b3401ee80eb31041 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'subsup'
            ]
        },
        attrs: {
            props: {
                type: {
                    type: 'enum',
                    values: [
                        'sub',
                        'sup'
                    ]
                }
            }
        }
    }
};
const $02e9876c0f622bf1$export$faab0ca9701d7048 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'syncBlock'
            ]
        },
        attrs: {
            props: {
                resourceId: {
                    type: 'string'
                },
                localId: {
                    type: 'string'
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'breakout'
            ]
        }
    }
};
const $02e9876c0f622bf1$export$9852986a3ec5f6a0 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'table'
            ]
        },
        attrs: {
            props: {
                displayMode: {
                    type: 'enum',
                    values: [
                        'default',
                        'fixed'
                    ],
                    optional: true
                },
                isNumberColumnEnabled: {
                    type: 'boolean',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'center',
                        'align-end',
                        'align-start',
                        'default'
                    ],
                    optional: true
                },
                localId: {
                    type: 'string',
                    minLength: 1,
                    optional: true
                },
                width: {
                    type: 'number',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                'tableRow'
            ],
            minItems: 1
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'fragment'
            ]
        }
    }
};
const $02e9876c0f622bf1$export$e1e720e5f4603e6a = {
    props: {
        type: {
            type: 'enum',
            values: [
                'tableCell'
            ]
        },
        attrs: {
            props: {
                colspan: {
                    type: 'number',
                    optional: true
                },
                rowspan: {
                    type: 'number',
                    optional: true
                },
                colwidth: {
                    type: 'array',
                    items: [
                        {
                            type: 'number'
                        }
                    ],
                    optional: true
                },
                background: {
                    type: 'string',
                    optional: true
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_alignment',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'codeBlock',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaGroup',
                    'decisionList',
                    'taskList',
                    'blockCard',
                    'embedCard',
                    'extension_with_marks',
                    'nestedExpand_with_no_marks'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    },
    required: [
        'content'
    ]
};
const $02e9876c0f622bf1$export$48884d2a5190dc73 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'tableHeader'
            ]
        },
        attrs: {
            props: {
                colspan: {
                    type: 'number',
                    optional: true
                },
                rowspan: {
                    type: 'number',
                    optional: true
                },
                colwidth: {
                    type: 'array',
                    items: [
                        {
                            type: 'number'
                        }
                    ],
                    optional: true
                },
                background: {
                    type: 'string',
                    optional: true
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_alignment',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'codeBlock',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaGroup',
                    'decisionList',
                    'taskList',
                    'blockCard',
                    'embedCard',
                    'extension_with_marks',
                    'nestedExpand_with_no_marks',
                    'nestedExpand'
                ]
            ],
            minItems: 1
        }
    },
    required: [
        'content'
    ]
};
const $02e9876c0f622bf1$export$ce666bf02318c957 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'tableRow'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'tableCell',
                    'tableHeader'
                ]
            ]
        }
    }
};
const $02e9876c0f622bf1$export$6d8b0ef52e2e6390 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'taskItem'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                },
                state: {
                    type: 'enum',
                    values: [
                        'TODO',
                        'DONE'
                    ]
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'inline_content'
            ],
            optional: true,
            allowUnsupportedInline: true
        }
    }
};
const $02e9876c0f622bf1$export$375b6afcc5f4d291 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'taskList'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                }
            }
        },
        content: {
            type: 'array',
            isTupleLike: true,
            items: [
                [
                    'taskItem',
                    'blockTaskItem'
                ],
                [
                    'taskItem',
                    'taskList',
                    'blockTaskItem'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $02e9876c0f622bf1$export$6f093cfa640b7166 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'text'
            ]
        },
        text: {
            type: 'string',
            minLength: 1
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $02e9876c0f622bf1$export$5008c13f04d544f6 = [
    'text',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'code',
                        'link',
                        'annotation'
                    ]
                ]
            }
        }
    }
];
const $02e9876c0f622bf1$export$d24a7becb4e0da7c = [
    'text',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'link',
                        'em',
                        'strong',
                        'strike',
                        'subsup',
                        'underline',
                        'textColor',
                        'annotation',
                        'backgroundColor',
                        null
                    ]
                ]
            }
        }
    }
];
const $02e9876c0f622bf1$export$2a9d18d5b3064e6c = [
    'text',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'link'
                ]
            }
        }
    }
];
const $02e9876c0f622bf1$export$437a3d96346717e0 = [
    'text',
    {
        props: {
            marks: {
                type: 'array',
                maxItems: 0,
                items: [],
                optional: true
            }
        }
    }
];
const $02e9876c0f622bf1$export$32f78bffcd82ff28 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'textColor'
            ]
        },
        attrs: {
            props: {
                color: {
                    type: 'string',
                    pattern: '^#[0-9a-fA-F]{6}$'
                }
            }
        }
    }
};
const $02e9876c0f622bf1$export$425327af25286e5e = {
    props: {
        type: {
            type: 'enum',
            values: [
                'underline'
            ]
        }
    }
};
module.exports["alignment"] = $02e9876c0f622bf1$export$8e53000a4ec837;
module.exports["annotation"] = $02e9876c0f622bf1$export$8512c9afa7b24c3b;
module.exports["backgroundColor"] = $02e9876c0f622bf1$export$8c5a050822fd698c;
module.exports["block_content"] = $02e9876c0f622bf1$export$a31afb40076fa18b;
module.exports["blockCard"] = $02e9876c0f622bf1$export$c4c2f833baaebdb8;
module.exports["blockquote"] = $02e9876c0f622bf1$export$67dc04e652a298ca;
module.exports["blockRootOnly"] = $02e9876c0f622bf1$export$ebb5393736e9ba23;
module.exports["blockTaskItem"] = $02e9876c0f622bf1$export$16018c61064a18df;
module.exports["bodiedExtension"] = $02e9876c0f622bf1$export$27903d543b563e39;
module.exports["bodiedExtension_with_marks"] = $02e9876c0f622bf1$export$ee052cc5b2356e83;
module.exports["bodiedSyncBlock"] = $02e9876c0f622bf1$export$e92c7e4302dd4371;
module.exports["border"] = $02e9876c0f622bf1$export$1edee58a52776cd9;
module.exports["breakout"] = $02e9876c0f622bf1$export$89015c65f1c75e3f;
module.exports["bulletList"] = $02e9876c0f622bf1$export$a140c94e5ea26bee;
module.exports["caption"] = $02e9876c0f622bf1$export$8e3c2dfdc4f0453d;
module.exports["code"] = $02e9876c0f622bf1$export$6565f9f03506010b;
module.exports["codeBlock"] = $02e9876c0f622bf1$export$7bb0d5c671655cc4;
module.exports["codeBlock_root_only"] = $02e9876c0f622bf1$export$38d90d1aac6883a3;
module.exports["confluenceInlineComment"] = $02e9876c0f622bf1$export$f3b72f8fc4684ecd;
module.exports["dataConsumer"] = $02e9876c0f622bf1$export$3024f02c495408d6;
module.exports["date"] = $02e9876c0f622bf1$export$324d90190a8b822a;
module.exports["decisionItem"] = $02e9876c0f622bf1$export$6959e16eeff859b4;
module.exports["decisionList"] = $02e9876c0f622bf1$export$62d45a65fb43d95e;
module.exports["doc"] = $02e9876c0f622bf1$export$2a111da947c407d2;
module.exports["em"] = $02e9876c0f622bf1$export$c63c6f932822f543;
module.exports["embedCard"] = $02e9876c0f622bf1$export$be4283d9a1cb1ff6;
module.exports["emoji"] = $02e9876c0f622bf1$export$a19185d1233fc4b2;
module.exports["expand"] = $02e9876c0f622bf1$export$9f77e0932fb78f72;
module.exports["expand_root_only"] = $02e9876c0f622bf1$export$b2817c6954dd6d2c;
module.exports["extension"] = $02e9876c0f622bf1$export$1b45514b112dd749;
module.exports["extension_with_marks"] = $02e9876c0f622bf1$export$15be7c145cec614a;
module.exports["extensionFrame"] = $02e9876c0f622bf1$export$4fdcae991fd743e7;
module.exports["fragment"] = $02e9876c0f622bf1$export$f00aeb236b6f05af;
module.exports["hardBreak"] = $02e9876c0f622bf1$export$371da9dd35aba193;
module.exports["heading"] = $02e9876c0f622bf1$export$46e4a324ac90507f;
module.exports["heading_with_alignment"] = $02e9876c0f622bf1$export$c17edf9af655deaf;
module.exports["heading_with_indentation"] = $02e9876c0f622bf1$export$1902f9737466a0dc;
module.exports["heading_with_no_marks"] = $02e9876c0f622bf1$export$7b491e75f1be9278;
module.exports["indentation"] = $02e9876c0f622bf1$export$480c699bd4ec0d86;
module.exports["inline_content"] = $02e9876c0f622bf1$export$e23e6162adaa368d;
module.exports["inlineCard"] = $02e9876c0f622bf1$export$cbf8224b64e0d942;
module.exports["inlineExtension"] = $02e9876c0f622bf1$export$16b353b2649bd8d9;
module.exports["inlineExtension_with_marks"] = $02e9876c0f622bf1$export$e37f10815f36843d;
module.exports["layoutColumn"] = $02e9876c0f622bf1$export$ab76e7c03cd6f650;
module.exports["layoutSection"] = $02e9876c0f622bf1$export$b3b6a70a7fa4a5be;
module.exports["layoutSection_full"] = $02e9876c0f622bf1$export$941b63fbd931e449;
module.exports["layoutSection_with_single_column"] = $02e9876c0f622bf1$export$e0e9834198e8601d;
module.exports["link"] = $02e9876c0f622bf1$export$9c30223ca0a664fb;
module.exports["listItem"] = $02e9876c0f622bf1$export$76c7e83ecc9cdf05;
module.exports["media"] = $02e9876c0f622bf1$export$987d49ffe1b0900f;
module.exports["mediaGroup"] = $02e9876c0f622bf1$export$2855e964765eac9;
module.exports["mediaInline"] = $02e9876c0f622bf1$export$38bab695e3f720f1;
module.exports["mediaSingle"] = $02e9876c0f622bf1$export$969fe3781ca15058;
module.exports["mediaSingle_caption"] = $02e9876c0f622bf1$export$68b0ead306f9670f;
module.exports["mediaSingle_full"] = $02e9876c0f622bf1$export$f7fd577406abd5f8;
module.exports["mention"] = $02e9876c0f622bf1$export$db83999c14438df4;
module.exports["multiBodiedExtension"] = $02e9876c0f622bf1$export$c3c04d555a8b9013;
module.exports["nestedExpand"] = $02e9876c0f622bf1$export$63cadbf5f4296627;
module.exports["nestedExpand_content"] = $02e9876c0f622bf1$export$9584f52f3ebd5d7e;
module.exports["nestedExpand_with_no_marks"] = $02e9876c0f622bf1$export$b756fc994eb0bc4f;
module.exports["non_nestable_block_content"] = $02e9876c0f622bf1$export$ed866000601e7fa5;
module.exports["orderedList"] = $02e9876c0f622bf1$export$a5dc81035676e7a;
module.exports["panel"] = $02e9876c0f622bf1$export$21f42ab9b6679f44;
module.exports["paragraph"] = $02e9876c0f622bf1$export$9c206ddddb32a9b;
module.exports["paragraph_with_alignment"] = $02e9876c0f622bf1$export$9ca11c06877e5c64;
module.exports["paragraph_with_indentation"] = $02e9876c0f622bf1$export$a3bd66932996fb7d;
module.exports["paragraph_with_no_marks"] = $02e9876c0f622bf1$export$f06f75eb1e56b0c5;
module.exports["placeholder"] = $02e9876c0f622bf1$export$c7187bbd1a7a9244;
module.exports["rule"] = $02e9876c0f622bf1$export$fbeb3a3956e8a3c7;
module.exports["status"] = $02e9876c0f622bf1$export$471f7ae5c4103ae1;
module.exports["strike"] = $02e9876c0f622bf1$export$4899a95d70ec5056;
module.exports["strong"] = $02e9876c0f622bf1$export$59ae2c325a998f89;
module.exports["subsup"] = $02e9876c0f622bf1$export$b3401ee80eb31041;
module.exports["syncBlock"] = $02e9876c0f622bf1$export$faab0ca9701d7048;
module.exports["table"] = $02e9876c0f622bf1$export$9852986a3ec5f6a0;
module.exports["tableCell"] = $02e9876c0f622bf1$export$e1e720e5f4603e6a;
module.exports["tableHeader"] = $02e9876c0f622bf1$export$48884d2a5190dc73;
module.exports["tableRow"] = $02e9876c0f622bf1$export$ce666bf02318c957;
module.exports["taskItem"] = $02e9876c0f622bf1$export$6d8b0ef52e2e6390;
module.exports["taskList"] = $02e9876c0f622bf1$export$375b6afcc5f4d291;
module.exports["text"] = $02e9876c0f622bf1$export$6f093cfa640b7166;
module.exports["text_code_inline"] = $02e9876c0f622bf1$export$5008c13f04d544f6;
module.exports["text_formatted"] = $02e9876c0f622bf1$export$d24a7becb4e0da7c;
module.exports["text_link_inline"] = $02e9876c0f622bf1$export$2a9d18d5b3064e6c;
module.exports["text_with_no_marks"] = $02e9876c0f622bf1$export$437a3d96346717e0;
module.exports["textColor"] = $02e9876c0f622bf1$export$32f78bffcd82ff28;
module.exports["underline"] = $02e9876c0f622bf1$export$425327af25286e5e;

});

parcelRegister("juTiU", function(module, exports) {

var $d925B = parcelRequire("d925B");

const $e291ba685b2f2282$var$whitelistedAttributes = [
    'align',
    'annotationType',
    'extensionKey',
    'extensionType',
    'layout',
    'type',
    'localId',
    'mode',
    'language',
    'timestamp',
    'state',
    'originalWidth',
    'originalHeight',
    'height',
    'width',
    'shortName',
    'level',
    'userType',
    'order',
    'panelType',
    'color',
    'style',
    'isNumberColumnEnabled',
    'colspan',
    'rowspan',
    'colwidth',
    'background'
];
function $e291ba685b2f2282$var$concatAncestorHierarchy(node, ancestoryHierarchy) {
    const { name: name } = node.type;
    // Space concatenator used to reduce analytics payload size
    return ancestoryHierarchy ? `${ancestoryHierarchy} ${name}` : name;
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $e291ba685b2f2282$var$sanitizeMarks = (marks = [])=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const sanitizedMarks = [];
    marks.forEach((mark)=>{
        if (mark.attrs) {
            const attrs = $e291ba685b2f2282$var$sanitizeAttributes(mark.attrs);
            sanitizedMarks.push({
                ...mark,
                attrs: attrs
            });
        } else sanitizedMarks.push({
            ...mark
        });
    });
    return sanitizedMarks;
};
const $e291ba685b2f2282$var$sanitizeAttributes = (attrs = {})=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const sanitizedAttrs = Object.assign({}, attrs);
    Object.keys(attrs).filter((key)=>!$e291ba685b2f2282$var$whitelistedAttributes.includes(key)).forEach((key)=>{
        sanitizedAttrs[key] !== null ? sanitizedAttrs[key] = '' : sanitizedAttrs[key] = 'null';
    });
    return sanitizedAttrs;
};
const $e291ba685b2f2282$var$trackUnsupportedContentTooltipActionFor = (action, dispatchAnalyticsEvent, unsupportedContentType, originalNodeType)=>{
    dispatchAnalyticsEvent({
        action: action,
        actionSubjectId: unsupportedContentType,
        actionSubject: (0, $d925B.ACTION_SUBJECT).TOOLTIP,
        eventType: (0, $d925B.EVENT_TYPE).UI,
        attributes: {
            unsupportedNodeType: originalNodeType
        }
    });
};
const $e291ba685b2f2282$export$d343369b8f25914 = (node, schema, dispatchAnalyticsEvent, ancestorHierarchy = '')=>{
    const { type: nodeType, marks: nodeMarks } = node;
    const { unsupportedMark: unsupportedMark, unsupportedNodeAttribute: unsupportedNodeAttribute } = schema.marks;
    const { unsupportedInline: unsupportedInline, unsupportedBlock: unsupportedBlock } = schema.nodes;
    const parentType = ancestorHierarchy.split(' ').pop() || '';
    if (nodeMarks.length) nodeMarks.forEach((mark)=>{
        if (mark.type === unsupportedMark) {
            const { originalValue: originalValue } = mark.attrs || {};
            const { type: type } = originalValue || {};
            const unsupportedNode = {
                type: type || '',
                ancestry: ancestorHierarchy,
                parentType: parentType,
                marks: [],
                attrs: originalValue.attrs || {}
            };
            $e291ba685b2f2282$export$e1051b410945e4d4(dispatchAnalyticsEvent, (0, $d925B.ACTION_SUBJECT_ID).UNSUPPORTED_MARK, unsupportedNode);
        } else if (mark.type === unsupportedNodeAttribute) {
            const { unsupported: unsupported } = mark.attrs || {};
            const unsupportedNodeAttribute = {
                type: nodeType.name || '',
                ancestry: ancestorHierarchy,
                parentType: parentType,
                marks: [],
                attrs: unsupported || {}
            };
            $e291ba685b2f2282$export$e1051b410945e4d4(dispatchAnalyticsEvent, (0, $d925B.ACTION_SUBJECT_ID).UNSUPPORTED_NODE_ATTRIBUTE, unsupportedNodeAttribute);
        }
    });
    if (nodeType === unsupportedInline || nodeType === unsupportedBlock) {
        const { originalValue: originalValue } = node.attrs || {};
        const { marks: marks } = originalValue || [];
        const { attrs: attrs } = originalValue || {};
        const { type: type } = originalValue || {};
        const unsupportedNode = {
            type: type || '',
            ancestry: ancestorHierarchy,
            parentType: parentType,
            marks: marks || [],
            attrs: attrs || {}
        };
        const actionSubjectId = nodeType === unsupportedInline ? (0, $d925B.ACTION_SUBJECT_ID).UNSUPPORTED_INLINE : (0, $d925B.ACTION_SUBJECT_ID).UNSUPPORTED_BLOCK;
        $e291ba685b2f2282$export$e1051b410945e4d4(dispatchAnalyticsEvent, actionSubjectId, unsupportedNode);
    } else // Recursive check for nested content
    node.content.forEach((childNode)=>$e291ba685b2f2282$export$d343369b8f25914(childNode, schema, dispatchAnalyticsEvent, $e291ba685b2f2282$var$concatAncestorHierarchy(node, ancestorHierarchy)));
};
const $e291ba685b2f2282$export$e1051b410945e4d4 = (dispatchAnalyticsEvent, actionSubjectId, unsupportedNode, errorCode)=>{
    const sanitizedAttrs = $e291ba685b2f2282$var$sanitizeAttributes(unsupportedNode.attrs);
    const sanitizedMarks = $e291ba685b2f2282$var$sanitizeMarks(unsupportedNode.marks);
    const sanitizedUnsupportedNode = {
        type: unsupportedNode.type,
        ancestry: unsupportedNode.ancestry,
        parentType: unsupportedNode.parentType,
        attrs: sanitizedAttrs,
        marks: sanitizedMarks
    };
    const payload = {
        action: (0, $d925B.ACTION).UNSUPPORTED_CONTENT_ENCOUNTERED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: actionSubjectId,
        attributes: {
            unsupportedNode: sanitizedUnsupportedNode,
            ...!!errorCode && {
                errorCode: errorCode
            }
        },
        eventType: (0, $d925B.EVENT_TYPE).TRACK
    };
    dispatchAnalyticsEvent(payload);
};
const $e291ba685b2f2282$export$3a34598135e7219b = (dispatchAnalyticsEvent, unsupportedContentType, originalNodeType)=>{
    $e291ba685b2f2282$var$trackUnsupportedContentTooltipActionFor((0, $d925B.ACTION).UNSUPPORTED_TOOLTIP_VIEWED, dispatchAnalyticsEvent, unsupportedContentType, originalNodeType);
};
module.exports["findAndTrackUnsupportedContentNodes"] = $e291ba685b2f2282$export$d343369b8f25914;
module.exports["fireUnsupportedEvent"] = $e291ba685b2f2282$export$e1051b410945e4d4;
module.exports["trackUnsupportedContentTooltipDisplayedFor"] = $e291ba685b2f2282$export$3a34598135e7219b;

});

parcelRegister("5nZsM", function(module, exports) {

var $iKCFj = parcelRequire("iKCFj");


var $2Ed9T = parcelRequire("2Ed9T");

/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */ var $3ebec708b133657c$var$camelCase = $2Ed9T(function(result, word, index) {
    word = word.toLowerCase();
    return result + (index ? $iKCFj(word) : word);
});
module.exports = $3ebec708b133657c$var$camelCase;

});

parcelRegister("iKCFj", function(module, exports) {

var $fPVB6 = parcelRequire("fPVB6");


var $12IaO = parcelRequire("12IaO");

/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */ function $da6a84003d7bc8a2$var$capitalize(string) {
    return $12IaO($fPVB6(string).toLowerCase());
}
module.exports = $da6a84003d7bc8a2$var$capitalize;

});

parcelRegister("52wl7", function(module, exports) {
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function $3ab639a44a152d0d$var$arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
module.exports = $3ab639a44a152d0d$var$arrayReduce;

});

parcelRegister("iOvMY", function(module, exports) {
var $d2258c0d042ca0c6$exports = {};

var $jghHU = parcelRequire("jghHU");

/** Used to map Latin Unicode letters to basic Latin letters. */ var $d2258c0d042ca0c6$var$deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',
    '\xc1': 'A',
    '\xc2': 'A',
    '\xc3': 'A',
    '\xc4': 'A',
    '\xc5': 'A',
    '\xe0': 'a',
    '\xe1': 'a',
    '\xe2': 'a',
    '\xe3': 'a',
    '\xe4': 'a',
    '\xe5': 'a',
    '\xc7': 'C',
    '\xe7': 'c',
    '\xd0': 'D',
    '\xf0': 'd',
    '\xc8': 'E',
    '\xc9': 'E',
    '\xca': 'E',
    '\xcb': 'E',
    '\xe8': 'e',
    '\xe9': 'e',
    '\xea': 'e',
    '\xeb': 'e',
    '\xcc': 'I',
    '\xcd': 'I',
    '\xce': 'I',
    '\xcf': 'I',
    '\xec': 'i',
    '\xed': 'i',
    '\xee': 'i',
    '\xef': 'i',
    '\xd1': 'N',
    '\xf1': 'n',
    '\xd2': 'O',
    '\xd3': 'O',
    '\xd4': 'O',
    '\xd5': 'O',
    '\xd6': 'O',
    '\xd8': 'O',
    '\xf2': 'o',
    '\xf3': 'o',
    '\xf4': 'o',
    '\xf5': 'o',
    '\xf6': 'o',
    '\xf8': 'o',
    '\xd9': 'U',
    '\xda': 'U',
    '\xdb': 'U',
    '\xdc': 'U',
    '\xf9': 'u',
    '\xfa': 'u',
    '\xfb': 'u',
    '\xfc': 'u',
    '\xdd': 'Y',
    '\xfd': 'y',
    '\xff': 'y',
    '\xc6': 'Ae',
    '\xe6': 'ae',
    '\xde': 'Th',
    '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',
    '\u0102': 'A',
    '\u0104': 'A',
    '\u0101': 'a',
    '\u0103': 'a',
    '\u0105': 'a',
    '\u0106': 'C',
    '\u0108': 'C',
    '\u010a': 'C',
    '\u010c': 'C',
    '\u0107': 'c',
    '\u0109': 'c',
    '\u010b': 'c',
    '\u010d': 'c',
    '\u010e': 'D',
    '\u0110': 'D',
    '\u010f': 'd',
    '\u0111': 'd',
    '\u0112': 'E',
    '\u0114': 'E',
    '\u0116': 'E',
    '\u0118': 'E',
    '\u011a': 'E',
    '\u0113': 'e',
    '\u0115': 'e',
    '\u0117': 'e',
    '\u0119': 'e',
    '\u011b': 'e',
    '\u011c': 'G',
    '\u011e': 'G',
    '\u0120': 'G',
    '\u0122': 'G',
    '\u011d': 'g',
    '\u011f': 'g',
    '\u0121': 'g',
    '\u0123': 'g',
    '\u0124': 'H',
    '\u0126': 'H',
    '\u0125': 'h',
    '\u0127': 'h',
    '\u0128': 'I',
    '\u012a': 'I',
    '\u012c': 'I',
    '\u012e': 'I',
    '\u0130': 'I',
    '\u0129': 'i',
    '\u012b': 'i',
    '\u012d': 'i',
    '\u012f': 'i',
    '\u0131': 'i',
    '\u0134': 'J',
    '\u0135': 'j',
    '\u0136': 'K',
    '\u0137': 'k',
    '\u0138': 'k',
    '\u0139': 'L',
    '\u013b': 'L',
    '\u013d': 'L',
    '\u013f': 'L',
    '\u0141': 'L',
    '\u013a': 'l',
    '\u013c': 'l',
    '\u013e': 'l',
    '\u0140': 'l',
    '\u0142': 'l',
    '\u0143': 'N',
    '\u0145': 'N',
    '\u0147': 'N',
    '\u014a': 'N',
    '\u0144': 'n',
    '\u0146': 'n',
    '\u0148': 'n',
    '\u014b': 'n',
    '\u014c': 'O',
    '\u014e': 'O',
    '\u0150': 'O',
    '\u014d': 'o',
    '\u014f': 'o',
    '\u0151': 'o',
    '\u0154': 'R',
    '\u0156': 'R',
    '\u0158': 'R',
    '\u0155': 'r',
    '\u0157': 'r',
    '\u0159': 'r',
    '\u015a': 'S',
    '\u015c': 'S',
    '\u015e': 'S',
    '\u0160': 'S',
    '\u015b': 's',
    '\u015d': 's',
    '\u015f': 's',
    '\u0161': 's',
    '\u0162': 'T',
    '\u0164': 'T',
    '\u0166': 'T',
    '\u0163': 't',
    '\u0165': 't',
    '\u0167': 't',
    '\u0168': 'U',
    '\u016a': 'U',
    '\u016c': 'U',
    '\u016e': 'U',
    '\u0170': 'U',
    '\u0172': 'U',
    '\u0169': 'u',
    '\u016b': 'u',
    '\u016d': 'u',
    '\u016f': 'u',
    '\u0171': 'u',
    '\u0173': 'u',
    '\u0174': 'W',
    '\u0175': 'w',
    '\u0176': 'Y',
    '\u0177': 'y',
    '\u0178': 'Y',
    '\u0179': 'Z',
    '\u017b': 'Z',
    '\u017d': 'Z',
    '\u017a': 'z',
    '\u017c': 'z',
    '\u017e': 'z',
    '\u0132': 'IJ',
    '\u0133': 'ij',
    '\u0152': 'Oe',
    '\u0153': 'oe',
    '\u0149': "'n",
    '\u017f': 's'
};
/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */ var $d2258c0d042ca0c6$var$deburrLetter = $jghHU($d2258c0d042ca0c6$var$deburredLetters);
$d2258c0d042ca0c6$exports = $d2258c0d042ca0c6$var$deburrLetter;



var $fPVB6 = parcelRequire("fPVB6");

/** Used to match Latin Unicode letters (excluding mathematical operators). */ var $db258e1bec5616a7$var$reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
/** Used to compose unicode character classes. */ var $db258e1bec5616a7$var$rsComboMarksRange = '\\u0300-\\u036f', $db258e1bec5616a7$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $db258e1bec5616a7$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $db258e1bec5616a7$var$rsComboRange = $db258e1bec5616a7$var$rsComboMarksRange + $db258e1bec5616a7$var$reComboHalfMarksRange + $db258e1bec5616a7$var$rsComboSymbolsRange;
/** Used to compose unicode capture groups. */ var $db258e1bec5616a7$var$rsCombo = '[' + $db258e1bec5616a7$var$rsComboRange + ']';
/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */ var $db258e1bec5616a7$var$reComboMark = RegExp($db258e1bec5616a7$var$rsCombo, 'g');
/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */ function $db258e1bec5616a7$var$deburr(string) {
    string = $fPVB6(string);
    return string && string.replace($db258e1bec5616a7$var$reLatin, $d2258c0d042ca0c6$exports).replace($db258e1bec5616a7$var$reComboMark, '');
}
module.exports = $db258e1bec5616a7$var$deburr;

});

parcelRegister("jghHU", function(module, exports) {
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */ function $e05d3f3448b226c6$var$basePropertyOf(object) {
    return function(key) {
        return object == null ? undefined : object[key];
    };
}
module.exports = $e05d3f3448b226c6$var$basePropertyOf;

});

parcelRegister("7uLCZ", function(module, exports) {

var $bDniu = parcelRequire("bDniu");


var $4tRVV = parcelRequire("4tRVV");



var $42omo = parcelRequire("42omo");


var $jTxSS = parcelRequire("jTxSS");

var $1f8c1559a495fd3f$export$2e2bcd8739ae039 = {
    disabled: false
};




var $lPGZG = parcelRequire("lPGZG");


var $dlky5 = parcelRequire("dlky5");

var $575047a4d1f8def0$export$bb38bb9a1161268 = 'unmounted';
var $575047a4d1f8def0$export$84cbff306f539230 = 'exited';
var $575047a4d1f8def0$export$df38205c966be359 = 'entering';
var $575047a4d1f8def0$export$78e9e6e3e014d60a = 'entered';
var $575047a4d1f8def0$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $575047a4d1f8def0$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $4tRVV.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $575047a4d1f8def0$export$84cbff306f539230;
                _this.appearStatus = $575047a4d1f8def0$export$df38205c966be359;
            } else initialStatus = $575047a4d1f8def0$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $575047a4d1f8def0$export$bb38bb9a1161268;
        else initialStatus = $575047a4d1f8def0$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $575047a4d1f8def0$export$bb38bb9a1161268) return {
            status: $575047a4d1f8def0$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $575047a4d1f8def0$export$df38205c966be359 && status !== $575047a4d1f8def0$export$78e9e6e3e014d60a) nextStatus = $575047a4d1f8def0$export$df38205c966be359;
            } else if (status === $575047a4d1f8def0$export$df38205c966be359 || status === $575047a4d1f8def0$export$78e9e6e3e014d60a) nextStatus = $575047a4d1f8def0$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $575047a4d1f8def0$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $dlky5.forceReflow)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $575047a4d1f8def0$export$84cbff306f539230) this.setState({
            status: $575047a4d1f8def0$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $1f8c1559a495fd3f$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $575047a4d1f8def0$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $575047a4d1f8def0$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $575047a4d1f8def0$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $1f8c1559a495fd3f$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $575047a4d1f8def0$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $575047a4d1f8def0$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $575047a4d1f8def0$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $575047a4d1f8def0$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $bDniu.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lPGZG.default).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component);
$575047a4d1f8def0$var$Transition.contextType = (0, $lPGZG.default);
$575047a4d1f8def0$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $575047a4d1f8def0$var$noop() {}
$575047a4d1f8def0$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $575047a4d1f8def0$var$noop,
    onEntering: $575047a4d1f8def0$var$noop,
    onEntered: $575047a4d1f8def0$var$noop,
    onExit: $575047a4d1f8def0$var$noop,
    onExiting: $575047a4d1f8def0$var$noop,
    onExited: $575047a4d1f8def0$var$noop
};
$575047a4d1f8def0$var$Transition.UNMOUNTED = $575047a4d1f8def0$export$bb38bb9a1161268;
$575047a4d1f8def0$var$Transition.EXITED = $575047a4d1f8def0$export$84cbff306f539230;
$575047a4d1f8def0$var$Transition.ENTERING = $575047a4d1f8def0$export$df38205c966be359;
$575047a4d1f8def0$var$Transition.ENTERED = $575047a4d1f8def0$export$78e9e6e3e014d60a;
$575047a4d1f8def0$var$Transition.EXITING = $575047a4d1f8def0$export$4aacc83d4d59139f;
var $575047a4d1f8def0$export$2e2bcd8739ae039 = $575047a4d1f8def0$var$Transition;
module.exports["default"] = $575047a4d1f8def0$export$2e2bcd8739ae039;

});

parcelRegister("lPGZG", function(module, exports) {
$parcel$export(module.exports, "default", () => $fe4fb61bd619d593$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

var $fe4fb61bd619d593$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(null);

});

parcelRegister("dlky5", function(module, exports) {
var $9b6d2d196fd1178d$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};
module.exports["forceReflow"] = $9b6d2d196fd1178d$export$7d26bbb1236dafd6;

});

parcelRegister("67O0h", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $1UrkW = parcelRequire("1UrkW");


var $4FxUL = parcelRequire("4FxUL");

var $6mbqi = parcelRequire("6mbqi");


var $4BBKV = parcelRequire("4BBKV");

var $kckFS = parcelRequire("kckFS");

var $iq4lN = parcelRequire("iq4lN");

var $bWRlG = parcelRequire("bWRlG");




var $1DWH0 = parcelRequire("1DWH0");

const $0d5221b11c687d15$export$9ac3d19711324187 = (0, $1DWH0.default)()(class WithCreateAnalyticsEvent extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    render() {
        const { render: render, createAnalyticsEvent: createAnalyticsEvent } = this.props;
        return render(createAnalyticsEvent);
    }
});



var $iu6m9 = parcelRequire("iu6m9");


var $9K4OG = parcelRequire("9K4OG");


var $d7ZU3 = parcelRequire("d7ZU3");


var $2T4ch = parcelRequire("2T4ch");


var $jz9wK = parcelRequire("jz9wK");


var $8pwxt = parcelRequire("8pwxt");


var $lWghV = parcelRequire("lWghV");

var $NPJKR = parcelRequire("NPJKR");


var $dh538 = parcelRequire("dh538");


var $k7eoe = parcelRequire("k7eoe");


var $ffCOo = parcelRequire("ffCOo");


var $d925B = parcelRequire("d925B");


var $9ciHB = parcelRequire("9ciHB");


var $cUcZ5 = parcelRequire("cUcZ5");


var $aUnCJ = parcelRequire("aUnCJ");

var $lf9Ji = parcelRequire("lf9Ji");


var $6uN0A = parcelRequire("6uN0A");


var $59U23 = parcelRequire("59U23");


var $l998X = parcelRequire("l998X");





var $grxv4 = parcelRequire("grxv4");

var $3rvSa = parcelRequire("3rvSa");




const $bd8a5c6aad625abd$export$77218b6ff680865f = ({ children: children, ssr: ssr })=>{
    const [mediaClientConfig, setMediaClientConfig] = (0, $42omo.useState)();
    const mediaProvider = (0, $6mbqi.useProviderLayout)('mediaProvider');
    /**
	 * If a mediaClientConfig is provided then we will force
	 * skip the mediaClient from context
	 */ const shouldSkipContext = Boolean(ssr?.config || mediaProvider);
    const contextMediaClient = (0, $42omo.useContext)((0, $3rvSa.MediaClientContext));
    // MediaClientProvider currently requires a mediaClientConfig
    // And inserting the MediaClientProvider will cause a re-render
    // We should use MediaClientProvider once it no longer requires a config
    const mediaClient = (0, $42omo.useMemo)(()=>mediaClientConfig ? (0, $grxv4.getMediaClient)(mediaClientConfig) : undefined, [
        mediaClientConfig
    ]);
    // Consumers can override the mediaClient for renderer,
    // by not providing both SSR config and mediaProvider,
    // and provide a top level mediaClient context
    // This is useful for testing and creating examples.
    (0, $42omo.useLayoutEffect)(()=>{
        if (ssr?.config) setMediaClientConfig(ssr.config);
        else if (mediaProvider) mediaProvider.then((provider)=>{
            setMediaClientConfig(provider.viewMediaClientConfig);
        });
    }, [
        mediaProvider,
        ssr
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3rvSa.MediaClientContext).Provider, {
        value: shouldSkipContext ? mediaClient : contextMediaClient,
        children: children
    });
};



var $iNqGB = parcelRequire("iNqGB");


var $bBvs5 = parcelRequire("bBvs5");


var $b7FrM = parcelRequire("b7FrM");


var $lspPP = parcelRequire("lspPP");


var $bZfVt = parcelRequire("bZfVt");


var $9KIOh = parcelRequire("9KIOh");


var $d7o2V = parcelRequire("d7o2V");


var $fZRom = parcelRequire("fZRom");




parcelRequire("42omo");


var $fJNzZ = parcelRequire("fJNzZ");





var $1zvWv = parcelRequire("1zvWv");

function $a8c331734550a1c3$export$cfc1361be0de4203({ noOpSSRInlineScript: noOpSSRInlineScript }) {
    /**
   * Should only inline this script while SSR,
   * not needed on the client side.
   */ // For hydrateRoot there is a mismatch on client for this script.
    // So we want to add the script on client side but guard it with check to
    // not execute logic
    if (typeof window !== 'undefined' && !window.navigator.userAgent.includes('jsdom')) {
        if (!noOpSSRInlineScript) return null;
        else window.__RENDERER_BYPASS_BREAKOUT_SSR__ = true;
    }
    const id = Math.floor(Math.random() * 9999990001) + 9999;
    const shouldSkipScript = {
        table: (0, $dh538.fg)('platform-ssr-table-resize')
    };
    return /*#__PURE__*/ (0, $l998X.jsx)("script", {
        "data-breakout-script-id": id,
        // To investigate if we can replace this.
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: $a8c331734550a1c3$export$92859d13f30c883e(id, shouldSkipScript)
        },
        "data-testid": "breakout-ssr-inline-script"
    });
}
function $a8c331734550a1c3$export$92859d13f30c883e(id, shouldSkipScript) {
    const flags = {
        platform_editor_fix_media_in_renderer: (0, $dh538.fg)('platform_editor_fix_media_in_renderer')
    };
    return `(function(window){
if(typeof window !== 'undefined' && window.__RENDERER_BYPASS_BREAKOUT_SSR__) { return; }
${$a8c331734550a1c3$export$47813c4121c8b4b3};
(${$a8c331734550a1c3$var$applyBreakoutAfterSSR.toString()})("${id}", breakoutConsts, ${JSON.stringify(shouldSkipScript)}, ${JSON.stringify(flags)});
})(window);
`;
}
const $a8c331734550a1c3$export$47813c4121c8b4b3 = `
  var breakoutConsts = ${JSON.stringify((0, $fJNzZ.breakoutConsts))};
  breakoutConsts.mapBreakpointToLayoutMaxWidth = ${(0, $fJNzZ.breakoutConsts).mapBreakpointToLayoutMaxWidth.toString()};
  breakoutConsts.getBreakpoint = ${(0, $fJNzZ.breakoutConsts).getBreakpoint.toString()};
  breakoutConsts.calcBreakoutWidth = ${(0, $fJNzZ.breakoutConsts).calcBreakoutWidth.toString()};
  breakoutConsts.calcLineLength = ${(0, $fJNzZ.breakoutConsts).calcLineLength.toString()};
  breakoutConsts.calcWideWidth = ${(0, $fJNzZ.breakoutConsts).calcWideWidth.toString()};
  breakoutConsts.FullPagePadding = ${(0, $1zvWv.FullPagePadding).toString()};
`;
/**
 * WARNING: NO EXTERNAL FUNCTION CALL IN THIS FUNCTION
 * This function will be put to DOM as an inline script.
 * It can not have any external function dependency.
 * All required data must be passed in as serializable parameters.
 */ // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $a8c331734550a1c3$var$applyBreakoutAfterSSR(id, breakoutConsts, shouldSkipBreakoutScript, flags) {
    const MEDIA_NODE_TYPE = 'mediaSingle';
    const WIDE_LAYOUT_MODES = [
        'full-width',
        'wide',
        'custom'
    ];
    function findUp(element, condition) {
        if (!element) return;
        while(element.parentElement){
            if (condition(element)) return element.parentElement;
            element = element.parentElement;
        }
    }
    const renderer = findUp(document.querySelector(`[data-breakout-script-id="${id}"]`), (elem)=>!!elem.parentElement?.classList.contains('ak-renderer-wrapper'));
    if (!renderer) return;
    const observer = new MutationObserver((mutationsList)=>{
        mutationsList.forEach((item)=>{
            if (item.target.nodeType !== Node.ELEMENT_NODE) return;
            // Remove with feature gate 'platform-ssr-table-resize'
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            if (item.target.classList.contains('ak-renderer-document')) item.addedNodes.forEach((maybeNode)=>{
                // maybeNode may contain comments which doesn't have a dataset property
                if (maybeNode.nodeType !== Node.ELEMENT_NODE) return;
                let width;
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const node = maybeNode;
                const mode = node.dataset.mode || node.dataset.layout || '';
                const nodeType = node.dataset.nodeType;
                const widthType = node.dataset.widthType;
                const isMediaSingleWithPixelWidth = nodeType === 'mediaSingle' && widthType === 'pixel';
                if (!mode || !WIDE_LAYOUT_MODES.includes(mode) || // skip apply width styling to mediaSingle node with pixel width to avoid image size changing
                // eslint-disable-next-line @atlaskit/platform/no-preconditioning
                isMediaSingleWithPixelWidth && flags['platform_editor_fix_media_in_renderer']) return;
                // When flag is on we are using CSS to calculate the table width thus don't need logic below to set the width and left.
                if (shouldSkipBreakoutScript.table && node.classList.contains('pm-table-container')) return;
                if (node.classList.contains('fabric-editor-breakout-mark')) return;
                // use breakout script for all other types of nodes
                if (node.classList.contains('pm-table-container') && mode === 'custom') {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    const rendererWidth = renderer.offsetWidth;
                    const effectiveWidth = rendererWidth - breakoutConsts.padding;
                    width = `${Math.min(parseInt(node.style.width), effectiveWidth)}px`;
                } else // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                width = breakoutConsts.calcBreakoutWidth(breakoutConsts)(mode, renderer.offsetWidth);
                if (node.style.width === width) return;
                node.style.width = width;
                // Tables require some special logic, as they are not using common css transform approach,
                // because it breaks with sticky headers. This logic is copied from a table node:
                // https://bitbucket.org/atlassian/atlassian-frontend/src/77938aee0c140d02ff99b98a03849be1236865b4/packages/editor/renderer/src/react/nodes/table.tsx#table.tsx-235:245
                if (node.classList.contains('pm-table-container') && // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                !renderer.classList.contains('is-full-width')) {
                    const lineLength = breakoutConsts.calcLineLength(breakoutConsts)();
                    const left = lineLength / 2 - parseInt(width) / 2;
                    if (left < 0 && parseInt(width) > lineLength) node.style.left = left + 'px';
                    else node.style.left = '';
                }
            });
            else if (/**
       * The mutation observer is only called once per added node.
       * The above condition only deals with direct children of <div class="ak-renderer-document" />
       * When it is initially called on the direct children, not all the sub children have loaded.
       * So nested media elements which are not immediately loaded as sub children are not available in the above conditional.
       * Thus adding this conditional to deal with all media elements directly.
       */ // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            item.target.dataset.nodeType === MEDIA_NODE_TYPE) // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            applyMediaBreakout(item.target);
        });
    });
    const applyMediaBreakout = (card)=>{
        // width was already set by another breakout script
        if (card.style.width) return;
        const tableParent = findUp(card, (elem)=>elem instanceof HTMLTableCellElement);
        // only apply the breakout to media elements not nested inside table
        // table sizing is not based on percentage width
        if (tableParent) return;
        const mode = card.dataset.mode || card.dataset.layout || '';
        const width = card.dataset.width;
        const isPixelBasedResizing = card.dataset.widthType === 'pixel';
        if (WIDE_LAYOUT_MODES.includes(mode)) card.style.width = '100%';
        else if (width && !isPixelBasedResizing) // Pixel based resizing has width set in pixels based on its width attribute
        // Thus, no need to override for non-wide layouts
        card.style.width = `${width}%`;
    };
    observer.observe(renderer, {
        childList: true,
        subtree: true
    });
    /**
   * Using window load event to unsubscribe from mutation observer, as at this stage document is fully rendered.
   * Experiment with DOMContentLoaded showed that some of the blocks were not processed at all.
   * That's why window load is necessary.
   *
   * More info:
   * – https://html.spec.whatwg.org/multipage/parsing.html#the-end
   * – https://developer.mozilla.org/en-US/docs/Web/API/Window/load_event
   * – https://developer.mozilla.org/en-US/docs/Web/API/Document/DOMContentLoaded_event
   */ const disconnect = ()=>{
        observer.disconnect();
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.removeEventListener('load', disconnect);
    };
    // Ignored via go/ees005
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    window.addEventListener('load', disconnect);
}
const $a8c331734550a1c3$export$2a0b3eeee3f2ea40 = (0, $fJNzZ.breakoutConsts).calcLineLength((0, $fJNzZ.breakoutConsts));



var $jTudT = parcelRequire("jTudT");


var $ozLJl = parcelRequire("ozLJl");

function $d3e1cf2918b1cf26$export$3dee5e4542c672d9(element) {
    if ('href' in element && element.href != null) return true;
    if (element.classList.contains((0, $ozLJl.mediaViewerPopupClass))) return true;
    if (element.classList.contains((0, $jTudT.fileCardImageViewSelector))) return true;
    return false;
}



var $1Qaul = parcelRequire("1Qaul");




/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766






const $af8e00728130c250$var$fadeOutStyles = (maxHeight, top, backgroundColor)=>/*#__PURE__*/ (0, $9K4OG.css)({
        position: 'relative',
        overflowY: 'hidden',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxHeight: `${maxHeight}px`,
        '&::after': {
            content: "''",
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            top: `${top}px`,
            bottom: 0,
            left: 0,
            right: 0,
            backgroundImage: `linear-gradient( ${"var(--ds-background-neutral-subtle, rgba(255, 255, 255, 0))"}, ${backgroundColor} )`
        }
    });
const $af8e00728130c250$var$FadeOut = (props)=>{
    const { children: children, backgroundColor: backgroundColor, fadeHeight: fadeHeight, height: height } = props;
    const top = height - fadeHeight;
    const styles = $af8e00728130c250$var$fadeOutStyles(height, top, backgroundColor);
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: styles
    }, children);
};
class $af8e00728130c250$export$79ad592494094f07 extends (0, $42omo.Component) {
    // TODO: DSP-4123 - Quality ticket as elevation.surface will be issue when sits top of modal.
    render() {
        const { height: height = 95, fadeHeight: fadeHeight = 24, backgroundColor: backgroundColor = "var(--ds-surface, white)", children: children } = this.props;
        return /*#__PURE__*/ (0, $9K4OG.jsx)($af8e00728130c250$var$FadeOut, {
            height: height,
            fadeHeight: fadeHeight,
            backgroundColor: backgroundColor
        }, children);
    }
    constructor(props){
        super(props);
    }
}



var $iZq0X = parcelRequire("iZq0X");

/* eslint-disable @atlaskit/ui-styling-standard/no-important-styles */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled







var $hTKp4 = parcelRequire("hTKp4");

// Find editor node dom with localId - similar to confluence useScrollOnUrlChange.ts
const $e1fb555e7bb7a894$var$getLocalIdSelector = (localId, container)=>{
    // Check if the element with data-local-id exists
    let element = container.querySelector(`[data-local-id="${localId}"]`);
    if (element) return element;
    // Special case for decision lists and task lists which already have localId
    element = container.querySelector(`[data-decision-list-local-id="${localId}"]`);
    if (element) return element;
    element = container.querySelector(`[data-task-list-local-id="${localId}"]`);
    if (element) return element;
    // Special case for tables which use data-table-local-id
    element = container.querySelector(`[data-table-local-id="${localId}"]`);
    if (element) return element;
    // Special case for extension, smart cards and media which use lowercase localid
    element = container.querySelector(`[localid="${localId}"]`);
    if (element) return element;
    return null;
};
const $e1fb555e7bb7a894$export$b61745354f522fe = (containerRef, shouldScrollToLocalId)=>{
    (0, $42omo.useEffect)(()=>{
        // Only run in browser environment
        if (typeof window === 'undefined' || !containerRef?.current || !shouldScrollToLocalId) return;
        // Parse URL parameters for block ID
        const urlParams = new URLSearchParams(window.location.search);
        const blockId = urlParams.get('block');
        if (!blockId) return;
        let retryCount = 0;
        // 5 second timeout based on dashboard showing ~4.96s TTI load time
        const maxRetries = 20; // Maximum 20 retries (5 seconds at 250ms intervals)
        const retryInterval = 250; // Check every 250ms
        let intervalId = null;
        const scrollToElement = ()=>{
            if (containerRef?.current) {
                const element = $e1fb555e7bb7a894$var$getLocalIdSelector(blockId, containerRef.current);
                if (element) {
                    element.scrollIntoView({
                        behavior: 'smooth'
                    });
                    return true;
                }
            }
            return false;
        };
        const attemptScroll = ()=>{
            retryCount++;
            // Try to scroll to element
            if (scrollToElement()) {
                if (intervalId) {
                    clearInterval(intervalId);
                    intervalId = null;
                }
                return true;
            }
            // Stop retrying if we've exceeded max retries
            if (retryCount >= maxRetries) {
                if (intervalId) {
                    clearInterval(intervalId);
                    intervalId = null;
                }
                return false;
            }
            return false;
        };
        // Try to scroll immediately
        if (attemptScroll()) return;
        if ((0, $hTKp4.getDocument)()?.readyState === 'complete') // Document is already ready, try a few more times with delays
        // This handles cases where elements are added after document ready
        intervalId = setInterval(()=>{
            attemptScroll();
        }, retryInterval);
        else // Document not ready yet, wait for it and then retry
        intervalId = setInterval(()=>{
            if ((0, $hTKp4.getDocument)()?.readyState === 'complete') attemptScroll();
            else if (retryCount >= maxRetries) // Stop retrying even if document isn't ready
            {
                if (intervalId) {
                    clearInterval(intervalId);
                    intervalId = null;
                }
            } else retryCount++;
        }, retryInterval);
        // Cleanup function
        return ()=>{
            if (intervalId) {
                clearInterval(intervalId);
                intervalId = null;
            }
        };
    }, [
        containerRef,
        shouldScrollToLocalId
    ]);
};



var $6fnsQ = parcelRequire("6fnsQ");








var $dZ8uq = parcelRequire("dZ8uq");


var $jVL42 = parcelRequire("jVL42");


var $aFUXX = parcelRequire("aFUXX");


var $fhm10 = parcelRequire("fhm10");


var $3HdsG = parcelRequire("3HdsG");


var $5MaNT = parcelRequire("5MaNT");

var $7bDsi = parcelRequire("7bDsi");

var $4mSjx = parcelRequire("4mSjx");

var $gnMzP = parcelRequire("gnMzP");

var $cV5SN = parcelRequire("cV5SN");

var $1zav4 = parcelRequire("1zav4");

var $7iisy = parcelRequire("7iisy");


var $76Qef = parcelRequire("76Qef");

var $bOKwh = parcelRequire("bOKwh");


var $frt7o = parcelRequire("frt7o");

var $fp8V7 = parcelRequire("fp8V7");








var $2jkq1 = parcelRequire("2jkq1");


var $1j8OE = parcelRequire("1j8OE");


var $j2w4t = parcelRequire("j2w4t");


var $ilPbq = parcelRequire("ilPbq");





var $1oCLl = parcelRequire("1oCLl");

const $ec7cc60cabf60b92$export$8e2864079bc476bd = (appearance, contentMode)=>{
    if ((0, $1oCLl.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test')) {
        if (contentMode === ((0, $1oCLl.expValEquals)('confluence_content_mode_replace_dense_with_compact', 'cohort', 'test') ? 'compact' : 'dense')) return 0, $aFUXX.akEditorFullPageDenseFontSize;
    }
    return appearance && appearance !== 'comment' ? (0, $aFUXX.akEditorFullPageDefaultFontSize) : 14;
};



var $fhsiz = parcelRequire("fhsiz");

var $98HrB = parcelRequire("98HrB");




function $913a570f210a4bc3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $913a570f210a4bc3$var$wrappedMediaBreakoutPoint = 410;
const $913a570f210a4bc3$var$TELEPOINTER_ID = 'ai-streaming-telepointer';
const $913a570f210a4bc3$var$tableShadowWidth = 32;
const $913a570f210a4bc3$var$LAYOUT_BREAKPOINT_RENDERER = 629;
// originally defined from packages/editor/editor-plugin-table/src/ui/common-styles.ts
// Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
// eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
// TODO: tableRowHeight can be moved into `@atlaskit/editor-common/table`
const $913a570f210a4bc3$var$tableRowHeight = 44;
const $913a570f210a4bc3$var$isBackgroundClipBrowserFixNeeded = ()=>{
    const browser = (0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $d7ZU3.getBrowserInfo)() : (0, $d7ZU3.browser);
    return browser.isGecko || browser.isIE || browser.isMac && browser.isChrome;
};
// styles are copied from ./style.tsx
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage
const $913a570f210a4bc3$var$baseStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: 'var(--ak-renderer-base-font-size)',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '1.5rem',
    color: `var(--ds-text, ${(0, $6fnsQ.N800)})`,
    [`.${(0, $jVL42.RendererCssClassName).DOCUMENT}::after`]: {
        // we add a clearfix after ak-renderer-document in order to
        // contain internal floats (such as media images that are "wrap-left")
        // to just the renderer (and not spill outside of it)
        content: '""',
        visibility: 'hidden',
        display: 'block',
        height: 0,
        clear: 'both'
    },
    [`.${(0, $jVL42.RendererCssClassName).DOCUMENT}`]: {
        // p, h3, and action items
        [`.${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
            height: '22px',
            transform: `translateY(-2px)`
        },
        h1: {
            [`> .mediaInlineView-content-wrap > .${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '36px',
                transform: `translateY(-3px)`
            }
        },
        h2: {
            [`> .mediaInlineView-content-wrap > .${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '31px',
                transform: `translateY(-3px)`
            }
        },
        h3: {
            [`> .mediaInlineView-content-wrap > .${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '25px',
                transform: `translateY(-2px)`
            }
        },
        h4: {
            [`> .mediaInlineView-content-wrap > .${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '23px',
                transform: `translateY(-2px)`
            }
        },
        h5: {
            [`> .mediaInlineView-content-wrap > .${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '20px',
                transform: `translateY(-2px)`
            }
        },
        h6: {
            [`> .mediaInlineView-content-wrap > .${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '18px',
                transform: `translateY(-2px)`
            }
        }
    },
    '& h1, & h2, & h3, & h4, & h5, & h6': {
        [`.${0, $3HdsG.HeadingAnchorWrapperClassName}`]: {
            position: 'absolute',
            marginLeft: "var(--ds-space-075, 6px)",
            button: {
                paddingLeft: 0,
                paddingRight: 0
            },
            /**
       * Adds the visibility of the button when in focus through keyboard navigation.
       */ 'button:focus': {
                opacity: 1,
                transform: 'none !important'
            }
        },
        [`@media (hover: hover) and (pointer: fine)`]: {
            [`.${0, $3HdsG.HeadingAnchorWrapperClassName}`]: {
                '> button': {
                    opacity: 0,
                    transform: `translate(-8px, 0px)`,
                    transition: `opacity 0.2s ease 0s, transform 0.2s ease 0s`
                }
            },
            '&:hover': {
                [`.${0, $3HdsG.HeadingAnchorWrapperClassName} > button`]: {
                    opacity: 1,
                    transform: 'none !important'
                }
            }
        }
    },
    '& h1': {
        [`.${0, $3HdsG.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${28 / 24}em`
        }
    },
    '& h2': {
        [`.${0, $3HdsG.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${1.2}em`
        }
    },
    '& h3': {
        [`.${0, $3HdsG.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${1.25}em`
        }
    },
    '& h4': {
        [`.${0, $3HdsG.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${16 / 14}em`
        }
    },
    '& h5': {
        [`.${0, $3HdsG.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${16 / 12}em`
        }
    },
    '& h6': {
        [`.${0, $3HdsG.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${16 / 11}em`
        }
    },
    [`& span.akActionMark`]: {
        color: `var(--ds-link, ${(0, $6fnsQ.B400)})`,
        textDecoration: 'none',
        cursor: 'pointer',
        '&:hover': {
            color: `var(--ds-link, ${(0, $6fnsQ.B300)})`,
            textDecoration: 'underline'
        },
        '&:active': {
            color: `var(--ds-link-pressed, ${(0, $6fnsQ.B500)})`
        }
    },
    '& span[data-placeholder]': {
        color: `var(--ds-text-subtlest, ${(0, $6fnsQ.N200)})`
    }
});
const $913a570f210a4bc3$var$akEditorBreakpointForSmallDevice = '1266px';
const $913a570f210a4bc3$var$responsiveBreakoutWidth = /*#__PURE__*/ (0, $9K4OG.css)({
    '--ak-editor--breakout-container-without-gutter-width': `calc(100cqw - ${(0, $aFUXX.akEditorGutterPadding)}px * 2)`,
    // Corresponds to the legacyContentStyles from `@atlaskit/editor-core` meant to introduce responsive breakout width.
    '--ak-editor--breakout-wide-layout-width': `${(0, $aFUXX.akEditorCalculatedWideLayoutWidthSmallViewport)}px`,
    [`@media (min-width: ${$913a570f210a4bc3$var$akEditorBreakpointForSmallDevice})`]: {
        '--ak-editor--breakout-wide-layout-width': `${(0, $aFUXX.akEditorCalculatedWideLayoutWidth)}px`
    }
});
const $913a570f210a4bc3$var$responsiveBreakoutWidthFullWidth = /*#__PURE__*/ (0, $9K4OG.css)({
    '--ak-editor--breakout-container-without-gutter-width': '100cqw',
    // Corresponds to the legacyContentStyles from `@atlaskit/editor-core` meant to introduce responsive breakout width.
    '--ak-editor--breakout-wide-layout-width': `${(0, $aFUXX.akEditorCalculatedWideLayoutWidthSmallViewport)}px`,
    [`@media (min-width: ${$913a570f210a4bc3$var$akEditorBreakpointForSmallDevice})`]: {
        '--ak-editor--breakout-wide-layout-width': `${(0, $aFUXX.akEditorCalculatedWideLayoutWidth)}px`
    }
});
const $913a570f210a4bc3$var$responsiveBreakoutWidthWithReducedPadding = /*#__PURE__*/ (0, $9K4OG.css)({
    '--ak-editor--breakout-container-without-gutter-width': `calc(100cqw - var(--ak-renderer--full-page-gutter) * 2)`,
    // Corresponds to the legacyContentStyles from `@atlaskit/editor-core` meant to introduce responsive breakout width.
    '--ak-editor--breakout-wide-layout-width': `${(0, $aFUXX.akEditorCalculatedWideLayoutWidthSmallViewport)}px`,
    [`@media (min-width: ${$913a570f210a4bc3$var$akEditorBreakpointForSmallDevice})`]: {
        '--ak-editor--breakout-wide-layout-width': `${(0, $aFUXX.akEditorCalculatedWideLayoutWidth)}px`
    },
    [`@media (max-width: ${0, $aFUXX.akEditorFullPageNarrowBreakout}px)`]: {
        '--ak-editor--breakout-container-without-gutter-width': `calc(100cqw - var(--ak-renderer--full-page-gutter) * 2)`
    }
});
const $913a570f210a4bc3$var$hideHeadingCopyLinkWrapperStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    '& h1, & h2, & h3, & h4, & h5, & h6': {
        [`.${0, $3HdsG.HeadingAnchorWrapperClassName}`]: {
            '&:focus-within': {
                opacity: 1
            }
        },
        [`@media (hover: hover) and (pointer: fine)`]: {
            [`.${0, $3HdsG.HeadingAnchorWrapperClassName}`]: {
                opacity: 0,
                transition: `opacity 0.2s ease 0s`
            },
            '&:hover': {
                [`.${0, $3HdsG.HeadingAnchorWrapperClassName}`]: {
                    opacity: 1
                }
            }
        }
    }
});
const $913a570f210a4bc3$var$rendererFullPageStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    maxWidth: `${(0, $aFUXX.akEditorDefaultLayoutWidth)}px`,
    margin: '0 auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    padding: `0 ${(0, $1zvWv.FullPagePadding)}px`
});
const $913a570f210a4bc3$var$rendererFullPageStylesWithReducedPadding = /*#__PURE__*/ (0, $9K4OG.css)({
    '--ak-renderer--full-page-gutter': `${(0, $1zvWv.FullPagePadding)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    maxWidth: `${(0, $aFUXX.akEditorDefaultLayoutWidth)}px`,
    margin: '0 auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    padding: `0 var(--ak-renderer--full-page-gutter)`,
    [`@media (max-width: ${0, $aFUXX.akEditorFullPageNarrowBreakout}px)`]: {
        '--ak-renderer--full-page-gutter': `${(0, $aFUXX.akEditorGutterPaddingReduced)}px`
    }
});
const $913a570f210a4bc3$var$rendererFullWidthStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    maxWidth: `${(0, $aFUXX.akEditorFullWidthLayoutWidth)}px`,
    margin: `0 auto`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.fabric-editor-breakout-mark:not([data-has-width="true"]), .ak-renderer-extension': {
        width: '100% !important'
    }
});
const $913a570f210a4bc3$var$rendererFullWidthStylesForTableResizing = {
    name: "b6n1sl",
    styles: ".pm-table-container{width:100% !important;}"
};
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
const $913a570f210a4bc3$var$telepointerStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    [`#${$913a570f210a4bc3$var$TELEPOINTER_ID}`]: {
        display: 'inline-block',
        position: 'relative',
        width: '1.5px',
        height: '25px',
        backgroundColor: "var(--ds-background-brand-bold, #1868DB)",
        marginLeft: "var(--ds-space-025, 2px)",
        '&::after': {
            content: '"AI"',
            position: 'absolute',
            display: 'block',
            top: 0,
            left: 0,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: '10px',
            fontWeight: "var(--ds-font-weight-bold, 700)",
            width: '12.5px',
            height: '13px',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            paddingTop: '1px',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            paddingLeft: '1.5px',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: 'initial',
            borderRadius: `0px ${"var(--ds-radius-xsmall, 2px)"} ${"var(--ds-radius-xsmall, 2px)"} 0px`,
            color: "var(--ds-text-inverse, white)",
            backgroundColor: "var(--ds-background-brand-bold, #1868DB)"
        }
    }
});
const $913a570f210a4bc3$var$rovoTelepointerStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    [`#${$913a570f210a4bc3$var$TELEPOINTER_ID}`]: {
        display: 'inline-block',
        position: 'relative',
        width: '1.5px',
        height: '24px',
        backgroundColor: "var(--ds-background-brand-bold, #1868DB)",
        marginLeft: "var(--ds-space-025, 2px)",
        '&::after': {
            content: '""',
            position: 'absolute',
            display: 'block',
            top: 0,
            left: 0,
            width: '31.5px',
            height: '15.5px',
            borderRadius: `0px ${"var(--ds-space-050, 4px)"} ${"var(--ds-space-050, 4px)"} 0px`,
            background: // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography, @atlaskit/design-system/ensure-design-token-usage
            'linear-gradient(to right, #1868db 0px, #1868db 1.5px, transparent 1.5px) 0 0 / 100% 100% no-repeat, conic-gradient(from 270deg at 50% 50%, #1868db 0deg, #1868db 115deg, #fca700 115deg, #fca700 180deg, #bf63f3 180deg, #bf63f3 310deg, #82b536 310deg, #82b536 359.96deg, #1868db 360deg)'
        },
        '&::before': {
            content: '"Rovo"',
            position: 'absolute',
            fontFamily: "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
            fontWeight: "var(--ds-font-weight-semibold, 600)",
            color: "var(--ds-text-inverse, white)",
            background: "var(--ds-text, #292A2E)",
            top: 1,
            left: 1,
            borderRadius: `0px ${"var(--ds-space-050, 4px)"} ${"var(--ds-space-050, 4px)"} 0px`,
            zIndex: 1,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: '10px',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            padding: '0.5px 2.5px',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: 'initial'
        }
    }
});
const $913a570f210a4bc3$var$whitespaceSharedStyles = {
    name: "1s8ykn2",
    styles: "word-wrap:break-word;white-space:pre-wrap"
};
const $913a570f210a4bc3$var$blockquoteSharedStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& blockquote': {
        boxSizing: 'border-box',
        color: 'inherit',
        width: '100%',
        display: 'inline-block',
        paddingLeft: "var(--ds-space-200, 16px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        borderLeft: `${"var(--ds-border-width-selected, 2px)"} solid ${`var(--ds-border, ${(0, $aFUXX.akEditorBlockquoteBorderColor)})`}`,
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: `${(0, $aFUXX.blockNodesVerticalMargin)} 0 0 0`,
        marginRight: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "[dir='rtl'] &": {
            paddingLeft: 0,
            paddingRight: "var(--ds-space-200, 16px)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:first-child': {
            marginTop: 0
        },
        '&::before': {
            content: "''"
        },
        '&::after': {
            content: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& p': {
            display: 'block'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '& table, & table:last-child': {
            display: 'inline-table'
        },
        // Workaround for overriding the inline-block display on last child of a blockquote set in CSS reset.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> .code-block:last-child, >.mediaSingleView-content-wrap:last-child, >.mediaGroupView-content-wrap:last-child': {
            display: 'block'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '> .extensionView-content-wrap:last-child': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            display: 'block'
        }
    }
});
const $913a570f210a4bc3$var$headingsSharedStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    '& h1': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: `${24 / 14}em`,
        fontStyle: 'inherit',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 28 / 24,
        color: "var(--ds-text, #292A2E)",
        fontWeight: "var(--ds-font-weight-medium, 500)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        letterSpacing: `-0.01em`,
        marginBottom: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.667em'
    },
    '& h2': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: `${20 / 14}em`,
        fontStyle: 'inherit',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 1.2,
        color: "var(--ds-text, #292A2E)",
        fontWeight: "var(--ds-font-weight-medium, 500)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        letterSpacing: `-0.008em`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.8em',
        marginBottom: 0
    },
    '& h3': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: `${16 / 14}em`,
        fontStyle: 'inherit',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 1.25,
        color: "var(--ds-text, #292A2E)",
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        letterSpacing: `-0.006em`,
        marginTop: "var(--ds-space-400, 2em)",
        marginBottom: 0
    },
    '& h4': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: `${1}em`,
        fontStyle: 'inherit',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 16 / 14,
        color: "var(--ds-text, #292A2E)",
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        letterSpacing: `-0.003em`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.357em'
    },
    '& h5': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: `${12 / 14}em`,
        fontStyle: 'inherit',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 16 / 12,
        color: "var(--ds-text, #292A2E)",
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.667em',
        textTransform: 'none'
    },
    '& h6': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: `${11 / 14}em`,
        fontStyle: 'inherit',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 16 / 11,
        color: "var(--ds-text-subtlest, #6B6E76)",
        fontWeight: "var(--ds-font-weight-bold, 700)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.455em',
        textTransform: 'none'
    }
});
const $913a570f210a4bc3$var$headingsSharedStylesWithEditorUGC = /*#__PURE__*/ (0, $9K4OG.css)({
    '& h1': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h1)`,
        marginBottom: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.45833em',
        '& strong': {
            // set all heading bold style to token font.weight.bold, as not matter what typography is used, the editorUGCToken will return the font weight 700
            fontWeight: "var(--ds-font-weight-bold, 700)"
        },
        '&::before': {}
    },
    '& h2': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h2)`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.4em',
        marginBottom: 0,
        '& strong': {
            // set all heading bold style to token font.weight.bold, as not matter what typography is used, the editorUGCToken will return the font weight 700
            fontWeight: "var(--ds-font-weight-bold, 700)"
        }
    },
    '& h3': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h3)`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.31249em',
        marginBottom: 0,
        '& strong': {
            // set all heading bold style to token font.weight.bold, as not matter what typography is used, the editorUGCToken will return the font weight 700
            fontWeight: "var(--ds-font-weight-bold, 700)"
        }
    },
    '& h4': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h4)`,
        marginTop: "var(--ds-space-250, 1.25em)",
        '& strong': {
            // set all heading bold style to token font.weight.bold, as not matter what typography is used, the editorUGCToken will return the font weight 700
            fontWeight: "var(--ds-font-weight-bold, 700)"
        }
    },
    '& h5': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h5)`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.45833em',
        textTransform: 'none',
        '& strong': {
            // set all heading bold style to token font.weight.bold, as not matter what typography is used, the editorUGCToken will return the font weight 700
            fontWeight: "var(--ds-font-weight-bold, 700)"
        }
    },
    '& h6': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h6)`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.59091em',
        textTransform: 'none',
        '& strong': {
            // set all heading bold style to token font.weight.bold, as not matter what typography is used, the editorUGCToken will return the font weight 700
            fontWeight: "var(--ds-font-weight-bold, 700)"
        }
    }
});
const $913a570f210a4bc3$var$headingWithAlignmentStyles = {
    name: "sd2n24",
    styles: ".fabric-editor-block-mark.fabric-editor-alignment:not(:first-child){> h1:first-child{margin-top:1.667em;} > h2:first-child{margin-top:1.8em;}> h3:first-child{margin-top:2em;}> h4:first-child{margin-top:1.357em;}> h5:first-child{margin-top:1.667em;}> h6:first-child{margin-top:1.455em;}}.ProseMirror-gapcursor:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .ProseMirror-widget:nth-child(2) + .fabric-editor-block-mark.fabric-editor-alignment{> :is(h1, h2, h3, h4, h5, h6):first-child{margin-top:0;}}"
};
const $913a570f210a4bc3$var$ruleSharedStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    '& hr': {
        border: 'none',
        backgroundColor: "var(--ds-border, #0B120E24)",
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: `${(0, $aFUXX.akEditorLineHeight)}em 0`,
        height: '2px',
        borderRadius: "var(--ds-radius-full, 9999px)"
    }
});
// When cleaning up `platform_editor_content_mode_button_mvp` simplify the name/ use the other paragraph style name
const $913a570f210a4bc3$var$paragraphSharedStylesWithEditorUGC = /*#__PURE__*/ (0, $9K4OG.css)({
    '& p': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-normal-text)`,
        marginTop: (0, $aFUXX.blockNodesVerticalMargin),
        marginBottom: 0
    }
});
const $913a570f210a4bc3$var$paragraphStylesUGCScaledMargin = /*#__PURE__*/ (0, $9K4OG.css)({
    '& p': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-normal-text)`,
        marginTop: (0, $aFUXX.scaledBlockNodesVerticalMargin),
        marginBottom: 0
    }
});
const $913a570f210a4bc3$var$paragraphSharedStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    '& p': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '1em',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: (0, $aFUXX.akEditorLineHeight),
        fontWeight: "var(--ds-font-weight-regular, 400)",
        marginTop: (0, $aFUXX.blockNodesVerticalMargin),
        marginBottom: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        letterSpacing: '-0.005em'
    }
});
// When cleaning up `platform_editor_content_mode_button_mvp` simplify the name/ use the other paragraph style name
const $913a570f210a4bc3$var$paragraphSharedStyleScaledMargin = /*#__PURE__*/ (0, $9K4OG.css)({
    '& p': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '1em',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: (0, $aFUXX.akEditorLineHeight),
        fontWeight: "var(--ds-font-weight-regular, 400)",
        marginTop: (0, $aFUXX.scaledBlockNodesVerticalMargin),
        marginBottom: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        letterSpacing: '-0.005em'
    }
});
const $913a570f210a4bc3$var$listsSharedStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    /* =============== INDENTATION SPACING ========= */ 'ul, ol': {
        boxSizing: 'border-box',
        paddingLeft: `var(--ed--list--item-counter--padding, ${(0, $4mSjx.listItemCounterPadding)}px)`
    },
    [`${0, $bOKwh.orderedListSelector}, ${0, $76Qef.bulletListSelector}`]: {
        /*
     Ensures list item content adheres to the list's margin instead
     of filling the entire block row. This is important to allow
     clicking interactive elements which are floated next to a list.
      For some history and context on this block, see PRs related to tickets.:
     @see ED-6551 - original issue.
     @see ED-7015 - follow up issue.
     @see ED-7447 - flow-root change.
      used to have display: 'table' in tag template style but not supported in object styles
     removed display: 'table' as 'flow-root' is supported in latest browsers
      @see https://css-tricks.com/display-flow-root/
    */ display: 'flow-root'
    },
    /* =============== INDENTATION AESTHETICS ========= */ /**
  	We support nested lists up to six levels deep.
  **/ /* LEGACY LISTS */ 'ul, ul ul ul ul': {
        listStyleType: 'disc'
    },
    'ul ul, ul ul ul ul ul': {
        listStyleType: 'circle'
    },
    'ul ul ul, ul ul ul ul ul ul': {
        listStyleType: 'square'
    },
    'ol, ol ol ol ol': {
        listStyleType: 'decimal'
    },
    'ol ol, ol ol ol ol ol': {
        listStyleType: 'lower-alpha'
    },
    'ol ol ol, ol ol ol ol ol ol': {
        listStyleType: 'lower-roman'
    },
    /* PREDICTABLE LISTS */ 'ol[data-indent-level="1"], ol[data-indent-level="4"]': {
        listStyleType: 'decimal'
    },
    'ol[data-indent-level="2"], ol[data-indent-level="5"]': {
        listStyleType: 'lower-alpha'
    },
    'ol[data-indent-level="3"], ol[data-indent-level="6"]': {
        listStyleType: 'lower-roman'
    },
    'ul[data-indent-level="1"], ul[data-indent-level="4"]': {
        listStyleType: 'disc'
    },
    'ul[data-indent-level="2"], ul[data-indent-level="5"]': {
        listStyleType: 'circle'
    },
    'ul[data-indent-level="3"], ul[data-indent-level="6"]': {
        listStyleType: 'square'
    }
});
/*
	Firefox does not handle empty block element inside li tag.
	If there is not block element inside li tag,
	then firefox sets inherited height to li
	However, if there is any block element and if it's empty
	(or has empty inline element) then
	firefox sets li tag height to zero.
	More details at
	https://product-fabric.atlassian.net/wiki/spaces/~455502413/pages/3149365890/ED-14110+Investigation
*/ const $913a570f210a4bc3$var$listsSharedStylesForGekko = {
    name: "jlg15n",
    styles: "ul, ol{li p:empty, li p > span:empty{display:inline-block;}}"
};
const $913a570f210a4bc3$var$indentationSharedStyles = {
    name: "1bgz9nd",
    styles: ".fabric-editor-indentation-mark{&[data-level='1']{margin-left:30px;}&[data-level='2']{margin-left:60px;}&[data-level='3']{margin-left:90px;}&[data-level='4']{margin-left:120px;}&[data-level='5']{margin-left:150px;}&[data-level='6']{margin-left:180px;}}"
};
const $913a570f210a4bc3$var$indentationSharedStylesWithMarginFix = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.fabric-editor-indentation-mark': {
        // Prevent marginTop of p:first-child overrode by batch.css
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        'p:first-child': {
            marginTop: (0, $aFUXX.blockNodesVerticalMargin)
        }
    }
});
const $913a570f210a4bc3$var$blockMarksSharedStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    /**
   * We need to remove margin-top from first item
   * inside doc, tableCell, tableHeader, blockquote, etc.
   */ [`*:not(.fabric-editor-block-mark) >,
  	*:not(.fabric-editor-block-mark) >
    div.fabric-editor-block-mark:first-of-type
	:not(.fabric-editor-indentation-mark)
	:not(.fabric-editor-alignment),
  	.fabric-editor-alignment:first-of-type:first-child,
  	.ProseMirror .fabric-editor-indentation-mark:first-of-type:first-child`]: {
        'p, h1, h2, h3, h4, h5, h6, .heading-wrapper': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            ':first-child:not(style), style:first-child + *': {
                marginTop: 0
            }
        }
    }
});
const $913a570f210a4bc3$var$codeMarkSharedStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.code': {
        '--ds--code--bg-color': "var(--ds-background-neutral, #0515240F)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '0.875em',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
        fontWeight: "var(--ds-font-weight-regular, 400)",
        backgroundColor: `var(--ds--code--bg-color,${`var(--ds-background-neutral, ${(0, $6fnsQ.N20)})`})`,
        color: `var(--ds-text, ${(0, $6fnsQ.N800)})`,
        borderStyle: 'none',
        borderRadius: "var(--ds-radius-small, 3px)",
        display: 'inline',
        padding: '2px 0.5ch',
        boxDecorationBreak: 'clone',
        overflow: 'auto',
        overflowWrap: 'break-word',
        whiteSpace: 'pre-wrap'
    }
});
const $913a570f210a4bc3$var$extensionStyle = {
    name: "188isfx",
    styles: ".ak-renderer-extension :not(.ak-renderer-extension .ak-renderer-document *, .aui-lozenge, .status-lozenge-span *), .ak-renderer-extension .ak-renderer-document .ak-renderer-extension:not(:has(.ak-renderer-document)) :not(.aui-lozenge, .status-lozenge-span *){font-size:var(--ak-renderer-base-font-size);}"
};
const $913a570f210a4bc3$var$shadowSharedStyle = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $frt7o.shadowClassNames).RIGHT_SHADOW}::before, .${(0, $frt7o.shadowClassNames).RIGHT_SHADOW}::after, .${(0, $frt7o.shadowClassNames).LEFT_SHADOW}::before, .${(0, $frt7o.shadowClassNames).LEFT_SHADOW}::after`]: {
        display: 'none',
        position: 'absolute',
        pointerEvents: 'none',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: (0, $aFUXX.akEditorShadowZIndex),
        width: '8px',
        content: "''",
        height: 'calc(100%)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $frt7o.shadowClassNames).RIGHT_SHADOW}, .${(0, $frt7o.shadowClassNames).LEFT_SHADOW}`]: {
        position: 'relative'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $frt7o.shadowClassNames).LEFT_SHADOW}::before`]: {
        background: `linear-gradient( to left, transparent 0, ${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 140% ), linear-gradient( to right, ${"var(--ds-shadow-overflow-perimeter, transparent)"} 0px, transparent 1px )`,
        top: '0px',
        left: 0,
        display: 'block'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $frt7o.shadowClassNames).RIGHT_SHADOW}::after`]: {
        background: `linear-gradient( to right, transparent 0, ${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 140% ), linear-gradient( to left, ${"var(--ds-shadow-overflow-perimeter, transparent)"} 0px, transparent 1px )`,
        right: '0px',
        top: '0px',
        display: 'block'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $fp8V7.shadowObserverClassNames).SENTINEL_LEFT}`]: {
        height: '100%',
        width: '0px',
        minWidth: '0px'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $fp8V7.shadowObserverClassNames).SENTINEL_RIGHT}`]: {
        height: '100%',
        width: '0px',
        minWidth: '0px'
    }
});
const $913a570f210a4bc3$var$dateSharedStyle = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${(0, $7bDsi.DateSharedCssClassName).DATE_WRAPPER} span`]: {
        whiteSpace: 'unset'
    }
});
const $913a570f210a4bc3$var$textColorStyles = {
    name: "1nlqh0j",
    styles: ".fabric-text-color-mark{color:var(--custom-palette-color, inherit);}a .fabric-text-color-mark{color:unset;}"
};
const $913a570f210a4bc3$var$backgroundColorStyles = {
    name: "yf96ao",
    styles: ".fabric-background-color-mark{background-color:var(--custom-palette-color, inherit);border-radius:var(--ds-radius-xsmall, 2px);padding-top:1px;padding-bottom:2px;box-decoration-break:clone;}a .fabric-background-color-mark{background-color:unset;}.fabric-background-color-mark .ak-editor-annotation{background-color:unset;}"
};
const $913a570f210a4bc3$export$a365082c2a191514 = {
    name: "nf8qu5",
    styles: ".fabric-background-color-mark:has(.background-color-padding-left){padding-left:var(--ds-space-025, 2px);margin-left:var(--ds-space-negative-025, -2px);}.fabric-background-color-mark:has(.background-color-padding-right){padding-right:var(--ds-space-025, 2px);margin-right:var(--ds-space-negative-025, -2px);}"
};
const $913a570f210a4bc3$var$tasksAndDecisionsStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    '.ProseMirror': {
        [`.taskItemView-content-wrap,
		.${(0, $7iisy.TaskDecisionSharedCssClassName).DECISION_CONTAINER}`]: {
            position: 'relative',
            minWidth: `${(0, $aFUXX.akEditorTableCellMinWidth)}px`
        },
        [`.${(0, $7iisy.TaskDecisionSharedCssClassName).DECISION_CONTAINER}`]: {
            marginTop: 0
        },
        [`.${(0, $7iisy.TaskDecisionSharedCssClassName).TASK_CONTAINER}`]: {
            'span[contenteditable="false"]': {
                height: `${(0, $aFUXX.akEditorLineHeight)}em`
            }
        },
        [`.${(0, $7iisy.TaskDecisionSharedCssClassName).TASK_ITEM}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: (0, $aFUXX.akEditorLineHeight)
        }
    },
    'div[data-task-local-id]': {
        'span[contenteditable="false"]': {
            height: `${(0, $aFUXX.akEditorLineHeight)}em`
        },
        'span[contenteditable="false"] + div': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${(0, $aFUXX.akEditorLineHeight)}em`
        }
    },
    'div[data-task-list-local-id]': {
        margin: `${"var(--ds-space-150, 12px)"} 0 0 0`,
        // If task item is not first in the list then set margin top to 4px.
        'div + div': {
            marginTop: "var(--ds-space-050, 4px)"
        }
    },
    // If task list is not first in the document then set margin top to 4px.
    'div[data-task-list-local-id] div[data-task-list-local-id]': {
        marginTop: "var(--ds-space-050, 4px)",
        marginLeft: "var(--ds-space-300, 24px)"
    },
    /* When action list is inside panel */ '.ak-editor-panel__content': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> div[data-task-list-local-id]:first-child': {
            margin: '0 0 0 0 !important'
        }
    }
});
const $913a570f210a4bc3$var$smartCardStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    [`.${(0, $cV5SN.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER}`]: {
        display: 'block',
        margin: `${(0, $aFUXX.blockNodesVerticalMargin)} 0 0`,
        maxWidth: `${760}px`
    }
});
const $913a570f210a4bc3$var$smartCardStylesAvatarFix = /*#__PURE__*/ (0, $9K4OG.css)({
    [`.${(0, $cV5SN.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER}:not(.${(0, $cV5SN.SmartCardSharedCssClassName).DATASOURCE_CONTAINER})`]: {
        /* EDM-11991: Fix list plugin adding padding to ADS AvatarGroup start */ 'ul, ol': {
            paddingLeft: 'inherit'
        }
    }
});
const $913a570f210a4bc3$var$smartCardStylesAvatarMarginFix = /*#__PURE__*/ (0, $9K4OG.css)({
    [`.${(0, $cV5SN.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER}:not(.${(0, $cV5SN.SmartCardSharedCssClassName).DATASOURCE_CONTAINER})`]: {
        'ul, ol': {
            marginRight: 'inherit'
        }
    }
});
const $913a570f210a4bc3$var$smartCardStylesAvatarListZeroMarginTop = /*#__PURE__*/ (0, $9K4OG.css)({
    [`.${(0, $cV5SN.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER}:not(.${(0, $cV5SN.SmartCardSharedCssClassName).DATASOURCE_CONTAINER})`]: {
        'ul, ol': {
            marginTop: 0
        }
    }
});
// In Renderer in Jira there is no SmartCardSharedCssClassName.INLINE_CARD_CONTAINER, so using data-inline-cart="true"
const $913a570f210a4bc3$var$headerSmartCardStyles = {
    name: "qwtpmh",
    styles: "[data-inline-card=\"true\"]{[data-inlinecard-button-overlay=\"icon-wrapper-line-height\"] span{line-height:0;}}"
};
const $913a570f210a4bc3$var$baseOtherStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    '& .UnknownBlock': {
        fontFamily: "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: `${0.875}rem`,
        fontWeight: "var(--ds-font-weight-regular, 400)",
        whiteSpace: 'pre-wrap',
        wordWrap: 'break-word'
    },
    '& span.date-node': {
        background: `var(--ds-background-neutral, ${(0, $6fnsQ.N30A)})`,
        borderRadius: "var(--ds-radius-small, 3px)",
        color: `var(--ds-text, ${(0, $6fnsQ.N800)})`,
        padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-050, 4px)"}`,
        margin: `0 1px`,
        transition: `background 0.3s`
    },
    '& span.date-node-highlighted': {
        background: `var(--ds-background-danger, ${(0, $6fnsQ.R50)})`,
        color: `var(--ds-text-danger, ${(0, $6fnsQ.R500)})`
    },
    '& .renderer-image': {
        maxWidth: '100%',
        display: 'block',
        margin: `${"var(--ds-space-300, 24px)"} 0`
    },
    [`.${0, $gnMzP.richMediaClassName}.rich-media-wrapped + .${0, $gnMzP.richMediaClassName}:not(.rich-media-wrapped)`]: {
        clear: 'both'
    },
    [`& .code-block,
	& blockquote,
	& hr,
	& > div > div:not(.rich-media-wrapped),
	.${0, $gnMzP.richMediaClassName}.rich-media-wrapped + .rich-media-wrapped + *:not(.rich-media-wrapped),
	.${0, $gnMzP.richMediaClassName}.rich-media-wrapped + div:not(.rich-media-wrapped),
	.${0, $gnMzP.richMediaClassName}.image-align-start,
		.${0, $gnMzP.richMediaClassName}.image-center,
		.${0, $gnMzP.richMediaClassName}.image-align-end`]: {
        clear: 'both'
    },
    '& .rich-media-wrapped': {
        '& + h1, & + h2, & + h3, & + h4, & + h5, & + h6': {
            marginTop: "var(--ds-space-100, 8px)"
        }
    },
    // originally copied the block after mediaSharedStyle
    'div[class^="image-wrap-"] + div[class^="image-wrap-"]': {
        marginLeft: 0,
        marginRight: 0
    },
    /* Breakout for tables and extensions */ [`.${(0, $jVL42.RendererCssClassName).DOCUMENT} >`]: {
        [`*:not([data-mark-type='fragment']) .${(0, $1zav4.TableSharedCssClassName).TABLE_CONTAINER}`]: {
            // Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
            // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
            // TODO - improve inline style logic on table container so important styles aren't required here
            width: '100% !important',
            left: '0 !important'
        },
        [`[data-mark-type='fragment'] * .${(0, $1zav4.TableSharedCssClassName).TABLE_CONTAINER}`]: {
            // Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
            // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
            // TODO - improve inline style logic on table container so important styles aren't required here
            width: '100% !important',
            left: '0 !important'
        },
        [`* .${(0, $jVL42.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`]: {
            overflowX: 'auto'
        },
        [`& .${(0, $jVL42.RendererCssClassName).EXTENSION}:first-child`]: {
            marginTop: 0
        }
    },
    [`.${(0, $jVL42.RendererCssClassName).DOCUMENT}`]: {
        [`.${(0, $jVL42.RendererCssClassName).EXTENSION}`]: {
            marginTop: `${(0, $aFUXX.blockNodesVerticalMargin)}`
        },
        [`.${(0, $jVL42.RendererCssClassName).EXTENSION_CENTER_ALIGN}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginLeft: '50%',
            transform: 'translateX(-50%)'
        },
        [`.${(0, $1zav4.TableSharedCssClassName).TABLE_NODE_WRAPPER}`]: {
            overflowX: 'auto'
        },
        [`.${(0, $fp8V7.shadowObserverClassNames).SHADOW_CONTAINER} .${(0, $1zav4.TableSharedCssClassName).TABLE_NODE_WRAPPER}`]: {
            display: 'flex'
        }
    }
});
const $913a570f210a4bc3$var$alignedHeadingAnchorStyle = /*#__PURE__*/ (0, $9K4OG.css)({
    // Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO Delete this comment after verifying space token -> previous value `margin: 6px`
    '.fabric-editor-block-mark[data-align] >': {
        'h1, h2, h3, h4, h5, h6': {
            position: 'relative'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.fabric-editor-block-mark:not([data-align="center"])[data-align]': {
        [`.${0, $3HdsG.HeadingAnchorWrapperClassName}`]: {
            margin: `0 ${"var(--ds-space-075, 6px)"} 0 0`,
            // If the anchor is right aligned then the left side of the heading
            // is aligned with the left side of the anchor.
            // In order to align as expected we transform it the width of the element (plus our expected 6px)
            // to the left
            transform: `translateX(calc(-100% - ${"var(--ds-space-075, 6px)"}))`
        },
        '@media (hover: hover) and (pointer: fine)': {
            [`.${0, $3HdsG.HeadingAnchorWrapperClassName} > button`]: {
                transform: `translate(8px, 0px)`
            }
        }
    }
});
const $913a570f210a4bc3$var$firstWrappedMediaStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    // Remove gap between first wrapped mediaSingle and its fellow wrapped mediaSingle
    [`.${0, $gnMzP.richMediaClassName}[class*="image-wrap-"]:has(+ .${0, $gnMzP.richMediaClassName}[class*="image-wrap-"])`]: {
        marginRight: 0,
        marginLeft: 0
    }
});
// Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
// eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
// TODO: emotion refactor - there's a mediaSingleSharedNewStyle, but not originally used in the renderer.
const $913a570f210a4bc3$var$mediaSingleSharedStyle = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`li .${0, $gnMzP.richMediaClassName}`]: {
        margin: 0
    },
    // Hack for chrome to fix media single position inside a list when media is the first child
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-chrome li > .mediaSingleView-content-wrap::before': {
        content: "''",
        display: 'block',
        height: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-firefox': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.mediaSingleView-content-wrap': {
            userSelect: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.captionView-content-wrap': {
            userSelect: 'text'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    ".mediaSingleView-content-wrap[layout='center']": {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`table .${0, $gnMzP.richMediaClassName}`]: {
        marginTop: "var(--ds-space-150, 12px)",
        marginBottom: "var(--ds-space-150, 12px)",
        clear: 'both',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&.image-wrap-left[data-layout], &.image-wrap-right[data-layout]': {
            clear: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '&:first-child': {
                marginTop: "var(--ds-space-150, 12px)"
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${0, $gnMzP.richMediaClassName}.image-wrap-right + .${0, $gnMzP.richMediaClassName}.image-wrap-left`]: {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${0, $gnMzP.richMediaClassName}.image-wrap-left + .${0, $gnMzP.richMediaClassName}.image-wrap-right, .${0, $gnMzP.richMediaClassName}.image-wrap-right + .${0, $gnMzP.richMediaClassName}.image-wrap-left, .${0, $gnMzP.richMediaClassName}.image-wrap-left + .${0, $gnMzP.richMediaClassName}.image-wrap-left, .${0, $gnMzP.richMediaClassName}.image-wrap-right + .${0, $gnMzP.richMediaClassName}.image-wrap-right`]: {
        marginRight: 0,
        marginLeft: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`@media all and (max-width: ${$913a570f210a4bc3$var$wrappedMediaBreakoutPoint}px)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "div.mediaSingleView-content-wrap[layout='wrap-left'], div.mediaSingleView-content-wrap[data-layout='wrap-left'], div.mediaSingleView-content-wrap[layout='wrap-right'], div.mediaSingleView-content-wrap[data-layout='wrap-right']": {
            float: 'none',
            overflow: 'auto',
            margin: `${"var(--ds-space-150, 12px)"} 0`
        }
    }
});
// was shared between editor-core and renderer
const $913a570f210a4bc3$var$tableSharedStyle = /*#__PURE__*/ (0, $9K4OG.css)({
    // originally from packages/editor/editor-common/src/styles/shared/tableCell.ts
    // Hardcoding the background color for the table cells to avoid the use of inline styles
    'td[colorname="white" i], th[colorname="white" i]': {
        backgroundColor: `${"var(--ds-surface, #FFFFFF)"} !important`
    },
    'td[colorname="light blue" i], th[colorname="light blue" i]': {
        backgroundColor: `${"var(--ds-background-accent-blue-subtlest, #DEEBFF)"} !important`
    },
    'td[colorname="light teal" i], th[colorname="light teal" i]': {
        backgroundColor: `${"var(--ds-background-accent-teal-subtlest, #E6FCFF)"} !important`
    },
    'td[colorname="light green" i], th[colorname="light green" i]': {
        backgroundColor: `${"var(--ds-background-accent-green-subtlest, #E3FCEF)"} !important`
    },
    'td[colorname="light yellow" i], th[colorname="light yellow" i]': {
        backgroundColor: `${"var(--ds-background-accent-yellow-subtlest, #FFFAE6)"} !important`
    },
    'td[colorname="light red" i], th[colorname="light red" i]': {
        backgroundColor: `${"var(--ds-background-accent-red-subtlest, #FFEBE6)"} !important`
    },
    'td[colorname="light purple" i], th[colorname="light purple" i]': {
        backgroundColor: `${"var(--ds-background-accent-purple-subtlest, #EAE6FF)"} !important`
    },
    'td[colorname="light gray" i], th[colorname="light gray" i]': {
        backgroundColor: `${"var(--ds-background-accent-gray-subtlest, #F4F5F7)"} !important`
    },
    'td[colorname="blue" i], th[colorname="blue" i]': {
        backgroundColor: `${"var(--ds-background-accent-blue-subtler, #B3D4FF)"} !important`
    },
    'td[colorname="teal" i], th[colorname="teal" i]': {
        backgroundColor: `${"var(--ds-background-accent-teal-subtler, #B3F5FF)"} !important`
    },
    'td[colorname="green" i], th[colorname="green" i]': {
        backgroundColor: `${"var(--ds-background-accent-green-subtler, #ABF5D1)"} !important`
    },
    'td[colorname="yellow" i], th[colorname="yellow" i]': {
        backgroundColor: `${"var(--ds-background-accent-yellow-subtler, #FFF0B3)"} !important`
    },
    'td[colorname="red" i], th[colorname="red" i]': {
        backgroundColor: `${"var(--ds-background-accent-red-subtler, #FFBDAD)"} !important`
    },
    'td[colorname="purple" i], th[colorname="purple" i]': {
        backgroundColor: `${"var(--ds-background-accent-purple-subtler, #C0B6F2)"} !important`
    },
    'td[colorname="gray" i], th[colorname="gray" i]': {
        backgroundColor: `${"var(--ds-background-accent-gray-subtle, #B3BAC5)"} !important`
    },
    'td[colorname="dark blue" i], th[colorname="dark blue" i]': {
        backgroundColor: `${"var(--ds-background-accent-blue-subtle, #4C9AFF)"} !important`
    },
    'td[colorname="dark teal" i], th[colorname="dark teal" i]': {
        backgroundColor: `${"var(--ds-background-accent-teal-subtle, #79E2F2)"} !important`
    },
    'td[colorname="dark green" i], th[colorname="dark green" i]': {
        backgroundColor: `${"var(--ds-background-accent-green-subtle, #57D9A3)"} !important`
    },
    'td[colorname="dark yellow" i], th[colorname="dark yellow" i]': {
        backgroundColor: `${"var(--ds-background-accent-orange-subtle, #FFC400)"} !important`
    },
    'td[colorname="dark red" i], th[colorname="dark red" i]': {
        backgroundColor: `${"var(--ds-background-accent-red-subtle, #FF8F73)"} !important`
    },
    'td[colorname="dark purple" i], th[colorname="dark purple" i]': {
        backgroundColor: `${"var(--ds-background-accent-purple-subtle, #998DD9)"} !important`
    },
    [`.${(0, $1zav4.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        position: 'relative',
        margin: `0 auto ${"var(--ds-space-200, 16px)"}`,
        boxSizing: 'border-box',
        /**
     * Fix block top alignment inside table cells.
     */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '.decisionItemView-content-wrap:first-of-type > div': {
            marginTop: 0
        }
    },
    [`.${(0, $1zav4.TableSharedCssClassName).TABLE_CONTAINER}[data-number-column='true']`]: {
        paddingLeft: `${(0, $aFUXX.akEditorTableNumberColumnWidth) - 1}px`,
        clear: 'both'
    },
    [`.${(0, $1zav4.TableSharedCssClassName).TABLE_RESIZER_CONTAINER}`]: {
        willChange: 'width, margin-left'
    },
    [`.${(0, $1zav4.TableSharedCssClassName).TABLE_RESIZER_CONTAINER} table`]: {
        willChange: 'width'
    },
    [`.${(0, $1zav4.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table`]: {
        margin: `${"var(--ds-space-300, 24px)"} 0 0 0`
    },
    [`.${(0, $1zav4.TableSharedCssClassName).TABLE_CONTAINER} > table,
	.${(0, $1zav4.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        margin: `${"var(--ds-space-300, 24px)"} ${"var(--ds-space-100, 8px)"} 0 0`
    },
    /* avoid applying styles to nested tables (possible via extensions) */ [`.${(0, $1zav4.TableSharedCssClassName).TABLE_CONTAINER} > table,
	.${(0, $1zav4.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
	.${(0, $1zav4.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        borderCollapse: 'collapse',
        border: `${(0, $1zav4.tableCellBorderWidth)}px solid ${`var(--ds-background-accent-gray-subtler, ${(0, $aFUXX.akEditorTableBorder)})`}`,
        tableLayout: 'fixed',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '1em',
        width: '100%',
        '&[data-autosize="true"]': {
            tableLayout: 'auto'
        },
        '*': {
            boxSizing: 'border-box'
        },
        hr: {
            boxSizing: 'content-box'
        },
        tbody: {
            borderBottom: 'none'
        },
        'th td': {
            backgroundColor: "var(--ds-background-neutral-subtle, white)"
        },
        '> tbody > tr > td': {
            backgroundColor: "var(--ds-surface, #FFFFFF)"
        },
        th: {
            backgroundColor: `var(--ds-background-accent-gray-subtlest, ${(0, $aFUXX.akEditorTableToolbar)})`,
            textAlign: 'left',
            /* only apply this styling to codeblocks in default background headercells */ /* TODO this needs to be overhauled as it relies on unsafe selectors */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not([style]):not(.danger)': {
                [`.${(0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER}:not(.danger)`]: {
                    backgroundColor: "var(--ds-surface-raised, rgb(235, 237, 240))",
                    [`&:not(.${0, $aFUXX.akEditorSelectedNodeClassName})`]: {
                        boxShadow: `0px 0px 0px 1px ${"var(--ds-border, transparent)"}`
                    },
                    [`.${(0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER}`]: {
                        // originally copied from packages/editor/editor-shared-styles/src/overflow-shadow/overflow-shadow.ts
                        backgroundImage: `linear-gradient(
							to right,
							${"var(--ds-background-neutral, #0515240F)"} ${"var(--ds-space-300, 24px)"},
							transparent ${"var(--ds-space-300, 24px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-300, 24px)"},
							transparent ${"var(--ds-space-300, 24px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-background-neutral, #0515240F)"} ${"var(--ds-space-100, 8px)"},
							transparent ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-100, 8px)"},
							transparent ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  )`,
                        backgroundColor: "var(--ds-background-neutral, rgb(235, 237, 240))"
                    },
                    [`.${(0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER}`]: {
                        backgroundColor: "var(--ds-background-neutral, rgb(226, 229, 233))"
                    },
                    /* this is only relevant to the element taken care of by renderer */ '> [data-ds--code--code-block]': {
                        // originally copied from packages/editor/editor-shared-styles/src/overflow-shadow/overflow-shadow.ts
                        backgroundImage: `linear-gradient(
							to right,
							${"var(--ds-background-neutral, #0515240F)"} ${"var(--ds-space-300, 24px)"},
							transparent ${"var(--ds-space-300, 24px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-300, 24px)"},
							transparent ${"var(--ds-space-300, 24px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-background-neutral, #0515240F)"} ${"var(--ds-space-100, 8px)"},
							transparent ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-100, 8px)"},
							transparent ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  )`,
                        backgroundColor: `${"var(--ds-background-neutral, rgb(235, 237, 240))"}!important`,
                        // selector lives inside @atlaskit/code
                        '--ds--code--line-number-bg-color': "var(--ds-background-neutral, rgb(226, 229, 233))"
                    }
                }
            }
        }
    }
});
const $913a570f210a4bc3$var$tableRendererHeaderStylesForTableCellOnly = /*#__PURE__*/ (0, $9K4OG.css)({
    [`.${(0, $1zav4.TableSharedCssClassName).TABLE_CONTAINER} > table,
		.${(0, $1zav4.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
		.${(0, $1zav4.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        '> tbody > tr > th, > tbody > tr > td': {
            minWidth: `${(0, $1zav4.tableCellMinWidth)}px`,
            fontWeight: "var(--ds-font-weight-regular, 400)",
            verticalAlign: 'top',
            border: `${"var(--ds-border-width, 1px)"} solid ${`var(--ds-background-accent-gray-subtler, ${(0, $aFUXX.akEditorTableBorder)})`}`,
            borderRightWidth: 0,
            borderBottomWidth: 0,
            padding: "var(--ds-space-100, 8px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            'th p:not(:first-of-type), td p:not(:first-of-type)': {
                marginTop: "var(--ds-space-150, 12px)"
            }
        }
    }
});
const $913a570f210a4bc3$var$tableRendererNestedPanelStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    [`.${(0, $1zav4.TableSharedCssClassName).TABLE_CONTAINER} .ak-editor-panel`]: {
        border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #d9dbea)"}`
    }
});
const $913a570f210a4bc3$var$tableStylesBackGroundClipForGeckoForTableCellOnly = /*#__PURE__*/ (0, $9K4OG.css)({
    [`.${(0, $1zav4.TableSharedCssClassName).TABLE_CONTAINER} > table,
		.${(0, $1zav4.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
		.${(0, $1zav4.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> tbody > tr > th, > tbody > tr > td': {
            backgroundClip: 'padding-box'
        }
    }
});
const $913a570f210a4bc3$var$firstNodeWithNotMarginTopWithNestedDnD = /*#__PURE__*/ (0, $9K4OG.css)({
    [`.${(0, $1zav4.TableSharedCssClassName).TABLE_CONTAINER} > table,
		.${(0, $1zav4.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
		.${(0, $1zav4.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        '> tbody > tr > th, > tbody > tr > td': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '> :nth-child(1 of :not(style, .ProseMirror-gapcursor, .ProseMirror-widget, span))': {
                marginTop: 0
            }
        }
    }
});
const $913a570f210a4bc3$var$firstNodeWithNotMarginTop = /*#__PURE__*/ (0, $9K4OG.css)({
    [`.${(0, $1zav4.TableSharedCssClassName).TABLE_CONTAINER} > table,
		.${(0, $1zav4.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
		.${(0, $1zav4.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        '> tbody > tr > th, > tbody > tr > td': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '> :first-child:not(style), > style:first-child + *': {
                marginTop: 0
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '> .ProseMirror-gapcursor:first-child + *, > style:first-child + .ProseMirror-gapcursor + *': {
                marginTop: 0
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '> .ProseMirror-gapcursor:first-child + span + *, > style:first-child + .ProseMirror-gapcursor + span + *': {
                marginTop: 0
            }
        }
    }
});
const $913a570f210a4bc3$var$rendererTableStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    [`.${(0, $jVL42.RendererCssClassName).DOCUMENT} .${(0, $1zav4.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        zIndex: 0,
        transition: `all 0.1s linear`,
        display: 'flex' /* needed to avoid position: fixed jumpiness in Chrome */ ,
        /** Shadow overrides */ [`&.${(0, $frt7o.shadowClassNames).RIGHT_SHADOW}::after, &.${(0, $frt7o.shadowClassNames).LEFT_SHADOW}::before`]: {
            top: `${(0, $1zav4.tableMarginTop) - 1}px`,
            height: `calc(100% - ${(0, $1zav4.tableMarginTop)}px)`,
            zIndex: `${(0, $aFUXX.akEditorStickyHeaderZIndex)}`,
            width: `${$913a570f210a4bc3$var$tableShadowWidth}px`,
            background: `linear-gradient(
					to left,
					transparent 0,
					${`var(--ds-shadow-overflow-spread, ${(0, $6fnsQ.N40A)})`} 140%
				),
				linear-gradient(
					to right,
					${"var(--ds-shadow-overflow-perimeter, transparent)"} 0px,
					transparent 1px
				)`
        },
        [`&.${(0, $frt7o.shadowClassNames).RIGHT_SHADOW}::after`]: {
            background: `linear-gradient(
					to right,
					transparent 0,
					${`var(--ds-shadow-overflow-spread, ${(0, $6fnsQ.N40A)})`} 140%
				),
				linear-gradient(
					to left,
					${"var(--ds-shadow-overflow-perimeter, transparent)"} 0px,
					transparent 1px
				)`,
            right: `0px`
        },
        [`&
          .${(0, $fp8V7.shadowObserverClassNames).SENTINEL_LEFT},
          &
          .${(0, $fp8V7.shadowObserverClassNames).SENTINEL_RIGHT}`]: {
            height: `calc(100% - ${(0, $1zav4.tableMarginTop)}px)`
        }
    }
});
const $913a570f210a4bc3$var$stickyScrollbarStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    [`.${(0, $jVL42.RendererCssClassName).DOCUMENT} .${(0, $1zav4.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        position: 'relative',
        flexDirection: 'column',
        [`> .${(0, $1zav4.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER}`]: {
            width: '100%',
            display: 'block',
            visibility: 'hidden',
            overflowX: 'auto',
            position: 'sticky',
            bottom: `${"var(--ds-space-0, 0px)"}`,
            zIndex: 1
        },
        [`> .${(0, $1zav4.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM},
		> .${(0, $1zav4.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP}`]: {
            position: 'absolute',
            width: '100%',
            height: '1px',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginTop: '-1px',
            // need this to avoid sentinel being focused via keyboard
            // this still allows it to be detected by intersection observer
            visibility: 'hidden'
        },
        [`> .${(0, $1zav4.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP}`]: {
            top: `${$913a570f210a4bc3$var$tableRowHeight * 3}px`
        },
        [`> .${(0, $1zav4.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM}`]: {
            bottom: `${"var(--ds-space-250, 20px)"}` // MAX_BROWSER_SCROLLBAR_HEIGHT = 20;
        }
    }
});
const $913a570f210a4bc3$var$rendererTableHeaderEqualHeightStylesForTableCellOnly = /*#__PURE__*/ (0, $9K4OG.css)({
    [`.${(0, $jVL42.RendererCssClassName).DOCUMENT} .${(0, $1zav4.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        [`.${(0, $1zav4.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table, .${(0, $1zav4.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
            height: '1px' /* will be ignored */ ,
            marginLeft: 0,
            marginRight: 0
        }
    },
    [`.${(0, $1zav4.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table > tbody > tr:first-of-type, .${(0, $1zav4.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table > tbody > tr:first-of-type`]: {
        height: '100%',
        'td, th': {
            position: 'relative'
        }
    }
});
const $913a570f210a4bc3$var$rendererTableSortableColumnStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    [`.${(0, $jVL42.RendererCssClassName).DOCUMENT} .${(0, $1zav4.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        [`.${(0, $1zav4.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table, .${(0, $1zav4.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
            // allow nested heading links
            [`.${(0, $jVL42.RendererCssClassName).SORTABLE_COLUMN_WRAPPER}`]: {
                padding: 0,
                [`.${(0, $jVL42.RendererCssClassName).SORTABLE_COLUMN}`]: {
                    width: '100%',
                    height: '100%',
                    padding: `${(0, $1zav4.tableCellPadding)}px`,
                    borderWidth: '1.5px',
                    borderStyle: 'solid',
                    borderColor: `transparent`,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
                    '> *:first-child': {
                        marginTop: 0
                    },
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
                    '> .ProseMirror-gapcursor:first-child + *, > style:first-child + .ProseMirror-gapcursor + *': {
                        marginTop: 0
                    },
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
                    '> .ProseMirror-gapcursor:first-child + span + *, > style:first-child + .ProseMirror-gapcursor + span + *': {
                        marginTop: 0
                    },
                    '@supports selector(:focus-visible)': {
                        '&:focus': {
                            outline: 'unset'
                        },
                        '&:focus-visible': {
                            borderColor: `${`var(--ds-border-focused, ${(0, $6fnsQ.B300)})`}`
                        }
                    }
                },
                [`> .${(0, $jVL42.RendererCssClassName).SORTABLE_COLUMN} > .${(0, $jVL42.RendererCssClassName).SORTABLE_COLUMN_ICON_WRAPPER}`]: {
                    margin: 0,
                    [`.${0, $1j8OE.SORTABLE_COLUMN_ICON_CLASSNAME}`]: {
                        opacity: 1,
                        transition: `opacity 0.2s ease-in-out`
                    }
                },
                [`> .${(0, $jVL42.RendererCssClassName).SORTABLE_COLUMN}
						> .${(0, $jVL42.RendererCssClassName).SORTABLE_COLUMN_NO_ORDER}`]: {
                    [`.${0, $1j8OE.SORTABLE_COLUMN_ICON_CLASSNAME}`]: {
                        opacity: 0,
                        '&:focus': {
                            opacity: 1
                        }
                    }
                },
                [`&:hover:not(
							:has(
									.${(0, $jVL42.RendererCssClassName).SORTABLE_COLUMN_WRAPPER}
										.${(0, $jVL42.RendererCssClassName).SORTABLE_COLUMN}:hover
								)
						)
						> .${(0, $jVL42.RendererCssClassName).SORTABLE_COLUMN}
						> .${(0, $jVL42.RendererCssClassName).SORTABLE_COLUMN_NO_ORDER}`]: {
                    [`.${0, $1j8OE.SORTABLE_COLUMN_ICON_CLASSNAME}`]: {
                        opacity: 1
                    }
                }
            }
        }
    }
});
const $913a570f210a4bc3$var$rendererTableColumnStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    [`.${(0, $jVL42.RendererCssClassName).DOCUMENT} .${(0, $1zav4.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        'table[data-number-column="true"]': {
            [`.${(0, $jVL42.RendererCssClassName).NUMBER_COLUMN}`]: {
                backgroundColor: `${"var(--ds-background-accent-gray-subtlest, #F0F1F2)"}`,
                borderRight: `${"var(--ds-border-width, 1px)"} solid
								${`var(--ds-background-accent-gray-subtler, ${(0, $aFUXX.akEditorTableBorder)})`}`,
                width: `${(0, $aFUXX.akEditorTableNumberColumnWidth)}px`,
                textAlign: 'center',
                color: `${`var(--ds-text-subtlest, ${(0, $6fnsQ.N200)})`}`,
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                fontSize: `${0.875} rem`
            },
            [`.fixed .${(0, $jVL42.RendererCssClassName).NUMBER_COLUMN}`]: {
                borderRight: `0px none`
            }
        }
    }
});
const $913a570f210a4bc3$var$rendererTableHeaderEqualHeightStylesAllowNestedHeaderLinks = /*#__PURE__*/ (0, $9K4OG.css)({
    [`.${(0, $jVL42.RendererCssClassName).DOCUMENT} .${(0, $1zav4.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        [`.${(0, $1zav4.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table, .${(0, $1zav4.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
            [`.${(0, $jVL42.RendererCssClassName).SORTABLE_COLUMN_WRAPPER}`]: {
                [`.${(0, $jVL42.RendererCssClassName).SORTABLE_COLUMN}`]: {
                    [`.${0, $3HdsG.HeadingAnchorWrapperClassName}`]: {
                        position: 'unset'
                    },
                    '>': {
                        'h1, h2, h3, h4, h5, h6': {
                            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
                            marginRight: '30px'
                        }
                    }
                }
            }
        }
    }
});
// @ts-expect-error - throw TS error when use !import in position.
const $913a570f210a4bc3$var$stickyHeaderStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    'tr[data-header-row].fixed': {
        position: 'fixed !important',
        display: 'flex',
        overflow: 'hidden',
        zIndex: `${(0, $aFUXX.akEditorStickyHeaderZIndex)}`,
        borderRight: `${"var(--ds-border-width, 1px)"} solid ${`var(--ds-background-accent-gray-subtler, ${(0, $aFUXX.akEditorTableBorder)})`}`,
        borderBottom: `${"var(--ds-border-width, 1px)"} solid ${`var(--ds-background-accent-gray-subtler, ${(0, $aFUXX.akEditorTableBorder)})`}`,
        /* this is to compensate for the table border */ transform: 'translateX(-1px)'
    },
    '.sticky > th': {
        zIndex: `${(0, $aFUXX.akEditorStickyHeaderZIndex)}`,
        position: 'fixed !important',
        top: 0
    },
    /* Make the number column header sticky */ '.sticky > td': {
        position: 'fixed !important',
        top: 0
    },
    /* add border for position: sticky
  and work around background-clip: padding-box
  bug for FF causing box-shadow bug in Chrome */ '.sticky th, .sticky td': {
        boxShadow: `0px 1px ${`var(--ds-background-accent-gray-subtler, ${(0, $aFUXX.akEditorTableBorder)})`},
			0px -0.5px ${`var(--ds-background-accent-gray-subtler, ${(0, $aFUXX.akEditorTableBorder)})`},
			inset -1px 0px ${`var(--ds-background-accent-gray-subtler, ${(0, $aFUXX.akEditorTableToolbar)})`},
			0px -1px ${`var(--ds-background-accent-gray-subtler, ${(0, $aFUXX.akEditorTableToolbar)})`}`
    },
    /* this will remove jumpiness caused in Chrome for sticky headers */ '.fixed + tr': {
        minHeight: '0px'
    }
});
const $913a570f210a4bc3$var$codeBlockAndLayoutStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    /*
   * We wrap CodeBlock in a grid to prevent it from overflowing the container of the renderer.
   * See ED-4159.
   */ '& .code-block': {
        maxWidth: '100%',
        display: 'block',
        position: 'relative',
        borderRadius: "var(--ds-radius-small, 3px)",
        /*
     * The overall renderer has word-wrap: break; which causes issues with
     * code block line numbers in Safari / iOS.
     */ wordWrap: 'normal'
    },
    '& .MediaGroup, & .code-block': {
        marginTop: `${(0, $aFUXX.blockNodesVerticalMargin)}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:first-child': {
            marginTop: 0
        }
    },
    // We overwrite the rule that clears margin-top for first nested codeblocks, as
    // our lightweight codeblock dom structure will always nest the codeblock inside
    // an extra container div which would constantly be targeted. Now, top-level
    // lightweight codeblock containers will not be targeted.
    // NOTE: This must be added after other .code-block styles in the root
    // Renderer stylesheet.
    [`.${(0, $jVL42.RendererCssClassName).DOCUMENT}
		> .${(0, $j2w4t.LightWeightCodeBlockCssClassName).CONTAINER}
		.${(0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER}`]: {
        marginTop: (0, $aFUXX.blockNodesVerticalMargin)
    },
    '& [data-layout-section]': {
        marginTop: "var(--ds-space-250, 20px)",
        '& > div + div': {
            marginLeft: "var(--ds-space-400, 32px)"
        },
        [`@media screen and (max-width: ${0, $aFUXX.gridMediumMaxWidth}px)`]: {
            '& > div + div': {
                marginLeft: 0
            }
        },
        '& .MediaGroup, & .code-block': {
            marginTop: (0, $aFUXX.blockNodesVerticalMargin),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:first-child': {
                marginTop: 0
            }
        }
    },
    '& li': {
        '> .code-block': {
            margin: `${(0, $aFUXX.blockNodesVerticalMargin)} 0 0 0`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> .code-block:first-child': {
            marginTop: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> div:last-of-type.code-block': {
            marginBottom: (0, $aFUXX.blockNodesVerticalMargin)
        }
    }
});
const $913a570f210a4bc3$var$layoutSectionForAdvancedLayoutsStyles = {
    name: "4wptv0",
    styles: "& [data-layout-section]{& > div + div{margin-left:0;}}"
};
const $913a570f210a4bc3$var$gridRenderForCodeBlockStyles = {
    name: "18d2t58",
    styles: "& .code-block{display:grid;grid-template-columns:minmax(0, 1fr);& > span{grid-column:1;}}"
};
// This prevents https://product-fabric.atlassian.net/browse/ED-20924
const $913a570f210a4bc3$var$codeBlockInListSafariFixStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    [`&:not([data-node-type='decisionList']) > li,
		&:not(.${(0, $cV5SN.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER}) > li`]: {
        '&::before': {
            content: '" "',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: (0, $aFUXX.akEditorLineHeight)
        },
        [`> p:first-child,
			> .code-block:first-child,
			> .ProseMirror-gapcursor:first-child + .code-block`]: {
            marginTop: `-${(0, $aFUXX.akEditorLineHeight)}em !important`
        }
    }
});
const $913a570f210a4bc3$var$columnLayoutSharedStyle = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '[data-layout-section]': {
        position: 'relative',
        display: 'flex',
        flexDirection: 'row',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > *': {
            flex: 1,
            minWidth: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > .unsupportedBlockView-content-wrap': {
            minWidth: 'initial'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`@media screen and (max-width: ${0, $aFUXX.gridMediumMaxWidth}px)`]: {
            flexDirection: 'column'
        }
    }
});
const $913a570f210a4bc3$var$columnLayoutResponsiveSharedStyle = {
    name: "ee7qh9",
    styles: "[data-layout-section]{display:flex;flex-direction:row;gap:var(--ds-space-100, 8px);& > *{flex:1;min-width:0;}& > .unsupportedBlockView-content-wrap{min-width:initial;}}.layout-section-container{container-type:inline-size;container-name:layout-area;}"
};
const $913a570f210a4bc3$var$columnLayoutResponsiveRendererStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.layout-section-container [data-layout-section]': {
        gap: "var(--ds-space-600, 48px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries
        [`@container layout-area (max-width: ${$913a570f210a4bc3$var$LAYOUT_BREAKPOINT_RENDERER}px)`]: {
            flexDirection: 'column',
            gap: "var(--ds-space-400, 32px)"
        }
    }
});
const $913a570f210a4bc3$var$rendererAnnotationStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    "& [data-mark-type='annotation'][data-mark-annotation-state='active'] [data-annotation-mark], & [data-annotation-draft-mark][data-annotation-inline-node]": {
        background: `var(--ds-background-accent-yellow-subtler, ${(0, $6fnsQ.Y75)})`,
        borderBottom: `${"var(--ds-border-width-selected, 2px)"} solid ${`var(--ds-border-accent-yellow, ${(0, $6fnsQ.Y300)})`}`,
        boxShadow: `var(--ds-shadow-overlay, ${`1px 2px 3px ${(0, $6fnsQ.N60A)}, -1px 2px 3px ${(0, $6fnsQ.N60A)}`})`,
        cursor: 'pointer',
        padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-025, 2px)"}`
    }
});
const $913a570f210a4bc3$var$rendererAnnotationStylesCommentHeightFix = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '& [data-annotation-draft-mark][data-annotation-inline-node]': {
        borderBottom: `${"var(--ds-border-width-selected, 2px)"} solid transparent`,
        cursor: 'pointer',
        padding: `1px 0 ${"var(--ds-space-025, 2px)"}`,
        background: `var(--ds-background-accent-yellow-subtler, ${(0, $6fnsQ.Y75)})`,
        borderBottomColor: `var(--ds-border-accent-yellow, ${(0, $6fnsQ.Y300)})`,
        boxShadow: `var(--ds-shadow-overlay, ${`1px 2px 3px ${(0, $6fnsQ.N60A)}, -1px 2px 3px ${(0, $6fnsQ.N60A)}`})`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '& [data-annotation-draft-mark][data-annotation-inline-node][data-inline-card]': {
        padding: '5px 0 3px 0'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '& [data-annotation-draft-mark][data-annotation-inline-node].date-lozenger-container': {
        paddingTop: "var(--ds-space-025, 2px)"
    }
});
const $913a570f210a4bc3$var$RENDERER_LIST_DENSE_GAP = `max(0px,calc((var(--ak-renderer-base-font-size) - ${(0, $aFUXX.akEditorFullPageDenseFontSize)}px)* (4/3)))`;
const $913a570f210a4bc3$var$TASKLIST_CONTAINER_DENSE_MARGIN = `max(calc(10px + (var(--ak-renderer-base-font-size) - ${(0, $aFUXX.akEditorFullPageDenseFontSize)}px) *( 2 / 3)))`;
const $913a570f210a4bc3$var$denseStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    // Scale emoji size based on base font size
    // Default: 20px emoji at 16px base font
    // Scaled: 20px * (baseFontSize/16)
    // E.g., dense mode (13px base): 20px * (13/16) = 16.25px
    [`.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE}`]: {
        height: `calc(${(0, $fhsiz.defaultEmojiHeight)} * var(--ak-renderer-base-font-size) / ${(0, $aFUXX.akEditorFullPageDefaultFontSize)})`,
        width: `calc(${(0, $fhsiz.defaultEmojiHeight)} * var(--ak-renderer-base-font-size) / ${(0, $aFUXX.akEditorFullPageDefaultFontSize)})`,
        maxHeight: `calc(${(0, $fhsiz.defaultEmojiHeight)} * var(--ak-renderer-base-font-size) / ${(0, $aFUXX.akEditorFullPageDefaultFontSize)})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        img: {
            width: '100%',
            height: '100%',
            objectFit: 'contain'
        }
    },
    // Scale panel icon
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    [`.${(0, $jVL42.RendererCssClassName).DOCUMENT} .ak-editor-panel .ak-editor-panel__icon`]: {
        height: "var(--ds-space-250, 20px)",
        width: "var(--ds-space-250, 20px)"
    },
    // Condense spacing across lists, tasks and decisions
    [`.${(0, $jVL42.RendererCssClassName).DOCUMENT}`]: {
        // Adjacent list items
        'li + li': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            marginTop: $913a570f210a4bc3$var$RENDERER_LIST_DENSE_GAP
        },
        // Nested lists directly under an li (unordered and ordered)
        'li > ul, li > ol, .ak-ul li > ul, .ak-ul li > ol, .ak-ol li > ul, .ak-ol li > ol': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            marginTop: $913a570f210a4bc3$var$RENDERER_LIST_DENSE_GAP
        },
        // Task lists
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-task-list-local-id]': {
            // Task lists: container top margin
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            marginTop: $913a570f210a4bc3$var$TASKLIST_CONTAINER_DENSE_MARGIN
        },
        // Task lists: sibling items and nested lists
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-task-list-local-id] > * + *': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            marginTop: $913a570f210a4bc3$var$RENDERER_LIST_DENSE_GAP
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-task-list-local-id] [data-task-list-local-id], [data-task-local-id] [data-task-local-id]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            marginTop: $913a570f210a4bc3$var$RENDERER_LIST_DENSE_GAP
        }
    }
});
const $913a570f210a4bc3$export$8f0929e72efe521f = (props)=>{
    const { onClick: onClick, onMouseDown: onMouseDown, appearance: appearance, contentMode: contentMode, allowNestedHeaderLinks: allowNestedHeaderLinks, allowColumnSorting: allowColumnSorting, useBlockRenderForCodeBlock: useBlockRenderForCodeBlock, children: children, innerRef: innerRef, testId: testId } = props;
    // Scroll to localId functionality
    (0, $e1fb555e7bb7a894$export$b61745354f522fe)(innerRef, (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_block_menu', 'isEnabled', true));
    const isAdvancedLayoutsOn = (0, $iu6m9.editorExperiment)('advanced_layouts', true);
    const isPreviewPanelResponsivenessOn = (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    });
    const baseFontSize = (0, $ec7cc60cabf60b92$export$8e2864079bc476bd)(appearance, contentMode);
    const browser = (0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $d7ZU3.getBrowserInfo)() : (0, $d7ZU3.browser);
    return(// eslint-disable-next-line @atlassian/a11y/click-events-have-key-events, @atlassian/a11y/interactive-element-not-keyboard-focusable, @atlassian/a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        ref: innerRef,
        onClick: onClick,
        onMouseDown: onMouseDown,
        style: {
            '--ak-renderer-base-font-size': `${baseFontSize}px`,
            '--ak-renderer-editor-font-heading-h1': `${(0, $ilPbq.default)('editor.font.heading.h1')}`,
            '--ak-renderer-editor-font-heading-h2': `${(0, $ilPbq.default)('editor.font.heading.h2')}`,
            '--ak-renderer-editor-font-heading-h3': `${(0, $ilPbq.default)('editor.font.heading.h3')}`,
            '--ak-renderer-editor-font-heading-h4': `${(0, $ilPbq.default)('editor.font.heading.h4')}`,
            '--ak-renderer-editor-font-heading-h5': `${(0, $ilPbq.default)('editor.font.heading.h5')}`,
            '--ak-renderer-editor-font-heading-h6': `${(0, $ilPbq.default)('editor.font.heading.h6')}`,
            '--ak-renderer-editor-font-normal-text': `${(0, $ilPbq.default)('editor.font.body')}`
        },
        css: [
            $913a570f210a4bc3$var$baseStyles,
            $913a570f210a4bc3$var$hideHeadingCopyLinkWrapperStyles,
            appearance === 'full-page' && isPreviewPanelResponsivenessOn && $913a570f210a4bc3$var$rendererFullPageStylesWithReducedPadding,
            appearance === 'full-page' && !isPreviewPanelResponsivenessOn && $913a570f210a4bc3$var$rendererFullPageStyles,
            appearance === 'full-width' && $913a570f210a4bc3$var$rendererFullWidthStyles,
            appearance === 'full-width' && !(0, $2jkq1.isTableResizingEnabled)(appearance) && $913a570f210a4bc3$var$rendererFullWidthStylesForTableResizing,
            !(0, $dh538.fg)('aifc_create_enabled') && $913a570f210a4bc3$var$telepointerStyles,
            (0, $dh538.fg)('aifc_create_enabled') && $913a570f210a4bc3$var$rovoTelepointerStyles,
            $913a570f210a4bc3$var$whitespaceSharedStyles,
            $913a570f210a4bc3$var$blockquoteSharedStyles,
            (0, $dh538.fg)('platform_editor_typography_ugc') ? $913a570f210a4bc3$var$headingsSharedStylesWithEditorUGC : $913a570f210a4bc3$var$headingsSharedStyles,
            $913a570f210a4bc3$var$headingWithAlignmentStyles,
            $913a570f210a4bc3$var$ruleSharedStyles,
            (contentMode === 'compact' || contentMode === 'dense') && (0, $1oCLl.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $dh538.fg)('platform_editor_content_mode_button_mvp') && $913a570f210a4bc3$var$extensionStyle,
            (0, $dh538.fg)('platform_editor_typography_ugc') ? (0, $1oCLl.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $dh538.fg)('platform_editor_content_mode_button_mvp') ? $913a570f210a4bc3$var$paragraphStylesUGCScaledMargin : $913a570f210a4bc3$var$paragraphSharedStylesWithEditorUGC : (0, $1oCLl.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $dh538.fg)('platform_editor_content_mode_button_mvp') ? $913a570f210a4bc3$var$paragraphSharedStyleScaledMargin : $913a570f210a4bc3$var$paragraphSharedStyles,
            $913a570f210a4bc3$var$listsSharedStyles,
            browser.gecko && $913a570f210a4bc3$var$listsSharedStylesForGekko,
            $913a570f210a4bc3$var$indentationSharedStyles,
            (0, $dh538.fg)('platform_editor__renderer_indentation_text_margin') && $913a570f210a4bc3$var$indentationSharedStylesWithMarginFix,
            $913a570f210a4bc3$var$blockMarksSharedStyles,
            $913a570f210a4bc3$var$codeMarkSharedStyles,
            $913a570f210a4bc3$var$shadowSharedStyle,
            $913a570f210a4bc3$var$dateSharedStyle,
            $913a570f210a4bc3$var$textColorStyles,
            $913a570f210a4bc3$var$backgroundColorStyles,
            (0, $1oCLl.expValEquals)('platform_editor_text_highlight_padding', 'isEnabled', true) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            $913a570f210a4bc3$export$a365082c2a191514,
            $913a570f210a4bc3$var$tasksAndDecisionsStyles,
            $913a570f210a4bc3$var$smartCardStyles,
            $913a570f210a4bc3$var$smartCardStylesAvatarFix,
            (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_linking_exp', true) && $913a570f210a4bc3$var$headerSmartCardStyles,
            $913a570f210a4bc3$var$smartCardStylesAvatarMarginFix,
            $913a570f210a4bc3$var$smartCardStylesAvatarListZeroMarginTop,
            (0, $dh538.fg)('editor_inline_comments_on_inline_nodes') && $913a570f210a4bc3$var$rendererAnnotationStyles,
            // eslint-disable-next-line @atlaskit/platform/no-preconditioning
            (0, $dh538.fg)('editor_inline_comments_on_inline_nodes') && (0, $dh538.fg)('annotations_align_editor_and_renderer_styles') && $913a570f210a4bc3$var$rendererAnnotationStylesCommentHeightFix,
            $913a570f210a4bc3$var$baseOtherStyles,
            allowNestedHeaderLinks && $913a570f210a4bc3$var$alignedHeadingAnchorStyle,
            $913a570f210a4bc3$var$mediaSingleSharedStyle,
            // merge firstWrappedMediaStyles with mediaSingleSharedStyle when clean up platform_editor_fix_media_in_renderer
            (0, $dh538.fg)('platform_editor_fix_media_in_renderer') && $913a570f210a4bc3$var$firstWrappedMediaStyles,
            $913a570f210a4bc3$var$tableSharedStyle,
            $913a570f210a4bc3$var$tableRendererHeaderStylesForTableCellOnly,
            (0, $dh538.fg)('platform_editor_bordered_panel_nested_in_table') && $913a570f210a4bc3$var$tableRendererNestedPanelStyles,
            $913a570f210a4bc3$var$isBackgroundClipBrowserFixNeeded() && $913a570f210a4bc3$var$tableStylesBackGroundClipForGeckoForTableCellOnly,
            (0, $dh538.fg)('platform_editor_nested_dnd_styles_changes') ? $913a570f210a4bc3$var$firstNodeWithNotMarginTopWithNestedDnD : $913a570f210a4bc3$var$firstNodeWithNotMarginTop,
            $913a570f210a4bc3$var$rendererTableStyles,
            (0, $2jkq1.isStickyScrollbarEnabled)(appearance) && $913a570f210a4bc3$var$stickyScrollbarStyles,
            $913a570f210a4bc3$var$rendererTableHeaderEqualHeightStylesForTableCellOnly,
            allowColumnSorting && $913a570f210a4bc3$var$rendererTableSortableColumnStyles,
            allowColumnSorting && allowNestedHeaderLinks && $913a570f210a4bc3$var$rendererTableHeaderEqualHeightStylesAllowNestedHeaderLinks,
            $913a570f210a4bc3$var$rendererTableColumnStyles,
            $913a570f210a4bc3$var$stickyHeaderStyles,
            $913a570f210a4bc3$var$codeBlockAndLayoutStyles,
            $913a570f210a4bc3$var$columnLayoutSharedStyle,
            isAdvancedLayoutsOn && $913a570f210a4bc3$var$columnLayoutResponsiveSharedStyle,
            isAdvancedLayoutsOn && $913a570f210a4bc3$var$columnLayoutResponsiveRendererStyles,
            isAdvancedLayoutsOn && $913a570f210a4bc3$var$layoutSectionForAdvancedLayoutsStyles,
            !useBlockRenderForCodeBlock && $913a570f210a4bc3$var$gridRenderForCodeBlockStyles,
            browser.safari && $913a570f210a4bc3$var$codeBlockInListSafariFixStyles,
            appearance === 'full-page' && !isPreviewPanelResponsivenessOn && $913a570f210a4bc3$var$responsiveBreakoutWidth,
            appearance === 'full-page' && isPreviewPanelResponsivenessOn && $913a570f210a4bc3$var$responsiveBreakoutWidthWithReducedPadding,
            appearance === 'full-width' && $913a570f210a4bc3$var$responsiveBreakoutWidthFullWidth,
            (0, $1oCLl.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $dh538.fg)('platform_editor_content_mode_button_mvp') && $913a570f210a4bc3$var$denseStyles
        ],
        "data-testid": testId
    }, children));
};



const $72f5f4ba20544324$export$c94cfc0c675062a1 = (document)=>{
    // Check if the document is valid
    if (!document || !document.content || !Array.isArray(document.content)) return document;
    // Check if the node is a meaningful content node meaning it is not an empty paragraph or a paragraph with only whitespace
    const isMeaningfulContentNode = (node)=>{
        // Check if the node is a non-empty paragraph or a non-paragraph node
        if (node.type !== 'paragraph') return true;
        // If the paragraph is empty, return false
        if (!node.content || node.content.length === 0) return false;
        // Check if paragraph has any content other than `hardBreak` or whitespace text nodes
        return node.content.some((child)=>{
            return !(child?.type === 'hardBreak' || child?.type === 'text' && typeof child.text === 'string' && child.text.trim() === '');
        });
    };
    const content = document.content;
    let firstContentIndex = -1;
    let lastContentIndex = -1;
    // Find the first and last paragraphs with content and check if they are meaningful
    for(let i = 0; i < content.length; i++)if (isMeaningfulContentNode(content[i])) {
        if (firstContentIndex === -1) firstContentIndex = i;
        lastContentIndex = i;
    }
    // If no content was found, return an empty document
    if (firstContentIndex === -1) return {
        ...document,
        content: []
    };
    // Slice the content array to include only paragraphs between the first and last content
    const trimmedContent = content.slice(firstContentIndex, lastContentIndex + 1);
    // Return a new document with the trimmed content
    return {
        ...document,
        content: trimmedContent
    };
};





function $6d2060ea59e4ee09$export$80ffe7e3c6bf25c3(factory, propsDerivator, props) {
    // cache the last set of props
    const prev = (0, $42omo.useRef)(props);
    const prevFactory = (0, $42omo.useRef)(null);
    return (0, $42omo.useMemo)(()=>{
        // check if the serializer is already created
        let shouldCreate = !prevFactory.current;
        // check each prop to see if value has changed and also check if the number of props has changed
        if (prev.current !== props) {
            const propsEntries = Object.entries(props);
            shouldCreate = propsEntries.length !== Object.keys(prev.current).length || propsEntries.some(([key, prop])=>prev.current[key] !== prop);
        }
        prev.current = props;
        // If first time or any prop value has changed, create a new serializer
        if (shouldCreate) prevFactory.current = factory(propsDerivator(props));
        return prevFactory.current;
    }, // To keep deps consistent, here disable the exhaustive-deps rule to drop factory from the deps array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        propsDerivator,
        props
    ]);
}



var $eauJy = parcelRequire("eauJy");










var $e2wMq = parcelRequire("e2wMq");

var $3824I = parcelRequire("3824I");




const $ac23999863c9cf10$export$208d2421b73f3f86 = (renderer)=>{
    const tablesInfo = [];
    const tableWrappers = renderer.querySelectorAll('.pm-table-wrapper');
    // only send the event if there are tables on the page
    if (tableWrappers.length === 0) return undefined;
    tableWrappers.forEach((tableWrapper)=>{
        const table = tableWrapper.querySelector(':scope > table');
        if (table) {
            const isNestedTable = Boolean(table.closest('td, th'));
            tablesInfo.push({
                tableWidth: table.scrollWidth,
                hasScrollbar: tableWrapper.clientWidth < table.scrollWidth,
                isNestedTable: isNestedTable
            });
        }
    });
    const maxTableWidth = Math.max(...tablesInfo.map((table)=>table.tableWidth));
    const editorWidth = renderer.scrollWidth;
    return {
        action: (0, $3824I.TABLE_ACTION).TABLE_WIDTH_INFO,
        actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
        attributes: {
            editorWidth: editorWidth,
            editorWidthBreakpoint: (0, $lWghV.getBreakpointKey)(editorWidth),
            tableWidthInfo: tablesInfo,
            maxTableWidthBreakpoint: (0, $lWghV.getBreakpointKey)(maxTableWidth),
            hasTableWiderThanEditor: maxTableWidth > editorWidth,
            hasTableWithScrollbar: tablesInfo.some((table)=>table.hasScrollbar),
            mode: (0, $e2wMq.MODE).RENDERER
        },
        eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
    };
};
const $ac23999863c9cf10$export$34e5b28c67455a81 = (renderer)=>{
    const tablesInfo = [];
    const tableWrappers = renderer.querySelectorAll('.pm-table-wrapper');
    // only send the event if there are tables on the page
    if (tableWrappers.length === 0) return undefined;
    tableWrappers.forEach((tableWrapper)=>{
        const table = tableWrapper.querySelector(':scope > table');
        if (table) {
            const isNestedTable = Boolean(table.closest('td, th'));
            tablesInfo.push({
                tableHeight: table.scrollHeight,
                isNestedTable: isNestedTable
            });
        }
    });
    const maxTableHeight = Math.max(...tablesInfo.map((table)=>table.tableHeight));
    /** NOTE: Renderer is not scrollable, so this height represents the height of the content */ const rendererClientHeight = renderer.clientHeight;
    const viewportHeight = window.innerHeight;
    if (!viewportHeight) return undefined;
    return {
        action: (0, $3824I.TABLE_ACTION).TABLE_RENDERER_HEIGHT_INFO,
        actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
        attributes: {
            viewportHeight: viewportHeight,
            rendererHeight: rendererClientHeight,
            maxTableHeight: maxTableHeight,
            maxTableToViewportHeightRatio: maxTableHeight / viewportHeight,
            tableHeightInfo: tablesInfo
        },
        eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
    };
};


function $19370cae7f055953$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $19370cae7f055953$export$47b2879ca9bbf67a = 2000;
const $19370cae7f055953$export$1b622068be977101 = 3000;
// we want to calculate all the table widths (which causes reflows) after the renderer has finished loading to mitigate performance impact
const $19370cae7f055953$var$TABLE_INFO_TIMEOUT = 10000;
const $19370cae7f055953$var$packageName = "platform-pkg";
const $19370cae7f055953$var$packageVersion = "0.0.0-use.local";
const $19370cae7f055953$var$setAsQueryContainerStyles = {
    name: "3qfej8",
    styles: "container-name:ak-renderer-wrapper;container-type:inline-size"
};
const $19370cae7f055953$var$handleMouseTripleClickInTables = (event)=>{
    const browser = (0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $d7ZU3.getBrowserInfo)() : (0, $d7ZU3.browser);
    if (browser.ios || browser.android) return;
    const badBrowser = browser.chrome || browser.safari;
    const tripleClick = event.detail >= 3;
    if (!(badBrowser && tripleClick)) return;
    const selection = window.getSelection();
    if (!selection) return;
    const { type: type, anchorNode: anchorNode, focusNode: focusNode } = selection;
    const rangeSelection = Boolean(type === 'Range' && anchorNode && focusNode);
    if (!rangeSelection) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const target = event.target;
    const tableCell = target.closest('td,th');
    const clickedInCell = Boolean(tableCell);
    if (!clickedInCell) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const anchorInCell = tableCell.contains(anchorNode);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const focusInCell = tableCell.contains(focusNode);
    const selectionStartsOrEndsOutsideClickedCell = !(anchorInCell && focusInCell);
    if (!selectionStartsOrEndsOutsideClickedCell) return;
    // Ensure that selecting text in the renderer doesn't trigger onUnhandledClick
    // This logic originated in jira-frontend:
    // src/packages/issue/issue-view/src/views/field/rich-text/rich-text-inline-edit-view.js
    // The selection is required to be checked in `onMouseDown` and here. If not here, a new
    // selection isn't reported; if not in `onMouseDown`, a click outside the selection will
    // return an empty selection, which will erroneously fire onUnhandledClick.
    const elementToSelect = anchorInCell ? // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    anchorNode.parentElement?.closest('div,p') : focusInCell ? // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    focusNode.parentElement?.closest('div,p') : tableCell;
    if (elementToSelect) selection.selectAllChildren(elementToSelect);
};
/**
 * Handle clicks inside renderer. If the click isn't on media, in the media picker, or on a
 * link, call the onUnhandledClick eventHandler (which in Jira for example, may switch the
 * renderer out for the editor).
 * @param event Click event anywhere inside renderer
 * @param props
 * @param mouseDownSelection
 * @example
 */ const $19370cae7f055953$var$handleWrapperOnClick = (event, props, mouseDownSelection)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const targetElement = event.target;
    $19370cae7f055953$var$handleMouseTripleClickInTables(event);
    // ED-14862: When a user triple clicks to select a line of content inside a
    // a table cell, but the browser incorrectly moves the selection start or end into
    // a different table cell, we manually set the selection back to within the original
    // table cell the user intended to target
    if (!props.eventHandlers?.onUnhandledClick) return;
    if (!(targetElement instanceof window.Element)) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const rendererWrapper = event.currentTarget;
    const isInteractiveElementInTree = (0, $b7FrM.findInTree)(targetElement, rendererWrapper, (0, $d3e1cf2918b1cf26$export$3dee5e4542c672d9));
    if (isInteractiveElementInTree) return;
    // Ensure that selecting text in the renderer doesn't trigger onUnhandledClick
    // This logic originated in jira-frontend:
    // src/packages/issue/issue-view/src/views/field/rich-text/rich-text-inline-edit-view.js
    // The selection is required to be checked in `onMouseDown` and here. If not here, a new
    // selection isn't reported; if not in `onMouseDown`, a click outside the selection will
    // return an empty selection, which will erroneously fire onUnhandledClick.
    const windowSelection = window.getSelection();
    const selection = windowSelection !== null ? windowSelection.toString() : undefined;
    const hasSelection = selection && selection.length !== 0;
    const hasSelectionMouseDown = mouseDownSelection.current && mouseDownSelection.current.length !== 0;
    const allowEditBasedOnSelection = !hasSelection && !hasSelectionMouseDown;
    if (allowEditBasedOnSelection) props.eventHandlers.onUnhandledClick(event);
};
const $19370cae7f055953$export$c49fe2316038f3c2 = (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = props;
    const mouseDownSelection = (0, $42omo.useRef)(undefined);
    const providerFactory = (0, $42omo.useMemo)(()=>props.dataProviders || new (0, $4FxUL.default)(), [
        props.dataProviders
    ]);
    const { contentMode: parentContextContentMode } = (0, $bBvs5.useRendererContext)();
    const createRendererContext = (0, $42omo.useMemo)(()=>(featureFlags, isTopLevelRenderer, contentMode)=>{
            const normalizedFeatureFlags = (0, $9ciHB.normalizeFeatureFlags)(featureFlags);
            return {
                featureFlags: normalizedFeatureFlags,
                isTopLevelRenderer: isTopLevelRenderer === undefined,
                ...(0, $dh538.fg)('platform_editor_content_mode_render_context') && {
                    contentMode: contentMode || parentContextContentMode
                }
            };
        }, [
        parentContextContentMode
    ]);
    const fireAnalyticsEventOld = (0, $42omo.useCallback)((event)=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = props;
        if (createAnalyticsEvent) {
            const channel = (0, $k7eoe.FabricChannel).editor;
            createAnalyticsEvent(event).fire(channel);
        }
    }, [
        props
    ]);
    const fireAnalyticsEventNew = (0, $42omo.useCallback)((event)=>{
        if (createAnalyticsEvent) {
            const channel = (0, $k7eoe.FabricChannel).editor;
            createAnalyticsEvent(event).fire(channel);
        }
    }, [
        createAnalyticsEvent
    ]);
    const fireAnalyticsEvent = (0, $iu6m9.editorExperiment)('platform_renderer_fix_analytics_memo_callback', true, {
        exposure: true
    }) ? fireAnalyticsEventNew : fireAnalyticsEventOld;
    const deriveSerializerProps = (0, $42omo.useCallback)((props)=>{
        const stickyHeaders = props.stickyHeaders ? props.stickyHeaders === true ? {} : props.stickyHeaders : undefined;
        const { annotationProvider: annotationProvider } = props;
        const allowAnnotationsDraftMode = Boolean(annotationProvider && annotationProvider.inlineComment && annotationProvider.inlineComment.allowDraftMode);
        const { featureFlags: featureFlags } = createRendererContext(props.featureFlags, props.isTopLevelRenderer, props.contentMode);
        return {
            startPos: props.startPos ?? 0,
            providers: providerFactory,
            eventHandlers: props.eventHandlers,
            extensionHandlers: props.extensionHandlers,
            portal: props.portal,
            objectContext: {
                adDoc: props.shouldRemoveEmptySpaceAroundContent ? (0, $72f5f4ba20544324$export$c94cfc0c675062a1)(props.document) : props.document,
                schema: props.schema,
                ...props.rendererContext
            },
            appearance: props.appearance,
            contentMode: props.contentMode,
            disableHeadingIDs: props.disableHeadingIDs,
            disableActions: props.disableActions,
            allowHeadingAnchorLinks: props.allowHeadingAnchorLinks,
            allowColumnSorting: props.allowColumnSorting,
            fireAnalyticsEvent: fireAnalyticsEvent,
            shouldOpenMediaViewer: props.shouldOpenMediaViewer,
            allowAltTextOnImages: props.allowAltTextOnImages,
            stickyHeaders: stickyHeaders,
            allowMediaLinking: props.media && props.media.allowLinking,
            surroundTextNodesWithTextWrapper: allowAnnotationsDraftMode,
            media: props.media,
            emojiResourceConfig: props.emojiResourceConfig,
            smartLinks: props.smartLinks,
            extensionViewportSizes: props.extensionViewportSizes,
            getExtensionHeight: props.getExtensionHeight,
            allowCopyToClipboard: props.allowCopyToClipboard,
            allowWrapCodeBlock: props.allowWrapCodeBlock,
            allowCustomPanels: props.allowCustomPanels,
            allowAnnotations: props.allowAnnotations,
            allowSelectAllTrap: props.allowSelectAllTrap,
            allowPlaceholderText: props.allowPlaceholderText,
            nodeComponents: props.nodeComponents,
            allowWindowedCodeBlock: featureFlags?.allowWindowedCodeBlock,
            isInsideOfInlineExtension: props.isInsideOfInlineExtension,
            isPresentational: props.UNSTABLE_isPresentational,
            textHighlighter: props.textHighlighter || props.UNSTABLE_textHighlighter,
            allowTableAlignment: props.UNSTABLE_allowTableAlignment,
            allowTableResizing: props.UNSTABLE_allowTableResizing,
            disableTableOverflowShadow: props.disableTableOverflowShadow
        };
    }, [
        createRendererContext,
        providerFactory,
        fireAnalyticsEvent
    ]);
    const serializer = (0, $6d2060ea59e4ee09$export$80ffe7e3c6bf25c3)((serializerProps)=>props.createSerializer?.(serializerProps) ?? new (0, $aUnCJ.default)(serializerProps), deriveSerializerProps, props);
    const localRef = (0, $42omo.useRef)(null);
    const editorRef = props.innerRef || localRef;
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const id = (0, $42omo.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))(), []);
    const renderedMeasurementDistortedDurationMonitor = (0, $42omo.useMemo)(()=>(0, $jz9wK.getDistortedDurationMonitor)(), []);
    // we are doing this to ensure it runs as
    // early as possible in the React lifecycle
    // to avoid any other side effects
    const measureStarted = (0, $42omo.useRef)(false);
    const startAnalyticsMeasure = ()=>{
        (0, $2T4ch.startMeasure)(`Renderer Render Time: ${id}`);
    };
    if (!measureStarted.current) {
        startAnalyticsMeasure();
        measureStarted.current = true;
    }
    const anchorLinkAnalytics = (0, $42omo.useCallback)(()=>{
        const hash = window.location.hash && decodeURIComponent(window.location.hash.slice(1));
        const disableHeadingIDs = props.disableHeadingIDs;
        if (!disableHeadingIDs && hash && editorRef && editorRef.current instanceof HTMLElement) {
            const anchorLinkElement = document.getElementById(hash);
            if (anchorLinkElement && editorRef.current.contains(anchorLinkElement)) fireAnalyticsEvent({
                action: (0, $d925B.ACTION).VIEWED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).ANCHOR_LINK,
                attributes: {
                    platform: (0, $59U23.PLATFORM).WEB,
                    mode: (0, $59U23.MODE).RENDERER
                },
                eventType: (0, $d925B.EVENT_TYPE).UI
            });
        }
    }, [
        props.disableHeadingIDs,
        editorRef,
        fireAnalyticsEvent
    ]);
    const getSchema = (0, $42omo.useMemo)(()=>{
        return (schema, adfStage)=>{
            if (schema) return schema;
            return (0, $1UrkW.getSchemaBasedOnStage)(adfStage);
        };
    }, []);
    const onMouseDownEditView = ()=>{
        const windowSelection = window.getSelection();
        mouseDownSelection.current = windowSelection !== null ? windowSelection.toString() : undefined;
    };
    const { dataProviders: dataProviders, analyticsEventSeverityTracking: analyticsEventSeverityTracking } = props;
    (0, $42omo.useEffect)(()=>{
        let rafID;
        let heightWidthAnalyticsSetTimeoutID;
        let heightWidthAnalyticsRicID;
        let heightWidthAnalyticsRafID;
        const handleAnalytics = ()=>{
            fireAnalyticsEvent({
                action: (0, $d925B.ACTION).STARTED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).RENDERER,
                attributes: {
                    platform: (0, $59U23.PLATFORM).WEB
                },
                eventType: (0, $d925B.EVENT_TYPE).UI
            });
            rafID = requestAnimationFrame(()=>{
                (0, $2T4ch.stopMeasure)(`Renderer Render Time: ${id}`, (duration)=>{
                    const forceSeverityTracking = typeof analyticsEventSeverityTracking === 'undefined' && (0, $NPJKR.shouldForceTracking)();
                    const severity = !!forceSeverityTracking || analyticsEventSeverityTracking?.enabled ? (0, $lWghV.getAnalyticsEventSeverity)(duration, analyticsEventSeverityTracking?.severityNormalThreshold ?? $19370cae7f055953$export$47b2879ca9bbf67a, analyticsEventSeverityTracking?.severityDegradedThreshold ?? $19370cae7f055953$export$1b622068be977101) : undefined;
                    const isTTRTrackingExplicitlyDisabled = analyticsEventSeverityTracking?.enabled === false;
                    if (!isTTRTrackingExplicitlyDisabled) fireAnalyticsEvent({
                        action: (0, $d925B.ACTION).RENDERED,
                        actionSubject: (0, $d925B.ACTION_SUBJECT).RENDERER,
                        attributes: {
                            platform: (0, $59U23.PLATFORM).WEB,
                            duration: duration,
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            distortedDuration: renderedMeasurementDistortedDurationMonitor.distortedDuration,
                            ttfb: (0, $8pwxt.getResponseEndTime)(),
                            nodes: (0, $1Qaul.countNodes)(props.document),
                            severity: severity
                        },
                        eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
                    });
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    renderedMeasurementDistortedDurationMonitor.cleanup();
                });
                anchorLinkAnalytics();
            });
            if ((0, $1oCLl.expValEquals)('platform_editor_editor_width_analytics', 'isEnabled', true)) // send statistics about the heights/widths of the tables on the page for alerting
            heightWidthAnalyticsSetTimeoutID = setTimeout(()=>{
                const requestIdleCallbackFn = ()=>{
                    const renderer = props.innerRef?.current?.querySelector('.ak-renderer-document');
                    if (renderer) {
                        const payload = (0, $ac23999863c9cf10$export$208d2421b73f3f86)(renderer);
                        if (payload) fireAnalyticsEvent(payload);
                        if ((0, $dh538.fg)('platform_editor_table_height_analytics_event')) {
                            const payloadHeight = (0, $ac23999863c9cf10$export$34e5b28c67455a81)(renderer);
                            if (payloadHeight) fireAnalyticsEvent(payloadHeight);
                        }
                    }
                };
                if (window && typeof window.requestIdleCallback === 'function') heightWidthAnalyticsRicID = window.requestIdleCallback(requestIdleCallbackFn);
                else if (window && typeof window.requestAnimationFrame === 'function') // requestIdleCallback is not supported in safari, fallback to requestAnimationFrame
                heightWidthAnalyticsRafID = window.requestAnimationFrame(requestIdleCallbackFn);
            }, $19370cae7f055953$var$TABLE_INFO_TIMEOUT);
        };
        handleAnalytics();
        return ()=>{
            if (rafID) window.cancelAnimationFrame(rafID);
            if (heightWidthAnalyticsSetTimeoutID) window.clearTimeout(heightWidthAnalyticsSetTimeoutID);
            if (heightWidthAnalyticsRafID) window.cancelAnimationFrame(heightWidthAnalyticsRafID);
            if (heightWidthAnalyticsRicID) window.cancelIdleCallback(heightWidthAnalyticsRicID);
            // if this is the ProviderFactory which was created in constructor
            // it's safe to destroy it on Renderer unmount
            // updated to match existing class component
            if (!dataProviders) providerFactory.destroy();
        };
    // we are going to ignore this because I'm doing this on purpose
    // having a dependency array means we run stopMeasure twice per render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const rendererContext = (0, $42omo.useMemo)(()=>createRendererContext(props.featureFlags, props.isTopLevelRenderer, props.contentMode), [
        props.featureFlags,
        props.isTopLevelRenderer,
        createRendererContext,
        props.contentMode
    ]);
    try {
        const schema = getSchema(props.schema, props.adfStage);
        const { result: result, stat: stat, pmDoc: pmDoc } = (0, $lf9Ji.renderDocument)(props.shouldRemoveEmptySpaceAroundContent ? (0, $72f5f4ba20544324$export$c94cfc0c675062a1)(props.document) : props.document, serializer, schema, props.adfStage, props.useSpecBasedValidator, id, fireAnalyticsEvent, props.unsupportedContentLevelsTracking, props.appearance, props.includeNodesCountInStats, props.skipValidation, props.validationOverrides);
        if (props.onComplete) props.onComplete(stat);
        const rendererOutput = /*#__PURE__*/ (0, $9K4OG.jsx)((0, $bBvs5.RendererContextProvider), {
            value: rendererContext
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $9KIOh.ActiveHeaderIdProvider), {
            value: (0, $iNqGB.getActiveHeadingId)(props.allowHeadingAnchorLinks)
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6uN0A.default).Provider, {
            value: {
                fireAnalyticsEvent: (event)=>fireAnalyticsEvent(event)
            }
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $bZfVt.Provider), null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6mbqi.ProviderFactoryProvider), {
            value: providerFactory
        }, /*#__PURE__*/ (0, $9K4OG.jsx)($19370cae7f055953$var$RendererWrapper, {
            allowAnnotations: props.allowAnnotations,
            appearance: props.appearance,
            contentMode: (0, $dh538.fg)('platform_editor_content_mode_render_context') ? props.contentMode || rendererContext.contentMode || 'standard' : props.contentMode || 'standard',
            allowNestedHeaderLinks: (0, $iNqGB.isNestedHeaderLinksEnabled)(props.allowHeadingAnchorLinks),
            allowColumnSorting: props.allowColumnSorting,
            allowCopyToClipboard: props.allowCopyToClipboard,
            allowWrapCodeBlock: props.allowWrapCodeBlock,
            allowCustomPanels: props.allowCustomPanels,
            allowPlaceholderText: props.allowPlaceholderText,
            useBlockRenderForCodeBlock: rendererContext.featureFlags.useBlockRenderForCodeBlock ?? true,
            addTelepointer: props.addTelepointer,
            innerRef: editorRef,
            onClick: (event)=>$19370cae7f055953$var$handleWrapperOnClick(event, props, mouseDownSelection),
            onMouseDown: onMouseDownEditView,
            ssr: props.media?.ssr,
            isInsideOfInlineExtension: props.isInsideOfInlineExtension,
            isTopLevelRenderer: rendererContext.isTopLevelRenderer,
            shouldRemoveEmptySpaceAroundContent: props.shouldRemoveEmptySpaceAroundContent,
            allowRendererContainerStyles: props.allowRendererContainerStyles
        }, props.enableSsrInlineScripts || props.noOpSSRInlineScript ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, $a8c331734550a1c3$export$cfc1361be0de4203), {
            noOpSSRInlineScript: Boolean(props.noOpSSRInlineScript)
        }) : null, /*#__PURE__*/ (0, $9K4OG.jsx)($19370cae7f055953$var$RendererActionsInternalUpdater, {
            doc: pmDoc,
            schema: schema,
            onAnalyticsEvent: fireAnalyticsEvent
        }, result)))))));
        const rendererResult = props.truncated ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, $af8e00728130c250$export$79ad592494094f07), {
            height: props.maxHeight,
            fadeHeight: props.fadeOutHeight
        }, rendererOutput) : rendererOutput;
        return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, rendererResult);
    } catch (e) {
        if (props.onError) props.onError(e);
        return /*#__PURE__*/ (0, $9K4OG.jsx)($19370cae7f055953$var$RendererWrapper, {
            allowAnnotations: props.allowAnnotations,
            appearance: props.appearance,
            contentMode: (0, $dh538.fg)('platform_editor_content_mode_render_context') ? props.contentMode || rendererContext.contentMode || 'standard' : props.contentMode || 'standard',
            allowCopyToClipboard: props.allowCopyToClipboard,
            allowWrapCodeBlock: props.allowWrapCodeBlock,
            allowPlaceholderText: props.allowPlaceholderText,
            allowColumnSorting: props.allowColumnSorting,
            allowNestedHeaderLinks: (0, $iNqGB.isNestedHeaderLinksEnabled)(props.allowHeadingAnchorLinks),
            useBlockRenderForCodeBlock: rendererContext.featureFlags.useBlockRenderForCodeBlock ?? true,
            addTelepointer: props.addTelepointer,
            onClick: (event)=>$19370cae7f055953$var$handleWrapperOnClick(event, props, mouseDownSelection),
            isTopLevelRenderer: rendererContext.isTopLevelRenderer,
            allowRendererContainerStyles: props.allowRendererContainerStyles
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $iq4lN.default), null));
    }
};
const $19370cae7f055953$var$RendererFunctionalComponentMemoized = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo($19370cae7f055953$export$c49fe2316038f3c2);
const $19370cae7f055953$var$RendererFunctionalComponentWithPortalContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo((props)=>{
    // If nodeComponents are provided, we don't remove portal from props and use context instead,
    // because we can't guarantee compatibility with existing Atlaskit Renderer consumers.
    if (props.nodeComponents) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($19370cae7f055953$var$RendererFunctionalComponentMemoized, props);
    const { portal: portal, ...propsWithoutPortal } = props;
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $eauJy.PortalContext).Provider, {
        value: portal
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($19370cae7f055953$export$c49fe2316038f3c2, propsWithoutPortal));
});
function $19370cae7f055953$export$88530751e3977073(props) {
    const { startPos: startPos } = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext((0, $d7o2V.AnnotationsPositionContext));
    const { isTopLevelRenderer: isTopLevelRenderer } = (0, $bBvs5.useRendererContext)();
    const { skipValidation: skipValidation, allowNestedTables: allowNestedTables } = (0, $42omo.useContext)((0, $iZq0X.ValidationContext)) || {};
    const validationOverrides = (0, $42omo.useMemo)(()=>({
            allowNestedTables: allowNestedTables
        }), [
        allowNestedTables
    ]);
    return /*#__PURE__*/ (0, $9K4OG.jsx)($19370cae7f055953$var$RendererFunctionalComponentWithPortalContext, {
        ...props,
        startPos: startPos,
        isTopLevelRenderer: props.isTopLevelRenderer ?? isTopLevelRenderer,
        skipValidation: skipValidation,
        validationOverrides: validationOverrides
    });
}
const $19370cae7f055953$export$af81ffb59b6ef0dd = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo((props)=>/*#__PURE__*/ (0, $9K4OG.jsx)((0, $ffCOo.FabricEditorAnalyticsContext), {
        data: {
            appearance: (0, $lWghV.getAnalyticsAppearance)(props.appearance),
            packageName: $19370cae7f055953$var$packageName,
            packageVersion: $19370cae7f055953$var$packageVersion,
            componentName: 'renderer',
            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            editorSessionId: (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))()
        }
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $0d5221b11c687d15$export$9ac3d19711324187), {
        render: (createAnalyticsEvent)=>{
            // `IntlErrorBoundary` only captures Internationalisation errors, leaving others for `ErrorBoundary`.
            return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $fZRom.ErrorBoundary), {
                component: (0, $d925B.ACTION_SUBJECT).RENDERER,
                rethrowError: true,
                fallbackComponent: null,
                createAnalyticsEvent: createAnalyticsEvent
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $kckFS.IntlErrorBoundary), null, /*#__PURE__*/ (0, $9K4OG.jsx)($19370cae7f055953$export$88530751e3977073, {
                ...props,
                createAnalyticsEvent: createAnalyticsEvent
            })));
        }
    })));
const $19370cae7f055953$var$RendererWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo((props)=>{
    const { allowColumnSorting: allowColumnSorting, allowNestedHeaderLinks: allowNestedHeaderLinks, innerRef: innerRef, appearance: appearance, contentMode: contentMode, children: children, onClick: onClick, onMouseDown: onMouseDown, useBlockRenderForCodeBlock: useBlockRenderForCodeBlock, addTelepointer: addTelepointer, ssr: ssr, isInsideOfInlineExtension: isInsideOfInlineExtension, allowTableResizing: allowTableResizing, isTopLevelRenderer: isTopLevelRenderer, allowRendererContainerStyles: allowRendererContainerStyles } = props;
    const createTelepointer = ()=>{
        const telepointer = document.createElement('span');
        telepointer.textContent = '\u200b';
        telepointer.id = (0, $1zvWv.TELEPOINTER_ID);
        return telepointer;
    };
    const initialUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(true);
    (0, $42omo.useEffect)(()=>{
        // We must check if window is defined, if it isn't we are in a SSR environment
        // and we don't want to add the telepointer
        if (typeof window !== 'undefined' && addTelepointer && innerRef?.current) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const renderer = innerRef.current.querySelector('.ak-renderer-document');
            if (initialUpdate.current) {
                const lastChild = renderer.lastChild;
                lastChild && lastChild.appendChild(createTelepointer());
            }
            const mutateTelepointer = (mutations)=>{
                mutations.forEach((mutation, index)=>{
                    if (initialUpdate.current) {
                        const oldTelepointer = renderer.querySelector(`#${(0, $1zvWv.TELEPOINTER_ID)}`);
                        if (oldTelepointer) oldTelepointer.remove();
                        const lastChild = renderer.lastChild;
                        lastChild && lastChild.appendChild(createTelepointer());
                        initialUpdate.current = false;
                    }
                    if (mutation.type === 'characterData') {
                        const parentNode = mutation.target.parentElement;
                        if (parentNode) {
                            const oldTelepointer = renderer.querySelector(`#${(0, $1zvWv.TELEPOINTER_ID)}`);
                            if (oldTelepointer) oldTelepointer.remove();
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            parentNode.appendChild(createTelepointer());
                        }
                    }
                    /**
           * When streaming ADF content, we may receive mutations where nodes get
           * replaced, rather than have characterData updated.
           *
           * Telepointer changes will also cause a childList mutation, so we manually ignore it.
           * Telepointer changes are always a singular node-adds or node-removes.
           */ const isAdfStreamingEnabled = (0, $dh538.fg)('platform_editor_ai_adf_prompts_in_all_products') || (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_ai_iw_adf_streaming', 'cohort', 'adf_gpt41mini') || (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_ai_iw_adf_streaming', 'cohort', 'adf_gemini25flash') || (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_ai_non_iw_adf_streaming', 'cohort', 'adf_gpt41mini') || (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_ai_non_iw_adf_streaming', 'cohort', 'adf_gemini25flash');
                    if (isAdfStreamingEnabled && mutation.type === 'childList' && !(mutation.addedNodes.length === 1 && mutation.addedNodes[0]?.id === (0, $1zvWv.TELEPOINTER_ID) || mutation.removedNodes.length === 1 && mutation.removedNodes[0]?.id === (0, $1zvWv.TELEPOINTER_ID))) {
                        const lastChild = renderer.lastChild;
                        if (lastChild) {
                            /**
               * We want to place telepointer inside content (which has data-renderer-start-pos) and
               * inside lines in codeblocks (which have data-ds--code--row).
               */ const contentElements = lastChild.querySelectorAll('[data-renderer-start-pos],[data-ds--code--row]');
                            const lastElement = contentElements[contentElements.length - 1];
                            const oldTelepointer = renderer.querySelector(`#${(0, $1zvWv.TELEPOINTER_ID)}`);
                            if (lastElement) {
                                oldTelepointer?.remove();
                                lastElement?.appendChild(createTelepointer());
                            } else {
                                oldTelepointer?.remove();
                                lastChild?.appendChild(createTelepointer());
                            }
                        }
                    }
                });
            };
            const observer = new MutationObserver(mutateTelepointer);
            observer.observe(innerRef.current, {
                characterData: true,
                attributes: false,
                childList: true,
                subtree: true
            });
            return ()=>observer.disconnect();
        }
    }, [
        innerRef,
        addTelepointer
    ]);
    const renderer = /*#__PURE__*/ (0, $9K4OG.jsx)((0, $bWRlG.WidthProvider), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `ak-renderer-wrapper is-${appearance}`,
        "data-appearance": appearance,
        shouldCheckExistingValue: isInsideOfInlineExtension
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $4BBKV.BaseTheme), {
        baseFontSize: (0, $ec7cc60cabf60b92$export$8e2864079bc476bd)(appearance, contentMode)
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $bd8a5c6aad625abd$export$77218b6ff680865f), {
        ssr: ssr
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $913a570f210a4bc3$export$8f0929e72efe521f), {
        innerRef: innerRef,
        onClick: onClick,
        onMouseDown: onMouseDown,
        appearance: appearance,
        contentMode: contentMode,
        allowNestedHeaderLinks: allowNestedHeaderLinks,
        allowColumnSorting: !!allowColumnSorting,
        useBlockRenderForCodeBlock: useBlockRenderForCodeBlock,
        allowAnnotations: props.allowAnnotations,
        allowTableResizing: allowTableResizing,
        allowRendererContainerStyles: allowRendererContainerStyles
    }, children))));
    // We can only make the wrapper div query container when we have a known width.
    // This is also required for SSR to work correctly. As WidthProvider/WithConsumer will not have the correct width during SSR.
    //
    // allowRendererContainerStyles is not needed for comment container styling as container should always be set for comments
    if (appearance === 'comment' && isTopLevelRenderer && (0, $dh538.fg)('platform-ssr-table-resize')) return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $19370cae7f055953$var$setAsQueryContainerStyles
    }, renderer);
    // We are setting this wrapper div as query container conditionally.
    // Only apply container-type = inline-size when having a known width in full-page/full-width/comment mode.
    // Otherwise when appearance is unspecified the renderer size is decided by the content.
    // In this case we can't set the container-type = inline-size as it will collapse width to 0.
    return (appearance === 'full-page' || appearance === 'full-width') && // In case of having excerpt-include on page there are multiple renderers nested.
    // Make sure only the root renderer is set to be query container.
    isTopLevelRenderer && allowRendererContainerStyles && (0, $dh538.fg)('platform-ssr-table-resize') ? /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $19370cae7f055953$var$setAsQueryContainerStyles
    }, renderer) : renderer;
});
const $19370cae7f055953$var$RootRendererContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(null);
function $19370cae7f055953$var$RendererActionsInternalUpdater({ children: children, doc: doc, schema: schema, onAnalyticsEvent: onAnalyticsEvent }) {
    const rootRendererContextValue = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext($19370cae7f055953$var$RootRendererContext);
    const actions = (0, $42omo.useContext)((0, $lspPP.RendererContext));
    const rendererRef = (0, $42omo.useRef)(null);
    // This doc is used by the renderer actions when applying comments to the document.
    // (via hand crafted steps based on non prosemirror based position calculations)
    // It is set to the root renderer's doc as otherwise the resulting document will
    // be incorrect (nested renderers use a fake document which represents a subset
    // of the actual document).
    let _doc;
    if ((0, $iu6m9.editorExperiment)('comment_on_bodied_extensions', true) && rootRendererContextValue) // If rootRendererContextValue is set -- we are inside a nested renderer
    // and should always use the doc from the root renderer
    _doc = rootRendererContextValue.doc;
    else // If rootRendererContextValue is not set -- we are in the root renderer
    // and set the doc to the current doc.
    _doc = doc;
    (0, $42omo.useLayoutEffect)(()=>{
        if (_doc) actions._privateRegisterRenderer(rendererRef, _doc, schema, onAnalyticsEvent);
        else actions._privateUnregisterRenderer();
        return ()=>actions._privateUnregisterRenderer();
    }, [
        actions,
        schema,
        _doc,
        onAnalyticsEvent
    ]);
    if ((0, $iu6m9.editorExperiment)('comment_on_bodied_extensions', true)) return /*#__PURE__*/ (0, $9K4OG.jsx)($19370cae7f055953$var$RootRendererContext.Provider, {
        value: {
            doc: _doc
        }
    }, children);
    return children;
}
// Usage notes:
// Used by Confluence for nested renderers
// For the View page renderer - see RendererWithAnalytics
const $19370cae7f055953$var$RendererWithAnnotationSelection = (props)=>{
    const { allowAnnotations: allowAnnotations, document: adfDocument } = props;
    const localRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(null);
    const innerRef = props.innerRef || localRef;
    if (!allowAnnotations) // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $9K4OG.jsx)($19370cae7f055953$export$af81ffb59b6ef0dd, {
        innerRef: innerRef,
        ...props
    });
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $lspPP.RendererActionsContext), null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $d7o2V.AnnotationsWrapper), {
        rendererRef: innerRef,
        adfDocument: adfDocument,
        annotationProvider: props.annotationProvider,
        isNestedRender: true
    }, /*#__PURE__*/ (0, $9K4OG.jsx)($19370cae7f055953$export$af81ffb59b6ef0dd, {
        innerRef: innerRef,
        ...props,
        featureFlags: props.featureFlags
    })));
};
var // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
/* @deprecated using this version of the renderer causes the RendererActions to inaccessible from any consumers */ $19370cae7f055953$export$2e2bcd8739ae039 = $19370cae7f055953$var$RendererWithAnnotationSelection;
module.exports["RendererWithAnalytics"] = $19370cae7f055953$export$af81ffb59b6ef0dd;
module.exports["default"] = $19370cae7f055953$export$2e2bcd8739ae039;

});

parcelRegister("4FxUL", function(module, exports) {
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $a192a3f63d3335de$var$isUndefined(x) {
    return x === undefined;
}
class $a192a3f63d3335de$export$2e2bcd8739ae039 {
    static create(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    providers) {
        const providerFactory = new $a192a3f63d3335de$export$2e2bcd8739ae039();
        const keys = Object.keys(providers);
        keys.forEach((name)=>{
            providerFactory.setProvider(name, providers[name]);
        });
        return providerFactory;
    }
    destroy() {
        this.providers.clear();
        this.subscribers.clear();
    }
    isEmpty() {
        return !this.providers.size && !this.subscribers.size;
    }
    setProvider(name, provider) {
        // Do not trigger notifyUpdate if provider is the same.
        if (this.providers.get(name) === provider) return;
        if (!$a192a3f63d3335de$var$isUndefined(provider)) this.providers.set(name, provider);
        else this.providers.delete(name);
        this.notifyUpdated(name, provider);
    }
    removeProvider(name) {
        this.providers.delete(name);
        this.notifyUpdated(name);
    }
    subscribe(name, handler) {
        const handlers = this.subscribers.get(name) || [];
        handlers.push(handler);
        this.subscribers.set(name, handlers);
        const provider = this.providers.get(name);
        if (provider) handler(name, provider);
        return provider;
    }
    unsubscribe(name, handler) {
        const handlers = this.subscribers.get(name);
        if (!handlers) return;
        const index = handlers.indexOf(handler);
        if (index !== -1) handlers.splice(index, 1);
        if (handlers.length === 0) this.subscribers.delete(name);
        else this.subscribers.set(name, handlers);
    }
    unsubscribeAll(name) {
        const handlers = this.subscribers.get(name);
        if (!handlers) return;
        this.subscribers.delete(name);
    }
    hasProvider(name) {
        return this.providers.has(name);
    }
    notifyUpdated(name, provider) {
        const handlers = this.subscribers.get(name);
        if (!handlers) return;
        handlers.forEach((handler)=>{
            handler(name, provider);
        });
    }
    constructor(){
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.providers = new Map();
        this.subscribers = new Map();
    }
}
module.exports["default"] = $a192a3f63d3335de$export$2e2bcd8739ae039;

});

parcelRegister("6mbqi", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4FxUL = parcelRequire("4FxUL");

const $78deebab959b7b48$var$ProviderFactoryContext = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(new (0, $4FxUL.default)());
const $78deebab959b7b48$export$617c134b25cc4265 = $78deebab959b7b48$var$ProviderFactoryContext.Provider;
const $78deebab959b7b48$export$a3af4b6980aa23b5 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext($78deebab959b7b48$var$ProviderFactoryContext);
const $78deebab959b7b48$export$693cdb10cec23617 = (name)=>{
    const [provider, setProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState();
    const providerFactory = $78deebab959b7b48$export$a3af4b6980aa23b5();
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        const providerHandler = (_, provider)=>{
            setProvider(provider);
        };
        providerFactory.subscribe(name, providerHandler);
        return ()=>{
            providerFactory.unsubscribe(name, providerHandler);
        };
    }, [
        name,
        providerFactory
    ]);
    return provider;
};
const $78deebab959b7b48$export$6fde1d0d81db98e1 = (name)=>{
    const [provider, setProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState();
    const providerFactory = $78deebab959b7b48$export$a3af4b6980aa23b5();
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useLayoutEffect(()=>{
        const providerHandler = (_, provider)=>{
            setProvider(provider);
        };
        providerFactory.subscribe(name, providerHandler);
        return ()=>{
            providerFactory.unsubscribe(name, providerHandler);
        };
    }, [
        name,
        providerFactory
    ]);
    return provider;
};
module.exports["ProviderFactoryProvider"] = $78deebab959b7b48$export$617c134b25cc4265;
module.exports["useProvider"] = $78deebab959b7b48$export$693cdb10cec23617;
module.exports["useProviderLayout"] = $78deebab959b7b48$export$6fde1d0d81db98e1;

});

parcelRegister("bWRlG", function(module, exports) {
$parcel$export(module.exports, "WidthConsumer", () => $3aa0833fdfae2152$export$5d8538aa831b6ebb);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $2XqLN = parcelRequire("2XqLN");


var $2P8Ax = parcelRequire("2P8Ax");


var $4JDbp = parcelRequire("4JDbp");


var $eTj7Y = parcelRequire("eTj7Y");

function $3aa0833fdfae2152$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $3aa0833fdfae2152$var$styles = {
    name: "pw7jst",
    styles: "position:relative;width:100%"
};
const $3aa0833fdfae2152$var$SCROLLBAR_WIDTH = 30;
function $3aa0833fdfae2152$export$1eb095b00b926404(width = 0) {
    const MAX_S = 1266;
    const MAX_M = 2146;
    if (width >= MAX_S && width < MAX_M) return 'M';
    else if (width >= MAX_M) return 'L';
    return 'S';
}
function $3aa0833fdfae2152$export$31a4966bffb9ac98(width = 0) {
    return {
        width: width,
        breakpoint: $3aa0833fdfae2152$export$1eb095b00b926404(width)
    };
}
const $3aa0833fdfae2152$export$27e39f636459b9f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext($3aa0833fdfae2152$export$31a4966bffb9ac98());
const { Provider: $3aa0833fdfae2152$var$Provider, Consumer: $3aa0833fdfae2152$export$5d8538aa831b6ebb } = $3aa0833fdfae2152$export$27e39f636459b9f;
const $3aa0833fdfae2152$export$df154c49e93b2ac2 = (0, $2XqLN.default)(()=>{
    return (0, $eTj7Y.isSSR)() ? 0 : document.body?.offsetWidth ?? 0;
});
const $3aa0833fdfae2152$export$7921e18173e8c666 = ({ className: className, shouldCheckExistingValue: shouldCheckExistingValue, children: children })=>{
    const existingContextValue = (0, $42omo.useContext)($3aa0833fdfae2152$export$27e39f636459b9f);
    const [width, setWidth] = (0, $42omo.useState)($3aa0833fdfae2152$export$df154c49e93b2ac2);
    const widthRef = (0, $42omo.useRef)(width);
    const isMountedRef = (0, $42omo.useRef)(true);
    const providerValue = (0, $42omo.useMemo)(()=>$3aa0833fdfae2152$export$31a4966bffb9ac98(width), [
        width
    ]);
    const updateWidth = (0, $42omo.useMemo)(()=>{
        return (0, $2P8Ax.default)((nextWidth)=>{
            const currentWidth = widthRef.current || 0;
            // Ignore changes that are less than SCROLLBAR_WIDTH, otherwise it can cause infinite re-scaling
            if (Math.abs(currentWidth - nextWidth) < $3aa0833fdfae2152$var$SCROLLBAR_WIDTH) return;
            // Avoid React memory leak by checking if the component is still mounted
            if (!isMountedRef.current) return;
            widthRef.current = nextWidth;
            setWidth(nextWidth);
        });
    }, []);
    const skipWidthDetection = shouldCheckExistingValue && existingContextValue.width > 0;
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useLayoutEffect(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $3aa0833fdfae2152$var$styles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className
    }, !skipWidthDetection && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $4JDbp.WidthObserver), {
        setWidth: updateWidth,
        offscreen: true
    }), /*#__PURE__*/ (0, $9K4OG.jsx)($3aa0833fdfae2152$var$Provider, {
        value: providerValue
    }, children)), skipWidthDetection && children);
};
module.exports["getBreakpoint"] = $3aa0833fdfae2152$export$1eb095b00b926404;
module.exports["createWidthContext"] = $3aa0833fdfae2152$export$31a4966bffb9ac98;
module.exports["WidthContext"] = $3aa0833fdfae2152$export$27e39f636459b9f;
module.exports["WidthProvider"] = $3aa0833fdfae2152$export$7921e18173e8c666;

});

parcelRegister("iq4lN", function(module, exports) {
$parcel$export(module.exports, "default", () => $879359e6a013f2d4$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $gmMgo = parcelRequire("gmMgo");


var $aFUXX = parcelRequire("aFUXX");


var $195qZ = parcelRequire("195qZ");


var $3gadb = parcelRequire("3gadb");


var $d925B = parcelRequire("d925B");


var $iCOwP = parcelRequire("iCOwP");


var $juTiU = parcelRequire("juTiU");


var $1QdLR = parcelRequire("1QdLR");

const $879359e6a013f2d4$var$blockNodeStyle = /*#__PURE__*/ (0, $9K4OG.css)({
    background: "var(--ds-background-disabled, #17171708)",
    border: `${"var(--ds-border-width, 1px)"} dashed ${"var(--ds-border-disabled, #0515240F)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: "var(--ds-radius-small, 3px)",
    boxSizing: 'border-box',
    cursor: 'default',
    display: 'flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: (0, $aFUXX.relativeFontSizeToBase16)(14),
    margin: `${"var(--ds-space-100, 8px)"} 0`,
    minHeight: '24px',
    padding: "var(--ds-space-150, 12px)",
    textAlign: 'center',
    verticalAlign: 'text-bottom',
    minWidth: '120px',
    alignItems: 'center',
    justifyContent: 'center'
});
const $879359e6a013f2d4$var$UnsupportedBlockNode = ({ node: node, intl: intl, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
    const message = (0, $1QdLR.getUnsupportedContent)((0, $iCOwP.unsupportedContentMessages).unsupportedBlockContent, (0, $iCOwP.unsupportedContentMessages).unsupportedBlockContent.defaultMessage + ':', node, intl);
    const tooltipContent = intl.formatMessage((0, $iCOwP.unsupportedContentMessages).unsupportedContentTooltip);
    const { current: style } = (0, $42omo.useRef)({
        padding: '4px'
    });
    const originalNodeType = node?.attrs.originalValue.type;
    const tooltipOnShowHandler = (0, $42omo.useCallback)(()=>dispatchAnalyticsEvent && (0, $juTiU.trackUnsupportedContentTooltipDisplayedFor)(dispatchAnalyticsEvent, (0, $d925B.ACTION_SUBJECT_ID).ON_UNSUPPORTED_BLOCK, originalNodeType), [
        dispatchAnalyticsEvent,
        originalNodeType
    ]);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $879359e6a013f2d4$var$blockNodeStyle,
        className: "unsupported"
    }, message, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3gadb.default), {
        content: tooltipContent,
        hideTooltipOnClick: false,
        position: "bottom",
        onShow: tooltipOnShowHandler,
        strategy: "absolute"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        style: style
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($195qZ))), {
        label: "?",
        LEGACY_size: "small"
    })))));
};
var $879359e6a013f2d4$export$2e2bcd8739ae039 = (0, $gmMgo.default)($879359e6a013f2d4$var$UnsupportedBlockNode);

});

parcelRegister("2T4ch", function(module, exports) {

var $aAn37 = parcelRequire("aAn37");

const $0c7596c6c4d45ef6$var$measureMap = new Map();
function $0c7596c6c4d45ef6$export$b62aa2130c86b59b(measureName) {
    if (!(0, $aAn37.isPerformanceAPIAvailable)()) return;
    performance.mark(`${measureName}::start`);
    $0c7596c6c4d45ef6$var$measureMap.set(measureName, performance.now());
}
function $0c7596c6c4d45ef6$export$37c25be427bec097(measureName, onMeasureComplete) {
    if (!(0, $aAn37.isPerformanceAPIAvailable)()) return;
    performance.mark(`${measureName}::end`);
    const start = onMeasureComplete ? $0c7596c6c4d45ef6$var$measureMap.get(measureName) : undefined;
    try {
        performance.measure(measureName, `${measureName}::start`, `${measureName}::end`);
    } catch (error) {} finally{
        if (onMeasureComplete) {
            const entry = performance.getEntriesByName(measureName).pop();
            if (entry) onMeasureComplete(entry.duration, entry.startTime);
            else if (start) onMeasureComplete(performance.now() - start, start);
        }
        $0c7596c6c4d45ef6$export$6f766653554dac02(measureName);
    }
}
function $0c7596c6c4d45ef6$export$6f766653554dac02(measureName) {
    if (!(0, $aAn37.isPerformanceAPIAvailable)()) return;
    $0c7596c6c4d45ef6$var$measureMap.delete(measureName);
    performance.clearMarks(`${measureName}::start`);
    performance.clearMarks(`${measureName}::end`);
    performance.clearMeasures(measureName);
}
function $0c7596c6c4d45ef6$export$b0a51f9f0047ea32(measureName) {
    if (!(0, $aAn37.isPerformanceAPIAvailable)()) return false;
    return $0c7596c6c4d45ef6$var$measureMap.get(measureName) !== undefined;
}
module.exports["startMeasure"] = $0c7596c6c4d45ef6$export$b62aa2130c86b59b;
module.exports["stopMeasure"] = $0c7596c6c4d45ef6$export$37c25be427bec097;
module.exports["clearMeasure"] = $0c7596c6c4d45ef6$export$6f766653554dac02;
module.exports["isMeasuring"] = $0c7596c6c4d45ef6$export$b0a51f9f0047ea32;

});

parcelRegister("aAn37", function(module, exports) {
let $5fe8bf23ec0d3d67$var$hasRequiredPerformanceAPIs;
function $5fe8bf23ec0d3d67$export$b5717a625dd4a3eb() {
    if ($5fe8bf23ec0d3d67$var$hasRequiredPerformanceAPIs === undefined) $5fe8bf23ec0d3d67$var$hasRequiredPerformanceAPIs = typeof window !== 'undefined' && 'performance' in window && [
        'measure',
        'clearMeasures',
        'clearMarks',
        'getEntriesByName',
        'getEntriesByType',
        'now'
    ].every((api)=>!!performance[api]);
    return $5fe8bf23ec0d3d67$var$hasRequiredPerformanceAPIs;
}
function $5fe8bf23ec0d3d67$export$48995af1e77d8643() {
    return !!(typeof window !== 'undefined' && 'PerformanceObserver' in window);
}
function $5fe8bf23ec0d3d67$export$4370ec0f52022f66() {
    return $5fe8bf23ec0d3d67$export$48995af1e77d8643() && PerformanceObserver.supportedEntryTypes && PerformanceObserver.supportedEntryTypes.includes('longtask');
}
module.exports["isPerformanceAPIAvailable"] = $5fe8bf23ec0d3d67$export$b5717a625dd4a3eb;
module.exports["isPerformanceObserverAvailable"] = $5fe8bf23ec0d3d67$export$48995af1e77d8643;

});

parcelRegister("jz9wK", function(module, exports) {

var $aAn37 = parcelRequire("aAn37");

const $ecd76f47871a107c$export$70f7d127254a90c = ()=>{
    if (typeof document === 'undefined') return {
        distortedDuration: false,
        cleanup () {}
    };
    // If an editor is rendered when the document is not visible -- the callback passed to
    // requestAnimationFrame will not fire until the document becomes visible again.
    //
    // For the purposes of using performance measurement -- this behaviour means the events
    // which have been fired in the background are not useful -- and lead to other events
    // being hard to draw conclusions from.
    //
    // To mitigate this -- we detect this state -- and fire a separate callback when the
    // measurement has occurred when the render was in the background
    let distortedDuration = document.visibilityState !== 'visible';
    function handleVisibilityChange() {
        if (document.visibilityState !== 'visible') distortedDuration = true;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return {
        distortedDuration: distortedDuration,
        /**
		 * Cleans up the document visibility event listener
		 */ cleanup () {
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        }
    };
};
function $ecd76f47871a107c$export$267ed650a5d21ae6(/**
	 * Unique name for the measurement
	 *
	 * Important: if multiple measureRender events are fired at the same time
	 * with the same measure name -- the result will not be correct.
	 */ measureName, /**
	 * Call back fired when the measurement completes.
	 *
	 * Note: when this function is called when the Document.visibilityState is not
	 * visible -- the duration is likely to be misleading/inaccurate. This is due
	 * to the measurements use of the `requestAnimationFrame` api which only fires
	 * when the Document.visibilityState is visible.
	 */ onMeasureComplete) {
    if (!(0, $aAn37.isPerformanceAPIAvailable)()) return;
    const startMark = `[START]: ${measureName}`;
    const endMark = `[END]: ${measureName}`;
    const startTime = performance.now();
    performance.mark(startMark);
    const distortedDurationMonitor = $ecd76f47871a107c$export$70f7d127254a90c();
    requestAnimationFrame(()=>{
        requestAnimationFrame(()=>{
            performance.mark(endMark);
            distortedDurationMonitor.cleanup();
            const duration = performance.now() - startTime;
            try {
                performance.measure(measureName, startMark, endMark);
                const entry = performance.getEntriesByName(measureName).pop();
                if (!entry) onMeasureComplete({
                    duration: duration,
                    startTime: startTime,
                    distortedDuration: distortedDurationMonitor.distortedDuration
                });
                else onMeasureComplete({
                    duration: entry.duration,
                    startTime: entry.startTime,
                    distortedDuration: distortedDurationMonitor.distortedDuration
                });
            } catch (e) {
                onMeasureComplete({
                    duration: duration,
                    startTime: startTime,
                    distortedDuration: distortedDurationMonitor.distortedDuration
                });
            }
            performance.clearMeasures(measureName);
            performance.clearMarks(startMark);
            performance.clearMarks(endMark);
        });
    });
}
module.exports["getDistortedDurationMonitor"] = $ecd76f47871a107c$export$70f7d127254a90c;
module.exports["measureRender"] = $ecd76f47871a107c$export$267ed650a5d21ae6;

});

parcelRegister("8pwxt", function(module, exports) {

var $aAn37 = parcelRequire("aAn37");

function $7ee14385cde98d2c$export$92d097a1155bbe27() {
    if (!(0, $aAn37.isPerformanceAPIAvailable)()) return;
    const nav = performance.getEntriesByType('navigation')[0];
    if (nav) return nav.responseEnd;
    return;
}
module.exports["getResponseEndTime"] = $7ee14385cde98d2c$export$92d097a1155bbe27;

});

parcelRegister("lWghV", function(module, exports) {

var $7i8J9 = parcelRequire("7i8J9");


var $ks2lK = parcelRequire("ks2lK");


var $8m4tT = parcelRequire("8m4tT");


var $7XFGZ = parcelRequire("7XFGZ");

const $b76cb162368f342e$export$be87849653b93e6b = (appearance)=>{
    switch(appearance){
        case 'full-page':
            return (0, $7i8J9.EDITOR_APPEARANCE_CONTEXT).FIXED_WIDTH;
        case 'full-width':
            return (0, $7i8J9.EDITOR_APPEARANCE_CONTEXT).FULL_WIDTH;
        case 'comment':
            return (0, $7i8J9.EDITOR_APPEARANCE_CONTEXT).COMMENT;
        case 'chromeless':
            return (0, $7i8J9.EDITOR_APPEARANCE_CONTEXT).CHROMELESS;
        case 'mobile':
            return (0, $7i8J9.EDITOR_APPEARANCE_CONTEXT).MOBILE;
    }
};
const $b76cb162368f342e$export$31ae53e002edded0 = (editorAppearance)=>editorAppearance ? `editor_${$b76cb162368f342e$export$be87849653b93e6b(editorAppearance)}` : '_unknown';
const $b76cb162368f342e$export$f8edd689e8b20f3a = (duration, normalThreshold, degradedThreshold)=>{
    if (duration > normalThreshold && duration <= degradedThreshold) return "degraded";
    if (duration > degradedThreshold) return "blocking";
    return "normal";
};
function $b76cb162368f342e$export$d770b562ead089d8(selection) {
    const { schema: schema, name: name } = selection.$from.doc.type;
    if (selection instanceof (0, $ks2lK.NodeSelection)) return selection.node.type.name;
    if (selection instanceof (0, $7XFGZ.CellSelection)) return schema.nodes.table.name;
    // Text selection
    const parentNodeInfo = (0, $8m4tT.findParentNode)((node)=>node.type !== schema.nodes.paragraph)(selection);
    return parentNodeInfo ? parentNodeInfo.node.type.name : name;
}
var $b76cb162368f342e$export$6a6bef12562cd865 = /*#__PURE__*/ function(SEVERITY) {
    SEVERITY["NORMAL"] = "normal";
    SEVERITY["DEGRADED"] = "degraded";
    SEVERITY["BLOCKING"] = "blocking";
    return SEVERITY;
}({});
const $b76cb162368f342e$export$288273ee3e3b6132 = 'EDITOR_ANALYTICS_EVENT';
const $b76cb162368f342e$var$EDITOR_BREAKPOINT_WIDTH = {
    S: 760,
    M: 1600,
    L: Infinity
};
const $b76cb162368f342e$var$TABLE_BREAKPOINT_KEYS = Object.keys($b76cb162368f342e$var$EDITOR_BREAKPOINT_WIDTH);
const $b76cb162368f342e$export$afdcbbd112676ca8 = (width)=>{
    return $b76cb162368f342e$var$TABLE_BREAKPOINT_KEYS.find((key)=>width <= $b76cb162368f342e$var$EDITOR_BREAKPOINT_WIDTH[key]) || 'L';
};
module.exports["getAnalyticsAppearance"] = $b76cb162368f342e$export$be87849653b93e6b;
module.exports["getAnalyticsEditorAppearance"] = $b76cb162368f342e$export$31ae53e002edded0;
module.exports["getAnalyticsEventSeverity"] = $b76cb162368f342e$export$f8edd689e8b20f3a;
module.exports["findInsertLocation"] = $b76cb162368f342e$export$d770b562ead089d8;
module.exports["analyticsEventKey"] = $b76cb162368f342e$export$288273ee3e3b6132;
module.exports["getBreakpointKey"] = $b76cb162368f342e$export$afdcbbd112676ca8;

});

parcelRegister("NPJKR", function(module, exports) {
// START: temporary code https://product-fabric.atlassian.net/browse/ED-10260
const $10cc70c3cd038eda$export$5b59d3e9e22dbdc6 = ()=>{
    try {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const { FRONTEND_VERSION: FRONTEND_VERSION = '' } = window.__buildInfo || {};
        return window.location.hostname === 'product-fabric.atlassian.net' && FRONTEND_VERSION.includes('branch-deploy');
    } catch (err) {
        // eslint-disable-next-line no-console
        console.warn(err);
        return false;
    }
}; // END:  temporary code  https://product-fabric.atlassian.net/browse/ED-10260
module.exports["shouldForceTracking"] = $10cc70c3cd038eda$export$5b59d3e9e22dbdc6;

});

parcelRegister("9ciHB", function(module, exports) {

var $5nZsM = parcelRequire("5nZsM");


var $kB2tR = parcelRequire("kB2tR");

const $afdd01693dbe3419$var$EMPTY = {};
function $afdd01693dbe3419$var$isObjectFlagKey(key, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
value, objectFlagKeys) {
    return Boolean(typeof value === 'string' && objectFlagKeys?.includes(key));
}
function $afdd01693dbe3419$var$isValidJSONObject(value) {
    try {
        const result = JSON.parse(value);
        if (typeof result === 'object' && result !== null) return true;
        return false;
    } catch (err) {
        return false;
    }
}
function $afdd01693dbe3419$export$f1485fc4974593c0(rawFeatureFlags, options) {
    if (!rawFeatureFlags) return $afdd01693dbe3419$var$EMPTY;
    return Object.entries(rawFeatureFlags).filter((e)=>{
        if (typeof e[1] === 'boolean') return true;
        if ($afdd01693dbe3419$var$isObjectFlagKey((0, (/*@__PURE__*/$parcel$interopDefault($5nZsM)))(e[0]), e[1], options?.objectFlagKeys) && $afdd01693dbe3419$var$isValidJSONObject(e[1])) return true;
        return false;
    }).filter(([key])=>(0, (/*@__PURE__*/$parcel$interopDefault($kB2tR)))(key) === key).map(([key, value])=>[
            (0, (/*@__PURE__*/$parcel$interopDefault($5nZsM)))(key),
            value
        ]).reduce((flags, [key, value])=>{
        if ($afdd01693dbe3419$var$isObjectFlagKey(key, value, options?.objectFlagKeys)) flags[key] = JSON.parse(value);
        if (typeof value === 'boolean') flags[key] = value;
        return flags;
    }, {});
}
function $afdd01693dbe3419$export$6d018dd0f6cbebcb(featureFlags) {
    return Object.keys(featureFlags).filter((key)=>featureFlags[key] === true);
}
module.exports["normalizeFeatureFlags"] = $afdd01693dbe3419$export$f1485fc4974593c0;
module.exports["getEnabledFeatureFlagKeys"] = $afdd01693dbe3419$export$6d018dd0f6cbebcb;

});

parcelRegister("kB2tR", function(module, exports) {

var $2Ed9T = parcelRequire("2Ed9T");

/**
 * Converts `string` to
 * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the kebab cased string.
 * @example
 *
 * _.kebabCase('Foo Bar');
 * // => 'foo-bar'
 *
 * _.kebabCase('fooBar');
 * // => 'foo-bar'
 *
 * _.kebabCase('__FOO_BAR__');
 * // => 'foo-bar'
 */ var $efe92ff277fe7159$var$kebabCase = $2Ed9T(function(result, word, index) {
    return result + (index ? '-' : '') + word.toLowerCase();
});
module.exports = $efe92ff277fe7159$var$kebabCase;

});

parcelRegister("aUnCJ", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $5SAOw = parcelRequire("5SAOw");


var $1oCLl = parcelRequire("1oCLl");


var $iu6m9 = parcelRequire("iu6m9");

parcelRequire("hlcQd");
var $8jc2v = parcelRequire("8jc2v");
var $hlcQd = parcelRequire("hlcQd");




parcelRequire("42omo");

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");

var $95b75d6dcf8c3302$export$c1bd4813440b4505 = /*#__PURE__*/ function(InsertDraftPosition) {
    InsertDraftPosition["AROUND_TEXT"] = "AROUND_TEXT";
    InsertDraftPosition["START"] = "START";
    InsertDraftPosition["END"] = "END";
    InsertDraftPosition["INSIDE"] = "INSIDE";
    return InsertDraftPosition;
}({});





const $1ab33d55077bc7e8$export$a9795c84b22a1f06 = (reactNode)=>{
    let result = null;
    const children = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.toArray(reactNode);
    for (const childNode of children){
        if (result) break;
        else if (typeof childNode === 'string') result = childNode;
        else if ($1ab33d55077bc7e8$var$isReactElement(childNode) && childNode.props.children) result = $1ab33d55077bc7e8$export$a9795c84b22a1f06(childNode.props.children);
    }
    return result;
};
function $1ab33d55077bc7e8$var$isReactElement(child) {
    return !!child.type;
}
const $1ab33d55077bc7e8$export$2878cc467c8be8fe = (text, { startOffset: startOffset, endOffset: endOffset })=>{
    if (endOffset > text.length || endOffset - startOffset <= 0) return null;
    return [
        text.slice(0, startOffset),
        text.slice(startOffset, endOffset),
        text.slice(endOffset)
    ].filter(Boolean);
};
const $1ab33d55077bc7e8$export$1059bfc467f4f55d = (position, textPosition, text)=>{
    const { start: start, end: end } = textPosition;
    const startOffset = Math.max(position.from - start, 0);
    const endOffset = Math.min(Math.abs(end - position.to - text.length), text.length);
    return {
        startOffset: startOffset,
        endOffset: endOffset
    };
};



const $6bc9d398fb95b20f$export$b1baddbd5f289877 = ({ start: startTextPosition, end: endTextPosition }, position)=>{
    const isRangePositionAroundText = position.from <= startTextPosition && position.to >= endTextPosition;
    if (isRangePositionAroundText) return (0, $95b75d6dcf8c3302$export$c1bd4813440b4505).AROUND_TEXT;
    const isRangePositionInsideText = position.from > startTextPosition && position.from < endTextPosition && position.to < endTextPosition && position.to > startTextPosition;
    if (isRangePositionInsideText) return (0, $95b75d6dcf8c3302$export$c1bd4813440b4505).INSIDE;
    const isRangePositionStartingAtText = position.from >= startTextPosition && position.from <= endTextPosition && position.to >= endTextPosition;
    if (isRangePositionStartingAtText) return (0, $95b75d6dcf8c3302$export$c1bd4813440b4505).END;
    const isRangePositionEndingAtText = position.from <= startTextPosition && position.to >= startTextPosition && position.to <= endTextPosition;
    if (isRangePositionEndingAtText) return (0, $95b75d6dcf8c3302$export$c1bd4813440b4505).START;
    return false;
};



var $jZG1P = parcelRequire("jZG1P");

function $5f4b8fc731c93068$export$93301b6f1ff0b0c3(text, highlighter) {
    if (!highlighter || !text) return [
        {
            type: 'plain',
            text: text ?? ''
        }
    ];
    const segments = [];
    let pos = 0;
    try {
        const markTextSegmentMatches = text.matchAll(highlighter.pattern);
        for (const markTextMatch of markTextSegmentMatches){
            if (markTextMatch.index !== 0) segments.push({
                type: 'plain',
                text: text.substring(pos, markTextMatch.index)
            });
            segments.push({
                type: 'match',
                text: markTextMatch[0],
                groups: markTextMatch.groups && // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                Object.keys(markTextMatch.groups).filter((key)=>markTextMatch.groups[key])
            });
            pos = markTextMatch.index + markTextMatch[0].length;
        }
        if (pos < text.length) segments.push({
            type: 'plain',
            text: text.substring(pos)
        });
        return segments;
    } catch (_e) {}
    return [
        {
            type: 'plain',
            text: text
        }
    ];
}








function $53c7ce50256f5198$export$8a20fd0614851c5f(segments, textHighlighter, marksList, startPos) {
    const Component = textHighlighter?.component;
    const marks = new Set(marksList.map((m)=>m.type.name));
    function renderSegment(segment, idx = 0) {
        if (segment.type === 'plain' || !Component) return segment.text;
        return /*#__PURE__*/ (0, $l998X.jsx)("span", {
            "data-highlighted": true,
            "data-vc": "highlighted-text",
            children: /*#__PURE__*/ (0, $l998X.jsx)(Component, {
                match: segment.text,
                groups: segment.groups,
                marks: marks,
                startPos: startPos + idx,
                children: segment.text
            }, `${segment.text}_${startPos}_${idx}`)
        });
    }
    if (segments.length === 1) return renderSegment(segments[0]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
        children: segments.map(renderSegment)
    }, `text-wrapper_${startPos}`);
}



var $jSHzw = parcelRequire("jSHzw");


var $3h7Ko = parcelRequire("3h7Ko");

// Localized AnnotationSharedCSSByState().common and AnnotationSharedCSSByState().focus
const $5f8afa0614c300d4$var$markStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    color: 'inherit',
    backgroundColor: 'unset',
    WebkitTapHighlightColor: 'transparent',
    borderBottom: `${"var(--ds-border-width-selected, 2px)"} solid transparent`,
    cursor: 'pointer',
    padding: '1px 0 2px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:has(.card), &:has([data-inline-card])': {
        padding: '5px 0 3px 0'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:has(.date-lozenger-container)': {
        paddingTop: "var(--ds-space-025, 2px)"
    },
    background: "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
    borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
    boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)"
});
const $5f8afa0614c300d4$export$8062d68eccdfa39c = ({ draftPosition: draftPosition, children: children })=>{
    const { dispatch: dispatch } = (0, $jSHzw.useAnnotationManagerDispatch)();
    const markRef = (0, $42omo.useCallback)((node)=>{
        dispatch({
            type: 'setDraftMarkRef',
            data: {
                draftMarkRef: node ?? undefined
            }
        });
    }, [
        dispatch
    ]);
    return /*#__PURE__*/ (0, $9K4OG.jsx)("mark", {
        "data-renderer-mark": true,
        ...(0, $jZG1P.dataAttributes)(draftPosition),
        css: $5f8afa0614c300d4$var$markStyles,
        ref: markRef
    }, children);
};
const $5f8afa0614c300d4$export$846ef6158669db08 = (annotationPosition, fragmentCount)=>{
    if (annotationPosition === (0, $95b75d6dcf8c3302$export$c1bd4813440b4505).START) return 0;
    if (annotationPosition === (0, $95b75d6dcf8c3302$export$c1bd4813440b4505).END) return fragmentCount - 1;
    if (annotationPosition === (0, $95b75d6dcf8c3302$export$c1bd4813440b4505).INSIDE && fragmentCount === 3) return 1;
    return -1;
};
const $5f8afa0614c300d4$export$b756d37afc321d72 = ({ texts: texts, shouldApplyAnnotationAt: shouldApplyAnnotationAt, draftPosition: draftPosition, textHighlighter: textHighlighter, marks: marks })=>{
    const annotateIndex = $5f8afa0614c300d4$export$846ef6158669db08(shouldApplyAnnotationAt, texts.length);
    return texts.map((value, index)=>{
        const segments = (0, $5f4b8fc731c93068$export$93301b6f1ff0b0c3)(value, textHighlighter);
        if (annotateIndex === index) return(// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        /*#__PURE__*/ (0, $9K4OG.jsx)($5f8afa0614c300d4$export$8062d68eccdfa39c, {
            key: index,
            draftPosition: draftPosition
        }, (0, $53c7ce50256f5198$export$8a20fd0614851c5f)(segments, textHighlighter, marks || [], draftPosition.from)));
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
            key: index
        }, (0, $53c7ce50256f5198$export$8a20fd0614851c5f)(segments, textHighlighter, marks || [], draftPosition.from)));
    });
};
const $5f8afa0614c300d4$export$69a4e0ac39aaf9b7 = ({ startPos: startPos, endPos: endPos, children: children, textHighlighter: textHighlighter, marks: marks })=>{
    const textPosition = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>({
            start: startPos,
            end: endPos
        }), [
        endPos,
        startPos
    ]);
    const { selectionDraftDocumentPosition: nextDraftPosition } = (0, $3h7Ko.useAnnotationRangeState)();
    const shouldApplyAnnotationAt = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>{
        if (!nextDraftPosition) return false;
        return (0, $6bc9d398fb95b20f$export$b1baddbd5f289877)(textPosition, nextDraftPosition);
    }, [
        nextDraftPosition,
        textPosition
    ]);
    const textString = (0, $1ab33d55077bc7e8$export$a9795c84b22a1f06)(children);
    if (!textString) return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, children);
    if (shouldApplyAnnotationAt === false || !nextDraftPosition) {
        const segments = (0, $5f4b8fc731c93068$export$93301b6f1ff0b0c3)(textString, textHighlighter);
        return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, (0, $53c7ce50256f5198$export$8a20fd0614851c5f)(segments, textHighlighter, marks || [], startPos));
    }
    if (shouldApplyAnnotationAt === (0, $95b75d6dcf8c3302$export$c1bd4813440b4505).AROUND_TEXT) {
        const segments = (0, $5f4b8fc731c93068$export$93301b6f1ff0b0c3)(textString, textHighlighter);
        return /*#__PURE__*/ (0, $9K4OG.jsx)($5f8afa0614c300d4$export$8062d68eccdfa39c, {
            key: 0,
            draftPosition: nextDraftPosition
        }, (0, $53c7ce50256f5198$export$8a20fd0614851c5f)(segments, textHighlighter, marks || [], startPos));
    }
    const offsets = (0, $1ab33d55077bc7e8$export$1059bfc467f4f55d)(nextDraftPosition, textPosition, textString);
    const texts = (0, $1ab33d55077bc7e8$export$2878cc467c8be8fe)(textString, offsets);
    if (!texts) {
        const segments = (0, $5f4b8fc731c93068$export$93301b6f1ff0b0c3)(textString, textHighlighter);
        return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, (0, $53c7ce50256f5198$export$8a20fd0614851c5f)(segments, textHighlighter, marks || [], startPos));
    }
    const components = $5f8afa0614c300d4$export$b756d37afc321d72({
        texts: texts,
        shouldApplyAnnotationAt: shouldApplyAnnotationAt,
        draftPosition: nextDraftPosition,
        textHighlighter: textHighlighter,
        marks: marks
    });
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, components);
};


const $3ab91fd4d23d289e$var$TextWrapper = (props)=>{
    const { startPos: startPos, endPos: endPos } = props;
    const { children: children } = props;
    if (!children) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $5f8afa0614c300d4$export$69a4e0ac39aaf9b7), {
        startPos: startPos,
        endPos: endPos,
        textHighlighter: props.textHighlighter,
        marks: props.marks,
        children: children
    });
};
var $3ab91fd4d23d289e$export$2e2bcd8739ae039 = $3ab91fd4d23d289e$var$TextWrapper;



var $iNqGB = parcelRequire("iNqGB");


var $caYZ2 = parcelRequire("caYZ2");


var $bSXAs = parcelRequire("bSXAs");


var $8m4tT = parcelRequire("8m4tT");


var $dh538 = parcelRequire("dh538");


var $b7FrM = parcelRequire("b7FrM");


var $7nUdN = parcelRequire("7nUdN");
/* eslint-disable @atlaskit/editor/no-re-export */ // Mapping file

var $GH4gU = parcelRequire("GH4gU");


var $hMQQ9 = parcelRequire("hMQQ9");


var $g5cj9 = parcelRequire("g5cj9");


var $jyYl7 = parcelRequire("jyYl7");


var $cHFH7 = parcelRequire("cHFH7");


var $2KFEz = parcelRequire("2KFEz");


var $6wVZ8 = parcelRequire("6wVZ8");


var $4XjCW = parcelRequire("4XjCW");


var $6ObvC = parcelRequire("6ObvC");


var $hJ84o = parcelRequire("hJ84o");

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("42omo");





var $ecu6E = parcelRequire("ecu6E");

const $82b4ce436e9fddb4$var$MarkWrapper = (props)=>{
    const dataAlign = props['data-align'] ? (0, $ecu6E.alignmentPositionMap)[props['data-align']] : undefined;
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        style: {
            textAlign: dataAlign
        },
        ...props
    }, props.children);
};
function $82b4ce436e9fddb4$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $9K4OG.jsx)($82b4ce436e9fddb4$var$MarkWrapper, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-editor-block-mark fabric-editor-alignment",
        "data-align": props.align
    }, props.children);
}





parcelRequire("42omo");

function $a3a9aa36f44a86d5$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-editor-block-mark fabric-editor-indentation-mark",
        "data-level": props.level,
        children: props.children
    });
}



var $9DaqG = parcelRequire("9DaqG");


var $gwCgB = parcelRequire("gwCgB");


var $118BP = parcelRequire("118BP");


var $a6ktG = parcelRequire("a6ktG");





var $5UG0R = parcelRequire("5UG0R");







class $9e616c67c8d349d1$export$2e2bcd8739ae039 extends (0, $42omo.Component) {
    render() {
        const { reference: reference, children: children } = this.props;
        return /*#__PURE__*/ (0, $l998X.jsx)("span", {
            "data-mark-type": "confluenceInlineComment",
            "data-reference": reference,
            children: children
        });
    }
}


const $75a8f360c7129c0b$export$c00d967a0f56fdb7 = {
    code: (0, $GH4gU.default),
    em: (0, $hMQQ9.default),
    link: (0, $g5cj9.default),
    strike: (0, $jyYl7.default),
    strong: (0, $cHFH7.default),
    subsup: (0, $2KFEz.default),
    textColor: (0, $6wVZ8.default),
    backgroundColor: (0, $4XjCW.default),
    underline: (0, $6ObvC.default),
    annotation: (0, $7nUdN.default),
    border: (0, $5UG0R.default),
    // Stage0
    confluenceInlineComment: (0, $9e616c67c8d349d1$export$2e2bcd8739ae039),
    breakout: (0, $hJ84o.default),
    alignment: (0, $82b4ce436e9fddb4$export$2e2bcd8739ae039),
    indentation: (0, $a3a9aa36f44a86d5$export$2e2bcd8739ae039),
    unsupportedMark: (0, $9DaqG.default),
    unsupportedNodeAttribute: (0, $gwCgB.default),
    dataConsumer: (0, $118BP.default),
    fragment: (0, $a6ktG.default)
};
const $75a8f360c7129c0b$export$d4334b129116aad7 = (mark)=>{
    return $75a8f360c7129c0b$export$c00d967a0f56fdb7[mark.type.name];
};





const $816aa5ff776b1fd8$var$isLayoutNode = (node)=>node.type.name === 'layoutSection';
const $816aa5ff776b1fd8$var$hasBreakOutMark = (node)=>node.marks.some((m)=>m.type.name === 'breakout');
const $816aa5ff776b1fd8$export$d7bc71cca336a3b = (path)=>path.some((item)=>$816aa5ff776b1fd8$var$isLayoutNode(item) && $816aa5ff776b1fd8$var$hasBreakOutMark(item));
const $816aa5ff776b1fd8$export$42ddc573eb5a7b43 = (path, schema)=>{
    const { nodes: { expand: expand, nestedExpand: nestedExpand, layoutColumn: layoutColumn } } = schema;
    const blockNodeNames = [
        expand,
        nestedExpand,
        layoutColumn
    ].filter((node)=>Boolean(node)).map((node)=>node.name);
    return path && path.some((n)=>n.type && blockNodeNames.indexOf(n.type.name) > -1);
};
const $816aa5ff776b1fd8$export$9f1e9347b0411934 = (path, schema)=>{
    const { nodes: { multiBodiedExtension: multiBodiedExtension } } = schema;
    return path.some((n)=>n.type === multiBodiedExtension);
};
const $816aa5ff776b1fd8$export$244bf4b32387ef62 = (path, schema)=>{
    const { nodes: { table: table } } = schema;
    return path.some((n)=>n.type === table);
};





var $aUnCJ = parcelRequire("aUnCJ");

const $96ace269c0bdcf98$export$eeb66772b38d7581 = (content)=>{
    const standaloneMarks = [];
    // keep track of the previous node's state
    let prev = {
        selfSpaceOnTheRight: true
    };
    let prevNode = null;
    // Iterates through each node in the content array.
    // Tracks if the previous node had a backgroundColor mark and if it ended with a space.
    // If a backgroundColor mark is followed by a text node that starts with a space,
    // and the previous node ended with a space, the previous backgroundColor mark is considered standalone.
    // At the end, flushes any remaining node that meets the standalone criteria.
    for(let i = 0; i < content.length; i++){
        const node = content[i];
        const nodeMarks = (0, $aUnCJ.default).getMarks(node);
        const isBackgroundColor = nodeMarks.some((m)=>m.type.name === 'backgroundColor');
        let selfSpaceOnTheLeft = false;
        let selfSpaceOnTheRight = false;
        if (node.text) {
            selfSpaceOnTheLeft = node.text.startsWith(' ');
            selfSpaceOnTheRight = node.text.endsWith(' ');
        }
        if (isBackgroundColor) {
            prevNode = node;
            prev = {
                selfSpaceOnTheRight: false,
                hasBackgroundColor: true,
                spaceToTheLeft: prev !== null && prev.selfSpaceOnTheRight
            };
        } else {
            // If prev exists, check for standalone logic
            if (prev && prev.hasBackgroundColor && prevNode) // If prev had space on the left and current is a TextNode and has space on the left
            {
                if (prev.spaceToTheLeft && selfSpaceOnTheLeft) {
                    const mark = (0, $aUnCJ.default).getMarks(prevNode).find((m)=>m.type.name === 'backgroundColor');
                    if (mark) standaloneMarks.push(mark);
                }
            }
            prevNode = null;
            prev = {
                selfSpaceOnTheRight: selfSpaceOnTheRight,
                hasBackgroundColor: false
            };
        }
    }
    if (prevNode) {
        if (prev && prev.hasBackgroundColor && prev.spaceToTheLeft) {
            const mark = (0, $aUnCJ.default).getMarks(prevNode).find((m)=>m.type.name === 'backgroundColor');
            if (mark) standaloneMarks.push(mark);
        }
    }
    return standaloneMarks;
};


function $4b5cdd4f3b34cbcf$var$mergeMarks(marksAndNodes) {
    return marksAndNodes.reduce((acc, markOrNode)=>{
        const prev = acc.length && acc[acc.length - 1] || null;
        if (markOrNode.type instanceof (0, $5SAOw.MarkType) && prev && prev.type instanceof (0, $5SAOw.MarkType) && Array.isArray(prev.content) && (0, $bSXAs.isSameMark)(prev, markOrNode)) prev.content = $4b5cdd4f3b34cbcf$var$mergeMarks(prev.content.concat(markOrNode.content));
        else acc.push(markOrNode);
        return acc;
    }, []);
}
class $4b5cdd4f3b34cbcf$export$2e2bcd8739ae039 {
    resetState() {
        this.headingIds = [];
        this.expandHeadingIds = [];
        this.startPos = this.initStartPos;
    }
    getNodeProps(node, parentInfo) {
        const path = parentInfo ? parentInfo.path : undefined;
        switch(node.type.name){
            case 'date':
                return this.getDateProps(node, parentInfo, path);
            case 'hardBreak':
                return this.getHardBreakProps(node, path);
            case 'heading':
                return this.getHeadingProps(node, path);
            case 'media':
                return this.getMediaProps(node, path);
            case 'emoji':
                return this.getEmojiProps(node, path);
            case 'extension':
            case 'bodiedExtension':
                return this.getExtensionProps(node, path);
            case 'mediaGroup':
                return this.getMediaGroupProps(node);
            case 'mediaInline':
                return this.getMediaInlineProps(node);
            case 'mediaSingle':
                return this.getMediaSingleProps(node, path);
            case 'table':
                return this.getTableProps(node, path);
            case 'tableHeader':
            case 'tableRow':
                return this.getTableChildrenProps(node);
            case 'taskItem':
                return this.getTaskItemProps(node, path);
            case 'embedCard':
                return this.getEmbedCardProps(node, path);
            case 'blockCard':
                return this.getBlockCardProps(node, path);
            case 'expand':
                return this.getExpandProps(node, path);
            case 'unsupportedBlock':
            case 'unsupportedInline':
                return this.getUnsupportedContentProps(node);
            case 'codeBlock':
                return this.getCodeBlockProps(node);
            case 'panel':
                return this.getPanelProps(node);
            default:
                return this.getProps(node, path);
        }
    }
    serializeFragment(fragment, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    props = {}, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    target = this.allowSelectAllTrap ? (0, $8jc2v.DocWithSelectAllTrap) : (0, $8jc2v.default), key = 'root-0', parentInfo) {
        // This makes sure that we reset internal state on re-render.
        if (key === 'root-0') this.resetState();
        return this.renderNode(target, props, key, $4b5cdd4f3b34cbcf$export$2e2bcd8739ae039.getChildNodes(fragment).map((node, index)=>{
            if ((0, $hlcQd.isTextWrapper)(node)) return this.serializeTextWrapper(node.content, {
                index: index,
                parentInfo: parentInfo
            });
            return this.serializeFragmentChild(node, {
                index: index,
                parentInfo: parentInfo
            });
        }));
    }
    serializeTextWrapper(content, { index: index, parentInfo: parentInfo }) {
        const currentPath = parentInfo && parentInfo.path || [];
        const nodePosition = parentInfo && parentInfo.pos || 1;
        if ((0, $1oCLl.expValEquals)('platform_editor_text_highlight_padding', 'isEnabled', true)) this.standaloneBackgroundColorMarks.push(...(0, $96ace269c0bdcf98$export$eeb66772b38d7581)(content));
        return $4b5cdd4f3b34cbcf$export$2e2bcd8739ae039.buildMarkStructure(content).map((mark, index)=>{
            return this.serializeMark({
                mark: mark,
                parentNode: {
                    path: currentPath,
                    pos: nodePosition
                },
                parentMark: {
                    path: [
                        mark
                    ]
                }
            });
        });
    }
    serializeMark({ mark: mark, parentNode: parentNode, parentMark: parentMark }) {
        if (!(0, $hlcQd.isTextNode)(mark)) {
            const serializeContent = (childMark, index)=>this.serializeMark({
                    mark: childMark,
                    parentNode: parentNode,
                    parentMark: {
                        path: [
                            ...parentMark.path,
                            childMark
                        ]
                    }
                });
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const content = (mark.content || []).map(serializeContent);
            const markKey = `${mark.type.name}-component__${this.startPos}__${parentMark.path.length}`;
            const isStandalone = (0, $1oCLl.expValEquals)('platform_editor_text_highlight_padding', 'isEnabled', true) && this.standaloneBackgroundColorMarks.some((m)=>mark.eq(m));
            return this.renderMark((0, $75a8f360c7129c0b$export$d4334b129116aad7)(mark), {
                ...this.getMarkProps(mark, parentMark.path),
                isStandalone: isStandalone
            }, markKey, content);
        }
        const startPos = this.startPos;
        const endPos = startPos + mark.nodeSize;
        this.startPos = endPos;
        const textKey = `text-wrapper_${this.startPos}`;
        if (this.surroundTextNodesWithTextWrapper) {
            const parentDepth = Math.max(parentNode.path.length - 1, 0);
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $3ab91fd4d23d289e$export$2e2bcd8739ae039), {
                startPos: startPos + parentDepth,
                endPos: endPos + parentDepth,
                textHighlighter: this.textHighlighter,
                marks: mark.marks,
                children: mark.text
            }, textKey);
        }
        const segments = (0, $5f4b8fc731c93068$export$93301b6f1ff0b0c3)(mark.text, this.textHighlighter);
        return (0, $53c7ce50256f5198$export$8a20fd0614851c5f)(segments, this.textHighlighter, mark.marks, startPos);
    }
    renderNode(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    NodeComponent, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    props, key, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    content) {
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        /*#__PURE__*/ (0, $l998X.jsx)(NodeComponent, {
            ...props,
            children: content
        }, key));
    }
    renderMark(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    MarkComponent, props, key, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    content) {
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        /*#__PURE__*/ (0, $l998X.jsx)(MarkComponent, {
            ...props,
            children: content
        }, key));
    }
    getTableChildrenProps(node) {
        return {
            ...this.getProps(node),
            allowColumnSorting: this.allowColumnSorting
        };
    }
    getTableProps(node, path = []) {
        const isInsideOfBlockNode = (0, $816aa5ff776b1fd8$export$42ddc573eb5a7b43)(path, node.type.schema);
        const isInsideMultiBodiedExtension = (0, $816aa5ff776b1fd8$export$9f1e9347b0411934)(path, node.type.schema);
        const isInsideOfTable = (0, $816aa5ff776b1fd8$export$244bf4b32387ef62)(path, node.type.schema);
        // TODO: CEMS-1048 - Support sticky headers inside breakout + layout
        const stickyHeaders = !isInsideOfTable && !(0, $816aa5ff776b1fd8$export$d7bc71cca336a3b)(path) ? this.stickyHeaders : undefined;
        return {
            ...this.getProps(node),
            allowColumnSorting: this.allowColumnSorting,
            columnWidths: (0, $caYZ2.getColumnWidths)(node),
            tableNode: node,
            stickyHeaders: stickyHeaders,
            isInsideOfBlockNode: isInsideOfBlockNode,
            isInsideOfTable: isInsideOfTable,
            isInsideMultiBodiedExtension: isInsideMultiBodiedExtension,
            allowTableAlignment: this.allowTableAlignment,
            allowTableResizing: this.allowTableResizing,
            isPresentational: (0, $dh538.fg)('platform_renderer_isPresentational') ? this.isPresentational : false,
            disableTableOverflowShadow: this.disableTableOverflowShadow
        };
    }
    getDateProps(node, parentInfo, path = []) {
        return {
            timestamp: node.attrs && node.attrs.timestamp,
            parentIsIncompleteTask: parentInfo && parentInfo.parentIsIncompleteTask,
            dataAttributes: {
                // We need to account for depth (path.length gives up depth) here
                // but depth doesnt increment the pos, only accounted for.
                'data-renderer-start-pos': this.startPos + path.length
            }
        };
    }
    getMediaSingleProps(node, path = []) {
        const { marks: { link: link } } = node.type.schema;
        const isInsideOfBlockNode = (0, $816aa5ff776b1fd8$export$42ddc573eb5a7b43)(path, node.type.schema);
        const isLinkMark = (mark)=>mark.type === link;
        const childHasLink = node.firstChild && node.firstChild.marks.filter((m)=>isLinkMark(m) || this.allowMediaLinking === true).length;
        return {
            ...this.getProps(node, path),
            isInsideOfBlockNode: isInsideOfBlockNode,
            childHasLink: childHasLink,
            allowCaptions: this.media && this.media.allowCaptions,
            featureFlags: this.media && this.media.featureFlags
        };
    }
    getMediaProps(node, path = []) {
        const { marks: { annotation: annotation, link: link, border: border } } = node.type.schema;
        const isChildOfMediaSingle = path.some((n)=>n.type?.name === 'mediaSingle');
        const isAnnotationMark = (mark)=>mark.type === annotation;
        const isLinkMark = (mark)=>mark.type === link;
        const isBorderMark = (mark)=>isChildOfMediaSingle && mark.type === border;
        return {
            ...this.getProps(node, path),
            marks: node.marks.filter((m)=>!isLinkMark(m) || this.allowMediaLinking === true),
            isLinkMark: isLinkMark,
            isBorderMark: isBorderMark,
            isAnnotationMark: isAnnotationMark,
            allowAltTextOnImages: this.allowAltTextOnImages,
            featureFlags: this.media && this.media.featureFlags,
            shouldOpenMediaViewer: this.shouldOpenMediaViewer,
            ssr: this.media?.ssr,
            // surroundTextNodesWithTextWrapper checks inlineComment.allowDraftMode
            allowAnnotationsDraftMode: this.surroundTextNodesWithTextWrapper,
            enableSyncMediaCard: this.media?.enableSyncMediaCard
        };
    }
    getExtensionProps(node, path = []) {
        return {
            ...this.getProps(node, path),
            extensionViewportSizes: this.extensionViewportSizes,
            nodeHeight: this.getExtensionHeight?.(node)
        };
    }
    getEmojiProps(node, path = []) {
        return {
            ...this.getProps(node, path),
            resourceConfig: this.emojiResourceConfig
        };
    }
    getEmbedCardProps(node, path = []) {
        const isInsideOfBlockNode = (0, $816aa5ff776b1fd8$export$42ddc573eb5a7b43)(path, node.type.schema);
        return {
            ...this.getProps(node),
            isInsideOfBlockNode: isInsideOfBlockNode
        };
    }
    getBlockCardProps(node, path = []) {
        return {
            ...this.getProps(node),
            isNodeNested: path.length > 0
        };
    }
    getMediaGroupProps(node) {
        return {
            ...this.getProps(node),
            shouldOpenMediaViewer: this.shouldOpenMediaViewer,
            allowAltTextOnImages: this.allowAltTextOnImages,
            featureFlags: this.media && this.media.featureFlags,
            enableDownloadButton: this.media?.enableDownloadButton,
            ssr: this.media?.ssr
        };
    }
    getMediaInlineProps(node) {
        return {
            ...this.getProps(node),
            ssr: this.media?.ssr
        };
    }
    getTaskItemProps(node, path = []) {
        return {
            ...this.getProps(node, path),
            disabled: this.disableActions
        };
    }
    getHardBreakProps(node, path = []) {
        let forceNewLine = false;
        const parentNode = path.length > 0 ? path[path.length - 1] : null;
        if (parentNode && parentNode.lastChild === node) forceNewLine = true;
        return {
            ...this.getProps(node),
            forceNewLine: forceNewLine
        };
    }
    getCodeBlockProps(node) {
        // The appearance being mobile indicates we are in an renderer being
        // rendered by mobile bridge in a web view.
        // The tooltip is likely to have unexpected behaviour there, with being cut
        // off, so we disable it. This is also to keep the behaviour consistent with
        // the rendering in the mobile Native Renderer.
        const codeBidiWarningTooltipEnabled = false;
        return {
            ...this.getProps(node),
            text: node.textContent,
            codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
        };
    }
    getPanelProps(node) {
        return {
            ...this.getProps(node),
            allowCustomPanels: this.allowCustomPanels
        };
    }
    getProps(node, path = []) {
        const startPos = this.startPos + path.length;
        return {
            text: node.text,
            providers: this.providers,
            eventHandlers: this.eventHandlers,
            extensionHandlers: this.extensionHandlers,
            portal: this.portal,
            rendererContext: this.rendererContext,
            serializer: this,
            content: node.content ? node.content.toJSON() : undefined,
            allowHeadingAnchorLinks: this.allowHeadingAnchorLinks,
            allowCopyToClipboard: this.allowCopyToClipboard,
            allowWrapCodeBlock: this.allowWrapCodeBlock,
            allowPlaceholderText: this.allowPlaceholderText,
            rendererAppearance: this.appearance,
            rendererContentMode: this.contentMode,
            fireAnalyticsEvent: this.fireAnalyticsEvent,
            nodeType: node.type.name,
            marks: node.marks,
            smartLinks: this.smartLinks,
            isInsideOfInlineExtension: this.isInsideOfInlineExtension,
            dataAttributes: {
                // We need to account for depth (path.length gives up depth) here
                // but depth doesnt increment the pos, only accounted for.
                'data-renderer-start-pos': startPos
            },
            startPos: startPos,
            path: path,
            ...node.attrs
        };
    }
    headingAnchorSupported(path = []) {
        const isImmediateParent = (path, nodeName)=>{
            return path.length > 0 && path[path.length - 1].type.name === nodeName;
        };
        return (0, $iNqGB.isNestedHeaderLinksEnabled)(this.allowHeadingAnchorLinks) || path.length === 0 || isImmediateParent(path, 'layoutColumn');
    }
    getHeadingProps(node, path = []) {
        return {
            ...this.getProps(node, path),
            content: node.content ? node.content.toJSON() : undefined,
            headingId: this.getHeadingId(node, this.headingIds),
            showAnchorLink: this.appearance !== 'comment' && this.allowHeadingAnchorLinks && !this.disableHeadingIDs && this.headingAnchorSupported(path)
        };
    }
    getExpandProps(node, path = []) {
        if (!(0, $iNqGB.isNestedHeaderLinksEnabled)(this.allowHeadingAnchorLinks)) return this.getProps(node);
        const nestedHeaderIds = (0, $8m4tT.findChildrenByType)(node, node.type.schema.nodes.heading).map(({ node: node })=>this.getHeadingId(node, this.expandHeadingIds));
        return {
            ...this.getProps(node),
            nestedHeaderIds: nestedHeaderIds
        };
    }
    // The return value of this function is NOT url encoded,
    // In HTML5 standard, id can contain any characters, encoding is no necessary.
    // Plus we trying to avoid double encoding, therefore we leave the value as is.
    // Remember to use encodeURIComponent when generating url from the id value.
    getHeadingId(node, headingIds) {
        if (this.disableHeadingIDs || !node.content.size) return;
        // We are not use node.textContent here, because we would like to handle cases where
        // headings only contain inline blocks like emoji, status and date.
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const nodeContent = node.content.toJSON()// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .reduce((acc, node)=>acc.concat((0, $b7FrM.getText)(node) || ''), '').trim()// Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        .replace(/\s/g, '-');
        if (!nodeContent) return;
        return this.getUniqueHeadingId(nodeContent, headingIds);
    }
    getUniqueHeadingId(baseId, headingIds, counter = 0) {
        if (counter === 0 && headingIds.indexOf(baseId) === -1) {
            headingIds.push(baseId);
            return baseId;
        } else if (counter !== 0) {
            const headingId = `${baseId}.${counter}`;
            if (headingIds.indexOf(headingId) === -1) {
                headingIds.push(headingId);
                return headingId;
            }
        }
        return this.getUniqueHeadingId(baseId, headingIds, ++counter);
    }
    static getChildNodes(fragment) {
        const children = [];
        fragment.forEach((node)=>{
            children.push(node);
        });
        return (0, $hlcQd.mergeTextNodes)(children);
    }
    static getMarks(node) {
        if (!node.marks || node.marks.length === 0) return [];
        return (0, $bSXAs.getMarksByOrder)(node.marks);
    }
    static buildMarkStructure(content) {
        return $4b5cdd4f3b34cbcf$var$mergeMarks(content.map((node)=>{
            const nodeMarks = this.getMarks(node);
            if (nodeMarks.length === 0) return node;
            return nodeMarks.reverse().reduce((acc, mark)=>{
                const { eq: eq } = mark;
                return {
                    ...mark,
                    eq: eq,
                    content: [
                        acc
                    ]
                };
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            }, node);
        }));
    }
    // TODO: ED-9004 - Remove unused ReactSerializer.fromSchema in renderer
    // https://sourcegraph-frontend.internal.shared-prod.us-west-2.kitt-inf.net/search?q=ReactSerializer.fromSchema&patternType=literal
    static fromSchema(_, init) {
        return new $4b5cdd4f3b34cbcf$export$2e2bcd8739ae039(init);
    }
    constructor(init){
        this.providers = void 0;
        this.eventHandlers = void 0;
        this.extensionHandlers = void 0;
        this.portal = void 0;
        this.rendererContext = void 0;
        this.appearance = void 0;
        this.contentMode = void 0;
        this.disableHeadingIDs = void 0;
        this.disableActions = void 0;
        this.headingIds = [];
        /**
     * The reason we have this extra array here is because we need to generate the same unique
     * heading id for 2 different nodes: headers and expands (check the implementation of
     * `getUniqueHeadingId` for more info).
     *
     * We will eventually need to refactor the current approach to generate unique ids
     * for headers under this ticket -> https://product-fabric.atlassian.net/browse/ED-9668
     */ this.expandHeadingIds = [];
        this.allowHeadingAnchorLinks = void 0;
        this.allowColumnSorting = void 0;
        this.allowCopyToClipboard = false;
        this.allowWrapCodeBlock = false;
        this.allowPlaceholderText = true;
        this.allowCustomPanels = false;
        this.fireAnalyticsEvent = void 0;
        this.shouldOpenMediaViewer = void 0;
        this.allowAltTextOnImages = void 0;
        this.stickyHeaders = void 0;
        this.allowMediaLinking = void 0;
        this.initStartPos = void 0;
        this.startPos = void 0;
        this.surroundTextNodesWithTextWrapper = false;
        this.media = void 0;
        this.emojiResourceConfig = void 0;
        this.smartLinks = void 0;
        this.extensionViewportSizes = void 0;
        this.getExtensionHeight = void 0;
        this.allowAnnotations = false;
        this.allowSelectAllTrap = void 0;
        this.nodeComponents = void 0;
        this.allowWindowedCodeBlock = void 0;
        this.isInsideOfInlineExtension = void 0;
        this.textHighlighter = void 0;
        this.allowTableAlignment = void 0;
        this.allowTableResizing = void 0;
        this.isPresentational = void 0;
        this.disableTableOverflowShadow = void 0;
        this.standaloneBackgroundColorMarks = [];
        this.serializeFragmentChild = (node, { index: index, parentInfo: parentInfo })=>{
            const pos = this.startPos;
            const currentPath = parentInfo && parentInfo.path || [];
            const parentIsIncompleteTask = (node.type.name === 'taskItem' || node.type.name === 'blockTaskItem' && (0, $1oCLl.expValEquals)('platform_editor_blocktaskitem_node_tenantid', 'isEnabled', true)) && node.attrs.state !== 'DONE' || // If blockTaskItem is in the schema, check if the parent of the current node
            // is an incomplete task item, because blockTaskItems can have nested nodes
            node.type.schema.nodes.blockTaskItem && parentInfo?.parentIsIncompleteTask === true && (0, $1oCLl.expValEquals)('platform_editor_blocktaskitem_node_tenantid', 'isEnabled', true);
            const nodeKey = `${node.type.name}__${this.startPos}`;
            const serializedContent = this.serializeFragment(node.content, this.getNodeProps(node, parentInfo), (0, $hlcQd.toReact)(node, {
                allowSelectAllTrap: this.allowSelectAllTrap,
                allowWindowedCodeBlock: this.allowWindowedCodeBlock
            }, this.nodeComponents), nodeKey, {
                parentIsIncompleteTask: parentIsIncompleteTask,
                path: [
                    ...currentPath,
                    node
                ],
                pos: this.startPos
            });
            this.startPos = pos + node.nodeSize;
            const marks = node.marks ? [
                ...node.marks
            ] : [];
            const isMedia = node.type.name === 'media';
            const shouldSkipBorderMark = (mark)=>currentPath.some((n)=>n.type?.name !== 'mediaSingle') && isMedia && mark.type.name === 'border';
            const shouldSkipLinkMark = (mark)=>this.allowMediaLinking !== true && isMedia && mark.type.name === 'link';
            return marks.reduceRight((content, mark)=>{
                if (shouldSkipLinkMark(mark) || shouldSkipBorderMark(mark)) return content;
                return this.renderMark((0, $75a8f360c7129c0b$export$d4334b129116aad7)(mark), this.withMediaMarkProps(node, mark, this.getMarkProps(mark, [], node)), `${mark.type.name}-${index}`, content);
            }, serializedContent);
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.withMediaMarkProps = (node, mark, defaultProps)=>{
            if (mark.type.name === 'link' && node.type.name === 'media') return {
                ...defaultProps,
                isMediaLink: true
            };
            if (node.type.name === 'mediaInline' && mark.type.name === 'annotation') return {
                ...defaultProps,
                isMediaInline: true
            };
            return defaultProps;
        };
        this.getUnsupportedContentProps = (node)=>{
            return {
                node: node,
                dispatchAnalyticsEvent: this.fireAnalyticsEvent
            };
        };
        this.getAnnotationMarkProps = (mark, marksParentPath)=>{
            const annotationParentIds = (marksParentPath || []).reduce((acc, parent)=>{
                if ((0, $7nUdN.isAnnotationMark)(parent)) return [
                    ...acc,
                    parent.attrs.id
                ];
                return acc;
            }, []);
            return {
                id: mark.attrs.id,
                annotationType: mark.attrs.annotationType,
                annotationParentIds: annotationParentIds,
                allowAnnotations: this.allowAnnotations,
                dataAttributes: {
                    'data-renderer-mark': true
                }
            };
        };
        this.getMarkProps = (mark, marksParentPath, node)=>{
            if ((0, $7nUdN.isAnnotationMark)(mark)) return this.getAnnotationMarkProps(mark, marksParentPath);
            const { key: key, ...otherAttrs } = mark.attrs;
            const extraProps = {
                isInline: node?.isInline
            };
            // currently the only mark which has custom props is the code mark
            const markSpecificProps = (0, $GH4gU.isCodeMark)(mark) ? {
                // The appearance being mobile indicates we are in an renderer being
                // rendered by mobile bridge in a web view.
                // The tooltip is likely to have unexpected behaviour there, with being cut
                // off, so we disable it. This is also to keep the behaviour consistent with
                // the rendering in the mobile Native Renderer.
                codeBidiWarningTooltipEnabled: false
            } : {};
            const props = {
                eventHandlers: this.eventHandlers,
                fireAnalyticsEvent: this.fireAnalyticsEvent,
                markKey: key,
                ...otherAttrs,
                ...extraProps,
                ...markSpecificProps,
                dataAttributes: {
                    'data-renderer-mark': true
                }
            };
            return props;
        };
        if ((0, $iu6m9.editorExperiment)('comment_on_bodied_extensions', true)) {
            this.initStartPos = init.startPos || 1;
            this.startPos = init.startPos || 1;
        } else {
            this.initStartPos = 1;
            this.startPos = 1;
        }
        this.providers = init.providers;
        this.eventHandlers = init.eventHandlers;
        this.extensionHandlers = init.extensionHandlers;
        this.portal = init.portal;
        this.rendererContext = init.objectContext;
        this.appearance = init.appearance;
        this.contentMode = init.contentMode;
        this.disableHeadingIDs = init.disableHeadingIDs;
        this.disableActions = init.disableActions;
        this.allowHeadingAnchorLinks = init.allowHeadingAnchorLinks;
        this.allowCopyToClipboard = init.allowCopyToClipboard;
        this.allowWrapCodeBlock = init.allowWrapCodeBlock;
        this.allowPlaceholderText = init.allowPlaceholderText;
        this.allowCustomPanels = init.allowCustomPanels;
        this.allowColumnSorting = init.allowColumnSorting;
        this.fireAnalyticsEvent = init.fireAnalyticsEvent;
        this.shouldOpenMediaViewer = init.shouldOpenMediaViewer;
        this.allowAltTextOnImages = init.allowAltTextOnImages;
        this.stickyHeaders = init.stickyHeaders;
        this.allowMediaLinking = init.allowMediaLinking;
        this.allowAnnotations = Boolean(init.allowAnnotations);
        this.surroundTextNodesWithTextWrapper = Boolean(init.surroundTextNodesWithTextWrapper);
        this.media = init.media;
        this.emojiResourceConfig = init.emojiResourceConfig;
        this.smartLinks = init.smartLinks;
        this.extensionViewportSizes = init.extensionViewportSizes;
        this.getExtensionHeight = init.getExtensionHeight;
        this.allowSelectAllTrap = init.allowSelectAllTrap;
        this.nodeComponents = init.nodeComponents;
        this.allowWindowedCodeBlock = init.allowWindowedCodeBlock;
        this.isInsideOfInlineExtension = init.isInsideOfInlineExtension;
        this.textHighlighter = init.textHighlighter;
        this.allowTableAlignment = init.allowTableAlignment;
        this.allowTableResizing = init.allowTableResizing;
        this.isPresentational = init.isPresentational;
        this.disableTableOverflowShadow = init.disableTableOverflowShadow;
    }
}
module.exports["default"] = $4b5cdd4f3b34cbcf$export$2e2bcd8739ae039;

});

parcelRegister("hlcQd", function(module, exports) {
$parcel$export(module.exports, "Doc", () => (parcelRequire("8jc2v")).default);
$parcel$export(module.exports, "DocWithSelectAllTrap", () => (parcelRequire("8jc2v")).DocWithSelectAllTrap);
/* eslint-disable @atlaskit/editor/no-re-export */ // Mapping file

var $4wH3g = parcelRequire("4wH3g");


var $iq4lN = parcelRequire("iq4lN");

var $gndLe = parcelRequire("gndLe");


var $dh538 = parcelRequire("dh538");


var $8FDtv = parcelRequire("8FDtv");


var $bHs3B = parcelRequire("bHs3B");

/* eslint-disable @atlaskit/design-system/prefer-primitives, @atlaskit/design-system/consistent-css-prop-usage */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");


var $6fnsQ = parcelRequire("6fnsQ");


var $42omo = parcelRequire("42omo");


var $k8515 = parcelRequire("k8515");


var $5VmpF = parcelRequire("5VmpF");


var $dsfZn = parcelRequire("dsfZn");

var $bWRlG = parcelRequire("bWRlG");


var $jVL42 = parcelRequire("jVL42");


var $fJNzZ = parcelRequire("fJNzZ");

const $bf762dfdd46e741a$var$useMultiBodiedExtensionActions = ({ updateActiveChild: updateActiveChild, children: children })=>{
    const actions = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>{
        return {
            changeActive (index) {
                return updateActiveChild(index);
            },
            addChild () {
                return false;
            },
            getChildrenCount () {
                return children ? children?.length : 0;
            },
            removeChild (index) {
                return false;
            },
            updateParameters (parameters) {
                return false;
            },
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            getChildren () {
                return [];
            },
            getChildrenContainer () {
                return null;
            }
        };
    }, [
        updateActiveChild,
        children
    ]);
    return actions;
};
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Ignored via go/DSP-18766
const $bf762dfdd46e741a$var$navigationCssExtended = /*#__PURE__*/ (0, $9K4OG.css)((0, $dsfZn.sharedMultiBodiedExtensionStyles).mbeNavigation, ";margin-left:0!important;margin-right:0!important;.mbe-add-tab-button,.mbe-remove-tab{display:none;}");
const $bf762dfdd46e741a$var$MultiBodiedExtension = (props)=>{
    const { children: children, layout: layout = 'default', path: path = [] } = props;
    const [activeChildIndex, setActiveChildIndex] = (0, $42omo.useState)(0);
    const removeOverflow = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.toArray(children)// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .map((child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(child) ? child.props.nodeType === 'table' : false).every(Boolean);
    const overflowContainerClass = !removeOverflow ? (0, $jVL42.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER : '';
    const updateActiveChild = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((index)=>{
        if (typeof index !== 'number') {
            // Ignored via go/ees007
            // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
            // TODO: Make sure we log this somewhere if this happens
            setActiveChildIndex(0);
            return false;
        }
        setActiveChildIndex(index);
        return true;
    }, [
        setActiveChildIndex
    ]);
    const actions = $bf762dfdd46e741a$var$useMultiBodiedExtensionActions({
        updateActiveChild: updateActiveChild,
        children: children
    });
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    const containerCssExtended = /*#__PURE__*/ (0, $9K4OG.css)((0, $dsfZn.sharedMultiBodiedExtensionStyles).mbeExtensionContainer, ";.ak-renderer-extension{margin-top:0!important;}[data-layout='full-width'],[data-layout='wide']{.multiBodiedExtension-navigation{border-right:3px solid ", `var(--ds-border, ${(0, $6fnsQ.N40)})`, "!important;}}.multiBodiedExtension--frames>[data-extension-frame='true']:nth-of-type(", activeChildIndex + 1, "){", (0, $dsfZn.sharedMultiBodiedExtensionStyles).extensionFrameContent, " margin-left:0;margin-right:0;}");
    const isTopLevel = path.length < 1;
    const centerAlignClass = isTopLevel && [
        'wide',
        'full-width'
    ].includes(layout) ? (0, $jVL42.RendererCssClassName).EXTENSION_CENTER_ALIGN : '';
    function renderMbeContent(width) {
        return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `${(0, $jVL42.RendererCssClassName).EXTENSION} ${centerAlignClass} ${overflowContainerClass}`,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                width: isTopLevel ? (0, $fJNzZ.calcBreakoutWidth)(layout, width) : '100%'
            },
            "data-layout": layout
        }, /*#__PURE__*/ (0, $9K4OG.jsx)("nav", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "multiBodiedExtension-navigation",
            css: $bf762dfdd46e741a$var$navigationCssExtended,
            "data-testid": "multiBodiedExtension-navigation"
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $5VmpF.default), {
            ...props,
            actions: actions,
            type: "multiBodiedExtension"
        }, ({ result: result })=>{
            try {
                if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(result)) // Return the content directly if it's a valid JSX.Element
                return (0, $k8515.renderExtension)(result, layout, {
                    isTopLevel: path.length < 1
                });
            } catch (e) {
            /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
            // Always return default content if anything goes wrong
            return (0, $k8515.renderExtension)(children, layout, {
                isTopLevel: path.length < 1
            });
        })), /*#__PURE__*/ (0, $9K4OG.jsx)("article", {
            "data-testid": "multiBodiedExtension--frames",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `multiBodiedExtension--frames`
        }, children));
    }
    return /*#__PURE__*/ (0, $9K4OG.jsx)("section", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "multiBodiedExtension--container",
        css: containerCssExtended,
        "data-testid": "multiBodiedExtension--container",
        "data-active-child-index": activeChildIndex,
        "data-layout": layout
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $bWRlG.WidthConsumer), null, ({ width: width })=>renderMbeContent(width)));
};
var $bf762dfdd46e741a$export$2e2bcd8739ae039 = $bf762dfdd46e741a$var$MultiBodiedExtension;



var $1acNj = parcelRequire("1acNj");


var $l5RsK = parcelRequire("l5RsK");


var $4aPtv = parcelRequire("4aPtv");


var $8jc2v = parcelRequire("8jc2v");





var $8dFG8 = parcelRequire("8dFG8");


var $9IIii = parcelRequire("9IIii");


var $AXP6M = parcelRequire("AXP6M");


var $iPgHB = parcelRequire("iPgHB");


var $gaxtd = parcelRequire("gaxtd");


var $2y2LK = parcelRequire("2y2LK");


var $e3xiQ = parcelRequire("e3xiQ");


var $iKbB3 = parcelRequire("iKbB3");


var $4AYMa = parcelRequire("4AYMa");


var $12YDi = parcelRequire("12YDi");


var $40qpT = parcelRequire("40qpT");


var $2jkq1 = parcelRequire("2jkq1");


var $iKFPk = parcelRequire("iKFPk");


var $a78Ri = parcelRequire("a78Ri");


var $cCNNZ = parcelRequire("cCNNZ");


const $bcf3851500a04fac$export$a22ee8f907eecb5f = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "lyuNf",
    name: "WindowedCodeBlock",
    loader: ()=>(parcelRequire("96XCF")).then((mod)=>mod.default),
    loading: ()=>null
});

const $bcf3851500a04fac$export$6c415d1fdae3dfdb = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "7voiQ",
    name: "CodeBlock",
    loader: ()=>(parcelRequire("lCaNp")).then((mod)=>mod.default),
    loading: ()=>null
});

const $bcf3851500a04fac$export$771a55a10b0a40ae = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "QxM0Q",
    name: "TaskList",
    loader: ()=>(parcelRequire("jblE9")).then((mod)=>mod.default),
    loading: ()=>null
});

const $bcf3851500a04fac$export$27c4189b8be1bf93 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "mFjlc",
    name: "TaskItem",
    loader: ()=>(parcelRequire("2ve85")).then((mod)=>mod.default),
    loading: ()=>null
});

const $bcf3851500a04fac$export$b458dfa720128865 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "Es_G2",
    name: "DecisionList",
    loader: ()=>(parcelRequire("8DVsQ")).then((mod)=>mod.default),
    loading: ()=>null
});

const $bcf3851500a04fac$export$b6f73a2b0b0de599 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "tXkFq",
    name: "DecisionItem",
    loader: ()=>(parcelRequire("gbCDG")).then((mod)=>mod.default),
    loading: ()=>null
});

const $bcf3851500a04fac$export$6341f9a885713487 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "UW2mx",
    name: "Date",
    loader: ()=>(parcelRequire("fHmdy")).then((mod)=>mod.default),
    loading: ()=>null
});

const $bcf3851500a04fac$export$96e9906d6d93a972 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "YWl55",
    name: "Status",
    loader: ()=>(parcelRequire("gafIU")).then((mod)=>mod.default),
    loading: ()=>null
});

const $bcf3851500a04fac$export$56cc48506ff790a = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "vg-Rq",
    name: "Emoji",
    _vcPlaceholderIgnored: true,
    loader: ()=>(parcelRequire("1emf0")).then((mod)=>mod.default),
    loading: ()=>null
});

const $bcf3851500a04fac$export$2ddb90ad54e5f587 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "Hm6N8",
    name: "Panel",
    _addVCPlaceholderWrapper: "span",
    loader: ()=>(parcelRequire("htYJT")).then((mod)=>mod.default),
    loading: ()=>null
});

const $bcf3851500a04fac$export$6789d7ecdc77631b = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "Ecfpn",
    name: "EmbedCard",
    loader: ()=>(parcelRequire("jRE4r")).then((mod)=>mod.default),
    loading: ()=>null
});

const $bcf3851500a04fac$export$aff6291803939b05 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "0vDZ-",
    name: "InlineCard",
    loader: ()=>(parcelRequire("k73Mv")).then((mod)=>mod.default),
    loading: ()=>null
});

const $bcf3851500a04fac$export$d18ccd25c0d2c6b0 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "cNtW6",
    name: "BlockCard",
    loader: ()=>(parcelRequire("8xIsH")).then((mod)=>mod.default),
    loading: ()=>null
});

const $bcf3851500a04fac$export$7fc53215244aec38 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "nouWf",
    name: "Media",
    _vcPlaceholderIgnored: true,
    loader: ()=>(parcelRequire("btJfW")).then((mod)=>mod.default),
    loading: ()=>null
});

const $bcf3851500a04fac$export$d7858be3df00d59 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "l7RKL",
    name: "MediaGroup",
    loader: ()=>(parcelRequire("27fpX")).then((mod)=>mod.default),
    loading: ()=>null
});

const $bcf3851500a04fac$export$462ea7c2a1c4cb1f = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "IVdRD",
    name: "MediaInline",
    loader: ()=>(parcelRequire("e3PaH")).then((mod)=>mod.default),
    loading: ()=>null
});

const $bcf3851500a04fac$export$888d74bc001c3a5d = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "Eb7Gh",
    name: "MediaSingle",
    _delayHydration: true,
    loader: ()=>(parcelRequire("lElg4")).then((mod)=>mod.default),
    loading: ()=>null
});

const $bcf3851500a04fac$export$e891316fea657d90 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "w10Xv",
    name: "Mention",
    loader: ()=>(parcelRequire("jLbE9")).then((mod)=>mod.default),
    loading: ()=>null
});

const $bcf3851500a04fac$export$49bd1dfb0ad29c40 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "UPgdC",
    name: "Expand",
    loader: ()=>(parcelRequire("4Y3We")).then((mod)=>mod.default),
    loading: ()=>null
});

const $bcf3851500a04fac$var$SyncBlockLoader = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "f1NYX",
    name: "SyncBlockLoader",
    loader: ()=>(parcelRequire("64LyH")).then((mod)=>mod.default),
    loading: ()=>null
});

const $bcf3851500a04fac$var$BodiedSyncBlock = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "uj9UW",
    name: "BodiedSyncBlock",
    loader: ()=>(parcelRequire("dvtp1")).then((mod)=>mod.default),
    loading: ()=>null
});
const $bcf3851500a04fac$export$3931063f6a5f290e = {
    blockquote: (0, $8FDtv.default),
    bulletList: (0, $4aPtv.default),
    blockCard: $bcf3851500a04fac$export$d18ccd25c0d2c6b0,
    caption: (0, $e3xiQ.default),
    date: $bcf3851500a04fac$export$6341f9a885713487,
    decisionItem: $bcf3851500a04fac$export$b6f73a2b0b0de599,
    decisionList: $bcf3851500a04fac$export$b458dfa720128865,
    doc: (0, $8jc2v.default),
    emoji: $bcf3851500a04fac$export$56cc48506ff790a,
    extension: (0, $k8515.default),
    bodiedExtension: (0, $bHs3B.default),
    multiBodiedExtension: (0, $1acNj.default),
    extensionFrame: (0, $l5RsK.default),
    hardBreak: (0, $8dFG8.default),
    heading: (0, $9IIii.default),
    inlineCard: $bcf3851500a04fac$export$aff6291803939b05,
    inlineExtension: (0, $AXP6M.default),
    layoutSection: (0, $iPgHB.default),
    layoutColumn: (0, $gaxtd.default),
    listItem: (0, $2y2LK.default),
    media: $bcf3851500a04fac$export$7fc53215244aec38,
    mediaGroup: $bcf3851500a04fac$export$d7858be3df00d59,
    mediaInline: $bcf3851500a04fac$export$462ea7c2a1c4cb1f,
    mediaSingle: $bcf3851500a04fac$export$888d74bc001c3a5d,
    mention: $bcf3851500a04fac$export$e891316fea657d90,
    orderedList: (0, $iKbB3.default),
    panel: $bcf3851500a04fac$export$2ddb90ad54e5f587,
    paragraph: (0, $4AYMa.default),
    placeholder: (0, $12YDi.default),
    rule: (0, $40qpT.default),
    status: $bcf3851500a04fac$export$96e9906d6d93a972,
    taskItem: $bcf3851500a04fac$export$27c4189b8be1bf93,
    taskList: $bcf3851500a04fac$export$771a55a10b0a40ae,
    table: (0, $2jkq1.default),
    tableCell: (0, $iKFPk.TableCell),
    tableHeader: (0, $iKFPk.TableHeader),
    tableRow: (0, $a78Ri.default),
    unknownBlock: (0, $cCNNZ.default),
    unsupportedBlock: (0, $iq4lN.default),
    unsupportedInline: (0, $gndLe.default),
    expand: $bcf3851500a04fac$export$49bd1dfb0ad29c40,
    syncBlock: $bcf3851500a04fac$var$SyncBlockLoader,
    bodiedSyncBlock: $bcf3851500a04fac$var$BodiedSyncBlock,
    nestedExpand: $bcf3851500a04fac$export$49bd1dfb0ad29c40,
    embedCard: $bcf3851500a04fac$export$6789d7ecdc77631b,
    blockTaskItem: $bcf3851500a04fac$export$27c4189b8be1bf93
};
const $bcf3851500a04fac$export$d4334b129116aad7 = (node, flags, nodeComponents)=>{
    if (node.type.name === 'doc' && flags?.allowSelectAllTrap === true) return 0, $8jc2v.DocWithSelectAllTrap;
    if (node.type.name === 'codeBlock') {
        if (flags?.allowWindowedCodeBlock === true) return $bcf3851500a04fac$export$a22ee8f907eecb5f;
        return $bcf3851500a04fac$export$6c415d1fdae3dfdb;
    }
    // Allowing custom components to override those provided in nodeToReact
    const nodes = {
        ...$bcf3851500a04fac$export$3931063f6a5f290e,
        ...nodeComponents
    };
    nodes['multiBodiedExtension'] = (0, $dh538.fg)('platform_editor_multi_body_extension_extensibility') ? (0, $1acNj.default) : (0, $bf762dfdd46e741a$export$2e2bcd8739ae039);
    return nodes[node.type.name];
};
const $bcf3851500a04fac$export$8045509d14b5046f = (nodes)=>{
    return nodes.reduce((acc, current)=>{
        if (!$bcf3851500a04fac$export$1879817ac5c922b7(current.type.name)) {
            acc.push(current);
            return acc;
        }
        // Append node to previous node, if it was a text wrapper
        if (acc.length > 0 && $bcf3851500a04fac$export$d4ebd3557ee7fac1(acc[acc.length - 1])) {
            const textWrapper = acc[acc.length - 1];
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            textWrapper.content.push(current);
            textWrapper.nodeSize += current.nodeSize;
        } else acc.push({
            type: {
                name: 'textWrapper'
            },
            content: [
                current
            ],
            nodeSize: current.nodeSize
        });
        return acc;
    }, []);
};
const $bcf3851500a04fac$export$1879817ac5c922b7 = (type)=>{
    return type === 'text';
};
const $bcf3851500a04fac$export$d4ebd3557ee7fac1 = (node)=>{
    return node.type.name === 'textWrapper';
};
function $bcf3851500a04fac$export$ccbedd67ef6e9417(node) {
    return node.type.name === 'text';
}
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $bcf3851500a04fac$var$whitespaceRegex = /^\s*$/;
const $bcf3851500a04fac$export$dd0c7365db1f79a5 = (doc)=>{
    if (doc.childCount !== 1) return false;
    const parentNodes = [];
    doc.forEach((child)=>parentNodes.push(child));
    const node = parentNodes[0];
    return node.type.name === 'paragraph' && $bcf3851500a04fac$var$isEmojiBlock(node.content);
};
const $bcf3851500a04fac$var$isEmojiBlock = (pnode)=>{
    const content = [];
    // Optimisation for long documents - worst case block will be space-emoji-space
    if (pnode.childCount > 7) return false;
    pnode.forEach((child)=>content.push(child));
    let emojiCount = 0;
    for(let i = 0; i < content.length; ++i){
        const node = content[i];
        switch(node.type.name){
            case 'text':
                if (node.text && !node.text.match($bcf3851500a04fac$var$whitespaceRegex)) return false;
                continue;
            case 'emoji':
                if (++emojiCount > 3) return false;
                continue;
            default:
                // Only text and emoji nodes are allowed
                return false;
        }
    }
    return emojiCount > 0;
};
module.exports["InlineCard"] = $bcf3851500a04fac$export$aff6291803939b05;
module.exports["nodeToReact"] = $bcf3851500a04fac$export$3931063f6a5f290e;
module.exports["toReact"] = $bcf3851500a04fac$export$d4334b129116aad7;
module.exports["mergeTextNodes"] = $bcf3851500a04fac$export$8045509d14b5046f;
module.exports["isTextWrapper"] = $bcf3851500a04fac$export$d4ebd3557ee7fac1;
module.exports["isTextNode"] = $bcf3851500a04fac$export$ccbedd67ef6e9417;

});

parcelRegister("gndLe", function(module, exports) {
$parcel$export(module.exports, "default", () => $21cc51f6839cd966$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $gmMgo = parcelRequire("gmMgo");


var $aFUXX = parcelRequire("aFUXX");


var $195qZ = parcelRequire("195qZ");


var $3gadb = parcelRequire("3gadb");


var $d925B = parcelRequire("d925B");


var $iCOwP = parcelRequire("iCOwP");


var $juTiU = parcelRequire("juTiU");


var $1QdLR = parcelRequire("1QdLR");

const $21cc51f6839cd966$var$inlineNodeStyle = /*#__PURE__*/ (0, $9K4OG.css)({
    alignItems: 'center',
    background: "var(--ds-background-disabled, #17171708)",
    border: `${"var(--ds-border-width, 1px)"} dashed ${"var(--ds-border-disabled, #0515240F)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: "var(--ds-radius-small, 3px)",
    boxSizing: 'border-box',
    cursor: 'default',
    display: 'inline-flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: (0, $aFUXX.relativeFontSizeToBase16)(14),
    margin: `0 ${"var(--ds-space-025, 2px)"}`,
    minHeight: '24px',
    padding: `0 ${"var(--ds-space-100, 8px)"}`,
    verticalAlign: 'middle',
    whiteSpace: 'nowrap'
});
const $21cc51f6839cd966$var$UnsupportedInlineNode = ({ node: node, intl: intl, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
    const message = (0, $1QdLR.getUnsupportedContent)((0, $iCOwP.unsupportedContentMessages).unsupportedInlineContent, 'Unsupported', node, intl);
    const tooltipContent = intl.formatMessage((0, $iCOwP.unsupportedContentMessages).unsupportedContentTooltip);
    const { current: style } = (0, $42omo.useRef)({
        padding: '4px'
    });
    const originalNodeType = node?.attrs.originalValue.type;
    const tooltipOnShowHandler = (0, $42omo.useCallback)(()=>dispatchAnalyticsEvent && (0, $juTiU.trackUnsupportedContentTooltipDisplayedFor)(dispatchAnalyticsEvent, (0, $d925B.ACTION_SUBJECT_ID).ON_UNSUPPORTED_INLINE, originalNodeType), [
        dispatchAnalyticsEvent,
        originalNodeType
    ]);
    return /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        css: $21cc51f6839cd966$var$inlineNodeStyle
    }, message, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3gadb.default), {
        content: tooltipContent,
        hideTooltipOnClick: false,
        position: "bottom",
        onShow: tooltipOnShowHandler,
        strategy: "absolute"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        style: style
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($195qZ))), {
        label: "?",
        LEGACY_size: "small"
    }))));
};
var $21cc51f6839cd966$export$2e2bcd8739ae039 = (0, $gmMgo.default)($21cc51f6839cd966$var$UnsupportedInlineNode);

});

parcelRegister("5VmpF", function(module, exports) {
$parcel$export(module.exports, "default", () => $52efeb67c19e95a1$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");


var $42omo = parcelRequire("42omo");


var $2XqLN = parcelRequire("2XqLN");


var $heH5c = parcelRequire("heH5c");


var $dYBVS = parcelRequire("dYBVS");


var $2diEG = parcelRequire("2diEG");


var $dh538 = parcelRequire("dh538");

function $52efeb67c19e95a1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $52efeb67c19e95a1$var$inlineExtensionStyle = /*#__PURE__*/ (0, $9K4OG.css)({
    display: 'inline-block',
    maxWidth: '100%',
    verticalAlign: 'middle',
    // 0px margin top is important here.
    // When running on server-side emotion will generate style tags before elements.
    // This caused packages/editor/editor-common/src/styles/shared/block-marks.ts to override the margin-top.
    // However as soon as the styles are extracted to <head> it adds back the margin.
    // The timing is tricky as it happens to be when UFO collects the dimension for the placeholder for TTVC calculation.
    // This resulted 1px mismatch on the image. Further cause everything on page to shift by 1px.
    // es-lint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    margin: `0px 1px ${"var(--ds-space-050, 4px)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& .rich-media-item': {
        maxWidth: '100%'
    }
});
const $52efeb67c19e95a1$var$plainTextMacroStyle = {
    name: "1b7osz4",
    styles: "display:inline;vertical-align:baseline;[data-macro-body]{display:inline;}"
};
function $52efeb67c19e95a1$export$2e2bcd8739ae039(props) {
    const { extensionHandlers: extensionHandlers, rendererContext: rendererContext, extensionType: extensionType, extensionKey: extensionKey, parameters: parameters, content: content, text: text, type: type, localId: localId, marks: marks, actions: actions, children: children } = props;
    const isMounted = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(true);
    const localGetNodeRenderer = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>(0, $2XqLN.default)((0, $heH5c.getNodeRenderer)), []);
    const [extensionProvider, setExtensionProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(null);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleProvider = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((name, providerPromise)=>{
        providerPromise && providerPromise.then((provider)=>{
            if (isMounted.current) setExtensionProvider(provider);
        });
    }, []);
    const renderExtensionNode = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((extensionProvider)=>{
        const fragmentLocalId = marks?.find((m)=>m.type.name === 'fragment')?.attrs?.localId;
        const node = {
            type: type,
            extensionKey: extensionKey,
            extensionType: extensionType,
            parameters: parameters,
            content: content || text,
            localId: localId,
            fragmentLocalId: fragmentLocalId
        };
        const isPlainTextMacro = Boolean(node?.parameters?.macroParams?.__bodyContent);
        let result = null;
        try {
            if (extensionHandlers && extensionHandlers[extensionType]) {
                const render = (0, $2diEG.getExtensionRenderer)(extensionHandlers[extensionType]);
                result = render(node, rendererContext.adDoc);
            }
            if (!result && extensionProvider) {
                const NodeRenderer = localGetNodeRenderer(extensionProvider, extensionType, extensionKey);
                if (node.type === 'multiBodiedExtension') result = /*#__PURE__*/ (0, $9K4OG.jsx)(NodeRenderer, {
                    node: node,
                    actions: actions
                });
                else if (node.type === 'inlineExtension') {
                    if ((0, $dh538.fg)('platform_editor_renderer_inline_extension_improve')) result = /*#__PURE__*/ (0, $9K4OG.jsx)($52efeb67c19e95a1$export$f41ccc3bd3324832, {
                        isPlainTextMacro: isPlainTextMacro
                    }, /*#__PURE__*/ (0, $9K4OG.jsx)(NodeRenderer, {
                        node: node
                    }));
                    else result = /*#__PURE__*/ (0, $9K4OG.jsx)($52efeb67c19e95a1$export$f41ccc3bd3324832, null, /*#__PURE__*/ (0, $9K4OG.jsx)(NodeRenderer, {
                        node: node
                    }));
                } else result = /*#__PURE__*/ (0, $9K4OG.jsx)(NodeRenderer, {
                    node: node
                });
            }
        } catch (e) {
        /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
        return children({
            result: result
        });
    }, [
        actions,
        children,
        content,
        extensionHandlers,
        extensionKey,
        extensionType,
        localGetNodeRenderer,
        localId,
        marks,
        parameters,
        rendererContext?.adDoc,
        text,
        type
    ]);
    const setupAndRenderExtensionNode = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((providers)=>{
        if (!extensionProvider && providers.extensionProvider) handleProvider('extensionProvider', providers.extensionProvider);
        return renderExtensionNode(extensionProvider);
    }, [
        extensionProvider,
        handleProvider,
        renderExtensionNode
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    if (!props.providers) return setupAndRenderExtensionNode({});
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $dYBVS.WithProviders), {
        providers: [
            'extensionProvider'
        ],
        providerFactory: props.providers,
        renderNode: setupAndRenderExtensionNode
    });
}
const $52efeb67c19e95a1$export$f41ccc3bd3324832 = ({ children: children, isPlainTextMacro: isPlainTextMacro, ssrPlaceholder: ssrPlaceholder, ssrPlaceholderReplace: ssrPlaceholderReplace })=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `inline-extension-renderer ${isPlainTextMacro ? 'plain-text-macro' : ''}`,
        css: [
            $52efeb67c19e95a1$var$inlineExtensionStyle,
            isPlainTextMacro && $52efeb67c19e95a1$var$plainTextMacroStyle
        ],
        "data-ssr-placeholder": ssrPlaceholder,
        "data-ssr-placeholder-replace": ssrPlaceholderReplace
    }, children);
};
module.exports["InlineNodeRendererWrapper"] = $52efeb67c19e95a1$export$f41ccc3bd3324832;

});

parcelRegister("heH5c", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4wH3g = parcelRequire("4wH3g");


var $3jQ9y = parcelRequire("3jQ9y");

function $05c1a9b049285eb2$var$getNodeFromManifest(// eslint-disable-next-line @typescript-eslint/no-explicit-any
manifest, extKey, nodeKey, extensionType, extensionKey) {
    if (!manifest) throw new Error(`Extension with key "${extKey}" and type "${extensionType}" not found!`);
    if (!manifest.modules.nodes) throw new Error(`Couldn't find any node for extension type "${extensionType}" and key "${extensionKey}"!`);
    const node = manifest.modules.nodes[nodeKey];
    if (!node) throw new Error(`Node with key "${extensionKey}" not found on manifest for extension type "${extensionType}" and key "${extensionKey}"!`);
    return node;
}
async function $05c1a9b049285eb2$export$82dd45c2db936caf(extensionProvider, extensionType, extensionKey) {
    const [extKey, nodeKey] = (0, $3jQ9y.getExtensionKeyAndNodeKey)(extensionKey, extensionType);
    const manifest = await extensionProvider.getExtension(extensionType, extKey);
    return $05c1a9b049285eb2$var$getNodeFromManifest(manifest, extKey, nodeKey, extensionType, extensionKey);
}
function $05c1a9b049285eb2$export$903681ffb5af37a7(extensionProvider, extensionType, extensionKey) {
    const [extKey, nodeKey] = (0, $3jQ9y.getExtensionKeyAndNodeKey)(extensionKey, extensionType);
    const manifest = extensionProvider?.getPreloadedExtension?.(extensionType, extKey);
    if (manifest) return $05c1a9b049285eb2$var$getNodeFromManifest(manifest, extKey, nodeKey, extensionType, extensionKey);
    else return extensionProvider.getExtension(extensionType, extKey).then((manifest)=>$05c1a9b049285eb2$var$getNodeFromManifest(manifest, extKey, nodeKey, extensionType, extensionKey));
}
async function $05c1a9b049285eb2$export$426f8efd8690d8aa(extensionProvider, extensionType, extensionKey) {
    const moduleNode = await $05c1a9b049285eb2$export$82dd45c2db936caf(extensionProvider, extensionType, extensionKey);
    return Object.keys(moduleNode).filter((key)=>key.startsWith('__')).reduce((acc, key)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        acc[key] = moduleNode[key];
        return acc;
    }, {});
}
function $05c1a9b049285eb2$var$ExtensionLoading(props) {
    if (props.error || props.timedOut) {
        // eslint-disable-next-line no-console
        console.error('Error rendering extension', props.error);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, "Error loading the extension!");
    } else return null;
}
function $05c1a9b049285eb2$export$67a7d49db68d30a0(extensionProvider, extensionType, extensionKey) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
        __loadable_id__: "w8Pzf",
        name: "getNodeRenderer",
        _maybeSyncLoader: true,
        loader: ()=>{
            const maybePromise = $05c1a9b049285eb2$export$903681ffb5af37a7(extensionProvider, extensionType, extensionKey);
            if (maybePromise instanceof Promise) return maybePromise.then((node)=>(0, $3jQ9y.resolveImport)(node.render()));
            else {
                const preloaded = maybePromise?.renderSync?.();
                // Only product implemented preloading will return sync result
                // However the out-of-box won't handle this. Confluence uses a custom implementation
                return preloaded ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, $3jQ9y.resolveImportSync)(preloaded) : (0, $3jQ9y.resolveImport)(maybePromise.render());
            }
        },
        loading: $05c1a9b049285eb2$var$ExtensionLoading
    });
}
module.exports["getExtensionModuleNode"] = $05c1a9b049285eb2$export$82dd45c2db936caf;
module.exports["getExtensionModuleNodePrivateProps"] = $05c1a9b049285eb2$export$426f8efd8690d8aa;
module.exports["getNodeRenderer"] = $05c1a9b049285eb2$export$67a7d49db68d30a0;

});

parcelRegister("3jQ9y", function(module, exports) {
const $e45bd9e65e516a2b$export$a7d04c836550045a = 'com.atlassian.ecosystem';
const $e45bd9e65e516a2b$export$8a49818572e1d105 = (extensionKey, extensionType)=>{
    // Forge macro extensionKey has a user generated string, so splitting on
    // a colon is unstable for their particular use case. They only have one
    // node in the relevant manifest so we can hardcode nodeKey to 'default'.
    if (extensionType === $e45bd9e65e516a2b$export$a7d04c836550045a) return [
        extensionKey,
        'default'
    ];
    const [extKey, nodeKey = 'default'] = extensionKey.split(':');
    return [
        extKey,
        nodeKey
    ];
};
const $e45bd9e65e516a2b$export$5f3eb042babacbbd = (extensionKey, nodeKey)=>{
    if (!nodeKey || nodeKey === 'default') return extensionKey;
    return `${extensionKey}:${nodeKey}`;
};
function $e45bd9e65e516a2b$export$bb33bcdd9a10a608(action, manifest) {
    if (typeof action === 'function') return action;
    if (action.type === 'node' && manifest.modules.nodes) return $e45bd9e65e516a2b$export$33863d887d6f4bfd(action, manifest);
}
const $e45bd9e65e516a2b$export$dca2026e63034304 = (importedModule)=>{
    return importedModule && importedModule.__esModule ? importedModule.default : importedModule;
};
const $e45bd9e65e516a2b$export$d69c9b451c47653b = async (importPromise)=>{
    return $e45bd9e65e516a2b$export$dca2026e63034304(await importPromise);
};
function $e45bd9e65e516a2b$export$33863d887d6f4bfd(action, manifest) {
    if (!manifest.modules.nodes) return;
    const node = manifest.modules.nodes[action.key];
    const extensionKey = $e45bd9e65e516a2b$export$5f3eb042babacbbd(manifest.key, action.key);
    const extension = {
        type: node.type,
        attrs: {
            extensionType: manifest.type,
            extensionKey: extensionKey,
            parameters: action.parameters
        }
    };
    if (node.type === 'bodiedExtension') return {
        ...extension,
        content: [
            {
                type: 'paragraph',
                content: []
            }
        ]
    };
    else if (node.type === 'multiBodiedExtension') return {
        ...extension,
        content: [
            {
                type: 'extensionFrame',
                content: [
                    {
                        type: 'paragraph',
                        content: []
                    }
                ]
            }
        ]
    };
    return extension;
}
module.exports["getExtensionKeyAndNodeKey"] = $e45bd9e65e516a2b$export$8a49818572e1d105;
module.exports["buildAction"] = $e45bd9e65e516a2b$export$bb33bcdd9a10a608;
module.exports["resolveImportSync"] = $e45bd9e65e516a2b$export$dca2026e63034304;
module.exports["resolveImport"] = $e45bd9e65e516a2b$export$d69c9b451c47653b;

});

parcelRegister("dYBVS", function(module, exports) {
/* eslint-disable @repo/internal/react/no-class-components */ 
var $42omo = parcelRequire("42omo");

class $45c1f6450eda5090$export$d498ee8be33e096f extends (0, $42omo.PureComponent) {
    componentDidMount() {
        this.mounted = true;
    }
    componentWillUnmount() {
        const { providers: providers, providerFactory: providerFactory } = this.props;
        providers.forEach((name)=>{
            providerFactory.unsubscribe(name, this.handleProviderIfMounted);
        });
    }
    render() {
        const { state: state, props: props } = this;
        const { renderNode: renderNode } = props;
        return renderNode(state.providers);
    }
    constructor(props){
        super(props);
        this.mounted = false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.handleProviderIfMounted = (name, provider)=>{
            if (!this.mounted) return;
            this.handleProvider(name, provider);
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.handleProvider = (name, provider)=>{
            this.setState(({ providers: providers })=>{
                return {
                    providers: {
                        ...providers,
                        [name]: provider
                    }
                };
            });
        };
        this.mounted = false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const _providers = {};
        this.props.providers.forEach((name)=>{
            const providerPromise = props.providerFactory.subscribe(name, this.handleProviderIfMounted);
            _providers[name] = providerPromise;
        });
        this.state = {
            providers: _providers
        };
    }
}
$45c1f6450eda5090$export$d498ee8be33e096f.displayName = 'WithProviders';
module.exports["WithProviders"] = $45c1f6450eda5090$export$d498ee8be33e096f;

});

parcelRegister("2diEG", function(module, exports) {
function $b48cc40544bb1d44$export$9214452ef07eda7(extensionHandler) {
    if (typeof extensionHandler === 'object') return extensionHandler.render;
    else return extensionHandler;
}
module.exports["getExtensionRenderer"] = $b48cc40544bb1d44$export$9214452ef07eda7;

});

parcelRegister("frt7o", function(module, exports) {
$parcel$export(module.exports, "default", () => $df5484c93cd47d97$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $fp8V7 = parcelRequire("fp8V7");

const $df5484c93cd47d97$export$4735dd2b0fa88aa5 = {
    RIGHT_SHADOW: 'right-shadow',
    LEFT_SHADOW: 'left-shadow'
};
function $df5484c93cd47d97$export$2e2bcd8739ae039(Component, options) {
    return class OverflowShadow extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
        componentWillUnmount() {
            if (options.useShadowObserver) return this.shadowObserver && this.shadowObserver.dispose();
            if (this.overflowContainer) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowContainer.removeEventListener('scroll', this.handleScroll);
            this.updateShadows();
        }
        componentDidUpdate() {
            if (!options.useShadowObserver) this.updateShadows();
        }
        initShadowObserver() {
            if (this.shadowObserver || !this.overflowContainer) return;
            this.shadowObserver = new (0, $fp8V7.ShadowObserver)({
                scrollContainer: this.overflowContainer,
                onUpdateShadows: (shadowStates)=>{
                    this.setState((prevState)=>{
                        const { showLeftShadow: showLeftShadow, showRightShadow: showRightShadow } = shadowStates;
                        if (showLeftShadow !== prevState.showLeftShadow || showRightShadow !== prevState.showRightShadow) return {
                            showLeftShadow: showLeftShadow,
                            showRightShadow: showRightShadow
                        };
                        return null;
                    });
                }
            });
        }
        render() {
            const { showLeftShadow: showLeftShadow, showRightShadow: showRightShadow } = this.state;
            const classNames = [
                !this.props?.disableTableOverflowShadow && showRightShadow && $df5484c93cd47d97$export$4735dd2b0fa88aa5.RIGHT_SHADOW,
                !this.props?.disableTableOverflowShadow && showLeftShadow && $df5484c93cd47d97$export$4735dd2b0fa88aa5.LEFT_SHADOW,
                options.useShadowObserver && (0, $fp8V7.shadowObserverClassNames).SHADOW_CONTAINER
            ].filter(Boolean).join(' ');
            return(// Ignored via go/ees005
            // eslint-disable-next-line react/jsx-props-no-spreading
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
                handleRef: this.handleContainer,
                shadowClassNames: classNames,
                ...this.props
            }));
        }
        constructor(...args){
            super(...args);
            this.overflowContainer = void 0;
            this.container = void 0;
            this.shadowObserver = void 0;
            this.overflowContainerWidth = 0;
            this.scrollable = void 0;
            this.diff = void 0;
            this.state = {
                showLeftShadow: false,
                showRightShadow: false
            };
            this.handleScroll = (event)=>{
                if (!this.overflowContainer || event.target !== this.overflowContainer || options.useShadowObserver) return;
                this.updateShadows();
            };
            this.updateShadows = ()=>{
                if (options.useShadowObserver) return;
                this.setState((prevState)=>{
                    if (!this.overflowContainer) return;
                    const diff = this.calcOverflowDiff();
                    const showRightShadow = diff > 0 && diff > this.overflowContainer.scrollLeft;
                    const showLeftShadow = this.showLeftShadow(this.overflowContainer);
                    if (showLeftShadow !== prevState.showLeftShadow || showRightShadow !== this.state.showRightShadow) return {
                        showLeftShadow: showLeftShadow,
                        showRightShadow: showRightShadow
                    };
                    return null;
                });
            };
            this.showLeftShadow = (overflowContainer)=>{
                return !!overflowContainer && overflowContainer.scrollLeft > 0;
            };
            this.calcOverflowDiff = ()=>{
                if (!this.overflowContainer) return 0;
                this.diff = this.calcScrollableWidth();
                return this.diff - this.overflowContainer.offsetWidth;
            };
            this.calcScrollableWidth = ()=>{
                if (!this.scrollable && this.overflowContainer) return this.overflowContainer.scrollWidth;
                if (!this.scrollable) return 0;
                let width = 0;
                for(let i = 0; i < this.scrollable.length; i++){
                    // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    const scrollableElement = this.scrollable[i];
                    width += scrollableElement.scrollWidth;
                }
                return width;
            };
            this.handleContainer = (container)=>{
                if (!container || this.container) return;
                this.container = container;
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                this.overflowContainer = container.querySelector(options.overflowSelector);
                if (!this.overflowContainer) this.overflowContainer = container;
                if (options.useShadowObserver) {
                    this.initShadowObserver();
                    return;
                }
                this.updateShadows();
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.overflowContainer.addEventListener('scroll', this.handleScroll);
            };
        }
    };
}
module.exports["shadowClassNames"] = $df5484c93cd47d97$export$4735dd2b0fa88aa5;

});

parcelRegister("fJNzZ", function(module, exports) {

var $aFUXX = parcelRequire("aFUXX");


var $61p3e = parcelRequire("61p3e");


var $4BBKV = parcelRequire("4BBKV");


var $bWRlG = parcelRequire("bWRlG");


var $4vlwG = parcelRequire("4vlwG");

const $d5ea6d1627235160$export$ead1fecec2ecf57c = {
    padding: (0, $aFUXX.akEditorBreakoutPadding),
    defaultLayoutWidth: (0, $aFUXX.akEditorDefaultLayoutWidth),
    wideScaleRatio: (0, $aFUXX.breakoutWideScaleRatio),
    fullWidthLayoutWidth: (0, $aFUXX.akEditorFullWidthLayoutWidth),
    wideLayoutWidth: (0, $aFUXX.akEditorWideLayoutWidth),
    mapBreakpointToLayoutMaxWidth: $4BBKV.mapBreakpointToLayoutMaxWidth,
    getBreakpoint: $bWRlG.getBreakpoint,
    /**
	 * This function can return percentage value or px value depending upon the inputs
	 */ calcBreakoutWidth: (breakoutConsts)=>(layout, containerWidth, padding)=>{
            const effectiveFullWidth = containerWidth - (padding ?? breakoutConsts.padding);
            switch(layout){
                case 'full-width':
                    return `${Math.min(effectiveFullWidth, breakoutConsts.fullWidthLayoutWidth)}px`;
                case 'wide':
                    if (effectiveFullWidth <= 0) return '100%';
                    const wideWidth = breakoutConsts.calcWideWidth(breakoutConsts)(containerWidth, undefined, undefined, padding);
                    if (wideWidth.endsWith('%')) return `${Math.min(effectiveFullWidth, breakoutConsts.fullWidthLayoutWidth)}px`;
                    return wideWidth;
                default:
                    return '100%';
            }
        },
    calcBreakoutWithCustomWidth: (breakoutConsts)=>(mode, width, editorContainerWidth)=>{
            if (width !== null && width > 0) {
                const effectiveFullWidth = editorContainerWidth - breakoutConsts.padding;
                // if below 0 then expect we're rendering in SSR
                return `${Math.min(width, effectiveFullWidth)}px`;
            }
            return breakoutConsts.calcBreakoutWidth(breakoutConsts)(mode, editorContainerWidth);
        },
    calcLineLength: (breakoutConsts)=>()=>breakoutConsts.defaultLayoutWidth,
    calcWideWidth: (breakoutConsts)=>(containerWidth = breakoutConsts.defaultLayoutWidth, maxWidth = Infinity, fallback = '100%', padding)=>{
            const effectiveFullWidth = containerWidth - (padding ?? breakoutConsts.padding);
            const layoutMaxWidth = breakoutConsts.mapBreakpointToLayoutMaxWidth(breakoutConsts.getBreakpoint(containerWidth));
            const wideWidth = Math.min(Math.ceil(layoutMaxWidth * breakoutConsts.wideScaleRatio), effectiveFullWidth);
            return layoutMaxWidth > wideWidth ? fallback : `${Math.min(maxWidth, wideWidth)}px`;
        }
};
const $d5ea6d1627235160$export$b34ea040d1533a3 = (layout, containerWidth)=>{
    const breakoutWidth = $d5ea6d1627235160$export$ead1fecec2ecf57c.calcBreakoutWidth($d5ea6d1627235160$export$ead1fecec2ecf57c)(layout, containerWidth);
    // If it's percent, map to max layout size
    if (breakoutWidth.endsWith('%')) switch(layout){
        case 'full-width':
            return 0, $aFUXX.akEditorFullWidthLayoutWidth;
        case 'wide':
            return 0, $aFUXX.akEditorWideLayoutWidth;
        default:
            return $d5ea6d1627235160$export$ead1fecec2ecf57c.mapBreakpointToLayoutMaxWidth($d5ea6d1627235160$export$ead1fecec2ecf57c.getBreakpoint(containerWidth));
    }
    return parseInt(breakoutWidth, 10);
};
const $d5ea6d1627235160$export$86325001fe8f3adc = $d5ea6d1627235160$export$ead1fecec2ecf57c.calcWideWidth($d5ea6d1627235160$export$ead1fecec2ecf57c);
const $d5ea6d1627235160$export$5f4502874a28dfce = $d5ea6d1627235160$export$ead1fecec2ecf57c.calcBreakoutWidth($d5ea6d1627235160$export$ead1fecec2ecf57c);
const $d5ea6d1627235160$export$ccc0a02edddeed39 = $d5ea6d1627235160$export$ead1fecec2ecf57c.calcBreakoutWithCustomWidth($d5ea6d1627235160$export$ead1fecec2ecf57c);
function $d5ea6d1627235160$export$c377853ecdd53e5b({ mode: mode, widthStateLineLength: widthStateLineLength, widthStateWidth: widthStateWidth }) {
    const breakoutWidth = $d5ea6d1627235160$export$5f4502874a28dfce(mode, widthStateWidth);
    const breakoutWidthPx = (0, $4vlwG.parsePx)(breakoutWidth);
    if (!widthStateLineLength) // lineLength is not normally undefined when this is run for,
    // consumers but can be in SSR, initial render or test (jsdom)
    // environments.
    //
    // this approach doesn't work well with position: fixed, so
    // it breaks things like sticky headers.
    //
    // It can also cause bluriness for some child content (such as iframes)
    return {
        type: 'line-length-unknown',
        width: breakoutWidth,
        minWidth: breakoutWidthPx,
        display: 'flex',
        justifyContent: 'center',
        transform: 'none',
        transition: `min-width 0.5s ${0, $aFUXX.akEditorSwoopCubicBezier}`
    };
    // NOTE
    // At time of writing -- when toggling between full-width and
    // full-page appearance modes. There is a slight delay before
    // the widthState is updated.
    // During this period -- the marginLeftPx will be incorrect.
    // const marginLeftPx = -(breakoutWidthPx - widthStateLineLength) / 2;
    return {
        type: 'line-length-known',
        width: breakoutWidth,
        minWidth: breakoutWidthPx,
        transition: `min-width 0.5s ${0, $aFUXX.akEditorSwoopCubicBezier}`,
        transform: `translateX(-50%)`,
        marginLeft: `50%`
    };
}
function $d5ea6d1627235160$export$586300c53bd298dd(mode, widthStateWidth, padding) {
    return (0, $4vlwG.parsePx)($d5ea6d1627235160$export$5f4502874a28dfce(mode, widthStateWidth, padding));
}
const $d5ea6d1627235160$export$7eb758567e6644fd = (currentMode)=>{
    if (currentMode === 'full-width') return 'center';
    else if (currentMode === 'wide') return 'full-width';
    return 'wide';
};
const $d5ea6d1627235160$export$70d1bf7729efff40 = (layout)=>{
    switch(layout){
        case 'full-width':
            return (0, $61p3e.default).layoutFixedWidth;
        case 'wide':
            return (0, $61p3e.default).layoutFullWidth;
        default:
            return (0, $61p3e.default).layoutWide;
    }
};
module.exports["breakoutConsts"] = $d5ea6d1627235160$export$ead1fecec2ecf57c;
module.exports["absoluteBreakoutWidth"] = $d5ea6d1627235160$export$b34ea040d1533a3;
module.exports["calcWideWidth"] = $d5ea6d1627235160$export$86325001fe8f3adc;
module.exports["calcBreakoutWidth"] = $d5ea6d1627235160$export$5f4502874a28dfce;
module.exports["calculateBreakoutStyles"] = $d5ea6d1627235160$export$c377853ecdd53e5b;
module.exports["getNextBreakoutMode"] = $d5ea6d1627235160$export$7eb758567e6644fd;
module.exports["getTitle"] = $d5ea6d1627235160$export$70d1bf7729efff40;

});

parcelRegister("61p3e", function(module, exports) {
$parcel$export(module.exports, "default", () => $deed4682d9d46c57$export$2e2bcd8739ae039);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $cgtv4 = parcelRequire("cgtv4");


var $hkTaH = parcelRequire("hkTaH");


var $ahUGI = parcelRequire("ahUGI");


var $5duTD = parcelRequire("5duTD");


var $eKkkY = parcelRequire("eKkkY");


var $2UWDO = parcelRequire("2UWDO");


var $7Rcde = parcelRequire("7Rcde");



var $fpEzC = parcelRequire("fpEzC");


var $ckqYV = parcelRequire("ckqYV");



var $f8J4a = parcelRequire("f8J4a");


var $4HWgE = parcelRequire("4HWgE");


var $gVDfZ = parcelRequire("gVDfZ");


var $3RxtY = parcelRequire("3RxtY");


var $8aWkM = parcelRequire("8aWkM");


var $2zaaI = parcelRequire("2zaaI");


var $2CQVV = parcelRequire("2CQVV");


var $5Ilz2 = parcelRequire("5Ilz2");


var $ocPnd = parcelRequire("ocPnd");


var $agX1m = parcelRequire("agX1m");


var $1moKB = parcelRequire("1moKB");


var $l51YQ = parcelRequire("l51YQ");


var $2REsZ = parcelRequire("2REsZ");


var $c5kBY = parcelRequire("c5kBY");


var $lzn6v = parcelRequire("lzn6v");



var $jOP6v = parcelRequire("jOP6v");


var $2iuib = parcelRequire("2iuib");


var $hdkJi = parcelRequire("hdkJi");


var $fHFVT = parcelRequire("fHFVT");


var $02xUP = parcelRequire("02xUP");


var $ePpFN = parcelRequire("ePpFN");


var $iesbi = parcelRequire("iesbi");


var $e0nFU = parcelRequire("e0nFU");


var $dwl7L = parcelRequire("dwl7L");


var $b0RMS = parcelRequire("b0RMS");


var $1o1Zn = parcelRequire("1o1Zn");


var $5dODy = parcelRequire("5dODy");


var $kofef = parcelRequire("kofef");


var $808tb = parcelRequire("808tb");


var $fzXn1 = parcelRequire("fzXn1");


var $c067q = parcelRequire("c067q");

var $deed4682d9d46c57$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    layoutFixedWidth: {
        id: "fabric.editor.layoutFixedWidth",
        defaultMessage: "Back to center"
    },
    layoutStateFixedWidth: {
        id: "fabric.editor.layoutStateFixedWidth",
        defaultMessage: "Centered"
    },
    layoutWide: {
        id: "fabric.editor.layoutWide",
        defaultMessage: "Go wide"
    },
    layoutStateWide: {
        id: "fabric.editor.layoutStateWide",
        defaultMessage: "Wide"
    },
    layoutFullWidth: {
        id: "fabric.editor.layoutFullWidth",
        defaultMessage: "Go full width"
    },
    layoutStateFullWidth: {
        id: "fabric.editor.layoutStateFullWidth",
        defaultMessage: "Full width"
    },
    alignImageRight: {
        id: "fabric.editor.alignImageRight",
        defaultMessage: "Align right"
    },
    alignImageCenter: {
        id: "fabric.editor.alignImageCenter",
        defaultMessage: "Align center"
    },
    alignImageLeft: {
        id: "fabric.editor.alignImageLeft",
        defaultMessage: "Align left"
    },
    delete: {
        id: "fabric.editor.delete",
        defaultMessage: "Delete"
    },
    remove: {
        id: "fabric.editor.remove",
        defaultMessage: "Remove"
    },
    removeEmoji: {
        id: "fabric.editor.removeEmoji",
        defaultMessage: "Remove emoji"
    },
    visit: {
        id: "fabric.editor.visit",
        defaultMessage: "Open link in a new window"
    },
    inviteToEditButtonTitle: {
        id: "fabric.editor.editMode.inviteToEditButton.title",
        defaultMessage: "Invite to edit"
    },
    saveButton: {
        id: "fabric.editor.saveButton",
        defaultMessage: "Save"
    },
    cancelButton: {
        id: "fabric.editor.cancelButton",
        defaultMessage: "Cancel"
    },
    taskList: {
        id: "fabric.editor.tooltip.taskList",
        defaultMessage: "an action item"
    },
    bulletList: {
        id: "fabric.editor.tooltip.bulletList",
        defaultMessage: "a list"
    },
    nestedExpand: {
        id: "fabric.editor.tooltip.nestedExpand",
        defaultMessage: "a nested expand"
    },
    decisionList: {
        id: "fabric.editor.tooltip.decisionList",
        defaultMessage: "a decision list"
    },
    defaultBlockNode: {
        id: "fabric.editor.tooltip.defaultBlockNode",
        defaultMessage: "a block node"
    },
    panel: {
        id: "fabric.editor.tooltip.blockPanel",
        defaultMessage: "a panel"
    },
    blockquote: {
        id: "fabric.editor.blockquote",
        defaultMessage: "a quote"
    },
    timeUpdated: {
        id: "fabric.editor.time.updated",
        defaultMessage: "Updated"
    },
    timeViewed: {
        id: "fabric.editor.time.viewed",
        defaultMessage: "Viewed"
    },
    timeAgo: {
        id: "fabric.editor.time.ago",
        defaultMessage: "ago"
    },
    copyToClipboard: {
        id: "fabric.editor.copyToClipboard",
        defaultMessage: "Copy"
    },
    copiedToClipboard: {
        id: "fabric.editor.copiedToClipboard",
        defaultMessage: "Copied!"
    },
    viewMore: {
        id: "fabric.editor.overflowMenuViewMore",
        defaultMessage: "View more"
    }
});

});

parcelRegister("hkTaH", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $e57f64ef4f7fa472$export$5229ffea355cfdf6 = (0, $cgtv4.defineMessages)({
    alignment: {
        id: "fabric.editor.alignment",
        defaultMessage: "Text alignment"
    },
    alignLeft: {
        id: "fabric.editor.alignLeft",
        defaultMessage: "Align left"
    },
    alignCenter: {
        id: "fabric.editor.alignCenter",
        defaultMessage: "Align center"
    },
    alignRight: {
        id: "fabric.editor.alignRight",
        defaultMessage: "Align right"
    }
});
module.exports["alignmentMessages"] = $e57f64ef4f7fa472$export$5229ffea355cfdf6;

});

parcelRegister("5duTD", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $d91c973aee84789e$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    fullWidthLabel: {
        id: "fabric.editor.breakoutFullWidthLabel",
        defaultMessage: "Full-width"
    },
    wideWidthLabel: {
        id: "fabric.editor.breakoutWideWidthLabel",
        defaultMessage: "Wide"
    },
    resizeHandle: {
        id: "fabric.editor.resizeHandle",
        defaultMessage: "Resize handle"
    },
    resizeExpand: {
        id: "fabric.editor.breakout.resizeExpand",
        defaultMessage: "Resize expand"
    },
    resizeCodeBlock: {
        id: "fabric.editor.breakout.resizeCodeBlock",
        defaultMessage: "Resize code snippet"
    },
    resizeLayout: {
        id: "fabric.editor.breakout.resizeLayout",
        defaultMessage: "Resize layout"
    },
    resizeElement: {
        id: "fabric.editor.breakout.resizeElement",
        defaultMessage: "Resize element"
    }
});
module.exports["messages"] = $d91c973aee84789e$export$defe85febe8b728c;

});

parcelRegister("eKkkY", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $1029fcd095daaf54$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    copyBlock: {
        id: "fabric.editor.block.menu.copy.block",
        defaultMessage: "Copy block"
    },
    copyContent: {
        id: "fabric.editor.block.menu.copy.content",
        defaultMessage: "Copy content"
    },
    moveUpBlock: {
        id: "fabric.editor.block.menu.move.up",
        defaultMessage: "Move up"
    },
    moveDownBlock: {
        id: "fabric.editor.block.menu.move.down",
        defaultMessage: "Move down"
    },
    copyLink: {
        id: "fabric.editor.block.menu.copy.link",
        defaultMessage: "Copy link"
    },
    copyLinkToBlock: {
        id: "fabric.editor.block.menu.copy.link.to.block",
        defaultMessage: "Copy link to block"
    },
    paragraph: {
        id: "fabric.editor.block.menu.paragraph",
        defaultMessage: "Paragraph"
    },
    codeBlock: {
        id: "fabric.editor.block.menu.codeblock",
        defaultMessage: "Code block"
    },
    layout: {
        id: "fabric.editor.block.menu.layout",
        defaultMessage: "Layout"
    },
    deleteBlock: {
        id: "fabric.editor.block.menu.delete.block",
        defaultMessage: "Delete"
    },
    turnInto: {
        id: "fabric.editor.block.menu.turn.into",
        defaultMessage: "Turn into"
    },
    createSyncedBlock: {
        id: "fabric.editor.block.menu.create.synced.block",
        defaultMessage: "Create synced block"
    },
    copySyncedBlock: {
        id: "fabric.editor.block.menu.copy.synced.block",
        defaultMessage: "Copy synced block"
    },
    newLozenge: {
        id: "fabric.editor.block.menu.new.lozenge",
        defaultMessage: "New"
    }
});
module.exports["messages"] = $1029fcd095daaf54$export$defe85febe8b728c;

});

parcelRegister("2UWDO", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $1be454cb3ba0e245$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    normal: {
        id: "fabric.editor.normal",
        defaultMessage: "Normal text"
    },
    heading1: {
        id: "fabric.editor.heading1",
        defaultMessage: "Heading 1"
    },
    heading1Description: {
        id: "fabric.editor.heading1Description",
        defaultMessage: "Use this for a top level heading"
    },
    heading2: {
        id: "fabric.editor.heading2",
        defaultMessage: "Heading 2"
    },
    heading2Description: {
        id: "fabric.editor.heading2Description",
        defaultMessage: "Use this for key sections"
    },
    heading3: {
        id: "fabric.editor.heading3",
        defaultMessage: "Heading 3"
    },
    heading3Description: {
        id: "fabric.editor.heading3Description",
        defaultMessage: "Use this for sub sections and group headings"
    },
    heading4: {
        id: "fabric.editor.heading4",
        defaultMessage: "Heading 4"
    },
    heading4Description: {
        id: "fabric.editor.heading4Description",
        defaultMessage: "Use this for deep headings"
    },
    heading5: {
        id: "fabric.editor.heading5",
        defaultMessage: "Heading 5"
    },
    heading5Description: {
        id: "fabric.editor.heading5Description",
        defaultMessage: "Use this for grouping list items"
    },
    heading6: {
        id: "fabric.editor.heading6",
        defaultMessage: "Heading 6"
    },
    heading6Description: {
        id: "fabric.editor.heading6Description",
        defaultMessage: "Use this for low level headings"
    },
    blockquote: {
        id: "fabric.editor.blockquote2",
        defaultMessage: "Quote"
    },
    blockquoteDescription: {
        id: "fabric.editor.blockquote.description",
        defaultMessage: "Insert a quote or citation"
    },
    codeblock: {
        id: "fabric.editor.codeblock",
        defaultMessage: "Code snippet"
    },
    codeblockDescription: {
        id: "fabric.editor.codeblock.description",
        defaultMessage: "Display code with syntax highlighting"
    },
    infoPanel: {
        id: "fabric.editor.infoPanel",
        defaultMessage: "Info panel"
    },
    infoPanelDescription: {
        id: "fabric.editor.infoPanel.description",
        defaultMessage: "Highlight information in a colored panel"
    },
    notePanel: {
        id: "fabric.editor.notePanel",
        defaultMessage: "Note panel"
    },
    notePanelDescription: {
        id: "fabric.editor.notePanel.description",
        defaultMessage: "Add a note in a colored panel"
    },
    successPanel: {
        id: "fabric.editor.successPanel",
        defaultMessage: "Success panel"
    },
    successPanelDescription: {
        id: "fabric.editor.successPanel.description",
        defaultMessage: "Add tips in a colored panel"
    },
    warningPanel: {
        id: "fabric.editor.warningPanel",
        defaultMessage: "Warning panel"
    },
    warningPanelDescription: {
        id: "fabric.editor.warningPanel.description",
        defaultMessage: "Add a note of caution in a colored panel"
    },
    errorPanel: {
        id: "fabric.editor.errorPanel",
        defaultMessage: "Error panel"
    },
    errorPanelDescription: {
        id: "fabric.editor.errorPanel.description",
        defaultMessage: "Call out errors in a colored panel"
    },
    customPanel: {
        id: "fabric.editor.customPanel",
        defaultMessage: "Custom panel"
    },
    customPanelDescription: {
        id: "fabric.editor.customPanel.description",
        defaultMessage: "Add a note with an emoji and colored background"
    },
    syncedBlock: {
        id: "fabric.editor.syncedBlock",
        defaultMessage: "Create synced block"
    },
    syncedBlockDescription: {
        id: "fabric.editor.syncedBlock.description",
        defaultMessage: "Sync content across multiple locations"
    },
    panel: {
        id: "fabric.editor.panel",
        defaultMessage: "Panel"
    },
    other: {
        id: "fabric.editor.other",
        defaultMessage: "Others..."
    }
});
module.exports["messages"] = $1be454cb3ba0e245$export$defe85febe8b728c;

});

parcelRegister("7Rcde", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $71e03d612e0cb7ab$export$42bb270d1224182 = (0, $cgtv4.defineMessages)({
    /**
   * Message taken from
   * https://hello.atlassian.net/wiki/spaces/~tswan/pages/1366555782/PSHELP-2943+Investigate+Trojan+Source+Attack+Vulnerability+design
   */ label: {
        id: "fabric.editor.codeBidiWarningLabel",
        defaultMessage: "Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code."
    }
});
module.exports["codeBidiWarningMessages"] = $71e03d612e0cb7ab$export$42bb270d1224182;

});

parcelRegister("fpEzC", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $8b2a73d924c824ef$export$4ce3884394d6d9 = (0, $cgtv4.defineMessages)({
    openLink: {
        id: "fabric.editor.openLink",
        defaultMessage: "Open link in a new tab"
    },
    openPreviewPanel: {
        id: "fabric.editor.openPreviewPanel",
        defaultMessage: "Open preview panel"
    }
});
module.exports["linkMessages"] = $8b2a73d924c824ef$export$4ce3884394d6d9;

});

parcelRegister("ckqYV", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $f9584a45f41233ef$export$2d7676d841c8ae9 = (0, $cgtv4.defineMessages)({
    addLink: {
        id: "fabric.editor.mediaAddLink",
        defaultMessage: "Add link"
    },
    unableToOpenLink: {
        id: "fabric.editor.unableToOpenLink",
        defaultMessage: "Unable to open this link"
    },
    unlink: {
        id: "fabric.editor.unlink",
        defaultMessage: "Unlink"
    },
    editDatasourceStandalone: {
        id: "fabric.editor.editDatasourceStandalone",
        defaultMessage: "Edit"
    },
    editDatasourceStandaloneTooltip: {
        id: "fabric.editor.editDatasourceStandaloneTooltip",
        defaultMessage: "Edit search query"
    },
    editLink: {
        id: "fabric.editor.editLink",
        defaultMessage: "Edit link"
    },
    placeholder: {
        id: "fabric.editor.hyperlinkToolbarPlaceholder",
        defaultMessage: "Paste or search for link"
    },
    linkPlaceholder: {
        id: "fabric.editor.linkPlaceholder",
        defaultMessage: "Paste link"
    },
    linkAddress: {
        id: "fabric.editor.linkAddress",
        defaultMessage: "Link address"
    },
    invalidLink: {
        id: "fabric.editor.invalidLink",
        defaultMessage: "Please enter a valid link."
    },
    emptyLink: {
        id: "fabric.editor.emptyLink",
        defaultMessage: "Please enter a link."
    },
    settingsLink: {
        id: "fabric.editor.settingsLinks",
        defaultMessage: "Go to Link Preferences"
    },
    preferencesLink: {
        id: "fabric.editor.preferencesLink",
        defaultMessage: "Link preferences"
    },
    editDatasource: {
        id: "fabric.editor.edit.datasource",
        defaultMessage: "Edit search query"
    },
    searchInput: {
        id: "fabric.editor.edit.searchInput",
        defaultMessage: "Add a link"
    }
});
module.exports["linkToolbarMessages"] = $f9584a45f41233ef$export$2d7676d841c8ae9;

});

parcelRegister("f8J4a", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $a33388bf0f1afdd4$export$74e304339778e94d = (0, $cgtv4.defineMessages)({
    copyCodeToClipboard: {
        id: "fabric.editor.codeBlockCopyButton.copyToClipboard",
        defaultMessage: "Copy as text"
    },
    copiedCodeToClipboard: {
        id: "fabric.editor.codeBlockCopyButton.copiedToClipboard",
        defaultMessage: "Copied!"
    },
    wrapCode: {
        id: "fabric.editor.codeBlockWrapButton.wrapCodeBlock",
        defaultMessage: "Turn on wrap"
    },
    unwrapCode: {
        id: "fabric.editor.codeBlockWrapButton.unwrapCodeBlock",
        defaultMessage: "Turn off wrap"
    },
    selectLanguage: {
        id: "fabric.editor.selectLanguage",
        defaultMessage: "Select language"
    }
});
module.exports["codeBlockButtonMessages"] = $a33388bf0f1afdd4$export$74e304339778e94d;

});

parcelRegister("gVDfZ", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $0889ec8859f0b4df$export$81b075fd34c2f0bb = (0, $cgtv4.defineMessages)({
    wrapLeft: {
        id: "fabric.editor.wrapLeft",
        defaultMessage: "Wrap left"
    },
    wrapRight: {
        id: "fabric.editor.wrapRight",
        defaultMessage: "Wrap right"
    },
    changeToMediaSingle: {
        id: "fabric.editor.media_change_mediasingle",
        defaultMessage: "Original size"
    },
    changeToMediaInlineImage: {
        id: "fabric.editor.media_change_mediainline_default",
        defaultMessage: "Inline"
    },
    changeToMediaInlineImageCaptionWarning: {
        id: "fabric.editor.media_change_mediainline_caption_warn",
        defaultMessage: "Inline (caption will be removed)"
    }
});
module.exports["toolbarMessages"] = $0889ec8859f0b4df$export$81b075fd34c2f0bb;

});

parcelRegister("3RxtY", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $75232df246e43c97$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    url: {
        id: "fabric.editor.url",
        defaultMessage: "Display URL"
    },
    block: {
        id: "fabric.editor.displayBlock",
        defaultMessage: "Display card"
    },
    inline: {
        id: "fabric.editor.displayInline",
        defaultMessage: "Display inline"
    },
    embed: {
        id: "fabric.editor.displayEmbed",
        defaultMessage: "Display embed"
    },
    link: {
        id: "fabric.editor.displayLink",
        defaultMessage: "Display as text"
    },
    card: {
        id: "fabric.editor.cardFloatingControls",
        defaultMessage: "Card options"
    },
    blockCardUnavailable: {
        id: "fabric.editor.blockCardUnavailable",
        defaultMessage: "The inline link is inside {node} and cannot have its view changed"
    },
    displayOptionUnavailableInParentNode: {
        id: "fabric.editor.displayOptionUnavailableInParentNode",
        defaultMessage: "This display option isn't available inside {node}"
    },
    urlTitle: {
        id: "fabric.editor.urlTitle",
        defaultMessage: "URL"
    },
    blockTitle: {
        id: "fabric.editor.blockTitle",
        defaultMessage: "Card"
    },
    inlineTitle: {
        id: "fabric.editor.inlineTitle",
        defaultMessage: "Inline"
    },
    openButtonTitle: {
        id: "fabric.editor.openButtonTitle",
        defaultMessage: "Open"
    },
    panelButtonTitle: {
        id: "fabric.editor.panelButtonTitle",
        defaultMessage: "Panel"
    },
    previewButtonTitle: {
        id: "fabric.editor.previewButtonTitle",
        defaultMessage: "Preview"
    },
    embedTitle: {
        id: "fabric.editor.embedTitle",
        defaultMessage: "Embed"
    },
    urlDescription: {
        id: "fabric.editor.urlDescription",
        defaultMessage: "Display link as URL"
    },
    blockDescription: {
        id: "fabric.editor.blockDescription",
        defaultMessage: "Display more information about a link, including a summary and actions"
    },
    inlineDescription: {
        id: "fabric.editor.inlineDescription",
        defaultMessage: "Display link as inline text"
    },
    embedDescription: {
        id: "fabric.editor.ecombedDescription",
        defaultMessage: "Display an interactive preview of a link"
    },
    embedToBlockCardWarning: {
        id: "fabric.editor.embedToBlockCardWarning",
        defaultMessage: "Displays as a card on small screens"
    },
    editDropdownExpandIconLabel: {
        id: "fabric.editor.editDropdownExpandIconLabel",
        defaultMessage: "Expand dropdown menu"
    },
    editDropdownTriggerTitle: {
        id: "fabric.editor.editDropdownTriggerTitle",
        defaultMessage: "Edit"
    },
    editDropdownEditLinkTitle: {
        id: "fabric.editor.editDropdownEditLinkTitle",
        defaultMessage: "Edit link"
    },
    editDropdownEditDatasourceTitle: {
        id: "fabric.editor.editDropdownEditDatasourceTitle",
        defaultMessage: "Edit search query"
    },
    datasourceTitle: {
        id: "fabric.editor.datasourceTitle",
        defaultMessage: "Edit search query"
    },
    datasourceAppearanceTitle: {
        id: "fabric.editor.datasourceAppearanceTitle",
        defaultMessage: "List"
    },
    datasourceJiraIssue: {
        id: "fabric.editor.datasource.jiraIssue",
        defaultMessage: "Jira Issues"
    },
    datasourceJiraIssueDescription: {
        id: "fabric.editor.datasource.jiraIssue.description",
        defaultMessage: "Insert Jira issues from Jira Cloud with enhanced search, filtering, and configuration."
    },
    datasourceAssetsObjectsGeneralAvailability: {
        id: "fabric.editor.datasource.assetsObjectsGeneralAvailability",
        defaultMessage: "Assets"
    },
    datasourceAssetsObjectsDescription: {
        id: "fabric.editor.datasource.assetsObjects.description",
        defaultMessage: "Insert objects from Assets in Jira Service Management with search and filtering"
    },
    inlineOverlay: {
        id: "fabric.editor.inlineOverlay",
        defaultMessage: "Configure"
    },
    inlineConfigureLink: {
        id: "fabric.editor.inlineConfigureLink",
        defaultMessage: "Configure link"
    },
    inlineGoToLink: {
        id: "fabric.editor.inlineGoToLink",
        defaultMessage: "Go to link"
    },
    datasourceConfluenceSearch: {
        id: "fabric.editor.datasource.confluenceSearch",
        defaultMessage: "Insert Confluence list"
    },
    datasourceConfluenceSearchDescription: {
        id: "fabric.editor.datasource.confluenceSearch.description",
        defaultMessage: "Insert list of search results from Confluence with enhanced search, filtering, and configuration."
    },
    datasourceJiraIssueIssueTermRefresh: {
        id: "fabric.editor.datasource.jiraIssue.issue-term-refresh",
        defaultMessage: "Jira Work Items"
    },
    datasourceJiraIssueDescriptionIssueTermRefresh: {
        id: "fabric.editor.datasource.jiraIssue.description.issue-term-refresh",
        defaultMessage: "Insert Jira work items from Jira Cloud with enhanced search, filtering, and configuration."
    }
});
module.exports["messages"] = $75232df246e43c97$export$defe85febe8b728c;

});

parcelRegister("8aWkM", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $a1c0ccc91a87c11c$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    toolbarLabel: {
        id: "fabric.editor.toolbarLabel",
        defaultMessage: "Editor"
    },
    pageActionsLabel: {
        id: "fabric.editor.pageActionsLabel",
        defaultMessage: "Page actions"
    },
    editableContentLabel: {
        id: "fabric.editor.editableContentLabel",
        defaultMessage: "Editable content"
    }
});
module.exports["messages"] = $a1c0ccc91a87c11c$export$defe85febe8b728c;

});

parcelRegister("2zaaI", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $09bc4db4179d16d9$export$81b075fd34c2f0bb = (0, $cgtv4.defineMessages)({
    underline: {
        id: "fabric.editor.underline",
        defaultMessage: "Underline"
    },
    strike: {
        id: "fabric.editor.strike",
        defaultMessage: "Strikethrough"
    },
    code: {
        id: "fabric.editor.code",
        defaultMessage: "Code"
    },
    codeOn: {
        id: "fabric.editor.code.on",
        defaultMessage: "{textFormattingOff}, Code On"
    },
    subscript: {
        id: "fabric.editor.subscript",
        defaultMessage: "Subscript"
    },
    subscriptOffSuperscriptOn: {
        id: "fabric.editor.subscript.off.superscript.on",
        defaultMessage: "Subscript Off, Superscript On"
    },
    superscript: {
        id: "fabric.editor.superscript",
        defaultMessage: "Superscript"
    },
    superscriptOffSubscriptOn: {
        id: "fabric.editor.superscript.off.subscript.on",
        defaultMessage: "Superscript Off, Subscript On"
    },
    clearFormatting: {
        id: "fabric.editor.clearFormatting",
        defaultMessage: "Clear formatting"
    },
    moreFormatting: {
        id: "fabric.editor.moreFormatting",
        defaultMessage: "More formatting"
    },
    textFormatting: {
        id: "fabric.editor.textFormatting",
        defaultMessage: "Text formatting"
    },
    textFormat: {
        id: "fabric.editor.textFormat",
        defaultMessage: "Format text"
    },
    bold: {
        id: "fabric.editor.bold",
        defaultMessage: "Bold"
    },
    italic: {
        id: "fabric.editor.italic",
        defaultMessage: "Italic"
    },
    on: {
        id: "fabric.editor.on",
        defaultMessage: "{formattingType} On"
    },
    off: {
        id: "fabric.editor.off",
        defaultMessage: "{formattingType} Off"
    },
    textStyles: {
        id: "fabric.editor.textStyles",
        defaultMessage: "{blockTypeName} Text styles"
    },
    textStylesTooltip: {
        id: "fabric.editor.textStylesTooltip",
        defaultMessage: "Text styles"
    },
    textFormattingOff: {
        id: "fabric.editor.text.formatting.off",
        defaultMessage: "Text formatting Off"
    },
    navigateToEditorToolbar: {
        id: "fabric.editor.navigate.toolbar.editor",
        defaultMessage: "Navigate to editor toolbar"
    },
    navigateToFloatingToolbar: {
        id: "fabric.editor.navigate.toolbar.floating",
        defaultMessage: "Navigate to floating toolbar"
    },
    askAI: {
        id: "fabric.editor.navigate.toolbar.askAI",
        defaultMessage: "Ask AI"
    },
    selectionToolbarOverflowMenuTooltip: {
        id: "fabric.editor.selectionToolbarOverflowMenuTooltip",
        defaultMessage: "More options"
    }
});
module.exports["toolbarMessages"] = $09bc4db4179d16d9$export$81b075fd34c2f0bb;

});

parcelRegister("2CQVV", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $3d7dc9b28782bfb3$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    tableScrollRegion: {
        id: "fabric.editor.tableScrollRegion",
        defaultMessage: "Table scroll region"
    },
    tableOptions: {
        id: "fabric.editor.tableOptions",
        defaultMessage: "Table options"
    },
    tableSizeIncreaseScreenReaderInformation: {
        id: "fabric.editor.tableResizeIncreaseScreenReaderInformation",
        defaultMessage: "Table width increased to {newWidth, plural, one {# pixel} other {# pixels}}."
    },
    tableSizeDecreaseScreenReaderInformation: {
        id: "fabric.editor.tableResizeDecreaseScreenReaderInformation",
        defaultMessage: "Table width decreased to {newWidth, plural, one {# pixel} other {# pixels}}."
    },
    headerRow: {
        id: "fabric.editor.headerRow",
        defaultMessage: "Header row"
    },
    headerColumn: {
        id: "fabric.editor.headerColumn",
        defaultMessage: "Header column"
    },
    numberedColumn: {
        id: "fabric.editor.numberedColumn",
        defaultMessage: "Numbered column"
    },
    collapseTable: {
        id: "fabric.editor.collapseTable",
        defaultMessage: "Collapse table"
    },
    resizeTable: {
        id: "fabric.editor.tables.resizeTable",
        defaultMessage: "Resize table"
    },
    insertColumn: {
        id: "fabric.editor.insertColumn",
        defaultMessage: "Insert column right"
    },
    addColumnLeft: {
        id: "fabric.editor.addColumnLeft",
        defaultMessage: "Add column left"
    },
    addColumnRight: {
        id: "fabric.editor.addColumnRight",
        defaultMessage: "Add column right"
    },
    insertColumnDrag: {
        id: "fabric.editor.insertColumnDrag",
        defaultMessage: "Insert column"
    },
    removeColumns: {
        id: "fabric.editor.removeColumns",
        defaultMessage: "Delete {0, plural, one {column} other {columns}}"
    },
    insertRow: {
        id: "fabric.editor.insertRow",
        defaultMessage: "Insert row below"
    },
    addRowAbove: {
        id: "fabric.editor.addRowAbove",
        defaultMessage: "Add row above"
    },
    addRowBelow: {
        id: "fabric.editor.addRowBelow",
        defaultMessage: "Add row below"
    },
    moveColumnLeft: {
        id: "fabric.editor.moveColumnLeft",
        defaultMessage: "Move {0, plural, one {column} other {columns}} left"
    },
    moveColumnRight: {
        id: "fabric.editor.moveColumnRight",
        defaultMessage: "Move {0, plural, one {column} other {columns}} right"
    },
    moveRowUp: {
        id: "fabric.editor.moveRowUp",
        defaultMessage: "Move {0, plural, one {row} other {rows}} up"
    },
    moveRowDown: {
        id: "fabric.editor.moveDownDown",
        defaultMessage: "Move {0, plural, one {row} other {rows}} down"
    },
    insertRowDrag: {
        id: "fabric.editor.insertRowDrag",
        defaultMessage: "Insert row"
    },
    removeRows: {
        id: "fabric.editor.removeRows",
        defaultMessage: "Delete {0, plural, one {row} other {rows}}"
    },
    rowNumbers: {
        id: "fabrid.editor.rowNumbers",
        defaultMessage: "Row numbers",
        desciption: 'Adds a number to each row except header row'
    },
    rowsAreInserted: {
        id: "fabric.editor.rowsAreInserted",
        defaultMessage: "{count, plural, one {A row has been} other {{count} rows have been}} inserted"
    },
    rowsAreRemoved: {
        id: "fabric.editor.rowsAreRemoved",
        defaultMessage: "{count, plural, one {The row has been} other {{count} rows have been}} removed"
    },
    rowSelected: {
        id: "fabric.editor.rowSelected",
        defaultMessage: "Row {index} of {total} selected"
    },
    rowMovedUp: {
        id: "fabric.editor.rowMovedUp",
        defaultMessage: "Row moved up to {index} of {total}"
    },
    rowMovedDown: {
        id: "fabric.editor.rowMovedDown",
        defaultMessage: "Row moved down to {index} of {total}"
    },
    columnsAreInserted: {
        id: "fabric.editor.columnsAreInserted",
        defaultMessage: "{count, plural, one {A column has been} other {{count} columns have been}} inserted"
    },
    columnsAreRemoved: {
        id: "fabric.editor.columnsAreRemoved",
        defaultMessage: "{count, plural, one {The column has been} other {{count} columns have been}} removed"
    },
    columnSelected: {
        id: "fabric.editor.columnSelected",
        defaultMessage: "Column {index} of {total} selected"
    },
    columnMovedLeft: {
        id: "fabric.editor.columnMovedLeft",
        defaultMessage: "Column moved left to {index} of {total}"
    },
    columnMovedRight: {
        id: "fabric.editor.columnMovedRight",
        defaultMessage: "Column moved right to {index} of {total}"
    },
    cellOptions: {
        id: "fabric.editor.cellOptions",
        defaultMessage: "Cell options"
    },
    confirmDeleteLinkedModalOKButton: {
        id: "fabric.editor.tables.confirmDeleteLinkedModalOKButton",
        defaultMessage: "Delete"
    },
    confirmDeleteLinkedModalMessage: {
        id: "fabric.editor.tables.confirmDeleteLinkedModalMessage",
        defaultMessage: "Deleting {nodeName} will break anything connected to it."
    },
    confirmDeleteLinkedModalMessagePrefix: {
        id: "fabric.editor.extension.confirmDeleteLinkedModalMessagePrefix",
        defaultMessage: "Deleting"
    },
    confirmModalCheckboxLabel: {
        id: "fabric.editor.floatingToolbar.confirmModalCheckboxLabel",
        defaultMessage: "Also delete connected elements"
    },
    deleteElementTitle: {
        id: "fabric.editor.extension.deleteElementTitle",
        defaultMessage: "Delete element"
    },
    unnamedSource: {
        id: "fabric.editor.extension.sourceNoTitledName",
        defaultMessage: "this element"
    },
    adjustColumns: {
        id: "fabric.editor.tables.adjustColumn",
        defaultMessage: "Adjust column"
    },
    cornerControl: {
        id: "fabric.editor.cornerControl",
        defaultMessage: "Highlight table"
    },
    cellBackground: {
        id: "fabric.editor.cellBackground",
        defaultMessage: "Cell background"
    },
    backgroundColor: {
        id: "fabric.editor.backgroundColor",
        defaultMessage: "Background color"
    },
    mergeCells: {
        id: "fabric.editor.mergeCells",
        defaultMessage: "Merge cells"
    },
    splitCell: {
        id: "fabric.editor.splitCell",
        defaultMessage: "Split cell"
    },
    clearCells: {
        id: "fabric.editor.clearCells",
        defaultMessage: "Clear {0, plural, one {cell} other {cells}}"
    },
    sortColumnASC: {
        id: "fabric.editor.sortColumnASC",
        defaultMessage: "Sort column A \u2192 Z"
    },
    sortColumnDESC: {
        id: "fabric.editor.sortColumnDESC",
        defaultMessage: "Sort column Z \u2192 A"
    },
    sortColumnIncreasing: {
        id: "fabric.editor.sortColumnIncreasing",
        defaultMessage: "Sort increasing"
    },
    sortColumnDecreasing: {
        id: "fabric.editor.sortColumnDecreasing",
        defaultMessage: "Sort decreasing"
    },
    canNotSortTable: {
        id: "fabric.editor.canNotSortTable",
        defaultMessage: "\u26A0\uFE0F You can't sort a table with merged cells"
    },
    distributeColumns: {
        id: "fabric.editor.distributeColumns",
        defaultMessage: "Distribute columns"
    },
    lockColumnWidths: {
        id: "fabric.editor.lockColumns",
        defaultMessage: "Fixed column widths"
    },
    rowControl: {
        id: "fabric.editor.rowControl",
        defaultMessage: "Highlight row"
    },
    rowDragHandle: {
        id: "fabric.editor.rowDragHandle",
        defaultMessage: "Row options"
    },
    dragHandleZone: {
        id: "fabric.editor.dragHandleZone",
        defaultMessage: "Activate drag handle zone"
    },
    columnDragHandle: {
        id: "fabric.editor.columnDragHandle",
        defaultMessage: "Column options"
    },
    fullWidthLabel: {
        id: "fabric.editor.tableFullWidthLabel",
        defaultMessage: "Full-width"
    },
    startedColumnResize: {
        id: "fabric.editor.tables.startedColumnResize",
        defaultMessage: "Started column resize"
    },
    focusedOtherResize: {
        id: "fabric.editor.tables.otherResize",
        defaultMessage: "{direction, select, left {Switched to the left column resize} right {Switched to the right column resize} other {}}"
    },
    changedColumnWidth: {
        id: "fabric.editor.tables.columnWidth",
        defaultMessage: "{width, plural, one {Column width was changed to {width} pixel} other {Column width was changed to {width} pixels}}"
    },
    columnResizeStop: {
        id: "fabric.editor.tables.resizeStop",
        defaultMessage: "Stopped resize"
    },
    columnResizeOverflow: {
        id: "fabric.editor.tables.columnResizeOverflow",
        defaultMessage: "You can only resize this column while the table has a scroll bar."
    },
    columnResizeLast: {
        id: "fabric.editor.tables.columnResizeLast",
        defaultMessage: "You can only resize this column to the left."
    },
    tableAlignmentOptions: {
        id: "fabric.editor.tableAlignmentOptions",
        defaultMessage: "Alignment options"
    },
    alignTableCenter: {
        id: "fabric.editor.alignTableCenter",
        defaultMessage: "Align center"
    },
    alignTableLeft: {
        id: "fabric.editor.alignTableLeft",
        defaultMessage: "Align left"
    }
});
module.exports["messages"] = $3d7dc9b28782bfb3$export$defe85febe8b728c;

});

parcelRegister("5Ilz2", function(module, exports) {
// Common Translations will live here

var $cgtv4 = parcelRequire("cgtv4");

const $068e62ba641eb2d0$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    unorderedList: {
        id: "fabric.editor.unorderedList",
        defaultMessage: "Bullet list"
    },
    unorderedListDescription: {
        id: "fabric.editor.unorderedList.description",
        defaultMessage: "Create an unordered list"
    },
    bulletedList: {
        id: "fabric.editor.bulletedList",
        defaultMessage: "Bulleted list"
    },
    orderedList: {
        id: "fabric.editor.orderedList",
        defaultMessage: "Numbered list"
    },
    orderedListDescription: {
        id: "fabric.editor.orderedList.description",
        defaultMessage: "Create an ordered list"
    },
    lists: {
        id: "fabric.editor.lists",
        defaultMessage: "Lists"
    },
    listsFormat: {
        id: "fabric.editor.listsFormat",
        defaultMessage: "List formatting"
    }
});
module.exports["messages"] = $068e62ba641eb2d0$export$defe85febe8b728c;

});

parcelRegister("ocPnd", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $fdd67bada3df875e$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    undo: {
        id: "fabric.editor.undo",
        defaultMessage: "Undo"
    },
    redo: {
        id: "fabric.editor.redo",
        defaultMessage: "Redo"
    }
});
module.exports["messages"] = $fdd67bada3df875e$export$defe85febe8b728c;

});

parcelRegister("agX1m", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $999917ff18060c14$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    statusEditorLabel: {
        id: "fabric.editor.statusEditorLabel",
        defaultMessage: "Status editor"
    },
    placeholder: {
        id: "fabric.editor.statusPlaceholder",
        defaultMessage: "Set a status"
    },
    editText: {
        id: "fabric.editor.editStatusText",
        defaultMessage: "Edit Status"
    },
    editColor: {
        id: "fabric.editor.editStatusColor",
        defaultMessage: "Edit Status Color"
    },
    statusPickerOpenedAlert: {
        id: "fabric.editor.statusPickerOpenedAlert",
        defaultMessage: "Status editor popup opened, press Tab to access popup"
    }
});
module.exports["messages"] = $999917ff18060c14$export$defe85febe8b728c;

});

parcelRegister("1moKB", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $1cc68e0c29594f76$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    editText: {
        id: "fabric.editor.editDateText",
        defaultMessage: "Edit Date"
    },
    invalidDateError: {
        id: "fabric.editor.invalidDateError",
        defaultMessage: "Enter a valid date"
    },
    onKeyUpDownText: {
        id: "fabric.editor.upDown",
        defaultMessage: "On the use of up and down arrow keys into the following input field, the date will update below"
    },
    datePickerOpenedAlert: {
        id: "fabric.editor.datePickerOpenedAlert",
        defaultMessage: "Date editor popup opened, press Tab to access popup"
    }
});
module.exports["messages"] = $1cc68e0c29594f76$export$defe85febe8b728c;

});

parcelRegister("l51YQ", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $d073017558d077cd$export$81b075fd34c2f0bb = (0, $cgtv4.defineMessages)({
    singleColumn: {
        id: "fabric.editor.single",
        defaultMessage: "Single column layout"
    },
    twoColumns: {
        id: "fabric.editor.twoColumns",
        defaultMessage: "Two columns layout"
    },
    singleColumnAdvancedLayout: {
        id: "fabric.editor.singleColumns",
        defaultMessage: "1 Column layout"
    },
    twoColumnsAdvancedLayout: {
        id: "fabric.editor.twoColumns",
        defaultMessage: "2 Column layout"
    },
    threeColumns: {
        id: "fabric.editor.threeColumns",
        defaultMessage: "Three columns layout"
    },
    threeColumnsAdvancedLayout: {
        id: "fabric.editor.threeColumns",
        defaultMessage: "3 Column layout"
    },
    fourColumns: {
        id: "fabric.editor.fourColumns",
        defaultMessage: "4 Column layout"
    },
    fiveColumns: {
        id: "fabric.editor.fiveColumns",
        defaultMessage: "5 Column layout"
    },
    rightSidebar: {
        id: "fabric.editor.rightSidebar",
        defaultMessage: "Right sidebar layout"
    },
    leftSidebar: {
        id: "fabric.editor.leftSidebar",
        defaultMessage: "Left sidebar layout"
    },
    threeColumnsWithSidebars: {
        id: "fabric.editor.threeColumnsWithSidebars",
        defaultMessage: "Three columns with sidebars layout"
    },
    threeColumnsWithLeftSidebars: {
        id: "fabric.editor.threeColumnsWithLeftSidebars",
        defaultMessage: "Three columns with left sidebar layout"
    },
    threeColumnsWithRightSidebars: {
        id: "fabric.editor.threeColumnsWithRightSidebars",
        defaultMessage: "Three columns with right sidebar layout"
    },
    floatingToolbarRadioGroupAriaLabel: {
        id: "fabric.editor.floatingToolbar.floatingToolbarRadioGroupAriaLabel",
        defaultMessage: "Layout options"
    },
    layoutPlaceholder: {
        id: "fabric.editor.layout.placeholder",
        defaultMessage: "Add content"
    },
    controlslayoutPlaceholder: {
        id: "fabric.editor.layout.controls.placeholder",
        defaultMessage: "/ to insert"
    },
    columnOption: {
        id: "fabric.editor.layout.columnOption",
        defaultMessage: "{count, plural, one {{count} Column} other {{count} Columns}}"
    },
    resizeLayout: {
        id: "fabric.editor.layout.resizeLayout",
        defaultMessage: "Resize layout"
    }
});
module.exports["toolbarMessages"] = $d073017558d077cd$export$81b075fd34c2f0bb;

});

parcelRegister("2REsZ", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $def49925be501c72$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    indent: {
        id: "fabric.editor.indent",
        defaultMessage: "Indent"
    },
    outdent: {
        id: "fabric.editor.outdent",
        defaultMessage: "Outdent"
    }
});
module.exports["messages"] = $def49925be501c72$export$defe85febe8b728c;

});

parcelRegister("c5kBY", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $42b8e02e0568f6fb$export$8a0e7c3f8f5b8868 = (0, $cgtv4.defineMessages)({
    editors: {
        id: "fabric.editor.editors",
        defaultMessage: "Editors"
    }
});
module.exports["avatarGroupMessages"] = $42b8e02e0568f6fb$export$8a0e7c3f8f5b8868;

});

parcelRegister("lzn6v", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $754e59d9d4a5571d$export$b46a930e1a386b2e = (0, $cgtv4.defineMessages)({
    find: {
        id: "fabric.editor.find",
        defaultMessage: "Find"
    },
    matchCase: {
        id: "fabric.editor.matchCase",
        defaultMessage: "Match case"
    },
    findNext: {
        id: "fabric.editor.findNext",
        defaultMessage: "Find next"
    },
    findPrevious: {
        id: "fabric.editor.findPrevious",
        defaultMessage: "Find previous"
    },
    closeFindReplaceDialog: {
        id: "fabric.editor.closeFindReplaceDialog",
        defaultMessage: "Close"
    },
    noResultsFound: {
        id: "fabric.editor.noResultsFound",
        defaultMessage: "No results"
    },
    resultsCount: {
        id: "fabric.editor.resultsCount",
        defaultMessage: "{selectedMatchPosition} of {totalResultsCount}"
    },
    findReplaceToolbarButton: {
        id: "fabric.editor.findReplaceToolbarButton",
        defaultMessage: "Find and replace"
    },
    replaceWith: {
        id: "fabric.editor.replaceWith",
        defaultMessage: "Replace with"
    },
    replace: {
        id: "fabric.editor.replace",
        defaultMessage: "Replace"
    },
    replaceAll: {
        id: "fabric.editor.replaceAll",
        defaultMessage: "Replace all"
    },
    replaceSuccess: {
        id: "fabric.editor.replaceSuccess",
        defaultMessage: "{numberOfMatches, plural, one {# match replaced} other {# matches replaced}}"
    }
});
module.exports["findReplaceMessages"] = $754e59d9d4a5571d$export$b46a930e1a386b2e;

});

parcelRegister("jOP6v", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $360b616eee27c764$export$effb4ee8b6f74abe = (0, $cgtv4.defineMessages)({
    textColor: {
        id: "fabric.editor.textColor",
        defaultMessage: "{selectedColorName} Text color"
    },
    textColorTooltip: {
        id: "fabric.editor.textColorTooltip",
        defaultMessage: "Text color"
    },
    textColorHighlightTooltip: {
        id: "fabric.editor.textColorHighlightTooltip",
        defaultMessage: "Text and Highlight color"
    }
});
module.exports["textColorMessages"] = $360b616eee27c764$export$effb4ee8b6f74abe;

});

parcelRegister("2iuib", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $924758c132d4c526$export$273d864e9e6d0b1f = (0, $cgtv4.defineMessages)({
    taskPlaceholder: {
        id: "fabric.editor.taskPlaceholder",
        defaultMessage: "Type your action, use '@' to assign to someone."
    },
    decisionPlaceholder: {
        id: "fabric.editor.decisionPlaceholder",
        defaultMessage: "Add a decision\u2026"
    },
    editAccessTitle: {
        id: "fabric.editor.editAccessTitle",
        defaultMessage: "You need edit access"
    },
    requestToEditDescription: {
        id: "fabric.editor.requestToEditDescription",
        defaultMessage: "When you request access, the page owner will receive a notification."
    },
    requestToEdit: {
        id: "fabric.editor.requestToEdit",
        defaultMessage: "Request to edit"
    },
    dismiss: {
        id: "fabric.editor.requestToEditDismiss",
        defaultMessage: "Dismiss"
    },
    markTaskAsCompleted: {
        id: "fabric.editor.taskDecision.markTaskAsCompleted",
        defaultMessage: "Mark task as completed"
    },
    markTaskAsNotCompleted: {
        id: "fabric.editor.taskDecision.markTaskAsNotCompleted",
        defaultMessage: "Mark task as not completed"
    },
    taskList: {
        id: "fabric.editor.taskList",
        defaultMessage: "Task list"
    }
});
module.exports["tasksAndDecisionsMessages"] = $924758c132d4c526$export$273d864e9e6d0b1f;

});

parcelRegister("hdkJi", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $18e8afe4cc6854a5$export$ee8ab8a034b5a8bd = (0, $cgtv4.defineMessages)({
    placeholderTextPlaceholder: {
        id: "fabric.editor.placeholderTextPlaceholder",
        defaultMessage: "Add placeholder text"
    },
    shortEmptyNodePlaceholderText: {
        id: "fabric.editor.shortEmptyNodePlaceholderText",
        defaultMessage: "/ to insert"
    },
    longEmptyNodePlaceholderText: {
        id: "fabric.editor.longEmptyNodePlaceholderText",
        defaultMessage: "Type / to insert elements"
    },
    syncBlockPlaceholderText: {
        id: "fabric.editor.syncBlockPlaceholderText",
        defaultMessage: "Add content then copy this synced block to access it across spaces"
    }
});
module.exports["placeholderTextMessages"] = $18e8afe4cc6854a5$export$ee8ab8a034b5a8bd;

});

parcelRegister("fHFVT", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $be64ff90a26bb531$export$703e803e9cb0cea4 = (0, $cgtv4.defineMessages)({
    pasteOptions: {
        id: "fabric.editor.pasteOptions",
        defaultMessage: "Paste options"
    },
    plainText: {
        id: "fabric.editor.plainText",
        defaultMessage: "Use plain text"
    },
    markdown: {
        id: "fabric.editor.useMarkdown",
        defaultMessage: "Use Markdown"
    },
    richText: {
        id: "fabric.editor.richText",
        defaultMessage: "Use rich text"
    }
});
module.exports["pasteOptionsToolbarMessages"] = $be64ff90a26bb531$export$703e803e9cb0cea4;

});

parcelRegister("02xUP", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $32a348785e1147ed$export$7bb18eb6f9170174 = (0, $cgtv4.defineMessages)({
    info: {
        id: "fabric.editor.info",
        defaultMessage: "Info"
    },
    note: {
        id: "fabric.editor.note",
        defaultMessage: "Note"
    },
    success: {
        id: "fabric.editor.success",
        defaultMessage: "Success"
    },
    warning: {
        id: "fabric.editor.warning",
        defaultMessage: "Warning"
    },
    error: {
        id: "fabric.editor.error",
        defaultMessage: "Error"
    },
    emoji: {
        id: "fabric.editor.panel.emoji",
        defaultMessage: "Add emoji"
    },
    custom: {
        id: "fabric.editor.panel.custom",
        defaultMessage: "Custom"
    },
    backgroundColor: {
        id: "fabric.editor.panel.backgroundColor",
        defaultMessage: "Background color"
    },
    panelsGroup: {
        id: "fabric.editor.panel.panelsGroup",
        defaultMessage: "Panel Types"
    }
});
module.exports["panelMessages"] = $32a348785e1147ed$export$7bb18eb6f9170174;

});

parcelRegister("ePpFN", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $13a2e5f08644d69c$export$33aafd5ccbbbd00a = (0, $cgtv4.defineMessages)({
    inviteItemTitle: {
        id: "fabric.editor.inviteItem.title",
        defaultMessage: "{userRole, select, admin {Invite} trusted {Invite} other {Add}} teammate to {productName}"
    },
    mentionsAddLabel: {
        id: "fabric.editor.mentionsAddLabel",
        defaultMessage: "add-icon"
    },
    mentionsIconLabel: {
        id: "fabric.editor.mentionsIconLabel",
        defaultMessage: "Mention"
    },
    mentionsNodeLabel: {
        id: "fabric.editor.mentionNode.label",
        defaultMessage: "Tagged user"
    },
    unknownLabel: {
        id: "fabric.editor.unknown.label",
        defaultMessage: "Unknown"
    }
});
module.exports["mentionMessages"] = $13a2e5f08644d69c$export$33aafd5ccbbbd00a;

});

parcelRegister("iesbi", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $b210df4a90d17f4b$export$83c85447c71428ba = (0, $cgtv4.defineMessages)({
    editorHelp: {
        id: "fabric.editor.editorHelp",
        defaultMessage: "Editor help"
    },
    helpDialogTips: {
        id: "fabric.editor.helpDialogTips",
        defaultMessage: "Press {keyMap} to quickly open this dialog at any time"
    },
    keyboardShortcuts: {
        id: "fabric.editor.keyboardShortcuts",
        defaultMessage: "Keyboard shortcuts"
    },
    markdown: {
        id: "fabric.editor.markdown",
        defaultMessage: "Markdown"
    },
    pastePlainText: {
        id: "fabric.editor.pastePlainText",
        defaultMessage: "Paste plain text"
    },
    CheckUncheckActionItem: {
        id: "fabric.editor.checkUncheckActionItem",
        defaultMessage: "Toggle action item"
    },
    InsertTableColumn: {
        id: "fabric.editor.insertTableColumn",
        defaultMessage: "Insert table column"
    },
    InsertTableRow: {
        id: "fabric.editor.insertTableRow",
        defaultMessage: "Insert table row"
    },
    altText: {
        id: "fabric.editor.altText",
        defaultMessage: "Alt text"
    },
    selectTableRow: {
        id: "fabric.editor.selectTableRow",
        defaultMessage: "Select table row"
    },
    selectTableColumn: {
        id: "fabric.editor.selectTableColumn",
        defaultMessage: "Select table column"
    },
    selectColumnResize: {
        id: "fabric.editor.selectColumnResize",
        defaultMessage: "Select column resize"
    },
    increaseSize: {
        id: "fabric.editor.increaseSize",
        defaultMessage: "Increase table or media size"
    },
    increaseElementSize: {
        id: "fabric.editor.increaseElementSize",
        defaultMessage: "Increase element size"
    },
    decreaseSize: {
        id: "fabric.editor.decreaseSize",
        defaultMessage: "Decrease table or media size"
    },
    decreaseElementSize: {
        id: "fabric.editor.decreaseElementSize",
        defaultMessage: "Decrease element size"
    },
    openCellOptions: {
        id: "fabric.editor.openCellOptions",
        defaultMessage: "Open cell options"
    },
    focusTableResizeHandle: {
        id: "fabric.editor.focusTableResizeHandle",
        defaultMessage: "Focus table resize handle"
    },
    closeHelpDialog: {
        id: "fabric.editor.closeHelpDialog",
        defaultMessage: "Close help dialog"
    },
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: Move it inside quick insert plugin
    quickInsert: {
        id: "fabric.editor.quickInsert",
        defaultMessage: "Quick insert"
    },
    highlightColor: {
        id: "fabric.editor.highlightColor",
        defaultMessage: "Toggle highlight color palette"
    }
});
module.exports["helpDialogMessages"] = $b210df4a90d17f4b$export$83c85447c71428ba;

});

parcelRegister("e0nFU", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $55d7177264572689$export$456100c8374b6011 = (0, $cgtv4.defineMessages)({
    highlight: {
        id: "fabric.editor.highlight",
        defaultMessage: "Highlight color"
    },
    highlightFloatingToolbar: {
        id: "fabric.editor.highlightFloatingToolbar",
        defaultMessage: "Highlight"
    },
    removeColor: {
        id: "fabric.editor.highlight.removeColor",
        defaultMessage: "Remove color"
    }
});
module.exports["highlightMessages"] = $55d7177264572689$export$456100c8374b6011;

});

parcelRegister("dwl7L", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $57e7b00f8aef02d8$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    dragToMove: {
        id: "fabric.editor.blockControlDragHandleMove",
        defaultMessage: "Drag to move"
    },
    dragToMoveClickToOpen: {
        id: "fabric.editor.blockControlDragHandleMoveOrOpen",
        defaultMessage: "Drag to move {br} Click to open menu"
    },
    dragToRearrange: {
        id: "fabric.editor.blockControlDragHandleRearrange",
        defaultMessage: "Drag to rearrange"
    },
    insert: {
        id: "fabric.editor.blockControlInsert",
        defaultMessage: "Insert"
    },
    moveUp: {
        id: "fabric.editor.blockControlMoveUp",
        defaultMessage: "Move up"
    },
    moveDown: {
        id: "fabric.editor.blockControlMoveDown",
        defaultMessage: "Move down"
    },
    movedup: {
        id: "fabric.editor.blockControlMovedUp",
        defaultMessage: "Content has been moved up"
    },
    movedDown: {
        id: "fabric.editor.blockControlMovedDown",
        defaultMessage: "Content has been moved down"
    },
    moveLeft: {
        id: "fabric.editor.blockControlMoveLeft",
        defaultMessage: "Move left"
    },
    moveRight: {
        id: "fabric.editor.blockControlMoveRight",
        defaultMessage: "Move right"
    },
    delete: {
        id: "fabric.editor.blockControlDelete",
        defaultMessage: "Delete"
    }
});
module.exports["messages"] = $57e7b00f8aef02d8$export$defe85febe8b728c;

});

parcelRegister("b0RMS", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $385543ae0341715d$export$7eb9dc59242bbc45 = (0, $cgtv4.defineMessages)({
    loadPreview: {
        id: "fabric.editor.media.insert.loadPreview",
        defaultMessage: "Load preview"
    },
    insert: {
        id: "fabric.editor.media.insert.insert",
        defaultMessage: "Insert"
    },
    pasteLinkToUpload: {
        id: "fabric.editor.media.insert.pasteLinkToUpload",
        defaultMessage: "Paste link to upload"
    },
    cancel: {
        id: "fabric.editor.media.insert.cancel",
        defaultMessage: "Cancel"
    },
    fromUrlErrorMessage: {
        id: "fabric.editor.media.insert.fromUrlErrorMessage",
        defaultMessage: "Unfortunately, we can\u2019t add this image link. Download the image, then drag and drop onto the page."
    },
    fromUrlWarning: {
        id: "fabric.editor.media.insert.fromUrlWarning",
        defaultMessage: "This image might not be visible to others due to source restrictions. Consider uploading the file instead."
    },
    localFileNetworkErrorMessage: {
        id: "fabric.editor.media.insert.localFileNetworkErrorMessage",
        defaultMessage: "File upload error. Check file path or network."
    },
    localFileErrorMessage: {
        id: "fabric.editor.media.insert.localFileErrorMessage",
        defaultMessage: "This file couldn\u2019t be uploaded."
    },
    mediaAlt: {
        id: "fabric.editor.media.insert.mediaAlt",
        defaultMessage: "Preview for uploaded image or video file"
    },
    upload: {
        id: "fabric.editor.media.insert.upload",
        defaultMessage: "Upload"
    },
    linkTabTitle: {
        id: "fabric.editor.media.insert.linkTabTitle",
        defaultMessage: "Link"
    },
    fileTabTitle: {
        id: "fabric.editor.media.insert.fileTabTitle",
        defaultMessage: "File"
    },
    mediaPickerPopupAriaLabel: {
        id: "fabric.editor.media.insert.mediaPickerPopupAriaLabel",
        defaultMessage: "Media picker"
    },
    invalidUrlErrorMessage: {
        id: "fabric.editor.media.insert.invalidUrlErrorMessage",
        defaultMessage: "Invalid link"
    }
});
module.exports["mediaInsertMessages"] = $385543ae0341715d$export$7eb9dc59242bbc45;

});

parcelRegister("1o1Zn", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $faa277178071abe8$export$6bc8062c04c761fa = (0, $cgtv4.defineMessages)({
    selectionExtensionDropdownButtonLabel: {
        id: "fabric.editor.selectionExtensionDropdownButtonLabel",
        defaultMessage: "Select app"
    },
    externalExtensionsHeading: {
        id: "fabric.editor.externalExtensionsHeading",
        defaultMessage: "Apps"
    }
});
module.exports["selectionExtensionMessages"] = $faa277178071abe8$export$6bc8062c04c761fa;

});

parcelRegister("5dODy", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $bb7725b6f12abdeb$export$b0226831bf5c0d3e = (0, $cgtv4.defineMessages)({
    toolbarAppears: {
        id: "fabric.editor.toolbarAppears",
        defaultMessage: "Toolbar appears"
    },
    toolbarPositionInline: {
        id: "fabric.editor.toolbarPositionInline",
        defaultMessage: "In-line with text"
    },
    toolbarPositionFixedAtTop: {
        id: "fabric.editor.toolbarPositionFixedAtTop",
        defaultMessage: "Fixed at top"
    },
    toolbarPositionUnpined: {
        id: "fabric.editor.toolbarPositionUnpined",
        defaultMessage: "Pin the toolbar at the top"
    },
    toolbarPositionPinedAtTop: {
        id: "fabric.editor.toolbarPositionPinedAtTop",
        defaultMessage: "Unpin the toolbar"
    },
    toolbarPositionUnpinnedConcise: {
        id: "fabric.editor.toolbarPositionUnpinnedConcise",
        defaultMessage: "Pin toolbar to top"
    }
});
module.exports["selectionToolbarMessages"] = $bb7725b6f12abdeb$export$b0226831bf5c0d3e;

});

parcelRegister("kofef", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $81a4f62f6d4935be$export$8ea7f7e979b71fa5 = (0, $cgtv4.defineMessages)({
    panelLabel: {
        id: "fabric.editor.contextPanel.panelLabel",
        defaultMessage: "Context panel"
    }
});
module.exports["contextPanelMessages"] = $81a4f62f6d4935be$export$8ea7f7e979b71fa5;

});

parcelRegister("808tb", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $bda778c801e17725$export$8448461a71ae48a1 = (0, $cgtv4.defineMessages)({
    toolbarIconLabel: {
        id: "editor.trackChanges.toolbarIconLabel",
        defaultMessage: "Track Changes"
    },
    removed: {
        id: "editor.trackChanges.removed",
        defaultMessage: "Removed"
    }
});
module.exports["trackChangesMessages"] = $bda778c801e17725$export$8448461a71ae48a1;

});

parcelRegister("fzXn1", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $f6c896072a7b1f2a$export$254768729b492c8b = (0, $cgtv4.defineMessages)({
    copySyncBlockLabel: {
        id: "fabric.editor.copySyncBlock",
        defaultMessage: "Copy"
    },
    copySyncBlockTooltip: {
        id: "fabric.editor.copySyncBlockTooltip",
        defaultMessage: "Copy reference to clipboard"
    },
    editSourceLabel: {
        id: "fabric.editor.editSourceLabel",
        defaultMessage: "Edit source"
    },
    editSourceTooltip: {
        id: "fabric.editor.editSourceTooltip",
        defaultMessage: "Navigate to source page of the sync block"
    },
    editSourceTooltipDisabled: {
        id: "fabric.editor.editSourceTooltipDisabled",
        defaultMessage: "Source link is not currently available"
    },
    syncBlockGroup: {
        id: "fabric.editor.syncBlockGroup",
        defaultMessage: "Sync Block Types"
    },
    syncedBlockLabel: {
        id: "fabric.editor.syncedBlock",
        defaultMessage: "Synced block"
    },
    permissionDeniedHeading: {
        id: "fabric.editor.syncedBlockPermissionDeniedHeading",
        defaultMessage: "You don't have permission to view this synced block"
    },
    permissionDeniedDescription: {
        id: "fabric.editor.syncedBlockPermissionDeniedDescription",
        defaultMessage: "The source of this synced block is a content item you don't have access to."
    },
    permissionDeniedAltText: {
        id: "fabric.editor.syncedBlockPermissionDeniedIconAltText",
        defaultMessage: "Permission denied."
    },
    requestAccessButton: {
        id: "fabric.editor.requestAccessToSyncedBlock",
        defaultMessage: "Request access"
    },
    accessRequested: {
        id: "fabric.editor.accessToSyncedBlockRequested",
        defaultMessage: "Access requested"
    },
    requestAccessError: {
        id: "fabric.editor.requestAccessToSyncedBlockError",
        defaultMessage: "Something went wrong. Click to try again"
    },
    sourceSyncBlockTooltip: {
        id: "fabric.editor.sourceSyncBlockTooltip",
        defaultMessage: "When you edit this source block it will update across synced locations."
    },
    defaultSyncBlockTooltip: {
        id: "fabric.editor.sourceSyncBlockTooltip",
        defaultMessage: "Synced block"
    },
    referenceSyncBlockTooltip: {
        id: "fabric.editor.referenceSyncBlockTooltip",
        defaultMessage: "Synced from: {title}"
    },
    deleteConfirmationModalTitle: {
        id: "fabric.editor.deleteConfirmationModalTitle",
        defaultMessage: "You're about to delete synced content"
    },
    deleteConfirmationModalCancelButton: {
        id: "fabric.editor.deleteConfirmationModalCancelButton",
        defaultMessage: "Cancel"
    },
    deleteConfirmationModalDeleteButton: {
        id: "fabric.editor.deleteConfirmationModalDeleteButton",
        defaultMessage: "Delete"
    },
    deleteConfirmationModalDescription: {
        id: "fabric.editor.deleteConfirmationModalDescriptionSingle",
        defaultMessage: "Deleting this content will also remove {syncBlockCount, plural, one {a synced block. References to this block} other {# synced blocks. References to these blocks}} in other locations will show an error. Continue with deletion?"
    },
    createSyncBlockLabel: {
        id: "fabric.editor.createSyncBlockLabel",
        defaultMessage: "Create a synced block"
    }
});
module.exports["syncBlockMessages"] = $f6c896072a7b1f2a$export$254768729b492c8b;

});

parcelRegister("c067q", function(module, exports) {
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $cgtv4 = parcelRequire("cgtv4");

const $7792b445fb63e00f$export$e43a7f40817e2ad = (0, $cgtv4.defineMessages)({
    limitedModeTitle: {
        id: "fabric.editor.limitedModeTitle",
        defaultMessage: "Speed improvements"
    },
    limitedModeDescriptionWithLink: {
        id: "fabric.editor.limitedModeDescription",
        defaultMessage: "To increase speed and response time <learnMoreLink>some editing features are limited</learnMoreLink>."
    },
    limitedModeDescriptionWithoutLink: {
        id: "fabric.editor.limitedModeDescriptionWithoutLink",
        defaultMessage: "To increase speed and response time some editing features are limited."
    }
});
module.exports["limitedModeMessages"] = $7792b445fb63e00f$export$e43a7f40817e2ad;

});

parcelRegister("4vlwG", function(module, exports) {
/**
 * Walks a DOM tree up to the provided `stopElement`, or if falsy before.
 * @param element
 * @param stopElement
 */ function $56f33ebd9f14b1a0$export$df14aaf7a527ab0c(element, shouldStop) {
    let rootElement = element;
    while(rootElement && rootElement.parentElement && !shouldStop(rootElement))rootElement = rootElement.parentElement;
    return rootElement;
}
function $56f33ebd9f14b1a0$export$debb760848ca95a(parent, wrapped) {
    const docsFragment = document.createDocumentFragment();
    Array.from(wrapped.children).forEach((child)=>{
        docsFragment.appendChild(child);
    });
    parent.replaceChild(docsFragment, wrapped);
}
function $56f33ebd9f14b1a0$export$5b66dc78851adb5e(el) {
    while(el.parentElement && el.childElementCount === 0 && el.textContent === ''){
        const parentEl = el.parentElement;
        parentEl.removeChild(el);
        el = parentEl;
    }
}
const $56f33ebd9f14b1a0$export$c8913a477cc44663 = (node, className)=>{
    if (!node) return false;
    if (node.classList && node.classList.contains) return node.classList.contains(className);
    if (!node.className) return false;
    const classNames = typeof node.className.baseVal === 'string' ? node.className.baseVal : node.className;
    return classNames.split(' ').indexOf(className) !== -1;
};
function $56f33ebd9f14b1a0$export$ff7f7c97cdce86e(node, s) {
    if (!node) return null;
    let el = node;
    if (!document.documentElement || !document.documentElement.contains(el)) return null;
    if (el.closest) return el.closest(s);
    do {
        const matchfn = el.matches ? el.matches : el.msMatchesSelector;
        if (matchfn && matchfn.call(el, s)) // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        return el;
        el = el.parentElement || el.parentNode;
    }while (el !== null && el.nodeType === 1);
    return null;
}
function $56f33ebd9f14b1a0$export$d508bcfb7f019487(node, s) {
    return $56f33ebd9f14b1a0$export$ff7f7c97cdce86e(node, s);
}
function $56f33ebd9f14b1a0$export$b0eef8cd00b29d5c(pxStr) {
    if (!pxStr.endsWith('px')) return undefined;
    const maybeNumber = parseInt(pxStr, 10);
    return !Number.isNaN(maybeNumber) ? maybeNumber : undefined;
}
function $56f33ebd9f14b1a0$export$b2d5d4f1aeebddf1(elem, callback) {
    const array = [];
    for(let i = 0; i < elem.childElementCount; i++)array.push(callback(elem.children[i], i, elem));
    return array;
}
function $56f33ebd9f14b1a0$export$5b6ab01a6efa50e2(elem, callback) {
    return $56f33ebd9f14b1a0$export$b2d5d4f1aeebddf1(elem, callback);
}
module.exports["walkUpTreeUntil"] = $56f33ebd9f14b1a0$export$df14aaf7a527ab0c;
module.exports["unwrap"] = $56f33ebd9f14b1a0$export$debb760848ca95a;
module.exports["removeNestedEmptyEls"] = $56f33ebd9f14b1a0$export$5b66dc78851adb5e;
module.exports["containsClassName"] = $56f33ebd9f14b1a0$export$c8913a477cc44663;
module.exports["closest"] = $56f33ebd9f14b1a0$export$ff7f7c97cdce86e;
module.exports["closestElement"] = $56f33ebd9f14b1a0$export$d508bcfb7f019487;
module.exports["parsePx"] = $56f33ebd9f14b1a0$export$b0eef8cd00b29d5c;
module.exports["maphElem"] = $56f33ebd9f14b1a0$export$5b6ab01a6efa50e2;

});

parcelRegister("fZRom", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $d925B = parcelRequire("d925B");


var $k7eoe = parcelRequire("k7eoe");


var $hWRJP = parcelRequire("hWRJP");


var $59U23 = parcelRequire("59U23");


var $dQl1W = parcelRequire("dQl1W");

class $e10374371e1c8ea4$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    fireAnalyticsEvent(event) {
        const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
        if (createAnalyticsEvent) {
            const channel = (0, $k7eoe.FabricChannel).editor;
            createAnalyticsEvent(event).fire(channel);
        }
    }
    hasFallback() {
        return typeof this.props.fallbackComponent !== 'undefined';
    }
    shouldRecover() {
        return this.hasFallback() && this.state.errorCaptured;
    }
    componentDidCatch(error, errorInfo) {
        const additionalInfo = this.props.additionalInfo ?? '';
        this.fireAnalyticsEvent({
            action: (0, $d925B.ACTION).CRASHED,
            actionSubject: this.props.component,
            actionSubjectId: this.props.componentId,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
            attributes: {
                platform: (0, $59U23.PLATFORM).WEB,
                errorMessage: `${additionalInfo}${error?.message}`,
                componentStack: errorInfo?.componentStack || undefined,
                errorRethrown: Boolean(this.props.rethrowError)
            }
        });
        (0, $hWRJP.logException)(error, {
            location: 'renderer'
        });
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        const pattern = /Failed to execute.*on 'Node'.*/;
        const matchesPattern = pattern.test(error.message);
        if (matchesPattern) {
            this.fireAnalyticsEvent({
                action: (0, $d925B.ACTION).CAUGHT_DOM_ERROR,
                actionSubject: this.props.component,
                actionSubjectId: this.props.componentId,
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    platform: (0, $59U23.PLATFORM).WEB,
                    errorMessage: `${additionalInfo}${error?.message}`
                }
            });
            this.setState(()=>({
                    domError: true
                }));
        }
        if (this.hasFallback()) this.setState({
            errorCaptured: true
        }, ()=>{
            if (this.props.rethrowError) throw error;
        });
    }
    render() {
        if (this.state.domError) // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
            children: this.props.children
        }, (0, (/*@__PURE__*/$parcel$interopDefault($dQl1W)))());
        if (this.shouldRecover()) return this.props.fallbackComponent;
        return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.state = {
            errorCaptured: false,
            domError: false
        };
    }
}
module.exports["ErrorBoundary"] = $e10374371e1c8ea4$export$e926676385687eaf;

});

parcelRegister("59U23", function(module, exports) {
var $7452dae99863188e$export$88c4881e092abcaf = /*#__PURE__*/ function(PLATFORM) {
    PLATFORM["NATIVE"] = "mobileNative";
    PLATFORM["HYBRID"] = "mobileHybrid";
    PLATFORM["WEB"] = "web";
    return PLATFORM;
}({});
var $7452dae99863188e$export$e48589d9e4824227 = /*#__PURE__*/ function(MODE) {
    MODE["RENDERER"] = "renderer";
    MODE["EDITOR"] = "editor";
    return MODE;
}({});
var $7452dae99863188e$var$RESOLVE_METHOD = /*#__PURE__*/ function(RESOLVE_METHOD) {
    RESOLVE_METHOD["COMPONENT"] = "component";
    RESOLVE_METHOD["CONSUMER"] = "consumer";
    RESOLVE_METHOD["ORPHANED"] = "orphaned";
    return RESOLVE_METHOD;
}($7452dae99863188e$var$RESOLVE_METHOD || {});
module.exports["PLATFORM"] = $7452dae99863188e$export$88c4881e092abcaf;
module.exports["MODE"] = $7452dae99863188e$export$e48589d9e4824227;

});

parcelRegister("gi5bC", function(module, exports) {
var $b7a27a5000feb1b6$export$76a2e4c433c23bb9 = /*#__PURE__*/ function(EVENT_TYPE) {
    EVENT_TYPE["OPERATIONAL"] = "operational";
    EVENT_TYPE["SCREEN"] = "screen";
    EVENT_TYPE["TRACK"] = "track";
    EVENT_TYPE["UI"] = "ui";
    return EVENT_TYPE;
}({});
var $b7a27a5000feb1b6$export$9523889e0a5da4ba = /*#__PURE__*/ function(ACTION) {
    ACTION["STARTED"] = "started";
    ACTION["RENDERED"] = "rendered";
    ACTION["CRASHED"] = "unhandledErrorCaught";
    ACTION["INVALID_PROSEMIRROR_DOCUMENT"] = "invalidProsemirrorDocument";
    ACTION["SELECT_ALL_CAUGHT"] = "selectAllCaught";
    ACTION["SELECT_ALL_ESCAPED"] = "selectAllEscaped";
    ACTION["CLICKED"] = "clicked";
    ACTION["VIEWED"] = "viewed";
    ACTION["VISITED"] = "visited";
    ACTION["SORT_COLUMN"] = "sortedColumn";
    ACTION["SORT_COLUMN_NOT_ALLOWED"] = "sortColumnNotAllowed";
    ACTION["TOGGLE_EXPAND"] = "toggleExpand";
    ACTION["INSERTED"] = "inserted";
    ACTION["OPENED"] = "opened";
    ACTION["CLOSED"] = "closed";
    ACTION["DELETED"] = "deleted";
    ACTION["EDITED"] = "edited";
    ACTION["RESOLVED"] = "resolved";
    ACTION["CREATE_NOT_ALLOWED"] = "createNotAllowed";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED"] = "unsupportedContentLevelsTrackingSucceeded";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED"] = "unsupportedContentLevelsTrackingErrored";
    ACTION["MEDIA_LINK_TRANSFORMED"] = "mediaLinkTransformed";
    ACTION["TABLE_WIDTH_INFO"] = "tableWidthInfo";
    return ACTION;
}({});
var $b7a27a5000feb1b6$export$7525482b5931e326 = /*#__PURE__*/ function(ACTION_SUBJECT) {
    ACTION_SUBJECT["RENDERER"] = "renderer";
    ACTION_SUBJECT["BUTTON"] = "button";
    ACTION_SUBJECT["ANCHOR_LINK"] = "anchorLink";
    ACTION_SUBJECT["TABLE"] = "table";
    ACTION_SUBJECT["EXPAND"] = "expand";
    ACTION_SUBJECT["NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT["MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT["LINK"] = "link";
    ACTION_SUBJECT["ANNOTATION"] = "annotation";
    ACTION_SUBJECT["MEDIA"] = "media";
    ACTION_SUBJECT["SMART_LINK"] = "smartLink";
    return ACTION_SUBJECT;
}({});
var $b7a27a5000feb1b6$export$9957974f8b4d8f74 = /*#__PURE__*/ function(ACTION_SUBJECT_ID) {
    ACTION_SUBJECT_ID["HEADING_ANCHOR_LINK"] = "headingAnchorLink";
    ACTION_SUBJECT_ID["LINK"] = "link";
    ACTION_SUBJECT_ID["HOVER_LABEL"] = "hoverLabel";
    ACTION_SUBJECT_ID["INLINE_COMMENT"] = "inlineComment";
    ACTION_SUBJECT_ID["CODEBLOCK_COPY"] = "codeBlockCopy";
    ACTION_SUBJECT_ID["CODEBLOCK_WRAP"] = "codeBlockWrap";
    return ACTION_SUBJECT_ID;
}({});
module.exports["EVENT_TYPE"] = $b7a27a5000feb1b6$export$76a2e4c433c23bb9;
module.exports["ACTION"] = $b7a27a5000feb1b6$export$9523889e0a5da4ba;
module.exports["ACTION_SUBJECT"] = $b7a27a5000feb1b6$export$7525482b5931e326;
module.exports["ACTION_SUBJECT_ID"] = $b7a27a5000feb1b6$export$9957974f8b4d8f74;

});

parcelRegister("d7o2V", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $e3kjM = parcelRequire("e3kjM");








var $IcpgS = parcelRequire("IcpgS");


var $1lzbj = parcelRequire("1lzbj");


var $lspPP = parcelRequire("lspPP");

const $a9788d28138ffd57$export$41cd4a02859c2806 = (props)=>{
    const providers = (0, $42omo.useContext)((0, $IcpgS.ProvidersContext));
    const actionContext = (0, $42omo.useContext)((0, $lspPP.RendererContext));
    const inlineCommentProvider = providers && providers.inlineComment;
    const updateSubscriber = inlineCommentProvider && inlineCommentProvider.updateSubscriber || null;
    const viewComponentProps = (0, $1lzbj.useAnnotationClickEvent)({
        updateSubscriber: updateSubscriber,
        createAnalyticsEvent: props.createAnalyticsEvent,
        isNestedRender: props.isNestedRender
    });
    const ViewComponent = inlineCommentProvider && inlineCommentProvider.viewComponent;
    const deleteAnnotation = (0, $42omo.useMemo)(()=>(annotationInfo)=>actionContext.deleteAnnotation(annotationInfo.id, annotationInfo.type), [
        actionContext
    ]);
    // For view mode, the finding of inline node types is a bit more complex,
    // that's why we will not provide it as a `inlineNodeTypes` props to the view component,
    // to speed up the rendering process.
    const getInlineNodeTypes = (0, $42omo.useCallback)((annotationId)=>actionContext.getInlineNodeTypes(annotationId), [
        actionContext
    ]);
    if (ViewComponent && viewComponentProps) {
        const { annotations: annotations, clickElementTarget: clickElementTarget } = viewComponentProps;
        return /*#__PURE__*/ (0, $l998X.jsx)(ViewComponent, {
            annotations: annotations,
            clickElementTarget: clickElementTarget,
            deleteAnnotation: deleteAnnotation,
            getInlineNodeTypes: getInlineNodeTypes
        });
    }
    return null;
};



























var $jZG1P = parcelRequire("jZG1P");


var $k7eoe = parcelRequire("k7eoe");


var $d925B = parcelRequire("d925B");





var $3h7Ko = parcelRequire("3h7Ko");

const $e42187240da9c39a$export$2109cd350bcf6eda = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo((props)=>{
    const { component: Component, range: range, isWithinRange: isWithinRange, isAnnotationAllowed: isAnnotationAllowed, wrapperDOM: wrapperDOM, onClose: onCloseProps, documentPosition: documentPosition, applyAnnotation: applyAnnotation, createAnalyticsEvent: createAnalyticsEvent, generateIndexMatch: generateIndexMatch } = props;
    const { promoteHoverToDraft: promoteHoverToDraft, clearHoverDraft: clearHoverDraft } = (0, $3h7Ko.useAnnotationRangeDispatch)();
    const { hoverDraftDocumentPosition: hoverDraftDocumentPosition } = (0, $3h7Ko.useAnnotationRangeState)();
    const actions = (0, $42omo.useContext)((0, $lspPP.RendererContext));
    const onCreateCallback = (0, $42omo.useCallback)((annotationId)=>{
        const positionToAnnotate = hoverDraftDocumentPosition || documentPosition;
        if (!isAnnotationAllowed || !positionToAnnotate || !applyAnnotation) return false;
        const annotation = {
            annotationId: annotationId,
            annotationType: (0, $e3kjM.AnnotationTypes).INLINE_COMMENT
        };
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $d925B.ACTION).INSERTED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).INLINE_COMMENT,
            attributes: {},
            eventType: (0, $d925B.EVENT_TYPE).TRACK
        }).fire((0, $k7eoe.FabricChannel).editor);
        return applyAnnotation(positionToAnnotate, annotation);
    }, [
        isAnnotationAllowed,
        documentPosition,
        applyAnnotation,
        createAnalyticsEvent,
        hoverDraftDocumentPosition
    ]);
    const createIndexCallback = (0, $42omo.useCallback)(()=>{
        if (!documentPosition || !generateIndexMatch) return false;
        const result = generateIndexMatch(documentPosition);
        if (!result) return false;
        return result;
    }, [
        documentPosition,
        generateIndexMatch
    ]);
    const applyDraftModeCallback = (0, $42omo.useCallback)((options)=>{
        if (!documentPosition || !isAnnotationAllowed) {
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $d925B.ACTION).CREATE_NOT_ALLOWED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).INLINE_COMMENT,
                attributes: {
                    documentPosition: documentPosition,
                    isAnnotationAllowed: isAnnotationAllowed
                },
                eventType: (0, $d925B.EVENT_TYPE).TRACK
            }).fire((0, $k7eoe.FabricChannel).editor);
            return false;
        }
        promoteHoverToDraft(documentPosition);
        if (createAnalyticsEvent) {
            const uniqueAnnotationsInRange = actions.getAnnotationsByPosition(range);
            createAnalyticsEvent({
                action: (0, $d925B.ACTION).OPENED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                attributes: {
                    overlap: uniqueAnnotationsInRange.length
                }
            }).fire((0, $k7eoe.FabricChannel).editor);
        }
        window.requestAnimationFrame(()=>{
            if (options.keepNativeSelection) (0, $jZG1P.updateWindowSelectionAroundDraft)(documentPosition);
            else {
                const sel = window.getSelection();
                if (sel) sel.removeAllRanges();
            }
        });
        const positionToAnnotate = hoverDraftDocumentPosition || documentPosition;
        if (!positionToAnnotate || !applyAnnotation || !options.annotationId) {
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $d925B.ACTION).CREATE_NOT_ALLOWED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).INLINE_COMMENT,
                attributes: {
                    positionToAnnotate: positionToAnnotate,
                    applyAnnotationMissing: !applyAnnotation,
                    annotationId: options.annotationId
                },
                eventType: (0, $d925B.EVENT_TYPE).TRACK
            }).fire((0, $k7eoe.FabricChannel).editor);
            return false;
        }
        const annotation = {
            annotationId: options.annotationId,
            annotationType: (0, $e3kjM.AnnotationTypes).INLINE_COMMENT
        };
        return applyAnnotation(positionToAnnotate, annotation);
    }, [
        documentPosition,
        isAnnotationAllowed,
        createAnalyticsEvent,
        applyAnnotation,
        actions,
        range,
        promoteHoverToDraft,
        hoverDraftDocumentPosition
    ]);
    const removeDraftModeCallback = (0, $42omo.useCallback)(()=>{
        clearHoverDraft();
        const sel = window.getSelection();
        if (sel) sel.removeAllRanges();
    }, [
        clearHoverDraft
    ]);
    const onCloseCallback = (0, $42omo.useCallback)(()=>{
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $d925B.ACTION).CLOSED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).INLINE_COMMENT,
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            attributes: {}
        }).fire((0, $k7eoe.FabricChannel).editor);
        removeDraftModeCallback();
        onCloseProps();
    }, [
        onCloseProps,
        removeDraftModeCallback,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)(Component, {
        range: range,
        isWithinRange: isWithinRange,
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        wrapperDOM: wrapperDOM.current,
        isAnnotationAllowed: isAnnotationAllowed,
        onClose: onCloseCallback,
        onCreate: onCreateCallback,
        getAnnotationIndexMatch: createIndexCallback,
        applyDraftMode: applyDraftModeCallback,
        removeDraftMode: removeDraftModeCallback
    });
});









var $hFjCV = parcelRequire("hFjCV");

const $a2ccd099cd67e7f8$export$6d8376a902cb8aa7 = (props)=>{
    const { component: component, rendererRef: rendererRef, createAnalyticsEvent: createAnalyticsEvent } = props;
    const actions = (0, $42omo.useContext)((0, $lspPP.RendererContext));
    const { clearHoverRange: clearHoverRange } = (0, $3h7Ko.useAnnotationRangeDispatch)();
    const { range: range, type: type } = (0, $3h7Ko.useAnnotationRangeState)();
    const { isWithinRange: isWithinRange } = (0, $hFjCV.useAnnotationHoverContext)();
    if (!range || type !== 'hover') return null;
    const documentPosition = actions.getPositionFromRange(range);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $e42187240da9c39a$export$2109cd350bcf6eda), {
        isWithinRange: isWithinRange,
        range: range,
        wrapperDOM: rendererRef,
        component: component,
        onClose: clearHoverRange,
        documentPosition: documentPosition,
        isAnnotationAllowed: true,
        applyAnnotation: actions.applyAnnotation.bind(actions),
        generateIndexMatch: actions.generateAnnotationIndexMatch.bind(actions),
        createAnalyticsEvent: createAnalyticsEvent
    });
};
$a2ccd099cd67e7f8$export$6d8376a902cb8aa7.displayName = 'HoverRangeValidator';














/** Exists in its own module to allow mocking in unit tests */ const $3fda5c6b1c3401ed$export$90ee8f2d9317f430 = (rendererDOM, range)=>{
    const sourceRange = document.createRange();
    sourceRange.selectNode(rendererDOM);
    const isSelectionStartsAfterRenderer = range.compareBoundaryPoints(Range.START_TO_START, sourceRange) === 1;
    const isSelectionStartsBeforeRenderer = range.compareBoundaryPoints(Range.START_TO_END, sourceRange) === 1;
    const isSelectionEndsAfterRenderer = range.compareBoundaryPoints(Range.END_TO_END, sourceRange) === 1;
    return isSelectionStartsAfterRenderer && isSelectionStartsBeforeRenderer && !isSelectionEndsAfterRenderer;
};



var $jSHzw = parcelRequire("jSHzw");

const $9c05d72e21b72e90$export$47201332e612f5a4 = (props)=>{
    const { rendererRef: { current: rendererDOM } } = props;
    const selectionTimeoutRef = (0, $42omo.useRef)();
    const { clearSelectionRange: clearSelectionRange, setSelectionRange: setSelectionRange } = (0, $3h7Ko.useAnnotationRangeDispatch)();
    const { range: range, type: type, selectionDraftRange: selectionDraftRange } = (0, $3h7Ko.useAnnotationRangeState)();
    const { annotationManager: annotationManager } = (0, $jSHzw.useAnnotationManagerDispatch)();
    const lastRangeRef = (0, $42omo.useRef)(null);
    const isAnnotationManagerEnabled = !!annotationManager;
    const onSelectionChange = (0, $42omo.useCallback)((event)=>{
        if (selectionTimeoutRef.current) clearTimeout(selectionTimeoutRef.current);
        selectionTimeoutRef.current = setTimeout(()=>{
            const sel = document.getSelection();
            if (!sel || sel.type !== 'Range' || sel.rangeCount !== 1) {
                lastRangeRef.current = null; // Clear last range if selection is invalid
                if (isAnnotationManagerEnabled) clearSelectionRange();
                return;
            }
            let _range = sel.getRangeAt(0);
            // Skip if the selection hasn't changed
            if (lastRangeRef.current && _range.compareBoundaryPoints(Range.START_TO_START, lastRangeRef.current) === 0 && _range.compareBoundaryPoints(Range.END_TO_END, lastRangeRef.current) === 0) return;
            if (rendererDOM && (0, $3fda5c6b1c3401ed$export$90ee8f2d9317f430)(rendererDOM, _range)) {
                const { startContainer: startContainer, endContainer: endContainer } = _range;
                const isTripleClick = endContainer.nodeType !== Node.TEXT_NODE;
                if (isTripleClick) {
                    let p = startContainer;
                    while(p && p.nodeName !== 'P' && p !== rendererDOM)p = p.parentNode;
                    if (p && p.nodeName === 'P' && p instanceof Element) {
                        const range = document.createRange();
                        range.selectNodeContents(p);
                        sel.removeAllRanges();
                        sel.addRange(range);
                        _range = sel.getRangeAt(0);
                    }
                }
                setSelectionRange(_range.cloneRange());
                lastRangeRef.current = _range;
            }
        }, 100);
    }, [
        rendererDOM,
        setSelectionRange,
        clearSelectionRange,
        isAnnotationManagerEnabled
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!document || !rendererDOM) return;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.addEventListener('selectionchange', onSelectionChange);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('selectionchange', onSelectionChange);
            clearSelectionRange();
        };
    }, [
        rendererDOM,
        onSelectionChange,
        clearSelectionRange
    ]);
    return [
        type,
        range,
        selectionDraftRange,
        clearSelectionRange
    ];
};









var $cUcZ5 = parcelRequire("cUcZ5");





var $dh538 = parcelRequire("dh538");











var $djzd2 = parcelRequire("djzd2");










const $b40078015275204e$export$ca7741472ed8ba00 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo((props)=>{
    const { component: Component, range: range, draftRange: draftRange, isAnnotationAllowed: isAnnotationAllowed, wrapperDOM: wrapperDOM, onClose: onCloseProps, documentPosition: documentPosition, applyAnnotation: applyAnnotation, createAnalyticsEvent: createAnalyticsEvent, generateIndexMatch: generateIndexMatch } = props;
    const { promoteSelectionToDraft: promoteSelectionToDraft, clearSelectionDraft: clearSelectionDraft } = (0, $3h7Ko.useAnnotationRangeDispatch)();
    const { selectionDraftDocumentPosition: selectionDraftDocumentPosition } = (0, $3h7Ko.useAnnotationRangeState)();
    const actions = (0, $42omo.useContext)((0, $lspPP.RendererContext));
    const { isDrafting: isDrafting, draftId: draftId } = (0, $jSHzw.useAnnotationManagerState)();
    const { annotationManager: annotationManager, dispatch: dispatch } = (0, $jSHzw.useAnnotationManagerDispatch)();
    const inlineNodeTypes = (0, $42omo.useMemo)(()=>{
        if (!actions.isRangeAnnotatable(range)) return undefined;
        return (0, $djzd2.getRendererRangeInlineNodeNames)({
            pos: documentPosition,
            actions: actions
        });
    }, [
        documentPosition,
        actions,
        range
    ]);
    const onCreateCallback = (0, $42omo.useCallback)((annotationId)=>{
        // We want to support creation on a documentPosition if the user is only using ranges
        // but we want to prioritize draft positions if they are being used by consumers
        // !!! at this point, the documentPosition can be the wrong position if the user select something else
        const positionToAnnotate = selectionDraftDocumentPosition || documentPosition;
        if (!positionToAnnotate || !applyAnnotation) return false;
        // Evaluate position validity when the user commits the position to be annotated
        const isCreateAllowedOnPosition = actions.isValidAnnotationPosition(positionToAnnotate);
        if (!isCreateAllowedOnPosition) return false;
        const annotation = {
            annotationId: annotationId,
            annotationType: (0, $e3kjM.AnnotationTypes).INLINE_COMMENT
        };
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $d925B.ACTION).INSERTED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).INLINE_COMMENT,
            attributes: {
                inlineNodeNames: inlineNodeTypes
            },
            eventType: (0, $d925B.EVENT_TYPE).TRACK
        }).fire((0, $k7eoe.FabricChannel).editor);
        return applyAnnotation(positionToAnnotate, annotation);
    }, [
        actions,
        documentPosition,
        applyAnnotation,
        createAnalyticsEvent,
        inlineNodeTypes,
        selectionDraftDocumentPosition
    ]);
    const createIndexCallback = (0, $42omo.useCallback)(()=>{
        if (!documentPosition || !generateIndexMatch) return false;
        const result = generateIndexMatch(documentPosition);
        if (!result) return false;
        return result;
    }, [
        documentPosition,
        generateIndexMatch
    ]);
    const applyDraftModeCallback = (0, $42omo.useCallback)((options)=>{
        if (!documentPosition || !isAnnotationAllowed) {
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $d925B.ACTION).CREATE_NOT_ALLOWED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).INLINE_COMMENT,
                attributes: {
                    inlineNodeNames: inlineNodeTypes,
                    documentPosition: documentPosition,
                    isAnnotationAllowed: isAnnotationAllowed
                },
                eventType: (0, $d925B.EVENT_TYPE).TRACK
            }).fire((0, $k7eoe.FabricChannel).editor);
            return false;
        }
        promoteSelectionToDraft(documentPosition);
        if (createAnalyticsEvent) {
            const uniqueAnnotationsInRange = range ? actions.getAnnotationsByPosition(range) : [];
            createAnalyticsEvent({
                action: (0, $d925B.ACTION).OPENED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                attributes: {
                    overlap: uniqueAnnotationsInRange.length,
                    inlineNodeNames: inlineNodeTypes
                }
            }).fire((0, $k7eoe.FabricChannel).editor);
        }
        window.requestAnimationFrame(()=>{
            if (options.keepNativeSelection) (0, $jZG1P.updateWindowSelectionAroundDraft)(documentPosition);
            else {
                const sel = window.getSelection();
                if (sel) sel.removeAllRanges();
            }
        });
        // at this point, the documentPosition is the position that the user has selected,
        // not the selectionDraftDocumentPosition
        // because the documentPosition is not promoted to selectionDraftDocumentPosition yet
        // use platform_editor_comments_api_manager here so we can clear the code path when the flag is removed
        const positionToAnnotate = (0, $dh538.fg)('platform_editor_comments_api_manager') ? documentPosition : selectionDraftDocumentPosition || documentPosition;
        if (!positionToAnnotate || !applyAnnotation || !options.annotationId) {
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $d925B.ACTION).CREATE_NOT_ALLOWED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).INLINE_COMMENT,
                attributes: {
                    positionToAnnotate: positionToAnnotate,
                    applyAnnotationMissing: !applyAnnotation,
                    annotationId: options.annotationId
                },
                eventType: (0, $d925B.EVENT_TYPE).TRACK
            }).fire((0, $k7eoe.FabricChannel).editor);
            return false;
        }
        const annotation = {
            annotationId: options.annotationId,
            annotationType: (0, $e3kjM.AnnotationTypes).INLINE_COMMENT
        };
        return applyAnnotation(positionToAnnotate, annotation);
    }, [
        documentPosition,
        isAnnotationAllowed,
        createAnalyticsEvent,
        applyAnnotation,
        actions,
        range,
        inlineNodeTypes,
        promoteSelectionToDraft,
        selectionDraftDocumentPosition
    ]);
    const removeDraftModeCallback = (0, $42omo.useCallback)(()=>{
        clearSelectionDraft();
        const sel = window.getSelection();
        if (sel) sel.removeAllRanges();
    }, [
        clearSelectionDraft
    ]);
    const onCloseCallback = (0, $42omo.useCallback)(()=>{
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $d925B.ACTION).CLOSED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).INLINE_COMMENT,
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            attributes: {
                inlineNodeNames: inlineNodeTypes
            }
        }).fire((0, $k7eoe.FabricChannel).editor);
        removeDraftModeCallback();
        onCloseProps();
    }, [
        onCloseProps,
        removeDraftModeCallback,
        createAnalyticsEvent,
        inlineNodeTypes
    ]);
    (0, $42omo.useEffect)(()=>{
        if (annotationManager) {
            const allowAnnotation = ()=>{
                if (isDrafting) return false;
                return isAnnotationAllowed;
            };
            annotationManager.hook('allowAnnotation', allowAnnotation);
            return ()=>{
                annotationManager.unhook('allowAnnotation', allowAnnotation);
            };
        }
    }, [
        annotationManager,
        isAnnotationAllowed,
        isDrafting
    ]);
    (0, $42omo.useEffect)(()=>{
        if (annotationManager) {
            const startDraft = ()=>{
                // if there is a draft in progress, we ignore it and start a new draft
                // this is because clearing the draft will remove the mark node from the DOM, which will cause the selection range to be invalid
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                const id = (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))();
                const result = applyDraftModeCallback({
                    annotationId: id,
                    keepNativeSelection: false
                });
                if (!result) return {
                    success: false,
                    reason: 'invalid-range'
                };
                dispatch({
                    type: 'setDrafting',
                    data: {
                        isDrafting: true,
                        draftId: id,
                        draftActionResult: result
                    }
                });
                dispatch({
                    type: 'resetSelectedAnnotation'
                });
                return {
                    success: true,
                    // We cannot get a ref to the target element here
                    // because the draft is not yet applied to the DOM
                    targetElement: undefined,
                    inlineNodeTypes: result.inlineNodeTypes ?? [],
                    actionResult: {
                        step: result.step,
                        doc: result.doc,
                        inlineNodeTypes: result.inlineNodeTypes,
                        targetNodeType: result.targetNodeType,
                        originalSelection: result.originalSelection,
                        numMatches: result.numMatches,
                        matchIndex: result.matchIndex,
                        pos: result.pos
                    }
                };
            };
            annotationManager.hook('startDraft', startDraft);
            return ()=>{
                annotationManager.unhook('startDraft', startDraft);
            };
        }
    }, [
        annotationManager,
        isDrafting,
        applyDraftModeCallback,
        actions,
        range,
        dispatch
    ]);
    (0, $42omo.useEffect)(()=>{
        if (annotationManager) {
            const clearDraft = ()=>{
                if (!isDrafting) return {
                    success: false,
                    reason: 'draft-not-started'
                };
                dispatch({
                    type: 'setDrafting',
                    data: {
                        isDrafting: false,
                        draftId: undefined,
                        draftActionResult: undefined
                    }
                });
                onCloseCallback();
                return {
                    success: true
                };
            };
            annotationManager.hook('clearDraft', clearDraft);
            return ()=>{
                annotationManager.unhook('clearDraft', clearDraft);
            };
        }
    }, [
        annotationManager,
        onCloseCallback,
        isDrafting,
        dispatch
    ]);
    (0, $42omo.useEffect)(()=>{
        if (annotationManager) {
            const applyDraft = (id)=>{
                if (!isDrafting || !draftId) return {
                    success: false,
                    reason: 'draft-not-started'
                };
                const result = onCreateCallback(id);
                if (!result) return {
                    success: false,
                    reason: 'range-no-longer-exists'
                };
                onCloseCallback();
                dispatch({
                    type: 'setDrafting',
                    data: {
                        isDrafting: false,
                        draftId: undefined,
                        draftActionResult: undefined
                    }
                });
                dispatch({
                    type: 'updateAnnotation',
                    data: {
                        id: id,
                        selected: true,
                        markState: (0, $e3kjM.AnnotationMarkStates).ACTIVE
                    }
                });
                return {
                    success: true,
                    targetElement: undefined,
                    actionResult: id !== draftId ? {
                        step: result.step,
                        doc: result.doc,
                        inlineNodeTypes: result.inlineNodeTypes,
                        targetNodeType: result.targetNodeType,
                        originalSelection: result.originalSelection,
                        numMatches: result.numMatches,
                        matchIndex: result.matchIndex,
                        pos: result.pos
                    } : undefined
                };
            };
            annotationManager.hook('applyDraft', applyDraft);
            return ()=>{
                annotationManager.unhook('applyDraft', applyDraft);
            };
        }
    }, [
        annotationManager,
        onCreateCallback,
        onCloseCallback,
        isDrafting,
        draftId,
        dispatch
    ]);
    // Please remove this NOP function when the flag platform_editor_comments_api_manager is removed.
    const nop = (0, $42omo.useMemo)(()=>()=>false, []);
    return /*#__PURE__*/ (0, $l998X.jsx)(Component, {
        range: range,
        draftRange: draftRange,
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        wrapperDOM: wrapperDOM.current,
        isAnnotationAllowed: isAnnotationAllowed,
        onClose: annotationManager ? nop : onCloseCallback,
        onCreate: annotationManager ? nop : onCreateCallback,
        getAnnotationIndexMatch: createIndexCallback,
        applyDraftMode: annotationManager ? nop : applyDraftModeCallback,
        removeDraftMode: annotationManager ? nop : removeDraftModeCallback,
        inlineNodeTypes: inlineNodeTypes
    });
});





const $b486b70e1a3998ec$export$74435b85e23b84d9 = (props)=>{
    const { selectionComponent: selectionComponent, rendererRef: rendererRef, createAnalyticsEvent: createAnalyticsEvent } = props;
    const actions = (0, $42omo.useContext)((0, $lspPP.RendererContext));
    const [type, range, draftRange, clearRange] = (0, $9c05d72e21b72e90$export$47201332e612f5a4)({
        rendererRef: rendererRef
    });
    const selectionRange = type === 'selection' ? range : null;
    // !!! the draft range will become invalid after the mark DOM is inserted
    if (!selectionRange && !draftRange) return null;
    const documentPosition = actions.getPositionFromRange(range);
    // This property is drilled down to consumers when a new range is selected to test it's validity
    let isAnnotationAllowedOnRange = false;
    try {
        isAnnotationAllowedOnRange = documentPosition && actions.isValidAnnotationPosition(documentPosition);
    } catch  {
        isAnnotationAllowedOnRange = false;
    }
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $b40078015275204e$export$ca7741472ed8ba00), {
        range: selectionRange,
        draftRange: draftRange,
        wrapperDOM: rendererRef,
        component: selectionComponent,
        onClose: clearRange,
        documentPosition: documentPosition,
        isAnnotationAllowed: isAnnotationAllowedOnRange,
        applyAnnotation: actions.applyAnnotation.bind(actions),
        generateIndexMatch: actions.generateAnnotationIndexMatch.bind(actions),
        createAnalyticsEvent: createAnalyticsEvent
    });
};
$b486b70e1a3998ec$export$74435b85e23b84d9.displayName = 'SelectionRangeValidator';


const $93be4f7567f6fd00$export$787af8a111ff3c03 = (props)=>{
    const providers = (0, $42omo.useContext)((0, $IcpgS.ProvidersContext));
    const { rendererRef: rendererRef, createAnalyticsEvent: createAnalyticsEvent, children: children } = props;
    const inlineCommentProvider = providers && providers.inlineComment;
    const selectionComponent = inlineCommentProvider && inlineCommentProvider.selectionComponent;
    const hoverComponent = inlineCommentProvider && inlineCommentProvider.hoverComponent;
    if (!selectionComponent && !hoverComponent) return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            children,
            !!hoverComponent && /*#__PURE__*/ (0, $l998X.jsx)((0, $a2ccd099cd67e7f8$export$6d8376a902cb8aa7), {
                createAnalyticsEvent: createAnalyticsEvent,
                rendererRef: rendererRef,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                component: hoverComponent
            }),
            !!selectionComponent && /*#__PURE__*/ (0, $l998X.jsx)((0, $b486b70e1a3998ec$export$74435b85e23b84d9), {
                createAnalyticsEvent: createAnalyticsEvent,
                rendererRef: rendererRef,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                selectionComponent: selectionComponent
            })
        ]
    });
};









var $21K7m = parcelRequire("21K7m");










const $d2f9ac245b0d60aa$export$39f7c1a861a0d41c = ({ adfDocument: adfDocument, isNestedRender: isNestedRender, onLoadComplete: onLoadComplete })=>{
    const actions = (0, $42omo.useContext)((0, $lspPP.RendererContext));
    const providers = (0, $42omo.useContext)((0, $IcpgS.ProvidersContext));
    const { annotationManager: annotationManager, dispatch: dispatch } = (0, $jSHzw.useAnnotationManagerDispatch)();
    const isAnnotationManagerEnabled = !!annotationManager;
    (0, $42omo.useEffect)(()=>{
        if (!providers) return;
        const { inlineComment: { getState: inlineCommentGetState, updateSubscriber: updateSubscriberInlineComment } } = providers;
        const annotations = actions.getAnnotationMarks();
        // we don't want to request integrators for state with an empty list of ids.
        if (!annotations.length) {
            if (!isNestedRender) // inlineCommentGetState handles empty lists gracefully. It has a side-effect of clearing state, which is why this call is needed
            inlineCommentGetState([], isNestedRender);
            onLoadComplete && onLoadComplete({
                numberOfUnresolvedInlineComments: 0
            });
            return;
        }
        const ids = annotations.map((mark)=>mark.attrs.id);
        const cb = (data)=>{
            if (!updateSubscriberInlineComment) return;
            const payload = data.reduce((acc, value)=>({
                    ...acc,
                    [value.id]: value
                }), {});
            if (isAnnotationManagerEnabled) dispatch({
                type: 'loadAnnotation',
                data: Object.keys(payload).map((id)=>({
                        id: id,
                        markState: payload[id].state ?? undefined
                    }))
            });
            else updateSubscriberInlineComment.emit((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_STATE, payload);
            onLoadComplete && onLoadComplete({
                numberOfUnresolvedInlineComments: data.filter((data)=>data.state === 'active').length
            });
        };
        inlineCommentGetState(ids, isNestedRender).then(cb);
    }, [
        actions,
        providers,
        adfDocument,
        isNestedRender,
        onLoadComplete,
        dispatch,
        isAnnotationManagerEnabled
    ]);
};






var $inPa6 = parcelRequire("inPa6");










const $848af0e2e5a97564$var$LoadAnnotations = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(({ adfDocument: adfDocument, isNestedRender: isNestedRender, onLoadComplete: onLoadComplete })=>{
    (0, $d2f9ac245b0d60aa$export$39f7c1a861a0d41c)({
        adfDocument: adfDocument,
        isNestedRender: isNestedRender,
        onLoadComplete: onLoadComplete
    });
    return null;
});
const $848af0e2e5a97564$export$8c8c3e12db6c0591 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    startPos: 1
});
const $848af0e2e5a97564$export$7121915072388536 = (props)=>{
    const { children: children, rendererRef: rendererRef, adfDocument: adfDocument, isNestedRender: isNestedRender, onLoadComplete: onLoadComplete } = props;
    const providers = (0, $42omo.useContext)((0, $IcpgS.ProvidersContext));
    const updateSubscriber = providers && providers.inlineComment && providers.inlineComment.updateSubscriber;
    const inlineCommentAnnotationsState = (0, $1lzbj.useAnnotationStateByTypeEvent)({
        type: (0, $e3kjM.AnnotationTypes).INLINE_COMMENT,
        updateSubscriber: updateSubscriber || null
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $IcpgS.InlineCommentsStateContext).Provider, {
        value: inlineCommentAnnotationsState,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3h7Ko.AnnotationRangeProvider), {
            allowCommentsOnMedia: providers?.inlineComment?.allowCommentsOnMedia ?? false,
            isNestedRender: isNestedRender,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $hFjCV.AnnotationHoverContext), {
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $93be4f7567f6fd00$export$787af8a111ff3c03), {
                    createAnalyticsEvent: createAnalyticsEvent,
                    rendererRef: rendererRef,
                    isNestedRender: isNestedRender,
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)($848af0e2e5a97564$var$LoadAnnotations, {
                            adfDocument: adfDocument,
                            isNestedRender: isNestedRender,
                            onLoadComplete: onLoadComplete
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $a9788d28138ffd57$export$41cd4a02859c2806), {
                            isNestedRender: isNestedRender,
                            createAnalyticsEvent: createAnalyticsEvent
                        }),
                        children
                    ]
                })
            })
        })
    });
};
const $848af0e2e5a97564$export$cef0157dd42cbb3f = (props)=>{
    const { children: children, annotationProvider: annotationProvider, rendererRef: rendererRef, adfDocument: adfDocument, isNestedRender: isNestedRender, onLoadComplete: onLoadComplete } = props;
    if (!isNestedRender && annotationProvider?.annotationManager) // We need to ensure there is a single instance of the annotation manager for the whole document
    // and that it is the same instance for all annotations.
    // This is because the annotation manager is responsible for managing the state of ALL annotations.
    // This includes annotations inside extensions.
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $IcpgS.ProvidersContext).Provider, {
        value: annotationProvider,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $jSHzw.AnnotationManagerProvider), {
            annotationManager: annotationProvider.annotationManager,
            updateSubscriber: annotationProvider?.inlineComment?.updateSubscriber ?? undefined,
            children: /*#__PURE__*/ (0, $l998X.jsx)($848af0e2e5a97564$export$7121915072388536, {
                rendererRef: rendererRef,
                adfDocument: adfDocument,
                isNestedRender: isNestedRender,
                onLoadComplete: onLoadComplete,
                children: children
            })
        })
    });
    else return /*#__PURE__*/ (0, $l998X.jsx)((0, $IcpgS.ProvidersContext).Provider, {
        value: annotationProvider,
        children: /*#__PURE__*/ (0, $l998X.jsx)($848af0e2e5a97564$export$7121915072388536, {
            rendererRef: rendererRef,
            adfDocument: adfDocument,
            isNestedRender: isNestedRender,
            onLoadComplete: onLoadComplete,
            children: children
        })
    });
};
module.exports["AnnotationsPositionContext"] = $848af0e2e5a97564$export$8c8c3e12db6c0591;
module.exports["AnnotationsWrapper"] = $848af0e2e5a97564$export$cef0157dd42cbb3f;

});

parcelRegister("21K7m", function(module, exports) {

var $5rDjV = parcelRequire("5rDjV");

var $b38ed7ab605aa654$export$c1c4b33b4e7b1c70 = /*#__PURE__*/ function(AnnotationUpdateEvent) {
    AnnotationUpdateEvent["SET_ANNOTATION_FOCUS"] = "SET_ANNOTATION_FOCUS";
    AnnotationUpdateEvent["SET_ANNOTATION_HOVERED"] = "SET_ANNOTATION_HOVERED";
    AnnotationUpdateEvent["SET_ANNOTATION_STATE"] = "SET_ANNOTATION_STATE";
    AnnotationUpdateEvent["REMOVE_ANNOTATION_FOCUS"] = "REMOVE_ANNOTATION_FOCUS";
    AnnotationUpdateEvent["REMOVE_ANNOTATION_HOVERED"] = "REMOVE_ANNOTATION_HOVERED";
    AnnotationUpdateEvent["ON_ANNOTATION_CLICK"] = "ON_ANNOTATION_CLICK";
    AnnotationUpdateEvent["DESELECT_ANNOTATIONS"] = "DESELECT_ANNOTATIONS";
    return AnnotationUpdateEvent;
}({});
class $b38ed7ab605aa654$export$7cc60aa9ef845515 {
    emit(event, params) {
        if (typeof params === 'undefined') return this.emitter.emit(event);
        return this.emitter.emit(event, params);
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    on(event, listener) {
        return this.emitter.on(event, listener);
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    off(event, listener) {
        return this.emitter.removeListener(event, listener);
    }
    listeners(event) {
        return this.emitter.listeners(event);
    }
    constructor(){
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($5rDjV)))();
    }
}
module.exports["AnnotationUpdateEvent"] = $b38ed7ab605aa654$export$c1c4b33b4e7b1c70;

});

parcelRegister("lspPP", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $inPa6 = parcelRequire("inPa6");


var $3pfAb = parcelRequire("3pfAb");


var $d925B = parcelRequire("d925B");


var $e3kjM = parcelRequire("e3kjM");


var $bYZ53 = parcelRequire("bYZ53");


var $h9yJL = parcelRequire("h9yJL");


var $ks2lK = parcelRequire("ks2lK");





var $aXG5V = parcelRequire("aXG5V");










function $d5988c5b4b1df67c$var$getStartPos(element) {
    return parseInt(element.dataset.rendererStartPos || '-1', 10);
}
const $d5988c5b4b1df67c$var$getNodeType = (element)=>element.dataset.nodeType;
function $d5988c5b4b1df67c$var$isPositionPointer(element) {
    return $d5988c5b4b1df67c$var$getStartPos(element) > -1;
}
function $d5988c5b4b1df67c$var$findParent(element) {
    const { parentElement: parentElement } = element;
    if (!parentElement || $d5988c5b4b1df67c$export$e3140dc7d0c35e48(parentElement)) return null;
    if ($d5988c5b4b1df67c$var$isPositionPointer(parentElement)) return parentElement;
    return $d5988c5b4b1df67c$var$findParent(parentElement);
}
function $d5988c5b4b1df67c$var$findMediaParent(element) {
    const { parentElement: parentElement } = element;
    if (!parentElement || $d5988c5b4b1df67c$export$e3140dc7d0c35e48(parentElement)) return null;
    if (parentElement.dataset.nodeType === 'mediaSingle') return parentElement;
    return $d5988c5b4b1df67c$var$findMediaParent(parentElement);
}
function $d5988c5b4b1df67c$var$findParentBeforePointer(element) {
    const { parentElement: parentElement } = element;
    if ($d5988c5b4b1df67c$export$e3140dc7d0c35e48(parentElement) || !parentElement) return null;
    if ($d5988c5b4b1df67c$var$isPositionPointer(parentElement)) return element;
    return $d5988c5b4b1df67c$var$findParentBeforePointer(parentElement);
}
function $d5988c5b4b1df67c$var$isElementNode(node) {
    return node.nodeType === Node.ELEMENT_NODE;
}
function $d5988c5b4b1df67c$var$isTextNode(node) {
    return node.nodeType === Node.TEXT_NODE;
}
function $d5988c5b4b1df67c$var$isHighlightTextNode(node) {
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    return !!node?.dataset?.highlighted;
}
function $d5988c5b4b1df67c$var$isNodeInlineMark(node) {
    return $d5988c5b4b1df67c$var$isElementNode(node) && Boolean(node.dataset.rendererMark);
}
function $d5988c5b4b1df67c$var$isElementInlineMark(element) {
    return !!element && Boolean(element.dataset.rendererMark);
}
function $d5988c5b4b1df67c$var$isNodeInlineTextMark(node) {
    if (node === null) return false;
    const isInlineMark = $d5988c5b4b1df67c$var$isElementNode(node) && Boolean(node.dataset.rendererMark);
    if (!isInlineMark) return false;
    /**
   * This checks if the element has any descendents with the data-inline-card
   * attribute set to 'true'. If it does, we should not consider it as an
   * inline text mark.
   **/ if ($d5988c5b4b1df67c$var$hasInlineNodeDescendant(node)) return false;
    return true;
}
/**
 * This checks all the descendents of a node and returns true if it reaches
 * a descendant with the data-inline-card attribute set to 'true'.
 */ function $d5988c5b4b1df67c$var$hasInlineNodeDescendant(node) {
    if ($d5988c5b4b1df67c$var$isElementNode(node)) {
        if ((0, $dh538.fg)('editor_inline_comments_on_inline_nodes')) {
            if (node.dataset.annotationInlineNode === 'true') return true;
        } else {
            if (node.dataset.inlineCard === 'true') return true;
        }
        return Array.from(node.childNodes).some($d5988c5b4b1df67c$var$hasInlineNodeDescendant);
    }
    return false;
}
function $d5988c5b4b1df67c$var$resolveNodePos(node) {
    let resolvedPos = 0;
    let prev = node.previousSibling;
    while(prev){
        if (prev.nodeType === Node.COMMENT_NODE) {
            // Comment nodes should not result in the position being
            // incremented, so we skip them.
            prev = prev.previousSibling;
            continue;
        }
        if (prev && ($d5988c5b4b1df67c$var$isTextNode(prev) || $d5988c5b4b1df67c$var$isHighlightTextNode(prev))) resolvedPos += (prev.textContent || '').length;
        else if (prev) {
            if ((0, $dh538.fg)('editor_inline_comments_on_inline_nodes')) {
                if ($d5988c5b4b1df67c$var$isNodeInlineTextMark(prev) && prev.textContent) resolvedPos += prev.textContent.length;
                else resolvedPos += 1;
            } else if ($d5988c5b4b1df67c$var$isNodeInlineMark(prev) && prev.textContent) resolvedPos += prev.textContent.length;
            else resolvedPos += 1;
        }
        prev = prev.previousSibling;
    }
    return resolvedPos;
}
function $d5988c5b4b1df67c$export$e3140dc7d0c35e48(element) {
    return !!element && element.classList.contains('ak-renderer-document');
}
function $d5988c5b4b1df67c$export$5db587db55468da7(node, offset, findEnd = false) {
    // If the passed node doesn't exist, we should abort
    if (!node) return false;
    if ((0, $dh538.fg)('editor_inline_comments_on_inline_nodes')) {
        const startPosAncestor = node.parentElement?.closest('[data-renderer-start-pos');
        const potentialParent = (0, $dh538.fg)('editor_inline_comments_on_inline_nodes') ? 'data-annotation-mark' : 'data-inline-card';
        if (startPosAncestor?.hasAttribute(potentialParent)) {
            if (findEnd) return parseInt(startPosAncestor?.getAttribute('data-renderer-start-pos') || '-1', 10) + 1;
            else return parseInt(startPosAncestor?.getAttribute('data-renderer-start-pos') || '-1', 10);
        }
    }
    /**
   * If anchor node is an element (e.g. after a triple click) the anchorOffset
   * is the number of child nodes preceding the anchor.
   * https://developer.mozilla.org/en-US/docs/Web/API/Selection/anchorOffset
   *
   * For end pos we calculate the number of characters by stepping through
   * each of the node's children.
   */ if (node instanceof HTMLElement && $d5988c5b4b1df67c$var$isPositionPointer(node)) {
        if (findEnd) {
            let count = $d5988c5b4b1df67c$var$getStartPos(node);
            const children = node.childNodes;
            for(let i = 0; i < offset; i++)count += children[i]?.textContent?.length || 1;
            return count;
        }
        return $d5988c5b4b1df67c$var$getStartPos(node) + offset;
    }
    const parent = $d5988c5b4b1df67c$var$findParent(node);
    // Similar to above, if we cant find a parent position pointer
    // we should not proceed.
    if (!parent) return false;
    let resolvedPos = $d5988c5b4b1df67c$var$getStartPos(parent);
    let current = node;
    if (current.parentElement && current.parentElement !== parent) {
        // Find the parent element that is a direct child of the position pointer
        // the outer most element from our text position.
        const preParentPointer = $d5988c5b4b1df67c$var$findParentBeforePointer(current.parentElement);
        // If our range is inside an inline node
        // We need to move our pointers to parent element
        // since we don't want to count text inside inline nodes at all
        if ((0, $dh538.fg)('editor_inline_comments_on_inline_nodes')) {
            if (!($d5988c5b4b1df67c$var$isNodeInlineTextMark(preParentPointer) || $d5988c5b4b1df67c$var$isHighlightTextNode(preParentPointer))) {
                current = current.parentElement;
                offset = 0;
            }
        } else if (!($d5988c5b4b1df67c$var$isElementInlineMark(preParentPointer) || $d5988c5b4b1df67c$var$isHighlightTextNode(preParentPointer))) {
            current = current.parentElement;
            offset = 0;
        }
        resolvedPos += $d5988c5b4b1df67c$var$resolveNodePos(current);
        while(current && current.parentElement !== parent){
            current = current.parentNode;
            if (current) {
                const nodePos = $d5988c5b4b1df67c$var$resolveNodePos(current);
                resolvedPos += nodePos;
            }
        }
    } else resolvedPos += $d5988c5b4b1df67c$var$resolveNodePos(current);
    return resolvedPos + offset;
}
function $d5988c5b4b1df67c$export$243cdddc5b21d8c1(range) {
    const { startContainer: startContainer, startOffset: startOffset, endContainer: endContainer, endOffset: endOffset } = range;
    const possibleMediaOrMediaSingleElement = $d5988c5b4b1df67c$var$findParent(startContainer);
    // Video hover targets return media single, not media, thus, the extra check in condition.
    const isMediaOrMediaSingle = possibleMediaOrMediaSingleElement && // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    /media|mediaSingle/.test($d5988c5b4b1df67c$var$getNodeType(possibleMediaOrMediaSingleElement) || '');
    if (isMediaOrMediaSingle) {
        let pos;
        const mediaSingleElement = $d5988c5b4b1df67c$var$getNodeType(possibleMediaOrMediaSingleElement) === 'mediaSingle' ? possibleMediaOrMediaSingleElement : $d5988c5b4b1df67c$var$findMediaParent(possibleMediaOrMediaSingleElement);
        if (mediaSingleElement) pos = $d5988c5b4b1df67c$var$getStartPos(mediaSingleElement);
        if (pos !== undefined) return {
            from: pos,
            to: pos
        };
    }
    const from = $d5988c5b4b1df67c$export$5db587db55468da7(startContainer, startOffset);
    const findEnd = true;
    const to = $d5988c5b4b1df67c$export$5db587db55468da7(endContainer, endOffset, findEnd);
    if (from === false || to === false) return false;
    return {
        from: from,
        to: to
    };
}
function $d5988c5b4b1df67c$export$74899f7e5acb5cd3(from, to, opts) {
    return new (0, $aXG5V.AddMarkStep)(Math.min(from, to), Math.max(from, to), opts.schema.marks.annotation.create({
        id: opts.annotationId,
        annotationType: opts.annotationType
    }));
}



var $djzd2 = parcelRequire("djzd2");

function $dfb07954adffbc39$export$fb7dab895a0d310e(doc, schema, selectedText, startIndex) {
    let textContent = '';
    let matchIndex = 0;
    let numMatches = 0;
    let blockNodePos;
    doc.descendants((node, pos)=>{
        const nodeType = node.type;
        const { media: media } = schema.nodes;
        // Mirrors Confluence backend and doesn't construct textContent if it doesn't allow annotations
        // Don't skip media node so that block node can be defined its startIndex in within [nodeStart, nodeEnd]
        if ((node.isText || !nodeType.allowsMarkType(schema.marks.annotation)) && nodeType !== media) // Note: `return true` as a parent disallowing annotations does not mean a child disallows annotations.
        // Eg: panel (invalid) > p (valid)
        return true;
        const nodeStart = pos;
        const nodeEnd = nodeStart + node.nodeSize;
        if (startIndex >= nodeStart && startIndex <= nodeEnd) {
            // if it's a node block, set position to pos to indicate to the backend
            // that it's an annotation on a block node
            if (nodeType === media) blockNodePos = pos;
            // If the start of the annotation selection is within the current node, we scan the document for previous occurrences
            // Find the index by counting all previous instances of the selectedText in the partial textContent
            // Need to scan from start, up to `startIndex` (which includes partial of the current node)
            textContent += doc.textBetween(nodeStart, startIndex - 1);
            matchIndex = $dfb07954adffbc39$export$3c2359e76fc742da(textContent, selectedText);
            // Complete appending of the node
            textContent += doc.textBetween(startIndex, nodeEnd);
        } else textContent += node.textContent;
        return true;
    });
    // Count total number of matches in final text
    numMatches = $dfb07954adffbc39$export$3c2359e76fc742da(textContent, selectedText);
    return {
        numMatches: numMatches,
        matchIndex: matchIndex,
        textContent: textContent,
        blockNodePos: blockNodePos
    };
}
function $dfb07954adffbc39$export$3c2359e76fc742da(searchString, query) {
    if (searchString === '' || query === '') return 0;
    // Escape characters that would trigger as syntax in a regex query before converting to the query
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const reg = new RegExp(query.replace(/(?=[.\\+*?[^\]$(){}\|])/g, '\\'), 'g');
    return (searchString.match(reg) || []).length;
}


class $99cc0efe08aadb17$export$2e2bcd8739ae039 {
    //#region private
    _privateRegisterRenderer(ref, doc, schema, onAnalyticsEvent) {
        if (!this.initFromContext) return;
        else if (!this.ref) this.ref = ref;
        else if (this.ref !== ref) throw new Error("Renderer has already been registered! It's not allowed to re-register with another new Renderer instance.");
        this.doc = doc;
        this.schema = schema;
        this.onAnalyticsEvent = onAnalyticsEvent;
    }
    _privateUnregisterRenderer() {
        this.doc = undefined;
        this.ref = undefined;
        this.schema = undefined;
    }
    /**
   * Validate whether we can create an annotation between two positions
   */ _privateValidatePositionsForAnnotation(from, to) {
        if (!this.doc || !this.schema) return false;
        const currentSelection = (0, $ks2lK.TextSelection).create(this.doc, from, to);
        if ((0, $bYZ53.isEmptyTextSelectionRenderer)(currentSelection, this.schema)) return false;
        const result = (0, $bYZ53.canApplyAnnotationOnRange)({
            from: from,
            to: to
        }, this.doc, this.schema);
        return result;
    }
    //#endregion
    deleteAnnotation(annotationId, annotationType) {
        if (!this.doc || !this.schema || !this.schema.marks.annotation) return false;
        const mark = this.schema.marks.annotation.create({
            id: annotationId,
            annotationType: annotationType
        });
        let from;
        let to;
        let nodePos;
        let step;
        this.doc.descendants((node, pos)=>{
            const found = mark.isInSet(node.marks);
            if (found && node.type.name === 'media') nodePos = pos;
            if (found && !from) {
                // Set both here incase it only spans one node.
                from = pos;
                to = pos + node.nodeSize;
            } else if (found && from) // If the mark spans multiple nodes,
            // we'll keep setting the end until no longer found.
            to = pos + node.nodeSize;
            return true;
        });
        if (nodePos !== undefined) step = new (0, $aXG5V.RemoveNodeMarkStep)(nodePos, mark);
        else {
            if (from === undefined || to === undefined) return false;
            step = new (0, $aXG5V.RemoveMarkStep)(from, to, mark);
        }
        const { doc: doc, failed: failed } = step.apply(this.doc);
        if (this.onAnalyticsEvent) {
            const payload = {
                action: (0, $d925B.ACTION).DELETED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                attributes: {
                    inlineNodeNames: step instanceof (0, $aXG5V.RemoveMarkStep) ? (0, $djzd2.getRendererRangeInlineNodeNames)({
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        pos: {
                            from: from,
                            to: to
                        },
                        actions: this
                    }) : undefined
                }
            };
            this.onAnalyticsEvent(payload);
        }
        if (!failed && doc) return {
            step: step,
            doc: this.transformer.encode(doc)
        };
        return false;
    }
    annotate(range, annotationId, annotationType) {
        if (!this.doc || !this.schema || !this.schema.marks.annotation) return false;
        const pos = (0, $d5988c5b4b1df67c$export$243cdddc5b21d8c1)(range);
        if (!pos) return false;
        const { from: from, to: to } = pos;
        const validPositions = this._privateValidatePositionsForAnnotation(from, to);
        if (!validPositions) return false;
        return this.applyAnnotation(pos, {
            annotationId: annotationId,
            annotationType: (0, $e3kjM.AnnotationTypes).INLINE_COMMENT
        });
    }
    isValidAnnotationRange(range) {
        if (!range) return false;
        if ((0, $dh538.fg)('editor_inline_comments_on_inline_nodes')) {
            if (this.isRendererWithinRange(range)) return false;
        }
        const pos = (0, $d5988c5b4b1df67c$export$243cdddc5b21d8c1)(range);
        if (!pos || !this.doc) return false;
        return this._privateValidatePositionsForAnnotation(pos.from, pos.to);
    }
    isRangeAnnotatable(range) {
        try {
            if (!range) return false;
            const { startContainer: startContainer, endContainer: endContainer } = range;
            if (startContainer.parentElement?.closest('.ak-renderer-extension') || endContainer.parentElement?.closest('.ak-renderer-extension')) return false;
            return this.isValidAnnotationRange(range);
        } catch  {
            // isValidAnnotationRange can fail when called inside nested renderers.
            // while isRendererWithinRange guards against this to some degree -- the classnames
            // are controlled by product -- and we don't have platform guarantees on them.
            //
            // Currently there is a mix of logic across the platform and confluence on determining
            // positions that are annotatable. This is a defensive check to ensure we don't throw an error
            // in cases where the range is not valid.
            return false;
        }
    }
    // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
    /**
   * This is replaced by `isRangeAnnotatable`.
   *
   * @deprecated
   **/ isRendererWithinRange(range) {
        const { startContainer: startContainer, endContainer: endContainer } = range;
        if (startContainer.parentElement && startContainer.parentElement.closest('.ak-renderer-extension') || endContainer.parentElement && endContainer.parentElement.closest('.ak-renderer-extension')) return true;
        return false;
    }
    isValidAnnotationPosition(pos) {
        if (!pos || !this.doc) return false;
        return this._privateValidatePositionsForAnnotation(pos.from, pos.to);
    }
    /**
   * Note: False indicates that the selection not able to be calculated.
   */ getPositionFromRange(range) {
        if (!this.doc || !this.schema || !range) return false;
        return (0, $d5988c5b4b1df67c$export$243cdddc5b21d8c1)(range);
    }
    getAnnotationMarks() {
        const { schema: schema, doc: doc } = this;
        if (!schema || !doc) return [];
        const { marks: { annotation: annotationMarkType } } = schema;
        if (!annotationMarkType) return [];
        const marks = [];
        doc.descendants((node)=>{
            const annotationsMark = node.marks.filter((m)=>m.type === annotationMarkType);
            if (!annotationsMark || !annotationsMark.length) return true;
            marks.push(...annotationsMark);
            return false;
        });
        const uniqueMarks = new Map();
        marks.forEach((m)=>{
            uniqueMarks.set(m.attrs.id, m);
        });
        return Array.from(uniqueMarks.values());
    }
    getAnnotationsByPosition(range) {
        if (!this.doc || !this.schema) return [];
        const pos = (0, $d5988c5b4b1df67c$export$243cdddc5b21d8c1)(range);
        if (!pos || !this.doc) return [];
        return (0, $bYZ53.getAnnotationIdsFromRange)(pos, this.doc, this.schema);
    }
    applyAnnotation(pos, annotation) {
        if (!this.doc || !pos || !this.schema) return false;
        const { from: from, to: to } = pos;
        const { annotationId: annotationId, annotationType: annotationType } = annotation;
        let step;
        let targetNodeType;
        // As part of fix for RAP, `from` points to the position right before media node
        // hence, -1 is not needed
        const beforeNodePos = from;
        const possibleNode = this.doc.nodeAt(beforeNodePos);
        if (possibleNode?.type.name === 'media') {
            targetNodeType = 'media';
            step = new (0, $aXG5V.AddNodeMarkStep)(beforeNodePos, this.schema.marks.annotation.create({
                id: annotationId,
                type: annotationType
            }));
        } else {
            const resolvedNode = this.doc.resolve(from).node();
            // annotation is technically on text, but the context is caption
            targetNodeType = resolvedNode.type.name === 'caption' ? 'caption' : 'text';
            step = (0, $d5988c5b4b1df67c$export$74899f7e5acb5cd3)(from, to, {
                annotationId: annotationId,
                annotationType: annotationType,
                schema: this.schema
            });
        }
        const { doc: doc, failed: failed } = step.apply(this.doc);
        if (failed || !doc) return false;
        const originalSelection = doc.textBetween(from, to);
        const { numMatches: numMatches, matchIndex: matchIndex, blockNodePos: blockNodePos } = (0, $dfb07954adffbc39$export$fb7dab895a0d310e)(this.doc, this.schema, originalSelection, from);
        return {
            step: step,
            doc: this.transformer.encode(doc),
            inlineNodeTypes: (0, $djzd2.getRendererRangeInlineNodeNames)({
                actions: this,
                pos: {
                    from: from,
                    to: to
                }
            }),
            ancestorNodeTypes: (0, $djzd2.getRendererRangeAncestorNodeNames)({
                actions: this,
                pos: {
                    from: from,
                    to: to
                }
            }),
            originalSelection: originalSelection,
            numMatches: numMatches,
            matchIndex: matchIndex,
            pos: blockNodePos,
            targetNodeType: targetNodeType
        };
    }
    generateAnnotationIndexMatch(pos) {
        if (!this.doc || !pos || !this.schema) return false;
        const { from: from, to: to } = pos;
        const originalSelection = this.doc.textBetween(from, to);
        const { numMatches: numMatches, matchIndex: matchIndex, blockNodePos: blockNodePos } = (0, $dfb07954adffbc39$export$fb7dab895a0d310e)(this.doc, this.schema, originalSelection, from);
        return {
            originalSelection: originalSelection,
            numMatches: numMatches,
            matchIndex: matchIndex,
            pos: blockNodePos
        };
    }
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: Do not forget to remove `undefined` when the `editor_inline_comments_on_inline_nodes` is removed.
    getInlineNodeTypes(annotationId) {
        if (!this.doc || !this.schema) return [];
        return (0, $bYZ53.getAnnotationInlineNodeTypes)({
            doc: this.doc,
            schema: this.schema
        }, annotationId);
    }
    constructor(initFromContext = false){
        // This is our psuedo feature flag for now
        // This module can only be used when wrapped with
        // the <RendererContext> component for now.
        this.initFromContext = false;
        this.transformer = void 0;
        this.doc = void 0;
        this.schema = void 0;
        // Any kind of refence is allowed
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.ref = void 0;
        this.onAnalyticsEvent = void 0;
        this.initFromContext = initFromContext;
        this.transformer = new (0, $h9yJL.JSONTransformer)();
    }
}


const $0a20e195094e2f97$export$1e9ea4edb6d1bfe6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(new (0, $99cc0efe08aadb17$export$2e2bcd8739ae039)());
function $0a20e195094e2f97$export$66feffbad722f9d4({ children: children, context: context }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const actions = (0, $42omo.useMemo)(()=>new (0, $99cc0efe08aadb17$export$2e2bcd8739ae039)(true), []);
    // Remove this eventually when root cause is assessed
    if ((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.count(children) > 1 && (0, $dh538.fg)('confluence_frontend_fix_view_page_slo')) // Send event when we get more than 1 child
    try {
        throw new Error('Too many children');
    } catch (e) {
        const { stack: stack } = e;
        createAnalyticsEvent({
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            action: 'rendered',
            actionSubject: 'multipleChildren',
            actionSubjectId: 'rendererActionsContext',
            attributes: {
                numChildren: (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.count(children),
                stackTrace: stack
            }
        }).fire((0, $3pfAb.FabricChannel).editor);
    }
    return /*#__PURE__*/ (0, $l998X.jsx)($0a20e195094e2f97$export$1e9ea4edb6d1bfe6.Provider, {
        value: context || actions,
        children: (0, $dh538.fg)('confluence_frontend_fix_view_page_slo') ? (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.only(children) : children
    });
}
const $0a20e195094e2f97$export$d5fcf151601331bc = $0a20e195094e2f97$export$1e9ea4edb6d1bfe6.Consumer;
module.exports["RendererContext"] = $0a20e195094e2f97$export$1e9ea4edb6d1bfe6;
module.exports["RendererActionsContext"] = $0a20e195094e2f97$export$66feffbad722f9d4;
module.exports["RendererActionsContextConsumer"] = $0a20e195094e2f97$export$d5fcf151601331bc;

});

parcelRegister("h9yJL", function(module, exports) {
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $a4TK8 = parcelRequire("a4TK8");


var $7tm9l = parcelRequire("7tm9l");

var $lU6iV = parcelRequire("lU6iV");

var $6vky0 = parcelRequire("6vky0");

var $lhEMc = parcelRequire("lhEMc");

var $nd92h = parcelRequire("nd92h");

var $gbkVM = parcelRequire("gbkVM");

var $53bvm = parcelRequire("53bvm");

var $8cHA0 = parcelRequire("8cHA0");

var $ivrsj = parcelRequire("ivrsj");


var $1UrkW = parcelRequire("1UrkW");

const $08eccc3aac6e9e51$var$defaultAllowOverrideBehaviour = {
    canOverrideUnsupportedMark: ()=>{
        return true;
    }
};
const $08eccc3aac6e9e51$var$defaultDoNotAllowOverrideBehaviour = {
    canOverrideUnsupportedMark: ()=>{
        return false;
    }
};
const $08eccc3aac6e9e51$export$28e4e3c024cce988 = (type)=>{
    switch(type){
        case 'link':
        case 'em':
        case 'strong':
        case 'strike':
        case 'subsup':
        case 'underline':
        case 'code':
        case 'textColor':
        case 'backgroundColor':
        case 'confluenceInlineComment':
        case 'breakout':
        case 'alignment':
        case 'indentation':
        case 'border':
            return $08eccc3aac6e9e51$var$defaultAllowOverrideBehaviour;
        default:
            return $08eccc3aac6e9e51$var$defaultDoNotAllowOverrideBehaviour;
    }
};



var $dDZcC = parcelRequire("dDZcC");


var $6jPem = parcelRequire("6jPem");

function $36b0fc3bb7ba2bf8$export$9bf001d8ef76e497(node) {
    const newNode = {
        ...node
    };
    delete newNode.marks;
    return newNode;
}
function $36b0fc3bb7ba2bf8$export$8cae9126fc577085(node) {
    const newNode = {
        ...node
    };
    if (node.marks) newNode.marks = node.marks.filter((mark)=>mark.type === 'annotation');
    return newNode;
}


const $f8993b2ce626873e$var$hasNestedTable = (tableCellNode)=>tableCellNode.content?.some((node)=>node?.type === 'table');
function $f8993b2ce626873e$export$48b382180baf8e88(json, options = {}) {
    const { keepNestedTables: keepNestedTables = false } = options;
    const sanitizedJSON = (0, $6jPem.traverse)(json, {
        text: (node)=>{
            if (!node || !Array.isArray(node.marks)) return node;
            return {
                ...node,
                marks: node.marks.filter((mark)=>mark.type !== 'typeAheadQuery')
            };
        },
        status: (node)=>{
            if (node.attrs && !!node.attrs.text) return (0, $36b0fc3bb7ba2bf8$export$8cae9126fc577085)(node);
            return false; // empty status
        },
        caption: (node)=>{
            if (node.content) return node;
            return false; // empty caption
        },
        tableCell: (node)=>{
            if ($f8993b2ce626873e$var$hasNestedTable(node)) return keepNestedTables ? node : (0, $dDZcC.transformNestedTableNodeOutgoingDocument)(node);
            return;
        },
        tableHeader: (node)=>{
            if ($f8993b2ce626873e$var$hasNestedTable(node)) return keepNestedTables ? node : (0, $dDZcC.transformNestedTableNodeOutgoingDocument)(node);
            return;
        },
        emoji: (0, $36b0fc3bb7ba2bf8$export$8cae9126fc577085),
        mention: (0, $36b0fc3bb7ba2bf8$export$8cae9126fc577085),
        date: (0, $36b0fc3bb7ba2bf8$export$8cae9126fc577085),
        hardBreak: (0, $36b0fc3bb7ba2bf8$export$9bf001d8ef76e497),
        inlineCard: (0, $36b0fc3bb7ba2bf8$export$8cae9126fc577085)
    });
    return sanitizedJSON;
}


var $f8f7a748914a9c23$export$933e6445c497ffd5 = /*#__PURE__*/ function(SchemaStage) {
    SchemaStage["FINAL"] = "final";
    SchemaStage["STAGE_0"] = "stage0";
    return SchemaStage;
}({});
const $f8f7a748914a9c23$var$isType = (type)=>(node)=>node.type.name === type;
// Create a Set of node types that should have empty attrs removed
const $f8f7a748914a9c23$var$NODES_WITH_EMPTY_ATTRS_REMOVAL = new Set([
    'paragraph',
    'layoutSection',
    'blockquote',
    'nestedExpand',
    'bulletList',
    'listItem',
    'orderedList',
    'rule',
    'caption',
    'tableRow',
    'media',
    'mediaSingle',
    'mediaInline'
]);
const $f8f7a748914a9c23$var$isCodeBlock = $f8f7a748914a9c23$var$isType('codeBlock');
const $f8f7a748914a9c23$var$isMediaNode = $f8f7a748914a9c23$var$isType('media');
const $f8f7a748914a9c23$var$isMediaInline = $f8f7a748914a9c23$var$isType('mediaInline');
const $f8f7a748914a9c23$var$isMediaSingleNode = $f8f7a748914a9c23$var$isType('mediaSingle');
const $f8f7a748914a9c23$var$isMentionNode = $f8f7a748914a9c23$var$isType('mention');
const $f8f7a748914a9c23$var$isParagraph = $f8f7a748914a9c23$var$isType('paragraph');
const $f8f7a748914a9c23$var$isHeading = $f8f7a748914a9c23$var$isType('heading');
const $f8f7a748914a9c23$var$isTable = $f8f7a748914a9c23$var$isType('table');
const $f8f7a748914a9c23$var$isTableCell = $f8f7a748914a9c23$var$isType('tableCell');
const $f8f7a748914a9c23$var$isTableHeader = $f8f7a748914a9c23$var$isType('tableHeader');
const $f8f7a748914a9c23$var$isLinkMark = $f8f7a748914a9c23$var$isType('link');
const $f8f7a748914a9c23$var$isUnsupportedMark = $f8f7a748914a9c23$var$isType('unsupportedMark');
const $f8f7a748914a9c23$var$isUnsupportedNodeAttributeMark = $f8f7a748914a9c23$var$isType('unsupportedNodeAttribute');
const $f8f7a748914a9c23$var$isExpand = $f8f7a748914a9c23$var$isType('expand');
const $f8f7a748914a9c23$var$isNestedExpand = $f8f7a748914a9c23$var$isType('nestedExpand');
const $f8f7a748914a9c23$var$isUnsupportedNode = (node)=>$f8f7a748914a9c23$var$isType('unsupportedBlock')(node) || $f8f7a748914a9c23$var$isType('unsupportedInline')(node);
const $f8f7a748914a9c23$var$isDataConsumer = $f8f7a748914a9c23$var$isType('dataConsumer');
const $f8f7a748914a9c23$var$isFragmentMark = $f8f7a748914a9c23$var$isType('fragment');
const $f8f7a748914a9c23$var$isHardBreak = $f8f7a748914a9c23$var$isType('hardBreak');
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $f8f7a748914a9c23$var$filterNull = (subject)=>{
    let output = {
        ...subject
    };
    // eslint-disable-next-line guard-for-in
    for(const key in output){
        const current = output[key];
        if (current === null) {
            const { [key]: unusedKey, ...filteredObj } = output;
            output = filteredObj;
        } else if (typeof current === 'object' && !Array.isArray(current)) output[key] = $f8f7a748914a9c23$var$filterNull(current);
    }
    return output;
};
const $f8f7a748914a9c23$var$createDocFromContent = (content)=>{
    return {
        version: 1,
        type: 'doc',
        content: content || []
    };
};
const $f8f7a748914a9c23$var$emptyDoc = $f8f7a748914a9c23$var$createDocFromContent([
    {
        type: 'paragraph',
        content: []
    }
]);
/**
 * Transforms a Prosemirror node into a JSON representation. Compared with
 * native Prosemirror JSON, this representation ensures we have valid ADF attrs.
 *
 * @param node The Prosemirror node to transform.
 * @param mentionMap A map of mention IDs to their display names.
 * @returns The JSON representation of the node.
 */ const $f8f7a748914a9c23$export$3a858d3babd60825 = (node, mentionMap)=>{
    const obj = {
        type: node.type.name
    };
    if ($f8f7a748914a9c23$var$isUnsupportedNode(node)) return node.attrs.originalValue;
    else if ($f8f7a748914a9c23$var$isMediaNode(node)) obj.attrs = (0, $53bvm.toJSON)(node).attrs;
    else if ($f8f7a748914a9c23$var$isMediaSingleNode(node)) obj.attrs = (0, $gbkVM.toJSON)(node).attrs;
    else if ($f8f7a748914a9c23$var$isMediaInline(node)) obj.attrs = (0, $53bvm.toJSON)(node).attrs;
    else if ($f8f7a748914a9c23$var$isMentionNode(node)) obj.attrs = (0, $8cHA0.toJSON)(node).attrs;
    else if ($f8f7a748914a9c23$var$isCodeBlock(node)) obj.attrs = (0, $7tm9l.toJSON)(node).attrs;
    else if ($f8f7a748914a9c23$var$isTable(node)) obj.attrs = (0, $ivrsj.tableToJSON)(node).attrs;
    else if ($f8f7a748914a9c23$var$isTableCell(node)) obj.attrs = (0, $ivrsj.toJSONTableCell)(node).attrs;
    else if ($f8f7a748914a9c23$var$isTableHeader(node)) obj.attrs = (0, $ivrsj.toJSONTableHeader)(node).attrs;
    else if ($f8f7a748914a9c23$var$isExpand(node) || $f8f7a748914a9c23$var$isNestedExpand(node)) obj.attrs = (0, $6vky0.toJSON)(node).attrs;
    else if (node.attrs && Object.keys(node.attrs).length) obj.attrs = node.attrs;
    if (obj.attrs) obj.attrs = $f8f7a748914a9c23$var$filterNull(obj.attrs);
    if ($f8f7a748914a9c23$var$isMentionNode(node) && mentionMap) {
        // If the mentionMap exists and has a name defined then we should use it and prepend @ to the begining of it.
        const name = !!mentionMap?.[node.attrs.id] ? `@${mentionMap[node.attrs.id]}` : '';
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const text = obj.attrs?.text ?? '';
        obj.attrs = {
            ...obj.attrs,
            // If an explicit text value is set on the mention then that should take priority over the mentionMap value.
            text: !!text ? text : name
        };
    }
    if ($f8f7a748914a9c23$var$NODES_WITH_EMPTY_ATTRS_REMOVAL.has(node.type.name) && obj.attrs && !Object.keys(obj.attrs).length || $f8f7a748914a9c23$var$isHardBreak(node)) delete obj.attrs;
    if (node.isText) obj.text = node.textContent;
    else node.content.forEach((child)=>{
        obj.content = obj.content || [];
        obj.content.push($f8f7a748914a9c23$export$3a858d3babd60825(child, mentionMap));
    });
    if ($f8f7a748914a9c23$var$isParagraph(node) || $f8f7a748914a9c23$var$isHeading(node)) obj.content = obj.content || [];
    if (node.marks.length) {
        // Run any custom mark serialisers
        const parsedMarks = node.marks.map((mark)=>{
            if ($f8f7a748914a9c23$var$isUnsupportedMark(mark)) return $f8f7a748914a9c23$var$canOverrideMark(mark, node.marks) ? null : mark.attrs.originalValue;
            else if ($f8f7a748914a9c23$var$isUnsupportedNodeAttributeMark(mark)) return null;
            else if ($f8f7a748914a9c23$var$isLinkMark(mark)) return (0, $nd92h.toJSON)(mark);
            else if ($f8f7a748914a9c23$var$isDataConsumer(mark)) {
                const serialised = (0, $lU6iV.toJSON)(mark);
                return !serialised.attrs.sources || serialised.attrs.sources?.length === 0 ? null : serialised;
            } else if ($f8f7a748914a9c23$var$isFragmentMark(mark)) {
                const fragmentMark = (0, $lhEMc.toJSON)(mark);
                if (!fragmentMark.attrs.localId) return null;
                return fragmentMark;
            } else return mark.toJSON();
        }).filter((maybeMark)=>maybeMark !== null);
        // Only set if we have a non-empty array, otherwise explicitly undefine it (as we only run this path if `node.marks.length`)
        obj.marks = parsedMarks?.length > 0 ? parsedMarks : undefined;
        const nodeAttributeMark = node.marks.find($f8f7a748914a9c23$var$isUnsupportedNodeAttributeMark);
        if (nodeAttributeMark && nodeAttributeMark.attrs.type.nodeType === obj.type) obj.attrs = {
            ...$f8f7a748914a9c23$var$getUnwrappedNodeAttributes(node, nodeAttributeMark, obj)
        };
    }
    return obj;
};
const $f8f7a748914a9c23$var$canOverrideMark = (mark, existingMarks)=>{
    if (existingMarks.some((e)=>mark.attrs.originalValue.type === e.type.name)) return (0, $08eccc3aac6e9e51$export$28e4e3c024cce988)(mark.attrs.originalValue.type).canOverrideUnsupportedMark();
    return false;
};
const $f8f7a748914a9c23$var$getUnwrappedNodeAttributes = (node, mark, obj)=>{
    const nodeAttributes = node.type.spec.attrs;
    const attributes = {
        ...mark.attrs.unsupported,
        ...obj.attrs
    };
    // Ignored via go/ees005
    // eslint-disable-next-line no-var
    for(var key in obj.attrs)if (obj.attrs.hasOwnProperty(key)) {
        const attribute = nodeAttributes ? nodeAttributes[key] : null;
        if (attribute) {
            if (attribute.default === node.attrs[key] && mark.attrs.unsupported[key]) return {
                ...attributes,
                [key]: mark.attrs.unsupported[key]
            };
        }
    }
    return attributes;
};
class $f8f7a748914a9c23$export$98cb1d9308d0944d {
    encode(node, options = {}) {
        const content = [];
        node.content.forEach((child)=>{
            content.push((0, $f8993b2ce626873e$export$48b382180baf8e88)($f8f7a748914a9c23$export$3a858d3babd60825(child, this.mentionMap), options));
        });
        if (!content || (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(content, $f8f7a748914a9c23$var$emptyDoc.content)) return $f8f7a748914a9c23$var$createDocFromContent([]);
        return $f8f7a748914a9c23$var$createDocFromContent(content);
    }
    internalParse(content, schema) {
        const doc = schema.nodeFromJSON(content);
        doc.check();
        return doc;
    }
    parse(content, stage) {
        if (content.type !== 'doc') throw new Error('Expected content format to be ADF');
        const schema = !!stage ? (0, $1UrkW.getSchemaBasedOnStage)(stage) : this.schema;
        if (!content.content || content.content.length === 0) return this.internalParse($f8f7a748914a9c23$var$emptyDoc, schema);
        return this.internalParse(content, schema);
    }
    /**
   * This method is used to encode a single node
   */ encodeNode(node) {
        return (0, $f8993b2ce626873e$export$48b382180baf8e88)($f8f7a748914a9c23$export$3a858d3babd60825(node, this.mentionMap));
    }
    /**
   * @param schema The current editor schema
   * @param mentionMap An optional mapping of user IDs to mention names. This is used by the encoder to substitute empty
   * mention node.attr.text values with mapped names.
   */ constructor(schema = (0, $1UrkW.defaultSchema), mentionMap){
        this.schema = void 0;
        this.mentionMap = void 0;
        this.schema = schema;
        this.mentionMap = mentionMap;
    }
}
module.exports["nodeToJSON"] = $f8f7a748914a9c23$export$3a858d3babd60825;
module.exports["JSONTransformer"] = $f8f7a748914a9c23$export$98cb1d9308d0944d;

});

parcelRegister("dDZcC", function(module, exports) {

var $6jPem = parcelRequire("6jPem");


var $9gh1o = parcelRequire("9gh1o");

/** NodeNestingTransformError  */ class $efc09fde1d3b7fcb$export$3d8e8d2182f13924 extends Error {
    /**
   * @param message - Error message - Do not use any UGC in this message
   */ constructor(message){
        super(message);
        this.name = 'NodeNestingTransformError';
    }
}


const $af3cc9663dee118d$var$NESTED_TABLE_EXTENSION_TYPE = 'com.atlassian.confluence.migration', $af3cc9663dee118d$var$NESTED_TABLE_EXTENSION_KEY = 'nested-table';
const $af3cc9663dee118d$export$f45e7335ec874bfe = (extensionNode)=>extensionNode.attrs?.extensionType === $af3cc9663dee118d$var$NESTED_TABLE_EXTENSION_TYPE && extensionNode.attrs?.extensionKey === $af3cc9663dee118d$var$NESTED_TABLE_EXTENSION_KEY;
const $af3cc9663dee118d$var$transformNestedTableExtension = (nestedTableExtension)=>{
    // No content - drop the extension node
    if (!nestedTableExtension.attrs?.parameters?.adf) return false;
    try {
        const adf = JSON.parse(nestedTableExtension.attrs?.parameters?.adf);
        if (!adf.content || adf.content.length === 0) return false;
        return adf.content[0];
    } catch (e) {
        throw new (0, $efc09fde1d3b7fcb$export$3d8e8d2182f13924)('Failed to parse nested table content');
    }
};
const $af3cc9663dee118d$export$18544d0b5f43e4a1 = (adf)=>{
    let isTransformed = false;
    const transformedAdf = (0, $6jPem.traverse)(adf, {
        extension: (node)=>{
            if ($af3cc9663dee118d$export$f45e7335ec874bfe(node)) {
                isTransformed = true;
                return $af3cc9663dee118d$var$transformNestedTableExtension(node);
            }
            return;
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};
const $af3cc9663dee118d$export$8a334a7d9fe120ec = (tableCellNode)=>{
    try {
        return {
            ...tableCellNode,
            content: tableCellNode.content?.map((childNode)=>{
                // wrap nested table in an extension node
                if (childNode?.type === 'table') return (0, $9gh1o.extension)({
                    extensionType: $af3cc9663dee118d$var$NESTED_TABLE_EXTENSION_TYPE,
                    extensionKey: $af3cc9663dee118d$var$NESTED_TABLE_EXTENSION_KEY,
                    parameters: {
                        adf: JSON.stringify({
                            type: 'doc',
                            version: 1,
                            content: [
                                childNode
                            ]
                        })
                    }
                });
                return childNode;
            })
        };
    } catch (e) {
        throw new (0, $efc09fde1d3b7fcb$export$3d8e8d2182f13924)('Failed to encode nested table node');
    }
};
module.exports["isNestedTableExtension"] = $af3cc9663dee118d$export$f45e7335ec874bfe;
module.exports["transformNestedTablesIncomingDocument"] = $af3cc9663dee118d$export$18544d0b5f43e4a1;
module.exports["transformNestedTableNodeOutgoingDocument"] = $af3cc9663dee118d$export$8a334a7d9fe120ec;

});

parcelRegister("9gh1o", function(module, exports) {
const $0b52ddd0ebfb8ca2$export$1b45514b112dd749 = (attrs)=>({
        type: 'extension',
        attrs: attrs
    });
module.exports["extension"] = $0b52ddd0ebfb8ca2$export$1b45514b112dd749;

});

parcelRegister("3h7Ko", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $ddde644a24a9c36e$var$initialState = {
    type: null,
    selectionRange: null,
    hoverRange: null,
    selectionDraftRange: null,
    hoverDraftRange: null,
    selectionDraftDocumentPosition: null,
    hoverDraftDocumentPosition: null
};
function $ddde644a24a9c36e$var$reducer(state, action) {
    switch(action.type){
        case 'clearSelection':
            if (state.selectionRange !== null) return {
                ...state,
                selectionRange: null,
                type: state.type === 'selection' ? null : state.type
            };
            return state;
        case 'clearHover':
            if (state.hoverRange !== null) return {
                ...state,
                hoverRange: null,
                type: state.type === 'hover' ? null : state.type
            };
            return state;
        case 'setSelection':
            if (state.selectionRange !== action.range) return {
                ...state,
                selectionRange: action.range,
                type: 'selection'
            };
            return state;
        case 'setHover':
            if (state.hoverRange !== action.range) return {
                ...state,
                hoverRange: action.range,
                type: 'hover'
            };
            return state;
        case 'promoteSelectionToDraft':
            // we should only promote the range to a draft if the current range type is a selection
            // we should also store the promotion type, so that a clear will not accidently clear the draft of a
            // different type
            if (state.selectionDraftRange !== state.selectionRange) return {
                ...state,
                selectionRange: null,
                type: state.type === 'selection' ? null : state.type,
                selectionDraftRange: state.selectionRange,
                selectionDraftDocumentPosition: action.position
            };
            return state;
        case 'promoteHoverToDraft':
            if (state.hoverDraftRange !== state.hoverRange) return {
                ...state,
                hoverRange: null,
                type: state.type === 'hover' ? null : state.type,
                hoverDraftRange: state.hoverRange,
                hoverDraftDocumentPosition: action.position
            };
            return state;
        case 'clearSelectionDraft':
            if (state.selectionDraftRange !== null) return {
                ...state,
                selectionDraftRange: null,
                selectionDraftDocumentPosition: null
            };
            return state;
        case 'clearHoverDraft':
            if (state.hoverDraftRange !== null) return {
                ...state,
                hoverDraftRange: null,
                hoverDraftDocumentPosition: null
            };
            return state;
    }
}
const $ddde644a24a9c36e$export$145b9bb655c3d220 = /*#__PURE__*/ (0, $42omo.createContext)({
    range: null,
    type: null,
    selectionDraftRange: null,
    hoverDraftRange: null,
    selectionDraftDocumentPosition: null,
    hoverDraftDocumentPosition: null
});
const $ddde644a24a9c36e$export$efb0d1c8cbaac647 = /*#__PURE__*/ (0, $42omo.createContext)({
    clearSelectionRange: ()=>{},
    clearHoverRange: ()=>{},
    setSelectionRange: ()=>{},
    promoteSelectionToDraft: ()=>{},
    promoteHoverToDraft: ()=>{},
    clearSelectionDraft: ()=>{},
    clearHoverDraft: ()=>{}
});
const $ddde644a24a9c36e$export$7cf774ce920e4bbd = ({ children: children, allowCommentsOnMedia: allowCommentsOnMedia })=>{
    const [{ selectionRange: selectionRange, hoverRange: hoverRange, type: type, selectionDraftRange: selectionDraftRange, selectionDraftDocumentPosition: selectionDraftDocumentPosition, hoverDraftRange: hoverDraftRange, hoverDraftDocumentPosition: hoverDraftDocumentPosition }, dispatch] = (0, $42omo.useReducer)($ddde644a24a9c36e$var$reducer, $ddde644a24a9c36e$var$initialState);
    const clearSelectionRange = (0, $42omo.useCallback)(()=>dispatch({
            type: 'clearSelection'
        }), []);
    const clearHoverRange = (0, $42omo.useCallback)(()=>dispatch({
            type: 'clearHover'
        }), []);
    const setSelectionRange = (0, $42omo.useCallback)((range)=>dispatch({
            type: 'setSelection',
            range: range
        }), []);
    const setHoverTarget = (0, $42omo.useCallback)((target)=>{
        // the HoverComponent expects an element deeply nested inside media, these classes work with the current implementation
        const mediaNode = target.querySelector('.media-card-inline-player, .media-file-card-view');
        if (!mediaNode) return;
        const range = document.createRange();
        range.setStartBefore(mediaNode);
        range.setEndAfter(mediaNode);
        dispatch({
            type: 'setHover',
            range: range
        });
    }, []);
    const promoteSelectionToDraft = (0, $42omo.useCallback)((position)=>{
        dispatch({
            type: 'promoteSelectionToDraft',
            position: position
        });
    }, []);
    const clearSelectionDraft = (0, $42omo.useCallback)(()=>{
        dispatch({
            type: 'clearSelectionDraft'
        });
    }, []);
    const promoteHoverToDraft = (0, $42omo.useCallback)((position)=>{
        dispatch({
            type: 'promoteHoverToDraft',
            position: position
        });
    }, []);
    const clearHoverDraft = (0, $42omo.useCallback)(()=>{
        dispatch({
            type: 'clearHoverDraft'
        });
    }, []);
    const stateData = (0, $42omo.useMemo)(()=>{
        return {
            // We techinically have two ranges, however we only want to expose one of them at a time, because only one draft
            // can be active at a time. The type of range is used to determine which range is active.
            range: type === 'selection' ? selectionRange : hoverRange,
            type: type,
            selectionDraftRange: selectionDraftRange,
            hoverDraftRange: hoverDraftRange,
            selectionDraftDocumentPosition: selectionDraftDocumentPosition,
            hoverDraftDocumentPosition: hoverDraftDocumentPosition
        };
    }, [
        selectionRange,
        hoverRange,
        type,
        selectionDraftRange,
        selectionDraftDocumentPosition,
        hoverDraftRange,
        hoverDraftDocumentPosition
    ]);
    const dispatchData = (0, $42omo.useMemo)(()=>({
            clearSelectionRange: clearSelectionRange,
            clearHoverRange: clearHoverRange,
            setSelectionRange: setSelectionRange,
            setHoverTarget: !!allowCommentsOnMedia ? setHoverTarget : undefined,
            promoteSelectionToDraft: promoteSelectionToDraft,
            promoteHoverToDraft: promoteHoverToDraft,
            clearSelectionDraft: clearSelectionDraft,
            clearHoverDraft: clearHoverDraft
        }), [
        allowCommentsOnMedia,
        clearSelectionRange,
        clearHoverRange,
        setSelectionRange,
        setHoverTarget,
        promoteSelectionToDraft,
        promoteHoverToDraft,
        clearSelectionDraft,
        clearHoverDraft
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($ddde644a24a9c36e$export$145b9bb655c3d220.Provider, {
        value: stateData,
        children: /*#__PURE__*/ (0, $l998X.jsx)($ddde644a24a9c36e$export$efb0d1c8cbaac647.Provider, {
            value: dispatchData,
            children: children
        })
    });
};
const $ddde644a24a9c36e$export$30384a6aedd19fee = ({ children: children, allowCommentsOnMedia: allowCommentsOnMedia, isNestedRender: isNestedRender })=>{
    /*
   * If this is a nested render, we do not provide the context
   * because it has already been provided higher up the component tree
   * and we need the original context to create annotations on extensions.
   */ return isNestedRender ? /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    }) : /*#__PURE__*/ (0, $l998X.jsx)($ddde644a24a9c36e$export$7cf774ce920e4bbd, {
        allowCommentsOnMedia: allowCommentsOnMedia,
        children: children
    });
};
const $ddde644a24a9c36e$export$e07ee6d6cc95d9a0 = ()=>{
    return (0, $42omo.useContext)($ddde644a24a9c36e$export$145b9bb655c3d220);
};
const $ddde644a24a9c36e$export$708fc397e2b6f08d = ()=>{
    return (0, $42omo.useContext)($ddde644a24a9c36e$export$efb0d1c8cbaac647);
};
module.exports["AnnotationRangeProvider"] = $ddde644a24a9c36e$export$30384a6aedd19fee;
module.exports["useAnnotationRangeState"] = $ddde644a24a9c36e$export$e07ee6d6cc95d9a0;
module.exports["useAnnotationRangeDispatch"] = $ddde644a24a9c36e$export$708fc397e2b6f08d;

});

parcelRegister("hFjCV", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $adc627cbe56a02e2$var$AnnotationHoverStateContext = /*#__PURE__*/ (0, $42omo.createContext)({
    isWithinRange: false
});
const $adc627cbe56a02e2$var$AnnotationHoverDispatchContext = /*#__PURE__*/ (0, $42omo.createContext)({
    cancelTimeout: ()=>{},
    initiateTimeout: ()=>{},
    setIsWithinRange: ()=>{}
});
const $adc627cbe56a02e2$export$b3db0feb20552fc3 = ({ children: children })=>{
    const [isWithinRange, setIsWithinRange] = (0, $42omo.useState)(false);
    const timeoutHandler = (0, $42omo.useRef)();
    const cancelTimeout = (0, $42omo.useCallback)(()=>{
        if (timeoutHandler) clearTimeout(timeoutHandler.current);
    }, [
        timeoutHandler
    ]);
    const initiateTimeout = (0, $42omo.useCallback)(()=>{
        if (isWithinRange) timeoutHandler.current = setTimeout(()=>{
            setIsWithinRange(false);
        }, 500);
    }, [
        isWithinRange
    ]);
    const stateData = (0, $42omo.useMemo)(()=>({
            isWithinRange: isWithinRange
        }), [
        isWithinRange
    ]);
    const dispatchData = (0, $42omo.useMemo)(()=>({
            cancelTimeout: cancelTimeout,
            initiateTimeout: initiateTimeout,
            setIsWithinRange: setIsWithinRange
        }), [
        cancelTimeout,
        initiateTimeout,
        setIsWithinRange
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($adc627cbe56a02e2$var$AnnotationHoverStateContext.Provider, {
        value: stateData,
        children: /*#__PURE__*/ (0, $l998X.jsx)($adc627cbe56a02e2$var$AnnotationHoverDispatchContext.Provider, {
            value: dispatchData,
            children: children
        })
    });
};
const $adc627cbe56a02e2$export$a02bfcbbbf920306 = ()=>{
    return (0, $42omo.useContext)($adc627cbe56a02e2$var$AnnotationHoverStateContext);
};
const $adc627cbe56a02e2$export$c288883964405c82 = ()=>{
    return (0, $42omo.useContext)($adc627cbe56a02e2$var$AnnotationHoverDispatchContext);
};
module.exports["AnnotationHoverContext"] = $adc627cbe56a02e2$export$b3db0feb20552fc3;
module.exports["useAnnotationHoverContext"] = $adc627cbe56a02e2$export$a02bfcbbbf920306;
module.exports["useAnnotationHoverDispatch"] = $adc627cbe56a02e2$export$c288883964405c82;

});

parcelRegister("iZq0X", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $1d0afbb8858f32d4$export$d452675449e81987 = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $1d0afbb8858f32d4$export$5b655fe45447a548 = $1d0afbb8858f32d4$export$d452675449e81987.Provider;
module.exports["ValidationContext"] = $1d0afbb8858f32d4$export$d452675449e81987;
module.exports["ValidationContextProvider"] = $1d0afbb8858f32d4$export$5b655fe45447a548;

});

parcelRegister("dsfZn", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");

function $a6eef6e1b2d41e58$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Wraps the navigation bar and extensionFrames
const $a6eef6e1b2d41e58$var$mbeExtensionContainer = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    background: 'transparent !important',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    'padding:': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        left: `${"var(--ds-space-100, 8px)"} !important`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        right: `${"var(--ds-space-100, 8px)"} !important`
    },
    paddingBottom: "var(--ds-space-100, 8px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.remove-padding': {
        paddingBottom: 0
    },
    position: 'relative',
    verticalAlign: 'middle',
    cursor: 'pointer',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.multiBodiedExtension-handler-result': {
        marginLeft: "var(--ds-space-100, 8px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    ".multiBodiedExtension-content-dom-wrapper > [data-extension-frame='true'], .multiBodiedExtension--frames > [data-extension-frame='true']": {
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.multiBodiedExtension-content-dom-wrapper, .multiBodiedExtension--frames': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "[data-extension-frame='true'] > :not(style):first-child, [data-extension-frame='true'] > style:first-child + *": {
            marginTop: 0
        }
    }
});
const $a6eef6e1b2d41e58$var$mbeNavigation = {
    name: "4tty3q",
    styles: "border-top-left-radius:var(--ds-radius-small, 3px);border-top-right-radius:var(--ds-radius-small, 3px);user-select:none;-webkit-user-modify:read-only;border-bottom:none !important;background:var(--ds-surface, white);margin-left:var(--ds-space-100, 8px);margin-right:var(--ds-space-100, 8px);&.remove-margins{margin:var(--ds-space-negative-100, -8px);}&.remove-border{border:none;}"
};
const $a6eef6e1b2d41e58$var$extensionFrameContent = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    padding: `${"var(--ds-space-100, 8px)"} !important`,
    display: 'block',
    minHeight: '100px',
    background: 'transparent',
    borderBottomLeftRadius: "var(--ds-radius-small, 3px)",
    borderBottomRightRadius: "var(--ds-radius-small, 3px)",
    marginLeft: "var(--ds-space-100, 8px)",
    marginRight: "var(--ds-space-100, 8px)",
    cursor: 'initial',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.pm-table-with-controls': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginLeft: `${"var(--ds-space-150, 12px)"} !important`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        paddingRight: `${"var(--ds-space-150, 12px)"} !important`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.bodiedExtensionView-content-wrap': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginTop: `${"var(--ds-space-150, 12px)"} !important`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.extensionView-content-wrap': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginTop: `${"var(--ds-space-100, 8px)"} !important`
    }
});
const $a6eef6e1b2d41e58$export$8df0393dc2d5d656 = {
    name: "c620zi",
    styles: "margin-left:0;margin-right:0;border:none"
};
const $a6eef6e1b2d41e58$export$9c7196ca47f67390 = {
    mbeExtensionContainer: $a6eef6e1b2d41e58$var$mbeExtensionContainer,
    mbeNavigation: $a6eef6e1b2d41e58$var$mbeNavigation,
    extensionFrameContent: $a6eef6e1b2d41e58$var$extensionFrameContent
};
module.exports["removeMarginsAndBorder"] = $a6eef6e1b2d41e58$export$8df0393dc2d5d656;
module.exports["sharedMultiBodiedExtensionStyles"] = $a6eef6e1b2d41e58$export$9c7196ca47f67390;

});

parcelRegister("6uN0A", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $1aa8eab29b174a45$var$AnalyticsContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    fireAnalyticsEvent: (_event)=>null
});
var $1aa8eab29b174a45$export$2e2bcd8739ae039 = $1aa8eab29b174a45$var$AnalyticsContext;
module.exports["default"] = $1aa8eab29b174a45$export$2e2bcd8739ae039;

});

parcelRegister("kIphX", function(module, exports) {
const $d510f2e588a31a71$export$f980440e1ab4537d = (text)=>new Promise((resolve, reject)=>{
        const isApiSupported = !!navigator.clipboard && typeof navigator.clipboard.writeText === 'function';
        if (isApiSupported) navigator.clipboard.writeText(text).then(()=>resolve(), (e)=>reject(e));
        else reject('Clipboard API is not supported');
    });
module.exports["copyTextToClipboard"] = $d510f2e588a31a71$export$f980440e1ab4537d;

});

parcelRegister("48Use", function(module, exports) {
$parcel$export(module.exports, "default", () => $c7d42479d13572a9$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $gmMgo = parcelRequire("gmMgo");


var $6f0Oj = parcelRequire("6f0Oj");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $cgtv4 = parcelRequire("cgtv4");

const $e087e0e2784d599e$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    placeholder: {
        id: "fabric.editor.captionPlaceholder",
        defaultMessage: "Add a caption"
    }
});


function $c7d42479d13572a9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $c7d42479d13572a9$var$captionWrapperStyle = {
    name: "4iruax",
    styles: "margin-top:var(--ds-space-100, 8px);text-align:center;position:relative;color:var(--ds-text-subtle, #505258)"
};
const $c7d42479d13572a9$var$placeholderStyle = (0, $ecnYn.xcss)({
    color: 'color.text.subtlest',
    position: 'absolute',
    top: 'space.0',
    width: '100%'
});
class $c7d42479d13572a9$export$f7feb87190a94c76 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    render() {
        const { selected: selected, hasContent: hasContent, children: children, dataAttributes: dataAttributes, intl: { formatMessage: formatMessage } } = this.props;
        const showPlaceholder = !selected && !hasContent;
        return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            "data-media-caption": true,
            "data-testid": "media-caption",
            ...dataAttributes,
            css: $c7d42479d13572a9$var$captionWrapperStyle
        }, showPlaceholder ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
            xcss: $c7d42479d13572a9$var$placeholderStyle
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $5dK2X.default), null, formatMessage((0, $e087e0e2784d599e$export$defe85febe8b728c).placeholder))) : null, children);
    }
}
var $c7d42479d13572a9$export$2e2bcd8739ae039 = (0, $gmMgo.default)($c7d42479d13572a9$export$f7feb87190a94c76);

});

parcelRegister("4mSjx", function(module, exports) {
const $34379dd11d589f9f$export$bafd6beec0797f87 = 24;
var $34379dd11d589f9f$var$CSS_VAR_NAMES = /*#__PURE__*/ function(CSS_VAR_NAMES) {
    CSS_VAR_NAMES["ITEM_COUNTER_PADDING"] = "--ed--list--item-counter--padding";
    return CSS_VAR_NAMES;
}($34379dd11d589f9f$var$CSS_VAR_NAMES || {});
const $34379dd11d589f9f$var$getItemCounterLeftPadding = (itemCounterDigitsSize)=>{
    // Previous padding-left was approximately 24px. We approximate that
    // same value using "ch" units (which represent the width of a "0" digit
    // character). We use "ch" so that this computed padding can now grow if
    //  the font-size ever enlarges.
    let paddingLeft = `2.385ch`;
    if (itemCounterDigitsSize >= 2) {
        // When there are 2 or more digits, we use a combination of "ch" units and
        // pixel values so that while the computed padding grows if font-size ever
        // enlarges, it doesn't over-scale with each digit (because of the fixed pixel
        // portion of the computed value). This way, very large item counters will not
        // become overly left-padded.
        const fixedBasePx = 2;
        paddingLeft = `calc(${itemCounterDigitsSize + 1}ch - ${fixedBasePx}px)`;
    }
    return paddingLeft;
};
const $34379dd11d589f9f$var$stringifyStyle = (style)=>Object.entries(style).reduce((str, [key, value])=>`${str}${key}:${value};`, ``);
function $34379dd11d589f9f$export$6d31fdb1d74cee3e(itemCounterDigitsSize, styleFormat) {
    const style = {
        ["--ed--list--item-counter--padding"]: $34379dd11d589f9f$var$getItemCounterLeftPadding(itemCounterDigitsSize)
    };
    if (styleFormat === 'string') return $34379dd11d589f9f$var$stringifyStyle(style);
    return style;
}
module.exports["listItemCounterPadding"] = $34379dd11d589f9f$export$bafd6beec0797f87;
module.exports["getOrderedListInlineStyles"] = $34379dd11d589f9f$export$6d31fdb1d74cee3e;

});

parcelRegister("irKZA", function(module, exports) {
// File has been copied to packages/editor/editor-plugin-ai/src/provider/prosemirror-transformer/utils/list.ts
// If changes are made to this file, please make the same update in the linked file.
const $775de8d03f6b80cd$export$8ef94ae42a3729bd = 1;
const $775de8d03f6b80cd$export$d445360e2a3c026b = (order)=>{
    const num = Number(order);
    if (Number.isNaN(num)) return;
    if (num < 0) return;
    return Math.floor(Math.max(num, 0));
};
const $775de8d03f6b80cd$export$cbefb5b89ef0719f = (orderedListNode)=>{
    const order = orderedListNode?.attrs?.order;
    return $775de8d03f6b80cd$export$d445360e2a3c026b(order) ?? $775de8d03f6b80cd$export$8ef94ae42a3729bd;
};
const $775de8d03f6b80cd$export$320582fc14ba1e0f = (options)=>{
    const order = $775de8d03f6b80cd$export$d445360e2a3c026b(options.order) ?? $775de8d03f6b80cd$export$8ef94ae42a3729bd;
    const itemsCount = typeof options.itemsCount === 'number' ? options.itemsCount : 0;
    const largestCounter = order + (itemsCount - 1);
    return String(largestCounter)?.split('.')?.[0]?.length;
};
function $775de8d03f6b80cd$export$a7d7d2b9ba4d4dbb(node) {
    return Boolean(node && node.type && [
        'orderedList',
        'bulletList'
    ].includes(node.type.name));
}
function $775de8d03f6b80cd$export$35f600abfe6f0127(node) {
    return Boolean(node && node.type && 'paragraph' === node.type.name);
}
function $775de8d03f6b80cd$export$2ddb0a75547407f6(node) {
    return Boolean(node && node.type && 'listItem' === node.type.name);
}
function $775de8d03f6b80cd$export$35b2f400604e700(node) {
    return Boolean(node && node.type && 'bulletList' === node.type.name);
}
module.exports["resolveOrder"] = $775de8d03f6b80cd$export$d445360e2a3c026b;
module.exports["getOrderFromOrderedListNode"] = $775de8d03f6b80cd$export$cbefb5b89ef0719f;
module.exports["getItemCounterDigitsSize"] = $775de8d03f6b80cd$export$320582fc14ba1e0f;
module.exports["isListNode"] = $775de8d03f6b80cd$export$a7d7d2b9ba4d4dbb;
module.exports["isParagraphNode"] = $775de8d03f6b80cd$export$35f600abfe6f0127;
module.exports["isListItemNode"] = $775de8d03f6b80cd$export$2ddb0a75547407f6;
module.exports["isBulletList"] = $775de8d03f6b80cd$export$35b2f400604e700;

});

parcelRegister("1zav4", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");


var $ivrsj = parcelRequire("ivrsj");


var $aFUXX = parcelRequire("aFUXX");

var $kPuBV = parcelRequire("kPuBV");


var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");


var $d7ZU3 = parcelRequire("d7ZU3");


var $5MaNT = parcelRequire("5MaNT");

/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766







var $6icEc = parcelRequire("6icEc");

// This is used in order to support usage of DS tokens. Table cell background-color
// is set inline in '@atlaskit/adf-schema' and the color value is stored in ADF so
// it is not possible to use tokens there without polluting ADF.
// As table cell backgrounds are set inline, this should not break mobile as
// hexToEditorBackgroundPaletteColor() outputs a css variable with fallback hex.
const $9afc1a6cc885e6cd$var$mapBackgroundColors = ()=>{
    let cssString = '';
    (0, $ivrsj.tableBackgroundColorNames).forEach((value, key)=>{
        const paletteColorValue = (0, $6icEc.hexToEditorBackgroundPaletteColor)(value);
        if (paletteColorValue) cssString += `
        td[colorname='${key}' i],
        th[colorname='${key}' i] {
          background-color: ${paletteColorValue} !important;
        }
      `;
    });
    return cssString;
};
const $9afc1a6cc885e6cd$export$677e93f0f5f9623a = ()=>/*#__PURE__*/ (0, $9K4OG.css)($9afc1a6cc885e6cd$var$mapBackgroundColors());


function $2799e2cdfcd8e59e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2799e2cdfcd8e59e$export$808015ab1dd6897a = 24;
const $2799e2cdfcd8e59e$export$afe1899c3eea9823 = 16;
const $2799e2cdfcd8e59e$export$910bf0d22c3d10f2 = 14;
const $2799e2cdfcd8e59e$export$a43e30915fab3ccf = 8;
const $2799e2cdfcd8e59e$export$531f77930bf508de = 48;
const $2799e2cdfcd8e59e$export$c60fae4049791eae = 140;
const $2799e2cdfcd8e59e$export$72aad729077aa0fb = 1;
const $2799e2cdfcd8e59e$export$e56b8ca552b280f6 = 8;
const $2799e2cdfcd8e59e$export$bba39e724bc39451 = 6;
const $2799e2cdfcd8e59e$export$e5ff276883773ffd = 8;
const $2799e2cdfcd8e59e$export$880976487022eb5 = $2799e2cdfcd8e59e$export$808015ab1dd6897a + $2799e2cdfcd8e59e$export$e5ff276883773ffd - $2799e2cdfcd8e59e$export$72aad729077aa0fb;
const $2799e2cdfcd8e59e$export$c096bca5477eb7ad = {
    TABLE_CONTAINER: `${(0, $ivrsj.tablePrefixSelector)}-container`,
    TABLE_NODE_WRAPPER: `${(0, $ivrsj.tablePrefixSelector)}-wrapper`,
    TABLE_NODE_WRAPPER_NO_OVERFLOW: `${(0, $ivrsj.tablePrefixSelector)}-wrapper-no-overflow`,
    TABLE_SCROLL_INLINE_SHADOW: `${(0, $ivrsj.tablePrefixSelector)}-scroll-inline-shadow`,
    TABLE_RIGHT_BORDER: `${(0, $ivrsj.tablePrefixSelector)}-right-border`,
    TABLE_LEFT_BORDER: `${(0, $ivrsj.tablePrefixSelector)}-left-border`,
    TABLE_LEFT_SHADOW: `${(0, $ivrsj.tablePrefixSelector)}-with-left-shadow`,
    TABLE_RIGHT_SHADOW: `${(0, $ivrsj.tablePrefixSelector)}-with-right-shadow`,
    TABLE_STICKY_SHADOW: `${(0, $ivrsj.tablePrefixSelector)}-sticky-shadow`,
    TABLE_STICKY_WRAPPER: `${(0, $ivrsj.tablePrefixSelector)}-sticky-wrapper`,
    TABLE_STICKY_SCROLLBAR_CONTAINER: `${(0, $ivrsj.tablePrefixSelector)}-sticky-scrollbar-container`,
    TABLE_STICKY_SENTINEL_TOP: `${(0, $ivrsj.tablePrefixSelector)}-sticky-sentinel-top`,
    TABLE_STICKY_SENTINEL_BOTTOM: `${(0, $ivrsj.tablePrefixSelector)}-sticky-sentinel-bottom`,
    TABLE_STICKY_SCROLLBAR_SENTINEL_TOP: `${(0, $ivrsj.tablePrefixSelector)}-sticky-scrollbar-sentinel-top`,
    TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM: `${(0, $ivrsj.tablePrefixSelector)}-sticky-scrollbar-sentinel-bottom`,
    TABLE_SHADOW_SENTINEL_LEFT: `${(0, $ivrsj.tablePrefixSelector)}-shadow-sentinel-left`,
    TABLE_SHADOW_SENTINEL_RIGHT: `${(0, $ivrsj.tablePrefixSelector)}-shadow-sentinel-right`,
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    TABLE_CELL_NODEVIEW_CONTENT_DOM: (0, $ivrsj.tableCellContentDomSelector),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    TABLE_CELL_WRAPPER: (0, $ivrsj.tableCellSelector),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    TABLE_HEADER_CELL_WRAPPER: (0, $ivrsj.tableHeaderSelector),
    TABLE_ROW_CONTROLS_WRAPPER: `${(0, $ivrsj.tablePrefixSelector)}-row-controls-wrapper`,
    TABLE_COLUMN_CONTROLS_DECORATIONS: `${(0, $ivrsj.tablePrefixSelector)}-column-controls-decoration`,
    TABLE_RESIZER_CONTAINER: `${(0, $ivrsj.tablePrefixSelector)}-resizer-container`
};
/* first block node has 0 top margin */ var $2799e2cdfcd8e59e$var$_ref = {
    name: "qubt66",
    styles: ">:first-child:not(style),>style:first-child+*{margin-top:0;}>.ProseMirror-gapcursor:first-child+*,>style:first-child+.ProseMirror-gapcursor+*{margin-top:0;}>.ProseMirror-gapcursor:first-child+span+*,>style:first-child+.ProseMirror-gapcursor+span+*{margin-top:0;}"
};
var $2799e2cdfcd8e59e$var$_ref2 = {
    name: "1fct7qz",
    styles: ">:nth-child(1 of :not(style, .ProseMirror-gapcursor, .ProseMirror-widget, span)){margin-top:0;}"
};
const $2799e2cdfcd8e59e$var$firstNodeWithNotMarginTop = ()=>(0, $dh538.fg)('platform_editor_nested_dnd_styles_changes') ? $2799e2cdfcd8e59e$var$_ref2 : $2799e2cdfcd8e59e$var$_ref;
const $2799e2cdfcd8e59e$export$c2bf8eea75aa9302 = ()=>{
    const browser = (0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $d7ZU3.getBrowserInfo)() : (0, $d7ZU3.browser);
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Appears safe to auto-fix, but leaving it up to the team to remediate as the readability only gets worse with autofixing
    return /*#__PURE__*/ (0, $9K4OG.css)((0, $9afc1a6cc885e6cd$export$677e93f0f5f9623a)(), " .", $2799e2cdfcd8e59e$export$c096bca5477eb7ad.TABLE_CONTAINER, "{position:relative;margin:0 auto var(--ds-space-200, 16px);box-sizing:border-box;", (0, $1oCLl.expValEquals)('platform_editor_disable_table_overflow_shadows', 'cohort', 'variant2') && `.${$2799e2cdfcd8e59e$export$c096bca5477eb7ad.TABLE_RIGHT_BORDER}, .${$2799e2cdfcd8e59e$export$c096bca5477eb7ad.TABLE_LEFT_BORDER} {
				display: block;
				width: 1px;
				height: calc(100% - ${"var(--ds-space-300, 24px)"});
				background: ${`var(--ds-background-accent-gray-subtler, ${0, $aFUXX.akEditorTableBorder})`};
				position: absolute;
				top: ${"var(--ds-space-300, 24px)"};
			}
			.${$2799e2cdfcd8e59e$export$c096bca5477eb7ad.TABLE_RIGHT_BORDER} {
				right: 0;
			}
			.${$2799e2cdfcd8e59e$export$c096bca5477eb7ad.TABLE_LEFT_BORDER} {
				left: 0;
			}
			`, ";.decisionItemView-content-wrap:first-of-type>div{margin-top:0;}}.", $2799e2cdfcd8e59e$export$c096bca5477eb7ad.TABLE_CONTAINER, "[data-number-column='true']{padding-left:", (0, $aFUXX.akEditorTableNumberColumnWidth) - 1, "px;clear:both;}.", $2799e2cdfcd8e59e$export$c096bca5477eb7ad.TABLE_RESIZER_CONTAINER, "{will-change:width,margin-left;}.", $2799e2cdfcd8e59e$export$c096bca5477eb7ad.TABLE_RESIZER_CONTAINER, " table{will-change:width;}.", $2799e2cdfcd8e59e$export$c096bca5477eb7ad.TABLE_NODE_WRAPPER, ">table{margin:var(--ds-space-300, 24px) 0 0 0;}.", $2799e2cdfcd8e59e$export$c096bca5477eb7ad.TABLE_CONTAINER, ">table,.", $2799e2cdfcd8e59e$export$c096bca5477eb7ad.TABLE_STICKY_WRAPPER, ">table{margin:var(--ds-space-300, 24px) var(--ds-space-100, 8px) 0 0;}", (0, $dh538.fg)('platform_editor_bordered_panel_nested_in_table') ? `.${$2799e2cdfcd8e59e$export$c096bca5477eb7ad.TABLE_NODE_WRAPPER} .ak-editor-panel {
			border: ${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #d9dbea)"};
		}` : '', ".", $2799e2cdfcd8e59e$export$c096bca5477eb7ad.TABLE_CONTAINER, ">table,.", $2799e2cdfcd8e59e$export$c096bca5477eb7ad.TABLE_NODE_WRAPPER, ">table,.", $2799e2cdfcd8e59e$export$c096bca5477eb7ad.TABLE_STICKY_WRAPPER, ">table{border-collapse:collapse;border:", $2799e2cdfcd8e59e$export$72aad729077aa0fb, "px solid ", `var(--ds-background-accent-gray-subtler, ${(0, $aFUXX.akEditorTableBorder)})`, ";", (0, $1oCLl.expValEquals)('platform_editor_disable_table_overflow_shadows', 'cohort', 'variant2') && `
				border-left-color: transparent;
				border-right-color: transparent;
			`, " table-layout:fixed;font-size:1em;width:100%;&[data-autosize='true']{table-layout:auto;}&{*{box-sizing:border-box;}hr{box-sizing:content-box;}tbody{border-bottom:none;}th td{background-color:var(--ds-background-neutral-subtle, white);}>tbody>tr>th,>tbody>tr>td{min-width:", $2799e2cdfcd8e59e$export$531f77930bf508de, "px;font-weight:var(--ds-font-weight-regular, 400);vertical-align:top;border:1px solid ", `var(--ds-background-accent-gray-subtler, ${(0, $aFUXX.akEditorTableBorder)})`, ";border-right-width:0;border-bottom-width:0;padding:var(--ds-space-100, 8px);", browser.gecko || browser.ie || browser.mac && browser.chrome ? 'background-clip: padding-box;' : '', " ", $2799e2cdfcd8e59e$var$firstNodeWithNotMarginTop(), " th p:not(:first-of-type),td p:not(:first-of-type){margin-top:var(--ds-space-150, 12px);}}>tbody>tr>td{background-color:var(--ds-surface, #FFFFFF);}th{background-color:", `var(--ds-background-accent-gray-subtlest, ${(0, $aFUXX.akEditorTableToolbar)})`, ";text-align:left;", (0, $1oCLl.expValEquals)('platform_editor_native_anchor_support', 'isEnabled', true) ? '&:not(.danger)' : '&:not([style]):not(.danger)', "{.", (0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER, ":not(.danger){background-color:var(--ds-surface-raised, rgb(235, 237, 240));:not(.", (0, $aFUXX.akEditorSelectedNodeClassName), "){box-shadow:0px 0px 0px 1px var(--ds-border, transparent);}.", (0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER, "{background-image:", (0, $kPuBV.overflowShadow)({
        leftCoverWidth: "var(--ds-space-300, 24px)"
    }), ";background-color:var(--ds-background-neutral, rgb(235, 237, 240));}.", (0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER, "{background-color:var(--ds-background-neutral, rgb(226, 229, 233));}>[data-ds--code--code-block]{background-image:", (0, $kPuBV.overflowShadow)({
        leftCoverWidth: "var(--ds-space-300, 24px)"
    }), "!important;background-color:var(--ds-background-neutral, rgb(235, 237, 240))!important;/* selector lives inside @atlaskit/code */--ds--code--line-number-bg-color:var(--ds-background-neutral, rgb(226, 229, 233));}}}}}}");
};
const $2799e2cdfcd8e59e$export$d7ece4d8beb06815 = (layout, containerWidth, addControllerPadding = true)=>{
    switch(layout){
        case 'full-width':
            return containerWidth ? Math.min(containerWidth - (addControllerPadding ? (0, $aFUXX.akEditorBreakoutPadding) : 0), (0, $aFUXX.akEditorFullWidthLayoutWidth)) : (0, $aFUXX.akEditorFullWidthLayoutWidth);
        case 'wide':
            if (containerWidth) return Math.min(containerWidth - (addControllerPadding ? (0, $aFUXX.akEditorBreakoutPadding) : 0), (0, $aFUXX.akEditorWideLayoutWidth));
            return 0, $aFUXX.akEditorWideLayoutWidth;
        default:
            return 'inherit';
    }
};
module.exports["tableMarginTop"] = $2799e2cdfcd8e59e$export$808015ab1dd6897a;
module.exports["tableMarginTopWithControl"] = $2799e2cdfcd8e59e$export$910bf0d22c3d10f2;
module.exports["tableMarginSides"] = $2799e2cdfcd8e59e$export$a43e30915fab3ccf;
module.exports["tableCellMinWidth"] = $2799e2cdfcd8e59e$export$531f77930bf508de;
module.exports["tableNewColumnMinWidth"] = $2799e2cdfcd8e59e$export$c60fae4049791eae;
module.exports["tableCellBorderWidth"] = $2799e2cdfcd8e59e$export$72aad729077aa0fb;
module.exports["tableCellPadding"] = $2799e2cdfcd8e59e$export$e56b8ca552b280f6;
module.exports["tableControlsSpacing"] = $2799e2cdfcd8e59e$export$880976487022eb5;
module.exports["TableSharedCssClassName"] = $2799e2cdfcd8e59e$export$c096bca5477eb7ad;
module.exports["tableSharedStyle"] = $2799e2cdfcd8e59e$export$c2bf8eea75aa9302;
module.exports["calcTableWidth"] = $2799e2cdfcd8e59e$export$d7ece4d8beb06815;

});

parcelRegister("5MaNT", function(module, exports) {
const $f61fb812fe2d68f7$export$42659c26f026f6ea = {
    CODEBLOCK_CONTAINER: 'code-block',
    CODEBLOCK_START: 'code-block--start',
    CODEBLOCK_END: 'code-block--end',
    CODEBLOCK_CONTENT_WRAPPER: 'code-block-content-wrapper',
    CODEBLOCK_LINE_NUMBER_GUTTER: 'line-number-gutter',
    CODEBLOCK_CONTENT: 'code-content',
    DS_CODEBLOCK: '[data-ds--code--code-block]',
    CODEBLOCK_CONTENT_WRAPPED: 'code-content--wrapped',
    CODEBLOCK_CONTAINER_LINE_NUMBER_WIDGET: 'code-content__line-number--wrapped'
};
module.exports["CodeBlockSharedCssClassName"] = $f61fb812fe2d68f7$export$42659c26f026f6ea;

});

parcelRegister("6icEc", function(module, exports) {
// This import will be stripped on build

var $1To4a = parcelRequire("1To4a");

function $76f1a9db98b6b1bf$export$5f6a44a42a4b38c2(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    const tokenData = $76f1a9db98b6b1bf$export$2462741d70e6a62f[hexColor.toUpperCase()];
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return tokenData ? tokenData.token : undefined;
}
function $76f1a9db98b6b1bf$export$a270511a0e7fd61a(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    const tokenData = $76f1a9db98b6b1bf$export$2462741d70e6a62f[hexColor.toUpperCase()];
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return tokenData ? tokenData.getValue(hexColor) : undefined;
}
const $76f1a9db98b6b1bf$export$2462741d70e6a62f = {
    // blue
    /** blue - light */ ['#DEEBFF']: {
        getValue: (fallback)=>(0, $1To4a.default)('color.background.accent.blue.subtlest', fallback),
        token: "var(--ds-background-accent-blue-subtlest, #DEEBFF)"
    },
    // source for hex code was legacy token B50
    /** blue - medium */ ['#B3D4FF']: {
        getValue: (fallback)=>(0, $1To4a.default)('color.background.accent.blue.subtler', fallback),
        token: "var(--ds-background-accent-blue-subtler, #B3D4FF)"
    },
    // source for hex code was legacy token B75
    /** blue - strong */ ['#4C9AFF']: {
        getValue: (fallback)=>(0, $1To4a.default)('color.background.accent.blue.subtle', fallback),
        token: "var(--ds-background-accent-blue-subtle, #4C9AFF)"
    },
    // source for hex code was legacy token B100
    // teal
    /** teal - light */ ['#E6FCFF']: {
        getValue: (fallback)=>(0, $1To4a.default)('color.background.accent.teal.subtlest', fallback),
        token: "var(--ds-background-accent-teal-subtlest, #E6FCFF)" // source for hex code was legacy token T50,
    },
    /** teal - medium */ ['#B3F5FF']: {
        getValue: (fallback)=>(0, $1To4a.default)('color.background.accent.teal.subtler', fallback),
        token: "var(--ds-background-accent-teal-subtler, #B3F5FF)" // source for hex code was legacy token T75,
    },
    /** teal - strong */ ['#79E2F2']: {
        getValue: (fallback)=>(0, $1To4a.default)('color.background.accent.teal.subtle', fallback),
        token: "var(--ds-background-accent-teal-subtle, #79E2F2)" // source for hex code was legacy token T100,
    },
    // green
    /** green - light */ ['#E3FCEF']: {
        getValue: (fallback)=>(0, $1To4a.default)('color.background.accent.green.subtlest', fallback),
        token: "var(--ds-background-accent-green-subtlest, #E3FCEF)" // source for hex code was legacy token G50,
    },
    /** green - medium */ ['#ABF5D1']: {
        getValue: (fallback)=>(0, $1To4a.default)('color.background.accent.green.subtler', fallback),
        token: "var(--ds-background-accent-green-subtler, #ABF5D1)" // source for hex code was legacy token G75,
    },
    /** green - strong */ ['#57D9A3']: {
        getValue: (fallback)=>(0, $1To4a.default)('color.background.accent.green.subtle', fallback),
        token: "var(--ds-background-accent-green-subtle, #57D9A3)" // source for hex code was legacy token G200,
    },
    // yellowOrange
    /** yellowOrange - light */ ['#FFFAE6']: {
        getValue: (fallback)=>(0, $1To4a.default)('color.background.accent.yellow.subtlest', fallback),
        token: "var(--ds-background-accent-yellow-subtlest, #FFFAE6)" // source for hex code was legacy token Y50,
    },
    /** yellowOrange - medium */ ['#FFF0B3']: {
        getValue: (fallback)=>(0, $1To4a.default)('color.background.accent.yellow.subtler', fallback),
        token: "var(--ds-background-accent-yellow-subtler, #FFF0B3)" // source for hex code was legacy token Y75,
    },
    /** yellowOrange - strong */ ['#FFC400']: {
        getValue: (fallback)=>(0, $1To4a.default)('color.background.accent.orange.subtle', fallback),
        token: "var(--ds-background-accent-orange-subtle, #FFC400)" // source for hex code was legacy token Y200,
    },
    // red
    /** red - light */ ['#FFEBE6']: {
        getValue: (fallback)=>(0, $1To4a.default)('color.background.accent.red.subtlest', fallback),
        token: "var(--ds-background-accent-red-subtlest, #FFEBE6)" // source for hex code was legacy token R50,
    },
    /** red - medium */ ['#FFBDAD']: {
        getValue: (fallback)=>(0, $1To4a.default)('color.background.accent.red.subtler', fallback),
        token: "var(--ds-background-accent-red-subtler, #FFBDAD)" // source for hex code was legacy token R75,
    },
    /** red - strong */ ['#FF8F73']: {
        getValue: (fallback)=>(0, $1To4a.default)('color.background.accent.red.subtle', fallback),
        token: "var(--ds-background-accent-red-subtle, #FF8F73)" // source for hex code was legacy token R100,
    },
    // purple
    /** purple - light */ ['#EAE6FF']: {
        getValue: (fallback)=>(0, $1To4a.default)('color.background.accent.purple.subtlest', fallback),
        token: "var(--ds-background-accent-purple-subtlest, #EAE6FF)" // source for hex code was legacy token P50,
    },
    /** purple - medium */ ['#C0B6F2']: {
        getValue: (fallback)=>(0, $1To4a.default)('color.background.accent.purple.subtler', fallback),
        token: "var(--ds-background-accent-purple-subtler, #C0B6F2)" // source for hex code was legacy token P75,
    },
    /** purple - strong */ ['#998DD9']: {
        getValue: (fallback)=>(0, $1To4a.default)('color.background.accent.purple.subtle', fallback),
        token: "var(--ds-background-accent-purple-subtle, #998DD9)" // source for hex code was legacy token P100,
    },
    // whiteGray
    /** whiteGray - light */ ['#FFFFFF']: {
        getValue: (fallback)=>(0, $1To4a.default)('elevation.surface', fallback),
        token: "var(--ds-surface, #FFFFFF)" // source for hex code was legacy token N0,
    },
    /** whiteGray - medium */ ['#F4F5F7']: {
        getValue: (fallback)=>(0, $1To4a.default)('color.background.accent.gray.subtlest', fallback),
        token: "var(--ds-background-accent-gray-subtlest, #F4F5F7)" // source for hex code was legacy token N20,
    },
    /** whiteGray - strong */ ['#B3BAC5']: {
        getValue: (fallback)=>(0, $1To4a.default)('color.background.accent.gray.subtle', fallback),
        token: "var(--ds-background-accent-gray-subtle, #B3BAC5)" // source for hex code was legacy token N60,
    }
};
module.exports["hexToEditorBackgroundPaletteColor"] = $76f1a9db98b6b1bf$export$5f6a44a42a4b38c2;
module.exports["hexToEditorBackgroundPaletteRawValue"] = $76f1a9db98b6b1bf$export$a270511a0e7fd61a;

});

parcelRegister("1To4a", function(module, exports) {


var $1vDIt = parcelRequire("1vDIt");


var $kyRHQ = parcelRequire("kyRHQ");

/**
 * Takes a dot-separated token name and and an optional fallback, and returns the current computed CSS value for the
 * resulting CSS Custom Property.
 * This should be used for when the CSS cascade isn't available, eg. `<canvas>` elements, JS charting libraries, etc.
 *
 * Note: these values change depending on the theme so consider pairing them with `useThemeObserver` in React, or the
 * `ThemeMutationObserver` class elsewhere.
 *
 * @param {string} path - A dot-separated token name (example: `'color.background.brand'` or `'spacing.scale.100'`).
 * @param {string} [fallback] - The fallback value that should render when token CSS is not present in your app.
 *
 * @example
 * ```
 * const theme = useThemeObserver();
 *
 * useEffect(() => {
 *  const lineColor = getTokenValue('color.background.accent.blue.subtle', B400);
 * }, [theme]);
 * ```
 *
 */ function $cd5eb1a9b0824c7e$var$getTokenValue(tokenId, fallback = '') {
    let token = (0, $1vDIt.default)[tokenId];
    let tokenValue = fallback;
    typeof $kyRHQ;
    if (typeof window === 'undefined') return tokenValue;
    tokenValue = window.getComputedStyle(document.documentElement).getPropertyValue(token).trim();
    tokenValue = tokenValue || fallback;
    return tokenValue;
}
var $cd5eb1a9b0824c7e$export$2e2bcd8739ae039 = $cd5eb1a9b0824c7e$var$getTokenValue;
module.exports["default"] = $cd5eb1a9b0824c7e$export$2e2bcd8739ae039;

});

parcelRegister("cN8vw", function(module, exports) {
/** Helper type for single arg function */ function $521e53eeebc4ccf3$export$f672e0b6f7222cd7(func, ...funcs) {
    const allFuncs = [
        func,
        ...funcs
    ];
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function composed(raw) {
        return allFuncs.reduceRight((memo, func)=>func(memo), raw);
    };
}
module.exports["compose"] = $521e53eeebc4ccf3$export$f672e0b6f7222cd7;

});

parcelRegister("caYZ2", function(module, exports) {
function $56d4043887516d4a$export$e54c9225ca52acc(node) {
    let tableColumnWidths = [];
    node.forEach((row)=>{
        const currentTableWidth = [];
        row.forEach((cell)=>{
            const { colspan: colspan, colwidth: colwidth } = cell.attrs;
            // column has been resized, colWidth will be an array, can safely take values even if cell is merged
            if (Array.isArray(colwidth)) currentTableWidth.push(...colwidth);
            else if (colspan !== undefined && colspan > 1) currentTableWidth.push(...Array(colspan).fill(0));
            else currentTableWidth.push(0);
        });
        if (currentTableWidth.length > tableColumnWidths.length) tableColumnWidths = currentTableWidth;
    });
    return tableColumnWidths;
}
function $56d4043887516d4a$export$98951d3cdcfd364b(node) {
    const firstRow = node.firstChild;
    const tableColumnWidths = [];
    if (firstRow) firstRow.forEach((cell)=>{
        const { colspan: colspan, colwidth: colwidth } = cell.attrs;
        // column has been resized, colWidth will be an array, can safely take values even if cell is merged
        if (Array.isArray(colwidth)) tableColumnWidths.push(...colwidth);
        else if (colspan > 1) tableColumnWidths.push(...Array(colspan).fill(0));
        else tableColumnWidths.push(0);
    });
    return tableColumnWidths;
}
function $56d4043887516d4a$export$f9d610bfbb78949b(tableNode) {
    let hasSpan = false;
    tableNode.descendants((node)=>{
        if (node.type.name === 'tableRow') return true;
        const { colspan: colspan, rowspan: rowspan } = node.attrs;
        if (colspan > 1 || rowspan > 1) hasSpan = true;
        return false;
    });
    return hasSpan;
}
function $56d4043887516d4a$export$69fbfaf01f2fd534(tableNode) {
    const result = [];
    tableNode.forEach((rowNode)=>{
        if (rowNode.type.name === 'tableRow') {
            const row = [];
            rowNode.forEach((n)=>row.push(n));
            result.push(row);
        }
    });
    return result;
}
function $56d4043887516d4a$export$889a8e446452be16(pos, schema, direction) {
    if (!schema.nodes.tableRow) return false;
    const doc = pos.doc;
    let resolved = pos;
    const sibling = direction === 'before' ? 'nodeBefore' : 'nodeAfter';
    while(resolved.depth > 0){
        const siblingType = resolved[sibling]?.type;
        if (siblingType === schema.nodes.tableRow) return true;
        resolved = doc.resolve(resolved[direction]());
    }
    return false;
}
module.exports["getColumnWidths"] = $56d4043887516d4a$export$e54c9225ca52acc;
module.exports["calcTableColumnWidths"] = $56d4043887516d4a$export$98951d3cdcfd364b;
module.exports["hasMergedCell"] = $56d4043887516d4a$export$f9d610bfbb78949b;
module.exports["convertProsemirrorTableNodeToArrayOfRows"] = $56d4043887516d4a$export$69fbfaf01f2fd534;
module.exports["isPositionNearTableRow"] = $56d4043887516d4a$export$889a8e446452be16;

});

parcelRegister("d4WtM", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $2QYOD = parcelRequire("2QYOD");

var $eff95bd9cb48403a$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType[ContentType["NUMBER"] = 0] = "NUMBER";
    ContentType[ContentType["TEXT"] = 5] = "TEXT";
    ContentType[ContentType["MENTION"] = 10] = "MENTION";
    ContentType[ContentType["DATE"] = 15] = "DATE";
    ContentType[ContentType["STATUS"] = 20] = "STATUS";
    ContentType[ContentType["LINK"] = 25] = "LINK";
    return ContentType;
}({});
function $eff95bd9cb48403a$var$getLinkMark(node) {
    const [linkMark] = node.marks.filter((mark)=>mark.type.name === 'link');
    return linkMark || null;
}
function $eff95bd9cb48403a$var$parseLocaleNumber(stringNumber, groupPattern, fractionPattern) {
    if (!stringNumber.trim().length) return null;
    const maybeANumber = Number.parseFloat(stringNumber.replace(groupPattern, '').replace(fractionPattern, '.'));
    if (Number.isNaN(maybeANumber)) return null;
    return maybeANumber;
}
function $eff95bd9cb48403a$export$8ebf986086b1866f() {
    // Source: https://stackoverflow.com/questions/12004808/does-javascript-take-local-decimal-separators-into-account
    const locale = window.navigator.language;
    const thousandSeparator = Intl.NumberFormat(locale).format(11111)// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    .replace(RegExp("\\p{Number}", "gu"), '');
    const decimalSeparator = Intl.NumberFormat(locale).format(1.1)// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    .replace(RegExp("\\p{Number}", "gu"), '');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const numericPattern = new RegExp(`(\\d+(?:[${thousandSeparator}${decimalSeparator}]?\\d+)*)`, 'g');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const thousandSeparatorPattern = new RegExp('\\' + thousandSeparator, 'g');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const decimalSeparatorPattern = new RegExp('\\' + decimalSeparator);
    return (text)=>{
        if (!text.trim().length) return null;
        // This will break the text apart at the locations of the formatted numbers
        const result = text.split(numericPattern);
        // We then put the text back together but with all the formatted numbers converted back to plain numerals,
        // for example a sentence like "What is 1,000.01% of 10,000.01" would be normalized and sorted as
        // if it's saying "What is 1000.01% of 10000.01". This way the Intl.Collator can use the numeric setting to sort
        // numeral values within string correctly.
        const tokens = result.reduce((acc, stringNumber)=>{
            if (!stringNumber?.length) return acc;
            const maybeANumber = $eff95bd9cb48403a$var$parseLocaleNumber(stringNumber, thousandSeparatorPattern, decimalSeparatorPattern);
            // NOTE: We know there can only be a single decimal separator. So we can assume that if the first found separator
            // is not at the same position as the last found one, then we can assume the locale used to format the number
            // is different to our locale. This will result in the value being treated as a string.
            if (maybeANumber !== null && stringNumber.indexOf(decimalSeparator) === stringNumber.lastIndexOf(decimalSeparator)) acc.push(maybeANumber);
            else acc.push(stringNumber);
            return acc;
        }, []);
        if (tokens.length === 1) return tokens[0];
        return tokens.join('');
    };
}
function $eff95bd9cb48403a$export$7cc053f549ed70b8(textNode, normalizeTextParser) {
    // treat as a link if contain a link
    const linkMark = $eff95bd9cb48403a$var$getLinkMark(textNode);
    if (linkMark) {
        const value = textNode.text || '';
        return {
            type: 25,
            value: value
        };
    }
    const text = textNode.text || '';
    const normalizedText = normalizeTextParser(text);
    if (typeof normalizedText === 'number') return {
        type: 0,
        value: normalizedText
    };
    return {
        type: 5,
        value: normalizedText ?? text
    };
}
function $eff95bd9cb48403a$var$getMetaFromNode(node, options, normalizeTextParser) {
    if (!node) return null;
    const firstChild = node.firstChild;
    if (!firstChild) return null;
    switch(firstChild.type.name){
        // Text case
        /*
      Get Meta value from the first child if the cell is of type
        * Heading (Any cell where the text is set to a heading type)
        * Paragraph (Normal text)
     */ case 'heading':
        case 'paragraph':
            return $eff95bd9cb48403a$var$getMetaFromNode(firstChild, options, normalizeTextParser);
        case 'inlineCard':
            {
                const attrs = firstChild.attrs;
                const maybeTitle = options.getInlineCardTextFromStore(attrs);
                if (maybeTitle) return {
                    type: 25,
                    value: maybeTitle
                };
                const url = attrs.url;
                return {
                    type: 25,
                    value: url ? url : ''
                };
            }
        case 'text':
            return $eff95bd9cb48403a$export$7cc053f549ed70b8(firstChild, normalizeTextParser);
        case 'status':
            {
                const text = firstChild.attrs.text;
                return {
                    type: 20,
                    value: text
                };
            }
        case 'date':
            {
                const timestamp = Number.parseInt(firstChild.attrs.timestamp, 20);
                return {
                    type: 15,
                    value: timestamp
                };
            }
        case 'mention':
            {
                const text = firstChild.attrs.text || '';
                return {
                    type: 10,
                    value: text.toLowerCase()
                };
            }
        default:
            return null;
    }
}
function $eff95bd9cb48403a$var$compareValue(valueA, valueB) {
    if (valueA === valueB) return 0;
    if (typeof valueA === 'string' && typeof valueB === 'string') return valueA.localeCompare(valueB, window.navigator.language, {
        caseFirst: 'upper',
        numeric: true
    });
    return valueA > valueB ? 1 : -1;
}
const $eff95bd9cb48403a$export$49215374a8bec29c = (options, order = (0, $2QYOD.SortOrder).ASC)=>{
    const normalizeTextParser = $eff95bd9cb48403a$export$8ebf986086b1866f();
    return (nodeA, nodeB)=>{
        const metaNodeA = $eff95bd9cb48403a$var$getMetaFromNode(nodeA, options, normalizeTextParser);
        const metaNodeB = $eff95bd9cb48403a$var$getMetaFromNode(nodeB, options, normalizeTextParser);
        /*
      Donot switch the order (Asec or Desc) if either node is null.
      This will ensure that empty cells are always at the bottom during sorting.
    */ if (metaNodeA === null || metaNodeB === null) return $eff95bd9cb48403a$var$compareMetaFromNode(metaNodeA, metaNodeB);
        return (order === (0, $2QYOD.SortOrder).DESC ? -1 : 1) * $eff95bd9cb48403a$var$compareMetaFromNode(metaNodeA, metaNodeB);
    };
};
function $eff95bd9cb48403a$var$compareMetaFromNode(metaNodeA, metaNodeB) {
    if (metaNodeA === metaNodeB) return 0;
    if (metaNodeA === null || metaNodeB === null) return metaNodeB === null ? -1 : 1;
    if ((0, $dh538.fg)('platform_editor_fix_mixed_types_column_sort')) {
        if (metaNodeA.type === 5 && metaNodeB.type === 0 || metaNodeA.type === 0 && metaNodeB.type === 5) return $eff95bd9cb48403a$var$compareValue(String(metaNodeA.value), String(metaNodeB.value));
    }
    if (metaNodeA.type !== metaNodeB.type) return metaNodeA.type > metaNodeB.type ? 1 : -1;
    return $eff95bd9cb48403a$var$compareValue(metaNodeA.value, metaNodeB.value);
}
module.exports["createCompareNodes"] = $eff95bd9cb48403a$export$49215374a8bec29c;

});

parcelRegister("2QYOD", function(module, exports) {
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $21K7m = parcelRequire("21K7m");


var $zMjD6 = parcelRequire("zMjD6");


var $ah4M9 = parcelRequire("ah4M9");

var $0829eaae2cd5a49f$export$7ae723045d45777a = /*#__PURE__*/ function(SortOrder) {
    SortOrder["ASC"] = "asc";
    SortOrder["DESC"] = "desc";
    SortOrder["NO_ORDER"] = "no_order";
    return SortOrder;
}({});
module.exports["SortOrder"] = $0829eaae2cd5a49f$export$7ae723045d45777a;

});

parcelRegister("zMjD6", function(module, exports) {
var $5e0903e4ee7a468f$export$ed55211407a9423 = /*#__PURE__*/ function(ToolbarSize) {
    ToolbarSize[ToolbarSize["XXL"] = 6] = "XXL";
    ToolbarSize[ToolbarSize["XL"] = 5] = "XL";
    ToolbarSize[ToolbarSize["L"] = 4] = "L";
    ToolbarSize[ToolbarSize["M"] = 3] = "M";
    ToolbarSize[ToolbarSize["S"] = 2] = "S";
    ToolbarSize[ToolbarSize["XXXS"] = 1] = "XXXS";
    return ToolbarSize;
}({});
var $5e0903e4ee7a468f$export$423b5e8c92d477b9 = /*#__PURE__*/ function(ToolbarWidths) {
    ToolbarWidths[ToolbarWidths["XXL"] = 610] = "XXL";
    ToolbarWidths[ToolbarWidths["XL"] = 540] = "XL";
    ToolbarWidths[ToolbarWidths["L"] = 460] = "L";
    ToolbarWidths[ToolbarWidths["M"] = 450] = "M";
    ToolbarWidths[ToolbarWidths["S"] = 410] = "S";
    return ToolbarWidths;
}({});
var $5e0903e4ee7a468f$export$3f050002d3df641b = /*#__PURE__*/ function(ToolbarWidthsNext) {
    ToolbarWidthsNext[ToolbarWidthsNext["XXL"] = 768] = "XXL";
    ToolbarWidthsNext[ToolbarWidthsNext["XL"] = 576] = "XL";
    ToolbarWidthsNext[ToolbarWidthsNext["L"] = 460] = "L";
    ToolbarWidthsNext[ToolbarWidthsNext["M"] = 450] = "M";
    ToolbarWidthsNext[ToolbarWidthsNext["S"] = 410] = "S";
    return ToolbarWidthsNext;
}({});
var $5e0903e4ee7a468f$export$63ca43752be70b90 = /*#__PURE__*/ function(ToolbarWidthsFullPage) {
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["XXL"] = 650] = "XXL";
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["XL"] = 580] = "XL";
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["L"] = 540] = "L";
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["M"] = 490] = "M";
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["S"] = 410] = "S";
    return ToolbarWidthsFullPage;
}({});
var $5e0903e4ee7a468f$export$501a79d885598191 = /*#__PURE__*/ function(ToolbarWidthsFullPageNext) {
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["XXL"] = 1200] = "XXL";
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["XL"] = 992] = "XL";
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["L"] = 768] = "L";
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["M"] = 576] = "M";
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["S"] = 410] = "S";
    return ToolbarWidthsFullPageNext;
}({});
module.exports["ToolbarSize"] = $5e0903e4ee7a468f$export$ed55211407a9423;
module.exports["ToolbarWidths"] = $5e0903e4ee7a468f$export$423b5e8c92d477b9;
module.exports["ToolbarWidthsNext"] = $5e0903e4ee7a468f$export$3f050002d3df641b;
module.exports["ToolbarWidthsFullPage"] = $5e0903e4ee7a468f$export$63ca43752be70b90;
module.exports["ToolbarWidthsFullPageNext"] = $5e0903e4ee7a468f$export$501a79d885598191;

});

parcelRegister("ah4M9", function(module, exports) {
var $0340026301a73b77$export$9106728c49045482 = /*#__PURE__*/ function(DIRECTION) {
    DIRECTION["UP"] = "up";
    DIRECTION["DOWN"] = "down";
    DIRECTION["LEFT"] = "left";
    DIRECTION["RIGHT"] = "right";
    return DIRECTION;
}({});
module.exports["DIRECTION"] = $0340026301a73b77$export$9106728c49045482;

});

parcelRegister("6fQl1", function(module, exports) {

var $8m4tT = parcelRequire("8m4tT");


var $aFUXX = parcelRequire("aFUXX");


var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");


var $5Ev1b = parcelRequire("5Ev1b");


var $boKri = parcelRequire("boKri");


var $1zav4 = parcelRequire("1zav4");


var $fJNzZ = parcelRequire("fJNzZ");

const $2eab9b0df279d802$var$GRID_SIZE = 8;
const $2eab9b0df279d802$var$NESTED_DND_GUTTER_OFFSET = 8;
const $2eab9b0df279d802$var$NESTED_DND_MARGIN_OFFSET = 12;
const $2eab9b0df279d802$export$9b77d38feba5446 = {
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    default: (0, $aFUXX.akEditorDefaultLayoutWidth),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    wide: (0, $aFUXX.akEditorWideLayoutWidth),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    'full-width': (0, $aFUXX.akEditorFullWidthLayoutWidth)
};
const $2eab9b0df279d802$export$d76cc081ce1449a8 = (pos, state, containerWidth, isFullWidthModeEnabled)=>{
    if (!pos) return;
    const node = $2eab9b0df279d802$var$getNestedParentNode(pos, state);
    if (!node) return;
    let layout = node.attrs.layout || 'default';
    const { schema: schema } = state;
    const breakoutMark = schema.marks.breakout && schema.marks.breakout.isInSet(node.marks);
    if (breakoutMark && breakoutMark.attrs.mode) layout = breakoutMark.attrs.mode;
    const breakoutWidth = breakoutMark ? breakoutMark.attrs.width : undefined;
    let parentWidth = $2eab9b0df279d802$var$calcBreakoutNodeWidth(layout, containerWidth, isFullWidthModeEnabled, breakoutWidth);
    // Please, do not copy or use this kind of code below
    // @ts-ignore
    const contextPanelPluginKey = {
        key: 'contextPanelPluginKey$',
        getState: (state)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return state['contextPanelPluginKey$'];
        }
    };
    switch(node.type){
        case schema.nodes.layoutSection:
            // the extra width of the layout does not add to the width of the area the table can be inside
            if (!(0, $1oCLl.expValEquals)('platform_editor_nested_table_refresh_width_fix', 'isEnabled', true)) parentWidth += (0, $aFUXX.akLayoutGutterOffset) * 2; // extra width that gets added to layout
            // Calculate width of parent layout column when
            // Parallel layout with viewport greater than 1024px
            // OR side panel of an extension is open and change the node width to smaller than containerWidth
            if (containerWidth.width > (0, $aFUXX.gridMediumMaxWidth) || contextPanelPluginKey.getState(state)?.contents.length > 0 && contextPanelPluginKey.getState(state)?.contents[0] !== undefined) {
                // margin between sections
                parentWidth -= (0, $1oCLl.expValEquals)('platform_editor_nested_table_refresh_width_fix', 'isEnabled', true) && (0, $dh538.fg)('platform_editor_nested_dnd_styles_changes') ? ((0, $boKri.LAYOUT_SECTION_MARGIN) + $2eab9b0df279d802$var$NESTED_DND_MARGIN_OFFSET + 2) * (node.childCount - 1) : ((0, $boKri.LAYOUT_SECTION_MARGIN) + 2) * (node.childCount - 1);
                const $pos = state.doc.resolve(pos);
                const column = (0, $8m4tT.findParentNodeOfTypeClosestToPos)($pos, [
                    state.schema.nodes.layoutColumn
                ]);
                if (column && column.node && !isNaN(column.node.attrs.width)) // get exact width of parent layout column using node attrs
                parentWidth = Math.round(parentWidth * column.node.attrs.width * 0.01);
            }
            // account for the padding of the parent node
            parentWidth -= (0, $1oCLl.expValEquals)('platform_editor_nested_table_refresh_width_fix', 'isEnabled', true) && (0, $dh538.fg)('platform_editor_nested_dnd_styles_changes') ? ((0, $boKri.LAYOUT_COLUMN_PADDING) + $2eab9b0df279d802$var$NESTED_DND_GUTTER_OFFSET) * 2 : (0, $boKri.LAYOUT_COLUMN_PADDING) * 2;
            break;
        case schema.nodes.bodiedExtension:
            parentWidth -= (0, $5Ev1b.BODIED_EXT_PADDING) * 2;
            break;
        case schema.nodes.extensionFrame:
            parentWidth -= (0, $5Ev1b.BODIED_EXT_PADDING) * 2;
            break;
        case schema.nodes.expand:
            // padding
            parentWidth -= $2eab9b0df279d802$var$GRID_SIZE * 2;
            // gutter offset
            parentWidth += $2eab9b0df279d802$var$GRID_SIZE * 3;
            // padding right
            parentWidth -= $2eab9b0df279d802$var$GRID_SIZE;
            // padding left
            parentWidth -= $2eab9b0df279d802$var$GRID_SIZE * 4 - $2eab9b0df279d802$var$GRID_SIZE / 2;
            break;
        case schema.nodes.tableCell:
        case schema.nodes.tableHeader:
            // Calculate the available column width
            if (Array.isArray(node.attrs.colwidth)) parentWidth = node.attrs.colwidth.slice(0, node.attrs.colspan).reduce((sum, width)=>sum + width, 0);
            // Compensate for padding
            parentWidth -= (0, $1zav4.tableCellPadding) * 2;
            break;
    }
    parentWidth -= 2; // border
    return parentWidth;
};
const $2eab9b0df279d802$var$getNestedParentNode = (tablePos, state)=>{
    if (tablePos === undefined) return null;
    const $pos = state.doc.resolve(tablePos);
    const parent = (0, $8m4tT.findParentNodeOfTypeClosestToPos)($pos, [
        state.schema.nodes.bodiedExtension,
        state.schema.nodes.extensionFrame,
        state.schema.nodes.layoutSection,
        state.schema.nodes.expand,
        state.schema.nodes.tableCell,
        state.schema.nodes.tableHeader
    ]);
    return parent ? parent.node : null;
};
const $2eab9b0df279d802$var$calcBreakoutNodeWidth = (layout, containerWidth, isFullWidthModeEnabled, breakoutWidth)=>{
    if (breakoutWidth && (0, $1oCLl.expValEquals)('platform_editor_nested_table_refresh_width_fix', 'isEnabled', true)) return isFullWidthModeEnabled ? Math.min(containerWidth.lineLength, breakoutWidth) : // --ak-editor--breakout-full-page-guttering-padding = (--ak-editor--large-gutter-padding * 2) + --ak-editor--default-gutter-padding
    Math.min(containerWidth.width - ((0, $aFUXX.akEditorGutterPaddingDynamic)() * 2 + (0, $aFUXX.akEditorGutterPadding)), breakoutWidth);
    return isFullWidthModeEnabled ? Math.min(containerWidth.lineLength, (0, $aFUXX.akEditorFullWidthLayoutWidth)) : (0, $fJNzZ.absoluteBreakoutWidth)(layout, containerWidth.width);
};
const $2eab9b0df279d802$export$3930799be057b305 = (node)=>{
    if (node?.attrs.width) return node.attrs.width;
    return $2eab9b0df279d802$export$9b77d38feba5446[node?.attrs.layout] || (0, $aFUXX.akEditorDefaultLayoutWidth);
};
const $2eab9b0df279d802$export$9724081a0d43786a = (node, offset)=>{
    const isNumberColumnEnabled = node.attrs.isNumberColumnEnabled;
    if (isNumberColumnEnabled && offset > 0) return $2eab9b0df279d802$export$3930799be057b305(node) - offset;
    return $2eab9b0df279d802$export$3930799be057b305(node);
};
module.exports["layoutToWidth"] = $2eab9b0df279d802$export$9b77d38feba5446;
module.exports["getParentNodeWidth"] = $2eab9b0df279d802$export$d76cc081ce1449a8;
module.exports["getTableContainerWidth"] = $2eab9b0df279d802$export$3930799be057b305;

});

parcelRegister("5Ev1b", function(module, exports) {
const $12a95dac6e3e610f$export$f5ecdce4c60ff98b = 8;
const $12a95dac6e3e610f$export$5ac5087fe1217160 = $12a95dac6e3e610f$export$f5ecdce4c60ff98b * 2;
const $12a95dac6e3e610f$export$91624ec52c59c24c = 12;
module.exports["BODIED_EXT_PADDING"] = $12a95dac6e3e610f$export$5ac5087fe1217160;
module.exports["BODIED_EXT_MBE_MARGIN_TOP"] = $12a95dac6e3e610f$export$91624ec52c59c24c;

});

parcelRegister("boKri", function(module, exports) {
const $59f993087aaa984c$export$cd04f19842abff0 = 8;
const $59f993087aaa984c$export$a1bb91aa2d5fcce8 = $59f993087aaa984c$export$cd04f19842abff0 * 1.5;
const $59f993087aaa984c$export$e5ee675b2c7e739b = 50;
module.exports["LAYOUT_SECTION_MARGIN"] = $59f993087aaa984c$export$cd04f19842abff0;
module.exports["LAYOUT_COLUMN_PADDING"] = $59f993087aaa984c$export$a1bb91aa2d5fcce8;
module.exports["DEFAULT_TWO_COLUMN_LAYOUT_COLUMN_WIDTH"] = $59f993087aaa984c$export$e5ee675b2c7e739b;

});

parcelRegister("1zvWv", function(module, exports) {
const $fd0f66b4af830316$export$12fd658e5eef0d79 = 32;
const $fd0f66b4af830316$export$74b525449cc7cbd1 = 'ai-streaming-telepointer';
module.exports["FullPagePadding"] = $fd0f66b4af830316$export$12fd658e5eef0d79;
module.exports["TELEPOINTER_ID"] = $fd0f66b4af830316$export$74b525449cc7cbd1;

});

parcelRegister("7f6CO", function(module, exports) {
$parcel$export(module.exports, "default", () => $cd5bbe471a3a63ba$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");


var $gmMgo = parcelRequire("gmMgo");


var $3gadb = parcelRequire("3gadb");


var $2QYOD = parcelRequire("2QYOD");


var $1j8OE = parcelRequire("1j8OE");


var $cgtv4 = parcelRequire("cgtv4");

const $39171b9c8b93a075$export$458c50917513cd1a = (0, $cgtv4.defineMessages)({
    noOrderLabel: {
        id: "fabric.editor.headingLink.noOrderLabel",
        defaultMessage: "Sort column A to Z"
    },
    ascOrderLabel: {
        id: "fabric.editor.headingLink.ascOrderLabel",
        defaultMessage: "Sort column Z to A"
    },
    descOrderLabel: {
        id: "fabric.editor.headingLink.descOrderLabel",
        defaultMessage: "Clear sorting"
    },
    invalidLabel: {
        id: "fabric.editor.headingLink.invalidLabel",
        defaultMessage: "\u26A0\uFE0F You can't sort a table with merged cells"
    }
});
const $39171b9c8b93a075$export$f142573f51a67577 = (0, $cgtv4.defineMessages)({
    noOrderLabel: {
        id: "fabric.editor.tableHeader.sorting.no",
        defaultMessage: "No sort applied to the column"
    },
    ascOrderLabel: {
        id: "fabric.editor.tableHeader.sorting.asc",
        defaultMessage: "Ascending sort applied"
    },
    descOrderLabel: {
        id: "fabric.editor.tableHeader.sorting.desc",
        defaultMessage: "Descending sort applied"
    },
    invalidLabel: {
        id: "fabric.editor.tableHeader.sorting.invalid",
        defaultMessage: "You can't sort a table with merged cells"
    },
    defaultLabel: {
        id: "fabric.editor.tableHeader.sorting.default",
        defaultMessage: "Sort the column"
    }
});


function $cd5bbe471a3a63ba$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $cd5bbe471a3a63ba$export$c3618f310f725028 = /*#__PURE__*/ function(StatusClassNames) {
    StatusClassNames["ASC"] = "sorting-icon-svg__asc";
    StatusClassNames["DESC"] = "sorting-icon-svg__desc";
    StatusClassNames["NO_ORDER"] = "sorting-icon-svg__no_order";
    StatusClassNames["SORTING_NOT_ALLOWED"] = "sorting-icon-svg__not-allowed";
    return StatusClassNames;
}({});
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $cd5bbe471a3a63ba$var$buttonStyles = /*#__PURE__*/ (0, $9K4OG.css)("position:absolute;display:flex;height:28px;width:28px;margin:var(--ds-space-075, 6px);right:0;top:0;border:var(--ds-border-width-selected, 2px) solid var(--ds-border, #fff);border-radius:var(--ds-radius-small, 4px);background-color:var(--ds-surface-overlay, #FFFFFF);justify-content:center;align-items:center;cursor:pointer;&:hover{background-color:var(--ds-surface-overlay-hovered, #F0F1F2);}&:active{background-color:var(--ds-surface-overlay-pressed, rgba(179, 212, 255, 0.6));}&.", (0, $1j8OE.SORTABLE_COLUMN_ICON_CLASSNAME), "__not-allowed{cursor:not-allowed;}");
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $cd5bbe471a3a63ba$var$iconWrapperStyles = /*#__PURE__*/ (0, $9K4OG.css)("width:8px;height:12px;transition:transform 0.3s cubic-bezier(0.15, 1, 0.3, 1);transform-origin:50% 50%;display:flex;justify-content:center;&.", "sorting-icon-svg__desc", "{transform:rotate(-180deg);}&.", (0, $1j8OE.SORTABLE_COLUMN_ICON_CLASSNAME), "-inactive{opacity:0.7;}");
// The icon is created with CSS due to the following Firefox issue: https://product-fabric.atlassian.net/browse/ED-8001
// The TL;DR is that svg's in tables mess up how HTML is copied in Firefox. Using a styled div instead solves the problem.
// For this reason, svg's should be avoided in tables until this issue is fixed: https://bugzilla.mozilla.org/show_bug.cgi?id=1664350
const $cd5bbe471a3a63ba$var$iconStyles = {
    name: "1fasfp6",
    styles: "height:100%;width:2px;border-radius:var(--ds-radius-full, 9999px);background:var(--ds-icon, #42526E);user-select:none;&::before, &::after{background:var(--ds-icon, #42526E);content:'';height:2px;width:6px;position:absolute;border-radius:var(--ds-radius-full, 9999px);}&::before{transform:rotate(45deg) translate(3.4px, 8.5px);}&::after{transform:rotate(-45deg) translate(-6.3px, 5.7px);}"
};
const $cd5bbe471a3a63ba$var$getIconClassName = (isSortingAllowed, sortOrdered)=>{
    const activated = sortOrdered !== (0, $2QYOD.SortOrder).NO_ORDER;
    const activeStatusClass = `${(0, $1j8OE.SORTABLE_COLUMN_ICON_CLASSNAME)}-${activated ? 'active' : 'inactive'}`;
    if (!isSortingAllowed) return `${"sorting-icon-svg__not-allowed"} ${activeStatusClass}`;
    switch(sortOrdered){
        case (0, $2QYOD.SortOrder).ASC:
            return `${"sorting-icon-svg__asc"} ${activeStatusClass}`;
        case (0, $2QYOD.SortOrder).DESC:
            return `${"sorting-icon-svg__desc"} ${activeStatusClass}`;
        default:
            return `${"sorting-icon-svg__no_order"} ${activeStatusClass}`;
    }
};
const $cd5bbe471a3a63ba$var$getTooltipTitle = (intl, isSortingAllowed, sortOrdered)=>{
    const { noOrderLabel: noOrderLabel, ascOrderLabel: ascOrderLabel, descOrderLabel: descOrderLabel, invalidLabel: invalidLabel } = (0, $39171b9c8b93a075$export$458c50917513cd1a);
    if (!isSortingAllowed) return intl.formatMessage(invalidLabel);
    switch(sortOrdered){
        case (0, $2QYOD.SortOrder).NO_ORDER:
            return intl.formatMessage(noOrderLabel);
        case (0, $2QYOD.SortOrder).ASC:
            return intl.formatMessage(ascOrderLabel);
        case (0, $2QYOD.SortOrder).DESC:
            return intl.formatMessage(descOrderLabel);
    }
    return '';
};
const $cd5bbe471a3a63ba$var$getAriaLabel = (intl, isSortingAllowed, sortOrdered)=>{
    const { noOrderLabel: noOrderLabel, ascOrderLabel: ascOrderLabel, descOrderLabel: descOrderLabel, invalidLabel: invalidLabel, defaultLabel: defaultLabel } = (0, $39171b9c8b93a075$export$f142573f51a67577);
    if (!isSortingAllowed) return intl.formatMessage(invalidLabel);
    switch(sortOrdered){
        case (0, $2QYOD.SortOrder).NO_ORDER:
            return intl.formatMessage(noOrderLabel);
        case (0, $2QYOD.SortOrder).ASC:
            return intl.formatMessage(ascOrderLabel);
        case (0, $2QYOD.SortOrder).DESC:
            return intl.formatMessage(descOrderLabel);
    }
    return intl.formatMessage(defaultLabel);
};
const $cd5bbe471a3a63ba$var$SortingIcon = ({ isSortingAllowed: isSortingAllowed, sortOrdered: sortOrdered, intl: intl, onClick: onClick, onKeyDown: onKeyDown })=>{
    const buttonClassName = `${(0, $1j8OE.SORTABLE_COLUMN_ICON_CLASSNAME)} ${sortOrdered !== (0, $2QYOD.SortOrder).NO_ORDER ? 'is-active' : ''}${isSortingAllowed ? '' : ` ${0, $1j8OE.SORTABLE_COLUMN_ICON_CLASSNAME}__not-allowed `}`;
    const content = $cd5bbe471a3a63ba$var$getTooltipTitle(intl, isSortingAllowed, sortOrdered);
    const ariaLabel = $cd5bbe471a3a63ba$var$getAriaLabel(intl, isSortingAllowed, sortOrdered);
    const handleClick = ()=>{
        if (isSortingAllowed) onClick();
    };
    const handleKeyDown = (event)=>{
        if (isSortingAllowed) onKeyDown(event);
    };
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3gadb.default), {
        delay: 0,
        content: content,
        position: "top"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $cd5bbe471a3a63ba$var$buttonStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: buttonClassName,
        role: "button",
        tabIndex: isSortingAllowed ? 0 : -1,
        "aria-label": ariaLabel,
        "aria-disabled": !isSortingAllowed,
        "aria-hidden": !isSortingAllowed,
        onClick: handleClick,
        onKeyDown: handleKeyDown
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $cd5bbe471a3a63ba$var$iconWrapperStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $cd5bbe471a3a63ba$var$getIconClassName(isSortingAllowed, sortOrdered)
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: [
            $cd5bbe471a3a63ba$var$iconStyles
        ]
    }))));
};
var $cd5bbe471a3a63ba$export$2e2bcd8739ae039 = (0, $gmMgo.default)($cd5bbe471a3a63ba$var$SortingIcon);

});

parcelRegister("1j8OE", function(module, exports) {
const $9f6a2cabc4658788$export$bd4f24d8b1e86b23 = `ak-renderer-tableHeader-sorting-icon`;
module.exports["SORTABLE_COLUMN_ICON_CLASSNAME"] = $9f6a2cabc4658788$export$bd4f24d8b1e86b23;

});

parcelRegister("bZfVt", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $9a2cd2417c72e065$export$841858b892ce1f4c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(new Map());
const $9a2cd2417c72e065$export$2881499e37b75b9a = function({ children: children }) {
    return /*#__PURE__*/ (0, $l998X.jsx)($9a2cd2417c72e065$export$841858b892ce1f4c.Provider, {
        value: new Map(),
        children: children
    });
};
const $9a2cd2417c72e065$export$65e2d5a272a382b0 = (WrappedComponent)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line react/prefer-stateless-function
    return class extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
        render() {
            return /*#__PURE__*/ (0, $l998X.jsx)($9a2cd2417c72e065$export$841858b892ce1f4c.Consumer, {
                children: (storage)=>/*#__PURE__*/ (0, $l998X.jsx)(WrappedComponent, {
                        ...this.props,
                        smartCardStorage: storage
                    })
            });
        }
    };
};
module.exports["Provider"] = $9a2cd2417c72e065$export$2881499e37b75b9a;
module.exports["withSmartCardStorage"] = $9a2cd2417c72e065$export$65e2d5a272a382b0;

});

parcelRegister("96XCF", function(module, exports) {

let $6a22ec6ce265855d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6a22ec6ce265855d$var$load("6wr18"),
    $6a22ec6ce265855d$var$load("ffEVr"),
    $6a22ec6ce265855d$var$load("2Yc7I")
]).then(()=>parcelRequire('4elbo'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("lCaNp", function(module, exports) {

let $fbc58573ad8d2491$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $fbc58573ad8d2491$var$load("c5uOY"),
    $fbc58573ad8d2491$var$load("6wr18"),
    $fbc58573ad8d2491$var$load("37ldp"),
    $fbc58573ad8d2491$var$load("ffEVr"),
    $fbc58573ad8d2491$var$load("9vWDd")
]).then(()=>parcelRequire('sc949'));

});

parcelRegister("jblE9", function(module, exports) {

let $df6fd5f5484060f1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $df6fd5f5484060f1$var$load("hri9L").then(()=>parcelRequire('b89xc'));

});

parcelRegister("2ve85", function(module, exports) {

let $1d296fdb291d1444$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1d296fdb291d1444$var$load("6wr18"),
    $1d296fdb291d1444$var$load("ffEVr"),
    $1d296fdb291d1444$var$load("hjv2W")
]).then(()=>parcelRequire('8aT3t'));

});

parcelRegister("8DVsQ", function(module, exports) {

let $64ae8a77c8da5e33$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $64ae8a77c8da5e33$var$load("h3GJZ").then(()=>parcelRequire('jouXW'));

});

parcelRegister("gbCDG", function(module, exports) {

let $bc8ba55b6259265c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bc8ba55b6259265c$var$load("6wr18"),
    $bc8ba55b6259265c$var$load("ffEVr"),
    $bc8ba55b6259265c$var$load("hAerp")
]).then(()=>parcelRequire('kGWTg'));

});

parcelRegister("fHmdy", function(module, exports) {

let $b6dc1b22535d2515$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b6dc1b22535d2515$var$load("c5uOY"),
    $b6dc1b22535d2515$var$load("cBo2a")
]).then(()=>parcelRequire('7xxJX'));

});

parcelRegister("gafIU", function(module, exports) {

let $bc49c6d532f223a6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bc49c6d532f223a6$var$load("Wowvf"),
    $bc49c6d532f223a6$var$load("fsppR"),
    $bc49c6d532f223a6$var$load("8m00X")
]).then(()=>parcelRequire('5xRci'));

});

parcelRegister("1emf0", function(module, exports) {

let $0e5859e07fb309d8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0e5859e07fb309d8$var$load("5465r"),
    $0e5859e07fb309d8$var$load("fkY2m"),
    $0e5859e07fb309d8$var$load("6wr18"),
    $0e5859e07fb309d8$var$load("ffEVr"),
    $0e5859e07fb309d8$var$load("f9WnJ")
]).then(()=>parcelRequire('gVFlX'));

});

parcelRegister("htYJT", function(module, exports) {

let $cba442a8230115cf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cba442a8230115cf$var$load("c5uOY"),
    $cba442a8230115cf$var$load("3TTZL"),
    $cba442a8230115cf$var$load("5465r"),
    $cba442a8230115cf$var$load("fkY2m"),
    $cba442a8230115cf$var$load("6wr18"),
    $cba442a8230115cf$var$load("ffEVr"),
    $cba442a8230115cf$var$load("f9WnJ"),
    $cba442a8230115cf$var$load("l50fY")
]).then(()=>parcelRequire('3ARr2'));

});

parcelRegister("jRE4r", function(module, exports) {

let $e7620cbf36438060$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e7620cbf36438060$var$load("5CdWD"),
    $e7620cbf36438060$var$load("c5uOY"),
    $e7620cbf36438060$var$load("i4FRJ"),
    $e7620cbf36438060$var$load("gbyG5"),
    $e7620cbf36438060$var$load("1Bh2o"),
    $e7620cbf36438060$var$load("5EQhG"),
    $e7620cbf36438060$var$load("36QeB"),
    $e7620cbf36438060$var$load("jYrum"),
    $e7620cbf36438060$var$load("hv4mn"),
    $e7620cbf36438060$var$load("7jSfd"),
    $e7620cbf36438060$var$load("4HZlX"),
    $e7620cbf36438060$var$load("kDqHr"),
    $e7620cbf36438060$var$load("6wr18"),
    $e7620cbf36438060$var$load("kjZZD"),
    $e7620cbf36438060$var$load("kWNlz"),
    $e7620cbf36438060$var$load("cHTTI"),
    $e7620cbf36438060$var$load("Wowvf"),
    $e7620cbf36438060$var$load("dTsOE"),
    $e7620cbf36438060$var$load("hhss7"),
    $e7620cbf36438060$var$load("7EorR"),
    $e7620cbf36438060$var$load("awqCy"),
    $e7620cbf36438060$var$load("ffEVr"),
    $e7620cbf36438060$var$load("axFxW"),
    $e7620cbf36438060$var$load("2jp1v"),
    $e7620cbf36438060$var$load("2zeg1")
]).then(()=>parcelRequire('f7Vk9'));

});

parcelRegister("k73Mv", function(module, exports) {

let $ea4764fbfdb34566$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ea4764fbfdb34566$var$load("c5uOY"),
    $ea4764fbfdb34566$var$load("i4FRJ"),
    $ea4764fbfdb34566$var$load("gbyG5"),
    $ea4764fbfdb34566$var$load("1Bh2o"),
    $ea4764fbfdb34566$var$load("5EQhG"),
    $ea4764fbfdb34566$var$load("36QeB"),
    $ea4764fbfdb34566$var$load("jYrum"),
    $ea4764fbfdb34566$var$load("hv4mn"),
    $ea4764fbfdb34566$var$load("7jSfd"),
    $ea4764fbfdb34566$var$load("4HZlX"),
    $ea4764fbfdb34566$var$load("kDqHr"),
    $ea4764fbfdb34566$var$load("6wr18"),
    $ea4764fbfdb34566$var$load("kjZZD"),
    $ea4764fbfdb34566$var$load("kWNlz"),
    $ea4764fbfdb34566$var$load("cHTTI"),
    $ea4764fbfdb34566$var$load("Wowvf"),
    $ea4764fbfdb34566$var$load("dTsOE"),
    $ea4764fbfdb34566$var$load("hhss7"),
    $ea4764fbfdb34566$var$load("7EorR"),
    $ea4764fbfdb34566$var$load("awqCy"),
    $ea4764fbfdb34566$var$load("ffEVr"),
    $ea4764fbfdb34566$var$load("axFxW")
]).then(()=>parcelRequire('5Iqpa'));

});

parcelRegister("8xIsH", function(module, exports) {

let $6383e4fe609eecd2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6383e4fe609eecd2$var$load("c5uOY"),
    $6383e4fe609eecd2$var$load("i4FRJ"),
    $6383e4fe609eecd2$var$load("gbyG5"),
    $6383e4fe609eecd2$var$load("1Bh2o"),
    $6383e4fe609eecd2$var$load("5EQhG"),
    $6383e4fe609eecd2$var$load("36QeB"),
    $6383e4fe609eecd2$var$load("jYrum"),
    $6383e4fe609eecd2$var$load("hv4mn"),
    $6383e4fe609eecd2$var$load("7jSfd"),
    $6383e4fe609eecd2$var$load("4HZlX"),
    $6383e4fe609eecd2$var$load("kDqHr"),
    $6383e4fe609eecd2$var$load("6wr18"),
    $6383e4fe609eecd2$var$load("kjZZD"),
    $6383e4fe609eecd2$var$load("kWNlz"),
    $6383e4fe609eecd2$var$load("cHTTI"),
    $6383e4fe609eecd2$var$load("Wowvf"),
    $6383e4fe609eecd2$var$load("dTsOE"),
    $6383e4fe609eecd2$var$load("hhss7"),
    $6383e4fe609eecd2$var$load("7EorR"),
    $6383e4fe609eecd2$var$load("awqCy"),
    $6383e4fe609eecd2$var$load("ffEVr"),
    $6383e4fe609eecd2$var$load("axFxW"),
    $6383e4fe609eecd2$var$load("2jp1v")
]).then(()=>parcelRequire('eQ05w'));

});

parcelRegister("btJfW", function(module, exports) {

let $85b5820e7aa74fc7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $85b5820e7aa74fc7$var$load("aeEUI"),
    $85b5820e7aa74fc7$var$load("5CdWD"),
    $85b5820e7aa74fc7$var$load("c5uOY"),
    $85b5820e7aa74fc7$var$load("f35QR"),
    $85b5820e7aa74fc7$var$load("eVYW1"),
    $85b5820e7aa74fc7$var$load("ls0Um"),
    $85b5820e7aa74fc7$var$load("020xd"),
    $85b5820e7aa74fc7$var$load("eTBsW"),
    $85b5820e7aa74fc7$var$load("bYxCZ"),
    $85b5820e7aa74fc7$var$load("6HBYC"),
    $85b5820e7aa74fc7$var$load("eDqo1"),
    $85b5820e7aa74fc7$var$load("lxiFd"),
    $85b5820e7aa74fc7$var$load("1oiJ6"),
    $85b5820e7aa74fc7$var$load("huUvS"),
    $85b5820e7aa74fc7$var$load("h4k4y"),
    $85b5820e7aa74fc7$var$load("8JZKd"),
    $85b5820e7aa74fc7$var$load("fisfU"),
    $85b5820e7aa74fc7$var$load("fwuXj"),
    $85b5820e7aa74fc7$var$load("4RcLg"),
    $85b5820e7aa74fc7$var$load("15VrD"),
    $85b5820e7aa74fc7$var$load("2fk6g"),
    $85b5820e7aa74fc7$var$load("6wr18"),
    $85b5820e7aa74fc7$var$load("8LPnw"),
    $85b5820e7aa74fc7$var$load("4jPsO"),
    $85b5820e7aa74fc7$var$load("hPalR"),
    $85b5820e7aa74fc7$var$load("hszIA"),
    $85b5820e7aa74fc7$var$load("8059b"),
    $85b5820e7aa74fc7$var$load("6vhrJ"),
    $85b5820e7aa74fc7$var$load("72780"),
    $85b5820e7aa74fc7$var$load("jDjSj"),
    $85b5820e7aa74fc7$var$load("hhss7"),
    $85b5820e7aa74fc7$var$load("awqCy"),
    $85b5820e7aa74fc7$var$load("ffEVr"),
    $85b5820e7aa74fc7$var$load("7EorR"),
    $85b5820e7aa74fc7$var$load("5jCVU")
]).then(()=>parcelRequire('4ebXC'));

});

parcelRegister("27fpX", function(module, exports) {

let $18a831d58f1cdfd3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $18a831d58f1cdfd3$var$load("4RcLg"),
    $18a831d58f1cdfd3$var$load("15VrD"),
    $18a831d58f1cdfd3$var$load("6wr18"),
    $18a831d58f1cdfd3$var$load("ffEVr"),
    $18a831d58f1cdfd3$var$load("4Kqu1")
]).then(()=>parcelRequire('i6jK3'));

});

parcelRegister("e3PaH", function(module, exports) {

let $a3c90a17f0fe446e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a3c90a17f0fe446e$var$load("aeEUI"),
    $a3c90a17f0fe446e$var$load("c5uOY"),
    $a3c90a17f0fe446e$var$load("f35QR"),
    $a3c90a17f0fe446e$var$load("eVYW1"),
    $a3c90a17f0fe446e$var$load("ls0Um"),
    $a3c90a17f0fe446e$var$load("020xd"),
    $a3c90a17f0fe446e$var$load("eTBsW"),
    $a3c90a17f0fe446e$var$load("bYxCZ"),
    $a3c90a17f0fe446e$var$load("6HBYC"),
    $a3c90a17f0fe446e$var$load("eDqo1"),
    $a3c90a17f0fe446e$var$load("lxiFd"),
    $a3c90a17f0fe446e$var$load("1oiJ6"),
    $a3c90a17f0fe446e$var$load("huUvS"),
    $a3c90a17f0fe446e$var$load("h4k4y"),
    $a3c90a17f0fe446e$var$load("8JZKd"),
    $a3c90a17f0fe446e$var$load("fisfU"),
    $a3c90a17f0fe446e$var$load("fwuXj"),
    $a3c90a17f0fe446e$var$load("4RcLg"),
    $a3c90a17f0fe446e$var$load("15VrD"),
    $a3c90a17f0fe446e$var$load("2fk6g"),
    $a3c90a17f0fe446e$var$load("6wr18"),
    $a3c90a17f0fe446e$var$load("8LPnw"),
    $a3c90a17f0fe446e$var$load("4jPsO"),
    $a3c90a17f0fe446e$var$load("hPalR"),
    $a3c90a17f0fe446e$var$load("hszIA"),
    $a3c90a17f0fe446e$var$load("8059b"),
    $a3c90a17f0fe446e$var$load("6vhrJ"),
    $a3c90a17f0fe446e$var$load("72780"),
    $a3c90a17f0fe446e$var$load("jDjSj"),
    $a3c90a17f0fe446e$var$load("ffEVr"),
    $a3c90a17f0fe446e$var$load("awqCy"),
    $a3c90a17f0fe446e$var$load("7EorR"),
    $a3c90a17f0fe446e$var$load("9YdHi")
]).then(()=>parcelRequire('9d6BC'));

});

parcelRegister("lElg4", function(module, exports) {

let $fc2dd2d14c955246$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $fc2dd2d14c955246$var$load("c5uOY"),
    $fc2dd2d14c955246$var$load("5CdWD"),
    $fc2dd2d14c955246$var$load("75rSO")
]).then(()=>parcelRequire('1HlBH'));

});

parcelRegister("jLbE9", function(module, exports) {

let $e62b70df32dfe3d5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e62b70df32dfe3d5$var$load("5465r"),
    $e62b70df32dfe3d5$var$load("fkY2m"),
    $e62b70df32dfe3d5$var$load("c5uOY"),
    $e62b70df32dfe3d5$var$load("6wr18"),
    $e62b70df32dfe3d5$var$load("6p14c"),
    $e62b70df32dfe3d5$var$load("ie88R"),
    $e62b70df32dfe3d5$var$load("9dhzF"),
    $e62b70df32dfe3d5$var$load("ffEVr"),
    $e62b70df32dfe3d5$var$load("diCLj")
]).then(()=>parcelRequire('7peIa'));

});

parcelRegister("4Y3We", function(module, exports) {

let $39dfd212b2ad980e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $39dfd212b2ad980e$var$load("6wr18"),
    $39dfd212b2ad980e$var$load("ffEVr"),
    $39dfd212b2ad980e$var$load("5xpVW")
]).then(()=>parcelRequire('babkf'));

});

parcelRegister("64LyH", function(module, exports) {

let $46c801f63bb419d2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $46c801f63bb419d2$var$load("8gytj").then(()=>parcelRequire('3UlV5'));

});

parcelRegister("dvtp1", function(module, exports) {

let $9d54fa5d7c6dc3c0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9d54fa5d7c6dc3c0$var$load("2ksh5").then(()=>parcelRequire('3BDe4'));

});

parcelRegister("b7FrM", function(module, exports) {
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $1UrkW = parcelRequire("1UrkW");


var $h9yJL = parcelRequire("h9yJL");

// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $e3bf22e8c40775ba$var$createEncoder(parser, encoder) {
    return (value)=>encoder.encode(parser.parse(value));
}
class $e3bf22e8c40775ba$export$bcf771b83128eae7 {
    constructor(createTransformerWithSchema){
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.encode = void 0;
        const transformer = createTransformerWithSchema((0, $1UrkW.defaultSchema));
        this.encode = $e3bf22e8c40775ba$var$createEncoder(transformer, new (0, $h9yJL.JSONTransformer)());
    }
}
const $e3bf22e8c40775ba$export$c72d34660a162238 = (node)=>{
    return node.text || node.attrs && (node.attrs.text || node.attrs.shortName) || `[${typeof node.type === 'string' ? node.type : node.type.name}]`;
};
const $e3bf22e8c40775ba$export$eee20638634729b3 = (eventHandlers, type, eventName = 'onClick')=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return eventHandlers && type && eventHandlers[type] && eventHandlers[type][eventName];
};
function $e3bf22e8c40775ba$export$38b61ebf4950cd39(element, topElement, evaluate) {
    if (element === topElement) return false;
    if (evaluate(element)) return true;
    if (!element.parentElement) return false;
    return $e3bf22e8c40775ba$export$38b61ebf4950cd39(element.parentElement, topElement, evaluate);
}
module.exports["ADFEncoder"] = $e3bf22e8c40775ba$export$bcf771b83128eae7;
module.exports["getText"] = $e3bf22e8c40775ba$export$c72d34660a162238;
module.exports["getEventHandler"] = $e3bf22e8c40775ba$export$eee20638634729b3;
module.exports["findInTree"] = $e3bf22e8c40775ba$export$38b61ebf4950cd39;

});

parcelRegister("7nUdN", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $e3kjM = parcelRequire("e3kjM");





var $42omo = parcelRequire("42omo");





var $21K7m = parcelRequire("21K7m");

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $9K4OG = parcelRequire("9K4OG");





var $dh538 = parcelRequire("dh538");


var $8C5kA = parcelRequire("8C5kA");


var $3kBFe = parcelRequire("3kBFe");


var $jSHzw = parcelRequire("jSHzw");

const $7fcae4a13326e885$var$markStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    color: 'inherit',
    backgroundColor: 'unset',
    WebkitTapHighlightColor: 'transparent',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`&[data-mark-annotation-state='${(0, $e3kjM.AnnotationMarkStates).ACTIVE}']`]: {
        // was from blur in AnnotationSharedCSSByState().blur
        background: "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
        borderBottom: `${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&[data-has-focus="true"]': {
            background: "var(--ds-background-accent-yellow-subtler, #F5E989)",
            borderBottom: `${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
            // TODO: DSP-4147 - Annotation shadow
            boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)",
            cursor: 'pointer'
        }
    }
});
const $7fcae4a13326e885$var$markStylesLayeringFix = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`&[data-mark-annotation-state='${(0, $e3kjM.AnnotationMarkStates).ACTIVE}']`]: {
        // Only apply transparency to nested marks when parent is focused
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&[data-has-focus="true"] mark': {
            backgroundColor: 'transparent'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.fabric-background-color-mark &[data-has-focus="true"], &[data-has-focus="true"]': {
            background: "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-raised, 0px 1px 1px #1E1F2140, 0px 0px 1px #1E1F214f)"
        }
    }
});
const $7fcae4a13326e885$var$markStylesWithUpdatedShadow = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`&[data-mark-annotation-state='${(0, $e3kjM.AnnotationMarkStates).ACTIVE}']`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&[data-has-focus="true"]': {
            background: "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-raised, 0px 1px 1px #1E1F2140, 0px 0px 1px #1E1F214f)"
        }
    }
});
const $7fcae4a13326e885$var$markStylesWithInlineComments = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`&[data-mark-annotation-state='${(0, $e3kjM.AnnotationMarkStates).ACTIVE}']`]: {
        // was from common in AnnotationSharedCSSByState().common
        borderBottom: `${"var(--ds-border-width-selected, 2px)"} solid transparent`,
        cursor: 'pointer',
        padding: `1px 0 ${"var(--ds-space-025, 2px)"}`,
        // it was under fg(annotations_align_editor_and_renderer_styles) from AnnotationSharedCSSByState().common, assume it's on as already rolled out
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:has(.card), &:has([data-inline-card])': {
            padding: '5px 0 3px 0'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:has(.date-lozenger-container)': {
            paddingTop: "var(--ds-space-025, 2px)"
        },
        // was from blur in AnnotationSharedCSSByState().blur
        background: "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
        borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&[data-has-focus="true"]': {
            background: "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)"
        }
    }
});
const $7fcae4a13326e885$var$markStylesWithCommentsPanel = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`&[data-mark-annotation-state='${(0, $e3kjM.AnnotationMarkStates).ACTIVE}']`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&[data-is-hovered="true"]:not([data-has-focus="true"])': {
            background: "var(--ds-background-accent-yellow-subtlest-hovered, #F5E989)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)"
        }
    }
});
const $7fcae4a13326e885$var$isMobile = ()=>{
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};
const $7fcae4a13326e885$var$accessibilityStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    '&::before, &::after': {
        clipPath: 'inset(100%)',
        clip: 'rect(1px, 1px, 1px, 1px)',
        height: '1px',
        overflow: 'hidden',
        position: 'absolute',
        whiteSpace: 'nowrap',
        width: '1px'
    },
    '&::before': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        content: `' [var(--ak-renderer-annotation-startmarker)] '`
    },
    '&::after': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        content: `' [var(--ak-renderer-annotation-endmarker)] '`
    }
});
const $7fcae4a13326e885$export$4f5a51511304fdd0 = ({ annotationParentIds: annotationParentIds, children: children, dataAttributes: dataAttributes, id: id, state: state, hasFocus: hasFocus, isHovered: isHovered, onClick: onClick, useBlockLevel: useBlockLevel })=>{
    const intl = (0, $8C5kA.default)();
    const annotationIds = (0, $42omo.useMemo)(()=>[
            ...new Set([
                ...annotationParentIds,
                id
            ])
        ], [
        id,
        annotationParentIds
    ]);
    const { annotationManager: annotationManager, dispatch: dispatch } = (0, $jSHzw.useAnnotationManagerDispatch)();
    const { currentSelectedAnnotationId: currentSelectedAnnotationId } = (0, $jSHzw.useAnnotationManagerState)();
    const isAnnotationManagerEnabled = !!annotationManager;
    // after creating a new annotation, we need to set the markRef to the new mark
    const markRef = (0, $42omo.useCallback)((node)=>{
        if (id === currentSelectedAnnotationId && node) dispatch({
            type: 'setSelectedMarkRef',
            data: {
                markRef: node
            }
        });
    }, [
        dispatch,
        id,
        currentSelectedAnnotationId
    ]);
    const onMarkClick = (0, $42omo.useCallback)((event)=>{
        // prevent inline mark logic for media block marks
        if (event.currentTarget instanceof HTMLElement && event.currentTarget.getAttribute('data-block-mark')) return;
        // prevents multiple callback on overlapping annotations
        if (event.defaultPrevented || state !== (0, $e3kjM.AnnotationMarkStates).ACTIVE) return;
        if ((0, $dh538.fg)('editor_inline_comments_on_inline_nodes')) // We only want to interfere with click events if the click is on some ui inside the renderer document
        // This is to prevent the click events from portaled content (such as link previews and mention profiles)
        {
            if (event.target instanceof HTMLElement && event.target.closest('.ak-renderer-document')) {
                if (event.target.closest('[data-mention-id]')) ;
                else {
                    // prevents from opening link URL inside webView in Safari
                    event.preventDefault();
                    event.stopPropagation();
                }
            }
        } else // prevents from opening link URL inside webView in Safari
        event.preventDefault();
        if (isAnnotationManagerEnabled) // currentTarget is the right element if there are multiple overlapping annotations
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        onClick({
            eventTarget: event.currentTarget,
            annotationIds: annotationIds
        });
        else // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        onClick({
            eventTarget: event.target,
            annotationIds: annotationIds
        });
    }, [
        annotationIds,
        onClick,
        state,
        isAnnotationManagerEnabled
    ]);
    const onMarkEnter = (evt)=>{
        const focusedElementTag = document.activeElement?.tagName;
        if (focusedElementTag === 'MARK' && evt.key === 'Enter') onMarkClick(evt);
    };
    const overriddenData = !state ? dataAttributes : {
        ...dataAttributes,
        'data-mark-annotation-state': state,
        'data-has-focus': hasFocus,
        'data-is-hovered': isHovered
    };
    const desktopAccessibilityAttributes = $7fcae4a13326e885$var$isMobile() ? {} : {
        role: 'button',
        tabIndex: 0,
        onKeyDown: onMarkEnter,
        'aria-expanded': hasFocus
    };
    const accessibility = state !== (0, $e3kjM.AnnotationMarkStates).ACTIVE ? {
        'aria-disabled': true
    } : {
        'aria-details': annotationIds.join(', '),
        ...desktopAccessibilityAttributes
    };
    return (0, $9K4OG.jsx)(useBlockLevel ? 'div' : 'mark', {
        ref: id === currentSelectedAnnotationId ? markRef : undefined,
        id: id,
        [(0, $dh538.fg)('editor_inline_comments_on_inline_nodes') ? 'onClickCapture' : 'onClick']: onMarkClick,
        ...accessibility,
        ...overriddenData,
        ...!useBlockLevel && {
            css: [
                $7fcae4a13326e885$var$markStyles,
                $7fcae4a13326e885$var$markStylesLayeringFix,
                (0, $dh538.fg)('editor_inline_comments_on_inline_nodes') && $7fcae4a13326e885$var$markStylesWithInlineComments,
                (0, $dh538.fg)('confluence-frontend-comments-panel') && $7fcae4a13326e885$var$markStylesWithCommentsPanel,
                !$7fcae4a13326e885$var$isMobile() && $7fcae4a13326e885$var$accessibilityStyles,
                $7fcae4a13326e885$var$markStylesWithUpdatedShadow
            ],
            style: {
                '--ak-renderer-annotation-startmarker': intl.formatMessage((0, $3kBFe.inlineCommentMessages).contentRendererInlineCommentMarkerStart),
                '--ak-renderer-annotation-endmarker': intl.formatMessage((0, $3kBFe.inlineCommentMessages).contentRendererInlineCommentMarkerEnd)
            }
        }
    }, children);
};



var $ancN7 = parcelRequire("ancN7");


var $hXhSb = parcelRequire("hXhSb");


var $1lzbj = parcelRequire("1lzbj");


var $IcpgS = parcelRequire("IcpgS");




const $8711d9493341addc$export$f3069f755c1eba0b = ({ annotationParentIds: annotationParentIds, children: children, dataAttributes: dataAttributes, id: id, useBlockLevel: useBlockLevel })=>{
    const updateSubscriber = (0, $hXhSb.useInlineCommentSubscriberContext)();
    const states = (0, $42omo.useContext)((0, $IcpgS.InlineCommentsStateContext));
    const { hasFocus: hasFocus, isHovered: isHovered } = (0, $1lzbj.useHasFocusEvent)({
        id: id,
        updateSubscriber: updateSubscriber
    });
    const dataAttributesMemorized = (0, $42omo.useMemo)(()=>dataAttributes, [
        dataAttributes
    ]);
    const { dispatch: dispatch, annotationManager: annotationManager } = (0, $jSHzw.useAnnotationManagerDispatch)();
    const onClick = (0, $42omo.useCallback)((props)=>{
        if (!updateSubscriber) return;
        if (useBlockLevel) return;
        const { eventTarget: eventTarget, annotationIds: annotationIds } = props;
        if (annotationManager) {
            if (hasFocus) {
                dispatch({
                    type: 'resetSelectedAnnotation'
                });
                return;
            }
            annotationManager.checkPreemptiveGate().then((canSelect)=>{
                if (canSelect) {
                    // if there is a draft, clear it first
                    annotationManager?.clearDraft();
                    // use setIsAnnotationSelected won't work here if there is a draft in progress
                    // so we need to use dispatch to update the state directly
                    dispatch({
                        type: 'updateAnnotation',
                        data: {
                            id: annotationIds[0],
                            selected: true
                        }
                    });
                    dispatch({
                        type: 'setSelectedMarkRef',
                        data: {
                            markRef: eventTarget
                        }
                    });
                }
            }).catch((error)=>{
            // TODO: EDITOR-595 - An error occurred while checking the preemptive gate. We should report this error.
            });
        } else updateSubscriber.emit((0, $21K7m.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
            annotationIds: annotationIds,
            eventTarget: eventTarget
        });
    }, [
        updateSubscriber,
        useBlockLevel,
        dispatch,
        annotationManager,
        hasFocus
    ]);
    const activeParentIds = (0, $ancN7.useInlineCommentsFilter)({
        annotationIds: annotationParentIds,
        filter: {
            state: (0, $e3kjM.AnnotationMarkStates).ACTIVE
        }
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $7fcae4a13326e885$export$4f5a51511304fdd0), {
        id: id,
        dataAttributes: dataAttributesMemorized,
        annotationParentIds: activeParentIds,
        onClick: onClick,
        hasFocus: hasFocus,
        isHovered: isHovered,
        state: states[id],
        useBlockLevel: useBlockLevel,
        children: children
    });
};


const $02b331d070d05b79$export$855795c145f03402 = (mark)=>{
    return mark && mark.type && mark.type.name === 'annotation';
};
const $02b331d070d05b79$var$AnnotationComponent = ({ id: id, annotationType: annotationType, children: children, dataAttributes: dataAttributes, annotationParentIds: annotationParentIds = [], allowAnnotations: allowAnnotations, useBlockLevel: useBlockLevel, isMediaInline: isMediaInline })=>{
    const data = {
        ...dataAttributes,
        ...(0, $e3kjM.buildDataAttributes)({
            id: id,
            annotationType: annotationType
        })
    };
    if (allowAnnotations) return isMediaInline ? // Inline comment on mediaInline is not supported as part of comments on media project,
    // hence skip any styling/event handling for annotations on mediaInline.
    // `id` is still needed so that comment view component can be correct positioned
    // when using comment navigation to access comments on mediaInline
    /*#__PURE__*/ (0, $l998X.jsx)("span", {
        id: id,
        children: children
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $8711d9493341addc$export$f3069f755c1eba0b), {
        id: id,
        dataAttributes: data,
        annotationParentIds: annotationParentIds,
        annotationType: annotationType,
        useBlockLevel: useBlockLevel,
        children: children
    });
    return(// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $l998X.jsx)("span", {
        id: id,
        ...data,
        children: children
    }));
};
var $02b331d070d05b79$export$2e2bcd8739ae039 = $02b331d070d05b79$var$AnnotationComponent;
module.exports["isAnnotationMark"] = $02b331d070d05b79$export$855795c145f03402;
module.exports["default"] = $02b331d070d05b79$export$2e2bcd8739ae039;

});

parcelRegister("ancN7", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $IcpgS = parcelRequire("IcpgS");

const $5c4a32a3b8bea484$export$8e7d47f9e38ad4f1 = ({ annotationIds: annotationIds, filter: { state: stateFilter } })=>{
    const states = (0, $42omo.useContext)((0, $IcpgS.InlineCommentsStateContext));
    return (0, $42omo.useMemo)(()=>{
        return annotationIds.reduce((acc, id)=>{
            if (states && states[id] === stateFilter) return [
                ...acc,
                id
            ];
            return acc;
        }, []);
    }, [
        annotationIds,
        states,
        stateFilter
    ]);
};
module.exports["useInlineCommentsFilter"] = $5c4a32a3b8bea484$export$8e7d47f9e38ad4f1;

});

parcelRegister("hXhSb", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $IcpgS = parcelRequire("IcpgS");

const $667d06be2b39b9f1$export$b46737175cffd396 = ()=>{
    const providers = (0, $42omo.useContext)((0, $IcpgS.ProvidersContext));
    if (!providers) return null;
    const { inlineComment: { updateSubscriber: updateSubscriber } } = providers;
    return updateSubscriber || null;
};
module.exports["useInlineCommentSubscriberContext"] = $667d06be2b39b9f1$export$b46737175cffd396;

});

parcelRegister("lwZHY", function(module, exports) {
/* code.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $g7Pc3 = parcelRequire("g7Pc3");


var $03WRT = parcelRequire("03WRT");

const $6cbd39251ee9e7e1$var$styles = {
    base: "_ca0qyh40 _u5f3m5ip _n3tdyh40 _19bvm5ip _2rkofajl _11c81u0j _1reo1wug _18m91wug _1dqoglyw _1e0c1nu9 _bfhk187e _16d9qvcn _syazi7uo _vwz41kw7 _1i4q1hna _o5721jtm"
}; /**
    * __Code__
    *
    * Code highlights short strings of code snippets inline with body text.
    *
    * - [Examples](https://atlassian.design/components/code/examples)
    * - [Code](https://atlassian.design/components/code/code)
    * - [Usage](https://atlassian.design/components/code/usage)
    */ 
const $6cbd39251ee9e7e1$var$Code = /*#__PURE__*/ (0, $42omo.memo)(/*#__PURE__*/ (0, $42omo.forwardRef)(function Code({ testId: testId, ...props }, ref) {
    const { children: children, codeBidiWarnings: codeBidiWarnings = true, hasBidiWarnings: hasBidiWarnings, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, isBidiWarningTooltipEnabled: isBidiWarningTooltipEnabled, ...otherProps } = props; // Use new props if provided, otherwise fall back to deprecated props
    const shouldShowBidiWarnings = hasBidiWarnings !== undefined ? hasBidiWarnings : codeBidiWarnings;
    const shouldEnableTooltip = isBidiWarningTooltipEnabled !== undefined ? isBidiWarningTooltipEnabled : codeBidiWarningTooltipEnabled;
    const decoratedChildren = shouldShowBidiWarnings ? /*#__PURE__*/ (0, $l998X.jsx)($6cbd39251ee9e7e1$var$RenderCodeChildrenWithBidiWarnings, {
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: shouldEnableTooltip,
        children: children
    }) : children;
    return /*#__PURE__*/ (0, $l998X.jsx)("code", {
        ref: ref,
        "data-testid": testId,
        ...otherProps,
        className: (0, $gMc0m.default)([
            $6cbd39251ee9e7e1$var$styles.base
        ]),
        children: decoratedChildren
    });
}));
function $6cbd39251ee9e7e1$var$RenderCodeChildrenWithBidiWarnings({ children: children, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled }) {
    const replacedChildren = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.map(children, (childNode)=>{
        if (typeof childNode === 'string') {
            const decorated = (0, $03WRT.default)(childNode, ({ bidiCharacter: bidiCharacter, index: index })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $g7Pc3.default), {
                    bidiCharacter: bidiCharacter,
                    label: codeBidiWarningLabel,
                    tooltipEnabled: codeBidiWarningTooltipEnabled
                }, index));
            return decorated;
        }
        if ($6cbd39251ee9e7e1$var$isReactElement(childNode) && childNode.props.children) {
            // eslint-disable-next-line @repo/internal/react/no-clone-element
            const newChildNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement(childNode, {
                children: /*#__PURE__*/ (0, $l998X.jsx)($6cbd39251ee9e7e1$var$RenderCodeChildrenWithBidiWarnings, {
                    codeBidiWarningLabel: codeBidiWarningLabel,
                    codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled,
                    children: childNode.props.children
                })
            });
            return newChildNode;
        }
        return childNode;
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
        children: replacedChildren
    });
}
function $6cbd39251ee9e7e1$var$isReactElement(child) {
    return !!child.type;
}
$6cbd39251ee9e7e1$var$Code.displayName = 'Code';
var $6cbd39251ee9e7e1$export$2e2bcd8739ae039 = $6cbd39251ee9e7e1$var$Code;
module.exports["default"] = $6cbd39251ee9e7e1$export$2e2bcd8739ae039;

});

parcelRegister("g7Pc3", function(module, exports) {
$parcel$export(module.exports, "default", () => $e34dc1cd2084e09d$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $3gadb = parcelRequire("3gadb");

/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $gMc0m = parcelRequire("gMc0m");


var $6F6hl = parcelRequire("6F6hl");

const $994b46f1e25bb927$var$decoration = {
    root: "_kqswh2mm _szpl2smr _dsq41wug _1xyt1b66 _123w1b66 _15nnze3t _rxygze3t _1a354jg8 _1j6r1odn _1uakf6fq _1kt9y7el _is061xn9 _1rus1917 _1cfcvrvc _24gj1h6o _19o61h6o _cfu1116y _1rba1xn9 _1xqc19zu"
};
function $994b46f1e25bb927$export$a592b67c93d52467({ bidiCharacter: bidiCharacter, children: children, testId: testId }) {
    const bidiCharacterCode = $994b46f1e25bb927$var$getBidiCharacterCode(bidiCharacter);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("span", {
                "data-testid": testId,
                "data-bidi-character-code": bidiCharacterCode,
                // screen readers as the content includes angle brackets for
                // visual decoration purposes.
                // We use a visually hidden `mark` element below for screen readers
                "aria-hidden": "true",
                className: (0, $gMc0m.default)([
                    $994b46f1e25bb927$var$decoration.root
                ]),
                children: children
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6F6hl.default), {
                testId: testId && `${testId}--visually-hidden`,
                children: /*#__PURE__*/ (0, $l998X.jsx)("mark", {
                    children: bidiCharacterCode
                })
            })
        ]
    });
}
function $994b46f1e25bb927$var$getBidiCharacterCode(bidiCharacter) {
    const bidiCharacterCode = bidiCharacter.codePointAt(0)?.toString(16);
    return `U+${bidiCharacterCode}`;
}


function $e34dc1cd2084e09d$export$2e2bcd8739ae039({ testId: testId, bidiCharacter: bidiCharacter, skipChildren: skipChildren, shouldSkipChildren: shouldSkipChildren, tooltipEnabled: tooltipEnabled, isTooltipEnabled: isTooltipEnabled, label: label = 'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.' }) {
    // Use new props if provided, otherwise fall back to deprecated props
    const shouldEnableTooltip = isTooltipEnabled !== undefined ? isTooltipEnabled : tooltipEnabled;
    const shouldSkip = shouldSkipChildren !== undefined ? shouldSkipChildren : skipChildren;
    if (shouldEnableTooltip) return(// Following patches, this should be updated to use the render props signature which will provide aria attributes.
    // Note: this should be tested, as initial testing did not see attributes work with current tooltip implementation.
    // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
    /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: label,
        tag: $e34dc1cd2084e09d$var$CustomizedTagWithRef,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $994b46f1e25bb927$export$a592b67c93d52467), {
            testId: testId,
            bidiCharacter: bidiCharacter,
            children: shouldSkip ? null : bidiCharacter
        })
    }));
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $994b46f1e25bb927$export$a592b67c93d52467), {
        testId: testId,
        bidiCharacter: bidiCharacter,
        children: shouldSkip ? null : bidiCharacter
    });
}
const $e34dc1cd2084e09d$var$CustomizedTagWithRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef((props, ref)=>{
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        ...rest,
        ref: ref,
        children: children
    });
});

});

parcelRegister("03WRT", function(module, exports) {
$parcel$export(module.exports, "default", () => $484d2d2be4c10078$export$2e2bcd8739ae039);
const $484d2d2be4c10078$export$ecb256e6a1f5ee7e = /[\u202A-\u202E\u2066-\u2069]/g;
function $484d2d2be4c10078$export$2e2bcd8739ae039(originalText, decorate) {
    const matches = [
        ...originalText.matchAll($484d2d2be4c10078$export$ecb256e6a1f5ee7e)
    ];
    if (matches.length === 0) // No matches encountered, so we return the originalText value
    return originalText;
    let children = [];
    let mappedTo = 0;
    for (const match of matches){
        if (mappedTo !== match.index) // There were unmatched characters prior to this match which haven't been
        // mapped to the children.
        // Add them as plain text.
        children.push(originalText.substring(mappedTo, match.index));
        children.push(decorate({
            bidiCharacter: match[0],
            index: match.index
        }));
        // While index is guaranteed to be present, it needs to be asserted due
        // to a limitation of typescripts regex handling
        //
        // https://github.com/microsoft/TypeScript/issues/36788
        // Decorate bidi character
        mappedTo = match.index + match[0].length;
    }
    if (mappedTo !== originalText.length) // There is text following the final match, which needs to be mapped
    // to the children.
    // Added as plain text.
    children.push(originalText.substring(mappedTo, originalText.length));
    // return the mapped children with decorated bidi characters
    return children;
}

});

parcelRegister("hn4RR", function(module, exports) {
$parcel$export(module.exports, "default", () => $e81c36a83f2b3e0f$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $fBMbo = parcelRequire("fBMbo");


var $ggbZE = parcelRequire("ggbZE");


var $c6GJD = parcelRequire("c6GJD");


var $2Nwuj = parcelRequire("2Nwuj");


var $6wQZE = parcelRequire("6wQZE");





var $bYRk6 = parcelRequire("bYRk6");

const $13440d2ce08719fa$export$9458cdec663b9ff1 = ({ display: display, id: id, children: children, source: source })=>{
    const displayCategory = display === 'url' ? 'link' : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bYRk6.default), {
        data: {
            source: source,
            attributes: {
                displayCategory: displayCategory,
                display: display,
                id: id
            }
        }
    }, children);
};











const $3be2cafa97b66d1a$var$Anchor = (0, $6wQZE.withLinkClickedEvent)('a');
const $3be2cafa97b66d1a$export$8c0773eab230d49e = (0, $6wQZE.withLinkClickedEvent)((0, $2Nwuj.default));
const $3be2cafa97b66d1a$var$Hyperlink = ({ href: href, children: children, testId: testId, isLinkComponent: isLinkComponent = false, ...props })=>{
    const Link = isLinkComponent ? $3be2cafa97b66d1a$export$8c0773eab230d49e : $3be2cafa97b66d1a$var$Anchor;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Link, {
        ...isLinkComponent ? {
            testId: testId
        } : {
            'data-testid': testId
        },
        href: href || '',
        ...props
    }, children);
};
var $3be2cafa97b66d1a$export$2e2bcd8739ae039 = $3be2cafa97b66d1a$var$Hyperlink;






var $lAJUP = parcelRequire("lAJUP");


var $gmMgo = parcelRequire("gmMgo");





var $79vw2 = parcelRequire("79vw2");


var $dh538 = parcelRequire("dh538");


var $226XV = parcelRequire("226XV");





var $dQl1W = parcelRequire("dQl1W");


var $kKODE = parcelRequire("kKODE");


var $l6tPN = parcelRequire("l6tPN");


var $a43ao = parcelRequire("a43ao");





var $lz9QA = parcelRequire("lz9QA");

/**
 * This is a scheduled batched register mechanism for resolving blue hyperlinks while the page is idle.
 * i.e. SharePoint tenants with the same hostname will be grouped together before the register is made.
 */ 


const $30de6a1f90cac3ee$var$batchQueue = new Map();
const $30de6a1f90cac3ee$var$batchTimeouts = new Map();
const $30de6a1f90cac3ee$var$BATCH_DELAY = 250;
const $30de6a1f90cac3ee$var$executeBatch = (hostname)=>{
    const items = $30de6a1f90cac3ee$var$batchQueue.get(hostname) || [];
    if (items.length === 0) return;
    $30de6a1f90cac3ee$var$batchQueue.delete(hostname);
    $30de6a1f90cac3ee$var$batchTimeouts.delete(hostname);
    items.forEach(({ register: register, resolve: resolve, reject: reject })=>{
        register().then(resolve).catch(reject);
    });
};
const $30de6a1f90cac3ee$var$addToBatch = (hostname, item)=>{
    if (!$30de6a1f90cac3ee$var$batchQueue.has(hostname)) $30de6a1f90cac3ee$var$batchQueue.set(hostname, []);
    $30de6a1f90cac3ee$var$batchQueue.get(hostname).push(item);
    if ($30de6a1f90cac3ee$var$batchTimeouts.has(hostname)) clearTimeout($30de6a1f90cac3ee$var$batchTimeouts.get(hostname));
    $30de6a1f90cac3ee$var$batchTimeouts.set(hostname, setTimeout(()=>{
        $30de6a1f90cac3ee$var$executeBatch(hostname);
    }, $30de6a1f90cac3ee$var$BATCH_DELAY));
};
const $30de6a1f90cac3ee$export$db80d61271e4d5af = (href, register)=>{
    const isScheduled = (0, $42omo.useRef)(false);
    const scheduledRegister = (0, $42omo.useCallback)(()=>{
        if (!href || !register || isScheduled.current) return Promise.resolve();
        isScheduled.current = true;
        return new Promise((resolve, reject)=>{
            const scheduleRegister = ()=>{
                try {
                    const hostname = new URL(href).hostname;
                    $30de6a1f90cac3ee$var$addToBatch(hostname, {
                        href: href,
                        register: register,
                        resolve: (value)=>{
                            isScheduled.current = false;
                            resolve(value);
                        },
                        reject: (error)=>{
                            isScheduled.current = false;
                            reject(error);
                        }
                    });
                } catch (error) {
                    isScheduled.current = false;
                    register().then(resolve).catch(reject);
                }
            };
            if (typeof window !== 'undefined') {
                if ('requestIdleCallback' in window) window.requestIdleCallback(scheduleRegister);
                else setTimeout(scheduleRegister, 0);
            } else scheduleRegister();
        });
    }, [
        href,
        register
    ]);
    return scheduledRegister;
};


const $8ce3085c5c5a77bd$var$useResolveHyperlink = ({ href: href })=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const [id] = (0, $42omo.useState)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($dQl1W)))());
    const state = (0, $lz9QA.useSmartCardState)(href);
    const definitionId = (0, $226XV.getDefinitionId)(state.details);
    const extensionKey = (0, $226XV.getExtensionKey)(state.details);
    const resourceType = (0, $226XV.getResourceType)(state.details);
    const actions = (0, $a43ao.useSmartCardActions)(id, href);
    const scheduledRegister = (0, $30de6a1f90cac3ee$export$db80d61271e4d5af)(href, actions.register);
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        scheduledRegister().catch((error)=>{
            throw error;
        });
    }, [
        scheduledRegister
    ]);
    (0, $42omo.useEffect)(()=>{
        $l6tPN.mark(id, state.status);
        if (state.status !== 'pending' && state.status !== 'resolving') {
            $l6tPN.create(id, state.status);
            if (state.status === 'resolved') fireEvent('operational.hyperlink.resolved', {
                definitionId: definitionId ?? null,
                extensionKey: extensionKey ?? null,
                resourceType: resourceType ?? null,
                duration: $l6tPN.getMeasure(id, state.status)?.duration ?? null
            });
            else if (state.error?.type !== 'ResolveUnsupportedError' && state.error?.type !== 'UnsupportedError') fireEvent('operational.hyperlink.unresolved', {
                definitionId: definitionId ?? null,
                extensionKey: extensionKey ?? null,
                resourceType: resourceType ?? null,
                reason: state.status,
                error: state.error === undefined ? null : {
                    name: state.error.name,
                    kind: state.error.kind,
                    type: state.error.type
                }
            });
        }
    }, [
        id,
        state.status,
        state.error,
        definitionId,
        extensionKey,
        resourceType,
        fireEvent
    ]);
    return {
        state: state,
        actions: actions
    };
};
var $8ce3085c5c5a77bd$export$2e2bcd8739ae039 = $8ce3085c5c5a77bd$var$useResolveHyperlink;






var $eIleF = parcelRequire("eIleF");

const $13849139a87405b6$var$allowedHostnames = [
    'sharepoint.com',
    'onedrive.live.com',
    'docs.google.com',
    'drive.google.com'
];
const $13849139a87405b6$export$aa45d36a96427452 = (href)=>{
    try {
        const hostname = new URL(href).hostname.toLowerCase();
        return $13849139a87405b6$var$allowedHostnames.some((allowedHostname)=>hostname.includes(allowedHostname));
    } catch  {
        return false;
    }
};
const $13849139a87405b6$var$useResolveHyperlinkValidator = (href = '')=>{
    const hasSmartCardProvider = !!(0, $42omo.useContext)((0, $eIleF.SmartCardContext));
    return hasSmartCardProvider && $13849139a87405b6$export$aa45d36a96427452(href);
};
var $13849139a87405b6$export$2e2bcd8739ae039 = $13849139a87405b6$var$useResolveHyperlinkValidator;



var $5MkWK = parcelRequire("5MkWK");





var $1e2E5 = parcelRequire("1e2E5");

/**
 * HOC to wrap component with IntlProvider if not available
 */ const $255ccdc0ab7e7f63$var$withIntlProvider = (Component)=>(props)=>{
        const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, props);
        return props?.intl ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1e2E5.default), {
            locale: "en"
        }, content);
    };
var $255ccdc0ab7e7f63$export$2e2bcd8739ae039 = $255ccdc0ab7e7f63$var$withIntlProvider;



var $dLAsE = parcelRequire("dLAsE");






var $gtD4K = parcelRequire("gtD4K");


var $afp1H = parcelRequire("afp1H");


var $7Vxvp = parcelRequire("7Vxvp");


const $9a1c9ba5dc2a7a31$var$HyperlinkUnauthorizedView = ({ onAuthorize: onAuthorize, provider: provider, showConnectBtn: showConnectBtn, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3be2cafa97b66d1a$export$2e2bcd8739ae039), props), showConnectBtn && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7Vxvp.ActionButton), {
        onClick: onAuthorize,
        testId: "button-connect-account"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...(0, $afp1H.messages).connect_link_account_card_name,
        values: {
            context: provider?.text
        }
    }))));
};
var $9a1c9ba5dc2a7a31$export$2e2bcd8739ae039 = $9a1c9ba5dc2a7a31$var$HyperlinkUnauthorizedView;


const $05b0889a04ec2be1$var$HyperlinkFallbackComponent = ()=>null;
const $05b0889a04ec2be1$var$withValidator = (Component, DefaultComponent)=>(props)=>{
        const shouldResolveHyperlink = (0, $13849139a87405b6$export$2e2bcd8739ae039)(props?.href);
        return shouldResolveHyperlink && props.href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5MkWK.SmartLinkAnalyticsContext), {
            url: props.href,
            display: "url"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, props)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(DefaultComponent, props);
    };
const $05b0889a04ec2be1$var$HyperlinkWithSmartLinkResolverInner = ({ onClick: onClickCallback, ...props })=>{
    const { actions: actions, state: state } = (0, $8ce3085c5c5a77bd$export$2e2bcd8739ae039)({
        href: props.href || ''
    });
    const services = (0, $226XV.getServices)(state?.details);
    const thirdPartyARI = (0, $226XV.getThirdPartyARI)(state?.details);
    const firstPartyIdentifier = (0, $226XV.getFirstPartyIdentifier)();
    const fire3PClickEvent = (0, $dh538.fg)('platform_smartlink_3pclick_analytics') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $dLAsE.useFire3PWorkflowsClickEvent)(firstPartyIdentifier, thirdPartyARI) : undefined;
    const onClick = (0, $42omo.useCallback)((e)=>{
        // Only fire the event if the feature flag is on and other conditions are met
        if (state?.status === 'resolved' && e?.button === 0 && fire3PClickEvent && (0, $dh538.fg)('platform_smartlink_3pclick_analytics')) // 0 taken from button state representation -
        // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
        fire3PClickEvent();
        onClickCallback?.(e);
    }, [
        onClickCallback,
        fire3PClickEvent,
        state?.status
    ]);
    const onAuthorize = (0, $42omo.useCallback)(()=>actions.authorize('url'), [
        actions
    ]);
    const shouldRenderConnectBtn = ()=>{
        if (!props.children || !Array.isArray(props.children) || props.children.length === 0) return false;
        const firstChild = props.children[0];
        try {
            // Check if first child has a string matching href
            if (typeof firstChild === 'string') return props.href === firstChild;
            // Check if first child has another child object containing matching href. This aligns with the behavior of the TextWrapper component used by editor to render link nodes
            if (firstChild?.props?.children && typeof firstChild.props.children === 'string') return props.href === firstChild.props.children;
        } catch (_) {
            return false;
        }
    };
    if (state?.status === 'unauthorized' && shouldRenderConnectBtn() && ((0, $c6GJD.default).getExperimentValue('platform_linking_bluelink_connect_confluence', 'isEnabled', false) || (0, $c6GJD.default).getExperimentValue('platform_linking_bluelink_connect_jira', 'isEnabled', false))) {
        const provider = (0, $79vw2.extractSmartLinkProvider)(state?.details);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9a1c9ba5dc2a7a31$export$2e2bcd8739ae039), {
            ...props,
            onAuthorize: services?.length ? onAuthorize : undefined,
            onClick: onClick,
            showConnectBtn: services?.length > 0,
            provider: provider
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3be2cafa97b66d1a$export$2e2bcd8739ae039), {
        ...props,
        onClick: onClick
    });
};
const $05b0889a04ec2be1$export$1fdb4f77fe528a52 = (0, $lAJUP.withErrorBoundary)($05b0889a04ec2be1$var$withValidator((0, $gmMgo.default)((0, $255ccdc0ab7e7f63$export$2e2bcd8739ae039)($05b0889a04ec2be1$var$HyperlinkWithSmartLinkResolverInner), {
    enforceContext: false
}), (0, $3be2cafa97b66d1a$export$2e2bcd8739ae039)), {
    FallbackComponent: $05b0889a04ec2be1$var$HyperlinkFallbackComponent
});


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");









var $eEA8O = parcelRequire("eEA8O");





var $8CZUH = parcelRequire("8CZUH");

var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");

var $6xdDU = parcelRequire("6xdDU");




const $edc36e514c97f3fa$var$breakWordsCss = null;
const $edc36e514c97f3fa$var$WarningModal = (props)=>{
    const { isOpen: isOpen, unsafeLinkText: unsafeLinkText, url: url, onClose: onClose, onContinue: onContinue, intl: intl } = props;
    const content = /*#__PURE__*/ $42omo.createElement((0, $6xdDU.default), null, isOpen && /*#__PURE__*/ $42omo.createElement((0, $8CZUH.default), {
        onClose: onClose,
        testId: "link-with-safety-warning"
    }, /*#__PURE__*/ $42omo.createElement((0, $9ot3w.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ $42omo.createElement((0, $d8eRd.default), {
        appearance: "warning"
    }, /*#__PURE__*/ $42omo.createElement((0, $gtD4K.default), (0, $afp1H.messages).check_this_link))), /*#__PURE__*/ $42omo.createElement((0, $1DHa6.default), null, /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            "_o5726vc6 _1nmz9jpi"
        ])
    }, url && unsafeLinkText && /*#__PURE__*/ $42omo.createElement((0, $gtD4K.default), {
        ...(0, $afp1H.messages).link_safety_warning_message,
        values: {
            unsafeLinkText: unsafeLinkText,
            a: ()=>/*#__PURE__*/ $42omo.createElement((0, $2Nwuj.default), {
                    href: url,
                    target: "_blank",
                    rel: "noopener noreferrer"
                }, url)
        }
    }))), /*#__PURE__*/ $42omo.createElement((0, $8o1lj.default), null, /*#__PURE__*/ $42omo.createElement((0, $eEA8O.default), {
        appearance: "subtle",
        onClick: onClose
    }, /*#__PURE__*/ $42omo.createElement((0, $gtD4K.default), (0, $afp1H.messages).go_back)), /*#__PURE__*/ $42omo.createElement((0, $eEA8O.default), {
        appearance: "warning",
        onClick: onContinue,
        autoFocus: true
    }, /*#__PURE__*/ $42omo.createElement((0, $gtD4K.default), (0, $afp1H.messages).continue)))));
    return intl ? content : /*#__PURE__*/ $42omo.createElement((0, $1e2E5.default), {
        locale: "en"
    }, content);
};
var $edc36e514c97f3fa$export$2e2bcd8739ae039 = (0, $gmMgo.default)($edc36e514c97f3fa$var$WarningModal, {
    enforceContext: false
});






var $inPa6 = parcelRequire("inPa6");


var $l3dur = parcelRequire("l3dur");


var $lgqac = parcelRequire("lgqac");

const $83b01bdf128d776a$var$toUrl = (url, base)=>{
    try {
        return new URL(url, base);
    } catch  {
        return undefined;
    }
};
const $83b01bdf128d776a$export$32b76c003683c2ec = ()=>{
    const [unsafeLinkText, setUnsafeLinkText] = (0, $42omo.useState)(null);
    const [url, setUrl] = (0, $42omo.useState)(null);
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const sendWarningModalViewedEvent = ()=>{
        createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'linkSafetyWarningModal',
            eventType: 'screen',
            name: 'linkSafetyWarningModal'
        }).fire((0, $lgqac.ANALYTICS_CHANNEL));
    };
    const sendContinueClickedEvent = ()=>{
        createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'linkSafetyWarningModalContinue',
            eventType: 'ui',
            screen: 'linkSafetyWarningModal'
        }).fire((0, $lgqac.ANALYTICS_CHANNEL));
    };
    /**
	 * It checks and warns if a link text is a URL and different from an actual link destination
	 */ const isLinkSafe = (event, href)=>{
        if (!href) return true;
        const anchor = event.currentTarget;
        const linkText = anchor.innerText;
        const normalisedUrlFromLinkText = (0, $l3dur.normalizeUrl)(linkText);
        if (!normalisedUrlFromLinkText) return true;
        const anchorLinkRegex = new RegExp(/^#/im);
        const isLinkTextAnchorLink = anchorLinkRegex.test(linkText);
        const isAnchorLink = anchorLinkRegex.test(href);
        if (isAnchorLink || isLinkTextAnchorLink) return true;
        const relativeLinkRegex = new RegExp(/^\//im);
        const isRelativeHrefLink = relativeLinkRegex.test(href);
        if (isRelativeHrefLink) return true;
        const hrefUrl = $83b01bdf128d776a$var$toUrl(href, window.location.origin);
        const linkTextUrl = $83b01bdf128d776a$var$toUrl(normalisedUrlFromLinkText, hrefUrl?.origin);
        if (!hrefUrl || !linkTextUrl) return true;
        const currentAtlassianProductOrigin = window.location.origin;
        const isSafeToIgnoreNonOriginDifferences = hrefUrl?.origin === currentAtlassianProductOrigin && linkTextUrl?.origin === currentAtlassianProductOrigin;
        if (isSafeToIgnoreNonOriginDifferences) return true;
        const httpProtocols = [
            'http:',
            'https:'
        ];
        let areProtocolsEquivalent;
        if (httpProtocols.includes(linkTextUrl.protocol) && httpProtocols.includes(hrefUrl.protocol)) {
            const noUserNameAndPassword = !linkTextUrl.username && !linkTextUrl.password && !hrefUrl.username && !hrefUrl.password;
            areProtocolsEquivalent = noUserNameAndPassword;
        } else areProtocolsEquivalent = linkTextUrl.protocol === hrefUrl.protocol;
        const areEquivalentLinks = linkTextUrl.hostname === hrefUrl.hostname && linkTextUrl.pathname === hrefUrl.pathname && linkTextUrl.search === hrefUrl.search && linkTextUrl.username === hrefUrl.username && linkTextUrl.password === hrefUrl.password && areProtocolsEquivalent;
        if (!areEquivalentLinks) return false;
        return true;
    };
    const showSafetyWarningModal = (event, href)=>{
        event.preventDefault();
        const anchor = event.currentTarget;
        const linkText = anchor.innerText;
        setUnsafeLinkText(linkText);
        href && setUrl(href);
        setIsOpen(true);
        sendWarningModalViewedEvent();
    };
    const onClose = ()=>{
        setIsOpen(false);
        setUnsafeLinkText(null);
        setUrl(null);
    };
    const onContinue = ()=>{
        onClose();
        sendContinueClickedEvent();
        url && window.open(url, '_blank', 'noopener noreferrer');
    };
    return {
        isLinkSafe: isLinkSafe,
        isOpen: isOpen,
        onClose: onClose,
        onContinue: onContinue,
        showSafetyWarningModal: showSafetyWarningModal,
        unsafeLinkText: unsafeLinkText,
        url: url
    };
};


const $e81c36a83f2b3e0f$var$PACKAGE_DATA = {
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local",
    componentName: 'linkUrl'
};
const $e81c36a83f2b3e0f$var$Anchor = (0, $6wQZE.withLinkClickedEvent)('a');
const $e81c36a83f2b3e0f$export$8c0773eab230d49e = (0, $6wQZE.withLinkClickedEvent)((0, $2Nwuj.default));
const $e81c36a83f2b3e0f$var$LinkUrl = ({ href: href, children: children, checkSafety: checkSafety = true, onClick: onClick, testId: testId = 'link-with-safety', isLinkComponent: isLinkComponent = false, enableResolve: enableResolve = false, ...props })=>{
    (0, $fBMbo.di)($e81c36a83f2b3e0f$export$8c0773eab230d49e, (0, $83b01bdf128d776a$export$32b76c003683c2ec));
    const { isLinkSafe: isLinkSafe, showSafetyWarningModal: showSafetyWarningModal, ...linkWarningModalProps } = (0, $83b01bdf128d776a$export$32b76c003683c2ec)();
    const resolveHyperlinkFG = (0, $c6GJD.default).checkGate('platform_editor_resolve_hyperlinks_killswitch');
    if (resolveHyperlinkFG) {
        const Link = enableResolve ? (0, $05b0889a04ec2be1$export$1fdb4f77fe528a52) : (0, $3be2cafa97b66d1a$export$2e2bcd8739ae039);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $13440d2ce08719fa$export$9458cdec663b9ff1), {
            url: href,
            display: "url"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Link, {
            href: href,
            isLinkComponent: isLinkComponent,
            onClick: (e)=>{
                if (!checkSafety) {
                    onClick && onClick(e);
                    return;
                }
                // Only call the onClick if the link is safe
                if (isLinkSafe(e, href)) onClick && onClick(e);
                else showSafetyWarningModal(e, href);
            },
            ...props
        }, children)), checkSafety && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $edc36e514c97f3fa$export$2e2bcd8739ae039), linkWarningModalProps));
    }
    const Link = isLinkComponent ? $e81c36a83f2b3e0f$export$8c0773eab230d49e : $e81c36a83f2b3e0f$var$Anchor;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $13440d2ce08719fa$export$9458cdec663b9ff1), {
        url: href,
        display: "url"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Link, {
        ...isLinkComponent ? {
            testId: testId
        } : {
            'data-testid': testId
        },
        href: href || '',
        onClick: (e)=>{
            if (!checkSafety) {
                onClick && onClick(e);
                return;
            }
            // Only call the onClick if the link is safe
            if (isLinkSafe(e, href)) onClick && onClick(e);
            else showSafetyWarningModal(e, href);
        },
        ...props
    }, children)), checkSafety && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $edc36e514c97f3fa$export$2e2bcd8739ae039), linkWarningModalProps));
};
var $e81c36a83f2b3e0f$export$2e2bcd8739ae039 = (0, $ggbZE.default)($e81c36a83f2b3e0f$var$PACKAGE_DATA)($e81c36a83f2b3e0f$var$LinkUrl);

});

parcelRegister("6wQZE", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4P6U3 = parcelRequire("4P6U3");


var $4gM1A = parcelRequire("4gM1A");


var $lgqac = parcelRequire("lgqac");

const $8b02aa09be31a1d9$export$cfb45d54e1604f6c = new Map([
    [
        undefined,
        'none'
    ],
    [
        0,
        'left'
    ],
    [
        1,
        'middle'
    ],
    [
        2,
        'right'
    ]
]);
const $8b02aa09be31a1d9$export$74743eda5dda3ccf = (e)=>{
    return [
        'alt',
        'ctrl',
        'meta',
        'shift'
    ].filter((key)=>e[`${key}Key`] === true);
};
const $8b02aa09be31a1d9$var$isContentEditable = (el)=>{
    return el instanceof HTMLElement && el.isContentEditable;
};
function $8b02aa09be31a1d9$export$d2a83e3b34be812b(e, clickType) {
    const { mac: mac, safari: safari } = (0, $4P6U3.browser)();
    /**
	 * If the link/parent is content editable then left click won't have typical effect
	 */ if ($8b02aa09be31a1d9$var$isContentEditable(e.currentTarget) && [
        'left',
        'middle'
    ].includes(clickType)) return 'contentEditable';
    switch(clickType){
        case 'left':
        case 'keyboard':
            {
                // Meta key = Cmd for macOS, Windows key sometimes for Windows (otherwise false)
                // https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/metaKey
                if (e.metaKey) return mac ? 'clickThroughNewTabOrWindow' : 'clickThrough';
                if (e.shiftKey) {
                    // Alt/option click in safari typically adds the link to bookmarks
                    if (safari) return 'alt';
                    return 'clickThroughNewTabOrWindow';
                }
                if (e.ctrlKey) {
                    // Ctrl+Left on macOS defaults to triggering a right click instead (so won't trigger onClick)
                    // but if this behaviour is disabled, likely outcome is clickThrough
                    if (mac) return 'clickThrough';
                    return 'clickThroughNewTabOrWindow';
                }
                if (e.altKey) return 'alt';
                const target = e.currentTarget.getAttribute('target');
                if (target === '_blank') return 'clickThroughNewTabOrWindow';
                return 'clickThrough';
            }
        case 'middle':
            return 'clickThroughNewTabOrWindow';
        case 'right':
            return 'contextMenu';
    }
    return 'unknown';
}
const $8b02aa09be31a1d9$var$linkClickedEvent = ({ clickType: clickType, clickOutcome: clickOutcome, keysHeld: keysHeld, defaultPrevented: defaultPrevented })=>({
        action: 'clicked',
        actionSubject: 'link',
        eventType: 'ui',
        attributes: {
            clickType: clickType,
            clickOutcome: clickOutcome,
            keysHeld: keysHeld,
            defaultPrevented: defaultPrevented
        }
    });
const $8b02aa09be31a1d9$export$7fedc699766c16de = (event)=>{
    // Through the `detail` property, we're able to determine if the event is (most likely) triggered via keyboard
    // https://developer.mozilla.org/en-US/docs/Web/API/UIEvent/detail
    const isKeyboard = event.nativeEvent.detail === 0;
    const clickType = isKeyboard ? 'keyboard' : $8b02aa09be31a1d9$export$cfb45d54e1604f6c.get(event.button);
    if (!clickType) return;
    const clickOutcome = $8b02aa09be31a1d9$export$d2a83e3b34be812b(event, clickType);
    const keysHeld = $8b02aa09be31a1d9$export$74743eda5dda3ccf(event);
    const defaultPrevented = event.defaultPrevented;
    const linkClickedEventResult = $8b02aa09be31a1d9$var$linkClickedEvent({
        clickType: clickType,
        clickOutcome: clickOutcome,
        keysHeld: keysHeld,
        defaultPrevented: defaultPrevented
    });
    // if the current target is an anchor tag, we can get the href from it and use that as the url being navigated too.
    if (event.currentTarget instanceof HTMLAnchorElement) {
        const url = event.currentTarget.href;
        return {
            ...linkClickedEventResult,
            nonPrivacySafeAttributes: {
                url: url
            }
        };
    } else // We can't get the href from the event target, so dont include the url or any non privacy safe attributes
    return linkClickedEventResult;
};
const $8b02aa09be31a1d9$export$7987de3055fbdcb0 = (createAnalyticsEvent)=>(event, overrides = {})=>{
        const payload = $8b02aa09be31a1d9$export$7fedc699766c16de(event);
        if (payload) createAnalyticsEvent({
            ...payload,
            ...overrides,
            attributes: {
                ...payload.attributes,
                ...overrides?.attributes
            },
            nonPrivacySafeAttributes: {
                ...payload.nonPrivacySafeAttributes,
                ...overrides?.nonPrivacySafeAttributes
            }
        }).fire((0, $lgqac.ANALYTICS_CHANNEL));
    };
const $8b02aa09be31a1d9$var$getDisplayName = (WrappedComponent)=>{
    if (typeof WrappedComponent === 'string') return WrappedComponent;
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};
function $8b02aa09be31a1d9$export$263352d59c0c5966(WrappedComponent) {
    const Component = (props)=>{
        const onClick = (0, $4gM1A.useLinkClicked)(props.onClick);
        const onMouseDown = (0, $4gM1A.useMouseDownEvent)(props.onMouseDown);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, {
            ...props,
            onClick: onClick,
            onMouseDown: onMouseDown
        });
    };
    Component.displayName = `withLinkClickedEvent(${$8b02aa09be31a1d9$var$getDisplayName(WrappedComponent)})`;
    return Component;
}
module.exports["fireLinkClickedEvent"] = $8b02aa09be31a1d9$export$7987de3055fbdcb0;
module.exports["withLinkClickedEvent"] = $8b02aa09be31a1d9$export$263352d59c0c5966;

});

parcelRegister("4P6U3", function(module, exports) {
const $9f845e05fed92a58$var$result = {
    mac: false,
    ie: false,
    ie_version: 0,
    gecko: false,
    chrome: false,
    chrome_version: 0,
    android: false,
    ios: false,
    webkit: false,
    safari: false,
    supportsIntersectionObserver: false,
    supportsResizeObserver: false
};
if (typeof navigator !== 'undefined') {
    const ieEdge = /Edge\/(\d+)/.exec(navigator.userAgent);
    const ieUpTo10 = /MSIE \d/.test(navigator.userAgent);
    const ie11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
    $9f845e05fed92a58$var$result.mac = /Mac/.test(navigator.platform);
    let ie = $9f845e05fed92a58$var$result.ie = !!(ieUpTo10 || ie11up || ieEdge);
    $9f845e05fed92a58$var$result.ie_version = ieUpTo10 ? document.documentMode || 6 : ie11up ? +ie11up[1] : ieEdge ? +ieEdge[1] : null;
    $9f845e05fed92a58$var$result.gecko = !ie && /gecko\/\d/i.test(navigator.userAgent);
    $9f845e05fed92a58$var$result.chrome = !ie && /Chrome\//.test(navigator.userAgent);
    $9f845e05fed92a58$var$result.chrome_version = parseInt((navigator.userAgent.match(/Chrome\/(\d+)/) || [])[1], 10);
    $9f845e05fed92a58$var$result.android = /Android \d/.test(navigator.userAgent);
    $9f845e05fed92a58$var$result.ios = !ie && /AppleWebKit/.test(navigator.userAgent) && /Mobile\/\w+/.test(navigator.userAgent);
    $9f845e05fed92a58$var$result.webkit = !ie && !!document.documentElement && 'WebkitAppearance' in document.documentElement.style;
    $9f845e05fed92a58$var$result.safari = Boolean(navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && navigator.userAgent.indexOf('CriOS') === -1 && navigator.userAgent.indexOf('FxiOS') === -1);
    $9f845e05fed92a58$var$result.supportsIntersectionObserver = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
    $9f845e05fed92a58$var$result.supportsResizeObserver = typeof window !== 'undefined' && 'ResizeObserver' in window && 'ResizeObserverEntry' in window;
}
function $9f845e05fed92a58$export$3f2684e5d7cb1006() {
    return $9f845e05fed92a58$var$result;
}
module.exports["browser"] = $9f845e05fed92a58$export$3f2684e5d7cb1006;

});

parcelRegister("4gM1A", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $6wQZE = parcelRequire("6wQZE");

var $77752028a2bf334b$export$81a5b494baf0f17c = /*#__PURE__*/ function(ClickButton) {
    ClickButton[ClickButton["Left"] = 0] = "Left";
    ClickButton[ClickButton["Middle"] = 1] = "Middle";
    ClickButton[ClickButton["Right"] = 2] = "Right";
    return ClickButton;
}({});
const $77752028a2bf334b$export$5993d3ca6c85f774 = (/**
	 * Handler to
	 */ handler, /**
	 * Filter which mouse events should trigger the link clicked event
	 */ predicate)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    return (0, $42omo.useCallback)((...args)=>{
        const [event] = args;
        handler?.apply(null, args);
        if (!predicate || predicate?.(event)) (0, $6wQZE.fireLinkClickedEvent)(createAnalyticsEvent)(event);
    }, [
        handler,
        predicate,
        createAnalyticsEvent
    ]);
};
const $77752028a2bf334b$var$isNotLeftClick = (event)=>event.button !== 0;
const $77752028a2bf334b$export$df67f318ded0283c = (onMouseDown)=>{
    return $77752028a2bf334b$export$5993d3ca6c85f774(onMouseDown, $77752028a2bf334b$var$isNotLeftClick);
};
module.exports["useLinkClicked"] = $77752028a2bf334b$export$5993d3ca6c85f774;
module.exports["useMouseDownEvent"] = $77752028a2bf334b$export$df67f318ded0283c;

});

parcelRegister("lgqac", function(module, exports) {
const $a2012143faf474ac$export$85183a312807388d = 'media';
const $a2012143faf474ac$export$a078c61943f9dbbe = {
    componentName: 'smart-cards',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
var $a2012143faf474ac$export$72af824fa910c33e = /*#__PURE__*/ function(TrackQuickActionType) {
    TrackQuickActionType["StatusUpdate"] = "StatusUpdate";
    return TrackQuickActionType;
}({});
var $a2012143faf474ac$export$c89e475f7f7174c2 = /*#__PURE__*/ function(TrackQuickActionFailureReason) {
    TrackQuickActionFailureReason["PermissionError"] = "PermissionError";
    TrackQuickActionFailureReason["ValidationError"] = "ValidationError";
    TrackQuickActionFailureReason["UnknownError"] = "UnknownError";
    return TrackQuickActionFailureReason;
}({});
class $a2012143faf474ac$export$b91e0203b928470c {
    insertSmartLink(url, type, createAnalyticsEvent) {
        $a2012143faf474ac$export$2a123f7ee48a122c({
            action: 'inserted',
            actionSubject: 'smartLink',
            eventType: 'track',
            attributes: {
                type: type
            },
            nonPrivacySafeAttributes: {
                domainName: url
            }
        }, createAnalyticsEvent);
    }
}
const $a2012143faf474ac$export$2a123f7ee48a122c = (payload, createAnalyticsEvent)=>{
    if (createAnalyticsEvent) createAnalyticsEvent(payload).fire($a2012143faf474ac$export$85183a312807388d);
};
module.exports["ANALYTICS_CHANNEL"] = $a2012143faf474ac$export$85183a312807388d;
module.exports["context"] = $a2012143faf474ac$export$a078c61943f9dbbe;
module.exports["TrackQuickActionType"] = $a2012143faf474ac$export$72af824fa910c33e;
module.exports["TrackQuickActionFailureReason"] = $a2012143faf474ac$export$c89e475f7f7174c2;
module.exports["SmartLinkEvents"] = $a2012143faf474ac$export$b91e0203b928470c;

});

parcelRegister("226XV", function(module, exports) {

var $dh538 = parcelRequire("dh538");

const $4a791b5829124355$export$c81497d3681f24f4 = (jsonLd)=>{
    return jsonLd['atlassian:visitUrl'];
};


const $c8f51fccdd166527$export$f75b0b690ab4dfb9 = (definitionId, store)=>{
    const urls = Object.keys(store);
    return urls.filter((url)=>{
        const { details: details } = store[url];
        return details && details.meta.definitionId === definitionId;
    });
};
const $c8f51fccdd166527$export$cf3c5acf9e9d0f02 = (url, jsonLd)=>{
    if (jsonLd && jsonLd.data) {
        const visitUrl = (0, $4a791b5829124355$export$c81497d3681f24f4)(jsonLd.data);
        if (visitUrl) return visitUrl;
    }
    return url;
};
const $c8f51fccdd166527$export$46fa3e7718c82e41 = (details)=>details?.meta?.definitionId;
const $c8f51fccdd166527$export$218d96312e385949 = (details)=>details?.meta?.key;
const $c8f51fccdd166527$export$81164c1570bcd038 = (details)=>details?.data && 'atlassian:ari' in details.data && details.data['atlassian:ari'] || undefined;
const $c8f51fccdd166527$export$e029950864672b4 = (details)=>{
    if ((0, $dh538.fg)('platform_smartlink_3pclick_analytics')) {
        if (details?.entityData && 'thirdPartyAri' in details.entityData && details.entityData.thirdPartyAri) return details.entityData.thirdPartyAri;
        if (details?.data && 'atlassian:ari' in details.data && typeof details.data['atlassian:ari'] === 'string') {
            const ari = details.data['atlassian:ari'];
            if (ari.includes('ari:third-party')) return ari;
        }
    }
    return undefined;
};
const $c8f51fccdd166527$export$48b4e58cdb8031ba = ()=>{
    if (!(0, $dh538.fg)('platform_smartlink_3pclick_analytics')) return undefined;
    const product = $c8f51fccdd166527$var$getProductFromWindowURL();
    const currentURL = window.location.href;
    if (product === 'confluence') {
        if (currentURL.includes('content.id')) {
            const contentId = $c8f51fccdd166527$var$extractContentIdFromURL(currentURL);
            if (contentId) return `ConfluenceContentId:${contentId}`;
        }
        const pageId = $c8f51fccdd166527$var$extractPageIdFromURL(currentURL);
        if (pageId) return `ConfluencePageId:${pageId}`;
    } else if (product === 'jira') {
        const issueKey = $c8f51fccdd166527$var$extractJiraIssueIdFromURL(currentURL);
        if (issueKey) return `JiraIssueKey:${issueKey}`;
    }
    return undefined;
};
const $c8f51fccdd166527$export$5615361d76a8be5 = (details)=>details?.data && 'name' in details.data && details.data.name || undefined;
const $c8f51fccdd166527$export$bcf275804417edda = (details)=>{
    if (details?.data && 'icon' in details.data && details.data.icon) {
        if (typeof details.data.icon === 'object' && 'url' in details.data.icon && details.data.icon.url && typeof details.data.icon.url === 'string') return details.data.icon.url;
    }
    return undefined;
};
const $c8f51fccdd166527$export$16c0ebb0de9b767b = (details)=>details?.meta?.resourceType;
const $c8f51fccdd166527$export$e2005c9600188ac7 = (details)=>details?.meta?.product;
const $c8f51fccdd166527$export$f8fdefc70357968e = (details)=>details?.meta?.subproduct;
const $c8f51fccdd166527$export$a009e3a1163d46fb = (details)=>details && details.meta.auth || [];
const $c8f51fccdd166527$export$ac5d414b1ebfab5a = (details)=>details && $c8f51fccdd166527$export$cd41ae544cfc2a65(details) && $c8f51fccdd166527$export$795910f5f15a9633(details);
const $c8f51fccdd166527$export$cd41ae544cfc2a65 = ({ meta: { access: access } })=>access === 'granted';
const $c8f51fccdd166527$export$795910f5f15a9633 = ({ meta: { visibility: visibility } })=>visibility === 'restricted' || visibility === 'public';
const $c8f51fccdd166527$export$a752a116d184ffbd = (details)=>{
    return details?.meta?.requestAccess?.accessType;
};
const $c8f51fccdd166527$export$d590d08942abc17a = (status)=>{
    return [
        'unauthorized',
        'forbidden',
        'errored',
        'resolved',
        'not_found'
    ].indexOf(status) > -1;
};
const $c8f51fccdd166527$export$66805b16d2a1da7c = (details)=>details?.datasources;
const $c8f51fccdd166527$export$ba6d13ab7b87c55c = (details)=>{
    const datasources = $c8f51fccdd166527$export$66805b16d2a1da7c(details);
    return !!datasources && datasources.length > 0;
};
const $c8f51fccdd166527$export$3f9446bb21b945a0 = (details)=>!!details?.meta.hasScopeOverrides;
// Helper function to extract page ID from standard Confluence page URLs
const $c8f51fccdd166527$var$extractPageIdFromURL = (url)=>{
    try {
        const urlObj = new URL(url);
        // Following this pattern for confluence URL -> /wiki/spaces/{space}/pages/{pageId}/{title}
        const pagesMatch = urlObj.pathname.match(/\/wiki\/spaces\/[^\/]+\/pages\/(\d+)(?:\/|$)/);
        if (pagesMatch && pagesMatch[1]) return pagesMatch[1];
        // Following this pattern for confluence URL -> /wiki/pages/viewpage.action?pageId={pageId}
        const pageIdParam = urlObj.searchParams.get('pageId');
        if (pageIdParam) return pageIdParam;
        // Following this pattern for confluence URL -> /wiki/display/{space}/{pageId}
        const displayMatch = urlObj.pathname.match(/\/wiki\/display\/[^\/]+\/(\d+)/);
        if (displayMatch && displayMatch[1]) return displayMatch[1];
    } catch  {
        return undefined;
    }
    return undefined;
};
const $c8f51fccdd166527$var$extractContentIdFromURL = (url)=>{
    try {
        const urlObj = new URL(url);
        // Pattern: ?content.id={contentId} (for app connector URLs and plugin servlet URLs)
        const contentId = urlObj.searchParams.get('content.id');
        if (contentId) return contentId;
        // Also support URLs where content.id is in the query string but not parsed by URL (edge case)
        // e.g., /wiki/plugins/servlet/ac/com.atlassian.perspectiveretros/perspective-retros?content.id=5662725850
        const match = url.match(/[?&]content\.id=(\d+)/);
        if (match && match[1]) return match[1];
    } catch  {
        return undefined;
    }
    return undefined;
};
const $c8f51fccdd166527$var$extractJiraIssueIdFromURL = (url)=>{
    try {
        const urlObj = new URL(url);
        // Support any case for Jira keys (e.g., AI3W-864, ai3w-864, Ai3W-864)
        const browseMatch = urlObj.pathname.match(/\/browse\/([A-Za-z0-9]+-\d+)/);
        if (browseMatch && browseMatch[1]) return browseMatch[1];
        // /jira/browse/{issueKey}
        const jiraBrowseMatch = urlObj.pathname.match(/\/jira\/browse\/([A-Za-z0-9]+-\d+)/);
        if (jiraBrowseMatch && jiraBrowseMatch[1]) return jiraBrowseMatch[1];
        // Query parameter ?selectedIssue={issueKey}
        const selectedIssue = urlObj.searchParams.get('selectedIssue');
        if (selectedIssue && /^[A-Za-z0-9]+-\d+$/.test(selectedIssue)) return selectedIssue;
        // Query parameter ?issueKey={issueKey}
        const issueKeyParam = urlObj.searchParams.get('issueKey');
        if (issueKeyParam && /^[A-Za-z0-9]+-\d+$/.test(issueKeyParam)) return issueKeyParam;
    } catch  {
        return undefined;
    }
    return undefined;
};
const $c8f51fccdd166527$var$getProductFromWindowURL = ()=>{
    try {
        const currentUrl = window.location.href;
        const urlObj = new URL(currentUrl);
        const hostname = urlObj.hostname.toLowerCase();
        const pathname = urlObj.pathname.toLowerCase();
        // Check for Confluence patterns
        if (hostname.includes('confluence') || pathname.includes('/wiki/') || pathname.includes('/display/') || pathname.includes('/spaces/')) return 'confluence';
        // Check for Jira patterns
        if (hostname.includes('jira') || pathname.includes('/browse/') || pathname.includes('/projects/') || pathname.includes('/secure/')) return 'jira';
    } catch  {
        return undefined;
    }
    return undefined;
};
module.exports["getByDefinitionId"] = $c8f51fccdd166527$export$f75b0b690ab4dfb9;
module.exports["getClickUrl"] = $c8f51fccdd166527$export$cf3c5acf9e9d0f02;
module.exports["getDefinitionId"] = $c8f51fccdd166527$export$46fa3e7718c82e41;
module.exports["getExtensionKey"] = $c8f51fccdd166527$export$218d96312e385949;
module.exports["getObjectAri"] = $c8f51fccdd166527$export$81164c1570bcd038;
module.exports["getThirdPartyARI"] = $c8f51fccdd166527$export$e029950864672b4;
module.exports["getFirstPartyIdentifier"] = $c8f51fccdd166527$export$48b4e58cdb8031ba;
module.exports["getObjectName"] = $c8f51fccdd166527$export$5615361d76a8be5;
module.exports["getObjectIconUrl"] = $c8f51fccdd166527$export$bcf275804417edda;
module.exports["getResourceType"] = $c8f51fccdd166527$export$16c0ebb0de9b767b;
module.exports["getServices"] = $c8f51fccdd166527$export$a009e3a1163d46fb;
module.exports["isFinalState"] = $c8f51fccdd166527$export$d590d08942abc17a;
module.exports["hasAuthScopeOverrides"] = $c8f51fccdd166527$export$3f9446bb21b945a0;

});

parcelRegister("kKODE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::676f76a2e45920437adc8c35a9af8b37>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen smart-card
 */ 
var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");

const $6678419bc4dceb3a$export$3f072f06b90c3985 = 'media';


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::f914fb83fac56e7154ef460866628f7d>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen smart-card
 */ const $4575fec4bf8df71a$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $4575fec4bf8df71a$export$2e2bcd8739ae039 = $4575fec4bf8df71a$var$createEventPayload;


const $5b5d947ab1fa491a$export$5bf35293e545f20c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireEvent = (0, $42omo.useCallback)((...params)=>{
        const event = createAnalyticsEvent((0, $4575fec4bf8df71a$export$2e2bcd8739ae039)(...params));
        event.fire((0, $6678419bc4dceb3a$export$3f072f06b90c3985));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEvent: fireEvent
    };
};
module.exports["useAnalyticsEvents"] = $5b5d947ab1fa491a$export$5bf35293e545f20c;

});

parcelRegister("l6tPN", function(module, exports) {
const $f72103dc56ec53a8$var$isPerformanceAPIAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && [
        'measure',
        'clearMeasures',
        'clearMarks',
        'getEntriesByName',
        'getEntriesByType'
    ].every((api)=>!!performance[api]);
};
const $f72103dc56ec53a8$var$hasPerformanceAPIAvailable = $f72103dc56ec53a8$var$isPerformanceAPIAvailable();
const $f72103dc56ec53a8$export$fcff3185c7ce7f2b = (id, status)=>`${status}:${id}`;
const $f72103dc56ec53a8$export$984df7f61dd7928f = (id, status)=>`time-to-${status}:${id}`;
const $f72103dc56ec53a8$export$1a717feb4df1a945 = (id)=>{
    if ($f72103dc56ec53a8$var$hasPerformanceAPIAvailable) {
        const marks = performance.getEntriesByType('mark').filter((mark)=>mark.name.includes(id));
        marks.forEach((mark)=>performance.clearMarks(mark.name));
    }
};
const $f72103dc56ec53a8$export$de42547d395c8271 = (id)=>{
    if ($f72103dc56ec53a8$var$hasPerformanceAPIAvailable) {
        const measures = performance.getEntriesByType('measure').filter((measure)=>measure.name.includes(id));
        measures.forEach((measure)=>performance.clearMeasures(measure.name));
    }
};
const $f72103dc56ec53a8$var$getMark = (id, status)=>{
    if ($f72103dc56ec53a8$var$hasPerformanceAPIAvailable) {
        const name = $f72103dc56ec53a8$export$fcff3185c7ce7f2b(id, status);
        const marks = performance.getEntriesByName(name);
        if (marks.length > 0) return marks[0];
        return undefined;
    }
};
const $f72103dc56ec53a8$export$d6e97a903ae9a3aa = (id, status)=>{
    if ($f72103dc56ec53a8$var$hasPerformanceAPIAvailable) {
        const name = $f72103dc56ec53a8$export$984df7f61dd7928f(id, status);
        const measures = performance.getEntriesByName(name);
        if (measures.length > 0) return measures[0];
        return undefined;
    }
};
const $f72103dc56ec53a8$export$bf7f2fce5c1cf636 = (id, status)=>{
    if ($f72103dc56ec53a8$var$hasPerformanceAPIAvailable) {
        const name = $f72103dc56ec53a8$export$fcff3185c7ce7f2b(id, status);
        performance.mark(name);
    }
};
const $f72103dc56ec53a8$export$185802fd694ee1f5 = (id, status)=>{
    if ($f72103dc56ec53a8$var$hasPerformanceAPIAvailable) {
        const name = $f72103dc56ec53a8$export$984df7f61dd7928f(id, status);
        const measure = $f72103dc56ec53a8$export$d6e97a903ae9a3aa(id, status);
        if (!measure) {
            const startMark = $f72103dc56ec53a8$var$getMark(id, 'pending');
            const endMark = $f72103dc56ec53a8$var$getMark(id, status);
            if (startMark && endMark) performance.measure(name, startMark.name, endMark.name);
        }
    }
};
module.exports["clearMarks"] = $f72103dc56ec53a8$export$1a717feb4df1a945;
module.exports["clearMeasures"] = $f72103dc56ec53a8$export$de42547d395c8271;
module.exports["getMeasure"] = $f72103dc56ec53a8$export$d6e97a903ae9a3aa;
module.exports["mark"] = $f72103dc56ec53a8$export$bf7f2fce5c1cf636;
module.exports["create"] = $f72103dc56ec53a8$export$185802fd694ee1f5;

});

parcelRegister("a43ao", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $eIleF = parcelRequire("eIleF");


var $9gPkz = parcelRequire("9gPkz");


var $3uVVG = parcelRequire("3uVVG");


var $kKODE = parcelRequire("kKODE");


var $5TXU5 = parcelRequire("5TXU5");


var $bIll3 = parcelRequire("bIll3");


var $226XV = parcelRequire("226XV");


var $9oOnT = parcelRequire("9oOnT");


var $7DSoa = parcelRequire("7DSoa");

const $35a2bf75aa5e3412$export$f7c340395f31e832 = (id, url)=>{
    const resolveUrl = (0, $7DSoa.default)();
    const invokeClientAction = (0, $9oOnT.default)({});
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const { store: store } = (0, $eIleF.useSmartLinkContext)();
    const { getState: getState, dispatch: dispatch } = store;
    const getSmartLinkState = (0, $42omo.useCallback)(()=>{
        const { details: details, status: status, metadataStatus: metadataStatus } = getState()[url] ?? {
            status: (0, $5TXU5.SmartLinkStatus).Pending
        };
        return {
            details: details,
            status: status,
            metadataStatus: metadataStatus
        };
    }, [
        getState,
        url
    ]);
    const setMetadataStatus = (0, $42omo.useCallback)((metadataStatus)=>{
        dispatch((0, $9gPkz.cardAction)((0, $9gPkz.ACTION_UPDATE_METADATA_STATUS), {
            url: url
        }, undefined, undefined, metadataStatus));
    }, [
        dispatch,
        url
    ]);
    const resolve = (0, $42omo.useCallback)(async (resourceUrl = url, isReloading = false, isMetadataRequest = false)=>resolveUrl(resourceUrl, isReloading, isMetadataRequest, id), [
        id,
        resolveUrl,
        url
    ]);
    const register = (0, $42omo.useCallback)(()=>{
        const { details: details } = getSmartLinkState();
        if (!details) {
            dispatch((0, $9gPkz.cardAction)((0, $9gPkz.ACTION_RESOLVING), {
                url: url
            }));
            setMetadataStatus('pending');
        }
        return resolve();
    }, [
        getSmartLinkState,
        resolve,
        dispatch,
        url,
        setMetadataStatus
    ]);
    const reload = (0, $42omo.useCallback)(()=>{
        const { details: details } = getSmartLinkState();
        const definitionId = (0, $226XV.getDefinitionId)(details);
        if (definitionId) (0, $226XV.getByDefinitionId)(definitionId, getState()).map((url)=>resolve(url, true));
        else resolve(url, true);
    }, [
        getSmartLinkState,
        url,
        getState,
        resolve
    ]);
    const loadMetadata = (0, $42omo.useCallback)(()=>{
        const { metadataStatus: metadataStatus } = getSmartLinkState();
        //metadataStatus will be undefined for SSR links only
        if (metadataStatus === undefined) {
            setMetadataStatus('pending');
            return resolve(url, false, true);
        }
    }, [
        getSmartLinkState,
        resolve,
        setMetadataStatus,
        url
    ]);
    const authorize = (0, $42omo.useCallback)((appearance)=>{
        const { details: details, status: status } = getSmartLinkState();
        const definitionId = (0, $226XV.getDefinitionId)(details);
        const extensionKey = (0, $226XV.getExtensionKey)(details);
        const services = (0, $226XV.getServices)(details);
        // When authentication is triggered, let GAS know!
        if (status === 'unauthorized') fireEvent('ui.button.clicked.connectAccount', {
            display: appearance,
            definitionId: definitionId ?? null
        });
        if (status === 'forbidden') fireEvent('ui.smartLink.clicked.tryAnotherAccount', {
            display: appearance,
            definitionId: definitionId ?? null
        });
        if (services.length > 0) {
            fireEvent('screen.consentModal.viewed', {
                definitionId: definitionId ?? null
            });
            (0, $3uVVG.auth)(services[0].url).then(()=>{
                fireEvent('track.applicationAccount.connected', {
                    definitionId: definitionId ?? null
                });
                (0, $bIll3.startUfoExperience)('smart-link-authenticated', id, {
                    extensionKey: extensionKey,
                    status: 'success'
                });
                fireEvent('operational.smartLink.connectSucceeded', {
                    definitionId: definitionId ?? null
                });
                reload();
            }, (err)=>{
                (0, $bIll3.startUfoExperience)('smart-link-authenticated', id, {
                    extensionKey: extensionKey,
                    status: err.type
                });
                fireEvent('operational.smartLink.connectFailed', {
                    definitionId: definitionId ?? null,
                    reason: err.type ?? null
                });
                if (err.type === 'auth_window_closed') fireEvent('ui.consentModal.closed', {
                    display: appearance,
                    definitionId: definitionId ?? null
                });
                reload();
            });
        }
    }, [
        getSmartLinkState,
        id,
        reload,
        fireEvent
    ]);
    const invoke = (0, $42omo.useCallback)(async (opts, appearance)=>{
        const { key: key, action: action } = opts;
        const source = opts.source || appearance;
        if (opts.type === 'client') return await invokeClientAction({
            actionFn: opts.action.promise,
            actionType: action.type,
            display: source,
            extensionKey: key
        });
    }, [
        invokeClientAction
    ]);
    return (0, $42omo.useMemo)(()=>({
            register: register,
            reload: reload,
            authorize: authorize,
            invoke: invoke,
            loadMetadata: loadMetadata
        }), [
        register,
        reload,
        authorize,
        invoke,
        loadMetadata
    ]);
};
module.exports["useSmartCardActions"] = $35a2bf75aa5e3412$export$f7c340395f31e832;

});

parcelRegister("eIleF", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


const $38c931550e91452f$export$156b523e63b4f63a = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
function $38c931550e91452f$export$e1d190b530cf0ee9() {
    const context = (0, $42omo.useContext)($38c931550e91452f$export$156b523e63b4f63a);
    if (!context) throw Error('useSmartCard() must be wrapped in <SmartCardProvider>');
    return context;
}
const $38c931550e91452f$export$10e9cca30e50f657 = ()=>$38c931550e91452f$var$useContextMemoized($38c931550e91452f$export$156b523e63b4f63a);
const $38c931550e91452f$export$797e3658f090919c = ({ children: children })=>{
    const cardContext = $38c931550e91452f$export$10e9cca30e50f657();
    if (!cardContext?.value) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
};
function $38c931550e91452f$var$useContextMemoized(reactContext) {
    const value = (0, $42omo.useContext)(reactContext);
    const context = (0, $42omo.useMemo)(()=>({
            Provider: reactContext.Provider,
            Consumer: reactContext.Consumer,
            value: value
        }), [
        value,
        reactContext
    ]);
    return context;
}
const $38c931550e91452f$export$2a29ca11e08dc129 = ({ children: children })=>{
    const cardContext = $38c931550e91452f$export$10e9cca30e50f657();
    const Provider = cardContext.Provider;
    return /*#__PURE__*/ (0, $l998X.jsx)(Provider, {
        value: cardContext.value,
        children: children
    });
};
var $38c931550e91452f$export$2e2bcd8739ae039 = $38c931550e91452f$export$156b523e63b4f63a;
module.exports["SmartCardContext"] = $38c931550e91452f$export$156b523e63b4f63a;
module.exports["useSmartLinkContext"] = $38c931550e91452f$export$e1d190b530cf0ee9;
module.exports["useSmartCardContext"] = $38c931550e91452f$export$10e9cca30e50f657;
module.exports["EditorSmartCardProviderValueGuard"] = $38c931550e91452f$export$797e3658f090919c;
module.exports["EditorSmartCardProvider"] = $38c931550e91452f$export$2a29ca11e08dc129;

});

parcelRegister("9gPkz", function(module, exports) {
// TODO: eventually move this file to @atlaskit/link-actions
const $4165c6e5bfa202ae$export$6e470aad5ba8952e = 'pending';
const $4165c6e5bfa202ae$export$9a6a932a0a39498e = 'resolving';
const $4165c6e5bfa202ae$export$63ec8bc7a8a75482 = 'resolved';
const $4165c6e5bfa202ae$export$b8cfaa842c9ab487 = 'reloading';
const $4165c6e5bfa202ae$export$6d8ed3f9433dd372 = 'errored';
const $4165c6e5bfa202ae$export$cfbbb7126bc8a0c6 = 'fallback';
const $4165c6e5bfa202ae$export$76b5c1aca20759c6 = 'preload';
const $4165c6e5bfa202ae$export$2c5edb971b673330 = 'metadata';
const $4165c6e5bfa202ae$export$a884a52152489cc3 = (type, { url: url }, payload, error, metadataStatus, ignoreStatusCheck)=>({
        type: type,
        url: url,
        payload: payload,
        error: error,
        metadataStatus: metadataStatus,
        ignoreStatusCheck: ignoreStatusCheck
    });
module.exports["ACTION_PENDING"] = $4165c6e5bfa202ae$export$6e470aad5ba8952e;
module.exports["ACTION_RESOLVING"] = $4165c6e5bfa202ae$export$9a6a932a0a39498e;
module.exports["ACTION_RESOLVED"] = $4165c6e5bfa202ae$export$63ec8bc7a8a75482;
module.exports["ACTION_RELOADING"] = $4165c6e5bfa202ae$export$b8cfaa842c9ab487;
module.exports["ACTION_ERROR"] = $4165c6e5bfa202ae$export$6d8ed3f9433dd372;
module.exports["ACTION_ERROR_FALLBACK"] = $4165c6e5bfa202ae$export$cfbbb7126bc8a0c6;
module.exports["ACTION_UPDATE_METADATA_STATUS"] = $4165c6e5bfa202ae$export$2c5edb971b673330;
module.exports["cardAction"] = $4165c6e5bfa202ae$export$a884a52152489cc3;

});

parcelRegister("3uVVG", function(module, exports) {
$parcel$export(module.exports, "AuthError", () => (parcelRequire("uvNb9")).AuthError);

var $uvNb9 = parcelRequire("uvNb9");


var $9P47v = parcelRequire("9P47v");

function $81514351a4f15f99$export$73693bad9f5880b0(startUrl, windowFeatures) {
    return new Promise((resolve, reject)=>{
        let authWindow = null;
        let authWindowInterval;
        const handleAuthWindowMessage = (event)=>{
            if (event.source !== authWindow) return;
            const { data: data } = event;
            if (typeof data !== 'object') return;
            switch(data.type){
                case 'outbound-auth:success':
                    finish();
                    resolve();
                    break;
                case 'outbound-auth:failure':
                    finish();
                    const errorType = data.errorType.toLowerCase();
                    if ((0, $9P47v.isOfTypeAuthError)(errorType)) reject(new (0, $uvNb9.AuthError)(data.message, errorType));
                    else reject(new (0, $uvNb9.AuthError)(data.message));
                    break;
            }
        };
        const handleAuthWindowInterval = ()=>{
            if (authWindow && authWindow.closed) {
                finish();
                reject(new (0, $uvNb9.AuthError)('The auth window was closed', 'auth_window_closed'));
            }
        };
        const start = ()=>{
            window.addEventListener('message', handleAuthWindowMessage);
            authWindow = window.open(startUrl, startUrl, windowFeatures);
            authWindowInterval = window.setInterval(handleAuthWindowInterval, 500);
        };
        const finish = ()=>{
            clearInterval(authWindowInterval);
            window.removeEventListener('message', handleAuthWindowMessage);
            if (authWindow) {
                authWindow.close();
                authWindow = null;
            }
        };
        start();
    });
}
module.exports["auth"] = $81514351a4f15f99$export$73693bad9f5880b0;

});

parcelRegister("9P47v", function(module, exports) {
// See https://tools.ietf.org/html/rfc6749#section-4.1.2.1
// 'auth_window_closed' is returned in addition to types from this RFC,
// representing when the authentication window is closed by the user
// 'authclientoauth2.autherror' is added to represent errors from
// outbound-auth
const $cd3cb472abe3f4ba$export$400e64c8451aa84f = (inputString)=>{
    return [
        'auth_window_closed',
        'invalid_request',
        'unauthorized_client',
        'access_denied',
        'unsupported_response_type',
        'invalid_scope',
        'server_error',
        'temporarily_unavailable',
        'authclientoauth2.autherror'
    ].includes(inputString);
};
module.exports["isOfTypeAuthError"] = $cd3cb472abe3f4ba$export$400e64c8451aa84f;

});

parcelRegister("5TXU5", function(module, exports) {
const $d747218f543c7aaa$export$5c881701926acbef = 'https://support.atlassian.com/confluence-cloud/docs/insert-links-and-anchors/#Smart-links';
const $d747218f543c7aaa$export$93d67ab022d9f8d2 = 'https://support.atlassian.com/confluence-cloud/docs/what-data-is-sent-and-received-when-pasting-a-smart-link/';
const $d747218f543c7aaa$export$70d24f0465ae60f8 = 'https://www.atlassian.com/trust/atlassian-intelligence';
const $d747218f543c7aaa$export$a3ed5c4e9d9599b7 = 'https://status.atlassian.com/';
const $d747218f543c7aaa$export$73b198e73554a323 = 'https://www.atlassian.com/legal/acceptable-use-policy';
var $d747218f543c7aaa$export$8910bf86027fe6be = /*#__PURE__*/ function(SmartLinkAlignment) {
    SmartLinkAlignment["Left"] = "left";
    SmartLinkAlignment["Right"] = "right";
    return SmartLinkAlignment;
}({});
var $d747218f543c7aaa$export$60831686b0574c86 = /*#__PURE__*/ function(SmartLinkDirection) {
    SmartLinkDirection["Horizontal"] = "horizontal";
    SmartLinkDirection["Vertical"] = "vertical";
    return SmartLinkDirection;
}({});
var $d747218f543c7aaa$export$d58e6377644d1dcf = /*#__PURE__*/ function(SmartLinkPosition) {
    SmartLinkPosition["Top"] = "top";
    SmartLinkPosition["Center"] = "center";
    return SmartLinkPosition;
}({});
var $d747218f543c7aaa$export$51f13ced115cbdae = /*#__PURE__*/ function(SmartLinkSize) {
    SmartLinkSize["XLarge"] = "xlarge";
    SmartLinkSize["Large"] = "large";
    SmartLinkSize["Medium"] = "medium";
    SmartLinkSize["Small"] = "small";
    return SmartLinkSize;
}({});
var $d747218f543c7aaa$export$61cff06be26816f = /*#__PURE__*/ function(SmartLinkStatus) {
    SmartLinkStatus["Pending"] = "pending";
    SmartLinkStatus["Resolving"] = "resolving";
    SmartLinkStatus["Resolved"] = "resolved";
    SmartLinkStatus["Forbidden"] = "forbidden";
    SmartLinkStatus["Errored"] = "errored";
    SmartLinkStatus["NotFound"] = "not_found";
    SmartLinkStatus["Unauthorized"] = "unauthorized";
    SmartLinkStatus["Fallback"] = "fallback";
    return SmartLinkStatus;
}({});
var $d747218f543c7aaa$export$aed0f1e801ad691f = /*#__PURE__*/ function(SmartLinkTheme) {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    SmartLinkTheme["Black"] = "black";
    SmartLinkTheme["Link"] = "link";
    return SmartLinkTheme;
}({});
var $d747218f543c7aaa$export$9aafec380d7005da = /*#__PURE__*/ function(SmartLinkInternalTheme) {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    SmartLinkInternalTheme["Grey"] = "grey";
    return SmartLinkInternalTheme;
}({});
var $d747218f543c7aaa$export$19c60054ee783de6 = /*#__PURE__*/ function(SmartLinkWidth) {
    SmartLinkWidth["FitToContent"] = "fit-to-content";
    SmartLinkWidth["Flexible"] = "flexible";
    return SmartLinkWidth;
}({});
var $d747218f543c7aaa$export$d65b168331104a46 = /*#__PURE__*/ function(ElementName) {
    ElementName["AppliedToComponentsCount"] = "AppliedToComponentsCount";
    ElementName["AssignedTo"] = "AssignedTo";
    ElementName["AssignedToGroup"] = "AssignedToGroup";
    ElementName["AttachmentCount"] = "AttachmentCount";
    ElementName["AuthorGroup"] = "AuthorGroup";
    ElementName["ChecklistProgress"] = "ChecklistProgress";
    ElementName["CollaboratorGroup"] = "CollaboratorGroup";
    ElementName["CommentCount"] = "CommentCount";
    ElementName["CreatedBy"] = "CreatedBy";
    ElementName["CreatedOn"] = "CreatedOn";
    ElementName["DueOn"] = "DueOn";
    ElementName["LatestCommit"] = "LatestCommit";
    ElementName["LinkIcon"] = "LinkIcon";
    ElementName["Location"] = "Location";
    ElementName["ModifiedBy"] = "ModifiedBy";
    ElementName["ModifiedOn"] = "ModifiedOn";
    ElementName["OwnedBy"] = "OwnedBy";
    ElementName["OwnedByGroup"] = "OwnedByGroup";
    ElementName["Preview"] = "Preview";
    ElementName["Priority"] = "Priority";
    ElementName["ProgrammingLanguage"] = "ProgrammingLanguage";
    ElementName["Provider"] = "Provider";
    ElementName["ReactCount"] = "ReactCount";
    ElementName["ReadTime"] = "ReadTime";
    ElementName["Snippet"] = "Snippet";
    ElementName["SourceBranch"] = "SourceBranch";
    ElementName["State"] = "State";
    ElementName["SubscriberCount"] = "SubscriberCount";
    ElementName["SubTasksProgress"] = "SubTasksProgress";
    ElementName["StoryPoints"] = "StoryPoints";
    ElementName["TargetBranch"] = "TargetBranch";
    ElementName["TeamMemberCount"] = "TeamMemberCount";
    ElementName["Title"] = "Title";
    ElementName["UserAttributes"] = "UserAttributes";
    ElementName["ViewCount"] = "ViewCount";
    ElementName["VoteCount"] = "VoteCount";
    ElementName["SentOn"] = "SentOn";
    return ElementName;
}({});
var $d747218f543c7aaa$export$9c95d6e1614bad84 = /*#__PURE__*/ function(ActionName) {
    ActionName["CopyLinkAction"] = "CopyLinkAction";
    ActionName["DeleteAction"] = "DeleteAction";
    ActionName["EditAction"] = "EditAction";
    ActionName["FollowAction"] = "FollowAction";
    ActionName["PreviewAction"] = "PreviewAction";
    ActionName["AutomationAction"] = "AutomationAction";
    ActionName["DownloadAction"] = "DownloadAction";
    ActionName["CustomAction"] = "CustomAction";
    return ActionName;
}({});
var $d747218f543c7aaa$export$4871a84b35cf8eb9 = /*#__PURE__*/ function(InternalActionName) {
    InternalActionName["AISummaryAction"] = "AISummaryAction";
    InternalActionName["UnresolvedAction"] = "UnresolvedAction";
    InternalActionName["ViewRelatedLinksAction"] = "ViewRelatedLinksAction";
    return InternalActionName;
}({});
var $d747218f543c7aaa$export$13ff1290a9e22e77 = /*#__PURE__*/ function(IconType) {
    IconType["Archive"] = "FileType:Archive";
    IconType["Audio"] = "FileType:Audio";
    IconType["Blog"] = "FileType:Blog";
    IconType["Code"] = "FileType:Code";
    IconType["Document"] = "FileType:Document";
    IconType["Executable"] = "FileType:Executable";
    IconType["File"] = "FileType:File";
    IconType["Folder"] = "FileType:Folder";
    IconType["Generic"] = "FileType:Generic";
    IconType["GIF"] = "FileType:GIF";
    IconType["GoogleDocs"] = "FileType:GoogleDocs";
    IconType["GoogleForms"] = "FileType:GoogleForms";
    IconType["GoogleSheets"] = "FileType:GoogleSheets";
    IconType["GoogleSlides"] = "FileType:GoogleSlides";
    IconType["Image"] = "FileType.Image";
    IconType["MSExcel"] = "FileType:Excel";
    IconType["MSPowerpoint"] = "FileType:Powerpoint";
    IconType["MSWord"] = "FileType:WordDocument";
    IconType["PDF"] = "FileType:PDF";
    IconType["Presentation"] = "FileType:Presentation";
    IconType["Sketch"] = "FileType:Sketch";
    IconType["Spreadsheet"] = "FileType:Spreadsheet";
    IconType["Template"] = "FileType:Template";
    IconType["Video"] = "FileType:Video";
    // BitBucket?
    IconType["Branch"] = "BitBucket:Branch";
    IconType["Commit"] = "BitBucket:Commit";
    IconType["Project"] = "BitBucket:Project";
    IconType["PullRequest"] = "BitBucket:PullRequest";
    IconType["Repo"] = "BitBucket:Repo";
    // Jira?
    IconType["Bug"] = "Jira:Bug";
    IconType["Change"] = "Jira:Change";
    IconType["Epic"] = "Jira:Epic";
    IconType["Incident"] = "Jira:Incident";
    IconType["Problem"] = "Jira:Problem";
    IconType["ServiceRequest"] = "Jira:ServiceRequest";
    IconType["Story"] = "Jira:Story";
    IconType["SubTask"] = "Jira:SubTask";
    IconType["Task"] = "Jira:Task";
    // Confluence
    IconType["LiveDocument"] = "Confluence:LiveDocument";
    // Provider
    IconType["Confluence"] = "Provider:Confluence";
    IconType["Jira"] = "Provider:Jira";
    // Fallback
    IconType["Default"] = "Default";
    IconType["Error"] = "Default:Error";
    IconType["Forbidden"] = "Default:Forbidden";
    // Badge
    IconType["Attachment"] = "Badge:Attachment";
    IconType["CheckItem"] = "Badge:Task";
    IconType["Comment"] = "Badge:Comment";
    IconType["Component"] = "Badge:Component";
    IconType["View"] = "Badge:View";
    IconType["React"] = "Badge:React";
    IconType["Vote"] = "Badge:Vote";
    IconType["PriorityBlocker"] = "Badge:PriorityBlocker";
    IconType["PriorityCritical"] = "Badge:PriorityCritical";
    IconType["PriorityHigh"] = "Badge:PriorityHigh";
    IconType["PriorityHighest"] = "Badge:PriorityHighest";
    IconType["PriorityLow"] = "Badge:PriorityLow";
    IconType["PriorityLowest"] = "Badge:PriorityLowest";
    IconType["PriorityMajor"] = "Badge:PriorityMajor";
    IconType["PriorityMedium"] = "Badge:PriorityMedium";
    IconType["PriorityMinor"] = "Badge:PriorityMinor";
    IconType["PriorityTrivial"] = "Badge:PriorityTrivial";
    IconType["PriorityUndefined"] = "Badge:PriorityUndefined";
    IconType["ProgrammingLanguage"] = "Badge:ProgrammingLanguage";
    IconType["Subscriber"] = "Badge:Subscriber";
    IconType["SubTasksProgress"] = "Badge:SubTask";
    return IconType;
}({});
var $d747218f543c7aaa$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["Image"] = "image";
    return MediaType;
}({});
var $d747218f543c7aaa$export$f9f4737e25ab90fa = /*#__PURE__*/ function(MediaPlacement) {
    MediaPlacement["Left"] = "left";
    MediaPlacement["Right"] = "right";
    return MediaPlacement;
}({});
var $d747218f543c7aaa$export$6ca4ef8b3dc2c804 = /*#__PURE__*/ function(CardDisplay) {
    CardDisplay["Inline"] = "inline";
    CardDisplay["Block"] = "block";
    CardDisplay["Embed"] = "embed";
    CardDisplay["EmbedPreview"] = "embedPreview";
    CardDisplay["Flexible"] = "flexible";
    CardDisplay["HoverCardPreview"] = "hoverCardPreview";
    return CardDisplay;
}({});
module.exports["CONTENT_URL_SECURITY_AND_PERMISSIONS"] = $d747218f543c7aaa$export$5c881701926acbef;
module.exports["CONTENT_URL_3P_ACCOUNT_AUTH"] = $d747218f543c7aaa$export$93d67ab022d9f8d2;
module.exports["CONTENT_URL_AI"] = $d747218f543c7aaa$export$70d24f0465ae60f8;
module.exports["CONTENT_URL_AI_TROUBLESHOOTING"] = $d747218f543c7aaa$export$a3ed5c4e9d9599b7;
module.exports["CONTENT_URL_ACCEPTABLE_USE_POLICY"] = $d747218f543c7aaa$export$73b198e73554a323;
module.exports["SmartLinkAlignment"] = $d747218f543c7aaa$export$8910bf86027fe6be;
module.exports["SmartLinkDirection"] = $d747218f543c7aaa$export$60831686b0574c86;
module.exports["SmartLinkPosition"] = $d747218f543c7aaa$export$d58e6377644d1dcf;
module.exports["SmartLinkSize"] = $d747218f543c7aaa$export$51f13ced115cbdae;
module.exports["SmartLinkStatus"] = $d747218f543c7aaa$export$61cff06be26816f;
module.exports["SmartLinkTheme"] = $d747218f543c7aaa$export$aed0f1e801ad691f;
module.exports["SmartLinkInternalTheme"] = $d747218f543c7aaa$export$9aafec380d7005da;
module.exports["SmartLinkWidth"] = $d747218f543c7aaa$export$19c60054ee783de6;
module.exports["ElementName"] = $d747218f543c7aaa$export$d65b168331104a46;
module.exports["ActionName"] = $d747218f543c7aaa$export$9c95d6e1614bad84;
module.exports["InternalActionName"] = $d747218f543c7aaa$export$4871a84b35cf8eb9;
module.exports["IconType"] = $d747218f543c7aaa$export$13ff1290a9e22e77;
module.exports["MediaType"] = $d747218f543c7aaa$export$483c11740a902fcd;
module.exports["MediaPlacement"] = $d747218f543c7aaa$export$f9f4737e25ab90fa;
module.exports["CardDisplay"] = $d747218f543c7aaa$export$6ca4ef8b3dc2c804;

});

parcelRegister("bIll3", function(module, exports) {

var $9801n = parcelRequire("9801n");

var $iqaft = parcelRequire("iqaft");

const $fe01df8db47f84d1$var$inlineExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $iqaft.ExperienceTypes).Experience,
    performanceType: (0, $iqaft.ExperiencePerformanceTypes).InlineResult
};
const $fe01df8db47f84d1$var$renderExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $iqaft.ExperienceTypes).Load,
    performanceType: (0, $iqaft.ExperiencePerformanceTypes).PageSegmentLoad
};
const $fe01df8db47f84d1$var$aiExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $iqaft.ExperienceTypes).Experience,
    performanceType: (0, $iqaft.ExperiencePerformanceTypes).InlineResult
};
const $fe01df8db47f84d1$var$ufoExperiences = {
    'smart-link-rendered': new (0, $9801n.ConcurrentExperience)('smart-link-rendered', $fe01df8db47f84d1$var$renderExperience),
    'smart-link-authenticated': new (0, $9801n.ConcurrentExperience)('smart-link-authenticated', $fe01df8db47f84d1$var$inlineExperience),
    'smart-link-action-invocation': new (0, $9801n.ConcurrentExperience)('smart-link-action-invocation', $fe01df8db47f84d1$var$inlineExperience),
    'smart-link-ai-summary': new (0, $9801n.ConcurrentExperience)('smart-link-ai-summary', $fe01df8db47f84d1$var$aiExperience)
};
const $fe01df8db47f84d1$export$5e9287b6a10f8075 = (experienceName, id, properties)=>{
    const experience = $fe01df8db47f84d1$var$ufoExperiences[experienceName].getInstance(id);
    experience.start();
    if (properties) experience.addMetadata(properties);
};
const $fe01df8db47f84d1$export$c5a5cf072c836c0e = (experienceName, id, properties)=>{
    const experience = $fe01df8db47f84d1$var$ufoExperiences[experienceName].getInstance(id);
    experience.success({
        metadata: properties
    });
};
const $fe01df8db47f84d1$export$8dda83bafca11b77 = (experienceName, id, properties)=>{
    const experience = $fe01df8db47f84d1$var$ufoExperiences[experienceName].getInstance(id);
    experience.failure({
        metadata: properties
    });
};
const $fe01df8db47f84d1$export$4084c0df4a03a6af = (experienceName, id, properties)=>{
    $fe01df8db47f84d1$var$ufoExperiences[experienceName].getInstance(id).addMetadata(properties);
};
module.exports["startUfoExperience"] = $fe01df8db47f84d1$export$5e9287b6a10f8075;
module.exports["succeedUfoExperience"] = $fe01df8db47f84d1$export$c5a5cf072c836c0e;
module.exports["failUfoExperience"] = $fe01df8db47f84d1$export$8dda83bafca11b77;
module.exports["addMetadataToExperience"] = $fe01df8db47f84d1$export$4084c0df4a03a6af;

});

parcelRegister("9oOnT", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dQl1W = parcelRequire("dQl1W");


var $kKODE = parcelRequire("kKODE");


var $l6tPN = parcelRequire("l6tPN");


var $bIll3 = parcelRequire("bIll3");

const $458a31c3ca98bc55$var$ACTION_EXPERIENCE_NAME = 'smart-link-action-invocation';
/**
 * Invoke client action such as preview, download and open link
 */ const $458a31c3ca98bc55$var$useInvokeClientAction = ({ fireEvent: fireEventProp })=>{
    const { fireEvent: defaultFireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const fireEvent = fireEventProp ?? defaultFireEvent;
    return (0, $42omo.useCallback)(async ({ actionSubjectId: actionSubjectId, actionType: actionType, actionFn: actionFn, definitionId: definitionId = null, extensionKey: extensionKey, display: display, id: id, resourceType: resourceType = null })=>{
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const experienceId = (0, (/*@__PURE__*/$parcel$interopDefault($dQl1W)))();
        // Begin performance instrumentation.
        const markName = `${experienceId}-${actionType}`;
        $l6tPN.mark(markName, 'pending');
        try {
            // Begin UFO experience
            (0, $bIll3.startUfoExperience)($458a31c3ca98bc55$var$ACTION_EXPERIENCE_NAME, experienceId, {
                actionType: actionType,
                display: display,
                extensionKey: extensionKey,
                invokeType: 'client'
            });
            // Begin analytics instrumentation.
            if (actionSubjectId !== undefined) fireEvent(`ui.button.clicked.${actionSubjectId}`, {
                actionType: actionType ?? null,
                definitionId: definitionId,
                display: display ?? null,
                id: id ?? experienceId,
                resourceType: resourceType
            });
            // Invoke action
            const result = await actionFn();
            $l6tPN.mark(markName, 'resolved');
            (0, $bIll3.succeedUfoExperience)($458a31c3ca98bc55$var$ACTION_EXPERIENCE_NAME, experienceId);
            fireEvent('operational.smartLinkAction.resolved', {
                actionType: actionType ?? null,
                definitionId: definitionId,
                display: display ?? null,
                duration: $l6tPN.getMeasure(markName, 'resolved')?.duration ?? null,
                id: id ?? experienceId,
                resourceType: resourceType
            });
            return result;
        } catch (err) {
            $l6tPN.mark(markName, 'errored');
            (0, $bIll3.failUfoExperience)($458a31c3ca98bc55$var$ACTION_EXPERIENCE_NAME, experienceId);
            const reason = typeof err === 'string' ? err : err?.message;
            fireEvent('operational.smartLinkAction.unresolved', {
                actionType: actionType ?? null,
                definitionId: definitionId,
                display: display ?? null,
                duration: $l6tPN.getMeasure(markName, 'errored')?.duration ?? null,
                id: id ?? experienceId,
                reason: reason,
                resourceType: resourceType
            });
        }
    }, [
        fireEvent
    ]);
};
var $458a31c3ca98bc55$export$2e2bcd8739ae039 = $458a31c3ca98bc55$var$useInvokeClientAction;
module.exports["default"] = $458a31c3ca98bc55$export$2e2bcd8739ae039;

});

parcelRegister("7DSoa", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $lyclm = parcelRequire("lyclm");


var $eIleF = parcelRequire("eIleF");


var $5TXU5 = parcelRequire("5TXU5");


var $bIll3 = parcelRequire("bIll3");


var $4IQbU = parcelRequire("4IQbU");

const $8fe2ac6ef7785039$var$useResolve = ()=>{
    // Request JSON-LD data for the card from ORS, if it has extended
    // its cache lifespan OR there is no data for it currently. Once the data
    // has come back asynchronously, call the useResponse callback to
    // dispatch the resolved action for the card.
    const { store: store, connections: connections } = (0, $eIleF.useSmartLinkContext)();
    const { getState: getState } = store;
    const { handleResolvedLinkResponse: handleResolvedLinkResponse, handleResolvedLinkError: handleResolvedLinkError } = (0, $4IQbU.default)();
    return (0, $42omo.useCallback)(async (url, isReloading = false, isMetadataRequest = false, id = '')=>{
        const { details: details } = getState()[url] || {
            status: (0, $5TXU5.SmartLinkStatus).Pending,
            details: undefined
        };
        const hasData = !!(details && details.data || (0, $lyclm.isEntityPresent)(details));
        if (isReloading || !hasData || isMetadataRequest) return connections.client.fetchData(url, isReloading).then((response)=>handleResolvedLinkResponse(url, response, isReloading, isMetadataRequest)).catch((error)=>handleResolvedLinkError(url, error, undefined, isMetadataRequest));
        else (0, $bIll3.addMetadataToExperience)('smart-link-rendered', id, {
            cached: true
        });
    }, [
        connections.client,
        getState,
        handleResolvedLinkError,
        handleResolvedLinkResponse
    ]);
};
var $8fe2ac6ef7785039$export$2e2bcd8739ae039 = $8fe2ac6ef7785039$var$useResolve;
module.exports["default"] = $8fe2ac6ef7785039$export$2e2bcd8739ae039;

});

parcelRegister("4IQbU", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jTxSS = parcelRequire("jTxSS");


var $eIleF = parcelRequire("eIleF");


var $9gPkz = parcelRequire("9gPkz");

var $jHnts = parcelRequire("jHnts");

var $btw9C = parcelRequire("btw9C");


var $5TXU5 = parcelRequire("5TXU5");


var $4ibS1 = parcelRequire("4ibS1");

const $96d7cda9026a4858$export$297c39c8b9bfca0 = 'resolving';
const $96d7cda9026a4858$export$b64a888338c24e0e = 'errored';
const $96d7cda9026a4858$export$677b6edfa0002c70 = 'fallback';
const $96d7cda9026a4858$export$3e81ce851ffda0ad = 'Provider.authFlow is not set to OAuth2.';
const $96d7cda9026a4858$export$45e7dda0d43d7f55 = 'Fatal error resolving URL';
const $96d7cda9026a4858$export$338f7d9ccca1975d = 'Error resolving metadata.';


const $afe444b12e732e06$var$useResponse = ()=>{
    // Takes in the JSON-LD response and dispatch the resolved action for the card.
    // It will dispatch a successful or error action
    const { store: store, config: config } = (0, $eIleF.useSmartLinkContext)();
    const { getState: getState, dispatch: dispatch } = store;
    const hasAuthFlowSupported = config.authFlow !== 'disabled';
    const setMetadataStatus = (0, $42omo.useCallback)((url, metadataStatus)=>{
        dispatch((0, $9gPkz.cardAction)((0, $9gPkz.ACTION_UPDATE_METADATA_STATUS), {
            url: url
        }, undefined, undefined, metadataStatus));
    }, [
        dispatch
    ]);
    const handleResolvedLinkError = (0, $42omo.useCallback)((url, error, response, isMetadataRequest)=>{
        const newState = {
            status: (0, $5TXU5.SmartLinkStatus).Pending,
            details: undefined
        };
        const { details: details } = getState()[url] || newState;
        const hasData = !!(details && details.data);
        // If metadata request then set metadata status, return and do not alter link status
        if (isMetadataRequest) {
            setMetadataStatus(url, 'errored');
            return;
        }
        if (error.kind === 'fatal') {
            // If we already have resolved data for this URL in the store, then
            // simply fallback to the previous data.
            if (hasData) dispatch((0, $9gPkz.cardAction)((0, $9gPkz.ACTION_RESOLVED), {
                url: url
            }, details));
            else {
                dispatch((0, $9gPkz.cardAction)((0, $9gPkz.ACTION_ERROR), {
                    url: url
                }, details, error));
                throw error;
            }
        } else if (error.kind === 'auth') dispatch((0, $9gPkz.cardAction)((0, $9gPkz.ACTION_RESOLVED), {
            url: url
        }, (0, $4ibS1.getUnauthorizedJsonLd)()));
        else if (error.kind === 'fallback') // Fallback to blue link with smart link formatting. Not part of reliability.
        dispatch((0, $9gPkz.cardAction)((0, $9gPkz.ACTION_ERROR_FALLBACK), {
            url: url
        }, response, error));
        else // Fallback to blue link with smart link formatting. Part of reliability.
        dispatch((0, $9gPkz.cardAction)((0, $9gPkz.ACTION_ERROR), {
            url: url
        }, undefined, error));
    }, [
        getState,
        setMetadataStatus,
        dispatch
    ]);
    const handleResolvedLinkSuccess = (0, $42omo.useCallback)((resourceUrl, response, isReloading, isMetadataRequest)=>{
        //if a link resolves normally, metadata will also always be resolved
        setMetadataStatus(resourceUrl, 'resolved');
        // Dispatch Analytics and resolved card action - including unauthorized states.
        if (isReloading) dispatch((0, $9gPkz.cardAction)((0, $9gPkz.ACTION_RELOADING), {
            url: resourceUrl
        }, response));
        else dispatch((0, $9gPkz.cardAction)((0, $9gPkz.ACTION_RESOLVED), {
            url: resourceUrl
        }, response, undefined, undefined, isMetadataRequest));
    }, [
        setMetadataStatus,
        dispatch
    ]);
    const handleResolvedLinkResponse = (0, $42omo.useCallback)((resourceUrl, response, isReloading = false, isMetadataRequest)=>{
        const hostname = new URL(resourceUrl).hostname;
        const nextStatus = response ? (0, $btw9C.getStatus)(response) : 'fatal';
        // If we require authorization & do not have an authFlow available,
        // throw an error and render as a normal blue link.
        if ((nextStatus === 'unauthorized' || nextStatus === 'forbidden') && !hasAuthFlowSupported) {
            handleResolvedLinkError(resourceUrl, new (0, $jHnts.APIError)('fallback', hostname, (0, $96d7cda9026a4858$export$3e81ce851ffda0ad)), response, isMetadataRequest);
            return;
        }
        // Handle any other errors
        if (!response || nextStatus === 'fatal') {
            handleResolvedLinkError(resourceUrl, new (0, $jHnts.APIError)('fatal', hostname, (0, $96d7cda9026a4858$export$45e7dda0d43d7f55)), undefined, isMetadataRequest);
            return;
        }
        // Handle errors of any other kind in the metadata request response
        if (isMetadataRequest && nextStatus !== 'resolved') {
            handleResolvedLinkError(resourceUrl, new (0, $jHnts.APIError)('error', hostname, (0, $96d7cda9026a4858$export$338f7d9ccca1975d)), response, isMetadataRequest);
            return;
        }
        /**
			 * Using unstable_batchedUpdates because this store update happens async and triggers a rerender
			 * more info:
			 * https://github.com/facebook/react/blob/v18.2.0/packages/use-sync-external-store/src/useSyncExternalStoreShimClient.js#L113
			 * https://react-redux.js.org/api/batch
			 */ (0, $jTxSS.unstable_batchedUpdates)(()=>{
            handleResolvedLinkSuccess(resourceUrl, response, isReloading, isMetadataRequest);
        });
    }, [
        handleResolvedLinkError,
        handleResolvedLinkSuccess,
        hasAuthFlowSupported
    ]);
    return (0, $42omo.useMemo)(()=>({
            handleResolvedLinkError: handleResolvedLinkError,
            handleResolvedLinkResponse: handleResolvedLinkResponse
        }), [
        handleResolvedLinkError,
        handleResolvedLinkResponse
    ]);
};
var $afe444b12e732e06$export$2e2bcd8739ae039 = $afe444b12e732e06$var$useResponse;
module.exports["default"] = $afe444b12e732e06$export$2e2bcd8739ae039;

});

parcelRegister("4ibS1", function(module, exports) {
const $edbc823e59ec01a7$var$emptyData = {
    '@context': {
        '@vocab': 'https://www.w3.org/ns/activitystreams#',
        atlassian: 'https://schema.atlassian.com/ns/vocabulary#',
        schema: 'http://schema.org/'
    },
    '@type': 'Object'
};
const $edbc823e59ec01a7$export$2796a804c6e44f63 = ()=>$edbc823e59ec01a7$var$emptyData;
const $edbc823e59ec01a7$export$b9482e0f6d365cc7 = ()=>({
        meta: {
            visibility: 'restricted',
            access: 'unauthorized',
            auth: [],
            definitionId: 'provider-not-found'
        },
        data: {
            ...$edbc823e59ec01a7$var$emptyData
        }
    });
const $edbc823e59ec01a7$export$e32193033a594efb = ()=>({
        meta: {
            visibility: 'restricted',
            access: 'forbidden',
            auth: [],
            definitionId: 'provider-not-found'
        },
        data: {
            ...$edbc823e59ec01a7$var$emptyData
        }
    });
module.exports["getEmptyJsonLd"] = $edbc823e59ec01a7$export$2796a804c6e44f63;
module.exports["getUnauthorizedJsonLd"] = $edbc823e59ec01a7$export$b9482e0f6d365cc7;
module.exports["getForbiddenJsonLd"] = $edbc823e59ec01a7$export$e32193033a594efb;

});

parcelRegister("lz9QA", function(module, exports) {

var $hpRUx = parcelRequire("hpRUx");


var $eIleF = parcelRequire("eIleF");

const $206782ec364200b6$var$PENDING_STATE = {
    status: 'pending'
};
function $206782ec364200b6$export$b0444d00ba7313c6(url) {
    const { store: store } = (0, $eIleF.useSmartLinkContext)();
    const cardState = (0, $hpRUx.useSyncExternalStoreWithSelector)(store.subscribe, store.getState, store.getState, (state)=>state[url]);
    return cardState ?? $206782ec364200b6$var$PENDING_STATE;
}
module.exports["useSmartCardState"] = $206782ec364200b6$export$b0444d00ba7313c6;

});

parcelRegister("5MkWK", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $bYRk6 = parcelRequire("bYRk6");


var $c6GJD = parcelRequire("c6GJD");


var $1xKpK = parcelRequire("1xKpK");


var $eIleF = parcelRequire("eIleF");


var $6q0AE = parcelRequire("6q0AE");


var $dh538 = parcelRequire("dh538");


var $lz9QA = parcelRequire("lz9QA");


var $lgqac = parcelRequire("lgqac");

const $9dd53b67e285af98$var$getExtendedResolvedAttributes = (linkDetails, details, linkStatus, error)=>({
        definitionId: details?.meta?.definitionId ?? null,
        resourceType: details?.meta?.resourceType ?? null,
        ...(0, $1xKpK.getResolvedAttributes)(linkDetails, details, linkStatus, error)
    });
const $9dd53b67e285af98$var$getSmartLinkAnalyticsContext = ({ display: display, id: id, response: response, source: source, status: status, url: url, error: error })=>{
    const isHyperlinkConnectExperimentEnabled = (0, $c6GJD.default).getExperimentValue('platform_linking_bluelink_connect_confluence', 'isEnabled', false) || (0, $c6GJD.default).getExperimentValue('platform_linking_bluelink_connect_jira', 'isEnabled', false);
    const resolvedAttributes = isHyperlinkConnectExperimentEnabled ? $9dd53b67e285af98$var$getExtendedResolvedAttributes({
        url: url,
        displayCategory: display === 'url' ? 'link' : 'smartLink'
    }, response, status, error) : $9dd53b67e285af98$var$getExtendedResolvedAttributes({
        url: url
    }, response, status, error);
    return {
        source: source,
        attributes: {
            ...(0, $lgqac.context),
            display: display,
            id: id,
            ...resolvedAttributes
        }
    };
};
const $9dd53b67e285af98$export$ac28ada90c4970b7 = ({ display: display, id: id, source: source, url: url })=>{
    const { store: store } = (0, $eIleF.useSmartLinkContext)();
    const state = store ? (0, $6q0AE.getUrl)(store, url) : undefined;
    return (0, $42omo.useMemo)(()=>{
        return $9dd53b67e285af98$var$getSmartLinkAnalyticsContext({
            display: display,
            id: id,
            response: state?.details,
            source: source,
            status: state?.status,
            url: url,
            error: state?.error
        });
    }, [
        display,
        id,
        source,
        state?.details,
        state?.status,
        url,
        state?.error
    ]);
};
const $9dd53b67e285af98$export$eaff10f7ec59c455 = ({ children: children, display: display, id: id, source: source, url: url })=>{
    const { details: details, status: status, error: error } = (0, $lz9QA.useSmartCardState)(url);
    const data = $9dd53b67e285af98$var$getSmartLinkAnalyticsContext({
        display: display,
        id: id,
        response: details,
        source: source,
        status: status,
        url: url,
        error: (0, $dh538.fg)('platform_bandicoots-smartlink-unresolved-error-key') ? error : undefined
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bYRk6.default), {
        data: data
    }, children);
};
module.exports["useSmartLinkAnalyticsContext"] = $9dd53b67e285af98$export$ac28ada90c4970b7;
module.exports["SmartLinkAnalyticsContext"] = $9dd53b67e285af98$export$eaff10f7ec59c455;

});

parcelRegister("1xKpK", function(module, exports) {

var $btw9C = parcelRequire("btw9C");

const $637663634becf001$export$28ddbae335bd80b5 = (status)=>{
    return !status || status !== 'not_found' ? 'smartLink' : 'link';
};



var $dh538 = parcelRequire("dh538");

const $6804f58a391a686f$export$7243431f5325a7b = (linkDetails, details, linkStatus, error)=>{
    const status = linkStatus ?? (details && (0, $btw9C.getStatus)(details));
    const displayCategory = linkDetails.displayCategory === 'link' ? 'link' : (0, $637663634becf001$export$28ddbae335bd80b5)(status);
    return {
        status: status ?? null,
        statusDetails: details?.meta?.requestAccess?.accessType ?? null,
        displayCategory: displayCategory,
        extensionKey: (0, $dh538.fg)('platform_bandicoots-smartlink-unresolved-error-key') ? details?.meta?.key ?? error?.extensionKey ?? null : details?.meta?.key ?? null,
        destinationTenantId: details?.meta?.tenantId ?? null,
        destinationActivationId: details?.meta?.activationId ?? null,
        destinationContainerId: details?.meta?.containerId ?? null,
        destinationCategory: details?.meta?.category ?? null,
        destinationProduct: details?.meta?.product ?? null,
        destinationSubproduct: details?.meta?.subproduct ?? null,
        destinationObjectId: details?.meta?.objectId ?? null,
        destinationObjectType: details?.meta?.resourceType ?? null,
        canBeDatasource: (details?.datasources || []).length > 0
    };
};
module.exports["getResolvedAttributes"] = $6804f58a391a686f$export$7243431f5325a7b;

});

parcelRegister("6q0AE", function(module, exports) {
const $30e97e7594f3b00b$export$94df0e59ebebf4a7 = (store, url)=>{
    return store.getState()[url] || {
        status: 'pending'
    };
};
module.exports["getUrl"] = $30e97e7594f3b00b$export$94df0e59ebebf4a7;

});

parcelRegister("dLAsE", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $lgqac = parcelRequire("lgqac");

function $ff5fb1232cd87c62$export$ed70996d478e16d3() {
    /**
	 * this utility maybe extended in the future to include
	 * more contextual info about SLs
	 */ const events = (0, $42omo.useMemo)(()=>new (0, $lgqac.SmartLinkEvents)(), []);
    return events;
}
function $ff5fb1232cd87c62$export$e682245dc886cff2(firstPartyIdentifier, thirdPartyARI) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    return ()=>{
        const smartlinkClickAnalyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'smartLink',
            actionSubjectId: 'smartlinkClickAnalyticsWorkflows',
            eventType: 'ui',
            attributes: {
                eventName: 'smartLinkClickAnalyticsThirdPartyWorkflows',
                firstPartyIdentifier: firstPartyIdentifier
            },
            nonPrivacySafeAttributes: {
                thirdPartyARI: thirdPartyARI
            }
        });
        smartlinkClickAnalyticsEvent.fire('media');
    };
}
module.exports["useSmartLinkEvents"] = $ff5fb1232cd87c62$export$ed70996d478e16d3;
module.exports["useFire3PWorkflowsClickEvent"] = $ff5fb1232cd87c62$export$e682245dc886cff2;

});

parcelRegister("afp1H", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $8ae4cb49ca93b6d8$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    actions: {
        id: "fabric.linking.actions",
        defaultMessage: "Actions"
    },
    add_account: {
        id: "fabric.linking.add_account",
        defaultMessage: "Add account"
    },
    ai_summarize: {
        id: "fabric.linking.ai_summarize",
        defaultMessage: "Summarize"
    },
    ai_summarized: {
        id: "fabric.linking.ai_summarized",
        defaultMessage: "Summarized by Atlassian Intelligence"
    },
    ai_summarized_abbreviation: {
        id: "fabric.linking.ai_summarized_abbreviation",
        defaultMessage: "Summarized by AI"
    },
    ai_summarized_info: {
        id: "fabric.linking.ai_summarized_info",
        defaultMessage: "Information quality may vary. <a>Learn more</a>"
    },
    ai_summarized_info_short: {
        id: "fabric.linking.ai_summarized_info_short",
        defaultMessage: "Content quality may vary"
    },
    ai_summarizing: {
        id: "fabric.linking.ai_summarizing",
        defaultMessage: "Atlassian Intelligence is working..."
    },
    ai_summary_error_generic: {
        id: "fabric.linking.ai_summary_error_generic",
        defaultMessage: "Atlassian Intelligence (AI) isn\u2019t responding. Try again later or <a>check the status of AI</a>."
    },
    ai_summary_error_acceptable_use_violation: {
        id: "fabric.linking.ai_summary_error_acceptable_use_violation",
        defaultMessage: "We cannot show the results of this summary as it goes against <a>Atlassian's Acceptable Use Policy</a>."
    },
    ai_summary_error_hipaa_content_detected: {
        id: "fabric.linking.ai_summary_error_hipaa_content_detected",
        defaultMessage: "Atlassian Intelligence was unable to process your request as your content contains links to HIPAA restricted content."
    },
    ai_summary_error_exceeding_context_length_error: {
        id: "fabric.linking.ai_summary_error_exceeding_context_length_error",
        defaultMessage: "Atlassian Intelligence can't generate a summary for you right now as there is too much content to summarize."
    },
    assigned_to: {
        id: "fabric.linking.assigned_to",
        defaultMessage: "Assigned to {context}"
    },
    automation_action_title: {
        id: "fabric.linking.automation-action.title",
        defaultMessage: "View automation rules"
    },
    automation_action_icon_label: {
        id: "fabric.linking.automation-action.icon.label",
        defaultMessage: "Automation icon"
    },
    automation_action_tooltip: {
        id: "fabric.linking.automation-action.tooltip",
        defaultMessage: "Select an automation rule to run"
    },
    automation_action_confluence_page_modal_title: {
        id: "fabric.linking.automation-action.confluence.page.modal.title",
        defaultMessage: "Page automations"
    },
    automation_action_confluence_page_modal_description: {
        id: "fabric.linking.automation-action.confluence.page.modal.description",
        defaultMessage: "Apply an automation to <b>{name}</b>.{br}The available selections are controlled by Confluence and space administrators."
    },
    cancel: {
        id: "fabric.linking.cancel",
        defaultMessage: "Cancel"
    },
    beta: {
        id: "fabric.linking.beta",
        defaultMessage: "Beta"
    },
    cannot_connect: {
        id: "fabric.linking.cannot_connect",
        defaultMessage: "Can't connect, try again"
    },
    cannot_find_link: {
        id: "fabric.linking.cannot_find_link",
        defaultMessage: "Can't find link"
    },
    click_to_join: {
        id: "fabric.linking.click_to_join",
        defaultMessage: "Join {context}"
    },
    click_to_join_description: {
        id: "fabric.linking.click_to_join_description",
        defaultMessage: "You've been approved, so you can join {context} right away."
    },
    close: {
        id: "fabric.linking.close",
        defaultMessage: "Close"
    },
    check_this_link: {
        id: "fabric.linking.check_this_link",
        defaultMessage: "Check this link"
    },
    compass_applied_components_count: {
        id: "compass.applied_components_count.non-final",
        defaultMessage: "Applied to {numberOfComponents, plural, one {{numberOfComponents, number} component} other {{numberOfComponents, number} components}}"
    },
    connect_to: {
        id: "fabric.linking.connect_to",
        defaultMessage: "Connect to {name}"
    },
    connect_account_description: {
        id: "fabric.linking.connect_account_description",
        defaultMessage: "We'll open a new page to help you connect your {name} account"
    },
    connect_link_account: {
        id: "fabric.linking.connect_link_account",
        defaultMessage: "Connect to preview"
    },
    connect_link_account_card: {
        id: "fabric.linking.connect_link_account_card_view",
        defaultMessage: "Connect"
    },
    connect_link_account_card_name: {
        id: "fabric.linking.connect_link_account_card_view_name",
        defaultMessage: "Connect your {context} account"
    },
    connect_link_account_card_description: {
        id: "fabric.linking.connect_link_account_card_view_description",
        defaultMessage: "To show a preview of this link, connect your {context} account."
    },
    connect_unauthorised_account_action: {
        id: "fabric.linking.connect_unauthorised_account_action",
        defaultMessage: "Connect to {context}"
    },
    connect_unauthorised_account_description: {
        id: "fabric.linking.connect_unauthorised_account_description",
        defaultMessage: "Connect your {context} account to collaborate on work across Atlassian products."
    },
    connect_unauthorised_account_description_no_provider: {
        id: "fabric.linking.connect_unauthorised_account_description_no_provider",
        defaultMessage: "Connect your account to collaborate on work across Atlassian products."
    },
    experiment_connect_unauthorised_account_action: {
        id: "fabric.linking.experiment_connect_unauthorised_account_action.non-final",
        defaultMessage: "Connect {context}"
    },
    experiment_connect_link_account_card_name_title: {
        id: "fabric.linking.experiment_connect_link_account_card_name.non-final",
        defaultMessage: "Get more out of {context}"
    },
    experiment_connect_hovercard_description_1: {
        id: "fabric.linking.experiment_connect_hovercard_description_1.non-final",
        defaultMessage: "Connect your {context} account to turn simple URLs into rich, interactive previews, making it easier to collaborate and stay in context."
    },
    experiment_connect_hovercard_description_2: {
        id: "fabric.linking.experiment_connect_hovercard_description_2.non-final",
        defaultMessage: "Connect your {context} account to turn simple URLs into rich, interactive previews and unlock more AI experiences, making it easier to collaborate and stay in context."
    },
    experiment_connect_hovercard_description_3: {
        id: "fabric.linking.experiment_connect_hovercard_description_3.non-final",
        defaultMessage: "Transform ordinary URLs into rich, interactive previews of your {context} content, and unlock enhanced AI-powered features within your Atlassian apps."
    },
    continue: {
        id: "fabric.linking.continue",
        defaultMessage: "Continue"
    },
    copy_url_to_clipboard: {
        id: "fabric.linking.copy_url_to_clipboard",
        defaultMessage: "Copy link"
    },
    copied_url_to_clipboard: {
        id: "fabric.linking.copied_url_to_clipboard",
        defaultMessage: "Copied!"
    },
    could_not_load_link: {
        id: "fabric.linking.couldnt_load_link",
        defaultMessage: "We couldn't load this link for an unknown reason."
    },
    created_by: {
        id: "fabric.linking.created_by",
        defaultMessage: "Created by {context}"
    },
    created_on_relative: {
        id: "fabric.linking.create_on_relative",
        defaultMessage: "Created {context}"
    },
    created_on_absolute: {
        id: "fabric.linking.create_on_absolute",
        defaultMessage: "Created on {context}"
    },
    delete: {
        id: "fabric.linking.delete",
        defaultMessage: "Delete"
    },
    download: {
        id: "fabric.linking.download",
        defaultMessage: "Download"
    },
    download_description: {
        id: "fabric.linking.download_description",
        defaultMessage: "Download this file into your local storage"
    },
    download_file: {
        id: "fabric.linking.download_file",
        defaultMessage: "Download file"
    },
    ai_summary_action: {
        id: "fabric.linking.ai_summary_action",
        defaultMessage: "Summarize with AI"
    },
    ai_summary_action_description: {
        id: "fabric.linking.ai_summary_action_description",
        defaultMessage: "Summarize the content of this link using Atlassian Intelligence."
    },
    copy_summary_action: {
        id: "fabric.linking.copy_summary_action",
        defaultMessage: "Copy summary"
    },
    copy_summary_action_description: {
        id: "fabric.linking.copy_summary_action_description",
        defaultMessage: "Copy summary"
    },
    copied_summary_action_description: {
        id: "fabric.linking.copied_summary_action_description",
        defaultMessage: "Copied summary to clipboard"
    },
    edit: {
        id: "fabric.linking.edit",
        defaultMessage: "Edit"
    },
    follow: {
        id: "fabric.linking.follow",
        defaultMessage: "Follow"
    },
    follow_project_description: {
        id: "fabric.linking.follow_project_description",
        defaultMessage: "Follow to get notifications on this project"
    },
    follow_project: {
        id: "fabric.linking.follow_project",
        defaultMessage: "Follow project"
    },
    follow_project_error: {
        id: "fabric.linking.follow_project_error",
        defaultMessage: "We encountered an error while trying to follow the project. Check your connection or refresh the page and try again."
    },
    follow_goal_description: {
        id: "fabric.linking.follow_goal_description",
        defaultMessage: "Follow this goal to get notifications on updates"
    },
    follow_goal: {
        id: "fabric.linking.follow_goal",
        defaultMessage: "Follow goal"
    },
    follow_goal_error: {
        id: "fabric.linking.follow_goal_error",
        defaultMessage: "We encountered an error while trying to follow the goal. Check your connection or refresh the page and try again."
    },
    go_back: {
        id: "fabric.linking.go_back",
        defaultMessage: "Go back"
    },
    invalid_permissions: {
        id: "fabric.linking.invalid_permissions",
        defaultMessage: "Restricted content"
    },
    invalid_permissions_description: {
        id: "fabric.linking.invalid_permissions_description",
        defaultMessage: "You'll need to request access or try a different account to view this preview."
    },
    join_to_view: {
        id: "fabric.linking.join_to_view",
        defaultMessage: "Join {context} to view this issue"
    },
    learn_more_about_smart_links: {
        id: "fabric.linking.learn_more_about_smart_links",
        defaultMessage: "Learn more about Smart Links."
    },
    experiment_learn_more_about_smart_links: {
        id: "fabric.linking.experiment_learn_more_about_smart_links.non-final",
        defaultMessage: "Learn more about smart link security and permissions."
    },
    learn_more_about_connecting_account: {
        id: "fabric.linking.learn_more_about_connecting_account",
        defaultMessage: "Learn more about connecting your account to Atlassian products."
    },
    loading: {
        id: "fabric.linking.loading",
        defaultMessage: "Loading..."
    },
    modified_by: {
        id: "fabric.linking.updated_by",
        defaultMessage: "Modified by {context}"
    },
    modified_on_relative: {
        id: "fabric.linking.modified_on_relative",
        defaultMessage: "Updated {context}"
    },
    modified_on_absolute: {
        id: "fabric.linking.modified_on_absolute",
        defaultMessage: "Updated on {context}"
    },
    more_actions: {
        id: "fabric.linking.more_actions",
        defaultMessage: "More actions"
    },
    open_issue_in_jira: {
        id: "fabric.linking.open_issue_in_jira",
        defaultMessage: "Open issue in Jira"
    },
    open_link_in_a_new_tab: {
        id: "fabric.linking.open_link_in_a_new_tab",
        defaultMessage: "Open link in a new tab"
    },
    owned_by: {
        id: "fabric.linking.owned_by",
        defaultMessage: "Owned by {context}"
    },
    owned_by_override: {
        id: "fabric.linking.owned_by_override",
        defaultMessage: "By {context}"
    },
    preview_description: {
        id: "fabric.linking.preview_description",
        defaultMessage: "Open a full screen preview of this link"
    },
    preview_improved: {
        id: "fabric.linking.preview_improved",
        defaultMessage: "Open preview"
    },
    preview_modal: {
        id: "fabric.linking.preview_modal",
        defaultMessage: "Open preview modal"
    },
    preview_panel: {
        id: "fabric.linking.preview_panel",
        defaultMessage: "Open preview panel"
    },
    preview_close: {
        id: "fabric.linking.preview_close",
        defaultMessage: "Close preview"
    },
    preview_max_size: {
        id: "fabric.linking.preview_max_size",
        defaultMessage: "View full screen"
    },
    preview_min_size: {
        id: "fabric.linking.preview_min_size",
        defaultMessage: "Close full screen"
    },
    priority_blocker: {
        id: "fabric.linking.priority_blocker",
        defaultMessage: "Blocker"
    },
    priority_critical: {
        id: "fabric.linking.priority_critical",
        defaultMessage: "Critical"
    },
    priority_high: {
        id: "fabric.linking.priority_high",
        defaultMessage: "High"
    },
    priority_highest: {
        id: "fabric.linking.priority_highest",
        defaultMessage: "Highest"
    },
    priority_low: {
        id: "fabric.linking.priority_low",
        defaultMessage: "Low"
    },
    priority_lowest: {
        id: "fabric.linking.priority_lowest",
        defaultMessage: "Lowest"
    },
    priority_major: {
        id: "fabric.linking.priority_major",
        defaultMessage: "Major"
    },
    priority_medium: {
        id: "fabric.linking.priority_medium",
        defaultMessage: "Medium"
    },
    priority_minor: {
        id: "fabric.linking.priority_minor",
        defaultMessage: "Minor"
    },
    priority_trivial: {
        id: "fabric.linking.priority_trivial",
        defaultMessage: "Trivial"
    },
    priority_undefined: {
        id: "fabric.linking.priority_undefined",
        defaultMessage: "Undefined"
    },
    forbidden_access: {
        id: "fabric.linking.forbidden_access",
        defaultMessage: "Your access is forbidden"
    },
    pending_request: {
        id: "fabric.linking.pending_request",
        defaultMessage: "Your access request is pending"
    },
    read_time: {
        id: "fabric.linking.read_time",
        defaultMessage: "{context} min read"
    },
    restricted_link: {
        id: "fabric.linking.restricted_link",
        defaultMessage: "Restricted link, try another account"
    },
    request_access_to_view: {
        id: "fabric.linking.request_access_to_view",
        defaultMessage: "Request access to {context} to view this issue"
    },
    request_denied: {
        id: "fabric.linking.request_denied",
        defaultMessage: "Your access request was denied"
    },
    retry: {
        id: "fabric.linking.retry",
        defaultMessage: "Retry"
    },
    save: {
        id: "fabric.linking.save",
        defaultMessage: "Save"
    },
    sent_on_relative: {
        id: "fabric.linking.sent_on_relative",
        defaultMessage: "Sent {context}"
    },
    sent_on_absolute: {
        id: "fabric.linking.sent_on_absolute",
        defaultMessage: "Sent on {context}"
    },
    status_change_load_error: {
        id: "fabric.linking.status_change_load_error",
        defaultMessage: "We couldn\u2019t load the statuses and transitions"
    },
    status_change_permission_error: {
        id: "fabric.linking.status_change_permission_error",
        defaultMessage: "You don\u2019t have permission to transition this issue."
    },
    status_change_update_error: {
        id: "fabric.linking.status_change_update_error",
        defaultMessage: "We couldn\u2019t update the status"
    },
    try_again: {
        id: "fabric.linking.try_again",
        defaultMessage: "Try again"
    },
    try_another_account: {
        id: "fabric.linking.try_another_account",
        defaultMessage: "Try another account"
    },
    link_safety_warning_message: {
        id: "fabric.linking.link_safety_warning_message",
        defaultMessage: "The link {unsafeLinkText} is taking you to a different site, <a>actual link here</a>"
    },
    unauthorised_account_description: {
        id: "fabric.linking.unauthorised_account_description",
        defaultMessage: "You're trying to preview a link to a private {context} page. We recommend you review the URL or contact the page owner."
    },
    unauthorised_account_description_no_provider: {
        id: "fabric.linking.unauthorised_account_description_no_provider",
        defaultMessage: "You're trying to preview a link to a private page. We recommend you review the URL or contact the page owner."
    },
    unauthorised_account_name: {
        id: "fabric.linking.unauthorised_account_name",
        defaultMessage: "We can't display private pages from {context}"
    },
    unauthorised_account_name_no_provider: {
        id: "fabric.linking.unauthorised_account_name_no_provider",
        defaultMessage: "We can't display private pages"
    },
    unassigned: {
        id: "fabric.linking.unassigned",
        defaultMessage: "Unassigned"
    },
    unfollow: {
        id: "fabric.linking.unfollow",
        defaultMessage: "Unfollow"
    },
    unfollow_project_description: {
        id: "fabric.linking.unfollow_project_description",
        defaultMessage: "Unfollow to stop receiving project notifications"
    },
    unfollow_project: {
        id: "fabric.linking.unfollow_project",
        defaultMessage: "Unfollow project"
    },
    unfollow_project_error: {
        id: "fabric.linking.unfollow_project_error",
        defaultMessage: "We encountered an error while trying to unfollow the project. Check your connection or refresh the page and try again."
    },
    unfollow_goal_description: {
        id: "fabric.linking.unfollow_goal_description",
        defaultMessage: "Unfollow to stop receiving notifications for this goal"
    },
    unfollow_goal: {
        id: "fabric.linking.unfollow_goal",
        defaultMessage: "Unfollow goal"
    },
    unfollow_goal_error: {
        id: "fabric.linking.unfollow_goal_error",
        defaultMessage: "We encountered an error while trying to unfollow the goal. Check your connection or refresh the page and try again."
    },
    unlink_account: {
        id: "fabric.linking.unlink_account",
        defaultMessage: "Unlink Account"
    },
    view: {
        id: "fabric.linking.view",
        defaultMessage: "View"
    },
    viewIn: {
        id: "fabric.linking.srclink",
        defaultMessage: "View in"
    },
    viewOriginal: {
        id: "fabric.linking.srclinkunknown",
        defaultMessage: "View Original"
    },
    default_no_access_title: {
        id: "fabric.linking.no_access_title",
        defaultMessage: "Join {product} to view this content"
    },
    direct_access_title: {
        id: "fabric.linking.direct_access_title",
        defaultMessage: "Join {product} to view this content"
    },
    direct_access_description: {
        id: "fabric.linking.direct_access_description",
        defaultMessage: "Your team uses {product} to collaborate and you can start using it right away!"
    },
    direct_access: {
        id: "fabric.linking.direct_access",
        defaultMessage: "Join now"
    },
    request_access_description: {
        id: "fabric.linking.request_access_description",
        defaultMessage: "Your team uses {product} to collaborate. Send your admin a request for access."
    },
    request_access: {
        id: "fabric.linking.request_access",
        defaultMessage: "Request access"
    },
    request_access_pending_title: {
        id: "fabric.linking.request_access_pending_title",
        defaultMessage: "Access to {product} is pending"
    },
    request_access_pending_description: {
        id: "fabric.linking.request_access_pending_description",
        defaultMessage: "Your request to access {hostname} is awaiting admin approval."
    },
    request_access_pending: {
        id: "fabric.linking.request_access_pending",
        defaultMessage: "Pending approval"
    },
    request_denied_description: {
        id: "fabric.linking.request_denied_description",
        defaultMessage: "Your admin didn't approve your request to view {product} pages from {hostname}."
    },
    access_exists_description: {
        id: "fabric.linking.access_exists_description",
        defaultMessage: "Request access to view this content from {hostname}."
    },
    not_found_description: {
        id: "fabric.linking.not_found_description",
        defaultMessage: "The page doesn't exist or it may have changed after this link was added."
    },
    not_found_title: {
        id: "fabric.linking.not_found_title",
        defaultMessage: "We can't show you this {product} page"
    },
    forbidden_title: {
        id: "fabric.linking.forbidden_title",
        defaultMessage: "You don't have access to this content"
    },
    forbidden_description: {
        id: "fabric.linking.forbidden_description",
        defaultMessage: "Contact your admin to request access to {hostname}."
    },
    related: {
        id: "fabric.linking.related",
        defaultMessage: "Related"
    },
    generic_error_message: {
        id: "fabric.linking.generic_error_message",
        defaultMessage: "An error occurred"
    },
    related_links_modal_title: {
        id: "fabric.linking.related_links_modal_title",
        defaultMessage: "Related links"
    },
    related_links_view_related_urls: {
        id: "fabric.linking.related_links_view_related_urls",
        defaultMessage: "View recent links"
    },
    related_links_view_related_links: {
        id: "fabric.linking.related_links_view_related_links",
        defaultMessage: "View related links"
    },
    related_links_found_in: {
        id: "fabric.linking.related_links_found_in",
        defaultMessage: "Found in"
    },
    related_links_not_found: {
        id: "fabric.linking.related_links_not_found",
        defaultMessage: "We didn't find any links to show here."
    },
    related_links_includes_links_to: {
        id: "fabric.linking.related_links_includes_links_to",
        defaultMessage: "Includes links to"
    },
    related_links_modal_error_title: {
        id: "fabric.linking.related_links_modal_error_title",
        defaultMessage: "We're having trouble loading related links"
    },
    related_links_modal_unavailable_title: {
        id: "fabric.linking.related_links_modal_unavailable_title",
        defaultMessage: "We couldn't find any related links"
    },
    related_links_modal_error_description: {
        id: "fabric.linking.related_links_modal_error_description",
        defaultMessage: "Check your connection or refresh the page to try again"
    },
    related_links_modal_unavailable_description: {
        id: "fabric.linking.related_links_modal_unavailable_description",
        defaultMessage: "We continuously review and add related links for updated pages or other content types"
    },
    join_to_viewIssueTermRefresh: {
        id: "fabric.linking.join_to_view-issue-term-refresh",
        defaultMessage: "Join {context} to view this work item"
    },
    open_issue_in_jiraIssueTermRefresh: {
        id: "fabric.linking.open_issue_in_jira-issue-term-refresh",
        defaultMessage: "Open work item in Jira"
    },
    request_access_to_viewIssueTermRefresh: {
        id: "fabric.linking.request_access_to_view-issue-term-refresh",
        defaultMessage: "Request access to {context} to view this work item"
    },
    status_change_permission_errorIssueTermRefresh: {
        id: "fabric.linking.status_change_permission_error-issue-term-refresh",
        defaultMessage: "You don\u2019t have permission to transition this work item."
    },
    team_members_count: {
        id: "fabric.linking.team_members_count",
        defaultMessage: "{context} members"
    },
    user_attributes: {
        id: "fabric.linking.user_attributes",
        defaultMessage: "{context}"
    },
    follow_project_descriptionGalaxia: {
        id: "fabric.linking.follow_project_description-galaxia",
        defaultMessage: "Follow to get notifications on this space"
    },
    follow_project_errorGalaxia: {
        id: "fabric.linking.follow_project_error-galaxia",
        defaultMessage: "We encountered an error while trying to follow the space. Check your connection or refresh the page and try again."
    },
    unfollow_project_descriptionGalaxia: {
        id: "fabric.linking.unfollow_project_description-galaxia",
        defaultMessage: "Unfollow to stop receiving space notifications"
    },
    unfollow_project_errorGalaxia: {
        id: "fabric.linking.unfollow_project_error-galaxia",
        defaultMessage: "We encountered an error while trying to unfollow the space. Check your connection or refresh the page and try again."
    },
    connect_unauthorised_account_description_appify: {
        id: "fabric.linking.connect_unauthorised_account_description-appify",
        defaultMessage: "Connect your {context} account to collaborate on work across Atlassian apps."
    },
    connect_unauthorised_account_description_no_provider_appify: {
        id: "fabric.linking.connect_unauthorised_account_description_no_provider-appify",
        defaultMessage: "Connect your account to collaborate on work across Atlassian apps."
    },
    learn_more_about_connecting_account_appify: {
        id: "fabric.linking.learn_more_about_connecting_account-appify",
        defaultMessage: "Learn more about connecting your account to Atlassian apps."
    }
});
module.exports["messages"] = $8ae4cb49ca93b6d8$export$defe85febe8b728c;

});

parcelRegister("7Vxvp", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $fVUfS = parcelRequire("fVUfS");


var $aeAfU = parcelRequire("aeAfU");

const $fee91c6d88bcaa54$var$styles = {
    button: "_1e0c1bgi",
    innerContainer: "_1e0c1nu9 _1y1m1u8q _16d9qvcn _k48p1wq8 _19bv12x7 _ca0qv77o _n3tdv77o _u5f312x7 _y3gn18uv _o5721btx _1nmz9jpi",
    enabled: "_syazi7uo _80omtlke _bfhki8nm _irr3plhp _1di61gdz",
    disabled: "_syaz1gmx _80om13gf _bfhkby5v"
};
const $fee91c6d88bcaa54$var$experimentEnabledStyles = {
    control: "_syazi7uo _80omtlke _bfhki8nm _irr3plhp _1di61gdz",
    test1: "_syaz15cr _80omtlke _bfhkjmqp _qrwqlb4i _1o0zlb4i _irr31q28 _1di612kk",
    test2: "_syaz15cr _80omtlke _bfhk1i45 _qrwqlb4i _1o0zlb4i _irr3byip _1di61van"
};
const $fee91c6d88bcaa54$export$cfc7921d29ef7b80 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, isDisabled: isDisabled, viewType: viewType = 'default', ...props }, ref)=>{
    const experimentValue = viewType === 'unauthorised' ? (0, $aeAfU.expVal)('platform_inline_smartcard_connect_button_exp', 'cohort', 'control') : 'control';
    return /*#__PURE__*/ $42omo.createElement((0, $fVUfS.default), {
        ...props,
        isDisabled: isDisabled,
        ref: ref,
        // from parent component such as paragraph and heading
        style: {
            font: `inherit`
        },
        xcss: $fee91c6d88bcaa54$var$styles.button
    }, /*#__PURE__*/ $42omo.createElement("span", {
        tabIndex: isDisabled ? undefined : 0,
        className: (0, $gMc0m.default)([
            $fee91c6d88bcaa54$var$styles.innerContainer,
            isDisabled ? $fee91c6d88bcaa54$var$styles.disabled : experimentValue !== 'control' ? $fee91c6d88bcaa54$var$experimentEnabledStyles[experimentValue] : $fee91c6d88bcaa54$var$styles.enabled
        ])
    }, children));
});
module.exports["ActionButton"] = $fee91c6d88bcaa54$export$cfc7921d29ef7b80;

});

parcelRegister("aeAfU", function(module, exports) {

var $c6GJD = parcelRequire("c6GJD");


var $7Rqpr = parcelRequire("7Rqpr");


var $8ihu7 = parcelRequire("8ihu7");

function $92366aa0166a9d31$var$expValInternal({ experimentName: experimentName, experimentParam: experimentParam, defaultValue: defaultValue, fireExperimentExposure: fireExperimentExposure }) {
    const experimentConfig = (0, $7Rqpr.editorExperimentsConfig)[experimentName];
    if (experimentConfig === undefined) // Warning! If a product is improperly configured (ie. their editor packages are misaligned)
    // it can cause the editor to crash here or if the experiment does not exist.
    // We will definitely crash via any code path later in this function - this just makes the error explicit and clear.
    throw new Error(`Editor experiment configuration is not defined ${experimentName}. Likely the experiment does not exist or editor package versions are misaligned`);
    // @ts-ignore need to loosen the type here to allow for any experiment name
    if ((0, $8ihu7._overrides)[experimentName] !== undefined) // This will be hit in the case of a test setting an override
    // @ts-ignore need to loosen the type here to allow for any experiment name
    return (0, $8ihu7._overrides)[experimentName];
    // Check for parameter overrides
    const paramOverride = (0, $8ihu7._paramOverrides)[experimentName]?.[experimentParam];
    if (paramOverride !== undefined) return paramOverride;
    // If client is not initialized, we return the default value
    if (!(0, $c6GJD.default).initializeCompleted()) return defaultValue;
    if (!(0, $8ihu7._product)) // This will be hit in the case of a product not having setup the editor experiment tooling
    return defaultValue;
    // Typescript is complaining here about accessing the productKeys property
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const experimentKey = experimentConfig?.productKeys?.[0, $8ihu7._product];
    if (!experimentKey) // This will be hit in the case of an experiment not being set up for the product
    return defaultValue;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $c6GJD.default).getExperimentValue(experimentName, experimentParam, defaultValue, {
        fireExperimentExposure: fireExperimentExposure
    });
    return experimentValue;
}
function $92366aa0166a9d31$export$9db1624a8af791a4(experimentName, experimentParam, defaultValue) {
    return $92366aa0166a9d31$var$expValInternal({
        experimentName: experimentName,
        experimentParam: experimentParam,
        defaultValue: defaultValue,
        fireExperimentExposure: true
    });
}
function $92366aa0166a9d31$export$94f132839aec533f(experimentName, experimentParam, defaultValue) {
    return $92366aa0166a9d31$var$expValInternal({
        experimentName: experimentName,
        experimentParam: experimentParam,
        defaultValue: defaultValue,
        fireExperimentExposure: false
    });
}
module.exports["expVal"] = $92366aa0166a9d31$export$9db1624a8af791a4;
module.exports["expValNoExposure"] = $92366aa0166a9d31$export$94f132839aec533f;

});

parcelRegister("l3dur", function(module, exports) {
/**
 * This file has been partially duplicated in packages/editor/adf-schema/src/utils/url.ts
 * Any changes made here should be mirrored there until the duplicate behaviour is resolved
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $2Gb84 = parcelRequire("2Gb84");

const $8a7492fb362aaff8$var$linkify = (0, (/*@__PURE__*/$parcel$interopDefault($2Gb84)))();
$8a7492fb362aaff8$var$linkify.add('sourcetree:', 'http:');
$8a7492fb362aaff8$var$linkify.add('jamfselfservice:', 'http:');
$8a7492fb362aaff8$var$linkify.add('notes:', 'http:');
const $8a7492fb362aaff8$var$tlds = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
const $8a7492fb362aaff8$var$tlds2Char = 'a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
$8a7492fb362aaff8$var$tlds.push($8a7492fb362aaff8$var$tlds2Char);
$8a7492fb362aaff8$var$linkify.tlds($8a7492fb362aaff8$var$tlds, false);
const $8a7492fb362aaff8$var$whitelistedURLPatterns = [
    /^https?:\/\/[^\s]*$/im,
    /^ftps?:\/\//im,
    /^gopher:\/\//im,
    /^integrity:\/\//im,
    /^file:\/\//im,
    /^smb:\/\//im,
    /^dynamicsnav:\/\//im,
    /^jamfselfservice:\/\/[^\s]*$/im,
    /^\//im,
    /^mailto:/im,
    /^skype:/im,
    /^callto:[^\s]*$/im,
    /^facetime:[^\s]*$/im,
    /^git:/im,
    /^irc6?:/im,
    /^news:/im,
    /^nntp:/im,
    /^feed:/im,
    /^cvs:/im,
    /^svn:/im,
    /^mvn:/im,
    /^ssh:/im,
    /^scp:\/\//im,
    /^sftp:\/\//im,
    /^itms:/im,
    // This is not a valid notes link, but we support this pattern for backwards compatibility
    /^notes:/im,
    /^notes:\/\//im,
    /^hipchat:\/\//im,
    /^sourcetree:/im,
    /^urn:/im,
    /^tel:/im,
    /^xmpp:/im,
    /^telnet:/im,
    /^vnc:/im,
    /^rdp:/im,
    /^whatsapp:/im,
    /^slack:/im,
    /^sips?:/im,
    /^magnet:/im,
    /^foo:/im,
    /^#/im
];
const $8a7492fb362aaff8$var$normaliseLinkHref = (url)=>{
    const match = $8a7492fb362aaff8$var$getLinkMatch(url);
    return match && match.url || null;
};
const $8a7492fb362aaff8$var$getLinkMatch = (str)=>{
    if (!str) return null;
    let match = $8a7492fb362aaff8$var$linkifyMatch(str);
    if (!match.length) match = $8a7492fb362aaff8$var$linkify.match(str);
    return match && match.length > 0 && match[0].index === 0 && match[0].lastIndex === str.trim().length ? match[0] : null;
};
const $8a7492fb362aaff8$var$LINK_REGEXP = /(https?|ftp|jamfselfservice|gopher|dynamicsnav|integrity|file|smb):\/\/[^\s]+/;
const $8a7492fb362aaff8$var$linkifyMatch = (text)=>{
    const matches = [];
    if (!$8a7492fb362aaff8$var$LINK_REGEXP.test(text)) return matches;
    let startpos = 0;
    let substr;
    while(substr = text.substr(startpos)){
        const link = (substr.match($8a7492fb362aaff8$var$LINK_REGEXP) || [
            ''
        ])[0];
        if (link) {
            const index = substr.search($8a7492fb362aaff8$var$LINK_REGEXP);
            const start = index >= 0 ? index + startpos : index;
            const end = start + link.length;
            matches.push({
                index: start,
                lastIndex: end,
                raw: link,
                url: link,
                text: link,
                schema: ''
            });
            startpos += end;
        } else break;
    }
    return matches;
};
const $8a7492fb362aaff8$export$c9f92f5469372e0f = (url)=>{
    const urlTrimmed = url.trim();
    return $8a7492fb362aaff8$var$whitelistedURLPatterns.some((p)=>p.test(urlTrimmed));
};
function $8a7492fb362aaff8$export$6535eb414fa2c8b6(url) {
    if (!url) return '';
    const urlWithoutNewlines = url.replace(/[\r\n]+/g, '');
    if ($8a7492fb362aaff8$export$c9f92f5469372e0f(urlWithoutNewlines)) return urlWithoutNewlines.trim();
    return $8a7492fb362aaff8$var$normaliseLinkHref(urlWithoutNewlines);
}
module.exports["isSafeUrl"] = $8a7492fb362aaff8$export$c9f92f5469372e0f;
module.exports["normalizeUrl"] = $8a7492fb362aaff8$export$6535eb414fa2c8b6;

});

parcelRegister("2Gb84", function(module, exports) {
'use strict';
////////////////////////////////////////////////////////////////////////////////
// Helpers
// Merge objects
//
function $1f38230d0a1b4a0b$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $1f38230d0a1b4a0b$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $1f38230d0a1b4a0b$var$isString(obj) {
    return $1f38230d0a1b4a0b$var$_class(obj) === '[object String]';
}
function $1f38230d0a1b4a0b$var$isObject(obj) {
    return $1f38230d0a1b4a0b$var$_class(obj) === '[object Object]';
}
function $1f38230d0a1b4a0b$var$isRegExp(obj) {
    return $1f38230d0a1b4a0b$var$_class(obj) === '[object RegExp]';
}
function $1f38230d0a1b4a0b$var$isFunction(obj) {
    return $1f38230d0a1b4a0b$var$_class(obj) === '[object Function]';
}
function $1f38230d0a1b4a0b$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
}
////////////////////////////////////////////////////////////////////////////////
var $1f38230d0a1b4a0b$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $1f38230d0a1b4a0b$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        return acc || $1f38230d0a1b4a0b$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
var $1f38230d0a1b4a0b$var$defaultSchemas = {
    'http:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp('^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i');
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    'https:': 'http:',
    'ftp:': 'http:',
    '//': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp('^' + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ':') return 0;
                if (pos >= 3 && text[pos - 3] === '/') return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    'mailto:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp('^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i');
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
/*eslint-disable max-len*/ // RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var $1f38230d0a1b4a0b$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var $1f38230d0a1b4a0b$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
/*eslint-enable max-len*/ ////////////////////////////////////////////////////////////////////////////////
function $1f38230d0a1b4a0b$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = '';
}
function $1f38230d0a1b4a0b$var$createValidator(re) {
    return function(text, pos) {
        var tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $1f38230d0a1b4a0b$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}

// Schemas compiler. Build regexps.
//
function $1f38230d0a1b4a0b$var$compile(self) {
    // Load & clone RE patterns.
    var re = self.re = (parcelRequire("aGmGa"))(self.__opts__);
    // Define dynamic patterns
    var tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($1f38230d0a1b4a0b$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join('|');
    function untpl(tpl) {
        return tpl.replace('%TLDS%', re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
    //
    // Compile each schema
    //
    var aliases = [];
    self.__compiled__ = {}; // Reset compiled data
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        var val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        var compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($1f38230d0a1b4a0b$var$isObject(val)) {
            if ($1f38230d0a1b4a0b$var$isRegExp(val.validate)) compiled.validate = $1f38230d0a1b4a0b$var$createValidator(val.validate);
            else if ($1f38230d0a1b4a0b$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($1f38230d0a1b4a0b$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $1f38230d0a1b4a0b$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($1f38230d0a1b4a0b$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[''] = {
        validate: null,
        normalize: $1f38230d0a1b4a0b$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    var slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($1f38230d0a1b4a0b$var$escapeRE).join('|');
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
    self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');
    self.re.pretest = RegExp('(' + self.re.schema_test.source + ')|(' + self.re.host_fuzzy_test.source + ')|@', 'i');
    //
    // Cleanup
    //
    $1f38230d0a1b4a0b$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $1f38230d0a1b4a0b$var$Match(self, shift) {
    var start = self.__index__, end = self.__last_index__, text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $1f38230d0a1b4a0b$var$createMatch(self, shift) {
    var match = new $1f38230d0a1b4a0b$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $1f38230d0a1b4a0b$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $1f38230d0a1b4a0b$var$LinkifyIt)) return new $1f38230d0a1b4a0b$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($1f38230d0a1b4a0b$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $1f38230d0a1b4a0b$var$assign({}, $1f38230d0a1b4a0b$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1; // Next scan position
    this.__schema__ = '';
    this.__text_cache__ = '';
    this.__schemas__ = $1f38230d0a1b4a0b$var$assign({}, $1f38230d0a1b4a0b$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $1f38230d0a1b4a0b$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $1f38230d0a1b4a0b$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $1f38230d0a1b4a0b$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $1f38230d0a1b4a0b$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $1f38230d0a1b4a0b$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $1f38230d0a1b4a0b$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $1f38230d0a1b4a0b$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    var m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = '';
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
        // guess schemaless emails
        at_pos = text.indexOf('@');
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = 'mailto:';
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $1f38230d0a1b4a0b$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $1f38230d0a1b4a0b$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $1f38230d0a1b4a0b$var$LinkifyIt.prototype.match = function match(text) {
    var shift = 0, result = [];
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($1f38230d0a1b4a0b$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    var tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($1f38230d0a1b4a0b$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $1f38230d0a1b4a0b$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $1f38230d0a1b4a0b$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $1f38230d0a1b4a0b$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $1f38230d0a1b4a0b$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = 'http://' + match.url;
    if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = 'mailto:' + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $1f38230d0a1b4a0b$var$LinkifyIt.prototype.onCompile = function onCompile() {};
module.exports = $1f38230d0a1b4a0b$var$LinkifyIt;

});

parcelRegister("aGmGa", function(module, exports) {
'use strict';




module.exports = function(opts) {
    var re = {};
    // Use direct extract instead of `regenerate` to reduse browserified size
    re.src_Any = (parcelRequire("6gKKW")).source;
    re.src_Cc = (parcelRequire("7wkNx")).source;
    re.src_Z = (parcelRequire("4QTDX")).source;
    re.src_P = (parcelRequire("eSMp5")).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join('|');
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join('|');
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    var text_separators = '[><\uff5c]';
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    ////////////////////////////////////////////////////////////////////////////////
    re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';
    re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
    re.src_host_terminator = '(?=$|' + text_separators + '|' + re.src_ZPCc + ')(?!-|_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-;]).|' + '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' + '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' + '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + '|[-]).|' + // allow `I'm_king` if no pair found
    '\\.{2,}[a-zA-Z0-9%/&]|' + // google has many dots in "google search" links (#66, #81).
    // github has ... in commit range links,
    // Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // - params separator
    // until more examples found.
    '\\.(?!' + re.src_ZCc + '|[.]).|' + (opts && opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
     : '\\-+|') + ',(?!' + re.src_ZCc + ').|' + // allow `,,,` in paths
    ';(?!' + re.src_ZCc + ').|' + // allow `;` if not followed by space-like char
    '\\!+(?!' + re.src_ZCc + '|[!]).|' + // allow `!!!` in paths, but not at the end
    '\\?(?!' + re.src_ZCc + '|[?]).' + ')+' + '|\\/' + ')?';
    // Allow anything in markdown spec, forbid quote (") at the first position
    // because emails enclosed in quotes are far more common
    re.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*';
    re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    '(?:' + re.src_xn + '|' + re.src_pseudo_letter + '{1,63}' + ')';
    re.src_domain = '(?:' + re.src_xn + '|' + '(?:' + re.src_pseudo_letter + ')' + '|' + '(?:' + re.src_pseudo_letter + '(?:-|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' + ')';
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ')\\.)*' + re.src_domain /*_root*/  + ')' + ')';
    re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' + ')';
    re.tpl_host_no_ip_fuzzy = '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    ////////////////////////////////////////////////////////////////////////////////
    // Main rules
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = 'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
    re.tpl_email_fuzzy = '(^|' + text_separators + '|"|\\(|' + re.src_ZCc + ')' + '(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
    return re;
};

});

parcelRegister("iS6Uy", function(module, exports) {
// This import will be stripped on build
/**
 * This takes an adf hex color and returns a matching text palette color.
 *
 * By providing a design token, this enables ADF content to be rendered in new themes such as dark mode.
 *
 * Example usage
 * ```tsx
 * const cssValue = hexToTextPaletteColor('#0747A6');
 * //     ^? const cssValue: string
 * <span style={{textColor: cssValue}} />
 * ```
 * The names of tokens can change over time, and the values of tokens will differ between themes.
 * The exact output of this function is an implementation detail and should only be used when rendering
 * content to the user, on a client with a matching major version of `@atlaskit/tokens`.
 * - **DO NOT**: store the output of these functions in any user-generated content or back-end.
 * - **DO**: store the ADF hex color, and use these utilities at render time to display the themed version of the color
 */ function $874fb90bacae98d1$export$9c2f408d391feb93(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    return $874fb90bacae98d1$export$57fa5089caad992[hexColor.toUpperCase()];
}
const $874fb90bacae98d1$export$57fa5089caad992 = {
    // blue
    /** blue - light */ ['#B3D4FF']: "var(--ds-background-accent-blue-subtler, #B3D4FF)",
    // source for hex code was legacy token B75
    /** blue - medium */ ['#4C9AFF']: "var(--ds-icon-accent-blue, #4C9AFF)",
    // source for hex code was legacy token B100
    /** blue - strong */ ['#0747A6']: "var(--ds-text-accent-blue, #0747A6)",
    // source for hex code was legacy token B500
    // teal
    /** teal - light */ ['#B3F5FF']: "var(--ds-background-accent-teal-subtler, #B3F5FF)",
    // source for hex code was legacy token T75
    /** teal - medium */ ['#00B8D9']: "var(--ds-icon-accent-teal, #00B8D9)",
    // source for hex code was legacy token T300
    /** teal - strong */ ['#008DA6']: "var(--ds-text-accent-teal, #008DA6)",
    // source for hex code was legacy token T500
    // green
    /** green - light */ ['#ABF5D1']: "var(--ds-background-accent-green-subtler, #ABF5D1)",
    // source for hex code was legacy token G75
    /** green - medium */ ['#36B37E']: "var(--ds-icon-accent-green, #36B37E)",
    // source for hex code was legacy token G300
    /** green - strong */ ['#006644']: "var(--ds-text-accent-green, #006644)",
    // source for hex code was legacy token G500
    // yellowOrange
    /** yellowOrange - light */ ['#FFF0B3']: "var(--ds-background-accent-yellow-subtler, #FFF0B3)",
    // source for hex code was legacy token Y75
    /** yellowOrange - medium */ ['#FFC400']: "var(--ds-background-accent-orange-subtle, #FFC400)",
    // source for hex code was legacy token Y200
    /** yellowOrange - strong */ ['#FF991F']: "var(--ds-icon-accent-orange, #FF991F)",
    // source for hex code was legacy token Y400
    // red
    /** red - light */ ['#FFBDAD']: "var(--ds-background-accent-red-subtler, #FFBDAD)",
    // source for hex code was legacy token R75
    /** red - medium */ ['#FF5630']: "var(--ds-icon-accent-red, #FF5630)",
    // source for hex code was legacy token R300
    /** red - strong */ ['#BF2600']: "var(--ds-text-accent-red, #BF2600)",
    // source for hex code was legacy token R500
    // purple
    /** purple - light */ ['#EAE6FF']: "var(--ds-background-accent-purple-subtler, #EAE6FF)",
    // source for hex code was legacy token P50
    /** purple - medium */ ['#6554C0']: "var(--ds-icon-accent-purple, #6554C0)",
    // source for hex code was legacy token P300
    /** purple - strong */ ['#403294']: "var(--ds-text-accent-purple, #403294)",
    // source for hex code was legacy token P500
    // whiteGray
    /** whiteGray - light */ ['#FFFFFF']: "var(--ds-text-inverse, #FFFFFF)",
    // source for hex code was legacy token N0
    /** whiteGray - medium */ ['#97A0AF']: "var(--ds-icon-accent-gray, #97A0AF)",
    // source for hex code was legacy token N80
    /** whiteGray - strong */ ['#172B4D']: "var(--ds-text, #172B4D)" // source for hex code was legacy token N800
};
module.exports["hexToEditorTextPaletteColor"] = $874fb90bacae98d1$export$9c2f408d391feb93;

});

parcelRegister("bWiTS", function(module, exports) {

var $1oCLl = parcelRequire("1oCLl");

const $9d897280e134968c$export$12a518ff137dd389 = {
    /** Gray - light */ ['#DCDFE4']: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
    /** Teal - light */ ['#C6EDFB']: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    /** Lime - light */ ['#D3F1A7']: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    /** Yellow - light */ ['#F8E6A0']: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
    /** Orange - light */ ['#FEDEC8']: "var(--ds-background-accent-orange-subtler, #FEDEC8)",
    /** Magenta - light */ ['#FDD0EC']: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    /** Purple - light */ ['#DFD8FD']: "var(--ds-background-accent-purple-subtler, #DFD8FD)"
};
function $9d897280e134968c$export$8b58ff1b36bb75e0(hexColor) {
    if (!(0, $1oCLl.expValEquals)('platform_editor_add_orange_highlight_color', 'cohort', 'test')) // @ts-expect-error Expect type error. Will modify production type
    // if experiment proceeds post-results.
    $9d897280e134968c$export$12a518ff137dd389['#FEDEC8'] = "var(--ds-background-accent-yellow-subtler, #F8E6A0)";
    // Ts ignore was used to allow use of conditional return type
    // (preferring better type on consumption over safety in implementation)
    // @ts-ignore
    return $9d897280e134968c$export$12a518ff137dd389[hexColor.toUpperCase()];
}
module.exports["hexToEditorTextBackgroundPaletteColor"] = $9d897280e134968c$export$8b58ff1b36bb75e0;

});

parcelRegister("lf9Ji", function(module, exports) {
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $1UrkW = parcelRequire("1UrkW");


var $1LHXq = parcelRequire("1LHXq");

var $dDZcC = parcelRequire("dDZcC");


var $d925B = parcelRequire("d925B");


var $juTiU = parcelRequire("juTiU");

var $6aq5c = parcelRequire("6aq5c");


var $bSXAs = parcelRequire("bSXAs");


var $dh538 = parcelRequire("dh538");


var $2XqLN = parcelRequire("2XqLN");


var $59U23 = parcelRequire("59U23");


var $lWghV = parcelRequire("lWghV");

var $kOYZR = parcelRequire("kOYZR");







const $ac4164d5be644112$var$rendersMap = {};
const $ac4164d5be644112$var$processLevelsAndTrack = (item, thresholds, dispatchAnalyticsEvent)=>{
    try {
        const { severity: severity, percentage: percentage, counts: { supportedNodes: supportedNodes, unsupportedNodes: unsupportedNodes, unsupportedNodeTypeCount: unsupportedNodeTypeCount } } = (0, $kOYZR.getUnsupportedContentLevelData)(item.doc, thresholds);
        dispatchAnalyticsEvent({
            action: (0, $d925B.ACTION).UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).RENDERER,
            attributes: {
                appearance: (0, $lWghV.getAnalyticsAppearance)(item.appearance),
                platform: (0, $59U23.PLATFORM).WEB,
                unsupportedContentLevelSeverity: severity,
                unsupportedContentLevelPercentage: percentage,
                unsupportedNodesCount: unsupportedNodes,
                supportedNodesCount: supportedNodes,
                unsupportedNodeTypeCount: unsupportedNodeTypeCount
            },
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
        });
    } catch (err) {
        dispatchAnalyticsEvent({
            action: (0, $d925B.ACTION).UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).RENDERER,
            attributes: {
                platform: (0, $59U23.PLATFORM).WEB,
                error: err instanceof Error ? err.message : String(err)
            },
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
        });
    }
};
const $ac4164d5be644112$var$schedule = (fn)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (typeof window.requestIdleCallback === 'function') // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.requestIdleCallback(fn);
    else setTimeout(fn, 0);
};
const $ac4164d5be644112$var$DEFAULT_SAMPLING_RATE = 100;
const $ac4164d5be644112$export$a43de96edd8d0a0 = (item, trackingOptions, dispatchAnalyticsEvent)=>{
    const { thresholds: thresholds, samplingRates: samplingRates } = trackingOptions;
    const appearance = item.appearance ?? 'unknown';
    if (!$ac4164d5be644112$var$rendersMap[appearance]) $ac4164d5be644112$var$rendersMap[appearance] = new Set();
    // bail out if already processed a render from a given renderer instance
    const didProcessRenderer = $ac4164d5be644112$var$rendersMap[appearance].has(item.rendererId);
    if (didProcessRenderer) return;
    // otherwise track the render
    $ac4164d5be644112$var$rendersMap[appearance].add(item.rendererId);
    const sampleRate = samplingRates && samplingRates[appearance] || $ac4164d5be644112$var$DEFAULT_SAMPLING_RATE;
    // sample from the first available tracked render
    if ($ac4164d5be644112$var$rendersMap[appearance].size === 1) $ac4164d5be644112$var$schedule(()=>$ac4164d5be644112$var$processLevelsAndTrack(item, thresholds, dispatchAnalyticsEvent));
    // cleanup/refresh tracked renders at the sampling rate
    if ($ac4164d5be644112$var$rendersMap[appearance].size % sampleRate === 0) $ac4164d5be644112$var$rendersMap[appearance] = new Set();
};



var $1Qaul = parcelRequire("1Qaul");

const $bb293804104002a3$var$SUPPORTS_HIRES_TIMER_API = !!(typeof window !== 'undefined' && window.performance && performance.now);
const $bb293804104002a3$var$withStopwatch = (cb)=>{
    const startTime = $bb293804104002a3$var$SUPPORTS_HIRES_TIMER_API ? performance.now() : Date.now();
    const output = cb();
    const endTime = $bb293804104002a3$var$SUPPORTS_HIRES_TIMER_API ? performance.now() : Date.now();
    const time = endTime - startTime;
    return {
        output: output,
        time: time
    };
};
const $bb293804104002a3$var$_validation = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
doc, schema, adfStage, useSpecBasedValidator, dispatchAnalyticsEvent, skipValidation, validationOverrides)=>{
    let result;
    if (useSpecBasedValidator) {
        // link mark on mediaSingle is deprecated, need to move link mark to child media node
        // https://product-fabric.atlassian.net/browse/ED-14043
        const { transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $1LHXq.transformMediaLinkMarks)(doc);
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $d925B.ACTION).MEDIA_LINK_TRANSFORMED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).RENDERER,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
        });
        result = skipValidation ? transformedAdf || doc : (0, $6aq5c.validateADFEntity)(schema, transformedAdf || doc, dispatchAnalyticsEvent, validationOverrides);
    } else result = (0, $bSXAs.getValidDocument)(doc, schema, adfStage);
    if (!result) return result;
    // ProseMirror always require a child under doc
    if (result.type === 'doc' && useSpecBasedValidator) {
        if (Array.isArray(result.content) && result.content.length === 0) result.content.push({
            type: 'paragraph',
            content: []
        });
        // Just making sure doc is always valid
        if (!result.version) result.version = 1;
    }
    // Convert nested-table extensions into nested tables
    try {
        const { transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $dDZcC.transformNestedTablesIncomingDocument)(result);
        if (isTransformed) {
            dispatchAnalyticsEvent?.({
                action: (0, $d925B.ACTION).NESTED_TABLE_TRANSFORMED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).RENDERER,
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
            });
            result = transformedAdf;
        }
    } catch (e) {
        dispatchAnalyticsEvent?.({
            action: (0, $d925B.ACTION).INVALID_PROSEMIRROR_DOCUMENT,
            actionSubject: (0, $d925B.ACTION_SUBJECT).RENDERER,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
            attributes: {
                platform: (0, $59U23.PLATFORM).WEB,
                errorStack: `${e instanceof Error && e.name === 'NodeNestingTransformError' ? 'NodeNestingTransformError - Failed to encode one or more nested tables' : undefined}`
            }
        });
    }
    return result;
};
const $bb293804104002a3$var$memoValidation = (0, $2XqLN.default)($bb293804104002a3$var$_validation, (newArgs, lastArgs)=>{
    const [newDoc, newSchema, newADFStage, newUseSpecValidator, , /* ignoring dispatchAnalyticsEvent */ newSkipValidation, newValidationOverrides] = newArgs;
    const [oldDoc, oldSchema, oldADFStage, oldUseSpecValidator, , /* ignoring dispatchAnalyticsEvent */ oldSkipValidation, oldValidationOverrides] = lastArgs;
    return $bb293804104002a3$var$areDocsEqual(newDoc, oldDoc) && newSchema === oldSchema && newADFStage === oldADFStage && newUseSpecValidator === oldUseSpecValidator && newSkipValidation === oldSkipValidation && newValidationOverrides === oldValidationOverrides;
});
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bb293804104002a3$var$areDocsEqual = (docA, docB)=>{
    if (docA === docB) return true;
    if (typeof docA === 'string' && typeof docB === 'string') return docA === docB;
    // PMNode
    if (docA.type && docA.toJSON && docB.type && docB.toJSON) return JSON.stringify(docA.toJSON()) === JSON.stringify(docB.toJSON());
    // Object
    return JSON.stringify(docA) === JSON.stringify(docB);
};
const $bb293804104002a3$var$_serializeFragment = (serializer, doc)=>{
    return serializer.serializeFragment(doc.content);
};
const $bb293804104002a3$var$memoSerializeFragment = (0, $2XqLN.default)($bb293804104002a3$var$_serializeFragment, (newArgs, lastArgs)=>{
    const [newSerializer, newDoc] = newArgs;
    const [oldSerializer, oldDoc] = lastArgs;
    return newSerializer === oldSerializer && $bb293804104002a3$var$areDocsEqual(newDoc, oldDoc);
});
const $bb293804104002a3$var$_createNodeAndCheck = (schema, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
doc, dispatchAnalyticsEvent)=>{
    const pmNode = schema.nodeFromJSON(doc);
    try {
        pmNode.check();
    } catch (err) {
        if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $d925B.ACTION).INVALID_PROSEMIRROR_DOCUMENT,
            actionSubject: (0, $d925B.ACTION_SUBJECT).RENDERER,
            attributes: {
                platform: (0, $59U23.PLATFORM).WEB,
                errorStack: err instanceof Error ? err.message : String(err)
            },
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
        });
    }
    return pmNode;
};
const $bb293804104002a3$var$memoCreateNodeAndCheck = (0, $2XqLN.default)($bb293804104002a3$var$_createNodeAndCheck, (newArgs, lastArgs)=>{
    // ignore dispatchAnalyticsEvent
    const [newSchema, newDoc] = newArgs;
    const [oldSchema, oldDoc] = lastArgs;
    return newSchema === oldSchema && $bb293804104002a3$var$areDocsEqual(newDoc, oldDoc);
});
const $bb293804104002a3$export$59a54f98b9753d5c = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
doc, serializer, schema = (0, $1UrkW.defaultSchema), adfStage = 'final', useSpecBasedValidator = false, rendererId = 'noid', dispatchAnalyticsEvent, unsupportedContentLevelsTracking, appearance, includeNodesCountInStats, skipValidation, validationOverrides)=>{
    const stat = {
        sanitizeTime: 0
    };
    if ((0, $dh538.fg)('platform_editor_renderer_rm_usespecbasedvalidator')) useSpecBasedValidator = true;
    const { output: validDoc, time: sanitizeTime } = $bb293804104002a3$var$withStopwatch(()=>{
        return $bb293804104002a3$var$memoValidation(doc, schema, adfStage, useSpecBasedValidator, dispatchAnalyticsEvent, skipValidation, validationOverrides);
    });
    // save sanitize time to stats
    stat.sanitizeTime = sanitizeTime;
    if (!validDoc) return {
        stat: stat,
        result: null
    };
    const { output: node, time: buildTreeTime } = $bb293804104002a3$var$withStopwatch(()=>{
        return $bb293804104002a3$var$memoCreateNodeAndCheck(schema, validDoc, dispatchAnalyticsEvent);
    });
    // save build tree time to stats
    stat.buildTreeTime = buildTreeTime;
    const { output: result, time: serializeTime } = $bb293804104002a3$var$withStopwatch(()=>{
        return $bb293804104002a3$var$memoSerializeFragment(serializer, node);
    });
    // save serialize tree time to stats
    stat.serializeTime = serializeTime;
    if (dispatchAnalyticsEvent && useSpecBasedValidator) {
        (0, $juTiU.findAndTrackUnsupportedContentNodes)(node, schema, dispatchAnalyticsEvent);
        if (unsupportedContentLevelsTracking?.enabled) {
            const documentData = {
                doc: validDoc,
                appearance: appearance,
                rendererId: rendererId
            };
            (0, $ac4164d5be644112$export$a43de96edd8d0a0)(documentData, unsupportedContentLevelsTracking, dispatchAnalyticsEvent);
        }
    }
    if (includeNodesCountInStats) stat.nodesCount = (0, $1Qaul.countNodes)(doc);
    return {
        result: result,
        stat: stat,
        pmDoc: node
    };
};
module.exports["renderDocument"] = $bb293804104002a3$export$59a54f98b9753d5c;

});

parcelRegister("kOYZR", function(module, exports) {

var $6jPem = parcelRequire("6jPem");

var $c9985f9e1fc7d853$export$6632e71a22d31bf1 = /*#__PURE__*/ function(UNSUPPORTED_CONTENT_LEVEL_SEVERITY) {
    UNSUPPORTED_CONTENT_LEVEL_SEVERITY["NORMAL"] = "normal";
    UNSUPPORTED_CONTENT_LEVEL_SEVERITY["DEGRADED"] = "degraded";
    UNSUPPORTED_CONTENT_LEVEL_SEVERITY["BLOCKING"] = "blocking";
    return UNSUPPORTED_CONTENT_LEVEL_SEVERITY;
}({});
const $c9985f9e1fc7d853$export$f9f8a29778652c3e = {
    DEGRADED: 10,
    BLOCKING: 25
};
const $c9985f9e1fc7d853$var$buildUnsupportedContentLevelThresholds = (customThresholds)=>{
    return {
        degraded: customThresholds?.degraded || $c9985f9e1fc7d853$export$f9f8a29778652c3e.DEGRADED,
        blocking: customThresholds?.blocking || $c9985f9e1fc7d853$export$f9f8a29778652c3e.BLOCKING
    };
};
const $c9985f9e1fc7d853$var$countSupportedUnsupportedNodes = (validDocument)=>{
    let unsupportedNodes = 0;
    let supportedNodes = 0;
    const unsupportedNodeTypeCount = {};
    const unsupportedNodeTypes = [
        'unsupportedInline',
        'unsupportedBlock',
        'confluenceUnsupportedInline',
        'confluenceUnsupportedBlock'
    ];
    (0, $6jPem.traverse)(validDocument, {
        any: (node)=>{
            if (unsupportedNodeTypes.includes(node.type)) {
                const originalNode = node.attrs?.originalValue;
                if (originalNode) // start an independent traversal for the purpose of counting
                // unsupported content nodes (with nested children contributing towards
                // that count)
                (0, $6jPem.traverse)(originalNode, {
                    any: (unsupportedNode, parent)=>{
                        unsupportedNodes++;
                        // Count the types of unsupported nodes
                        const parentType = parent.parent?.node?.type ?? 'unknown';
                        const type = `${parentType}/${unsupportedNode?.type ?? 'unknown'}`;
                        unsupportedNodeTypeCount[type] = (unsupportedNodeTypeCount?.[type] ?? 0) + 1;
                    }
                });
                // force the parent traversal (which is counting supported content nodes)
                // to skip traversal/counting of nested children of the unsupported nodes
                return false;
            } else supportedNodes++;
        }
    });
    return {
        unsupportedNodes: unsupportedNodes,
        supportedNodes: supportedNodes,
        unsupportedNodeTypeCount: unsupportedNodeTypeCount
    };
};
const $c9985f9e1fc7d853$var$mapUnsupportedContentLevelToSeverity = (unsupportedContentLevelPercent, thresholds)=>{
    if (thresholds.degraded <= unsupportedContentLevelPercent && unsupportedContentLevelPercent < thresholds.blocking) return "degraded";
    if (thresholds.blocking <= unsupportedContentLevelPercent) return "blocking";
    return "normal";
};
const $c9985f9e1fc7d853$export$484b83e0462998d = (validDocument, customThresholds)=>{
    const { unsupportedNodes: unsupportedNodes, supportedNodes: supportedNodes, unsupportedNodeTypeCount: unsupportedNodeTypeCount } = $c9985f9e1fc7d853$var$countSupportedUnsupportedNodes(validDocument);
    const thresholds = $c9985f9e1fc7d853$var$buildUnsupportedContentLevelThresholds(customThresholds);
    const percentage = Math.round(unsupportedNodes / (unsupportedNodes + supportedNodes) * 100);
    const severity = $c9985f9e1fc7d853$var$mapUnsupportedContentLevelToSeverity(percentage, thresholds);
    return {
        severity: severity,
        percentage: percentage,
        counts: {
            supportedNodes: supportedNodes,
            unsupportedNodes: unsupportedNodes,
            unsupportedNodeTypeCount: unsupportedNodeTypeCount
        }
    };
};
module.exports["getUnsupportedContentLevelData"] = $c9985f9e1fc7d853$export$484b83e0462998d;

});

parcelRegister("1A9t2", function(module, exports) {

var $6jPem = parcelRequire("6jPem");

function $6d2a4e7dc7af02b0$export$533b26079ad0b4b(adf, callback, initial) {
    let result = initial;
    (0, $6jPem.traverse)(adf, {
        any: (node)=>{
            result = callback(result, node);
        }
    });
    return result;
}
module.exports["reduce"] = $6d2a4e7dc7af02b0$export$533b26079ad0b4b;

});

parcelRegister("3rvSa", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $grxv4 = parcelRequire("grxv4");

const $1c0162128aea5b38$export$ba5d7212f2b4619f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(undefined);
const $1c0162128aea5b38$export$5bff351c86f56d97 = ({ children: children, clientConfig: clientConfig })=>{
    const mediaClient = (0, $42omo.useMemo)(()=>(0, $grxv4.getMediaClient)(clientConfig), [
        clientConfig
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($1c0162128aea5b38$export$ba5d7212f2b4619f.Provider, {
        value: mediaClient,
        children: children
    });
};
module.exports["MediaClientContext"] = $1c0162128aea5b38$export$ba5d7212f2b4619f;
module.exports["MediaClientProvider"] = $1c0162128aea5b38$export$5bff351c86f56d97;

});

parcelRegister("9KIOh", function(module, exports) {
$parcel$export(module.exports, "ActiveHeaderIdProvider", () => $b77f3940744feba2$export$20439b49fdd0d26c);

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const { Provider: $b77f3940744feba2$export$20439b49fdd0d26c, Consumer: $b77f3940744feba2$var$Consumer } = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(undefined);
/**
 * We need to expose this abstraction on top of the native Consumer in order to control when
 * The consumer will get notified when a match has happened. If we use the Consumer directly in
 * Expand components without this inner state, everytime a new prop comes in, and the `newActiveHeaderId`
 * is the same as before, we will set the expand to true forever, until the active header id changes.
 * Thus, the user won't be able to collapse the expand.
 *
 * By exposing `onNestedHeaderIdMatch` here we can control when will consumers be notified:
 * only when a `newActiveHeaderId` comes in from the Provider and the list of header ids includes it.
 */ const $b77f3940744feba2$export$cddc3c6ebe2d2cec = ({ nestedHeaderIds: nestedHeaderIds, onNestedHeaderIdMatch: onNestedHeaderIdMatch })=>{
    const [activeHeaderId, setActiveHeaderId] = (0, $42omo.useState)();
    return /*#__PURE__*/ (0, $l998X.jsx)($b77f3940744feba2$var$Consumer, {
        children: (newActiveHeaderId)=>{
            if (!newActiveHeaderId || !nestedHeaderIds.includes(newActiveHeaderId)) setActiveHeaderId(undefined);
            else if (newActiveHeaderId !== activeHeaderId && nestedHeaderIds.includes(newActiveHeaderId)) {
                setActiveHeaderId(newActiveHeaderId);
                onNestedHeaderIdMatch();
            }
            return null;
        }
    });
};
module.exports["ActiveHeaderIdConsumer"] = $b77f3940744feba2$export$cddc3c6ebe2d2cec;

});

parcelRegister("jTudT", function(module, exports) {
const $6167473ae8c2b69b$export$7a6526d4be3b7eb3 = 'media-file-card-view';
const $6167473ae8c2b69b$export$1b2a6cb6a124ba37 = 'media-file-card-view-selected';
module.exports["fileCardImageViewSelector"] = $6167473ae8c2b69b$export$7a6526d4be3b7eb3;

});

parcelRegister("ozLJl", function(module, exports) {
/**
 * Classname for the media viewer popup that appears adjacent to the editor div. Use this to check
 * if the media viewer has appeared.
 */ const $7c537b76f301caad$export$42c8d07e41ed1e74 = 'media-viewer-popup';
module.exports["mediaViewerPopupClass"] = $7c537b76f301caad$export$42c8d07e41ed1e74;

});

parcelRegister("fhm10", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");


var $5gVJx = parcelRequire("5gVJx");

const $d6d0bc28331ae132$export$dd2e16f83ae6aa78 = 'media-inline-image-wrapper';
const $d6d0bc28331ae132$export$7ab34e219ce6eef = '--editor-media-inline-image-aspect-ratio';
const $d6d0bc28331ae132$export$263a8a844c370a89 = '--editor-media-inline-image-border-size';
const $d6d0bc28331ae132$export$b0d1f1e1fb3c4b46 = '--editor-media-inline-image-border-color';
// We implemented such selectors to ensure specificity:
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Nested and dynamic css calls are violations, needs manual remediation
const $d6d0bc28331ae132$var$inlineImageHeight = (height, margin = 0)=>/*#__PURE__*/ (0, $9K4OG.css)(">.mediaInlineView-content-wrap>.", $d6d0bc28331ae132$export$dd2e16f83ae6aa78, ",>:is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap>.", $d6d0bc28331ae132$export$dd2e16f83ae6aa78, ",>.", $d6d0bc28331ae132$export$dd2e16f83ae6aa78, ",>:is(a, span[data-mark-type='border']) .", $d6d0bc28331ae132$export$dd2e16f83ae6aa78, "{height:", height, "px;transform:translateY(", margin, "px);}");
const $d6d0bc28331ae132$export$dee15762144889b7 = /*#__PURE__*/ (0, $9K4OG.css)(".", $d6d0bc28331ae132$export$dd2e16f83ae6aa78, "{height:", (0, $5gVJx.referenceHeights)['p'], "px;transform:translateY(-2px);}h1{", $d6d0bc28331ae132$var$inlineImageHeight((0, $5gVJx.referenceHeights)['h1'], -3), ";}h2{", $d6d0bc28331ae132$var$inlineImageHeight((0, $5gVJx.referenceHeights)['h2'], -3), ";}h3{", $d6d0bc28331ae132$var$inlineImageHeight((0, $5gVJx.referenceHeights)['h3'], -2), ";}h4{", $d6d0bc28331ae132$var$inlineImageHeight((0, $5gVJx.referenceHeights)['h4'], -2), ";}h5{", $d6d0bc28331ae132$var$inlineImageHeight((0, $5gVJx.referenceHeights)['h5'], -2), ";}h6{", $d6d0bc28331ae132$var$inlineImageHeight((0, $5gVJx.referenceHeights)['h6'], -2), ";}");
const $d6d0bc28331ae132$export$c4d4f06a25de97f = /*#__PURE__*/ (0, $9K4OG.css)({
    display: 'inline-flex',
    cursor: 'pointer',
    justifyContent: 'center',
    alignItems: 'center',
    verticalAlign: 'middle',
    overflow: 'hidden',
    borderRadius: `${"var(--ds-radius-small, 3px)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    aspectRatio: `var(${$d6d0bc28331ae132$export$7ab34e219ce6eef}, ${(0, $5gVJx.DEFAULT_INLINE_IMAGE_ASPECT_RATIO)})`,
    maxWidth: '100%'
});
const $d6d0bc28331ae132$export$a7abb1b3dc25813f = /*#__PURE__*/ (0, $9K4OG.css)({
    boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #1868DB)"}`,
    outline: 'none'
});
const $d6d0bc28331ae132$export$4d0a7f76ad443516 = /*#__PURE__*/ (0, $9K4OG.css)({
    borderColor: `var(${$d6d0bc28331ae132$export$b0d1f1e1fb3c4b46})`,
    borderStyle: 'solid',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `calc(var(${$d6d0bc28331ae132$export$263a8a844c370a89}, ${(0, $5gVJx.DEFAULT_INLINE_IMAGE_BORDER_SIZE)}) * 2px)`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderWidth: `calc(var(${$d6d0bc28331ae132$export$263a8a844c370a89}, ${(0, $5gVJx.DEFAULT_INLINE_IMAGE_BORDER_SIZE)}) * 1px)`,
    boxSizing: `border-box`
});
module.exports["INLINE_IMAGE_WRAPPER_CLASS_NAME"] = $d6d0bc28331ae132$export$dd2e16f83ae6aa78;
module.exports["INLINE_IMAGE_ASPECT_RATIO_CSS_VAR_KEY"] = $d6d0bc28331ae132$export$7ab34e219ce6eef;
module.exports["INLINE_IMAGE_BORDER_SIZE_CSS_VAR_KEY"] = $d6d0bc28331ae132$export$263a8a844c370a89;
module.exports["INLINE_IMAGE_BORDER_COLOR_CSS_VAR_KEY"] = $d6d0bc28331ae132$export$b0d1f1e1fb3c4b46;
module.exports["wrapperStyle"] = $d6d0bc28331ae132$export$c4d4f06a25de97f;
module.exports["selectedStyle"] = $d6d0bc28331ae132$export$a7abb1b3dc25813f;
module.exports["borderStyle"] = $d6d0bc28331ae132$export$4d0a7f76ad443516;

});

parcelRegister("5gVJx", function(module, exports) {
const $34d61841b825d2c8$export$d722b7527b1834a8 = 250;
const $34d61841b825d2c8$export$da894f7669b4e67c = 200;
const $34d61841b825d2c8$export$286cf28b87ad4b4f = $34d61841b825d2c8$export$d722b7527b1834a8 / $34d61841b825d2c8$export$da894f7669b4e67c;
const $34d61841b825d2c8$export$64fe09732fb8680 = 0;
const $34d61841b825d2c8$export$c1317a9224e4d798 = {
    p: 22,
    h1: 36,
    h2: 31,
    h3: 25,
    h4: 23,
    h5: 20,
    h6: 18
};
module.exports["DEFAULT_IMAGE_WIDTH"] = $34d61841b825d2c8$export$d722b7527b1834a8;
module.exports["DEFAULT_IMAGE_HEIGHT"] = $34d61841b825d2c8$export$da894f7669b4e67c;
module.exports["DEFAULT_INLINE_IMAGE_ASPECT_RATIO"] = $34d61841b825d2c8$export$286cf28b87ad4b4f;
module.exports["DEFAULT_INLINE_IMAGE_BORDER_SIZE"] = $34d61841b825d2c8$export$64fe09732fb8680;
module.exports["referenceHeights"] = $34d61841b825d2c8$export$c1317a9224e4d798;

});

parcelRegister("7bDsi", function(module, exports) {
const $2d87519b5d393b3d$export$99cdf122d0bb9f95 = {
    DATE_WRAPPER: `date-lozenger-container`,
    DATE_CONTAINER: 'dateView-content-wrap'
};
module.exports["DateSharedCssClassName"] = $2d87519b5d393b3d$export$99cdf122d0bb9f95;

});

parcelRegister("gnMzP", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");


var $aFUXX = parcelRequire("aFUXX");

const $1a978e7ea9233092$export$cfe6da7d522d87bb = 'rich-media-item';
const $1a978e7ea9233092$var$wrappedMediaBreakoutPoint = 410;
const $1a978e7ea9233092$export$d031611b96ba4cf0 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`li .${$1a978e7ea9233092$export$cfe6da7d522d87bb}`]: {
        margin: 0
    },
    // Hack for chrome to fix media single position inside a list when media is the first child
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-chrome li > .mediaSingleView-content-wrap::before': {
        content: "''",
        display: 'block',
        height: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-firefox': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.mediaSingleView-content-wrap': {
            userSelect: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.captionView-content-wrap': {
            userSelect: 'text'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    ".mediaSingleView-content-wrap[layout='center']": {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`table .${$1a978e7ea9233092$export$cfe6da7d522d87bb}`]: {
        marginTop: "var(--ds-space-150, 12px)",
        marginBottom: "var(--ds-space-150, 12px)",
        clear: 'both',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&.image-wrap-left[data-layout], &.image-wrap-right[data-layout]': {
            clear: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '&:first-child': {
                marginTop: "var(--ds-space-150, 12px)"
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$1a978e7ea9233092$export$cfe6da7d522d87bb}.image-wrap-right + .${$1a978e7ea9233092$export$cfe6da7d522d87bb}.image-wrap-left`]: {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$1a978e7ea9233092$export$cfe6da7d522d87bb}.image-wrap-left + .${$1a978e7ea9233092$export$cfe6da7d522d87bb}.image-wrap-right, .${$1a978e7ea9233092$export$cfe6da7d522d87bb}.image-wrap-right + .${$1a978e7ea9233092$export$cfe6da7d522d87bb}.image-wrap-left, .${$1a978e7ea9233092$export$cfe6da7d522d87bb}.image-wrap-left + .${$1a978e7ea9233092$export$cfe6da7d522d87bb}.image-wrap-left, .${$1a978e7ea9233092$export$cfe6da7d522d87bb}.image-wrap-right + .${$1a978e7ea9233092$export$cfe6da7d522d87bb}.image-wrap-right`]: {
        marginRight: 0,
        marginLeft: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`@media all and (max-width: ${$1a978e7ea9233092$var$wrappedMediaBreakoutPoint}px)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "div.mediaSingleView-content-wrap[layout='wrap-left'], div.mediaSingleView-content-wrap[data-layout='wrap-left'], div.mediaSingleView-content-wrap[layout='wrap-right'], div.mediaSingleView-content-wrap[data-layout='wrap-right']": {
            float: 'none',
            overflow: 'auto',
            margin: `${"var(--ds-space-150, 12px)"} 0`
        }
    }
});
const $1a978e7ea9233092$export$b51dea84d928a378 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`li .${$1a978e7ea9233092$export$cfe6da7d522d87bb}`]: {
        margin: 0
    },
    // Hack for chrome to fix media single position inside a list when media is the first child
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-chrome li > .mediaSingleView-content-wrap::before': {
        content: "''",
        display: 'block',
        height: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-firefox': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.mediaSingleView-content-wrap': {
            userSelect: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.captionView-content-wrap': {
            userSelect: 'text'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ".mediaSingleView-content-wrap[layout^='wrap-']": {
        position: 'relative',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        zIndex: (0, $aFUXX.akEditorWrappedNodeZIndex)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    ".mediaSingleView-content-wrap[layout='center']": {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`table .${$1a978e7ea9233092$export$cfe6da7d522d87bb}`]: {
        marginTop: "var(--ds-space-150, 12px)",
        marginBottom: "var(--ds-space-150, 12px)",
        clear: 'both',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&.image-wrap-left[data-layout], &.image-wrap-right[data-layout]': {
            clear: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '&:first-child': {
                marginTop: "var(--ds-space-150, 12px)"
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$1a978e7ea9233092$export$cfe6da7d522d87bb}.image-wrap-right + .${$1a978e7ea9233092$export$cfe6da7d522d87bb}.image-wrap-left`]: {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$1a978e7ea9233092$export$cfe6da7d522d87bb}.image-wrap-left + .${$1a978e7ea9233092$export$cfe6da7d522d87bb}.image-wrap-right, .${$1a978e7ea9233092$export$cfe6da7d522d87bb}.image-wrap-right + .${$1a978e7ea9233092$export$cfe6da7d522d87bb}.image-wrap-left, .${$1a978e7ea9233092$export$cfe6da7d522d87bb}.image-wrap-left + .${$1a978e7ea9233092$export$cfe6da7d522d87bb}.image-wrap-left, .${$1a978e7ea9233092$export$cfe6da7d522d87bb}.image-wrap-right + .${$1a978e7ea9233092$export$cfe6da7d522d87bb}.image-wrap-right`]: {
        marginRight: 0,
        marginLeft: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`@media all and (max-width: ${$1a978e7ea9233092$var$wrappedMediaBreakoutPoint}px)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "div.mediaSingleView-content-wrap[layout='wrap-left'], div.mediaSingleView-content-wrap[data-layout='wrap-left'], div.mediaSingleView-content-wrap[layout='wrap-right'], div.mediaSingleView-content-wrap[data-layout='wrap-right']": {
            float: 'none',
            overflow: 'auto',
            margin: `${"var(--ds-space-150, 12px)"} 0`
        }
    }
});
module.exports["richMediaClassName"] = $1a978e7ea9233092$export$cfe6da7d522d87bb;

});

parcelRegister("cV5SN", function(module, exports) {
const $2775743fdfdf82a1$export$4ccd31bf665a88f6 = {
    INLINE_CARD_CONTAINER: 'inlineCardView-content-wrap',
    BLOCK_CARD_CONTAINER: 'blockCardView-content-wrap',
    EMBED_CARD_CONTAINER: 'embedCardView-content-wrap',
    DATASOURCE_CONTAINER: 'datasourceView-content-wrap',
    LOADER_WRAPPER: 'loader-wrapper'
};
module.exports["SmartCardSharedCssClassName"] = $2775743fdfdf82a1$export$4ccd31bf665a88f6;

});

parcelRegister("7iisy", function(module, exports) {
const $d23ce9b4e7735d18$export$a7172b75d403a0e4 = {
    DECISION_CONTAINER: 'decisionItemView-content-wrap',
    TASK_CONTAINER: 'taskItemView-content-wrap',
    //NOTE: value is a selector (data attribute), not a class name
    TASK_LIST_CONTAINER: '[data-node-type="actionList]',
    TASK_ITEM: 'task-item',
    TASK_CHECKBOX_CONTAINER: 'task-item-checkbox-wrap'
};
module.exports["TaskDecisionSharedCssClassName"] = $d23ce9b4e7735d18$export$a7172b75d403a0e4;

});

parcelRegister("j2w4t", function(module, exports) {
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $aFUXX = parcelRequire("aFUXX");

var $kPuBV = parcelRequire("kPuBV");


var $5MaNT = parcelRequire("5MaNT");


var $1tRSs = parcelRequire("1tRSs");


var $jVL42 = parcelRequire("jVL42");

const $223f15bdc9399d28$var$codeBlockSharedStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    [`.${(0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPED}
		> .${(0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER}
		> .${(0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT}`]: {
        marginRight: "var(--ds-space-100, 8px)",
        code: {
            display: 'block',
            wordBreak: 'break-word',
            whiteSpace: 'pre-wrap'
        }
    },
    [`.${(0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER}
		> .${(0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT}`]: {
        display: 'flex',
        flex: 1,
        code: {
            flexGrow: 1,
            whiteSpace: 'pre'
        }
    },
    [`.${(0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER}`]: {
        position: 'relative',
        backgroundColor: "var(--ds-surface-raised, #FFFFFF)",
        borderRadius: "var(--ds-radius-small, 3px)",
        margin: `${(0, $aFUXX.blockNodesVerticalMargin)} 0 0 0`,
        fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
        minWidth: `${(0, $aFUXX.akEditorTableCellMinWidth)}px`,
        cursor: 'pointer',
        clear: 'both',
        '--ds--code--bg-color': 'transparent',
        '.code-block-gutter-pseudo-element::before': {
            content: '"attr(data-label)"'
        },
        /* This is necessary to allow for arrow key navigation in/out of code blocks in Firefox. */ whiteSpace: 'normal',
        [`.${(0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_START}`]: {
            position: 'absolute',
            visibility: 'hidden',
            height: '1.5rem',
            top: '0px',
            left: '0px'
        },
        [`${(0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_END}`]: {
            position: 'absolute',
            visibility: 'hidden',
            height: '1.5rem',
            bottom: '0px',
            right: '0px'
        },
        [`.${(0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER}`]: {
            position: 'relative',
            backgroundColor: "var(--ds-background-neutral, #0515240F)",
            display: 'flex',
            borderRadius: "var(--ds-radius-small, 3px)",
            width: '100%',
            counterReset: 'line',
            overflowX: 'auto',
            backgroundImage: 'var(--ak-renderer-codeblock-content-wrapper-bg-img)',
            backgroundRepeat: 'no-repeat',
            backgroundAttachment: 'local, local, local, local, scroll, scroll, scroll, scroll',
            backgroundSize: `${"var(--ds-space-300, 24px)"} 100%,
				${"var(--ds-space-300, 24px)"} 100%,
				${"var(--ds-space-100, 8px)"} 100%,
				${"var(--ds-space-100, 8px)"} 100%,
				${"var(--ds-space-100, 8px)"} 100%,
				1px 100%,
				${"var(--ds-space-100, 8px)"} 100%,
				1px 100%`,
            backgroundPosition: `0 0,
				0 0,
				100% 0,
				100% 0,
				100% 0,
				100% 0,
				0 0,
				0 0`,
            /* Be careful if refactoring this; it is needed to keep arrow key navigation in Firefox consistent with other browsers. */ overflowY: 'hidden'
        },
        [`.${(0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER}`]: {
            backgroundColor: "var(--ds-background-neutral, #0515240F)",
            position: 'relative',
            width: 'var(--lineNumberGutterWidth, 2rem)',
            padding: "var(--ds-space-100, 8px)",
            flexShrink: 0,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: `${0.875}rem`,
            boxSizing: 'content-box'
        },
        // This is a fix of marker of list item with code block.
        // The list item marker in Chrome is aligned by the baseline of the text,
        // that's why we need to add a text (content: "1") to the line number gutter to align
        // the list item marker with the text.
        // Without it, the list item marker will be aligned by the bottom of the code block.
        [`.${(0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER}::before`]: {
            content: '"1"',
            visibility: 'hidden',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: `${0.875}rem`,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: '1.5rem'
        },
        [`.${(0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT}`]: {
            code: {
                tabSize: 4,
                cursor: 'text',
                color: "var(--ds-text, #292A2E)",
                borderRadius: "var(--ds-radius-small, 3px)",
                margin: "var(--ds-space-100, 8px)",
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                fontSize: `${0.875}rem`,
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                lineHeight: '1.5rem'
            }
        },
        [`.${(0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER_LINE_NUMBER_WIDGET}`]: {
            pointerEvents: 'none',
            userSelect: 'none',
            width: 'var(--lineNumberGutterWidth, 2rem)',
            left: 0,
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: `${0.875}rem`,
            padding: `0px ${"var(--ds-space-100, 8px)"}`,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: '1.5rem',
            textAlign: 'right',
            color: "var(--ds-text-subtlest, #505F79)",
            boxSizing: 'content-box'
        }
    }
});
const $223f15bdc9399d28$var$lightWeightCodeBlockStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    [`.${(0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER}`]: {
        cursor: 'text'
    }
});
const $223f15bdc9399d28$export$afbde0e7339bed51 = {
    CONTAINER: 'light-weight-code-block'
};
const $223f15bdc9399d28$export$3f1ff491ca7c4c4a = ()=>{
    // We overwrite the rule that clears margin-top for first nested codeblocks, as
    // our lightweight codeblock dom structure will always nest the codeblock inside
    // an extra container div which would constantly be targeted. Now, top-level
    // lightweight codeblock containers will not be targeted.
    // NOTE: This must be added after other .code-block styles in the root
    // Renderer stylesheet.
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    return /*#__PURE__*/ (0, $9K4OG.css)(".", (0, $jVL42.RendererCssClassName).DOCUMENT, ">.", $223f15bdc9399d28$export$afbde0e7339bed51.CONTAINER, " .", (0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER, "{margin-top:", (0, $aFUXX.blockNodesVerticalMargin), ";}");
};
const $223f15bdc9399d28$var$LightWeightCodeBlock = /*#__PURE__*/ (0, $42omo.forwardRef)(({ text: text, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, className: className }, ref)=>{
    const textRows = (0, $42omo.useMemo)(()=>(text ?? '').split('\n'), [
        text
    ]);
    const { renderBidiWarnings: renderBidiWarnings } = (0, $1tRSs.useBidiWarnings)({
        enableWarningTooltip: codeBidiWarningTooltipEnabled
    });
    const classNames = [
        $223f15bdc9399d28$export$afbde0e7339bed51.CONTAINER,
        className
    ].join(' ');
    const codeBlockBackgroundImage = (0, $kPuBV.overflowShadow)({
        leftCoverWidth: "var(--ds-space-300, 24px)"
    });
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: classNames,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $223f15bdc9399d28$var$codeBlockSharedStyles,
            $223f15bdc9399d28$var$lightWeightCodeBlockStyles
        ],
        style: {
            '--ak-renderer-codeblock-content-wrapper-bg-img': codeBlockBackgroundImage
        }
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        className: (0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER
    }, textRows.map((_, index)=>// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            key: index
        }))), /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        className: (0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("code", null, renderBidiWarnings(text))))));
});
var $223f15bdc9399d28$export$2e2bcd8739ae039 = $223f15bdc9399d28$var$LightWeightCodeBlock;
module.exports["LightWeightCodeBlockCssClassName"] = $223f15bdc9399d28$export$afbde0e7339bed51;
module.exports["default"] = $223f15bdc9399d28$export$2e2bcd8739ae039;

});

parcelRegister("1tRSs", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $g7Pc3 = parcelRequire("g7Pc3");


var $7Rcde = parcelRequire("7Rcde");


var $03WRT = parcelRequire("03WRT");


var $1oCLl = parcelRequire("1oCLl");

const $1ac1bf4a86d18ce4$export$9fb9fe546a188c7b = ({ enableWarningTooltip: enableWarningTooltip = true })=>{
    const intl = (0, $8C5kA.default)();
    const warningLabel = intl.formatMessage((0, $7Rcde.codeBidiWarningMessages).label);
    const renderBidiWarnings = (text)=>{
        if ((0, $1oCLl.expValEquals)('platform_editor_remove_bidi_char_warning', 'isEnabled', true)) return text;
        return (0, $03WRT.default)(text, ({ bidiCharacter: bidiCharacter, index: index })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $g7Pc3.default), {
                bidiCharacter: bidiCharacter,
                label: warningLabel,
                tooltipEnabled: enableWarningTooltip
            }, index));
    };
    return {
        renderBidiWarnings: renderBidiWarnings,
        warningLabel: warningLabel
    };
};
module.exports["useBidiWarnings"] = $1ac1bf4a86d18ce4$export$9fb9fe546a188c7b;

});

parcelRegister("ilPbq", function(module, exports) {

var $dh538 = parcelRequire("dh538");

const $9202133f4d3acb51$export$4a3637dc6e2ae29e = {
    'editor.font.heading.h1': 'normal 500 1.71429em/1.16667 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h2': 'normal 500 1.42857em/1.2 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h3': 'normal 600 1.14286em/1.25 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h4': 'normal 600 1em/1.14286 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h5': 'normal 600 0.857143em/1.33333 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h6': 'normal 700 0.785714em/1.45455 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.body': 'normal 400 1em/1.714 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.weight.heading.h1.bold': '700',
    'editor.font.weight.heading.h2.bold': '700',
    'editor.font.weight.heading.h3.bold': '700',
    'editor.font.weight.heading.h4.bold': '700',
    'editor.font.weight.heading.h5.bold': '700',
    'editor.font.weight.heading.h6.bold': '700'
};
const $9202133f4d3acb51$export$95588e746468319e = {
    'editor.font.heading.h1': 'normal 600 1.71429em/1.16667 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h2': 'normal 600 1.42857em/1.2 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h3': 'normal 600 1.14286em/1.25 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h4': 'normal 600  1em/1.14286 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h5': 'normal 600  0.857143em/1.33333 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h6': 'normal 600 0.785714em/1.45455 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.body': 'normal 400 1em/1.714 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.weight.heading.h1.bold': '700',
    'editor.font.weight.heading.h2.bold': '700',
    'editor.font.weight.heading.h3.bold': '700',
    'editor.font.weight.heading.h4.bold': '700',
    'editor.font.weight.heading.h5.bold': '700',
    'editor.font.weight.heading.h6.bold': '700'
};
const $9202133f4d3acb51$export$63adc0ebe3278d31 = {
    'editor.font.heading.h1': 'normal 600 1.71429em/1.16667 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h2': 'normal 600 1.42857em/1.2 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h3': 'normal 600 1.14286em/1.25 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h4': 'normal 600 1em/1.14286 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h5': 'normal 600 0.857143em/1.33333 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h6': 'normal 600 0.785714em/1.45455 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.body': 'normal 400 1em/1.714 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.weight.heading.h1.bold': '700',
    'editor.font.weight.heading.h2.bold': '700',
    'editor.font.weight.heading.h3.bold': '700',
    'editor.font.weight.heading.h4.bold': '700',
    'editor.font.weight.heading.h5.bold': '700',
    'editor.font.weight.heading.h6.bold': '700'
};


function $cf904c6b16edcd21$var$editorUGCToken(path) {
    let tokens;
    if ((0, $dh538.fg)('platform_editor_typography_ugc')) tokens = (0, $9202133f4d3acb51$export$63adc0ebe3278d31);
    else tokens = (0, $9202133f4d3acb51$export$4a3637dc6e2ae29e);
    return tokens[path];
}
var $cf904c6b16edcd21$export$2e2bcd8739ae039 = $cf904c6b16edcd21$var$editorUGCToken;
module.exports["default"] = $cf904c6b16edcd21$export$2e2bcd8739ae039;

});

parcelRegister("eauJy", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $5e9b251857e7eb9b$export$60d741e20e0aa309 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(undefined);
function $5e9b251857e7eb9b$export$b1072f43c67b540c(props) {
    const portalFromContext = (0, $42omo.useContext)($5e9b251857e7eb9b$export$60d741e20e0aa309);
    return props?.portal || portalFromContext;
}
module.exports["PortalContext"] = $5e9b251857e7eb9b$export$60d741e20e0aa309;
module.exports["usePortal"] = $5e9b251857e7eb9b$export$b1072f43c67b540c;

});

parcelRegister("e2wMq", function(module, exports) {
var $c8d6368806133d17$export$a8d23193462f2b63 = /*#__PURE__*/ function(PLATFORMS) {
    PLATFORMS["NATIVE"] = "mobileNative";
    PLATFORMS["HYBRID"] = "mobileHybrid";
    PLATFORMS["WEB"] = "web";
    return PLATFORMS;
}({});
var $c8d6368806133d17$export$e48589d9e4824227 = /*#__PURE__*/ function(MODE) {
    MODE["RENDERER"] = "renderer";
    MODE["EDITOR"] = "editor";
    return MODE;
}({});
var $c8d6368806133d17$export$57453495b81e2dde = /*#__PURE__*/ function(FULL_WIDTH_MODE) {
    FULL_WIDTH_MODE["FIXED_WIDTH"] = "fixedWidth";
    FULL_WIDTH_MODE["FULL_WIDTH"] = "fullWidth";
    return FULL_WIDTH_MODE;
}({});
var $c8d6368806133d17$export$60a219cfaef9722 = /*#__PURE__*/ function(BROWSER_FREEZE_INTERACTION_TYPE) {
    BROWSER_FREEZE_INTERACTION_TYPE["LOADING"] = "loading";
    BROWSER_FREEZE_INTERACTION_TYPE["TYPING"] = "typing";
    BROWSER_FREEZE_INTERACTION_TYPE["CLICKING"] = "clicking";
    BROWSER_FREEZE_INTERACTION_TYPE["PASTING"] = "pasting";
    return BROWSER_FREEZE_INTERACTION_TYPE;
}({});
module.exports["PLATFORMS"] = $c8d6368806133d17$export$a8d23193462f2b63;
module.exports["MODE"] = $c8d6368806133d17$export$e48589d9e4824227;
module.exports["FULL_WIDTH_MODE"] = $c8d6368806133d17$export$57453495b81e2dde;
module.exports["BROWSER_FREEZE_INTERACTION_TYPE"] = $c8d6368806133d17$export$60a219cfaef9722;

});

parcelRegister("3824I", function(module, exports) {
var $fa05b1e32f887e46$export$1627223e090990cf = /*#__PURE__*/ function(TABLE_ACTION) {
    TABLE_ACTION["DELETED"] = "deleted";
    TABLE_ACTION["CLEARED"] = "cleared";
    TABLE_ACTION["COLLAPSED"] = "collapsed";
    TABLE_ACTION["MERGED"] = "merged";
    TABLE_ACTION["SPLIT"] = "split";
    TABLE_ACTION["COLORED"] = "colored";
    TABLE_ACTION["TOGGLED_HEADER_COLUMN"] = "toggledHeaderColumn";
    TABLE_ACTION["TOGGLED_HEADER_ROW"] = "toggledHeaderRow";
    TABLE_ACTION["TOGGLED_NUMBER_COLUMN"] = "toggledNumberColumn";
    TABLE_ACTION["CHANGED_BREAKOUT_MODE"] = "changedBreakoutMode";
    TABLE_ACTION["CUT"] = "cut";
    TABLE_ACTION["COPIED"] = "copied";
    TABLE_ACTION["ADDED_ROW"] = "addedRow";
    TABLE_ACTION["ADDED_COLUMN"] = "addedColumn";
    TABLE_ACTION["DELETED_ROW"] = "deletedRow";
    TABLE_ACTION["DELETED_COLUMN"] = "deletedColumn";
    TABLE_ACTION["SORTED_COLUMN"] = "sortedColumn";
    TABLE_ACTION["REPLACED"] = "replaced";
    TABLE_ACTION["ATTEMPTED_TABLE_WIDTH_CHANGE"] = "attemptedTableWidthChange";
    TABLE_ACTION["DISTRIBUTED_COLUMNS_WIDTHS"] = "distributedColumnsWidths";
    TABLE_ACTION["FIXED"] = "fixed";
    TABLE_ACTION["RESIZED"] = "resized";
    TABLE_ACTION["RESIZE_PERF_SAMPLING"] = "resizePerfSampling";
    TABLE_ACTION["COLUMN_RESIZED"] = "columnResized";
    TABLE_ACTION["OVERFLOW_CHANGED"] = "overflowChanged";
    TABLE_ACTION["INITIAL_OVERFLOW_CAPTURED"] = "initialOverflowCaptured";
    TABLE_ACTION["MOVED_ROW"] = "movedRow";
    TABLE_ACTION["MOVED_COLUMN"] = "movedColumn";
    TABLE_ACTION["CLONED_ROW"] = "clonedRow";
    TABLE_ACTION["CLONED_COLUMN"] = "clonedColumn";
    /**
	 * This is a unique action that's used to track legacy table move behaviour flow of insert+copy+paste. Please use
	 * the MOVED_ROW | MOVED_COLUMN actions if you want to track events which move row/cols in a single step.
	 */ TABLE_ACTION["ROW_OR_COLUMN_MOVED"] = "rowOrColumnMoved";
    TABLE_ACTION["CHANGED_DISPLAY_MODE"] = "changedDisplayMode";
    TABLE_ACTION["CHANGED_ALIGNMENT"] = "changedAlignment";
    // Temporary to track usage of CONFCLOUD-78239 bug
    TABLE_ACTION["TABLE_CELL_BACKGROUND_FIXED"] = "tableCellBackgroundFixed";
    TABLE_ACTION["TABLE_WIDTH_INFO"] = "tableWidthInformation";
    TABLE_ACTION["TABLE_EDITOR_HEIGHT_INFO"] = "tableEditorHeightInformation";
    TABLE_ACTION["TABLE_RENDERER_HEIGHT_INFO"] = "tableRendererHeightInformation";
    return TABLE_ACTION;
}({});
var $fa05b1e32f887e46$export$6b0804bad09b61c6 = /*#__PURE__*/ function(TABLE_BREAKOUT) {
    TABLE_BREAKOUT["WIDE"] = "wide";
    TABLE_BREAKOUT["FULL_WIDTH"] = "fullWidth";
    TABLE_BREAKOUT["NORMAL"] = "normal";
    return TABLE_BREAKOUT;
}({});
var $fa05b1e32f887e46$export$e0b2ad636c1c8ab4 = /*#__PURE__*/ function(TABLE_OVERFLOW_CHANGE_TRIGGER) {
    TABLE_OVERFLOW_CHANGE_TRIGGER["EXTERNAL"] = "external";
    TABLE_OVERFLOW_CHANGE_TRIGGER["ADDED_COLUMN"] = "addedColumn";
    TABLE_OVERFLOW_CHANGE_TRIGGER["DELETED_COLUMN"] = "deletedColumn";
    TABLE_OVERFLOW_CHANGE_TRIGGER["RESIZED_COLUMN"] = "resizedColumn";
    TABLE_OVERFLOW_CHANGE_TRIGGER["ENABLED_NUMBERED_COLUMN"] = "enabledNumberedColumn";
    TABLE_OVERFLOW_CHANGE_TRIGGER["DISABLED_NUMBERED_COLUMN"] = "disabledNumberedColumn";
    TABLE_OVERFLOW_CHANGE_TRIGGER["DISTRIBUTED_COLUMNS"] = "distributedColumnsWidths";
    TABLE_OVERFLOW_CHANGE_TRIGGER["RESIZED"] = "resizedTable";
    return TABLE_OVERFLOW_CHANGE_TRIGGER;
}({});
var $fa05b1e32f887e46$export$90dde066fa32cf2f = /*#__PURE__*/ function(TABLE_STATUS) {
    TABLE_STATUS["SUCCESS"] = "success";
    TABLE_STATUS["CANCELLED"] = "cancelled";
    TABLE_STATUS["INVALID"] = "invalid";
    return TABLE_STATUS;
}({});
var $fa05b1e32f887e46$export$a62a68f32aa71693 = /*#__PURE__*/ function(TABLE_DISPLAY_MODE) {
    TABLE_DISPLAY_MODE["FIXED"] = "fixed";
    TABLE_DISPLAY_MODE["DEFAULT"] = "default";
    TABLE_DISPLAY_MODE["INITIAL"] = "initial";
    return TABLE_DISPLAY_MODE;
}({});
var $fa05b1e32f887e46$export$ba2dfc055a59d951 = /*#__PURE__*/ function(CHANGE_ALIGNMENT_REASON) {
    CHANGE_ALIGNMENT_REASON["TABLE_RESIZING"] = "tableResizing";
    CHANGE_ALIGNMENT_REASON["TABLE_COLUMN_RESIZED"] = "tableColumnResized";
    CHANGE_ALIGNMENT_REASON["EDITOR_APPEARANCE_CHANGED"] = "editorAppearanceChanged";
    CHANGE_ALIGNMENT_REASON["TOOLBAR_OPTION_CHANGED"] = "toolbarOptionChanged";
    return CHANGE_ALIGNMENT_REASON;
}({});
module.exports["TABLE_ACTION"] = $fa05b1e32f887e46$export$1627223e090990cf;
module.exports["TABLE_OVERFLOW_CHANGE_TRIGGER"] = $fa05b1e32f887e46$export$e0b2ad636c1c8ab4;
module.exports["TABLE_STATUS"] = $fa05b1e32f887e46$export$90dde066fa32cf2f;
module.exports["TABLE_DISPLAY_MODE"] = $fa05b1e32f887e46$export$a62a68f32aa71693;
module.exports["CHANGE_ALIGNMENT_REASON"] = $fa05b1e32f887e46$export$ba2dfc055a59d951;

});

parcelRegister("cTQmR", function(module, exports) {
// The full list of languages that can potentially be supported is found in
// https://prismjs.com/#supported-languages

const $a6db6a3439cd9017$export$7c77c3a9bb93870d = [
    {
        name: 'PHP',
        alias: [
            'php',
            'php3',
            'php4',
            'php5'
        ],
        value: 'php'
    },
    {
        name: 'Java',
        alias: [
            'java'
        ],
        value: 'java'
    },
    {
        name: 'CSharp',
        alias: [
            'csharp',
            'c#'
        ],
        value: 'cs'
    },
    {
        name: 'Python',
        alias: [
            'python',
            'py'
        ],
        value: 'python'
    },
    {
        name: 'JavaScript',
        alias: [
            'javascript',
            'js'
        ],
        value: 'javascript'
    },
    {
        name: 'Html',
        alias: [
            'html'
        ],
        value: 'xml'
    },
    {
        name: 'C++',
        alias: [
            'c++',
            'cpp',
            'clike'
        ],
        value: 'cpp'
    },
    {
        name: 'Ruby',
        alias: [
            'ruby',
            'rb',
            'duby'
        ],
        value: 'ruby'
    },
    {
        name: 'Objective-C',
        alias: [
            'objective-c',
            'objectivec',
            'obj-c',
            'objc'
        ],
        value: 'objectivec'
    },
    {
        name: 'C',
        alias: [
            'c'
        ],
        value: 'cpp'
    },
    {
        name: 'Swift',
        alias: [
            'swift'
        ],
        value: 'swift'
    },
    {
        name: 'TeX',
        alias: [
            'tex',
            'latex'
        ],
        value: 'tex'
    },
    {
        name: 'Shell',
        alias: [
            'shell',
            'bash',
            'sh',
            'ksh',
            'zsh'
        ],
        value: 'shell'
    },
    {
        name: 'Scala',
        alias: [
            'scala'
        ],
        value: 'scala'
    },
    {
        name: 'Go',
        alias: [
            'go'
        ],
        value: 'go'
    },
    {
        name: 'ActionScript',
        alias: [
            'actionscript',
            'actionscript3',
            'as'
        ],
        value: 'actionscript'
    },
    {
        name: 'ColdFusion',
        alias: [
            'coldfusion'
        ],
        value: 'xml'
    },
    {
        name: 'JavaFX',
        alias: [
            'javafx',
            'jfx'
        ],
        value: 'java'
    },
    {
        name: 'VbNet',
        alias: [
            'vbnet',
            'vb.net',
            'vfp',
            'clipper',
            'xbase'
        ],
        value: 'vbnet'
    },
    {
        name: 'JSON',
        alias: [
            'json'
        ],
        value: 'json'
    },
    {
        name: 'MATLAB',
        alias: [
            'matlab'
        ],
        value: 'matlab'
    },
    {
        name: 'Groovy',
        alias: [
            'groovy'
        ],
        value: 'groovy'
    },
    {
        name: 'SQL',
        alias: [
            'sql',
            'postgresql',
            'postgres',
            'plpgsql',
            'psql',
            'postgresql-console',
            'postgres-console',
            'tsql',
            't-sql',
            'mysql',
            'sqlite'
        ],
        value: 'sql'
    },
    {
        name: 'R',
        alias: [
            'r'
        ],
        value: 'r'
    },
    {
        name: 'Perl',
        alias: [
            'perl',
            'pl'
        ],
        value: 'perl'
    },
    {
        name: 'Lua',
        alias: [
            'lua'
        ],
        value: 'lua'
    },
    {
        name: 'Pascal',
        alias: [
            'pas',
            'pascal',
            'objectpascal',
            'delphi'
        ],
        value: 'pascal'
    },
    {
        name: 'XML',
        alias: [
            'xml'
        ],
        value: 'xml'
    },
    {
        name: 'TypeScript',
        alias: [
            'typescript',
            'ts'
        ],
        value: 'typescript'
    },
    {
        name: 'CoffeeScript',
        alias: [
            'coffeescript',
            'coffee-script',
            'coffee'
        ],
        value: 'coffeescript'
    },
    {
        name: 'Haskell',
        alias: [
            'haskell',
            'hs'
        ],
        value: 'haskell'
    },
    {
        name: 'Puppet',
        alias: [
            'puppet'
        ],
        value: 'puppet'
    },
    {
        name: 'Arduino',
        alias: [
            'arduino'
        ],
        value: 'arduino'
    },
    {
        name: 'Fortran',
        alias: [
            'fortran'
        ],
        value: 'fortran'
    },
    {
        name: 'Erlang',
        alias: [
            'erlang',
            'erl'
        ],
        value: 'erlang'
    },
    {
        name: 'PowerShell',
        alias: [
            'powershell',
            'posh',
            'ps1',
            'psm1'
        ],
        value: 'powershell'
    },
    {
        name: 'Haxe',
        alias: [
            'haxe',
            'hx',
            'hxsl'
        ],
        value: 'haxe'
    },
    {
        name: 'Elixir',
        alias: [
            'elixir',
            'ex',
            'exs'
        ],
        value: 'elixir'
    },
    {
        name: 'Verilog',
        alias: [
            'verilog',
            'v'
        ],
        value: 'verilog'
    },
    {
        name: 'Rust',
        alias: [
            'rust'
        ],
        value: 'rust'
    },
    {
        name: 'VHDL',
        alias: [
            'vhdl'
        ],
        value: 'vhdl'
    },
    {
        name: 'Sass',
        alias: [
            'sass'
        ],
        value: 'less'
    },
    {
        name: 'OCaml',
        alias: [
            'ocaml'
        ],
        value: 'ocaml'
    },
    {
        name: 'Dart',
        alias: [
            'dart'
        ],
        value: 'dart'
    },
    {
        name: 'CSS',
        alias: [
            'css'
        ],
        value: 'css'
    },
    {
        name: 'reStructuredText',
        alias: [
            'restructuredtext',
            'rst',
            'rest'
        ],
        value: 'rest'
    },
    {
        name: 'Kotlin',
        alias: [
            'kotlin'
        ],
        value: 'kotlin'
    },
    {
        name: 'D',
        alias: [
            'd'
        ],
        value: 'd'
    },
    {
        name: 'Octave',
        alias: [
            'octave'
        ],
        value: 'matlab'
    },
    {
        name: 'QML',
        alias: [
            'qbs',
            'qml'
        ],
        value: 'qml'
    },
    {
        name: 'Prolog',
        alias: [
            'prolog'
        ],
        value: 'prolog'
    },
    {
        name: 'FoxPro',
        alias: [
            'foxpro',
            'purebasic'
        ],
        value: 'purebasic'
    },
    {
        name: 'Scheme',
        alias: [
            'scheme',
            'scm'
        ],
        value: 'scheme'
    },
    {
        name: 'CUDA',
        alias: [
            'cuda',
            'cu'
        ],
        value: 'cpp'
    },
    {
        name: 'Julia',
        alias: [
            'julia',
            'jl'
        ],
        value: 'julia'
    },
    {
        name: 'Racket',
        alias: [
            'racket',
            'rkt'
        ],
        value: 'lisp'
    },
    {
        name: 'Ada',
        alias: [
            'ada',
            'ada95',
            'ada2005'
        ],
        value: 'ada'
    },
    {
        name: 'Tcl',
        alias: [
            'tcl'
        ],
        value: 'tcl'
    },
    {
        name: 'Mathematica',
        alias: [
            'mathematica',
            'mma',
            'nb'
        ],
        value: 'mathematica'
    },
    {
        name: 'Autoit',
        alias: [
            'autoit'
        ],
        value: 'autoit'
    },
    {
        name: 'StandardML',
        alias: [
            'standardmL',
            'sml',
            'standardml'
        ],
        value: 'sml'
    },
    {
        name: 'Objective-J',
        alias: [
            'objective-j',
            'objectivej',
            'obj-j',
            'objj'
        ],
        value: 'objectivec'
    },
    {
        name: 'Smalltalk',
        alias: [
            'smalltalk',
            'squeak',
            'st'
        ],
        value: 'smalltalk'
    },
    {
        name: 'Vala',
        alias: [
            'vala',
            'vapi'
        ],
        value: 'vala'
    },
    {
        name: 'LiveScript',
        alias: [
            'livescript',
            'live-script'
        ],
        value: 'livescript'
    },
    {
        name: 'XQuery',
        alias: [
            'xquery',
            'xqy',
            'xq',
            'xql',
            'xqm'
        ],
        value: 'xquery'
    },
    {
        name: 'PlainText',
        alias: [
            'text',
            'plaintext'
        ],
        value: 'text'
    },
    {
        name: 'Yaml',
        alias: [
            'yaml',
            'yml'
        ],
        value: 'yaml'
    },
    {
        name: 'GraphQL',
        alias: [
            'graphql'
        ],
        value: 'graphql'
    },
    {
        name: 'AppleScript',
        alias: [
            'applescript'
        ],
        value: 'applescript'
    },
    {
        name: 'Clojure',
        alias: [
            'clojure'
        ],
        value: 'clojure'
    },
    {
        name: 'Diff',
        alias: [
            'diff'
        ],
        value: 'diff'
    },
    {
        name: 'VisualBasic',
        alias: [
            'visualbasic'
        ],
        value: 'visual-basic'
    },
    {
        name: 'JSX',
        alias: [
            'jsx'
        ],
        value: 'jsx'
    },
    {
        name: 'TSX',
        alias: [
            'tsx'
        ],
        value: 'tsx'
    },
    {
        name: 'SplunkSPL',
        alias: [
            'splunk-spl'
        ],
        value: 'splunk-spl'
    },
    {
        name: 'Dockerfile',
        alias: [
            'docker',
            'dockerfile'
        ],
        value: 'dockerfile'
    },
    {
        name: 'HCL',
        alias: [
            'hcl',
            'terraform'
        ],
        value: 'hcl'
    },
    {
        name: 'NGINX',
        alias: [
            'nginx'
        ],
        value: 'nginx'
    },
    {
        name: 'Protocol Buffers',
        alias: [
            'protobuf',
            'proto'
        ],
        value: 'protobuf'
    },
    {
        name: 'TOML',
        alias: [
            'toml'
        ],
        value: 'toml'
    },
    {
        name: 'Handlebars',
        alias: [
            'handlebars',
            'mustache'
        ],
        value: 'handlebars'
    },
    {
        name: 'Gherkin',
        alias: [
            'gherkin',
            'cucumber'
        ],
        value: 'gherkin'
    },
    {
        name: 'ABAP',
        alias: [
            'abap'
        ],
        value: 'abap'
    },
    {
        name: 'Markdown',
        alias: [
            'markdown'
        ],
        value: 'markdown'
    }
];
module.exports["SUPPORTED_LANGUAGES"] = $a6db6a3439cd9017$export$7c77c3a9bb93870d;

});

parcelRegister("dIxHZ", function(module, exports) {

var $2Hy4R = parcelRequire("2Hy4R");


var $dlSEv = parcelRequire("dlSEv");

var $73c40f69a74688ac$var$FORMATS = /*#__PURE__*/ function(FORMATS) {
    FORMATS["ISO_FORMAT"] = "YYYY-MM-DD";
    FORMATS["LOCALIZED_FORMAT"] = "LOCALIZED_FORMAT";
    return FORMATS;
}($73c40f69a74688ac$var$FORMATS || {});
const $73c40f69a74688ac$export$56c3660a4ee2196a = (timestamp)=>{
    const date = new Date(Number(timestamp));
    const day = date.getUTCDate();
    const month = date.getUTCMonth() + 1;
    const year = date.getUTCFullYear();
    return {
        day: day,
        month: month,
        year: year
    };
};
const $73c40f69a74688ac$export$6297728405c48562 = ()=>{
    const today = new Date(Date.now());
    const todayInUTC = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());
    return todayInUTC.toString();
};
const $73c40f69a74688ac$var$addLeadingZero = (val)=>{
    if (val < 10) return `0${val}`;
    return val;
};
const $73c40f69a74688ac$var$capitalizeFirstLetter = (str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
};
const $73c40f69a74688ac$export$48755a044ef883a0 = (timestamp, intl, pattern)=>{
    if (!intl || pattern === "YYYY-MM-DD") return $73c40f69a74688ac$export$70a1b7b6fffe4dd1(timestamp);
    const date = new Date(Number(timestamp));
    return intl.formatDate(date, {
        timeZone: 'UTC',
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        formatMatcher: 'best fit'
    });
};
const $73c40f69a74688ac$export$70a1b7b6fffe4dd1 = (timestamp)=>{
    const date = new Date(Number(timestamp));
    return `${date.getUTCFullYear()}-${$73c40f69a74688ac$var$addLeadingZero(date.getUTCMonth() + 1)}-${$73c40f69a74688ac$var$addLeadingZero(date.getUTCDate())}`;
};
const $73c40f69a74688ac$export$e6cc7bfc6e0e363e = (timestamp)=>{
    return (0, $dlSEv.default)(new Date(Number(timestamp)), new Date(Number($73c40f69a74688ac$export$6297728405c48562())));
};
const $73c40f69a74688ac$export$fbc04a9e57b04a80 = (timestamp, intl)=>{
    const curDate = new Date(Number($73c40f69a74688ac$export$6297728405c48562()));
    const givenDate = new Date(Number(timestamp));
    const distance = (0, $2Hy4R.default)(givenDate, curDate);
    if (intl && [
        -1,
        0,
        1
    ].indexOf(distance) > -1) return $73c40f69a74688ac$var$capitalizeFirstLetter(intl.formatRelativeTime(distance, 'day', {
        numeric: 'auto'
    }));
    return $73c40f69a74688ac$export$48755a044ef883a0(timestamp, intl, "LOCALIZED_FORMAT");
};
module.exports["timestampToUTCDate"] = $73c40f69a74688ac$export$56c3660a4ee2196a;
module.exports["todayTimestampInUTC"] = $73c40f69a74688ac$export$6297728405c48562;
module.exports["timestampToString"] = $73c40f69a74688ac$export$48755a044ef883a0;
module.exports["timestampToIsoFormat"] = $73c40f69a74688ac$export$70a1b7b6fffe4dd1;
module.exports["isPastDate"] = $73c40f69a74688ac$export$e6cc7bfc6e0e363e;
module.exports["timestampToTaskContext"] = $73c40f69a74688ac$export$fbc04a9e57b04a80;

});

parcelRegister("DoNsZ", function(module, exports) {

var $0pwCz = parcelRequire("0pwCz");


var $6icEc = parcelRequire("6icEc");

const $2d8620dcf810155b$var$lightPanelColors = {
    info: '#DEEBFF',
    note: '#EAE6FF',
    tip: '#E3FCEF',
    success: '#E3FCEF',
    warning: '#FFFAE6',
    error: '#FFEBE6'
};
const $2d8620dcf810155b$export$804476272fbaff5e = {
    // standard panels
    info: `#0C294F`,
    error: `#441C13`,
    warning: `#413001`,
    tip: `#052E21`,
    success: `#052E21`,
    note: `#282249`,
    // Reds
    R900: '#601D16',
    // Red Saturated
    R100S: `#FFEFEB`,
    R300S: `#FFB5A3`,
    R500S: `#FF6B47`,
    R800S: `#C4320E`,
    R1200S: `#441C13`,
    // Yellows
    Y900: '#533F04',
    // Yellow Saturated
    Y100S: `#FFF3D1`,
    Y300S: `#FFDC7A`,
    Y500S: `#FFC933`,
    Y800S: `#D8A003`,
    Y1200S: `#413001`,
    // Greens
    G900: '#164B35',
    // Green Saturated
    G100S: `#E3FCF0`,
    G300S: `#95EEC5`,
    G400S: `#60DCA8`,
    G900S: `#086848`,
    G1200S: `#052E21`,
    // Blues
    B900: '#09326C',
    // Saturated Blues
    B100S: '#E5F0FF',
    B300S: '#A3C9FF',
    B500S: '#4794FF',
    B800S: '#0055CC',
    B1200S: '#0C294F',
    // Purples
    P900: `#352C63`,
    // Purple Saturated
    P100S: `#EEEBFF`,
    P300S: `#CCC3FE`,
    P500S: `#A292F7`,
    P800S: `#5E49CA`,
    P1200S: `#282249`,
    // Teals
    T900: '#1D474C',
    // Teal Saturated
    T100S: `#DBFAFF`,
    T300S: `#78EBFC`,
    T400S: `#3AD6EE`,
    T900S: `#056270`,
    T1200S: `#0B3037`,
    // Dark Mode Alpha
    DarkGray: '#161A1D',
    Gray: '#2C333A',
    LightGray: '#5A6977',
    TextColor: '#D9DDE3'
};
function $2d8620dcf810155b$export$9490e629452e7f9e(colorName, colorValue) {
    return `
  &[data-panel-color="${colorName}"] {
    background-color: ${colorValue} !important; // !important to override default style color
    color: ${$2d8620dcf810155b$export$804476272fbaff5e.TextColor};
  }
  `;
}
const $2d8620dcf810155b$var$prefix = 'ak-editor-panel';
const $2d8620dcf810155b$export$6dd740b6c888e050 = {
    prefix: $2d8620dcf810155b$var$prefix,
    content: `${$2d8620dcf810155b$var$prefix}__content`,
    icon: `${$2d8620dcf810155b$var$prefix}__icon`,
    noIcon: `${$2d8620dcf810155b$var$prefix}__no-icon`
};
const $2d8620dcf810155b$export$b0ee08fae091706a = {
    infoPanel: `.${$2d8620dcf810155b$var$prefix}[data-panel-type=${(0, $0pwCz.PanelType).INFO}]`,
    notePanel: `.${$2d8620dcf810155b$var$prefix}[data-panel-type=${(0, $0pwCz.PanelType).NOTE}]`,
    warningPanel: `.${$2d8620dcf810155b$var$prefix}[data-panel-type=${(0, $0pwCz.PanelType).WARNING}]`,
    errorPanel: `.${$2d8620dcf810155b$var$prefix}[data-panel-type=${(0, $0pwCz.PanelType).ERROR}]`,
    successPanel: `.${$2d8620dcf810155b$var$prefix}[data-panel-type=${(0, $0pwCz.PanelType).SUCCESS}]`,
    noteButton: `button[aria-label="Note"]`,
    warningButton: `button[aria-label="Warning"]`,
    removeButton: `button[aria-label="Remove"]`,
    colorPalette: `[aria-label="Background color"]`,
    selectedColor: `[aria-label="Light green"]`,
    removeEmojiIcon: `[aria-label="Remove emoji"]`,
    emojiIcon: `[aria-label="editor-add-emoji"]`,
    selectedEmoji: `[aria-label=":grinning:"]`,
    addYourOwnEmoji: `#add-custom-emoji`,
    emojiNameInCustomEmoji: `[aria-label="Enter a name for the new emoji"]`,
    title: `#editor-title`,
    emojiPopup: `[aria-label="Popup"]`,
    searchEmoji: `[aria-label="Emoji name"]`,
    orangeWarningIcon: `[aria-label=":warning:"]`,
    yellowWarningIcon: `[aria-label=":warning:"]  span:nth-child(1)`,
    copyButton: `button[aria-label="Copy"]`
};
const $2d8620dcf810155b$export$8099afddf1b1be78 = (panelType)=>$2d8620dcf810155b$var$lightPanelColors[panelType] || 'none';
const $2d8620dcf810155b$export$dd3f0fd482ae7ccc = (panelType)=>(0, $6icEc.hexToEditorBackgroundPaletteColor)($2d8620dcf810155b$var$lightPanelColors[panelType]) || 'none';
module.exports["darkPanelColors"] = $2d8620dcf810155b$export$804476272fbaff5e;
module.exports["PanelSharedCssClassName"] = $2d8620dcf810155b$export$6dd740b6c888e050;
module.exports["getPanelTypeBackgroundNoTokens"] = $2d8620dcf810155b$export$8099afddf1b1be78;

});

parcelRegister("2daQU", function(module, exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRegister("gAARK", function(module, exports) {
const $42341a766fe51017$export$5937600f4cc784f0 = 24;
const $42341a766fe51017$export$71d660e8ca5b8f73 = 320;
const $42341a766fe51017$export$cd11d7d46412c89b = 3;
const $42341a766fe51017$export$71482734bb54ac3 = 10;
const $42341a766fe51017$export$fd2b09475ada41cc = 12;
const $42341a766fe51017$export$8c5ac0b0c62a3d21 = 8;
const $42341a766fe51017$export$68d0abe4f03863fb = $42341a766fe51017$export$fd2b09475ada41cc * 2;
const $42341a766fe51017$export$d722b7527b1834a8 = 250;
const $42341a766fe51017$export$da894f7669b4e67c = 200;
const $42341a766fe51017$export$e13825c38da2ce1 = 100;
var $42341a766fe51017$export$c84671f46d6a1ca = /*#__PURE__*/ function(Layout) {
    Layout["FULL_WIDTH"] = "full-width";
    Layout["WIDE"] = "wide";
    Layout["CENTER"] = "center";
    Layout["ALIGN_START"] = "align-start";
    Layout["ALIGN_END"] = "align-end";
    Layout["WRAP_RIGHT"] = "wrap-right";
    Layout["WRAP_LEFT"] = "wrap-left";
    return Layout;
}({});
const $42341a766fe51017$export$405baca3d8bc263d = [
    'wrap-left',
    'wrap-right',
    'align-end',
    'align-start'
];
const $42341a766fe51017$export$4d41d008e9cd4f34 = 0.5;
const $42341a766fe51017$export$b4b560efd3c61856 = 'caption-placeholder';
module.exports["MEDIA_SINGLE_DEFAULT_MIN_PIXEL_WIDTH"] = $42341a766fe51017$export$5937600f4cc784f0;
module.exports["MEDIA_SINGLE_VIDEO_MIN_PIXEL_WIDTH"] = $42341a766fe51017$export$71d660e8ca5b8f73;
module.exports["MEDIA_SINGLE_SNAP_GAP"] = $42341a766fe51017$export$cd11d7d46412c89b;
module.exports["MEDIA_SINGLE_ADJACENT_HANDLE_MARGIN"] = $42341a766fe51017$export$8c5ac0b0c62a3d21;
module.exports["MEDIA_SINGLE_GUTTER_SIZE"] = $42341a766fe51017$export$68d0abe4f03863fb;
module.exports["DEFAULT_IMAGE_WIDTH"] = $42341a766fe51017$export$d722b7527b1834a8;
module.exports["DEFAULT_IMAGE_HEIGHT"] = $42341a766fe51017$export$da894f7669b4e67c;
module.exports["MEDIA_SINGLE_RESIZE_THROTTLE_TIME"] = $42341a766fe51017$export$e13825c38da2ce1;
module.exports["wrappedLayouts"] = $42341a766fe51017$export$405baca3d8bc263d;
module.exports["DEFAULT_ROUNDING_INTERVAL"] = $42341a766fe51017$export$4d41d008e9cd4f34;
module.exports["CAPTION_PLACEHOLDER_ID"] = $42341a766fe51017$export$b4b560efd3c61856;

});

parcelRegister("lqWNh", function(module, exports) {

var $8m4tT = parcelRequire("8m4tT");


var $aFUXX = parcelRequire("aFUXX");


var $3UbBx = parcelRequire("3UbBx");

const $f9e9293fb4fd549c$export$7cd5aab2c4f1fb1e = (layout, width, lineLength)=>{
    return (0, $3UbBx.wrappedLayouts).indexOf(layout) > -1 && lineLength && width && width > 0.5 * lineLength;
};
const $f9e9293fb4fd549c$export$607795ead6e50626 = [
    'center',
    'wide',
    'full-width'
];
const $f9e9293fb4fd549c$export$7c0073a4d21b222d = [
    'wrap-left',
    'wrap-right'
];
const $f9e9293fb4fd549c$export$55fb9d6810f2e04b = (view, pos)=>{
    if (typeof pos !== 'number' || isNaN(pos) || !view) return false;
    const $pos = view.state.doc.resolve(pos);
    const { expand: expand, nestedExpand: nestedExpand, layoutColumn: layoutColumn } = view.state.schema.nodes;
    return !!(0, $8m4tT.findParentNodeOfTypeClosestToPos)($pos, [
        expand,
        nestedExpand,
        layoutColumn
    ]);
};
const $f9e9293fb4fd549c$export$b2258912a400ba32 = (layout, oldAttrs, gridSize = 12, originalWidth, lineLength)=>{
    let width = oldAttrs.width;
    const oldLayout = oldAttrs.layout;
    const oldLayoutIsNonWrapped = $f9e9293fb4fd549c$export$607795ead6e50626.indexOf(oldLayout) > -1;
    const newLayoutIsNonWrapped = $f9e9293fb4fd549c$export$607795ead6e50626.indexOf(layout) > -1;
    const newLayoutIsWrapped = (0, $3UbBx.wrappedLayouts).indexOf(layout) > -1;
    const oldLayoutIsWrapped = (0, $3UbBx.wrappedLayouts).indexOf(oldLayout) > -1;
    if (oldLayoutIsNonWrapped && $f9e9293fb4fd549c$export$7cd5aab2c4f1fb1e(layout, originalWidth, lineLength)) // 'full-width' or 'wide' or 'center' -> 'wrap-left' or 'wrap-right' or 'align-end' or 'align-start'
    {
        if (!width || width >= 100 || oldLayout !== 'center' // == 'full-width' or 'wide'
        ) width = 50;
    } else if (layout !== oldLayout && [
        'full-width',
        'wide'
    ].indexOf(oldLayout) > -1) // 'full-width' -> 'center' or 'wide'
    // 'wide' -> 'center' or 'full-width'
    // unset width
    width = undefined;
    else if (width) {
        const cols = Math.round(width / 100 * gridSize);
        let targetCols = cols;
        if (oldLayoutIsWrapped && newLayoutIsNonWrapped) {
            // wrap -> center needs to align to even grid
            targetCols = Math.floor(targetCols / 2) * 2;
            width = undefined;
        } else if (oldLayoutIsNonWrapped && newLayoutIsWrapped) {
            // Can be here only if
            // 'full-width' or 'wide' or 'center' -> 'wrap-left' or 'wrap-right' or 'align-end' or 'align-start'
            // AND
            // !originalWidth || !lineLength || small image
            // AND
            // width defined!
            // cannot resize to full column width, and cannot resize to 1 column
            if (cols <= 1) targetCols = 2;
            else if (cols >= gridSize) targetCols = 10;
        }
        if (targetCols !== cols) width = targetCols / gridSize * 100;
    }
    return {
        ...oldAttrs,
        layout: layout,
        width: width
    };
};
function $f9e9293fb4fd549c$export$de65085e667b4bf1({ $pos: $pos, akEditorWideLayoutWidth: akEditorWideLayoutWidth, allowBreakoutSnapPoints: allowBreakoutSnapPoints, containerWidth: containerWidth, gridSize: gridSize, gridWidth: gridWidth, insideInlineLike: insideInlineLike, insideLayout: insideLayout, isVideoFile: isVideoFile, lineLength: lineLength, offsetLeft: offsetLeft, wrappedLayout: wrappedLayout }) {
    const snapTargets = [];
    for(let i = 0; i < gridWidth; i++){
        const pxFromColumns = (0, $3UbBx.calcPxFromColumns)(i, lineLength, gridWidth);
        snapTargets.push(insideLayout ? pxFromColumns : pxFromColumns - offsetLeft);
    }
    // full width
    snapTargets.push(lineLength - offsetLeft);
    const columns = wrappedLayout || insideInlineLike ? 1 : 2;
    const minimumWidth = (0, $3UbBx.calcPxFromColumns)(columns, lineLength, gridSize);
    let snapPoints = snapTargets.filter((width)=>width >= minimumWidth);
    if (!$pos) return snapPoints;
    snapPoints = isVideoFile ? snapPoints.filter((width)=>width > 320) : snapPoints;
    const isTopLevel = $pos.parent.type.name === 'doc';
    if (isTopLevel && allowBreakoutSnapPoints) {
        snapPoints.push(akEditorWideLayoutWidth);
        const fullWidthPoint = containerWidth - (0, $aFUXX.akEditorBreakoutPadding);
        if (fullWidthPoint > akEditorWideLayoutWidth) snapPoints.push(fullWidthPoint);
    }
    // EDM-1107: Ensure new snapPoints are sorted with existing points
    snapPoints = snapPoints.sort((a, b)=>a - b);
    return snapPoints;
}
module.exports["shouldAddDefaultWrappedWidth"] = $f9e9293fb4fd549c$export$7cd5aab2c4f1fb1e;
module.exports["nonWrappedLayouts"] = $f9e9293fb4fd549c$export$607795ead6e50626;
module.exports["floatingLayouts"] = $f9e9293fb4fd549c$export$7c0073a4d21b222d;
module.exports["isRichMediaInsideOfBlockNode"] = $f9e9293fb4fd549c$export$55fb9d6810f2e04b;
module.exports["alignAttributes"] = $f9e9293fb4fd549c$export$b2258912a400ba32;
module.exports["calculateSnapPoints"] = $f9e9293fb4fd549c$export$de65085e667b4bf1;

});

parcelRegister("3UbBx", function(module, exports) {

var $aFUXX = parcelRequire("aFUXX");


var $gAARK = parcelRequire("gAARK");

const $7bd202241742fd44$var$validWidthModes = [
    'center',
    'wrap-left',
    'wrap-right',
    'align-start',
    'align-end'
];
const $7bd202241742fd44$export$adfc02948d64a4f2 = (layout)=>$7bd202241742fd44$var$validWidthModes.indexOf(layout) > -1;
function $7bd202241742fd44$export$1e3701608f0cee80(columns, lineLength, gridSize) {
    const maxWidth = lineLength + (0, $gAARK.MEDIA_SINGLE_GUTTER_SIZE);
    return maxWidth / gridSize * columns - (0, $gAARK.MEDIA_SINGLE_GUTTER_SIZE);
}
function $7bd202241742fd44$export$10912f14d8d54640(width, lineLength, gridSize) {
    const maxWidth = lineLength + (0, $gAARK.MEDIA_SINGLE_GUTTER_SIZE);
    return (width + (0, $gAARK.MEDIA_SINGLE_GUTTER_SIZE)) * gridSize / maxWidth;
}
function $7bd202241742fd44$export$e70e278a1f662f8d(pct, lineLength) {
    const maxWidth = lineLength + (0, $gAARK.MEDIA_SINGLE_GUTTER_SIZE);
    return maxWidth * pct - (0, $gAARK.MEDIA_SINGLE_GUTTER_SIZE);
}
function $7bd202241742fd44$export$55ddb36b3404ec6d(width, lineLength) {
    const maxWidth = lineLength + (0, $gAARK.MEDIA_SINGLE_GUTTER_SIZE);
    return (width + (0, $gAARK.MEDIA_SINGLE_GUTTER_SIZE)) / maxWidth;
}
const $7bd202241742fd44$export$405baca3d8bc263d = [
    'wrap-left',
    'wrap-right',
    'align-end',
    'align-start'
];
const $7bd202241742fd44$export$144a1e648ed4962e = (containerWidth, pctWidth, origWidth, origHeight)=>pctWidth && origWidth && origHeight && Math.ceil($7bd202241742fd44$export$e70e278a1f662f8d(pctWidth / 100, containerWidth.lineLength || containerWidth.width));
const $7bd202241742fd44$export$5e51fc02b9ada5af = (opts)=>{
    const { origWidth: origWidth, origHeight: origHeight, layout: layout, pctWidth: pctWidth, containerWidth: containerWidth, resizedPctWidth: resizedPctWidth } = opts;
    const { width: width, lineLength: lineLength } = containerWidth;
    const calculatedPctWidth = $7bd202241742fd44$export$144a1e648ed4962e(containerWidth, pctWidth, origWidth, origHeight);
    const calculatedResizedPctWidth = $7bd202241742fd44$export$144a1e648ed4962e(containerWidth, resizedPctWidth, origWidth, origHeight);
    if (layout === 'wide') {
        if (lineLength) {
            const wideWidth = Math.ceil(lineLength * (0, $aFUXX.breakoutWideScaleRatio));
            return wideWidth > width ? lineLength : wideWidth;
        }
    } else if (layout === 'full-width') return width - (0, $aFUXX.akEditorBreakoutPadding);
    else if (calculatedPctWidth) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if ($7bd202241742fd44$export$405baca3d8bc263d.indexOf(layout) > -1) {
            if (calculatedResizedPctWidth) {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                if (resizedPctWidth < 50) return calculatedResizedPctWidth;
                return calculatedPctWidth;
            }
            return Math.min(calculatedPctWidth, origWidth);
        }
        if (calculatedResizedPctWidth) return calculatedResizedPctWidth;
        return calculatedPctWidth;
    } else if (layout === 'center') {
        if (calculatedResizedPctWidth) return calculatedResizedPctWidth;
        return Math.min(origWidth, lineLength || width);
    } else if (layout && $7bd202241742fd44$export$405baca3d8bc263d.indexOf(layout) !== -1) {
        const halfLineLength = Math.ceil((lineLength || width) / 2);
        return origWidth <= halfLineLength ? origWidth : halfLineLength;
    }
    return origWidth;
};
const $7bd202241742fd44$export$195604d042fd3f87 = (gridWidth, width, height, lineLength, gridSize)=>{
    const pxWidth = $7bd202241742fd44$export$e70e278a1f662f8d(gridWidth / 100, lineLength);
    const columnSpan = Math.round($7bd202241742fd44$export$10912f14d8d54640(pxWidth, lineLength, gridSize));
    const alignedWidth = $7bd202241742fd44$export$1e3701608f0cee80(columnSpan, lineLength, gridSize);
    return {
        height: height / width * alignedWidth,
        width: alignedWidth
    };
};
module.exports["calcPxFromColumns"] = $7bd202241742fd44$export$1e3701608f0cee80;
module.exports["calcColumnsFromPx"] = $7bd202241742fd44$export$10912f14d8d54640;
module.exports["calcPctFromPx"] = $7bd202241742fd44$export$55ddb36b3404ec6d;
module.exports["wrappedLayouts"] = $7bd202241742fd44$export$405baca3d8bc263d;
module.exports["calcMediaPxWidth"] = $7bd202241742fd44$export$5e51fc02b9ada5af;

});

parcelRegister("9JpPs", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

function $c712b10e1cbb5738$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>condition() ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, $l998X.jsx)(ComponentTrue, {
            ...props,
            ref: ref
        }) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, $l998X.jsx)(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ComponentWithCondition;
}
module.exports["componentWithCondition"] = $c712b10e1cbb5738$export$6e8ea24b15199873;

});

parcelRegister("iGbqR", function(module, exports) {

var $d925B = parcelRequire("d925B");

const $2e985ae6445cc58f$export$7f3c24765adf61f0 = (type)=>{
    return {
        action: (0, $d925B.ACTION).CLICKED,
        actionSubject: type === (0, $d925B.ACTION_SUBJECT_ID).HYPERLINK ? (0, $d925B.ACTION_SUBJECT).HYPERLINK : (0, $d925B.ACTION_SUBJECT).SMART_LINK,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).EDIT_LINK,
        attributes: type !== (0, $d925B.ACTION_SUBJECT_ID).HYPERLINK ? {
            // @ts-ignore
            display: type
        } : {},
        eventType: (0, $d925B.EVENT_TYPE).UI
    };
};
const $2e985ae6445cc58f$var$mapLinkTypeToCardAppearance = (type)=>{
    switch(type){
        case (0, $d925B.ACTION_SUBJECT_ID).CARD_INLINE:
            return 'inline';
        case (0, $d925B.ACTION_SUBJECT_ID).CARD_BLOCK:
            return 'block';
        case (0, $d925B.ACTION_SUBJECT_ID).EMBEDS:
            return 'embed';
        default:
            return 'url';
    }
};
const $2e985ae6445cc58f$export$e81ec2390acfc152 = (type)=>{
    return type === (0, $d925B.ACTION_SUBJECT_ID).HYPERLINK ? $2e985ae6445cc58f$var$buildVisitedHyperLinkPayload() : $2e985ae6445cc58f$export$4c5e2a0406e7eae8(type, (0, $d925B.INPUT_METHOD).TOOLBAR);
};
const $2e985ae6445cc58f$var$buildVisitedHyperLinkPayload = ()=>{
    return {
        action: (0, $d925B.ACTION).VISITED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).HYPERLINK,
        actionSubjectId: undefined,
        attributes: {
            inputMethod: (0, $d925B.INPUT_METHOD).TOOLBAR
        },
        eventType: (0, $d925B.EVENT_TYPE).TRACK
    };
};
const $2e985ae6445cc58f$export$4c5e2a0406e7eae8 = (type, inputMethod)=>{
    return {
        action: (0, $d925B.ACTION).VISITED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).SMART_LINK,
        actionSubjectId: type,
        attributes: {
            inputMethod: inputMethod
        },
        eventType: (0, $d925B.EVENT_TYPE).TRACK
    };
};
const $2e985ae6445cc58f$export$96aa8ae974c8591a = (type)=>{
    return {
        action: (0, $d925B.ACTION).CLICKED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).BUTTON,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).GOTO_SMART_LINK_SETTINGS,
        attributes: {
            // @ts-ignore
            inputMethod: (0, $d925B.INPUT_METHOD).TOOLBAR,
            display: $2e985ae6445cc58f$var$mapLinkTypeToCardAppearance(type)
        },
        eventType: (0, $d925B.EVENT_TYPE).UI
    };
};
const $2e985ae6445cc58f$export$aab75a08bdd88be4 = (type)=>{
    return {
        action: (0, $d925B.ACTION).UNLINK,
        actionSubject: type === (0, $d925B.ACTION_SUBJECT_ID).HYPERLINK ? (0, $d925B.ACTION_SUBJECT).HYPERLINK : (0, $d925B.ACTION_SUBJECT).SMART_LINK,
        actionSubjectId: type === (0, $d925B.ACTION_SUBJECT_ID).HYPERLINK ? undefined : type,
        attributes: {
            inputMethod: (0, $d925B.INPUT_METHOD).TOOLBAR
        },
        eventType: (0, $d925B.EVENT_TYPE).TRACK
    };
};
module.exports["buildEditLinkPayload"] = $2e985ae6445cc58f$export$7f3c24765adf61f0;
module.exports["buildVisitedLinkPayload"] = $2e985ae6445cc58f$export$e81ec2390acfc152;
module.exports["buildVisitedNonHyperLinkPayload"] = $2e985ae6445cc58f$export$4c5e2a0406e7eae8;
module.exports["buildOpenedSettingsPayload"] = $2e985ae6445cc58f$export$96aa8ae974c8591a;
module.exports["unlinkPayload"] = $2e985ae6445cc58f$export$aab75a08bdd88be4;

});

parcelRegister("bEi27", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $259677dc07a6f27a$export$34a6fbdd67f09ff6 = '361d618a-3c04-40ad-9b27-3c8ea6927020';

const $259677dc07a6f27a$var$LazyAssetsConfigModal = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("3dIXS")).then((module)=>({
            default: module.AssetsConfigModal
        })));
const $259677dc07a6f27a$var$AssetsConfigModalWithWrappers = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": 'assets-aql-datasource-table-suspense'
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($259677dc07a6f27a$var$LazyAssetsConfigModal, props));
};
var $259677dc07a6f27a$export$2e2bcd8739ae039 = $259677dc07a6f27a$var$AssetsConfigModalWithWrappers;
module.exports["ASSETS_LIST_OF_LINKS_DATASOURCE_ID"] = $259677dc07a6f27a$export$34a6fbdd67f09ff6;
module.exports["default"] = $259677dc07a6f27a$export$2e2bcd8739ae039;

});

parcelRegister("3dIXS", function(module, exports) {

let $2585770ba864394f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2585770ba864394f$var$load("5fSdR"),
    $2585770ba864394f$var$load("i4FRJ"),
    $2585770ba864394f$var$load("gbyG5"),
    $2585770ba864394f$var$load("5pvpJ"),
    $2585770ba864394f$var$load("8JZKd"),
    $2585770ba864394f$var$load("gxkWc"),
    $2585770ba864394f$var$load("cwpgX"),
    $2585770ba864394f$var$load("8makw"),
    $2585770ba864394f$var$load("iXzmH"),
    $2585770ba864394f$var$load("65c4i"),
    $2585770ba864394f$var$load("7RjGl"),
    $2585770ba864394f$var$load("aZ4rV"),
    $2585770ba864394f$var$load("hv4mn"),
    $2585770ba864394f$var$load("7EorR"),
    $2585770ba864394f$var$load("6wr18"),
    $2585770ba864394f$var$load("kjZZD"),
    $2585770ba864394f$var$load("kWNlz"),
    $2585770ba864394f$var$load("cHTTI"),
    $2585770ba864394f$var$load("dTsOE"),
    $2585770ba864394f$var$load("kHOMt"),
    $2585770ba864394f$var$load("hhss7"),
    $2585770ba864394f$var$load("Wowvf"),
    $2585770ba864394f$var$load("ffEVr"),
    $2585770ba864394f$var$load("c5uOY"),
    $2585770ba864394f$var$load("eSDS8")
]).then(()=>parcelRequire('75SNN'));

});

parcelRegister("16GCc", function(module, exports) {

var $bEi27 = parcelRequire("bEi27");

var $jPEjP = parcelRequire("jPEjP");

var $iB8ko = parcelRequire("iB8ko");


var $dh538 = parcelRequire("dh538");

const $4d17943085b99665$export$19af9860957ca153 = (datasourceId)=>{
    switch(datasourceId){
        case 0, $iB8ko.JIRA_LIST_OF_LINKS_DATASOURCE_ID:
            return 'jira';
        case 0, $bEi27.ASSETS_LIST_OF_LINKS_DATASOURCE_ID:
            return 'assets';
        case 0, $jPEjP.CONFLUENCE_SEARCH_DATASOURCE_ID:
            return 'confluence-search';
        default:
            return undefined;
    }
};
const $4d17943085b99665$export$1974047c293dd52e = (datasourceId, defaultValue = true)=>{
    const datasourceType = $4d17943085b99665$export$19af9860957ca153(datasourceId);
    switch(datasourceType){
        case 'jira':
            return true;
        case 'assets':
            if ((0, $dh538.fg)('linking_platform_datasource_assets_objects')) return true;
            return false;
        default:
            return defaultValue;
    }
};
module.exports["getDatasourceType"] = $4d17943085b99665$export$19af9860957ca153;
module.exports["canRenderDatasource"] = $4d17943085b99665$export$1974047c293dd52e;

});

parcelRegister("jPEjP", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $eb530dc3f36406bb$export$d9788d6cf1867282 = '768fc736-3af4-4a8f-b27e-203602bff8ca';

const $eb530dc3f36406bb$var$LazyConfluenceSearchConfigModal = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("3zOsW")).then((module)=>({
            default: module.ConfluenceSearchConfigModal
        })));
const $eb530dc3f36406bb$var$ConfluenceSearchConfigModalWithWrappers = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": 'confluence-search-datasource-table-suspense'
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($eb530dc3f36406bb$var$LazyConfluenceSearchConfigModal, props));
};
var $eb530dc3f36406bb$export$2e2bcd8739ae039 = $eb530dc3f36406bb$var$ConfluenceSearchConfigModalWithWrappers;
module.exports["CONFLUENCE_SEARCH_DATASOURCE_ID"] = $eb530dc3f36406bb$export$d9788d6cf1867282;
module.exports["default"] = $eb530dc3f36406bb$export$2e2bcd8739ae039;

});

parcelRegister("3zOsW", function(module, exports) {

let $29abc972422371bd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $29abc972422371bd$var$load("5fSdR"),
    $29abc972422371bd$var$load("i4FRJ"),
    $29abc972422371bd$var$load("gbyG5"),
    $29abc972422371bd$var$load("aeEUI"),
    $29abc972422371bd$var$load("5YOHm"),
    $29abc972422371bd$var$load("5pvpJ"),
    $29abc972422371bd$var$load("8JZKd"),
    $29abc972422371bd$var$load("gxkWc"),
    $29abc972422371bd$var$load("cwpgX"),
    $29abc972422371bd$var$load("8makw"),
    $29abc972422371bd$var$load("iXzmH"),
    $29abc972422371bd$var$load("65c4i"),
    $29abc972422371bd$var$load("7RjGl"),
    $29abc972422371bd$var$load("aZ4rV"),
    $29abc972422371bd$var$load("hv4mn"),
    $29abc972422371bd$var$load("7EorR"),
    $29abc972422371bd$var$load("6wr18"),
    $29abc972422371bd$var$load("kjZZD"),
    $29abc972422371bd$var$load("kWNlz"),
    $29abc972422371bd$var$load("cHTTI"),
    $29abc972422371bd$var$load("dTsOE"),
    $29abc972422371bd$var$load("kHOMt"),
    $29abc972422371bd$var$load("hhss7"),
    $29abc972422371bd$var$load("Wowvf"),
    $29abc972422371bd$var$load("ffEVr"),
    $29abc972422371bd$var$load("c5uOY"),
    $29abc972422371bd$var$load("40QiO")
]).then(()=>parcelRequire('4dMJk'));

});

parcelRegister("iB8ko", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $0a545d08f6a56386$export$8ce19958117ece5c = 'd8b75300-dfda-4519-b6cd-e49abbd50401';

const $0a545d08f6a56386$var$LazyJiraIssuesConfigModal = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("kH0BT")).then((module)=>({
            default: module.JiraIssuesConfigModal
        })));
const $0a545d08f6a56386$var$JiraIssuesConfigModalWithWrappers = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": 'jira-datasource-table-suspense'
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0a545d08f6a56386$var$LazyJiraIssuesConfigModal, props));
};
var $0a545d08f6a56386$export$2e2bcd8739ae039 = $0a545d08f6a56386$var$JiraIssuesConfigModalWithWrappers;
module.exports["JIRA_LIST_OF_LINKS_DATASOURCE_ID"] = $0a545d08f6a56386$export$8ce19958117ece5c;
module.exports["default"] = $0a545d08f6a56386$export$2e2bcd8739ae039;

});

parcelRegister("kH0BT", function(module, exports) {

let $f1084bfd122a11eb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f1084bfd122a11eb$var$load("5fSdR"),
    $f1084bfd122a11eb$var$load("5465r"),
    $f1084bfd122a11eb$var$load("fkY2m"),
    $f1084bfd122a11eb$var$load("i4FRJ"),
    $f1084bfd122a11eb$var$load("gbyG5"),
    $f1084bfd122a11eb$var$load("9ijrN"),
    $f1084bfd122a11eb$var$load("iFEfD"),
    $f1084bfd122a11eb$var$load("l8LQp"),
    $f1084bfd122a11eb$var$load("4xzkC"),
    $f1084bfd122a11eb$var$load("1oAGT"),
    $f1084bfd122a11eb$var$load("cmCrq"),
    $f1084bfd122a11eb$var$load("5YOHm"),
    $f1084bfd122a11eb$var$load("5pvpJ"),
    $f1084bfd122a11eb$var$load("8JZKd"),
    $f1084bfd122a11eb$var$load("gxkWc"),
    $f1084bfd122a11eb$var$load("cwpgX"),
    $f1084bfd122a11eb$var$load("8makw"),
    $f1084bfd122a11eb$var$load("iXzmH"),
    $f1084bfd122a11eb$var$load("65c4i"),
    $f1084bfd122a11eb$var$load("7RjGl"),
    $f1084bfd122a11eb$var$load("aZ4rV"),
    $f1084bfd122a11eb$var$load("hv4mn"),
    $f1084bfd122a11eb$var$load("7EorR"),
    $f1084bfd122a11eb$var$load("6wr18"),
    $f1084bfd122a11eb$var$load("kjZZD"),
    $f1084bfd122a11eb$var$load("kWNlz"),
    $f1084bfd122a11eb$var$load("cHTTI"),
    $f1084bfd122a11eb$var$load("dTsOE"),
    $f1084bfd122a11eb$var$load("kHOMt"),
    $f1084bfd122a11eb$var$load("hhss7"),
    $f1084bfd122a11eb$var$load("Wowvf"),
    $f1084bfd122a11eb$var$load("ffEVr"),
    $f1084bfd122a11eb$var$load("c5uOY"),
    $f1084bfd122a11eb$var$load("2Aekd")
]).then(()=>parcelRequire('ksmD9'));

});

parcelRegister("3FxV8", function(module, exports) {

var $bCMS0 = parcelRequire("bCMS0");


var $abOaY = parcelRequire("abOaY");

/**
 * Clamps `number` within the inclusive `lower` and `upper` bounds.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Number
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 * @example
 *
 * _.clamp(-10, -5, 5);
 * // => -5
 *
 * _.clamp(10, -5, 5);
 * // => 5
 */ function $2abf835653f9d26a$var$clamp(number, lower, upper) {
    if (upper === undefined) {
        upper = lower;
        lower = undefined;
    }
    if (upper !== undefined) {
        upper = $abOaY(upper);
        upper = upper === upper ? upper : 0;
    }
    if (lower !== undefined) {
        lower = $abOaY(lower);
        lower = lower === lower ? lower : 0;
    }
    return $bCMS0($abOaY(number), lower, upper);
}
module.exports = $2abf835653f9d26a$var$clamp;

});

parcelRegister("ftzrq", function(module, exports) {

var $ks2lK = parcelRequire("ks2lK");


var $5SAOw = parcelRequire("5SAOw");


var $aXG5V = parcelRequire("aXG5V");

const $b4450e5745e49325$var$domIndex = function(node) {
    for(var index = 0;; index++){
        node = node.previousSibling;
        if (!node) return index;
    }
};
const $b4450e5745e49325$var$parentNode = function(node) {
    let parent = node.assignedSlot || node.parentNode;
    return parent && parent.nodeType == 11 ? parent.host : parent;
};
let $b4450e5745e49325$var$reusedRange = null;
// Note that this will always return the same range, because DOM range
// objects are every expensive, and keep slowing down subsequent DOM
// updates, for some reason.
const $b4450e5745e49325$var$textRange = function(node, from, to) {
    let range = $b4450e5745e49325$var$reusedRange || ($b4450e5745e49325$var$reusedRange = document.createRange());
    range.setEnd(node, to == null ? node.nodeValue.length : to);
    range.setStart(node, from || 0);
    return range;
};
const $b4450e5745e49325$var$clearReusedRange = function() {
    $b4450e5745e49325$var$reusedRange = null;
};
// Scans forward and backward through DOM positions equivalent to the
// given one to see if the two are in the same place (i.e. after a
// text node vs at the end of that text node)
const $b4450e5745e49325$var$isEquivalentPosition = function(node, off, targetNode, targetOff) {
    return targetNode && ($b4450e5745e49325$var$scanFor(node, off, targetNode, targetOff, -1) || $b4450e5745e49325$var$scanFor(node, off, targetNode, targetOff, 1));
};
const $b4450e5745e49325$var$atomElements = /^(img|br|input|textarea|hr)$/i;
function $b4450e5745e49325$var$scanFor(node, off, targetNode, targetOff, dir) {
    for(;;){
        if (node == targetNode && off == targetOff) return true;
        if (off == (dir < 0 ? 0 : $b4450e5745e49325$var$nodeSize(node))) {
            let parent = node.parentNode;
            if (!parent || parent.nodeType != 1 || $b4450e5745e49325$var$hasBlockDesc(node) || $b4450e5745e49325$var$atomElements.test(node.nodeName) || node.contentEditable == "false") return false;
            off = $b4450e5745e49325$var$domIndex(node) + (dir < 0 ? 0 : 1);
            node = parent;
        } else if (node.nodeType == 1) {
            node = node.childNodes[off + (dir < 0 ? -1 : 0)];
            if (node.contentEditable == "false") return false;
            off = dir < 0 ? $b4450e5745e49325$var$nodeSize(node) : 0;
        } else return false;
    }
}
function $b4450e5745e49325$var$nodeSize(node) {
    return node.nodeType == 3 ? node.nodeValue.length : node.childNodes.length;
}
function $b4450e5745e49325$var$textNodeBefore$1(node, offset) {
    for(;;){
        if (node.nodeType == 3 && offset) return node;
        if (node.nodeType == 1 && offset > 0) {
            if (node.contentEditable == "false") return null;
            node = node.childNodes[offset - 1];
            offset = $b4450e5745e49325$var$nodeSize(node);
        } else if (node.parentNode && !$b4450e5745e49325$var$hasBlockDesc(node)) {
            offset = $b4450e5745e49325$var$domIndex(node);
            node = node.parentNode;
        } else return null;
    }
}
function $b4450e5745e49325$var$textNodeAfter$1(node, offset) {
    for(;;){
        if (node.nodeType == 3 && offset < node.nodeValue.length) return node;
        if (node.nodeType == 1 && offset < node.childNodes.length) {
            if (node.contentEditable == "false") return null;
            node = node.childNodes[offset];
            offset = 0;
        } else if (node.parentNode && !$b4450e5745e49325$var$hasBlockDesc(node)) {
            offset = $b4450e5745e49325$var$domIndex(node) + 1;
            node = node.parentNode;
        } else return null;
    }
}
function $b4450e5745e49325$var$isOnEdge(node, offset, parent) {
    for(let atStart = offset == 0, atEnd = offset == $b4450e5745e49325$var$nodeSize(node); atStart || atEnd;){
        if (node == parent) return true;
        let index = $b4450e5745e49325$var$domIndex(node);
        node = node.parentNode;
        if (!node) return false;
        atStart = atStart && index == 0;
        atEnd = atEnd && index == $b4450e5745e49325$var$nodeSize(node);
    }
}
function $b4450e5745e49325$var$hasBlockDesc(dom) {
    let desc;
    for(let cur = dom; cur; cur = cur.parentNode)if (desc = cur.pmViewDesc) break;
    return desc && desc.node && desc.node.isBlock && (desc.dom == dom || desc.contentDOM == dom);
}
// Work around Chrome issue https://bugs.chromium.org/p/chromium/issues/detail?id=447523
// (isCollapsed inappropriately returns true in shadow dom)
const $b4450e5745e49325$var$selectionCollapsed = function(domSel) {
    return domSel.focusNode && $b4450e5745e49325$var$isEquivalentPosition(domSel.focusNode, domSel.focusOffset, domSel.anchorNode, domSel.anchorOffset);
};
function $b4450e5745e49325$var$keyEvent(keyCode, key) {
    let event = document.createEvent("Event");
    event.initEvent("keydown", true, true);
    event.keyCode = keyCode;
    event.key = event.code = key;
    return event;
}
function $b4450e5745e49325$var$deepActiveElement(doc) {
    let elt = doc.activeElement;
    while(elt && elt.shadowRoot)elt = elt.shadowRoot.activeElement;
    return elt;
}
function $b4450e5745e49325$var$caretFromPoint(doc, x, y) {
    if (doc.caretPositionFromPoint) try {
        let pos = doc.caretPositionFromPoint(x, y);
        // Clip the offset, because Chrome will return a text offset
        // into <input> nodes, which can't be treated as a regular DOM
        // offset
        if (pos) return {
            node: pos.offsetNode,
            offset: Math.min($b4450e5745e49325$var$nodeSize(pos.offsetNode), pos.offset)
        };
    } catch (_) {}
    if (doc.caretRangeFromPoint) {
        let range = doc.caretRangeFromPoint(x, y);
        if (range) return {
            node: range.startContainer,
            offset: Math.min($b4450e5745e49325$var$nodeSize(range.startContainer), range.startOffset)
        };
    }
}
const $b4450e5745e49325$var$nav = typeof navigator != "undefined" ? navigator : null;
const $b4450e5745e49325$var$doc = typeof document != "undefined" ? document : null;
const $b4450e5745e49325$var$agent = $b4450e5745e49325$var$nav && $b4450e5745e49325$var$nav.userAgent || "";
const $b4450e5745e49325$var$ie_edge = /Edge\/(\d+)/.exec($b4450e5745e49325$var$agent);
const $b4450e5745e49325$var$ie_upto10 = /MSIE \d/.exec($b4450e5745e49325$var$agent);
const $b4450e5745e49325$var$ie_11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec($b4450e5745e49325$var$agent);
const $b4450e5745e49325$var$ie = !!($b4450e5745e49325$var$ie_upto10 || $b4450e5745e49325$var$ie_11up || $b4450e5745e49325$var$ie_edge);
const $b4450e5745e49325$var$ie_version = $b4450e5745e49325$var$ie_upto10 ? document.documentMode : $b4450e5745e49325$var$ie_11up ? +$b4450e5745e49325$var$ie_11up[1] : $b4450e5745e49325$var$ie_edge ? +$b4450e5745e49325$var$ie_edge[1] : 0;
const $b4450e5745e49325$var$gecko = !$b4450e5745e49325$var$ie && /gecko\/(\d+)/i.test($b4450e5745e49325$var$agent);
$b4450e5745e49325$var$gecko && (/Firefox\/(\d+)/.exec($b4450e5745e49325$var$agent) || [
    0,
    0
])[1];
const $b4450e5745e49325$var$_chrome = !$b4450e5745e49325$var$ie && /Chrome\/(\d+)/.exec($b4450e5745e49325$var$agent);
const $b4450e5745e49325$var$chrome = !!$b4450e5745e49325$var$_chrome;
const $b4450e5745e49325$var$chrome_version = $b4450e5745e49325$var$_chrome ? +$b4450e5745e49325$var$_chrome[1] : 0;
const $b4450e5745e49325$var$safari = !$b4450e5745e49325$var$ie && !!$b4450e5745e49325$var$nav && /Apple Computer/.test($b4450e5745e49325$var$nav.vendor);
// Is true for both iOS and iPadOS for convenience
const $b4450e5745e49325$var$ios = $b4450e5745e49325$var$safari && (/Mobile\/\w+/.test($b4450e5745e49325$var$agent) || !!$b4450e5745e49325$var$nav && $b4450e5745e49325$var$nav.maxTouchPoints > 2);
const $b4450e5745e49325$var$mac = $b4450e5745e49325$var$ios || ($b4450e5745e49325$var$nav ? /Mac/.test($b4450e5745e49325$var$nav.platform) : false);
const $b4450e5745e49325$var$windows = $b4450e5745e49325$var$nav ? /Win/.test($b4450e5745e49325$var$nav.platform) : false;
const $b4450e5745e49325$var$android = /Android \d/.test($b4450e5745e49325$var$agent);
const $b4450e5745e49325$var$webkit = !!$b4450e5745e49325$var$doc && "webkitFontSmoothing" in $b4450e5745e49325$var$doc.documentElement.style;
const $b4450e5745e49325$var$webkit_version = $b4450e5745e49325$var$webkit ? +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [
    0,
    0
])[1] : 0;
function $b4450e5745e49325$var$windowRect(doc) {
    let vp = doc.defaultView && doc.defaultView.visualViewport;
    if (vp) return {
        left: 0,
        right: vp.width,
        top: 0,
        bottom: vp.height
    };
    return {
        left: 0,
        right: doc.documentElement.clientWidth,
        top: 0,
        bottom: doc.documentElement.clientHeight
    };
}
function $b4450e5745e49325$var$getSide(value, side) {
    return typeof value == "number" ? value : value[side];
}
function $b4450e5745e49325$var$clientRect(node) {
    let rect = node.getBoundingClientRect();
    // Adjust for elements with style "transform: scale()"
    let scaleX = rect.width / node.offsetWidth || 1;
    let scaleY = rect.height / node.offsetHeight || 1;
    // Make sure scrollbar width isn't included in the rectangle
    return {
        left: rect.left,
        right: rect.left + node.clientWidth * scaleX,
        top: rect.top,
        bottom: rect.top + node.clientHeight * scaleY
    };
}
function $b4450e5745e49325$var$scrollRectIntoView(view, rect, startDOM) {
    let scrollThreshold = view.someProp("scrollThreshold") || 0, scrollMargin = view.someProp("scrollMargin") || 5;
    let doc = view.dom.ownerDocument;
    for(let parent = startDOM || view.dom;; parent = $b4450e5745e49325$var$parentNode(parent)){
        if (!parent) break;
        if (parent.nodeType != 1) continue;
        let elt = parent;
        let atTop = elt == doc.body;
        let bounding = atTop ? $b4450e5745e49325$var$windowRect(doc) : $b4450e5745e49325$var$clientRect(elt);
        let moveX = 0, moveY = 0;
        if (rect.top < bounding.top + $b4450e5745e49325$var$getSide(scrollThreshold, "top")) moveY = -(bounding.top - rect.top + $b4450e5745e49325$var$getSide(scrollMargin, "top"));
        else if (rect.bottom > bounding.bottom - $b4450e5745e49325$var$getSide(scrollThreshold, "bottom")) moveY = rect.bottom - rect.top > bounding.bottom - bounding.top ? rect.top + $b4450e5745e49325$var$getSide(scrollMargin, "top") - bounding.top : rect.bottom - bounding.bottom + $b4450e5745e49325$var$getSide(scrollMargin, "bottom");
        if (rect.left < bounding.left + $b4450e5745e49325$var$getSide(scrollThreshold, "left")) moveX = -(bounding.left - rect.left + $b4450e5745e49325$var$getSide(scrollMargin, "left"));
        else if (rect.right > bounding.right - $b4450e5745e49325$var$getSide(scrollThreshold, "right")) moveX = rect.right - bounding.right + $b4450e5745e49325$var$getSide(scrollMargin, "right");
        if (moveX || moveY) {
            if (atTop) doc.defaultView.scrollBy(moveX, moveY);
            else {
                let startX = elt.scrollLeft, startY = elt.scrollTop;
                if (moveY) elt.scrollTop += moveY;
                if (moveX) elt.scrollLeft += moveX;
                let dX = elt.scrollLeft - startX, dY = elt.scrollTop - startY;
                rect = {
                    left: rect.left - dX,
                    top: rect.top - dY,
                    right: rect.right - dX,
                    bottom: rect.bottom - dY
                };
            }
        }
        if (atTop || /^(fixed|sticky)$/.test(getComputedStyle(parent).position)) break;
    }
}
// Store the scroll position of the editor's parent nodes, along with
// the top position of an element near the top of the editor, which
// will be used to make sure the visible viewport remains stable even
// when the size of the content above changes.
function $b4450e5745e49325$var$storeScrollPos(view) {
    let rect = view.dom.getBoundingClientRect(), startY = Math.max(0, rect.top);
    let refDOM, refTop;
    for(let x = (rect.left + rect.right) / 2, y = startY + 1; y < Math.min(innerHeight, rect.bottom); y += 5){
        let dom = view.root.elementFromPoint(x, y);
        if (!dom || dom == view.dom || !view.dom.contains(dom)) continue;
        let localRect = dom.getBoundingClientRect();
        if (localRect.top >= startY - 20) {
            refDOM = dom;
            refTop = localRect.top;
            break;
        }
    }
    return {
        refDOM: refDOM,
        refTop: refTop,
        stack: $b4450e5745e49325$var$scrollStack(view.dom)
    };
}
function $b4450e5745e49325$var$scrollStack(dom) {
    let stack = [], doc = dom.ownerDocument;
    for(let cur = dom; cur; cur = $b4450e5745e49325$var$parentNode(cur)){
        stack.push({
            dom: cur,
            top: cur.scrollTop,
            left: cur.scrollLeft
        });
        if (dom == doc) break;
    }
    return stack;
}
// Reset the scroll position of the editor's parent nodes to that what
// it was before, when storeScrollPos was called.
function $b4450e5745e49325$var$resetScrollPos({ refDOM: refDOM, refTop: refTop, stack: stack }) {
    let newRefTop = refDOM ? refDOM.getBoundingClientRect().top : 0;
    $b4450e5745e49325$var$restoreScrollStack(stack, newRefTop == 0 ? 0 : newRefTop - refTop);
}
function $b4450e5745e49325$var$restoreScrollStack(stack, dTop) {
    for(let i = 0; i < stack.length; i++){
        let { dom: dom, top: top, left: left } = stack[i];
        if (dom.scrollTop != top + dTop) dom.scrollTop = top + dTop;
        if (dom.scrollLeft != left) dom.scrollLeft = left;
    }
}
let $b4450e5745e49325$var$preventScrollSupported = null;
// Feature-detects support for .focus({preventScroll: true}), and uses
// a fallback kludge when not supported.
function $b4450e5745e49325$var$focusPreventScroll(dom) {
    if (dom.setActive) return dom.setActive(); // in IE
    if ($b4450e5745e49325$var$preventScrollSupported) return dom.focus($b4450e5745e49325$var$preventScrollSupported);
    let stored = $b4450e5745e49325$var$scrollStack(dom);
    dom.focus($b4450e5745e49325$var$preventScrollSupported == null ? {
        get preventScroll () {
            $b4450e5745e49325$var$preventScrollSupported = {
                preventScroll: true
            };
            return true;
        }
    } : undefined);
    if (!$b4450e5745e49325$var$preventScrollSupported) {
        $b4450e5745e49325$var$preventScrollSupported = false;
        $b4450e5745e49325$var$restoreScrollStack(stored, 0);
    }
}
function $b4450e5745e49325$var$findOffsetInNode(node, coords) {
    let closest, dxClosest = 2e8, coordsClosest, offset = 0;
    let rowBot = coords.top, rowTop = coords.top;
    let firstBelow, coordsBelow;
    for(let child = node.firstChild, childIndex = 0; child; child = child.nextSibling, childIndex++){
        let rects;
        if (child.nodeType == 1) rects = child.getClientRects();
        else if (child.nodeType == 3) rects = $b4450e5745e49325$var$textRange(child).getClientRects();
        else continue;
        for(let i = 0; i < rects.length; i++){
            let rect = rects[i];
            if (rect.top <= rowBot && rect.bottom >= rowTop) {
                rowBot = Math.max(rect.bottom, rowBot);
                rowTop = Math.min(rect.top, rowTop);
                let dx = rect.left > coords.left ? rect.left - coords.left : rect.right < coords.left ? coords.left - rect.right : 0;
                if (dx < dxClosest) {
                    closest = child;
                    dxClosest = dx;
                    coordsClosest = dx && closest.nodeType == 3 ? {
                        left: rect.right < coords.left ? rect.right : rect.left,
                        top: coords.top
                    } : coords;
                    if (child.nodeType == 1 && dx) offset = childIndex + (coords.left >= (rect.left + rect.right) / 2 ? 1 : 0);
                    continue;
                }
            } else if (rect.top > coords.top && !firstBelow && rect.left <= coords.left && rect.right >= coords.left) {
                firstBelow = child;
                coordsBelow = {
                    left: Math.max(rect.left, Math.min(rect.right, coords.left)),
                    top: rect.top
                };
            }
            if (!closest && (coords.left >= rect.right && coords.top >= rect.top || coords.left >= rect.left && coords.top >= rect.bottom)) offset = childIndex + 1;
        }
    }
    if (!closest && firstBelow) {
        closest = firstBelow;
        coordsClosest = coordsBelow;
        dxClosest = 0;
    }
    if (closest && closest.nodeType == 3) return $b4450e5745e49325$var$findOffsetInText(closest, coordsClosest);
    if (!closest || dxClosest && closest.nodeType == 1) return {
        node: node,
        offset: offset
    };
    return $b4450e5745e49325$var$findOffsetInNode(closest, coordsClosest);
}
function $b4450e5745e49325$var$findOffsetInText(node, coords) {
    let len = node.nodeValue.length;
    let range = document.createRange();
    for(let i = 0; i < len; i++){
        range.setEnd(node, i + 1);
        range.setStart(node, i);
        let rect = $b4450e5745e49325$var$singleRect(range, 1);
        if (rect.top == rect.bottom) continue;
        if ($b4450e5745e49325$var$inRect(coords, rect)) return {
            node: node,
            offset: i + (coords.left >= (rect.left + rect.right) / 2 ? 1 : 0)
        };
    }
    return {
        node: node,
        offset: 0
    };
}
function $b4450e5745e49325$var$inRect(coords, rect) {
    return coords.left >= rect.left - 1 && coords.left <= rect.right + 1 && coords.top >= rect.top - 1 && coords.top <= rect.bottom + 1;
}
function $b4450e5745e49325$var$targetKludge(dom, coords) {
    let parent = dom.parentNode;
    if (parent && /^li$/i.test(parent.nodeName) && coords.left < dom.getBoundingClientRect().left) return parent;
    return dom;
}
function $b4450e5745e49325$var$posFromElement(view, elt, coords) {
    let { node: node, offset: offset } = $b4450e5745e49325$var$findOffsetInNode(elt, coords), bias = -1;
    if (node.nodeType == 1 && !node.firstChild) {
        let rect = node.getBoundingClientRect();
        bias = rect.left != rect.right && coords.left > (rect.left + rect.right) / 2 ? 1 : -1;
    }
    return view.docView.posFromDOM(node, offset, bias);
}
function $b4450e5745e49325$var$posFromCaret(view, node, offset, coords) {
    // Browser (in caretPosition/RangeFromPoint) will agressively
    // normalize towards nearby inline nodes. Since we are interested in
    // positions between block nodes too, we first walk up the hierarchy
    // of nodes to see if there are block nodes that the coordinates
    // fall outside of. If so, we take the position before/after that
    // block. If not, we call `posFromDOM` on the raw node/offset.
    let outsideBlock = -1;
    for(let cur = node, sawBlock = false;;){
        if (cur == view.dom) break;
        let desc = view.docView.nearestDesc(cur, true), rect;
        if (!desc) return null;
        if (desc.dom.nodeType == 1 && (desc.node.isBlock && desc.parent || !desc.contentDOM) && // Ignore elements with zero-size bounding rectangles
        ((rect = desc.dom.getBoundingClientRect()).width || rect.height)) {
            if (desc.node.isBlock && desc.parent) {
                // Only apply the horizontal test to the innermost block. Vertical for any parent.
                if (!sawBlock && rect.left > coords.left || rect.top > coords.top) outsideBlock = desc.posBefore;
                else if (!sawBlock && rect.right < coords.left || rect.bottom < coords.top) outsideBlock = desc.posAfter;
                sawBlock = true;
            }
            if (!desc.contentDOM && outsideBlock < 0 && !desc.node.isText) {
                // If we are inside a leaf, return the side of the leaf closer to the coords
                let before = desc.node.isBlock ? coords.top < (rect.top + rect.bottom) / 2 : coords.left < (rect.left + rect.right) / 2;
                return before ? desc.posBefore : desc.posAfter;
            }
        }
        cur = desc.dom.parentNode;
    }
    return outsideBlock > -1 ? outsideBlock : view.docView.posFromDOM(node, offset, -1);
}
function $b4450e5745e49325$var$elementFromPoint(element, coords, box) {
    let len = element.childNodes.length;
    if (len && box.top < box.bottom) for(let startI = Math.max(0, Math.min(len - 1, Math.floor(len * (coords.top - box.top) / (box.bottom - box.top)) - 2)), i = startI;;){
        let child = element.childNodes[i];
        if (child.nodeType == 1) {
            let rects = child.getClientRects();
            for(let j = 0; j < rects.length; j++){
                let rect = rects[j];
                if ($b4450e5745e49325$var$inRect(coords, rect)) return $b4450e5745e49325$var$elementFromPoint(child, coords, rect);
            }
        }
        if ((i = (i + 1) % len) == startI) break;
    }
    return element;
}
// Given an x,y position on the editor, get the position in the document.
function $b4450e5745e49325$var$posAtCoords(view, coords) {
    let doc = view.dom.ownerDocument, node, offset = 0;
    let caret = $b4450e5745e49325$var$caretFromPoint(doc, coords.left, coords.top);
    if (caret) ({ node: node, offset: offset } = caret);
    let elt = (view.root.elementFromPoint ? view.root : doc).elementFromPoint(coords.left, coords.top);
    let pos;
    if (!elt || !view.dom.contains(elt.nodeType != 1 ? elt.parentNode : elt)) {
        let box = view.dom.getBoundingClientRect();
        if (!$b4450e5745e49325$var$inRect(coords, box)) return null;
        elt = $b4450e5745e49325$var$elementFromPoint(view.dom, coords, box);
        if (!elt) return null;
    }
    // Safari's caretRangeFromPoint returns nonsense when on a draggable element
    if ($b4450e5745e49325$var$safari) {
        for(let p = elt; node && p; p = $b4450e5745e49325$var$parentNode(p))if (p.draggable) node = undefined;
    }
    elt = $b4450e5745e49325$var$targetKludge(elt, coords);
    if (node) {
        if ($b4450e5745e49325$var$gecko && node.nodeType == 1) {
            // Firefox will sometimes return offsets into <input> nodes, which
            // have no actual children, from caretPositionFromPoint (#953)
            offset = Math.min(offset, node.childNodes.length);
            // It'll also move the returned position before image nodes,
            // even if those are behind it.
            if (offset < node.childNodes.length) {
                let next = node.childNodes[offset], box;
                if (next.nodeName == "IMG" && (box = next.getBoundingClientRect()).right <= coords.left && box.bottom > coords.top) offset++;
            }
        }
        let prev;
        // When clicking above the right side of an uneditable node, Chrome will report a cursor position after that node.
        if ($b4450e5745e49325$var$webkit && offset && node.nodeType == 1 && (prev = node.childNodes[offset - 1]).nodeType == 1 && prev.contentEditable == "false" && prev.getBoundingClientRect().top >= coords.top) offset--;
        // Suspiciously specific kludge to work around caret*FromPoint
        // never returning a position at the end of the document
        if (node == view.dom && offset == node.childNodes.length - 1 && node.lastChild.nodeType == 1 && coords.top > node.lastChild.getBoundingClientRect().bottom) pos = view.state.doc.content.size;
        else if (offset == 0 || node.nodeType != 1 || node.childNodes[offset - 1].nodeName != "BR") pos = $b4450e5745e49325$var$posFromCaret(view, node, offset, coords);
    }
    if (pos == null) pos = $b4450e5745e49325$var$posFromElement(view, elt, coords);
    let desc = view.docView.nearestDesc(elt, true);
    return {
        pos: pos,
        inside: desc ? desc.posAtStart - desc.border : -1
    };
}
function $b4450e5745e49325$var$nonZero(rect) {
    return rect.top < rect.bottom || rect.left < rect.right;
}
function $b4450e5745e49325$var$singleRect(target, bias) {
    let rects = target.getClientRects();
    if (rects.length) {
        let first = rects[bias < 0 ? 0 : rects.length - 1];
        if ($b4450e5745e49325$var$nonZero(first)) return first;
    }
    return Array.prototype.find.call(rects, $b4450e5745e49325$var$nonZero) || target.getBoundingClientRect();
}
const $b4450e5745e49325$var$BIDI = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
// Given a position in the document model, get a bounding box of the
// character at that position, relative to the window.
function $b4450e5745e49325$var$coordsAtPos(view, pos, side) {
    let { node: node, offset: offset, atom: atom } = view.docView.domFromPos(pos, side < 0 ? -1 : 1);
    let supportEmptyRange = $b4450e5745e49325$var$webkit || $b4450e5745e49325$var$gecko;
    if (node.nodeType == 3) {
        // These browsers support querying empty text ranges. Prefer that in
        // bidi context or when at the end of a node.
        if (supportEmptyRange && ($b4450e5745e49325$var$BIDI.test(node.nodeValue) || (side < 0 ? !offset : offset == node.nodeValue.length))) {
            let rect = $b4450e5745e49325$var$singleRect($b4450e5745e49325$var$textRange(node, offset, offset), side);
            // Firefox returns bad results (the position before the space)
            // when querying a position directly after line-broken
            // whitespace. Detect this situation and and kludge around it
            if ($b4450e5745e49325$var$gecko && offset && /\s/.test(node.nodeValue[offset - 1]) && offset < node.nodeValue.length) {
                let rectBefore = $b4450e5745e49325$var$singleRect($b4450e5745e49325$var$textRange(node, offset - 1, offset - 1), -1);
                if (rectBefore.top == rect.top) {
                    let rectAfter = $b4450e5745e49325$var$singleRect($b4450e5745e49325$var$textRange(node, offset, offset + 1), -1);
                    if (rectAfter.top != rect.top) return $b4450e5745e49325$var$flattenV(rectAfter, rectAfter.left < rectBefore.left);
                }
            }
            return rect;
        } else {
            let from = offset, to = offset, takeSide = side < 0 ? 1 : -1;
            if (side < 0 && !offset) {
                to++;
                takeSide = -1;
            } else if (side >= 0 && offset == node.nodeValue.length) {
                from--;
                takeSide = 1;
            } else if (side < 0) from--;
            else to++;
            return $b4450e5745e49325$var$flattenV($b4450e5745e49325$var$singleRect($b4450e5745e49325$var$textRange(node, from, to), takeSide), takeSide < 0);
        }
    }
    let $dom = view.state.doc.resolve(pos - (atom || 0));
    // Return a horizontal line in block context
    if (!$dom.parent.inlineContent) {
        if (atom == null && offset && (side < 0 || offset == $b4450e5745e49325$var$nodeSize(node))) {
            let before = node.childNodes[offset - 1];
            if (before.nodeType == 1) return $b4450e5745e49325$var$flattenH(before.getBoundingClientRect(), false);
        }
        if (atom == null && offset < $b4450e5745e49325$var$nodeSize(node)) {
            let after = node.childNodes[offset];
            if (after.nodeType == 1) return $b4450e5745e49325$var$flattenH(after.getBoundingClientRect(), true);
        }
        return $b4450e5745e49325$var$flattenH(node.getBoundingClientRect(), side >= 0);
    }
    // Inline, not in text node (this is not Bidi-safe)
    if (atom == null && offset && (side < 0 || offset == $b4450e5745e49325$var$nodeSize(node))) {
        let before = node.childNodes[offset - 1];
        let target = before.nodeType == 3 ? $b4450e5745e49325$var$textRange(before, $b4450e5745e49325$var$nodeSize(before) - (supportEmptyRange ? 0 : 1)) : before.nodeType == 1 && (before.nodeName != "BR" || !before.nextSibling) ? before : null;
        if (target) return $b4450e5745e49325$var$flattenV($b4450e5745e49325$var$singleRect(target, 1), false);
    }
    if (atom == null && offset < $b4450e5745e49325$var$nodeSize(node)) {
        let after = node.childNodes[offset];
        while(after.pmViewDesc && after.pmViewDesc.ignoreForCoords)after = after.nextSibling;
        let target = !after ? null : after.nodeType == 3 ? $b4450e5745e49325$var$textRange(after, 0, supportEmptyRange ? 0 : 1) : after.nodeType == 1 ? after : null;
        if (target) return $b4450e5745e49325$var$flattenV($b4450e5745e49325$var$singleRect(target, -1), true);
    }
    // All else failed, just try to get a rectangle for the target node
    return $b4450e5745e49325$var$flattenV($b4450e5745e49325$var$singleRect(node.nodeType == 3 ? $b4450e5745e49325$var$textRange(node) : node, -side), side >= 0);
}
function $b4450e5745e49325$var$flattenV(rect, left) {
    if (rect.width == 0) return rect;
    let x = left ? rect.left : rect.right;
    return {
        top: rect.top,
        bottom: rect.bottom,
        left: x,
        right: x
    };
}
function $b4450e5745e49325$var$flattenH(rect, top) {
    if (rect.height == 0) return rect;
    let y = top ? rect.top : rect.bottom;
    return {
        top: y,
        bottom: y,
        left: rect.left,
        right: rect.right
    };
}
function $b4450e5745e49325$var$withFlushedState(view, state, f) {
    let viewState = view.state, active = view.root.activeElement;
    if (viewState != state) view.updateState(state);
    if (active != view.dom) view.focus();
    try {
        return f();
    } finally{
        if (viewState != state) view.updateState(viewState);
        if (active != view.dom && active) active.focus();
    }
}
// Whether vertical position motion in a given direction
// from a position would leave a text block.
function $b4450e5745e49325$var$endOfTextblockVertical(view, state, dir) {
    let sel = state.selection;
    let $pos = dir == "up" ? sel.$from : sel.$to;
    return $b4450e5745e49325$var$withFlushedState(view, state, ()=>{
        let { node: dom } = view.docView.domFromPos($pos.pos, dir == "up" ? -1 : 1);
        for(;;){
            let nearest = view.docView.nearestDesc(dom, true);
            if (!nearest) break;
            if (nearest.node.isBlock) {
                dom = nearest.contentDOM || nearest.dom;
                break;
            }
            dom = nearest.dom.parentNode;
        }
        let coords = $b4450e5745e49325$var$coordsAtPos(view, $pos.pos, 1);
        for(let child = dom.firstChild; child; child = child.nextSibling){
            let boxes;
            if (child.nodeType == 1) boxes = child.getClientRects();
            else if (child.nodeType == 3) boxes = $b4450e5745e49325$var$textRange(child, 0, child.nodeValue.length).getClientRects();
            else continue;
            for(let i = 0; i < boxes.length; i++){
                let box = boxes[i];
                if (box.bottom > box.top + 1 && (dir == "up" ? coords.top - box.top > (box.bottom - coords.top) * 2 : box.bottom - coords.bottom > (coords.bottom - box.top) * 2)) return false;
            }
        }
        return true;
    });
}
const $b4450e5745e49325$var$maybeRTL = /[\u0590-\u08ac]/;
function $b4450e5745e49325$var$endOfTextblockHorizontal(view, state, dir) {
    let { $head: $head } = state.selection;
    if (!$head.parent.isTextblock) return false;
    let offset = $head.parentOffset, atStart = !offset, atEnd = offset == $head.parent.content.size;
    let sel = view.domSelection();
    if (!sel) return $head.pos == $head.start() || $head.pos == $head.end();
    // If the textblock is all LTR, or the browser doesn't support
    // Selection.modify (Edge), fall back to a primitive approach
    if (!$b4450e5745e49325$var$maybeRTL.test($head.parent.textContent) || !sel.modify) return dir == "left" || dir == "backward" ? atStart : atEnd;
    return $b4450e5745e49325$var$withFlushedState(view, state, ()=>{
        // This is a huge hack, but appears to be the best we can
        // currently do: use `Selection.modify` to move the selection by
        // one character, and see if that moves the cursor out of the
        // textblock (or doesn't move it at all, when at the start/end of
        // the document).
        let { focusNode: oldNode, focusOffset: oldOff, anchorNode: anchorNode, anchorOffset: anchorOffset } = view.domSelectionRange();
        let oldBidiLevel = sel.caretBidiLevel // Only for Firefox
        ;
        sel.modify("move", dir, "character");
        let parentDOM = $head.depth ? view.docView.domAfterPos($head.before()) : view.dom;
        let { focusNode: newNode, focusOffset: newOff } = view.domSelectionRange();
        let result = newNode && !parentDOM.contains(newNode.nodeType == 1 ? newNode : newNode.parentNode) || oldNode == newNode && oldOff == newOff;
        // Restore the previous selection
        try {
            sel.collapse(anchorNode, anchorOffset);
            if (oldNode && (oldNode != anchorNode || oldOff != anchorOffset) && sel.extend) sel.extend(oldNode, oldOff);
        } catch (_) {}
        if (oldBidiLevel != null) sel.caretBidiLevel = oldBidiLevel;
        return result;
    });
}
let $b4450e5745e49325$var$cachedState = null;
let $b4450e5745e49325$var$cachedDir = null;
let $b4450e5745e49325$var$cachedResult = false;
function $b4450e5745e49325$var$endOfTextblock(view, state, dir) {
    if ($b4450e5745e49325$var$cachedState == state && $b4450e5745e49325$var$cachedDir == dir) return $b4450e5745e49325$var$cachedResult;
    $b4450e5745e49325$var$cachedState = state;
    $b4450e5745e49325$var$cachedDir = dir;
    return $b4450e5745e49325$var$cachedResult = dir == "up" || dir == "down" ? $b4450e5745e49325$var$endOfTextblockVertical(view, state, dir) : $b4450e5745e49325$var$endOfTextblockHorizontal(view, state, dir);
}
// View descriptions are data structures that describe the DOM that is
// used to represent the editor's content. They are used for:
//
// - Incremental redrawing when the document changes
//
// - Figuring out what part of the document a given DOM position
//   corresponds to
//
// - Wiring in custom implementations of the editing interface for a
//   given node
//
// They form a doubly-linked mutable tree, starting at `view.docView`.
const $b4450e5745e49325$var$NOT_DIRTY = 0, $b4450e5745e49325$var$CHILD_DIRTY = 1, $b4450e5745e49325$var$CONTENT_DIRTY = 2, $b4450e5745e49325$var$NODE_DIRTY = 3;
// Superclass for the various kinds of descriptions. Defines their
// basic structure and shared methods.
class $b4450e5745e49325$var$ViewDesc {
    // Used to check whether a given description corresponds to a
    // widget/mark/node.
    matchesWidget(widget) {
        return false;
    }
    matchesMark(mark) {
        return false;
    }
    matchesNode(node, outerDeco, innerDeco) {
        return false;
    }
    matchesHack(nodeName) {
        return false;
    }
    // When parsing in-editor content (in domchange.js), we allow
    // descriptions to determine the parse rules that should be used to
    // parse them.
    parseRule() {
        return null;
    }
    // Used by the editor's event handler to ignore events that come
    // from certain descs.
    stopEvent(event) {
        return false;
    }
    // The size of the content represented by this desc.
    get size() {
        let size = 0;
        for(let i = 0; i < this.children.length; i++)size += this.children[i].size;
        return size;
    }
    // For block nodes, this represents the space taken up by their
    // start/end tokens.
    get border() {
        return 0;
    }
    destroy() {
        this.parent = undefined;
        if (this.dom.pmViewDesc == this) this.dom.pmViewDesc = undefined;
        for(let i = 0; i < this.children.length; i++)this.children[i].destroy();
    }
    posBeforeChild(child) {
        for(let i = 0, pos = this.posAtStart;; i++){
            let cur = this.children[i];
            if (cur == child) return pos;
            pos += cur.size;
        }
    }
    get posBefore() {
        return this.parent.posBeforeChild(this);
    }
    get posAtStart() {
        return this.parent ? this.parent.posBeforeChild(this) + this.border : 0;
    }
    get posAfter() {
        return this.posBefore + this.size;
    }
    get posAtEnd() {
        return this.posAtStart + this.size - 2 * this.border;
    }
    localPosFromDOM(dom, offset, bias) {
        // If the DOM position is in the content, use the child desc after
        // it to figure out a position.
        if (this.contentDOM && this.contentDOM.contains(dom.nodeType == 1 ? dom : dom.parentNode)) {
            if (bias < 0) {
                let domBefore, desc;
                if (dom == this.contentDOM) domBefore = dom.childNodes[offset - 1];
                else {
                    while(dom.parentNode != this.contentDOM)dom = dom.parentNode;
                    domBefore = dom.previousSibling;
                }
                while(domBefore && !((desc = domBefore.pmViewDesc) && desc.parent == this))domBefore = domBefore.previousSibling;
                return domBefore ? this.posBeforeChild(desc) + desc.size : this.posAtStart;
            } else {
                let domAfter, desc;
                if (dom == this.contentDOM) domAfter = dom.childNodes[offset];
                else {
                    while(dom.parentNode != this.contentDOM)dom = dom.parentNode;
                    domAfter = dom.nextSibling;
                }
                while(domAfter && !((desc = domAfter.pmViewDesc) && desc.parent == this))domAfter = domAfter.nextSibling;
                return domAfter ? this.posBeforeChild(desc) : this.posAtEnd;
            }
        }
        // Otherwise, use various heuristics, falling back on the bias
        // parameter, to determine whether to return the position at the
        // start or at the end of this view desc.
        let atEnd;
        if (dom == this.dom && this.contentDOM) atEnd = offset > $b4450e5745e49325$var$domIndex(this.contentDOM);
        else if (this.contentDOM && this.contentDOM != this.dom && this.dom.contains(this.contentDOM)) atEnd = dom.compareDocumentPosition(this.contentDOM) & 2;
        else if (this.dom.firstChild) {
            if (offset == 0) for(let search = dom;; search = search.parentNode){
                if (search == this.dom) {
                    atEnd = false;
                    break;
                }
                if (search.previousSibling) break;
            }
            if (atEnd == null && offset == dom.childNodes.length) for(let search = dom;; search = search.parentNode){
                if (search == this.dom) {
                    atEnd = true;
                    break;
                }
                if (search.nextSibling) break;
            }
        }
        return (atEnd == null ? bias > 0 : atEnd) ? this.posAtEnd : this.posAtStart;
    }
    nearestDesc(dom, onlyNodes = false) {
        for(let first = true, cur = dom; cur; cur = cur.parentNode){
            let desc = this.getDesc(cur), nodeDOM;
            if (desc && (!onlyNodes || desc.node)) {
                // If dom is outside of this desc's nodeDOM, don't count it.
                if (first && (nodeDOM = desc.nodeDOM) && !(nodeDOM.nodeType == 1 ? nodeDOM.contains(dom.nodeType == 1 ? dom : dom.parentNode) : nodeDOM == dom)) first = false;
                else return desc;
            }
        }
    }
    getDesc(dom) {
        let desc = dom.pmViewDesc;
        for(let cur = desc; cur; cur = cur.parent)if (cur == this) return desc;
    }
    posFromDOM(dom, offset, bias) {
        for(let scan = dom; scan; scan = scan.parentNode){
            let desc = this.getDesc(scan);
            if (desc) return desc.localPosFromDOM(dom, offset, bias);
        }
        return -1;
    }
    // Find the desc for the node after the given pos, if any. (When a
    // parent node overrode rendering, there might not be one.)
    descAt(pos) {
        for(let i = 0, offset = 0; i < this.children.length; i++){
            let child = this.children[i], end = offset + child.size;
            if (offset == pos && end != offset) {
                while(!child.border && child.children.length)child = child.children[0];
                return child;
            }
            if (pos < end) return child.descAt(pos - offset - child.border);
            offset = end;
        }
    }
    domFromPos(pos, side) {
        if (!this.contentDOM) return {
            node: this.dom,
            offset: 0,
            atom: pos + 1
        };
        // First find the position in the child array
        let i = 0, offset = 0;
        for(let curPos = 0; i < this.children.length; i++){
            let child = this.children[i], end = curPos + child.size;
            if (end > pos || child instanceof $b4450e5745e49325$var$TrailingHackViewDesc) {
                offset = pos - curPos;
                break;
            }
            curPos = end;
        }
        // If this points into the middle of a child, call through
        if (offset) return this.children[i].domFromPos(offset - this.children[i].border, side);
        // Go back if there were any zero-length widgets with side >= 0 before this point
        for(let prev; i && !(prev = this.children[i - 1]).size && prev instanceof $b4450e5745e49325$var$WidgetViewDesc && prev.side >= 0; i--);
        // Scan towards the first useable node
        if (side <= 0) {
            let prev, enter = true;
            for(;; i--, enter = false){
                prev = i ? this.children[i - 1] : null;
                if (!prev || prev.dom.parentNode == this.contentDOM) break;
            }
            if (prev && side && enter && !prev.border && !prev.domAtom) return prev.domFromPos(prev.size, side);
            return {
                node: this.contentDOM,
                offset: prev ? $b4450e5745e49325$var$domIndex(prev.dom) + 1 : 0
            };
        } else {
            let next, enter = true;
            for(;; i++, enter = false){
                next = i < this.children.length ? this.children[i] : null;
                if (!next || next.dom.parentNode == this.contentDOM) break;
            }
            if (next && enter && !next.border && !next.domAtom) return next.domFromPos(0, side);
            return {
                node: this.contentDOM,
                offset: next ? $b4450e5745e49325$var$domIndex(next.dom) : this.contentDOM.childNodes.length
            };
        }
    }
    // Used to find a DOM range in a single parent for a given changed
    // range.
    parseRange(from, to, base = 0) {
        if (this.children.length == 0) return {
            node: this.contentDOM,
            from: from,
            to: to,
            fromOffset: 0,
            toOffset: this.contentDOM.childNodes.length
        };
        let fromOffset = -1, toOffset = -1;
        for(let offset = base, i = 0;; i++){
            let child = this.children[i], end = offset + child.size;
            if (fromOffset == -1 && from <= end) {
                let childBase = offset + child.border;
                // FIXME maybe descend mark views to parse a narrower range?
                if (from >= childBase && to <= end - child.border && child.node && child.contentDOM && this.contentDOM.contains(child.contentDOM)) return child.parseRange(from, to, childBase);
                from = offset;
                for(let j = i; j > 0; j--){
                    let prev = this.children[j - 1];
                    if (prev.size && prev.dom.parentNode == this.contentDOM && !prev.emptyChildAt(1)) {
                        fromOffset = $b4450e5745e49325$var$domIndex(prev.dom) + 1;
                        break;
                    }
                    from -= prev.size;
                }
                if (fromOffset == -1) fromOffset = 0;
            }
            if (fromOffset > -1 && (end > to || i == this.children.length - 1)) {
                to = end;
                for(let j = i + 1; j < this.children.length; j++){
                    let next = this.children[j];
                    if (next.size && next.dom.parentNode == this.contentDOM && !next.emptyChildAt(-1)) {
                        toOffset = $b4450e5745e49325$var$domIndex(next.dom);
                        break;
                    }
                    to += next.size;
                }
                if (toOffset == -1) toOffset = this.contentDOM.childNodes.length;
                break;
            }
            offset = end;
        }
        return {
            node: this.contentDOM,
            from: from,
            to: to,
            fromOffset: fromOffset,
            toOffset: toOffset
        };
    }
    emptyChildAt(side) {
        if (this.border || !this.contentDOM || !this.children.length) return false;
        let child = this.children[side < 0 ? 0 : this.children.length - 1];
        return child.size == 0 || child.emptyChildAt(side);
    }
    domAfterPos(pos) {
        let { node: node, offset: offset } = this.domFromPos(pos, 0);
        if (node.nodeType != 1 || offset == node.childNodes.length) throw new RangeError("No node after pos " + pos);
        return node.childNodes[offset];
    }
    // View descs are responsible for setting any selection that falls
    // entirely inside of them, so that custom implementations can do
    // custom things with the selection. Note that this falls apart when
    // a selection starts in such a node and ends in another, in which
    // case we just use whatever domFromPos produces as a best effort.
    setSelection(anchor, head, view, force = false) {
        // If the selection falls entirely in a child, give it to that child
        let from = Math.min(anchor, head), to = Math.max(anchor, head);
        for(let i = 0, offset = 0; i < this.children.length; i++){
            let child = this.children[i], end = offset + child.size;
            if (from > offset && to < end) return child.setSelection(anchor - offset - child.border, head - offset - child.border, view, force);
            offset = end;
        }
        let anchorDOM = this.domFromPos(anchor, anchor ? -1 : 1);
        let headDOM = head == anchor ? anchorDOM : this.domFromPos(head, head ? -1 : 1);
        let domSel = view.root.getSelection();
        let selRange = view.domSelectionRange();
        let brKludge = false;
        // On Firefox, using Selection.collapse to put the cursor after a
        // BR node for some reason doesn't always work (#1073). On Safari,
        // the cursor sometimes inexplicable visually lags behind its
        // reported position in such situations (#1092).
        if (($b4450e5745e49325$var$gecko || $b4450e5745e49325$var$safari) && anchor == head) {
            let { node: node, offset: offset } = anchorDOM;
            if (node.nodeType == 3) {
                brKludge = !!(offset && node.nodeValue[offset - 1] == "\n");
                // Issue #1128
                if (brKludge && offset == node.nodeValue.length) for(let scan = node, after; scan; scan = scan.parentNode){
                    if (after = scan.nextSibling) {
                        if (after.nodeName == "BR") anchorDOM = headDOM = {
                            node: after.parentNode,
                            offset: $b4450e5745e49325$var$domIndex(after) + 1
                        };
                        break;
                    }
                    let desc = scan.pmViewDesc;
                    if (desc && desc.node && desc.node.isBlock) break;
                }
            } else {
                let prev = node.childNodes[offset - 1];
                brKludge = prev && (prev.nodeName == "BR" || prev.contentEditable == "false");
            }
        }
        // Firefox can act strangely when the selection is in front of an
        // uneditable node. See #1163 and https://bugzilla.mozilla.org/show_bug.cgi?id=1709536
        if ($b4450e5745e49325$var$gecko && selRange.focusNode && selRange.focusNode != headDOM.node && selRange.focusNode.nodeType == 1) {
            let after = selRange.focusNode.childNodes[selRange.focusOffset];
            if (after && after.contentEditable == "false") force = true;
        }
        if (!(force || brKludge && $b4450e5745e49325$var$safari) && $b4450e5745e49325$var$isEquivalentPosition(anchorDOM.node, anchorDOM.offset, selRange.anchorNode, selRange.anchorOffset) && $b4450e5745e49325$var$isEquivalentPosition(headDOM.node, headDOM.offset, selRange.focusNode, selRange.focusOffset)) return;
        // Selection.extend can be used to create an 'inverted' selection
        // (one where the focus is before the anchor), but not all
        // browsers support it yet.
        let domSelExtended = false;
        if ((domSel.extend || anchor == head) && !brKludge) {
            domSel.collapse(anchorDOM.node, anchorDOM.offset);
            try {
                if (anchor != head) domSel.extend(headDOM.node, headDOM.offset);
                domSelExtended = true;
            } catch (_) {
            // In some cases with Chrome the selection is empty after calling
            // collapse, even when it should be valid. This appears to be a bug, but
            // it is difficult to isolate. If this happens fallback to the old path
            // without using extend.
            // Similarly, this could crash on Safari if the editor is hidden, and
            // there was no selection.
            }
        }
        if (!domSelExtended) {
            if (anchor > head) {
                let tmp = anchorDOM;
                anchorDOM = headDOM;
                headDOM = tmp;
            }
            let range = document.createRange();
            range.setEnd(headDOM.node, headDOM.offset);
            range.setStart(anchorDOM.node, anchorDOM.offset);
            domSel.removeAllRanges();
            domSel.addRange(range);
        }
    }
    ignoreMutation(mutation) {
        return !this.contentDOM && mutation.type != "selection";
    }
    get contentLost() {
        return this.contentDOM && this.contentDOM != this.dom && !this.dom.contains(this.contentDOM);
    }
    // Remove a subtree of the element tree that has been touched
    // by a DOM change, so that the next update will redraw it.
    markDirty(from, to) {
        for(let offset = 0, i = 0; i < this.children.length; i++){
            let child = this.children[i], end = offset + child.size;
            if (offset == end ? from <= end && to >= offset : from < end && to > offset) {
                let startInside = offset + child.border, endInside = end - child.border;
                if (from >= startInside && to <= endInside) {
                    this.dirty = from == offset || to == end ? $b4450e5745e49325$var$CONTENT_DIRTY : $b4450e5745e49325$var$CHILD_DIRTY;
                    if (from == startInside && to == endInside && (child.contentLost || child.dom.parentNode != this.contentDOM)) child.dirty = $b4450e5745e49325$var$NODE_DIRTY;
                    else child.markDirty(from - startInside, to - startInside);
                    return;
                } else child.dirty = child.dom == child.contentDOM && child.dom.parentNode == this.contentDOM && !child.children.length ? $b4450e5745e49325$var$CONTENT_DIRTY : $b4450e5745e49325$var$NODE_DIRTY;
            }
            offset = end;
        }
        this.dirty = $b4450e5745e49325$var$CONTENT_DIRTY;
    }
    markParentsDirty() {
        let level = 1;
        for(let node = this.parent; node; node = node.parent, level++){
            let dirty = level == 1 ? $b4450e5745e49325$var$CONTENT_DIRTY : $b4450e5745e49325$var$CHILD_DIRTY;
            if (node.dirty < dirty) node.dirty = dirty;
        }
    }
    get domAtom() {
        return false;
    }
    get ignoreForCoords() {
        return false;
    }
    isText(text) {
        return false;
    }
    constructor(parent, children, dom, // This is the node that holds the child views. It may be null for
    // descs that don't have children.
    contentDOM){
        this.parent = parent;
        this.children = children;
        this.dom = dom;
        this.contentDOM = contentDOM;
        this.dirty = $b4450e5745e49325$var$NOT_DIRTY;
        // An expando property on the DOM node provides a link back to its
        // description.
        dom.pmViewDesc = this;
    }
}
// A widget desc represents a widget decoration, which is a DOM node
// drawn between the document nodes.
class $b4450e5745e49325$var$WidgetViewDesc extends $b4450e5745e49325$var$ViewDesc {
    matchesWidget(widget) {
        return this.dirty == $b4450e5745e49325$var$NOT_DIRTY && widget.type.eq(this.widget.type);
    }
    parseRule() {
        return {
            ignore: true
        };
    }
    stopEvent(event) {
        let stop = this.widget.spec.stopEvent;
        return stop ? stop(event) : false;
    }
    ignoreMutation(mutation) {
        return mutation.type != "selection" || this.widget.spec.ignoreSelection;
    }
    destroy() {
        this.widget.type.destroy(this.dom);
        super.destroy();
    }
    get domAtom() {
        return true;
    }
    get side() {
        return this.widget.type.side;
    }
    constructor(parent, widget, view, pos){
        let self, dom = widget.type.toDOM;
        if (typeof dom == "function") dom = dom(view, ()=>{
            if (!self) return pos;
            if (self.parent) return self.parent.posBeforeChild(self);
        });
        if (!widget.type.spec.raw) {
            if (dom.nodeType != 1) {
                let wrap = document.createElement("span");
                wrap.appendChild(dom);
                dom = wrap;
            }
            dom.contentEditable = "false";
            dom.classList.add("ProseMirror-widget");
        }
        super(parent, [], dom, null);
        this.widget = widget;
        this.widget = widget;
        self = this;
    }
}
class $b4450e5745e49325$var$CompositionViewDesc extends $b4450e5745e49325$var$ViewDesc {
    get size() {
        return this.text.length;
    }
    localPosFromDOM(dom, offset) {
        if (dom != this.textDOM) return this.posAtStart + (offset ? this.size : 0);
        return this.posAtStart + offset;
    }
    domFromPos(pos) {
        return {
            node: this.textDOM,
            offset: pos
        };
    }
    ignoreMutation(mut) {
        return mut.type === 'characterData' && mut.target.nodeValue == mut.oldValue;
    }
    constructor(parent, dom, textDOM, text){
        super(parent, [], dom, null);
        this.textDOM = textDOM;
        this.text = text;
    }
}
// A mark desc represents a mark. May have multiple children,
// depending on how the mark is split. Note that marks are drawn using
// a fixed nesting order, for simplicity and predictability, so in
// some cases they will be split more often than would appear
// necessary.
class $b4450e5745e49325$var$MarkViewDesc extends $b4450e5745e49325$var$ViewDesc {
    static create(parent, mark, inline, view) {
        let custom = view.nodeViews[mark.type.name];
        let spec = custom && custom(mark, view, inline);
        if (!spec || !spec.dom) spec = (0, $5SAOw.DOMSerializer).renderSpec(document, mark.type.spec.toDOM(mark, inline), null, mark.attrs);
        return new $b4450e5745e49325$var$MarkViewDesc(parent, mark, spec.dom, spec.contentDOM || spec.dom, spec);
    }
    parseRule() {
        if (this.dirty & $b4450e5745e49325$var$NODE_DIRTY || this.mark.type.spec.reparseInView) return null;
        return {
            mark: this.mark.type.name,
            attrs: this.mark.attrs,
            contentElement: this.contentDOM
        };
    }
    matchesMark(mark) {
        return this.dirty != $b4450e5745e49325$var$NODE_DIRTY && this.mark.eq(mark);
    }
    markDirty(from, to) {
        super.markDirty(from, to);
        // Move dirty info to nearest node view
        if (this.dirty != $b4450e5745e49325$var$NOT_DIRTY) {
            let parent = this.parent;
            while(!parent.node)parent = parent.parent;
            if (parent.dirty < this.dirty) parent.dirty = this.dirty;
            this.dirty = $b4450e5745e49325$var$NOT_DIRTY;
        }
    }
    slice(from, to, view) {
        let copy = $b4450e5745e49325$var$MarkViewDesc.create(this.parent, this.mark, true, view);
        let nodes = this.children, size = this.size;
        if (to < size) nodes = $b4450e5745e49325$var$replaceNodes(nodes, to, size, view);
        if (from > 0) nodes = $b4450e5745e49325$var$replaceNodes(nodes, 0, from, view);
        for(let i = 0; i < nodes.length; i++)nodes[i].parent = copy;
        copy.children = nodes;
        return copy;
    }
    ignoreMutation(mutation) {
        return this.spec.ignoreMutation ? this.spec.ignoreMutation(mutation) : super.ignoreMutation(mutation);
    }
    destroy() {
        if (this.spec.destroy) this.spec.destroy();
        super.destroy();
    }
    constructor(parent, mark, dom, contentDOM, spec){
        super(parent, [], dom, contentDOM);
        this.mark = mark;
        this.spec = spec;
    }
}
// Node view descs are the main, most common type of view desc, and
// correspond to an actual node in the document. Unlike mark descs,
// they populate their child array themselves.
class $b4450e5745e49325$var$NodeViewDesc extends $b4450e5745e49325$var$ViewDesc {
    // By default, a node is rendered using the `toDOM` method from the
    // node type spec. But client code can use the `nodeViews` spec to
    // supply a custom node view, which can influence various aspects of
    // the way the node works.
    //
    // (Using subclassing for this was intentionally decided against,
    // since it'd require exposing a whole slew of finicky
    // implementation details to the user code that they probably will
    // never need.)
    static create(parent, node, outerDeco, innerDeco, view, pos) {
        let custom = view.nodeViews[node.type.name], descObj;
        let spec = custom && custom(node, view, ()=>{
            // (This is a function that allows the custom view to find its
            // own position)
            if (!descObj) return pos;
            if (descObj.parent) return descObj.parent.posBeforeChild(descObj);
        }, outerDeco, innerDeco);
        let dom = spec && spec.dom, contentDOM = spec && spec.contentDOM;
        if (node.isText) {
            if (!dom) dom = document.createTextNode(node.text);
            else if (dom.nodeType != 3) throw new RangeError("Text must be rendered as a DOM text node");
        } else if (!dom) {
            let spec = (0, $5SAOw.DOMSerializer).renderSpec(document, node.type.spec.toDOM(node), null, node.attrs);
            ({ dom: dom, contentDOM: contentDOM } = spec);
        }
        if (!contentDOM && !node.isText && dom.nodeName != "BR") {
            if (!dom.hasAttribute("contenteditable")) dom.contentEditable = "false";
            if (node.type.spec.draggable) dom.draggable = true;
        }
        let nodeDOM = dom;
        dom = $b4450e5745e49325$var$applyOuterDeco(dom, outerDeco, node);
        if (spec) return descObj = new $b4450e5745e49325$var$CustomNodeViewDesc(parent, node, outerDeco, innerDeco, dom, contentDOM || null, nodeDOM, spec, view, pos + 1);
        else if (node.isText) return new $b4450e5745e49325$var$TextViewDesc(parent, node, outerDeco, innerDeco, dom, nodeDOM, view);
        else return new $b4450e5745e49325$var$NodeViewDesc(parent, node, outerDeco, innerDeco, dom, contentDOM || null, nodeDOM, view, pos + 1);
    }
    parseRule() {
        // Experimental kludge to allow opt-in re-parsing of nodes
        if (this.node.type.spec.reparseInView) return null;
        // FIXME the assumption that this can always return the current
        // attrs means that if the user somehow manages to change the
        // attrs in the dom, that won't be picked up. Not entirely sure
        // whether this is a problem
        let rule = {
            node: this.node.type.name,
            attrs: this.node.attrs
        };
        if (this.node.type.whitespace == "pre") rule.preserveWhitespace = "full";
        if (!this.contentDOM) rule.getContent = ()=>this.node.content;
        else if (!this.contentLost) rule.contentElement = this.contentDOM;
        else {
            // Chrome likes to randomly recreate parent nodes when
            // backspacing things. When that happens, this tries to find the
            // new parent.
            for(let i = this.children.length - 1; i >= 0; i--){
                let child = this.children[i];
                if (this.dom.contains(child.dom.parentNode)) {
                    rule.contentElement = child.dom.parentNode;
                    break;
                }
            }
            if (!rule.contentElement) rule.getContent = ()=>(0, $5SAOw.Fragment).empty;
        }
        return rule;
    }
    matchesNode(node, outerDeco, innerDeco) {
        return this.dirty == $b4450e5745e49325$var$NOT_DIRTY && node.eq(this.node) && $b4450e5745e49325$var$sameOuterDeco(outerDeco, this.outerDeco) && innerDeco.eq(this.innerDeco);
    }
    get size() {
        return this.node.nodeSize;
    }
    get border() {
        return this.node.isLeaf ? 0 : 1;
    }
    // Syncs `this.children` to match `this.node.content` and the local
    // decorations, possibly introducing nesting for marks. Then, in a
    // separate step, syncs the DOM inside `this.contentDOM` to
    // `this.children`.
    updateChildren(view, pos) {
        let inline = this.node.inlineContent, off = pos;
        let composition = view.composing ? this.localCompositionInfo(view, pos) : null;
        let localComposition = composition && composition.pos > -1 ? composition : null;
        let compositionInChild = composition && composition.pos < 0;
        let updater = new $b4450e5745e49325$var$ViewTreeUpdater(this, localComposition && localComposition.node, view);
        $b4450e5745e49325$var$iterDeco(this.node, this.innerDeco, (widget, i, insideNode)=>{
            if (widget.spec.marks) updater.syncToMarks(widget.spec.marks, inline, view);
            else if (widget.type.side >= 0 && !insideNode) updater.syncToMarks(i == this.node.childCount ? (0, $5SAOw.Mark).none : this.node.child(i).marks, inline, view);
            // If the next node is a desc matching this widget, reuse it,
            // otherwise insert the widget as a new view desc.
            updater.placeWidget(widget, view, off);
        }, (child, outerDeco, innerDeco, i)=>{
            // Make sure the wrapping mark descs match the node's marks.
            updater.syncToMarks(child.marks, inline, view);
            // Try several strategies for drawing this node
            let compIndex;
            if (updater.findNodeMatch(child, outerDeco, innerDeco, i)) ;
            else if (compositionInChild && view.state.selection.from > off && view.state.selection.to < off + child.nodeSize && (compIndex = updater.findIndexWithChild(composition.node)) > -1 && updater.updateNodeAt(child, outerDeco, innerDeco, compIndex, view)) ;
            else if (updater.updateNextNode(child, outerDeco, innerDeco, view, i, off)) ;
            else // Add it as a new view
            updater.addNode(child, outerDeco, innerDeco, view, off);
            off += child.nodeSize;
        });
        // Drop all remaining descs after the current position.
        updater.syncToMarks([], inline, view);
        if (this.node.isTextblock) updater.addTextblockHacks();
        updater.destroyRest();
        // Sync the DOM if anything changed
        if (updater.changed || this.dirty == $b4450e5745e49325$var$CONTENT_DIRTY) {
            // May have to protect focused DOM from being changed if a composition is active
            if (localComposition) this.protectLocalComposition(view, localComposition);
            $b4450e5745e49325$var$renderDescs(this.contentDOM, this.children, view);
            if ($b4450e5745e49325$var$ios) $b4450e5745e49325$var$iosHacks(this.dom);
        }
    }
    localCompositionInfo(view, pos) {
        // Only do something if both the selection and a focused text node
        // are inside of this node
        let { from: from, to: to } = view.state.selection;
        if (!(view.state.selection instanceof (0, $ks2lK.TextSelection)) || from < pos || to > pos + this.node.content.size) return null;
        let textNode = view.input.compositionNode;
        if (!textNode || !this.dom.contains(textNode.parentNode)) return null;
        if (this.node.inlineContent) {
            // Find the text in the focused node in the node, stop if it's not
            // there (may have been modified through other means, in which
            // case it should overwritten)
            let text = textNode.nodeValue;
            let textPos = $b4450e5745e49325$var$findTextInFragment(this.node.content, text, from - pos, to - pos);
            return textPos < 0 ? null : {
                node: textNode,
                pos: textPos,
                text: text
            };
        } else return {
            node: textNode,
            pos: -1,
            text: ""
        };
    }
    protectLocalComposition(view, { node: node, pos: pos, text: text }) {
        // The node is already part of a local view desc, leave it there
        if (this.getDesc(node)) return;
        // Create a composition view for the orphaned nodes
        let topNode = node;
        for(;; topNode = topNode.parentNode){
            if (topNode.parentNode == this.contentDOM) break;
            while(topNode.previousSibling)topNode.parentNode.removeChild(topNode.previousSibling);
            while(topNode.nextSibling)topNode.parentNode.removeChild(topNode.nextSibling);
            if (topNode.pmViewDesc) topNode.pmViewDesc = undefined;
        }
        let desc = new $b4450e5745e49325$var$CompositionViewDesc(this, topNode, node, text);
        view.input.compositionNodes.push(desc);
        // Patch up this.children to contain the composition view
        this.children = $b4450e5745e49325$var$replaceNodes(this.children, pos, pos + text.length, view, desc);
    }
    // If this desc must be updated to match the given node decoration,
    // do so and return true.
    update(node, outerDeco, innerDeco, view) {
        if (this.dirty == $b4450e5745e49325$var$NODE_DIRTY || !node.sameMarkup(this.node)) return false;
        this.updateInner(node, outerDeco, innerDeco, view);
        return true;
    }
    updateInner(node, outerDeco, innerDeco, view) {
        this.updateOuterDeco(outerDeco);
        this.node = node;
        this.innerDeco = innerDeco;
        if (this.contentDOM) this.updateChildren(view, this.posAtStart);
        this.dirty = $b4450e5745e49325$var$NOT_DIRTY;
    }
    updateOuterDeco(outerDeco) {
        if ($b4450e5745e49325$var$sameOuterDeco(outerDeco, this.outerDeco)) return;
        let needsWrap = this.nodeDOM.nodeType != 1;
        let oldDOM = this.dom;
        this.dom = $b4450e5745e49325$var$patchOuterDeco(this.dom, this.nodeDOM, $b4450e5745e49325$var$computeOuterDeco(this.outerDeco, this.node, needsWrap), $b4450e5745e49325$var$computeOuterDeco(outerDeco, this.node, needsWrap));
        if (this.dom != oldDOM) {
            oldDOM.pmViewDesc = undefined;
            this.dom.pmViewDesc = this;
        }
        this.outerDeco = outerDeco;
    }
    // Mark this node as being the selected node.
    selectNode() {
        if (this.nodeDOM.nodeType == 1) this.nodeDOM.classList.add("ProseMirror-selectednode");
        if (this.contentDOM || !this.node.type.spec.draggable) this.dom.draggable = true;
    }
    // Remove selected node marking from this node.
    deselectNode() {
        if (this.nodeDOM.nodeType == 1) {
            this.nodeDOM.classList.remove("ProseMirror-selectednode");
            if (this.contentDOM || !this.node.type.spec.draggable) this.dom.removeAttribute("draggable");
        }
    }
    get domAtom() {
        return this.node.isAtom;
    }
    constructor(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, view, pos){
        super(parent, [], dom, contentDOM);
        this.node = node;
        this.outerDeco = outerDeco;
        this.innerDeco = innerDeco;
        this.nodeDOM = nodeDOM;
    }
}
// Create a view desc for the top-level document node, to be exported
// and used by the view class.
function $b4450e5745e49325$var$docViewDesc(doc, outerDeco, innerDeco, dom, view) {
    $b4450e5745e49325$var$applyOuterDeco(dom, outerDeco, doc);
    let docView = new $b4450e5745e49325$var$NodeViewDesc(undefined, doc, outerDeco, innerDeco, dom, dom, dom, view, 0);
    if (docView.contentDOM) docView.updateChildren(view, 0);
    return docView;
}
class $b4450e5745e49325$var$TextViewDesc extends $b4450e5745e49325$var$NodeViewDesc {
    parseRule() {
        let skip = this.nodeDOM.parentNode;
        while(skip && skip != this.dom && !skip.pmIsDeco)skip = skip.parentNode;
        return {
            skip: skip || true
        };
    }
    update(node, outerDeco, innerDeco, view) {
        if (this.dirty == $b4450e5745e49325$var$NODE_DIRTY || this.dirty != $b4450e5745e49325$var$NOT_DIRTY && !this.inParent() || !node.sameMarkup(this.node)) return false;
        this.updateOuterDeco(outerDeco);
        if ((this.dirty != $b4450e5745e49325$var$NOT_DIRTY || node.text != this.node.text) && node.text != this.nodeDOM.nodeValue) {
            this.nodeDOM.nodeValue = node.text;
            if (view.trackWrites == this.nodeDOM) view.trackWrites = null;
        }
        this.node = node;
        this.dirty = $b4450e5745e49325$var$NOT_DIRTY;
        return true;
    }
    inParent() {
        let parentDOM = this.parent.contentDOM;
        for(let n = this.nodeDOM; n; n = n.parentNode)if (n == parentDOM) return true;
        return false;
    }
    domFromPos(pos) {
        return {
            node: this.nodeDOM,
            offset: pos
        };
    }
    localPosFromDOM(dom, offset, bias) {
        if (dom == this.nodeDOM) return this.posAtStart + Math.min(offset, this.node.text.length);
        return super.localPosFromDOM(dom, offset, bias);
    }
    ignoreMutation(mutation) {
        return mutation.type != "characterData" && mutation.type != "selection";
    }
    slice(from, to, view) {
        let node = this.node.cut(from, to), dom = document.createTextNode(node.text);
        return new $b4450e5745e49325$var$TextViewDesc(this.parent, node, this.outerDeco, this.innerDeco, dom, dom, view);
    }
    markDirty(from, to) {
        super.markDirty(from, to);
        if (this.dom != this.nodeDOM && (from == 0 || to == this.nodeDOM.nodeValue.length)) this.dirty = $b4450e5745e49325$var$NODE_DIRTY;
    }
    get domAtom() {
        return false;
    }
    isText(text) {
        return this.node.text == text;
    }
    constructor(parent, node, outerDeco, innerDeco, dom, nodeDOM, view){
        super(parent, node, outerDeco, innerDeco, dom, null, nodeDOM, view, 0);
    }
}
// A dummy desc used to tag trailing BR or IMG nodes created to work
// around contentEditable terribleness.
class $b4450e5745e49325$var$TrailingHackViewDesc extends $b4450e5745e49325$var$ViewDesc {
    parseRule() {
        return {
            ignore: true
        };
    }
    matchesHack(nodeName) {
        return this.dirty == $b4450e5745e49325$var$NOT_DIRTY && this.dom.nodeName == nodeName;
    }
    get domAtom() {
        return true;
    }
    get ignoreForCoords() {
        return this.dom.nodeName == "IMG";
    }
}
// A separate subclass is used for customized node views, so that the
// extra checks only have to be made for nodes that are actually
// customized.
class $b4450e5745e49325$var$CustomNodeViewDesc extends $b4450e5745e49325$var$NodeViewDesc {
    // A custom `update` method gets to decide whether the update goes
    // through. If it does, and there's a `contentDOM` node, our logic
    // updates the children.
    update(node, outerDeco, innerDeco, view) {
        if (this.dirty == $b4450e5745e49325$var$NODE_DIRTY) return false;
        if (this.spec.update && (this.node.type == node.type || this.spec.multiType)) {
            let result = this.spec.update(node, outerDeco, innerDeco);
            if (result) this.updateInner(node, outerDeco, innerDeco, view);
            return result;
        } else if (!this.contentDOM && !node.isLeaf) return false;
        else return super.update(node, outerDeco, innerDeco, view);
    }
    selectNode() {
        this.spec.selectNode ? this.spec.selectNode() : super.selectNode();
    }
    deselectNode() {
        this.spec.deselectNode ? this.spec.deselectNode() : super.deselectNode();
    }
    setSelection(anchor, head, view, force) {
        this.spec.setSelection ? this.spec.setSelection(anchor, head, view.root) : super.setSelection(anchor, head, view, force);
    }
    destroy() {
        if (this.spec.destroy) this.spec.destroy();
        super.destroy();
    }
    stopEvent(event) {
        return this.spec.stopEvent ? this.spec.stopEvent(event) : false;
    }
    ignoreMutation(mutation) {
        return this.spec.ignoreMutation ? this.spec.ignoreMutation(mutation) : super.ignoreMutation(mutation);
    }
    constructor(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, spec, view, pos){
        super(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, view, pos);
        this.spec = spec;
    }
}
// Sync the content of the given DOM node with the nodes associated
// with the given array of view descs, recursing into mark descs
// because this should sync the subtree for a whole node at a time.
function $b4450e5745e49325$var$renderDescs(parentDOM, descs, view) {
    let dom = parentDOM.firstChild, written = false;
    for(let i = 0; i < descs.length; i++){
        let desc = descs[i], childDOM = desc.dom;
        if (childDOM.parentNode == parentDOM) {
            while(childDOM != dom){
                dom = $b4450e5745e49325$var$rm(dom);
                written = true;
            }
            dom = dom.nextSibling;
        } else {
            written = true;
            parentDOM.insertBefore(childDOM, dom);
        }
        if (desc instanceof $b4450e5745e49325$var$MarkViewDesc) {
            let pos = dom ? dom.previousSibling : parentDOM.lastChild;
            $b4450e5745e49325$var$renderDescs(desc.contentDOM, desc.children, view);
            dom = pos ? pos.nextSibling : parentDOM.firstChild;
        }
    }
    while(dom){
        dom = $b4450e5745e49325$var$rm(dom);
        written = true;
    }
    if (written && view.trackWrites == parentDOM) view.trackWrites = null;
}
const $b4450e5745e49325$var$OuterDecoLevel = function(nodeName) {
    if (nodeName) this.nodeName = nodeName;
};
$b4450e5745e49325$var$OuterDecoLevel.prototype = Object.create(null);
const $b4450e5745e49325$var$noDeco = [
    new $b4450e5745e49325$var$OuterDecoLevel
];
function $b4450e5745e49325$var$computeOuterDeco(outerDeco, node, needsWrap) {
    if (outerDeco.length == 0) return $b4450e5745e49325$var$noDeco;
    let top = needsWrap ? $b4450e5745e49325$var$noDeco[0] : new $b4450e5745e49325$var$OuterDecoLevel, result = [
        top
    ];
    for(let i = 0; i < outerDeco.length; i++){
        let attrs = outerDeco[i].type.attrs;
        if (!attrs) continue;
        if (attrs.nodeName) result.push(top = new $b4450e5745e49325$var$OuterDecoLevel(attrs.nodeName));
        for(let name in attrs){
            let val = attrs[name];
            if (val == null) continue;
            if (needsWrap && result.length == 1) result.push(top = new $b4450e5745e49325$var$OuterDecoLevel(node.isInline ? "span" : "div"));
            if (name == "class") top.class = (top.class ? top.class + " " : "") + val;
            else if (name == "style") top.style = (top.style ? top.style + ";" : "") + val;
            else if (name != "nodeName") top[name] = val;
        }
    }
    return result;
}
function $b4450e5745e49325$var$patchOuterDeco(outerDOM, nodeDOM, prevComputed, curComputed) {
    // Shortcut for trivial case
    if (prevComputed == $b4450e5745e49325$var$noDeco && curComputed == $b4450e5745e49325$var$noDeco) return nodeDOM;
    let curDOM = nodeDOM;
    for(let i = 0; i < curComputed.length; i++){
        let deco = curComputed[i], prev = prevComputed[i];
        if (i) {
            let parent;
            if (prev && prev.nodeName == deco.nodeName && curDOM != outerDOM && (parent = curDOM.parentNode) && parent.nodeName.toLowerCase() == deco.nodeName) curDOM = parent;
            else {
                parent = document.createElement(deco.nodeName);
                parent.pmIsDeco = true;
                parent.appendChild(curDOM);
                prev = $b4450e5745e49325$var$noDeco[0];
                curDOM = parent;
            }
        }
        $b4450e5745e49325$var$patchAttributes(curDOM, prev || $b4450e5745e49325$var$noDeco[0], deco);
    }
    return curDOM;
}
function $b4450e5745e49325$var$patchAttributes(dom, prev, cur) {
    for(let name in prev)if (name != "class" && name != "style" && name != "nodeName" && !(name in cur)) dom.removeAttribute(name);
    for(let name in cur)if (name != "class" && name != "style" && name != "nodeName" && cur[name] != prev[name]) dom.setAttribute(name, cur[name]);
    if (prev.class != cur.class) {
        let prevList = prev.class ? prev.class.split(" ").filter(Boolean) : [];
        let curList = cur.class ? cur.class.split(" ").filter(Boolean) : [];
        for(let i = 0; i < prevList.length; i++)if (curList.indexOf(prevList[i]) == -1) dom.classList.remove(prevList[i]);
        for(let i = 0; i < curList.length; i++)if (prevList.indexOf(curList[i]) == -1) dom.classList.add(curList[i]);
        if (dom.classList.length == 0) dom.removeAttribute("class");
    }
    if (prev.style != cur.style) {
        if (prev.style) {
            let prop = /\s*([\w\-\xa1-\uffff]+)\s*:(?:"(?:\\.|[^"])*"|'(?:\\.|[^'])*'|\(.*?\)|[^;])*/g, m;
            while(m = prop.exec(prev.style))dom.style.removeProperty(m[1]);
        }
        if (cur.style) dom.style.cssText += cur.style;
    }
}
function $b4450e5745e49325$var$applyOuterDeco(dom, deco, node) {
    return $b4450e5745e49325$var$patchOuterDeco(dom, dom, $b4450e5745e49325$var$noDeco, $b4450e5745e49325$var$computeOuterDeco(deco, node, dom.nodeType != 1));
}
function $b4450e5745e49325$var$sameOuterDeco(a, b) {
    if (a.length != b.length) return false;
    for(let i = 0; i < a.length; i++)if (!a[i].type.eq(b[i].type)) return false;
    return true;
}
// Remove a DOM node and return its next sibling.
function $b4450e5745e49325$var$rm(dom) {
    let next = dom.nextSibling;
    dom.parentNode.removeChild(dom);
    return next;
}
// Helper class for incrementally updating a tree of mark descs and
// the widget and node descs inside of them.
class $b4450e5745e49325$var$ViewTreeUpdater {
    // Destroy and remove the children between the given indices in
    // `this.top`.
    destroyBetween(start, end) {
        if (start == end) return;
        for(let i = start; i < end; i++)this.top.children[i].destroy();
        this.top.children.splice(start, end - start);
        this.changed = true;
    }
    // Destroy all remaining children in `this.top`.
    destroyRest() {
        this.destroyBetween(this.index, this.top.children.length);
    }
    // Sync the current stack of mark descs with the given array of
    // marks, reusing existing mark descs when possible.
    syncToMarks(marks, inline, view) {
        let keep = 0, depth = this.stack.length >> 1;
        let maxKeep = Math.min(depth, marks.length);
        while(keep < maxKeep && (keep == depth - 1 ? this.top : this.stack[keep + 1 << 1]).matchesMark(marks[keep]) && marks[keep].type.spec.spanning !== false)keep++;
        while(keep < depth){
            this.destroyRest();
            this.top.dirty = $b4450e5745e49325$var$NOT_DIRTY;
            this.index = this.stack.pop();
            this.top = this.stack.pop();
            depth--;
        }
        while(depth < marks.length){
            this.stack.push(this.top, this.index + 1);
            let found = -1;
            for(let i = this.index; i < Math.min(this.index + 3, this.top.children.length); i++){
                let next = this.top.children[i];
                if (next.matchesMark(marks[depth]) && !this.isLocked(next.dom)) {
                    found = i;
                    break;
                }
            }
            if (found > -1) {
                if (found > this.index) {
                    this.changed = true;
                    this.destroyBetween(this.index, found);
                }
                this.top = this.top.children[this.index];
            } else {
                let markDesc = $b4450e5745e49325$var$MarkViewDesc.create(this.top, marks[depth], inline, view);
                this.top.children.splice(this.index, 0, markDesc);
                this.top = markDesc;
                this.changed = true;
            }
            this.index = 0;
            depth++;
        }
    }
    // Try to find a node desc matching the given data. Skip over it and
    // return true when successful.
    findNodeMatch(node, outerDeco, innerDeco, index) {
        let found = -1, targetDesc;
        if (index >= this.preMatch.index && (targetDesc = this.preMatch.matches[index - this.preMatch.index]).parent == this.top && targetDesc.matchesNode(node, outerDeco, innerDeco)) found = this.top.children.indexOf(targetDesc, this.index);
        else for(let i = this.index, e = Math.min(this.top.children.length, i + 5); i < e; i++){
            let child = this.top.children[i];
            if (child.matchesNode(node, outerDeco, innerDeco) && !this.preMatch.matched.has(child)) {
                found = i;
                break;
            }
        }
        if (found < 0) return false;
        this.destroyBetween(this.index, found);
        this.index++;
        return true;
    }
    updateNodeAt(node, outerDeco, innerDeco, index, view) {
        let child = this.top.children[index];
        if (child.dirty == $b4450e5745e49325$var$NODE_DIRTY && child.dom == child.contentDOM) child.dirty = $b4450e5745e49325$var$CONTENT_DIRTY;
        if (!child.update(node, outerDeco, innerDeco, view)) return false;
        this.destroyBetween(this.index, index);
        this.index++;
        return true;
    }
    findIndexWithChild(domNode) {
        for(;;){
            let parent = domNode.parentNode;
            if (!parent) return -1;
            if (parent == this.top.contentDOM) {
                let desc = domNode.pmViewDesc;
                if (desc) for(let i = this.index; i < this.top.children.length; i++){
                    if (this.top.children[i] == desc) return i;
                }
                return -1;
            }
            domNode = parent;
        }
    }
    // Try to update the next node, if any, to the given data. Checks
    // pre-matches to avoid overwriting nodes that could still be used.
    updateNextNode(node, outerDeco, innerDeco, view, index, pos) {
        for(let i = this.index; i < this.top.children.length; i++){
            let next = this.top.children[i];
            if (next instanceof $b4450e5745e49325$var$NodeViewDesc) {
                let preMatch = this.preMatch.matched.get(next);
                if (preMatch != null && preMatch != index) return false;
                let nextDOM = next.dom, updated;
                // Can't update if nextDOM is or contains this.lock, except if
                // it's a text node whose content already matches the new text
                // and whose decorations match the new ones.
                let locked = this.isLocked(nextDOM) && !(node.isText && next.node && next.node.isText && next.nodeDOM.nodeValue == node.text && next.dirty != $b4450e5745e49325$var$NODE_DIRTY && $b4450e5745e49325$var$sameOuterDeco(outerDeco, next.outerDeco));
                if (!locked && next.update(node, outerDeco, innerDeco, view)) {
                    this.destroyBetween(this.index, i);
                    if (next.dom != nextDOM) this.changed = true;
                    this.index++;
                    return true;
                } else if (!locked && (updated = this.recreateWrapper(next, node, outerDeco, innerDeco, view, pos))) {
                    this.destroyBetween(this.index, i);
                    this.top.children[this.index] = updated;
                    if (updated.contentDOM) {
                        updated.dirty = $b4450e5745e49325$var$CONTENT_DIRTY;
                        updated.updateChildren(view, pos + 1);
                        updated.dirty = $b4450e5745e49325$var$NOT_DIRTY;
                    }
                    this.changed = true;
                    this.index++;
                    return true;
                }
                break;
            }
        }
        return false;
    }
    // When a node with content is replaced by a different node with
    // identical content, move over its children.
    recreateWrapper(next, node, outerDeco, innerDeco, view, pos) {
        if (next.dirty || node.isAtom || !next.children.length || !next.node.content.eq(node.content) || !$b4450e5745e49325$var$sameOuterDeco(outerDeco, next.outerDeco) || !innerDeco.eq(next.innerDeco)) return null;
        let wrapper = $b4450e5745e49325$var$NodeViewDesc.create(this.top, node, outerDeco, innerDeco, view, pos);
        if (wrapper.contentDOM) {
            wrapper.children = next.children;
            next.children = [];
            for (let ch of wrapper.children)ch.parent = wrapper;
        }
        next.destroy();
        return wrapper;
    }
    // Insert the node as a newly created node desc.
    addNode(node, outerDeco, innerDeco, view, pos) {
        let desc = $b4450e5745e49325$var$NodeViewDesc.create(this.top, node, outerDeco, innerDeco, view, pos);
        if (desc.contentDOM) desc.updateChildren(view, pos + 1);
        this.top.children.splice(this.index++, 0, desc);
        this.changed = true;
    }
    placeWidget(widget, view, pos) {
        let next = this.index < this.top.children.length ? this.top.children[this.index] : null;
        if (next && next.matchesWidget(widget) && (widget == next.widget || !next.widget.type.toDOM.parentNode)) this.index++;
        else {
            let desc = new $b4450e5745e49325$var$WidgetViewDesc(this.top, widget, view, pos);
            this.top.children.splice(this.index++, 0, desc);
            this.changed = true;
        }
    }
    // Make sure a textblock looks and behaves correctly in
    // contentEditable.
    addTextblockHacks() {
        let lastChild = this.top.children[this.index - 1], parent = this.top;
        while(lastChild instanceof $b4450e5745e49325$var$MarkViewDesc){
            parent = lastChild;
            lastChild = parent.children[parent.children.length - 1];
        }
        if (!lastChild || // Empty textblock
        !(lastChild instanceof $b4450e5745e49325$var$TextViewDesc) || /\n$/.test(lastChild.node.text) || this.view.requiresGeckoHackNode && /\s$/.test(lastChild.node.text)) {
            // Avoid bugs in Safari's cursor drawing (#1165) and Chrome's mouse selection (#1152)
            if (($b4450e5745e49325$var$safari || $b4450e5745e49325$var$chrome) && lastChild && lastChild.dom.contentEditable == "false") this.addHackNode("IMG", parent);
            this.addHackNode("BR", this.top);
        }
    }
    addHackNode(nodeName, parent) {
        if (parent == this.top && this.index < parent.children.length && parent.children[this.index].matchesHack(nodeName)) this.index++;
        else {
            let dom = document.createElement(nodeName);
            if (nodeName == "IMG") {
                dom.className = "ProseMirror-separator";
                dom.alt = "";
            }
            if (nodeName == "BR") dom.className = "ProseMirror-trailingBreak";
            let hack = new $b4450e5745e49325$var$TrailingHackViewDesc(this.top, [], dom, null);
            if (parent != this.top) parent.children.push(hack);
            else parent.children.splice(this.index++, 0, hack);
            this.changed = true;
        }
    }
    isLocked(node) {
        return this.lock && (node == this.lock || node.nodeType == 1 && node.contains(this.lock.parentNode));
    }
    constructor(top, lock, view){
        this.lock = lock;
        this.view = view;
        // Index into `this.top`'s child array, represents the current
        // update position.
        this.index = 0;
        // When entering a mark, the current top and index are pushed
        // onto this.
        this.stack = [];
        // Tracks whether anything was changed
        this.changed = false;
        this.top = top;
        this.preMatch = $b4450e5745e49325$var$preMatch(top.node.content, top);
    }
}
// Iterate from the end of the fragment and array of descs to find
// directly matching ones, in order to avoid overeagerly reusing those
// for other nodes. Returns the fragment index of the first node that
// is part of the sequence of matched nodes at the end of the
// fragment.
function $b4450e5745e49325$var$preMatch(frag, parentDesc) {
    let curDesc = parentDesc, descI = curDesc.children.length;
    let fI = frag.childCount, matched = new Map, matches = [];
    outer: while(fI > 0){
        let desc;
        for(;;){
            if (descI) {
                let next = curDesc.children[descI - 1];
                if (next instanceof $b4450e5745e49325$var$MarkViewDesc) {
                    curDesc = next;
                    descI = next.children.length;
                } else {
                    desc = next;
                    descI--;
                    break;
                }
            } else if (curDesc == parentDesc) break outer;
            else {
                // FIXME
                descI = curDesc.parent.children.indexOf(curDesc);
                curDesc = curDesc.parent;
            }
        }
        let node = desc.node;
        if (!node) continue;
        if (node != frag.child(fI - 1)) break;
        --fI;
        matched.set(desc, fI);
        matches.push(desc);
    }
    return {
        index: fI,
        matched: matched,
        matches: matches.reverse()
    };
}
function $b4450e5745e49325$var$compareSide(a, b) {
    return a.type.side - b.type.side;
}
// This function abstracts iterating over the nodes and decorations in
// a fragment. Calls `onNode` for each node, with its local and child
// decorations. Splits text nodes when there is a decoration starting
// or ending inside of them. Calls `onWidget` for each widget.
function $b4450e5745e49325$var$iterDeco(parent, deco, onWidget, onNode) {
    let locals = deco.locals(parent), offset = 0;
    // Simple, cheap variant for when there are no local decorations
    if (locals.length == 0) {
        for(let i = 0; i < parent.childCount; i++){
            let child = parent.child(i);
            onNode(child, locals, deco.forChild(offset, child), i);
            offset += child.nodeSize;
        }
        return;
    }
    let decoIndex = 0, active = [], restNode = null;
    for(let parentIndex = 0;;){
        let widget, widgets;
        while(decoIndex < locals.length && locals[decoIndex].to == offset){
            let next = locals[decoIndex++];
            if (next.widget) {
                if (!widget) widget = next;
                else (widgets || (widgets = [
                    widget
                ])).push(next);
            }
        }
        if (widget) {
            if (widgets) {
                widgets.sort($b4450e5745e49325$var$compareSide);
                for(let i = 0; i < widgets.length; i++)onWidget(widgets[i], parentIndex, !!restNode);
            } else onWidget(widget, parentIndex, !!restNode);
        }
        let child, index;
        if (restNode) {
            index = -1;
            child = restNode;
            restNode = null;
        } else if (parentIndex < parent.childCount) {
            index = parentIndex;
            child = parent.child(parentIndex++);
        } else break;
        for(let i = 0; i < active.length; i++)if (active[i].to <= offset) active.splice(i--, 1);
        while(decoIndex < locals.length && locals[decoIndex].from <= offset && locals[decoIndex].to > offset)active.push(locals[decoIndex++]);
        let end = offset + child.nodeSize;
        if (child.isText) {
            let cutAt = end;
            if (decoIndex < locals.length && locals[decoIndex].from < cutAt) cutAt = locals[decoIndex].from;
            for(let i = 0; i < active.length; i++)if (active[i].to < cutAt) cutAt = active[i].to;
            if (cutAt < end) {
                restNode = child.cut(cutAt - offset);
                child = child.cut(0, cutAt - offset);
                end = cutAt;
                index = -1;
            }
        } else while(decoIndex < locals.length && locals[decoIndex].to < end)decoIndex++;
        let outerDeco = child.isInline && !child.isLeaf ? active.filter((d)=>!d.inline) : active.slice();
        onNode(child, outerDeco, deco.forChild(offset, child), index);
        offset = end;
    }
}
// List markers in Mobile Safari will mysteriously disappear
// sometimes. This works around that.
function $b4450e5745e49325$var$iosHacks(dom) {
    if (dom.nodeName == "UL" || dom.nodeName == "OL") {
        let oldCSS = dom.style.cssText;
        dom.style.cssText = oldCSS + "; list-style: square !important";
        window.getComputedStyle(dom).listStyle;
        dom.style.cssText = oldCSS;
    }
}
// Find a piece of text in an inline fragment, overlapping from-to
function $b4450e5745e49325$var$findTextInFragment(frag, text, from, to) {
    for(let i = 0, pos = 0; i < frag.childCount && pos <= to;){
        let child = frag.child(i++), childStart = pos;
        pos += child.nodeSize;
        if (!child.isText) continue;
        let str = child.text;
        while(i < frag.childCount){
            let next = frag.child(i++);
            pos += next.nodeSize;
            if (!next.isText) break;
            str += next.text;
        }
        if (pos >= from) {
            if (pos >= to && str.slice(to - text.length - childStart, to - childStart) == text) return to - text.length;
            let found = childStart < to ? str.lastIndexOf(text, to - childStart - 1) : -1;
            if (found >= 0 && found + text.length + childStart >= from) return childStart + found;
            if (from == to && str.length >= to + text.length - childStart && str.slice(to - childStart, to - childStart + text.length) == text) return to;
        }
    }
    return -1;
}
// Replace range from-to in an array of view descs with replacement
// (may be null to just delete). This goes very much against the grain
// of the rest of this code, which tends to create nodes with the
// right shape in one go, rather than messing with them after
// creation, but is necessary in the composition hack.
function $b4450e5745e49325$var$replaceNodes(nodes, from, to, view, replacement) {
    let result = [];
    for(let i = 0, off = 0; i < nodes.length; i++){
        let child = nodes[i], start = off, end = off += child.size;
        if (start >= to || end <= from) result.push(child);
        else {
            if (start < from) result.push(child.slice(0, from - start, view));
            if (replacement) {
                result.push(replacement);
                replacement = undefined;
            }
            if (end > to) result.push(child.slice(to - start, child.size, view));
        }
    }
    return result;
}
function $b4450e5745e49325$var$selectionFromDOM(view, origin = null) {
    let domSel = view.domSelectionRange(), doc = view.state.doc;
    if (!domSel.focusNode) return null;
    let nearestDesc = view.docView.nearestDesc(domSel.focusNode), inWidget = nearestDesc && nearestDesc.size == 0;
    let head = view.docView.posFromDOM(domSel.focusNode, domSel.focusOffset, 1);
    if (head < 0) return null;
    let $head = doc.resolve(head), anchor, selection;
    if ($b4450e5745e49325$var$selectionCollapsed(domSel)) {
        anchor = head;
        while(nearestDesc && !nearestDesc.node)nearestDesc = nearestDesc.parent;
        let nearestDescNode = nearestDesc.node;
        if (nearestDesc && nearestDescNode.isAtom && (0, $ks2lK.NodeSelection).isSelectable(nearestDescNode) && nearestDesc.parent && !(nearestDescNode.isInline && $b4450e5745e49325$var$isOnEdge(domSel.focusNode, domSel.focusOffset, nearestDesc.dom))) {
            let pos = nearestDesc.posBefore;
            selection = new (0, $ks2lK.NodeSelection)(head == pos ? $head : doc.resolve(pos));
        }
    } else {
        if (domSel instanceof view.dom.ownerDocument.defaultView.Selection && domSel.rangeCount > 1) {
            let min = head, max = head;
            for(let i = 0; i < domSel.rangeCount; i++){
                let range = domSel.getRangeAt(i);
                min = Math.min(min, view.docView.posFromDOM(range.startContainer, range.startOffset, 1));
                max = Math.max(max, view.docView.posFromDOM(range.endContainer, range.endOffset, -1));
            }
            if (min < 0) return null;
            [anchor, head] = max == view.state.selection.anchor ? [
                max,
                min
            ] : [
                min,
                max
            ];
            $head = doc.resolve(head);
        } else anchor = view.docView.posFromDOM(domSel.anchorNode, domSel.anchorOffset, 1);
        if (anchor < 0) return null;
    }
    let $anchor = doc.resolve(anchor);
    if (!selection) {
        let bias = origin == "pointer" || view.state.selection.head < $head.pos && !inWidget ? 1 : -1;
        selection = $b4450e5745e49325$var$selectionBetween(view, $anchor, $head, bias);
    }
    return selection;
}
function $b4450e5745e49325$var$editorOwnsSelection(view) {
    return view.editable ? view.hasFocus() : $b4450e5745e49325$var$hasSelection(view) && document.activeElement && document.activeElement.contains(view.dom);
}
function $b4450e5745e49325$var$selectionToDOM(view, force = false) {
    let sel = view.state.selection;
    $b4450e5745e49325$var$syncNodeSelection(view, sel);
    if (!$b4450e5745e49325$var$editorOwnsSelection(view)) return;
    // The delayed drag selection causes issues with Cell Selections
    // in Safari. And the drag selection delay is to workarond issues
    // which only present in Chrome.
    if (!force && view.input.mouseDown && view.input.mouseDown.allowDefault && $b4450e5745e49325$var$chrome) {
        let domSel = view.domSelectionRange(), curSel = view.domObserver.currentSelection;
        if (domSel.anchorNode && curSel.anchorNode && $b4450e5745e49325$var$isEquivalentPosition(domSel.anchorNode, domSel.anchorOffset, curSel.anchorNode, curSel.anchorOffset)) {
            view.input.mouseDown.delayedSelectionSync = true;
            view.domObserver.setCurSelection();
            return;
        }
    }
    view.domObserver.disconnectSelection();
    if (view.cursorWrapper) $b4450e5745e49325$var$selectCursorWrapper(view);
    else {
        let { anchor: anchor, head: head } = sel, resetEditableFrom, resetEditableTo;
        if ($b4450e5745e49325$var$brokenSelectBetweenUneditable && !(sel instanceof (0, $ks2lK.TextSelection))) {
            if (!sel.$from.parent.inlineContent) resetEditableFrom = $b4450e5745e49325$var$temporarilyEditableNear(view, sel.from);
            if (!sel.empty && !sel.$from.parent.inlineContent) resetEditableTo = $b4450e5745e49325$var$temporarilyEditableNear(view, sel.to);
        }
        view.docView.setSelection(anchor, head, view, force);
        if ($b4450e5745e49325$var$brokenSelectBetweenUneditable) {
            if (resetEditableFrom) $b4450e5745e49325$var$resetEditable(resetEditableFrom);
            if (resetEditableTo) $b4450e5745e49325$var$resetEditable(resetEditableTo);
        }
        if (sel.visible) view.dom.classList.remove("ProseMirror-hideselection");
        else {
            view.dom.classList.add("ProseMirror-hideselection");
            if ("onselectionchange" in document) $b4450e5745e49325$var$removeClassOnSelectionChange(view);
        }
    }
    view.domObserver.setCurSelection();
    view.domObserver.connectSelection();
}
// Kludge to work around Webkit not allowing a selection to start/end
// between non-editable block nodes. We briefly make something
// editable, set the selection, then set it uneditable again.
const $b4450e5745e49325$var$brokenSelectBetweenUneditable = $b4450e5745e49325$var$safari || $b4450e5745e49325$var$chrome && $b4450e5745e49325$var$chrome_version < 63;
function $b4450e5745e49325$var$temporarilyEditableNear(view, pos) {
    let { node: node, offset: offset } = view.docView.domFromPos(pos, 0);
    let after = offset < node.childNodes.length ? node.childNodes[offset] : null;
    let before = offset ? node.childNodes[offset - 1] : null;
    if ($b4450e5745e49325$var$safari && after && after.contentEditable == "false") return $b4450e5745e49325$var$setEditable(after);
    if ((!after || after.contentEditable == "false") && (!before || before.contentEditable == "false")) {
        if (after) return $b4450e5745e49325$var$setEditable(after);
        else if (before) return $b4450e5745e49325$var$setEditable(before);
    }
}
function $b4450e5745e49325$var$setEditable(element) {
    element.contentEditable = "true";
    if ($b4450e5745e49325$var$safari && element.draggable) {
        element.draggable = false;
        element.wasDraggable = true;
    }
    return element;
}
function $b4450e5745e49325$var$resetEditable(element) {
    element.contentEditable = "false";
    if (element.wasDraggable) {
        element.draggable = true;
        element.wasDraggable = null;
    }
}
function $b4450e5745e49325$var$removeClassOnSelectionChange(view) {
    let doc = view.dom.ownerDocument;
    doc.removeEventListener("selectionchange", view.input.hideSelectionGuard);
    let domSel = view.domSelectionRange();
    let node = domSel.anchorNode, offset = domSel.anchorOffset;
    doc.addEventListener("selectionchange", view.input.hideSelectionGuard = ()=>{
        if (domSel.anchorNode != node || domSel.anchorOffset != offset) {
            doc.removeEventListener("selectionchange", view.input.hideSelectionGuard);
            setTimeout(()=>{
                if (!$b4450e5745e49325$var$editorOwnsSelection(view) || view.state.selection.visible) view.dom.classList.remove("ProseMirror-hideselection");
            }, 20);
        }
    });
}
function $b4450e5745e49325$var$selectCursorWrapper(view) {
    let domSel = view.domSelection(), range = document.createRange();
    if (!domSel) return;
    let node = view.cursorWrapper.dom, img = node.nodeName == "IMG";
    if (img) range.setStart(node.parentNode, $b4450e5745e49325$var$domIndex(node) + 1);
    else range.setStart(node, 0);
    range.collapse(true);
    domSel.removeAllRanges();
    domSel.addRange(range);
    // Kludge to kill 'control selection' in IE11 when selecting an
    // invisible cursor wrapper, since that would result in those weird
    // resize handles and a selection that considers the absolutely
    // positioned wrapper, rather than the root editable node, the
    // focused element.
    if (!img && !view.state.selection.visible && $b4450e5745e49325$var$ie && $b4450e5745e49325$var$ie_version <= 11) {
        node.disabled = true;
        node.disabled = false;
    }
}
function $b4450e5745e49325$var$syncNodeSelection(view, sel) {
    if (sel instanceof (0, $ks2lK.NodeSelection)) {
        let desc = view.docView.descAt(sel.from);
        if (desc != view.lastSelectedViewDesc) {
            $b4450e5745e49325$var$clearNodeSelection(view);
            if (desc) desc.selectNode();
            view.lastSelectedViewDesc = desc;
        }
    } else $b4450e5745e49325$var$clearNodeSelection(view);
}
// Clear all DOM statefulness of the last node selection.
function $b4450e5745e49325$var$clearNodeSelection(view) {
    if (view.lastSelectedViewDesc) {
        if (view.lastSelectedViewDesc.parent) view.lastSelectedViewDesc.deselectNode();
        view.lastSelectedViewDesc = undefined;
    }
}
function $b4450e5745e49325$var$selectionBetween(view, $anchor, $head, bias) {
    return view.someProp("createSelectionBetween", (f)=>f(view, $anchor, $head)) || (0, $ks2lK.TextSelection).between($anchor, $head, bias);
}
function $b4450e5745e49325$var$hasFocusAndSelection(view) {
    if (view.editable && !view.hasFocus()) return false;
    return $b4450e5745e49325$var$hasSelection(view);
}
function $b4450e5745e49325$var$hasSelection(view) {
    let sel = view.domSelectionRange();
    if (!sel.anchorNode) return false;
    try {
        // Firefox will raise 'permission denied' errors when accessing
        // properties of `sel.anchorNode` when it's in a generated CSS
        // element.
        return view.dom.contains(sel.anchorNode.nodeType == 3 ? sel.anchorNode.parentNode : sel.anchorNode) && (view.editable || view.dom.contains(sel.focusNode.nodeType == 3 ? sel.focusNode.parentNode : sel.focusNode));
    } catch (_) {
        return false;
    }
}
function $b4450e5745e49325$var$anchorInRightPlace(view) {
    let anchorDOM = view.docView.domFromPos(view.state.selection.anchor, 0);
    let domSel = view.domSelectionRange();
    return $b4450e5745e49325$var$isEquivalentPosition(anchorDOM.node, anchorDOM.offset, domSel.anchorNode, domSel.anchorOffset);
}
function $b4450e5745e49325$var$moveSelectionBlock(state, dir) {
    let { $anchor: $anchor, $head: $head } = state.selection;
    let $side = dir > 0 ? $anchor.max($head) : $anchor.min($head);
    let $start = !$side.parent.inlineContent ? $side : $side.depth ? state.doc.resolve(dir > 0 ? $side.after() : $side.before()) : null;
    return $start && (0, $ks2lK.Selection).findFrom($start, dir);
}
function $b4450e5745e49325$var$apply(view, sel) {
    view.dispatch(view.state.tr.setSelection(sel).scrollIntoView());
    return true;
}
function $b4450e5745e49325$var$selectHorizontally(view, dir, mods) {
    let sel = view.state.selection;
    if (sel instanceof (0, $ks2lK.TextSelection)) {
        if (mods.indexOf("s") > -1) {
            let { $head: $head } = sel, node = $head.textOffset ? null : dir < 0 ? $head.nodeBefore : $head.nodeAfter;
            if (!node || node.isText || !node.isLeaf) return false;
            let $newHead = view.state.doc.resolve($head.pos + node.nodeSize * (dir < 0 ? -1 : 1));
            return $b4450e5745e49325$var$apply(view, new (0, $ks2lK.TextSelection)(sel.$anchor, $newHead));
        } else if (!sel.empty) return false;
        else if (view.endOfTextblock(dir > 0 ? "forward" : "backward")) {
            let next = $b4450e5745e49325$var$moveSelectionBlock(view.state, dir);
            if (next && next instanceof (0, $ks2lK.NodeSelection)) return $b4450e5745e49325$var$apply(view, next);
            return false;
        } else if (!($b4450e5745e49325$var$mac && mods.indexOf("m") > -1)) {
            let $head = sel.$head, node = $head.textOffset ? null : dir < 0 ? $head.nodeBefore : $head.nodeAfter, desc;
            if (!node || node.isText) return false;
            let nodePos = dir < 0 ? $head.pos - node.nodeSize : $head.pos;
            if (!(node.isAtom || (desc = view.docView.descAt(nodePos)) && !desc.contentDOM)) return false;
            if ((0, $ks2lK.NodeSelection).isSelectable(node)) return $b4450e5745e49325$var$apply(view, new (0, $ks2lK.NodeSelection)(dir < 0 ? view.state.doc.resolve($head.pos - node.nodeSize) : $head));
            else if ($b4450e5745e49325$var$webkit) // Chrome and Safari will introduce extra pointless cursor
            // positions around inline uneditable nodes, so we have to
            // take over and move the cursor past them (#937)
            return $b4450e5745e49325$var$apply(view, new (0, $ks2lK.TextSelection)(view.state.doc.resolve(dir < 0 ? nodePos : nodePos + node.nodeSize)));
            else return false;
        }
    } else if (sel instanceof (0, $ks2lK.NodeSelection) && sel.node.isInline) return $b4450e5745e49325$var$apply(view, new (0, $ks2lK.TextSelection)(dir > 0 ? sel.$to : sel.$from));
    else {
        let next = $b4450e5745e49325$var$moveSelectionBlock(view.state, dir);
        if (next) return $b4450e5745e49325$var$apply(view, next);
        return false;
    }
}
function $b4450e5745e49325$var$nodeLen(node) {
    return node.nodeType == 3 ? node.nodeValue.length : node.childNodes.length;
}
function $b4450e5745e49325$var$isIgnorable(dom, dir) {
    let desc = dom.pmViewDesc;
    return desc && desc.size == 0 && (dir < 0 || dom.nextSibling || dom.nodeName != "BR");
}
function $b4450e5745e49325$var$skipIgnoredNodes(view, dir) {
    return dir < 0 ? $b4450e5745e49325$var$skipIgnoredNodesBefore(view) : $b4450e5745e49325$var$skipIgnoredNodesAfter(view);
}
// Make sure the cursor isn't directly after one or more ignored
// nodes, which will confuse the browser's cursor motion logic.
function $b4450e5745e49325$var$skipIgnoredNodesBefore(view) {
    let sel = view.domSelectionRange();
    let node = sel.focusNode, offset = sel.focusOffset;
    if (!node) return;
    let moveNode, moveOffset, force = false;
    // Gecko will do odd things when the selection is directly in front
    // of a non-editable node, so in that case, move it into the next
    // node if possible. Issue prosemirror/prosemirror#832.
    if ($b4450e5745e49325$var$gecko && node.nodeType == 1 && offset < $b4450e5745e49325$var$nodeLen(node) && $b4450e5745e49325$var$isIgnorable(node.childNodes[offset], -1)) force = true;
    for(;;){
        if (offset > 0) {
            if (node.nodeType != 1) break;
            else {
                let before = node.childNodes[offset - 1];
                if ($b4450e5745e49325$var$isIgnorable(before, -1)) {
                    moveNode = node;
                    moveOffset = --offset;
                } else if (before.nodeType == 3) {
                    node = before;
                    offset = node.nodeValue.length;
                } else break;
            }
        } else if ($b4450e5745e49325$var$isBlockNode(node)) break;
        else {
            let prev = node.previousSibling;
            while(prev && $b4450e5745e49325$var$isIgnorable(prev, -1)){
                moveNode = node.parentNode;
                moveOffset = $b4450e5745e49325$var$domIndex(prev);
                prev = prev.previousSibling;
            }
            if (!prev) {
                node = node.parentNode;
                if (node == view.dom) break;
                offset = 0;
            } else {
                node = prev;
                offset = $b4450e5745e49325$var$nodeLen(node);
            }
        }
    }
    if (force) $b4450e5745e49325$var$setSelFocus(view, node, offset);
    else if (moveNode) $b4450e5745e49325$var$setSelFocus(view, moveNode, moveOffset);
}
// Make sure the cursor isn't directly before one or more ignored
// nodes.
function $b4450e5745e49325$var$skipIgnoredNodesAfter(view) {
    let sel = view.domSelectionRange();
    let node = sel.focusNode, offset = sel.focusOffset;
    if (!node) return;
    let len = $b4450e5745e49325$var$nodeLen(node);
    let moveNode, moveOffset;
    for(;;){
        if (offset < len) {
            if (node.nodeType != 1) break;
            let after = node.childNodes[offset];
            if ($b4450e5745e49325$var$isIgnorable(after, 1)) {
                moveNode = node;
                moveOffset = ++offset;
            } else break;
        } else if ($b4450e5745e49325$var$isBlockNode(node)) break;
        else {
            let next = node.nextSibling;
            while(next && $b4450e5745e49325$var$isIgnorable(next, 1)){
                moveNode = next.parentNode;
                moveOffset = $b4450e5745e49325$var$domIndex(next) + 1;
                next = next.nextSibling;
            }
            if (!next) {
                node = node.parentNode;
                if (node == view.dom) break;
                offset = len = 0;
            } else {
                node = next;
                offset = 0;
                len = $b4450e5745e49325$var$nodeLen(node);
            }
        }
    }
    if (moveNode) $b4450e5745e49325$var$setSelFocus(view, moveNode, moveOffset);
}
function $b4450e5745e49325$var$isBlockNode(dom) {
    let desc = dom.pmViewDesc;
    return desc && desc.node && desc.node.isBlock;
}
function $b4450e5745e49325$var$textNodeAfter(node, offset) {
    while(node && offset == node.childNodes.length && !$b4450e5745e49325$var$hasBlockDesc(node)){
        offset = $b4450e5745e49325$var$domIndex(node) + 1;
        node = node.parentNode;
    }
    while(node && offset < node.childNodes.length){
        let next = node.childNodes[offset];
        if (next.nodeType == 3) return next;
        if (next.nodeType == 1 && next.contentEditable == "false") break;
        node = next;
        offset = 0;
    }
}
function $b4450e5745e49325$var$textNodeBefore(node, offset) {
    while(node && !offset && !$b4450e5745e49325$var$hasBlockDesc(node)){
        offset = $b4450e5745e49325$var$domIndex(node);
        node = node.parentNode;
    }
    while(node && offset){
        let next = node.childNodes[offset - 1];
        if (next.nodeType == 3) return next;
        if (next.nodeType == 1 && next.contentEditable == "false") break;
        node = next;
        offset = node.childNodes.length;
    }
}
function $b4450e5745e49325$var$setSelFocus(view, node, offset) {
    if (node.nodeType != 3) {
        let before, after;
        if (after = $b4450e5745e49325$var$textNodeAfter(node, offset)) {
            node = after;
            offset = 0;
        } else if (before = $b4450e5745e49325$var$textNodeBefore(node, offset)) {
            node = before;
            offset = before.nodeValue.length;
        }
    }
    let sel = view.domSelection();
    if (!sel) return;
    if ($b4450e5745e49325$var$selectionCollapsed(sel)) {
        let range = document.createRange();
        range.setEnd(node, offset);
        range.setStart(node, offset);
        sel.removeAllRanges();
        sel.addRange(range);
    } else if (sel.extend) sel.extend(node, offset);
    view.domObserver.setCurSelection();
    let { state: state } = view;
    // If no state update ends up happening, reset the selection.
    setTimeout(()=>{
        if (view.state == state) $b4450e5745e49325$var$selectionToDOM(view);
    }, 50);
}
function $b4450e5745e49325$var$findDirection(view, pos) {
    let $pos = view.state.doc.resolve(pos);
    if (!($b4450e5745e49325$var$chrome || $b4450e5745e49325$var$windows) && $pos.parent.inlineContent) {
        let coords = view.coordsAtPos(pos);
        if (pos > $pos.start()) {
            let before = view.coordsAtPos(pos - 1);
            let mid = (before.top + before.bottom) / 2;
            if (mid > coords.top && mid < coords.bottom && Math.abs(before.left - coords.left) > 1) return before.left < coords.left ? "ltr" : "rtl";
        }
        if (pos < $pos.end()) {
            let after = view.coordsAtPos(pos + 1);
            let mid = (after.top + after.bottom) / 2;
            if (mid > coords.top && mid < coords.bottom && Math.abs(after.left - coords.left) > 1) return after.left > coords.left ? "ltr" : "rtl";
        }
    }
    let computed = getComputedStyle(view.dom).direction;
    return computed == "rtl" ? "rtl" : "ltr";
}
// Check whether vertical selection motion would involve node
// selections. If so, apply it (if not, the result is left to the
// browser)
function $b4450e5745e49325$var$selectVertically(view, dir, mods) {
    let sel = view.state.selection;
    if (sel instanceof (0, $ks2lK.TextSelection) && !sel.empty || mods.indexOf("s") > -1) return false;
    if ($b4450e5745e49325$var$mac && mods.indexOf("m") > -1) return false;
    let { $from: $from, $to: $to } = sel;
    if (!$from.parent.inlineContent || view.endOfTextblock(dir < 0 ? "up" : "down")) {
        let next = $b4450e5745e49325$var$moveSelectionBlock(view.state, dir);
        if (next && next instanceof (0, $ks2lK.NodeSelection)) return $b4450e5745e49325$var$apply(view, next);
    }
    if (!$from.parent.inlineContent) {
        let side = dir < 0 ? $from : $to;
        let beyond = sel instanceof (0, $ks2lK.AllSelection) ? (0, $ks2lK.Selection).near(side, dir) : (0, $ks2lK.Selection).findFrom(side, dir);
        return beyond ? $b4450e5745e49325$var$apply(view, beyond) : false;
    }
    return false;
}
function $b4450e5745e49325$var$stopNativeHorizontalDelete(view, dir) {
    if (!(view.state.selection instanceof (0, $ks2lK.TextSelection))) return true;
    let { $head: $head, $anchor: $anchor, empty: empty } = view.state.selection;
    if (!$head.sameParent($anchor)) return true;
    if (!empty) return false;
    if (view.endOfTextblock(dir > 0 ? "forward" : "backward")) return true;
    let nextNode = !$head.textOffset && (dir < 0 ? $head.nodeBefore : $head.nodeAfter);
    if (nextNode && !nextNode.isText) {
        let tr = view.state.tr;
        if (dir < 0) tr.delete($head.pos - nextNode.nodeSize, $head.pos);
        else tr.delete($head.pos, $head.pos + nextNode.nodeSize);
        view.dispatch(tr);
        return true;
    }
    return false;
}
function $b4450e5745e49325$var$switchEditable(view, node, state) {
    view.domObserver.stop();
    node.contentEditable = state;
    view.domObserver.start();
}
// Issue #867 / #1090 / https://bugs.chromium.org/p/chromium/issues/detail?id=903821
// In which Safari (and at some point in the past, Chrome) does really
// wrong things when the down arrow is pressed when the cursor is
// directly at the start of a textblock and has an uneditable node
// after it
function $b4450e5745e49325$var$safariDownArrowBug(view) {
    if (!$b4450e5745e49325$var$safari || view.state.selection.$head.parentOffset > 0) return false;
    let { focusNode: focusNode, focusOffset: focusOffset } = view.domSelectionRange();
    if (focusNode && focusNode.nodeType == 1 && focusOffset == 0 && focusNode.firstChild && focusNode.firstChild.contentEditable == "false") {
        let child = focusNode.firstChild;
        $b4450e5745e49325$var$switchEditable(view, child, "true");
        setTimeout(()=>$b4450e5745e49325$var$switchEditable(view, child, "false"), 20);
    }
    return false;
}
// A backdrop key mapping used to make sure we always suppress keys
// that have a dangerous default effect, even if the commands they are
// bound to return false, and to make sure that cursor-motion keys
// find a cursor (as opposed to a node selection) when pressed. For
// cursor-motion keys, the code in the handlers also takes care of
// block selections.
function $b4450e5745e49325$var$getMods(event) {
    let result = "";
    if (event.ctrlKey) result += "c";
    if (event.metaKey) result += "m";
    if (event.altKey) result += "a";
    if (event.shiftKey) result += "s";
    return result;
}
function $b4450e5745e49325$var$captureKeyDown(view, event) {
    let code = event.keyCode, mods = $b4450e5745e49325$var$getMods(event);
    if (code == 8 || $b4450e5745e49325$var$mac && code == 72 && mods == "c") return $b4450e5745e49325$var$stopNativeHorizontalDelete(view, -1) || $b4450e5745e49325$var$skipIgnoredNodes(view, -1);
    else if (code == 46 && !event.shiftKey || $b4450e5745e49325$var$mac && code == 68 && mods == "c") return $b4450e5745e49325$var$stopNativeHorizontalDelete(view, 1) || $b4450e5745e49325$var$skipIgnoredNodes(view, 1);
    else if (code == 13 || code == 27) return true;
    else if (code == 37 || $b4450e5745e49325$var$mac && code == 66 && mods == "c") {
        let dir = code == 37 ? $b4450e5745e49325$var$findDirection(view, view.state.selection.from) == "ltr" ? -1 : 1 : -1;
        return $b4450e5745e49325$var$selectHorizontally(view, dir, mods) || $b4450e5745e49325$var$skipIgnoredNodes(view, dir);
    } else if (code == 39 || $b4450e5745e49325$var$mac && code == 70 && mods == "c") {
        let dir = code == 39 ? $b4450e5745e49325$var$findDirection(view, view.state.selection.from) == "ltr" ? 1 : -1 : 1;
        return $b4450e5745e49325$var$selectHorizontally(view, dir, mods) || $b4450e5745e49325$var$skipIgnoredNodes(view, dir);
    } else if (code == 38 || $b4450e5745e49325$var$mac && code == 80 && mods == "c") return $b4450e5745e49325$var$selectVertically(view, -1, mods) || $b4450e5745e49325$var$skipIgnoredNodes(view, -1);
    else if (code == 40 || $b4450e5745e49325$var$mac && code == 78 && mods == "c") return $b4450e5745e49325$var$safariDownArrowBug(view) || $b4450e5745e49325$var$selectVertically(view, 1, mods) || $b4450e5745e49325$var$skipIgnoredNodes(view, 1);
    else if (mods == ($b4450e5745e49325$var$mac ? "m" : "c") && (code == 66 || code == 73 || code == 89 || code == 90)) return true;
    return false;
}
function $b4450e5745e49325$var$serializeForClipboard(view, slice) {
    view.someProp("transformCopied", (f)=>{
        slice = f(slice, view);
    });
    let context = [], { content: content, openStart: openStart, openEnd: openEnd } = slice;
    while(openStart > 1 && openEnd > 1 && content.childCount == 1 && content.firstChild.childCount == 1){
        openStart--;
        openEnd--;
        let node = content.firstChild;
        context.push(node.type.name, node.attrs != node.type.defaultAttrs ? node.attrs : null);
        content = node.content;
    }
    let serializer = view.someProp("clipboardSerializer") || (0, $5SAOw.DOMSerializer).fromSchema(view.state.schema);
    let doc = $b4450e5745e49325$var$detachedDoc(), wrap = doc.createElement("div");
    wrap.appendChild(serializer.serializeFragment(content, {
        document: doc
    }));
    let firstChild = wrap.firstChild, needsWrap, wrappers = 0;
    while(firstChild && firstChild.nodeType == 1 && (needsWrap = $b4450e5745e49325$var$wrapMap[firstChild.nodeName.toLowerCase()])){
        for(let i = needsWrap.length - 1; i >= 0; i--){
            let wrapper = doc.createElement(needsWrap[i]);
            while(wrap.firstChild)wrapper.appendChild(wrap.firstChild);
            wrap.appendChild(wrapper);
            wrappers++;
        }
        firstChild = wrap.firstChild;
    }
    if (firstChild && firstChild.nodeType == 1) firstChild.setAttribute("data-pm-slice", `${openStart} ${openEnd}${wrappers ? ` -${wrappers}` : ""} ${JSON.stringify(context)}`);
    let text = view.someProp("clipboardTextSerializer", (f)=>f(slice, view)) || slice.content.textBetween(0, slice.content.size, "\n\n");
    return {
        dom: wrap,
        text: text,
        slice: slice
    };
}
// Read a slice of content from the clipboard (or drop data).
function $b4450e5745e49325$var$parseFromClipboard(view, text, html, plainText, $context) {
    let inCode = $context.parent.type.spec.code;
    let dom, slice;
    if (!html && !text) return null;
    let asText = text && (plainText || inCode || !html);
    if (asText) {
        view.someProp("transformPastedText", (f)=>{
            text = f(text, inCode || plainText, view);
        });
        if (inCode) return text ? new (0, $5SAOw.Slice)((0, $5SAOw.Fragment).from(view.state.schema.text(text.replace(/\r\n?/g, "\n"))), 0, 0) : (0, $5SAOw.Slice).empty;
        let parsed = view.someProp("clipboardTextParser", (f)=>f(text, $context, plainText, view));
        if (parsed) slice = parsed;
        else {
            let marks = $context.marks();
            let { schema: schema } = view.state, serializer = (0, $5SAOw.DOMSerializer).fromSchema(schema);
            dom = document.createElement("div");
            text.split(/(?:\r\n?|\n)+/).forEach((block)=>{
                let p = dom.appendChild(document.createElement("p"));
                if (block) p.appendChild(serializer.serializeNode(schema.text(block, marks)));
            });
        }
    } else {
        view.someProp("transformPastedHTML", (f)=>{
            html = f(html, view);
        });
        dom = $b4450e5745e49325$var$readHTML(html);
        if ($b4450e5745e49325$var$webkit) $b4450e5745e49325$var$restoreReplacedSpaces(dom);
    }
    let contextNode = dom && dom.querySelector("[data-pm-slice]");
    let sliceData = contextNode && /^(\d+) (\d+)(?: -(\d+))? (.*)/.exec(contextNode.getAttribute("data-pm-slice") || "");
    if (sliceData && sliceData[3]) for(let i = +sliceData[3]; i > 0; i--){
        let child = dom.firstChild;
        while(child && child.nodeType != 1)child = child.nextSibling;
        if (!child) break;
        dom = child;
    }
    if (!slice) {
        let parser = view.someProp("clipboardParser") || view.someProp("domParser") || (0, $5SAOw.DOMParser).fromSchema(view.state.schema);
        slice = parser.parseSlice(dom, {
            preserveWhitespace: !!(asText || sliceData),
            context: $context,
            ruleFromNode (dom) {
                if (dom.nodeName == "BR" && !dom.nextSibling && dom.parentNode && !$b4450e5745e49325$var$inlineParents.test(dom.parentNode.nodeName)) return {
                    ignore: true
                };
                return null;
            }
        });
    }
    if (sliceData) slice = $b4450e5745e49325$var$addContext($b4450e5745e49325$var$closeSlice(slice, +sliceData[1], +sliceData[2]), sliceData[4]);
    else {
        slice = (0, $5SAOw.Slice).maxOpen($b4450e5745e49325$var$normalizeSiblings(slice.content, $context), true);
        if (slice.openStart || slice.openEnd) {
            let openStart = 0, openEnd = 0;
            for(let node = slice.content.firstChild; openStart < slice.openStart && !node.type.spec.isolating; openStart++, node = node.firstChild);
            for(let node = slice.content.lastChild; openEnd < slice.openEnd && !node.type.spec.isolating; openEnd++, node = node.lastChild);
            slice = $b4450e5745e49325$var$closeSlice(slice, openStart, openEnd);
        }
    }
    view.someProp("transformPasted", (f)=>{
        slice = f(slice, view);
    });
    return slice;
}
const $b4450e5745e49325$var$inlineParents = /^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var)$/i;
// Takes a slice parsed with parseSlice, which means there hasn't been
// any content-expression checking done on the top nodes, tries to
// find a parent node in the current context that might fit the nodes,
// and if successful, rebuilds the slice so that it fits into that parent.
//
// This addresses the problem that Transform.replace expects a
// coherent slice, and will fail to place a set of siblings that don't
// fit anywhere in the schema.
function $b4450e5745e49325$var$normalizeSiblings(fragment, $context) {
    if (fragment.childCount < 2) return fragment;
    for(let d = $context.depth; d >= 0; d--){
        let parent = $context.node(d);
        let match = parent.contentMatchAt($context.index(d));
        let lastWrap, result = [];
        fragment.forEach((node)=>{
            if (!result) return;
            let wrap = match.findWrapping(node.type), inLast;
            if (!wrap) return result = null;
            if (inLast = result.length && lastWrap.length && $b4450e5745e49325$var$addToSibling(wrap, lastWrap, node, result[result.length - 1], 0)) result[result.length - 1] = inLast;
            else {
                if (result.length) result[result.length - 1] = $b4450e5745e49325$var$closeRight(result[result.length - 1], lastWrap.length);
                let wrapped = $b4450e5745e49325$var$withWrappers(node, wrap);
                result.push(wrapped);
                match = match.matchType(wrapped.type);
                lastWrap = wrap;
            }
        });
        if (result) return (0, $5SAOw.Fragment).from(result);
    }
    return fragment;
}
function $b4450e5745e49325$var$withWrappers(node, wrap, from = 0) {
    for(let i = wrap.length - 1; i >= from; i--)node = wrap[i].create(null, (0, $5SAOw.Fragment).from(node));
    return node;
}
// Used to group adjacent nodes wrapped in similar parents by
// normalizeSiblings into the same parent node
function $b4450e5745e49325$var$addToSibling(wrap, lastWrap, node, sibling, depth) {
    if (depth < wrap.length && depth < lastWrap.length && wrap[depth] == lastWrap[depth]) {
        let inner = $b4450e5745e49325$var$addToSibling(wrap, lastWrap, node, sibling.lastChild, depth + 1);
        if (inner) return sibling.copy(sibling.content.replaceChild(sibling.childCount - 1, inner));
        let match = sibling.contentMatchAt(sibling.childCount);
        if (match.matchType(depth == wrap.length - 1 ? node.type : wrap[depth + 1])) return sibling.copy(sibling.content.append((0, $5SAOw.Fragment).from($b4450e5745e49325$var$withWrappers(node, wrap, depth + 1))));
    }
}
function $b4450e5745e49325$var$closeRight(node, depth) {
    if (depth == 0) return node;
    let fragment = node.content.replaceChild(node.childCount - 1, $b4450e5745e49325$var$closeRight(node.lastChild, depth - 1));
    let fill = node.contentMatchAt(node.childCount).fillBefore((0, $5SAOw.Fragment).empty, true);
    return node.copy(fragment.append(fill));
}
function $b4450e5745e49325$var$closeRange(fragment, side, from, to, depth, openEnd) {
    let node = side < 0 ? fragment.firstChild : fragment.lastChild, inner = node.content;
    if (fragment.childCount > 1) openEnd = 0;
    if (depth < to - 1) inner = $b4450e5745e49325$var$closeRange(inner, side, from, to, depth + 1, openEnd);
    if (depth >= from) inner = side < 0 ? node.contentMatchAt(0).fillBefore(inner, openEnd <= depth).append(inner) : inner.append(node.contentMatchAt(node.childCount).fillBefore((0, $5SAOw.Fragment).empty, true));
    return fragment.replaceChild(side < 0 ? 0 : fragment.childCount - 1, node.copy(inner));
}
function $b4450e5745e49325$var$closeSlice(slice, openStart, openEnd) {
    if (openStart < slice.openStart) slice = new (0, $5SAOw.Slice)($b4450e5745e49325$var$closeRange(slice.content, -1, openStart, slice.openStart, 0, slice.openEnd), openStart, slice.openEnd);
    if (openEnd < slice.openEnd) slice = new (0, $5SAOw.Slice)($b4450e5745e49325$var$closeRange(slice.content, 1, openEnd, slice.openEnd, 0, 0), slice.openStart, openEnd);
    return slice;
}
// Trick from jQuery -- some elements must be wrapped in other
// elements for innerHTML to work. I.e. if you do `div.innerHTML =
// "<td>..</td>"` the table cells are ignored.
const $b4450e5745e49325$var$wrapMap = {
    thead: [
        "table"
    ],
    tbody: [
        "table"
    ],
    tfoot: [
        "table"
    ],
    caption: [
        "table"
    ],
    colgroup: [
        "table"
    ],
    col: [
        "table",
        "colgroup"
    ],
    tr: [
        "table",
        "tbody"
    ],
    td: [
        "table",
        "tbody",
        "tr"
    ],
    th: [
        "table",
        "tbody",
        "tr"
    ]
};
let $b4450e5745e49325$var$_detachedDoc = null;
function $b4450e5745e49325$var$detachedDoc() {
    return $b4450e5745e49325$var$_detachedDoc || ($b4450e5745e49325$var$_detachedDoc = document.implementation.createHTMLDocument("title"));
}
let $b4450e5745e49325$var$_policy = null;
function $b4450e5745e49325$var$maybeWrapTrusted(html) {
    let trustedTypes = window.trustedTypes;
    if (!trustedTypes) return html;
    // With the require-trusted-types-for CSP, Chrome will block
    // innerHTML, even on a detached document. This wraps the string in
    // a way that makes the browser allow us to use its parser again.
    if (!$b4450e5745e49325$var$_policy) $b4450e5745e49325$var$_policy = trustedTypes.createPolicy("ProseMirrorClipboard", {
        createHTML: (s)=>s
    });
    return $b4450e5745e49325$var$_policy.createHTML(html);
}
function $b4450e5745e49325$var$readHTML(html) {
    let metas = /^(\s*<meta [^>]*>)*/.exec(html);
    if (metas) html = html.slice(metas[0].length);
    let elt = $b4450e5745e49325$var$detachedDoc().createElement("div");
    let firstTag = /<([a-z][^>\s]+)/i.exec(html), wrap;
    if (wrap = firstTag && $b4450e5745e49325$var$wrapMap[firstTag[1].toLowerCase()]) html = wrap.map((n)=>"<" + n + ">").join("") + html + wrap.map((n)=>"</" + n + ">").reverse().join("");
    elt.innerHTML = $b4450e5745e49325$var$maybeWrapTrusted(html);
    if (wrap) for(let i = 0; i < wrap.length; i++)elt = elt.querySelector(wrap[i]) || elt;
    return elt;
}
// Webkit browsers do some hard-to-predict replacement of regular
// spaces with non-breaking spaces when putting content on the
// clipboard. This tries to convert such non-breaking spaces (which
// will be wrapped in a plain span on Chrome, a span with class
// Apple-converted-space on Safari) back to regular spaces.
function $b4450e5745e49325$var$restoreReplacedSpaces(dom) {
    let nodes = dom.querySelectorAll($b4450e5745e49325$var$chrome ? "span:not([class]):not([style])" : "span.Apple-converted-space");
    for(let i = 0; i < nodes.length; i++){
        let node = nodes[i];
        if (node.childNodes.length == 1 && node.textContent == "\u00a0" && node.parentNode) node.parentNode.replaceChild(dom.ownerDocument.createTextNode(" "), node);
    }
}
function $b4450e5745e49325$var$addContext(slice, context) {
    if (!slice.size) return slice;
    let schema = slice.content.firstChild.type.schema, array;
    try {
        array = JSON.parse(context);
    } catch (e) {
        return slice;
    }
    let { content: content, openStart: openStart, openEnd: openEnd } = slice;
    for(let i = array.length - 2; i >= 0; i -= 2){
        let type = schema.nodes[array[i]];
        if (!type || type.hasRequiredAttrs()) break;
        content = (0, $5SAOw.Fragment).from(type.create(array[i + 1], content));
        openStart++;
        openEnd++;
    }
    return new (0, $5SAOw.Slice)(content, openStart, openEnd);
}
// A collection of DOM events that occur within the editor, and callback functions
// to invoke when the event fires.
const $b4450e5745e49325$var$handlers = {};
const $b4450e5745e49325$var$editHandlers = {};
const $b4450e5745e49325$var$passiveHandlers = {
    touchstart: true,
    touchmove: true
};
class $b4450e5745e49325$var$InputState {
    constructor(){
        this.shiftKey = false;
        this.mouseDown = null;
        this.lastKeyCode = null;
        this.lastKeyCodeTime = 0;
        this.lastClick = {
            time: 0,
            x: 0,
            y: 0,
            type: ""
        };
        this.lastSelectionOrigin = null;
        this.lastSelectionTime = 0;
        this.lastIOSEnter = 0;
        this.lastIOSEnterFallbackTimeout = -1;
        this.lastFocus = 0;
        this.lastTouch = 0;
        this.lastChromeDelete = 0;
        this.composing = false;
        this.compositionNode = null;
        this.composingTimeout = -1;
        this.compositionNodes = [];
        this.compositionEndedAt = -200000000;
        this.compositionID = 1;
        // Set to a composition ID when there are pending changes at compositionend
        this.compositionPendingChanges = 0;
        this.domChangeCount = 0;
        this.eventHandlers = Object.create(null);
        this.hideSelectionGuard = null;
    }
}
function $b4450e5745e49325$var$initInput(view) {
    for(let event in $b4450e5745e49325$var$handlers){
        let handler = $b4450e5745e49325$var$handlers[event];
        view.dom.addEventListener(event, view.input.eventHandlers[event] = (event)=>{
            if ($b4450e5745e49325$var$eventBelongsToView(view, event) && !$b4450e5745e49325$var$runCustomHandler(view, event) && (view.editable || !(event.type in $b4450e5745e49325$var$editHandlers))) handler(view, event);
        }, $b4450e5745e49325$var$passiveHandlers[event] ? {
            passive: true
        } : undefined);
    }
    // On Safari, for reasons beyond my understanding, adding an input
    // event handler makes an issue where the composition vanishes when
    // you press enter go away.
    if ($b4450e5745e49325$var$safari) view.dom.addEventListener("input", ()=>null);
    $b4450e5745e49325$var$ensureListeners(view);
}
function $b4450e5745e49325$var$setSelectionOrigin(view, origin) {
    view.input.lastSelectionOrigin = origin;
    view.input.lastSelectionTime = Date.now();
}
function $b4450e5745e49325$var$destroyInput(view) {
    view.domObserver.stop();
    for(let type in view.input.eventHandlers)view.dom.removeEventListener(type, view.input.eventHandlers[type]);
    clearTimeout(view.input.composingTimeout);
    clearTimeout(view.input.lastIOSEnterFallbackTimeout);
}
function $b4450e5745e49325$var$ensureListeners(view) {
    view.someProp("handleDOMEvents", (currentHandlers)=>{
        for(let type in currentHandlers)if (!view.input.eventHandlers[type]) view.dom.addEventListener(type, view.input.eventHandlers[type] = (event)=>$b4450e5745e49325$var$runCustomHandler(view, event));
    });
}
function $b4450e5745e49325$var$runCustomHandler(view, event) {
    return view.someProp("handleDOMEvents", (handlers)=>{
        let handler = handlers[event.type];
        return handler ? handler(view, event) || event.defaultPrevented : false;
    });
}
function $b4450e5745e49325$var$eventBelongsToView(view, event) {
    if (!event.bubbles) return true;
    if (event.defaultPrevented) return false;
    for(let node = event.target; node != view.dom; node = node.parentNode)if (!node || node.nodeType == 11 || node.pmViewDesc && node.pmViewDesc.stopEvent(event)) return false;
    return true;
}
function $b4450e5745e49325$var$dispatchEvent(view, event) {
    if (!$b4450e5745e49325$var$runCustomHandler(view, event) && $b4450e5745e49325$var$handlers[event.type] && (view.editable || !(event.type in $b4450e5745e49325$var$editHandlers))) $b4450e5745e49325$var$handlers[event.type](view, event);
}
$b4450e5745e49325$var$editHandlers.keydown = (view, _event)=>{
    let event = _event;
    view.input.shiftKey = event.keyCode == 16 || event.shiftKey;
    if ($b4450e5745e49325$var$inOrNearComposition(view, event)) return;
    view.input.lastKeyCode = event.keyCode;
    view.input.lastKeyCodeTime = Date.now();
    // Suppress enter key events on Chrome Android, because those tend
    // to be part of a confused sequence of composition events fired,
    // and handling them eagerly tends to corrupt the input.
    if ($b4450e5745e49325$var$android && $b4450e5745e49325$var$chrome && event.keyCode == 13) return;
    if (event.keyCode != 229) view.domObserver.forceFlush();
    // On iOS, if we preventDefault enter key presses, the virtual
    // keyboard gets confused. So the hack here is to set a flag that
    // makes the DOM change code recognize that what just happens should
    // be replaced by whatever the Enter key handlers do.
    if ($b4450e5745e49325$var$ios && event.keyCode == 13 && !event.ctrlKey && !event.altKey && !event.metaKey) {
        let now = Date.now();
        view.input.lastIOSEnter = now;
        view.input.lastIOSEnterFallbackTimeout = setTimeout(()=>{
            if (view.input.lastIOSEnter == now) {
                view.someProp("handleKeyDown", (f)=>f(view, $b4450e5745e49325$var$keyEvent(13, "Enter")));
                view.input.lastIOSEnter = 0;
            }
        }, 200);
    } else if (view.someProp("handleKeyDown", (f)=>f(view, event)) || $b4450e5745e49325$var$captureKeyDown(view, event)) event.preventDefault();
    else $b4450e5745e49325$var$setSelectionOrigin(view, "key");
};
$b4450e5745e49325$var$editHandlers.keyup = (view, event)=>{
    if (event.keyCode == 16) view.input.shiftKey = false;
};
$b4450e5745e49325$var$editHandlers.keypress = (view, _event)=>{
    let event = _event;
    if ($b4450e5745e49325$var$inOrNearComposition(view, event) || !event.charCode || event.ctrlKey && !event.altKey || $b4450e5745e49325$var$mac && event.metaKey) return;
    if (view.someProp("handleKeyPress", (f)=>f(view, event))) {
        event.preventDefault();
        return;
    }
    let sel = view.state.selection;
    if (!(sel instanceof (0, $ks2lK.TextSelection)) || !sel.$from.sameParent(sel.$to)) {
        let text = String.fromCharCode(event.charCode);
        if (!/[\r\n]/.test(text) && !view.someProp("handleTextInput", (f)=>f(view, sel.$from.pos, sel.$to.pos, text))) view.dispatch(view.state.tr.insertText(text).scrollIntoView());
        event.preventDefault();
    }
};
function $b4450e5745e49325$var$eventCoords(event) {
    return {
        left: event.clientX,
        top: event.clientY
    };
}
function $b4450e5745e49325$var$isNear(event, click) {
    let dx = click.x - event.clientX, dy = click.y - event.clientY;
    return dx * dx + dy * dy < 100;
}
function $b4450e5745e49325$var$runHandlerOnContext(view, propName, pos, inside, event) {
    if (inside == -1) return false;
    let $pos = view.state.doc.resolve(inside);
    for(let i = $pos.depth + 1; i > 0; i--){
        if (view.someProp(propName, (f)=>i > $pos.depth ? f(view, pos, $pos.nodeAfter, $pos.before(i), event, true) : f(view, pos, $pos.node(i), $pos.before(i), event, false))) return true;
    }
    return false;
}
function $b4450e5745e49325$var$updateSelection(view, selection, origin) {
    if (!view.focused) view.focus();
    if (view.state.selection.eq(selection)) return;
    let tr = view.state.tr.setSelection(selection);
    if (origin == "pointer") tr.setMeta("pointer", true);
    view.dispatch(tr);
}
function $b4450e5745e49325$var$selectClickedLeaf(view, inside) {
    if (inside == -1) return false;
    let $pos = view.state.doc.resolve(inside), node = $pos.nodeAfter;
    if (node && node.isAtom && (0, $ks2lK.NodeSelection).isSelectable(node)) {
        $b4450e5745e49325$var$updateSelection(view, new (0, $ks2lK.NodeSelection)($pos), "pointer");
        return true;
    }
    return false;
}
function $b4450e5745e49325$var$selectClickedNode(view, inside) {
    if (inside == -1) return false;
    let sel = view.state.selection, selectedNode, selectAt;
    if (sel instanceof (0, $ks2lK.NodeSelection)) selectedNode = sel.node;
    let $pos = view.state.doc.resolve(inside);
    for(let i = $pos.depth + 1; i > 0; i--){
        let node = i > $pos.depth ? $pos.nodeAfter : $pos.node(i);
        if ((0, $ks2lK.NodeSelection).isSelectable(node)) {
            if (selectedNode && sel.$from.depth > 0 && i >= sel.$from.depth && $pos.before(sel.$from.depth + 1) == sel.$from.pos) selectAt = $pos.before(sel.$from.depth);
            else selectAt = $pos.before(i);
            break;
        }
    }
    if (selectAt != null) {
        $b4450e5745e49325$var$updateSelection(view, (0, $ks2lK.NodeSelection).create(view.state.doc, selectAt), "pointer");
        return true;
    } else return false;
}
function $b4450e5745e49325$var$handleSingleClick(view, pos, inside, event, selectNode) {
    return $b4450e5745e49325$var$runHandlerOnContext(view, "handleClickOn", pos, inside, event) || view.someProp("handleClick", (f)=>f(view, pos, event)) || (selectNode ? $b4450e5745e49325$var$selectClickedNode(view, inside) : $b4450e5745e49325$var$selectClickedLeaf(view, inside));
}
function $b4450e5745e49325$var$handleDoubleClick(view, pos, inside, event) {
    return $b4450e5745e49325$var$runHandlerOnContext(view, "handleDoubleClickOn", pos, inside, event) || view.someProp("handleDoubleClick", (f)=>f(view, pos, event));
}
function $b4450e5745e49325$var$handleTripleClick(view, pos, inside, event) {
    return $b4450e5745e49325$var$runHandlerOnContext(view, "handleTripleClickOn", pos, inside, event) || view.someProp("handleTripleClick", (f)=>f(view, pos, event)) || $b4450e5745e49325$var$defaultTripleClick(view, inside, event);
}
function $b4450e5745e49325$var$defaultTripleClick(view, inside, event) {
    if (event.button != 0) return false;
    let doc = view.state.doc;
    if (inside == -1) {
        if (doc.inlineContent) {
            $b4450e5745e49325$var$updateSelection(view, (0, $ks2lK.TextSelection).create(doc, 0, doc.content.size), "pointer");
            return true;
        }
        return false;
    }
    let $pos = doc.resolve(inside);
    for(let i = $pos.depth + 1; i > 0; i--){
        let node = i > $pos.depth ? $pos.nodeAfter : $pos.node(i);
        let nodePos = $pos.before(i);
        if (node.inlineContent) $b4450e5745e49325$var$updateSelection(view, (0, $ks2lK.TextSelection).create(doc, nodePos + 1, nodePos + 1 + node.content.size), "pointer");
        else if ((0, $ks2lK.NodeSelection).isSelectable(node)) $b4450e5745e49325$var$updateSelection(view, (0, $ks2lK.NodeSelection).create(doc, nodePos), "pointer");
        else continue;
        return true;
    }
}
function $b4450e5745e49325$var$forceDOMFlush(view) {
    return $b4450e5745e49325$var$endComposition(view);
}
const $b4450e5745e49325$var$selectNodeModifier = $b4450e5745e49325$var$mac ? "metaKey" : "ctrlKey";
$b4450e5745e49325$var$handlers.mousedown = (view, _event)=>{
    let event = _event;
    view.input.shiftKey = event.shiftKey;
    let flushed = $b4450e5745e49325$var$forceDOMFlush(view);
    let now = Date.now(), type = "singleClick";
    if (now - view.input.lastClick.time < 500 && $b4450e5745e49325$var$isNear(event, view.input.lastClick) && !event[$b4450e5745e49325$var$selectNodeModifier]) {
        if (view.input.lastClick.type == "singleClick") type = "doubleClick";
        else if (view.input.lastClick.type == "doubleClick") type = "tripleClick";
    }
    view.input.lastClick = {
        time: now,
        x: event.clientX,
        y: event.clientY,
        type: type
    };
    let pos = view.posAtCoords($b4450e5745e49325$var$eventCoords(event));
    if (!pos) return;
    if (type == "singleClick") {
        if (view.input.mouseDown) view.input.mouseDown.done();
        view.input.mouseDown = new $b4450e5745e49325$var$MouseDown(view, pos, event, !!flushed);
    } else if ((type == "doubleClick" ? $b4450e5745e49325$var$handleDoubleClick : $b4450e5745e49325$var$handleTripleClick)(view, pos.pos, pos.inside, event)) event.preventDefault();
    else $b4450e5745e49325$var$setSelectionOrigin(view, "pointer");
};
class $b4450e5745e49325$var$MouseDown {
    done() {
        this.view.root.removeEventListener("mouseup", this.up);
        this.view.root.removeEventListener("mousemove", this.move);
        if (this.mightDrag && this.target) {
            this.view.domObserver.stop();
            if (this.mightDrag.addAttr) this.target.removeAttribute("draggable");
            if (this.mightDrag.setUneditable) this.target.removeAttribute("contentEditable");
            this.view.domObserver.start();
        }
        if (this.delayedSelectionSync) setTimeout(()=>$b4450e5745e49325$var$selectionToDOM(this.view));
        this.view.input.mouseDown = null;
    }
    up(event) {
        this.done();
        if (!this.view.dom.contains(event.target)) return;
        let pos = this.pos;
        if (this.view.state.doc != this.startDoc) pos = this.view.posAtCoords($b4450e5745e49325$var$eventCoords(event));
        this.updateAllowDefault(event);
        if (this.allowDefault || !pos) $b4450e5745e49325$var$setSelectionOrigin(this.view, "pointer");
        else if ($b4450e5745e49325$var$handleSingleClick(this.view, pos.pos, pos.inside, event, this.selectNode)) event.preventDefault();
        else if (event.button == 0 && (this.flushed || // Safari ignores clicks on draggable elements
        $b4450e5745e49325$var$safari && this.mightDrag && !this.mightDrag.node.isAtom || // Chrome will sometimes treat a node selection as a
        // cursor, but still report that the node is selected
        // when asked through getSelection. You'll then get a
        // situation where clicking at the point where that
        // (hidden) cursor is doesn't change the selection, and
        // thus doesn't get a reaction from ProseMirror. This
        // works around that.
        $b4450e5745e49325$var$chrome && !this.view.state.selection.visible && Math.min(Math.abs(pos.pos - this.view.state.selection.from), Math.abs(pos.pos - this.view.state.selection.to)) <= 2)) {
            $b4450e5745e49325$var$updateSelection(this.view, (0, $ks2lK.Selection).near(this.view.state.doc.resolve(pos.pos)), "pointer");
            event.preventDefault();
        } else $b4450e5745e49325$var$setSelectionOrigin(this.view, "pointer");
    }
    move(event) {
        this.updateAllowDefault(event);
        $b4450e5745e49325$var$setSelectionOrigin(this.view, "pointer");
        if (event.buttons == 0) this.done();
    }
    updateAllowDefault(event) {
        if (!this.allowDefault && (Math.abs(this.event.x - event.clientX) > 4 || Math.abs(this.event.y - event.clientY) > 4)) this.allowDefault = true;
    }
    constructor(view, pos, event, flushed){
        this.view = view;
        this.pos = pos;
        this.event = event;
        this.flushed = flushed;
        this.delayedSelectionSync = false;
        this.mightDrag = null;
        this.startDoc = view.state.doc;
        this.selectNode = !!event[$b4450e5745e49325$var$selectNodeModifier];
        this.allowDefault = event.shiftKey;
        let targetNode, targetPos;
        if (pos.inside > -1) {
            targetNode = view.state.doc.nodeAt(pos.inside);
            targetPos = pos.inside;
        } else {
            let $pos = view.state.doc.resolve(pos.pos);
            targetNode = $pos.parent;
            targetPos = $pos.depth ? $pos.before() : 0;
        }
        const target = flushed ? null : event.target;
        const targetDesc = target ? view.docView.nearestDesc(target, true) : null;
        this.target = targetDesc && targetDesc.dom.nodeType == 1 ? targetDesc.dom : null;
        let { selection: selection } = view.state;
        if (event.button == 0 && targetNode.type.spec.draggable && targetNode.type.spec.selectable !== false || selection instanceof (0, $ks2lK.NodeSelection) && selection.from <= targetPos && selection.to > targetPos) this.mightDrag = {
            node: targetNode,
            pos: targetPos,
            addAttr: !!(this.target && !this.target.draggable),
            setUneditable: !!(this.target && $b4450e5745e49325$var$gecko && !this.target.hasAttribute("contentEditable"))
        };
        if (this.target && this.mightDrag && (this.mightDrag.addAttr || this.mightDrag.setUneditable)) {
            this.view.domObserver.stop();
            if (this.mightDrag.addAttr) this.target.draggable = true;
            if (this.mightDrag.setUneditable) setTimeout(()=>{
                if (this.view.input.mouseDown == this) this.target.setAttribute("contentEditable", "false");
            }, 20);
            this.view.domObserver.start();
        }
        view.root.addEventListener("mouseup", this.up = this.up.bind(this));
        view.root.addEventListener("mousemove", this.move = this.move.bind(this));
        $b4450e5745e49325$var$setSelectionOrigin(view, "pointer");
    }
}
$b4450e5745e49325$var$handlers.touchstart = (view)=>{
    view.input.lastTouch = Date.now();
    $b4450e5745e49325$var$forceDOMFlush(view);
    $b4450e5745e49325$var$setSelectionOrigin(view, "pointer");
};
$b4450e5745e49325$var$handlers.touchmove = (view)=>{
    view.input.lastTouch = Date.now();
    $b4450e5745e49325$var$setSelectionOrigin(view, "pointer");
};
$b4450e5745e49325$var$handlers.contextmenu = (view)=>$b4450e5745e49325$var$forceDOMFlush(view);
function $b4450e5745e49325$var$inOrNearComposition(view, event) {
    if (view.composing) return true;
    // See https://www.stum.de/2016/06/24/handling-ime-events-in-javascript/.
    // On Japanese input method editors (IMEs), the Enter key is used to confirm character
    // selection. On Safari, when Enter is pressed, compositionend and keydown events are
    // emitted. The keydown event triggers newline insertion, which we don't want.
    // This method returns true if the keydown event should be ignored.
    // We only ignore it once, as pressing Enter a second time *should* insert a newline.
    // Furthermore, the keydown event timestamp must be close to the compositionEndedAt timestamp.
    // This guards against the case where compositionend is triggered without the keyboard
    // (e.g. character confirmation may be done with the mouse), and keydown is triggered
    // afterwards- we wouldn't want to ignore the keydown event in this case.
    if ($b4450e5745e49325$var$safari && Math.abs(event.timeStamp - view.input.compositionEndedAt) < 500) {
        view.input.compositionEndedAt = -200000000;
        return true;
    }
    return false;
}
// Drop active composition after 5 seconds of inactivity on Android
const $b4450e5745e49325$var$timeoutComposition = $b4450e5745e49325$var$android ? 5000 : -1;
$b4450e5745e49325$var$editHandlers.compositionstart = $b4450e5745e49325$var$editHandlers.compositionupdate = (view)=>{
    if (!view.composing) {
        view.domObserver.flush();
        let { state: state } = view, $pos = state.selection.$to;
        if (state.selection instanceof (0, $ks2lK.TextSelection) && (state.storedMarks || !$pos.textOffset && $pos.parentOffset && $pos.nodeBefore.marks.some((m)=>m.type.spec.inclusive === false))) {
            // Need to wrap the cursor in mark nodes different from the ones in the DOM context
            view.markCursor = view.state.storedMarks || $pos.marks();
            $b4450e5745e49325$var$endComposition(view, true);
            view.markCursor = null;
        } else {
            $b4450e5745e49325$var$endComposition(view, !state.selection.empty);
            // In firefox, if the cursor is after but outside a marked node,
            // the inserted text won't inherit the marks. So this moves it
            // inside if necessary.
            if ($b4450e5745e49325$var$gecko && state.selection.empty && $pos.parentOffset && !$pos.textOffset && $pos.nodeBefore.marks.length) {
                let sel = view.domSelectionRange();
                for(let node = sel.focusNode, offset = sel.focusOffset; node && node.nodeType == 1 && offset != 0;){
                    let before = offset < 0 ? node.lastChild : node.childNodes[offset - 1];
                    if (!before) break;
                    if (before.nodeType == 3) {
                        let sel = view.domSelection();
                        if (sel) sel.collapse(before, before.nodeValue.length);
                        break;
                    } else {
                        node = before;
                        offset = -1;
                    }
                }
            }
        }
        view.input.composing = true;
    }
    $b4450e5745e49325$var$scheduleComposeEnd(view, $b4450e5745e49325$var$timeoutComposition);
};
$b4450e5745e49325$var$editHandlers.compositionend = (view, event)=>{
    if (view.composing) {
        view.input.composing = false;
        view.input.compositionEndedAt = event.timeStamp;
        view.input.compositionPendingChanges = view.domObserver.pendingRecords().length ? view.input.compositionID : 0;
        view.input.compositionNode = null;
        if (view.input.compositionPendingChanges) Promise.resolve().then(()=>view.domObserver.flush());
        view.input.compositionID++;
        $b4450e5745e49325$var$scheduleComposeEnd(view, 20);
    }
};
function $b4450e5745e49325$var$scheduleComposeEnd(view, delay) {
    clearTimeout(view.input.composingTimeout);
    if (delay > -1) view.input.composingTimeout = setTimeout(()=>$b4450e5745e49325$var$endComposition(view), delay);
}
function $b4450e5745e49325$var$clearComposition(view) {
    if (view.composing) {
        view.input.composing = false;
        view.input.compositionEndedAt = $b4450e5745e49325$var$timestampFromCustomEvent();
    }
    while(view.input.compositionNodes.length > 0)view.input.compositionNodes.pop().markParentsDirty();
}
function $b4450e5745e49325$var$findCompositionNode(view) {
    let sel = view.domSelectionRange();
    if (!sel.focusNode) return null;
    let textBefore = $b4450e5745e49325$var$textNodeBefore$1(sel.focusNode, sel.focusOffset);
    let textAfter = $b4450e5745e49325$var$textNodeAfter$1(sel.focusNode, sel.focusOffset);
    if (textBefore && textAfter && textBefore != textAfter) {
        let descAfter = textAfter.pmViewDesc, lastChanged = view.domObserver.lastChangedTextNode;
        if (textBefore == lastChanged || textAfter == lastChanged) return lastChanged;
        if (!descAfter || !descAfter.isText(textAfter.nodeValue)) return textAfter;
        else if (view.input.compositionNode == textAfter) {
            let descBefore = textBefore.pmViewDesc;
            if (!(!descBefore || !descBefore.isText(textBefore.nodeValue))) return textAfter;
        }
    }
    return textBefore || textAfter;
}
function $b4450e5745e49325$var$timestampFromCustomEvent() {
    let event = document.createEvent("Event");
    event.initEvent("event", true, true);
    return event.timeStamp;
}
/**
@internal
*/ function $b4450e5745e49325$var$endComposition(view, restarting = false) {
    if ($b4450e5745e49325$var$android && view.domObserver.flushingSoon >= 0) return;
    view.domObserver.forceFlush();
    $b4450e5745e49325$var$clearComposition(view);
    if (restarting || view.docView && view.docView.dirty) {
        let sel = $b4450e5745e49325$var$selectionFromDOM(view);
        if (sel && !sel.eq(view.state.selection)) view.dispatch(view.state.tr.setSelection(sel));
        else if ((view.markCursor || restarting) && !view.state.selection.empty) view.dispatch(view.state.tr.deleteSelection());
        else view.updateState(view.state);
        return true;
    }
    return false;
}
function $b4450e5745e49325$var$captureCopy(view, dom) {
    // The extra wrapper is somehow necessary on IE/Edge to prevent the
    // content from being mangled when it is put onto the clipboard
    if (!view.dom.parentNode) return;
    let wrap = view.dom.parentNode.appendChild(document.createElement("div"));
    wrap.appendChild(dom);
    wrap.style.cssText = "position: fixed; left: -10000px; top: 10px";
    let sel = getSelection(), range = document.createRange();
    range.selectNodeContents(dom);
    // Done because IE will fire a selectionchange moving the selection
    // to its start when removeAllRanges is called and the editor still
    // has focus (which will mess up the editor's selection state).
    view.dom.blur();
    sel.removeAllRanges();
    sel.addRange(range);
    setTimeout(()=>{
        if (wrap.parentNode) wrap.parentNode.removeChild(wrap);
        view.focus();
    }, 50);
}
// This is very crude, but unfortunately both these browsers _pretend_
// that they have a clipboard API—all the objects and methods are
// there, they just don't work, and they are hard to test.
const $b4450e5745e49325$var$brokenClipboardAPI = $b4450e5745e49325$var$ie && $b4450e5745e49325$var$ie_version < 15 || $b4450e5745e49325$var$ios && $b4450e5745e49325$var$webkit_version < 604;
$b4450e5745e49325$var$handlers.copy = $b4450e5745e49325$var$editHandlers.cut = (view, _event)=>{
    let event = _event;
    let sel = view.state.selection, cut = event.type == "cut";
    if (sel.empty) return;
    // IE and Edge's clipboard interface is completely broken
    let data = $b4450e5745e49325$var$brokenClipboardAPI ? null : event.clipboardData;
    let slice = sel.content(), { dom: dom, text: text } = $b4450e5745e49325$var$serializeForClipboard(view, slice);
    if (data) {
        event.preventDefault();
        data.clearData();
        data.setData("text/html", dom.innerHTML);
        data.setData("text/plain", text);
    } else $b4450e5745e49325$var$captureCopy(view, dom);
    if (cut) view.dispatch(view.state.tr.deleteSelection().scrollIntoView().setMeta("uiEvent", "cut"));
};
function $b4450e5745e49325$var$sliceSingleNode(slice) {
    return slice.openStart == 0 && slice.openEnd == 0 && slice.content.childCount == 1 ? slice.content.firstChild : null;
}
function $b4450e5745e49325$var$capturePaste(view, event) {
    if (!view.dom.parentNode) return;
    let plainText = view.input.shiftKey || view.state.selection.$from.parent.type.spec.code;
    let target = view.dom.parentNode.appendChild(document.createElement(plainText ? "textarea" : "div"));
    if (!plainText) target.contentEditable = "true";
    target.style.cssText = "position: fixed; left: -10000px; top: 10px";
    target.focus();
    let plain = view.input.shiftKey && view.input.lastKeyCode != 45;
    setTimeout(()=>{
        view.focus();
        if (target.parentNode) target.parentNode.removeChild(target);
        if (plainText) $b4450e5745e49325$var$doPaste(view, target.value, null, plain, event);
        else $b4450e5745e49325$var$doPaste(view, target.textContent, target.innerHTML, plain, event);
    }, 50);
}
function $b4450e5745e49325$var$doPaste(view, text, html, preferPlain, event) {
    let slice = $b4450e5745e49325$var$parseFromClipboard(view, text, html, preferPlain, view.state.selection.$from);
    if (view.someProp("handlePaste", (f)=>f(view, event, slice || (0, $5SAOw.Slice).empty))) return true;
    if (!slice) return false;
    let singleNode = $b4450e5745e49325$var$sliceSingleNode(slice);
    let tr = singleNode ? view.state.tr.replaceSelectionWith(singleNode, preferPlain) : view.state.tr.replaceSelection(slice);
    view.dispatch(tr.scrollIntoView().setMeta("paste", true).setMeta("uiEvent", "paste"));
    return true;
}
function $b4450e5745e49325$var$getText(clipboardData) {
    let text = clipboardData.getData("text/plain") || clipboardData.getData("Text");
    if (text) return text;
    let uris = clipboardData.getData("text/uri-list");
    return uris ? uris.replace(/\r?\n/g, " ") : "";
}
$b4450e5745e49325$var$editHandlers.paste = (view, _event)=>{
    let event = _event;
    // Handling paste from JavaScript during composition is very poorly
    // handled by browsers, so as a dodgy but preferable kludge, we just
    // let the browser do its native thing there, except on Android,
    // where the editor is almost always composing.
    if (view.composing && !$b4450e5745e49325$var$android) return;
    let data = $b4450e5745e49325$var$brokenClipboardAPI ? null : event.clipboardData;
    let plain = view.input.shiftKey && view.input.lastKeyCode != 45;
    if (data && $b4450e5745e49325$var$doPaste(view, $b4450e5745e49325$var$getText(data), data.getData("text/html"), plain, event)) event.preventDefault();
    else $b4450e5745e49325$var$capturePaste(view, event);
};
class $b4450e5745e49325$var$Dragging {
    constructor(slice, move, node){
        this.slice = slice;
        this.move = move;
        this.node = node;
    }
}
const $b4450e5745e49325$var$dragCopyModifier = $b4450e5745e49325$var$mac ? "altKey" : "ctrlKey";
$b4450e5745e49325$var$handlers.dragstart = (view, _event)=>{
    let event = _event;
    let mouseDown = view.input.mouseDown;
    if (mouseDown) mouseDown.done();
    if (!event.dataTransfer) return;
    let sel = view.state.selection;
    let pos = sel.empty ? null : view.posAtCoords($b4450e5745e49325$var$eventCoords(event));
    let node;
    if (pos && pos.pos >= sel.from && pos.pos <= (sel instanceof (0, $ks2lK.NodeSelection) ? sel.to - 1 : sel.to)) ;
    else if (mouseDown && mouseDown.mightDrag) node = (0, $ks2lK.NodeSelection).create(view.state.doc, mouseDown.mightDrag.pos);
    else if (event.target && event.target.nodeType == 1) {
        let desc = view.docView.nearestDesc(event.target, true);
        if (desc && desc.node.type.spec.draggable && desc != view.docView) node = (0, $ks2lK.NodeSelection).create(view.state.doc, desc.posBefore);
    }
    let draggedSlice = (node || view.state.selection).content();
    let { dom: dom, text: text, slice: slice } = $b4450e5745e49325$var$serializeForClipboard(view, draggedSlice);
    // Pre-120 Chrome versions clear files when calling `clearData` (#1472)
    if (!event.dataTransfer.files.length || !$b4450e5745e49325$var$chrome || $b4450e5745e49325$var$chrome_version > 120) event.dataTransfer.clearData();
    event.dataTransfer.setData($b4450e5745e49325$var$brokenClipboardAPI ? "Text" : "text/html", dom.innerHTML);
    // See https://github.com/ProseMirror/prosemirror/issues/1156
    event.dataTransfer.effectAllowed = "copyMove";
    if (!$b4450e5745e49325$var$brokenClipboardAPI) event.dataTransfer.setData("text/plain", text);
    view.dragging = new $b4450e5745e49325$var$Dragging(slice, !event[$b4450e5745e49325$var$dragCopyModifier], node);
};
$b4450e5745e49325$var$handlers.dragend = (view)=>{
    let dragging = view.dragging;
    window.setTimeout(()=>{
        if (view.dragging == dragging) view.dragging = null;
    }, 50);
};
$b4450e5745e49325$var$editHandlers.dragover = $b4450e5745e49325$var$editHandlers.dragenter = (_, e)=>e.preventDefault();
$b4450e5745e49325$var$editHandlers.drop = (view, _event)=>{
    let event = _event;
    let dragging = view.dragging;
    view.dragging = null;
    if (!event.dataTransfer) return;
    let eventPos = view.posAtCoords($b4450e5745e49325$var$eventCoords(event));
    if (!eventPos) return;
    let $mouse = view.state.doc.resolve(eventPos.pos);
    let slice = dragging && dragging.slice;
    if (slice) view.someProp("transformPasted", (f)=>{
        slice = f(slice, view);
    });
    else slice = $b4450e5745e49325$var$parseFromClipboard(view, $b4450e5745e49325$var$getText(event.dataTransfer), $b4450e5745e49325$var$brokenClipboardAPI ? null : event.dataTransfer.getData("text/html"), false, $mouse);
    let move = !!(dragging && !event[$b4450e5745e49325$var$dragCopyModifier]);
    if (view.someProp("handleDrop", (f)=>f(view, event, slice || (0, $5SAOw.Slice).empty, move))) {
        event.preventDefault();
        return;
    }
    if (!slice) return;
    event.preventDefault();
    let insertPos = slice ? (0, $aXG5V.dropPoint)(view.state.doc, $mouse.pos, slice) : $mouse.pos;
    if (insertPos == null) insertPos = $mouse.pos;
    let tr = view.state.tr;
    if (move) {
        let { node: node } = dragging;
        if (node) node.replace(tr);
        else tr.deleteSelection();
    }
    let pos = tr.mapping.map(insertPos);
    let isNode = slice.openStart == 0 && slice.openEnd == 0 && slice.content.childCount == 1;
    let beforeInsert = tr.doc;
    if (isNode) tr.replaceRangeWith(pos, pos, slice.content.firstChild);
    else tr.replaceRange(pos, pos, slice);
    if (tr.doc.eq(beforeInsert)) return;
    let $pos = tr.doc.resolve(pos);
    if (isNode && (0, $ks2lK.NodeSelection).isSelectable(slice.content.firstChild) && $pos.nodeAfter && $pos.nodeAfter.sameMarkup(slice.content.firstChild)) tr.setSelection(new (0, $ks2lK.NodeSelection)($pos));
    else {
        let end = tr.mapping.map(insertPos);
        tr.mapping.maps[tr.mapping.maps.length - 1].forEach((_from, _to, _newFrom, newTo)=>end = newTo);
        tr.setSelection($b4450e5745e49325$var$selectionBetween(view, $pos, tr.doc.resolve(end)));
    }
    view.focus();
    view.dispatch(tr.setMeta("uiEvent", "drop"));
};
$b4450e5745e49325$var$handlers.focus = (view)=>{
    view.input.lastFocus = Date.now();
    if (!view.focused) {
        view.domObserver.stop();
        view.dom.classList.add("ProseMirror-focused");
        view.domObserver.start();
        view.focused = true;
        setTimeout(()=>{
            if (view.docView && view.hasFocus() && !view.domObserver.currentSelection.eq(view.domSelectionRange())) $b4450e5745e49325$var$selectionToDOM(view);
        }, 20);
    }
};
$b4450e5745e49325$var$handlers.blur = (view, _event)=>{
    let event = _event;
    if (view.focused) {
        view.domObserver.stop();
        view.dom.classList.remove("ProseMirror-focused");
        view.domObserver.start();
        if (event.relatedTarget && view.dom.contains(event.relatedTarget)) view.domObserver.currentSelection.clear();
        view.focused = false;
    }
};
$b4450e5745e49325$var$handlers.beforeinput = (view, _event)=>{
    let event = _event;
    // We should probably do more with beforeinput events, but support
    // is so spotty that I'm still waiting to see where they are going.
    // Very specific hack to deal with backspace sometimes failing on
    // Chrome Android when after an uneditable node.
    if ($b4450e5745e49325$var$chrome && $b4450e5745e49325$var$android && event.inputType == "deleteContentBackward") {
        view.domObserver.flushSoon();
        let { domChangeCount: domChangeCount } = view.input;
        setTimeout(()=>{
            if (view.input.domChangeCount != domChangeCount) return; // Event already had some effect
            // This bug tends to close the virtual keyboard, so we refocus
            view.dom.blur();
            view.focus();
            if (view.someProp("handleKeyDown", (f)=>f(view, $b4450e5745e49325$var$keyEvent(8, "Backspace")))) return;
            let { $cursor: $cursor } = view.state.selection;
            // Crude approximation of backspace behavior when no command handled it
            if ($cursor && $cursor.pos > 0) view.dispatch(view.state.tr.delete($cursor.pos - 1, $cursor.pos).scrollIntoView());
        }, 50);
    }
};
// Make sure all handlers get registered
for(let prop in $b4450e5745e49325$var$editHandlers)$b4450e5745e49325$var$handlers[prop] = $b4450e5745e49325$var$editHandlers[prop];
function $b4450e5745e49325$var$compareObjs(a, b) {
    if (a == b) return true;
    for(let p in a)if (a[p] !== b[p]) return false;
    for(let p in b)if (!(p in a)) return false;
    return true;
}
class $b4450e5745e49325$var$WidgetType {
    map(mapping, span, offset, oldOffset) {
        let { pos: pos, deleted: deleted } = mapping.mapResult(span.from + oldOffset, this.side < 0 ? -1 : 1);
        return deleted ? null : new $b4450e5745e49325$export$10e30b733df217ea(pos - offset, pos - offset, this);
    }
    valid() {
        return true;
    }
    eq(other) {
        return this == other || other instanceof $b4450e5745e49325$var$WidgetType && (this.spec.key && this.spec.key == other.spec.key || this.toDOM == other.toDOM && $b4450e5745e49325$var$compareObjs(this.spec, other.spec));
    }
    destroy(node) {
        if (this.spec.destroy) this.spec.destroy(node);
    }
    constructor(toDOM, spec){
        this.toDOM = toDOM;
        this.spec = spec || $b4450e5745e49325$var$noSpec;
        this.side = this.spec.side || 0;
    }
}
class $b4450e5745e49325$var$InlineType {
    map(mapping, span, offset, oldOffset) {
        let from = mapping.map(span.from + oldOffset, this.spec.inclusiveStart ? -1 : 1) - offset;
        let to = mapping.map(span.to + oldOffset, this.spec.inclusiveEnd ? 1 : -1) - offset;
        return from >= to ? null : new $b4450e5745e49325$export$10e30b733df217ea(from, to, this);
    }
    valid(_, span) {
        return span.from < span.to;
    }
    eq(other) {
        return this == other || other instanceof $b4450e5745e49325$var$InlineType && $b4450e5745e49325$var$compareObjs(this.attrs, other.attrs) && $b4450e5745e49325$var$compareObjs(this.spec, other.spec);
    }
    static is(span) {
        return span.type instanceof $b4450e5745e49325$var$InlineType;
    }
    destroy() {}
    constructor(attrs, spec){
        this.attrs = attrs;
        this.spec = spec || $b4450e5745e49325$var$noSpec;
    }
}
class $b4450e5745e49325$var$NodeType {
    map(mapping, span, offset, oldOffset) {
        let from = mapping.mapResult(span.from + oldOffset, 1);
        if (from.deleted) return null;
        let to = mapping.mapResult(span.to + oldOffset, -1);
        if (to.deleted || to.pos <= from.pos) return null;
        return new $b4450e5745e49325$export$10e30b733df217ea(from.pos - offset, to.pos - offset, this);
    }
    valid(node, span) {
        let { index: index, offset: offset } = node.content.findIndex(span.from), child;
        return offset == span.from && !(child = node.child(index)).isText && offset + child.nodeSize == span.to;
    }
    eq(other) {
        return this == other || other instanceof $b4450e5745e49325$var$NodeType && $b4450e5745e49325$var$compareObjs(this.attrs, other.attrs) && $b4450e5745e49325$var$compareObjs(this.spec, other.spec);
    }
    destroy() {}
    constructor(attrs, spec){
        this.attrs = attrs;
        this.spec = spec || $b4450e5745e49325$var$noSpec;
    }
}
/**
Decoration objects can be provided to the view through the
[`decorations` prop](https://prosemirror.net/docs/ref/#view.EditorProps.decorations). They come in
several variants—see the static members of this class for details.
*/ class $b4450e5745e49325$export$10e30b733df217ea {
    /**
    @internal
    */ copy(from, to) {
        return new $b4450e5745e49325$export$10e30b733df217ea(from, to, this.type);
    }
    /**
    @internal
    */ eq(other, offset = 0) {
        return this.type.eq(other.type) && this.from + offset == other.from && this.to + offset == other.to;
    }
    /**
    @internal
    */ map(mapping, offset, oldOffset) {
        return this.type.map(mapping, this, offset, oldOffset);
    }
    /**
    Creates a widget decoration, which is a DOM node that's shown in
    the document at the given position. It is recommended that you
    delay rendering the widget by passing a function that will be
    called when the widget is actually drawn in a view, but you can
    also directly pass a DOM node. `getPos` can be used to find the
    widget's current document position.
    */ static widget(pos, toDOM, spec) {
        return new $b4450e5745e49325$export$10e30b733df217ea(pos, pos, new $b4450e5745e49325$var$WidgetType(toDOM, spec));
    }
    /**
    Creates an inline decoration, which adds the given attributes to
    each inline node between `from` and `to`.
    */ static inline(from, to, attrs, spec) {
        return new $b4450e5745e49325$export$10e30b733df217ea(from, to, new $b4450e5745e49325$var$InlineType(attrs, spec));
    }
    /**
    Creates a node decoration. `from` and `to` should point precisely
    before and after a node in the document. That node, and only that
    node, will receive the given attributes.
    */ static node(from, to, attrs, spec) {
        return new $b4450e5745e49325$export$10e30b733df217ea(from, to, new $b4450e5745e49325$var$NodeType(attrs, spec));
    }
    /**
    The spec provided when creating this decoration. Can be useful
    if you've stored extra information in that object.
    */ get spec() {
        return this.type.spec;
    }
    /**
    @internal
    */ get inline() {
        return this.type instanceof $b4450e5745e49325$var$InlineType;
    }
    /**
    @internal
    */ get widget() {
        return this.type instanceof $b4450e5745e49325$var$WidgetType;
    }
    /**
    @internal
    */ constructor(/**
    The start position of the decoration.
    */ from, /**
    The end position. Will be the same as `from` for [widget
    decorations](https://prosemirror.net/docs/ref/#view.Decoration^widget).
    */ to, /**
    @internal
    */ type){
        this.from = from;
        this.to = to;
        this.type = type;
    }
}
const $b4450e5745e49325$var$none = [], $b4450e5745e49325$var$noSpec = {};
/**
A collection of [decorations](https://prosemirror.net/docs/ref/#view.Decoration), organized in such
a way that the drawing algorithm can efficiently use and compare
them. This is a persistent data structure—it is not modified,
updates create a new value.
*/ class $b4450e5745e49325$export$93bf62eb445cec98 {
    /**
    Create a set of decorations, using the structure of the given
    document. This will consume (modify) the `decorations` array, so
    you must make a copy if you want need to preserve that.
    */ static create(doc, decorations) {
        return decorations.length ? $b4450e5745e49325$var$buildTree(decorations, doc, 0, $b4450e5745e49325$var$noSpec) : $b4450e5745e49325$var$empty;
    }
    /**
    Find all decorations in this set which touch the given range
    (including decorations that start or end directly at the
    boundaries) and match the given predicate on their spec. When
    `start` and `end` are omitted, all decorations in the set are
    considered. When `predicate` isn't given, all decorations are
    assumed to match.
    */ find(start, end, predicate) {
        let result = [];
        this.findInner(start == null ? 0 : start, end == null ? 1e9 : end, result, 0, predicate);
        return result;
    }
    findInner(start, end, result, offset, predicate) {
        for(let i = 0; i < this.local.length; i++){
            let span = this.local[i];
            if (span.from <= end && span.to >= start && (!predicate || predicate(span.spec))) result.push(span.copy(span.from + offset, span.to + offset));
        }
        for(let i = 0; i < this.children.length; i += 3)if (this.children[i] < end && this.children[i + 1] > start) {
            let childOff = this.children[i] + 1;
            this.children[i + 2].findInner(start - childOff, end - childOff, result, offset + childOff, predicate);
        }
    }
    /**
    Map the set of decorations in response to a change in the
    document.
    */ map(mapping, doc, options) {
        if (this == $b4450e5745e49325$var$empty || mapping.maps.length == 0) return this;
        return this.mapInner(mapping, doc, 0, 0, options || $b4450e5745e49325$var$noSpec);
    }
    /**
    @internal
    */ mapInner(mapping, node, offset, oldOffset, options) {
        let newLocal;
        for(let i = 0; i < this.local.length; i++){
            let mapped = this.local[i].map(mapping, offset, oldOffset);
            if (mapped && mapped.type.valid(node, mapped)) (newLocal || (newLocal = [])).push(mapped);
            else if (options.onRemove) options.onRemove(this.local[i].spec);
        }
        if (this.children.length) return $b4450e5745e49325$var$mapChildren(this.children, newLocal || [], mapping, node, offset, oldOffset, options);
        else return newLocal ? new $b4450e5745e49325$export$93bf62eb445cec98(newLocal.sort($b4450e5745e49325$var$byPos), $b4450e5745e49325$var$none) : $b4450e5745e49325$var$empty;
    }
    /**
    Add the given array of decorations to the ones in the set,
    producing a new set. Consumes the `decorations` array. Needs
    access to the current document to create the appropriate tree
    structure.
    */ add(doc, decorations) {
        if (!decorations.length) return this;
        if (this == $b4450e5745e49325$var$empty) return $b4450e5745e49325$export$93bf62eb445cec98.create(doc, decorations);
        return this.addInner(doc, decorations, 0);
    }
    addInner(doc, decorations, offset) {
        let children, childIndex = 0;
        doc.forEach((childNode, childOffset)=>{
            let baseOffset = childOffset + offset, found;
            if (!(found = $b4450e5745e49325$var$takeSpansForNode(decorations, childNode, baseOffset))) return;
            if (!children) children = this.children.slice();
            while(childIndex < children.length && children[childIndex] < childOffset)childIndex += 3;
            if (children[childIndex] == childOffset) children[childIndex + 2] = children[childIndex + 2].addInner(childNode, found, baseOffset + 1);
            else children.splice(childIndex, 0, childOffset, childOffset + childNode.nodeSize, $b4450e5745e49325$var$buildTree(found, childNode, baseOffset + 1, $b4450e5745e49325$var$noSpec));
            childIndex += 3;
        });
        let local = $b4450e5745e49325$var$moveSpans(childIndex ? $b4450e5745e49325$var$withoutNulls(decorations) : decorations, -offset);
        for(let i = 0; i < local.length; i++)if (!local[i].type.valid(doc, local[i])) local.splice(i--, 1);
        return new $b4450e5745e49325$export$93bf62eb445cec98(local.length ? this.local.concat(local).sort($b4450e5745e49325$var$byPos) : this.local, children || this.children);
    }
    /**
    Create a new set that contains the decorations in this set, minus
    the ones in the given array.
    */ remove(decorations) {
        if (decorations.length == 0 || this == $b4450e5745e49325$var$empty) return this;
        return this.removeInner(decorations, 0);
    }
    removeInner(decorations, offset) {
        let children = this.children, local = this.local;
        for(let i = 0; i < children.length; i += 3){
            let found;
            let from = children[i] + offset, to = children[i + 1] + offset;
            for(let j = 0, span; j < decorations.length; j++)if (span = decorations[j]) {
                if (span.from > from && span.to < to) {
                    decorations[j] = null;
                    (found || (found = [])).push(span);
                }
            }
            if (!found) continue;
            if (children == this.children) children = this.children.slice();
            let removed = children[i + 2].removeInner(found, from + 1);
            if (removed != $b4450e5745e49325$var$empty) children[i + 2] = removed;
            else {
                children.splice(i, 3);
                i -= 3;
            }
        }
        if (local.length) {
            for(let i = 0, span; i < decorations.length; i++)if (span = decorations[i]) {
                for(let j = 0; j < local.length; j++)if (local[j].eq(span, offset)) {
                    if (local == this.local) local = this.local.slice();
                    local.splice(j--, 1);
                }
            }
        }
        if (children == this.children && local == this.local) return this;
        return local.length || children.length ? new $b4450e5745e49325$export$93bf62eb445cec98(local, children) : $b4450e5745e49325$var$empty;
    }
    forChild(offset, node) {
        if (this == $b4450e5745e49325$var$empty) return this;
        if (node.isLeaf) return $b4450e5745e49325$export$93bf62eb445cec98.empty;
        let child, local;
        for(let i = 0; i < this.children.length; i += 3)if (this.children[i] >= offset) {
            if (this.children[i] == offset) child = this.children[i + 2];
            break;
        }
        let start = offset + 1, end = start + node.content.size;
        for(let i = 0; i < this.local.length; i++){
            let dec = this.local[i];
            if (dec.from < end && dec.to > start && dec.type instanceof $b4450e5745e49325$var$InlineType) {
                let from = Math.max(start, dec.from) - start, to = Math.min(end, dec.to) - start;
                if (from < to) (local || (local = [])).push(dec.copy(from, to));
            }
        }
        if (local) {
            let localSet = new $b4450e5745e49325$export$93bf62eb445cec98(local.sort($b4450e5745e49325$var$byPos), $b4450e5745e49325$var$none);
            return child ? new $b4450e5745e49325$var$DecorationGroup([
                localSet,
                child
            ]) : localSet;
        }
        return child || $b4450e5745e49325$var$empty;
    }
    /**
    @internal
    */ eq(other) {
        if (this == other) return true;
        if (!(other instanceof $b4450e5745e49325$export$93bf62eb445cec98) || this.local.length != other.local.length || this.children.length != other.children.length) return false;
        for(let i = 0; i < this.local.length; i++)if (!this.local[i].eq(other.local[i])) return false;
        for(let i = 0; i < this.children.length; i += 3)if (this.children[i] != other.children[i] || this.children[i + 1] != other.children[i + 1] || !this.children[i + 2].eq(other.children[i + 2])) return false;
        return true;
    }
    /**
    @internal
    */ locals(node) {
        return $b4450e5745e49325$var$removeOverlap(this.localsInner(node));
    }
    /**
    @internal
    */ localsInner(node) {
        if (this == $b4450e5745e49325$var$empty) return $b4450e5745e49325$var$none;
        if (node.inlineContent || !this.local.some($b4450e5745e49325$var$InlineType.is)) return this.local;
        let result = [];
        for(let i = 0; i < this.local.length; i++)if (!(this.local[i].type instanceof $b4450e5745e49325$var$InlineType)) result.push(this.local[i]);
        return result;
    }
    forEachSet(f) {
        f(this);
    }
    /**
    @internal
    */ constructor(local, children){
        this.local = local.length ? local : $b4450e5745e49325$var$none;
        this.children = children.length ? children : $b4450e5745e49325$var$none;
    }
}
/**
The empty set of decorations.
*/ $b4450e5745e49325$export$93bf62eb445cec98.empty = new $b4450e5745e49325$export$93bf62eb445cec98([], []);
/**
@internal
*/ $b4450e5745e49325$export$93bf62eb445cec98.removeOverlap = $b4450e5745e49325$var$removeOverlap;
const $b4450e5745e49325$var$empty = $b4450e5745e49325$export$93bf62eb445cec98.empty;
// An abstraction that allows the code dealing with decorations to
// treat multiple DecorationSet objects as if it were a single object
// with (a subset of) the same interface.
class $b4450e5745e49325$var$DecorationGroup {
    map(mapping, doc) {
        const mappedDecos = this.members.map((member)=>member.map(mapping, doc, $b4450e5745e49325$var$noSpec));
        return $b4450e5745e49325$var$DecorationGroup.from(mappedDecos);
    }
    forChild(offset, child) {
        if (child.isLeaf) return $b4450e5745e49325$export$93bf62eb445cec98.empty;
        let found = [];
        for(let i = 0; i < this.members.length; i++){
            let result = this.members[i].forChild(offset, child);
            if (result == $b4450e5745e49325$var$empty) continue;
            if (result instanceof $b4450e5745e49325$var$DecorationGroup) found = found.concat(result.members);
            else found.push(result);
        }
        return $b4450e5745e49325$var$DecorationGroup.from(found);
    }
    eq(other) {
        if (!(other instanceof $b4450e5745e49325$var$DecorationGroup) || other.members.length != this.members.length) return false;
        for(let i = 0; i < this.members.length; i++)if (!this.members[i].eq(other.members[i])) return false;
        return true;
    }
    locals(node) {
        let result, sorted = true;
        for(let i = 0; i < this.members.length; i++){
            let locals = this.members[i].localsInner(node);
            if (!locals.length) continue;
            if (!result) result = locals;
            else {
                if (sorted) {
                    result = result.slice();
                    sorted = false;
                }
                for(let j = 0; j < locals.length; j++)result.push(locals[j]);
            }
        }
        return result ? $b4450e5745e49325$var$removeOverlap(sorted ? result : result.sort($b4450e5745e49325$var$byPos)) : $b4450e5745e49325$var$none;
    }
    // Create a group for the given array of decoration sets, or return
    // a single set when possible.
    static from(members) {
        switch(members.length){
            case 0:
                return $b4450e5745e49325$var$empty;
            case 1:
                return members[0];
            default:
                return new $b4450e5745e49325$var$DecorationGroup(members.every((m)=>m instanceof $b4450e5745e49325$export$93bf62eb445cec98) ? members : members.reduce((r, m)=>r.concat(m instanceof $b4450e5745e49325$export$93bf62eb445cec98 ? m : m.members), []));
        }
    }
    forEachSet(f) {
        for(let i = 0; i < this.members.length; i++)this.members[i].forEachSet(f);
    }
    constructor(members){
        this.members = members;
    }
}
function $b4450e5745e49325$var$mapChildren(oldChildren, newLocal, mapping, node, offset, oldOffset, options) {
    let children = oldChildren.slice();
    // Mark the children that are directly touched by changes, and
    // move those that are after the changes.
    for(let i = 0, baseOffset = oldOffset; i < mapping.maps.length; i++){
        let moved = 0;
        mapping.maps[i].forEach((oldStart, oldEnd, newStart, newEnd)=>{
            let dSize = newEnd - newStart - (oldEnd - oldStart);
            for(let i = 0; i < children.length; i += 3){
                let end = children[i + 1];
                if (end < 0 || oldStart > end + baseOffset - moved) continue;
                let start = children[i] + baseOffset - moved;
                if (oldEnd >= start) children[i + 1] = oldStart <= start ? -2 : -1;
                else if (oldStart >= baseOffset && dSize) {
                    children[i] += dSize;
                    children[i + 1] += dSize;
                }
            }
            moved += dSize;
        });
        baseOffset = mapping.maps[i].map(baseOffset, -1);
    }
    // Find the child nodes that still correspond to a single node,
    // recursively call mapInner on them and update their positions.
    let mustRebuild = false;
    for(let i = 0; i < children.length; i += 3)if (children[i + 1] < 0) {
        if (children[i + 1] == -2) {
            mustRebuild = true;
            children[i + 1] = -1;
            continue;
        }
        let from = mapping.map(oldChildren[i] + oldOffset), fromLocal = from - offset;
        if (fromLocal < 0 || fromLocal >= node.content.size) {
            mustRebuild = true;
            continue;
        }
        // Must read oldChildren because children was tagged with -1
        let to = mapping.map(oldChildren[i + 1] + oldOffset, -1), toLocal = to - offset;
        let { index: index, offset: childOffset } = node.content.findIndex(fromLocal);
        let childNode = node.maybeChild(index);
        if (childNode && childOffset == fromLocal && childOffset + childNode.nodeSize == toLocal) {
            let mapped = children[i + 2].mapInner(mapping, childNode, from + 1, oldChildren[i] + oldOffset + 1, options);
            if (mapped != $b4450e5745e49325$var$empty) {
                children[i] = fromLocal;
                children[i + 1] = toLocal;
                children[i + 2] = mapped;
            } else {
                children[i + 1] = -2;
                mustRebuild = true;
            }
        } else mustRebuild = true;
    }
    // Remaining children must be collected and rebuilt into the appropriate structure
    if (mustRebuild) {
        let decorations = $b4450e5745e49325$var$mapAndGatherRemainingDecorations(children, oldChildren, newLocal, mapping, offset, oldOffset, options);
        let built = $b4450e5745e49325$var$buildTree(decorations, node, 0, options);
        newLocal = built.local;
        for(let i = 0; i < children.length; i += 3)if (children[i + 1] < 0) {
            children.splice(i, 3);
            i -= 3;
        }
        for(let i = 0, j = 0; i < built.children.length; i += 3){
            let from = built.children[i];
            while(j < children.length && children[j] < from)j += 3;
            children.splice(j, 0, built.children[i], built.children[i + 1], built.children[i + 2]);
        }
    }
    return new $b4450e5745e49325$export$93bf62eb445cec98(newLocal.sort($b4450e5745e49325$var$byPos), children);
}
function $b4450e5745e49325$var$moveSpans(spans, offset) {
    if (!offset || !spans.length) return spans;
    let result = [];
    for(let i = 0; i < spans.length; i++){
        let span = spans[i];
        result.push(new $b4450e5745e49325$export$10e30b733df217ea(span.from + offset, span.to + offset, span.type));
    }
    return result;
}
function $b4450e5745e49325$var$mapAndGatherRemainingDecorations(children, oldChildren, decorations, mapping, offset, oldOffset, options) {
    // Gather all decorations from the remaining marked children
    function gather(set, oldOffset) {
        for(let i = 0; i < set.local.length; i++){
            let mapped = set.local[i].map(mapping, offset, oldOffset);
            if (mapped) decorations.push(mapped);
            else if (options.onRemove) options.onRemove(set.local[i].spec);
        }
        for(let i = 0; i < set.children.length; i += 3)gather(set.children[i + 2], set.children[i] + oldOffset + 1);
    }
    for(let i = 0; i < children.length; i += 3)if (children[i + 1] == -1) gather(children[i + 2], oldChildren[i] + oldOffset + 1);
    return decorations;
}
function $b4450e5745e49325$var$takeSpansForNode(spans, node, offset) {
    if (node.isLeaf) return null;
    let end = offset + node.nodeSize, found = null;
    for(let i = 0, span; i < spans.length; i++)if ((span = spans[i]) && span.from > offset && span.to < end) {
        (found || (found = [])).push(span);
        spans[i] = null;
    }
    return found;
}
function $b4450e5745e49325$var$withoutNulls(array) {
    let result = [];
    for(let i = 0; i < array.length; i++)if (array[i] != null) result.push(array[i]);
    return result;
}
// Build up a tree that corresponds to a set of decorations. `offset`
// is a base offset that should be subtracted from the `from` and `to`
// positions in the spans (so that we don't have to allocate new spans
// for recursive calls).
function $b4450e5745e49325$var$buildTree(spans, node, offset, options) {
    let children = [], hasNulls = false;
    node.forEach((childNode, localStart)=>{
        let found = $b4450e5745e49325$var$takeSpansForNode(spans, childNode, localStart + offset);
        if (found) {
            hasNulls = true;
            let subtree = $b4450e5745e49325$var$buildTree(found, childNode, offset + localStart + 1, options);
            if (subtree != $b4450e5745e49325$var$empty) children.push(localStart, localStart + childNode.nodeSize, subtree);
        }
    });
    let locals = $b4450e5745e49325$var$moveSpans(hasNulls ? $b4450e5745e49325$var$withoutNulls(spans) : spans, -offset).sort($b4450e5745e49325$var$byPos);
    for(let i = 0; i < locals.length; i++)if (!locals[i].type.valid(node, locals[i])) {
        if (options.onRemove) options.onRemove(locals[i].spec);
        locals.splice(i--, 1);
    }
    return locals.length || children.length ? new $b4450e5745e49325$export$93bf62eb445cec98(locals, children) : $b4450e5745e49325$var$empty;
}
// Used to sort decorations so that ones with a low start position
// come first, and within a set with the same start position, those
// with an smaller end position come first.
function $b4450e5745e49325$var$byPos(a, b) {
    return a.from - b.from || a.to - b.to;
}
// Scan a sorted array of decorations for partially overlapping spans,
// and split those so that only fully overlapping spans are left (to
// make subsequent rendering easier). Will return the input array if
// no partially overlapping spans are found (the common case).
function $b4450e5745e49325$var$removeOverlap(spans) {
    let working = spans;
    for(let i = 0; i < working.length - 1; i++){
        let span = working[i];
        if (span.from != span.to) for(let j = i + 1; j < working.length; j++){
            let next = working[j];
            if (next.from == span.from) {
                if (next.to != span.to) {
                    if (working == spans) working = spans.slice();
                    // Followed by a partially overlapping larger span. Split that
                    // span.
                    working[j] = next.copy(next.from, span.to);
                    $b4450e5745e49325$var$insertAhead(working, j + 1, next.copy(span.to, next.to));
                }
                continue;
            } else {
                if (next.from < span.to) {
                    if (working == spans) working = spans.slice();
                    // The end of this one overlaps with a subsequent span. Split
                    // this one.
                    working[i] = span.copy(span.from, next.from);
                    $b4450e5745e49325$var$insertAhead(working, j, span.copy(next.from, span.to));
                }
                break;
            }
        }
    }
    return working;
}
function $b4450e5745e49325$var$insertAhead(array, i, deco) {
    while(i < array.length && $b4450e5745e49325$var$byPos(deco, array[i]) > 0)i++;
    array.splice(i, 0, deco);
}
// Get the decorations associated with the current props of a view.
function $b4450e5745e49325$var$viewDecorations(view) {
    let found = [];
    view.someProp("decorations", (f)=>{
        let result = f(view.state);
        if (result && result != $b4450e5745e49325$var$empty) found.push(result);
    });
    if (view.cursorWrapper) found.push($b4450e5745e49325$export$93bf62eb445cec98.create(view.state.doc, [
        view.cursorWrapper.deco
    ]));
    return $b4450e5745e49325$var$DecorationGroup.from(found);
}
const $b4450e5745e49325$var$observeOptions = {
    childList: true,
    characterData: true,
    characterDataOldValue: true,
    attributes: true,
    attributeOldValue: true,
    subtree: true
};
// IE11 has very broken mutation observers, so we also listen to DOMCharacterDataModified
const $b4450e5745e49325$var$useCharData = $b4450e5745e49325$var$ie && $b4450e5745e49325$var$ie_version <= 11;
class $b4450e5745e49325$var$SelectionState {
    set(sel) {
        this.anchorNode = sel.anchorNode;
        this.anchorOffset = sel.anchorOffset;
        this.focusNode = sel.focusNode;
        this.focusOffset = sel.focusOffset;
    }
    clear() {
        this.anchorNode = this.focusNode = null;
    }
    eq(sel) {
        return sel.anchorNode == this.anchorNode && sel.anchorOffset == this.anchorOffset && sel.focusNode == this.focusNode && sel.focusOffset == this.focusOffset;
    }
    constructor(){
        this.anchorNode = null;
        this.anchorOffset = 0;
        this.focusNode = null;
        this.focusOffset = 0;
    }
}
class $b4450e5745e49325$var$DOMObserver {
    flushSoon() {
        if (this.flushingSoon < 0) this.flushingSoon = window.setTimeout(()=>{
            this.flushingSoon = -1;
            this.flush();
        }, 20);
    }
    forceFlush() {
        if (this.flushingSoon > -1) {
            window.clearTimeout(this.flushingSoon);
            this.flushingSoon = -1;
            this.flush();
        }
    }
    start() {
        if (this.observer) {
            this.observer.takeRecords();
            this.observer.observe(this.view.dom, $b4450e5745e49325$var$observeOptions);
        }
        if (this.onCharData) this.view.dom.addEventListener("DOMCharacterDataModified", this.onCharData);
        this.connectSelection();
    }
    stop() {
        if (this.observer) {
            let take = this.observer.takeRecords();
            if (take.length) {
                for(let i = 0; i < take.length; i++)this.queue.push(take[i]);
                window.setTimeout(()=>this.flush(), 20);
            }
            this.observer.disconnect();
        }
        if (this.onCharData) this.view.dom.removeEventListener("DOMCharacterDataModified", this.onCharData);
        this.disconnectSelection();
    }
    connectSelection() {
        this.view.dom.ownerDocument.addEventListener("selectionchange", this.onSelectionChange);
    }
    disconnectSelection() {
        this.view.dom.ownerDocument.removeEventListener("selectionchange", this.onSelectionChange);
    }
    suppressSelectionUpdates() {
        this.suppressingSelectionUpdates = true;
        setTimeout(()=>this.suppressingSelectionUpdates = false, 50);
    }
    onSelectionChange() {
        if (!$b4450e5745e49325$var$hasFocusAndSelection(this.view)) return;
        if (this.suppressingSelectionUpdates) return $b4450e5745e49325$var$selectionToDOM(this.view);
        // Deletions on IE11 fire their events in the wrong order, giving
        // us a selection change event before the DOM changes are
        // reported.
        if ($b4450e5745e49325$var$ie && $b4450e5745e49325$var$ie_version <= 11 && !this.view.state.selection.empty) {
            let sel = this.view.domSelectionRange();
            // Selection.isCollapsed isn't reliable on IE
            if (sel.focusNode && $b4450e5745e49325$var$isEquivalentPosition(sel.focusNode, sel.focusOffset, sel.anchorNode, sel.anchorOffset)) return this.flushSoon();
        }
        this.flush();
    }
    setCurSelection() {
        this.currentSelection.set(this.view.domSelectionRange());
    }
    ignoreSelectionChange(sel) {
        if (!sel.focusNode) return true;
        let ancestors = new Set, container;
        for(let scan = sel.focusNode; scan; scan = $b4450e5745e49325$var$parentNode(scan))ancestors.add(scan);
        for(let scan = sel.anchorNode; scan; scan = $b4450e5745e49325$var$parentNode(scan))if (ancestors.has(scan)) {
            container = scan;
            break;
        }
        let desc = container && this.view.docView.nearestDesc(container);
        if (desc && desc.ignoreMutation({
            type: "selection",
            target: container.nodeType == 3 ? container.parentNode : container
        })) {
            this.setCurSelection();
            return true;
        }
    }
    pendingRecords() {
        if (this.observer) for (let mut of this.observer.takeRecords())this.queue.push(mut);
        return this.queue;
    }
    flush() {
        let { view: view } = this;
        if (!view.docView || this.flushingSoon > -1) return;
        let mutations = this.pendingRecords();
        if (mutations.length) this.queue = [];
        let sel = view.domSelectionRange();
        let newSel = !this.suppressingSelectionUpdates && !this.currentSelection.eq(sel) && $b4450e5745e49325$var$hasFocusAndSelection(view) && !this.ignoreSelectionChange(sel);
        let from = -1, to = -1, typeOver = false, added = [];
        if (view.editable) for(let i = 0; i < mutations.length; i++){
            let result = this.registerMutation(mutations[i], added);
            if (result) {
                from = from < 0 ? result.from : Math.min(result.from, from);
                to = to < 0 ? result.to : Math.max(result.to, to);
                if (result.typeOver) typeOver = true;
            }
        }
        if ($b4450e5745e49325$var$gecko && added.length) {
            let brs = added.filter((n)=>n.nodeName == "BR");
            if (brs.length == 2) {
                let [a, b] = brs;
                if (a.parentNode && a.parentNode.parentNode == b.parentNode) b.remove();
                else a.remove();
            } else {
                let { focusNode: focusNode } = this.currentSelection;
                for (let br of brs){
                    let parent = br.parentNode;
                    if (parent && parent.nodeName == "LI" && (!focusNode || $b4450e5745e49325$var$blockParent(view, focusNode) != parent)) br.remove();
                }
            }
        }
        let readSel = null;
        // If it looks like the browser has reset the selection to the
        // start of the document after focus, restore the selection from
        // the state
        if (from < 0 && newSel && view.input.lastFocus > Date.now() - 200 && Math.max(view.input.lastTouch, view.input.lastClick.time) < Date.now() - 300 && $b4450e5745e49325$var$selectionCollapsed(sel) && (readSel = $b4450e5745e49325$var$selectionFromDOM(view)) && readSel.eq((0, $ks2lK.Selection).near(view.state.doc.resolve(0), 1))) {
            view.input.lastFocus = 0;
            $b4450e5745e49325$var$selectionToDOM(view);
            this.currentSelection.set(sel);
            view.scrollToSelection();
        } else if (from > -1 || newSel) {
            if (from > -1) {
                view.docView.markDirty(from, to);
                $b4450e5745e49325$var$checkCSS(view);
            }
            this.handleDOMChange(from, to, typeOver, added);
            if (view.docView && view.docView.dirty) view.updateState(view.state);
            else if (!this.currentSelection.eq(sel)) $b4450e5745e49325$var$selectionToDOM(view);
            this.currentSelection.set(sel);
        }
    }
    registerMutation(mut, added) {
        // Ignore mutations inside nodes that were already noted as inserted
        if (added.indexOf(mut.target) > -1) return null;
        let desc = this.view.docView.nearestDesc(mut.target);
        if (mut.type == "attributes" && (desc == this.view.docView || mut.attributeName == "contenteditable" || // Firefox sometimes fires spurious events for null/empty styles
        mut.attributeName == "style" && !mut.oldValue && !mut.target.getAttribute("style"))) return null;
        if (!desc || desc.ignoreMutation(mut)) return null;
        if (mut.type == "childList") {
            for(let i = 0; i < mut.addedNodes.length; i++){
                let node = mut.addedNodes[i];
                added.push(node);
                if (node.nodeType == 3) this.lastChangedTextNode = node;
            }
            if (desc.contentDOM && desc.contentDOM != desc.dom && !desc.contentDOM.contains(mut.target)) return {
                from: desc.posBefore,
                to: desc.posAfter
            };
            let prev = mut.previousSibling, next = mut.nextSibling;
            if ($b4450e5745e49325$var$ie && $b4450e5745e49325$var$ie_version <= 11 && mut.addedNodes.length) // IE11 gives us incorrect next/prev siblings for some
            // insertions, so if there are added nodes, recompute those
            for(let i = 0; i < mut.addedNodes.length; i++){
                let { previousSibling: previousSibling, nextSibling: nextSibling } = mut.addedNodes[i];
                if (!previousSibling || Array.prototype.indexOf.call(mut.addedNodes, previousSibling) < 0) prev = previousSibling;
                if (!nextSibling || Array.prototype.indexOf.call(mut.addedNodes, nextSibling) < 0) next = nextSibling;
            }
            let fromOffset = prev && prev.parentNode == mut.target ? $b4450e5745e49325$var$domIndex(prev) + 1 : 0;
            let from = desc.localPosFromDOM(mut.target, fromOffset, -1);
            let toOffset = next && next.parentNode == mut.target ? $b4450e5745e49325$var$domIndex(next) : mut.target.childNodes.length;
            let to = desc.localPosFromDOM(mut.target, toOffset, 1);
            return {
                from: from,
                to: to
            };
        } else if (mut.type == "attributes") return {
            from: desc.posAtStart - desc.border,
            to: desc.posAtEnd + desc.border
        };
        else {
            this.lastChangedTextNode = mut.target;
            return {
                from: desc.posAtStart,
                to: desc.posAtEnd,
                // An event was generated for a text change that didn't change
                // any text. Mark the dom change to fall back to assuming the
                // selection was typed over with an identical value if it can't
                // find another change.
                typeOver: mut.target.nodeValue == mut.oldValue
            };
        }
    }
    constructor(view, handleDOMChange){
        this.view = view;
        this.handleDOMChange = handleDOMChange;
        this.queue = [];
        this.flushingSoon = -1;
        this.observer = null;
        this.currentSelection = new $b4450e5745e49325$var$SelectionState;
        this.onCharData = null;
        this.suppressingSelectionUpdates = false;
        this.lastChangedTextNode = null;
        this.observer = window.MutationObserver && new window.MutationObserver((mutations)=>{
            for(let i = 0; i < mutations.length; i++)this.queue.push(mutations[i]);
            // IE11 will sometimes (on backspacing out a single character
            // text node after a BR node) call the observer callback
            // before actually updating the DOM, which will cause
            // ProseMirror to miss the change (see #930)
            if ($b4450e5745e49325$var$ie && $b4450e5745e49325$var$ie_version <= 11 && mutations.some((m)=>m.type == "childList" && m.removedNodes.length || m.type == "characterData" && m.oldValue.length > m.target.nodeValue.length)) this.flushSoon();
            else this.flush();
        });
        if ($b4450e5745e49325$var$useCharData) this.onCharData = (e)=>{
            this.queue.push({
                target: e.target,
                type: "characterData",
                oldValue: e.prevValue
            });
            this.flushSoon();
        };
        this.onSelectionChange = this.onSelectionChange.bind(this);
    }
}
let $b4450e5745e49325$var$cssChecked = new WeakMap();
let $b4450e5745e49325$var$cssCheckWarned = false;
function $b4450e5745e49325$var$checkCSS(view) {
    if ($b4450e5745e49325$var$cssChecked.has(view)) return;
    $b4450e5745e49325$var$cssChecked.set(view, null);
    if ([
        'normal',
        'nowrap',
        'pre-line'
    ].indexOf(getComputedStyle(view.dom).whiteSpace) !== -1) {
        view.requiresGeckoHackNode = $b4450e5745e49325$var$gecko;
        if ($b4450e5745e49325$var$cssCheckWarned) return;
        console["warn"]("ProseMirror expects the CSS white-space property to be set, preferably to 'pre-wrap'. It is recommended to load style/prosemirror.css from the prosemirror-view package.");
        $b4450e5745e49325$var$cssCheckWarned = true;
    }
}
function $b4450e5745e49325$var$rangeToSelectionRange(view, range) {
    let anchorNode = range.startContainer, anchorOffset = range.startOffset;
    let focusNode = range.endContainer, focusOffset = range.endOffset;
    let currentAnchor = view.domAtPos(view.state.selection.anchor);
    // Since such a range doesn't distinguish between anchor and head,
    // use a heuristic that flips it around if its end matches the
    // current anchor.
    if ($b4450e5745e49325$var$isEquivalentPosition(currentAnchor.node, currentAnchor.offset, focusNode, focusOffset)) [anchorNode, anchorOffset, focusNode, focusOffset] = [
        focusNode,
        focusOffset,
        anchorNode,
        anchorOffset
    ];
    return {
        anchorNode: anchorNode,
        anchorOffset: anchorOffset,
        focusNode: focusNode,
        focusOffset: focusOffset
    };
}
// Used to work around a Safari Selection/shadow DOM bug
// Based on https://github.com/codemirror/dev/issues/414 fix
function $b4450e5745e49325$var$safariShadowSelectionRange(view, selection) {
    if (selection.getComposedRanges) {
        let range = selection.getComposedRanges(view.root)[0];
        if (range) return $b4450e5745e49325$var$rangeToSelectionRange(view, range);
    }
    let found;
    function read(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        found = event.getTargetRanges()[0];
    }
    // Because Safari (at least in 2018-2022) doesn't provide regular
    // access to the selection inside a shadowRoot, we have to perform a
    // ridiculous hack to get at it—using `execCommand` to trigger a
    // `beforeInput` event so that we can read the target range from the
    // event.
    view.dom.addEventListener("beforeinput", read, true);
    document.execCommand("indent");
    view.dom.removeEventListener("beforeinput", read, true);
    return found ? $b4450e5745e49325$var$rangeToSelectionRange(view, found) : null;
}
function $b4450e5745e49325$var$blockParent(view, node) {
    for(let p = node.parentNode; p && p != view.dom; p = p.parentNode){
        let desc = view.docView.nearestDesc(p, true);
        if (desc && desc.node.isBlock) return p;
    }
    return null;
}
// Note that all referencing and parsing is done with the
// start-of-operation selection and document, since that's the one
// that the DOM represents. If any changes came in in the meantime,
// the modification is mapped over those before it is applied, in
// readDOMChange.
function $b4450e5745e49325$var$parseBetween(view, from_, to_) {
    let { node: parent, fromOffset: fromOffset, toOffset: toOffset, from: from, to: to } = view.docView.parseRange(from_, to_);
    let domSel = view.domSelectionRange();
    let find;
    let anchor = domSel.anchorNode;
    if (anchor && view.dom.contains(anchor.nodeType == 1 ? anchor : anchor.parentNode)) {
        find = [
            {
                node: anchor,
                offset: domSel.anchorOffset
            }
        ];
        if (!$b4450e5745e49325$var$selectionCollapsed(domSel)) find.push({
            node: domSel.focusNode,
            offset: domSel.focusOffset
        });
    }
    // Work around issue in Chrome where backspacing sometimes replaces
    // the deleted content with a random BR node (issues #799, #831)
    if ($b4450e5745e49325$var$chrome && view.input.lastKeyCode === 8) for(let off = toOffset; off > fromOffset; off--){
        let node = parent.childNodes[off - 1], desc = node.pmViewDesc;
        if (node.nodeName == "BR" && !desc) {
            toOffset = off;
            break;
        }
        if (!desc || desc.size) break;
    }
    let startDoc = view.state.doc;
    let parser = view.someProp("domParser") || (0, $5SAOw.DOMParser).fromSchema(view.state.schema);
    let $from = startDoc.resolve(from);
    let sel = null, doc = parser.parse(parent, {
        topNode: $from.parent,
        topMatch: $from.parent.contentMatchAt($from.index()),
        topOpen: true,
        from: fromOffset,
        to: toOffset,
        preserveWhitespace: $from.parent.type.whitespace == "pre" ? "full" : true,
        findPositions: find,
        ruleFromNode: $b4450e5745e49325$var$ruleFromNode,
        context: $from
    });
    if (find && find[0].pos != null) {
        let anchor = find[0].pos, head = find[1] && find[1].pos;
        if (head == null) head = anchor;
        sel = {
            anchor: anchor + from,
            head: head + from
        };
    }
    return {
        doc: doc,
        sel: sel,
        from: from,
        to: to
    };
}
function $b4450e5745e49325$var$ruleFromNode(dom) {
    let desc = dom.pmViewDesc;
    if (desc) return desc.parseRule();
    else if (dom.nodeName == "BR" && dom.parentNode) {
        // Safari replaces the list item or table cell with a BR
        // directly in the list node (?!) if you delete the last
        // character in a list item or table cell (#708, #862)
        if ($b4450e5745e49325$var$safari && /^(ul|ol)$/i.test(dom.parentNode.nodeName)) {
            let skip = document.createElement("div");
            skip.appendChild(document.createElement("li"));
            return {
                skip: skip
            };
        } else if (dom.parentNode.lastChild == dom || $b4450e5745e49325$var$safari && /^(tr|table)$/i.test(dom.parentNode.nodeName)) return {
            ignore: true
        };
    } else if (dom.nodeName == "IMG" && dom.getAttribute("mark-placeholder")) return {
        ignore: true
    };
    return null;
}
const $b4450e5745e49325$var$isInline = /^(a|abbr|acronym|b|bd[io]|big|br|button|cite|code|data(list)?|del|dfn|em|i|ins|kbd|label|map|mark|meter|output|q|ruby|s|samp|small|span|strong|su[bp]|time|u|tt|var)$/i;
function $b4450e5745e49325$var$readDOMChange(view, from, to, typeOver, addedNodes) {
    let compositionID = view.input.compositionPendingChanges || (view.composing ? view.input.compositionID : 0);
    view.input.compositionPendingChanges = 0;
    if (from < 0) {
        let origin = view.input.lastSelectionTime > Date.now() - 50 ? view.input.lastSelectionOrigin : null;
        let newSel = $b4450e5745e49325$var$selectionFromDOM(view, origin);
        if (newSel && !view.state.selection.eq(newSel)) {
            if ($b4450e5745e49325$var$chrome && $b4450e5745e49325$var$android && view.input.lastKeyCode === 13 && Date.now() - 100 < view.input.lastKeyCodeTime && view.someProp("handleKeyDown", (f)=>f(view, $b4450e5745e49325$var$keyEvent(13, "Enter")))) return;
            let tr = view.state.tr.setSelection(newSel);
            if (origin == "pointer") tr.setMeta("pointer", true);
            else if (origin == "key") tr.scrollIntoView();
            if (compositionID) tr.setMeta("composition", compositionID);
            view.dispatch(tr);
        }
        return;
    }
    let $before = view.state.doc.resolve(from);
    let shared = $before.sharedDepth(to);
    from = $before.before(shared + 1);
    to = view.state.doc.resolve(to).after(shared + 1);
    let sel = view.state.selection;
    let parse = $b4450e5745e49325$var$parseBetween(view, from, to);
    let doc = view.state.doc, compare = doc.slice(parse.from, parse.to);
    let preferredPos, preferredSide;
    // Prefer anchoring to end when Backspace is pressed
    if (view.input.lastKeyCode === 8 && Date.now() - 100 < view.input.lastKeyCodeTime) {
        preferredPos = view.state.selection.to;
        preferredSide = "end";
    } else {
        preferredPos = view.state.selection.from;
        preferredSide = "start";
    }
    view.input.lastKeyCode = null;
    let change = $b4450e5745e49325$var$findDiff(compare.content, parse.doc.content, parse.from, preferredPos, preferredSide);
    if (change) view.input.domChangeCount++;
    if (($b4450e5745e49325$var$ios && view.input.lastIOSEnter > Date.now() - 225 || $b4450e5745e49325$var$android) && addedNodes.some((n)=>n.nodeType == 1 && !$b4450e5745e49325$var$isInline.test(n.nodeName)) && (!change || change.endA >= change.endB) && view.someProp("handleKeyDown", (f)=>f(view, $b4450e5745e49325$var$keyEvent(13, "Enter")))) {
        view.input.lastIOSEnter = 0;
        return;
    }
    if (!change) {
        if (typeOver && sel instanceof (0, $ks2lK.TextSelection) && !sel.empty && sel.$head.sameParent(sel.$anchor) && !view.composing && !(parse.sel && parse.sel.anchor != parse.sel.head)) change = {
            start: sel.from,
            endA: sel.to,
            endB: sel.to
        };
        else {
            if (parse.sel) {
                let sel = $b4450e5745e49325$var$resolveSelection(view, view.state.doc, parse.sel);
                if (sel && !sel.eq(view.state.selection)) {
                    let tr = view.state.tr.setSelection(sel);
                    if (compositionID) tr.setMeta("composition", compositionID);
                    view.dispatch(tr);
                }
            }
            return;
        }
    }
    // Handle the case where overwriting a selection by typing matches
    // the start or end of the selected content, creating a change
    // that's smaller than what was actually overwritten.
    if (view.state.selection.from < view.state.selection.to && change.start == change.endB && view.state.selection instanceof (0, $ks2lK.TextSelection)) {
        if (change.start > view.state.selection.from && change.start <= view.state.selection.from + 2 && view.state.selection.from >= parse.from) change.start = view.state.selection.from;
        else if (change.endA < view.state.selection.to && change.endA >= view.state.selection.to - 2 && view.state.selection.to <= parse.to) {
            change.endB += view.state.selection.to - change.endA;
            change.endA = view.state.selection.to;
        }
    }
    // IE11 will insert a non-breaking space _ahead_ of the space after
    // the cursor space when adding a space before another space. When
    // that happened, adjust the change to cover the space instead.
    if ($b4450e5745e49325$var$ie && $b4450e5745e49325$var$ie_version <= 11 && change.endB == change.start + 1 && change.endA == change.start && change.start > parse.from && parse.doc.textBetween(change.start - parse.from - 1, change.start - parse.from + 1) == " \u00a0") {
        change.start--;
        change.endA--;
        change.endB--;
    }
    let $from = parse.doc.resolveNoCache(change.start - parse.from);
    let $to = parse.doc.resolveNoCache(change.endB - parse.from);
    let $fromA = doc.resolve(change.start);
    let inlineChange = $from.sameParent($to) && $from.parent.inlineContent && $fromA.end() >= change.endA;
    let nextSel;
    // If this looks like the effect of pressing Enter (or was recorded
    // as being an iOS enter press), just dispatch an Enter key instead.
    if (($b4450e5745e49325$var$ios && view.input.lastIOSEnter > Date.now() - 225 && (!inlineChange || addedNodes.some((n)=>n.nodeName == "DIV" || n.nodeName == "P")) || !inlineChange && $from.pos < parse.doc.content.size && !$from.sameParent($to) && (nextSel = (0, $ks2lK.Selection).findFrom(parse.doc.resolve($from.pos + 1), 1, true)) && nextSel.head == $to.pos) && view.someProp("handleKeyDown", (f)=>f(view, $b4450e5745e49325$var$keyEvent(13, "Enter")))) {
        view.input.lastIOSEnter = 0;
        return;
    }
    // Same for backspace
    if (view.state.selection.anchor > change.start && $b4450e5745e49325$var$looksLikeBackspace(doc, change.start, change.endA, $from, $to) && view.someProp("handleKeyDown", (f)=>f(view, $b4450e5745e49325$var$keyEvent(8, "Backspace")))) {
        if ($b4450e5745e49325$var$android && $b4450e5745e49325$var$chrome) view.domObserver.suppressSelectionUpdates(); // #820
        return;
    }
    // Chrome will occasionally, during composition, delete the
    // entire composition and then immediately insert it again. This is
    // used to detect that situation.
    if ($b4450e5745e49325$var$chrome && change.endB == change.start) view.input.lastChromeDelete = Date.now();
    // This tries to detect Android virtual keyboard
    // enter-and-pick-suggestion action. That sometimes (see issue
    // #1059) first fires a DOM mutation, before moving the selection to
    // the newly created block. And then, because ProseMirror cleans up
    // the DOM selection, it gives up moving the selection entirely,
    // leaving the cursor in the wrong place. When that happens, we drop
    // the new paragraph from the initial change, and fire a simulated
    // enter key afterwards.
    if ($b4450e5745e49325$var$android && !inlineChange && $from.start() != $to.start() && $to.parentOffset == 0 && $from.depth == $to.depth && parse.sel && parse.sel.anchor == parse.sel.head && parse.sel.head == change.endA) {
        change.endB -= 2;
        $to = parse.doc.resolveNoCache(change.endB - parse.from);
        setTimeout(()=>{
            view.someProp("handleKeyDown", function(f) {
                return f(view, $b4450e5745e49325$var$keyEvent(13, "Enter"));
            });
        }, 20);
    }
    let chFrom = change.start, chTo = change.endA;
    let tr, storedMarks, markChange;
    if (inlineChange) {
        if ($from.pos == $to.pos) {
            // IE11 sometimes weirdly moves the DOM selection around after
            // backspacing out the first element in a textblock
            if ($b4450e5745e49325$var$ie && $b4450e5745e49325$var$ie_version <= 11 && $from.parentOffset == 0) {
                view.domObserver.suppressSelectionUpdates();
                setTimeout(()=>$b4450e5745e49325$var$selectionToDOM(view), 20);
            }
            tr = view.state.tr.delete(chFrom, chTo);
            storedMarks = doc.resolve(change.start).marksAcross(doc.resolve(change.endA));
        } else if (change.endA == change.endB && (markChange = $b4450e5745e49325$var$isMarkChange($from.parent.content.cut($from.parentOffset, $to.parentOffset), $fromA.parent.content.cut($fromA.parentOffset, change.endA - $fromA.start())))) {
            tr = view.state.tr;
            if (markChange.type == "add") tr.addMark(chFrom, chTo, markChange.mark);
            else tr.removeMark(chFrom, chTo, markChange.mark);
        } else if ($from.parent.child($from.index()).isText && $from.index() == $to.index() - ($to.textOffset ? 0 : 1)) {
            // Both positions in the same text node -- simply insert text
            let text = $from.parent.textBetween($from.parentOffset, $to.parentOffset);
            if (view.someProp("handleTextInput", (f)=>f(view, chFrom, chTo, text))) return;
            tr = view.state.tr.insertText(text, chFrom, chTo);
        }
    }
    if (!tr) tr = view.state.tr.replace(chFrom, chTo, parse.doc.slice(change.start - parse.from, change.endB - parse.from));
    if (parse.sel) {
        let sel = $b4450e5745e49325$var$resolveSelection(view, tr.doc, parse.sel);
        // Chrome will sometimes, during composition, report the
        // selection in the wrong place. If it looks like that is
        // happening, don't update the selection.
        // Edge just doesn't move the cursor forward when you start typing
        // in an empty block or between br nodes.
        if (sel && !($b4450e5745e49325$var$chrome && view.composing && sel.empty && (change.start != change.endB || view.input.lastChromeDelete < Date.now() - 100) && (sel.head == chFrom || sel.head == tr.mapping.map(chTo) - 1) || $b4450e5745e49325$var$ie && sel.empty && sel.head == chFrom)) tr.setSelection(sel);
    }
    if (storedMarks) tr.ensureMarks(storedMarks);
    if (compositionID) tr.setMeta("composition", compositionID);
    view.dispatch(tr.scrollIntoView());
}
function $b4450e5745e49325$var$resolveSelection(view, doc, parsedSel) {
    if (Math.max(parsedSel.anchor, parsedSel.head) > doc.content.size) return null;
    return $b4450e5745e49325$var$selectionBetween(view, doc.resolve(parsedSel.anchor), doc.resolve(parsedSel.head));
}
// Given two same-length, non-empty fragments of inline content,
// determine whether the first could be created from the second by
// removing or adding a single mark type.
function $b4450e5745e49325$var$isMarkChange(cur, prev) {
    let curMarks = cur.firstChild.marks, prevMarks = prev.firstChild.marks;
    let added = curMarks, removed = prevMarks, type, mark, update;
    for(let i = 0; i < prevMarks.length; i++)added = prevMarks[i].removeFromSet(added);
    for(let i = 0; i < curMarks.length; i++)removed = curMarks[i].removeFromSet(removed);
    if (added.length == 1 && removed.length == 0) {
        mark = added[0];
        type = "add";
        update = (node)=>node.mark(mark.addToSet(node.marks));
    } else if (added.length == 0 && removed.length == 1) {
        mark = removed[0];
        type = "remove";
        update = (node)=>node.mark(mark.removeFromSet(node.marks));
    } else return null;
    let updated = [];
    for(let i = 0; i < prev.childCount; i++)updated.push(update(prev.child(i)));
    if ((0, $5SAOw.Fragment).from(updated).eq(cur)) return {
        mark: mark,
        type: type
    };
}
function $b4450e5745e49325$var$looksLikeBackspace(old, start, end, $newStart, $newEnd) {
    if (end - start <= $newEnd.pos - $newStart.pos || // newEnd must point directly at or after the end of the block that newStart points into
    $b4450e5745e49325$var$skipClosingAndOpening($newStart, true, false) < $newEnd.pos) return false;
    let $start = old.resolve(start);
    // Handle the case where, rather than joining blocks, the change just removed an entire block
    if (!$newStart.parent.isTextblock) {
        let after = $start.nodeAfter;
        return after != null && end == start + after.nodeSize;
    }
    // Start must be at the end of a block
    if ($start.parentOffset < $start.parent.content.size || !$start.parent.isTextblock) return false;
    let $next = old.resolve($b4450e5745e49325$var$skipClosingAndOpening($start, true, true));
    // The next textblock must start before end and end near it
    if (!$next.parent.isTextblock || $next.pos > end || $b4450e5745e49325$var$skipClosingAndOpening($next, true, false) < end) return false;
    // The fragments after the join point must match
    return $newStart.parent.content.cut($newStart.parentOffset).eq($next.parent.content);
}
function $b4450e5745e49325$var$skipClosingAndOpening($pos, fromEnd, mayOpen) {
    let depth = $pos.depth, end = fromEnd ? $pos.end() : $pos.pos;
    while(depth > 0 && (fromEnd || $pos.indexAfter(depth) == $pos.node(depth).childCount)){
        depth--;
        end++;
        fromEnd = false;
    }
    if (mayOpen) {
        let next = $pos.node(depth).maybeChild($pos.indexAfter(depth));
        while(next && !next.isLeaf){
            next = next.firstChild;
            end++;
        }
    }
    return end;
}
function $b4450e5745e49325$var$findDiff(a, b, pos, preferredPos, preferredSide) {
    let start = a.findDiffStart(b, pos);
    if (start == null) return null;
    let { a: endA, b: endB } = a.findDiffEnd(b, pos + a.size, pos + b.size);
    if (preferredSide == "end") {
        let adjust = Math.max(0, start - Math.min(endA, endB));
        preferredPos -= endA + adjust - start;
    }
    if (endA < start && a.size < b.size) {
        let move = preferredPos <= start && preferredPos >= endA ? start - preferredPos : 0;
        start -= move;
        if (start && start < b.size && $b4450e5745e49325$var$isSurrogatePair(b.textBetween(start - 1, start + 1))) start += move ? 1 : -1;
        endB = start + (endB - endA);
        endA = start;
    } else if (endB < start) {
        let move = preferredPos <= start && preferredPos >= endB ? start - preferredPos : 0;
        start -= move;
        if (start && start < a.size && $b4450e5745e49325$var$isSurrogatePair(a.textBetween(start - 1, start + 1))) start += move ? 1 : -1;
        endA = start + (endA - endB);
        endB = start;
    }
    return {
        start: start,
        endA: endA,
        endB: endB
    };
}
function $b4450e5745e49325$var$isSurrogatePair(str) {
    if (str.length != 2) return false;
    let a = str.charCodeAt(0), b = str.charCodeAt(1);
    return a >= 0xDC00 && a <= 0xDFFF && b >= 0xD800 && b <= 0xDBFF;
}
/**
@internal
*/ const $b4450e5745e49325$export$38b79e3fdcfcfd68 = $b4450e5745e49325$var$serializeForClipboard;
/**
@internal
*/ const $b4450e5745e49325$export$5d42ca91c11c9e4d = $b4450e5745e49325$var$parseFromClipboard;
/**
@internal
*/ const $b4450e5745e49325$export$76b14d3c719c32fc = $b4450e5745e49325$var$endComposition;
/**
An editor view manages the DOM structure that represents an
editable document. Its state and behavior are determined by its
[props](https://prosemirror.net/docs/ref/#view.DirectEditorProps).
*/ class $b4450e5745e49325$export$eece2fccabbb77c5 {
    /**
    Holds `true` when a
    [composition](https://w3c.github.io/uievents/#events-compositionevents)
    is active.
    */ get composing() {
        return this.input.composing;
    }
    /**
    The view's current [props](https://prosemirror.net/docs/ref/#view.EditorProps).
    */ get props() {
        if (this._props.state != this.state) {
            let prev = this._props;
            this._props = {};
            for(let name in prev)this._props[name] = prev[name];
            this._props.state = this.state;
        }
        return this._props;
    }
    /**
    Update the view's props. Will immediately cause an update to
    the DOM.
    */ update(props) {
        if (props.handleDOMEvents != this._props.handleDOMEvents) $b4450e5745e49325$var$ensureListeners(this);
        let prevProps = this._props;
        this._props = props;
        if (props.plugins) {
            props.plugins.forEach($b4450e5745e49325$var$checkStateComponent);
            this.directPlugins = props.plugins;
        }
        this.updateStateInner(props.state, prevProps);
    }
    /**
    Update the view by updating existing props object with the object
    given as argument. Equivalent to `view.update(Object.assign({},
    view.props, props))`.
    */ setProps(props) {
        let updated = {};
        for(let name in this._props)updated[name] = this._props[name];
        updated.state = this.state;
        for(let name in props)updated[name] = props[name];
        this.update(updated);
    }
    /**
    Update the editor's `state` prop, without touching any of the
    other props.
    */ updateState(state) {
        this.updateStateInner(state, this._props);
    }
    updateStateInner(state, prevProps) {
        var _a;
        let prev = this.state, redraw = false, updateSel = false;
        // When stored marks are added, stop composition, so that they can
        // be displayed.
        if (state.storedMarks && this.composing) {
            $b4450e5745e49325$var$clearComposition(this);
            updateSel = true;
        }
        this.state = state;
        let pluginsChanged = prev.plugins != state.plugins || this._props.plugins != prevProps.plugins;
        if (pluginsChanged || this._props.plugins != prevProps.plugins || this._props.nodeViews != prevProps.nodeViews) {
            let nodeViews = $b4450e5745e49325$var$buildNodeViews(this);
            if ($b4450e5745e49325$var$changedNodeViews(nodeViews, this.nodeViews)) {
                this.nodeViews = nodeViews;
                redraw = true;
            }
        }
        if (pluginsChanged || prevProps.handleDOMEvents != this._props.handleDOMEvents) $b4450e5745e49325$var$ensureListeners(this);
        this.editable = $b4450e5745e49325$var$getEditable(this);
        $b4450e5745e49325$var$updateCursorWrapper(this);
        let innerDeco = $b4450e5745e49325$var$viewDecorations(this), outerDeco = $b4450e5745e49325$var$computeDocDeco(this);
        let scroll = prev.plugins != state.plugins && !prev.doc.eq(state.doc) ? "reset" : state.scrollToSelection > prev.scrollToSelection ? "to selection" : "preserve";
        let updateDoc = redraw || !this.docView.matchesNode(state.doc, outerDeco, innerDeco);
        if (updateDoc || !state.selection.eq(prev.selection)) updateSel = true;
        let oldScrollPos = scroll == "preserve" && updateSel && this.dom.style.overflowAnchor == null && $b4450e5745e49325$var$storeScrollPos(this);
        if (updateSel) {
            this.domObserver.stop();
            // Work around an issue in Chrome, IE, and Edge where changing
            // the DOM around an active selection puts it into a broken
            // state where the thing the user sees differs from the
            // selection reported by the Selection object (#710, #973,
            // #1011, #1013, #1035).
            let forceSelUpdate = updateDoc && ($b4450e5745e49325$var$ie || $b4450e5745e49325$var$chrome) && !this.composing && !prev.selection.empty && !state.selection.empty && $b4450e5745e49325$var$selectionContextChanged(prev.selection, state.selection);
            if (updateDoc) {
                // If the node that the selection points into is written to,
                // Chrome sometimes starts misreporting the selection, so this
                // tracks that and forces a selection reset when our update
                // did write to the node.
                let chromeKludge = $b4450e5745e49325$var$chrome ? this.trackWrites = this.domSelectionRange().focusNode : null;
                if (this.composing) this.input.compositionNode = $b4450e5745e49325$var$findCompositionNode(this);
                if (redraw || !this.docView.update(state.doc, outerDeco, innerDeco, this)) {
                    this.docView.updateOuterDeco(outerDeco);
                    this.docView.destroy();
                    this.docView = $b4450e5745e49325$var$docViewDesc(state.doc, outerDeco, innerDeco, this.dom, this);
                }
                if (chromeKludge && !this.trackWrites) forceSelUpdate = true;
            }
            // Work around for an issue where an update arriving right between
            // a DOM selection change and the "selectionchange" event for it
            // can cause a spurious DOM selection update, disrupting mouse
            // drag selection.
            if (forceSelUpdate || !(this.input.mouseDown && this.domObserver.currentSelection.eq(this.domSelectionRange()) && $b4450e5745e49325$var$anchorInRightPlace(this))) $b4450e5745e49325$var$selectionToDOM(this, forceSelUpdate);
            else {
                $b4450e5745e49325$var$syncNodeSelection(this, state.selection);
                this.domObserver.setCurSelection();
            }
            this.domObserver.start();
        }
        this.updatePluginViews(prev);
        if (((_a = this.dragging) === null || _a === void 0 ? void 0 : _a.node) && !prev.doc.eq(state.doc)) this.updateDraggedNode(this.dragging, prev);
        if (scroll == "reset") this.dom.scrollTop = 0;
        else if (scroll == "to selection") this.scrollToSelection();
        else if (oldScrollPos) $b4450e5745e49325$var$resetScrollPos(oldScrollPos);
    }
    /**
    @internal
    */ scrollToSelection() {
        let startDOM = this.domSelectionRange().focusNode;
        if (this.someProp("handleScrollToSelection", (f)=>f(this))) ;
        else if (this.state.selection instanceof (0, $ks2lK.NodeSelection)) {
            let target = this.docView.domAfterPos(this.state.selection.from);
            if (target.nodeType == 1) $b4450e5745e49325$var$scrollRectIntoView(this, target.getBoundingClientRect(), startDOM);
        } else $b4450e5745e49325$var$scrollRectIntoView(this, this.coordsAtPos(this.state.selection.head, 1), startDOM);
    }
    destroyPluginViews() {
        let view;
        while(view = this.pluginViews.pop())if (view.destroy) view.destroy();
    }
    updatePluginViews(prevState) {
        if (!prevState || prevState.plugins != this.state.plugins || this.directPlugins != this.prevDirectPlugins) {
            this.prevDirectPlugins = this.directPlugins;
            this.destroyPluginViews();
            for(let i = 0; i < this.directPlugins.length; i++){
                let plugin = this.directPlugins[i];
                if (plugin.spec.view) this.pluginViews.push(plugin.spec.view(this));
            }
            for(let i = 0; i < this.state.plugins.length; i++){
                let plugin = this.state.plugins[i];
                if (plugin.spec.view) this.pluginViews.push(plugin.spec.view(this));
            }
        } else for(let i = 0; i < this.pluginViews.length; i++){
            let pluginView = this.pluginViews[i];
            if (pluginView.update) pluginView.update(this, prevState);
        }
    }
    updateDraggedNode(dragging, prev) {
        let sel = dragging.node, found = -1;
        if (this.state.doc.nodeAt(sel.from) == sel.node) found = sel.from;
        else {
            let movedPos = sel.from + (this.state.doc.content.size - prev.doc.content.size);
            let moved = movedPos > 0 && this.state.doc.nodeAt(movedPos);
            if (moved == sel.node) found = movedPos;
        }
        this.dragging = new $b4450e5745e49325$var$Dragging(dragging.slice, dragging.move, found < 0 ? undefined : (0, $ks2lK.NodeSelection).create(this.state.doc, found));
    }
    someProp(propName, f) {
        let prop = this._props && this._props[propName], value;
        if (prop != null && (value = f ? f(prop) : prop)) return value;
        for(let i = 0; i < this.directPlugins.length; i++){
            let prop = this.directPlugins[i].props[propName];
            if (prop != null && (value = f ? f(prop) : prop)) return value;
        }
        let plugins = this.state.plugins;
        if (plugins) for(let i = 0; i < plugins.length; i++){
            let prop = plugins[i].props[propName];
            if (prop != null && (value = f ? f(prop) : prop)) return value;
        }
    }
    /**
    Query whether the view has focus.
    */ hasFocus() {
        // Work around IE not handling focus correctly if resize handles are shown.
        // If the cursor is inside an element with resize handles, activeElement
        // will be that element instead of this.dom.
        if ($b4450e5745e49325$var$ie) {
            // If activeElement is within this.dom, and there are no other elements
            // setting `contenteditable` to false in between, treat it as focused.
            let node = this.root.activeElement;
            if (node == this.dom) return true;
            if (!node || !this.dom.contains(node)) return false;
            while(node && this.dom != node && this.dom.contains(node)){
                if (node.contentEditable == 'false') return false;
                node = node.parentElement;
            }
            return true;
        }
        return this.root.activeElement == this.dom;
    }
    /**
    Focus the editor.
    */ focus() {
        this.domObserver.stop();
        if (this.editable) $b4450e5745e49325$var$focusPreventScroll(this.dom);
        $b4450e5745e49325$var$selectionToDOM(this);
        this.domObserver.start();
    }
    /**
    Get the document root in which the editor exists. This will
    usually be the top-level `document`, but might be a [shadow
    DOM](https://developer.mozilla.org/en-US/docs/Web/Web_Components/Shadow_DOM)
    root if the editor is inside one.
    */ get root() {
        let cached = this._root;
        if (cached == null) {
            for(let search = this.dom.parentNode; search; search = search.parentNode)if (search.nodeType == 9 || search.nodeType == 11 && search.host) {
                if (!search.getSelection) Object.getPrototypeOf(search).getSelection = ()=>search.ownerDocument.getSelection();
                return this._root = search;
            }
        }
        return cached || document;
    }
    /**
    When an existing editor view is moved to a new document or
    shadow tree, call this to make it recompute its root.
    */ updateRoot() {
        this._root = null;
    }
    /**
    Given a pair of viewport coordinates, return the document
    position that corresponds to them. May return null if the given
    coordinates aren't inside of the editor. When an object is
    returned, its `pos` property is the position nearest to the
    coordinates, and its `inside` property holds the position of the
    inner node that the position falls inside of, or -1 if it is at
    the top level, not in any node.
    */ posAtCoords(coords) {
        return $b4450e5745e49325$var$posAtCoords(this, coords);
    }
    /**
    Returns the viewport rectangle at a given document position.
    `left` and `right` will be the same number, as this returns a
    flat cursor-ish rectangle. If the position is between two things
    that aren't directly adjacent, `side` determines which element
    is used. When < 0, the element before the position is used,
    otherwise the element after.
    */ coordsAtPos(pos, side = 1) {
        return $b4450e5745e49325$var$coordsAtPos(this, pos, side);
    }
    /**
    Find the DOM position that corresponds to the given document
    position. When `side` is negative, find the position as close as
    possible to the content before the position. When positive,
    prefer positions close to the content after the position. When
    zero, prefer as shallow a position as possible.
    
    Note that you should **not** mutate the editor's internal DOM,
    only inspect it (and even that is usually not necessary).
    */ domAtPos(pos, side = 0) {
        return this.docView.domFromPos(pos, side);
    }
    /**
    Find the DOM node that represents the document node after the
    given position. May return `null` when the position doesn't point
    in front of a node or if the node is inside an opaque node view.
    
    This is intended to be able to call things like
    `getBoundingClientRect` on that DOM node. Do **not** mutate the
    editor DOM directly, or add styling this way, since that will be
    immediately overriden by the editor as it redraws the node.
    */ nodeDOM(pos) {
        let desc = this.docView.descAt(pos);
        return desc ? desc.nodeDOM : null;
    }
    /**
    Find the document position that corresponds to a given DOM
    position. (Whenever possible, it is preferable to inspect the
    document structure directly, rather than poking around in the
    DOM, but sometimes—for example when interpreting an event
    target—you don't have a choice.)
    
    The `bias` parameter can be used to influence which side of a DOM
    node to use when the position is inside a leaf node.
    */ posAtDOM(node, offset, bias = -1) {
        let pos = this.docView.posFromDOM(node, offset, bias);
        if (pos == null) throw new RangeError("DOM position not inside the editor");
        return pos;
    }
    /**
    Find out whether the selection is at the end of a textblock when
    moving in a given direction. When, for example, given `"left"`,
    it will return true if moving left from the current cursor
    position would leave that position's parent textblock. Will apply
    to the view's current state by default, but it is possible to
    pass a different state.
    */ endOfTextblock(dir, state) {
        return $b4450e5745e49325$var$endOfTextblock(this, state || this.state, dir);
    }
    /**
    Run the editor's paste logic with the given HTML string. The
    `event`, if given, will be passed to the
    [`handlePaste`](https://prosemirror.net/docs/ref/#view.EditorProps.handlePaste) hook.
    */ pasteHTML(html, event) {
        return $b4450e5745e49325$var$doPaste(this, "", html, false, event || new ClipboardEvent("paste"));
    }
    /**
    Run the editor's paste logic with the given plain-text input.
    */ pasteText(text, event) {
        return $b4450e5745e49325$var$doPaste(this, text, null, true, event || new ClipboardEvent("paste"));
    }
    /**
    Removes the editor from the DOM and destroys all [node
    views](https://prosemirror.net/docs/ref/#view.NodeView).
    */ destroy() {
        if (!this.docView) return;
        $b4450e5745e49325$var$destroyInput(this);
        this.destroyPluginViews();
        if (this.mounted) {
            this.docView.update(this.state.doc, [], $b4450e5745e49325$var$viewDecorations(this), this);
            this.dom.textContent = "";
        } else if (this.dom.parentNode) this.dom.parentNode.removeChild(this.dom);
        this.docView.destroy();
        this.docView = null;
        $b4450e5745e49325$var$clearReusedRange();
    }
    /**
    This is true when the view has been
    [destroyed](https://prosemirror.net/docs/ref/#view.EditorView.destroy) (and thus should not be
    used anymore).
    */ get isDestroyed() {
        return this.docView == null;
    }
    /**
    Used for testing.
    */ dispatchEvent(event) {
        return $b4450e5745e49325$var$dispatchEvent(this, event);
    }
    /**
    Dispatch a transaction. Will call
    [`dispatchTransaction`](https://prosemirror.net/docs/ref/#view.DirectEditorProps.dispatchTransaction)
    when given, and otherwise defaults to applying the transaction to
    the current state and calling
    [`updateState`](https://prosemirror.net/docs/ref/#view.EditorView.updateState) with the result.
    This method is bound to the view instance, so that it can be
    easily passed around.
    */ dispatch(tr) {
        let dispatchTransaction = this._props.dispatchTransaction;
        if (dispatchTransaction) dispatchTransaction.call(this, tr);
        else this.updateState(this.state.apply(tr));
    }
    /**
    @internal
    */ domSelectionRange() {
        let sel = this.domSelection();
        if (!sel) return {
            focusNode: null,
            focusOffset: 0,
            anchorNode: null,
            anchorOffset: 0
        };
        return $b4450e5745e49325$var$safari && this.root.nodeType === 11 && $b4450e5745e49325$var$deepActiveElement(this.dom.ownerDocument) == this.dom && $b4450e5745e49325$var$safariShadowSelectionRange(this, sel) || sel;
    }
    /**
    @internal
    */ domSelection() {
        return this.root.getSelection();
    }
    /**
    Create a view. `place` may be a DOM node that the editor should
    be appended to, a function that will place it into the document,
    or an object whose `mount` property holds the node to use as the
    document container. If it is `null`, the editor will not be
    added to the document.
    */ constructor(place, props){
        this._root = null;
        /**
        @internal
        */ this.focused = false;
        /**
        Kludge used to work around a Chrome bug @internal
        */ this.trackWrites = null;
        this.mounted = false;
        /**
        @internal
        */ this.markCursor = null;
        /**
        @internal
        */ this.cursorWrapper = null;
        /**
        @internal
        */ this.lastSelectedViewDesc = undefined;
        /**
        @internal
        */ this.input = new $b4450e5745e49325$var$InputState;
        this.prevDirectPlugins = [];
        this.pluginViews = [];
        /**
        Holds `true` when a hack node is needed in Firefox to prevent the
        [space is eaten issue](https://github.com/ProseMirror/prosemirror/issues/651)
        @internal
        */ this.requiresGeckoHackNode = false;
        /**
        When editor content is being dragged, this object contains
        information about the dragged slice and whether it is being
        copied or moved. At any other time, it is null.
        */ this.dragging = null;
        this._props = props;
        this.state = props.state;
        this.directPlugins = props.plugins || [];
        this.directPlugins.forEach($b4450e5745e49325$var$checkStateComponent);
        this.dispatch = this.dispatch.bind(this);
        this.dom = place && place.mount || document.createElement("div");
        if (place) {
            if (place.appendChild) place.appendChild(this.dom);
            else if (typeof place == "function") place(this.dom);
            else if (place.mount) this.mounted = true;
        }
        this.editable = $b4450e5745e49325$var$getEditable(this);
        $b4450e5745e49325$var$updateCursorWrapper(this);
        this.nodeViews = $b4450e5745e49325$var$buildNodeViews(this);
        this.docView = $b4450e5745e49325$var$docViewDesc(this.state.doc, $b4450e5745e49325$var$computeDocDeco(this), $b4450e5745e49325$var$viewDecorations(this), this.dom, this);
        this.domObserver = new $b4450e5745e49325$var$DOMObserver(this, (from, to, typeOver, added)=>$b4450e5745e49325$var$readDOMChange(this, from, to, typeOver, added));
        this.domObserver.start();
        $b4450e5745e49325$var$initInput(this);
        this.updatePluginViews();
    }
}
function $b4450e5745e49325$var$computeDocDeco(view) {
    let attrs = Object.create(null);
    attrs.class = "ProseMirror";
    attrs.contenteditable = String(view.editable);
    view.someProp("attributes", (value)=>{
        if (typeof value == "function") value = value(view.state);
        if (value) for(let attr in value){
            if (attr == "class") attrs.class += " " + value[attr];
            else if (attr == "style") attrs.style = (attrs.style ? attrs.style + ";" : "") + value[attr];
            else if (!attrs[attr] && attr != "contenteditable" && attr != "nodeName") attrs[attr] = String(value[attr]);
        }
    });
    if (!attrs.translate) attrs.translate = "no";
    return [
        $b4450e5745e49325$export$10e30b733df217ea.node(0, view.state.doc.content.size, attrs)
    ];
}
function $b4450e5745e49325$var$updateCursorWrapper(view) {
    if (view.markCursor) {
        let dom = document.createElement("img");
        dom.className = "ProseMirror-separator";
        dom.setAttribute("mark-placeholder", "true");
        dom.setAttribute("alt", "");
        view.cursorWrapper = {
            dom: dom,
            deco: $b4450e5745e49325$export$10e30b733df217ea.widget(view.state.selection.from, dom, {
                raw: true,
                marks: view.markCursor
            })
        };
    } else view.cursorWrapper = null;
}
function $b4450e5745e49325$var$getEditable(view) {
    return !view.someProp("editable", (value)=>value(view.state) === false);
}
function $b4450e5745e49325$var$selectionContextChanged(sel1, sel2) {
    let depth = Math.min(sel1.$anchor.sharedDepth(sel1.head), sel2.$anchor.sharedDepth(sel2.head));
    return sel1.$anchor.start(depth) != sel2.$anchor.start(depth);
}
function $b4450e5745e49325$var$buildNodeViews(view) {
    let result = Object.create(null);
    function add(obj) {
        for(let prop in obj)if (!Object.prototype.hasOwnProperty.call(result, prop)) result[prop] = obj[prop];
    }
    view.someProp("nodeViews", add);
    view.someProp("markViews", add);
    return result;
}
function $b4450e5745e49325$var$changedNodeViews(a, b) {
    let nA = 0, nB = 0;
    for(let prop in a){
        if (a[prop] != b[prop]) return true;
        nA++;
    }
    for(let _ in b)nB++;
    return nA != nB;
}
function $b4450e5745e49325$var$checkStateComponent(plugin) {
    if (plugin.spec.state || plugin.spec.filterTransaction || plugin.spec.appendTransaction) throw new RangeError("Plugins passed directly to the view must not have a state component");
}
module.exports["Decoration"] = $b4450e5745e49325$export$10e30b733df217ea;
module.exports["DecorationSet"] = $b4450e5745e49325$export$93bf62eb445cec98;
module.exports["EditorView"] = $b4450e5745e49325$export$eece2fccabbb77c5;

});

parcelRegister("astHL", function(module, exports) {

var $aXG5V = parcelRequire("aXG5V");


var $5SAOw = parcelRequire("5SAOw");


var $ks2lK = parcelRequire("ks2lK");

/**
Delete the selection, if there is one.
*/ const $79d38fafc7d67c3d$export$e9a518a637d1e641 = (state, dispatch)=>{
    if (state.selection.empty) return false;
    if (dispatch) dispatch(state.tr.deleteSelection().scrollIntoView());
    return true;
};
function $79d38fafc7d67c3d$var$atBlockStart(state, view) {
    let { $cursor: $cursor } = state.selection;
    if (!$cursor || (view ? !view.endOfTextblock("backward", state) : $cursor.parentOffset > 0)) return null;
    return $cursor;
}
/**
If the selection is empty and at the start of a textblock, try to
reduce the distance between that block and the one before it—if
there's a block directly before it that can be joined, join them.
If not, try to move the selected block closer to the next one in
the document structure by lifting it out of its parent or moving it
into a parent of the previous block. Will use the view for accurate
(bidi-aware) start-of-textblock detection if given.
*/ const $79d38fafc7d67c3d$export$979097b097459299 = (state, dispatch, view)=>{
    let $cursor = $79d38fafc7d67c3d$var$atBlockStart(state, view);
    if (!$cursor) return false;
    let $cut = $79d38fafc7d67c3d$var$findCutBefore($cursor);
    // If there is no node before this, try to lift
    if (!$cut) {
        let range = $cursor.blockRange(), target = range && (0, $aXG5V.liftTarget)(range);
        if (target == null) return false;
        if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
        return true;
    }
    let before = $cut.nodeBefore;
    // Apply the joining algorithm
    if ($79d38fafc7d67c3d$var$deleteBarrier(state, $cut, dispatch, -1)) return true;
    // If the node below has no content and the node above is
    // selectable, delete the node below and select the one above.
    if ($cursor.parent.content.size == 0 && ($79d38fafc7d67c3d$var$textblockAt(before, "end") || (0, $ks2lK.NodeSelection).isSelectable(before))) for(let depth = $cursor.depth;; depth--){
        let delStep = (0, $aXG5V.replaceStep)(state.doc, $cursor.before(depth), $cursor.after(depth), (0, $5SAOw.Slice).empty);
        if (delStep && delStep.slice.size < delStep.to - delStep.from) {
            if (dispatch) {
                let tr = state.tr.step(delStep);
                tr.setSelection($79d38fafc7d67c3d$var$textblockAt(before, "end") ? (0, $ks2lK.Selection).findFrom(tr.doc.resolve(tr.mapping.map($cut.pos, -1)), -1) : (0, $ks2lK.NodeSelection).create(tr.doc, $cut.pos - before.nodeSize));
                dispatch(tr.scrollIntoView());
            }
            return true;
        }
        if (depth == 1 || $cursor.node(depth - 1).childCount > 1) break;
    }
    // If the node before is an atom, delete it
    if (before.isAtom && $cut.depth == $cursor.depth - 1) {
        if (dispatch) dispatch(state.tr.delete($cut.pos - before.nodeSize, $cut.pos).scrollIntoView());
        return true;
    }
    return false;
};
/**
A more limited form of [`joinBackward`]($commands.joinBackward)
that only tries to join the current textblock to the one before
it, if the cursor is at the start of a textblock.
*/ const $79d38fafc7d67c3d$export$1dce4f5c74f5f90f = (state, dispatch, view)=>{
    let $cursor = $79d38fafc7d67c3d$var$atBlockStart(state, view);
    if (!$cursor) return false;
    let $cut = $79d38fafc7d67c3d$var$findCutBefore($cursor);
    return $cut ? $79d38fafc7d67c3d$var$joinTextblocksAround(state, $cut, dispatch) : false;
};
/**
A more limited form of [`joinForward`]($commands.joinForward)
that only tries to join the current textblock to the one after
it, if the cursor is at the end of a textblock.
*/ const $79d38fafc7d67c3d$export$e796bb96d22be2cd = (state, dispatch, view)=>{
    let $cursor = $79d38fafc7d67c3d$var$atBlockEnd(state, view);
    if (!$cursor) return false;
    let $cut = $79d38fafc7d67c3d$var$findCutAfter($cursor);
    return $cut ? $79d38fafc7d67c3d$var$joinTextblocksAround(state, $cut, dispatch) : false;
};
function $79d38fafc7d67c3d$var$joinTextblocksAround(state, $cut, dispatch) {
    let before = $cut.nodeBefore, beforeText = before, beforePos = $cut.pos - 1;
    for(; !beforeText.isTextblock; beforePos--){
        if (beforeText.type.spec.isolating) return false;
        let child = beforeText.lastChild;
        if (!child) return false;
        beforeText = child;
    }
    let after = $cut.nodeAfter, afterText = after, afterPos = $cut.pos + 1;
    for(; !afterText.isTextblock; afterPos++){
        if (afterText.type.spec.isolating) return false;
        let child = afterText.firstChild;
        if (!child) return false;
        afterText = child;
    }
    let step = (0, $aXG5V.replaceStep)(state.doc, beforePos, afterPos, (0, $5SAOw.Slice).empty);
    if (!step || step.from != beforePos || step instanceof (0, $aXG5V.ReplaceStep) && step.slice.size >= afterPos - beforePos) return false;
    if (dispatch) {
        let tr = state.tr.step(step);
        tr.setSelection((0, $ks2lK.TextSelection).create(tr.doc, beforePos));
        dispatch(tr.scrollIntoView());
    }
    return true;
}
function $79d38fafc7d67c3d$var$textblockAt(node, side, only = false) {
    for(let scan = node; scan; scan = side == "start" ? scan.firstChild : scan.lastChild){
        if (scan.isTextblock) return true;
        if (only && scan.childCount != 1) return false;
    }
    return false;
}
/**
When the selection is empty and at the start of a textblock, select
the node before that textblock, if possible. This is intended to be
bound to keys like backspace, after
[`joinBackward`](https://prosemirror.net/docs/ref/#commands.joinBackward) or other deleting
commands, as a fall-back behavior when the schema doesn't allow
deletion at the selected point.
*/ const $79d38fafc7d67c3d$export$52b8a4af68d19794 = (state, dispatch, view)=>{
    let { $head: $head, empty: empty } = state.selection, $cut = $head;
    if (!empty) return false;
    if ($head.parent.isTextblock) {
        if (view ? !view.endOfTextblock("backward", state) : $head.parentOffset > 0) return false;
        $cut = $79d38fafc7d67c3d$var$findCutBefore($head);
    }
    let node = $cut && $cut.nodeBefore;
    if (!node || !(0, $ks2lK.NodeSelection).isSelectable(node)) return false;
    if (dispatch) dispatch(state.tr.setSelection((0, $ks2lK.NodeSelection).create(state.doc, $cut.pos - node.nodeSize)).scrollIntoView());
    return true;
};
function $79d38fafc7d67c3d$var$findCutBefore($pos) {
    if (!$pos.parent.type.spec.isolating) for(let i = $pos.depth - 1; i >= 0; i--){
        if ($pos.index(i) > 0) return $pos.doc.resolve($pos.before(i + 1));
        if ($pos.node(i).type.spec.isolating) break;
    }
    return null;
}
function $79d38fafc7d67c3d$var$atBlockEnd(state, view) {
    let { $cursor: $cursor } = state.selection;
    if (!$cursor || (view ? !view.endOfTextblock("forward", state) : $cursor.parentOffset < $cursor.parent.content.size)) return null;
    return $cursor;
}
/**
If the selection is empty and the cursor is at the end of a
textblock, try to reduce or remove the boundary between that block
and the one after it, either by joining them or by moving the other
block closer to this one in the tree structure. Will use the view
for accurate start-of-textblock detection if given.
*/ const $79d38fafc7d67c3d$export$bf432e340007f9ef = (state, dispatch, view)=>{
    let $cursor = $79d38fafc7d67c3d$var$atBlockEnd(state, view);
    if (!$cursor) return false;
    let $cut = $79d38fafc7d67c3d$var$findCutAfter($cursor);
    // If there is no node after this, there's nothing to do
    if (!$cut) return false;
    let after = $cut.nodeAfter;
    // Try the joining algorithm
    if ($79d38fafc7d67c3d$var$deleteBarrier(state, $cut, dispatch, 1)) return true;
    // If the node above has no content and the node below is
    // selectable, delete the node above and select the one below.
    if ($cursor.parent.content.size == 0 && ($79d38fafc7d67c3d$var$textblockAt(after, "start") || (0, $ks2lK.NodeSelection).isSelectable(after))) {
        let delStep = (0, $aXG5V.replaceStep)(state.doc, $cursor.before(), $cursor.after(), (0, $5SAOw.Slice).empty);
        if (delStep && delStep.slice.size < delStep.to - delStep.from) {
            if (dispatch) {
                let tr = state.tr.step(delStep);
                tr.setSelection($79d38fafc7d67c3d$var$textblockAt(after, "start") ? (0, $ks2lK.Selection).findFrom(tr.doc.resolve(tr.mapping.map($cut.pos)), 1) : (0, $ks2lK.NodeSelection).create(tr.doc, tr.mapping.map($cut.pos)));
                dispatch(tr.scrollIntoView());
            }
            return true;
        }
    }
    // If the next node is an atom, delete it
    if (after.isAtom && $cut.depth == $cursor.depth - 1) {
        if (dispatch) dispatch(state.tr.delete($cut.pos, $cut.pos + after.nodeSize).scrollIntoView());
        return true;
    }
    return false;
};
/**
When the selection is empty and at the end of a textblock, select
the node coming after that textblock, if possible. This is intended
to be bound to keys like delete, after
[`joinForward`](https://prosemirror.net/docs/ref/#commands.joinForward) and similar deleting
commands, to provide a fall-back behavior when the schema doesn't
allow deletion at the selected point.
*/ const $79d38fafc7d67c3d$export$5835b52680b80cfd = (state, dispatch, view)=>{
    let { $head: $head, empty: empty } = state.selection, $cut = $head;
    if (!empty) return false;
    if ($head.parent.isTextblock) {
        if (view ? !view.endOfTextblock("forward", state) : $head.parentOffset < $head.parent.content.size) return false;
        $cut = $79d38fafc7d67c3d$var$findCutAfter($head);
    }
    let node = $cut && $cut.nodeAfter;
    if (!node || !(0, $ks2lK.NodeSelection).isSelectable(node)) return false;
    if (dispatch) dispatch(state.tr.setSelection((0, $ks2lK.NodeSelection).create(state.doc, $cut.pos)).scrollIntoView());
    return true;
};
function $79d38fafc7d67c3d$var$findCutAfter($pos) {
    if (!$pos.parent.type.spec.isolating) for(let i = $pos.depth - 1; i >= 0; i--){
        let parent = $pos.node(i);
        if ($pos.index(i) + 1 < parent.childCount) return $pos.doc.resolve($pos.after(i + 1));
        if (parent.type.spec.isolating) break;
    }
    return null;
}
/**
Join the selected block or, if there is a text selection, the
closest ancestor block of the selection that can be joined, with
the sibling above it.
*/ const $79d38fafc7d67c3d$export$4bb15e6d4372b393 = (state, dispatch)=>{
    let sel = state.selection, nodeSel = sel instanceof (0, $ks2lK.NodeSelection), point;
    if (nodeSel) {
        if (sel.node.isTextblock || !(0, $aXG5V.canJoin)(state.doc, sel.from)) return false;
        point = sel.from;
    } else {
        point = (0, $aXG5V.joinPoint)(state.doc, sel.from, -1);
        if (point == null) return false;
    }
    if (dispatch) {
        let tr = state.tr.join(point);
        if (nodeSel) tr.setSelection((0, $ks2lK.NodeSelection).create(tr.doc, point - state.doc.resolve(point).nodeBefore.nodeSize));
        dispatch(tr.scrollIntoView());
    }
    return true;
};
/**
Join the selected block, or the closest ancestor of the selection
that can be joined, with the sibling after it.
*/ const $79d38fafc7d67c3d$export$8dd967a262b064bb = (state, dispatch)=>{
    let sel = state.selection, point;
    if (sel instanceof (0, $ks2lK.NodeSelection)) {
        if (sel.node.isTextblock || !(0, $aXG5V.canJoin)(state.doc, sel.to)) return false;
        point = sel.to;
    } else {
        point = (0, $aXG5V.joinPoint)(state.doc, sel.to, 1);
        if (point == null) return false;
    }
    if (dispatch) dispatch(state.tr.join(point).scrollIntoView());
    return true;
};
/**
Lift the selected block, or the closest ancestor block of the
selection that can be lifted, out of its parent node.
*/ const $79d38fafc7d67c3d$export$590e8b2c435046d9 = (state, dispatch)=>{
    let { $from: $from, $to: $to } = state.selection;
    let range = $from.blockRange($to), target = range && (0, $aXG5V.liftTarget)(range);
    if (target == null) return false;
    if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
    return true;
};
/**
If the selection is in a node whose type has a truthy
[`code`](https://prosemirror.net/docs/ref/#model.NodeSpec.code) property in its spec, replace the
selection with a newline character.
*/ const $79d38fafc7d67c3d$export$a5d02b4b65e94f91 = (state, dispatch)=>{
    let { $head: $head, $anchor: $anchor } = state.selection;
    if (!$head.parent.type.spec.code || !$head.sameParent($anchor)) return false;
    if (dispatch) dispatch(state.tr.insertText("\n").scrollIntoView());
    return true;
};
function $79d38fafc7d67c3d$var$defaultBlockAt(match) {
    for(let i = 0; i < match.edgeCount; i++){
        let { type: type } = match.edge(i);
        if (type.isTextblock && !type.hasRequiredAttrs()) return type;
    }
    return null;
}
/**
When the selection is in a node with a truthy
[`code`](https://prosemirror.net/docs/ref/#model.NodeSpec.code) property in its spec, create a
default block after the code block, and move the cursor there.
*/ const $79d38fafc7d67c3d$export$634b78845598ff5b = (state, dispatch)=>{
    let { $head: $head, $anchor: $anchor } = state.selection;
    if (!$head.parent.type.spec.code || !$head.sameParent($anchor)) return false;
    let above = $head.node(-1), after = $head.indexAfter(-1), type = $79d38fafc7d67c3d$var$defaultBlockAt(above.contentMatchAt(after));
    if (!type || !above.canReplaceWith(after, after, type)) return false;
    if (dispatch) {
        let pos = $head.after(), tr = state.tr.replaceWith(pos, pos, type.createAndFill());
        tr.setSelection((0, $ks2lK.Selection).near(tr.doc.resolve(pos), 1));
        dispatch(tr.scrollIntoView());
    }
    return true;
};
/**
If a block node is selected, create an empty paragraph before (if
it is its parent's first child) or after it.
*/ const $79d38fafc7d67c3d$export$d0f80ac1b4510888 = (state, dispatch)=>{
    let sel = state.selection, { $from: $from, $to: $to } = sel;
    if (sel instanceof (0, $ks2lK.AllSelection) || $from.parent.inlineContent || $to.parent.inlineContent) return false;
    let type = $79d38fafc7d67c3d$var$defaultBlockAt($to.parent.contentMatchAt($to.indexAfter()));
    if (!type || !type.isTextblock) return false;
    if (dispatch) {
        let side = (!$from.parentOffset && $to.index() < $to.parent.childCount ? $from : $to).pos;
        let tr = state.tr.insert(side, type.createAndFill());
        tr.setSelection((0, $ks2lK.TextSelection).create(tr.doc, side + 1));
        dispatch(tr.scrollIntoView());
    }
    return true;
};
/**
If the cursor is in an empty textblock that can be lifted, lift the
block.
*/ const $79d38fafc7d67c3d$export$a3574cc681852c08 = (state, dispatch)=>{
    let { $cursor: $cursor } = state.selection;
    if (!$cursor || $cursor.parent.content.size) return false;
    if ($cursor.depth > 1 && $cursor.after() != $cursor.end(-1)) {
        let before = $cursor.before();
        if ((0, $aXG5V.canSplit)(state.doc, before)) {
            if (dispatch) dispatch(state.tr.split(before).scrollIntoView());
            return true;
        }
    }
    let range = $cursor.blockRange(), target = range && (0, $aXG5V.liftTarget)(range);
    if (target == null) return false;
    if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
    return true;
};
/**
Create a variant of [`splitBlock`](https://prosemirror.net/docs/ref/#commands.splitBlock) that uses
a custom function to determine the type of the newly split off block.
*/ function $79d38fafc7d67c3d$export$8bf8350f33b1e5ab(splitNode) {
    return (state, dispatch)=>{
        let { $from: $from, $to: $to } = state.selection;
        if (state.selection instanceof (0, $ks2lK.NodeSelection) && state.selection.node.isBlock) {
            if (!$from.parentOffset || !(0, $aXG5V.canSplit)(state.doc, $from.pos)) return false;
            if (dispatch) dispatch(state.tr.split($from.pos).scrollIntoView());
            return true;
        }
        if (!$from.depth) return false;
        let types = [];
        let splitDepth, deflt, atEnd = false, atStart = false;
        for(let d = $from.depth;; d--){
            let node = $from.node(d);
            if (node.isBlock) {
                atEnd = $from.end(d) == $from.pos + ($from.depth - d);
                atStart = $from.start(d) == $from.pos - ($from.depth - d);
                deflt = $79d38fafc7d67c3d$var$defaultBlockAt($from.node(d - 1).contentMatchAt($from.indexAfter(d - 1)));
                let splitType = splitNode && splitNode($to.parent, atEnd, $from);
                types.unshift(splitType || (atEnd && deflt ? {
                    type: deflt
                } : null));
                splitDepth = d;
                break;
            } else {
                if (d == 1) return false;
                types.unshift(null);
            }
        }
        let tr = state.tr;
        if (state.selection instanceof (0, $ks2lK.TextSelection) || state.selection instanceof (0, $ks2lK.AllSelection)) tr.deleteSelection();
        let splitPos = tr.mapping.map($from.pos);
        let can = (0, $aXG5V.canSplit)(tr.doc, splitPos, types.length, types);
        if (!can) {
            types[0] = deflt ? {
                type: deflt
            } : null;
            can = (0, $aXG5V.canSplit)(tr.doc, splitPos, types.length, types);
        }
        tr.split(splitPos, types.length, types);
        if (!atEnd && atStart && $from.node(splitDepth).type != deflt) {
            let first = tr.mapping.map($from.before(splitDepth)), $first = tr.doc.resolve(first);
            if (deflt && $from.node(splitDepth - 1).canReplaceWith($first.index(), $first.index() + 1, deflt)) tr.setNodeMarkup(tr.mapping.map($from.before(splitDepth)), deflt);
        }
        if (dispatch) dispatch(tr.scrollIntoView());
        return true;
    };
}
/**
Split the parent block of the selection. If the selection is a text
selection, also delete its content.
*/ const $79d38fafc7d67c3d$export$e99155638ff4dff0 = $79d38fafc7d67c3d$export$8bf8350f33b1e5ab();
/**
Acts like [`splitBlock`](https://prosemirror.net/docs/ref/#commands.splitBlock), but without
resetting the set of active marks at the cursor.
*/ const $79d38fafc7d67c3d$export$eeb429476568b72b = (state, dispatch)=>{
    return $79d38fafc7d67c3d$export$e99155638ff4dff0(state, dispatch && ((tr)=>{
        let marks = state.storedMarks || state.selection.$to.parentOffset && state.selection.$from.marks();
        if (marks) tr.ensureMarks(marks);
        dispatch(tr);
    }));
};
/**
Move the selection to the node wrapping the current selection, if
any. (Will not select the document node.)
*/ const $79d38fafc7d67c3d$export$a37f6aaa9169911d = (state, dispatch)=>{
    let { $from: $from, to: to } = state.selection, pos;
    let same = $from.sharedDepth(to);
    if (same == 0) return false;
    pos = $from.before(same);
    if (dispatch) dispatch(state.tr.setSelection((0, $ks2lK.NodeSelection).create(state.doc, pos)));
    return true;
};
/**
Select the whole document.
*/ const $79d38fafc7d67c3d$export$90aca4adda6ff0f5 = (state, dispatch)=>{
    if (dispatch) dispatch(state.tr.setSelection(new (0, $ks2lK.AllSelection)(state.doc)));
    return true;
};
function $79d38fafc7d67c3d$var$joinMaybeClear(state, $pos, dispatch) {
    let before = $pos.nodeBefore, after = $pos.nodeAfter, index = $pos.index();
    if (!before || !after || !before.type.compatibleContent(after.type)) return false;
    if (!before.content.size && $pos.parent.canReplace(index - 1, index)) {
        if (dispatch) dispatch(state.tr.delete($pos.pos - before.nodeSize, $pos.pos).scrollIntoView());
        return true;
    }
    if (!$pos.parent.canReplace(index, index + 1) || !(after.isTextblock || (0, $aXG5V.canJoin)(state.doc, $pos.pos))) return false;
    if (dispatch) dispatch(state.tr.join($pos.pos).scrollIntoView());
    return true;
}
function $79d38fafc7d67c3d$var$deleteBarrier(state, $cut, dispatch, dir) {
    let before = $cut.nodeBefore, after = $cut.nodeAfter, conn, match;
    let isolated = before.type.spec.isolating || after.type.spec.isolating;
    if (!isolated && $79d38fafc7d67c3d$var$joinMaybeClear(state, $cut, dispatch)) return true;
    let canDelAfter = !isolated && $cut.parent.canReplace($cut.index(), $cut.index() + 1);
    if (canDelAfter && (conn = (match = before.contentMatchAt(before.childCount)).findWrapping(after.type)) && match.matchType(conn[0] || after.type).validEnd) {
        if (dispatch) {
            let end = $cut.pos + after.nodeSize, wrap = (0, $5SAOw.Fragment).empty;
            for(let i = conn.length - 1; i >= 0; i--)wrap = (0, $5SAOw.Fragment).from(conn[i].create(null, wrap));
            wrap = (0, $5SAOw.Fragment).from(before.copy(wrap));
            let tr = state.tr.step(new (0, $aXG5V.ReplaceAroundStep)($cut.pos - 1, end, $cut.pos, end, new (0, $5SAOw.Slice)(wrap, 1, 0), conn.length, true));
            let $joinAt = tr.doc.resolve(end + 2 * conn.length);
            if ($joinAt.nodeAfter && $joinAt.nodeAfter.type == before.type && (0, $aXG5V.canJoin)(tr.doc, $joinAt.pos)) tr.join($joinAt.pos);
            dispatch(tr.scrollIntoView());
        }
        return true;
    }
    let selAfter = after.type.spec.isolating || dir > 0 && isolated ? null : (0, $ks2lK.Selection).findFrom($cut, 1);
    let range = selAfter && selAfter.$from.blockRange(selAfter.$to), target = range && (0, $aXG5V.liftTarget)(range);
    if (target != null && target >= $cut.depth) {
        if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
        return true;
    }
    if (canDelAfter && $79d38fafc7d67c3d$var$textblockAt(after, "start", true) && $79d38fafc7d67c3d$var$textblockAt(before, "end")) {
        let at = before, wrap = [];
        for(;;){
            wrap.push(at);
            if (at.isTextblock) break;
            at = at.lastChild;
        }
        let afterText = after, afterDepth = 1;
        for(; !afterText.isTextblock; afterText = afterText.firstChild)afterDepth++;
        if (at.canReplace(at.childCount, at.childCount, afterText.content)) {
            if (dispatch) {
                let end = (0, $5SAOw.Fragment).empty;
                for(let i = wrap.length - 1; i >= 0; i--)end = (0, $5SAOw.Fragment).from(wrap[i].copy(end));
                let tr = state.tr.step(new (0, $aXG5V.ReplaceAroundStep)($cut.pos - wrap.length, $cut.pos + after.nodeSize, $cut.pos + afterDepth, $cut.pos + after.nodeSize - afterDepth, new (0, $5SAOw.Slice)(end, wrap.length, 0), 0, true));
                dispatch(tr.scrollIntoView());
            }
            return true;
        }
    }
    return false;
}
function $79d38fafc7d67c3d$var$selectTextblockSide(side) {
    return function(state, dispatch) {
        let sel = state.selection, $pos = side < 0 ? sel.$from : sel.$to;
        let depth = $pos.depth;
        while($pos.node(depth).isInline){
            if (!depth) return false;
            depth--;
        }
        if (!$pos.node(depth).isTextblock) return false;
        if (dispatch) dispatch(state.tr.setSelection((0, $ks2lK.TextSelection).create(state.doc, side < 0 ? $pos.start(depth) : $pos.end(depth))));
        return true;
    };
}
/**
Moves the cursor to the start of current text block.
*/ const $79d38fafc7d67c3d$export$c3a64f3c9604a1b1 = $79d38fafc7d67c3d$var$selectTextblockSide(-1);
/**
Moves the cursor to the end of current text block.
*/ const $79d38fafc7d67c3d$export$a66c1876556415e5 = $79d38fafc7d67c3d$var$selectTextblockSide(1);
// Parameterized commands
/**
Wrap the selection in a node of the given type with the given
attributes.
*/ function $79d38fafc7d67c3d$export$6e5e3c49755affd0(nodeType, attrs = null) {
    return function(state, dispatch) {
        let { $from: $from, $to: $to } = state.selection;
        let range = $from.blockRange($to), wrapping = range && (0, $aXG5V.findWrapping)(range, nodeType, attrs);
        if (!wrapping) return false;
        if (dispatch) dispatch(state.tr.wrap(range, wrapping).scrollIntoView());
        return true;
    };
}
/**
Returns a command that tries to set the selected textblocks to the
given node type with the given attributes.
*/ function $79d38fafc7d67c3d$export$36987f561c736aad(nodeType, attrs = null) {
    return function(state, dispatch) {
        let applicable = false;
        for(let i = 0; i < state.selection.ranges.length && !applicable; i++){
            let { $from: { pos: from }, $to: { pos: to } } = state.selection.ranges[i];
            state.doc.nodesBetween(from, to, (node, pos)=>{
                if (applicable) return false;
                if (!node.isTextblock || node.hasMarkup(nodeType, attrs)) return;
                if (node.type == nodeType) applicable = true;
                else {
                    let $pos = state.doc.resolve(pos), index = $pos.index();
                    applicable = $pos.parent.canReplaceWith(index, index + 1, nodeType);
                }
            });
        }
        if (!applicable) return false;
        if (dispatch) {
            let tr = state.tr;
            for(let i = 0; i < state.selection.ranges.length; i++){
                let { $from: { pos: from }, $to: { pos: to } } = state.selection.ranges[i];
                tr.setBlockType(from, to, nodeType, attrs);
            }
            dispatch(tr.scrollIntoView());
        }
        return true;
    };
}
function $79d38fafc7d67c3d$var$markApplies(doc, ranges, type, enterAtoms) {
    for(let i = 0; i < ranges.length; i++){
        let { $from: $from, $to: $to } = ranges[i];
        let can = $from.depth == 0 ? doc.inlineContent && doc.type.allowsMarkType(type) : false;
        doc.nodesBetween($from.pos, $to.pos, (node, pos)=>{
            if (can || !enterAtoms && node.isAtom && node.isInline && pos >= $from.pos && pos + node.nodeSize <= $to.pos) return false;
            can = node.inlineContent && node.type.allowsMarkType(type);
        });
        if (can) return true;
    }
    return false;
}
function $79d38fafc7d67c3d$var$removeInlineAtoms(ranges) {
    let result = [];
    for(let i = 0; i < ranges.length; i++){
        let { $from: $from, $to: $to } = ranges[i];
        $from.doc.nodesBetween($from.pos, $to.pos, (node, pos)=>{
            if (node.isAtom && node.content.size && node.isInline && pos >= $from.pos && pos + node.nodeSize <= $to.pos) {
                if (pos + 1 > $from.pos) result.push(new (0, $ks2lK.SelectionRange)($from, $from.doc.resolve(pos + 1)));
                $from = $from.doc.resolve(pos + 1 + node.content.size);
                return false;
            }
        });
        if ($from.pos < $to.pos) result.push(new (0, $ks2lK.SelectionRange)($from, $to));
    }
    return result;
}
/**
Create a command function that toggles the given mark with the
given attributes. Will return `false` when the current selection
doesn't support that mark. This will remove the mark if any marks
of that type exist in the selection, or add it otherwise. If the
selection is empty, this applies to the [stored
marks](https://prosemirror.net/docs/ref/#state.EditorState.storedMarks) instead of a range of the
document.
*/ function $79d38fafc7d67c3d$export$797ad2667b8015a8(markType, attrs = null, options) {
    let removeWhenPresent = (options && options.removeWhenPresent) !== false;
    let enterAtoms = (options && options.enterInlineAtoms) !== false;
    return function(state, dispatch) {
        let { empty: empty, $cursor: $cursor, ranges: ranges } = state.selection;
        if (empty && !$cursor || !$79d38fafc7d67c3d$var$markApplies(state.doc, ranges, markType, enterAtoms)) return false;
        if (dispatch) {
            if ($cursor) {
                if (markType.isInSet(state.storedMarks || $cursor.marks())) dispatch(state.tr.removeStoredMark(markType));
                else dispatch(state.tr.addStoredMark(markType.create(attrs)));
            } else {
                let add, tr = state.tr;
                if (!enterAtoms) ranges = $79d38fafc7d67c3d$var$removeInlineAtoms(ranges);
                if (removeWhenPresent) add = !ranges.some((r)=>state.doc.rangeHasMark(r.$from.pos, r.$to.pos, markType));
                else add = !ranges.every((r)=>{
                    let missing = false;
                    tr.doc.nodesBetween(r.$from.pos, r.$to.pos, (node, pos, parent)=>{
                        if (missing) return false;
                        missing = !markType.isInSet(node.marks) && !!parent && parent.type.allowsMarkType(markType) && !(node.isText && /^\s*$/.test(node.textBetween(Math.max(0, r.$from.pos - pos), Math.min(node.nodeSize, r.$to.pos - pos))));
                    });
                    return !missing;
                });
                for(let i = 0; i < ranges.length; i++){
                    let { $from: $from, $to: $to } = ranges[i];
                    if (!add) tr.removeMark($from.pos, $to.pos, markType);
                    else {
                        let from = $from.pos, to = $to.pos, start = $from.nodeAfter, end = $to.nodeBefore;
                        let spaceStart = start && start.isText ? /^\s*/.exec(start.text)[0].length : 0;
                        let spaceEnd = end && end.isText ? /\s*$/.exec(end.text)[0].length : 0;
                        if (from + spaceStart < to) {
                            from += spaceStart;
                            to -= spaceEnd;
                        }
                        tr.addMark(from, to, markType.create(attrs));
                    }
                }
                dispatch(tr.scrollIntoView());
            }
        }
        return true;
    };
}
function $79d38fafc7d67c3d$var$wrapDispatchForJoin(dispatch, isJoinable) {
    return (tr)=>{
        if (!tr.isGeneric) return dispatch(tr);
        let ranges = [];
        for(let i = 0; i < tr.mapping.maps.length; i++){
            let map = tr.mapping.maps[i];
            for(let j = 0; j < ranges.length; j++)ranges[j] = map.map(ranges[j]);
            map.forEach((_s, _e, from, to)=>ranges.push(from, to));
        }
        // Figure out which joinable points exist inside those ranges,
        // by checking all node boundaries in their parent nodes.
        let joinable = [];
        for(let i = 0; i < ranges.length; i += 2){
            let from = ranges[i], to = ranges[i + 1];
            let $from = tr.doc.resolve(from), depth = $from.sharedDepth(to), parent = $from.node(depth);
            for(let index = $from.indexAfter(depth), pos = $from.after(depth + 1); pos <= to; ++index){
                let after = parent.maybeChild(index);
                if (!after) break;
                if (index && joinable.indexOf(pos) == -1) {
                    let before = parent.child(index - 1);
                    if (before.type == after.type && isJoinable(before, after)) joinable.push(pos);
                }
                pos += after.nodeSize;
            }
        }
        // Join the joinable points
        joinable.sort((a, b)=>a - b);
        for(let i = joinable.length - 1; i >= 0; i--)if ((0, $aXG5V.canJoin)(tr.doc, joinable[i])) tr.join(joinable[i]);
        dispatch(tr);
    };
}
/**
Wrap a command so that, when it produces a transform that causes
two joinable nodes to end up next to each other, those are joined.
Nodes are considered joinable when they are of the same type and
when the `isJoinable` predicate returns true for them or, if an
array of strings was passed, if their node type name is in that
array.
*/ function $79d38fafc7d67c3d$export$29903073afddcd8b(command, isJoinable) {
    let canJoin = Array.isArray(isJoinable) ? (node)=>isJoinable.indexOf(node.type.name) > -1 : isJoinable;
    return (state, dispatch, view)=>command(state, dispatch && $79d38fafc7d67c3d$var$wrapDispatchForJoin(dispatch, canJoin), view);
}
/**
Combine a number of command functions into a single function (which
calls them one by one until one returns true).
*/ function $79d38fafc7d67c3d$export$146a774cdef7663a(...commands) {
    return function(state, dispatch, view) {
        for(let i = 0; i < commands.length; i++)if (commands[i](state, dispatch, view)) return true;
        return false;
    };
}
let $79d38fafc7d67c3d$var$backspace = $79d38fafc7d67c3d$export$146a774cdef7663a($79d38fafc7d67c3d$export$e9a518a637d1e641, $79d38fafc7d67c3d$export$979097b097459299, $79d38fafc7d67c3d$export$52b8a4af68d19794);
let $79d38fafc7d67c3d$var$del = $79d38fafc7d67c3d$export$146a774cdef7663a($79d38fafc7d67c3d$export$e9a518a637d1e641, $79d38fafc7d67c3d$export$bf432e340007f9ef, $79d38fafc7d67c3d$export$5835b52680b80cfd);
/**
A basic keymap containing bindings not specific to any schema.
Binds the following keys (when multiple commands are listed, they
are chained with [`chainCommands`](https://prosemirror.net/docs/ref/#commands.chainCommands)):

* **Enter** to `newlineInCode`, `createParagraphNear`, `liftEmptyBlock`, `splitBlock`
* **Mod-Enter** to `exitCode`
* **Backspace** and **Mod-Backspace** to `deleteSelection`, `joinBackward`, `selectNodeBackward`
* **Delete** and **Mod-Delete** to `deleteSelection`, `joinForward`, `selectNodeForward`
* **Mod-Delete** to `deleteSelection`, `joinForward`, `selectNodeForward`
* **Mod-a** to `selectAll`
*/ const $79d38fafc7d67c3d$export$eb36e8971b04df36 = {
    "Enter": $79d38fafc7d67c3d$export$146a774cdef7663a($79d38fafc7d67c3d$export$a5d02b4b65e94f91, $79d38fafc7d67c3d$export$d0f80ac1b4510888, $79d38fafc7d67c3d$export$a3574cc681852c08, $79d38fafc7d67c3d$export$e99155638ff4dff0),
    "Mod-Enter": $79d38fafc7d67c3d$export$634b78845598ff5b,
    "Backspace": $79d38fafc7d67c3d$var$backspace,
    "Mod-Backspace": $79d38fafc7d67c3d$var$backspace,
    "Shift-Backspace": $79d38fafc7d67c3d$var$backspace,
    "Delete": $79d38fafc7d67c3d$var$del,
    "Mod-Delete": $79d38fafc7d67c3d$var$del,
    "Mod-a": $79d38fafc7d67c3d$export$90aca4adda6ff0f5
};
/**
A copy of `pcBaseKeymap` that also binds **Ctrl-h** like Backspace,
**Ctrl-d** like Delete, **Alt-Backspace** like Ctrl-Backspace, and
**Ctrl-Alt-Backspace**, **Alt-Delete**, and **Alt-d** like
Ctrl-Delete.
*/ const $79d38fafc7d67c3d$export$f292ad8dbd5063c8 = {
    "Ctrl-h": $79d38fafc7d67c3d$export$eb36e8971b04df36["Backspace"],
    "Alt-Backspace": $79d38fafc7d67c3d$export$eb36e8971b04df36["Mod-Backspace"],
    "Ctrl-d": $79d38fafc7d67c3d$export$eb36e8971b04df36["Delete"],
    "Ctrl-Alt-Backspace": $79d38fafc7d67c3d$export$eb36e8971b04df36["Mod-Delete"],
    "Alt-Delete": $79d38fafc7d67c3d$export$eb36e8971b04df36["Mod-Delete"],
    "Alt-d": $79d38fafc7d67c3d$export$eb36e8971b04df36["Mod-Delete"],
    "Ctrl-a": $79d38fafc7d67c3d$export$c3a64f3c9604a1b1,
    "Ctrl-e": $79d38fafc7d67c3d$export$a66c1876556415e5
};
for(let key in $79d38fafc7d67c3d$export$eb36e8971b04df36)$79d38fafc7d67c3d$export$f292ad8dbd5063c8[key] = $79d38fafc7d67c3d$export$eb36e8971b04df36[key];
const $79d38fafc7d67c3d$var$mac = typeof navigator != "undefined" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : typeof os != "undefined" && os.platform ? os.platform() == "darwin" : false;
/**
Depending on the detected platform, this will hold
[`pcBasekeymap`](https://prosemirror.net/docs/ref/#commands.pcBaseKeymap) or
[`macBaseKeymap`](https://prosemirror.net/docs/ref/#commands.macBaseKeymap).
*/ const $79d38fafc7d67c3d$export$4a0c2b85b1f0a889 = $79d38fafc7d67c3d$var$mac ? $79d38fafc7d67c3d$export$f292ad8dbd5063c8 : $79d38fafc7d67c3d$export$eb36e8971b04df36;
module.exports["deleteSelection"] = $79d38fafc7d67c3d$export$e9a518a637d1e641;
module.exports["selectNodeBackward"] = $79d38fafc7d67c3d$export$52b8a4af68d19794;
module.exports["exitCode"] = $79d38fafc7d67c3d$export$634b78845598ff5b;
module.exports["createParagraphNear"] = $79d38fafc7d67c3d$export$d0f80ac1b4510888;
module.exports["splitBlock"] = $79d38fafc7d67c3d$export$e99155638ff4dff0;
module.exports["selectAll"] = $79d38fafc7d67c3d$export$90aca4adda6ff0f5;
module.exports["toggleMark"] = $79d38fafc7d67c3d$export$797ad2667b8015a8;
module.exports["autoJoin"] = $79d38fafc7d67c3d$export$29903073afddcd8b;
module.exports["chainCommands"] = $79d38fafc7d67c3d$export$146a774cdef7663a;
module.exports["baseKeymap"] = $79d38fafc7d67c3d$export$4a0c2b85b1f0a889;

});

parcelRegister("8Yfbq", function(module, exports) {

var $jSnXV = parcelRequire("jSnXV");


var $lc9ud = parcelRequire("lc9ud");

/** Error message constants. */ var $687fb4659a5afde2$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $687fb4659a5afde2$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError($687fb4659a5afde2$var$FUNC_ERROR_TEXT);
    if ($lc9ud(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return $jSnXV(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
module.exports = $687fb4659a5afde2$var$throttle;

});

parcelRegister("fDGbV", function(module, exports) {
const $fdb0bbe11c94f00f$export$36acad525b1fb57b = (dimensions = {
    width: '100%',
    height: '100%'
})=>{
    return {
        height: typeof dimensions.height === 'number' ? `${dimensions.height}px` : dimensions.height,
        width: typeof dimensions.width === 'number' ? `${dimensions.width}px` : dimensions.width
    };
};
module.exports["getDimensionsWithDefault"] = $fdb0bbe11c94f00f$export$36acad525b1fb57b;

});

parcelRegister("Girkv", function(module, exports) {
const $89e375f5fe352748$var$mediaBlobUrlIdentifier = 'media-blob-url';
const $89e375f5fe352748$export$e1e8ad57ada2d90 = (url)=>{
    return url.indexOf(`${$89e375f5fe352748$var$mediaBlobUrlIdentifier}=true`) > -1;
};
const $89e375f5fe352748$var$getNumberFromParams = (params, name)=>{
    const value = params.get(name);
    return typeof value === 'string' && !isNaN(parseInt(value)) ? parseInt(value) : undefined;
};
const $89e375f5fe352748$var$getStringFromParams = (params, name)=>{
    const value = params.get(name);
    if (!value) return;
    return decodeURIComponent(value);
};
const $89e375f5fe352748$export$b91a9e94ff0cbb29 = (blobUrl)=>{
    const url = new URL(blobUrl);
    const hash = url.hash.replace('#', '');
    const params = new URLSearchParams(hash);
    const id = params.get('id');
    const contextId = params.get('contextId');
    // check if we have the required params
    if (!id || !contextId) return;
    return {
        id: id,
        contextId: contextId,
        collection: $89e375f5fe352748$var$getStringFromParams(params, 'collection'),
        alt: $89e375f5fe352748$var$getStringFromParams(params, 'alt'),
        height: $89e375f5fe352748$var$getNumberFromParams(params, 'height'),
        width: $89e375f5fe352748$var$getNumberFromParams(params, 'width'),
        size: $89e375f5fe352748$var$getNumberFromParams(params, 'size'),
        name: $89e375f5fe352748$var$getStringFromParams(params, 'name'),
        mimeType: $89e375f5fe352748$var$getStringFromParams(params, 'mimeType')
    };
};
const $89e375f5fe352748$export$89a7e74069fbb7af = (json)=>{
    return Object.keys(json).filter((attrName)=>typeof json[attrName] !== 'undefined' && json[attrName] !== null).map((key)=>{
        const value = json[key];
        if (typeof value === 'undefined' || value === null) return;
        return `${encodeURIComponent(key)}=${encodeURIComponent(value.toString())}`;
    }).join('&');
};
const $89e375f5fe352748$export$e51a8146182600b8 = (url, fileAttrs)=>{
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (isSafari) return url;
    const mediaIdentifierAttr = {
        [$89e375f5fe352748$var$mediaBlobUrlIdentifier]: 'true'
    };
    const mergedAttrs = {
        ...mediaIdentifierAttr,
        ...fileAttrs
    };
    const queryAttrs = $89e375f5fe352748$export$89a7e74069fbb7af(mergedAttrs);
    // we can't use '?' separator for blob url params
    return `${url}#${queryAttrs}`;
};
module.exports["isMediaBlobUrl"] = $89e375f5fe352748$export$e1e8ad57ada2d90;
module.exports["getAttrsFromUrl"] = $89e375f5fe352748$export$b91a9e94ff0cbb29;
module.exports["addFileAttrsToUrl"] = $89e375f5fe352748$export$e51a8146182600b8;

});

parcelRegister("8jrlU", function(module, exports) {
const $dba4e4fdcb4b1deb$export$c5ba918dbb0b00f3 = 'new-file-experience-wrapper';
module.exports["newFileExperienceClassName"] = $dba4e4fdcb4b1deb$export$c5ba918dbb0b00f3;

});

parcelRegister("8Doca", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $f6eec6bbba6041ad$export$3a0bcc6ff2e20f36 = (Wrapped)=>{
    class WithImageLoader extends (0, $42omo.Component) {
        /**
   *
   * @example
   */ componentDidMount() {
            this.fetchImage(this.props);
        }
        /**
   *
   * @param nextProps
   * @example
   */ // Ignored via go/ees005
        // eslint-disable-next-line react/no-unsafe
        UNSAFE_componentWillReceiveProps(nextProps) {
            if (nextProps.url !== this.props.url) {
                this.setState({
                    imageStatus: 'loading'
                });
                this.fetchImage(nextProps);
            }
        }
        /**
   *
   * @example
   */ componentWillUnmount() {
            if (this.img) {
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.img.removeEventListener('load', this.onLoad);
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.img.removeEventListener('error', this.onError);
                this.img = null;
            }
        }
        /**
   *
   * @param root0
   * @param root0.url
   * @example
   */ fetchImage({ url: url }) {
            if (url) {
                if (!this.img) {
                    this.img = new Image();
                    // Ignored via go/ees005
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    this.img.addEventListener('load', this.onLoad);
                    // Ignored via go/ees005
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    this.img.addEventListener('error', this.onError);
                }
                this.img.src = url;
            }
        }
        /**
   *
   * @example
   */ render() {
            const { imageStatus: imageStatus } = this.state;
            // Ignored via go/ees005
            // eslint-disable-next-line react/jsx-props-no-spreading
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Wrapped, {
                ...this.props,
                imageStatus: imageStatus
            });
        }
        constructor(...args){
            super(...args);
            this.state = {
                imageStatus: 'loading'
            };
            this.img = void 0;
            this.onLoad = ()=>{
                this.setState({
                    imageStatus: 'complete'
                });
                const { onExternalImageLoaded: onExternalImageLoaded } = this.props;
                if (onExternalImageLoaded && this.img) onExternalImageLoaded({
                    width: this.img.naturalWidth,
                    height: this.img.naturalHeight
                });
            };
            this.onError = ()=>{
                this.setState({
                    imageStatus: 'error'
                });
            };
        }
    }
    return WithImageLoader;
};
const $f6eec6bbba6041ad$var$withImageLoaderNew = (Wrapped)=>{
    class WithImageLoader extends (0, $42omo.Component) {
        componentDidMount() {
            this.fetchImage(this.props);
        }
        componentDidUpdate(newProps) {
            if (newProps.url !== this.props.url) {
                this.setState({
                    imageStatus: 'loading'
                });
                this.fetchImage(newProps);
            }
        }
        componentWillUnmount() {
            if (this.img) {
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.img.removeEventListener('load', this.onLoad);
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.img.removeEventListener('error', this.onError);
                this.img = null;
            }
        }
        fetchImage({ url: url }) {
            if (url) {
                if (!this.img) {
                    this.img = new Image();
                    // Ignored via go/ees005
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    this.img.addEventListener('load', this.onLoad);
                    // Ignored via go/ees005
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    this.img.addEventListener('error', this.onError);
                }
                this.img.src = url;
            }
        }
        render() {
            const { imageStatus: imageStatus } = this.state;
            // Ignored via go/ees005
            // eslint-disable-next-line react/jsx-props-no-spreading
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Wrapped, {
                ...this.props,
                imageStatus: imageStatus
            });
        }
        constructor(...args){
            super(...args);
            this.state = {
                imageStatus: 'loading'
            };
            this.img = void 0;
            this.onLoad = ()=>{
                this.setState({
                    imageStatus: 'complete'
                });
                const { onExternalImageLoaded: onExternalImageLoaded } = this.props;
                if (onExternalImageLoaded && this.img) onExternalImageLoaded({
                    width: this.img.naturalWidth,
                    height: this.img.naturalHeight
                });
            };
            this.onError = ()=>{
                this.setState({
                    imageStatus: 'error'
                });
            };
        }
    }
    return WithImageLoader;
};
const $f6eec6bbba6041ad$export$9b0f795b2e33f057 = (Wrapped)=>{
    return $f6eec6bbba6041ad$var$withImageLoaderNew(Wrapped);
};
module.exports["withImageLoader"] = $f6eec6bbba6041ad$export$9b0f795b2e33f057;

});

parcelRegister("bqMS3", function(module, exports) {

var $dwp40 = parcelRequire("dwp40");


var $6mYMS = parcelRequire("6mYMS");


var $jaPjp = parcelRequire("jaPjp");


var $3jsXx = parcelRequire("3jsXx");


var $jSnXV = parcelRequire("jSnXV");

const $298721003a2aaba7$var$MAX_QUERY_ITEMS = 100;
const $298721003a2aaba7$var$MAX_NOTIFIED_ITEMS = 20;
const $298721003a2aaba7$var$emptySecurityProvider = ()=>{
    return {
        params: {},
        headers: {}
    };
};
class $298721003a2aaba7$export$4529f10aed0950d4 {
    subscribe(key, callback, errCallback, infoCallback, allResultsCallback, analyticsListeners) {
        if (callback) this.changeListeners.set(key, callback);
        if (errCallback) this.errListeners.set(key, errCallback);
        if (infoCallback) this.infoListeners.set(key, infoCallback);
        if (allResultsCallback) this.allResultsListeners.set(key, allResultsCallback);
        if (analyticsListeners) this.analyticsListeners.set(key, analyticsListeners);
    }
    unsubscribe(key) {
        this.changeListeners.delete(key);
        this.errListeners.delete(key);
        this.infoListeners.delete(key);
        this.allResultsListeners.delete(key);
        this.analyticsListeners.delete(key);
    }
    constructor(){
        this.changeListeners = void 0;
        this.errListeners = void 0;
        this.infoListeners = void 0;
        this.allResultsListeners = void 0;
        this.analyticsListeners = void 0;
        this.changeListeners = new Map();
        this.allResultsListeners = new Map();
        this.errListeners = new Map();
        this.infoListeners = new Map();
        this.analyticsListeners = new Map();
    }
}
class $298721003a2aaba7$export$8576ba1ed2760927 extends $298721003a2aaba7$export$4529f10aed0950d4 {
    shouldHighlightMention(_mention) {
        return false;
    }
    // eslint-disable-next-line class-methods-use-this
    filter(query) {
        throw new Error(`not yet implemented.\nParams: query=${query}`);
    }
    // eslint-disable-next-line class-methods-use-this, no-unused-vars
    recordMentionSelection(_mention) {
    // Do nothing
    }
    isFiltering(_query) {
        return false;
    }
    _notifyListeners(mentionsResult, stats) {
        (0, $jaPjp.default)('ak-mention-resource._notifyListeners', mentionsResult && mentionsResult.mentions && mentionsResult.mentions.length, this.changeListeners);
        this.changeListeners.forEach((listener, key)=>{
            try {
                listener(mentionsResult.mentions.slice(0, $298721003a2aaba7$var$MAX_NOTIFIED_ITEMS), mentionsResult.query, stats);
            } catch (e) {
                // ignore error from listener
                (0, $jaPjp.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyAllResultsListeners(mentionsResult) {
        (0, $jaPjp.default)('ak-mention-resource._notifyAllResultsListeners', mentionsResult && mentionsResult.mentions && mentionsResult.mentions.length, this.changeListeners);
        this.allResultsListeners.forEach((listener, key)=>{
            try {
                listener(mentionsResult.mentions.slice(0, $298721003a2aaba7$var$MAX_NOTIFIED_ITEMS), mentionsResult.query);
            } catch (e) {
                // ignore error from listener
                (0, $jaPjp.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyErrorListeners(error, query) {
        this.errListeners.forEach((listener, key)=>{
            try {
                listener(error, query);
            } catch (e) {
                // ignore error from listener
                (0, $jaPjp.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyInfoListeners(info) {
        this.infoListeners.forEach((listener, key)=>{
            try {
                listener(info);
            } catch (e) {
                // ignore error fromr listener
                (0, $jaPjp.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyAnalyticsListeners(event, actionSubject, action, attributes) {
        this.analyticsListeners.forEach((listener, key)=>{
            try {
                listener(event, actionSubject, action, attributes);
            } catch (e) {
                // ignore error from listener
                (0, $jaPjp.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
}
class $298721003a2aaba7$export$5a4331e3e1c43553 extends $298721003a2aaba7$export$8576ba1ed2760927 {
    shouldHighlightMention(mention) {
        if (this.config.shouldHighlightMention) return this.config.shouldHighlightMention(mention);
        return false;
    }
    notify(searchTime, mentionResult, query) {
        if (searchTime > this.lastReturnedSearch) {
            this.lastReturnedSearch = searchTime;
            this._notifyListeners(mentionResult, {
                duration: Date.now() - searchTime
            });
        } else {
            const date = new Date(searchTime).toISOString().substr(17, 6);
            (0, $jaPjp.default)('Stale search result, skipping', date, query); // eslint-disable-line no-console, max-len
        }
        this._notifyAllResultsListeners(mentionResult);
    }
    notifyError(error, query) {
        this._notifyErrorListeners(error, query);
        if (query) this.activeSearches.delete(query);
    }
    async filter(query, contextIdentifier) {
        try {
            const searchTime = Date.now();
            let results;
            if (!query) results = await this.initialState(contextIdentifier);
            else {
                this.activeSearches.add(query);
                const searchResponse = this.search(query, contextIdentifier);
                results = await searchResponse.mentions;
            }
            this.notify(searchTime, results, query);
        } catch (error) {
            this.notifyError(error, query);
        }
    }
    isFiltering(query) {
        return this.activeSearches.has(query);
    }
    resolveMentionName(id) {
        if (!this.config.mentionNameResolver) return {
            id: id,
            name: '',
            status: (0, $6mYMS.MentionNameStatus).UNKNOWN
        };
        return this.config.mentionNameResolver.lookupName(id);
    }
    cacheMentionName(id, mentionName) {
        if (!this.config.mentionNameResolver) return;
        this.config.mentionNameResolver.cacheName(id, mentionName);
    }
    supportsMentionNameResolving() {
        return !!this.config.mentionNameResolver;
    }
    updateActiveSearches(query) {
        this.activeSearches.add(query);
    }
    verifyMentionConfig(config) {
        if (!config.url) throw new Error('config.url is a required parameter');
        if (!config.securityProvider) config.securityProvider = $298721003a2aaba7$var$emptySecurityProvider;
    }
    initialState(contextIdentifier) {
        return this.remoteInitialState(contextIdentifier);
    }
    /**
   * Clear a context object to generate query params by removing empty
   * strings, `undefined` and empty values.
   *
   * @param contextIdentifier the current context identifier
   * @returns a safe context for query encoding
   */ clearContext(contextIdentifier = {}) {
        return Object.keys(contextIdentifier).filter((key)=>contextIdentifier[key]).reduce((context, key)=>({
                [key]: contextIdentifier[key],
                ...context
            }), {});
    }
    getQueryParams(contextIdentifier) {
        const configParams = {};
        if (this.config.containerId) configParams['containerId'] = this.config.containerId;
        if (this.config.productId) configParams['productIdentifier'] = this.config.productId;
        // if contextParams exist then it will override configParams for containerId
        return {
            ...configParams,
            ...this.clearContext(contextIdentifier)
        };
    }
    /**
   * Returns the initial mention display list before a search is performed for the specified
   * container.
   *
   * @param contextIdentifier
   * @returns Promise
   */ async remoteInitialState(contextIdentifier) {
        const queryParams = this.getQueryParams(contextIdentifier);
        const options = {
            path: 'bootstrap',
            queryParams: queryParams
        };
        try {
            const result = await (0, $dwp40.utils).requestService(this.config, options);
            this._notifyAnalyticsListeners((0, $3jsXx.SLI_EVENT_TYPE), (0, $6mYMS.SliNames).INITIAL_STATE, (0, $6mYMS.Actions).SUCCEEDED);
            return this.transformServiceResponse(result, '');
        } catch (error) {
            this._notifyAnalyticsListeners((0, $3jsXx.SLI_EVENT_TYPE), (0, $6mYMS.SliNames).INITIAL_STATE, (0, $6mYMS.Actions).FAILED);
            throw error;
        }
    }
    search(query, contextIdentifier) {
        return {
            mentions: this.remoteSearch(query, contextIdentifier)
        };
    }
    async remoteSearch(query, contextIdentifier) {
        const options = {
            path: 'search',
            queryParams: {
                query: query,
                limit: $298721003a2aaba7$var$MAX_QUERY_ITEMS,
                ...this.getQueryParams(contextIdentifier)
            }
        };
        try {
            const result = await (0, $dwp40.utils).requestService(this.config, options);
            this._notifyAnalyticsListeners((0, $3jsXx.SLI_EVENT_TYPE), (0, $6mYMS.SliNames).SEARCH, (0, $6mYMS.Actions).SUCCEEDED);
            return this.transformServiceResponse(result, query);
        } catch (error) {
            this._notifyAnalyticsListeners((0, $3jsXx.SLI_EVENT_TYPE), (0, $6mYMS.SliNames).SEARCH, (0, $6mYMS.Actions).FAILED);
            throw error;
        }
    }
    transformServiceResponse(result, query) {
        const mentions = result.mentions.map((mention)=>{
            let lozenge;
            if ((0, $6mYMS.isAppMention)(mention)) lozenge = mention.userType;
            else if ((0, $6mYMS.isTeamMention)(mention)) lozenge = mention.userType;
            return {
                ...mention,
                lozenge: lozenge,
                query: query
            };
        });
        return {
            ...result,
            mentions: mentions,
            query: result.query || query
        };
    }
    constructor(config){
        super();
        this.config = void 0;
        this.lastReturnedSearch = void 0;
        this.activeSearches = void 0;
        this.productName = void 0;
        this.shouldEnableInvite = void 0;
        this.userRole = void 0;
        this.onInviteItemClick = void 0;
        this.inviteXProductUser = void 0;
        this.verifyMentionConfig(config);
        this.config = config;
        this.lastReturnedSearch = 0;
        this.activeSearches = new Set();
        this.productName = config.productName;
        this.shouldEnableInvite = !!config.shouldEnableInvite;
        this.onInviteItemClick = config.onInviteItemClick;
        this.inviteXProductUser = config.inviteXProductUser;
        this.userRole = config.userRole || 'basic';
        if (this.config.debounceTime) this.filter = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(this.filter, this.config.debounceTime);
    }
}
class $298721003a2aaba7$export$65bd6083489bd8bb {
    constructor(statusCode, statusMessage){
        this.name = void 0;
        this.message = void 0;
        this.statusCode = void 0;
        this.stack = void 0;
        this.statusCode = statusCode;
        this.message = statusMessage;
        this.name = 'HttpError';
        this.stack = new Error().stack;
    }
}
const $298721003a2aaba7$export$ae1fce5f69858ef3 = (p)=>!!(p && p.supportsMentionNameResolving && p.supportsMentionNameResolving());
var $298721003a2aaba7$export$2e2bcd8739ae039 = $298721003a2aaba7$export$5a4331e3e1c43553;
module.exports["AbstractResource"] = $298721003a2aaba7$export$4529f10aed0950d4;
module.exports["AbstractMentionResource"] = $298721003a2aaba7$export$8576ba1ed2760927;
module.exports["isResolvingMentionProvider"] = $298721003a2aaba7$export$ae1fce5f69858ef3;
module.exports["default"] = $298721003a2aaba7$export$2e2bcd8739ae039;

});

parcelRegister("6mYMS", function(module, exports) {
var $4e350b6bba0e5c59$export$2102863a3c660c6b = /*#__PURE__*/ function(MentionType) {
    MentionType[MentionType["SELF"] = 0] = "SELF";
    MentionType[MentionType["RESTRICTED"] = 1] = "RESTRICTED";
    MentionType[MentionType["DEFAULT"] = 2] = "DEFAULT";
    return MentionType;
}({});
var $4e350b6bba0e5c59$export$81124e6148ca5db0 = /*#__PURE__*/ function(UserAccessLevel) {
    UserAccessLevel[UserAccessLevel["NONE"] = 0] = "NONE";
    UserAccessLevel[UserAccessLevel["SITE"] = 1] = "SITE";
    UserAccessLevel[UserAccessLevel["APPLICATION"] = 2] = "APPLICATION";
    UserAccessLevel[UserAccessLevel["CONTAINER"] = 3] = "CONTAINER";
    return UserAccessLevel;
}({});
var $4e350b6bba0e5c59$export$8436e53e45ffe15b = /*#__PURE__*/ function(UserType) {
    UserType[UserType["DEFAULT"] = 0] = "DEFAULT";
    UserType[UserType["SPECIAL"] = 1] = "SPECIAL";
    UserType[UserType["APP"] = 2] = "APP";
    UserType[UserType["TEAM"] = 3] = "TEAM";
    UserType[UserType["SYSTEM"] = 4] = "SYSTEM";
    return UserType;
}({});
var $4e350b6bba0e5c59$export$7afb0727c7d7e8af = /*#__PURE__*/ function(SliNames) {
    SliNames["SEARCH"] = "searchUser";
    SliNames["SEARCH_TEAM"] = "searchTeam";
    SliNames["INITIAL_STATE"] = "initialState";
    SliNames["SELECT"] = "select";
    SliNames["SELECT_TEAM"] = "selectTeam";
    return SliNames;
}({});
var $4e350b6bba0e5c59$export$5c42d9dea6d035c1 = /*#__PURE__*/ function(ComponentNames) {
    ComponentNames["TYPEAHEAD"] = "mentionTypeahead";
    ComponentNames["MENTION"] = "mention";
    return ComponentNames;
}({});
var $4e350b6bba0e5c59$export$b52183d5cfb26dc9 = /*#__PURE__*/ function(Actions) {
    Actions["VIEWED"] = "viewed";
    Actions["CLICKED"] = "clicked";
    Actions["CLOSED"] = "closed";
    Actions["SUCCEEDED"] = "succeeded";
    Actions["FAILED"] = "failed";
    return Actions;
}({});
var $4e350b6bba0e5c59$export$b8fa67dc54502853 = /*#__PURE__*/ function(MentionNameStatus) {
    MentionNameStatus[MentionNameStatus["UNKNOWN"] = 0] = "UNKNOWN";
    MentionNameStatus[MentionNameStatus["SERVICE_ERROR"] = 1] = "SERVICE_ERROR";
    MentionNameStatus[MentionNameStatus["OK"] = 2] = "OK";
    return MentionNameStatus;
}({});
function $4e350b6bba0e5c59$export$dbaa15dc1820b89a(accessLevel) {
    return !!accessLevel && accessLevel === $4e350b6bba0e5c59$export$81124e6148ca5db0[0];
}
function $4e350b6bba0e5c59$export$37b8dcac6198c514(mention) {
    return !!mention.userType && mention.userType === $4e350b6bba0e5c59$export$8436e53e45ffe15b[1];
}
function $4e350b6bba0e5c59$export$eb590c844d13454c(mention) {
    return mention.userType && mention.userType === $4e350b6bba0e5c59$export$8436e53e45ffe15b[2];
}
function $4e350b6bba0e5c59$export$803b1379348dbfd5(mention) {
    return mention.userType && mention.userType === $4e350b6bba0e5c59$export$8436e53e45ffe15b[3];
}
function $4e350b6bba0e5c59$export$d13d4f976b36a397(mentionText) {
    return mentionText && (mentionText === '@all' || mentionText === '@here');
}
const $4e350b6bba0e5c59$export$4369c812aac99591 = (p)=>!!(p && p.then);
module.exports["MentionType"] = $4e350b6bba0e5c59$export$2102863a3c660c6b;
module.exports["UserAccessLevel"] = $4e350b6bba0e5c59$export$81124e6148ca5db0;
module.exports["UserType"] = $4e350b6bba0e5c59$export$8436e53e45ffe15b;
module.exports["SliNames"] = $4e350b6bba0e5c59$export$7afb0727c7d7e8af;
module.exports["ComponentNames"] = $4e350b6bba0e5c59$export$5c42d9dea6d035c1;
module.exports["Actions"] = $4e350b6bba0e5c59$export$b52183d5cfb26dc9;
module.exports["MentionNameStatus"] = $4e350b6bba0e5c59$export$b8fa67dc54502853;
module.exports["isRestricted"] = $4e350b6bba0e5c59$export$dbaa15dc1820b89a;
module.exports["isSpecialMention"] = $4e350b6bba0e5c59$export$37b8dcac6198c514;
module.exports["isAppMention"] = $4e350b6bba0e5c59$export$eb590c844d13454c;
module.exports["isTeamMention"] = $4e350b6bba0e5c59$export$803b1379348dbfd5;
module.exports["isSpecialMentionText"] = $4e350b6bba0e5c59$export$d13d4f976b36a397;
module.exports["isPromise"] = $4e350b6bba0e5c59$export$4369c812aac99591;

});

parcelRegister("jaPjp", function(module, exports) {
$parcel$export(module.exports, "default", () => $f7f0f11694d4a0f0$export$2e2bcd8739ae039);
let $f7f0f11694d4a0f0$var$debugEnabled = false;
let $f7f0f11694d4a0f0$var$stacktracesEnabled = false;
function $f7f0f11694d4a0f0$export$748ada60eaf985cc(enable) {
    $f7f0f11694d4a0f0$var$debugEnabled = enable;
}
function $f7f0f11694d4a0f0$export$4f7017086af31c25(enable) {
    $f7f0f11694d4a0f0$var$stacktracesEnabled = enable;
}
function $f7f0f11694d4a0f0$export$2a858f450a2f66d() {
    if ($f7f0f11694d4a0f0$var$stacktracesEnabled) // eslint-disable-next-line no-console
    console.log(new Error().stack);
}
function $f7f0f11694d4a0f0$export$2e2bcd8739ae039(msg, ...args) {
    if ($f7f0f11694d4a0f0$var$debugEnabled) // eslint-disable-next-line no-console
    console.log(msg, ...args);
}

});

parcelRegister("3jsXx", function(module, exports) {

var $7TH2w = parcelRequire("7TH2w");


var $ElsUb = parcelRequire("ElsUb");


var $6mYMS = parcelRequire("6mYMS");

const $43ca455672da960d$var$packageName = "platform-pkg";
const $43ca455672da960d$var$packageVersion = "0.0.0-use.local";
const $43ca455672da960d$export$245097525aef1262 = 'sli';
const $43ca455672da960d$export$c724588856bbfbcf = 'smart';
const $43ca455672da960d$export$a823474ae5cb9e9c = (props)=>(action, duration, userIds = [], query)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = {
                action: action,
                actionSubject: (0, $6mYMS.ComponentNames).TYPEAHEAD,
                attributes: {
                    packageName: $43ca455672da960d$var$packageName,
                    packageVersion: $43ca455672da960d$var$packageVersion,
                    componentName: (0, $6mYMS.ComponentNames).MENTION,
                    duration: Math.round(duration),
                    userIds: userIds,
                    queryLength: query ? query.length : 0
                },
                eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE)
            };
            const analyticsEvent = props.createAnalyticsEvent(eventPayload);
            analyticsEvent.fire((0, $ElsUb.ELEMENTS_CHANNEL));
        }
    };
const $43ca455672da960d$export$44902bc7b3f0b09f = (createEvent)=>(actionSubject, action, text, id, accessLevel)=>{
        const payload = {
            action: action,
            actionSubject: actionSubject,
            eventType: (0, $7TH2w.UI_EVENT_TYPE),
            attributes: {
                packageName: $43ca455672da960d$var$packageName,
                packageVersion: $43ca455672da960d$var$packageVersion,
                componentName: (0, $6mYMS.ComponentNames).MENTION,
                accessLevel: accessLevel,
                isSpecial: (0, $6mYMS.isSpecialMentionText)(text),
                userId: id
            }
        };
        const event = createEvent(payload);
        event.fire((0, $ElsUb.ELEMENTS_CHANNEL));
        return event;
    };
const $43ca455672da960d$export$c8b245b690e10169 = (props)=>(actionSubject, action)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = $43ca455672da960d$export$c357a2872628de7c(actionSubject, action);
            props.createAnalyticsEvent(eventPayload).fire((0, $ElsUb.ELEMENTS_CHANNEL));
        }
    };
const $43ca455672da960d$export$c357a2872628de7c = (actionSubject, action, attributes)=>{
    const eventPayload = {
        action: action,
        actionSubject: actionSubject,
        eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
        attributes: {
            packageName: $43ca455672da960d$var$packageName,
            packageVersion: $43ca455672da960d$var$packageVersion,
            componentName: (0, $6mYMS.ComponentNames).MENTION,
            ...attributes
        }
    };
    return eventPayload;
};
const $43ca455672da960d$export$91b2fa6a0fe06408 = (props)=>(action, userId, fromCache, duration)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = {
                action: action,
                actionSubject: (0, $6mYMS.ComponentNames).MENTION,
                actionSubjectId: 'hydration',
                attributes: {
                    packageName: $43ca455672da960d$var$packageName,
                    packageVersion: $43ca455672da960d$var$packageVersion,
                    componentName: (0, $6mYMS.ComponentNames).MENTION,
                    userId: userId,
                    fromCache: fromCache,
                    duration: Math.round(duration)
                },
                eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE)
            };
            const analyticsEvent = props.createAnalyticsEvent(eventPayload);
            analyticsEvent.fire((0, $ElsUb.ELEMENTS_CHANNEL));
        }
    };
// OLD Analytics
const $43ca455672da960d$var$MENTION_ANALYTICS_PREFIX = 'atlassian.fabric.mention';
const $43ca455672da960d$export$34ac71ce24cddec2 = (firePrivateAnalyticsEvent)=>(eventName, text, accessLevel)=>{
        if (firePrivateAnalyticsEvent) firePrivateAnalyticsEvent(`${$43ca455672da960d$var$MENTION_ANALYTICS_PREFIX}.${eventName}`, {
            accessLevel: accessLevel,
            isSpecial: (0, $6mYMS.isSpecialMentionText)(text)
        });
    };
module.exports["SLI_EVENT_TYPE"] = $43ca455672da960d$export$245097525aef1262;
module.exports["SMART_EVENT_TYPE"] = $43ca455672da960d$export$c724588856bbfbcf;
module.exports["fireAnalyticsMentionTypeaheadEvent"] = $43ca455672da960d$export$a823474ae5cb9e9c;
module.exports["fireAnalyticsMentionEvent"] = $43ca455672da960d$export$44902bc7b3f0b09f;
module.exports["fireSliAnalyticsEvent"] = $43ca455672da960d$export$c8b245b690e10169;
module.exports["fireAnalyticsMentionHydrationEvent"] = $43ca455672da960d$export$91b2fa6a0fe06408;

});

parcelRegister("ElsUb", function(module, exports) {
const $cc0765a5d08d319a$export$d821aa4c8afb384e = 'fabric-elements';
module.exports["ELEMENTS_CHANNEL"] = $cc0765a5d08d319a$export$d821aa4c8afb384e;

});

parcelRegister("bedQP", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $9JpPs = parcelRequire("9JpPs");

const $9aeacd26f36a9957$export$cf56d0f54cfcce4 = (featureFlagName, ComponentTrue, ComponentFalse)=>(0, $9JpPs.componentWithCondition)(()=>(0, $dh538.fg)(featureFlagName), ComponentTrue, ComponentFalse);
module.exports["componentWithFG"] = $9aeacd26f36a9957$export$cf56d0f54cfcce4;

});

parcelRegister("7HtfM", function(module, exports) {
$parcel$export(module.exports, "default", () => $59b33dafbf54dd0b$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $2U6f2 = parcelRequire("2U6f2");


var $bIrEX = parcelRequire("bIrEX");


var $b5utg = parcelRequire("b5utg");





var $52s3i = parcelRequire("52s3i");


var $jBv2F = parcelRequire("jBv2F");




function $5395425e245a8a7a$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b5utg.default)(1, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    return (0, $52s3i.default)(date).getTime() === (0, $jBv2F.default)(date).getTime();
}


function $59b33dafbf54dd0b$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $b5utg.default)(2, arguments);
    var dateLeft = (0, $egXhZ.default)(dirtyDateLeft);
    var dateRight = (0, $egXhZ.default)(dirtyDateRight);
    var sign = (0, $bIrEX.default)(dateLeft, dateRight);
    var difference = Math.abs((0, $2U6f2.default)(dateLeft, dateRight));
    var result;
    // Check for the difference of less than month
    if (difference < 1) result = 0;
    else {
        if (dateLeft.getMonth() === 1 && dateLeft.getDate() > 27) // This will check if the date is end of Feb and assign a higher end of month date
        // to compare it with Jan
        dateLeft.setDate(30);
        dateLeft.setMonth(dateLeft.getMonth() - sign * difference);
        // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
        // If so, result must be decreased by 1 in absolute value
        var isLastMonthNotFull = (0, $bIrEX.default)(dateLeft, dateRight) === -sign;
        // Check for cases of one full calendar month
        if ((0, $5395425e245a8a7a$export$2e2bcd8739ae039)((0, $egXhZ.default)(dirtyDateLeft)) && difference === 1 && (0, $bIrEX.default)(dirtyDateLeft, dateRight) === 1) isLastMonthNotFull = false;
        result = sign * (difference - Number(isLastMonthNotFull));
    }
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});

parcelRegister("2U6f2", function(module, exports) {
$parcel$export(module.exports, "default", () => $21d5a727b9d6b5f1$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $21d5a727b9d6b5f1$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $b5utg.default)(2, arguments);
    var dateLeft = (0, $egXhZ.default)(dirtyDateLeft);
    var dateRight = (0, $egXhZ.default)(dirtyDateRight);
    var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
    var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
}

});

parcelRegister("bIrEX", function(module, exports) {
$parcel$export(module.exports, "default", () => $8879425dbfc491c0$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $8879425dbfc491c0$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $b5utg.default)(2, arguments);
    var dateLeft = (0, $egXhZ.default)(dirtyDateLeft);
    var dateRight = (0, $egXhZ.default)(dirtyDateRight);
    var diff = dateLeft.getTime() - dateRight.getTime();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}

});

parcelRegister("52s3i", function(module, exports) {
$parcel$export(module.exports, "default", () => $3ab2e6405264a6ac$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $3ab2e6405264a6ac$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b5utg.default)(1, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("jBv2F", function(module, exports) {
$parcel$export(module.exports, "default", () => $e4598d57c80bb5c7$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $e4598d57c80bb5c7$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b5utg.default)(1, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("3KVX0", function(module, exports) {
/**
 * Fuse.js v6.6.2 - Lightweight fuzzy-search (http://fusejs.io)
 *
 * Copyright (c) 2022 Kiro Risk (http://kiro.me)
 * All Rights Reserved. Apache Software License 2.0
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 */ function $2bc29ecddddf3571$var$isArray(value) {
    return !Array.isArray ? $2bc29ecddddf3571$var$getTag(value) === '[object Array]' : Array.isArray(value);
}
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/baseToString.js
const $2bc29ecddddf3571$var$INFINITY = 1 / 0;
function $2bc29ecddddf3571$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    let result = value + '';
    return result == '0' && 1 / value == -$2bc29ecddddf3571$var$INFINITY ? '-0' : result;
}
function $2bc29ecddddf3571$var$toString(value) {
    return value == null ? '' : $2bc29ecddddf3571$var$baseToString(value);
}
function $2bc29ecddddf3571$var$isString(value) {
    return typeof value === 'string';
}
function $2bc29ecddddf3571$var$isNumber(value) {
    return typeof value === 'number';
}
// Adapted from: https://github.com/lodash/lodash/blob/master/isBoolean.js
function $2bc29ecddddf3571$var$isBoolean(value) {
    return value === true || value === false || $2bc29ecddddf3571$var$isObjectLike(value) && $2bc29ecddddf3571$var$getTag(value) == '[object Boolean]';
}
function $2bc29ecddddf3571$var$isObject(value) {
    return typeof value === 'object';
}
// Checks if `value` is object-like.
function $2bc29ecddddf3571$var$isObjectLike(value) {
    return $2bc29ecddddf3571$var$isObject(value) && value !== null;
}
function $2bc29ecddddf3571$var$isDefined(value) {
    return value !== undefined && value !== null;
}
function $2bc29ecddddf3571$var$isBlank(value) {
    return !value.trim().length;
}
// Gets the `toStringTag` of `value`.
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/getTag.js
function $2bc29ecddddf3571$var$getTag(value) {
    return value == null ? value === undefined ? '[object Undefined]' : '[object Null]' : Object.prototype.toString.call(value);
}
const $2bc29ecddddf3571$var$EXTENDED_SEARCH_UNAVAILABLE = 'Extended search is not available';
const $2bc29ecddddf3571$var$INCORRECT_INDEX_TYPE = "Incorrect 'index' type";
const $2bc29ecddddf3571$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY = (key)=>`Invalid value for key ${key}`;
const $2bc29ecddddf3571$var$PATTERN_LENGTH_TOO_LARGE = (max)=>`Pattern length exceeds max of ${max}.`;
const $2bc29ecddddf3571$var$MISSING_KEY_PROPERTY = (name)=>`Missing ${name} property in key`;
const $2bc29ecddddf3571$var$INVALID_KEY_WEIGHT_VALUE = (key)=>`Property 'weight' in key '${key}' must be a positive integer`;
const $2bc29ecddddf3571$var$hasOwn = Object.prototype.hasOwnProperty;
class $2bc29ecddddf3571$var$KeyStore {
    get(keyId) {
        return this._keyMap[keyId];
    }
    keys() {
        return this._keys;
    }
    toJSON() {
        return JSON.stringify(this._keys);
    }
    constructor(keys){
        this._keys = [];
        this._keyMap = {};
        let totalWeight = 0;
        keys.forEach((key)=>{
            let obj = $2bc29ecddddf3571$var$createKey(key);
            totalWeight += obj.weight;
            this._keys.push(obj);
            this._keyMap[obj.id] = obj;
            totalWeight += obj.weight;
        });
        // Normalize weights so that their sum is equal to 1
        this._keys.forEach((key)=>{
            key.weight /= totalWeight;
        });
    }
}
function $2bc29ecddddf3571$var$createKey(key) {
    let path = null;
    let id = null;
    let src = null;
    let weight = 1;
    let getFn = null;
    if ($2bc29ecddddf3571$var$isString(key) || $2bc29ecddddf3571$var$isArray(key)) {
        src = key;
        path = $2bc29ecddddf3571$var$createKeyPath(key);
        id = $2bc29ecddddf3571$var$createKeyId(key);
    } else {
        if (!$2bc29ecddddf3571$var$hasOwn.call(key, 'name')) throw new Error($2bc29ecddddf3571$var$MISSING_KEY_PROPERTY('name'));
        const name = key.name;
        src = name;
        if ($2bc29ecddddf3571$var$hasOwn.call(key, 'weight')) {
            weight = key.weight;
            if (weight <= 0) throw new Error($2bc29ecddddf3571$var$INVALID_KEY_WEIGHT_VALUE(name));
        }
        path = $2bc29ecddddf3571$var$createKeyPath(name);
        id = $2bc29ecddddf3571$var$createKeyId(name);
        getFn = key.getFn;
    }
    return {
        path: path,
        id: id,
        weight: weight,
        src: src,
        getFn: getFn
    };
}
function $2bc29ecddddf3571$var$createKeyPath(key) {
    return $2bc29ecddddf3571$var$isArray(key) ? key : key.split('.');
}
function $2bc29ecddddf3571$var$createKeyId(key) {
    return $2bc29ecddddf3571$var$isArray(key) ? key.join('.') : key;
}
function $2bc29ecddddf3571$var$get(obj, path) {
    let list = [];
    let arr = false;
    const deepGet = (obj, path, index)=>{
        if (!$2bc29ecddddf3571$var$isDefined(obj)) return;
        if (!path[index]) // If there's no path left, we've arrived at the object we care about.
        list.push(obj);
        else {
            let key = path[index];
            const value = obj[key];
            if (!$2bc29ecddddf3571$var$isDefined(value)) return;
            // If we're at the last value in the path, and if it's a string/number/bool,
            // add it to the list
            if (index === path.length - 1 && ($2bc29ecddddf3571$var$isString(value) || $2bc29ecddddf3571$var$isNumber(value) || $2bc29ecddddf3571$var$isBoolean(value))) list.push($2bc29ecddddf3571$var$toString(value));
            else if ($2bc29ecddddf3571$var$isArray(value)) {
                arr = true;
                // Search each item in the array.
                for(let i = 0, len = value.length; i < len; i += 1)deepGet(value[i], path, index + 1);
            } else if (path.length) // An object. Recurse further.
            deepGet(value, path, index + 1);
        }
    };
    // Backwards compatibility (since path used to be a string)
    deepGet(obj, $2bc29ecddddf3571$var$isString(path) ? path.split('.') : path, 0);
    return arr ? list : list[0];
}
const $2bc29ecddddf3571$var$MatchOptions = {
    // Whether the matches should be included in the result set. When `true`, each record in the result
    // set will include the indices of the matched characters.
    // These can consequently be used for highlighting purposes.
    includeMatches: false,
    // When `true`, the matching function will continue to the end of a search pattern even if
    // a perfect match has already been located in the string.
    findAllMatches: false,
    // Minimum number of characters that must be matched before a result is considered a match
    minMatchCharLength: 1
};
const $2bc29ecddddf3571$var$BasicOptions = {
    // When `true`, the algorithm continues searching to the end of the input even if a perfect
    // match is found before the end of the same input.
    isCaseSensitive: false,
    // When true, the matching function will continue to the end of a search pattern even if
    includeScore: false,
    // List of properties that will be searched. This also supports nested properties.
    keys: [],
    // Whether to sort the result list, by score
    shouldSort: true,
    // Default sort function: sort by ascending score, ascending index
    sortFn: (a, b)=>a.score === b.score ? a.idx < b.idx ? -1 : 1 : a.score < b.score ? -1 : 1
};
const $2bc29ecddddf3571$var$FuzzyOptions = {
    // Approximately where in the text is the pattern expected to be found?
    location: 0,
    // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match
    // (of both letters and location), a threshold of '1.0' would match anything.
    threshold: 0.6,
    // Determines how close the match must be to the fuzzy location (specified above).
    // An exact letter match which is 'distance' characters away from the fuzzy location
    // would score as a complete mismatch. A distance of '0' requires the match be at
    // the exact location specified, a threshold of '1000' would require a perfect match
    // to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
    distance: 100
};
const $2bc29ecddddf3571$var$AdvancedOptions = {
    // When `true`, it enables the use of unix-like search commands
    useExtendedSearch: false,
    // The get function to use when fetching an object's properties.
    // The default will search nested paths *ie foo.bar.baz*
    getFn: $2bc29ecddddf3571$var$get,
    // When `true`, search will ignore `location` and `distance`, so it won't matter
    // where in the string the pattern appears.
    // More info: https://fusejs.io/concepts/scoring-theory.html#fuzziness-score
    ignoreLocation: false,
    // When `true`, the calculation for the relevance score (used for sorting) will
    // ignore the field-length norm.
    // More info: https://fusejs.io/concepts/scoring-theory.html#field-length-norm
    ignoreFieldNorm: false,
    // The weight to determine how much field length norm effects scoring.
    fieldNormWeight: 1
};
var $2bc29ecddddf3571$var$Config = {
    ...$2bc29ecddddf3571$var$BasicOptions,
    ...$2bc29ecddddf3571$var$MatchOptions,
    ...$2bc29ecddddf3571$var$FuzzyOptions,
    ...$2bc29ecddddf3571$var$AdvancedOptions
};
const $2bc29ecddddf3571$var$SPACE = /[^ ]+/g;
// Field-length norm: the shorter the field, the higher the weight.
// Set to 3 decimals to reduce index size.
function $2bc29ecddddf3571$var$norm(weight = 1, mantissa = 3) {
    const cache = new Map();
    const m = Math.pow(10, mantissa);
    return {
        get (value) {
            const numTokens = value.match($2bc29ecddddf3571$var$SPACE).length;
            if (cache.has(numTokens)) return cache.get(numTokens);
            // Default function is 1/sqrt(x), weight makes that variable
            const norm = 1 / Math.pow(numTokens, 0.5 * weight);
            // In place of `toFixed(mantissa)`, for faster computation
            const n = parseFloat(Math.round(norm * m) / m);
            cache.set(numTokens, n);
            return n;
        },
        clear () {
            cache.clear();
        }
    };
}
class $2bc29ecddddf3571$var$FuseIndex {
    setSources(docs = []) {
        this.docs = docs;
    }
    setIndexRecords(records = []) {
        this.records = records;
    }
    setKeys(keys = []) {
        this.keys = keys;
        this._keysMap = {};
        keys.forEach((key, idx)=>{
            this._keysMap[key.id] = idx;
        });
    }
    create() {
        if (this.isCreated || !this.docs.length) return;
        this.isCreated = true;
        // List is Array<String>
        if ($2bc29ecddddf3571$var$isString(this.docs[0])) this.docs.forEach((doc, docIndex)=>{
            this._addString(doc, docIndex);
        });
        else // List is Array<Object>
        this.docs.forEach((doc, docIndex)=>{
            this._addObject(doc, docIndex);
        });
        this.norm.clear();
    }
    // Adds a doc to the end of the index
    add(doc) {
        const idx = this.size();
        if ($2bc29ecddddf3571$var$isString(doc)) this._addString(doc, idx);
        else this._addObject(doc, idx);
    }
    // Removes the doc at the specified index of the index
    removeAt(idx) {
        this.records.splice(idx, 1);
        // Change ref index of every subsquent doc
        for(let i = idx, len = this.size(); i < len; i += 1)this.records[i].i -= 1;
    }
    getValueForItemAtKeyId(item, keyId) {
        return item[this._keysMap[keyId]];
    }
    size() {
        return this.records.length;
    }
    _addString(doc, docIndex) {
        if (!$2bc29ecddddf3571$var$isDefined(doc) || $2bc29ecddddf3571$var$isBlank(doc)) return;
        let record = {
            v: doc,
            i: docIndex,
            n: this.norm.get(doc)
        };
        this.records.push(record);
    }
    _addObject(doc, docIndex) {
        let record = {
            i: docIndex,
            $: {}
        };
        // Iterate over every key (i.e, path), and fetch the value at that key
        this.keys.forEach((key, keyIndex)=>{
            let value = key.getFn ? key.getFn(doc) : this.getFn(doc, key.path);
            if (!$2bc29ecddddf3571$var$isDefined(value)) return;
            if ($2bc29ecddddf3571$var$isArray(value)) {
                let subRecords = [];
                const stack = [
                    {
                        nestedArrIndex: -1,
                        value: value
                    }
                ];
                while(stack.length){
                    const { nestedArrIndex: nestedArrIndex, value: value } = stack.pop();
                    if (!$2bc29ecddddf3571$var$isDefined(value)) continue;
                    if ($2bc29ecddddf3571$var$isString(value) && !$2bc29ecddddf3571$var$isBlank(value)) {
                        let subRecord = {
                            v: value,
                            i: nestedArrIndex,
                            n: this.norm.get(value)
                        };
                        subRecords.push(subRecord);
                    } else if ($2bc29ecddddf3571$var$isArray(value)) value.forEach((item, k)=>{
                        stack.push({
                            nestedArrIndex: k,
                            value: item
                        });
                    });
                }
                record.$[keyIndex] = subRecords;
            } else if ($2bc29ecddddf3571$var$isString(value) && !$2bc29ecddddf3571$var$isBlank(value)) {
                let subRecord = {
                    v: value,
                    n: this.norm.get(value)
                };
                record.$[keyIndex] = subRecord;
            }
        });
        this.records.push(record);
    }
    toJSON() {
        return {
            keys: this.keys,
            records: this.records
        };
    }
    constructor({ getFn: getFn = $2bc29ecddddf3571$var$Config.getFn, fieldNormWeight: fieldNormWeight = $2bc29ecddddf3571$var$Config.fieldNormWeight } = {}){
        this.norm = $2bc29ecddddf3571$var$norm(fieldNormWeight, 3);
        this.getFn = getFn;
        this.isCreated = false;
        this.setIndexRecords();
    }
}
function $2bc29ecddddf3571$var$createIndex(keys, docs, { getFn: getFn = $2bc29ecddddf3571$var$Config.getFn, fieldNormWeight: fieldNormWeight = $2bc29ecddddf3571$var$Config.fieldNormWeight } = {}) {
    const myIndex = new $2bc29ecddddf3571$var$FuseIndex({
        getFn: getFn,
        fieldNormWeight: fieldNormWeight
    });
    myIndex.setKeys(keys.map($2bc29ecddddf3571$var$createKey));
    myIndex.setSources(docs);
    myIndex.create();
    return myIndex;
}
function $2bc29ecddddf3571$var$parseIndex(data, { getFn: getFn = $2bc29ecddddf3571$var$Config.getFn, fieldNormWeight: fieldNormWeight = $2bc29ecddddf3571$var$Config.fieldNormWeight } = {}) {
    const { keys: keys, records: records } = data;
    const myIndex = new $2bc29ecddddf3571$var$FuseIndex({
        getFn: getFn,
        fieldNormWeight: fieldNormWeight
    });
    myIndex.setKeys(keys);
    myIndex.setIndexRecords(records);
    return myIndex;
}
function $2bc29ecddddf3571$var$computeScore$1(pattern, { errors: errors = 0, currentLocation: currentLocation = 0, expectedLocation: expectedLocation = 0, distance: distance = $2bc29ecddddf3571$var$Config.distance, ignoreLocation: ignoreLocation = $2bc29ecddddf3571$var$Config.ignoreLocation } = {}) {
    const accuracy = errors / pattern.length;
    if (ignoreLocation) return accuracy;
    const proximity = Math.abs(expectedLocation - currentLocation);
    if (!distance) // Dodge divide by zero error.
    return proximity ? 1.0 : accuracy;
    return accuracy + proximity / distance;
}
function $2bc29ecddddf3571$var$convertMaskToIndices(matchmask = [], minMatchCharLength = $2bc29ecddddf3571$var$Config.minMatchCharLength) {
    let indices = [];
    let start = -1;
    let end = -1;
    let i = 0;
    for(let len = matchmask.length; i < len; i += 1){
        let match = matchmask[i];
        if (match && start === -1) start = i;
        else if (!match && start !== -1) {
            end = i - 1;
            if (end - start + 1 >= minMatchCharLength) indices.push([
                start,
                end
            ]);
            start = -1;
        }
    }
    // (i-1 - start) + 1 => i - start
    if (matchmask[i - 1] && i - start >= minMatchCharLength) indices.push([
        start,
        i - 1
    ]);
    return indices;
}
// Machine word size
const $2bc29ecddddf3571$var$MAX_BITS = 32;
function $2bc29ecddddf3571$var$search(text, pattern, patternAlphabet, { location: location = $2bc29ecddddf3571$var$Config.location, distance: distance = $2bc29ecddddf3571$var$Config.distance, threshold: threshold = $2bc29ecddddf3571$var$Config.threshold, findAllMatches: findAllMatches = $2bc29ecddddf3571$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $2bc29ecddddf3571$var$Config.minMatchCharLength, includeMatches: includeMatches = $2bc29ecddddf3571$var$Config.includeMatches, ignoreLocation: ignoreLocation = $2bc29ecddddf3571$var$Config.ignoreLocation } = {}) {
    if (pattern.length > $2bc29ecddddf3571$var$MAX_BITS) throw new Error($2bc29ecddddf3571$var$PATTERN_LENGTH_TOO_LARGE($2bc29ecddddf3571$var$MAX_BITS));
    const patternLen = pattern.length;
    // Set starting location at beginning text and initialize the alphabet.
    const textLen = text.length;
    // Handle the case when location > text.length
    const expectedLocation = Math.max(0, Math.min(location, textLen));
    // Highest score beyond which we give up.
    let currentThreshold = threshold;
    // Is there a nearby exact match? (speedup)
    let bestLocation = expectedLocation;
    // Performance: only computer matches when the minMatchCharLength > 1
    // OR if `includeMatches` is true.
    const computeMatches = minMatchCharLength > 1 || includeMatches;
    // A mask of the matches, used for building the indices
    const matchMask = computeMatches ? Array(textLen) : [];
    let index;
    // Get all exact matches, here for speed up
    while((index = text.indexOf(pattern, bestLocation)) > -1){
        let score = $2bc29ecddddf3571$var$computeScore$1(pattern, {
            currentLocation: index,
            expectedLocation: expectedLocation,
            distance: distance,
            ignoreLocation: ignoreLocation
        });
        currentThreshold = Math.min(score, currentThreshold);
        bestLocation = index + patternLen;
        if (computeMatches) {
            let i = 0;
            while(i < patternLen){
                matchMask[index + i] = 1;
                i += 1;
            }
        }
    }
    // Reset the best location
    bestLocation = -1;
    let lastBitArr = [];
    let finalScore = 1;
    let binMax = patternLen + textLen;
    const mask = 1 << patternLen - 1;
    for(let i = 0; i < patternLen; i += 1){
        // Scan for the best match; each iteration allows for one more error.
        // Run a binary search to determine how far from the match location we can stray
        // at this error level.
        let binMin = 0;
        let binMid = binMax;
        while(binMin < binMid){
            const score = $2bc29ecddddf3571$var$computeScore$1(pattern, {
                errors: i,
                currentLocation: expectedLocation + binMid,
                expectedLocation: expectedLocation,
                distance: distance,
                ignoreLocation: ignoreLocation
            });
            if (score <= currentThreshold) binMin = binMid;
            else binMax = binMid;
            binMid = Math.floor((binMax - binMin) / 2 + binMin);
        }
        // Use the result from this iteration as the maximum for the next.
        binMax = binMid;
        let start = Math.max(1, expectedLocation - binMid + 1);
        let finish = findAllMatches ? textLen : Math.min(expectedLocation + binMid, textLen) + patternLen;
        // Initialize the bit array
        let bitArr = Array(finish + 2);
        bitArr[finish + 1] = (1 << i) - 1;
        for(let j = finish; j >= start; j -= 1){
            let currentLocation = j - 1;
            let charMatch = patternAlphabet[text.charAt(currentLocation)];
            if (computeMatches) // Speed up: quick bool to int conversion (i.e, `charMatch ? 1 : 0`)
            matchMask[currentLocation] = +!!charMatch;
            // First pass: exact match
            bitArr[j] = (bitArr[j + 1] << 1 | 1) & charMatch;
            // Subsequent passes: fuzzy match
            if (i) bitArr[j] |= (lastBitArr[j + 1] | lastBitArr[j]) << 1 | 1 | lastBitArr[j + 1];
            if (bitArr[j] & mask) {
                finalScore = $2bc29ecddddf3571$var$computeScore$1(pattern, {
                    errors: i,
                    currentLocation: currentLocation,
                    expectedLocation: expectedLocation,
                    distance: distance,
                    ignoreLocation: ignoreLocation
                });
                // This match will almost certainly be better than any existing match.
                // But check anyway.
                if (finalScore <= currentThreshold) {
                    // Indeed it is
                    currentThreshold = finalScore;
                    bestLocation = currentLocation;
                    // Already passed `loc`, downhill from here on in.
                    if (bestLocation <= expectedLocation) break;
                    // When passing `bestLocation`, don't exceed our current distance from `expectedLocation`.
                    start = Math.max(1, 2 * expectedLocation - bestLocation);
                }
            }
        }
        // No hope for a (better) match at greater error levels.
        const score = $2bc29ecddddf3571$var$computeScore$1(pattern, {
            errors: i + 1,
            currentLocation: expectedLocation,
            expectedLocation: expectedLocation,
            distance: distance,
            ignoreLocation: ignoreLocation
        });
        if (score > currentThreshold) break;
        lastBitArr = bitArr;
    }
    const result = {
        isMatch: bestLocation >= 0,
        // Count exact matches (those with a score of 0) to be "almost" exact
        score: Math.max(0.001, finalScore)
    };
    if (computeMatches) {
        const indices = $2bc29ecddddf3571$var$convertMaskToIndices(matchMask, minMatchCharLength);
        if (!indices.length) result.isMatch = false;
        else if (includeMatches) result.indices = indices;
    }
    return result;
}
function $2bc29ecddddf3571$var$createPatternAlphabet(pattern) {
    let mask = {};
    for(let i = 0, len = pattern.length; i < len; i += 1){
        const char = pattern.charAt(i);
        mask[char] = (mask[char] || 0) | 1 << len - i - 1;
    }
    return mask;
}
class $2bc29ecddddf3571$var$BitapSearch {
    searchIn(text) {
        const { isCaseSensitive: isCaseSensitive, includeMatches: includeMatches } = this.options;
        if (!isCaseSensitive) text = text.toLowerCase();
        // Exact match
        if (this.pattern === text) {
            let result = {
                isMatch: true,
                score: 0
            };
            if (includeMatches) result.indices = [
                [
                    0,
                    text.length - 1
                ]
            ];
            return result;
        }
        // Otherwise, use Bitap algorithm
        const { location: location, distance: distance, threshold: threshold, findAllMatches: findAllMatches, minMatchCharLength: minMatchCharLength, ignoreLocation: ignoreLocation } = this.options;
        let allIndices = [];
        let totalScore = 0;
        let hasMatches = false;
        this.chunks.forEach(({ pattern: pattern, alphabet: alphabet, startIndex: startIndex })=>{
            const { isMatch: isMatch, score: score, indices: indices } = $2bc29ecddddf3571$var$search(text, pattern, alphabet, {
                location: location + startIndex,
                distance: distance,
                threshold: threshold,
                findAllMatches: findAllMatches,
                minMatchCharLength: minMatchCharLength,
                includeMatches: includeMatches,
                ignoreLocation: ignoreLocation
            });
            if (isMatch) hasMatches = true;
            totalScore += score;
            if (isMatch && indices) allIndices = [
                ...allIndices,
                ...indices
            ];
        });
        let result = {
            isMatch: hasMatches,
            score: hasMatches ? totalScore / this.chunks.length : 1
        };
        if (hasMatches && includeMatches) result.indices = allIndices;
        return result;
    }
    constructor(pattern, { location: location = $2bc29ecddddf3571$var$Config.location, threshold: threshold = $2bc29ecddddf3571$var$Config.threshold, distance: distance = $2bc29ecddddf3571$var$Config.distance, includeMatches: includeMatches = $2bc29ecddddf3571$var$Config.includeMatches, findAllMatches: findAllMatches = $2bc29ecddddf3571$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $2bc29ecddddf3571$var$Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = $2bc29ecddddf3571$var$Config.isCaseSensitive, ignoreLocation: ignoreLocation = $2bc29ecddddf3571$var$Config.ignoreLocation } = {}){
        this.options = {
            location: location,
            threshold: threshold,
            distance: distance,
            includeMatches: includeMatches,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            isCaseSensitive: isCaseSensitive,
            ignoreLocation: ignoreLocation
        };
        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        this.chunks = [];
        if (!this.pattern.length) return;
        const addChunk = (pattern, startIndex)=>{
            this.chunks.push({
                pattern: pattern,
                alphabet: $2bc29ecddddf3571$var$createPatternAlphabet(pattern),
                startIndex: startIndex
            });
        };
        const len = this.pattern.length;
        if (len > $2bc29ecddddf3571$var$MAX_BITS) {
            let i = 0;
            const remainder = len % $2bc29ecddddf3571$var$MAX_BITS;
            const end = len - remainder;
            while(i < end){
                addChunk(this.pattern.substr(i, $2bc29ecddddf3571$var$MAX_BITS), i);
                i += $2bc29ecddddf3571$var$MAX_BITS;
            }
            if (remainder) {
                const startIndex = len - $2bc29ecddddf3571$var$MAX_BITS;
                addChunk(this.pattern.substr(startIndex), startIndex);
            }
        } else addChunk(this.pattern, 0);
    }
}
class $2bc29ecddddf3571$var$BaseMatch {
    static isMultiMatch(pattern) {
        return $2bc29ecddddf3571$var$getMatch(pattern, this.multiRegex);
    }
    static isSingleMatch(pattern) {
        return $2bc29ecddddf3571$var$getMatch(pattern, this.singleRegex);
    }
    search() {}
    constructor(pattern){
        this.pattern = pattern;
    }
}
function $2bc29ecddddf3571$var$getMatch(pattern, exp) {
    const matches = pattern.match(exp);
    return matches ? matches[1] : null;
}
// Token: 'file
class $2bc29ecddddf3571$var$ExactMatch extends $2bc29ecddddf3571$var$BaseMatch {
    static get type() {
        return 'exact';
    }
    static get multiRegex() {
        return /^="(.*)"$/;
    }
    static get singleRegex() {
        return /^=(.*)$/;
    }
    search(text) {
        const isMatch = text === this.pattern;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                this.pattern.length - 1
            ]
        };
    }
    constructor(pattern){
        super(pattern);
    }
}
// Token: !fire
class $2bc29ecddddf3571$var$InverseExactMatch extends $2bc29ecddddf3571$var$BaseMatch {
    static get type() {
        return 'inverse-exact';
    }
    static get multiRegex() {
        return /^!"(.*)"$/;
    }
    static get singleRegex() {
        return /^!(.*)$/;
    }
    search(text) {
        const index = text.indexOf(this.pattern);
        const isMatch = index === -1;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
    constructor(pattern){
        super(pattern);
    }
}
// Token: ^file
class $2bc29ecddddf3571$var$PrefixExactMatch extends $2bc29ecddddf3571$var$BaseMatch {
    static get type() {
        return 'prefix-exact';
    }
    static get multiRegex() {
        return /^\^"(.*)"$/;
    }
    static get singleRegex() {
        return /^\^(.*)$/;
    }
    search(text) {
        const isMatch = text.startsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                this.pattern.length - 1
            ]
        };
    }
    constructor(pattern){
        super(pattern);
    }
}
// Token: !^fire
class $2bc29ecddddf3571$var$InversePrefixExactMatch extends $2bc29ecddddf3571$var$BaseMatch {
    static get type() {
        return 'inverse-prefix-exact';
    }
    static get multiRegex() {
        return /^!\^"(.*)"$/;
    }
    static get singleRegex() {
        return /^!\^(.*)$/;
    }
    search(text) {
        const isMatch = !text.startsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
    constructor(pattern){
        super(pattern);
    }
}
// Token: .file$
class $2bc29ecddddf3571$var$SuffixExactMatch extends $2bc29ecddddf3571$var$BaseMatch {
    static get type() {
        return 'suffix-exact';
    }
    static get multiRegex() {
        return /^"(.*)"\$$/;
    }
    static get singleRegex() {
        return /^(.*)\$$/;
    }
    search(text) {
        const isMatch = text.endsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                text.length - this.pattern.length,
                text.length - 1
            ]
        };
    }
    constructor(pattern){
        super(pattern);
    }
}
// Token: !.file$
class $2bc29ecddddf3571$var$InverseSuffixExactMatch extends $2bc29ecddddf3571$var$BaseMatch {
    static get type() {
        return 'inverse-suffix-exact';
    }
    static get multiRegex() {
        return /^!"(.*)"\$$/;
    }
    static get singleRegex() {
        return /^!(.*)\$$/;
    }
    search(text) {
        const isMatch = !text.endsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
    constructor(pattern){
        super(pattern);
    }
}
class $2bc29ecddddf3571$var$FuzzyMatch extends $2bc29ecddddf3571$var$BaseMatch {
    static get type() {
        return 'fuzzy';
    }
    static get multiRegex() {
        return /^"(.*)"$/;
    }
    static get singleRegex() {
        return /^(.*)$/;
    }
    search(text) {
        return this._bitapSearch.searchIn(text);
    }
    constructor(pattern, { location: location = $2bc29ecddddf3571$var$Config.location, threshold: threshold = $2bc29ecddddf3571$var$Config.threshold, distance: distance = $2bc29ecddddf3571$var$Config.distance, includeMatches: includeMatches = $2bc29ecddddf3571$var$Config.includeMatches, findAllMatches: findAllMatches = $2bc29ecddddf3571$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $2bc29ecddddf3571$var$Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = $2bc29ecddddf3571$var$Config.isCaseSensitive, ignoreLocation: ignoreLocation = $2bc29ecddddf3571$var$Config.ignoreLocation } = {}){
        super(pattern);
        this._bitapSearch = new $2bc29ecddddf3571$var$BitapSearch(pattern, {
            location: location,
            threshold: threshold,
            distance: distance,
            includeMatches: includeMatches,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            isCaseSensitive: isCaseSensitive,
            ignoreLocation: ignoreLocation
        });
    }
}
// Token: 'file
class $2bc29ecddddf3571$var$IncludeMatch extends $2bc29ecddddf3571$var$BaseMatch {
    static get type() {
        return 'include';
    }
    static get multiRegex() {
        return /^'"(.*)"$/;
    }
    static get singleRegex() {
        return /^'(.*)$/;
    }
    search(text) {
        let location = 0;
        let index;
        const indices = [];
        const patternLen = this.pattern.length;
        // Get all exact matches
        while((index = text.indexOf(this.pattern, location)) > -1){
            location = index + patternLen;
            indices.push([
                index,
                location - 1
            ]);
        }
        const isMatch = !!indices.length;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: indices
        };
    }
    constructor(pattern){
        super(pattern);
    }
}
// ❗Order is important. DO NOT CHANGE.
const $2bc29ecddddf3571$var$searchers = [
    $2bc29ecddddf3571$var$ExactMatch,
    $2bc29ecddddf3571$var$IncludeMatch,
    $2bc29ecddddf3571$var$PrefixExactMatch,
    $2bc29ecddddf3571$var$InversePrefixExactMatch,
    $2bc29ecddddf3571$var$InverseSuffixExactMatch,
    $2bc29ecddddf3571$var$SuffixExactMatch,
    $2bc29ecddddf3571$var$InverseExactMatch,
    $2bc29ecddddf3571$var$FuzzyMatch
];
const $2bc29ecddddf3571$var$searchersLen = $2bc29ecddddf3571$var$searchers.length;
// Regex to split by spaces, but keep anything in quotes together
const $2bc29ecddddf3571$var$SPACE_RE = / +(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)/;
const $2bc29ecddddf3571$var$OR_TOKEN = '|';
// Return a 2D array representation of the query, for simpler parsing.
// Example:
// "^core go$ | rb$ | py$ xy$" => [["^core", "go$"], ["rb$"], ["py$", "xy$"]]
function $2bc29ecddddf3571$var$parseQuery(pattern, options = {}) {
    return pattern.split($2bc29ecddddf3571$var$OR_TOKEN).map((item)=>{
        let query = item.trim().split($2bc29ecddddf3571$var$SPACE_RE).filter((item)=>item && !!item.trim());
        let results = [];
        for(let i = 0, len = query.length; i < len; i += 1){
            const queryItem = query[i];
            // 1. Handle multiple query match (i.e, once that are quoted, like `"hello world"`)
            let found = false;
            let idx = -1;
            while(!found && ++idx < $2bc29ecddddf3571$var$searchersLen){
                const searcher = $2bc29ecddddf3571$var$searchers[idx];
                let token = searcher.isMultiMatch(queryItem);
                if (token) {
                    results.push(new searcher(token, options));
                    found = true;
                }
            }
            if (found) continue;
            // 2. Handle single query matches (i.e, once that are *not* quoted)
            idx = -1;
            while(++idx < $2bc29ecddddf3571$var$searchersLen){
                const searcher = $2bc29ecddddf3571$var$searchers[idx];
                let token = searcher.isSingleMatch(queryItem);
                if (token) {
                    results.push(new searcher(token, options));
                    break;
                }
            }
        }
        return results;
    });
}
// These extended matchers can return an array of matches, as opposed
// to a singl match
const $2bc29ecddddf3571$var$MultiMatchSet = new Set([
    $2bc29ecddddf3571$var$FuzzyMatch.type,
    $2bc29ecddddf3571$var$IncludeMatch.type
]);
/**
 * Command-like searching
 * ======================
 *
 * Given multiple search terms delimited by spaces.e.g. `^jscript .python$ ruby !java`,
 * search in a given text.
 *
 * Search syntax:
 *
 * | Token       | Match type                 | Description                            |
 * | ----------- | -------------------------- | -------------------------------------- |
 * | `jscript`   | fuzzy-match                | Items that fuzzy match `jscript`       |
 * | `=scheme`   | exact-match                | Items that are `scheme`                |
 * | `'python`   | include-match              | Items that include `python`            |
 * | `!ruby`     | inverse-exact-match        | Items that do not include `ruby`       |
 * | `^java`     | prefix-exact-match         | Items that start with `java`           |
 * | `!^earlang` | inverse-prefix-exact-match | Items that do not start with `earlang` |
 * | `.js$`      | suffix-exact-match         | Items that end with `.js`              |
 * | `!.go$`     | inverse-suffix-exact-match | Items that do not end with `.go`       |
 *
 * A single pipe character acts as an OR operator. For example, the following
 * query matches entries that start with `core` and end with either`go`, `rb`,
 * or`py`.
 *
 * ```
 * ^core go$ | rb$ | py$
 * ```
 */ class $2bc29ecddddf3571$var$ExtendedSearch {
    static condition(_, options) {
        return options.useExtendedSearch;
    }
    searchIn(text) {
        const query = this.query;
        if (!query) return {
            isMatch: false,
            score: 1
        };
        const { includeMatches: includeMatches, isCaseSensitive: isCaseSensitive } = this.options;
        text = isCaseSensitive ? text : text.toLowerCase();
        let numMatches = 0;
        let allIndices = [];
        let totalScore = 0;
        // ORs
        for(let i = 0, qLen = query.length; i < qLen; i += 1){
            const searchers = query[i];
            // Reset indices
            allIndices.length = 0;
            numMatches = 0;
            // ANDs
            for(let j = 0, pLen = searchers.length; j < pLen; j += 1){
                const searcher = searchers[j];
                const { isMatch: isMatch, indices: indices, score: score } = searcher.search(text);
                if (isMatch) {
                    numMatches += 1;
                    totalScore += score;
                    if (includeMatches) {
                        const type = searcher.constructor.type;
                        if ($2bc29ecddddf3571$var$MultiMatchSet.has(type)) allIndices = [
                            ...allIndices,
                            ...indices
                        ];
                        else allIndices.push(indices);
                    }
                } else {
                    totalScore = 0;
                    numMatches = 0;
                    allIndices.length = 0;
                    break;
                }
            }
            // OR condition, so if TRUE, return
            if (numMatches) {
                let result = {
                    isMatch: true,
                    score: totalScore / numMatches
                };
                if (includeMatches) result.indices = allIndices;
                return result;
            }
        }
        // Nothing was matched
        return {
            isMatch: false,
            score: 1
        };
    }
    constructor(pattern, { isCaseSensitive: isCaseSensitive = $2bc29ecddddf3571$var$Config.isCaseSensitive, includeMatches: includeMatches = $2bc29ecddddf3571$var$Config.includeMatches, minMatchCharLength: minMatchCharLength = $2bc29ecddddf3571$var$Config.minMatchCharLength, ignoreLocation: ignoreLocation = $2bc29ecddddf3571$var$Config.ignoreLocation, findAllMatches: findAllMatches = $2bc29ecddddf3571$var$Config.findAllMatches, location: location = $2bc29ecddddf3571$var$Config.location, threshold: threshold = $2bc29ecddddf3571$var$Config.threshold, distance: distance = $2bc29ecddddf3571$var$Config.distance } = {}){
        this.query = null;
        this.options = {
            isCaseSensitive: isCaseSensitive,
            includeMatches: includeMatches,
            minMatchCharLength: minMatchCharLength,
            findAllMatches: findAllMatches,
            ignoreLocation: ignoreLocation,
            location: location,
            threshold: threshold,
            distance: distance
        };
        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        this.query = $2bc29ecddddf3571$var$parseQuery(this.pattern, this.options);
    }
}
const $2bc29ecddddf3571$var$registeredSearchers = [];
function $2bc29ecddddf3571$var$register(...args) {
    $2bc29ecddddf3571$var$registeredSearchers.push(...args);
}
function $2bc29ecddddf3571$var$createSearcher(pattern, options) {
    for(let i = 0, len = $2bc29ecddddf3571$var$registeredSearchers.length; i < len; i += 1){
        let searcherClass = $2bc29ecddddf3571$var$registeredSearchers[i];
        if (searcherClass.condition(pattern, options)) return new searcherClass(pattern, options);
    }
    return new $2bc29ecddddf3571$var$BitapSearch(pattern, options);
}
const $2bc29ecddddf3571$var$LogicalOperator = {
    AND: '$and',
    OR: '$or'
};
const $2bc29ecddddf3571$var$KeyType = {
    PATH: '$path',
    PATTERN: '$val'
};
const $2bc29ecddddf3571$var$isExpression = (query)=>!!(query[$2bc29ecddddf3571$var$LogicalOperator.AND] || query[$2bc29ecddddf3571$var$LogicalOperator.OR]);
const $2bc29ecddddf3571$var$isPath = (query)=>!!query[$2bc29ecddddf3571$var$KeyType.PATH];
const $2bc29ecddddf3571$var$isLeaf = (query)=>!$2bc29ecddddf3571$var$isArray(query) && $2bc29ecddddf3571$var$isObject(query) && !$2bc29ecddddf3571$var$isExpression(query);
const $2bc29ecddddf3571$var$convertToExplicit = (query)=>({
        [$2bc29ecddddf3571$var$LogicalOperator.AND]: Object.keys(query).map((key)=>({
                [key]: query[key]
            }))
    });
// When `auto` is `true`, the parse function will infer and initialize and add
// the appropriate `Searcher` instance
function $2bc29ecddddf3571$var$parse(query, options, { auto: auto = true } = {}) {
    const next = (query)=>{
        let keys = Object.keys(query);
        const isQueryPath = $2bc29ecddddf3571$var$isPath(query);
        if (!isQueryPath && keys.length > 1 && !$2bc29ecddddf3571$var$isExpression(query)) return next($2bc29ecddddf3571$var$convertToExplicit(query));
        if ($2bc29ecddddf3571$var$isLeaf(query)) {
            const key = isQueryPath ? query[$2bc29ecddddf3571$var$KeyType.PATH] : keys[0];
            const pattern = isQueryPath ? query[$2bc29ecddddf3571$var$KeyType.PATTERN] : query[key];
            if (!$2bc29ecddddf3571$var$isString(pattern)) throw new Error($2bc29ecddddf3571$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY(key));
            const obj = {
                keyId: $2bc29ecddddf3571$var$createKeyId(key),
                pattern: pattern
            };
            if (auto) obj.searcher = $2bc29ecddddf3571$var$createSearcher(pattern, options);
            return obj;
        }
        let node = {
            children: [],
            operator: keys[0]
        };
        keys.forEach((key)=>{
            const value = query[key];
            if ($2bc29ecddddf3571$var$isArray(value)) value.forEach((item)=>{
                node.children.push(next(item));
            });
        });
        return node;
    };
    if (!$2bc29ecddddf3571$var$isExpression(query)) query = $2bc29ecddddf3571$var$convertToExplicit(query);
    return next(query);
}
// Practical scoring function
function $2bc29ecddddf3571$var$computeScore(results, { ignoreFieldNorm: ignoreFieldNorm = $2bc29ecddddf3571$var$Config.ignoreFieldNorm }) {
    results.forEach((result)=>{
        let totalScore = 1;
        result.matches.forEach(({ key: key, norm: norm, score: score })=>{
            const weight = key ? key.weight : null;
            totalScore *= Math.pow(score === 0 && weight ? Number.EPSILON : score, (weight || 1) * (ignoreFieldNorm ? 1 : norm));
        });
        result.score = totalScore;
    });
}
function $2bc29ecddddf3571$var$transformMatches(result, data) {
    const matches = result.matches;
    data.matches = [];
    if (!$2bc29ecddddf3571$var$isDefined(matches)) return;
    matches.forEach((match)=>{
        if (!$2bc29ecddddf3571$var$isDefined(match.indices) || !match.indices.length) return;
        const { indices: indices, value: value } = match;
        let obj = {
            indices: indices,
            value: value
        };
        if (match.key) obj.key = match.key.src;
        if (match.idx > -1) obj.refIndex = match.idx;
        data.matches.push(obj);
    });
}
function $2bc29ecddddf3571$var$transformScore(result, data) {
    data.score = result.score;
}
function $2bc29ecddddf3571$var$format(results, docs, { includeMatches: includeMatches = $2bc29ecddddf3571$var$Config.includeMatches, includeScore: includeScore = $2bc29ecddddf3571$var$Config.includeScore } = {}) {
    const transformers = [];
    if (includeMatches) transformers.push($2bc29ecddddf3571$var$transformMatches);
    if (includeScore) transformers.push($2bc29ecddddf3571$var$transformScore);
    return results.map((result)=>{
        const { idx: idx } = result;
        const data = {
            item: docs[idx],
            refIndex: idx
        };
        if (transformers.length) transformers.forEach((transformer)=>{
            transformer(result, data);
        });
        return data;
    });
}
class $2bc29ecddddf3571$export$2e2bcd8739ae039 {
    setCollection(docs, index) {
        this._docs = docs;
        if (index && !(index instanceof $2bc29ecddddf3571$var$FuseIndex)) throw new Error($2bc29ecddddf3571$var$INCORRECT_INDEX_TYPE);
        this._myIndex = index || $2bc29ecddddf3571$var$createIndex(this.options.keys, this._docs, {
            getFn: this.options.getFn,
            fieldNormWeight: this.options.fieldNormWeight
        });
    }
    add(doc) {
        if (!$2bc29ecddddf3571$var$isDefined(doc)) return;
        this._docs.push(doc);
        this._myIndex.add(doc);
    }
    remove(predicate = ()=>false) {
        const results = [];
        for(let i = 0, len = this._docs.length; i < len; i += 1){
            const doc = this._docs[i];
            if (predicate(doc, i)) {
                this.removeAt(i);
                i -= 1;
                len -= 1;
                results.push(doc);
            }
        }
        return results;
    }
    removeAt(idx) {
        this._docs.splice(idx, 1);
        this._myIndex.removeAt(idx);
    }
    getIndex() {
        return this._myIndex;
    }
    search(query, { limit: limit = -1 } = {}) {
        const { includeMatches: includeMatches, includeScore: includeScore, shouldSort: shouldSort, sortFn: sortFn, ignoreFieldNorm: ignoreFieldNorm } = this.options;
        let results = $2bc29ecddddf3571$var$isString(query) ? $2bc29ecddddf3571$var$isString(this._docs[0]) ? this._searchStringList(query) : this._searchObjectList(query) : this._searchLogical(query);
        $2bc29ecddddf3571$var$computeScore(results, {
            ignoreFieldNorm: ignoreFieldNorm
        });
        if (shouldSort) results.sort(sortFn);
        if ($2bc29ecddddf3571$var$isNumber(limit) && limit > -1) results = results.slice(0, limit);
        return $2bc29ecddddf3571$var$format(results, this._docs, {
            includeMatches: includeMatches,
            includeScore: includeScore
        });
    }
    _searchStringList(query) {
        const searcher = $2bc29ecddddf3571$var$createSearcher(query, this.options);
        const { records: records } = this._myIndex;
        const results = [];
        // Iterate over every string in the index
        records.forEach(({ v: text, i: idx, n: norm })=>{
            if (!$2bc29ecddddf3571$var$isDefined(text)) return;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) results.push({
                item: text,
                idx: idx,
                matches: [
                    {
                        score: score,
                        value: text,
                        norm: norm,
                        indices: indices
                    }
                ]
            });
        });
        return results;
    }
    _searchLogical(query) {
        const expression = $2bc29ecddddf3571$var$parse(query, this.options);
        const evaluate = (node, item, idx)=>{
            if (!node.children) {
                const { keyId: keyId, searcher: searcher } = node;
                const matches = this._findMatches({
                    key: this._keyStore.get(keyId),
                    value: this._myIndex.getValueForItemAtKeyId(item, keyId),
                    searcher: searcher
                });
                if (matches && matches.length) return [
                    {
                        idx: idx,
                        item: item,
                        matches: matches
                    }
                ];
                return [];
            }
            const res = [];
            for(let i = 0, len = node.children.length; i < len; i += 1){
                const child = node.children[i];
                const result = evaluate(child, item, idx);
                if (result.length) res.push(...result);
                else if (node.operator === $2bc29ecddddf3571$var$LogicalOperator.AND) return [];
            }
            return res;
        };
        const records = this._myIndex.records;
        const resultMap = {};
        const results = [];
        records.forEach(({ $: item, i: idx })=>{
            if ($2bc29ecddddf3571$var$isDefined(item)) {
                let expResults = evaluate(expression, item, idx);
                if (expResults.length) {
                    // Dedupe when adding
                    if (!resultMap[idx]) {
                        resultMap[idx] = {
                            idx: idx,
                            item: item,
                            matches: []
                        };
                        results.push(resultMap[idx]);
                    }
                    expResults.forEach(({ matches: matches })=>{
                        resultMap[idx].matches.push(...matches);
                    });
                }
            }
        });
        return results;
    }
    _searchObjectList(query) {
        const searcher = $2bc29ecddddf3571$var$createSearcher(query, this.options);
        const { keys: keys, records: records } = this._myIndex;
        const results = [];
        // List is Array<Object>
        records.forEach(({ $: item, i: idx })=>{
            if (!$2bc29ecddddf3571$var$isDefined(item)) return;
            let matches = [];
            // Iterate over every key (i.e, path), and fetch the value at that key
            keys.forEach((key, keyIndex)=>{
                matches.push(...this._findMatches({
                    key: key,
                    value: item[keyIndex],
                    searcher: searcher
                }));
            });
            if (matches.length) results.push({
                idx: idx,
                item: item,
                matches: matches
            });
        });
        return results;
    }
    _findMatches({ key: key, value: value, searcher: searcher }) {
        if (!$2bc29ecddddf3571$var$isDefined(value)) return [];
        let matches = [];
        if ($2bc29ecddddf3571$var$isArray(value)) value.forEach(({ v: text, i: idx, n: norm })=>{
            if (!$2bc29ecddddf3571$var$isDefined(text)) return;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) matches.push({
                score: score,
                key: key,
                value: text,
                idx: idx,
                norm: norm,
                indices: indices
            });
        });
        else {
            const { v: text, n: norm } = value;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) matches.push({
                score: score,
                key: key,
                value: text,
                norm: norm,
                indices: indices
            });
        }
        return matches;
    }
    constructor(docs, options = {}, index){
        this.options = {
            ...$2bc29ecddddf3571$var$Config,
            ...options
        };
        this.options.useExtendedSearch;
        this._keyStore = new $2bc29ecddddf3571$var$KeyStore(this.options.keys);
        this.setCollection(docs, index);
    }
}
$2bc29ecddddf3571$export$2e2bcd8739ae039.version = '6.6.2';
$2bc29ecddddf3571$export$2e2bcd8739ae039.createIndex = $2bc29ecddddf3571$var$createIndex;
$2bc29ecddddf3571$export$2e2bcd8739ae039.parseIndex = $2bc29ecddddf3571$var$parseIndex;
$2bc29ecddddf3571$export$2e2bcd8739ae039.config = $2bc29ecddddf3571$var$Config;
$2bc29ecddddf3571$export$2e2bcd8739ae039.parseQuery = $2bc29ecddddf3571$var$parse;
$2bc29ecddddf3571$var$register($2bc29ecddddf3571$var$ExtendedSearch);
module.exports["default"] = $2bc29ecddddf3571$export$2e2bcd8739ae039;

});

parcelRegister("4XhNP", function(module, exports) {

var $iLaQ6 = parcelRequire("iLaQ6");


var $aXG5V = parcelRequire("aXG5V");
parcelRequire("2eY6H");



var $5SAOw = parcelRequire("5SAOw");

const $39ba7b57eb2a7102$export$9126078e8b0f76e4 = 'atlaskit-analytics';
const $39ba7b57eb2a7102$export$89a6d622be04d823 = 'atlaskit-analytics-invert';
var $39ba7b57eb2a7102$var$HISTORY_ACTIONS = /*#__PURE__*/ function(HISTORY_ACTIONS) {
    HISTORY_ACTIONS["UNDID"] = "undid";
    HISTORY_ACTIONS["REDID"] = "redid";
    return HISTORY_ACTIONS;
}($39ba7b57eb2a7102$var$HISTORY_ACTIONS || {});
/** Creates undo event from a normal analytics event */ function $39ba7b57eb2a7102$var$createUndoEvent(analyticsEvent) {
    var _analyticsEvent$paylo;
    return {
        ...analyticsEvent,
        payload: {
            action: $39ba7b57eb2a7102$var$HISTORY_ACTIONS.UNDID,
            actionSubject: analyticsEvent.payload.actionSubject,
            actionSubjectId: analyticsEvent.payload.action,
            attributes: {
                ...analyticsEvent.payload.attributes,
                actionSubjectId: analyticsEvent.payload.actionSubjectId,
                inputMethod: ((_analyticsEvent$paylo = analyticsEvent.payload.attributes) === null || _analyticsEvent$paylo === void 0 ? void 0 : _analyticsEvent$paylo.inputMethod) || ''
            },
            eventType: 'track'
        }
    };
}
/** Toggles event action between undo & redo */ const $39ba7b57eb2a7102$var$toggleEventAction = (analyticsEvent)=>({
        ...analyticsEvent,
        payload: {
            ...analyticsEvent.payload,
            action: analyticsEvent.payload.action === $39ba7b57eb2a7102$var$HISTORY_ACTIONS.UNDID ? $39ba7b57eb2a7102$var$HISTORY_ACTIONS.REDID : $39ba7b57eb2a7102$var$HISTORY_ACTIONS.UNDID
        }
    });
function $39ba7b57eb2a7102$var$isHistoryAnalyticsEvent(event) {
    return event.payload.action === $39ba7b57eb2a7102$var$HISTORY_ACTIONS.UNDID || event.payload.action === $39ba7b57eb2a7102$var$HISTORY_ACTIONS.REDID;
}
class $39ba7b57eb2a7102$export$cc33374693c7fb23 extends (0, $aXG5V.Step) {
    /**
   * Generate new undo/redo analytics event when step is inverted
   */ invert() {
        const analyticsEvents = this.analyticsEvents.filter((analyticsEvent)=>this.actionsToIgnore.indexOf(analyticsEvent.payload.action) === -1).map((analyticsEvent)=>{
            if ($39ba7b57eb2a7102$var$isHistoryAnalyticsEvent(analyticsEvent)) return $39ba7b57eb2a7102$var$toggleEventAction(analyticsEvent);
            else return $39ba7b57eb2a7102$var$createUndoEvent(analyticsEvent);
        });
        return new $39ba7b57eb2a7102$export$cc33374693c7fb23(analyticsEvents, []);
    }
    apply(doc) {
        return (0, $aXG5V.StepResult).ok(doc);
    }
    map(mapping) {
        let newPos = this.pos;
        if (typeof newPos === 'number') newPos = mapping.map(newPos);
        // Return the same events, this step will never be removed
        return new $39ba7b57eb2a7102$export$cc33374693c7fb23(this.analyticsEvents, this.actionsToIgnore, newPos);
    }
    getMap() {
        if (typeof this.pos === 'number') return new (0, $aXG5V.StepMap)([
            this.pos,
            0,
            0
        ]);
        return new (0, $aXG5V.StepMap)([]);
    }
    merge(other) {
        if (other instanceof $39ba7b57eb2a7102$export$cc33374693c7fb23) {
            const otherAnalyticsEvents = other.analyticsEvents;
            return new $39ba7b57eb2a7102$export$cc33374693c7fb23([
                ...otherAnalyticsEvents,
                ...this.analyticsEvents
            ]);
        }
        return null;
    }
    toJSON() {
        return {
            stepType: $39ba7b57eb2a7102$export$9126078e8b0f76e4
        };
    }
    static fromJSON() {
        return new (0, $aXG5V.ReplaceStep)(0, 0, (0, $5SAOw.Slice).empty);
    }
    constructor(analyticsEvents, actionsToIgnore = [], pos // Used to create the map, prevent splitting history.
    ){
        super();
        (0, $iLaQ6.default)(this, "analyticsEvents", []);
        (0, $iLaQ6.default)(this, "actionsToIgnore", []);
        this.analyticsEvents = analyticsEvents;
        this.actionsToIgnore = actionsToIgnore;
        this.pos = pos;
    }
}
/** Register this step with Prosemirror */ (0, $aXG5V.Step).jsonID($39ba7b57eb2a7102$export$9126078e8b0f76e4, $39ba7b57eb2a7102$export$cc33374693c7fb23);
module.exports["AnalyticsStep"] = $39ba7b57eb2a7102$export$cc33374693c7fb23;

});

parcelRegister("2eY6H", function(module, exports) {
$parcel$export(module.exports, "Step", () => (parcelRequire("aXG5V")).Step);

var $dh538 = parcelRequire("dh538");


var $aXG5V = parcelRequire("aXG5V");

// Using this avoids infinite recursion, as referencing Step.fromJSON inside Step.fromJSON
// will refer to the reassigned version, not the original version
const $1a1b839ca3f354ae$var$originalFromJSON = (0, $aXG5V.Step).fromJSON;
(0, $aXG5V.Step).fromJSON = (schema, jsonStep)=>{
    const stepImplementation = $1a1b839ca3f354ae$var$originalFromJSON(schema, jsonStep);
    // See https://switcheroo.atlassian.com/ui/gates/4e7e1e8c-9126-4dba-a2a3-1c2b86f81c36/key/platform_editor_metadata_steps
    if (!(0, $dh538.fg)('platform_editor_metadata_step')) return stepImplementation;
    return new Proxy(stepImplementation, {
        get (target, prop, receiver) {
            if (prop === 'toJSON') {
                const toJSONfunc = Reflect.get(target, prop, receiver);
                // @ts-expect-error Metadata may or may not exist at this stage, depending on step type,
                // but also additions outside of the type system that others may have done.
                const classMetadata = target.metadata;
                return new Proxy(toJSONfunc, {
                    apply (target, thisArg, argArray) {
                        const originalResult = Reflect.apply(target, thisArg, argArray);
                        const metadata = {
                            ...jsonStep.metadata,
                            ...classMetadata,
                            ...originalResult.metadata
                        };
                        return {
                            ...originalResult,
                            ...Object.keys(metadata).length === 0 ? {} : {
                                metadata: metadata
                            }
                        };
                    }
                });
            }
            return Reflect.get(target, prop, receiver);
        }
    });
};

});

parcelRegister("h3X17", function(module, exports) {

var $9K4OG = parcelRequire("9K4OG");


var $aFUXX = parcelRequire("aFUXX");


var $8z9j5 = parcelRequire("8z9j5");

var $f0c66da303fc9af9$export$54cb529986e2487b = /*#__PURE__*/ function(PROVIDER_ERROR_CODE) {
    PROVIDER_ERROR_CODE["NO_PERMISSION_ERROR"] = "NO_PERMISSION_ERROR";
    PROVIDER_ERROR_CODE["INVALID_USER_TOKEN"] = "INVALID_USER_TOKEN";
    PROVIDER_ERROR_CODE["DOCUMENT_NOT_FOUND"] = "DOCUMENT_NOT_FOUND";
    PROVIDER_ERROR_CODE["LOCKED"] = "LOCKED";
    PROVIDER_ERROR_CODE["FAIL_TO_SAVE"] = "FAIL_TO_SAVE";
    PROVIDER_ERROR_CODE["DOCUMENT_RESTORE_ERROR"] = "DOCUMENT_RESTORE_ERROR";
    PROVIDER_ERROR_CODE["INITIALISATION_ERROR"] = "INITIALISATION_ERROR";
    PROVIDER_ERROR_CODE["NETWORK_ISSUE"] = "NETWORK_ISSUE";
    PROVIDER_ERROR_CODE["INVALID_PROVIDER_CONFIGURATION"] = "INVALID_PROVIDER_CONFIGURATION";
    PROVIDER_ERROR_CODE["INTERNAL_SERVICE_ERROR"] = "INTERNAL_SERVICE_ERROR";
    PROVIDER_ERROR_CODE["DOCUMENT_UPDATE_ERROR"] = "DOCUMENT_UPDATE_ERROR";
    return PROVIDER_ERROR_CODE;
}({});
var $f0c66da303fc9af9$export$258d16488300d83f = /*#__PURE__*/ function(DisconnectReason) {
    DisconnectReason["CLIENT_DISCONNECT"] = "CLIENT_DISCONNECT";
    DisconnectReason["SERVER_DISCONNECT"] = "SERVER_DISCONNECT";
    DisconnectReason["SOCKET_CLOSED"] = "SOCKET_CLOSED";
    DisconnectReason["SOCKET_ERROR"] = "SOCKET_ERROR";
    DisconnectReason["SOCKET_TIMEOUT"] = "SOCKET_TIMEOUT";
    DisconnectReason["UNKNOWN_DISCONNECT"] = "UNKNOWN_DISCONNECT";
    return DisconnectReason;
}({});
const $f0c66da303fc9af9$var$telepointerColorStyle = (backgroundColor, textColor, index)=>{
    const { colorMode: colorMode } = (0, $8z9j5.default)();
    const backgroundStyle = colorMode === 'dark' ? `linear-gradient(to bottom, ${backgroundColor} -800000%, transparent 200000%)` : `linear-gradient(to bottom, ${backgroundColor} -850000%, transparent 150000%)`;
    return `
    &.color-${index} {
      background: ${backgroundStyle};
      &::after {
        background-color: ${backgroundColor};
        color: ${textColor};
        border-color: ${backgroundColor};
      }
    }
  `;
};
const $f0c66da303fc9af9$export$75f1e2b0ae2c8197 = 'telepointer-dim';
const $f0c66da303fc9af9$export$44ee82a2b1106d13 = 'telepointer-pulse-animate';
const $f0c66da303fc9af9$export$15875d5e8ce4fd42 = 'telepointer-pulse-during-tr';
const $f0c66da303fc9af9$export$cea3f62f94f5fdf0 = 7500; // Keeping it longer so it'll be easier to spot during transactions
const $f0c66da303fc9af9$export$74788e2dc4d9be50 = 'data-telepointer-sessionid';
const $f0c66da303fc9af9$export$c94087d6ea5127ad = /*#__PURE__*/ (0, $9K4OG.css)("@keyframes pulseIn{0%,100%{transform:scaleX(0);opacity:0;}10%{transform:scaleX(1.4);opacity:1;}15%,85%{transform:scaleX(1);opacity:1;}}@keyframes pulseOut{0%,90%,100%{transform:scaleX(1);opacity:1;}10%,80%{transform:scaleX(0);opacity:0;}}@keyframes pulseInDuringTr{0%,95%{transform:scaleX(1);opacity:1;}100%{transform:scaleX(0);opacity:0;}}@keyframes pulseOutDuringTr{100%{transform:scaleX(1);opacity:1;}0%,90%{transform:scaleX(0);opacity:0;}}.ProseMirror .telepointer{position:relative;transition:opacity 200ms;", (0, $aFUXX.participantColors).map((participantColor, index)=>$f0c66da303fc9af9$var$telepointerColorStyle(participantColor.backgroundColor, participantColor.textColor, index)), ";&.telepointer-selection:not(.inlineNodeView){line-height:1.2;pointer-events:none;user-select:none;}&.telepointer-selection-badge{.telepointer-initial,.telepointer-fullname{position:absolute;display:block;user-select:none;white-space:pre;top:-14px;left:0px;font:var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);padding-left:var(--ds-space-050, 4px);padding-right:var(--ds-space-050, 4px);border-radius:0 2px 2px 0;}.telepointer-initial{opacity:1;transition:opacity 0.15s ease-out;}.telepointer-fullname{opacity:0;transform:scaleX(0);transform-origin:top left;transition:transform 0.15s ease-out,opacity 0.15s ease-out;}}&.", $f0c66da303fc9af9$export$44ee82a2b1106d13, "{.telepointer-initial{animation:pulseOut 2.5s ease-in-out;}.telepointer-fullname{animation:pulseIn 2.5s ease-in-out;}}&.", $f0c66da303fc9af9$export$15875d5e8ce4fd42, "{.telepointer-initial{animation:pulseOutDuringTr ", $f0c66da303fc9af9$export$cea3f62f94f5fdf0, "ms ease-in-out;}.telepointer-fullname{animation:pulseInDuringTr ", $f0c66da303fc9af9$export$cea3f62f94f5fdf0, "ms ease-in-out;}}&:hover{.telepointer-initial{opacity:0;transition-delay:150ms;}.telepointer-fullname{transform:scaleX(1);opacity:1;z-index:1;}}&.", $f0c66da303fc9af9$export$75f1e2b0ae2c8197, "{opacity:0.2;}}");
const $f0c66da303fc9af9$var$tintKey = 'collab:isDirtyTransaction';
const $f0c66da303fc9af9$export$c500b1bc696a0abc = (tr)=>{
    return Boolean(tr.getMeta($f0c66da303fc9af9$var$tintKey));
};
const $f0c66da303fc9af9$export$f25182515d14d793 = (tr)=>{
    tr.setMeta($f0c66da303fc9af9$var$tintKey, true);
};
module.exports["PROVIDER_ERROR_CODE"] = $f0c66da303fc9af9$export$54cb529986e2487b;
module.exports["DisconnectReason"] = $f0c66da303fc9af9$export$258d16488300d83f;
module.exports["TELEPOINTER_DIM_CLASS"] = $f0c66da303fc9af9$export$75f1e2b0ae2c8197;
module.exports["TELEPOINTER_PULSE_CLASS"] = $f0c66da303fc9af9$export$44ee82a2b1106d13;
module.exports["TELEPOINTER_PULSE_DURING_TR_CLASS"] = $f0c66da303fc9af9$export$15875d5e8ce4fd42;
module.exports["TELEPOINTER_PULSE_DURING_TR_DURATION_MS"] = $f0c66da303fc9af9$export$cea3f62f94f5fdf0;
module.exports["TELEPOINTER_DATA_SESSION_ID_ATTR"] = $f0c66da303fc9af9$export$74788e2dc4d9be50;
module.exports["isDirtyTransaction"] = $f0c66da303fc9af9$export$c500b1bc696a0abc;
module.exports["tintDirtyTransaction"] = $f0c66da303fc9af9$export$f25182515d14d793;

});

parcelRegister("eiA8Z", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jSnXV = parcelRequire("jSnXV");

/**
 *
 * Directly map object values
 *
 * @private
 * @param object The object to transform
 * @param mapFunction The function to map an old value to new one
 * @returns Object with the same key but transformed values
 *
 */ function $1663cf3718a173a6$var$mapValues(object, mapFunction) {
    return Object.entries(object).reduce((acc, [key, value])=>({
            ...acc,
            [key]: mapFunction(value)
        }), {});
}
// When we use the `useSharedPluginStateWithSelector` example: `useSharedPluginStateWithSelector(api, ['width'], selector)`
// it will re-render every time the component re-renders as the array "['width']" is seen as an update.
// This hook is used to prevent re-renders due to this.
function $1663cf3718a173a6$var$useStaticPlugins(plugins) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $42omo.useMemo)(()=>plugins, []);
}
function $1663cf3718a173a6$export$e5d623015ec283cc(injectionApi, plugins, selector) {
    const pluginNames = $1663cf3718a173a6$var$useStaticPlugins(plugins);
    const selectorRef = (0, $42omo.useRef)(selector);
    // Create a memoized object containing the named plugins
    const namedExternalPlugins = (0, $42omo.useMemo)(()=>pluginNames.reduce((acc, pluginName)=>({
                ...acc,
                [`${String(pluginName)}State`]: injectionApi?.[pluginName]
            }), {}), [
        injectionApi,
        pluginNames
    ]);
    return $1663cf3718a173a6$var$useSharedPluginStateInternal(namedExternalPlugins, selectorRef);
}
function $1663cf3718a173a6$var$useSharedPluginStateInternal(externalPlugins, selector) {
    const refStates = (0, $42omo.useRef)($1663cf3718a173a6$var$mapValues(externalPlugins, (value)=>value?.sharedState.currentState()));
    const [pluginStates, setPluginState] = (0, $42omo.useState)(()=>selector.current(refStates.current));
    const mounted = (0, $42omo.useRef)(false);
    (0, $42omo.useLayoutEffect)(()=>{
        const debouncedPluginStateUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(()=>{
            setPluginState((currentPluginStates)=>{
                const nextStates = selector.current({
                    ...refStates.current
                });
                if ($1663cf3718a173a6$var$shallowEqual(nextStates, currentPluginStates)) return currentPluginStates;
                return nextStates;
            });
        });
        // If we re-render this hook due to a change in the external
        // plugins we need to push a state update to ensure we have
        // the most current state.
        if (mounted.current) {
            refStates.current = $1663cf3718a173a6$var$mapValues(externalPlugins, (value)=>value?.sharedState.currentState());
            debouncedPluginStateUpdate();
        }
        const unsubs = Object.entries(externalPlugins).map(([pluginKey, externalPlugin])=>{
            return externalPlugin?.sharedState.onChange(({ nextSharedState: nextSharedState, prevSharedState: prevSharedState })=>{
                if (prevSharedState === nextSharedState) return;
                refStates.current[pluginKey] = nextSharedState;
                debouncedPluginStateUpdate();
            });
        });
        mounted.current = true;
        return ()=>{
            refStates.current = {};
            unsubs.forEach((cb)=>cb?.());
        };
    }, [
        externalPlugins,
        selector
    ]);
    return pluginStates;
}
function $1663cf3718a173a6$var$shallowEqual(objA, objB) {
    if (objA === objB) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for (const key of keysA){
        if (objA[key] !== objB[key]) return false;
    }
    return true;
}
module.exports["useSharedPluginStateWithSelector"] = $1663cf3718a173a6$export$e5d623015ec283cc;

});

parcelRegister("2cmfr", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $3jQ9y = parcelRequire("3jQ9y");

const $cdbf3a2c8517d76b$export$3f063810d7bf01bd = (arr, attr, keyRenamer)=>// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    arr.reduce((acc, item)=>{
        acc[keyRenamer(item[attr])] = item;
        return acc;
    }, {});
function $cdbf3a2c8517d76b$export$30871400b97708b4(manifest, extensionModule) {
    const title = extensionModule.title || manifest.title;
    const key = `${manifest.key}:${extensionModule.key}`;
    const node = (0, $3jQ9y.buildAction)(extensionModule.action, manifest);
    if (!node) throw new Error(`Couldn't find any action for ${title} (${key})`);
    return {
        key: key,
        title: title,
        extensionType: manifest.type,
        extensionKey: manifest.key,
        keywords: extensionModule.keywords || manifest.keywords || [],
        featured: extensionModule.featured || false,
        categories: extensionModule.categories || manifest.categories || [],
        description: extensionModule.description || manifest.description,
        summary: manifest.summary,
        documentationUrl: manifest.documentationUrl,
        ...(0, $dh538.fg)('cc_fd_wb_create_priority_in_slash_menu_enabled') && {
            priority: extensionModule.priority
        },
        icon: extensionModule.icon || manifest.icons['48'],
        node: node
    };
}
const $cdbf3a2c8517d76b$export$a1d0004a197b97a3 = (extensions, transformFunction)=>{
    const items = extensions.map((manifest)=>{
        const modules = manifest.modules.quickInsert || [];
        return modules.map((extensionModule)=>$cdbf3a2c8517d76b$export$30871400b97708b4(manifest, extensionModule));
    });
    const flatItems = [].concat(...items);
    return flatItems.map(transformFunction);
};
async function $cdbf3a2c8517d76b$export$60407594ea5edd1c(extensions) {
    const items = await Promise.all(// Ignored via go/ees005
    // eslint-disable-next-line require-await
    extensions.map(async (manifest)=>{
        if (manifest.modules.autoConvert && manifest.modules.autoConvert.url) return manifest.modules.autoConvert.url;
        return [];
    }));
    return [].concat(...items);
}
const $cdbf3a2c8517d76b$export$5ae7aa0814ef4090 = (autoConvertHandlers)=>(text)=>{
        for (const handler of autoConvertHandlers){
            const result = handler(text);
            if (result) return result;
        }
    };
async function $cdbf3a2c8517d76b$export$38a3a11e6509754a(extensionProviderPromise) {
    const extensionProvider = await extensionProviderPromise;
    const extensionAutoConverters = await extensionProvider.getAutoConverter();
    return $cdbf3a2c8517d76b$export$5ae7aa0814ef4090(extensionAutoConverters);
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $cdbf3a2c8517d76b$var$logError = (msg, ...args)=>{
    // eslint-disable-next-line no-console
    console.error(msg, ...args);
};
const $cdbf3a2c8517d76b$var$toolbarItemToButtonConfig = (toolbarButton, parentKey)=>{
    const { tooltip: tooltip, tooltipStyle: tooltipStyle, key: key, label: label, ariaLabel: ariaLabel, icon: icon, action: action, disabled: disabled } = toolbarButton;
    const itemKey = [
        parentKey,
        key
    ].join(':');
    if (typeof action !== 'function') $cdbf3a2c8517d76b$var$logError(`Provided action is not a function for extension toolbar button: ${label} (${itemKey})`);
    let labelAndIcon = {};
    switch(toolbarButton.display){
        case 'icon':
            if (!icon) $cdbf3a2c8517d76b$var$logError(`icon should be provided for extension toolbar button (${itemKey}), when display is set to 'icon'`);
            labelAndIcon = {
                icon: icon
            };
            break;
        case 'label':
            if (!label) $cdbf3a2c8517d76b$var$logError(`label should be provided for extension toolbar button (${itemKey}), when display is set to 'label'`);
            labelAndIcon = {
                label: label
            };
            break;
        default:
            if (!label || !icon) $cdbf3a2c8517d76b$var$logError(`label and icon should be provided for extension toolbar button (${itemKey}), when display is not set or set to 'icon-and-label'`);
            labelAndIcon = {
                icon: icon,
                label: label
            };
            break;
    }
    return {
        key: itemKey,
        ariaLabel: ariaLabel,
        tooltip: tooltip,
        tooltipStyle: tooltipStyle,
        action: action,
        disabled: disabled,
        ...labelAndIcon
    };
};
const $cdbf3a2c8517d76b$var$compareContext = (contextA, contextB)=>{
    if (contextA.type === contextB.type && contextA.nodeType === contextB.nodeType) {
        if (contextA.type === 'node') return true;
        if (contextA.type === 'extension' && contextB.type === 'extension') return contextA.extensionKey === contextB.extensionKey && contextA.extensionType === contextB.extensionType;
    }
    return false;
};
const $cdbf3a2c8517d76b$var$hasDuplicateContext = (contextualToolbars)=>{
    if (contextualToolbars.length > 1) {
        const contexts = contextualToolbars.map((contextualToolbar)=>contextualToolbar.context);
        return contexts.find((currentContext, currentIndex)=>currentIndex !== contexts.findIndex((context)=>$cdbf3a2c8517d76b$var$compareContext(currentContext, context)));
    }
};
const $cdbf3a2c8517d76b$export$9d13b95c50a2a6c9 = (extensions, node, api)=>{
    return extensions.map((extension)=>{
        if (extension.modules.contextualToolbars) {
            const duplicateContext = $cdbf3a2c8517d76b$var$hasDuplicateContext(extension.modules.contextualToolbars);
            if (duplicateContext) {
                $cdbf3a2c8517d76b$var$logError(`[contextualToolbars] Duplicate context detected - ${JSON.stringify(duplicateContext)}.`);
                return [];
            }
            return extension.modules.contextualToolbars.map((contextualToolbar)=>{
                if ($cdbf3a2c8517d76b$var$shouldAddExtensionItemForNode(contextualToolbar, node)) {
                    const { toolbarItems: toolbarItems } = contextualToolbar;
                    if (typeof toolbarItems === 'function') return toolbarItems(node, api);
                    return toolbarItems;
                }
                return [];
            }).flatMap((toolbarItems)=>toolbarItems.map((toolbarItem)=>{
                    if ($cdbf3a2c8517d76b$var$isToolbarButton(toolbarItem)) return $cdbf3a2c8517d76b$var$toolbarItemToButtonConfig(toolbarItem, extension.key);
                    return toolbarItem;
                }));
        }
        return [];
    }).flatMap((extensionToolbarButtons)=>extensionToolbarButtons);
};
const $cdbf3a2c8517d76b$var$isToolbarButton = (toolbarItem)=>{
    if ('type' in toolbarItem) return false;
    return true;
};
// defines whether to add toolbar item for the given node
function $cdbf3a2c8517d76b$var$shouldAddExtensionItemForNode(item, node) {
    // if item type is a standard node - should match the nodeType
    if (item.context.type === 'node' && item.context.nodeType === node.type) return true;
    // for other cases should be an extension and match the nodeType ("extension" | "inlineExtension" | "bodiedExtension" | "multiBodiedExtension")
    if (item.context.type !== 'extension' || node.type !== item.context.nodeType) return false;
    // in cases where we need custom exclusion depending on the node
    if (item.context.shouldExclude) {
        if (item.context.shouldExclude(node)) return false;
    }
    const { extensionType: extensionType, extensionKey: extensionKey } = item.context;
    // if extension type is given - should match extension type
    if (extensionType && extensionType !== node.attrs?.extensionType) return false;
    // if extension key is a string
    if (typeof extensionKey === 'string') return extensionKey === node.attrs?.extensionKey;
    // if extension key is an array
    if (Array.isArray(extensionKey) && extensionKey.length) return extensionKey.includes(node.attrs?.extensionKey);
    return false;
}
module.exports["getQuickInsertItemsFromModule"] = $cdbf3a2c8517d76b$export$a1d0004a197b97a3;
module.exports["getAutoConvertPatternsFromModule"] = $cdbf3a2c8517d76b$export$60407594ea5edd1c;
module.exports["getExtensionAutoConvertersFromProvider"] = $cdbf3a2c8517d76b$export$38a3a11e6509754a;
module.exports["getContextualToolbarItemsFromModule"] = $cdbf3a2c8517d76b$export$9d13b95c50a2a6c9;

});

parcelRegister("ag6aQ", function(module, exports) {
const $fba53d904c5be787$var$prefix = 'pm-alt-text';
const $fba53d904c5be787$export$9b9c0f9d9f3552b8 = {
    FLOATING_TOOLBAR_COMPONENT: `${$fba53d904c5be787$var$prefix}-alt-text-floating-toolbar`,
    MEDIA_CONTAINER: 'mediaView-content-wrap'
};
module.exports["ClassNames"] = $fba53d904c5be787$export$9b9c0f9d9f3552b8;

});

parcelRegister("b5IZN", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $a4TK8 = parcelRequire("a4TK8");


var $cUcZ5 = parcelRequire("cUcZ5");


var $ffCOo = parcelRequire("ffCOo");


var $inPa6 = parcelRequire("inPa6");


var $d925B = parcelRequire("d925B");

var $ajtqX = parcelRequire("ajtqX");


var $2T4ch = parcelRequire("2T4ch");


var $lWghV = parcelRequire("lWghV");


var $fswVK = parcelRequire("fswVK");


var $auTg8 = parcelRequire("auTg8");


var $6DQRK = parcelRequire("6DQRK");


var $7lreV = parcelRequire("7lreV");


var $75KVc = parcelRequire("75KVc");





var $jSnXV = parcelRequire("jSnXV");









// Adapted from https://github.com/GoogleChrome/web-vitals/blob/main/src/lib/onINP.ts
// Adapted from https://github.com/GoogleChrome/web-vitals/blob/main/src/lib/bindReporter.ts
const $df33a49f9570fdc5$export$17679dccdd551979 = (callback)=>{
    let prevValue;
    let delta;
    return (metric)=>{
        if (metric.value >= 0) {
            delta = metric.value - (prevValue || 0);
            // Report the metric if there's a non-zero delta or if no previous
            // value exists (which can happen in the case of the document becoming
            // hidden when the metric value is 0).
            // See: https://github.com/GoogleChrome/web-vitals/issues/14
            if (delta || prevValue === undefined) {
                prevValue = metric.value;
                metric.delta = delta;
                callback(metric);
            }
        }
    };
};


// Adapted from https://github.com/GoogleChrome/web-vitals/blob/main/src/lib/interactions.ts
// Adapted from https://github.com/GoogleChrome/web-vitals/blob/main/src/lib/polyfills/interactionCountPolyfill.ts
class $2791f7d61bdfd64e$export$51e52147760fc784 {
    cleanup() {
        this.po?.disconnect();
    }
    updateEstimate(entries) {
        entries.forEach((e)=>{
            if (e.interactionId) {
                this.minKnownInteractionId = Math.min(this.minKnownInteractionId, e.interactionId);
                this.maxKnownInteractionId = Math.max(this.maxKnownInteractionId, e.interactionId);
                this.interactionCountEstimate = this.maxKnownInteractionId ? (this.maxKnownInteractionId - this.minKnownInteractionId) / 7 + 1 : 0;
            }
        });
    }
    /**
   * Returns the `interactionCount` value using the native API (if available)
   * or the polyfill estimate in this module.
   */ getInteractionCount() {
        return this.po ? this.interactionCountEstimate : performance.interactionCount || 0;
    }
    constructor(){
        this.interactionCountEstimate = 0;
        this.minKnownInteractionId = Infinity;
        this.maxKnownInteractionId = 0;
        this.po = void 0;
        if ('interactionCount' in performance || this.po) return;
        if (!PerformanceObserver.supportedEntryTypes.includes('event')) return;
        this.po = new PerformanceObserver((list)=>{
            // Delay by a microtask to workaround a bug in Safari where the
            // callback is invoked immediately, rather than in a separate task.
            // See: https://github.com/GoogleChrome/web-vitals/issues/277
            Promise.resolve().then(()=>{
                this.updateEstimate(list.getEntries());
            });
        });
        this.po.observe({
            type: 'event',
            buffered: true,
            durationThreshold: 0
        });
    }
}


class $11086031fa1bcc5c$export$aaa80641d584351c {
    cleanup() {
        this.interactionCountPolyfill.cleanup();
    }
    /**
   * Returns the estimated p98 longest interaction based on the stored
   * interaction candidates and the interaction count for the current page.
   */ estimateP98LongestInteraction() {
        const candidateInteractionIndex = Math.min(this.longestInteractionList.length - 1, Math.floor(this.interactionCountPolyfill.getInteractionCount() / 50));
        return this.longestInteractionList[candidateInteractionIndex];
    }
    /**
   * Takes a performance entry and adds it to the list of worst interactions
   * if its duration is long enough to make it among the worst. If the
   * entry is part of an existing interaction, it is merged and the latency
   * and entries list is updated as needed.
   */ processInteractionEntry(entry) {
        // Skip further processing for entries that cannot be INP candidates.
        if (!(entry.interactionId || entry.entryType === 'first-input')) return;
        // The least-long of the 10 longest interactions.
        const minLongestInteraction = this.longestInteractionList[this.longestInteractionList.length - 1];
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const existingInteraction = this.longestInteractionMap.get(entry.interactionId);
        // Only process the entry if it's possibly one of the ten longest,
        // or if it's part of an existing interaction.
        if (existingInteraction || this.longestInteractionList.length < $11086031fa1bcc5c$export$aaa80641d584351c.MAX_INTERACTIONS_TO_CONSIDER || entry.duration > minLongestInteraction.latency) {
            // If the interaction already exists, update it. Otherwise create one.
            if (existingInteraction) {
                // If the new entry has a longer duration, replace the old entries,
                // otherwise add to the array.
                if (entry.duration > existingInteraction.latency) {
                    existingInteraction.entries = [
                        entry
                    ];
                    existingInteraction.latency = entry.duration;
                } else if (entry.duration === existingInteraction.latency && entry.startTime === existingInteraction.entries[0].startTime) existingInteraction.entries.push(entry);
            } else {
                const interaction = {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: entry.interactionId,
                    latency: entry.duration,
                    entries: [
                        entry
                    ]
                };
                this.longestInteractionMap.set(interaction.id, interaction);
                this.longestInteractionList.push(interaction);
            }
            // Sort the entries by latency (descending) and keep only the top ten.
            this.longestInteractionList.sort((a, b)=>b.latency - a.latency);
            if (this.longestInteractionList.length > $11086031fa1bcc5c$export$aaa80641d584351c.MAX_INTERACTIONS_TO_CONSIDER) this.longestInteractionList.splice($11086031fa1bcc5c$export$aaa80641d584351c.MAX_INTERACTIONS_TO_CONSIDER).forEach((i)=>this.longestInteractionMap.delete(i.id));
        }
    }
    constructor(){
        this.longestInteractionList = void 0;
        this.longestInteractionMap = void 0;
        this.interactionCountPolyfill = void 0;
        this.longestInteractionList = [];
        this.longestInteractionMap = new Map();
        this.interactionCountPolyfill = new (0, $2791f7d61bdfd64e$export$51e52147760fc784)();
    }
}
$11086031fa1bcc5c$export$aaa80641d584351c.MAX_INTERACTIONS_TO_CONSIDER = 10;


// Adapted from https://github.com/GoogleChrome/web-vitals/blob/main/src/lib/onHidden.ts
const $a86e91972531a920$export$91ec2be6fdd8f1b4 = (cb)=>{
    const handleVisibilityChange = ()=>{
        if (document.visibilityState === 'hidden') cb();
    };
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return ()=>{
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
};


// Adapted from https://github.com/GoogleChrome/web-vitals/blob/main/src/lib/whenIdle.ts

const $4716358fa782d9bd$export$4d9952dcbf5b2792 = (cb)=>{
    const rIC = window.requestIdleCallback || window.setTimeout;
    let handle = -1;
    cb = $4716358fa782d9bd$var$runOnce(cb);
    // If the document is hidden, run the callback immediately, otherwise
    // race an idle callback with the next `visibilitychange` event.
    if (document.visibilityState === 'hidden') cb();
    else {
        const cleanup = (0, $a86e91972531a920$export$91ec2be6fdd8f1b4)(()=>{
            cb();
            cleanup();
        });
        handle = rIC(()=>{
            cb();
            cleanup();
        });
    }
    return handle;
};
// Adapted from https://github.com/GoogleChrome/web-vitals/blob/main/src/lib/runOnce.ts
const $4716358fa782d9bd$var$runOnce = (cb)=>{
    let called = false;
    return ()=>{
        if (!called) {
            cb();
            called = true;
        }
    };
};


const $e53cd74394c138c9$export$7df4b36ecaed99e1 = (callback)=>{
    const metric = {
        value: 0,
        delta: 0,
        entries: []
    };
    const reporter = (0, $df33a49f9570fdc5$export$17679dccdd551979)(callback);
    const interactionManager = new (0, $11086031fa1bcc5c$export$aaa80641d584351c)();
    const handleEntries = (entries)=>{
        (0, $4716358fa782d9bd$export$4d9952dcbf5b2792)(()=>{
            entries.forEach((entry)=>interactionManager.processInteractionEntry(entry));
            const inp = interactionManager.estimateP98LongestInteraction();
            if (inp && inp.latency !== metric.value) {
                metric.value = inp.latency;
                metric.entries = entries;
                reporter(metric);
            }
        });
    };
    const po = $e53cd74394c138c9$var$observeInteractionEvent(handleEntries);
    const onHiddenCleanup = (0, $a86e91972531a920$export$91ec2be6fdd8f1b4)(()=>{
        handleEntries(po.takeRecords());
        reporter(metric);
    });
    return ()=>{
        po.disconnect();
        interactionManager.cleanup();
        onHiddenCleanup();
    };
};
const $e53cd74394c138c9$var$observeInteractionEvent = (callback)=>{
    const po = new PerformanceObserver((list)=>{
        // Delay by a microtask to workaround a bug in Safari where the
        // callback is invoked immediately, rather than in a separate task.
        // See: https://github.com/GoogleChrome/web-vitals/issues/277
        Promise.resolve().then(()=>{
            callback(list.getEntries());
        });
    });
    // Event Timing entries have their durations rounded to the nearest 8ms,
    // so a duration of 40ms would be any event that spans 2.5 or more frames
    // at 60Hz. This threshold is chosen to strike a balance between usefulness
    // and performance. Running this callback for any interaction that spans
    // just one or two frames is likely not worth the insight that could be
    // gained.
    if (PerformanceObserver.supportedEntryTypes.includes('event')) po.observe({
        type: 'event',
        buffered: true,
        durationThreshold: 40
    });
    if (PerformanceObserver.supportedEntryTypes.includes('first-input')) po.observe({
        type: 'first-input',
        buffered: true
    });
    return po;
};



var $kyRHQ = parcelRequire("kyRHQ");

const $1035ef17fe90bcc8$export$56930d9a67e0aae6 = (callback)=>{
    if (!$1035ef17fe90bcc8$var$isINPSupported()) return;
    return (0, $e53cd74394c138c9$export$7df4b36ecaed99e1)((metric)=>{
        callback({
            value: metric.value
        });
    });
};
const $1035ef17fe90bcc8$var$isINPSupported = ()=>{
    const isSSR = !window || typeof $kyRHQ !== 'undefined' && Boolean($kyRHQ?.env?.REACT_SSR || false);
    if (isSSR) return false;
    // Return if the browser doesn't support all APIs needed to measure INP.
    if (!('PerformanceEventTiming' in window && 'interactionId' in PerformanceEventTiming.prototype)) return false;
    if (!PerformanceObserver.supportedEntryTypes.includes('event') && !PerformanceObserver.supportedEntryTypes.includes('first-input')) return false;
    return true;
};



var $4u5NT = parcelRequire("4u5NT");

const $32714f82364735d9$export$5942461441325be9 = ()=>{
    const analyticsEvents = (0, $inPa6.useAnalyticsEvents)();
    // onMount lifecycle hook
    (0, $42omo.useEffect)(()=>{
        let cleanupFn;
        const cleanupIdleCallback = $32714f82364735d9$var$createIdleCallback(()=>{
            cleanupFn = (0, $1035ef17fe90bcc8$export$56930d9a67e0aae6)(({ value: value })=>{
                const interaction = (0, $4u5NT.getActiveInteraction)();
                const ufoName = interaction?.ufoName;
                $32714f82364735d9$var$sendAnalytics(analyticsEvents.createAnalyticsEvent, value, ufoName);
            });
        });
        // Cleanup function that will be called when the component unmounts
        return ()=>{
            cleanupIdleCallback();
            cleanupFn?.();
        };
    // Using hook as mount lifecycle hook.
    // We do not need to set dependency on analyticsEvents since we are using the analyticsEvents object reference
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // This component doesn't render anything
    return null;
};
const $32714f82364735d9$var$sendAnalytics = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))((createAnalyticsEvent, value, ufoName)=>{
    (0, $ajtqX.fireAnalyticsEvent)(createAnalyticsEvent)({
        payload: {
            // @ts-expect-error Temporary data
            action: 'inp',
            actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            attributes: {
                inp: value,
                ufoName: ufoName
            }
        }
    });
}, 1000, {
    trailing: true
});
const $32714f82364735d9$var$createIdleCallback = (callback)=>{
    if (typeof window.requestIdleCallback === 'function') {
        const id = window.requestIdleCallback(callback);
        return ()=>window.cancelIdleCallback(id);
    }
    // Fallback to setTimeout with 0 delay if requestIdleCallback is not available
    const id = window.setTimeout(callback, 0);
    return ()=>window.clearTimeout(id);
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 















var $jTxSS = parcelRequire("jTxSS");




function $03c9dba1f478f2d1$export$828f0f29e8293a07({ id: id, portalManager: portalManager }) {
    // State to hold the current portals for this bucket
    const [portals, setPortals] = (0, $42omo.useState)({});
    // Effect to register/unregister this bucket with the portal manager on mount/unmount
    (0, $42omo.useLayoutEffect)(()=>{
        portalManager.registerBucket(id, setPortals);
        return ()=>{
            portalManager.unregisterBucket(id);
        };
    }, [
        id,
        portalManager
    ]);
    // Memoize the portal elements to avoid unnecessary re-renders
    const portalElements = (0, $42omo.useMemo)(()=>Object.values(portals), [
        portals
    ]);
    // Render the current portal elements
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, portalElements);
}


function $07ca771f5bf2bd0c$export$adfaaa25a1ea6e69(portalManager) {
    return function PortalRenderer() {
        const [buckets, setBuckets] = (0, $42omo.useState)(portalManager.getBuckets());
        (0, $42omo.useLayoutEffect)(()=>{
            portalManager.registerPortalRenderer(setBuckets);
            return ()=>{
                portalManager.unregisterPortalRenderer();
            };
        }, []);
        const portalsElements = (0, $42omo.useMemo)(// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        ()=>buckets.map((_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $03c9dba1f478f2d1$export$828f0f29e8293a07), {
                    key: i,
                    id: i,
                    portalManager: portalManager
                })), [
            buckets
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, portalsElements);
    };
}
const $07ca771f5bf2bd0c$export$eab0ea19ad3bed77 = ({ getChildren: getChildren, onBeforeRender: onBeforeRender })=>{
    (0, $42omo.useLayoutEffect)(()=>{
        if (onBeforeRender) onBeforeRender();
    }, [
        onBeforeRender
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, getChildren());
};
const $07ca771f5bf2bd0c$var$PortalRenderWrapper = /*#__PURE__*/ (0, $42omo.memo)($07ca771f5bf2bd0c$export$eab0ea19ad3bed77);
$07ca771f5bf2bd0c$var$PortalRenderWrapper.displayName = 'PortalRenderWrapper';
const $07ca771f5bf2bd0c$export$3a6b5f5c5bba4bde = (portalManager)=>{
    const portalsMap = new Map();
    return {
        render: (children, container, key, onBeforeReactDomRender, immediate = false)=>{
            if (typeof onBeforeReactDomRender === 'function') {
                const portal = /*#__PURE__*/ (0, $jTxSS.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($07ca771f5bf2bd0c$var$PortalRenderWrapper, {
                    getChildren: children,
                    onBeforeRender: onBeforeReactDomRender
                }), container, key);
                portalsMap.set(key, portalManager.registerPortal(key, portal, immediate));
            } else {
                const portal = /*#__PURE__*/ (0, $jTxSS.createPortal)(children(), container, key);
                portalsMap.set(key, portalManager.registerPortal(key, portal, immediate));
            }
        },
        remove: (key)=>{
            portalsMap.get(key)?.();
            portalsMap.delete(key);
        },
        destroy: ()=>{
            portalsMap.clear();
            portalManager.destroy();
        }
    };
};



var $8Yfbq = parcelRequire("8Yfbq");


var $1oCLl = parcelRequire("1oCLl");

const $3a8111d444031088$var$DEFAULT_INITIAL_BUCKETS = 50;
const $3a8111d444031088$var$DEFAULT_MAX_BUCKET_CAPACITY = 50;
const $3a8111d444031088$var$DEFAULT_SCALE_RATIO = 0.5;
const $3a8111d444031088$var$DEFAULT_THROTTLE_DELAY = 16; // ~60fps for smooth updates
/**
 * Creates an empty bucket object with a specified capacity. Each bucket is designed
 * to hold a certain number of React portals and has an associated updater function
 * which can be null initially.
 *
 * @function createEmptyBucket
 * @param {number} capacity - The maximum capacity of the bucket.
 * @returns {PortalBucketType} An object representing an empty bucket with the specified capacity.
 */ function $3a8111d444031088$var$createEmptyBucket(capacity) {
    return {
        portals: {},
        capacity: capacity,
        updater: null
    };
}
class $3a8111d444031088$export$52c7ef79917c2f38 {
    getCurrentBucket() {
        return this.availableBuckets.values().next().value;
    }
    createBucket() {
        const currentBucket = this.getCurrentBucket();
        //If the current bucket has capacity, skip this logic
        // @ts-ignore - TS2538 TypeScript 5.9.2 upgrade
        if (this.buckets[currentBucket].capacity > 0) return;
        else // The current bucket is full, delete the bucket from the list of available buckets
        // @ts-ignore - TS2345 TypeScript 5.9.2 upgrade
        this.availableBuckets.delete(currentBucket);
        // Skip creating new bucket if there are buckets still available
        if (this.availableBuckets.size > 0) return;
        // Scale the buckets up only if there are no available buckets left
        // Calculate how many new buckets need to be added
        const numBucketsToAdd = Math.floor(this.buckets.length * this.scaleRatio);
        this.buckets = [
            ...this.buckets
        ];
        for(let i = 0; i < numBucketsToAdd; i++){
            this.buckets.push($3a8111d444031088$var$createEmptyBucket(this.maxBucketCapacity));
            this.availableBuckets.add(this.buckets.length - 1);
        }
        this.portalRendererUpdater?.(this.buckets);
    }
    getOrCreateThrottledUpdater(id) {
        if (!this.throttledBucketUpdaters.has(id)) {
            const throttledUpdater = (0, (/*@__PURE__*/$parcel$interopDefault($8Yfbq)))(()=>{
                this.buckets[id]?.updater?.(()=>({
                        ...this.buckets[id].portals
                    }));
            }, this.throttleDelay);
            this.throttledBucketUpdaters.set(id, throttledUpdater);
        }
        return this.throttledBucketUpdaters.get(id);
    }
    getBuckets() {
        return this.buckets;
    }
    registerBucket(id, updater) {
        this.buckets[id].updater = updater;
        this.buckets[id].updater?.(()=>({
                ...this.buckets[id].portals
            }));
    }
    unregisterBucket(id) {
        this.buckets[id].updater = null;
        // Clean up throttled updater when bucket is unregistered
        if (this.throttledBucketUpdaters.has(id)) {
            this.throttledBucketUpdaters.get(id)?.cancel();
            this.throttledBucketUpdaters.delete(id);
        }
    }
    updateBuckets(id, immediate = false) {
        if (!this.throttleActivationRAFId && (0, $1oCLl.expValEquals)('platform_editor_debounce_portal_provider', 'isEnabled', true)) this.throttleActivationRAFId = requestAnimationFrame(()=>{
            this.shouldUseThrottledUpdates = true;
        });
        if (immediate || !this.shouldUseThrottledUpdates || !(0, $1oCLl.expValEquals)('platform_editor_debounce_portal_provider', 'isEnabled', true)) {
            // Cancel any pending throttled update and update immediately
            if (this.throttledBucketUpdaters.has(id)) this.throttledBucketUpdaters.get(id)?.cancel();
            this.buckets[id].updater?.(()=>({
                    ...this.buckets[id].portals
                }));
        } else // Use throttled update for smooth, regular updates
        this.getOrCreateThrottledUpdater(id)?.();
    }
    registerPortal(key, portal, immediate = false) {
        this.createBucket();
        // @ts-ignore - TS2538 TypeScript 5.9.2 upgrade
        this.buckets[this.getCurrentBucket()].capacity -= 1;
        const id = this.portalToBucketMap.get(key) ?? this.getCurrentBucket();
        // @ts-ignore - TS2345 TypeScript 5.9.2 upgrade
        this.portalToBucketMap.set(key, id);
        // @ts-ignore - TS2538 TypeScript 5.9.2 upgrade
        if (this.buckets[id].portals[key] !== portal) {
            // @ts-ignore - TS2538 TypeScript 5.9.2 upgrade
            this.buckets[id].portals[key] = portal;
            // @ts-ignore - TS2345 TypeScript 5.9.2 upgrade
            this.updateBuckets(id, immediate);
        }
        //returns a function to unregister the portal
        return ()=>{
            // @ts-ignore - TS2538 TypeScript 5.9.2 upgrade
            delete this.buckets[id].portals[key];
            this.portalToBucketMap.delete(key);
            // @ts-ignore - TS2538 TypeScript 5.9.2 upgrade
            this.buckets[id].capacity += 1;
            // @ts-ignore - TS2538 TypeScript 5.9.2 upgrade
            if (this.buckets[id].capacity > this.scaleCapacityThreshold) // @ts-ignore - TS2345 TypeScript 5.9.2 upgrade
            this.availableBuckets.add(id);
            // @ts-ignore - TS2345 TypeScript 5.9.2 upgrade
            this.updateBuckets(id, immediate);
        };
    }
    registerPortalRenderer(updater) {
        if (!this.portalRendererUpdater) updater(()=>this.buckets);
        this.portalRendererUpdater = updater;
    }
    unregisterPortalRenderer() {
        this.portalRendererUpdater = null;
    }
    /**
   * Cleans up resources used by the PortalManager. This includes clearing all portals,
   * unregistering all buckets, and resetting internal state.
   */ destroy() {
        // Cancel all pending throttled updates
        this.throttledBucketUpdaters.forEach((updater)=>{
            updater.cancel();
        });
        this.throttledBucketUpdaters.clear();
        // Iterate through each bucket and clear its portals and unset the updater function
        this.buckets.forEach((bucket, id)=>{
            bucket.portals = {}; // Clearing all portals from the bucket
            bucket.updater = null; // Unsetting the bucket's updater function
            this.availableBuckets.add(id); // Mark all buckets as available
        });
        this.portalToBucketMap.clear();
        this.portalRendererUpdater = null;
        this.availableBuckets = new Set(this.buckets.map((_, index)=>index));
    }
    constructor(initialBuckets = $3a8111d444031088$var$DEFAULT_INITIAL_BUCKETS, maxBucketCapacity = $3a8111d444031088$var$DEFAULT_MAX_BUCKET_CAPACITY, scaleRatio = $3a8111d444031088$var$DEFAULT_SCALE_RATIO, throttleDelay = $3a8111d444031088$var$DEFAULT_THROTTLE_DELAY){
        this.maxBucketCapacity = void 0;
        this.scaleRatio = void 0;
        this.buckets = void 0;
        this.availableBuckets = void 0;
        this.portalToBucketMap = void 0;
        this.portalRendererUpdater = void 0;
        this.scaleCapacityThreshold = void 0;
        this.throttledBucketUpdaters = void 0;
        this.throttleDelay = void 0;
        /**
     * Controls whether to use throttled updates or immediate synchronous updates.
     * During initial load, we use synchronous updates to avoid delays and ensure immediate responsiveness.
     * After the initial load period (one RAF cycle), we switch to throttled updates for better performance.
     */ this.shouldUseThrottledUpdates = false;
        /**
     * RequestAnimationFrame callback ID used to transition from synchronous to throttled update mode.
     * This ensures we switch to throttled mode after the initial render cycle completes.
     */ this.throttleActivationRAFId = void 0;
        this.maxBucketCapacity = maxBucketCapacity;
        this.scaleRatio = scaleRatio;
        this.throttleDelay = throttleDelay;
        // Initialise buckets array by creating an array of length `initialBuckets` containing empty buckets
        this.buckets = Array.from({
            length: initialBuckets
        }, ()=>$3a8111d444031088$var$createEmptyBucket(maxBucketCapacity));
        this.portalToBucketMap = new Map();
        this.availableBuckets = new Set(Array.from({
            length: initialBuckets
        }, (_, i)=>i));
        this.portalRendererUpdater = null;
        this.scaleCapacityThreshold = maxBucketCapacity / 2;
        this.throttledBucketUpdaters = new Map();
    }
}


function $b81f72f3142ef144$export$9b00782c24eb3d6b() {
    const portalManager = (0, $42omo.useMemo)(()=>new (0, $3a8111d444031088$export$52c7ef79917c2f38)(), []);
    const PortalRenderer = (0, $42omo.useMemo)(()=>(0, $07ca771f5bf2bd0c$export$adfaaa25a1ea6e69)(portalManager), [
        portalManager
    ]);
    const portalProviderAPI = (0, $42omo.useMemo)(()=>(0, $07ca771f5bf2bd0c$export$3a6b5f5c5bba4bde)(portalManager), [
        portalManager
    ]);
    // Cleanup on unmount
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            portalProviderAPI.destroy();
        };
    }, [
        portalManager,
        portalProviderAPI
    ]);
    return [
        portalProviderAPI,
        PortalRenderer
    ];
}



var $dh538 = parcelRequire("dh538");





var $dQl1W = parcelRequire("dQl1W");







var $56Wjx = parcelRequire("56Wjx");


var $kckFS = parcelRequire("kckFS");


var $hWRJP = parcelRequire("hWRJP");

const $1ad229e75f2927fb$export$12d09524e028927 = (userAgent)=>{
    // Take browsers in both Desktop and Mobile (includes Chrome, Firefox, Edge and Safari) within last 2 years
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const chrome = /Chrome\//.test(userAgent) && !/OPR\//.test(userAgent);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const chromeVersion = chrome ? parseInt((userAgent.match(/Chrome\/(\d+)/) || [])[1], 10) : 0;
    if (chromeVersion >= 84) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const gecko = /gecko\/\d/i.test(userAgent);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const geckoVersion = gecko ? parseInt((userAgent.match(/Firefox\/(\d+)/) || [])[1], 10) : 0;
    if (geckoVersion >= 84) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const edge = /Edge\/(\d+)/.exec(userAgent);
    const edgeVersion = edge ? +edge[1] : 0;
    if (edgeVersion >= 84) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const safari = !chrome && !gecko && /Version\/([0-9\._]+).*Safari/.test(userAgent);
    const safariVersion = safari ? // eslint-disable-next-line require-unicode-regexp
    parseInt((userAgent.match(/Version\/([0-9\._]+).*Safari/) || [])[1], 10) : 0;
    if (safariVersion >= 12) return false;
    return true;
};








const $090d7aafd4648237$export$cf381084b490bd31 = (WrappedComponent)=>{
    const _WithFeatureFlags = (props)=>{
        const { editorActions: editorActions } = (0, $auTg8.useEditorContext)();
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, {
            ...props,
            editorView: editorActions?._privateGetEditorView()
        }));
    };
    return _WithFeatureFlags;
};


class $24b7332c0d770745$export$d6d3bedcc5fc09c8 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    componentDidCatch(error, errorInfo) {
        // Only report and re-render once, to avoid over-reporting errors and infinite rerendering
        if (this.state.error) return;
        if (this.props.errorTracking) this.sendErrorData({
            error: error,
            errorInfo: errorInfo,
            errorStack: error.stack
        });
        // Update state to allow a re-render to attempt graceful recovery (in the event that
        // the error was caused by a race condition or is intermittent)
        this.setState({
            error: error
        }, ()=>{
            if (this.props.rethrow) // Now that a re-render has occurred, we re-throw to allow product error boundaries
            // to catch and handle the error too.
            //
            // Note that when rethrowing inside a error boundary, the stack trace
            // from a higher error boundary's componentDidCatch.info param will reset
            // to this component, instead of the original component which threw it.
            throw error;
        });
    }
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // FIXME: This is causing more problems then it's solving. The async check to sniff the browser extensions is block some
    // react unit tests. Essentially jest never completes and just hangs. This was code was added 3yrs ago so that errors
    // would detail if the browser had grammarly extension installed or not. I'm not sure if anyone has every inspecting this
    // as it doesn't look like any dashboards exist for it.
    // You can see the open handles that are block tests if you run unit tests with --detectOpenHandles
    // async componentDidMount() {
    // 	this.browserExtensions = await sniffUserBrowserExtensions({
    // 		extensions: ['grammarly'],
    // 		async: true,
    // 		asyncTimeoutMs: 20000,
    // 	});
    // }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kckFS.IntlErrorBoundary), null, this.props.children);
    }
    constructor(props){
        super(props);
        this.featureFlags = void 0;
        this.browserExtensions = undefined;
        this.state = {
            error: undefined
        };
        this.sendErrorData = async (analyticsErrorPayload)=>{
            const product = await this.getProductName();
            const { error: error, errorInfo: errorInfo } = analyticsErrorPayload;
            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            const sharedId = (0, (/*@__PURE__*/$parcel$interopDefault($dQl1W)))();
            const browserInfo = window?.navigator?.userAgent || 'unknown';
            const attributes = {
                product: product,
                browserInfo: browserInfo,
                error: error.toString(),
                errorInfo: errorInfo,
                errorId: sharedId,
                browserExtensions: this.browserExtensions,
                docStructure: this.featureFlags.errorBoundaryDocStructure && this.props.editorView ? (0, $56Wjx.getDocStructure)(this.props.editorView.state.doc, {
                    compact: true
                }) : undefined,
                outdatedBrowser: (0, $1ad229e75f2927fb$export$12d09524e028927)(browserInfo)
            };
            this.fireAnalyticsEvent({
                action: (0, $d925B.ACTION).EDITOR_CRASHED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                attributes: attributes
            });
            this.fireAnalyticsEvent({
                action: (0, $d925B.ACTION).EDITOR_CRASHED_ADDITIONAL_INFORMATION,
                actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    errorId: sharedId
                }
            });
            (0, $hWRJP.logException)(error, {
                location: 'editor-core/create-editor',
                product: product
            });
        };
        this.getProductName = async ()=>{
            const { contextIdentifierProvider: contextIdentifierProvider } = this.props;
            if (contextIdentifierProvider) {
                const context = await contextIdentifierProvider;
                if (context.product) return context.product;
            }
            return 'atlaskit';
        };
        this.fireAnalyticsEvent = (event)=>{
            this.props.createAnalyticsEvent?.(event).fire((0, $ajtqX.editorAnalyticsChannel));
        };
        this.featureFlags = props.featureFlags;
    }
}
$24b7332c0d770745$export$d6d3bedcc5fc09c8.defaultProps = {
    rethrow: true,
    errorTracking: true
};
var $24b7332c0d770745$export$2e2bcd8739ae039 = (0, $090d7aafd4648237$export$cf381084b490bd31)($24b7332c0d770745$export$d6d3bedcc5fc09c8);



var $bn5lP = parcelRequire("bn5lP");





var $f8zg2 = parcelRequire("f8zg2");





var $2oRGU = parcelRequire("2oRGU");





var $6dGgK = parcelRequire("6dGgK");


var $aFUXX = parcelRequire("aFUXX");

// Default value from: `import { fontSize } from '@atlaskit/theme/constants';`
const $67f6e75f4f4df09d$var$defaultFontSize = 14;
function $67f6e75f4f4df09d$export$3de34996b814f0f0({ baseFontSize: baseFontSize, children: children }) {
    const memoizedTheme = (0, $42omo.useMemo)(()=>({
            baseFontSize: baseFontSize || $67f6e75f4f4df09d$var$defaultFontSize,
            layoutMaxWidth: (0, $aFUXX.akEditorDefaultLayoutWidth)
        }), [
        baseFontSize
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6dGgK.a), {
        theme: memoizedTheme
    }, children);
}



var $jTtEd = parcelRequire("jTtEd");

function $93c55730732033da$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $93c55730732033da$var$editorContainerStyles = {
    name: "zxsb69",
    styles: "position:relative;width:100%;height:100%"
};
const $93c55730732033da$export$2617c0dabe49c335 = /*#__PURE__*/ (0, $42omo.memo)(({ props: props, handleAnalyticsEvent: handleAnalyticsEvent, createAnalyticsEvent: createAnalyticsEvent, handleSave: handleSave, editorActions: editorActions, providerFactory: providerFactory, onEditorCreated: onEditorCreated, onEditorDestroyed: onEditorDestroyed, preset: preset, AppearanceComponent: AppearanceComponent })=>{
    const overriddenEditorProps = {
        ...props,
        onSave: props.onSave ? handleSave : undefined,
        // noop all analytic events, even if a handler is still passed.
        analyticsHandler: undefined
    };
    const featureFlags = (0, $6DQRK.createFeatureFlagsFromProps)(props.featureFlags);
    // Render tracking is firing too many events in Jira so we are disabling them for now. See - https://product-fabric.atlassian.net/browse/ED-25616
    // Also firing too many events for the legacy content macro, so disabling for now. See - https://product-fabric.atlassian.net/browse/ED-26650
    const renderTrackingEnabled = !(0, $dh538.fg)('platform_editor_disable_rerender_tracking_jira') && !featureFlags.lcmPreventRenderTracking;
    const useShallow = false;
    const [portalProviderAPI, PortalRenderer] = (0, $b81f72f3142ef144$export$9b00782c24eb3d6b)();
    const [nodeViewPortalProviderAPI, NodeViewPortalRenderer] = (0, $b81f72f3142ef144$export$9b00782c24eb3d6b)();
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, renderTrackingEnabled && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $2oRGU.RenderTracking), {
        componentProps: props,
        action: (0, $d925B.ACTION).RE_RENDERED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
        handleAnalyticsEvent: handleAnalyticsEvent,
        propsToIgnore: [
            'defaultValue'
        ],
        useShallow: useShallow
    }), /*#__PURE__*/ (0, $9K4OG.jsx)((0, $24b7332c0d770745$export$2e2bcd8739ae039), {
        errorTracking: true,
        createAnalyticsEvent: createAnalyticsEvent,
        contextIdentifierProvider: props.contextIdentifierProvider,
        featureFlags: featureFlags
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $93c55730732033da$var$editorContainerStyles
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $auTg8.default), {
        editorActions: editorActions
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $f8zg2.IntlProviderIfMissingWrapper), null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $bn5lP.default), {
        editorProps: overriddenEditorProps,
        createAnalyticsEvent: createAnalyticsEvent,
        portalProviderAPI: portalProviderAPI,
        nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
        providerFactory: providerFactory,
        onEditorCreated: onEditorCreated,
        onEditorDestroyed: onEditorDestroyed,
        disabled: props.disabled,
        preset: preset,
        render: ({ editor: editor, view: view, eventDispatcher: eventDispatcher, config: config, dispatchAnalyticsEvent: dispatchAnalyticsEvent, editorRef: editorRef, editorAPI: editorAPI })=>/*#__PURE__*/ (0, $9K4OG.jsx)((0, $67f6e75f4f4df09d$export$3de34996b814f0f0), {
                baseFontSize: (0, $jTtEd.getBaseFontSize)(props.appearance, props.contentMode)
            }, /*#__PURE__*/ (0, $9K4OG.jsx)(AppearanceComponent, {
                innerRef: editorRef,
                editorAPI: editorAPI,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                appearance: props.appearance,
                disabled: props.disabled,
                editorActions: editorActions,
                editorDOMElement: editor,
                editorView: view,
                providerFactory: providerFactory,
                eventDispatcher: eventDispatcher,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                maxHeight: props.maxHeight,
                minHeight: props.minHeight,
                onSave: props.onSave ? handleSave : undefined,
                onCancel: props.onCancel,
                popupsMountPoint: props.popupsMountPoint,
                popupsBoundariesElement: props.popupsBoundariesElement,
                popupsScrollableElement: props.popupsScrollableElement,
                contentComponents: config.contentComponents,
                contentMode: props.contentMode,
                primaryToolbarComponents: config.primaryToolbarComponents,
                primaryToolbarIconBefore: props.primaryToolbarIconBefore,
                secondaryToolbarComponents: config.secondaryToolbarComponents,
                customContentComponents: props.contentComponents,
                customPrimaryToolbarComponents: props.primaryToolbarComponents,
                customSecondaryToolbarComponents: props.secondaryToolbarComponents,
                contextPanel: props.contextPanel,
                collabEdit: props.collabEdit,
                persistScrollGutter: props.persistScrollGutter,
                enableToolbarMinWidth: props.featureFlags?.toolbarMinWidthOverflow != null ? !!props.featureFlags?.toolbarMinWidthOverflow : props.allowUndoRedoButtons,
                useStickyToolbar: props.useStickyToolbar,
                featureFlags: featureFlags,
                pluginHooks: config.pluginHooks,
                __livePage: props.__livePage,
                preset: preset
            }))
    }), /*#__PURE__*/ (0, $9K4OG.jsx)(PortalRenderer, null), /*#__PURE__*/ (0, $9K4OG.jsx)(NodeViewPortalRenderer, null)))))));
});


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
















function $ea8d7238f61ed9d1$export$2e2bcd8739ae039(action, props, createAnalyticsEvent) {
    return async (duration, startTime)=>{
        const contextIdentifier = await props.contextIdentifierProvider;
        const objectId = contextIdentifier?.objectId;
        if (createAnalyticsEvent) (0, $ajtqX.fireAnalyticsEvent)(createAnalyticsEvent)({
            payload: {
                action: action,
                actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
                attributes: {
                    duration: duration,
                    startTime: startTime,
                    objectId: objectId
                },
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
            }
        });
    };
}


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $9HtP4 = parcelRequire("9HtP4");







function $04f7f6d8a5e7af43$export$2e2bcd8739ae039() {
    (0, $9HtP4.default)(()=>{
        (0, $2T4ch.startMeasure)((0, $7lreV.default).EDITOR_MOUNTED);
    });
}


function $4672b7597b696155$export$2e2bcd8739ae039(props, createAnalyticsEvent) {
    (0, $04f7f6d8a5e7af43$export$2e2bcd8739ae039)();
    (0, $42omo.useEffect)(()=>{
        (0, $2T4ch.stopMeasure)((0, $7lreV.default).EDITOR_MOUNTED, (0, $ea8d7238f61ed9d1$export$2e2bcd8739ae039)((0, $d925B.ACTION).EDITOR_MOUNTED, props, createAnalyticsEvent));
        return ()=>{
            (0, $2T4ch.clearMeasure)((0, $7lreV.default).EDITOR_MOUNTED);
            (0, $2T4ch.clearMeasure)((0, $7lreV.default).ON_EDITOR_READY_CALLBACK);
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
// Disable Exhaustive Deps here since we only want to stop the measure on mount.
}





const $1b1b779d278e7645$export$d9d7e48a5f16fb4d = (passedProps)=>{
    const memodProps = (0, $42omo.useMemo)(()=>{
        // That sounds awful but this is the only way to make sure we didn't missed any EditorProps
        const allProps = {
            preset: passedProps.preset,
            appearance: passedProps.appearance,
            contentMode: passedProps.contentMode,
            contentComponents: passedProps.contentComponents,
            primaryToolbarIconBefore: passedProps.primaryToolbarIconBefore,
            secondaryToolbarComponents: passedProps.secondaryToolbarComponents,
            persistScrollGutter: passedProps.persistScrollGutter,
            quickInsert: passedProps.quickInsert,
            shouldFocus: passedProps.shouldFocus,
            disabled: passedProps.disabled,
            contextPanel: passedProps.contextPanel,
            errorReporterHandler: passedProps.errorReporterHandler,
            contentTransformerProvider: passedProps.contentTransformerProvider,
            maxHeight: passedProps.maxHeight,
            minHeight: passedProps.minHeight,
            placeholder: passedProps.placeholder,
            placeholderBracketHint: passedProps.placeholderBracketHint,
            defaultValue: passedProps.defaultValue,
            assistiveLabel: passedProps.assistiveLabel,
            assistiveDescribedBy: passedProps.assistiveDescribedBy,
            popupsMountPoint: passedProps.popupsMountPoint,
            popupsBoundariesElement: passedProps.popupsBoundariesElement,
            popupsScrollableElement: passedProps.popupsScrollableElement,
            editorActions: passedProps.editorActions,
            onEditorReady: passedProps.onEditorReady,
            onDestroy: passedProps.onDestroy,
            onChange: passedProps.onChange,
            onCancel: passedProps.onCancel,
            extensionProviders: passedProps.extensionProviders,
            UNSAFE_useAnalyticsContext: passedProps.UNSAFE_useAnalyticsContext,
            useStickyToolbar: passedProps.useStickyToolbar,
            featureFlags: passedProps.featureFlags,
            onSave: passedProps.onSave,
            sanitizePrivateContent: passedProps.sanitizePrivateContent,
            media: passedProps.media,
            collabEdit: passedProps.collabEdit,
            primaryToolbarComponents: passedProps.primaryToolbarComponents,
            performanceTracking: passedProps.performanceTracking,
            inputSamplingLimit: passedProps.inputSamplingLimit,
            allowUndoRedoButtons: passedProps.allowUndoRedoButtons,
            linking: passedProps.linking,
            activityProvider: passedProps.activityProvider,
            searchProvider: passedProps.searchProvider,
            annotationProviders: passedProps.annotationProviders,
            collabEditProvider: passedProps.collabEditProvider,
            presenceProvider: passedProps.presenceProvider,
            emojiProvider: passedProps.emojiProvider,
            taskDecisionProvider: passedProps.taskDecisionProvider,
            legacyImageUploadProvider: passedProps.legacyImageUploadProvider,
            mentionProvider: passedProps.mentionProvider,
            autoformattingProvider: passedProps.autoformattingProvider,
            macroProvider: passedProps.macroProvider,
            contextIdentifierProvider: passedProps.contextIdentifierProvider,
            allowExpand: passedProps.allowExpand,
            allowNestedTasks: passedProps.allowNestedTasks,
            allowBlockType: passedProps.allowBlockType,
            allowTasksAndDecisions: passedProps.allowTasksAndDecisions,
            allowBreakout: passedProps.allowBreakout,
            allowRule: passedProps.allowRule,
            allowHelpDialog: passedProps.allowHelpDialog,
            allowPanel: passedProps.allowPanel,
            allowExtension: passedProps.allowExtension,
            allowConfluenceInlineComment: passedProps.allowConfluenceInlineComment,
            allowTemplatePlaceholders: passedProps.allowTemplatePlaceholders,
            allowDate: passedProps.allowDate,
            allowLayouts: passedProps.allowLayouts,
            allowStatus: passedProps.allowStatus,
            allowTextAlignment: passedProps.allowTextAlignment,
            allowIndentation: passedProps.allowIndentation,
            showIndentationButtons: passedProps.showIndentationButtons,
            allowFindReplace: passedProps.allowFindReplace,
            allowBorderMark: passedProps.allowBorderMark,
            allowFragmentMark: passedProps.allowFragmentMark,
            autoScrollIntoView: passedProps.autoScrollIntoView,
            elementBrowser: passedProps.elementBrowser,
            maxContentSize: passedProps.maxContentSize,
            saveOnEnter: passedProps.saveOnEnter,
            feedbackInfo: passedProps.feedbackInfo,
            mention: passedProps.mention,
            mentionInsertDisplayName: passedProps.mentionInsertDisplayName,
            uploadErrorHandler: passedProps.uploadErrorHandler,
            waitForMediaUpload: passedProps.waitForMediaUpload,
            extensionHandlers: passedProps.extensionHandlers,
            allowTextColor: passedProps.allowTextColor,
            allowTables: passedProps.allowTables,
            insertMenuItems: passedProps.insertMenuItems,
            UNSAFE_cards: passedProps.UNSAFE_cards,
            smartLinks: passedProps.smartLinks,
            allowAnalyticsGASV3: passedProps.allowAnalyticsGASV3,
            codeBlock: passedProps.codeBlock,
            textFormatting: passedProps.textFormatting,
            __livePage: passedProps.__livePage,
            AppearanceComponent: passedProps.AppearanceComponent,
            skipValidation: passedProps.skipValidation,
            syncBlock: passedProps.syncBlock,
            syncedBlockProvider: passedProps.syncedBlockProvider
        };
        const defaultProps = {
            appearance: 'comment',
            disabled: false,
            quickInsert: true
        };
        const nextProps = {
            ...defaultProps,
            ...allProps
        };
        return nextProps;
    }, [
        passedProps.preset,
        passedProps.appearance,
        passedProps.contentMode,
        passedProps.contentComponents,
        passedProps.primaryToolbarIconBefore,
        passedProps.secondaryToolbarComponents,
        passedProps.persistScrollGutter,
        passedProps.quickInsert,
        passedProps.shouldFocus,
        passedProps.disabled,
        passedProps.contextPanel,
        passedProps.errorReporterHandler,
        passedProps.contentTransformerProvider,
        passedProps.maxHeight,
        passedProps.minHeight,
        passedProps.placeholder,
        passedProps.placeholderBracketHint,
        passedProps.performanceTracking,
        passedProps.inputSamplingLimit,
        passedProps.defaultValue,
        passedProps.assistiveLabel,
        passedProps.assistiveDescribedBy,
        passedProps.popupsMountPoint,
        passedProps.popupsBoundariesElement,
        passedProps.popupsScrollableElement,
        passedProps.editorActions,
        passedProps.onEditorReady,
        passedProps.onDestroy,
        passedProps.onChange,
        passedProps.onCancel,
        passedProps.extensionProviders,
        passedProps.UNSAFE_useAnalyticsContext,
        passedProps.useStickyToolbar,
        passedProps.featureFlags,
        passedProps.onSave,
        passedProps.sanitizePrivateContent,
        passedProps.media,
        passedProps.collabEdit,
        passedProps.primaryToolbarComponents,
        passedProps.allowUndoRedoButtons,
        passedProps.linking,
        passedProps.activityProvider,
        passedProps.searchProvider,
        passedProps.annotationProviders,
        passedProps.collabEditProvider,
        passedProps.presenceProvider,
        passedProps.emojiProvider,
        passedProps.taskDecisionProvider,
        passedProps.legacyImageUploadProvider,
        passedProps.mentionProvider,
        passedProps.autoformattingProvider,
        passedProps.macroProvider,
        passedProps.contextIdentifierProvider,
        passedProps.allowExpand,
        passedProps.allowNestedTasks,
        passedProps.allowBlockType,
        passedProps.allowTasksAndDecisions,
        passedProps.allowBreakout,
        passedProps.allowRule,
        passedProps.allowHelpDialog,
        passedProps.allowPanel,
        passedProps.allowExtension,
        passedProps.allowConfluenceInlineComment,
        passedProps.allowTemplatePlaceholders,
        passedProps.allowDate,
        passedProps.allowLayouts,
        passedProps.allowStatus,
        passedProps.allowTextAlignment,
        passedProps.allowIndentation,
        passedProps.showIndentationButtons,
        passedProps.allowFindReplace,
        passedProps.allowBorderMark,
        passedProps.allowFragmentMark,
        passedProps.autoScrollIntoView,
        passedProps.elementBrowser,
        passedProps.maxContentSize,
        passedProps.saveOnEnter,
        passedProps.feedbackInfo,
        passedProps.mention,
        passedProps.mentionInsertDisplayName,
        passedProps.uploadErrorHandler,
        passedProps.waitForMediaUpload,
        passedProps.extensionHandlers,
        passedProps.allowTextColor,
        passedProps.allowTables,
        passedProps.insertMenuItems,
        passedProps.UNSAFE_cards,
        passedProps.smartLinks,
        passedProps.allowAnalyticsGASV3,
        passedProps.codeBlock,
        passedProps.textFormatting,
        passedProps.__livePage,
        passedProps.AppearanceComponent,
        passedProps.skipValidation,
        passedProps.syncBlock,
        passedProps.syncedBlockProvider
    ]);
    return memodProps;
};
var $1b1b779d278e7645$export$2e2bcd8739ae039 = $1b1b779d278e7645$export$d9d7e48a5f16fb4d;






var $4FxUL = parcelRequire("4FxUL");


var $2XqLN = parcelRequire("2XqLN");


var $eEmxu = parcelRequire("eEmxu");

function $9b8bf99e5ea95e38$var$prepareExtensionProvidersInternal(editorActions, extensionProviders) {
    if (!extensionProviders) return;
    if (typeof extensionProviders === 'function') return (0, $eEmxu.default)(extensionProviders(editorActions));
    return (0, $eEmxu.default)(extensionProviders);
}
const $9b8bf99e5ea95e38$var$prepareExtensionProvider = (getEditorActions)=>(0, $2XqLN.default)((extensionProviders)=>$9b8bf99e5ea95e38$var$prepareExtensionProvidersInternal(getEditorActions(), extensionProviders));
var $9b8bf99e5ea95e38$export$2e2bcd8739ae039 = $9b8bf99e5ea95e38$var$prepareExtensionProvider;






var $4wH3g = parcelRequire("4wH3g");







var $2cmfr = parcelRequire("2cmfr");

var $3jQ9y = parcelRequire("3jQ9y");


var $iScNA = parcelRequire("iScNA");







/**
 * Utils to send analytics event when a extension is inserted using quickInsert
 */ function $4a8f1fc352d7e11f$var$sendExtensionQuickInsertAnalytics(item, selection, createAnalyticsEvent, source) {
    if (createAnalyticsEvent) {
        const insertLocation = (0, $lWghV.findInsertLocation)(selection);
        (0, $ajtqX.fireAnalyticsEvent)(createAnalyticsEvent)({
            payload: {
                action: (0, $d925B.ACTION).INSERTED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).EXTENSION,
                attributes: {
                    extensionType: item.extensionType,
                    extensionKey: item.extensionKey,
                    key: item.key,
                    inputMethod: source || (0, $d925B.INPUT_METHOD).QUICK_INSERT,
                    ...insertLocation ? {
                        insertLocation: insertLocation
                    } : {}
                },
                eventType: (0, $d925B.EVENT_TYPE).TRACK
            }
        });
    }
}
const $4a8f1fc352d7e11f$var$showDummyAPIWarning = (location)=>{};
const $4a8f1fc352d7e11f$var$dummyExtensionAPI = {
    editInContextPanel: ()=>$4a8f1fc352d7e11f$var$showDummyAPIWarning('editInContextPanel'),
    _editInLegacyMacroBrowser: ()=>$4a8f1fc352d7e11f$var$showDummyAPIWarning('_editInLegacyMacroBrowser'),
    getNodeWithPosByLocalId: ()=>({
            node: null,
            pos: null
        }),
    doc: {
        insertAfter: ()=>$4a8f1fc352d7e11f$var$showDummyAPIWarning('doc:insertAfter'),
        scrollTo: ()=>$4a8f1fc352d7e11f$var$showDummyAPIWarning('doc:scrollTo'),
        update: ()=>$4a8f1fc352d7e11f$var$showDummyAPIWarning('doc:update')
    }
};
async function $4a8f1fc352d7e11f$export$6b0bb34c2583056f(extensionProvider, editorActions, apiRef, createAnalyticsEvent) {
    const extensions = await extensionProvider.getExtensions();
    return {
        getItems: ()=>{
            const quickInsertItems = (0, $2cmfr.getQuickInsertItemsFromModule)(extensions, (item)=>{
                const Icon = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
                    __loadable_id__: "N8xjw",
                    name: "Icon",
                    loader: item.icon,
                    loading: ()=>null
                });
                return {
                    // Add module key so typeahead/quick-insert can identify items
                    // **locale-agnostically**! nb: we _already_ send key in analytics
                    // events, this standardises and makes our items more predictable.
                    ...(0, $dh538.fg)('confluence-whiteboards-quick-insert-l10n-eligible') && {
                        key: item.key
                    },
                    title: item.title,
                    description: item.description,
                    icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
                            label: ""
                        }),
                    keywords: item.keywords,
                    featured: item.featured,
                    ...(0, $dh538.fg)('cc_fd_wb_create_priority_in_slash_menu_enabled') && {
                        priority: item.priority
                    },
                    categories: item.categories,
                    isDisabledOffline: true,
                    action: (insert, state, source)=>{
                        if (typeof item.node === 'function') {
                            const extensionAPI = apiRef?.current?.extension?.actions?.api();
                            // While this should only run when the extension some setups of editor
                            // may not have the extension API
                            if (extensionAPI) (0, $3jQ9y.resolveImport)(item.node(extensionAPI)).then((node)=>{
                                $4a8f1fc352d7e11f$var$sendExtensionQuickInsertAnalytics(item, state.selection, createAnalyticsEvent, source);
                                if (node) editorActions.replaceSelection(node);
                            });
                            else // Originally it was understood we could only use this if we were using the extension plugin
                            // However there are some edge cases where this is not true (ie. in jira)
                            // Since making it optional now would be a breaking change - instead we can just pass a dummy
                            // extension API to consumers that warns them of using the methods.
                            (0, $3jQ9y.resolveImport)(item.node($4a8f1fc352d7e11f$var$dummyExtensionAPI)).then((node)=>{
                                $4a8f1fc352d7e11f$var$sendExtensionQuickInsertAnalytics(item, state.selection, createAnalyticsEvent, source);
                                if (node) editorActions.replaceSelection(node);
                            });
                            return insert('');
                        } else {
                            $4a8f1fc352d7e11f$var$sendExtensionQuickInsertAnalytics(item, state.selection, createAnalyticsEvent, source);
                            return insert(item.node);
                        }
                    }
                };
            });
            return Promise.all(quickInsertItems);
        }
    };
}
async function $4a8f1fc352d7e11f$export$e3759a254d73dcb7(quickInsertProviders) {
    const { invokeList: invokeList } = (0, $iScNA.default)(quickInsertProviders);
    return {
        getItems () {
            return invokeList('getItems');
        }
    };
}


function $857dcb67a4f61ef1$export$2e2bcd8739ae039(editorActions, apiRef, extensionProvider, quickInsert, createAnalyticsEvent) {
    const quickInsertProvider = quickInsert && typeof quickInsert !== 'boolean' && quickInsert.provider;
    const extensionQuickInsertProvider = extensionProvider && (0, $4a8f1fc352d7e11f$export$6b0bb34c2583056f)(extensionProvider, editorActions, apiRef, createAnalyticsEvent);
    return quickInsertProvider && extensionQuickInsertProvider ? (0, $4a8f1fc352d7e11f$export$e3759a254d73dcb7)([
        quickInsertProvider,
        extensionQuickInsertProvider
    ]) : quickInsertProvider || extensionQuickInsertProvider;
}


function $e5d3ec72975fd3ba$export$2e2bcd8739ae039({ autoformattingProvider: autoformattingProvider, emojiProvider: emojiProvider, mentionProvider: mentionProvider, legacyImageUploadProvider: legacyImageUploadProvider, taskDecisionProvider: taskDecisionProvider, contextIdentifierProvider: contextIdentifierProvider, searchProvider: searchProvider, macroProvider: macroProvider, activityProvider: activityProvider, collabEdit: collabEdit, collabEditProvider: collabEditProvider, presenceProvider: presenceProvider }) {
    return {
        emojiProvider: emojiProvider,
        mentionProvider: mentionProvider,
        autoformattingProvider: autoformattingProvider,
        activityProvider: activityProvider,
        imageUploadProvider: legacyImageUploadProvider,
        taskDecisionProvider: taskDecisionProvider,
        contextIdentifierProvider: contextIdentifierProvider,
        searchProvider: searchProvider,
        presenceProvider: presenceProvider,
        macroProvider: macroProvider,
        collabEditProvider: collabEdit?.provider ? collabEdit.provider : collabEditProvider
    };
}


function $6c9d292cfdbfb05b$export$2e2bcd8739ae039(providerFactory, { mentionProvider: mentionProvider, contextIdentifierProvider: contextIdentifierProvider, collabEditProvider: collabEditProvider, activityProvider: activityProvider, presenceProvider: presenceProvider, macroProvider: macroProvider, imageUploadProvider: imageUploadProvider, searchProvider: searchProvider }, extensionProvider, quickInsertProvider) {
    providerFactory.setProvider('mentionProvider', mentionProvider);
    providerFactory.setProvider('contextIdentifierProvider', contextIdentifierProvider);
    providerFactory.setProvider('imageUploadProvider', imageUploadProvider);
    providerFactory.setProvider('collabEditProvider', collabEditProvider);
    providerFactory.setProvider('activityProvider', activityProvider);
    providerFactory.setProvider('searchProvider', searchProvider);
    providerFactory.setProvider('presenceProvider', presenceProvider);
    providerFactory.setProvider('macroProvider', macroProvider);
    if (extensionProvider) providerFactory.setProvider('extensionProvider', Promise.resolve(extensionProvider));
    if (quickInsertProvider) providerFactory.setProvider('quickInsertProvider', quickInsertProvider);
}


function $cf88016029b1c3dc$var$useEditorRef(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
preset) {
    const apiRef = (0, $42omo.useRef)();
    (0, $42omo.useEffect)(()=>{
        return preset?.apiResolver.on((api)=>{
            apiRef.current = api;
        });
    }, [
        preset?.apiResolver
    ]);
    return apiRef;
}
function $cf88016029b1c3dc$var$prepareProviders(editorActions, apiRef, quickInsert, extensionProviders, createAnalyticsEvent) {
    const extensionProvider = (0, $9b8bf99e5ea95e38$export$2e2bcd8739ae039)(()=>editorActions)(extensionProviders);
    const quickInsertProvider = (0, $857dcb67a4f61ef1$export$2e2bcd8739ae039)(editorActions, apiRef, extensionProvider, quickInsert, createAnalyticsEvent);
    return {
        extensionProvider: extensionProvider,
        quickInsertProvider: quickInsertProvider
    };
}
function $cf88016029b1c3dc$export$2e2bcd8739ae039(props, editorActions, createAnalyticsEvent) {
    const { autoformattingProvider: autoformattingProvider, emojiProvider: emojiProvider, mentionProvider: mentionProvider, legacyImageUploadProvider: legacyImageUploadProvider, taskDecisionProvider: taskDecisionProvider, contextIdentifierProvider: contextIdentifierProvider, searchProvider: searchProvider, macroProvider: macroProvider, activityProvider: activityProvider, collabEdit: collabEdit, collabEditProvider: collabEditProvider, presenceProvider: presenceProvider, quickInsert: quickInsert, extensionProviders: extensionProviders } = props;
    const providers = (0, $42omo.useMemo)(()=>(0, $e5d3ec72975fd3ba$export$2e2bcd8739ae039)({
            autoformattingProvider: autoformattingProvider,
            emojiProvider: emojiProvider,
            mentionProvider: mentionProvider,
            legacyImageUploadProvider: legacyImageUploadProvider,
            taskDecisionProvider: taskDecisionProvider,
            contextIdentifierProvider: contextIdentifierProvider,
            searchProvider: searchProvider,
            macroProvider: macroProvider,
            activityProvider: activityProvider,
            collabEdit: collabEdit,
            collabEditProvider: collabEditProvider,
            presenceProvider: presenceProvider
        }), [
        autoformattingProvider,
        emojiProvider,
        mentionProvider,
        legacyImageUploadProvider,
        taskDecisionProvider,
        contextIdentifierProvider,
        searchProvider,
        macroProvider,
        activityProvider,
        collabEdit,
        collabEditProvider,
        presenceProvider
    ]);
    const providerFactory = (0, $42omo.useRef)(new (0, $4FxUL.default)());
    const editorRef = $cf88016029b1c3dc$var$useEditorRef(props.preset);
    const preparedProviders = (0, $42omo.useMemo)(()=>// Though this will introduce some performance regression related to quick insert
        // loading but we can remove it soon when Forge will move to new API.
        // quickInsert={Promise.resolve(consumerQuickInsert)} is one of the main reason behind this performance issue.
        $cf88016029b1c3dc$var$prepareProviders(editorActions, editorRef, quickInsert, extensionProviders, createAnalyticsEvent), [
        extensionProviders,
        quickInsert,
        editorActions,
        createAnalyticsEvent,
        editorRef
    ]);
    (0, $42omo.useEffect)(()=>{
        (0, $6c9d292cfdbfb05b$export$2e2bcd8739ae039)(providerFactory.current, providers, preparedProviders.extensionProvider, preparedProviders.quickInsertProvider);
    }, [
        providers,
        preparedProviders
    ]);
    // componentWillUnmount equivalent
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            // Disable this next line because it is not a React node
            // so we can safely call destroy on the ref.
            // eslint-disable-next-line react-hooks/exhaustive-deps
            providerFactory.current.destroy();
        };
    }, []);
    return providerFactory.current;
}



/**
 * Editor wrapper that deals with the lifecycle logic of the editor
 * @param passedProps
 * @example
 */ function $f12bc0dec21ca30e$var$Editor(passedProps) {
    const propsRef = (0, $42omo.useRef)(passedProps);
    const props = (0, $1b1b779d278e7645$export$2e2bcd8739ae039)(passedProps);
    (0, $42omo.useMemo)(()=>{
        propsRef.current = props;
    }, [
        props
    ]);
    const editorContext = (0, $auTg8.useEditorContext)();
    const editorActionsPlaceholderInstance = (0, $42omo.useMemo)(()=>new (0, $fswVK.default)(), []);
    const editorActions = editorContext.editorActions || editorActionsPlaceholderInstance;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handleAnalyticsEvent = (0, $42omo.useCallback)((data)=>{
        (0, $ajtqX.fireAnalyticsEvent)(createAnalyticsEvent)(data);
    }, [
        createAnalyticsEvent
    ]);
    const getFeatureFlagsFromRef = (0, $42omo.useCallback)(()=>{
        return {
            ...(0, $6DQRK.createFeatureFlagsFromProps)(propsRef.current.featureFlags),
            useNativeCollabPlugin: Boolean(typeof propsRef.current.collabEdit?.useNativePlugin === 'boolean' ? !!propsRef.current.collabEdit?.useNativePlugin : false)
        };
    }, []);
    const onEditorCreated = (0, $42omo.useCallback)((instance)=>{
        const { contextIdentifierProvider: contextIdentifierProvider, onEditorReady: onEditorReady, featureFlags: featureFlags } = propsRef.current;
        editorActions._privateRegisterEditor(instance.view, instance.eventDispatcher, instance.transformer, getFeatureFlagsFromRef);
        if (onEditorReady) {
            (0, $2T4ch.startMeasure)((0, $7lreV.default).ON_EDITOR_READY_CALLBACK);
            onEditorReady(editorActions);
            (0, $2T4ch.stopMeasure)((0, $7lreV.default).ON_EDITOR_READY_CALLBACK, (0, $ea8d7238f61ed9d1$export$2e2bcd8739ae039)((0, $d925B.ACTION).ON_EDITOR_READY_CALLBACK, {
                contextIdentifierProvider: contextIdentifierProvider,
                featureFlags: featureFlags
            }, createAnalyticsEvent));
        }
    }, [
        editorActions,
        createAnalyticsEvent,
        getFeatureFlagsFromRef,
        propsRef
    ]);
    const onEditorDestroyed = (0, $42omo.useCallback)((_instance)=>{
        const { onDestroy: onDestroy } = propsRef.current;
        editorActions._privateUnregisterEditor();
        if (onDestroy) onDestroy();
    }, [
        editorActions,
        propsRef
    ]);
    (0, $4672b7597b696155$export$2e2bcd8739ae039)(props, createAnalyticsEvent);
    const providerFactory = (0, $cf88016029b1c3dc$export$2e2bcd8739ae039)(props, editorActions, createAnalyticsEvent);
    const { onSave: onSaveFromProps } = props;
    const handleSave = (0, $42omo.useCallback)((view)=>{
        if (onSaveFromProps) onSaveFromProps(view);
    }, [
        onSaveFromProps
    ]);
    const isFullPageApperance = Boolean(props.appearance && [
        'full-page',
        'full-width'
    ].includes(props.appearance));
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, isFullPageApperance ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, $32714f82364735d9$export$5942461441325be9), null) : null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $93c55730732033da$export$2617c0dabe49c335), {
        props: props,
        handleAnalyticsEvent: handleAnalyticsEvent,
        createAnalyticsEvent: createAnalyticsEvent,
        preset: props.preset,
        handleSave: handleSave,
        editorActions: editorActions,
        onEditorCreated: onEditorCreated,
        onEditorDestroyed: onEditorDestroyed,
        providerFactory: providerFactory,
        AppearanceComponent: props.AppearanceComponent
    }));
}
const $f12bc0dec21ca30e$var$useMemoEditorFeatureFlags = (featureFlags)=>{
    const ffRef = (0, $42omo.useRef)(featureFlags);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(ffRef.current, featureFlags)) ffRef.current = featureFlags;
    return ffRef.current;
};
function $f12bc0dec21ca30e$export$be7eaacc86ce4514(props) {
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const editorSessionId = (0, $42omo.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))());
    const data = (0, $42omo.useMemo)(()=>{
        return {
            packageName: (0, $75KVc.name),
            packageVersion: (0, $75KVc.version),
            componentName: 'editorCore',
            appearance: (0, $lWghV.getAnalyticsAppearance)(props.appearance),
            editorSessionId: editorSessionId.current
        };
    }, [
        props.appearance
    ]);
    const memodEditorFeatureFlags = $f12bc0dec21ca30e$var$useMemoEditorFeatureFlags(props.featureFlags);
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $ffCOo.FabricEditorAnalyticsContext), {
        // @ts-expect-error Type 'string' is not assignable to type '"editorCore" | "renderer"'.
        data: data
    }, /*#__PURE__*/ (0, $9K4OG.jsx)($f12bc0dec21ca30e$var$Editor, {
        ...props,
        featureFlags: memodEditorFeatureFlags
    }));
}
$f12bc0dec21ca30e$export$be7eaacc86ce4514.propTypes = {
    minHeight: ({ appearance: appearance, minHeight: minHeight })=>{
        if (minHeight && appearance && ![
            'comment',
            'chromeless'
        ].includes(appearance)) return new Error('minHeight only supports editor appearance chromeless and comment for Editor');
        return null;
    }
};
var $f12bc0dec21ca30e$export$2e2bcd8739ae039 = $f12bc0dec21ca30e$export$be7eaacc86ce4514;
module.exports["CoreEditor"] = $f12bc0dec21ca30e$export$be7eaacc86ce4514;

});

parcelRegister("ajtqX", function(module, exports) {

var $k7eoe = parcelRequire("k7eoe");


var $2XqLN = parcelRequire("2XqLN");

var $59df087331ac03f0$var$_AnalyticsQueue;
class $59df087331ac03f0$export$b44c4ba8fe19bbc7 {
    request(fn) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (window.requestIdleCallback) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        window.requestIdleCallback(fn);
        else {
            const start = performance.now();
            setTimeout(()=>{
                fn({
                    didTimeout: false,
                    timeRemaining: ()=>Math.max(0, 50 - (performance.now() - start))
                });
            }, 0);
        }
    }
    pending() {
        // Defensive coding as navigator.scheduling.isInputPending is an experimental API
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (typeof window.navigator?.scheduling?.isInputPending === 'function') // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return window.navigator?.scheduling?.isInputPending() === true;
        return false;
    }
    process() {
        if (this.running) return;
        this.running = true;
        this.request((deadline)=>{
            while(deadline.timeRemaining() > 0 && this.tasks.length > 0 && !this.pending()){
                const task = this.tasks.shift();
                if (task) task();
            }
            this.running = false;
            if (this.tasks.length > 0) this.process();
        });
    }
    schedule(task) {
        this.tasks.push(task);
        this.process();
    }
    constructor(){
        this.tasks = [];
        this.running = false;
    }
}
$59df087331ac03f0$var$_AnalyticsQueue = $59df087331ac03f0$export$b44c4ba8fe19bbc7;
$59df087331ac03f0$export$b44c4ba8fe19bbc7.get = (0, $2XqLN.default)(()=>new $59df087331ac03f0$var$_AnalyticsQueue());


const $2ca897dc13b18654$export$1467dbbb3bb418c6 = (0, $k7eoe.FabricChannel).editor;
const $2ca897dc13b18654$export$c7d191551feb734 = (createAnalyticsEvent, options)=>({ payload: payload, channel: channel = $2ca897dc13b18654$export$1467dbbb3bb418c6 })=>{
        if (!createAnalyticsEvent) return;
        if (options?.immediate) {
            createAnalyticsEvent(payload)?.fire(channel);
            return;
        }
        const queue = (0, $59df087331ac03f0$export$b44c4ba8fe19bbc7).get();
        queue.schedule(()=>createAnalyticsEvent(payload)?.fire(channel));
    };
module.exports["editorAnalyticsChannel"] = $2ca897dc13b18654$export$1467dbbb3bb418c6;
module.exports["fireAnalyticsEvent"] = $2ca897dc13b18654$export$c7d191551feb734;

});

parcelRegister("fswVK", function(module, exports) {

var $d925B = parcelRequire("d925B");


var $5vVM5 = parcelRequire("5vVM5");


var $6tl2G = parcelRequire("6tl2G");


var $lWghV = parcelRequire("lWghV");


var $5SAOw = parcelRequire("5SAOw");


var $ks2lK = parcelRequire("ks2lK");


var $8m4tT = parcelRequire("8m4tT");

// Please, do not copy or use this kind of code below
// @ts-ignore
const $674469a067b8ad06$var$mediaPluginKey = {
    key: 'mediaPlugin$',
    getState: (state)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return state['mediaPlugin$'];
    }
};
async function $674469a067b8ad06$export$99c45752ffdaa598(editorView) {
    const mediaPluginState = editorView.state && $674469a067b8ad06$var$mediaPluginKey.getState(editorView.state);
    if (mediaPluginState && mediaPluginState.waitForMediaUpload) await mediaPluginState.waitForPendingTasks();
    return editorView.state.doc;
}


function $24808638338110d5$var$deprecationWarnings(className, props, deprecations) {
    return;
}
var $24808638338110d5$export$2e2bcd8739ae039 = $24808638338110d5$var$deprecationWarnings;


const $4f0bf41d03b55c89$export$1dc8bea8646ac811 = (state, ids)=>{
    if (ids.length === 0) return [];
    const nodes = [];
    const localIdSet = new Set(ids);
    state.doc.descendants((node, pos)=>{
        const fragmentLocalIdList = node.marks?.filter((m)=>m.type.name === 'fragment').map((m)=>m.attrs?.localId).filter((id)=>id && localIdSet.has(id));
        if (fragmentLocalIdList.length > 0) nodes.push({
            node: node,
            pos: pos
        });
        // stop traversing once we found all the nodes
        return localIdSet.size !== nodes.length;
    });
    return nodes;
};


/**
 * Temporary file which extracts function from `editor-common`.
 *
 * Eventually we will deprecate and delete EditorActions. This is here to
 * help decouple it from editor-common
 */ function $1ec3bd762a62c85b$export$b648602b09795358(node) {
    return !!node && node.type.name === 'paragraph' && !node.childCount;
}
function $1ec3bd762a62c85b$export$2da47a16c0b6bcb(node) {
    const nodeChild = node.content.firstChild;
    if (node.childCount !== 1 || !nodeChild) return false;
    return $1ec3bd762a62c85b$export$b648602b09795358(nodeChild);
}


/**
 * Temporary file which extracts function from `editor-common`.
 *
 * Eventually we will deprecate and delete EditorActions. This is here to
 * help decouple it from editor-common
 */ const $9bc21d8203f55b17$export$947fc26275418e36 = (state, ids, option = {})=>{
    if (ids.length === 0) return [];
    const nodes = [];
    const localIdSet = new Set(ids);
    if (option.includeDocNode && localIdSet.has(state.doc.attrs?.localId)) nodes.push({
        node: state.doc,
        pos: 0
    });
    state.doc.descendants((node, pos)=>{
        if (localIdSet.has(node.attrs?.localId)) nodes.push({
            node: node,
            pos: pos
        });
        // stop traversing once we found all the nodes
        return localIdSet.size !== nodes.length;
    });
    return nodes;
};


/**
 * Temporary file which extracts function from `editor-common`.
 *
 * Eventually we will deprecate and delete EditorActions. This is here to
 * help decouple it from editor-common
 */ 
var $h9yJL = parcelRequire("h9yJL");

const $e456faba3d0c2065$var$transformer = new (0, $h9yJL.JSONTransformer)();
function $e456faba3d0c2065$export$54fd2c36b5cc6731(node) {
    return $e456faba3d0c2065$var$transformer.encode(node);
}


// Please, do not copy or use this kind of code below
// @ts-ignore
const $982b9f7bd08d5545$var$fakePluginKey = {
    key: 'nativeCollabProviderPlugin$',
    getState: (state)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return state['nativeCollabProviderPlugin$'];
    }
};
class $982b9f7bd08d5545$export$2e2bcd8739ae039 {
    static from(view, eventDispatcher, transformer) {
        const editorActions = new $982b9f7bd08d5545$export$2e2bcd8739ae039();
        editorActions._privateRegisterEditor(view, eventDispatcher, transformer);
        return editorActions;
    }
    //#region private
    // This method needs to be public for context based helper components.
    _privateGetEditorView() {
        return this.editorView;
    }
    _privateGetEventDispatcher() {
        return this.eventDispatcher;
    }
    getFeatureFlags() {
        return {};
    }
    // This method needs to be public for EditorContext component.
    _privateRegisterEditor(editorView, eventDispatcher, contentTransformer, getFeatureFlags = ()=>({})) {
        this.contentTransformer = contentTransformer;
        this.eventDispatcher = eventDispatcher;
        this.getFeatureFlags = getFeatureFlags;
        if (!this.editorView && editorView) {
            this.editorView = editorView;
            this.listeners.forEach((cb)=>cb(editorView, eventDispatcher));
        } else if (this.editorView !== editorView) throw new Error("Editor has already been registered! It's not allowed to re-register editor with the new Editor instance.");
        if (this.contentTransformer) this.contentEncode = this.contentTransformer.encode.bind(this.contentTransformer);
    }
    // This method needs to be public for EditorContext component.
    _privateUnregisterEditor() {
        this.editorView = undefined;
        this.contentTransformer = undefined;
        this.contentEncode = undefined;
        this.eventDispatcher = undefined;
        this.getFeatureFlags = ()=>({});
    }
    _privateSubscribe(cb) {
        // If editor is registered and somebody is trying to add a listener,
        // just call it first.
        if (this.editorView && this.eventDispatcher) cb(this.editorView, this.eventDispatcher);
        this.listeners.push(cb);
    }
    _privateUnsubscribe(cb) {
        this.listeners = this.listeners.filter((c)=>c !== cb);
    }
    //#endregion
    focus({ scrollIntoView: scrollIntoView } = {
        scrollIntoView: true
    }) {
        if (!this.editorView || this.editorView.hasFocus()) return false;
        this.editorView.focus();
        if (scrollIntoView ?? true) this.editorView.dispatch(this.editorView.state.tr.scrollIntoView());
        return true;
    }
    blur() {
        if (!this.editorView || !this.editorView.hasFocus()) return false;
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.editorView.dom.blur();
        return true;
    }
    clear() {
        if (!this.editorView) return false;
        const editorView = this.editorView;
        const { state: state } = editorView;
        const tr = editorView.state.tr.setSelection((0, $ks2lK.TextSelection).create(state.doc, 0, state.doc.nodeSize - 2)).deleteSelection();
        editorView.dispatch(tr);
        return true;
    }
    // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
    /**
   * @deprecated This is deprecated and is no longer maintained.
   *
   * Use the `requestDocument` API from `editorAPI` (ie. `editorApi?.core?.actions.requestDocument( ... ))
   * it has inbuilt throttling and is designed for use with `ComposableEditor`.
   *
   * Docs on its usage are available from: https://atlaskit.atlassian.com/packages/editor/editor-core
   *
   * WARNING: this may be called repeatedly, async with care
   */ async getValue() {
        const { editorView: editorView } = this;
        if (!editorView) return;
        const doc = await (0, $674469a067b8ad06$export$99c45752ffdaa598)(editorView);
        const json = (0, $e456faba3d0c2065$export$54fd2c36b5cc6731)(doc);
        if (!this.contentEncode) return json;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const nodeSanitized = (0, $5SAOw.Node).fromJSON(this.editorView.state.schema, json);
        try {
            return this.contentEncode(nodeSanitized);
        } catch (e) {
            this.dispatchAnalyticsEvent({
                action: (0, $d925B.ACTION).DOCUMENT_PROCESSING_ERROR,
                actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    errorMessage: `${e instanceof Error && e.name === 'NodeNestingTransformError' ? 'NodeNestingTransformError - Failed to encode one or more nested tables' : undefined}`
                }
            });
            throw e;
        }
    }
    // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
    /**
   * @deprecated - please use `getNodeWithPosByLocalId` found in the core plugin actions instead
   * @example
    	const { editorApi, preset } = usePreset(...);
  	const extensionAPI = editorAPI?.extension?.actions?.api();
  	// Use nodeWithPos as desired
  	const nodeWithPos = extensionAPI.getNodeWithPosByLocalId(localId);
  	const node = nodeWithPos.node;
  	const nodePos = nodeWithPos.pos;
   */ getNodeByLocalId(id) {
        if (this.editorView?.state) {
            const nodes = (0, $9bc21d8203f55b17$export$947fc26275418e36)(this.editorView?.state, [
                id
            ]);
            const node = nodes.length >= 1 ? nodes[0] : undefined;
            return node?.node;
        }
    }
    getNodeByFragmentLocalId(id) {
        if (this.editorView?.state) {
            const nodes = (0, $4f0bf41d03b55c89$export$1dc8bea8646ac811)(this.editorView?.state, [
                id
            ]);
            return nodes.length > 0 ? nodes[0].node : undefined;
        }
    }
    /**
   * This method will return the currently selected `Node` if the selection is a `Node`.
   * Otherwise, if the selection is textual or a non-selectable `Node` within another selectable `Node`, the closest selectable parent `Node` will be returned.
   */ getSelectedNode() {
        if (this.editorView?.state?.selection) {
            const { selection: selection } = this.editorView.state;
            if (selection instanceof (0, $ks2lK.NodeSelection)) return selection.node;
            return (0, $8m4tT.findParentNode)((node)=>Boolean(node.type.spec.selectable))(selection)?.node;
        }
    }
    isDocumentEmpty() {
        // Unlikely case when editorView has been destroyed before calling isDocumentEmpty,
        // we treat this case as if document was empty.
        if (!this.editorView) return true;
        return (0, $1ec3bd762a62c85b$export$2da47a16c0b6bcb)(this.editorView.state.doc);
    }
    // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
    /**
   * @deprecated - please use `replaceDocument` found in the core plugin actions instead
   * using this will reset your Editor State which could cause some things to break (like emojis)
   * @example - use the `replaceDocument` from the core plugin actions instead
   * ```ts
   * const { editorApi, preset } = usePreset(...);
  	// where you need it
  	editorApi?.core.actions.replaceDocument(value);
  	return <ComposableEditor preset={preset} ... />
   */ replaceDocument(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    rawValue, shouldScrollToBottom = true, // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
    /** @deprecated [ED-14158] shouldAddToHistory is not being used in this function */ shouldAddToHistory = true) {
        (0, $24808638338110d5$export$2e2bcd8739ae039)('EditorActions.replaceDocument', {
            shouldAddToHistory: shouldAddToHistory
        }, [
            {
                property: 'shouldAddToHistory',
                description: '[ED-14158] EditorActions.replaceDocument does not use the shouldAddToHistory arg',
                type: 'removed'
            }
        ]);
        if (!this.editorView || rawValue === undefined || rawValue === null) return false;
        if (this.eventDispatcher) this.eventDispatcher.emit('resetEditorState', {
            doc: rawValue,
            shouldScrollToBottom: shouldScrollToBottom
        });
        return true;
    }
    replaceSelection(rawValue, tryToReplace, position) {
        if (!this.editorView) return false;
        const { state: state } = this.editorView;
        if (!rawValue) {
            const tr = state.tr.deleteSelection().scrollIntoView();
            this.editorView.dispatch(tr);
            return true;
        }
        const { schema: schema } = state;
        const content = Array.isArray(rawValue) ? (0, $6tl2G.processRawFragmentValue)(schema, rawValue, undefined, undefined, undefined, this.dispatchAnalyticsEvent) : (0, $6tl2G.processRawValue)(schema, rawValue, undefined, undefined, undefined, this.dispatchAnalyticsEvent);
        if (!content) return false;
        // try to find a place in the document where to insert a node if its not allowed at the cursor position by schema
        this.editorView.dispatch((0, $8m4tT.safeInsert)(content, position, tryToReplace)(state.tr).scrollIntoView());
        return true;
    }
    appendText(text) {
        if (!this.editorView || !text) return false;
        const { state: state } = this.editorView;
        const lastChild = state.doc.lastChild;
        if (lastChild && lastChild.type !== state.schema.nodes.paragraph) return false;
        const tr = state.tr.insertText(text).scrollIntoView();
        this.editorView.dispatch(tr);
        return true;
    }
    constructor(){
        this.editorView = void 0;
        this.contentTransformer = void 0;
        this.contentEncode = void 0;
        this.eventDispatcher = void 0;
        this.listeners = [];
        this.dispatchAnalyticsEvent = (payload)=>{
            if (this.eventDispatcher) {
                const dispatch = (0, $5vVM5.createDispatch)(this.eventDispatcher);
                dispatch((0, $lWghV.analyticsEventKey), {
                    payload: payload
                });
            }
        };
        /**
     * If editor is using new collab service,
     * we want editor to call the collab provider to
     * retrieve the final acknowledged state of the
     * editor. The final acknowledged editor state
     * refers to the latest state of editor with confirmed
     * steps.
     */ this.getResolvedEditorState = async (reason)=>{
            const { useNativeCollabPlugin: useNativeCollabPlugin } = this.getFeatureFlags();
            if (!this.editorView) throw new Error('Called getResolvedEditorState before editorView is ready');
            if (!useNativeCollabPlugin) {
                const editorValue = await this.getValue();
                if (!editorValue) throw new Error('editorValue is undefined');
                return {
                    content: editorValue,
                    title: null,
                    stepVersion: -1
                };
            }
            const editorView = this.editorView;
            await (0, $674469a067b8ad06$export$99c45752ffdaa598)(editorView);
            const collabEditState = $982b9f7bd08d5545$var$fakePluginKey.getState(editorView.state);
            return collabEditState?.getFinalAcknowledgedState(reason);
        };
    }
}
module.exports["default"] = $982b9f7bd08d5545$export$2e2bcd8739ae039;

});

parcelRegister("5vVM5", function(module, exports) {
class $36d44ab91368ab14$export$ec8b666c5fe2c75a {
    on(event, cb) {
        if (!this.listeners[event]) this.listeners[event] = new Set();
        this.listeners[event].add(cb);
    }
    has(event, cb) {
        if (!this.listeners[event]) return false;
        return this.listeners[event].has(cb);
    }
    off(event, cb) {
        if (!this.listeners[event]) return;
        if (this.listeners[event].has(cb)) this.listeners[event].delete(cb);
    }
    emit(event, data) {
        if (!this.listeners[event]) return;
        this.listeners[event].forEach((cb)=>cb(data));
    }
    destroy() {
        this.listeners = {};
    }
    constructor(){
        this.listeners = {};
    }
}
function $36d44ab91368ab14$var$getEventFromEventName(eventName) {
    return typeof eventName === 'string' ? eventName : eventName.key;
}
function $36d44ab91368ab14$export$f57f9cc7ce57b7d0(eventDispatcher) {
    return (eventName, data)=>{
        if (!eventName) throw new Error('event name is required!');
        eventDispatcher.emit($36d44ab91368ab14$var$getEventFromEventName(eventName), data);
    };
}
module.exports["EventDispatcher"] = $36d44ab91368ab14$export$ec8b666c5fe2c75a;
module.exports["createDispatch"] = $36d44ab91368ab14$export$f57f9cc7ce57b7d0;

});

parcelRegister("6tl2G", function(module, exports) {

var $6jPem = parcelRequire("6jPem");

const $584b2e64b69fa432$export$dbdec03917c683f4 = (schema, adf)=>{
    let isTransformed = false;
    const { syncBlock: syncBlock, bodiedSyncBlock: bodiedSyncBlock, unsupportedBlock: unsupportedBlock } = schema.nodes;
    if (!unsupportedBlock) return {
        isTransformed: isTransformed,
        transformedAdf: adf
    };
    const transformedAdf = (0, $6jPem.traverse)(adf, {
        syncBlock: (node)=>{
            if (syncBlock) return node;
            isTransformed = true;
            const unsupportedBlockNode = unsupportedBlock.createChecked({
                originalValue: node
            });
            return unsupportedBlockNode.toJSON();
        },
        bodiedSyncBlock: (node)=>{
            if (bodiedSyncBlock) return node;
            isTransformed = true;
            const unsupportedBlockNode = unsupportedBlock.createChecked({
                originalValue: node
            });
            return unsupportedBlockNode.toJSON();
        },
        unsupportedBlock: (node)=>{
            if (!node.attrs?.originalValue) return node;
            if (node.attrs.originalValue.type === 'syncBlock' && syncBlock) {
                isTransformed = true;
                return node.attrs.originalValue;
            } else if (node.attrs.originalValue.type === 'bodiedSyncBlock' && bodiedSyncBlock) {
                isTransformed = true;
                return node.attrs.originalValue;
            }
            return node;
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};




// This is the set of marks that we wont allow in duplicate to
// exist on a given node, regardless of their attributes. We do
// not include annotations here, because we do allow duplicate
// annotations as long as they have unique id attributes (valid scenario)
const $1c2816ef0c8b7188$var$markDuplicatesDisallowed = new Set([
    'strong',
    'underline',
    'textColor',
    'link',
    'em',
    'subsup',
    'strike',
    'backgroundColor'
]);
const $1c2816ef0c8b7188$var$maybeHasDisallowedDuplicateMarks = (node)=>{
    const markTypes = node.marks?.map((mark)=>mark.type)?.filter((markType)=>// For annotations, we are performing the same cheap check
        // for duplicates by type, without considering IDs, to quickly determine
        // whether there may be potential deduping targets.
        // In the actual deduping logic in maybeRemoveDisallowedDuplicateMarks,
        // we correctly/safely dedupe annotations by their unique IDs.
        $1c2816ef0c8b7188$var$markDuplicatesDisallowed.has(markType) || markType === 'annotation');
    if (!markTypes?.length) return false;
    return new Set(markTypes).size !== markTypes.length;
};
const $1c2816ef0c8b7188$var$maybeRemoveDisallowedDuplicateMarks = (node)=>{
    const quota = new Map();
    const annotationsQuota = new Map();
    const discardedMarks = [];
    $1c2816ef0c8b7188$var$markDuplicatesDisallowed.forEach((mark)=>{
        quota.set(mark, false);
    });
    if (!node.marks) return {
        discardedMarks: discardedMarks
    };
    const dedupedMarks = node.marks.filter((mark)=>{
        const markType = mark.type;
        if (markType === 'annotation') {
            const id = mark.attrs?.id;
            if (annotationsQuota.has(id)) {
                discardedMarks.push(mark);
                return false;
            } else {
                annotationsQuota.set(id, true);
                return true;
            }
        }
        if (quota.has(markType)) {
            if (!quota.get(markType)) {
                quota.set(markType, true);
                return true;
            } else {
                discardedMarks.push(mark);
                return false;
            }
        }
        return true;
    });
    return {
        node: {
            ...node,
            marks: dedupedMarks
        },
        discardedMarks: discardedMarks
    };
};
const $1c2816ef0c8b7188$export$af4e387303482581 = (adf)=>{
    let isTransformed = false;
    const discardedMarks = [];
    const transformedAdf = (0, $6jPem.traverse)(adf, {
        text: (node)=>{
            if ($1c2816ef0c8b7188$var$maybeHasDisallowedDuplicateMarks(node)) {
                const result = $1c2816ef0c8b7188$var$maybeRemoveDisallowedDuplicateMarks(node);
                const resultDiscardedMarks = result.discardedMarks;
                if (resultDiscardedMarks.length) {
                    discardedMarks.push(...resultDiscardedMarks);
                    isTransformed = true;
                    return result.node;
                }
            }
            return;
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed,
        discardedMarks: discardedMarks
    };
};




const $c7e8fda47c191e04$var$hasChildHeadingWithIndentation = (node)=>node.content?.some((childNode)=>childNode?.type === 'heading' && childNode?.marks?.some((mark)=>mark.type === 'indentation')) ?? false;
const $c7e8fda47c191e04$var$removeIndentationFromHeadings = (node)=>{
    return {
        ...node,
        content: node.content?.map((childNode)=>{
            if (childNode?.type === 'heading') return {
                ...childNode,
                marks: childNode.marks?.filter((mark)=>mark.type !== 'indentation')
            };
            return childNode;
        })
    };
};
const $c7e8fda47c191e04$export$c06e4b521519af22 = (adf)=>{
    let isTransformed = false;
    const transformedAdf = (0, $6jPem.traverse)(adf, {
        tableCell: (node)=>{
            if ($c7e8fda47c191e04$var$hasChildHeadingWithIndentation(node)) {
                isTransformed = true;
                return $c7e8fda47c191e04$var$removeIndentationFromHeadings(node);
            }
            return;
        },
        tableHeader: (node)=>{
            if ($c7e8fda47c191e04$var$hasChildHeadingWithIndentation(node)) {
                isTransformed = true;
                return $c7e8fda47c191e04$var$removeIndentationFromHeadings(node);
            }
            return;
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};





var $hbEec = parcelRequire("hbEec");

const $5b85afc4a4930f06$var$getChildrenTypeCounts = (nodeContent, allowedTypes)=>{
    const childrenTypes = {};
    nodeContent.forEach((childNode)=>{
        if (!childNode?.type || !allowedTypes.includes(childNode.type)) return;
        if (!childrenTypes[childNode.type]) {
            childrenTypes[childNode.type] = 1;
            return;
        }
        childrenTypes[childNode.type]++;
    });
    return childrenTypes;
};
const $5b85afc4a4930f06$var$removeDuplicatedNodes = (type, content, predicate)=>{
    let maxIterations = 10;
    let childrenTypeCounts = $5b85afc4a4930f06$var$getChildrenTypeCounts(content, [
        type
    ])[type];
    let firstPredicateNodeIndex = content.findIndex(predicate);
    while(childrenTypeCounts > 1 && firstPredicateNodeIndex > -1 && maxIterations-- > 0){
        content.splice(firstPredicateNodeIndex, 1);
        firstPredicateNodeIndex = content.findIndex(predicate);
        childrenTypeCounts = $5b85afc4a4930f06$var$getChildrenTypeCounts(content, [
            type
        ])[type];
    }
};
/**
 * @param  {{[type:string]:number}} allowedTypes - array types allowed to deduplicate
 */ const $5b85afc4a4930f06$var$deduplicateMediaSingleChildren = (node, allowedTypes)=>{
    if (!node.content) return;
    const content = [
        ...node.content
    ];
    Object.keys(allowedTypes).forEach((type)=>{
        //prioritise removing empty nodes first
        $5b85afc4a4930f06$var$removeDuplicatedNodes(type, content, (node)=>node?.type === type && (0, $hbEec.isEmpty)(node));
        //remove other remaining dupicates
        $5b85afc4a4930f06$var$removeDuplicatedNodes(type, content, (node)=>node?.type === type);
    });
    return {
        ...node,
        content: content
    };
};
const $5b85afc4a4930f06$export$1c8c16d74c7a63bf = (adf)=>{
    let isTransformed = false;
    const transformedAdf = (0, $6jPem.traverse)(adf, {
        mediaSingle: (node)=>{
            if (!node?.content?.length) return;
            const disallowedDuplicateTypes = [
                'media',
                'caption'
            ];
            const childrenTypes = $5b85afc4a4930f06$var$getChildrenTypeCounts(node.content, disallowedDuplicateTypes);
            if (Object.values(childrenTypes).some((occurences)=>occurences > 1)) {
                isTransformed = true;
                return $5b85afc4a4930f06$var$deduplicateMediaSingleChildren(node, childrenTypes);
            }
            return;
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};


var $1LHXq = parcelRequire("1LHXq");



const $012dd1aff3a76210$export$abd79dcca4cbaf32 = (adf)=>{
    let isTransformed = false;
    const transformedAdf = (0, $6jPem.traverse)(adf, {
        mediaSingle: (node)=>{
            const { width: width, widthType: widthType } = node.attrs || {};
            // if width is not a number or greater than 100, and widthType is not set, we set width to 100
            if (typeof width === 'number' && width > 100 && !widthType) {
                isTransformed = true;
                const newAttrs = {
                    ...node.attrs,
                    width: 100
                };
                return {
                    ...node,
                    attrs: newAttrs
                };
            }
            return node;
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};


var $dDZcC = parcelRequire("dDZcC");




var $eyfm5 = parcelRequire("eyfm5");

var $2FFuS = parcelRequire("2FFuS");

var $inmjk = parcelRequire("inmjk");

var $8WrQo = parcelRequire("8WrQo");




const $c977c2fbc5484638$var$getMaxColumnsCountForTable = (tableNode)=>{
    let colsInRow = 1;
    tableNode.content?.forEach((childNode)=>{
        if (childNode?.type === 'tableRow' && typeof childNode.content?.length === 'number' && childNode.content.length > colsInRow) colsInRow = childNode.content.length;
    });
    return colsInRow;
};
const $c977c2fbc5484638$var$createValidEmptyContent = (node)=>{
    switch(node.type){
        case 'tableCell':
            return [
                (0, $2FFuS.paragraph)()
            ];
        default:
            return [];
    }
};
const $c977c2fbc5484638$var$fixIfTableCellInvalidEmpty = (reportTransform)=>(node)=>{
        if ((0, $hbEec.isEmpty)(node)) {
            reportTransform();
            return {
                ...node,
                content: $c977c2fbc5484638$var$createValidEmptyContent(node)
            };
        }
        return;
    };
const $c977c2fbc5484638$var$hasNonListItemChildren = (node)=>node.content?.some((node)=>node?.type !== 'listItem');
const $c977c2fbc5484638$var$hasEmptyListItemChildren = (node)=>node.content?.some((childNode)=>childNode?.type === 'listItem' && !childNode.content?.length);
const $c977c2fbc5484638$var$tryCreateValidListItemWrappedChildren = (parentListNode)=>{
    return parentListNode.content?.map((childNode)=>{
        if (childNode) switch(childNode.type){
            case 'listItem':
                if ((0, $hbEec.isEmpty)(childNode)) {
                    const result = (0, $eyfm5.listItem)([
                        (0, $2FFuS.paragraph)()
                    ]);
                    return result;
                }
                return childNode;
            case 'text':
                return (0, $eyfm5.listItem)([
                    (0, $2FFuS.paragraph)(childNode)
                ]);
            default:
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                return (0, $eyfm5.listItem)([
                    childNode
                ]);
        }
        return childNode;
    });
};
const $c977c2fbc5484638$var$fixIfListParentWithInvalidListItemChildren = (reportTransform)=>(node)=>{
        if ($c977c2fbc5484638$var$hasNonListItemChildren(node) || $c977c2fbc5484638$var$hasEmptyListItemChildren(node)) {
            reportTransform();
            return {
                ...node,
                content: $c977c2fbc5484638$var$tryCreateValidListItemWrappedChildren(node)
            };
        }
        return;
    };
const $c977c2fbc5484638$var$hasNonTableRowChildren = (node)=>node.content?.some((node)=>node?.type !== 'tableRow');
const $c977c2fbc5484638$var$tryCreateValidTableRowWrappedChildren = (parentTableNode)=>{
    const maxColsCount = $c977c2fbc5484638$var$getMaxColumnsCountForTable(parentTableNode);
    return parentTableNode.content?.map((childNode)=>{
        if (childNode) switch(childNode.type){
            case 'text':
                return (0, $8WrQo.tableRow)([
                    (0, $inmjk.tableCell)({})((0, $2FFuS.paragraph)(childNode)),
                    ...new Array(maxColsCount - 1).fill((0, $inmjk.tableCell)({})((0, $2FFuS.paragraph)()))
                ]);
            case 'tableCell':
                return (0, $8WrQo.tableRow)([
                    childNode
                ]);
            case 'tableRow':
                if ((0, $hbEec.isEmpty)(childNode)) return (0, $8WrQo.tableRow)([
                    ...new Array(maxColsCount).fill((0, $inmjk.tableCell)({})((0, $2FFuS.paragraph)()))
                ]);
                return childNode;
            default:
                return childNode;
        }
        return childNode;
    });
};
const $c977c2fbc5484638$var$hasEmptyTableRowChildren = (node)=>node?.content?.some((node)=>node?.type === 'tableRow' && node?.content?.length === 0) || undefined;
const $c977c2fbc5484638$var$fixIfTableParentWithInvalidTableRowChildren = (reportTransform)=>(node)=>{
        if ($c977c2fbc5484638$var$hasEmptyTableRowChildren(node) || $c977c2fbc5484638$var$hasNonTableRowChildren(node)) {
            reportTransform();
            return {
                ...node,
                content: $c977c2fbc5484638$var$tryCreateValidTableRowWrappedChildren(node)
            };
        }
        return;
    };
const $c977c2fbc5484638$var$removeMediaSingleWithNoContent = (reportTransform)=>(node)=>{
        if ((0, $hbEec.isEmpty)(node)) {
            reportTransform();
            return false;
        }
        return;
    };
const $c977c2fbc5484638$export$652814b83c30d251 = (adf)=>{
    let isTransformed = false;
    const reportTransform = ()=>{
        isTransformed = true;
    };
    let transformedAdf = (0, $6jPem.traverse)(adf, {
        tableCell: $c977c2fbc5484638$var$fixIfTableCellInvalidEmpty(reportTransform)
    });
    // Empty mediaSingle nodes get stripped from the document and so this transform
    // will create an empty listItem if the media node is in a list. Empty listItems
    // are invalid adf, so we need to transform the mediaSingle nodes first.
    transformedAdf = (0, $6jPem.traverse)(transformedAdf || adf, {
        mediaSingle: $c977c2fbc5484638$var$removeMediaSingleWithNoContent(reportTransform)
    });
    transformedAdf = (0, $6jPem.traverse)(transformedAdf || adf, {
        bulletList: $c977c2fbc5484638$var$fixIfListParentWithInvalidListItemChildren(reportTransform),
        orderedList: $c977c2fbc5484638$var$fixIfListParentWithInvalidListItemChildren(reportTransform),
        table: $c977c2fbc5484638$var$fixIfTableParentWithInvalidTableRowChildren(reportTransform)
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};




const $8fc0fe8ad0751ae2$var$hasLinkAndCodeMarks = (node)=>{
    const marks = node.marks?.map((mark)=>mark.type);
    return marks?.includes('link') && marks?.includes('code');
};
const $8fc0fe8ad0751ae2$var$removeCodeMarks = (node)=>{
    if (node.marks) return {
        ...node,
        marks: node.marks.filter((mark)=>mark.type !== 'code')
    };
    return node;
};
const $8fc0fe8ad0751ae2$export$3d531d2daf0e8a14 = (adf)=>{
    let isTransformed = false;
    const transformedAdf = (0, $6jPem.traverse)(adf, {
        text: (node)=>{
            if ($8fc0fe8ad0751ae2$var$hasLinkAndCodeMarks(node)) {
                isTransformed = true;
                return $8fc0fe8ad0751ae2$var$removeCodeMarks(node);
            }
            return;
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};



var $5SAOw = parcelRequire("5SAOw");


var $dh538 = parcelRequire("dh538");


var $d925B = parcelRequire("d925B");


var $hpdQE = parcelRequire("hpdQE");


var $juTiU = parcelRequire("juTiU");


var $6aq5c = parcelRequire("6aq5c");

const $c8ab5aa71274e362$var$transformNestedTablesWithAnalytics = (node, dispatchAnalyticsEvent)=>{
    try {
        const { transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $dDZcC.transformNestedTablesIncomingDocument)(node);
        if (isTransformed && dispatchAnalyticsEvent) {
            dispatchAnalyticsEvent({
                action: (0, $d925B.ACTION).NESTED_TABLE_TRANSFORMED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
            });
            return {
                transformedAdf: transformedAdf,
                isTransformed: isTransformed
            };
        }
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error('Failed to transform one or more nested tables in the document');
        if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $d925B.ACTION).DOCUMENT_PROCESSING_ERROR,
            actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
            attributes: {
                errorMessage: `${e instanceof Error && e.name === 'NodeNestingTransformError' ? 'NodeNestingTransformError - Failed to transform one or more nested tables' : undefined}`
            }
        });
    }
    return {
        transformedAdf: node,
        isTransformed: false
    };
};
function $c8ab5aa71274e362$export$cafe23194e65f591(schema, value, dispatchAnalyticsEvent) {
    if (!value) return;
    let node;
    if (typeof value === 'string') try {
        node = JSON.parse(value);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(`Error processing value: ${value} isn't a valid JSON`);
        return;
    }
    else node = value;
    // Convert nested-table extensions into nested tables
    let { transformedAdf: transformedAdf } = $c8ab5aa71274e362$var$transformNestedTablesWithAnalytics(node, dispatchAnalyticsEvent);
    if ((0, $dh538.fg)('platform_editor_sync_block_fallback_transform')) {
        const result = (0, $584b2e64b69fa432$export$dbdec03917c683f4)(schema, transformedAdf);
        if (result.isTransformed && result.transformedAdf) transformedAdf = result.transformedAdf;
    }
    return (0, $5SAOw.Node).fromJSON(schema, transformedAdf);
}
function $c8ab5aa71274e362$export$f1a0a61081c3ed62(schema, value, providerFactory, sanitizePrivateContent, contentTransformer, dispatchAnalyticsEvent) {
    if (!value) return;
    let node;
    if (typeof value === 'string') try {
        if (contentTransformer) {
            const doc = contentTransformer.parse(value);
            node = doc.toJSON();
        } else node = JSON.parse(value);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(`Error processing value: ${value} isn't a valid JSON`);
        return;
    }
    else node = value;
    if (Array.isArray(node)) {
        // eslint-disable-next-line no-console
        console.error(`Error processing value: ${node} is an array, but it must be an object.`);
        return;
    }
    try {
        // ProseMirror always require a child under doc
        if (node.type === 'doc') {
            if (Array.isArray(node.content) && node.content.length === 0) node.content.push({
                type: 'paragraph',
                content: []
            });
            // Just making sure doc is always valid
            if (!node.version) node.version = 1;
        }
        if (contentTransformer) return (0, $5SAOw.Node).fromJSON(schema, node);
        // link mark on mediaSingle is deprecated, need to move link mark to child media node
        // https://product-fabric.atlassian.net/browse/ED-14043
        let { transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $1LHXq.transformMediaLinkMarks)(node);
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $d925B.ACTION).MEDIA_LINK_TRANSFORMED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
        });
        if ((0, $dh538.fg)('platform_editor_transform_invalid_media_width')) {
            // Fix mediaSingle width issues
            ({ transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $012dd1aff3a76210$export$abd79dcca4cbaf32)(transformedAdf));
            if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
                action: (0, $d925B.ACTION).MEDIA_SINGLE_WIDTH_TRANSFORMED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
            });
        }
        // See: HOT-97965 https://product-fabric.atlassian.net/browse/ED-14400
        // We declared in code mark spec that links and marks should not co-exist on
        // text nodes. This util strips code marks from bad text nodes and preserves links.
        // Otherwise, prosemirror will try to repair the invalid document by stripping links
        // and preserving code marks during content changes.
        ({ transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $8fc0fe8ad0751ae2$export$3d531d2daf0e8a14)(transformedAdf));
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $d925B.ACTION).TEXT_LINK_MARK_TRANSFORMED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
        });
        let discardedMarks = [];
        ({ transformedAdf: transformedAdf, isTransformed: isTransformed, discardedMarks: discardedMarks } = (0, $1c2816ef0c8b7188$export$af4e387303482581)(transformedAdf));
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $d925B.ACTION).DEDUPE_MARKS_TRANSFORMED_V2,
            actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
            attributes: {
                /** UGC WARNING
					 *
					 * DO NOT include the `mark` attributes inside, we map here to only
					 * extract the mark type as that is the only non-UGC safe information
					 * that we can add to event-attributes
					 *
					 */ discardedMarkTypes: discardedMarks.map((mark)=>mark.type)
            }
        });
        ({ transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $c977c2fbc5484638$export$652814b83c30d251)(transformedAdf));
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $d925B.ACTION).NODES_MISSING_CONTENT_TRANSFORMED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
        });
        ({ transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $c7e8fda47c191e04$export$c06e4b521519af22)(transformedAdf));
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $d925B.ACTION).INDENTATION_MARKS_TRANSFORMED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
        });
        ({ transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $5b85afc4a4930f06$export$1c8c16d74c7a63bf)(transformedAdf));
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $d925B.ACTION).INVALID_MEDIA_CONTENT_TRANSFORMED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
        });
        // Convert nested-table extensions into nested tables
        ({ transformedAdf: transformedAdf } = $c8ab5aa71274e362$var$transformNestedTablesWithAnalytics(transformedAdf, dispatchAnalyticsEvent));
        if (dispatchAnalyticsEvent) {
            const hasSingleColumnLayout = transformedAdf.content?.some((node)=>node && node.type === 'layoutSection' && node.content?.length === 1);
            if (hasSingleColumnLayout) dispatchAnalyticsEvent({
                action: (0, $d925B.ACTION).SINGLE_COL_LAYOUT_DETECTED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
            });
        }
        const entity = (0, $6aq5c.validateADFEntity)(schema, transformedAdf || node, dispatchAnalyticsEvent);
        const newEntity = $c8ab5aa71274e362$var$maySanitizePrivateContent(entity, providerFactory, sanitizePrivateContent);
        const parsedDoc = (0, $5SAOw.Node).fromJSON(schema, newEntity);
        // throws an error if the document is invalid
        try {
            parsedDoc.check();
        } catch (err) {
            if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
                action: (0, $d925B.ACTION).INVALID_PROSEMIRROR_DOCUMENT,
                actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
            });
            throw err;
        }
        if (dispatchAnalyticsEvent) (0, $juTiU.findAndTrackUnsupportedContentNodes)(parsedDoc, schema, dispatchAnalyticsEvent);
        return parsedDoc;
    } catch (e) {
        if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $d925B.ACTION).DOCUMENT_PROCESSING_ERROR,
            actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
        });
        // eslint-disable-next-line no-console
        console.error(`Error processing document:\n${e instanceof Error ? e.message : String(e)}\n\n`, JSON.stringify(node));
        if ($c8ab5aa71274e362$var$isProseMirrorSchemaCheckError(e)) throw e;
        return;
    }
}
function $c8ab5aa71274e362$export$89b7989c347e6a7b(schema, value, providerFactory, sanitizePrivateContent, contentTransformer, dispatchAnalyticsEvent) {
    if (!value) return;
    const adfEntities = value.map((item)=>$c8ab5aa71274e362$export$f1a0a61081c3ed62(schema, item, providerFactory, sanitizePrivateContent, contentTransformer, dispatchAnalyticsEvent)).filter((item)=>Boolean(item));
    if (adfEntities.length === 0) return;
    return (0, $5SAOw.Fragment).from(adfEntities);
}
function $c8ab5aa71274e362$var$isProseMirrorSchemaCheckError(error) {
    return error instanceof RangeError && // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    (!!error.message.match(/^Invalid collection of marks for node/) || // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    !!error.message.match(/^Invalid content for node/));
}
const $c8ab5aa71274e362$var$maySanitizePrivateContent = (entity, providerFactory, sanitizePrivateContent)=>{
    if (sanitizePrivateContent && providerFactory) return (0, $hpdQE.sanitizeNodeForPrivacy)(entity, providerFactory);
    return entity;
};
module.exports["processRawValueWithoutValidation"] = $c8ab5aa71274e362$export$cafe23194e65f591;
module.exports["processRawValue"] = $c8ab5aa71274e362$export$f1a0a61081c3ed62;
module.exports["processRawFragmentValue"] = $c8ab5aa71274e362$export$89b7989c347e6a7b;

});

parcelRegister("hbEec", function(module, exports) {
const $5f601bcc1718fb0b$export$dd1bc94b04021eeb = (node)=>!node?.content?.length;
module.exports["isEmpty"] = $5f601bcc1718fb0b$export$dd1bc94b04021eeb;

});

parcelRegister("eyfm5", function(module, exports) {
const $6fd46c311db8d44c$export$76c7e83ecc9cdf05 = (content)=>({
        type: 'listItem',
        content: content
    });
module.exports["listItem"] = $6fd46c311db8d44c$export$76c7e83ecc9cdf05;

});

parcelRegister("2FFuS", function(module, exports) {

var $aoDcQ = parcelRequire("aoDcQ");

function $b397a3d9dc60a40a$export$3a269a5941b62f04(nodes) {
    return nodes.map($b397a3d9dc60a40a$export$72b9432ea0656b50);
}
function $b397a3d9dc60a40a$export$72b9432ea0656b50(str) {
    return typeof str === 'string' ? (0, $aoDcQ.text)(str) : str;
}


const $a4fc62108e90d067$export$9c206ddddb32a9b = (...content)=>({
        type: 'paragraph',
        content: (0, $b397a3d9dc60a40a$export$3a269a5941b62f04)(content)
    });
module.exports["paragraph"] = $a4fc62108e90d067$export$9c206ddddb32a9b;

});

parcelRegister("aoDcQ", function(module, exports) {
const $cb8b1b1eb7a280a9$export$6f093cfa640b7166 = (text)=>({
        type: 'text',
        text: text
    });
module.exports["text"] = $cb8b1b1eb7a280a9$export$6f093cfa640b7166;

});

parcelRegister("inmjk", function(module, exports) {
const $c51384942fa452cc$export$e1e720e5f4603e6a = (attrs)=>(...content)=>({
            type: 'tableCell',
            attrs: attrs,
            content: content
        });
module.exports["tableCell"] = $c51384942fa452cc$export$e1e720e5f4603e6a;

});

parcelRegister("8WrQo", function(module, exports) {
const $e620d19b8ea2ca65$export$ce666bf02318c957 = (content)=>({
        type: 'tableRow',
        content: content
    });
module.exports["tableRow"] = $e620d19b8ea2ca65$export$ce666bf02318c957;

});

parcelRegister("hpdQE", function(module, exports) {

var $6jPem = parcelRequire("6jPem");


var $bqMS3 = parcelRequire("bqMS3");

function $5dc3e3095b1b3f43$export$8a32f625580e0a06(json, providerFactory) {
    const mentionNames = new Map();
    let hasCacheableMentions = false;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const sanitizedJSON = (0, $6jPem.traverse)(json, {
        mention: (node)=>{
            if (node.attrs && node.attrs.text) {
                hasCacheableMentions = true;
                // Remove @ prefix
                const text = node.attrs.text;
                const name = text.startsWith('@') ? text.slice(1) : text;
                mentionNames.set(node.attrs.id, name);
            }
            return {
                ...node,
                attrs: {
                    ...node.attrs,
                    text: ''
                }
            };
        }
    });
    if (hasCacheableMentions && providerFactory) {
        const handler = (_name, providerPromise)=>{
            if (providerPromise) providerPromise.then((provider)=>{
                if ((0, $bqMS3.isResolvingMentionProvider)(provider)) {
                    mentionNames.forEach((name, id)=>{
                        provider.cacheMentionName(id, name);
                    });
                    mentionNames.clear();
                    providerFactory.unsubscribe('mentionProvider', handler);
                }
            });
        };
        providerFactory.subscribe('mentionProvider', handler);
    }
    return sanitizedJSON;
}
module.exports["sanitizeNodeForPrivacy"] = $5dc3e3095b1b3f43$export$8a32f625580e0a06;

});

parcelRegister("auTg8", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4xcIM = parcelRequire("4xcIM");


var $jZrBc = parcelRequire("jZrBc");


var $fswVK = parcelRequire("fswVK");

const $f19f4e00be795c13$export$b119c82498f162a5 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext((0, $jZrBc.EditorContext));
class $f19f4e00be795c13$export$797df872f5526664 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    render() {
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f19f4e00be795c13$var$LegacyEditorContextNew, this.props, this.props.children);
    }
    constructor(props){
        super(props);
    }
}
function $f19f4e00be795c13$var$LegacyEditorContextNew({ children: children, editorActions: editorActions }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jZrBc.EditorContext).Provider, {
        value: {
            editorActions: editorActions ?? new (0, $fswVK.default)()
        }
    }, children);
}
class $f19f4e00be795c13$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    getChildContext() {
        return {
            editorActions: this.editorActions
        };
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jZrBc.EditorContext).Provider, {
            value: this.getChildContext()
        }, this.props.children);
    }
    constructor(props){
        super(props);
        this.editorActions = void 0;
        this.editorActions = props.editorActions || new (0, $fswVK.default)();
    }
}
$f19f4e00be795c13$export$2e2bcd8739ae039.childContextTypes = {
    editorActions: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object
};
module.exports["useEditorContext"] = $f19f4e00be795c13$export$b119c82498f162a5;
module.exports["default"] = $f19f4e00be795c13$export$2e2bcd8739ae039;

});

parcelRegister("jZrBc", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $ff30c9f22b7e82bd$export$27b8dd149e32f6c7 = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({});
module.exports["EditorContext"] = $ff30c9f22b7e82bd$export$27b8dd149e32f6c7;

});

parcelRegister("6DQRK", function(module, exports) {

var $9ciHB = parcelRequire("9ciHB");

function $157ce49029366e0b$var$verifyJSON(json) {
    try {
        return JSON.parse(json);
    } catch (e) {
        return undefined;
    }
}
function $157ce49029366e0b$var$getSpellCheck(featureFlags) {
    if (!!featureFlags?.['disableSpellcheckByBrowser']) return typeof featureFlags?.['disableSpellcheckByBrowser'] === 'object' ? featureFlags?.['disableSpellcheckByBrowser'] : typeof featureFlags?.['disableSpellcheckByBrowser'] === 'string' ? $157ce49029366e0b$var$verifyJSON(featureFlags?.['disableSpellcheckByBrowser']) : undefined;
    if (!!featureFlags?.['disable-spellcheck-by-browser']) return typeof featureFlags?.['disable-spellcheck-by-browser'] === 'object' ? featureFlags?.['disable-spellcheck-by-browser'] : typeof featureFlags?.['disable-spellcheck-by-browser'] === 'string' ? $157ce49029366e0b$var$verifyJSON(featureFlags?.['disable-spellcheck-by-browser']) : undefined;
    return undefined;
}
function $157ce49029366e0b$export$63102b0cbe181144(featureFlags) {
    const normalizedFeatureFlags = (0, $9ciHB.normalizeFeatureFlags)(featureFlags);
    return {
        ...normalizedFeatureFlags,
        catchAllTracking: false,
        showAvatarGroupAsPlugin: Boolean(typeof featureFlags?.showAvatarGroupAsPlugin === 'boolean' ? !!featureFlags?.showAvatarGroupAsPlugin : false),
        errorBoundaryDocStructure: Boolean(typeof featureFlags?.useErrorBoundaryDocStructure === 'boolean' ? !!featureFlags?.useErrorBoundaryDocStructure : false),
        synchronyErrorDocStructure: Boolean(typeof featureFlags?.synchronyErrorDocStructure === 'boolean' ? !!featureFlags?.synchronyErrorDocStructure : false),
        enableViewUpdateSubscription: Boolean(typeof featureFlags?.enableViewUpdateSubscription === 'boolean' ? !!featureFlags?.enableViewUpdateSubscription : false),
        collabAvatarScroll: Boolean(typeof featureFlags?.collabAvatarScroll === 'boolean' ? !!featureFlags?.collabAvatarScroll : false),
        twoLineEditorToolbar: Boolean(typeof featureFlags?.twoLineEditorToolbar === 'boolean' ? !!featureFlags?.twoLineEditorToolbar : false),
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        disableSpellcheckByBrowser: $157ce49029366e0b$var$getSpellCheck(featureFlags)
    };
}
module.exports["createFeatureFlagsFromProps"] = $157ce49029366e0b$export$63102b0cbe181144;

});

parcelRegister("7lreV", function(module, exports) {
$parcel$export(module.exports, "default", () => $2a614873fe7dde33$export$2e2bcd8739ae039);
var $2a614873fe7dde33$export$2e2bcd8739ae039 = {
    EDITOR_MOUNTED: 'Editor Component Mount Time',
    PROSEMIRROR_RENDERED: 'ProseMirror Render Time',
    PROSEMIRROR_CONTENT_RENDERED: 'ProseMirror Content Render Time',
    ON_EDITOR_READY_CALLBACK: 'onEditorReady Callback Duration'
};

});

parcelRegister("75KVc", function(module, exports) {
const $23e0513e23b2d5c1$export$a8ff84c12d48cfa6 = "platform-pkg";
const $23e0513e23b2d5c1$export$83d89fbfd8236492 = "0.0.0-use.local";
module.exports["name"] = $23e0513e23b2d5c1$export$a8ff84c12d48cfa6;
module.exports["version"] = $23e0513e23b2d5c1$export$83d89fbfd8236492;

});

parcelRegister("56Wjx", function(module, exports) {
const $34f2b048c002519b$var$hash = {
    nodes: {
        doc: 'doc',
        paragraph: 'p',
        text: 't',
        bulletList: 'ul',
        orderedList: 'ol',
        listItem: 'li',
        heading: 'h',
        blockquote: 'blockq',
        codeBlock: 'codebl',
        panel: 'pnl',
        rule: 'rl',
        hardBreak: 'br',
        mention: 'ment',
        emoji: 'emj',
        image: 'img',
        caption: 'cap',
        media: 'media',
        mediaGroup: 'mediag',
        mediaSingle: 'medias',
        plain: 'pln',
        table: 'table',
        tableCell: 'td',
        tableHeader: 'th',
        tableRow: 'tr',
        decisionList: 'dl',
        decisionItem: 'di',
        taskList: 'tl',
        taskItem: 'ti',
        extension: 'ext',
        inlineExtension: 'exti',
        bodiedExtension: 'extb',
        multiBodiedExtension: 'extmbe',
        extensionFrame: 'extfrm',
        status: 'sts',
        placeholder: 'plh',
        inlineCard: 'cardi',
        blockCard: 'cardb',
        embedCard: 'carde',
        expand: 'exp',
        nestedExpand: 'expn',
        unsupportedBlock: 'unsupb',
        unsupportedInline: 'unsupi',
        unknownBlock: 'unkb',
        date: 'date'
    },
    marks: {
        em: 'em',
        strong: 'strong',
        code: 'code',
        strike: 'strike',
        underline: 'undline',
        link: 'lnk',
        subsup: 'subsup',
        textColor: 'txtclr',
        unsupportedMark: 'unsupmrk',
        unsupportedNodeAttribute: 'unsupnattr',
        annotation: 'anno'
    }
};
function $34f2b048c002519b$var$shortHash(type, isMark) {
    const code = $34f2b048c002519b$var$hash[isMark ? 'marks' : 'nodes'][type];
    return code ? code : type;
}
function $34f2b048c002519b$var$compactStringifier(node) {
    const isContentEmpty = !node.content;
    const isTextNode = node?.type === 'text';
    const hasMarks = node.marks?.length;
    const isContentArray = Array.isArray(node.content);
    const marks = (child)=>{
        if (hasMarks) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return node.marks.reduce((str, mark)=>`${$34f2b048c002519b$var$shortHash(mark, true)}(${str})`, child);
        return child;
    };
    let content;
    if (isTextNode) content = String(node.nodeSize);
    else if (isContentEmpty) content = '';
    else if (isContentArray) // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    content = node.content.map((node)=>$34f2b048c002519b$var$compactStringifier(node)).join(',');
    return marks(`${$34f2b048c002519b$var$shortHash(node.type, false)}(${content})`);
}
const $34f2b048c002519b$export$6451b72139862cbd = (doc, options)=>{
    try {
        const result = $34f2b048c002519b$var$getBlockNode(doc, 0);
        if (options?.compact) return $34f2b048c002519b$var$compactStringifier(result);
        return result;
    } catch (error) {
        return `Error logging document structure: ${error}`;
    }
};
const $34f2b048c002519b$var$getBlockNode = (node, pos)=>{
    const blockNode = {
        type: node.type.name,
        pos: pos,
        nodeSize: node.nodeSize
    };
    const content = $34f2b048c002519b$var$getBlockNodeContent(node.content, pos);
    if (content.length > 0) blockNode.content = content;
    const marks = $34f2b048c002519b$var$getMarks(node);
    if (marks.length > 0) blockNode.marks = marks;
    return blockNode;
};
const $34f2b048c002519b$var$getBlockNodeContent = (node, pos)=>{
    if (!node || !node.content || !node.content.length) return [];
    let blockNodeContent = [];
    const { content: content } = node;
    if (content[0].isBlock) {
        // children are block nodes
        let prevNode;
        blockNodeContent = content.map((node)=>{
            pos += prevNode ? prevNode.nodeSize : 1;
            prevNode = node;
            return $34f2b048c002519b$var$getBlockNode(node, pos);
        });
    } else {
        // children are inline nodes .
        const result = $34f2b048c002519b$var$getInlineNodes(content, pos);
        blockNodeContent = result.inlineNodes;
        pos = result.pos;
    }
    return blockNodeContent;
};
const $34f2b048c002519b$var$getInlineNodes = (nodes, pos)=>{
    const inlineNodes = nodes.map((node)=>{
        const { nodeSize: nodeSize } = node;
        const inlineNode = {
            type: node.type.name,
            pos: pos,
            nodeSize: nodeSize
        };
        const marks = $34f2b048c002519b$var$getMarks(node);
        if (marks.length > 0) inlineNode.marks = marks;
        pos += nodeSize;
        return inlineNode;
    });
    return {
        inlineNodes: inlineNodes,
        pos: pos
    };
};
const $34f2b048c002519b$var$getMarks = (node)=>node.marks.map((mark)=>mark.type.name);
module.exports["getDocStructure"] = $34f2b048c002519b$export$6451b72139862cbd;

});

parcelRegister("bn5lP", function(module, exports) {
$parcel$export(module.exports, "default", () => $024596570cb688e3$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $gmMgo = parcelRequire("gmMgo");


var $cUcZ5 = parcelRequire("cUcZ5");


var $d925B = parcelRequire("d925B");

var $ajtqX = parcelRequire("ajtqX");

var $e2wMq = parcelRequire("e2wMq");


var $eTj7Y = parcelRequire("eTj7Y");


var $5vVM5 = parcelRequire("5vVM5");


var $9HtP4 = parcelRequire("9HtP4");

var $7541v = parcelRequire("7541v");


var $92LVN = parcelRequire("92LVN");


var $9ciHB = parcelRequire("9ciHB");


var $jz9wK = parcelRequire("jz9wK");


var $8pwxt = parcelRequire("8pwxt");


var $a4TK8 = parcelRequire("a4TK8");


var $8Yfbq = parcelRequire("8Yfbq");


var $5SAOw = parcelRequire("5SAOw");


var $dh538 = parcelRequire("dh538");


var $b7atO = parcelRequire("b7atO");


var $6tl2G = parcelRequire("6tl2G");


var $gmyMu = parcelRequire("gmyMu");


var $h9yJL = parcelRequire("h9yJL");










const $c623ea262c2cbc76$var$transformer = new (0, $h9yJL.JSONTransformer)();
function $c623ea262c2cbc76$export$54fd2c36b5cc6731(node) {
    return $c623ea262c2cbc76$var$transformer.encode(node);
}
function $c623ea262c2cbc76$export$6a1dd68d75badcc7(callback) {
    let frameId;
    let lastArgs;
    const delayedCallbacks = [];
    const wrapperFn = (...args)=>{
        const lastArgsBefore = lastArgs;
        lastArgs = args;
        if (frameId) {
            if ((0, $dh538.fg)('aifc_create_enabled')) {
                if (lastArgsBefore) {
                    const [_v, _c, _t, _f, alwaysFire] = lastArgsBefore;
                    if (alwaysFire) delayedCallbacks.push(lastArgsBefore);
                }
            }
            return;
        }
        // If `requestIdleCallback` doesn't exist - fallback to `requestAnimationFrame`
        const delayFunction = globalThis.requestIdleCallback ?? globalThis.requestAnimationFrame;
        frameId = delayFunction(()=>{
            frameId = undefined;
            if (lastArgs) {
                if ((0, $dh538.fg)('aifc_create_enabled')) delayedCallbacks.forEach((savedArgs)=>{
                    callback(...savedArgs);
                });
                callback(...lastArgs);
            }
        }, {
            timeout: 100
        });
    };
    return wrapperFn;
}
function $c623ea262c2cbc76$export$dce79649e5264171(editorView, callback, transformer, fireAnalyticsEvent, alwaysFire) {
    const { doc: doc, schema: schema } = editorView?.state ?? {};
    if (!doc || !schema) return undefined;
    try {
        const json = $c623ea262c2cbc76$export$54fd2c36b5cc6731(doc);
        if (typeof transformer === 'undefined') callback(json);
        else {
            const nodeSanitized = (0, $5SAOw.Node).fromJSON(schema, json);
            callback(transformer.encode(nodeSanitized));
        }
    } catch (e) {
        fireAnalyticsEvent?.({
            payload: {
                action: (0, $d925B.ACTION).DOCUMENT_PROCESSING_ERROR,
                actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    errorMessage: `${e instanceof Error && e.name === 'NodeNestingTransformError' ? 'NodeNestingTransformError - Failed to transform one or more nested tables' : undefined}`
                }
            }
        });
        throw e;
    }
}


const $9e9cac93742fed46$export$71ab138dd170c35 = ({ config: config })=>{
    // Create the document request throttler per editor (rather than at a module level)
    const scheduleDocumentRequest = (0, $c623ea262c2cbc76$export$6a1dd68d75badcc7)((0, $c623ea262c2cbc76$export$dce79649e5264171));
    return {
        name: 'core',
        getSharedState (state) {
            return {
                schema: state?.schema
            };
        },
        actions: {
            execute: (command)=>{
                const editorView = config?.getEditorView();
                if (!editorView || !command) return false;
                const { state: state, dispatch: dispatch } = editorView;
                return (0, $gmyMu.editorCommandToPMCommand)(command)(state, dispatch);
            },
            // Code copied from `EditorActions.focus()`
            focus: (options)=>{
                const editorView = config?.getEditorView();
                if (!editorView || editorView.hasFocus()) return false;
                editorView.focus();
                if (options?.scrollIntoView ?? true) editorView.dispatch(editorView.state.tr.scrollIntoView());
                return true;
            },
            // Code copied from `EditorActions.blur()`
            blur: ()=>{
                const editorView = config?.getEditorView();
                if (!editorView || !editorView.hasFocus()) return false;
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                editorView.dom.blur();
                return true;
            },
            scrollToPos (pos, scrollOptions) {
                const editorView = config?.getEditorView();
                if (!editorView) return false;
                const tr = editorView.state.tr;
                const isValidPos = typeof pos === 'number' && pos >= 0 && pos <= tr.doc.content.size;
                if (!isValidPos) return false;
                const dom = editorView.domAtPos(pos).node;
                if (!(dom instanceof Element)) {
                    // If it's not an element (e.g. #text node), we'll try the parent.
                    // This is expected to cover most of the scenarios, if not, window.scrollTo is an alternative
                    if (dom.parentNode instanceof Element) {
                        dom.parentNode.scrollIntoView(scrollOptions);
                        return true;
                    }
                    return false;
                }
                dom.scrollIntoView(scrollOptions);
                return true;
            },
            replaceDocument: (replaceValue, options)=>{
                const editorView = config?.getEditorView();
                if (!editorView || replaceValue === undefined || replaceValue === null) return false;
                const { state: state } = editorView;
                const { schema: schema } = state;
                const content = options?.skipValidation ? (0, $6tl2G.processRawValueWithoutValidation)(schema, replaceValue) : Array.isArray(replaceValue) ? (0, $6tl2G.processRawFragmentValue)(schema, replaceValue) : (0, $6tl2G.processRawValue)(schema, replaceValue);
                // Don't replace the document if it's the same document, as full size
                // replace transactions cause issues for collaborative editing and
                // content reconciliation (eg. inline comments getting dropped)
                if (content instanceof (0, $5SAOw.Node) && state.doc.eq(content)) return false;
                if (content) {
                    const tr = state.tr.replaceWith(0, state.doc.nodeSize - 2, content);
                    if (options?.addToHistory === false) tr.setMeta('addToHistory', false);
                    if (options?.scrollIntoView ?? true) editorView.dispatch(tr.scrollIntoView());
                    else if ((0, $dh538.fg)('aifc_create_enabled')) editorView.dispatch(tr.setMeta('scrollIntoView', false));
                    return true;
                }
                return false;
            },
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            requestDocument (onReceive, options) {
                const view = config?.getEditorView() ?? null;
                scheduleDocumentRequest(view, onReceive, options?.transformer, config?.fireAnalyticsEvent, options?.alwaysFire);
            },
            createTransformer (cb) {
                const view = config?.getEditorView() ?? null;
                if (!view?.state.schema) return undefined;
                return cb(view?.state.schema);
            },
            getAnchorIdForNode (node, pos) {
                const view = config?.getEditorView() ?? null;
                if (!view) return undefined;
                const nodeIdProvider = (0, $b7atO.getNodeIdProvider)(view);
                const cachedId = nodeIdProvider.getIdForNode(node);
                if (cachedId) return cachedId;
                if (pos < 0) return undefined;
                if ((0, $dh538.fg)('platform_editor_ai_local_id_short')) {
                    const generatedId = nodeIdProvider.getOrGenerateId(node, pos);
                    if (generatedId) return generatedId;
                }
                const nodeDOM = view.nodeDOM(pos);
                if (nodeDOM instanceof HTMLElement) return nodeDOM.getAttribute('data-node-anchor') || undefined;
                return undefined;
            }
        }
    };
};


function $a71d406c80bedd2b$var$hasGetSharedState(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
plugin) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return typeof plugin.getSharedState === 'function';
}
function $a71d406c80bedd2b$var$hasActions(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
plugin) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return typeof plugin.actions === 'object';
}
function $a71d406c80bedd2b$var$hasCommands(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
plugin) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return typeof plugin.commands === 'object';
}
const $a71d406c80bedd2b$var$filterPluginsWithListeners = ({ listeners: listeners, plugins: plugins })=>Array.from(listeners.keys()).map((pluginName)=>plugins.get(pluginName)).filter((plugin)=>plugin !== undefined && $a71d406c80bedd2b$var$hasGetSharedState(plugin));
const $a71d406c80bedd2b$var$extractSharedStateFromPlugins = ({ oldEditorState: oldEditorState, newEditorState: newEditorState, plugins: plugins })=>{
    const isInitialization = !oldEditorState && newEditorState;
    const result = new Map();
    for (const plugin of plugins){
        if (!plugin || !$a71d406c80bedd2b$var$hasGetSharedState(plugin)) continue;
        const nextSharedState = plugin.getSharedState(newEditorState);
        const prevSharedState = !isInitialization && oldEditorState ? plugin.getSharedState(oldEditorState) : undefined;
        const isSamePluginState = (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(prevSharedState, nextSharedState);
        if (isInitialization || !isSamePluginState) result.set(plugin.name, {
            nextSharedState: nextSharedState,
            prevSharedState: prevSharedState
        });
    }
    return result;
};
const $a71d406c80bedd2b$var$THROTTLE_CALLS_FOR_MILLISECONDS = 0;
const $a71d406c80bedd2b$var$notifyListenersThrottled = (0, (/*@__PURE__*/$parcel$interopDefault($8Yfbq)))(({ listeners: listeners, updatesToNotifyQueue: updatesToNotifyQueue })=>{
    const callbacks = [];
    for (const [pluginName, diffs] of updatesToNotifyQueue.entries()){
        const pluginListeners = listeners.get(pluginName) || [];
        pluginListeners.forEach((callback)=>{
            diffs.forEach((diff)=>{
                callbacks.push(callback.bind(callback, diff));
            });
        });
    }
    updatesToNotifyQueue.clear();
    if (callbacks.length === 0) return;
    callbacks.reverse().forEach((cb)=>{
        cb();
    });
}, $a71d406c80bedd2b$var$THROTTLE_CALLS_FOR_MILLISECONDS);
class $a71d406c80bedd2b$export$855252f33d470a3f {
}
class $a71d406c80bedd2b$var$ActionsAPI {
    createAPI(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    plugin) {
        if (!plugin || !$a71d406c80bedd2b$var$hasActions(plugin)) return {};
        return new Proxy(plugin.actions || {}, {
            get: function(target, prop, receiver) {
                // We will be able to track perfomance here
                return Reflect.get(target, prop);
            }
        });
    }
}
class $a71d406c80bedd2b$var$EditorCommandsAPI {
    createAPI(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    plugin) {
        if (!plugin || !$a71d406c80bedd2b$var$hasCommands(plugin)) return {};
        return new Proxy(plugin.commands || {}, {
            get: function(target, prop, receiver) {
                // We will be able to track perfomance here
                return Reflect.get(target, prop);
            }
        });
    }
}
class $a71d406c80bedd2b$export$da7528f3fb233b4a {
    createAPI(plugin) {
        if (!plugin) return {
            currentState: ()=>undefined,
            onChange: (sub)=>{
                return ()=>{};
            }
        };
        const pluginName = plugin.name;
        return {
            currentState: ()=>{
                if (!$a71d406c80bedd2b$var$hasGetSharedState(plugin)) return undefined;
                const state = this.getEditorState();
                return plugin.getSharedState(state);
            },
            onChange: (sub)=>{
                const pluginListeners = this.listeners.get(pluginName) || new Set();
                pluginListeners.add(sub);
                this.listeners.set(pluginName, pluginListeners);
                return ()=>this.cleanupSubscription(pluginName, sub);
            }
        };
    }
    cleanupSubscription(pluginName, sub) {
        (this.listeners.get(pluginName) || new Set()).delete(sub);
    }
    notifyListeners({ newEditorState: newEditorState, oldEditorState: oldEditorState, plugins: plugins }) {
        const { listeners: listeners, updatesToNotifyQueue: updatesToNotifyQueue } = this;
        const pluginsFiltered = $a71d406c80bedd2b$var$filterPluginsWithListeners({
            plugins: plugins,
            listeners: listeners
        });
        const sharedStateDiffs = $a71d406c80bedd2b$var$extractSharedStateFromPlugins({
            oldEditorState: oldEditorState,
            newEditorState: newEditorState,
            plugins: pluginsFiltered
        });
        if (sharedStateDiffs.size === 0) return;
        for (const [pluginName, nextDiff] of sharedStateDiffs){
            const currentDiffQueue = updatesToNotifyQueue.get(pluginName) || [];
            updatesToNotifyQueue.set(pluginName, [
                ...currentDiffQueue,
                nextDiff
            ]);
        }
        $a71d406c80bedd2b$var$notifyListenersThrottled({
            updatesToNotifyQueue: updatesToNotifyQueue,
            listeners: listeners
        });
    }
    destroy() {
        this.listeners.clear();
        this.updatesToNotifyQueue.clear();
    }
    constructor({ getEditorState: getEditorState }){
        this.getEditorState = void 0;
        this.listeners = void 0;
        this.updatesToNotifyQueue = new Map();
        this.getEditorState = getEditorState;
        this.listeners = new Map();
    }
}
const $a71d406c80bedd2b$var$editorAPICache = new WeakMap();
class $a71d406c80bedd2b$export$50ccbedb1c6559a0 {
    createAPI() {
        const { sharedStateAPI: sharedStateAPI, actionsAPI: actionsAPI, commandsAPI: commandsAPI, getPluginByName: getPluginByName } = this;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return new Proxy({}, {
            get: function(target, prop, receiver) {
                // If we pass this as a prop React hates us
                // Let's just reflect the result and ignore these
                if (prop === 'toJSON') return Reflect.get(target, prop);
                const plugin = getPluginByName(prop);
                if (!plugin) return undefined;
                const sharedState = sharedStateAPI.createAPI(plugin);
                const actions = actionsAPI.createAPI(plugin);
                const commands = commandsAPI.createAPI(plugin);
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const proxyCoreAPI = {
                    sharedState: sharedState,
                    actions: actions,
                    commands: commands
                };
                return proxyCoreAPI;
            }
        });
    }
    api() {
        if (!$a71d406c80bedd2b$var$editorAPICache.get(this)) $a71d406c80bedd2b$var$editorAPICache.set(this, this.createAPI());
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return $a71d406c80bedd2b$var$editorAPICache.get(this);
    }
    constructor({ getEditorState: getEditorState, getEditorView: getEditorView, fireAnalyticsEvent: fireAnalyticsEvent }){
        this.sharedStateAPI = void 0;
        this.actionsAPI = void 0;
        this.commandsAPI = void 0;
        this.plugins = void 0;
        this.onEditorViewUpdated = ({ newEditorState: newEditorState, oldEditorState: oldEditorState })=>{
            this.sharedStateAPI.notifyListeners({
                newEditorState: newEditorState,
                oldEditorState: oldEditorState,
                plugins: this.plugins
            });
        };
        this.onEditorPluginInitialized = (plugin)=>{
            this.addPlugin(plugin);
        };
        this.addPlugin = (plugin)=>{
            // Plugins other than `core` are checked by the preset itself
            // For some reason in some tests we have duplicates that are missed.
            // To follow-up in ED-19611
            if (plugin.name === 'core' && this.plugins.has(plugin.name)) throw new Error(`Plugin ${plugin.name} has already been initialised in the Editor API!
        There cannot be duplicate plugins or you will have unexpected behaviour`);
            this.plugins.set(plugin.name, plugin);
        };
        this.getPluginByName = (pluginName)=>{
            const plugin = this.plugins.get(pluginName);
            return plugin;
        };
        this.sharedStateAPI = new $a71d406c80bedd2b$export$da7528f3fb233b4a({
            getEditorState: getEditorState
        });
        this.plugins = new Map();
        this.actionsAPI = new $a71d406c80bedd2b$var$ActionsAPI();
        this.commandsAPI = new $a71d406c80bedd2b$var$EditorCommandsAPI();
        // Special core plugin that is always added
        this.addPlugin((0, $9e9cac93742fed46$export$71ab138dd170c35)({
            config: {
                getEditorView: getEditorView,
                fireAnalyticsEvent: fireAnalyticsEvent
            }
        }));
    }
}






var $40aJG = parcelRequire("40aJG");


var $lWghV = parcelRequire("lWghV");


var $2pjJ5 = parcelRequire("2pjJ5");


var $ks2lK = parcelRequire("ks2lK");


var $ftzrq = parcelRequire("ftzrq");





var $4u5NT = parcelRequire("4u5NT");


var $1oCLl = parcelRequire("1oCLl");


var $aeAfU = parcelRequire("aeAfU");




const $9dc7d15a9979d8e6$export$e4c19534640d7866 = ({ editorApi: editorApi, contextIdentifierProvider: contextIdentifierProvider, mediaProvider: mediaProvider, mentionProvider: mentionProvider, cardProvider: cardProvider, emojiProvider: emojiProvider, autoformattingProvider: autoformattingProvider, taskDecisionProvider: taskDecisionProvider })=>{
    (0, $42omo.useEffect)(()=>{
        async function setProvider() {
            if (!contextIdentifierProvider) return;
            const provider = await contextIdentifierProvider;
            editorApi?.core?.actions.execute(editorApi?.contextIdentifier?.commands.setProvider({
                contextIdentifierProvider: provider
            }));
        }
        setProvider();
    }, [
        contextIdentifierProvider,
        editorApi
    ]);
    (0, $42omo.useEffect)(()=>{
        if (mediaProvider) editorApi?.media?.actions.setProvider(mediaProvider);
    }, [
        mediaProvider,
        editorApi
    ]);
    (0, $42omo.useEffect)(()=>{
        if (mentionProvider) editorApi?.mention?.actions.setProvider(mentionProvider);
    }, [
        mentionProvider,
        editorApi
    ]);
    (0, $42omo.useEffect)(()=>{
        if (cardProvider) editorApi?.card?.actions.setProvider(cardProvider);
    }, [
        cardProvider,
        editorApi
    ]);
    (0, $42omo.useEffect)(()=>{
        if (emojiProvider) editorApi?.emoji?.actions.setProvider(emojiProvider);
    }, [
        emojiProvider,
        editorApi
    ]);
    (0, $42omo.useEffect)(()=>{
        if (autoformattingProvider) editorApi?.customAutoformat?.actions.setProvider(autoformattingProvider);
    }, [
        autoformattingProvider,
        editorApi
    ]);
    (0, $42omo.useEffect)(()=>{
        if (taskDecisionProvider) editorApi?.taskDecision?.actions.setProvider(taskDecisionProvider);
    }, [
        taskDecisionProvider,
        editorApi
    ]);
};



var $6DQRK = parcelRequire("6DQRK");


var $hEPfr = parcelRequire("hEPfr");

/**
 * Check if a DOM element is visible within the viewport. We deem a node visible if the top left corner coordinate is within the viewport.
 * This may not look visible, and may include a node that looks below the fold – but it's more than 0 pixels within the viewport.
 */ const $668f6e52ed8ba3c9$export$9c8a351faafa8fbb = (node)=>{
    const rect = node.getBoundingClientRect();
    const isVisible = rect.x >= 0 && rect.x < window.innerWidth && rect.y >= 0 && rect.y < window.innerHeight;
    return isVisible;
};
const $668f6e52ed8ba3c9$export$f20e3cf045904cb = (editorDom)=>{
    const MAX_NODES_TO_COUNT = 200;
    const pmNodesList = editorDom.querySelectorAll('[data-prosemirror-node-name]');
    const nodesTypeCounter = {};
    for(let i = 0; i < Math.min(MAX_NODES_TO_COUNT, pmNodesList.length); i++){
        const node = pmNodesList[i];
        const type = node.getAttribute('data-prosemirror-node-name');
        // No valid prosemirrornode type, skip.
        if (!type) continue;
        const isVisible = $668f6e52ed8ba3c9$export$9c8a351faafa8fbb(node);
        // Not a visible node, end counting.
        if (!isVisible) break;
        nodesTypeCounter[type] = (nodesTypeCounter[type] || 0) + 1;
    }
    return nodesTypeCounter;
};



var $geLSP = parcelRequire("geLSP");


var $2oRGU = parcelRequire("2oRGU");


var $7lreV = parcelRequire("7lreV");

const $769e182f77e7bc85$export$646a6982857f2cd5 = 2000;
const $769e182f77e7bc85$export$79d7eac6cbb6352d = 3000;
const $769e182f77e7bc85$export$7d7bd496a5206996 = 100;



var $dSVmA = parcelRequire("dSVmA");


var $2oGxU = parcelRequire("2oGxU");





var $1S4f7 = parcelRequire("1S4f7");










const $4c2f9c6d3992052f$var$injectNodeViewNodeTypeList = [
    'paragraph',
    'heading',
    'bulletList',
    'orderedList',
    'blockquote',
    'rule',
    'decisionList',
    'taskList',
    'layoutColumn',
    'hardBreak'
];
const $4c2f9c6d3992052f$var$injectNodeViewNodeTypeConditionalList = [
    ...$4c2f9c6d3992052f$var$injectNodeViewNodeTypeList,
    // nodes that have custom nodeView behind experiment/FG
    'layoutSection'
];
const $4c2f9c6d3992052f$var$key = new (0, $ks2lK.PluginKey)('editorNativeAnchorSupportPlugin');
const $4c2f9c6d3992052f$export$dc8df63091e87b7a = (schema)=>{
    const nodeViewEntries = [];
    const injectList = (0, $1oCLl.expValEquals)('advanced_layouts', 'isEnabled', true) && !(0, $1oCLl.expValEquals)('platform_editor_breakout_resizing', 'isEnabled', true) ? $4c2f9c6d3992052f$var$injectNodeViewNodeTypeList : $4c2f9c6d3992052f$var$injectNodeViewNodeTypeConditionalList;
    schema.spec.nodes.forEach((nodeName, nodeSpec)=>{
        if (injectList.includes(nodeName)) {
            if (nodeSpec.toDOM && typeof nodeSpec.toDOM === 'function') {
                const toDOM = nodeSpec.toDOM.bind(nodeSpec);
                nodeViewEntries.push([
                    nodeName,
                    (node)=>(0, $5SAOw.DOMSerializer).renderSpec(document, toDOM(node))
                ]);
            }
        }
    });
    return new (0, $1S4f7.SafePlugin)({
        key: $4c2f9c6d3992052f$var$key,
        props: {
            nodeViews: Object.fromEntries(nodeViewEntries)
        }
    });
};








const $0857bd5143cc04f2$var$key = new (0, $ks2lK.PluginKey)('editorStateNotificationPlugin');
const $0857bd5143cc04f2$export$e0355cecc74597d = (onEditorStateUpdated, onEditorViewStateUpdatedCallbacks)=>{
    const transactions = [];
    return new (0, $1S4f7.SafePlugin)({
        key: $0857bd5143cc04f2$var$key,
        state: {
            init () {
                return {
                    latestTransaction: undefined
                };
            },
            apply (tr) {
                transactions.push(tr);
                return {
                    latestTransaction: tr
                };
            }
        },
        view: ()=>{
            return {
                update: (view, oldEditorState)=>{
                    onEditorStateUpdated({
                        oldEditorState: oldEditorState,
                        newEditorState: view.state
                    });
                }
            };
        }
    });
};


function $5b9727cf4df72475$export$935d38a2e170d1f3(a, b) {
    return a.rank - b.rank;
}
function $5b9727cf4df72475$export$ef6c09ff452189fa(marks) {
    const markKeys = Object.keys(marks);
    const markGroups = new Set(markKeys.map((mark)=>marks[mark].group));
    markKeys.forEach((markKey)=>{
        const mark = marks[markKey];
        if (mark.excludes) mark.excludes = mark.excludes.split(' ').filter((group)=>markGroups.has(group)).join(' ');
    });
    return marks;
}
function $5b9727cf4df72475$export$7265233e78178a4(plugins) {
    /**
	 * First pass to collect pluginsOptions
	 */ const pluginsOptions = plugins.reduce((acc, plugin)=>{
        if (plugin.pluginsOptions) Object.keys(plugin.pluginsOptions).forEach((pluginName)=>{
            if (!acc[pluginName]) acc[pluginName] = [];
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            acc[pluginName].push(plugin.pluginsOptions[pluginName]);
        });
        return acc;
    }, {});
    /**
	 * Process plugins
	 */ return plugins.reduce((acc, plugin)=>{
        if (plugin.pmPlugins) acc.pmPlugins.push(...plugin.pmPlugins(plugin.name ? pluginsOptions[plugin.name] : undefined));
        if (plugin.nodes) acc.nodes.push(...plugin.nodes());
        if (plugin.marks) acc.marks.push(...plugin.marks());
        if (plugin.contentComponent) acc.contentComponents.push(plugin.contentComponent);
        if (plugin.usePluginHook) acc.pluginHooks.push(plugin.usePluginHook);
        if (plugin.primaryToolbarComponent) acc.primaryToolbarComponents.push(plugin.primaryToolbarComponent);
        if (plugin.secondaryToolbarComponent) acc.secondaryToolbarComponents.push(plugin.secondaryToolbarComponent);
        if (plugin.onEditorViewStateUpdated) acc.onEditorViewStateUpdatedCallbacks.push({
            pluginName: plugin.name,
            callback: plugin.onEditorViewStateUpdated
        });
        return acc;
    }, {
        nodes: [],
        marks: [],
        pmPlugins: [],
        contentComponents: [],
        pluginHooks: [],
        primaryToolbarComponents: [],
        secondaryToolbarComponents: [],
        onEditorViewStateUpdatedCallbacks: []
    });
}
function $5b9727cf4df72475$export$169329cb2979ef81(config) {
    const { editorConfig: editorConfig } = config;
    const pmPlugins = editorConfig.pmPlugins.sort((0, $2oGxU.sortByOrder)('plugins')).map(({ plugin: plugin })=>plugin({
            schema: config.schema,
            dispatch: config.dispatch,
            eventDispatcher: config.eventDispatcher,
            providerFactory: config.providerFactory,
            errorReporter: config.errorReporter,
            portalProviderAPI: config.portalProviderAPI,
            nodeViewPortalProviderAPI: config.nodeViewPortalProviderAPI,
            dispatchAnalyticsEvent: config.dispatchAnalyticsEvent,
            featureFlags: config.featureFlags || {},
            getIntl: config.getIntl
        })).filter((plugin)=>typeof plugin !== 'undefined');
    if ((0, $1oCLl.expValEquals)('platform_editor_native_anchor_support', 'isEnabled', true)) pmPlugins.push((0, $4c2f9c6d3992052f$export$dc8df63091e87b7a)(config.schema));
    if (config.onEditorStateUpdated !== undefined) return [
        (0, $0857bd5143cc04f2$export$e0355cecc74597d)(config.onEditorStateUpdated, config.editorConfig.onEditorViewStateUpdatedCallbacks),
        ...pmPlugins
    ];
    return pmPlugins;
}
function $5b9727cf4df72475$export$e98521bb0cea2db1(errorReporterHandler) {
    const errorReporter = new (0, $dSVmA.ErrorReporter)();
    if (errorReporterHandler) errorReporter.handler = errorReporterHandler;
    return errorReporter;
}



var $1B55v = parcelRequire("1B55v");


var $jQdRj = parcelRequire("jQdRj");





var $6VsTy = parcelRequire("6VsTy");





const $083bb79fcbe2f990$export$29c1e593063b23a7 = ({ nodeOrMark: nodeOrMark, domSpec: domSpec })=>{
    if (!Array.isArray(domSpec)) return domSpec;
    const maybeDefinedAttributes = domSpec[1];
    const metadata = (0, $6VsTy.createProseMirrorMetadata)(nodeOrMark);
    const hasDefinedAttributes = typeof maybeDefinedAttributes === 'object' && !Array.isArray(maybeDefinedAttributes);
    if (hasDefinedAttributes) domSpec[1] = Object.assign(maybeDefinedAttributes, metadata);
    else domSpec.splice(1, 0, metadata);
    return domSpec;
};
const $083bb79fcbe2f990$export$48404bb361c0cbc1 = (toDOM)=>{
    return new Proxy(toDOM, {
        apply (target, thisArg, argumentsList) {
            const domSpec = Reflect.apply(target, thisArg, argumentsList);
            if (!Array.isArray(domSpec)) return domSpec;
            const nodeOrMark = argumentsList[0];
            return $083bb79fcbe2f990$export$29c1e593063b23a7({
                nodeOrMark: nodeOrMark,
                domSpec: domSpec
            });
        }
    });
};
const $083bb79fcbe2f990$export$83e999ea28e263f4 = (spec)=>{
    return new Proxy(spec, {
        get (target, prop, receiver) {
            const result = Reflect.get(target, prop, receiver);
            if (prop === 'toDOM' && typeof result === 'function') return $083bb79fcbe2f990$export$48404bb361c0cbc1(result);
            return result;
        }
    });
};
function $083bb79fcbe2f990$export$5f4ce795563f4211(editorConfig) {
    const marks = (0, $5b9727cf4df72475$export$ef6c09ff452189fa)(editorConfig.marks.sort((0, $2oGxU.sortByOrder)('marks')).reduce((acc, mark)=>{
        acc[mark.name] = $083bb79fcbe2f990$export$83e999ea28e263f4(mark.mark);
        return acc;
    }, {}));
    const nodes = (0, $jQdRj.sanitizeNodes)(editorConfig.nodes.sort((0, $2oGxU.sortByOrder)('nodes')).reduce((acc, node)=>{
        acc[node.name] = $083bb79fcbe2f990$export$83e999ea28e263f4(node.node);
        return acc;
    }, {}), marks);
    return new (0, $5SAOw.Schema)({
        nodes: nodes,
        marks: marks
    });
}



var $cgtv4 = parcelRequire("cgtv4");

const $170f814baa647977$export$3b488057bfc1868f = (0, $cgtv4.defineMessages)({
    editorAssistiveLabel: {
        id: "fabric.editor.editorAssistiveLabel",
        defaultMessage: "Main content area, start typing to enter text."
    }
});


function $0d3266c92e7feda8$export$32ec9f77297f7957(editorId) {
    const parentElement = document.querySelector(`[data-focus-id="${editorId}"]`);
    if (!(parentElement instanceof HTMLElement)) return;
    parentElement.focus({
        preventScroll: true
    });
}



var $d7ZU3 = parcelRequire("d7ZU3");




function $f1dc1dfba26b7751$export$11a24c7b1b4aab81() {
    const browser = (0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $d7ZU3.getBrowserInfo)() : (0, $d7ZU3.browser);
    if (browser.chrome) return 'ua-chrome';
    else if (browser.ie) return 'ua-ie';
    else if (browser.gecko) return 'ua-firefox';
    else if (browser.safari) return 'ua-safari';
    return '';
}











function $565b25adcfad3caf$export$ebebb7f5b9271fd7(view) {
    if (view?.hasFocus()) return;
    /**
	 * If startTransition is available (in React 18),
	 * don't use setTimeout as startTransition will be used in ReactEditorViewNext.
	 * setTimeout(fn, 0) will not defer the focus reliably in React 18 with
	 * concurrent rendering.
	 */ const react16OnlySetTimeout = (0, (/*@__PURE__*/$parcel$interopDefault($42omo)))?.startTransition && (0, $dh538.fg)('platform_editor_react_18_autofocus_fix') ? (fn)=>fn() : (fn)=>window.setTimeout(fn, 0);
    return react16OnlySetTimeout(()=>{
        // Due to race conditions during editor lifecycle transitions (e.g. SPA route changes during opening or closing)
        // where the view (and its internal docView) may have been destroyed, the timeout callback may fire on a stale view.
        // Bail out in that scenario to prevent operating on an unmounted view.
        if (view?.isDestroyed) return;
        if (view?.hasFocus()) return;
        if (!window.getSelection) {
            view?.focus();
            return;
        }
        const domSelection = window.getSelection();
        if (!domSelection || domSelection.rangeCount === 0) {
            view?.focus();
            return;
        }
        const range = domSelection.getRangeAt(0);
        // if selection is outside editor focus and exit
        if (view && range.startContainer.contains(view.dom)) {
            view.focus();
            return;
        }
        // set cursor/selection and focus
        const anchor = view?.posAtDOM(range.startContainer, range.startOffset);
        const head = view?.posAtDOM(range.endContainer, range.endOffset);
        // if anchor or head < 0 focus and exit
        if (anchor && anchor < 0 || head && head < 0) {
            view?.focus();
            return;
        }
        if (view && anchor) {
            const selection = (0, $ks2lK.TextSelection).create(view.state.doc, anchor, head);
            const tr = view.state.tr.setSelection(selection);
            view.dispatch(tr);
            view.focus();
        }
    });
}








var $4VpM8 = parcelRequire("4VpM8");


var $h3X17 = parcelRequire("h3X17");


var $56Wjx = parcelRequire("56Wjx");


var $2T4ch = parcelRequire("2T4ch");

const $015e54f1cc15a3ff$export$cdc577fd3f583194 = (tr)=>{
    const nodes = [];
    const steps = tr.steps || [];
    steps.forEach((step)=>{
        step.getMap().forEach((_oldStart, _oldEnd, newStart, newEnd)=>{
            tr.doc.nodesBetween(newStart, Math.min(newEnd, tr.doc.content.size), (node)=>{
                if (!nodes.find((n)=>n === node)) nodes.push(node);
                return false;
            });
        });
    });
    return nodes;
};





const $b985ded6f19ca760$export$9f24e92219b6e945 = 'Setting an unsafe property on transaction after dispatch!';
// since selection uses curSelection under the hood, we guard setSelection instead
const $b985ded6f19ca760$var$isUnsafeMethod = (prop)=>[
        'setSelection'
    ].includes(prop.toString());
const $b985ded6f19ca760$var$isReadOnlyProperty = (prop)=>[
        'doc',
        'docs',
        'steps',
        'selection'
    ].includes(prop.toString());
const $b985ded6f19ca760$export$668aa008bdae439f = ({ dispatchAnalyticsEvent: dispatchAnalyticsEvent, pluginKey: pluginKey })=>{
    const isUnsafe = ()=>{
        if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $d925B.ACTION).TRANSACTION_MUTATED_AFTER_DISPATCH,
            actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
            attributes: {
                pluginKey: pluginKey || 'unknown'
            }
        });
        throw new Error($b985ded6f19ca760$export$9f24e92219b6e945);
    };
    return {
        get: function(target, prop, receiver) {
            if ($b985ded6f19ca760$var$isUnsafeMethod(prop)) isUnsafe();
            return Reflect.get(target, prop, receiver);
        },
        set: function(target, prop, receiver) {
            if ($b985ded6f19ca760$var$isReadOnlyProperty(prop)) isUnsafe();
            return Reflect.set(target, prop, receiver);
        }
    };
};



var $aAn37 = parcelRequire("aAn37");




/**
 * Calculate the difference between performance.now() and the given startTime.
 * This allows for the timing to be overridable during tests.
 *
 * @param startTime DOMHighResTimeStamp
 * @returns DOMHighResTimeStamp
 */ const $1d60a1b0507e65ba$export$a26b90db2c8f1b97 = (startTime)=>performance.now() - startTime;


const $a17905ab9de46c9b$export$5e38f3b295505ec8 = `\u{1F989} EditorView::state::apply`;
const $a17905ab9de46c9b$export$646ca0d076c98ad5 = `\u{1F989} EditorView::updateState`;
const $a17905ab9de46c9b$export$2f488cec9729a7d6 = `\u{1F989} EditorView::onEditorViewStateUpdated`;
const $a17905ab9de46c9b$export$bb82e7cfb8987f35 = `\u{1F989} ReactEditorView::onChange`;
const $a17905ab9de46c9b$export$373baa16b824d295 = `\u{1F989} ReactEditorView::dispatchTransaction`;
const $a17905ab9de46c9b$export$735da5ee20c885d5 = false;
const $a17905ab9de46c9b$var$DEFAULT_SAMPLING_RATE = 100;
const $a17905ab9de46c9b$var$noop = ()=>{};
class $a17905ab9de46c9b$export$7a054319813aafa {
    addMeasureListener(listener) {
        this.measureListeners.push(listener);
    }
    removeMeasureListener(listener) {
        const index = this.measureListeners.indexOf(listener);
        if (index > -1) this.measureListeners.splice(index, 1);
    }
    shouldTrackTransaction(options) {
        const { enabled: trackingEnabled, samplingRate: samplingRate = $a17905ab9de46c9b$var$DEFAULT_SAMPLING_RATE } = options;
        return trackingEnabled && this.dispatchCallCounter === samplingRate;
    }
    constructor(){
        // Counter so we can rate limit the transaction performance tracking
        this.dispatchCallCounter = 0;
        // A map containing the time which measurement starts
        this.measureMap = new Map();
        this.measureListeners = [];
        this.bumpDispatchCounter = (options)=>{
            const { enabled: trackingEnabled, samplingRate: samplingRate = $a17905ab9de46c9b$var$DEFAULT_SAMPLING_RATE } = options;
            if (trackingEnabled) {
                if (this.dispatchCallCounter >= samplingRate) this.dispatchCallCounter = 0;
                this.dispatchCallCounter++;
            }
            return this.dispatchCallCounter;
        };
        this.getMeasureHelpers = (options)=>{
            const { usePerformanceMarks: usePerformanceMarks = $a17905ab9de46c9b$export$735da5ee20c885d5 } = options;
            if (!this.shouldTrackTransaction(options)) return {
                startMeasure: $a17905ab9de46c9b$var$noop,
                stopMeasure: $a17905ab9de46c9b$var$noop
            };
            return {
                startMeasure: usePerformanceMarks ? (0, $2T4ch.startMeasure) : this.startMeasureSimple,
                stopMeasure: usePerformanceMarks ? (0, $2T4ch.stopMeasure) : this.stopMeasureSimple
            };
        };
        this.startMeasureSimple = (measureName)=>{
            if (!(0, $aAn37.isPerformanceAPIAvailable)()) return;
            this.measureMap.set(measureName, performance.now());
        };
        this.stopMeasureSimple = (measureName, onMeasureComplete)=>{
            if (!(0, $aAn37.isPerformanceAPIAvailable)()) return;
            const startTime = this.measureMap.get(measureName);
            if (startTime) {
                const duration = (0, $1d60a1b0507e65ba$export$a26b90db2c8f1b97)(startTime);
                this.measureMap.delete(measureName);
                if (onMeasureComplete) onMeasureComplete(duration, startTime);
                // Call each subscribed listener
                this.measureListeners.forEach((listener)=>listener({
                        name: measureName,
                        duration: duration,
                        startTime: startTime
                    }));
            }
        };
    }
}


const $e81162bdf75802d2$export$4c39e41e39b3c449 = (node)=>{
    try {
        node.check();
    } catch (error) {
        return false;
    }
    return true;
};
const $e81162bdf75802d2$export$996213f7c272fc6f = (nodes)=>nodes.every($e81162bdf75802d2$export$4c39e41e39b3c449);


const $f260cf531ae15748$export$b582387940572fe7 = ({ onChange: onChange, dispatchAnalyticsEvent: dispatchAnalyticsEvent, onEditorViewUpdated: onEditorViewUpdated, isRemoteReplaceDocumentTransaction: isRemoteReplaceDocumentTransaction })=>{
    // We need to have a ref to the latest `onChange` since the `dispatchTransaction` gets captured
    const onChangeRef = (0, $42omo.useRef)(onChange);
    (0, $42omo.useEffect)(()=>{
        onChangeRef.current = onChange;
    }, [
        onChange
    ]);
    const dispatchTransaction = (0, $42omo.useCallback)((view, unsafeTransaction)=>{
        if (!view) return;
        const nodes = (0, $015e54f1cc15a3ff$export$cdc577fd3f583194)(unsafeTransaction);
        const changedNodesValid = (0, $e81162bdf75802d2$export$996213f7c272fc6f)(nodes);
        const transaction = new Proxy(unsafeTransaction, (0, $b985ded6f19ca760$export$668aa008bdae439f)({
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            pluginKey: 'unknown-reacteditorview'
        }));
        // If the transaction is a remote replaceDocument transaction, we should skip validation.
        // Remote replaceDocument transactions are fired when the document is replaced by initialization of editor-plugin-collab-edit
        // If there is a discrepancy in the ProseMirror schema at initialization, it results in the editor being loaded with no content,
        // giving the user the impression that content has been lost
        const isRemoteReplace = isRemoteReplaceDocumentTransaction ? isRemoteReplaceDocumentTransaction(transaction) : false;
        if (changedNodesValid || isRemoteReplace) {
            const oldEditorState = view.state;
            // go ahead and update the state now we know the transaction is good
            const { state: newEditorState, transactions: transactions } = view.state.applyTransaction(transaction);
            if (newEditorState === oldEditorState) return;
            view.updateState(newEditorState);
            onEditorViewUpdated({
                originalTransaction: transaction,
                transactions: transactions,
                oldEditorState: oldEditorState,
                newEditorState: newEditorState
            });
            if (onChangeRef.current && transaction.docChanged) {
                const source = transaction.getMeta('isRemote') ? 'remote' : 'local';
                const isDirtyChange = (0, $h3X17.isDirtyTransaction)(transaction);
                (0, $2T4ch.startMeasure)((0, $a17905ab9de46c9b$export$bb82e7cfb8987f35));
                onChangeRef.current(view, {
                    source: source,
                    isDirtyChange: isDirtyChange
                });
                (0, $2T4ch.stopMeasure)((0, $a17905ab9de46c9b$export$bb82e7cfb8987f35));
            }
        }
        if (!changedNodesValid) {
            const invalidNodes = nodes.filter((node)=>!(0, $e81162bdf75802d2$export$4c39e41e39b3c449)(node)).map((node)=>(0, $56Wjx.getDocStructure)(node, {
                    compact: true
                }));
            dispatchAnalyticsEvent({
                action: (0, $d925B.ACTION).DISPATCHED_INVALID_TRANSACTION,
                actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    analyticsEventPayloads: (0, $4VpM8.getAnalyticsEventsFromTransaction)(transaction),
                    invalidNodes: invalidNodes,
                    isRemoteReplaceDocumentTransaction: isRemoteReplace
                }
            });
        }
    }, [
        dispatchAnalyticsEvent,
        onEditorViewUpdated,
        isRemoteReplaceDocumentTransaction
    ]);
    return dispatchTransaction;
};














const $2507994582b7e2f3$export$47d5b79f3ddf0b92 = (appearance)=>{
    if (appearance === 'full-width') return (0, $e2wMq.FULL_WIDTH_MODE).FULL_WIDTH;
    return (0, $e2wMq.FULL_WIDTH_MODE).FIXED_WIDTH;
};


const $5953f1dbb50e9aa2$export$4998b7b36606f9c3 = (appearance, dispatchAnalyticsEvent)=>{
    const previousAppearance = (0, $7541v.default)(appearance);
    (0, $42omo.useEffect)(()=>{
        if (appearance !== previousAppearance) {
            if (appearance === 'full-width' || previousAppearance === 'full-width') dispatchAnalyticsEvent({
                action: (0, $d925B.ACTION).CHANGED_FULL_WIDTH_MODE,
                actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                attributes: {
                    previousMode: (0, $2507994582b7e2f3$export$47d5b79f3ddf0b92)(previousAppearance),
                    newMode: (0, $2507994582b7e2f3$export$47d5b79f3ddf0b92)(appearance)
                }
            });
        }
    }, [
        appearance,
        previousAppearance,
        dispatchAnalyticsEvent
    ]);
};


const $024596570cb688e3$var$EDIT_AREA_ID = 'ak-editor-textarea';
function $024596570cb688e3$export$e7d1b1cbca007e16(props) {
    const { preset: preset, editorProps: { appearance: nextAppearance, disabled: disabled, featureFlags: editorPropFeatureFlags, errorReporterHandler: errorReporterHandler, defaultValue: defaultValue, shouldFocus: shouldFocus, __livePage: __livePage }, onEditorCreated: onEditorCreated, onEditorDestroyed: onEditorDestroyed } = props;
    const [editorAPI, setEditorAPI] = (0, $42omo.useState)(undefined);
    const editorRef = (0, $42omo.useRef)(null);
    const viewRef = (0, $42omo.useRef)();
    const focusTimeoutId = (0, $42omo.useRef)();
    // ProseMirror is instantiated prior to the initial React render cycle,
    // so we allow transactions by default, to avoid discarding the initial one.
    const canDispatchTransactions = (0, $42omo.useRef)(true);
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const editorId = (0, $42omo.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))());
    const eventDispatcher = (0, $42omo.useMemo)(()=>new (0, $5vVM5.EventDispatcher)(), []);
    const config = (0, $42omo.useRef)({
        nodes: [],
        marks: [],
        pmPlugins: [],
        contentComponents: [],
        pluginHooks: [],
        primaryToolbarComponents: [],
        secondaryToolbarComponents: [],
        onEditorViewStateUpdatedCallbacks: []
    });
    const contentTransformer = (0, $42omo.useRef)(undefined);
    const featureFlags = (0, $42omo.useMemo)(()=>(0, $6DQRK.createFeatureFlagsFromProps)(editorPropFeatureFlags), [
        editorPropFeatureFlags
    ]);
    const getEditorState = (0, $42omo.useCallback)(()=>viewRef.current?.state, []);
    const getEditorView = (0, $42omo.useCallback)(()=>viewRef.current, []);
    const dispatch = (0, $42omo.useMemo)(()=>(0, $5vVM5.createDispatch)(eventDispatcher), [
        eventDispatcher
    ]);
    const errorReporter = (0, $42omo.useMemo)(()=>(0, $5b9727cf4df72475$export$e98521bb0cea2db1)(errorReporterHandler), [
        errorReporterHandler
    ]);
    const handleAnalyticsEvent = (0, $42omo.useCallback)((payload)=>{
        (0, $ajtqX.fireAnalyticsEvent)(props.createAnalyticsEvent)(payload);
    }, [
        props.createAnalyticsEvent
    ]);
    const dispatchAnalyticsEvent = (0, $42omo.useCallback)((payload)=>{
        const dispatch = (0, $5vVM5.createDispatch)(eventDispatcher);
        dispatch((0, $lWghV.analyticsEventKey), {
            payload: payload
        });
    }, [
        eventDispatcher
    ]);
    const pluginInjectionAPI = (0, $42omo.useRef)(new (0, $a71d406c80bedd2b$export$50ccbedb1c6559a0)({
        getEditorState: getEditorState,
        getEditorView: getEditorView,
        fireAnalyticsEvent: handleAnalyticsEvent
    }));
    const createEditorState = (0, $42omo.useCallback)((options)=>{
        let schema;
        if (viewRef.current) {
            if (options.resetting) /**
         * ReactEditorView currently does NOT handle dynamic schema,
         * We are reusing the existing schema, and rely on #reconfigureState
         * to update `this.config`
         */ schema = viewRef.current.state.schema;
            else {
                /**
         * There's presently a number of issues with changing the schema of a
         * editor inflight. A significant issue is that we lose the ability
         * to keep track of a user's history as the internal plugin state
         * keeps a list of Steps to undo/redo (which are tied to the schema).
         * Without a good way to do work around this, we prevent this for now.
         */ // eslint-disable-next-line no-console
                console.warn('The editor does not support changing the schema dynamically.');
                return viewRef.current.state;
            }
        } else {
            config.current = (0, $5b9727cf4df72475$export$7265233e78178a4)((0, $1B55v.default)(options.props.preset, props.editorProps, pluginInjectionAPI.current));
            schema = (0, $083bb79fcbe2f990$export$5f4ce795563f4211)(config.current);
            setEditorAPI(pluginInjectionAPI.current.api());
        }
        const { contentTransformerProvider: contentTransformerProvider } = options.props.editorProps;
        const plugins = (0, $5b9727cf4df72475$export$169329cb2979ef81)({
            schema: schema,
            dispatch: dispatch,
            errorReporter: errorReporter,
            editorConfig: config.current,
            eventDispatcher: eventDispatcher,
            providerFactory: options.props.providerFactory,
            portalProviderAPI: props.portalProviderAPI,
            nodeViewPortalProviderAPI: props.nodeViewPortalProviderAPI,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            featureFlags: featureFlags,
            getIntl: ()=>props.intl,
            onEditorStateUpdated: pluginInjectionAPI.current.onEditorViewUpdated
        });
        contentTransformer.current = contentTransformerProvider ? contentTransformerProvider(schema) : undefined;
        const api = pluginInjectionAPI.current.api();
        // If we have a doc prop, we need to process it into a PMNode
        let doc;
        if (options.doc) {
            // if the collabEdit API is set, skip this validation due to potential pm validation errors
            // from docs that end up with invalid marks after processing (See #hot-111702 for more details)
            if (api?.collabEdit !== undefined || options.props.editorProps.skipValidation) doc = (0, $6tl2G.processRawValueWithoutValidation)(schema, options.doc, dispatchAnalyticsEvent);
            else doc = (0, $6tl2G.processRawValue)(schema, options.doc, options.props.providerFactory, options.props.editorProps.sanitizePrivateContent, contentTransformer.current, dispatchAnalyticsEvent);
        }
        const isViewMode = api?.editorViewMode?.sharedState.currentState().mode === 'view';
        let selection;
        if (doc) {
            if (isViewMode) {
                const emptySelection = new (0, $ks2lK.TextSelection)(doc.resolve(0));
                return (0, $ks2lK.EditorState).create({
                    schema: schema,
                    plugins: plugins,
                    doc: doc,
                    selection: emptySelection
                });
            } else selection = options.selectionAtStart ? (0, $ks2lK.Selection).atStart(doc) : (0, $ks2lK.Selection).atEnd(doc);
        }
        // Workaround for ED-3507: When media node is the last element, scrollIntoView throws an error
        const patchedSelection = selection ? (0, $ks2lK.Selection).findFrom(selection.$head, -1, true) || undefined : undefined;
        return (0, $ks2lK.EditorState).create({
            schema: schema,
            plugins: plugins,
            doc: doc,
            selection: patchedSelection
        });
    }, [
        errorReporter,
        featureFlags,
        props.intl,
        props.portalProviderAPI,
        props.nodeViewPortalProviderAPI,
        props.editorProps,
        dispatchAnalyticsEvent,
        eventDispatcher,
        dispatch
    ]);
    const initialEditorState = (0, $42omo.useMemo)(()=>createEditorState({
            props: props,
            doc: defaultValue,
            // ED-4759: Don't set selection at end for full-page editor - should be at start.
            selectionAtStart: (0, $geLSP.isFullPage)(nextAppearance)
        }), // This is only used for the initial state - afterwards we will have `viewRef` available for use
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    const getCurrentEditorState = (0, $42omo.useCallback)(()=>{
        return viewRef.current?.state ?? initialEditorState;
    }, [
        initialEditorState
    ]);
    const blur = (0, $42omo.useCallback)(()=>{
        if (!viewRef.current) return;
        if (viewRef.current.dom instanceof HTMLElement && viewRef.current.hasFocus()) viewRef.current.dom.blur();
        // The selectionToDOM method uses the document selection to determine currently selected node
        // We need to mimic blurring this as it seems doing the above is not enough.
        // @ts-expect-error
        const sel = viewRef.current.root.getSelection();
        if (sel) sel.removeAllRanges();
    }, []);
    const resetEditorState = (0, $42omo.useCallback)(({ doc: doc, shouldScrollToBottom: shouldScrollToBottom })=>{
        if (!viewRef.current) return;
        // We cannot currently guarantee when all the portals will have re-rendered during a reconfigure
        // so we blur here to stop ProseMirror from trying to apply selection to detached nodes or
        // nodes that haven't been re-rendered to the document yet.
        blur();
        const newEditorState = createEditorState({
            props: props,
            doc: doc,
            resetting: true,
            selectionAtStart: !shouldScrollToBottom
        });
        viewRef.current.updateState(newEditorState);
        props.editorProps.onChange?.(viewRef.current, {
            source: 'local',
            isDirtyChange: false
        });
    }, [
        blur,
        createEditorState,
        props
    ]);
    // Initialise phase
    // Using constructor hook so we setup and dispatch analytics before anything else
    (0, $9HtP4.default)(()=>{
        // This needs to be before initialising editorState because
        // we dispatch analytics events in plugin initialisation
        eventDispatcher.on((0, $lWghV.analyticsEventKey), handleAnalyticsEvent);
        eventDispatcher.on('resetEditorState', resetEditorState);
        dispatchAnalyticsEvent({
            action: (0, $d925B.ACTION).STARTED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
            attributes: {
                platform: (0, $e2wMq.PLATFORMS).WEB,
                featureFlags: featureFlags ? (0, $9ciHB.getEnabledFeatureFlagKeys)(featureFlags) : [],
                accountLocale: props.intl?.locale,
                browserLocale: window.navigator.language
            },
            eventType: (0, $d925B.EVENT_TYPE).UI
        });
    });
    (0, $42omo.useLayoutEffect)(()=>{
        // Transaction dispatching is already enabled by default prior to
        // mounting, but we reset it here, just in case the editor view
        // instance is ever recycled (mounted again after unmounting) with
        // the same key.
        // AND since React 18 effects may run multiple times so we need to ensure
        // this is reset so that transactions are still allowed.
        // Although storing mounted state is an anti-pattern in React,
        // we do so here so that we can intercept and abort asynchronous
        // ProseMirror transactions when a dismount is imminent.
        canDispatchTransactions.current = true;
        return ()=>{
            // We can ignore any transactions from this point onwards.
            // This serves to avoid potential runtime exceptions which could arise
            // from an async dispatched transaction after it's unmounted.
            canDispatchTransactions.current = false;
        };
    }, []);
    // Cleanup
    (0, $42omo.useLayoutEffect)(()=>{
        return ()=>{
            const focusTimeoutIdCurrent = focusTimeoutId.current;
            if (focusTimeoutIdCurrent) clearTimeout(focusTimeoutIdCurrent);
            if (viewRef.current) {
                // Destroy the state if the Editor is being unmounted
                const editorState = viewRef.current.state;
                editorState.plugins.forEach((plugin)=>{
                    const state = plugin.getState(editorState);
                    if (state && state.destroy) state.destroy();
                });
            }
            eventDispatcher.destroy();
        // this.view will be destroyed when React unmounts in handleEditorViewRef
        };
    }, [
        eventDispatcher
    ]);
    const reconfigureState = (0, $42omo.useCallback)((props)=>{
        if (!viewRef.current) return;
        // We cannot currently guarantee when all the portals will have re-rendered during a reconfigure
        // so we blur here to stop ProseMirror from trying to apply selection to detached nodes or
        // nodes that haven't been re-rendered to the document yet.
        blur();
        const editorPlugins = (0, $1B55v.default)(props.preset, props.editorProps, pluginInjectionAPI.current);
        config.current = (0, $5b9727cf4df72475$export$7265233e78178a4)(editorPlugins);
        const state = viewRef.current.state;
        const plugins = (0, $5b9727cf4df72475$export$169329cb2979ef81)({
            schema: state.schema,
            dispatch: dispatch,
            errorReporter: errorReporter,
            editorConfig: config.current,
            eventDispatcher: eventDispatcher,
            providerFactory: props.providerFactory,
            portalProviderAPI: props.portalProviderAPI,
            nodeViewPortalProviderAPI: props.nodeViewPortalProviderAPI,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            featureFlags: featureFlags,
            getIntl: ()=>props.intl,
            onEditorStateUpdated: pluginInjectionAPI.current.onEditorViewUpdated
        });
        const newState = state.reconfigure({
            plugins: plugins
        });
        // need to update the state first so when the view builds the nodeviews it is
        // using the latest plugins
        viewRef.current.updateState(newState);
        return viewRef.current.update({
            ...viewRef.current.props,
            state: newState
        });
    }, [
        blur,
        dispatchAnalyticsEvent,
        eventDispatcher,
        dispatch,
        errorReporter,
        featureFlags
    ]);
    const onEditorViewUpdated = (0, $42omo.useCallback)(({ originalTransaction: originalTransaction, transactions: transactions, oldEditorState: oldEditorState, newEditorState: newEditorState })=>{
        config.current?.onEditorViewStateUpdatedCallbacks.forEach((entry)=>{
            entry.callback({
                originalTransaction: originalTransaction,
                transactions: transactions,
                oldEditorState: oldEditorState,
                newEditorState: newEditorState
            });
        });
    }, []);
    const dispatchTransaction = (0, $f260cf531ae15748$export$b582387940572fe7)({
        onChange: props.editorProps.onChange,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        onEditorViewUpdated: onEditorViewUpdated,
        isRemoteReplaceDocumentTransaction: pluginInjectionAPI.current.api()?.collabEdit?.actions?.isRemoteReplaceDocumentTransaction
    });
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: Remove these when we deprecate these props from editor-props - smartLinks is unfortunately still used in some places, we can sidestep this problem if we move everyone across to ComposableEditor and deprecate Editor
    const UNSAFE_cards = props.editorProps.UNSAFE_cards;
    const smartLinks = props.editorProps.smartLinks;
    // Temporary to replace provider factory while migration to `ComposableEditor` occurs
    (0, $9dc7d15a9979d8e6$export$e4c19534640d7866)({
        editorApi: editorAPI,
        contextIdentifierProvider: props.editorProps.contextIdentifierProvider,
        mediaProvider: props.editorProps.media?.provider,
        mentionProvider: props.editorProps.mentionProvider,
        cardProvider: props.editorProps.linking?.smartLinks?.provider || smartLinks && smartLinks.provider || UNSAFE_cards && UNSAFE_cards.provider,
        emojiProvider: props.editorProps.emojiProvider,
        autoformattingProvider: props.editorProps.autoformattingProvider,
        taskDecisionProvider: props.editorProps.taskDecisionProvider
    });
    const getDirectEditorProps = (0, $42omo.useCallback)((state)=>{
        return {
            state: state ?? getCurrentEditorState(),
            dispatchTransaction: (tr)=>{
                // Block stale transactions:
                // Prevent runtime exceptions from async transactions that would attempt to
                // update the DOM after React has unmounted the Editor.
                if (canDispatchTransactions.current) dispatchTransaction(viewRef.current, tr);
            },
            // Disables the contentEditable attribute of the editor if the editor is disabled
            editable: (_state)=>!disabled,
            attributes: {
                'data-gramm': 'false'
            }
        };
    }, [
        dispatchTransaction,
        disabled,
        getCurrentEditorState
    ]);
    const createEditorView = (0, $42omo.useCallback)((node)=>{
        // Creates the editor-view from this.editorState. If an editor has been mounted
        // previously, this will contain the previous state of the editor.
        const view = new (0, $ftzrq.EditorView)({
            mount: node
        }, getDirectEditorProps());
        viewRef.current = view;
        (0, $jz9wK.measureRender)((0, $7lreV.default).PROSEMIRROR_RENDERED, ({ duration: duration, startTime: startTime, distortedDuration: distortedDuration })=>{
            const proseMirrorRenderedSeverity = (0, $lWghV.getAnalyticsEventSeverity)(duration, (0, $769e182f77e7bc85$export$646a6982857f2cd5), (0, $769e182f77e7bc85$export$79d7eac6cbb6352d));
            if (viewRef.current) {
                const nodes = (0, $hEPfr.getNodesCount)(viewRef.current.state.doc);
                const ttfb = (0, $8pwxt.getResponseEndTime)();
                const contextIdentifier = pluginInjectionAPI.current.api().base?.sharedState.currentState();
                const nodesInViewport = (0, $668f6e52ed8ba3c9$export$f20e3cf045904cb)(viewRef.current.dom);
                const nodeSize = viewRef.current.state.doc.nodeSize;
                const { totalNodes: totalNodes, nodeSizeBucket: nodeSizeBucket } = (0, $1oCLl.expValEquals)('cc_editor_insm_doc_size_stats', 'isEnabled', true) ? {
                    totalNodes: Object.values(nodes).reduce((acc, curr)=>acc + curr, 0),
                    // Computed on client for dimension bucketing in Statsig
                    nodeSizeBucket: (()=>{
                        switch(true){
                            case nodeSize < 10000:
                                return '<10000';
                            case nodeSize < 20000:
                                return '<20000';
                            case nodeSize < 30000:
                                return '<30000';
                            case nodeSize < 40000:
                                return '<40000';
                            case nodeSize < 50000:
                                return '<50000';
                            default:
                                return '50000+';
                        }
                    })()
                } : {};
                dispatchAnalyticsEvent({
                    action: (0, $d925B.ACTION).PROSEMIRROR_RENDERED,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
                    attributes: {
                        duration: duration,
                        startTime: startTime,
                        nodes: nodes,
                        nodesInViewport: nodesInViewport,
                        nodeSize: nodeSize,
                        nodeSizeBucket: nodeSizeBucket,
                        totalNodes: totalNodes,
                        ttfb: ttfb,
                        severity: proseMirrorRenderedSeverity,
                        objectId: contextIdentifier?.objectId,
                        distortedDuration: distortedDuration
                    },
                    eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
                });
            }
        });
        pluginInjectionAPI.current.onEditorViewUpdated({
            newEditorState: viewRef.current.state,
            oldEditorState: undefined
        });
        return view;
    }, [
        getDirectEditorProps,
        dispatchAnalyticsEvent
    ]);
    const [editorView, setEditorView] = (0, $42omo.useState)(undefined);
    // Detects if the editor is nested inside an extension - ie. it is a Legacy Content Extension (LCE)
    const isNestedEditor = (0, $42omo.useRef)(null);
    const isNestedEditorCalculated = (0, $42omo.useRef)(false);
    if ((0, $dh538.fg)('platform_editor_lce_scrolltop_mitigation')) {
        if (editorRef.current !== null && !isNestedEditorCalculated.current) {
            isNestedEditor.current = !!editorRef.current?.closest('.extension-editable-area');
            isNestedEditorCalculated.current = true;
        }
    }
    const originalScrollToRestore = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(!isNestedEditor.current && (0, $geLSP.isFullPage)(props.editorProps.appearance) ? document.querySelector('[data-editor-scroll-container]')?.scrollTop : undefined);
    const mitigateScrollJump = // The feature gate here is being used to avoid potential bugs with the scroll restoration code
    // moving it to the end of the expression negates the point of the feature gate
    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    (0, $geLSP.isFullPage)(props.editorProps.appearance) && originalScrollToRestore.current && originalScrollToRestore.current !== 0;
    (0, $42omo.useLayoutEffect)(()=>{
        if (shouldFocus && editorView?.props.editable?.(editorView.state) && (0, $dh538.fg)('platform_editor_react_18_autofocus_fix')) {
            if (!mitigateScrollJump) {
                const liveDocWithContent = (__livePage || (0, $1oCLl.expValEquals)('platform_editor_no_cursor_on_edit_page_init', 'isEnabled', true)) && !(0, $2pjJ5.isEmptyDocument)(editorView.state.doc);
                if (!liveDocWithContent) focusTimeoutId.current = (0, $565b25adcfad3caf$export$ebebb7f5b9271fd7)(editorView);
                if ((0, $1oCLl.expValEquals)('platform_editor_no_cursor_on_edit_page_init', 'isEnabled', true) && (0, $dh538.fg)('cc_editor_focus_before_editor_on_load')) {
                    if (!disabled && shouldFocus && !(0, $2pjJ5.isEmptyDocument)(editorView.state.doc)) (0, $0d3266c92e7feda8$export$32ec9f77297f7957)(editorId.current);
                }
            }
        }
    }, [
        editorView,
        shouldFocus,
        __livePage,
        mitigateScrollJump,
        disabled
    ]);
    const scrollElement = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef();
    const possibleListeners = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef([]);
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        return ()=>{
            if (scrollElement.current) // eslint-disable-next-line react-hooks/exhaustive-deps
            for (const possibleListener of possibleListeners.current)// eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            scrollElement.current?.removeEventListener(...possibleListener);
            scrollElement.current = null;
        };
    }, []);
    const handleEditorViewRef = (0, $42omo.useCallback)((node)=>{
        if ((0, $aeAfU.expVal)('platform_editor_no_ssr', 'isEnabled', false) && (0, $eTj7Y.isSSR)()) return;
        if (node) {
            // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
            scrollElement.current = document.querySelector('[data-editor-scroll-container]');
            const cleanupListeners = ()=>{
                // eslint-disable-next-line react-hooks/exhaustive-deps
                for (const possibleListener of possibleListeners.current)// eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                scrollElement.current?.removeEventListener(...possibleListener);
            };
            if (scrollElement.current) {
                const wheelAbortHandler = ()=>{
                    const activeInteraction = (0, $4u5NT.getActiveInteraction)();
                    if (activeInteraction && [
                        'edit-page',
                        'live-edit'
                    ].includes(activeInteraction.ufoName)) (0, $4u5NT.abortAll)('new_interaction', `wheel-on-editor-element`);
                    cleanupListeners();
                };
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                scrollElement.current.addEventListener('wheel', wheelAbortHandler);
                possibleListeners.current.push([
                    'wheel',
                    wheelAbortHandler
                ]);
                const scrollAbortHandler = ()=>{
                    const activeInteraction = (0, $4u5NT.getActiveInteraction)();
                    if (activeInteraction && [
                        'edit-page',
                        'live-edit'
                    ].includes(activeInteraction.ufoName)) (0, $4u5NT.abortAll)('new_interaction', `scroll-on-editor-element`);
                    cleanupListeners();
                };
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                scrollElement.current.addEventListener('scroll', scrollAbortHandler);
                possibleListeners.current.push([
                    'scroll',
                    scrollAbortHandler
                ]);
            }
        }
        if (!viewRef.current && node) {
            (0, $92LVN.nodeVisibilityManager)(node).initialiseNodeObserver();
            const view = createEditorView(node);
            if (mitigateScrollJump) {
                const scrollElement = document.querySelector('[data-editor-scroll-container]');
                scrollElement?.scrollTo({
                    top: originalScrollToRestore.current,
                    behavior: 'instant'
                });
            }
            onEditorCreated({
                view: view,
                config: config.current,
                eventDispatcher: eventDispatcher,
                transformer: contentTransformer.current
            });
            if ((0, $dh538.fg)('platform_editor_react_18_autofocus_fix')) {
                /**
         * Defer using startTransition when it is available (in React 18) to fix
         * autofocus bug where React 18's concurrent rendering mode interferes with
         * setTimeout used in handleEditorFocus, causing autofocus to break.
         */ const react18OnlyStartTransition = (0, (/*@__PURE__*/$parcel$interopDefault($42omo)))?.startTransition ?? ((fn)=>fn());
                react18OnlyStartTransition(()=>{
                    // Force React to re-render so consumers get a reference to the editor view
                    setEditorView(view);
                });
            } else {
                if (shouldFocus && view.props.editable && view.props.editable(view.state)) {
                    if (!mitigateScrollJump) {
                        const isLivePageWithContent = (__livePage || (0, $1oCLl.expValEquals)('platform_editor_no_cursor_on_edit_page_init', 'isEnabled', true)) && !(0, $2pjJ5.isEmptyDocument)(view.state.doc);
                        if (!isLivePageWithContent && shouldFocus && view.props.editable && view.props.editable(view.state)) focusTimeoutId.current = (0, $565b25adcfad3caf$export$ebebb7f5b9271fd7)(view);
                        if ((0, $1oCLl.expValEquals)('platform_editor_no_cursor_on_edit_page_init', 'isEnabled', true) && (0, $dh538.fg)('cc_editor_focus_before_editor_on_load')) {
                            if (shouldFocus && view.props.editable && view.props.editable(view.state) && !(0, $2pjJ5.isEmptyDocument)(view.state.doc)) (0, $0d3266c92e7feda8$export$32ec9f77297f7957)(editorId.current);
                        }
                    }
                }
                // Force React to re-render so consumers get a reference to the editor view
                setEditorView(view);
            }
        } else if (viewRef.current && !node) {
            // When the appearance is changed, React will call handleEditorViewRef with node === null
            // to destroy the old EditorView, before calling this method again with node === div to
            // create the new EditorView
            onEditorDestroyed({
                view: viewRef.current,
                config: config.current,
                eventDispatcher: eventDispatcher,
                transformer: contentTransformer.current
            });
            const wasAnalyticsDisconnected = !eventDispatcher.has((0, $lWghV.analyticsEventKey), handleAnalyticsEvent);
            // If we disabled event listening for some reason we should re-enable it temporarily while we destroy
            // the view for any analytics that occur there.
            if (wasAnalyticsDisconnected) {
                eventDispatcher.on((0, $lWghV.analyticsEventKey), handleAnalyticsEvent);
                viewRef.current.destroy(); // Destroys the dom node & all node views
                eventDispatcher.off((0, $lWghV.analyticsEventKey), handleAnalyticsEvent);
            } else viewRef.current.destroy(); // Destroys the dom node & all node views
            (0, $92LVN.nodeVisibilityManager)(viewRef.current.dom).disconnect();
            viewRef.current = undefined;
        }
    }, [
        createEditorView,
        onEditorCreated,
        eventDispatcher,
        shouldFocus,
        __livePage,
        onEditorDestroyed,
        handleAnalyticsEvent,
        mitigateScrollJump
    ]);
    const createEditor = (0, $42omo.useCallback)((assistiveLabel, assistiveDescribedBy)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, (0, $dh538.fg)('cc_editor_focus_before_editor_on_load') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            tabIndex: -1,
            "data-focus-id": editorId.current,
            "data-testid": "react-editor-view-inital-focus-element"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `ProseMirror ${(0, $f1dc1dfba26b7751$export$11a24c7b1b4aab81)()}`,
            key: "ProseMirror",
            ref: handleEditorViewRef,
            "aria-label": assistiveLabel || props.intl.formatMessage((0, $170f814baa647977$export$3b488057bfc1868f).editorAssistiveLabel),
            // setting aria-multiline to true when not mobile appearance.
            //  because somehow mobile tests are failing when it set.
            //  don't know why that is happening.
            // Created https://product-fabric.atlassian.net/jira/servicedesk/projects/DTR/queues/issue/DTR-1675
            //  to investigate further.
            "aria-multiline": true,
            role: "textbox",
            id: $024596570cb688e3$var$EDIT_AREA_ID,
            "aria-describedby": assistiveDescribedBy,
            "data-editor-id": editorId.current,
            "data-vc-ignore-if-no-layout-shift": true,
            // eslint-disable-next-line react/no-danger -- needed for SSR and hydration so react keeps the HTML untouched
            dangerouslySetInnerHTML: (0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? {
                __html: ''
            } : undefined
        }));
    }, [
        handleEditorViewRef,
        props.intl
    ]);
    const previousPreset = (0, $7541v.default)(preset);
    (0, $42omo.useLayoutEffect)(()=>{
        if (previousPreset && previousPreset !== preset) reconfigureState(props);
    }, [
        reconfigureState,
        previousPreset,
        preset,
        props
    ]);
    const previousDisabledState = (0, $7541v.default)(disabled);
    (0, $42omo.useLayoutEffect)(()=>{
        if (viewRef.current && previousDisabledState !== disabled) {
            // Disables the contentEditable attribute of the editor if the editor is disabled
            viewRef.current.setProps({
                editable: (_state)=>!disabled
            });
            const isLivePageWithContent = (__livePage || (0, $1oCLl.expValEquals)('platform_editor_no_cursor_on_edit_page_init', 'isEnabled', true)) && !(0, $2pjJ5.isEmptyDocument)(viewRef.current.state.doc);
            if (!disabled && shouldFocus && !isLivePageWithContent) focusTimeoutId.current = (0, $565b25adcfad3caf$export$ebebb7f5b9271fd7)(viewRef.current);
            if ((0, $1oCLl.expValEquals)('platform_editor_no_cursor_on_edit_page_init', 'isEnabled', true) && (0, $dh538.fg)('cc_editor_focus_before_editor_on_load')) {
                if (!disabled && shouldFocus && !(0, $2pjJ5.isEmptyDocument)(viewRef.current.state.doc)) (0, $0d3266c92e7feda8$export$32ec9f77297f7957)(editorId.current);
            }
        }
    }, [
        disabled,
        shouldFocus,
        previousDisabledState,
        __livePage
    ]);
    (0, $5953f1dbb50e9aa2$export$4998b7b36606f9c3)(nextAppearance, dispatchAnalyticsEvent);
    const editor = (0, $42omo.useMemo)(()=>createEditor(props.editorProps.assistiveLabel, props.editorProps.assistiveDescribedBy), // `createEditor` changes a little too frequently - we don't want to recreate the editor view in this case
    // We should follow-up
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        props.editorProps.assistiveLabel,
        props.editorProps.assistiveDescribedBy
    ]);
    // Render tracking is firing too many events in Jira so we are disabling them for now. See - https://product-fabric.atlassian.net/browse/ED-25616
    // Also firing too many events for the legacy content macro, so disabling for now. See - https://product-fabric.atlassian.net/browse/ED-26650
    const renderTrackingEnabled = !(0, $dh538.fg)('platform_editor_disable_rerender_tracking_jira') && !featureFlags.lcmPreventRenderTracking;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $40aJG.default).Provider, {
        value: {
            editorRef: editorRef,
            editorView: viewRef.current,
            popupsMountPoint: props.editorProps.popupsMountPoint
        }
    }, renderTrackingEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2oRGU.RenderTracking), {
        componentProps: props,
        action: (0, $d925B.ACTION).RE_RENDERED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).REACT_EDITOR_VIEW,
        handleAnalyticsEvent: handleAnalyticsEvent,
        useShallow: true
    }), props.render ? props.render?.({
        editor: editor,
        view: viewRef.current,
        config: config.current,
        eventDispatcher: eventDispatcher,
        transformer: contentTransformer.current,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        editorRef: editorRef,
        editorAPI: editorAPI
    }) ?? editor : editor);
}
var // Preserving exact type generated by TypeScript
// eslint-disable-next-line @typescript-eslint/ban-types
$024596570cb688e3$export$2e2bcd8739ae039 = (0, $gmMgo.default)($024596570cb688e3$export$e7d1b1cbca007e16);
module.exports["ReactEditorView"] = $024596570cb688e3$export$e7d1b1cbca007e16;

});

parcelRegister("7541v", function(module, exports) {
$parcel$export(module.exports, "default", () => $ebe99912880d9fde$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

function $ebe99912880d9fde$export$2e2bcd8739ae039(value, initialValue) {
    const ref = (0, $42omo.useRef)(initialValue);
    (0, $42omo.useEffect)(()=>{
        // Setting the value to ref.current inside an effect, or otherwise the behaviour in staging/prod doesn't match with local
        // In local, the double rendering in react dev mode causes the previous value to be the same as next value immediately after
        // In prod and staging, double rendering is not done since that is a react prod build
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}

});

parcelRegister("92LVN", function(module, exports) {
// Use this selector to set the intersection observer boundary for editor's inline node views
// If this does not exist, it will use the IntersectionObserver's default root
const $1660546fee445dc4$var$INTERSECTION_OBSERVER_ROOT_SELECTOR = '[data-editor-scroll-container="true"]';
const $1660546fee445dc4$var$editorObservers = new WeakMap();
const $1660546fee445dc4$var$callbackMap = new WeakMap();
const $1660546fee445dc4$export$565ab8668cdfbb7c = (editorElement)=>{
    // Warning! do not reference editorElement outside of internal functions.
    // editorElement is passed to allow support for multiple editors,
    const unObserveInternal = (nodeElement)=>{
        $1660546fee445dc4$var$editorObservers.get(editorElement)?.unobserve(nodeElement);
        $1660546fee445dc4$var$callbackMap.delete(nodeElement);
    };
    const observe = (observerConfig)=>{
        $1660546fee445dc4$var$callbackMap.set(observerConfig.element, observerConfig);
        $1660546fee445dc4$var$editorObservers.get(editorElement)?.observe(observerConfig.element);
        // return clean up
        return ()=>{
            // consumer needs to unobserve on destroy if their element
            // was observed but never scrolled into view
            unObserveInternal(observerConfig.element);
        };
    };
    const initialiseNodeObserver = ()=>{
        if ($1660546fee445dc4$var$editorObservers.has(editorElement)) return;
        const intersectionObserverOptions = {
            root: editorElement.closest($1660546fee445dc4$var$INTERSECTION_OBSERVER_ROOT_SELECTOR),
            rootMargin: '0px 0px 100px 0px',
            threshold: 0
        };
        const editorObserver = new IntersectionObserver((entries)=>entries.map((entry)=>({
                    entry: entry,
                    callback: $1660546fee445dc4$var$callbackMap.get(entry.target)
                }))// Invoke callbacks together to group browser rendering
            // Avoiding requestAnimationFrame to reduce visual flickering
            .forEach(({ entry: entry, callback: callback })=>{
                if (entry.isIntersecting) {
                    callback?.onFirstVisible();
                    if (entry.target instanceof HTMLElement) // immediately unobserve the element after it is visible
                    unObserveInternal(entry.target);
                }
            }), intersectionObserverOptions);
        $1660546fee445dc4$var$editorObservers.set(editorElement, editorObserver);
    };
    const disconnect = ()=>{
        $1660546fee445dc4$var$editorObservers.get(editorElement)?.disconnect();
        $1660546fee445dc4$var$editorObservers.delete(editorElement);
    };
    return {
        initialiseNodeObserver: initialiseNodeObserver,
        observe: observe,
        disconnect: disconnect
    };
};
module.exports["nodeVisibilityManager"] = $1660546fee445dc4$export$565ab8668cdfbb7c;

});

parcelRegister("2pjJ5", function(module, exports) {

var $3FxV8 = parcelRequire("3FxV8");


var $aXG5V = parcelRequire("aXG5V");


var $dh538 = parcelRequire("dh538");


var $kTbzR = parcelRequire("kTbzR");

const $a5f7a02a123b6264$export$c8e611b6ac095e6d = (transaction)=>{
    let from = -1;
    let to = -1;
    transaction.mapping.maps.forEach((stepMap, index)=>{
        stepMap.forEach((oldStart, oldEnd)=>{
            const newStart = transaction.mapping.slice(index).map(oldStart, -1);
            const newEnd = transaction.mapping.slice(index).map(oldEnd);
            from = newStart < from || from === -1 ? newStart : from;
            to = newEnd > to || to === -1 ? newEnd : to;
            // See ticket https://hello.jira.atlassian.cloud/browse/EDITOR-1223 and
            // PR https://bitbucket.org/atlassian/atlassian-frontend-monorepo/pull-requests/208332/overview
            // to see why use clamp here
            if ((0, $dh538.fg)('aifc_create_enabled')) {
                const docSize = transaction.doc.content.size;
                from = (0, (/*@__PURE__*/$parcel$interopDefault($3FxV8)))(from, 0, docSize);
                to = (0, (/*@__PURE__*/$parcel$interopDefault($3FxV8)))(to, 0, docSize);
            }
        });
    });
    if (from !== -1) return {
        from: from,
        to: to
    };
    return null;
};
function $a5f7a02a123b6264$export$f76a7d770092ea11($anchor) {
    return $anchor.depth === 1;
}
function $a5f7a02a123b6264$export$2da47a16c0b6bcb(node) {
    const nodeChild = node.content.firstChild;
    if (node.childCount !== 1 || !nodeChild) return false;
    return (0, $kTbzR.isEmptyParagraph)(nodeChild);
}
function $a5f7a02a123b6264$export$df0539d254c75c33(state) {
    const { selection: selection } = state;
    const { $cursor: $cursor, $anchor: $anchor } = selection;
    if (!$cursor) return false;
    const node = $cursor.nodeBefore;
    if (!node) return false;
    if (node.type.name === 'text' && node.text === '{') {
        const paragraphNode = $anchor.node();
        return paragraphNode.marks.length === 0 && $a5f7a02a123b6264$export$f76a7d770092ea11($anchor);
    }
    return false;
}
function $a5f7a02a123b6264$export$f9e52d2e832a6aae(tr, f, startPos) {
    const stepRange = $a5f7a02a123b6264$export$c8e611b6ac095e6d(tr);
    if (!stepRange) return;
    tr.doc.nodesBetween(stepRange.from, stepRange.to, f, startPos);
}
function $a5f7a02a123b6264$export$c9083db5521330d3(node) {
    const isInlineNodeHasVisibleContent = (inlineNode)=>{
        return inlineNode.isText ? !!inlineNode.textContent.trim() : inlineNode.type.name !== 'hardBreak';
    };
    if (node.isInline) return isInlineNodeHasVisibleContent(node);
    else if (node.isBlock && (node.isLeaf || node.isAtom)) return true;
    else if (!node.childCount) return false;
    for(let index = 0; index < node.childCount; index++){
        const child = node.child(index);
        const invisibleNodeTypes = [
            'paragraph',
            'text',
            'hardBreak'
        ];
        if (!invisibleNodeTypes.includes(child.type.name) || $a5f7a02a123b6264$export$c9083db5521330d3(child)) return true;
    }
    return false;
}
const $a5f7a02a123b6264$export$435c1d4e61a8723b = (state)=>state.selection.$to.parent.type === state.schema.nodes.paragraph && state.selection.$to.pos === state.doc.resolve(state.selection.$to.pos).end();
function $a5f7a02a123b6264$var$getChangedNodesIn({ tr: tr, doc: doc }) {
    const nodes = [];
    const stepRange = $a5f7a02a123b6264$export$c8e611b6ac095e6d(tr);
    if (!stepRange) return nodes;
    const from = Math.min(doc.nodeSize - 2, stepRange.from);
    const to = Math.min(doc.nodeSize - 2, stepRange.to);
    doc.nodesBetween(from, to, (node, pos)=>{
        nodes.push({
            node: node,
            pos: pos
        });
    });
    return nodes;
}
function $a5f7a02a123b6264$export$fd9c3e0f31aab835(tr) {
    return $a5f7a02a123b6264$var$getChangedNodesIn({
        tr: tr,
        doc: tr.doc
    });
}
const $a5f7a02a123b6264$export$b81ebf241519dbe1 = (transactions, oldState)=>{
    return transactions.some((tr)=>{
        if (tr.getMeta('replaceDocument')) return true;
        const hasStepReplacingEntireDocument = tr.steps.some((step)=>{
            if (!(step instanceof (0, $aXG5V.ReplaceStep))) return false;
            const isStepReplacingFromDocStart = step.from === 0;
            const isStepReplacingUntilTheEndOfDocument = step.to === oldState.doc.content.size;
            if (!isStepReplacingFromDocStart || !isStepReplacingUntilTheEndOfDocument) return false;
            return true;
        });
        return hasStepReplacingEntireDocument;
    });
};
function $a5f7a02a123b6264$export$e3b603f98921291f(node1, node2) {
    if (node1.isText) return node1.eq(node2);
    return node1 === node2 || node1.hasMarkup(node2.type, node1.attrs, node2.marks) && $a5f7a02a123b6264$var$areFragmentsEqual(node1.content, node2.content);
}
function $a5f7a02a123b6264$var$areFragmentsEqual(frag1, frag2) {
    if (frag1.content.length !== frag2.content.length) return false;
    let childrenEqual = true;
    frag1.content.forEach((child, i)=>{
        const otherChild = frag2.child(i);
        if (child === otherChild || otherChild && $a5f7a02a123b6264$export$e3b603f98921291f(child, otherChild)) return;
        childrenEqual = false;
    });
    return childrenEqual;
}
module.exports["getStepRange"] = $a5f7a02a123b6264$export$c8e611b6ac095e6d;
module.exports["hasDocAsParent"] = $a5f7a02a123b6264$export$f76a7d770092ea11;
module.exports["isEmptyDocument"] = $a5f7a02a123b6264$export$2da47a16c0b6bcb;
module.exports["bracketTyped"] = $a5f7a02a123b6264$export$df0539d254c75c33;
module.exports["nodesBetweenChanged"] = $a5f7a02a123b6264$export$f9e52d2e832a6aae;
module.exports["hasVisibleContent"] = $a5f7a02a123b6264$export$c9083db5521330d3;
module.exports["isSelectionEndOfParagraph"] = $a5f7a02a123b6264$export$435c1d4e61a8723b;
module.exports["getChangedNodes"] = $a5f7a02a123b6264$export$fd9c3e0f31aab835;
module.exports["isReplaceDocOperation"] = $a5f7a02a123b6264$export$b81ebf241519dbe1;
module.exports["areNodesEqualIgnoreAttrs"] = $a5f7a02a123b6264$export$e3b603f98921291f;

});

parcelRegister("kTbzR", function(module, exports) {

var $ks2lK = parcelRequire("ks2lK");


var $aXG5V = parcelRequire("aXG5V");


var $8m4tT = parcelRequire("8m4tT");


var $7XFGZ = parcelRequire("7XFGZ");


var $4vlwG = parcelRequire("4vlwG");

function $ab19fe955bb1fbb0$export$b648602b09795358(node) {
    return !!node && node.type.name === 'paragraph' && !node.childCount;
}
const $ab19fe955bb1fbb0$export$53780b185b887309 = (step)=>step && step.hasOwnProperty('slice');
function $ab19fe955bb1fbb0$export$f4d51ccab05f55c9(step, nodeTypes) {
    let adds = false;
    if (!$ab19fe955bb1fbb0$export$53780b185b887309(step)) return adds;
    step.slice.content.descendants((node)=>{
        if (nodeTypes.has(node.type)) adds = true;
        return !adds;
    });
    return adds;
}
const $ab19fe955bb1fbb0$export$d0a9dfe2556a9577 = (step)=>{
    if (!(step instanceof (0, $aXG5V.ReplaceStep)) && !(step instanceof (0, $aXG5V.ReplaceAroundStep))) return null;
    // @ts-ignore This is by design. Slice is a private property, but accesible, from ReplaceStep.
    // However, we need to read it to found if the step was adding a newline
    const slice = step.slice;
    return slice;
};
const $ab19fe955bb1fbb0$export$38b50bf35e79aaf3 = (selection)=>selection instanceof (0, $ks2lK.TextSelection);
const $ab19fe955bb1fbb0$export$5588122b9eea7733 = (element)=>{
    return (0, $4vlwG.closest)(element, 'td, th');
};
const $ab19fe955bb1fbb0$export$142c0ee6457f50d6 = (node)=>{
    const { content: content } = node;
    return !!content.lastChild && content.lastChild.type.name === 'mediaGroup';
};
const $ab19fe955bb1fbb0$export$a367515ca2c9ace1 = (view, pos)=>{
    const { state: state, dispatch: dispatch } = view;
    if (!isFinite(pos)) return;
    const tr = state.tr.setSelection((0, $ks2lK.NodeSelection).create(state.doc, pos));
    dispatch(tr);
};
function $ab19fe955bb1fbb0$export$1df6d14df6b0b758(view, anchor, head) {
    const { state: state, dispatch: dispatch } = view;
    const tr = state.tr.setSelection((0, $ks2lK.TextSelection).create(state.doc, anchor, head));
    dispatch(tr);
}
function $ab19fe955bb1fbb0$export$abad69d764760c05(view) {
    const { state: state, dispatch: dispatch } = view;
    const tr = state.tr.setSelection(new (0, $ks2lK.AllSelection)(view.state.doc));
    dispatch(tr);
}
function $ab19fe955bb1fbb0$export$8f10f8581a0e9ba2(view, anchor, head) {
    const { state: state, dispatch: dispatch } = view;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    dispatch(state.tr.setSelection((0, $7XFGZ.CellSelection).create(state.doc, anchor, head)));
}
function $ab19fe955bb1fbb0$export$26128561c93f5847(value) {
    return value !== null && value !== undefined;
}
const $ab19fe955bb1fbb0$export$de0495c7bd37bf4e = (pos, state)=>{
    if (typeof pos !== 'number') return false;
    if (pos >= 0 && pos <= state.doc.resolve(0).end()) return true;
    return false;
};
const $ab19fe955bb1fbb0$export$2de06a6e688827fd = (state)=>{
    return (0, $8m4tT.hasParentNodeOfType)(state.schema.nodes.layoutSection)(state.selection);
};
function $ab19fe955bb1fbb0$export$e46323d96cf32194(doc, from, to, predicate) {
    const results = [];
    doc.nodesBetween(from, to, (node, pos, parent)=>{
        if (predicate(node, pos, parent)) results.push({
            node: node,
            pos: pos
        });
    });
    return results;
}
const $ab19fe955bb1fbb0$export$fba8af3b998832b9 = (state, marks)=>{
    const { selection: selection, schema: schema } = state;
    let { tr: tr } = state;
    // Marks might not exist in Schema
    const marksToRemove = marks.filter(Boolean);
    if (marksToRemove.length === 0) return undefined;
    /** Saves an extra dispatch */ let blockMarksExists = false;
    const hasMark = (mark)=>marksToRemove.indexOf(mark.type) > -1;
    /**
	 * When you need to toggle the selection
	 * when another type which does not allow alignment is applied
	 */ state.doc.nodesBetween(selection.from, selection.to, (node, pos)=>{
        if (node.type === schema.nodes.paragraph && node.marks.some(hasMark)) {
            blockMarksExists = true;
            const resolvedPos = state.doc.resolve(pos);
            const withoutBlockMarks = node.marks.filter($ab19fe955bb1fbb0$var$not(hasMark));
            tr = tr.setNodeMarkup(resolvedPos.pos, undefined, node.attrs, withoutBlockMarks);
        }
    });
    return blockMarksExists ? tr : undefined;
};
const $ab19fe955bb1fbb0$var$not = (fn)=>(arg)=>!fn(arg);
module.exports["isEmptyParagraph"] = $ab19fe955bb1fbb0$export$b648602b09795358;
module.exports["stepHasSlice"] = $ab19fe955bb1fbb0$export$53780b185b887309;
module.exports["stepAddsOneOf"] = $ab19fe955bb1fbb0$export$f4d51ccab05f55c9;
module.exports["extractSliceFromStep"] = $ab19fe955bb1fbb0$export$d0a9dfe2556a9577;
module.exports["isTextSelection"] = $ab19fe955bb1fbb0$export$38b50bf35e79aaf3;
module.exports["isElementInTableCell"] = $ab19fe955bb1fbb0$export$5588122b9eea7733;
module.exports["isLastItemMediaGroup"] = $ab19fe955bb1fbb0$export$142c0ee6457f50d6;
module.exports["setNodeSelection"] = $ab19fe955bb1fbb0$export$a367515ca2c9ace1;
module.exports["setTextSelection"] = $ab19fe955bb1fbb0$export$1df6d14df6b0b758;
module.exports["nonNullable"] = $ab19fe955bb1fbb0$export$26128561c93f5847;
module.exports["isValidPosition"] = $ab19fe955bb1fbb0$export$de0495c7bd37bf4e;
module.exports["isInLayoutColumn"] = $ab19fe955bb1fbb0$export$2de06a6e688827fd;
module.exports["filterChildrenBetween"] = $ab19fe955bb1fbb0$export$e46323d96cf32194;
module.exports["removeBlockMarks"] = $ab19fe955bb1fbb0$export$fba8af3b998832b9;

});

parcelRegister("hEPfr", function(module, exports) {
function $0f830263e94a6c1b$export$3674f49b2d541ad(node) {
    const count = {};
    node.nodesBetween(0, node.nodeSize - 2, (node)=>{
        count[node.type.name] = (count[node.type.name] || 0) + 1;
    });
    return count;
}
module.exports["getNodesCount"] = $0f830263e94a6c1b$export$3674f49b2d541ad;

});

parcelRegister("geLSP", function(module, exports) {
function $636443110c5c1dfb$export$2800a15841f40ad7(appearance) {
    return appearance === 'full-page' || appearance === 'full-width';
}
module.exports["isFullPage"] = $636443110c5c1dfb$export$2800a15841f40ad7;

});

parcelRegister("h9Yad", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cUcZ5 = parcelRequire("cUcZ5");


var $ZkPRR = parcelRequire("ZkPRR");

function $3946837408650aa8$export$ebce6d7d8ca67353({ onRender: onRender, propsDiffingOptions: propsDiffingOptions, zeroBasedCount: zeroBasedCount = true }) {
    const propsRef = (0, $42omo.useRef)();
    const renderCountRef = (0, $42omo.useRef)(zeroBasedCount ? 0 : 1);
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const { current: componentId } = (0, $42omo.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))());
    (0, $42omo.useEffect)(()=>{
        const lastProps = propsRef.current;
        const renderCount = renderCountRef.current;
        let propsDifference;
        if (propsDiffingOptions?.enabled && lastProps) propsDifference = propsDiffingOptions?.useShallow ? (0, $ZkPRR.getShallowPropsDifference)(lastProps, propsDiffingOptions.props) : (0, $ZkPRR.getPropsDifference)(lastProps, propsDiffingOptions.props, 0, 2, propsDiffingOptions?.propsToIgnore);
        const result = {
            renderCount: renderCount,
            propsDifference: propsDifference,
            componentId: componentId
        };
        onRender(result);
        if (propsDiffingOptions?.enabled) propsRef.current = propsDiffingOptions.props;
        renderCountRef.current = renderCountRef.current + 1;
    }); // No dependencies run on each render
}
module.exports["useComponentRenderTracking"] = $3946837408650aa8$export$ebce6d7d8ca67353;

});

parcelRegister("ZkPRR", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $88475e86f62b9e57$export$74743eda5dda3ccf = Object.keys;
const $88475e86f62b9e57$export$aedd1a2d18cbf42b = (object1, object2)=>{
    const oldKeys = object1 !== null ? $88475e86f62b9e57$export$74743eda5dda3ccf(object1) : [];
    const newKeys = object2 !== null ? $88475e86f62b9e57$export$74743eda5dda3ccf(object2) : [];
    const removed = oldKeys.filter((key)=>!newKeys.includes(key));
    const added = newKeys.filter((key)=>!oldKeys.includes(key));
    const common = oldKeys.filter((key)=>newKeys.includes(key));
    return {
        added: added,
        common: common,
        removed: removed
    };
};
const $88475e86f62b9e57$export$f4c1dafc9df1f03 = (value)=>{
    const valueType = typeof value;
    if (value === null) return 'null';
    else if (value === undefined) return 'undefined';
    else if (valueType === 'string' || valueType === 'number') return value;
    else if (valueType === 'symbol') return value.toString();
    else if (valueType === 'function') return `function:${value.name}`;
    else if (valueType === 'object') return {
        type: 'object',
        keys: Object.keys(value)
    };
};
const $88475e86f62b9e57$export$d438af18e3a25d10 = (object1, object2, curDepth = 0, maxDepth = 2, keysToIgnore = [])=>{
    const { added: added, common: common, removed: removed } = $88475e86f62b9e57$export$aedd1a2d18cbf42b(object1, object2);
    const changed = [];
    common.forEach((key)=>{
        const value1 = object1[key];
        const value2 = object2[key];
        const value1Type = typeof value1;
        const value2Type = typeof value2;
        // Do comparision only if values doesn't match (or reference to same object in memory).
        // Or if key does not exist in keys to ignore.
        if (value1 !== value2 && keysToIgnore.indexOf(key) === -1) {
            // if both key value are objects and not referencing same object in memory.
            //  then get recursive difference.
            if ((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(value1) || (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(value2)) changed.push({
                key: key,
                reactElementChanged: true
            });
            else if (value1Type === 'object' && value2Type === 'object') {
                if (curDepth <= maxDepth) {
                    const difference = $88475e86f62b9e57$export$d438af18e3a25d10(value1, value2, curDepth + 1, maxDepth);
                    changed.push({
                        key: key,
                        difference: difference
                    });
                } else changed.push({
                    key: key,
                    maxDepthReached: true
                });
            } else changed.push({
                key: key,
                oldValue: $88475e86f62b9e57$export$f4c1dafc9df1f03(value1),
                newValue: $88475e86f62b9e57$export$f4c1dafc9df1f03(value2)
            });
        }
    });
    return {
        added: added,
        changed: changed,
        removed: removed
    };
};
const $88475e86f62b9e57$export$418b0a935c0a0030 = (object1, object2)=>{
    const { added: added, common: common, removed: removed } = $88475e86f62b9e57$export$aedd1a2d18cbf42b(object1, object2);
    const changed = common.filter((key)=>object1[key] !== object2[key]);
    return {
        added: added,
        changed: changed,
        removed: removed
    };
};
module.exports["getPropsDifference"] = $88475e86f62b9e57$export$d438af18e3a25d10;
module.exports["getShallowPropsDifference"] = $88475e86f62b9e57$export$418b0a935c0a0030;

});

parcelRegister("dSVmA", function(module, exports) {
class $9e998316eee14f1b$export$88da0ac32d9c271e {
    captureMessage(msg, tags) {
        if (this.handlerStorage) this.handlerStorage.captureMessage(msg, tags);
    }
    captureException(err, tags) {
        if (this.handlerStorage) this.handlerStorage.captureException(err, tags);
    }
    set handler(handler) {
        this.handlerStorage = handler;
    }
    constructor(){
        this.handlerStorage = null;
    }
}
module.exports["ErrorReporter"] = $9e998316eee14f1b$export$88da0ac32d9c271e;

});

parcelRegister("2oGxU", function(module, exports) {
// eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
// @deprecated
// @private This rank is not stable and should not be trusted. If you need to change this file, please let the Editor lego team know about it
const $1829e3410f9040f1$export$d4a08ec0aa6e0cef = {
    plugins: [
        'featureFlagsContextPlugin',
        'compositionPlugin',
        'inlineCursorTargetPlugin',
        'typeAhead',
        'typeAheadInsertItem',
        'focusHandlerPlugin',
        'frozenEditor',
        'submitEditor',
        'saveOnEnter',
        'customAutoformatting',
        'newlinePreserveMarksPlugin',
        'imageUpload',
        'imageUploadInputRule',
        'clipboard',
        'paste',
        'pasteKeymap',
        'mention',
        'mentionInputRule',
        'mentionKeymap',
        'emoji',
        'placeholderText',
        'emojiInputRule',
        'emojiKeymap',
        'emojiAsciiInputRule',
        'blockType',
        'quickInsert',
        'tasksAndDecisions',
        'blockTypeInputRule',
        'tasksAndDecisionsInputRule',
        'list',
        'typeAheadKeymap',
        'typeAheadInputRule',
        'date',
        'dateKeymap',
        // This should be always after `typeAheadKeymap` & `emojiKeymap`
        'indentationKeymap',
        'textColor',
        'highlight',
        'highlightKeymap',
        'alignmentPlugin',
        'listInputRule',
        'listKeymap',
        'codeBlock',
        'codeBlockIDEKeyBindings',
        'codeBlockKeyMap',
        'textFormatting',
        'textFormattingCursor',
        'textFormattingInputRule',
        'textFormattingSmartRule',
        'textFormattingClear',
        'textFormattingKeymap',
        // task/decisions keymap needs to be above table keymap so can indent actions in a table
        'tasksAndDecisionsKeyMap',
        // expand and table keymaps need to be above selection keymap to add their custom selection behaviour:
        // https://product-fabric.atlassian.net/wiki/spaces/E/pages/1113098008/Selection+Guide#Special-Cases
        'expandKeymap',
        'tableSelectionKeymap',
        'tableKeymap',
        'captionKeymap',
        // media keymap above selection keymap to allow navigating past the mediaSingle node
        'mediaKeymap',
        // selection keymap needs to be above gap cursor keymap so it can set node selections from
        // left/right arrows
        'selectionKeymap',
        'gapCursorKeymap',
        'gapCursor',
        'syncUrlText',
        'fakeCursorToolbarPlugin',
        'hyperLink',
        'table',
        'tableDecorations',
        'hyperlinkInputRule',
        'tablePMColResizing',
        'hyperlinkKeymap',
        'tableColResizing',
        'undoRedoKeyMap',
        'blockTypeKeyMap',
        'tableEditing',
        'filterStepsPlugin',
        'pmCollab',
        'collab',
        'ruleInputRule',
        'ruleKeymap',
        'panel',
        'media',
        'mediaSingleKeymap',
        'mediaEditor',
        'unsupportedContent',
        'jiraIssue',
        'helpDialog',
        'helpDialogKeymap',
        'macro',
        'expand',
        'extension',
        'layout',
        'contextPanel',
        'selectionToolbar',
        'floatingToolbar',
        'clearMarksOnChange',
        'reactNodeView',
        'history',
        'undoRedoPlugin',
        'codeBlockIndent',
        'placeholder',
        'width',
        'maxContentSize',
        'multilineContent',
        'grid',
        'mobileDimensions',
        'scrollGutterPlugin',
        'analytics',
        'findReplace',
        'selection',
        'avatarGroup',
        'viewUpdateSubscription',
        'beforePrimaryToolbar',
        'inlineCode'
    ],
    nodes: [
        'doc',
        'paragraph',
        'text',
        'bulletList',
        'orderedList',
        'listItem',
        'heading',
        'blockquote',
        'codeBlock',
        'rule',
        'panel',
        'mention',
        'confluenceUnsupportedBlock',
        'confluenceUnsupportedInline',
        'unsupportedBlock',
        'unsupportedInline',
        'confluenceJiraIssue',
        'hardBreak',
        'emoji',
        'placeholder',
        'mediaSingle',
        'mediaGroup',
        'table',
        'expand',
        'nestedExpand',
        'media',
        'tableHeader',
        'decisionList',
        'tableRow',
        'decisionItem',
        'tableCell',
        'taskList',
        'taskItem',
        'extension',
        'bodiedExtension',
        'multiBodiedExtension',
        'inlineExtension',
        'layoutSection',
        'layoutColumn',
        'inlineCard',
        'blockCard',
        'embedCard'
    ],
    marks: [
        // Fragment mark is both for inline and block elements
        'fragment',
        // Inline marks
        'link',
        'em',
        'strong',
        'textColor',
        'backgroundColor',
        'strike',
        'subsup',
        'underline',
        'code',
        'typeAheadQuery',
        // Block marks
        'alignment',
        'breakout',
        'indentation',
        'annotation',
        'dataConsumer',
        'border',
        // Unsupported mark
        'unsupportedMark',
        'unsupportedNodeAttribute'
    ]
};
function $1829e3410f9040f1$export$49afdc3354d5c84e(item) {
    return function(a, b) {
        return $1829e3410f9040f1$export$d4a08ec0aa6e0cef[item].indexOf(a.name) - $1829e3410f9040f1$export$d4a08ec0aa6e0cef[item].indexOf(b.name);
    };
}
function $1829e3410f9040f1$export$b4ae7ad1c009d0a1(item) {
    return function(a, b) {
        return $1829e3410f9040f1$export$d4a08ec0aa6e0cef[item].indexOf(a.type.name) - $1829e3410f9040f1$export$d4a08ec0aa6e0cef[item].indexOf(b.type.name);
    };
}
module.exports["sortByOrder"] = $1829e3410f9040f1$export$49afdc3354d5c84e;
module.exports["sortByOrderWithTypeName"] = $1829e3410f9040f1$export$b4ae7ad1c009d0a1;

});

parcelRegister("1B55v", function(module, exports) {
$parcel$export(module.exports, "default", () => $a071074fd2398ee1$export$2e2bcd8739ae039);

var $6DQRK = parcelRequire("6DQRK");


var $geLSP = parcelRequire("geLSP");

const $a071074fd2398ee1$var$isCodeBlockAllowed = (options)=>{
    const exclude = options && options.allowBlockType && options.allowBlockType.exclude ? options.allowBlockType.exclude : [];
    return exclude.indexOf('codeBlock') === -1;
};
function $a071074fd2398ee1$export$f94443780f769f8(props) {
    const { appearance: appearance } = props;
    if ((0, $geLSP.isFullPage)(appearance)) // Full Page appearance uses a scrollable div wrapper.
    return {
        getScrollElement: ()=>document.querySelector('.fabric-editor-popup-scroll-parent')
    };
    return undefined;
}
function $a071074fd2398ee1$export$fdea1e40b8747a5b(props, createAnalyticsEvent) {
    const appearance = props.appearance;
    const cardOptions = props.linking?.smartLinks || props.smartLinks || props.UNSAFE_cards;
    return {
        ...props,
        createAnalyticsEvent: createAnalyticsEvent,
        typeAhead: {
            isMobile: false
        },
        featureFlags: (0, $6DQRK.createFeatureFlagsFromProps)(props.featureFlags),
        paste: {
            cardOptions: cardOptions,
            sanitizePrivateContent: props.sanitizePrivateContent
        },
        base: {
            allowInlineCursorTarget: true,
            allowScrollGutter: $a071074fd2398ee1$export$f94443780f769f8(props)
        },
        blockType: {
            lastNodeMustBeParagraph: appearance === 'comment' || appearance === 'chromeless',
            allowBlockType: props.allowBlockType,
            isUndoRedoButtonsEnabled: props.allowUndoRedoButtons
        },
        placeholder: {
            placeholder: props.placeholder,
            placeholderBracketHint: props.placeholderBracketHint
        },
        textFormatting: {
            ...props.textFormatting || {},
            responsiveToolbarMenu: props.textFormatting?.responsiveToolbarMenu != null ? props.textFormatting.responsiveToolbarMenu : props.allowUndoRedoButtons
        },
        submitEditor: props.onSave,
        quickInsert: {
            enableElementBrowser: props.elementBrowser && props.elementBrowser.showModal,
            elementBrowserHelpUrl: props.elementBrowser && props.elementBrowser.helpUrl,
            disableDefaultItems: props.quickInsert && typeof props.quickInsert !== 'boolean' && props.quickInsert.disableDefaultItems || false,
            headless: false,
            emptyStateHandler: props.elementBrowser && props.elementBrowser.emptyStateHandler,
            prioritySortingFn: props.quickInsert && typeof props.quickInsert !== 'boolean' && props.quickInsert.prioritySortingFn || undefined,
            onInsert: props.quickInsert && typeof props.quickInsert !== 'boolean' && props.quickInsert.onInsert || undefined
        },
        selection: {
            useLongPressSelection: false
        },
        hyperlinkOptions: {
            editorAppearance: props.appearance,
            linkPicker: props.linking?.linkPicker,
            onClickCallback: cardOptions?.onClickCallback,
            platform: 'web',
            autoLinkOnBlur: props.linking?.autoLinkOnBlur
        },
        codeBlock: {
            ...props.codeBlock,
            useLongPressSelection: false,
            allowCompositionInputOverride: false
        }
    };
}
function $a071074fd2398ee1$export$2e2bcd8739ae039(// eslint-disable-next-line @typescript-eslint/no-explicit-any
preset, props, pluginInjectionAPI) {
    const excludes = new Set();
    if (!$a071074fd2398ee1$var$isCodeBlockAllowed({
        allowBlockType: props.allowBlockType
    })) excludes.add('codeBlock');
    return preset.build({
        pluginInjectionAPI: pluginInjectionAPI,
        excludePlugins: excludes
    });
}
module.exports["getDefaultPresetOptionsFromEditorProps"] = $a071074fd2398ee1$export$fdea1e40b8747a5b;

});

parcelRegister("4VpM8", function(module, exports) {

var $4XhNP = parcelRequire("4XhNP");

function $62c5e4b0ecece381$export$d9985be1ece4b7ee(tr) {
    return tr.steps.filter((step)=>step instanceof (0, $4XhNP.AnalyticsStep)).reduce((acc, step)=>[
            ...acc,
            ...step.analyticsEvents
        ], []);
}
module.exports["getAnalyticsEventsFromTransaction"] = $62c5e4b0ecece381$export$d9985be1ece4b7ee;

});

parcelRegister("f8zg2", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gmMgo = parcelRequire("gmMgo");

var $1e2E5 = parcelRequire("1e2E5");

const $2dfeb0eb8ad08222$var$useCheckIntlContext = ()=>(0, $42omo.useContext)((0, $gmMgo.Context)) === null;
function $2dfeb0eb8ad08222$export$742fe272b8921eea({ children: children }) {
    const missingIntlContext = $2dfeb0eb8ad08222$var$useCheckIntlContext();
    if (missingIntlContext) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1e2E5.default), {
        locale: "en"
    }, children);
    return children;
}
module.exports["IntlProviderIfMissingWrapper"] = $2dfeb0eb8ad08222$export$742fe272b8921eea;

});

parcelRegister("eEmxu", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b623af3ab0506ee$export$2e2bcd8739ae039);

var $iScNA = parcelRequire("iScNA");

var /**
 * Allow to run methods from the `ExtensionProvider` interface across all providers seamlessly.
 * This handles promise racing and discards rejected promises safely.
 */ $9b623af3ab0506ee$export$2e2bcd8739ae039 = (extensionProviders)=>{
    let providersCache = [];
    const { invokeSingle: invokeSingle, invokeList: invokeList } = (0, $iScNA.default)(extensionProviders);
    return {
        getExtensions () {
            return invokeList('getExtensions');
        },
        async preload () {
            if (providersCache.length === 0) providersCache = await Promise.all(extensionProviders.map((provider)=>Promise.resolve(provider)));
            await Promise.all(providersCache.map((provider)=>provider?.preload?.()));
        },
        getPreloadedExtension (type, key) {
            if (providersCache.length === 0) // preload() has not been called yet
            return;
            for (const provider of providersCache)try {
                const result = provider?.getPreloadedExtension?.(type, key);
                if (result) return result;
            } catch  {
            // Not every provider will implement this method.
            // In that case we would get error from other providers in the loop
            // and undefined from that particular provider.
            // We can safely ignore it and fallback to the async getExtension when nothing was found.
            }
        },
        getExtension (type, key) {
            return invokeSingle('getExtension', [
                type,
                key
            ]);
        },
        search (keyword) {
            return invokeList('search', [
                keyword
            ]);
        },
        getAutoConverter () {
            return invokeList('getAutoConverter');
        }
    };
};

});

parcelRegister("6cQbn", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $2daQU = parcelRequire("2daQU");


var $8C5kA = parcelRequire("8C5kA");


var $hArLp = parcelRequire("hArLp");


var $ccHMk = parcelRequire("ccHMk");


var $1Oo9w = parcelRequire("1Oo9w");

var $eiA8Z = parcelRequire("eiA8Z");


var $61p3e = parcelRequire("61p3e");


var $bWRlG = parcelRequire("bWRlG");


var $5Gwdo = parcelRequire("5Gwdo");


var $aFUXX = parcelRequire("aFUXX");


var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");


var $kXpLO = parcelRequire("kXpLO");


var $45E6y = parcelRequire("45E6y");


var $axOCf = parcelRequire("axOCf");


var $3ae8F = parcelRequire("3ae8F");


var $4cy2V = parcelRequire("4cy2V");


var $1xxAs = parcelRequire("1xxAs");


var $uq7dM = parcelRequire("uq7dM");





var $cPCP8 = parcelRequire("cPCP8");


var $5ZzFz = parcelRequire("5ZzFz");


var $eUp7e = parcelRequire("eUp7e");

const $7b17ca9ed479c680$export$48156340a1673791 = ({ editorAPI: editorAPI, editorView: editorView, editorAppearance: editorAppearance, disabled: disabled, popupsBoundariesElement: popupsBoundariesElement, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement })=>{
    const components = editorAPI?.toolbar?.actions.getComponents();
    const toolbar = components?.find((component)=>component.key === (0, $cPCP8.TOOLBARS).PRIMARY_TOOLBAR);
    if (!components || !(0, $5ZzFz.isToolbar)(toolbar)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eUp7e.ToolbarNext), {
        toolbar: toolbar,
        components: components,
        editorView: editorView,
        editorAPI: editorAPI,
        editorAppearance: editorAppearance,
        isDisabled: disabled,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        popupsMountPoint: popupsMountPoint
    });
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 











function $e32357fdc808702d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e32357fdc808702d$var$MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT = 490;
const $e32357fdc808702d$var$akEditorMenuZIndex = 500;
const $e32357fdc808702d$var$akEditorToolbarKeylineHeight = 2;
const $e32357fdc808702d$var$mainToolbarWrapperStyleNew = /*#__PURE__*/ (0, $9K4OG.css)({
    position: 'relative',
    alignItems: 'center',
    padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"} 0`,
    display: 'flex',
    height: 'auto',
    backgroundColor: "var(--ds-surface, white)",
    boxShadow: 'none',
    paddingLeft: "var(--ds-space-250, 20px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '> div': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> div:first-of-type:not(style), > style:first-of-type + *': {
            marginLeft: 0
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.block-type-btn': {
        paddingLeft: 0
    }
});
/** keep default padding for entire toolbar */ const $e32357fdc808702d$var$mainToolbarWithoutLeftPadding = /*#__PURE__*/ (0, $9K4OG.css)({
    padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"} 0`
});
const $e32357fdc808702d$var$mainToolbarWithPadding = /*#__PURE__*/ (0, $9K4OG.css)({
    padding: `${"var(--ds-space-100, 8px)"}`
});
const $e32357fdc808702d$var$mainToolbarTwoLineStylesNew = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '& > div': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`@media (max-width: ${$e32357fdc808702d$var$MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT}px)`]: {
            flexDirection: 'column-reverse',
            alignItems: 'end',
            display: 'flex',
            justifyContent: 'flex-end'
        },
        /* make this more explicit for a toolbar */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> div:first-of-type': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            [`@media (max-width: ${$e32357fdc808702d$var$MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT}px)`]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
                '> div:nth-of-type(2)': {
                    justifyContent: 'flex-end',
                    display: 'flex'
                }
            }
        }
    }
});
const $e32357fdc808702d$var$mainToolbarWrapperStylesVisualRefresh = {
    name: "y5dbpb",
    styles: "span svg{max-width:100%;}"
};
const $e32357fdc808702d$var$mainToolbarWithRadiusStyle = /*#__PURE__*/ (0, $9K4OG.css)({
    borderRadius: `${"var(--ds-radius-small, 3px)"} ${"var(--ds-radius-small, 3px)"} 0 0`
});
const $e32357fdc808702d$var$stickyToolbarWrapperStyleNew = /*#__PURE__*/ (0, $9K4OG.css)({
    position: 'sticky',
    paddingBottom: "var(--ds-space-100, 8px)",
    zIndex: $e32357fdc808702d$var$akEditorMenuZIndex,
    transition: 'box-shadow ease-in-out 0.2s',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '&.show-keyline': {
        boxShadow: `0 ${$e32357fdc808702d$var$akEditorToolbarKeylineHeight}px 0 0 ${"var(--ds-background-accent-gray-subtlest, #F0F1F2)"}`
    }
});
const $e32357fdc808702d$var$StickyToolbar = (props)=>{
    const [top, setTop] = (0, $42omo.useState)(0);
    const toolbarPatch6Enabled = (0, $1oCLl.expValEquals)('platform_editor_toolbar_aifc_patch_6', 'isEnabled', true);
    // ED-15802: if externalToolbarRef is passed in, set top to externalToolbarRef?.current?.clientHeight
    // else if offsetTop is a number set top to offsetTop
    // otherwise top is 0 as initial state
    (0, $42omo.useEffect)(()=>{
        if (props.externalToolbarRef?.current?.clientHeight) setTop(props.externalToolbarRef.current.clientHeight);
        else setTop(props.offsetTop || 0);
    }, [
        props.externalToolbarRef,
        props.offsetTop
    ]);
    return(// eslint-disable-next-line @atlaskit/design-system/prefer-primitives
    /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: [
            $e32357fdc808702d$var$mainToolbarWrapperStyleNew,
            props.twoLineEditorToolbar && $e32357fdc808702d$var$mainToolbarTwoLineStylesNew,
            (0, $dh538.fg)('platform-visual-refresh-icons') && $e32357fdc808702d$var$mainToolbarWrapperStylesVisualRefresh,
            $e32357fdc808702d$var$stickyToolbarWrapperStyleNew,
            props.isNewToolbarEnabled && !toolbarPatch6Enabled && $e32357fdc808702d$var$mainToolbarWithoutLeftPadding,
            props.isNewToolbarEnabled && toolbarPatch6Enabled && $e32357fdc808702d$var$mainToolbarWithPadding
        ],
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
        style: {
            top: `${top}px`
        },
        "data-testid": "ak-editor-main-toolbar",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: 'show-keyline'
    }, props.children));
};
const $e32357fdc808702d$var$FixedToolbar = (props)=>// eslint-disable-next-line @atlaskit/design-system/prefer-primitives
    /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: [
            $e32357fdc808702d$var$mainToolbarWrapperStyleNew,
            props.twoLineEditorToolbar && $e32357fdc808702d$var$mainToolbarTwoLineStylesNew,
            (0, $dh538.fg)('platform-visual-refresh-icons') && $e32357fdc808702d$var$mainToolbarWrapperStylesVisualRefresh,
            props.isNewToolbarEnabled && $e32357fdc808702d$var$mainToolbarWithoutLeftPadding,
            (0, $dh538.fg)('platform_editor_comments_border_radius') && $e32357fdc808702d$var$mainToolbarWithRadiusStyle
        ],
        "data-testid": "ak-editor-main-toolbar"
    }, props.children);
/**
 * ED-15802: Scenarios when a sticky bar is used:
 * 1. useStickyToolbar is true
 * 2. useStickyToolbar is a DOM element
 * 3. useStickyToolbar is an object and has offsetTop key;
 */ const $e32357fdc808702d$var$getStickyParameters = (configuration)=>{
    // const isUsingStickyOffset, isHTMLElement is used so TS can properly infer types.
    const isHTMLElement = typeof configuration === 'object' && !('offsetTop' in configuration);
    const isUsingStickyOffset = typeof configuration === 'object' && 'offsetTop' in configuration;
    if (typeof configuration !== 'object') return {
        externalToolbarRef: undefined,
        offsetTop: undefined
    };
    if (isUsingStickyOffset) return {
        offsetTop: configuration.offsetTop
    };
    if (isHTMLElement) return {
        externalToolbarRef: configuration
    };
};
const $e32357fdc808702d$export$f7e5e5a2fbd99270 = ({ useStickyToolbar: useStickyToolbar, twoLineEditorToolbar: twoLineEditorToolbar, children: children, isNewToolbarEnabled: isNewToolbarEnabled })=>{
    if (useStickyToolbar) return /*#__PURE__*/ (0, $9K4OG.jsx)($e32357fdc808702d$var$StickyToolbar, {
        ...$e32357fdc808702d$var$getStickyParameters(useStickyToolbar),
        twoLineEditorToolbar: twoLineEditorToolbar,
        isNewToolbarEnabled: isNewToolbarEnabled
    }, children);
    return /*#__PURE__*/ (0, $9K4OG.jsx)($e32357fdc808702d$var$FixedToolbar, {
        twoLineEditorToolbar: twoLineEditorToolbar,
        isNewToolbarEnabled: isNewToolbarEnabled
    }, children);
};


function $9cfcad4a35f316a8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9cfcad4a35f316a8$var$MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT = 490;
const $9cfcad4a35f316a8$var$commentEditorStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    display: 'flex',
    flexDirection: 'column',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.less-margin > .ProseMirror': {
        margin: `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"}`
    },
    minWidth: '272px',
    height: 'auto',
    backgroundColor: "var(--ds-background-input, white)",
    border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border-input, #8C8F97)"}`,
    boxSizing: 'border-box',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: "var(--ds-radius-small, 3px)",
    maxWidth: 'inherit',
    wordWrap: 'break-word'
});
const $9cfcad4a35f316a8$var$secondaryToolbarStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    boxSizing: 'border-box',
    justifyContent: 'flex-end',
    alignItems: 'center',
    display: 'flex',
    padding: `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-025, 2px)"}`
});
const $9cfcad4a35f316a8$var$mainToolbarCustomComponentsSlotStyleNew = {
    name: "4cnzc6",
    styles: "display:flex;justify-content:flex-end;align-items:center;flex-grow:1;padding-right:var(--ds-space-250, 20px);> div{display:flex;flex-shrink:0;}"
};
const $9cfcad4a35f316a8$var$mainToolbarCustomComponentsSlotStyleTwoLineToolbarNew = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    [`@media (max-width: ${$9cfcad4a35f316a8$var$MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT}px)`]: {
        paddingRight: 0
    }
});
const $9cfcad4a35f316a8$var$appearance = 'comment';
const $9cfcad4a35f316a8$export$7b9f3a51cd0c1967 = (props)=>{
    const { editorAPI: editorAPI } = props;
    const { editorViewMode: editorViewMode, primaryToolbarComponentsState: primaryToolbarComponentsState, maxContentSizeReached: maxContentSizeReached } = (0, $eiA8Z.useSharedPluginStateWithSelector)(editorAPI, [
        'maxContentSize',
        'primaryToolbar',
        'editorViewMode'
    ], (states)=>({
            maxContentSizeReached: !!states.maxContentSizeState?.maxContentSizeReached,
            primaryToolbarComponentsState: states.primaryToolbarState?.components,
            editorViewMode: states.editorViewModeState?.mode
        }));
    const primaryToolbarState = (0, $4cy2V.getPrimaryToolbarComponents)(editorAPI, primaryToolbarComponentsState);
    const { mediaState: mediaState } = (0, $1Oo9w.useSharedPluginState)(editorAPI, [
        'media'
    ]);
    const intl = (0, $8C5kA.default)();
    const { editorDOMElement: editorDOMElement, editorView: editorView, editorActions: editorActions, eventDispatcher: eventDispatcher, providerFactory: providerFactory, contentComponents: contentComponents, customContentComponents: customContentComponents, customPrimaryToolbarComponents: customPrimaryToolbarComponents, primaryToolbarComponents: primaryToolbarComponentsProp, customSecondaryToolbarComponents: customSecondaryToolbarComponents, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, maxHeight: maxHeight, minHeight: minHeight = 150, onSave: onSave, onCancel: onCancel, disabled: disabled, dispatchAnalyticsEvent: dispatchAnalyticsEvent, useStickyToolbar: useStickyToolbar, pluginHooks: pluginHooks, featureFlags: featureFlags, innerRef: innerRef } = props;
    const showSecondaryToolbar = !!onSave || !!onCancel || !!customSecondaryToolbarComponents;
    const containerElement = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(null);
    // Wrapper container for toolbar and content area
    const wrapperElementRef = (0, $42omo.useMemo)(()=>innerRef || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef(), [
        innerRef
    ]);
    const [saveButtonDisabled, setSaveButtonDisabled] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        if (mediaState) mediaState.subscribeToUploadInProgressState(setSaveButtonDisabled);
        return ()=>mediaState?.unsubscribeFromUploadInProgressState(setSaveButtonDisabled);
    }, [
        mediaState
    ]);
    const handleSave = (0, $42omo.useCallback)(()=>{
        if (editorView && onSave) onSave(editorView);
    }, [
        editorView,
        onSave
    ]);
    const handleCancel = (0, $42omo.useCallback)(()=>{
        if (editorView && onCancel) onCancel(editorView);
    }, [
        editorView,
        onCancel
    ]);
    const isShortcutToFocusToolbar = (0, $42omo.useCallback)((event)=>{
        //Alt + F9 to reach first element in this main toolbar
        return event.altKey && (event.key === 'F9' || event.keyCode === 120);
    }, []);
    // When primary toolbar components is undefined, do not show two line editor toolbar
    const isTwoLineToolbarEnabled = !!customPrimaryToolbarComponents;
    const handleEscape = (0, $42omo.useCallback)((event)=>{
        if (!editorView?.hasFocus()) editorView?.focus();
        event.preventDefault();
        event.stopPropagation();
    }, [
        editorView
    ]);
    let primaryToolbarComponents = primaryToolbarComponentsProp;
    if (Array.isArray(primaryToolbarState?.components) && Array.isArray(primaryToolbarComponents)) primaryToolbarComponents = primaryToolbarState.components.concat(primaryToolbarComponents);
    const customToolbarSlot = /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: [
            $9cfcad4a35f316a8$var$mainToolbarCustomComponentsSlotStyleNew,
            isTwoLineToolbarEnabled && $9cfcad4a35f316a8$var$mainToolbarCustomComponentsSlotStyleTwoLineToolbarNew
        ]
    }, customPrimaryToolbarComponents);
    const isToolbarAIFCEnabled = Boolean(editorAPI?.toolbar);
    const patch6Enabled = (0, $1oCLl.expValEquals)('platform_editor_toolbar_aifc_patch_6', 'isEnabled', true);
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $uq7dM.default), {
        animate: maxContentSizeReached
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $bWRlG.WidthProvider), null, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: [
            $9cfcad4a35f316a8$var$commentEditorStyles,
            /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $9K4OG.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                minHeight: `${minHeight}px`
            })
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "akEditor",
        ref: wrapperElementRef
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $e32357fdc808702d$export$f7e5e5a2fbd99270), {
        useStickyToolbar: useStickyToolbar,
        twoLineEditorToolbar: isTwoLineToolbarEnabled,
        isNewToolbarEnabled: isToolbarAIFCEnabled
    }, isToolbarAIFCEnabled ? (0, $dh538.fg)('platform_editor_toolbar_aifc_patch_7') ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, $5Gwdo.ToolbarArrowKeyNavigationProvider), {
        editorView: editorView,
        childComponentSelector: "[data-testid='ak-editor-main-toolbar']",
        isShortcutToFocusToolbar: isShortcutToFocusToolbar,
        handleEscape: handleEscape,
        editorAppearance: $9cfcad4a35f316a8$var$appearance,
        useStickyToolbar: useStickyToolbar,
        intl: intl
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $7b17ca9ed479c680$export$48156340a1673791), {
        editorAPI: editorAPI,
        editorView: editorView,
        editorAppearance: $9cfcad4a35f316a8$var$appearance,
        disabled: patch6Enabled ? !!disabled : undefined,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        popupsMountPoint: popupsMountPoint
    }), customPrimaryToolbarComponents ? customToolbarSlot : null) : /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $7b17ca9ed479c680$export$48156340a1673791), {
        editorAPI: editorAPI,
        editorView: editorView,
        editorAppearance: $9cfcad4a35f316a8$var$appearance,
        disabled: patch6Enabled ? !!disabled : undefined,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        popupsMountPoint: popupsMountPoint
    }), customPrimaryToolbarComponents ? customToolbarSlot : null) : /*#__PURE__*/ (0, $9K4OG.jsx)((0, $5Gwdo.ToolbarArrowKeyNavigationProvider), {
        editorView: editorView,
        childComponentSelector: "[data-testid='ak-editor-main-toolbar']",
        isShortcutToFocusToolbar: isShortcutToFocusToolbar,
        handleEscape: handleEscape,
        editorAppearance: $9cfcad4a35f316a8$var$appearance,
        useStickyToolbar: useStickyToolbar,
        intl: intl
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $1xxAs.ToolbarWithSizeDetector), {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        editorView: editorView,
        editorActions: editorActions,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        eventDispatcher: eventDispatcher,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        providerFactory: providerFactory,
        appearance: $9cfcad4a35f316a8$var$appearance,
        items: primaryToolbarComponents,
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        disabled: !!disabled,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        containerElement: containerElement.current,
        twoLineEditorToolbar: isTwoLineToolbarEnabled
    }), customToolbarSlot)), /*#__PURE__*/ (0, $9K4OG.jsx)((0, $kXpLO.default), {
        editorView: editorView,
        editorDisabled: disabled
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $bWRlG.WidthConsumer), null, ({ width: width })=>{
        return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $axOCf.default), {
            ref: containerElement,
            css: [
                maxHeight ? /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                (0, $9K4OG.css)({
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                    maxHeight: `${maxHeight}px`,
                    // When maxHeight is set, content area should have overflow-y explicitly set as auto
                    // As we have overflow-x: clip for the content area, and when maxHeight prop is set, overflow-y will be computed as visible by default.
                    // This will cause the content area to have content overflowing the container
                    // so need to set overflow-y as auto to make sure the content area is scrollable
                    overflowY: 'auto'
                }) : null
            ],
            isScrollable: maxHeight ? true : undefined,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))('ak-editor-content-area', {
                'less-margin': width < (0, $aFUXX.akEditorMobileBreakoutPoint)
            }),
            featureFlags: featureFlags,
            viewMode: editorViewMode,
            appearance: $9cfcad4a35f316a8$var$appearance
        }, customContentComponents && 'before' in customContentComponents ? (0, $45E6y.contentComponentClickWrapper)(customContentComponents.before) : (0, $45E6y.contentComponentClickWrapper)(customContentComponents), /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3ae8F.default), {
            editorView: editorView,
            editorActions: editorActions,
            eventDispatcher: eventDispatcher,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            providerFactory: providerFactory,
            appearance: $9cfcad4a35f316a8$var$appearance,
            items: contentComponents,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            containerElement: containerElement.current,
            disabled: !!disabled,
            wrapperElement: wrapperElementRef.current,
            pluginHooks: pluginHooks
        }), editorDOMElement, customContentComponents && 'after' in customContentComponents ? (0, $45E6y.contentComponentClickWrapper)(customContentComponents.after) : null);
    }))), showSecondaryToolbar && /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $9cfcad4a35f316a8$var$secondaryToolbarStyles,
        "data-testid": "ak-editor-secondary-toolbar"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $hArLp.default), null, !!onSave && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $ccHMk.default), {
        appearance: "primary",
        onClick: handleSave,
        testId: "comment-save-button",
        isDisabled: disabled || saveButtonDisabled,
        interactionName: "editor-comment-save-button"
    }, intl.formatMessage((0, $61p3e.default).saveButton)), !!onCancel && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $ccHMk.default), {
        appearance: "subtle",
        onClick: handleCancel,
        testId: "comment-cancel-button",
        isDisabled: disabled,
        interactionName: "editor-comment-cancel-button"
    }, intl.formatMessage((0, $61p3e.default).cancelButton))), /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        style: {
            flexGrow: 1
        }
    }), customSecondaryToolbarComponents)));
};
$9cfcad4a35f316a8$export$7b9f3a51cd0c1967.displayName = 'CommentEditorAppearance';
module.exports["CommentEditorWithIntl"] = $9cfcad4a35f316a8$export$7b9f3a51cd0c1967;

});

parcelRegister("5Gwdo", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $dh538 = parcelRequire("dh538");


var $dK4ZR = parcelRequire("dK4ZR");


var $8aWkM = parcelRequire("8aWkM");


var $b0RMS = parcelRequire("b0RMS");


var $f9zLy = parcelRequire("f9zLy");

function $75d74c57448b9b48$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $75d74c57448b9b48$export$5455406531e3792c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    handleArrowLeft: ()=>{},
    handleArrowRight: ()=>{},
    handleTab: ()=>{}
});
const $75d74c57448b9b48$var$centeredToolbarContainer = {
    name: "1iikq5b",
    styles: "display:flex;width:100%;align-items:center"
};
const $75d74c57448b9b48$export$9837e395eba6f527 = ({ children: children, editorView: editorView, childComponentSelector: childComponentSelector, handleEscape: handleEscape, disableArrowKeyNavigation: disableArrowKeyNavigation, isShortcutToFocusToolbar: isShortcutToFocusToolbar, editorAppearance: editorAppearance, useStickyToolbar: useStickyToolbar, intl: intl })=>{
    const wrapperRef = (0, $42omo.useRef)(null);
    const selectedItemIndex = (0, $42omo.useRef)(0);
    const incrementIndex = (0, $42omo.useCallback)((list)=>{
        let index = 0;
        if (document.activeElement) {
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            index = list.indexOf(document.activeElement);
            index = (index + 1) % list.length;
        }
        selectedItemIndex.current = index;
    }, []);
    const decrementIndex = (0, $42omo.useCallback)((list)=>{
        let index = 0;
        if (document.activeElement) {
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            index = list.indexOf(document.activeElement);
            index = (list.length + index - 1) % list.length;
        }
        selectedItemIndex.current = index;
    }, []);
    const handleArrowRightMemoized = (0, $42omo.useCallback)(()=>{
        const filteredFocusableElements = $75d74c57448b9b48$var$getFilteredFocusableElements(wrapperRef?.current);
        incrementIndex(filteredFocusableElements);
        filteredFocusableElements[selectedItemIndex.current]?.focus();
    }, [
        incrementIndex
    ]);
    const handleArrowLeftMemoized = (0, $42omo.useCallback)(()=>{
        const filteredFocusableElements = $75d74c57448b9b48$var$getFilteredFocusableElements(wrapperRef?.current);
        decrementIndex(filteredFocusableElements);
        filteredFocusableElements[selectedItemIndex.current]?.focus();
    }, [
        decrementIndex
    ]);
    const handleTabMemoized = (0, $42omo.useCallback)(()=>{
        const filteredFocusableElements = $75d74c57448b9b48$var$getFilteredFocusableElements(wrapperRef?.current);
        filteredFocusableElements[selectedItemIndex.current]?.focus();
    }, []);
    const handleTabLocal = ()=>{
        const filteredFocusableElements = $75d74c57448b9b48$var$getFilteredFocusableElements(wrapperRef?.current);
        filteredFocusableElements.forEach((element)=>{
            element.setAttribute('tabindex', '-1');
        });
        filteredFocusableElements[selectedItemIndex.current].setAttribute('tabindex', '0');
    };
    const focusAndScrollToElement = (element, scrollToElement = true)=>{
        if (scrollToElement) element?.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'nearest'
        });
        element.focus();
    };
    const submenuKeydownHandleContext = (0, $42omo.useMemo)(()=>({
            handleArrowLeft: handleArrowLeftMemoized,
            handleArrowRight: handleArrowRightMemoized,
            handleTab: handleTabMemoized
        }), [
        handleArrowLeftMemoized,
        handleArrowRightMemoized,
        handleTabMemoized
    ]);
    (0, $42omo.useLayoutEffect)(()=>{
        if (!wrapperRef.current || disableArrowKeyNavigation) return;
        const { current: element } = wrapperRef;
        /**
     * To handle the key events on the list
     * @param event
     */ const handleKeyDown = (event)=>{
            // To trap the focus inside the horizontal toolbar for left and right arrow keys
            const targetElement = event.target;
            if (targetElement instanceof HTMLElement && !targetElement.closest(`${childComponentSelector}`)) return;
            if (targetElement instanceof HTMLElement && document.querySelector('[data-role="droplistContent"], [data-test-id="color-picker-menu"], [data-emoji-picker-container="true"]')?.contains(targetElement) || targetElement instanceof HTMLElement && document.querySelector('[data-test-id="color-picker-menu"]')?.contains(targetElement) || event.key === 'ArrowUp' || event.key === 'ArrowDown' || disableArrowKeyNavigation) return;
            const menuWrapper = document.querySelector('.menu-key-handler-wrapper');
            if (menuWrapper) // if menu wrapper exists, then a menu is open and arrow keys will be handled by MenuArrowKeyNavigationProvider
            return;
            const elementBrowser = wrapperRef?.current?.querySelector(`#${(0, $dK4ZR.ELEMENT_BROWSER_ID)}`);
            if (elementBrowser) // if element browser is open, then arrow keys will be handled by MenuArrowKeyNavigationProvider
            return;
            const filteredFocusableElements = $75d74c57448b9b48$var$getFilteredFocusableElements(wrapperRef?.current);
            if (!filteredFocusableElements || filteredFocusableElements?.length === 0) return;
            // If the target element is the media picker then navigation is handled by the media picker
            if (targetElement instanceof HTMLElement && targetElement.closest(`[aria-label="${intl.formatMessage((0, $b0RMS.mediaInsertMessages).mediaPickerPopupAriaLabel)}"]`)) return;
            if (targetElement instanceof HTMLElement && !wrapperRef.current?.contains(targetElement)) selectedItemIndex.current = -1;
            else selectedItemIndex.current = targetElement instanceof HTMLElement && filteredFocusableElements.indexOf(targetElement) > -1 ? filteredFocusableElements.indexOf(targetElement) : selectedItemIndex.current;
            // do not scroll to focused element for sticky toolbar when navigating with arrows to avoid unnesessary scroll jump
            const allowScrollToElement = !(editorAppearance === 'comment' && !!useStickyToolbar);
            switch(event.key){
                case 'ArrowRight':
                    incrementIndex(filteredFocusableElements);
                    focusAndScrollToElement(filteredFocusableElements[selectedItemIndex.current], allowScrollToElement);
                    event.preventDefault();
                    break;
                case 'ArrowLeft':
                    decrementIndex(filteredFocusableElements);
                    focusAndScrollToElement(filteredFocusableElements[selectedItemIndex.current], allowScrollToElement);
                    event.preventDefault();
                    break;
                case 'Tab':
                    handleTabLocal();
                    break;
                case 'Escape':
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    handleEscape(event);
                    break;
                default:
            }
        };
        const globalKeyDownHandler = (event)=>{
            // To focus the first element in the toolbar
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            if (isShortcutToFocusToolbar(event)) {
                const filteredFocusableElements = $75d74c57448b9b48$var$getFilteredFocusableElements(wrapperRef?.current);
                filteredFocusableElements[0]?.focus();
                // Button component from DS removes focus ring when :focus:not(:focus-visible) is true
                // Since here we programmatically focus the first button in the toolbar (as suppose to keyboard navigation), browser does not always force focus-visible to true
                // which is why the first button in the toolbar is not shown with focus ring
                // The workaround is add a new classname so we add back focus ring when the button is focused
                if (filteredFocusableElements[0]?.tagName === 'BUTTON') filteredFocusableElements[0].classList.add('first-floating-toolbar-button');
                filteredFocusableElements[0]?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                    inline: 'nearest'
                });
            }
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element?.addEventListener('keydown', handleKeyDown);
        const editorViewDom = editorView?.dom;
        if (isShortcutToFocusToolbar) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        editorViewDom?.addEventListener('keydown', globalKeyDownHandler);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element?.removeEventListener('keydown', handleKeyDown);
            if (isShortcutToFocusToolbar) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            editorViewDom?.removeEventListener('keydown', globalKeyDownHandler);
        };
    }, [
        selectedItemIndex,
        wrapperRef,
        editorView,
        disableArrowKeyNavigation,
        handleEscape,
        childComponentSelector,
        incrementIndex,
        decrementIndex,
        isShortcutToFocusToolbar,
        editorAppearance,
        useStickyToolbar,
        intl
    ]);
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: editorAppearance === 'comment' && $75d74c57448b9b48$var$centeredToolbarContainer,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "custom-key-handler-wrapper",
        ref: wrapperRef,
        role: "toolbar",
        "aria-label": intl.formatMessage((0, $8aWkM.messages).toolbarLabel),
        "aria-controls": (0, $f9zLy.EDIT_AREA_ID)
    }, /*#__PURE__*/ (0, $9K4OG.jsx)($75d74c57448b9b48$export$5455406531e3792c.Provider, {
        value: submenuKeydownHandleContext
    }, children));
};
function $75d74c57448b9b48$var$getFocusableElements(rootNode) {
    if (!rootNode) return [];
    const focusableModalElements = rootNode.querySelectorAll('a[href], button:not([disabled]), textarea, input, select, div[tabindex="-1"], div[tabindex="0"]') || [];
    return Array.from(focusableModalElements);
}
function $75d74c57448b9b48$var$isElementOrAncestorHiddenOrDisabled(element, rootNode) {
    let currentElement = element;
    while(currentElement && currentElement !== rootNode && currentElement !== document.body){
        const style = window.getComputedStyle(currentElement);
        // Check if current element is hidden
        if (style.visibility === 'hidden' || style.display === 'none') return true;
        // Check if current element is disabled
        if (currentElement.hasAttribute('disabled') || currentElement.getAttribute('aria-disabled') === 'true' || currentElement.disabled === true) return true;
        // Move to parent element
        currentElement = currentElement.parentElement;
    }
    return false;
}
function $75d74c57448b9b48$var$getFilteredFocusableElements(rootNode) {
    // The focusable elements from child components such as dropdown menus / popups are ignored
    return $75d74c57448b9b48$var$getFocusableElements(rootNode).filter((elm)=>{
        const style = window.getComputedStyle(elm);
        // ignore invisible element to avoid losing focus
        const isVisible = style.visibility !== 'hidden' && style.display !== 'none';
        // Check if element or any ancestor is hidden or disabled
        const isHiddenOrDisabled = $75d74c57448b9b48$var$isElementOrAncestorHiddenOrDisabled(elm, rootNode);
        if ((0, $dh538.fg)('platform_editor_toolbar_aifc_patch_7')) return !elm.closest('[data-role="droplistContent"]') && !elm.closest('[data-emoji-picker-container="true"]') && !elm.closest('[data-test-id="color-picker-menu"]') && !elm.closest('.scroll-buttons') && !isHiddenOrDisabled;
        return !elm.closest('[data-role="droplistContent"]') && !elm.closest('[data-emoji-picker-container="true"]') && !elm.closest('[data-test-id="color-picker-menu"]') && !elm.closest('.scroll-buttons') && isVisible;
    });
}
module.exports["KeyDownHandlerContext"] = $75d74c57448b9b48$export$5455406531e3792c;
module.exports["ToolbarArrowKeyNavigationProvider"] = $75d74c57448b9b48$export$9837e395eba6f527;

});

parcelRegister("dK4ZR", function(module, exports) {
const $75f348dd52cc6fb8$export$bc90872e265d166e = 8;
const $75f348dd52cc6fb8$export$1f1798e92fa75806 = {
    small: $75f348dd52cc6fb8$export$bc90872e265d166e * 40,
    medium: $75f348dd52cc6fb8$export$bc90872e265d166e * 75,
    large: $75f348dd52cc6fb8$export$bc90872e265d166e * 128
};
const $75f348dd52cc6fb8$export$69bde1b03e8b5224 = {
    small: $75f348dd52cc6fb8$export$bc90872e265d166e * 50,
    medium: $75f348dd52cc6fb8$export$1f1798e92fa75806.medium,
    large: $75f348dd52cc6fb8$export$1f1798e92fa75806.large
};
const $75f348dd52cc6fb8$export$780035d9fe48eb32 = `${$75f348dd52cc6fb8$export$bc90872e265d166e * 25}px`;
const $75f348dd52cc6fb8$export$95b62a1773aa5ebe = `${$75f348dd52cc6fb8$export$bc90872e265d166e * 6}px`;
const $75f348dd52cc6fb8$export$387950d54d372827 = '12px';
const $75f348dd52cc6fb8$export$51a2d6b2c009fbfd = '54px';
const $75f348dd52cc6fb8$export$df8bcac60101d466 = '20px';
const $75f348dd52cc6fb8$export$9a6bb2acef5e644a = 15;
const $75f348dd52cc6fb8$export$3b8e93b2c0f295b0 = 2;
const $75f348dd52cc6fb8$export$6d221f35db1b75aa = 60;
const $75f348dd52cc6fb8$export$ab53450bc5fd5b7d = 10;
const $75f348dd52cc6fb8$export$6ee360fa4b93ee8e = 'editor-element-browser';
const $75f348dd52cc6fb8$export$f5c254b5428bf7c6 = 'editor-element-browser-list';
module.exports["GRID_SIZE"] = $75f348dd52cc6fb8$export$bc90872e265d166e;
module.exports["DEVICE_BREAKPOINT_NUMBERS"] = $75f348dd52cc6fb8$export$1f1798e92fa75806;
module.exports["FLEX_ITEMS_CONTAINER_BREAKPOINT_NUMBERS"] = $75f348dd52cc6fb8$export$69bde1b03e8b5224;
module.exports["SIDEBAR_WIDTH"] = $75f348dd52cc6fb8$export$780035d9fe48eb32;
module.exports["SIDEBAR_HEADING_WRAPPER_HEIGHT"] = $75f348dd52cc6fb8$export$95b62a1773aa5ebe;
module.exports["INLINE_SIDEBAR_HEIGHT"] = $75f348dd52cc6fb8$export$51a2d6b2c009fbfd;
module.exports["SEARCH_ITEM_HEIGHT_WIDTH"] = $75f348dd52cc6fb8$export$df8bcac60101d466;
module.exports["SCROLLBAR_WIDTH"] = $75f348dd52cc6fb8$export$9a6bb2acef5e644a;
module.exports["ELEMENT_LIST_PADDING"] = $75f348dd52cc6fb8$export$3b8e93b2c0f295b0;
module.exports["ELEMENT_ITEM_HEIGHT"] = $75f348dd52cc6fb8$export$6d221f35db1b75aa;
module.exports["ELEMENT_ITEM_PADDING"] = $75f348dd52cc6fb8$export$ab53450bc5fd5b7d;
module.exports["ELEMENT_BROWSER_ID"] = $75f348dd52cc6fb8$export$6ee360fa4b93ee8e;
module.exports["ELEMENT_BROWSER_LIST_ID"] = $75f348dd52cc6fb8$export$f5c254b5428bf7c6;

});

parcelRegister("f9zLy", function(module, exports) {
const $12841799d44c3fc4$export$b16ce0826b76e795 = 'ak-editor-textarea';
module.exports["EDIT_AREA_ID"] = $12841799d44c3fc4$export$b16ce0826b76e795;

});

parcelRegister("kXpLO", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $h3X17 = parcelRequire("h3X17");


var $dhoHU = parcelRequire("dhoHU");


var $1zPzM = parcelRequire("1zPzM");


var $4vlwG = parcelRequire("4vlwG");


var $1oCLl = parcelRequire("1oCLl");


var $45E6y = parcelRequire("45E6y");

// we ignore all of the clicks made inside <div class="ak-editor-content-area" /> (but not clicks on the node itself)
const $fdee4aa7754cfd6c$var$insideContentArea = (ref)=>{
    while(ref){
        if (ref.classList && ref.classList.contains('ak-editor-content-area')) return true;
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        ref = ref.parentNode;
    }
    return false;
};
const $fdee4aa7754cfd6c$var$insideProseMirrorEditableArea = (ref)=>{
    return Boolean(ref?.closest('.ProseMirror'));
};
const $fdee4aa7754cfd6c$export$79ba7abfc5f47a65 = (target)=>{
    const modalDialog = target?.closest('[role=dialog]');
    if (modalDialog) // return false if not an editor inside modal, otherwise return true
    return !!modalDialog?.querySelector('.akEditor');
    // no modal present so we can return true
    return true;
};
const $fdee4aa7754cfd6c$export$28b64e3e5a38e8a2 = (view, event)=>{
    const isEditorFocused = !!view?.hasFocus?.();
    if (!(event.target instanceof HTMLElement)) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const target = event.target;
    const isTargetContentArea = target?.classList.contains('ak-editor-content-area');
    const isTargetChildOfContentArea = $fdee4aa7754cfd6c$var$insideContentArea(target?.parentNode instanceof HTMLElement ? target?.parentNode : null);
    const isTargetInsideEditableArea = $fdee4aa7754cfd6c$var$insideProseMirrorEditableArea(target);
    // Any click inside ProseMirror should be managed by ProseMirror
    if (isTargetInsideEditableArea) return false;
    const isEventComingFromContentArea = Boolean(event.currentTarget.querySelector('.ak-editor-content-area'));
    // @see https://product-fabric.atlassian.net/browse/ED-4287
    // click event gets triggered twice on a checkbox (on <label> first and then on <input>)
    // by the time it gets triggered on input, PM already re-renders nodeView and detaches it from DOM
    // which doesn't pass the check !contentArea.contains(event.target)
    const isInputClicked = target?.nodeName === 'INPUT';
    // @see ED-5126
    const isPopupClicked = !!(0, $4vlwG.closestElement)(target, '[data-editor-popup]');
    // Fixes issue when using a textarea for editor title in full page editor doesn't let user focus it.
    const isTextAreaClicked = target?.nodeName === 'TEXTAREA';
    const isBreadcrumbClicked = !!(0, $4vlwG.closestElement)(target, 'nav[aria-label="Breadcrumbs"]');
    const selection = window.getSelection();
    const isEditorPopupTextSelected = selection?.type === 'Range' && // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    (0, $4vlwG.closestElement)(selection?.anchorNode, '[data-editor-popup]');
    // For clicks directly on the content component -- they should not be ignored
    const isContentComponent = target?.parentElement?.closest(`[${(0, $45E6y.ignoreAttribute)}]`);
    // This is a super workaround to find when events are coming from Confluence InlineComment modal
    // We don't own those components, so we can't change them
    const isEventComingFromInlineCommentPopup = Boolean((0, $4vlwG.closestElement)(event.currentTarget, 'div[offset]')) || Boolean((0, $4vlwG.closestElement)(target, 'div[offset]'));
    const isAnchorButtonClicked = Boolean((0, $4vlwG.closestElement)(event.currentTarget, 'a')) || Boolean((0, $4vlwG.closestElement)(target, 'a')) || event.currentTarget?.nodeName === 'A' || target?.nodeName === 'A';
    const isButtonClicked = Boolean((0, $4vlwG.closestElement)(event.currentTarget, 'button')) || Boolean((0, $4vlwG.closestElement)(target, 'button')) || event.currentTarget?.nodeName === 'BUTTON' || target?.nodeName === 'BUTTON' || (0, $1oCLl.expValEquals)('platform_editor_toolbar_migrate_loom', 'isEnabled', true) && isAnchorButtonClicked;
    const isTargetInsideContentArea = Boolean(isTargetChildOfContentArea);
    const isBetweenContentAreaAndEditableContent = isTargetInsideContentArea && !isTargetInsideEditableArea;
    // Column Picker dropdown in Datasources table
    const isDatasourcePopupClicked = !!target?.closest('#column-picker-popup');
    const edgeCaseScenario1 = (isBetweenContentAreaAndEditableContent || !isEventComingFromContentArea) && !isEditorFocused;
    const edgeCaseScenario2 = !isTargetInsideContentArea && isEditorFocused;
    const edgeCaseScenario3 = isTargetContentArea && !isTargetInsideContentArea && !isEditorFocused;
    const edgeCaseScenario4 = isEventComingFromContentArea && !isTargetContentArea && !isTargetInsideContentArea && !isEditorFocused;
    const edgeCases = edgeCaseScenario1 || edgeCaseScenario2 || edgeCaseScenario3 || edgeCaseScenario4;
    const isClickOutsideEditor = edgeCases && !isDatasourcePopupClicked && !isEventComingFromInlineCommentPopup && !isButtonClicked && !isInputClicked && !isTextAreaClicked && !isPopupClicked && !isBreadcrumbClicked && !isEditorPopupTextSelected && !isContentComponent && $fdee4aa7754cfd6c$export$79ba7abfc5f47a65(target);
    // click was within editor container and focus should be brought to input
    if (isClickOutsideEditor && view) $fdee4aa7754cfd6c$export$c5a7a653c4681bfd(view, event);
};
const $fdee4aa7754cfd6c$export$c5a7a653c4681bfd = (view, event)=>{
    const { dispatch: dispatch, dom: dom, state: state } = view;
    const { tr: tr } = state;
    const isEditorFocused = !!view?.hasFocus?.();
    const isBottomAreaClicked = event.clientY > dom.getBoundingClientRect().bottom;
    if (isBottomAreaClicked) {
        tr.setMeta('outsideProsemirrorEditorClicked', true);
        (0, $dhoHU.addParagraphAtEnd)(tr);
    }
    (0, $1zPzM.setSelectionTopLevelBlocks)(tr, event, // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    dom, view.posAtCoords.bind(view), isEditorFocused);
    (0, $h3X17.tintDirtyTransaction)(tr);
    if (!tr.docChanged && !tr.selectionSet) return;
    if (dispatch) dispatch(tr);
    view.focus();
    event.preventDefault();
};


function $d312f85c475dacb6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d312f85c475dacb6$var$clickWrapper = {
    name: "sox1a6",
    styles: "flex-grow:1;height:100%"
};
const $d312f85c475dacb6$export$68468c5dbde37b99 = ({ editorView: editorView, editorDisabled: editorDisabled, children: children })=>{
    const handleMouseDown = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((event)=>{
        if (!editorView) return;
        if (!editorDisabled) (0, $fdee4aa7754cfd6c$export$28b64e3e5a38e8a2)(editorView, event);
    }, [
        editorView,
        editorDisabled
    ]);
    return(// eslint-disable-next-line @atlassian/a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        "data-editor-click-wrapper": true,
        "data-testid": "click-wrapper",
        css: $d312f85c475dacb6$var$clickWrapper,
        onMouseDown: handleMouseDown
    }, children));
};
var $d312f85c475dacb6$export$2e2bcd8739ae039 = $d312f85c475dacb6$export$68468c5dbde37b99;
module.exports["default"] = $d312f85c475dacb6$export$2e2bcd8739ae039;

});

parcelRegister("dhoHU", function(module, exports) {

var $ks2lK = parcelRequire("ks2lK");


var $7XFGZ = parcelRequire("7XFGZ");


var $afcIe = parcelRequire("afcIe");

function $1d2e8dba41928471$export$fc18809329b5ff08(tr) {
    const { doc: { type: { schema: { nodes: { paragraph: paragraph } } } }, doc: doc } = tr;
    if (doc.lastChild && !(doc.lastChild.type === paragraph && doc.lastChild.content.size === 0)) {
        if (paragraph) tr.insert(doc.content.size, paragraph.createAndFill());
    }
    tr.setSelection((0, $ks2lK.TextSelection).create(tr.doc, tr.doc.content.size - 1));
    tr.scrollIntoView();
}
function $1d2e8dba41928471$export$2864da03fd603a92() {
    return function(state, dispatch) {
        const { tr: tr } = state;
        $1d2e8dba41928471$export$fc18809329b5ff08(tr);
        if (dispatch) dispatch(tr);
        return true;
    };
}
const $1d2e8dba41928471$export$774cc08dd90b6a6a = (align)=>(state, dispatch)=>{
        const { from: from, to: to } = state.selection;
        const tr = state.tr;
        state.doc.nodesBetween(from, to, (node, pos)=>{
            if (node.type === state.schema.nodes.mediaSingle) tr.setNodeMarkup(pos, undefined, {
                ...node.attrs,
                layout: align === 'center' ? 'center' : `align-${align}`
            });
        });
        if (tr.docChanged && dispatch) {
            dispatch(tr.scrollIntoView());
            return true;
        }
        return false;
    };
const $1d2e8dba41928471$export$b637dda807357427 = (align)=>(tr)=>{
        const { from: from, to: to } = tr.selection;
        const initialDoc = tr.doc;
        tr.doc.nodesBetween(from, to, (node, pos)=>{
            if (node.type === tr.doc.type.schema.nodes.mediaSingle) tr.setNodeMarkup(pos, undefined, {
                ...node.attrs,
                layout: align === 'center' ? 'center' : `align-${align}`
            });
        });
        // compare tr.doc with initialDoc instead of tr.docChanged
        // because tr passed in might have been modified prior this function
        // e.g. see changeAlignmentTr platform/packages/editor/editor-plugin-alignment/src/editor-commands/index.ts:L197
        if (!tr.doc.eq(initialDoc)) {
            tr.scrollIntoView();
            return true;
        }
        return false;
    };
const $1d2e8dba41928471$export$1115c4cf51ae1924 = (markType, getAttrs, allowedBlocks)=>(from, to, tr, state)=>{
        let markApplied = false;
        state.doc.nodesBetween(from, to, (node, pos, parent)=>{
            if (!node.type.isBlock) return false;
            const parentAllowsMark = state?.schema?.nodes?.blockTaskItem && parent?.type === state?.schema?.nodes?.blockTaskItem && markType === state?.schema?.marks?.indentation ? false : parent?.type.allowsMarkType(markType);
            if ((!allowedBlocks || (Array.isArray(allowedBlocks) ? allowedBlocks.indexOf(node.type) > -1 : allowedBlocks(state.schema, node, parent))) && parentAllowsMark) {
                const oldMarks = node.marks.filter((mark)=>mark.type === markType);
                const prevAttrs = oldMarks.length ? oldMarks[0].attrs : undefined;
                const newAttrs = getAttrs(prevAttrs, node);
                if (newAttrs !== undefined) {
                    tr.setNodeMarkup(pos, node.type, node.attrs, node.marks.filter((mark)=>!markType.excludes(mark.type)).concat(newAttrs === false ? [] : markType.create(newAttrs)));
                    markApplied = true;
                }
            }
            return;
        });
        return markApplied;
    };
const $1d2e8dba41928471$export$8614a16deba8906f = (markType, getAttrs, allowedBlocks)=>(from, to, tr)=>{
        let markApplied = false;
        tr.doc.nodesBetween(from, to, (node, pos, parent)=>{
            if (!node.type.isBlock) return false;
            const schema = tr.doc.type.schema;
            const parentAllowsMark = schema?.nodes?.blockTaskItem && parent?.type === schema?.nodes?.blockTaskItem && markType === schema?.marks?.indentation ? false : parent?.type.allowsMarkType(markType);
            if ((!allowedBlocks || (Array.isArray(allowedBlocks) ? allowedBlocks.indexOf(node.type) > -1 : allowedBlocks(tr.doc.type.schema, node, parent))) && parentAllowsMark) {
                const oldMarks = node.marks.filter((mark)=>mark.type === markType);
                const prevAttrs = oldMarks.length ? oldMarks[0].attrs : undefined;
                const newAttrs = getAttrs(prevAttrs, node);
                if (newAttrs !== undefined) {
                    tr.setNodeMarkup(pos, node.type, node.attrs, node.marks.filter((mark)=>!markType.excludes(mark.type)).concat(newAttrs === false ? [] : markType.create(newAttrs)));
                    markApplied = true;
                }
            }
            return;
        });
        return markApplied;
    };
const $1d2e8dba41928471$export$a10bb5a1a10022f6 = (markType, getAttrs)=>(from, to, tr, state)=>{
        let markApplied = false;
        state.doc.nodesBetween(from, to, (node, pos, parent)=>{
            if (parent?.type.allowsMarkType(markType)) {
                const oldMarks = node.marks.filter((mark)=>mark.type === markType);
                const prevAttrs = oldMarks.length ? oldMarks[0].attrs : undefined;
                const newAttrs = getAttrs(prevAttrs, node);
                if (newAttrs !== undefined) {
                    tr.setNodeMarkup(pos, node.type, node.attrs, node.marks.filter((mark)=>!markType.excludes(mark.type)).concat(newAttrs === false ? [] : markType.create(newAttrs)));
                    tr.setSelection((0, $ks2lK.NodeSelection).create(tr.doc, state.selection.from));
                    markApplied = true;
                }
            }
            return;
        });
        return markApplied;
    };
const $1d2e8dba41928471$export$72d6145976985e8c = (markType, getAttrs, allowedBlocks)=>(state, dispatch)=>{
        let markApplied = false;
        const tr = state.tr;
        const toggleBlockMarkOnRange = $1d2e8dba41928471$export$1115c4cf51ae1924(markType, getAttrs, allowedBlocks);
        if (state.selection instanceof (0, $7XFGZ.CellSelection)) state.selection.forEachCell((cell, pos)=>{
            markApplied = toggleBlockMarkOnRange(pos, pos + cell.nodeSize, tr, state);
        });
        else {
            const { from: from, to: to } = state.selection;
            markApplied = toggleBlockMarkOnRange(from, to, tr, state);
        }
        if (markApplied && tr.docChanged) {
            if (dispatch) dispatch(tr.scrollIntoView());
            return true;
        }
        return false;
    };
const $1d2e8dba41928471$export$23f118e134ed2228 = (markType, getAttrs, allowedBlocks)=>(tr)=>{
        let markApplied = false;
        const toggleBlockMarkOnRange = $1d2e8dba41928471$export$8614a16deba8906f(markType, getAttrs, allowedBlocks);
        const initialDoc = tr.doc;
        const { selection: selection } = tr;
        if (selection instanceof (0, $7XFGZ.CellSelection)) selection.forEachCell((cell, pos)=>{
            markApplied = toggleBlockMarkOnRange(pos, pos + cell.nodeSize, tr);
        });
        else {
            const { from: from, to: to } = selection;
            markApplied = toggleBlockMarkOnRange(from, to, tr);
        }
        // compare tr.doc with initialDoc instead of tr.docChanged
        // because tr passed in might have been modified prior this function
        // e.g. see changeAlignmentTr platform/packages/editor/editor-plugin-alignment/src/editor-commands/index.ts:L197
        if (markApplied && !initialDoc.eq(tr.doc)) {
            tr.scrollIntoView();
            return true;
        }
        return false;
    };
const $1d2e8dba41928471$export$59c0bf8874edecc7 = (state, dispatch)=>{
    const tr = state.tr;
    tr.replace(0, state.doc.nodeSize - 2);
    tr.setSelection((0, $ks2lK.Selection).atStart(tr.doc));
    if (dispatch) {
        dispatch(tr);
        return true;
    }
    return false;
};
function $1d2e8dba41928471$export$ad1078cb3917e860($pos) {
    // parent is non-isolating, so we can look across this boundary
    if (!$pos.parent.type.spec.isolating) // search up the tree from the pos's *parent*
    for(let i = $pos.depth - 1; i >= 0; i--){
        // starting from the inner most node's parent, find out
        // if we're not its first child
        if ($pos.index(i) > 0) return $pos.doc.resolve($pos.before(i + 1));
        if ($pos.node(i).type.spec.isolating) break;
    }
    return null;
}
function $1d2e8dba41928471$export$c6a04dca1ed03a3c(level) {
    return function(state, dispatch) {
        const { selection: selection, schema: schema, tr: tr } = state;
        const ranges = selection instanceof (0, $7XFGZ.CellSelection) ? selection.ranges : [
            selection
        ];
        ranges.forEach(({ $from: $from, $to: $to })=>{
            tr.setBlockType($from.pos, $to.pos, schema.nodes.heading, {
                level: level
            });
        });
        if (dispatch) dispatch(tr);
        return true;
    };
}
module.exports["addParagraphAtEnd"] = $1d2e8dba41928471$export$fc18809329b5ff08;
module.exports["changeImageAlignment"] = $1d2e8dba41928471$export$774cc08dd90b6a6a;
module.exports["changeImageAlignmentNext"] = $1d2e8dba41928471$export$b637dda807357427;
module.exports["createToggleBlockMarkOnRange"] = $1d2e8dba41928471$export$1115c4cf51ae1924;
module.exports["createToggleInlineMarkOnRange"] = $1d2e8dba41928471$export$a10bb5a1a10022f6;
module.exports["toggleBlockMark"] = $1d2e8dba41928471$export$72d6145976985e8c;
module.exports["toggleBlockMarkNext"] = $1d2e8dba41928471$export$23f118e134ed2228;
module.exports["findCutBefore"] = $1d2e8dba41928471$export$ad1078cb3917e860;

});

parcelRegister("afcIe", function(module, exports) {

var $ks2lK = parcelRequire("ks2lK");


var $8m4tT = parcelRequire("8m4tT");

const $fde5eb025de1bc5c$export$f51280337625031 = (state, nodeType, start, end, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
attrs)=>{
    // To ensure that match is done after HardBreak.
    const { hardBreak: hardBreak, codeBlock: codeBlock, listItem: listItem } = state.schema.nodes;
    const $pos = state.doc.resolve(start);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    if ($pos.nodeAfter.type !== hardBreak) return null;
    // To ensure no nesting is done. (unless we're inserting a codeBlock inside lists)
    if ($pos.depth > 1 && !(nodeType === codeBlock && (0, $8m4tT.hasParentNodeOfType)(listItem)(state.selection))) return null;
    // Split at the start of autoformatting and delete formatting characters.
    let tr = state.tr.delete(start, end).split(start);
    let currentNode = tr.doc.nodeAt(start + 1);
    // If node has more content split at the end of autoformatting.
    let nodeHasMoreContent = false;
    tr.doc.nodesBetween(start, start + currentNode.nodeSize, (node, pos)=>{
        if (!nodeHasMoreContent && node.type === hardBreak) {
            nodeHasMoreContent = true;
            tr = tr.split(pos + 1).delete(pos, pos + 1);
        }
    });
    if (nodeHasMoreContent) currentNode = tr.doc.nodeAt(start + 1);
    // Create new node and fill with content of current node.
    const { blockquote: blockquote, paragraph: paragraph } = state.schema.nodes;
    let content;
    let depth;
    if (nodeType === blockquote) {
        depth = 3;
        content = [
            paragraph.create({}, currentNode.content)
        ];
    } else {
        depth = 2;
        content = currentNode.content;
    }
    const newNode = nodeType.create(attrs, content);
    // Add new node.
    tr = tr.setSelection(new (0, $ks2lK.NodeSelection)(tr.doc.resolve(start + 1)))// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    .replaceSelectionWith(newNode).setSelection(new (0, $ks2lK.TextSelection)(tr.doc.resolve(start + depth)));
    return tr;
};
module.exports["insertBlock"] = $fde5eb025de1bc5c$export$f51280337625031;

});

parcelRegister("1zPzM", function(module, exports) {

var $ks2lK = parcelRequire("ks2lK");


var $adhil = parcelRequire("adhil");


var $1gpr6 = parcelRequire("1gpr6");

// This function captures clicks outside of the ProseMirror contentEditable area
// see also description of "handleClick" in gap-cursor pm-plugin
const $4bfd6331a10a8378$var$captureCursorCoords = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
event, editorRef, posAtCoords, tr)=>{
    const rect = editorRef.getBoundingClientRect();
    // capture clicks before the first block element
    if (event.clientY < rect.top) return {
        position: 0,
        side: (0, $adhil.Side).LEFT
    };
    if (rect.left > 0) {
        // calculate start position of a node that is vertically at the same level
        const coords = posAtCoords({
            left: rect.left,
            top: event.clientY
        });
        if (coords && coords.inside > -1) {
            const $from = tr.doc.resolve(coords.inside);
            const start = $from.before(1);
            const side = event.clientX < rect.left ? (0, $adhil.Side).LEFT : (0, $adhil.Side).RIGHT;
            let position;
            if (side === (0, $adhil.Side).LEFT) position = start;
            else {
                const node = tr.doc.nodeAt(start);
                if (node) position = start + node.nodeSize;
            }
            return {
                position: position,
                side: side
            };
        }
    }
    return null;
};
const $4bfd6331a10a8378$export$1b305efb24649ca5 = (tr, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
event, editorRef, posAtCoords, editorFocused)=>{
    const cursorCoords = $4bfd6331a10a8378$var$captureCursorCoords(event, editorRef, posAtCoords, tr);
    if (!cursorCoords) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const $pos = cursorCoords.position !== undefined ? tr.doc.resolve(cursorCoords.position) : null;
    if ($pos === null) return;
    const isGapCursorAllowed = cursorCoords.side === (0, $adhil.Side).LEFT ? (0, $1gpr6.isValidTargetNode)($pos.nodeAfter) : (0, $1gpr6.isValidTargetNode)($pos.nodeBefore);
    if (isGapCursorAllowed && (0, $adhil.GapCursorSelection).valid($pos)) {
        // this forces PM to re-render the decoration node if we change the side of the gap cursor, it doesn't do it by default
        if (tr.selection instanceof (0, $adhil.GapCursorSelection)) tr.setSelection((0, $ks2lK.Selection).near($pos));
        else tr.setSelection(new (0, $adhil.GapCursorSelection)($pos, cursorCoords.side));
    } else if (editorFocused === false) {
        const selectionTemp = (0, $ks2lK.Selection).findFrom($pos, cursorCoords.side === (0, $adhil.Side).LEFT ? 1 : -1, true);
        if (selectionTemp) tr.setSelection(selectionTemp);
    }
};
const $4bfd6331a10a8378$export$44fdd7840a0a11f2 = (position, side = (0, $adhil.Side).LEFT)=>(state, dispatch)=>{
        // @see ED-6231
        if (position > state.doc.content.size) return false;
        const $pos = state.doc.resolve(position);
        if ((0, $adhil.GapCursorSelection).valid($pos)) {
            if (dispatch) dispatch(state.tr.setSelection(new (0, $adhil.GapCursorSelection)($pos, side)));
            return true;
        }
        return false;
    };
module.exports["setSelectionTopLevelBlocks"] = $4bfd6331a10a8378$export$1b305efb24649ca5;
module.exports["setGapCursorAtPos"] = $4bfd6331a10a8378$export$44fdd7840a0a11f2;

});

parcelRegister("adhil", function(module, exports) {

var $5SAOw = parcelRequire("5SAOw");


var $ks2lK = parcelRequire("ks2lK");


var $1gpr6 = parcelRequire("1gpr6");

var $51f4ad1a1d4c86a3$export$80a00690bda7f17e = /*#__PURE__*/ function(Side) {
    Side["LEFT"] = "left";
    Side["RIGHT"] = "right";
    return Side;
}({});
const $51f4ad1a1d4c86a3$export$d9f9f34e18094ffd = 'gapcursor';
class $51f4ad1a1d4c86a3$export$7d98c58ca1423246 extends (0, $ks2lK.Selection) {
    static valid($pos) {
        const { parent: parent, nodeBefore: nodeBefore, nodeAfter: nodeAfter } = $pos;
        const targetNode = (0, $1gpr6.isValidTargetNode)(nodeBefore) ? nodeBefore : (0, $1gpr6.isValidTargetNode)(nodeAfter) ? nodeAfter : null;
        if (!targetNode || parent.isTextblock) return false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const deflt = parent.contentMatchAt($pos.index()).defaultType;
        return deflt && deflt.isTextblock;
    }
    static findFrom($pos, dir, mustMove = false) {
        const side = dir === 1 ? "right" : "left";
        if (!mustMove && $51f4ad1a1d4c86a3$export$7d98c58ca1423246.valid($pos)) return new $51f4ad1a1d4c86a3$export$7d98c58ca1423246($pos, side);
        let pos = $pos.pos;
        // TODO: ED-5048 - Fix any, potential issue.
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let next = null;
        // Scan up from this position
        for(let d = $pos.depth;; d--){
            const parent = $pos.node(d);
            if (side === "right" ? $pos.indexAfter(d) < parent.childCount : $pos.index(d) > 0) {
                next = parent.maybeChild(side === "right" ? $pos.indexAfter(d) : $pos.index(d) - 1);
                break;
            } else if (d === 0) return null;
            pos += dir;
            const $cur = $pos.doc.resolve(pos);
            if ($51f4ad1a1d4c86a3$export$7d98c58ca1423246.valid($cur)) return new $51f4ad1a1d4c86a3$export$7d98c58ca1423246($cur, side);
        }
        // And then down into the next node
        for(;;){
            next = side === "right" ? next.firstChild : next.lastChild;
            if (next === null) break;
            pos += dir;
            const $cur = $pos.doc.resolve(pos);
            if ($51f4ad1a1d4c86a3$export$7d98c58ca1423246.valid($cur)) return new $51f4ad1a1d4c86a3$export$7d98c58ca1423246($cur, side);
        }
        return null;
    }
    static fromJSON(doc, json) {
        return new $51f4ad1a1d4c86a3$export$7d98c58ca1423246(doc.resolve(json.pos), json.side);
    }
    map(doc, mapping) {
        const $pos = doc.resolve(mapping.map(this.head));
        return $51f4ad1a1d4c86a3$export$7d98c58ca1423246.valid($pos) ? new $51f4ad1a1d4c86a3$export$7d98c58ca1423246($pos, this.side) : (0, $ks2lK.Selection).near($pos);
    }
    eq(other) {
        return other instanceof $51f4ad1a1d4c86a3$export$7d98c58ca1423246 && other.head === this.head;
    }
    content() {
        return (0, $5SAOw.Slice).empty;
    }
    getBookmark() {
        return new $51f4ad1a1d4c86a3$export$afd2c0d75bc9ce6c(this.anchor);
    }
    toJSON() {
        return {
            pos: this.head,
            type: $51f4ad1a1d4c86a3$export$d9f9f34e18094ffd,
            side: this.side
        };
    }
    /**
   * Construct a GapCursorSelection
   * @param {ResolvedPos} $pos resolved position
   * @param {Side} side side where the gap cursor is drawn
   */ constructor($pos, side = "left"){
        super($pos, $pos), this.side = side;
        this.visible = false;
    }
}
(0, $ks2lK.Selection).jsonID($51f4ad1a1d4c86a3$export$d9f9f34e18094ffd, $51f4ad1a1d4c86a3$export$7d98c58ca1423246);
class $51f4ad1a1d4c86a3$export$afd2c0d75bc9ce6c {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    map(mapping) {
        return new $51f4ad1a1d4c86a3$export$afd2c0d75bc9ce6c(mapping.map(this.pos));
    }
    resolve(doc) {
        const $pos = doc.resolve(this.pos);
        return $51f4ad1a1d4c86a3$export$7d98c58ca1423246.valid($pos) ? new $51f4ad1a1d4c86a3$export$7d98c58ca1423246($pos) : (0, $ks2lK.Selection).near($pos);
    }
    constructor(pos){
        this.pos = pos;
    }
}
module.exports["Side"] = $51f4ad1a1d4c86a3$export$80a00690bda7f17e;
module.exports["JSON_ID"] = $51f4ad1a1d4c86a3$export$d9f9f34e18094ffd;
module.exports["GapCursorSelection"] = $51f4ad1a1d4c86a3$export$7d98c58ca1423246;

});

parcelRegister("1gpr6", function(module, exports) {

var $4Wd8f = parcelRequire("4Wd8f");

const $27b8041df1cc92a4$export$b485b49b5e1715ef = (node)=>{
    return !!node && !(0, $4Wd8f.isIgnored)(node);
};
module.exports["isValidTargetNode"] = $27b8041df1cc92a4$export$b485b49b5e1715ef;

});

parcelRegister("4Wd8f", function(module, exports) {
// we don't show gap cursor for those nodes
const $f3b25ae2912922b3$var$IGNORED_NODES = [
    'paragraph',
    'bulletList',
    'orderedList',
    'listItem',
    'taskItem',
    'decisionItem',
    'heading',
    'blockquote',
    'layoutColumn',
    'caption',
    'media',
    'extensionFrame'
];
const $f3b25ae2912922b3$export$ac3f691269cd6d9b = (node)=>{
    return !!node && $f3b25ae2912922b3$var$IGNORED_NODES.indexOf(node.type.name) !== -1;
};
module.exports["isIgnored"] = $f3b25ae2912922b3$export$ac3f691269cd6d9b;

});

parcelRegister("45E6y", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $938cf1eec2ff4dc1$export$72d101e93c081651 = 'data-editor-content-component';
const $938cf1eec2ff4dc1$export$57a965c23051130d = (reactComponents)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-editor-content-component": 'true'
    }, reactComponents);
};
module.exports["ignoreAttribute"] = $938cf1eec2ff4dc1$export$72d101e93c081651;
module.exports["contentComponentClickWrapper"] = $938cf1eec2ff4dc1$export$57a965c23051130d;

});

parcelRegister("axOCf", function(module, exports) {
/* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");

var $6dGgK = parcelRequire("6dGgK");


var $d7ZU3 = parcelRequire("d7ZU3");


var $gnMzP = parcelRequire("gnMzP");


var $aFUXX = parcelRequire("aFUXX");


var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");


var $dZ8uq = parcelRequire("dZ8uq");


var $iu6m9 = parcelRequire("iu6m9");


var $aeAfU = parcelRequire("aeAfU");


var $cOrQJ = parcelRequire("cOrQJ");


var $jTtEd = parcelRequire("jTtEd");

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled



/**
 * aiPanelStyles
 * was imported from packages/editor/editor-core/src/ui/ContentStyles/ai-panels.ts
 */ const $30cdf9ef77478b9f$var$rotationAnimation = (0, $9K4OG.keyframes)({
    '0%': {
        '--panel-gradient-angle': '0deg'
    },
    '100%': {
        '--panel-gradient-angle': '360deg'
    }
});
const $30cdf9ef77478b9f$var$rotationAnimationFirefox = (0, $9K4OG.keyframes)({
    '0%': {
        '--panel-gradient-angle': '0deg',
        backgroundPosition: '100%'
    },
    '100%': {
        '--panel-gradient-angle': '360deg',
        backgroundPosition: '-100%'
    }
});
const $30cdf9ef77478b9f$var$aiPrismColor = {
    ['prism.border.step.1']: {
        light: '#0065FF',
        dark: '#0065FF80'
    },
    ['prism.border.step.2']: {
        light: '#0469FF',
        dark: '#0469FF80'
    },
    ['prism.border.step.3']: {
        light: '#BF63F3',
        dark: '#BF63F380'
    },
    ['prism.border.step.4']: {
        light: '#FFA900',
        dark: '#FFA90080'
    }
};
const $30cdf9ef77478b9f$var$aiPrismColorStep1Light = $30cdf9ef77478b9f$var$aiPrismColor['prism.border.step.1']['light'];
const $30cdf9ef77478b9f$var$aiPrismColorStep2Light = $30cdf9ef77478b9f$var$aiPrismColor['prism.border.step.2']['light'];
const $30cdf9ef77478b9f$var$aiPrismColorStep3Light = $30cdf9ef77478b9f$var$aiPrismColor['prism.border.step.3']['light'];
const $30cdf9ef77478b9f$var$aiPrismColorStep4Light = $30cdf9ef77478b9f$var$aiPrismColor['prism.border.step.4']['light'];
const $30cdf9ef77478b9f$var$aiPrismColorStep1Dark = $30cdf9ef77478b9f$var$aiPrismColor['prism.border.step.1']['dark'];
const $30cdf9ef77478b9f$var$aiPrismColorStep2Dark = $30cdf9ef77478b9f$var$aiPrismColor['prism.border.step.2']['dark'];
const $30cdf9ef77478b9f$var$aiPrismColorStep3Dark = $30cdf9ef77478b9f$var$aiPrismColor['prism.border.step.3']['dark'];
const $30cdf9ef77478b9f$var$aiPrismColorStep4Dark = $30cdf9ef77478b9f$var$aiPrismColor['prism.border.step.4']['dark'];
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
const $30cdf9ef77478b9f$var$prismBorderBaseBackgroundFirefox = `linear-gradient(90deg, ${$30cdf9ef77478b9f$var$aiPrismColorStep1Light} 0%, ${$30cdf9ef77478b9f$var$aiPrismColorStep2Light} 12%, ${$30cdf9ef77478b9f$var$aiPrismColorStep3Light} 24%, ${$30cdf9ef77478b9f$var$aiPrismColorStep4Light} 48%, ${$30cdf9ef77478b9f$var$aiPrismColorStep3Light} 64%, ${$30cdf9ef77478b9f$var$aiPrismColorStep2Light} 80%, ${$30cdf9ef77478b9f$var$aiPrismColorStep1Light} 100%)`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
const $30cdf9ef77478b9f$var$prismBorderBaseBackground = `conic-gradient(from var(--panel-gradient-angle, 270deg), ${$30cdf9ef77478b9f$var$aiPrismColorStep1Light} 0%, ${$30cdf9ef77478b9f$var$aiPrismColorStep2Light} 20%, ${$30cdf9ef77478b9f$var$aiPrismColorStep3Light} 50%, ${$30cdf9ef77478b9f$var$aiPrismColorStep4Light} 56%, ${$30cdf9ef77478b9f$var$aiPrismColorStep1Light} 100%)`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
const $30cdf9ef77478b9f$var$prismBorderDarkBackgroundFirefox = `linear-gradient(90deg, ${$30cdf9ef77478b9f$var$aiPrismColorStep1Dark} 0%, ${$30cdf9ef77478b9f$var$aiPrismColorStep2Dark} 12%, ${$30cdf9ef77478b9f$var$aiPrismColorStep3Dark} 24%, ${$30cdf9ef77478b9f$var$aiPrismColorStep4Dark} 48%, ${$30cdf9ef77478b9f$var$aiPrismColorStep3Dark} 64%, ${$30cdf9ef77478b9f$var$aiPrismColorStep2Dark} 80%, ${$30cdf9ef77478b9f$var$aiPrismColorStep1Dark} 100%)`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
const $30cdf9ef77478b9f$var$prismBorderDarkBackground = `conic-gradient(from var(--panel-gradient-angle, 270deg), ${$30cdf9ef77478b9f$var$aiPrismColorStep1Dark} 0%, ${$30cdf9ef77478b9f$var$aiPrismColorStep2Dark} 20%, ${$30cdf9ef77478b9f$var$aiPrismColorStep3Dark} 50%, ${$30cdf9ef77478b9f$var$aiPrismColorStep4Dark} 56%, ${$30cdf9ef77478b9f$var$aiPrismColorStep1Dark} 100%)`;
const $30cdf9ef77478b9f$export$7d2a5652980d3808 = /*#__PURE__*/ (0, $9K4OG.css)({
    '@property --panel-gradient-angle': {
        syntax: '<angle>',
        initialValue: '270deg',
        inherits: false
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    'div[extensionType="com.atlassian.ai-blocks"]': {
        /* This hides the label for the extension */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.extension-label': {
            display: 'none'
        },
        /* This styles the ai panel correctly when its just sitting on the page and there
    is no user interaction */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.extension-container': {
            position: 'relative',
            boxShadow: 'none',
            overflow: 'unset',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            backgroundColor: `${"var(--ds-surface, #FFFFFF)"} !important`,
            // prismBorderBaseStyles
            '&::before, &::after': {
                content: "''",
                position: 'absolute',
                zIndex: -1,
                width: `calc(100% + 2px)`,
                height: `calc(100% + 2px)`,
                top: `-1px`,
                left: `-1px`,
                borderRadius: `calc(${"var(--ds-radius-small, 3px)"} + 1px)`,
                transform: 'translate3d(0, 0, 0)',
                background: $30cdf9ef77478b9f$var$prismBorderBaseBackground
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.with-hover-border': {
                '&::before, &::after': {
                    //prismBorderHoverStyles
                    background: "var(--ds-border-input, #8C8F97)"
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '& .with-margin-styles': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                backgroundColor: `${"var(--ds-surface, #FFFFFF)"} !important`,
                borderRadius: "var(--ds-radius-small, 3px)"
            }
        }
    },
    /* This styles the ai panel correctly when its streaming */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    'div[extensionType="com.atlassian.ai-blocks"]:has(.streaming)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.extension-container': {
            '&::before, &::after': {
                // prismBorderAnimationStyles
                animationName: $30cdf9ef77478b9f$var$rotationAnimation,
                animationDuration: '2s',
                animationTimingFunction: 'linear',
                animationIterationCount: 'infinite',
                '@media (prefers-reduced-motion)': {
                    animation: 'none'
                }
            }
        }
    },
    /* This styles the ai panel correctly when a user is hovering over the delete button in the floating panel */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    'div[extensionType="com.atlassian.ai-blocks"].danger': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.extension-container': {
            boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`
        }
    },
    /* This removes the margin from the action list when inside an ai panel */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    'div[extensiontype="com.atlassian.ai-blocks"][extensionkey="ai-action-items-block:aiActionItemsBodiedExtension"]': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'div[data-node-type="actionList"]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            margin: '0 !important'
        }
    }
});
const $30cdf9ef77478b9f$export$541b06daf7fd8fce = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    'div[extensionType="com.atlassian.ai-blocks"]': {
        '&::before, &::after': {
            background: $30cdf9ef77478b9f$var$prismBorderBaseBackgroundFirefox,
            backgroundSize: '200%'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    'div[extensionType="com.atlassian.ai-blocks"]:has(.streaming)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.extension-container': {
            '&::before, &::after': {
                animationName: $30cdf9ef77478b9f$var$rotationAnimationFirefox,
                animationDirection: 'normal',
                animationDuration: '1s'
            }
        }
    }
});
const $30cdf9ef77478b9f$export$9a2d17c0df63f635 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    'div[extensionType="com.atlassian.ai-blocks"]': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.extension-container': {
            '&::before, &::after': {
                background: $30cdf9ef77478b9f$var$prismBorderDarkBackground
            }
        }
    }
});
const $30cdf9ef77478b9f$export$18b242302a502e32 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    'div[extensionType="com.atlassian.ai-blocks"]': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.extension-container': {
            '&::before, &::after': {
                background: $30cdf9ef77478b9f$var$prismBorderDarkBackgroundFirefox,
                backgroundSize: '200%'
            }
        }
    }
});


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled




var $6ESsx = parcelRequire("6ESsx");

const $e744a1f22573fa53$export$65cde0a0b7e7c1c1 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${(0, $6ESsx.AnnotationSharedClassNames).blur}, .${(0, $6ESsx.AnnotationSharedClassNames).focus}, .${(0, $6ESsx.AnnotationSharedClassNames).draft}, .${(0, $6ESsx.AnnotationSharedClassNames).hover}`]: {
            borderBottom: '2px solid transparent',
            cursor: 'pointer',
            padding: '1px 0 2px',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:has(.card), &:has([data-inline-card])': {
                padding: '5px 0 3px 0'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:has(.date-lozenger-container)': {
                paddingTop: "var(--ds-space-025, 2px)"
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${(0, $6ESsx.AnnotationSharedClassNames).focus}`]: {
            background: "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-raised, 0px 1px 1px #1E1F2140, 0px 0px 1px #1E1F214f)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${(0, $6ESsx.AnnotationSharedClassNames).draft}`]: {
            background: "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-raised, 0px 1px 1px #1E1F2140, 0px 0px 1px #1E1F214f)",
            cursor: 'initial'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${(0, $6ESsx.AnnotationSharedClassNames).blur}`]: {
            background: "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${(0, $6ESsx.AnnotationSharedClassNames).hover}`]: {
            background: "var(--ds-background-accent-yellow-subtlest-hovered, #F5E989)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-raised, 0px 1px 1px #1E1F2140, 0px 0px 1px #1E1F214f)"
        }
    }
});


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $680457c62c4e856c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $680457c62c4e856c$export$a365082c2a191514 = {
    name: "nf8qu5",
    styles: ".fabric-background-color-mark:has(.background-color-padding-left){padding-left:var(--ds-space-025, 2px);margin-left:var(--ds-space-negative-025, -2px);}.fabric-background-color-mark:has(.background-color-padding-right){padding-right:var(--ds-space-025, 2px);margin-right:var(--ds-space-negative-025, -2px);}"
};
const $680457c62c4e856c$export$e4cca17cf56e99d = {
    name: "yf96ao",
    styles: ".fabric-background-color-mark{background-color:var(--custom-palette-color, inherit);border-radius:var(--ds-radius-xsmall, 2px);padding-top:1px;padding-bottom:2px;box-decoration-break:clone;}a .fabric-background-color-mark{background-color:unset;}.fabric-background-color-mark .ak-editor-annotation{background-color:unset;}"
};


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled



function $0c8159821f1481e1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// = akEditorDefaultLayoutWidth * breakoutWideScaleRatio = 1010.8 ~ 1011 This is a resulting width value that is applied to nodes that currently use breakouts (except table) and are set to `wide` when the viewport's width is > 1329px.
const $0c8159821f1481e1$var$akEditorCalculatedWideLayoutWidth = 1011;
// from breakoutConsts.calcWideWidth, layoutMaxWidth * breakoutConsts.wideScaleRatio = 904.8 ~ 905 This is a resulting width value that is applied to nodes that currently use breakouts (except table) and are set to `wide` when the viewport's width is <= 1266px.
const $0c8159821f1481e1$var$akEditorCalculatedWideLayoutWidthSmallViewport = 905;
const $0c8159821f1481e1$var$akEditorGutterPadding = 32;
const $0c8159821f1481e1$var$akEditorDefaultLayoutWidth = 760;
const $0c8159821f1481e1$var$akEditorFullWidthLayoutWidth = 1800;
// The breakpoint for small devices is 1266px, copied from getBreakpoint in platform/packages/editor/editor-common/src/ui/WidthProvider/index.tsx
const $0c8159821f1481e1$var$akEditorBreakpointForSmallDevice = `1266px`;
const $0c8159821f1481e1$var$akEditorGutterPaddingReduced = 24;
const $0c8159821f1481e1$var$akEditorFullPageNarrowBreakout = 600;
const $0c8159821f1481e1$export$6a08aa478781aaec = /*#__PURE__*/ (0, $9K4OG.css)({
    '--ak-editor--default-gutter-padding': `${$0c8159821f1481e1$var$akEditorGutterPadding}px`,
    '--ak-editor--default-layout-width': `${$0c8159821f1481e1$var$akEditorDefaultLayoutWidth}px`,
    '--ak-editor--resizer-handle-spacing': `12px`,
    '--ak-editor--full-width-layout-width': `${$0c8159821f1481e1$var$akEditorFullWidthLayoutWidth}px`,
    /* calculate editor line length, 100cqw is the editor container width */ '--ak-editor--line-length': 'min(calc(100cqw - var(--ak-editor--large-gutter-padding) * 2), var(--ak-editor--default-layout-width))',
    '--ak-editor--breakout-wide-layout-width': `${$0c8159821f1481e1$var$akEditorCalculatedWideLayoutWidthSmallViewport}px`,
    '--ak-editor--breakout-full-page-guttering-padding': 'calc(var(--ak-editor--large-gutter-padding) * 2 + var(--ak-editor--default-gutter-padding))',
    '--ak-editor--breakout-fallback-width': 'calc(100cqw - var(--ak-editor--breakout-full-page-guttering-padding))',
    '--ak-editor--breakout-min-width': '100%',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.fabric-editor--full-width-mode': {
        '--ak-editor--line-length': 'min(calc(100cqw - var(--ak-editor--large-gutter-padding) * 2), var(--ak-editor--full-width-layout-width))',
        /* in full width appearances it's not possible to rely on cqw because it doesn't account for the page scrollbar, which depends on users system settings */ '--ak-editor--breakout-fallback-width': '100%',
        '--ak-editor--breakout-min-width': '0px'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        '--ak-editor-max-container-width': 'calc(100cqw - var(--ak-editor--large-gutter-padding))',
        outline: 'none',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 'var(--ak-editor-base-font-size)'
    },
    /* We can't allow nodes that are inside other nodes to bleed from the parent container */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror > div[data-prosemirror-node-block] [data-prosemirror-node-block]': {
        '--ak-editor-max-container-width': '100%'
    },
    /* container editor-area is defined in platform/packages/editor/editor-core/src/ui/Appearance/FullPage/StyledComponents.ts */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries, @atlaskit/ui-styling-standard/no-unsafe-values
    [`@container editor-area (width >= ${$0c8159821f1481e1$var$akEditorBreakpointForSmallDevice})`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ProseMirror': {
            '--ak-editor--breakout-wide-layout-width': `${$0c8159821f1481e1$var$akEditorCalculatedWideLayoutWidth}px`
        }
    }
});
const $0c8159821f1481e1$export$9e26088fca9327a2 = {
    name: "ituy02",
    styles: "--ak-editor--large-gutter-padding:52px"
};
const $0c8159821f1481e1$export$cc6d483a79f2d275 = {
    name: "n99on3",
    styles: "--ak-editor--large-gutter-padding:72px"
};
const $0c8159821f1481e1$export$23029c6a73ca6b8c = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries, @atlaskit/ui-styling-standard/no-unsafe-values
    [`@container editor-area (max-width: ${$0c8159821f1481e1$var$akEditorFullPageNarrowBreakout}px)`]: {
        '--ak-editor--large-gutter-padding': `${$0c8159821f1481e1$var$akEditorGutterPaddingReduced}px`
    }
});


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
function $7a303160bb76f51c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7a303160bb76f51c$export$e561f1e4e17b129d = {
    name: "13r502m",
    styles: "*:not(.fabric-editor-block-mark) >, *:not(.fabric-editor-block-mark) > div.fabric-editor-block-mark:first-of-type:not(.fabric-editor-indentation-mark):not(.fabric-editor-alignment), .fabric-editor-alignment:first-of-type:first-child, .ProseMirror .fabric-editor-indentation-mark:first-of-type:first-child{p, h1, h2, h3, h4, h5, h6, .heading-wrapper{&:first-child:not(style), style:first-child + *{margin-top:0;}}}"
};


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled



function $375f45f3b6bd3ab6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $375f45f3b6bd3ab6$export$610a2509037eaf6 = {
    name: "1auxodh",
    styles: ".ProseMirror{& blockquote{box-sizing:border-box;color:inherit;width:100%;display:inline-block;padding-left:var(--ds-space-200, 16px);border-left-width:var(--ds-border-width-selected, 2px);border-left-style:solid;border-left-color:var(--ds-border, #0B120E24);margin:0.75rem 0 0 0;margin-right:0;[dir=\"rtl\"] &{padding-left:0;padding-right:var(--ds-space-200, 16px);}&:first-child{margin-top:0;}&::before{content:'';}&::after{content:none;}& p{display:block;}& table, & table:last-child{display:inline-table;}> .code-block:last-child, >.mediaSingleView-content-wrap:last-child, >.mediaGroupView-content-wrap:last-child{display:block;}> .extensionView-content-wrap:last-child{display:block;}}.fabric-editor-block-mark.fabric-editor-alignment:not(:first-child){> h1:first-child{margin-top:1.667em;}> h2:first-child{margin-top:1.8em;}> h3:first-child{margin-top:2em;}> h4:first-child{margin-top:1.357em;}> h5:first-child{margin-top:1.667em;}> h6:first-child{margin-top:1.455em;}}.ProseMirror-gapcursor:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .ProseMirror-widget:nth-child(2) + .fabric-editor-block-mark.fabric-editor-alignment{> :is(h1, h2, h3, h4, h5, h6):first-child{margin-top:0;}}}"
};
const $375f45f3b6bd3ab6$export$36460e974c9904b9 = {
    name: "jrdqfj",
    styles: ".ProseMirror{& h1{font:var(--editor-font-ugc-token-heading-h1);margin-bottom:0;margin-top:1.45833em;& strong{font-weight:var(--editor-font-ugc-token-weight-heading-bold);}}& h2{font:var(--editor-font-ugc-token-heading-h2);margin-bottom:0;margin-top:1.4em;& strong{font-weight:var(--editor-font-ugc-token-weight-heading-bold);}}& h3{font:var(--editor-font-ugc-token-heading-h3);margin-bottom:0;margin-top:1.31249em;& strong{font-weight:var(--editor-font-ugc-token-weight-heading-bold);}}& h4{font:var(--editor-font-ugc-token-heading-h4);margin-top:1.25em;& strong{font-weight:var(--editor-font-ugc-token-weight-heading-bold);}}& h5{font:var(--editor-font-ugc-token-heading-h5);margin-top:1.45833em;text-transform:none;& strong{font-weight:var(--editor-font-ugc-token-weight-heading-bold);}}& h6{font:var(--editor-font-ugc-token-heading-h6);margin-top:1.59091em;text-transform:none;& strong{font-weight:var(--editor-font-ugc-token-weight-heading-bold);}}}"
};
const $375f45f3b6bd3ab6$export$4a8301858e3f950 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& h1': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: 'calc(24em / 14)',
            fontStyle: 'inherit',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: 'calc(28 / 24)',
            color: "var(--ds-text, #292A2E)",
            fontWeight: "var(--ds-font-weight-medium, 500)",
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            letterSpacing: `-0.01em`,
            marginBottom: 0,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginTop: '1.667em'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& h2': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: 'calc(20em / 14)',
            fontStyle: 'inherit',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: 'calc(24 / 20)',
            color: "var(--ds-text, #292A2E)",
            fontWeight: "var(--ds-font-weight-medium, 500)",
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            letterSpacing: `-0.008em`,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginTop: '1.8em',
            marginBottom: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& h3': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: 'calc(16em / 14)',
            fontStyle: 'inherit',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: 'calc(20 / 16)',
            color: "var(--ds-text, #292A2E)",
            fontWeight: "var(--ds-font-weight-semibold, 600)",
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            letterSpacing: `-0.006em`,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginTop: '2em',
            marginBottom: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& h4': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: 'calc(14em / 14)',
            fontStyle: 'inherit',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: 'calc(16 / 14)',
            color: "var(--ds-text, #292A2E)",
            fontWeight: "var(--ds-font-weight-semibold, 600)",
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            letterSpacing: `-0.003em`,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginTop: '1.357em'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& h5': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: 'calc(12em / 14)',
            fontStyle: 'inherit',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: 'calc(16 / 12)',
            color: "var(--ds-text, #292A2E)",
            fontWeight: "var(--ds-font-weight-semibold, 600)",
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginTop: '1.667em',
            textTransform: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& h6': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: 'calc(11em / 14)',
            fontStyle: 'inherit',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: 'calc(16 / 11)',
            color: "var(--ds-text-subtlest, #6B6E76)",
            fontWeight: "var(--ds-font-weight-bold, 700)",
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginTop: '1.455em',
            textTransform: 'none'
        }
    }
});
const $375f45f3b6bd3ab6$export$13d8dd04b9497c9a = {
    name: "18w6jtp",
    styles: ".ak-editor-content-area.appearance-full-page .ProseMirror blockquote{padding-left:var(--ds-space-250, 20px);}.ak-editor-content-area .ak-editor-content-area .ProseMirror blockquote{padding-left:var(--ds-space-200, 16px);}"
};


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled



const $80ac58d0463897a9$export$98853831203df33a = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="code-bidi-warning"]': {
        display: 'inline-block'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="code-bidi-warning"] [data-bidi-component="code-bidi-warning-decorator"]': {
        paddingInlineStart: "var(--ds-space-050, 4px)",
        paddingInlineEnd: "var(--ds-space-050, 4px)",
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        fontStyle: 'normal',
        fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        paddingTop: '0.05rem',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        paddingBottom: '0.05rem',
        color: "var(--ds-text-warning, #9E4C00)",
        backgroundColor: "var(--ds-background-warning, #FFF5DB)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="code-bidi-warning"] [data-bidi-component="code-bidi-warning-decorator"]:hover': {
        color: "var(--ds-text-warning, #9E4C00)",
        backgroundColor: "var(--ds-background-warning-hovered, #FCE4A6)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="code-bidi-warning"] [data-bidi-component="code-bidi-warning-tooltip"]': {
        visibility: 'hidden',
        boxSizing: 'border-box',
        width: '15pc',
        backgroundColor: "var(--ds-background-neutral-bold, #292A2E)",
        color: "var(--ds-text-inverse, #FFFFFF)",
        overflowWrap: 'break-word',
        cursor: 'default',
        borderRadius: "var(--ds-radius-small, 4px)",
        margin: "var(--ds-space-0, 0px)",
        padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-075, 6px)"}`,
        position: 'fixed',
        // The character label will be ~80px and this is positioned from the end of that label
        // We also use this instead of top: 24px to make sure the tooltip maintains its initial position
        // instead of being positioned relative to the viewport.
        // We need to use position: fixed so that the tooltip bypasses the overflow settings of the code block
        // and is always visible.
        // We also offset a little extra here to account for the transition behavior (to replicate ADS fade-in-from-top)
        transform: 'translate(calc(-50% - 40px), calc(24px - 4px))',
        opacity: 0,
        whiteSpace: 'normal',
        font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        zIndex: 9999,
        // Exit animation timings
        // - Mark invisible after 0.475s
        // - After 0.3s, fade out and move up over 0.175s
        transition: 'visibility 0s linear 0.475s, opacity 0.175s cubic-bezier(0.15,1,0.3,1) 0.3s, transform 0.175s cubic-bezier(0.15,1,0.3,1) 0.3s'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="code-bidi-warning"]:hover [data-bidi-component="code-bidi-warning-tooltip"]': {
        visibility: 'visible',
        transform: 'translate(calc(-50% - 40px), calc(24px))',
        opacity: 1,
        // Enter animation timings
        // - Mark visible after 0.3s of hovering
        // - After 0.3s, fade in over 0.175s
        // - After 0.3s, move down over 0.35s
        transition: 'visibility 0s linear 0.3s, opacity 0.175s cubic-bezier(0.15,1,0.3,1) 0.3s, transform 0.35s cubic-bezier(0.15,1,0.3,1) 0.3s'
    }
});


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled



// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled



const $e93d54020f263515$export$cd7bee32f3fef345 = /*#__PURE__*/ (0, $9K4OG.css)({
    backgroundImage: `
		linear-gradient(
			to right,
			${"var(--ds-background-neutral, #0515240F)"} ${"var(--ds-space-300, 24px)"},
			transparent ${"var(--ds-space-300, 24px)"}
		),
		linear-gradient(
			to right,
			${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-300, 24px)"},
			transparent ${"var(--ds-space-300, 24px)"}
		),
		linear-gradient(
			to left,
			${"var(--ds-background-neutral, #0515240F)"} ${"var(--ds-space-100, 8px)"},
			transparent ${"var(--ds-space-100, 8px)"}
		),
		linear-gradient(
			to left,
			${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-100, 8px)"},
			transparent ${"var(--ds-space-100, 8px)"}
		),
		linear-gradient(
			to left,
			${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 0,
			${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
		),
		linear-gradient(
			to left,
			${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0,
			${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
		),
		linear-gradient(
			to right,
			${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 0,
			${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
		),
		linear-gradient(
			to right,
			${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0,
			${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
		)
	`
});


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled



function $65bb5c5a687b3665$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $65bb5c5a687b3665$export$a716852a0c5e54d5 = {
    name: "1fqpa4w",
    styles: "&::selection,*::selection{background-color:transparent;}&::-moz-selection,*::-moz-selection{background-color:transparent;}"
};
const $65bb5c5a687b3665$export$48dd9ca0c16e4625 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
    border: `1px solid ${"var(--ds-border-selected, #1868DB)"}`,
    // Fixes ED-15246: Trello card is visible through a border of a table border
    '&::after': {
        height: '100%',
        content: "'\\00a0'",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
        background: "var(--ds-border-selected, #1868DB)",
        position: 'absolute',
        right: -1,
        top: 0,
        bottom: 0,
        width: 1,
        border: 'none',
        display: 'inline-block'
    }
});
const $65bb5c5a687b3665$export$a8e8bf15b18b52a0 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
    boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #1868DB)"}`,
    borderColor: 'transparent'
});
const $65bb5c5a687b3665$export$b2937e5c446645ec = {
    name: "16c0srz",
    styles: "background-color:var(--ds-background-selected, #E9F2FE)"
};
const $65bb5c5a687b3665$export$e7c1f2908e268236 = {
    name: "na0ofp",
    styles: "position:relative;-webkit-user-select:text;&::before{position:absolute;content:'';left:0;right:0;top:0;bottom:0;width:100%;pointer-events:none;z-index:12;background-color:var(--ds-blanket-selected, #388BFF14);}"
};
const $65bb5c5a687b3665$export$b8cc3f8fc9e3d56a = {
    name: "105gl83",
    styles: ".ProseMirror-hideselection{*::selection{background:transparent;}*::-moz-selection{background:transparent;}}"
};
const $65bb5c5a687b3665$export$cc1dcabcf4a29354 = {
    name: "p4ha7",
    styles: ".ProseMirror-hideselection{caret-color:transparent;}"
};
const $65bb5c5a687b3665$export$a3d8f4cb8a14da43 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror-selectednode': {
        outline: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror-selectednode:empty': {
        outline: `2px solid ${"var(--ds-border-focused, #4688EC)"}`
    }
});
const $65bb5c5a687b3665$export$57f48b634c3a2512 = /*#__PURE__*/ (0, $9K4OG.css)({
    boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`
});
const $65bb5c5a687b3665$export$fd4ac125b4ba4c28 = {
    name: "74cays",
    styles: "background-color:var(--ds-background-danger, #FFECEB)"
};


function $1e5fdc47935572b3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1e5fdc47935572b3$export$42659c26f026f6ea = {
    CODEBLOCK_CONTAINER: 'code-block',
    CODEBLOCK_START: 'code-block--start',
    CODEBLOCK_END: 'code-block--end',
    CODEBLOCK_CONTENT_WRAPPER: 'code-block-content-wrapper',
    CODEBLOCK_LINE_NUMBER_GUTTER: 'line-number-gutter',
    CODEBLOCK_CONTENT: 'code-content',
    DS_CODEBLOCK: '[data-ds--code--code-block]',
    CODEBLOCK_CONTENT_WRAPPED: 'code-content--wrapped',
    CODEBLOCK_CONTAINER_LINE_NUMBER_WIDGET: 'code-content__line-number--wrapped'
};
const $1e5fdc47935572b3$var$fontSize14px = `${0.875}rem`;
const $1e5fdc47935572b3$var$blockNodesVerticalMargin = '0.75rem';
const $1e5fdc47935572b3$var$gutterDangerOverlay = {
    name: "110x2n0",
    styles: "&::after{height:100%;content:'';position:absolute;left:0;top:0;width:24px;background-color:var(--ds-blanket-danger, #EF5C4814);}"
};
const $1e5fdc47935572b3$export$4baaed2b257b830 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$1e5fdc47935572b3$export$42659c26f026f6ea.CODEBLOCK_CONTENT_WRAPPED} > .${$1e5fdc47935572b3$export$42659c26f026f6ea.CODEBLOCK_CONTENT_WRAPPER} > .${$1e5fdc47935572b3$export$42659c26f026f6ea.CODEBLOCK_CONTENT}`]: {
            marginRight: "var(--ds-space-100, 8px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            code: {
                display: 'block',
                wordBreak: 'break-word',
                whiteSpace: 'pre-wrap'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$1e5fdc47935572b3$export$42659c26f026f6ea.CODEBLOCK_CONTENT_WRAPPER} > .${$1e5fdc47935572b3$export$42659c26f026f6ea.CODEBLOCK_CONTENT}`]: {
            display: 'flex',
            flex: 1,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            code: {
                flexGrow: 1,
                whiteSpace: 'pre'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$1e5fdc47935572b3$export$42659c26f026f6ea.CODEBLOCK_CONTAINER}`]: {
            position: 'relative',
            backgroundColor: "var(--ds-surface-raised, #FFFFFF)",
            borderRadius: "var(--ds-radius-small, 3px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
            margin: `${$1e5fdc47935572b3$var$blockNodesVerticalMargin} 0 0 0`,
            fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
            minWidth: 48,
            cursor: 'pointer',
            clear: 'both',
            // This is necessary to allow for arrow key navigation in/out of code blocks in Firefox.
            whiteSpace: 'normal',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.code-block-gutter-pseudo-element::before': {
                content: 'attr(data-label)'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$1e5fdc47935572b3$export$42659c26f026f6ea.CODEBLOCK_START}`]: {
                position: 'absolute',
                visibility: 'hidden',
                height: '1.5rem',
                top: 0,
                left: 0
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$1e5fdc47935572b3$export$42659c26f026f6ea.CODEBLOCK_END}`]: {
                position: 'absolute',
                visibility: 'hidden',
                height: '1.5rem',
                bottom: 0,
                right: 0
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$1e5fdc47935572b3$export$42659c26f026f6ea.CODEBLOCK_CONTENT_WRAPPER}`]: [
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $e93d54020f263515$export$cd7bee32f3fef345),
                {
                    position: 'relative',
                    backgroundColor: "var(--ds-background-neutral, #0515240F)",
                    display: 'flex',
                    borderRadius: "var(--ds-radius-small, 3px)",
                    width: '100%',
                    counterReset: 'line',
                    overflowX: 'auto',
                    backgroundRepeat: 'no-repeat',
                    backgroundAttachment: 'local, local, local, local, scroll, scroll, scroll, scroll',
                    backgroundSize: `${"var(--ds-space-300, 24px)"} 100%,
	                         ${"var(--ds-space-300, 24px)"} 100%,
	                         ${"var(--ds-space-100, 8px)"} 100%,
	                         ${"var(--ds-space-100, 8px)"} 100%,
	                         ${"var(--ds-space-100, 8px)"} 100%,
	                         1px 100%,
	                         ${"var(--ds-space-100, 8px)"} 100%,
	                         1px 100%`,
                    backgroundPosition: `0 0,
	                             0 0,
                               100% 0,
                               100% 0,
                               100% 0,
                               100% 0,
	                             0 0,
	                             0 0`,
                    // Be careful if refactoring this; it is needed to keep arrow key navigation in Firefox consistent with other browsers.
                    overflowY: 'hidden'
                }
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$1e5fdc47935572b3$export$42659c26f026f6ea.CODEBLOCK_LINE_NUMBER_GUTTER}`]: {
                backgroundColor: "var(--ds-background-neutral, #0515240F)",
                position: 'relative',
                width: 'var(--lineNumberGutterWidth, 2rem)',
                padding: "var(--ds-space-100, 8px)",
                flexShrink: 0,
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                fontSize: $1e5fdc47935572b3$var$fontSize14px,
                boxSizing: 'content-box'
            },
            // This is a fix of marker of list item with code block.
            // The list item marker in Chrome is aligned by the baseline of the text,
            // that's why we need to add a text (content: "1") to the line number gutter to align
            // the list item marker with the text.
            // Without it, the list item marker will be aligned by the bottom of the code block. */
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$1e5fdc47935572b3$export$42659c26f026f6ea.CODEBLOCK_LINE_NUMBER_GUTTER}::before`]: {
                content: "'1'",
                visibility: 'hidden',
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                fontSize: $1e5fdc47935572b3$var$fontSize14px,
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                lineHeight: '1.5rem'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$1e5fdc47935572b3$export$42659c26f026f6ea.CODEBLOCK_CONTENT}`]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                code: {
                    tabSize: 4,
                    cursor: 'text',
                    color: "var(--ds-text, #292A2E)",
                    borderRadius: "var(--ds-radius-small, 3px)",
                    margin: "var(--ds-space-100, 8px)",
                    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                    fontSize: $1e5fdc47935572b3$var$fontSize14px,
                    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                    lineHeight: '1.5rem'
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$1e5fdc47935572b3$export$42659c26f026f6ea.CODEBLOCK_CONTAINER_LINE_NUMBER_WIDGET}`]: {
                pointerEvents: 'none',
                userSelect: 'none',
                width: 'var(--lineNumberGutterWidth, 2rem)',
                left: 0,
                position: 'absolute',
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                fontSize: $1e5fdc47935572b3$var$fontSize14px,
                padding: `0px ${"var(--ds-space-100, 8px)"}`,
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                lineHeight: '1.5rem',
                textAlign: 'right',
                color: "var(--ds-text-subtlest, #505F79)",
                boxSizing: 'content-box'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        li: {
            // if same list item has multiple code blocks we need top margin for all but first
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> .code-block': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
                margin: `${$1e5fdc47935572b3$var$blockNodesVerticalMargin} 0 0 0`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
            '> .code-block:first-child, > .ProseMirror-gapcursor:first-child + .code-block': {
                marginTop: 0
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
            '> div:last-of-type.code-block, > pre:last-of-type.code-block': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
                marginBottom: $1e5fdc47935572b3$var$blockNodesVerticalMargin
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-imported-style-values
        [`.code-block.ak-editor-selected-node:not(.danger)`]: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$e7c1f2908e268236),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a716852a0c5e54d5)
        ],
        // Danger when top level node
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.danger.code-block': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
            boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$1e5fdc47935572b3$export$42659c26f026f6ea.CODEBLOCK_LINE_NUMBER_GUTTER}`]: [
                {
                    backgroundColor: "var(--ds-background-danger, #FFECEB)",
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    color: "var(--ds-text-danger, #AE2E24)"
                },
                $1e5fdc47935572b3$var$gutterDangerOverlay
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$1e5fdc47935572b3$export$42659c26f026f6ea.CODEBLOCK_CONTENT}`]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                backgroundColor: "var(--ds-blanket-danger, #EF5C4814)"
            }
        },
        // Danger when nested node
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.danger .code-block': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$1e5fdc47935572b3$export$42659c26f026f6ea.CODEBLOCK_LINE_NUMBER_GUTTER}`]: [
                {
                    backgroundColor: "var(--ds-background-danger, #FFECEB)",
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    color: "var(--ds-text-danger, #AE2E24)"
                },
                $1e5fdc47935572b3$var$gutterDangerOverlay
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$1e5fdc47935572b3$export$42659c26f026f6ea.CODEBLOCK_CONTENT}`]: {
                backgroundColor: "var(--ds-blanket-danger, #EF5C4814)"
            }
        }
    }
});
const $1e5fdc47935572b3$export$921fec04d268c00a = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$1e5fdc47935572b3$export$42659c26f026f6ea.CODEBLOCK_CONTAINER}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.code-block-gutter-pseudo-element::before': {
                display: 'flow',
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                lineHeight: '1.5em'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$1e5fdc47935572b3$export$42659c26f026f6ea.CODEBLOCK_CONTENT}`]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                code: {
                    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                    fontSize: '0.875em',
                    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                    lineHeight: '1.5em'
                }
            }
        }
    }
});
const $1e5fdc47935572b3$export$107831225ad52bb4 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$1e5fdc47935572b3$export$42659c26f026f6ea.CODEBLOCK_CONTAINER}`]: {
        '--ds--code--bg-color': 'transparent'
    }
});
const $1e5fdc47935572b3$export$ddc3dd3ba723d1af = {
    name: "1pwqusk",
    styles: ".ProseMirror{.ak-editor-panel__content{> .code-block:first-child, > .ProseMirror-widget:first-child + .code-block, > .ProseMirror-widget:first-child + .ProseMirror-widget + .code-block{margin:0!important;}}}"
};
const $1e5fdc47935572b3$export$50458a606d5c37d0 = {
    name: "1jcwwg4",
    styles: ".ProseMirror{.ak-editor-panel__content{> .code-block:first-child{margin:0!important;}}}"
};


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled



const $9fb7690d6af70e31$export$2029176b06e1b241 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.code': {
        '--ds--code--bg-color': "var(--ds-background-neutral, #0515240F)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        display: 'inline',
        padding: '2px 0.5ch',
        backgroundColor: `var(--ds--code--bg-color,${"var(--ds-background-neutral, #0515240F)"})`,
        borderRadius: "var(--ds-radius-small, 3px)",
        borderStyle: 'none',
        boxDecorationBreak: 'clone',
        color: "var(--ds-text, #292A2E)",
        fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '0.875em',
        fontWeight: "var(--ds-font-weight-regular, 400)",
        overflow: 'auto',
        overflowWrap: 'break-word',
        whiteSpace: 'pre-wrap'
    }
});


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled



const $8ba9ce11757ecee6$var$CommentEditorMargin = 14;
const $8ba9ce11757ecee6$var$GRID_GUTTER = 12;
const $8ba9ce11757ecee6$export$d6e7bceefcc20e27 = /*#__PURE__*/ (0, $9K4OG.css)({
    flexGrow: 1,
    overflowX: 'clip',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '24px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.ProseMirror': {
        margin: "var(--ds-space-150, 12px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.gridParent': {
        marginLeft: "var(--ds-space-025, 2px)",
        marginRight: "var(--ds-space-025, 2px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `calc(100% + ${$8ba9ce11757ecee6$var$CommentEditorMargin - $8ba9ce11757ecee6$var$GRID_GUTTER}px)`
    },
    padding: "var(--ds-space-250, 20px)"
});


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
function $034503d6cd31c145$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $034503d6cd31c145$export$f21d9f928c6ae322 = {
    name: "l350f4",
    styles: ".ProseMirror.ProseMirror-focused:has(.ProseMirror-mark-boundary-cursor){caret-color:transparent;}.ProseMirror:not(.ProseMirror-focused) .ProseMirror-mark-boundary-cursor{display:none;}.ProseMirror:has(.ProseMirror-hide-cursor){caret-color:transparent;}"
};


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled




const $332bd83257b23222$export$99cdf122d0bb9f95 = {
    DATE_WRAPPER: `date-lozenger-container`,
    DATE_CONTAINER: 'dateView-content-wrap'
};
const $332bd83257b23222$export$b89fadc5134d50fa = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`[data-prosemirror-node-name='date'] .${$332bd83257b23222$export$99cdf122d0bb9f95.DATE_WRAPPER} span`]: {
        backgroundColor: "var(--ds-background-neutral, #0515240F)",
        color: "var(--ds-text, #292A2E)",
        borderRadius: "var(--ds-radius-small, 4px)",
        padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-050, 4px)"}`,
        margin: '0 1px',
        position: 'relative',
        transition: 'background 0.3s',
        whiteSpace: 'nowrap',
        cursor: 'unset'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`[data-prosemirror-node-name='date'] .${$332bd83257b23222$export$99cdf122d0bb9f95.DATE_WRAPPER} span:hover`]: {
        backgroundColor: "var(--ds-background-neutral-hovered, #0B120E24)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`[data-prosemirror-node-name='date'] .${$332bd83257b23222$export$99cdf122d0bb9f95.DATE_WRAPPER} span.date-node-color-red`]: {
        backgroundColor: "var(--ds-background-accent-red-subtlest, #FFECEB)",
        color: "var(--ds-text-accent-red, #AE2E24)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`[data-prosemirror-node-name='date'] .${$332bd83257b23222$export$99cdf122d0bb9f95.DATE_WRAPPER} span.date-node-color-red:hover`]: {
        backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)"
    }
});
const $332bd83257b23222$export$37579fbc35dcc1a9 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$332bd83257b23222$export$99cdf122d0bb9f95.DATE_WRAPPER} span`]: {
        whiteSpace: 'unset'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$332bd83257b23222$export$99cdf122d0bb9f95.DATE_CONTAINER}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$332bd83257b23222$export$99cdf122d0bb9f95.DATE_WRAPPER}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: 'initial',
            cursor: 'pointer'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.ak-editor-selected-node': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$332bd83257b23222$export$99cdf122d0bb9f95.DATE_WRAPPER} > span`]: [
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $65bb5c5a687b3665$export$a716852a0c5e54d5)
            ]
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.danger': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$332bd83257b23222$export$99cdf122d0bb9f95.DATE_CONTAINER}.ak-editor-selected-node .${$332bd83257b23222$export$99cdf122d0bb9f95.DATE_WRAPPER} > span`]: {
            boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`
        }
    }
});
const $332bd83257b23222$export$f9f3f08b750aaa7d = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$332bd83257b23222$export$99cdf122d0bb9f95.DATE_CONTAINER}.ak-editor-selected-node.danger .${$332bd83257b23222$export$99cdf122d0bb9f95.DATE_WRAPPER} > span`]: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [
        (0, $65bb5c5a687b3665$export$57f48b634c3a2512)
    ]
});


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
function $8c084c7e0576e8c1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8c084c7e0576e8c1$export$87e0522332cd3719 = {
    name: "u5gvmr",
    styles: "--editor-font-ugc-token-heading-h1:normal 500 1.71429em/1.16667 ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-heading-h2:normal 500 1.42857em/1.2 ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-heading-h3:normal 600 1.14286em/1.25 ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-heading-h4:normal 600 1em/1.14286 ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-heading-h5:normal 600 0.857143em/1.33333 ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-heading-h6:normal 700 0.785714em/1.45455 ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-body:normal 400 1em/1.714 ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-weight-heading-bold:700"
};
const $8c084c7e0576e8c1$export$95588e746468319e = {
    name: "14r7dlz",
    styles: "--editor-font-ugc-token-heading-h1:normal 600 1.71429em/1.16667 ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-heading-h2:normal 600 1.42857em/1.2 ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-heading-h3:normal 600 1.14286em/1.25 ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-heading-h4:normal 600  1em/1.14286 ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-heading-h5:normal 600  0.857143em/1.33333 ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-heading-h6:normal 600 0.785714em/1.45455 ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-body:normal 400 1em/1.714 ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-weight-heading-bold:700"
};
const $8c084c7e0576e8c1$export$63adc0ebe3278d31 = {
    name: "1maftdw",
    styles: "--editor-font-ugc-token-heading-h1:normal 600 1.71429em/1.16667 \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-heading-h2:normal 600 1.42857em/1.2 \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-heading-h3:normal 600 1.14286em/1.25 \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-heading-h4:normal 600 1em/1.14286 \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-heading-h5:normal 600 0.857143em/1.33333 \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-heading-h6:normal 600 0.785714em/1.45455 \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-body:normal 400 1em/1.714 \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-weight-heading-bold:700"
};


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
function $92bd659d1ad36350$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $92bd659d1ad36350$export$5a1f57c6600b90f1 = {
    name: "1tw1dm8",
    styles: ".ProseMirror{.embedCardView-content-wrap[layout^='wrap-']{max-width:100%;position:relative;z-index:2;}.embedCardView-content-wrap[layout='wrap-left']{float:left;}.embedCardView-content-wrap[layout='wrap-right']{float:right;}.embedCardView-content-wrap[layout='wrap-right'] + .embedCardView-content-wrap[layout='wrap-left']{clear:both;}}"
};


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled




var $fhsiz = parcelRequire("fhsiz");

var $98HrB = parcelRequire("98HrB");





function $64073fed169900b9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $64073fed169900b9$var$emojiSelectionStyles = {
    name: "1h3rhjl",
    styles: "border-radius:var(--ds-radius-xsmall, 2px)"
};
const $64073fed169900b9$export$d73b97ac20f33f4 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.ProseMirror .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_CONTAINER}`]: {
        display: 'inline-block'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.ProseMirror :is(.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE})`]: {
        background: 'no-repeat transparent',
        display: 'inline-block',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        height: `${(0, $fhsiz.defaultEmojiHeight)}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        maxHeight: `${(0, $fhsiz.defaultEmojiHeight)}px`,
        cursor: 'pointer',
        verticalAlign: 'middle',
        userSelect: 'all'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.ProseMirror .${0, $aFUXX.akEditorSelectedNodeClassName}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE}`]: [
            $64073fed169900b9$var$emojiSelectionStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$e7c1f2908e268236),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a716852a0c5e54d5)
        ]
    }
});
/**
 * Gets dynamic emoji styles that scale emoji size based on the base font size.
 * This allows emojis to scale proportionally when the base font size changes.
 * @param baseFontSize - The base font size in pixels (e.g., 16 for default, 13 for dense mode)
 * @returns SerializedStyles with emoji size overrides if baseFontSize is provided and different from default.
 */ var $64073fed169900b9$var$_ref = {
    name: "0",
    styles: ""
};
const $64073fed169900b9$export$2a2707475ad11d76 = (baseFontSize)=>{
    if (!baseFontSize || baseFontSize === (0, $aFUXX.akEditorFullPageDefaultFontSize)) return $64073fed169900b9$var$_ref;
    // Calculate emoji size based on base font size
    // Default: 20px emoji at 16px base font
    // Scaled: 20px * (baseFontSize/16)
    // E.g., dense mode (13px base): 20px * (13/16) = 16.25px
    const emojiSize = (0, $fhsiz.defaultEmojiHeight) * baseFontSize / (0, $aFUXX.akEditorFullPageDefaultFontSize);
    return /*#__PURE__*/ (0, $9K4OG.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`.ProseMirror :is(.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE})`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            width: emojiSize,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            height: emojiSize,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            maxHeight: emojiSize,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            img: {
                width: '100%',
                height: '100%',
                objectFit: 'contain'
            }
        },
        // Scale panel icon in dense mode
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ProseMirror .ak-editor-panel .ak-editor-panel__icon': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            height: "var(--ds-space-250, 20px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            width: "var(--ds-space-250, 20px)"
        }
    });
};
const $64073fed169900b9$export$df03c70a9b9671c1 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.ProseMirror .${0, $aFUXX.akEditorSelectedNodeClassName}.danger`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE}`]: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            [
                (0, $65bb5c5a687b3665$export$57f48b634c3a2512),
                (0, $65bb5c5a687b3665$export$fd4ac125b4ba4c28)
            ]
        ]
    }
});


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled






function $35750f0b594d4ce9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $35750f0b594d4ce9$export$4bb28258452e3b9a = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ak-editor-expand__icon > div': {
        display: 'flex'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ak-editor-expand': {
        // sharedExpandStyles.containerStyles({ expanded: false, focused: false })(),
        borderWidth: "var(--ds-border-width, 1px)",
        borderStyle: 'solid',
        borderColor: 'transparent',
        borderRadius: "var(--ds-radius-small, 4px)",
        minHeight: '25px',
        background: "var(--ds-background-neutral-subtle, transparent)",
        margin: `${"var(--ds-space-050, 0.25rem)"} 0 0`,
        transition: 'background 0.3s cubic-bezier(0.15, 1, 0.3, 1), border-color 0.3s cubic-bezier(0.15, 1, 0.3, 1)',
        padding: "var(--ds-space-100, 8px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        'td > :not(style):first-child, td > style:first-child + *': {
            marginTop: 0
        },
        cursor: 'pointer',
        boxSizing: 'border-box',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        'td > &': {
            marginTop: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-expand__icon-container svg': {
            color: "var(--ds-icon-subtle, #505258)",
            transform: 'rotate(90deg)'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&.ak-editor-selected-node:not(.danger)': {
            // SelectionStyle.Blanket
            position: 'relative',
            // Fixes ED-9263, where emoji or inline card in panel makes selection go outside the panel
            // in Safari. Looks like it's caused by user-select: all in the emoji element
            WebkitUserSelect: 'text',
            '&::before': {
                position: 'absolute',
                content: "''",
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                width: '100%',
                pointerEvents: 'none',
                zIndex: 12,
                // akEditorStickyheaderZIndex (11) + 1
                backgroundColor: "var(--ds-blanket-selected, #388BFF14)"
            },
            // SelectionStyle.Border (common case)
            border: `1px solid ${"var(--ds-border-selected, #1868DB)"}`,
            // If fg('platform_editor_nested_dnd_styles_changes') is true,
            // then we'll also need the rest of the selection styles for blanket
            // hideNativeBrowserTextSelectionStyles
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&::selection, *::selection': {
                backgroundColor: 'transparent'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&::-moz-selection, *::-moz-selection': {
                backgroundColor: 'transparent'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger': {
            background: "var(--ds-background-danger, #FFECEB)",
            borderColor: "var(--ds-border-danger, #E2483D)"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror > .ak-editor-expand__type-expand, .fabric-editor-breakout-mark-dom > .ak-editor-expand__type-expand': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginLeft: '-12px',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginRight: '-12px'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ak-editor-expand__content': {
        // sharedExpandStyles.contentStyles({ expanded: false, focused: false })(),
        paddingTop: "var(--ds-space-0, 0px)",
        paddingRight: "var(--ds-space-100, 8px)",
        paddingLeft: "var(--ds-space-300, 24px)",
        marginLeft: "var(--ds-space-050, 4px)",
        display: 'flow-root',
        /* The follow rules inside @supports block are added as a part of ED-8893
    	The fix is targeting mobile bridge on iOS 12 or below,
    	We should consider remove this fix when we no longer support iOS 12 */ '@supports not (display: flow-root)': {
            width: '100%',
            boxSizing: 'border-box'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.expand-content-wrapper, .nestedExpand-content-wrapper': {
            /* We visually hide the content here to preserve the content during copy+paste */ /* Do not add text nowrap here because inline comment navigation depends on the location of the text */ width: '100%',
            display: 'block',
            height: 0,
            overflow: 'hidden',
            clip: 'rect(1px, 1px, 1px, 1px)',
            userSelect: 'none'
        },
        cursor: 'text'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ak-editor-expand__title-input': {
        // sharedExpandStyles.titleInputStyles(),
        outline: 'none',
        border: 'none',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 'calc(14rem / 16)',
        // relativeFontSizeToBase16(14),
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 1.714,
        // If fg('platform-visual-refresh-icons') then this needs to be overridden
        fontWeight: "var(--ds-font-weight-regular, 400)",
        color: "var(--ds-text-subtlest, #6B6E76)",
        background: 'transparent',
        display: 'flex',
        flex: 1,
        padding: `0 0 0 ${"var(--ds-space-050, 4px)"}`,
        width: '100%',
        '&::placeholder': {
            opacity: 1,
            color: "var(--ds-text-subtlest, #6B6E76)"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ak-editor-expand__title-container': {
        // sharedExpandStyles.titleContainerStyles(),
        padding: 0,
        display: 'flex',
        // Omitting alignItems: 'flex-start' as it would be overridden
        background: 'none',
        border: 'none',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 'calc(14rem / 16)',
        // relativeFontSizeToBase16(14),
        width: '100%',
        color: "var(--ds-text-subtle, #505258)",
        // Omitting overflow: 'hidden' as it would be overridden
        cursor: 'pointer',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&:focus': {
            outline: 0
        },
        alignItems: 'center',
        overflow: 'visible'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ak-editor-expand__icon-button': {
        appearance: 'none',
        width: "var(--ds-space-300, 24px)",
        height: "var(--ds-space-300, 24px)",
        border: 'none',
        borderRadius: "var(--ds-radius-small, 4px)",
        background: "var(--ds-background-neutral-subtle, #00000000)",
        padding: 0,
        margin: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        '&:disabled': {
            cursor: 'not-allowed'
        },
        '&:focus-visible': {
            outline: `2px solid ${"var(--ds-border-focused, #4688EC)"}`,
            outlineOffset: "var(--ds-space-025, 2px)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:hover:not(:disabled)': {
            background: "var(--ds-background-neutral-subtle-hovered, #0515240F)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-expand__icon-svg': {
            color: "var(--ds-icon-subtle, #505258)",
            transform: 'rotate(0deg)',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
            transition: `transform 0.2s ${(0, $aFUXX.akEditorSwoopCubicBezier)};`
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ak-editor-expand__expanded': {
        background: "var(--ds-background-neutral-subtle, #00000000)",
        borderColor: "var(--ds-border, #0B120E24)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-expand__content': {
            paddingTop: "var(--ds-space-100, 8px)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-expand__icon-button': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.ak-editor-expand__icon-svg': {
                transform: 'rotate(90deg)'
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ak-editor-expand__input-container': {
        width: '100%'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.ak-editor-expand:not(.ak-editor-expand__expanded)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-expand__content': {
            position: 'absolute',
            height: '1px',
            width: '1px',
            overflow: 'hidden',
            clip: 'rect(1px, 1px, 1px, 1px)',
            whiteSpace: 'nowrap'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-expand__icon-container svg': {
            color: "var(--ds-icon-subtle, #505258)",
            transform: 'rotate(0deg)'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:not(.ak-editor-selected-node):not(.danger)': {
            background: 'transparent',
            borderColor: 'transparent',
            '&:hover': {
                borderColor: "var(--ds-border, #0B120E24)",
                background: "var(--ds-background-neutral-subtle, #00000000)"
            }
        }
    }
});
/**
 * This function gets the dynamic styles that scale the expand title font size based on the base font size.
 * If the base font size is not the default font size, we want the expand title font size to match the base font size.
 * @param baseFontSize - The base font size in pixels. (e.g., 16 for default, 13 for dense mode)
 * @returns SerializedStyles with expand title font size override if baseFontSize is provided and different from default.
 */ var $35750f0b594d4ce9$var$_ref = {
    name: "0",
    styles: ""
};
const $35750f0b594d4ce9$export$9f08fc5d3959d07e = (baseFontSize)=>{
    if (!baseFontSize || baseFontSize === (0, $aFUXX.akEditorFullPageDefaultFontSize)) return $35750f0b594d4ce9$var$_ref;
    return /*#__PURE__*/ (0, $9K4OG.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-expand__title-input': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography, @atlaskit/ui-styling-standard/no-unsafe-values
            fontSize: `${baseFontSize}px`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-expand__title-container': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography, @atlaskit/ui-styling-standard/no-unsafe-values
            fontSize: `${baseFontSize}px`
        }
    });
};
const $35750f0b594d4ce9$export$20843fd014d7530c = {
    name: "1izbe44",
    styles: ".ak-editor-expand__title-input{line-height:1;}"
};
const $35750f0b594d4ce9$export$26d7f96b2bb98b5b = {
    name: "b2r3jw",
    styles: ".ak-editor-content-area.appearance-full-page .ProseMirror > .ak-editor-expand__type-expand, .fabric-editor-breakout-mark-dom > .ak-editor-expand__type-expand{margin-left:-20px;margin-right:-20px;}.ak-editor-expand__expanded{.ak-editor-expand__content{> :nth-child(1 of :not(style, .ProseMirror-gapcursor, .ProseMirror-widget, span)){margin-top:0;}> div.ak-editor-expand[data-node-type=\"nestedExpand\"]{margin-top:var(--ds-space-050, 0.25rem);}}}"
};
const $35750f0b594d4ce9$export$4dd1b2c2505a38a = {
    name: "yqkk6p",
    styles: ".ak-editor-expand{&.ak-editor-selected-node:not(.danger){&::after{height:100%;content:'\\00a0';background:var(--ds-border-selected, #1868DB);position:absolute;right:-1px;top:0;bottom:0;width:1px;border:none;display:inline-block;}}}"
};


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled













function $91793a38cb990edb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Creates the extension styles with the ability to use feature flags and experiments.
 * @returns Complete SerializedStyles including base styles and any feature-gated styles
 */ var $91793a38cb990edb$var$_ref = {
    name: "0",
    styles: ""
};
var $91793a38cb990edb$var$_ref2 = {
    name: "pwxs72",
    styles: ".extension-container [data-macro-name=\"toc\"] * :not(.status-lozenge-span *){font-size:var(--ak-editor-base-font-size);}.extension-container .ak-excerpt-include :not([data-inline-card-lozenge] *, code, .status-lozenge-span *, .code-block *){font-size:var(--ak-editor-base-font-size);}"
};
const $91793a38cb990edb$export$9abdb593a2600bc6 = (contentMode)=>{
    const baseExtensionStyles = /*#__PURE__*/ (0, $9K4OG.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.multiBodiedExtensionView-content-wrap': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger > span > .multiBodiedExtension--container': {
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`,
                backgroundColor: "var(--ds-background-danger, #FFECEB)"
            },
            // ...extensionLabelStyles
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger > span > div > .extension-label': {
                backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
                color: "var(--ds-text-danger, #AE2E24)",
                opacity: 1,
                boxShadow: 'none'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not(.danger).ak-editor-selected-node > span > div > .extension-label': {
                backgroundColor: "var(--ds-background-selected, #E9F2FE)",
                color: "var(--ds-text-selected, #1868DB)",
                opacity: 1,
                boxShadow: 'none'
            },
            /* Targets the icon for bodied macro styling in button label */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger > span > div > .extension-label > span': {
                display: 'inline'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not(.danger).ak-editor-selected-node > span > div .extension-label > span': {
                display: 'inline'
            },
            /* Start of bodied extension edit toggle styles */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger.ak-editor-selected-node > span > .extension-edit-toggle-container': {
                opacity: 1
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not(.danger).ak-editor-selected-node > span > .extension-edit-toggle-container': {
                opacity: 1
            },
            /* In view mode of the bodied macro, we never want to show the extension label */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger.ak-editor-selected-node > span > div > .extension-label.always-hide-label': {
                opacity: 0
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not(.danger).ak-editor-selected-node > span > div > .extension-label.always-hide-label': {
                opacity: 0
            },
            /* .with-bodied-macro-live-page-styles class will only be added to bodied macros with the renderer mode gate enabled */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not(.danger).ak-editor-selected-node > span > div > .extension-label.with-bodied-macro-live-page-styles': {
                boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #1868DB)"}`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger.ak-editor-selected-node > span > div > .extension-label.with-bodied-macro-live-page-styles': {
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger.ak-editor-selected-node > span > .extension-edit-toggle-container > .extension-edit-toggle': {
                backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
                color: "var(--ds-text-danger, #AE2E24)",
                boxShadow: 'none'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&.danger > span > .with-danger-overlay': {
                backgroundColor: 'transparent',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '.multiBodiedExtension--overlay': {
                    // ...dangerOverlayStyles
                    opacity: 0.3,
                    backgroundColor: "var(--ds-background-danger-hovered, #FFD5D2)"
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not(.danger).ak-editor-selected-node': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
                '& > span > .multiBodiedExtension--container': [
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0),
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    (0, $65bb5c5a687b3665$export$e7c1f2908e268236),
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    (0, $65bb5c5a687b3665$export$a716852a0c5e54d5)
                ]
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.multiBodiedExtension--container': {
                width: '100%',
                maxWidth: '100%' // ensure width can't go over 100%
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.inlineExtensionView-content-wrap': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger > span > .extension-container': {
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`,
                backgroundColor: "var(--ds-background-danger, #FFECEB)"
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger > span > .with-danger-overlay': {
                /* If the macro turned used to red before, not setting the background to be transparent will cause the
        danger state to have two layers of red which we don't want. */ backgroundColor: 'transparent',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '.extension-overlay': {
                    // ...dangerOverlayStyles
                    opacity: 0.3,
                    backgroundColor: "var(--ds-background-danger-hovered, #FFD5D2)"
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not(.danger).ak-editor-selected-node': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
                '& > span > .extension-container': [
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0),
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    (0, $65bb5c5a687b3665$export$a716852a0c5e54d5)
                ]
            },
            // ...extensionLabelStyles
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger > span > div > .extension-label': {
                backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
                color: "var(--ds-text-danger, #AE2E24)",
                opacity: 1,
                boxShadow: 'none'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not(.danger).ak-editor-selected-node > span > div > .extension-label': {
                backgroundColor: "var(--ds-background-selected, #E9F2FE)",
                color: "var(--ds-text-selected, #1868DB)",
                opacity: 1,
                boxShadow: 'none'
            },
            /* Targets the icon for bodied macro styling in button label */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger > span > div > .extension-label > span': {
                display: 'inline'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not(.danger).ak-editor-selected-node > span > div .extension-label > span': {
                display: 'inline'
            },
            /* Start of bodied extension edit toggle styles */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger.ak-editor-selected-node > span > .extension-edit-toggle-container': {
                opacity: 1
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not(.danger).ak-editor-selected-node > span > .extension-edit-toggle-container': {
                opacity: 1
            },
            /* In view mode of the bodied macro, we never want to show the extension label */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger.ak-editor-selected-node > span > div > .extension-label.always-hide-label': {
                opacity: 0
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not(.danger).ak-editor-selected-node > span > div > .extension-label.always-hide-label': {
                opacity: 0
            },
            /* .with-bodied-macro-live-page-styles class will only be added to bodied macros with the renderer mode gate enabled */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not(.danger).ak-editor-selected-node > span > div > .extension-label.with-bodied-macro-live-page-styles': {
                boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #1868DB)"}`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger.ak-editor-selected-node > span > div > .extension-label.with-bodied-macro-live-page-styles': {
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger.ak-editor-selected-node > span > .extension-edit-toggle-container > .extension-edit-toggle': {
                backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
                color: "var(--ds-text-danger, #AE2E24)",
                boxShadow: 'none'
            }
        },
        /* This is referenced in the toDOM of a bodied extension and is used to put
    label content into the bodied extension.
    We do this so that we don't serialise the label (which causes the label to be
    copied to the clipboard causing copy-paste issues). */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.bodied-extension-to-dom-label::after': {
            content: 'attr(data-bodied-extension-label)'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.extensionView-content-wrap, .multiBodiedExtensionView-content-wrap, .bodiedExtensionView-content-wrap': {
            margin: `0.75rem 0`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:first-of-type': {
                marginTop: 0
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:last-of-type': {
                marginBottom: 0
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not(.danger).ak-editor-selected-node': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
                '& > span > .extension-container': [
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0),
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    (0, $65bb5c5a687b3665$export$a716852a0c5e54d5)
                ]
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger > span > .extension-container': {
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`,
                backgroundColor: "var(--ds-background-danger, #FFECEB)"
            },
            // ...extensionLabelStyles
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger > span > div > .extension-label': {
                backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
                color: "var(--ds-text-danger, #AE2E24)",
                opacity: 1,
                boxShadow: 'none'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not(.danger).ak-editor-selected-node > span > div > .extension-label': {
                backgroundColor: "var(--ds-background-selected, #E9F2FE)",
                color: "var(--ds-text-selected, #1868DB)",
                opacity: 1,
                boxShadow: 'none'
            },
            /* Targets the icon for bodied macro styling in button label */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger > span > div > .extension-label > span': {
                display: 'inline'
            },
            /** Targets legacy content header in LCM extension */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger > span > .legacy-content-header': {
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`,
                backgroundColor: `${"var(--ds-background-danger, #FFECEB)"}`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '& .status-lozenge-span > span': {
                    backgroundColor: `${"var(--ds-background-accent-red-subtle-hovered, #FD9891)"}`
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not(.danger).ak-editor-selected-node > span > div .extension-label > span': {
                display: 'inline'
            },
            /* Start of bodied extension edit toggle styles */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger.ak-editor-selected-node > span > .extension-edit-toggle-container': {
                opacity: 1
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not(.danger).ak-editor-selected-node > span > .extension-edit-toggle-container': {
                opacity: 1
            },
            /* In view mode of the bodied macro, we never want to show the extension label */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger.ak-editor-selected-node > span > div > .extension-label.always-hide-label': {
                opacity: 0
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not(.danger).ak-editor-selected-node > span > div > .extension-label.always-hide-label': {
                opacity: 0
            },
            /* .with-bodied-macro-live-page-styles class will only be added to bodied macros with the renderer mode gate enabled */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not(.danger).ak-editor-selected-node > span > div > .extension-label.with-bodied-macro-live-page-styles': {
                boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #1868DB)"}`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger.ak-editor-selected-node > span > div > .extension-label.with-bodied-macro-live-page-styles': {
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger.ak-editor-selected-node > span > .extension-edit-toggle-container > .extension-edit-toggle': {
                backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
                color: "var(--ds-text-danger, #AE2E24)",
                boxShadow: 'none'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&.danger > span > .with-danger-overlay': {
                backgroundColor: 'transparent',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '.extension-overlay': {
                    // ...dangerOverlayStyles
                    opacity: 0.3,
                    backgroundColor: "var(--ds-background-danger-hovered, #FFD5D2)"
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.inline': {
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.extensionView-content-wrap .extension-container': {
            overflow: 'hidden',
            /* Don't hide overflow for editors inside extensions. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:has(.extension-editable-area)': {
                overflow: 'visible'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.bodiedExtensionView-content-wrap .extensionView-content-wrap .extension-container': {
            width: '100%',
            maxWidth: '100%' // ensure width can't go over 100%
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "[data-mark-type='fragment']": {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '& > .extensionView-content-wrap, & > .bodiedExtensionView-content-wrap': {
                margin: '0.75rem 0'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            "& > [data-mark-type='dataConsumer']": {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '& > .extensionView-content-wrap, & > .bodiedExtensionView-content-wrap': {
                    margin: '0.75rem 0'
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:first-child': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '& > .extensionView-content-wrap, & > .bodiedExtensionView-content-wrap': {
                    marginTop: 0
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                "& > [data-mark-type='dataConsumer']": {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                    '& > .extensionView-content-wrap, & > .bodiedExtensionView-content-wrap': {
                        marginTop: 0
                    }
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:nth-last-of-type(-n + 2):not(:first-of-type)': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '& > .extensionView-content-wrap, & > .bodiedExtensionView-content-wrap': {
                    marginBottom: 0
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                "& > [data-mark-type='dataConsumer']": {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                    '& > .extensionView-content-wrap, & > .bodiedExtensionView-content-wrap': {
                        marginBottom: 0
                    }
                }
            }
        }
    });
    // Dense content mode extensions styling fix - addresses EDITOR-1992
    // When cleaning up the experiment, move this logic into the baseExtensionStyles above
    const fontSize = (0, $1oCLl.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') ? (0, $aFUXX.relativeFontSizeToBase16)((0, $aFUXX.akEditorFullPageDenseFontSize)) : undefined;
    const denseExtensionStyles = (contentMode === 'compact' || contentMode === 'dense') && (0, $1oCLl.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $dh538.fg)('platform_editor_content_mode_button_mvp') ? $91793a38cb990edb$var$_ref2 : (contentMode === 'compact' || contentMode === 'dense') && (0, $1oCLl.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') ? /*#__PURE__*/ (0, $9K4OG.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.extension-container a span': {
            fontSize: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            fontSize
        }
    }) : $91793a38cb990edb$var$_ref;
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    return /*#__PURE__*/ (0, $9K4OG.css)(baseExtensionStyles, denseExtensionStyles);
};


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled




var $5MaNT = parcelRequire("5MaNT");

const $19957a194e4b6622$export$c5ceb9c726010930 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match': {
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
        borderRadius: "var(--ds-radius-small, 3px)",
        backgroundColor: "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
        boxShadow: `${"var(--ds-shadow-raised, 0 1px 1px 0 rgba(9, 30, 66, 0.25), 0 0 1px 0 rgba(9, 30, 66, 0.31))"}, inset 0 0 0 1px ${"var(--ds-border-input, #8C8F97)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.selected-search-match': {
        backgroundColor: "var(--ds-background-accent-teal-subtle, #6CC3E0)"
    }
});
const $19957a194e4b6622$export$a5471dc947aff188 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.${(0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER} .search-match.selected-search-match`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        span: {
            // we need to use !important here as we need to override inline selection styles
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            color: `${"var(--ds-text, #292A2E)"} !important`
        }
    }
});
const $19957a194e4b6622$export$fae24dca059c5 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.${(0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER} .search-match-text.selected-search-match`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        span: {
            // we need to use !important here as we need to override inline selection styles
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            color: `${"var(--ds-text, #292A2E)"} !important`
        }
    }
});
const $19957a194e4b6622$export$f6e8277f5198ab7b = /*#__PURE__*/ (0, $9K4OG.css)({
    /** Text match styles */ /** Light mode */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-text': {
        borderRadius: "var(--ds-space-050, 4px)",
        boxShadow: `
		inset 0 0 0 1px ${"var(--ds-background-accent-magenta-subtler-pressed, #F797D2)"},
		inset 0 0 0 5px ${"var(--ds-background-accent-magenta-subtler, #FDD0EC)"}
		`,
        // we need to use !important here as we need to override inline selection styles
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        backgroundColor: `${"var(--ds-background-accent-magenta-subtler, #FDD0EC)"} !important`,
        color: "var(--ds-text, #292A2E)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-text.selected-search-match': {
        boxShadow: `
		inset 0 0 0 1px ${"var(--ds-background-accent-magenta-subtler-pressed, #F797D2)"},
		inset 0 0 0 5px ${"var(--ds-background-accent-magenta-subtlest-pressed, #FCB6E1)"}
		`,
        // we need to use !important here as we need to override inline selection styles
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        backgroundColor: `${"var(--ds-background-accent-magenta-subtlest-pressed, #FCB6E1)"} !important`
    },
    /** Dark mode */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-text.search-match-dark': {
        boxShadow: `
		inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"},
		inset 0 0 0 5px ${"var(--ds-background-accent-magenta-bolder-pressed, #77325B)"}
		`,
        // we need to use !important here as we need to override inline selection styles
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        backgroundColor: `${"var(--ds-background-accent-magenta-bolder-pressed, #77325B)"} !important`,
        color: "var(--ds-text-inverse, #FFFFFF)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-text.selected-search-match.search-match-dark': {
        boxShadow: `
		inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"},
		inset 0 0 0 5px ${"var(--ds-background-accent-magenta-bolder-hovered, #943D73)"}
		`,
        // we need to use !important here as we need to override inline selection styles
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        backgroundColor: `${"var(--ds-background-accent-magenta-bolder-hovered, #943D73)"} !important`
    },
    /** Block match styles */ /** Light mode */ /** Without node selection */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-block': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-smart-link-container="true"], .loader-wrapper>div::after': {
            boxShadow: `
			inset 0 0 0 1px ${"var(--ds-background-accent-magenta-subtler-pressed, #F797D2)"},
			inset 0 0 0 5px ${"var(--ds-background-accent-magenta-subtler, #FDD0EC)"}
			`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.loader-wrapper>a, .hover-card-trigger-wrapper>a, .lozenge-wrapper, .editor-mention-primitive, .date-lozenger-container>span': {
            boxShadow: `0px 0px 0px 4px ${"var(--ds-background-accent-magenta-subtler, #FDD0EC)"}, 0px 0px 0px 5px ${"var(--ds-background-accent-magenta-subtler-pressed, #F797D2)"}`
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-block.search-match-block-selected': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-smart-link-container="true"], .loader-wrapper>div::after': {
            boxShadow: `
			inset 0 0 0 1px ${"var(--ds-background-accent-magenta-subtler-pressed, #F797D2)"},
			inset 0 0 0 4px ${"var(--ds-background-accent-magenta-subtlest-pressed, #FCB6E1)"}
			`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.loader-wrapper>a, .hover-card-trigger-wrapper>a, .lozenge-wrapper, .editor-mention-primitive, .date-lozenger-container>span': {
            boxShadow: `0px 0px 0px 4px ${"var(--ds-background-accent-magenta-subtlest-pressed, #FCB6E1)"}, 0px 0px 0px 5px ${"var(--ds-background-accent-magenta-subtler-pressed, #F797D2)"}`
        }
    },
    /** With node selection */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-block.ak-editor-selected-node': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.loader-wrapper>div::after': {
            boxShadow: `
			inset 0 0 0 1px ${"var(--ds-background-accent-magenta-subtler-pressed, #F797D2)"},
			inset 0 0 0 5px ${"var(--ds-background-accent-magenta-subtler, #FDD0EC)"},
			0 0 0 1px ${"var(--ds-border-selected, #1868DB)"}
			`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.loader-wrapper>a, .hover-card-trigger-wrapper>a, .lozenge-wrapper, .editor-mention-primitive, .date-lozenger-container>span': {
            boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #1868DB)"}, 0px 0px 0px 4px ${"var(--ds-background-accent-magenta-subtler, #FDD0EC)"}, 0px 0px 0px 5px ${"var(--ds-background-accent-magenta-subtler-pressed, #F797D2)"}`
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-block.search-match-block-selected.ak-editor-selected-node': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-smart-link-container="true"], .loader-wrapper>div::after': {
            boxShadow: `
			inset 0 0 0 1px ${"var(--ds-background-accent-magenta-subtler-pressed, #F797D2)"},
			inset 0 0 0 4px ${"var(--ds-background-accent-magenta-subtlest-pressed, #FCB6E1)"},
			0 0 0 1px ${"var(--ds-border-selected, #1868DB)"}
			`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.loader-wrapper>a, .hover-card-trigger-wrapper>a, .lozenge-wrapper, .editor-mention-primitive, .date-lozenger-container>span': {
            boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #1868DB)"}, 0px 0px 0px 4px ${"var(--ds-background-accent-magenta-subtlest-pressed, #FCB6E1)"}, 0px 0px 0px 5px ${"var(--ds-background-accent-magenta-subtler-pressed, #F797D2)"}`
        }
    },
    /** Dark mode */ /** Without node selection */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-block.search-match-dark': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-smart-link-container="true"], .loader-wrapper>div::after': {
            boxShadow: `
			inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"},
			inset 0 0 0 5px ${"var(--ds-background-accent-magenta-bolder-pressed, #77325B)"}
			`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.loader-wrapper>a, .hover-card-trigger-wrapper>a, .lozenge-wrapper, .editor-mention-primitive, .date-lozenger-container>span': {
            boxShadow: `0px 0px 0px 4px ${"var(--ds-background-accent-magenta-bolder-pressed, #77325B)"}, 0px 0px 0px 5px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"}`
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-block.search-match-block-selected.search-match-dark': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-smart-link-container="true"], .loader-wrapper>div::after': {
            boxShadow: `
			inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"},
			inset 0 0 0 4px ${"var(--ds-background-accent-magenta-bolder-hovered, #943D73)"}
			`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.loader-wrapper>a, .hover-card-trigger-wrapper>a, .lozenge-wrapper, .editor-mention-primitive, .date-lozenger-container>span': {
            boxShadow: `0px 0px 0px 4px ${"var(--ds-background-accent-magenta-bolder-hovered, #943D73)"}, 0px 0px 0px 5px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"}`
        }
    },
    /** With node selection */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-block.search-match-dark.ak-editor-selected-node': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.loader-wrapper>div::after': {
            boxShadow: `
			inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"},
			inset 0 0 0 5px ${"var(--ds-background-accent-magenta-bolder-pressed, #77325B)"},
			0 0 0 1px ${"var(--ds-border-selected, #1868DB)"}
			`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.loader-wrapper>a, .hover-card-trigger-wrapper>a, .lozenge-wrapper, .editor-mention-primitive, .date-lozenger-container>span': {
            boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #1868DB)"}, 0px 0px 0px 4px ${"var(--ds-background-accent-magenta-bolder-pressed, #77325B)"}, 0px 0px 0px 5px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"}`
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-block.search-match-block-selected.search-match-dark.ak-editor-selected-node': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-smart-link-container="true"], .loader-wrapper>div::after': {
            boxShadow: `
			inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"},
			inset 0 0 0 4px ${"var(--ds-background-accent-magenta-bolder-hovered, #943D73)"},
			0 0 0 1px ${"var(--ds-border-selected, #1868DB)"}
			`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.loader-wrapper>a, .hover-card-trigger-wrapper>a, .lozenge-wrapper, .editor-mention-primitive, .date-lozenger-container>span': {
            boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #1868DB)"}, 0px 0px 0px 4px ${"var(--ds-background-accent-magenta-bolder-hovered, #943D73)"}, 0px 0px 0px 5px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"}`
        }
    },
    /** Expand title match styles */ /** Light mode */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-expand-title > .ak-editor-expand__title-container > .ak-editor-expand__input-container': {
        borderRadius: "var(--ds-space-050, 4px)",
        boxShadow: `
		inset 0 0 0 1px ${"var(--ds-background-accent-magenta-subtler-pressed, #F797D2)"},
		inset 0 0 0 5px ${"var(--ds-background-accent-magenta-subtler, #FDD0EC)"}
		`,
        backgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-expand__title-input': {
            color: "var(--ds-text, #292A2E)"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-expand-title.selected-search-match > .ak-editor-expand__title-container > .ak-editor-expand__input-container': {
        boxShadow: `
		inset 0 0 0 1px ${"var(--ds-background-accent-magenta-subtler-pressed, #F797D2)"},
		inset 0 0 0 5px ${"var(--ds-background-accent-magenta-subtlest-pressed, #FCB6E1)"}
		`,
        backgroundColor: "var(--ds-background-accent-magenta-subtlest-pressed, #FCB6E1)"
    },
    /** Dark mode */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-expand-title.search-match-dark > .ak-editor-expand__title-container > .ak-editor-expand__input-container': {
        boxShadow: `
		inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"},
		inset 0 0 0 5px ${"var(--ds-background-accent-magenta-bolder-pressed, #77325B)"}
		`,
        backgroundColor: "var(--ds-background-accent-magenta-bolder-pressed, #77325B)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-expand__title-input': {
            color: "var(--ds-text-inverse, #FFFFFF)"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-expand-title.selected-search-match.search-match-dark > .ak-editor-expand__title-container > .ak-editor-expand__input-container': {
        boxShadow: `
		inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"},
		inset 0 0 0 5px ${"var(--ds-background-accent-magenta-bolder-hovered, #943D73)"}
		`,
        backgroundColor: "var(--ds-background-accent-magenta-bolder-hovered, #943D73)"
    }
});


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled




var $DoNsZ = parcelRequire("DoNsZ");


var $iMS6j = parcelRequire("iMS6j");

var $cV5SN = parcelRequire("cV5SN");


const $563563a54a51d8c3$export$2d6e8a1d666d4a60 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`> .${(0, $DoNsZ.PanelSharedCssClassName).prefix}, > .${(0, $1e5fdc47935572b3$export$42659c26f026f6ea).CODEBLOCK_CONTAINER}, > .${(0, $cV5SN.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER}, > div[data-task-list-local-id], > div[data-layout-section], > .${(0, $iMS6j.expandClassNames).prefix}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:first-child': {
                marginTop: 0
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
        '> hr:first-child, > .ProseMirror-widget:first-child + hr': {
            marginTop: 0
        }
    }
});


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled



const $b08ecd070af20ccb$export$f06cff4aa315bcf9 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    'button.first-floating-toolbar-button:focus': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        outline: `2px solid ${"var(--ds-border-focused, #4688EC)"}`
    }
});


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
function $8478647a8b452658$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8478647a8b452658$export$eb88bb4706d67f65 = {
    name: "1ro9jdo",
    styles: "flex-grow:1;height:100%;overflow-y:scroll;position:relative;display:flex;flex-direction:column;scroll-behavior:smooth"
};


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled



const $ba96bd4668ffc758$var$gapCursorBlink = (0, $9K4OG.keyframes)({
    'from, to': {
        opacity: 0
    },
    '50%': {
        opacity: 1
    }
});
const $ba96bd4668ffc758$export$8adc5edbc4a22166 = 'ProseMirror-hide-gapcursor';
const $ba96bd4668ffc758$var$gapCursorSelector = '.ProseMirror-gapcursor';
const $ba96bd4668ffc758$var$prosemirrorwidgetNotBlock = '.ProseMirror-widget:not([data-blocks-decoration-container="true"]):not([data-blocks-drag-handle-container="true"]):not([data-blocks-quick-insert-container="true"])';
const $ba96bd4668ffc758$var$wrapLeft = '[layout="wrap-left"]';
const $ba96bd4668ffc758$var$wrapRight = '[layout="wrap-right"]';
const $ba96bd4668ffc758$var$fixVerticalAlignmentSelector = `
	&:first-of-type + ul,
	&:first-of-type + span + ul,
	&:first-of-type + ol,
	&:first-of-type + span + ol,
	&:first-of-type + pre,
	&:first-of-type + span + pre,
	&:first-of-type + blockquote,
	&:first-of-type + span + blockquote
`;
const $ba96bd4668ffc758$var$twoImagesSideBySideFixSelector = `
  ${$ba96bd4668ffc758$var$gapCursorSelector}${$ba96bd4668ffc758$var$wrapLeft} + span + ${$ba96bd4668ffc758$var$wrapLeft},
  ${$ba96bd4668ffc758$var$gapCursorSelector}${$ba96bd4668ffc758$var$wrapRight} + span + ${$ba96bd4668ffc758$var$wrapRight},
  ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapLeft} + ${$ba96bd4668ffc758$var$wrapRight},
  ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapLeft} + span + ${$ba96bd4668ffc758$var$wrapRight},
  ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapRight} + ${$ba96bd4668ffc758$var$wrapLeft},
  ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapRight} + span + ${$ba96bd4668ffc758$var$wrapLeft},
  ${$ba96bd4668ffc758$var$wrapLeft} + ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapRight},
  ${$ba96bd4668ffc758$var$wrapLeft} + ${$ba96bd4668ffc758$var$gapCursorSelector} + span ${$ba96bd4668ffc758$var$wrapRight},
  ${$ba96bd4668ffc758$var$wrapRight} + ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapLeft},
  ${$ba96bd4668ffc758$var$wrapRight} + ${$ba96bd4668ffc758$var$gapCursorSelector} + span + ${$ba96bd4668ffc758$var$wrapLeft},
  ${$ba96bd4668ffc758$var$wrapLeft} + ${$ba96bd4668ffc758$var$gapCursorSelector}`;
const $ba96bd4668ffc758$var$marginFixSelector = `
  ${$ba96bd4668ffc758$var$wrapLeft} + ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapRight} > div,
  ${$ba96bd4668ffc758$var$wrapLeft} + ${$ba96bd4668ffc758$var$gapCursorSelector} + span + ${$ba96bd4668ffc758$var$wrapRight} > div,
  ${$ba96bd4668ffc758$var$wrapRight} + ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapLeft} > div,
  ${$ba96bd4668ffc758$var$wrapRight} + ${$ba96bd4668ffc758$var$gapCursorSelector} + span + ${$ba96bd4668ffc758$var$wrapLeft} > div,
  ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapRight} + ${$ba96bd4668ffc758$var$wrapLeft} > div,
  ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapRight} + span + ${$ba96bd4668ffc758$var$wrapLeft} > div,
  ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapLeft} + ${$ba96bd4668ffc758$var$wrapRight} > div,
  ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapLeft} + span + ${$ba96bd4668ffc758$var$wrapRight} > div`;
const $ba96bd4668ffc758$var$floatLeftFixSelector = `
  ${$ba96bd4668ffc758$var$wrapLeft} + ${$ba96bd4668ffc758$var$gapCursorSelector},
  ${$ba96bd4668ffc758$var$wrapRight} + ${$ba96bd4668ffc758$var$gapCursorSelector}`;
const $ba96bd4668ffc758$var$afterPresudoSelector = `
  ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapLeft} + span + ${$ba96bd4668ffc758$var$wrapRight}::after,
  ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapRight} + span + ${$ba96bd4668ffc758$var$wrapLeft}::after,
  ${$ba96bd4668ffc758$var$wrapLeft} + ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapRight}::after,
  ${$ba96bd4668ffc758$var$wrapLeft} + ${$ba96bd4668ffc758$var$gapCursorSelector} + span + ${$ba96bd4668ffc758$var$wrapRight}::after,
  ${$ba96bd4668ffc758$var$wrapRight} + ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapLeft}::after,
  ${$ba96bd4668ffc758$var$wrapRight} + ${$ba96bd4668ffc758$var$gapCursorSelector} + span + ${$ba96bd4668ffc758$var$wrapLeft}::after`;
const $ba96bd4668ffc758$var$marginDeepChildrenFixSelector = `
${$ba96bd4668ffc758$var$wrapLeft} + ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapRight} + *,
  ${$ba96bd4668ffc758$var$wrapLeft} + ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapRight} + span + *,
  ${$ba96bd4668ffc758$var$wrapRight} + ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapLeft} + *,
  ${$ba96bd4668ffc758$var$wrapRight} + ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapLeft} + span + *,
  ${$ba96bd4668ffc758$var$wrapLeft} + ${$ba96bd4668ffc758$var$gapCursorSelector} + span + ${$ba96bd4668ffc758$var$wrapRight} + *,
  ${$ba96bd4668ffc758$var$wrapRight} + ${$ba96bd4668ffc758$var$gapCursorSelector} + span + ${$ba96bd4668ffc758$var$wrapLeft} + *,
  ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapLeft} + span + ${$ba96bd4668ffc758$var$wrapRight} + *,
  ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapRight} + span + ${$ba96bd4668ffc758$var$wrapLeft} + *,
  ${$ba96bd4668ffc758$var$wrapLeft} + ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapRight} + * > *,
  ${$ba96bd4668ffc758$var$wrapLeft} + ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapRight} + span + * > *,
  ${$ba96bd4668ffc758$var$wrapRight} + ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapLeft} + * > *,
  ${$ba96bd4668ffc758$var$wrapRight} + ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapLeft} + span + * > *,
  ${$ba96bd4668ffc758$var$wrapLeft} + ${$ba96bd4668ffc758$var$gapCursorSelector} + span + ${$ba96bd4668ffc758$var$wrapRight} + * > *,
  ${$ba96bd4668ffc758$var$wrapRight} + ${$ba96bd4668ffc758$var$gapCursorSelector} + span + ${$ba96bd4668ffc758$var$wrapLeft} + * > *,
  ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapLeft} + span + ${$ba96bd4668ffc758$var$wrapRight} + * > *,
  ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapRight} + span + ${$ba96bd4668ffc758$var$wrapLeft} + * > *,
  ${$ba96bd4668ffc758$var$prosemirrorwidgetNotBlock} + ${$ba96bd4668ffc758$var$gapCursorSelector} + *,
  ${$ba96bd4668ffc758$var$prosemirrorwidgetNotBlock} + ${$ba96bd4668ffc758$var$gapCursorSelector} + span + *`;
const $ba96bd4668ffc758$export$f6b9d90c2745834e = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.${$ba96bd4668ffc758$export$8adc5edbc4a22166}`]: {
            caretColor: 'transparent'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [$ba96bd4668ffc758$var$gapCursorSelector]: {
            display: 'none',
            pointerEvents: 'none',
            position: 'relative',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '& span': {
                caretColor: 'transparent',
                position: 'absolute',
                height: '100%',
                width: '100%',
                display: 'block'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '& span::after': {
                animation: `1s ${$ba96bd4668ffc758$var$gapCursorBlink} step-start infinite`,
                borderLeft: '1px solid',
                content: "''",
                display: 'block',
                position: 'absolute',
                top: 0,
                height: '100%'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.-left span::after': {
                left: "var(--ds-space-negative-050, -4px)"
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.-right span::after': {
                right: "var(--ds-space-negative-050, -4px)"
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '& span[layout="full-width"], & span[layout="wide"], & span[layout="fixed-width"]': {
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
                marginLeft: '50%',
                transform: 'translateX(-50%)'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            [`&${$ba96bd4668ffc758$var$wrapRight}`]: {
                float: 'right'
            },
            /* fix vertical alignment of gap cursor */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
            [$ba96bd4668ffc758$var$fixVerticalAlignmentSelector]: {
                marginTop: 0
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.ProseMirror-focused ${$ba96bd4668ffc758$var$gapCursorSelector}`]: {
            display: 'block',
            borderColor: 'transparent'
        }
    },
    /* This hack below is for two images aligned side by side */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [$ba96bd4668ffc758$var$twoImagesSideBySideFixSelector]: {
        clear: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [$ba96bd4668ffc758$var$marginFixSelector]: {
        marginRight: 0,
        marginLeft: 0,
        marginBottom: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [$ba96bd4668ffc758$var$floatLeftFixSelector]: {
        float: 'left'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [$ba96bd4668ffc758$var$afterPresudoSelector]: {
        visibility: 'hidden',
        display: 'block',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 0,
        content: "' '",
        clear: 'both',
        height: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [$ba96bd4668ffc758$var$marginDeepChildrenFixSelector]: {
        marginTop: 0
    }
});


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled



const $3b9a5370a72c9df5$export$61d0da483c72dda3 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.gridParent': {
        width: `calc(100% + 24px)`,
        marginLeft: "var(--ds-space-negative-150, -12px)",
        marginRight: "var(--ds-space-negative-150, -12px)",
        transform: 'scale(1)',
        zIndex: 2
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.gridContainer': {
        position: 'fixed',
        height: '100vh',
        width: '100%',
        pointerEvents: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.gridLine': {
        borderLeft: `1px solid ${"var(--ds-border, #0B120E24)"}`,
        display: 'inline-block',
        boxSizing: 'border-box',
        height: '100%',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginLeft: '-1px',
        transition: 'border-color 0.15s linear',
        zIndex: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.highlight': {
        borderLeft: `1px solid ${"var(--ds-border-focused, #4688EC)"}`
    }
});


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
function $e776189f3c3af959$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e776189f3c3af959$export$fc74cf03693076b4 = {
    name: "86ymtv",
    styles: ".ProseMirror{.fabric-editor-indentation-mark{&[data-level='1']{margin-left:30px;}&[data-level='2']{margin-left:60px;}&[data-level='3']{margin-left:90px;}&[data-level='4']{margin-left:120px;}&[data-level='5']{margin-left:150px;}&[data-level='6']{margin-left:180px;}}}"
};


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
function $3b65c10c9ad50286$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $3b65c10c9ad50286$export$3fc32cdc53f6edeb = {
    name: "n6ftfq",
    styles: ".ProseMirror{.inlineNodeView{display:inline;user-select:all;white-space:nowrap;& > *:not(.zeroWidthSpaceContainer){white-space:pre-wrap;}& > .assistive{user-select:none;}}&.ua-safari{.inlineNodeView{&::selection, *::selection{background:transparent;}}}&.ua-chrome .inlineNodeView > span{user-select:none;}.inlineNodeViewAddZeroWidthSpace{&::after{content:'\u200B';}}}"
};


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled




function $07d5bf3f0b10fce1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $07d5bf3f0b10fce1$var$gridMediumMaxWidth = 1024;
const $07d5bf3f0b10fce1$var$akEditorSelectedNodeClassName = 'ak-editor-selected-node';
const $07d5bf3f0b10fce1$var$selectorForNotResizedLayoutInFulllWidthEditor = '.fabric-editor--full-width-mode .ProseMirror > .layoutSectionView-content-wrap';
const $07d5bf3f0b10fce1$var$selectorForNotResizedLayoutInFixedWidthEditor = '.ak-editor-content-area:not(.fabric-editor--full-width-mode) .ProseMirror > .layoutSectionView-content-wrap';
const $07d5bf3f0b10fce1$var$selectorForResizedLayoutInFullOrFixedWidthEditor = '.ProseMirror .fabric-editor-breakout-mark .layoutSectionView-content-wrap';
const $07d5bf3f0b10fce1$var$layoutResponsiveSelectedSelector = `&.selected, &:hover, &.selected.danger, &.${$07d5bf3f0b10fce1$var$akEditorSelectedNodeClassName}:not(.danger)`;
const $07d5bf3f0b10fce1$var$layoutSelectedSelector = `&.selected, [data-empty-layout='true'], &:hover, &.selected.danger [data-layout-section], &.${$07d5bf3f0b10fce1$var$akEditorSelectedNodeClassName}:not(.danger) [data-layout-section]`;
const $07d5bf3f0b10fce1$export$8dd21c7c24132a82 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror [data-layout-section]': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '> [data-layout-column]': {
            margin: '0 4px'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
        '> [data-layout-column]:first-of-type': {
            marginLeft: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
        '> [data-layout-column]:last-of-type': {
            marginRight: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`@media screen and (max-width: ${$07d5bf3f0b10fce1$var$gridMediumMaxWidth}px)`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '[data-layout-column] + [data-layout-column]': {
                margin: 0
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`> [data-layout-column].${$07d5bf3f0b10fce1$var$akEditorSelectedNodeClassName}:not(.danger)`]: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$e7c1f2908e268236),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a716852a0c5e54d5),
            {
                // layout column selection shorter after layout border has been removed
                '::before': {
                    width: 'calc(100% - 8px)',
                    left: 4,
                    borderRadius: "var(--ds-radius-small, 3px)"
                }
            }
        ]
    }
});
const $07d5bf3f0b10fce1$export$fe39d5414c0135d3 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror [data-layout-section]': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-layout-column] + [data-layout-column]': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginLeft: 8
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`@media screen and (max-width: ${$07d5bf3f0b10fce1$var$gridMediumMaxWidth}px)`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '[data-layout-column] + [data-layout-column]': {
                marginLeft: 0
            }
        }
    }
});
const $07d5bf3f0b10fce1$export$55890fd3e3be7f1b = {
    name: "4jflbi",
    styles: ".ProseMirror [data-layout-section]{display:flex;flex-direction:row;gap:var(--ds-space-100, 8px);& > *{flex:1;min-width:0;}& > .unsupportedBlockView-content-wrap{min-width:initial;}}.layout-section-container{container-type:inline-size;container-name:layout-area;}"
};
const $07d5bf3f0b10fce1$export$d9912ef7f698aab8 = {
    name: "xjr39a",
    styles: ".ProseMirror .layout-section-container [data-layout-section]{> .ProseMirror-widget{flex:none;display:contents !important;&[data-blocks-drag-handle-container] div{display:contents !important;}&[data-blocks-drop-target-container]{display:block !important;margin:var(--ds-space-negative-050, -4px);[data-drop-target-for-element]{position:absolute;}}& + [data-layout-column]{margin:0;}}> [data-layout-column]{margin:0;}}"
};
const $07d5bf3f0b10fce1$export$17d7fe9c8be65e97 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.ProseMirror [data-layout-section]': {
        position: 'relative',
        display: 'flex',
        flexDirection: 'row',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > *': {
            flex: 1,
            minWidth: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > .unsupportedBlockView-content-wrap': {
            minWidth: 'initial'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`@media screen and (max-width: ${$07d5bf3f0b10fce1$var$gridMediumMaxWidth}px)`]: {
            flexDirection: 'column'
        }
    }
});
const $07d5bf3f0b10fce1$export$cdcbf2d4bffabda6 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-layout-section], .layoutSectionView-content-wrap': {
            // Shows the border when cursor is inside a layout
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.selected [data-layout-column], &:hover [data-layout-column]': {
                border: `1px solid ${"var(--ds-border, #0B120E24)"}`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.selected.danger [data-layout-column]': {
                backgroundColor: "var(--ds-background-danger, #FFECEB)",
                borderColor: "var(--ds-border-danger, #E2483D)"
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`&.${$07d5bf3f0b10fce1$var$akEditorSelectedNodeClassName}:not(.danger)`]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                '[data-layout-column]': [
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    (0, $65bb5c5a687b3665$export$48dd9ca0c16e4625),
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    (0, $65bb5c5a687b3665$export$e7c1f2908e268236),
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    (0, $65bb5c5a687b3665$export$a716852a0c5e54d5),
                    {
                        '::after': {
                            backgroundColor: 'transparent'
                        }
                    }
                ]
            }
        }
    }
});
// TODO: ED-28075 - inline rowSeparatorBaseStyles to unblock Compiled CSS migration
const $07d5bf3f0b10fce1$var$rowSeparatorBaseStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-layout-content]::before': {
        content: "''",
        borderTop: `1px solid ${"var(--ds-border, #0B120E24)"}`,
        position: 'absolute',
        width: 'calc(100% - 32px)',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: -13,
        // clear styles for column separator
        borderLeft: 'unset',
        marginLeft: 'unset',
        height: 'unset'
    }
});
const $07d5bf3f0b10fce1$export$fe59793079ccb11a = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-layout-section], .layoutSectionView-content-wrap': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
            [$07d5bf3f0b10fce1$var$layoutSelectedSelector]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
                '[data-layout-column]:not(:first-of-type) [data-layout-content]::before': {
                    content: "''",
                    borderLeft: `1px solid ${"var(--ds-border, #0B120E24)"}`,
                    position: 'absolute',
                    height: 'calc(100% - 24px)',
                    // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
                    marginLeft: -25
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.selected.danger [data-layout-section]': {
                backgroundColor: "var(--ds-background-danger, #FFECEB)",
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`,
                borderRadius: "var(--ds-radius-small, 4px)"
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`&.${$07d5bf3f0b10fce1$var$akEditorSelectedNodeClassName}:not(.danger) [data-layout-section]`]: {
                boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #1868DB)"}`,
                borderRadius: "var(--ds-radius-small, 4px)",
                backgroundColor: "var(--ds-background-selected, #E9F2FE)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                '[data-layout-column]': [
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    (0, $65bb5c5a687b3665$export$e7c1f2908e268236),
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    (0, $65bb5c5a687b3665$export$a716852a0c5e54d5),
                    {
                        border: 0,
                        '::before': {
                            backgroundColor: 'transparent'
                        }
                    }
                ]
            }
        }
    }
});
const $07d5bf3f0b10fce1$export$c1454bb6dd8837f5 = /*#__PURE__*/ (0, $9K4OG.css)({
    // chosen breakpoints in container queries are to make sure layout responsiveness in editor aligns with renderer
    // not resized layout in full-width editor
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [$07d5bf3f0b10fce1$var$selectorForNotResizedLayoutInFulllWidthEditor]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-layout-section]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries
            '@container editor-area (max-width:724px)': {
                flexDirection: 'column'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [$07d5bf3f0b10fce1$var$layoutResponsiveSelectedSelector]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
            '[data-layout-column]:not(:first-of-type)': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries,@atlaskit/ui-styling-standard/no-unsafe-values
                [`@container editor-area (max-width:724px)`]: $07d5bf3f0b10fce1$var$rowSeparatorBaseStyles
            }
        }
    },
    // not resized layout in fixed-width editor
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [$07d5bf3f0b10fce1$var$selectorForNotResizedLayoutInFixedWidthEditor]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-layout-section]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries
            '@container editor-area (max-width:788px)': {
                flexDirection: 'column'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [$07d5bf3f0b10fce1$var$layoutResponsiveSelectedSelector]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
            '[data-layout-column]:not(:first-of-type)': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries,@atlaskit/ui-styling-standard/no-unsafe-values
                [`@container editor-area (max-width:788px)`]: $07d5bf3f0b10fce1$var$rowSeparatorBaseStyles
            }
        }
    },
    // resized layout in full/fixed-width editor
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [$07d5bf3f0b10fce1$var$selectorForResizedLayoutInFullOrFixedWidthEditor]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-layout-section]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries
            '@container editor-area (max-width:820px)': {
                flexDirection: 'column'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [$07d5bf3f0b10fce1$var$layoutResponsiveSelectedSelector]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
            '[data-layout-column]:not(:first-of-type)': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries,@atlaskit/ui-styling-standard/no-unsafe-values
                [`@container editor-area (max-width:820px)`]: $07d5bf3f0b10fce1$var$rowSeparatorBaseStyles
            }
        }
    }
});
const $07d5bf3f0b10fce1$export$203a03d09c37c555 = /*#__PURE__*/ (0, $9K4OG.css)({
    // chosen breakpoints in container queries are to make sure layout responsiveness in editor aligns with renderer
    // not resized layout in full-width editor
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [$07d5bf3f0b10fce1$var$selectorForNotResizedLayoutInFulllWidthEditor]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [$07d5bf3f0b10fce1$var$layoutResponsiveSelectedSelector]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
            '[data-layout-column]:not(:first-of-type)': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries,@atlaskit/ui-styling-standard/no-unsafe-values
                [`@container editor-area (max-width:724px)`]: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                    '[data-layout-content]::before': {
                        borderTop: 0
                    }
                }
            }
        }
    },
    // not resized layout in fixed-width editor
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [$07d5bf3f0b10fce1$var$selectorForNotResizedLayoutInFixedWidthEditor]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [$07d5bf3f0b10fce1$var$layoutResponsiveSelectedSelector]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
            '[data-layout-column]:not(:first-of-type)': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries,@atlaskit/ui-styling-standard/no-unsafe-values
                [`@container editor-area (max-width:788px)`]: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                    '[data-layout-content]::before': {
                        borderTop: 0
                    }
                }
            }
        }
    },
    // resized layout in full/fixed-width editor
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [$07d5bf3f0b10fce1$var$selectorForResizedLayoutInFullOrFixedWidthEditor]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [$07d5bf3f0b10fce1$var$layoutResponsiveSelectedSelector]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
            '[data-layout-column]:not(:first-of-type)': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries,@atlaskit/ui-styling-standard/no-unsafe-values
                [`@container editor-area (max-width:820px)`]: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                    '[data-layout-content]::before': {
                        borderTop: 0
                    }
                }
            }
        }
    }
});
const $07d5bf3f0b10fce1$export$ce383b8d82e44bf5 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-layout-section]': {
            margin: `${"var(--ds-space-100, 8px)"} -12px 0`,
            transition: 'border-color 0.3s cubic-bezier(0.15, 1, 0.3, 1)',
            cursor: 'pointer',
            // Inner cursor located 26px from left
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '[data-layout-column]': {
                flex: 1,
                position: 'relative',
                minWidth: 0,
                /* disable 4 borders when in view mode and advanced layouts is on */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
                borderRadius: "var(--ds-radius-small, 4px)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                padding: "var(--ds-space-150, 12px)",
                boxSizing: 'border-box',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '> div': {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
                    '> .embedCardView-content-wrap:first-of-type .rich-media-item': {
                        marginTop: 0
                    },
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
                    '> .mediaSingleView-content-wrap:first-of-type .rich-media-item': {
                        marginTop: 0
                    },
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
                    '> .ProseMirror-gapcursor.-right:first-child + .mediaSingleView-content-wrap .rich-media-item, > style:first-child + .ProseMirror-gapcursor.-right + .mediaSingleView-content-wrap .rich-media-item, > .ProseMirror-gapcursor.-right:first-of-type + .embedCardView-content-wrap .rich-media-item': {
                        marginTop: 0
                    },
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
                    '> .ProseMirror-gapcursor:first-child + span + .mediaSingleView-content-wrap .rich-media-item, > style:first-child + .ProseMirror-gapcursor + span + .mediaSingleView-content-wrap .rich-media-item': {
                        marginTop: 0
                    },
                    // Prevent first DecisionWrapper's margin-top: 8px from shifting decisions down and shrinking layout's node selectable area (leniency margin)
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                    "> [data-node-type='decisionList']": {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
                        'li:first-of-type [data-decision-wrapper]': {
                            marginTop: 0
                        }
                    }
                },
                // Make the 'content' fill the entire height of the layout column to allow click handler of layout section nodeview to target only data-layout-column
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '[data-layout-content]': {
                    height: '100%',
                    cursor: 'text',
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                    '.mediaGroupView-content-wrap': {
                        clear: 'both'
                    }
                }
            }
        }
    },
    // hide separator when element is dragging on top of a layout column
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-blocks-drop-target-container] ~ [data-layout-column] > [data-layout-content]::before': {
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.fabric-editor--full-width-mode .ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-layout-section]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.pm-table-container': {
                margin: '0 2px'
            }
        }
    }
});
const $07d5bf3f0b10fce1$export$74ce03ae8f7cbe1a = {
    name: "14on7sz",
    styles: ".ProseMirror [data-layout-section] [data-layout-column]{border:0;}"
};
const $07d5bf3f0b10fce1$export$4d009f8d3cbd5535 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror [data-layout-section]': {
        margin: `${"var(--ds-space-100, 8px)"} -20px 0`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror [data-layout-section] [data-layout-column]': {
        padding: '12px 20px'
    }
});
const $07d5bf3f0b10fce1$export$20e6a345585c5c3c = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-layout-section], .layoutSectionView-content-wrap': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-nested-selectors
            [$07d5bf3f0b10fce1$var$layoutSelectedSelector]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
                '[data-layout-column]:not(:first-of-type) [data-layout-content]::before': {
                    borderLeft: 0
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.selected.danger [data-layout-section]': {
                boxShadow: `0 0 0 0 ${"var(--ds-border-danger, #E2483D)"}`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-nested-selectors
            [`&.${$07d5bf3f0b10fce1$var$akEditorSelectedNodeClassName}:not(.danger) [data-layout-section]`]: {
                boxShadow: `0 0 0 0 ${"var(--ds-border-selected, #1868DB)"}`
            }
        }
    }
});
const $07d5bf3f0b10fce1$export$70038a77af1ac7b5 = {
    name: "1nqe1o0",
    styles: ".ProseMirror{[data-layout-section], .layoutSectionView-content-wrap{&.selected [data-layout-column], &:hover [data-layout-column]{border:0;}}}"
};
const $07d5bf3f0b10fce1$export$ec8bdd18ecbadae7 = {
    name: "1xloaqb",
    styles: ".ProseMirror{[data-layout-section]{cursor:default;[data-layout-column]{border:0;}}}"
};
const $07d5bf3f0b10fce1$export$c60086c81c0ffabf = {
    name: "1gk7267",
    styles: ".ProseMirror [data-layout-section] [data-layout-column] > div{> :nth-child(1 of :not(style, .ProseMirror-gapcursor, .ProseMirror-widget, span)){margin-top:0;}}"
};
const $07d5bf3f0b10fce1$export$598dd68f26eb7eff = {
    name: "uvfuhz",
    styles: ".ProseMirror [data-layout-section] [data-layout-column] > div{> :not(style):first-child, > style:first-child + *{margin-top:0;}> .ProseMirror-gapcursor:first-child + *, > style:first-child + .ProseMirror-gapcursor + *{margin-top:0;}> .ProseMirror-gapcursor:first-child + span + *{margin-top:0;}}"
};


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
function $9be63d8bc680ee45$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9be63d8bc680ee45$export$4ea5976125a01ffa = {
    name: "aj1leh",
    styles: ".ProseMirror a.blockLink{display:block;}.ProseMirror a[data-prosemirror-mark-name=\"link\"]{text-decoration:underline;}.ProseMirror a[data-prosemirror-mark-name=\"link\"]:hover{text-decoration:none;}"
};
const $9be63d8bc680ee45$export$889b949305b162f9 = {
    name: "1cwtun1",
    styles: ".hyperlink-floating-toolbar{padding:0;}"
};
const $9be63d8bc680ee45$export$e696625219a66da6 = {
    name: "1li8ktf",
    styles: ".hyperlink-open-link{min-width:24px;svg{max-width:18px;}}"
};


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled






function $7ea00528076df401$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// copied from packages/editor/editor-shared-styles/src/consts/consts.ts
const $7ea00528076df401$var$akEditorLineHeight = 1.714;
// copied from packages/editor/editor-common/src/styles/shared/smart-card.ts
const $7ea00528076df401$var$BLOCK_CARD_CONTAINER = 'blockCardView-content-wrap';
// copied from packages/editor/editor-shared-styles/src/consts/consts.ts
const $7ea00528076df401$var$blockNodesVerticalMargin = '0.75rem';
const $7ea00528076df401$export$5f95d55c83a3b7bc = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        /* =============== INDENTATION SPACING ========= */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'ul, ol': {
            boxSizing: 'border-box',
            paddingLeft: `var(--ed--list--item-counter--padding, 24px)`
        },
        // Firefox does not handle empty block element inside li tag.
        // If there is not block element inside li tag,	then firefox sets inherited height to li
        // However, if there is any block element and if it's empty	(or has empty inline element) then
        // firefox sets li tag height to zero.
        //
        // More details at
        // https://product-fabric.atlassian.net/wiki/spaces/~455502413/pages/3149365890/ED-14110+Investigation
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.ua-firefox': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            'ul, ol': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                'li p:empty, li p > span:empty': {
                    display: 'inline-block'
                }
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-ol, .ak-ul': {
            // Ensures list item content adheres to the list's margin instead
            // of filling the entire block row. This is important to allow
            // clicking interactive elements which are floated next to a list.
            //
            // For some history and context on this block, see PRs related to tickets.:
            // @see ED-6551 - original issue.
            // @see ED-7015 - follow up issue.
            // @see ED-7447 - flow-root change.
            //
            // @see https://css-tricks.com/display-flow-root/
            //
            // For older browsers the do not support flow-root. */
            // stylelint-disable declaration-block-no-duplicate-properties */
            display: 'flow-root'
        },
        /* =============== INDENTATION AESTHETICS ========= */ // We support nested lists up to six levels deep.
        /*  ======== LEGACY LISTS ======== */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'ul, ul ul ul ul': {
            listStyleType: 'disc'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'ul ul, ul ul ul ul ul': {
            listStyleType: 'circle'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'ul ul ul, ul ul ul ul ul ul': {
            listStyleType: 'square'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'ol, ol ol ol ol': {
            listStyleType: 'decimal'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'ol ol, ol ol ol ol ol': {
            listStyleType: 'lower-alpha'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'ol ol ol, ol ol ol ol ol ol': {
            listStyleType: 'lower-roman'
        },
        /* ======== PREDICTABLE LISTS ======== */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "ol[data-indent-level='1'], ol[data-indent-level='4']": {
            listStyleType: 'decimal'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "ol[data-indent-level='2'], ol[data-indent-level='5']": {
            listStyleType: 'lower-alpha'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "ol[data-indent-level='3'], ol[data-indent-level='6']": {
            listStyleType: 'lower-roman'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "ul[data-indent-level='1'], ul[data-indent-level='4']": {
            listStyleType: 'disc'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "ul[data-indent-level='2'], ul[data-indent-level='5']": {
            listStyleType: 'circle'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "ul[data-indent-level='3'], ul[data-indent-level='6']": {
            listStyleType: 'square'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        li: {
            position: 'relative',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '& > p:not(:first-child)': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                margin: `${"var(--ds-space-050, 4px)"} 0 0 0`
            },
            /* In SSR the above rule will apply to all p tags because first-child would be a style tag.
      	The following rule resets the first p tag back to its original margin
      	defined in packages/editor/editor-common/src/styles/shared/paragraph.ts */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '& > style:first-child + p': {
                marginTop: $7ea00528076df401$var$blockNodesVerticalMargin
            }
        }
    }
});
const $7ea00528076df401$export$b5b1b7a81c86d94e = {
    name: "2ngyxg",
    styles: "li[data-testid=\"show-diff-changed-decoration-node\"]::marker{color:var(--diff-decoration-marker-color);}"
};
const $7ea00528076df401$export$3861aadd8944b16f = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // Root lists: 12px top margin (design system value), except first content child. Uses :not(:nth-child(1 of ...)) to exclude first content lists.
        // A more complex selector is used here to ensure this style is not applied to block quotes and panels, as they do not have a margin-top property already, and this will incorrectly add a margin-top to them.
        // This is unlike tables and expands, which do have a margin-top property already, and this style would not change their top margin, even without the :not(:nth-child(1 of ...)) selector.
        // This targeted approach reduces the blast radius of the fix. Instead of modifying numerous existing styles, we add this single selector until the issue with bundle.css & aui-reset.less is fixed.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        'ul:not(li > ul):not(:nth-child(1 of :not(style, .ProseMirror-gapcursor, .ProseMirror-widget, span))), ol:not(li > ol):not(:nth-child(1 of :not(style, .ProseMirror-gapcursor, .ProseMirror-widget, span)))': {
            marginTop: `var(--ds-space-150, 12px)`
        },
        // Nested lists: 4px top margin (design system value)
        // Applies to both OL and UL nested inside list items
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'li > ol, li > ul': {
            marginTop: `var(--ds-space-050, 4px)`
        }
    }
});
const $7ea00528076df401$export$dba87c9b43c1033d = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.ProseMirror:not(.${$7ea00528076df401$var$BLOCK_CARD_CONTAINER}) > li::before`]: {
        content: '" "',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        lineHeight: $7ea00528076df401$var$akEditorLineHeight
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.ProseMirror:not(.${$7ea00528076df401$var$BLOCK_CARD_CONTAINER}) > li > p:first-child, .ProseMirror:not(.${$7ea00528076df401$var$BLOCK_CARD_CONTAINER}) > li > .code-block:first-child, .ProseMirror:not(.${$7ea00528076df401$var$BLOCK_CARD_CONTAINER}) > li > .ProseMirror-gapcursor:first-child + .code-block`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        marginTop: `-${$7ea00528076df401$var$akEditorLineHeight}em !important`
    }
});
const $7ea00528076df401$export$b9f4317d28be80aa = `max(0px, calc((var(--ak-editor-base-font-size, ${(0, $aFUXX.akEditorFullPageDefaultFontSize)}px) - ${(0, $aFUXX.akEditorFullPageDenseFontSize)}px) * (4 / 3)))`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles
var $7ea00528076df401$var$_ref = {
    name: "0",
    styles: ""
};
const $7ea00528076df401$export$dc36e8e603594c1d = (baseFontSize)=>{
    if (!baseFontSize || baseFontSize === (0, $aFUXX.akEditorFullPageDefaultFontSize)) return $7ea00528076df401$var$_ref;
    return /*#__PURE__*/ (0, $9K4OG.css)({
        /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors */ '.ProseMirror': {
            // Adjacent list items
            'li + li': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                marginTop: $7ea00528076df401$export$b9f4317d28be80aa
            },
            // Nested lists directly under an li (unordered and ordered)
            'li > ul, li > ol, .ak-ul li > ul, .ak-ul li > ol, .ak-ol li > ul, .ak-ol li > ol': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                marginTop: $7ea00528076df401$export$b9f4317d28be80aa
            }
        }
    });
};


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled




var $fhm10 = parcelRequire("fhm10");


var $gAARK = parcelRequire("gAARK");


var $ag6aQ = parcelRequire("ag6aQ");







var $jTudT = parcelRequire("jTudT");
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766




var $fDGbV = parcelRequire("fDGbV");


var $ieXGd = parcelRequire("ieXGd");

var $b38UX = parcelRequire("b38UX");

/*
 * Used to display the blue border around a selected card without
 * shrinking the image OR growing the card size
 */ const $4bc6aca00a4d4c4d$var$getSelectedBorderStyle = ({ selected: selected })=>`
    ${selected ? (0, $ieXGd.hideNativeBrowserTextSelectionStyles) : ''}

    &::after {
      content: '';
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      box-sizing: border-box;
      pointer-events: none;
      border-radius: ${"var(--ds-radius-small, 3px)"};
      ${selected ? (0, $ieXGd.getSelectionStyles)([
        (0, $b38UX.SelectionStyle).Border
    ]) : ''}
    }
  `;
const $4bc6aca00a4d4c4d$export$70bc5d30fe886af = 'media-card-inline-player';
const $4bc6aca00a4d4c4d$export$bffd1a8ecf8d5d06 = ({ dimensions: dimensions, selected: selected })=>/*#__PURE__*/ (0, $9K4OG.css)("width:", (0, $fDGbV.getDimensionsWithDefault)(dimensions).width || '100%', ";height:", (0, $fDGbV.getDimensionsWithDefault)(dimensions).height || 'auto', ";overflow:hidden;border-radius:var(--ds-radius-small, 3px);position:relative;max-width:100%;max-height:100%;", $4bc6aca00a4d4c4d$var$getSelectedBorderStyle(selected), " video{width:100%;height:100%;}");
$4bc6aca00a4d4c4d$export$bffd1a8ecf8d5d06.displayName = 'InlinePlayerWrapper';


var $8jrlU = parcelRequire("8jrlU");


function $8b8a9e34027bcb70$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8b8a9e34027bcb70$var$wrappedMediaBreakoutPoint = 410;
/**
 * Reference Heights
 *
 * These heights enforce consistent sizes with media inline nodes due to
 * inconsistencies with center aligned inline nodes and text.
 *
 * There is conversation about refactoring media inline nodes to conform to
 * aligning correctly with the surrounding text.
 *
 * These constants originally came from `headingSizes` from the `theme` package
 * and have been copied here to remove this package.
 */ const $8b8a9e34027bcb70$var$referenceHeights = {
    p: 22,
    h1: 36,
    h2: 31,
    h3: 25,
    h4: 23,
    h5: 20,
    h6: 18
};
const $8b8a9e34027bcb70$var$inlineImageSelector = `> .mediaInlineView-content-wrap > .${(0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME)}, > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${(0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME)}, > .${(0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME)}, > :is(a, span[data-mark-type='border']) .${(0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME)}`;
const $8b8a9e34027bcb70$export$abd2efc27ac7e809 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-imported-style-values
        [`li .${0, $gnMzP.richMediaClassName}`]: {
            margin: 0
        },
        // Hack for chrome to fix media single position inside a list when media is the first child
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.ua-chrome li > .mediaSingleView-content-wrap::before': {
            content: "''",
            display: 'block',
            height: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.ua-firefox': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.mediaSingleView-content-wrap': {
                userSelect: 'none'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.captionView-content-wrap': {
                userSelect: 'text'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        ".mediaSingleView-content-wrap[layout^='wrap-']": {
            position: 'relative',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-imported-style-values
            zIndex: (0, $aFUXX.akEditorWrappedNodeZIndex),
            maxWidth: '100%',
            /* overwrite default Prosemirror setting making it clear: both */ clear: 'inherit'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        ".mediaSingleView-content-wrap[layout='center']": {
            clear: 'both'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-imported-style-values
        [`table .${0, $gnMzP.richMediaClassName}`]: {
            marginTop: "var(--ds-space-150, 12px)",
            marginBottom: "var(--ds-space-150, 12px)",
            clear: 'both',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.image-wrap-left[data-layout], &.image-wrap-right[data-layout]': {
                clear: 'none',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
                '&:first-child': {
                    marginTop: "var(--ds-space-150, 12px)"
                }
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-imported-style-values
        [`.${0, $gnMzP.richMediaClassName}.image-wrap-right + .${0, $gnMzP.richMediaClassName}.image-wrap-left`]: {
            clear: 'both'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-imported-style-values
        [`.${0, $gnMzP.richMediaClassName}.image-wrap-left + .${0, $gnMzP.richMediaClassName}.image-wrap-right, .${0, $gnMzP.richMediaClassName}.image-wrap-right + .${0, $gnMzP.richMediaClassName}.image-wrap-left, .${0, $gnMzP.richMediaClassName}.image-wrap-left + .${0, $gnMzP.richMediaClassName}.image-wrap-left, .${0, $gnMzP.richMediaClassName}.image-wrap-right + .${0, $gnMzP.richMediaClassName}.image-wrap-right`]: {
            marginRight: 0,
            marginLeft: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`@media all and (max-width: ${$8b8a9e34027bcb70$var$wrappedMediaBreakoutPoint}px)`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            "div.mediaSingleView-content-wrap[layout='wrap-left'], div.mediaSingleView-content-wrap[data-layout='wrap-left'], div.mediaSingleView-content-wrap[layout='wrap-right'], div.mediaSingleView-content-wrap[data-layout='wrap-right']": {
                float: 'none',
                overflow: 'auto',
                margin: `${"var(--ds-space-150, 12px)"} 0`
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`& [layout='full-width'] .${0, $gnMzP.richMediaClassName}, & [layout='wide'] .${0, $gnMzP.richMediaClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginLeft: '50%',
            transform: 'translateX(-50%)'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        ".media-extended-resize-experience[layout^='wrap-']": {
            // override 'overflow: auto' when viewport <= 410 set by mediaSingleSharedStyle
            // to prevent scroll bar
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            overflow: 'visible !important'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "& [layout^='wrap-'] + [layout^='wrap-']": {
            clear: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            "& + p, & + div[class^='fabric-editor-align'], & + ul, & + ol, & + h1, & + h2, & + h3, & + h4, & + h5, & + h6": {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles,@atlaskit/ui-styling-standard/no-unsafe-values
                clear: 'both !important'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`& .${0, $gnMzP.richMediaClassName}`]: {
                marginLeft: 0,
                marginRight: 0
            }
        },
        // Shifting the mediaInline image component (renders image) to align nicely with
        // mediaInline (renders text) is a bit of a testing ground. This numbers represent
        // shift in top and bottom and size adjustments to make up for lack of 1to1 size
        //  mapping
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            height: $8b8a9e34027bcb70$var$referenceHeights['p'],
            transform: 'translateY(-2px)'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        h1: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [$8b8a9e34027bcb70$var$inlineImageSelector]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                height: $8b8a9e34027bcb70$var$referenceHeights.h1,
                transform: `translateY(-3px)`
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        h2: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [$8b8a9e34027bcb70$var$inlineImageSelector]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                height: $8b8a9e34027bcb70$var$referenceHeights.h2,
                transform: `translateY(-3px)`
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        h3: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [$8b8a9e34027bcb70$var$inlineImageSelector]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                height: $8b8a9e34027bcb70$var$referenceHeights.h3,
                transform: `translateY(-2px)`
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        h4: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [$8b8a9e34027bcb70$var$inlineImageSelector]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                height: $8b8a9e34027bcb70$var$referenceHeights.h4,
                transform: `translateY(-2px)`
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        h5: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [$8b8a9e34027bcb70$var$inlineImageSelector]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                height: $8b8a9e34027bcb70$var$referenceHeights.h5,
                transform: `translateY(-2px)`
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        h6: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [$8b8a9e34027bcb70$var$inlineImageSelector]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                height: $8b8a9e34027bcb70$var$referenceHeights.h6,
                transform: `translateY(-2px)`
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        ".mediaSingleView-content-wrap[layout='wrap-left']": {
            float: 'left'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        ".mediaSingleView-content-wrap[layout='wrap-right']": {
            float: 'right'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        ".mediaSingleView-content-wrap[layout='wrap-right'] + .mediaSingleView-content-wrap[layout='wrap-left']": {
            clear: 'both'
        },
        // Larger margins for resize handlers when at depth 0 of the document
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& > .mediaSingleView-content-wrap': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.richMedia-resize-handle-right': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
                marginRight: `-${(0, $aFUXX.akEditorMediaResizeHandlerPaddingWide)}px`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.richMedia-resize-handle-left': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
                marginLeft: `-${(0, $aFUXX.akEditorMediaResizeHandlerPaddingWide)}px`
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-imported-style-values
    [`.${(0, $ag6aQ.ClassNames).FLOATING_TOOLBAR_COMPONENT}`]: {
        padding: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.richMedia-resize-handle-right, .richMedia-resize-handle-left': {
        display: 'flex',
        flexDirection: 'column',
        /* vertical align */ justifyContent: 'center'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.richMedia-resize-handle-right': {
        alignItems: 'flex-end',
        paddingRight: "var(--ds-space-150, 12px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
        marginRight: `-${(0, $aFUXX.akEditorMediaResizeHandlerPadding)}px`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.richMedia-resize-handle-left': {
        alignItems: 'flex-start',
        paddingLeft: "var(--ds-space-150, 12px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
        marginLeft: `-${(0, $aFUXX.akEditorMediaResizeHandlerPadding)}px`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.richMedia-resize-handle-right::after, .richMedia-resize-handle-left::after': {
        content: "' '",
        display: 'flex',
        width: 3,
        height: 64,
        borderRadius: "var(--ds-radius-medium, 6px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${0, $gnMzP.richMediaClassName}:hover .richMedia-resize-handle-left::after, .${0, $gnMzP.richMediaClassName}:hover .richMedia-resize-handle-right::after`]: {
        background: "var(--ds-border, #0B120E24)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${0, $aFUXX.akEditorSelectedNodeClassName} .richMedia-resize-handle-right::after, .${0, $aFUXX.akEditorSelectedNodeClassName} .richMedia-resize-handle-left::after, .${0, $gnMzP.richMediaClassName} .richMedia-resize-handle-right:hover::after, .${0, $gnMzP.richMediaClassName} .richMedia-resize-handle-left:hover::after, .${0, $gnMzP.richMediaClassName}.is-resizing .richMedia-resize-handle-right::after, .${0, $gnMzP.richMediaClassName}.is-resizing .richMedia-resize-handle-left::after`]: {
        background: "var(--ds-border-focused, #4688EC)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.__resizable_base__': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        left: 'unset !important',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        width: 'auto !important',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        height: 'auto !important'
    },
    // Danger when top level node for smart cards / inline links
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.danger > div > div > .media-card-frame, .danger > span > a': {
        backgroundColor: "var(--ds-background-danger, #FFECEB)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
        boxShadow: `0px 0px 0px ${(0, $aFUXX.akEditorSelectedBorderBoldSize)}px, ${"var(--ds-border-danger, #E2483D)"}`,
        transition: 'background-color 0s, box-shadow 0s'
    },
    // Danger when nested node or common
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.danger': {
        // Media single
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${0, $gnMzP.richMediaClassName} .${0, $jTudT.fileCardImageViewSelector}::after`]: {
            border: `1px solid ${"var(--ds-border-danger, #E2483D)"}`
        },
        // Media single video player
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${0, $gnMzP.richMediaClassName} .${0, $4bc6aca00a4d4c4d$export$70bc5d30fe886af}::after`]: {
            border: `1px solid ${"var(--ds-border-danger, #E2483D)"}`
        },
        // New file experience
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${0, $gnMzP.richMediaClassName} .${0, $8jrlU.newFileExperienceClassName}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"} !important`
        },
        // Media resize legacy handlers
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.richMedia-resize-handle-right::after, .richMedia-resize-handle-left::after': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            background: `${"var(--ds-icon-danger, #C9372C)"} !important`
        },
        // Media resize new handlers
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.resizer-handle-thumb': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            background: `${"var(--ds-icon-danger, #C9372C)"} !important`
        },
        // Smart cards
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'div div .media-card-frame, .inlineCardView-content-wrap > span > a': {
            backgroundColor: `${"var(--ds-blanket-danger, #EF5C4814)"}`,
            transition: `background-color 0s`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'div div .media-card-frame::after': {
            boxShadow: 'none'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.warning': {
        // Media single
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${0, $gnMzP.richMediaClassName} .${0, $jTudT.fileCardImageViewSelector}::after`]: {
            border: `1px solid ${"var(--ds-border-warning, #E06C00)"}`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${0, $gnMzP.richMediaClassName} .${0, $4bc6aca00a4d4c4d$export$70bc5d30fe886af}::after`]: {
            border: `1px solid ${"var(--ds-border-warning, #E06C00)"}`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${0, $gnMzP.richMediaClassName} .${0, $8jrlU.newFileExperienceClassName}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            boxShadow: `0 0 0 1px ${"var(--ds-border-warning, #E06C00)"} !important`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.resizer-handle-thumb': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            background: `${"var(--ds-icon-warning, #E06C00)"} !important`
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.media-filmstrip-list-item': {
        cursor: 'pointer'
    },
    // When clicking drag handle, mediaGroup node will be selected. Hence we need to apply selected style to each media node
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.mediaGroupView-content-wrap.${0, $aFUXX.akEditorSelectedNodeClassName} #newFileExperienceWrapper`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
        boxShadow: (0, $aFUXX.akEditorSelectedBoxShadow)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ak-editor-no-interaction #newFileExperienceWrapper': {
        boxShadow: 'none'
    }
});
const $8b8a9e34027bcb70$export$c47a18e5da2466ef = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-nested-selectors
        [`.mediaInlineView-content-wrap.${0, $aFUXX.akEditorSelectedNodeClassName}.danger`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            [` .${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: [
                (0, $65bb5c5a687b3665$export$57f48b634c3a2512)
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            '>span> span[role="button"]': [
                (0, $65bb5c5a687b3665$export$57f48b634c3a2512)
            ]
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.mediaGroupView-content-wrap.danger #newFileExperienceWrapper`]: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
        [
            (0, $65bb5c5a687b3665$export$57f48b634c3a2512)
        ]
    }
});
const $8b8a9e34027bcb70$export$cbc2f5b7ba4a5b45 = {
    name: "efqvbk",
    styles: ".mediaGroupView-content-wrap ul{padding:0;}"
};
const $8b8a9e34027bcb70$export$228abfa0106fa708 = {
    name: "1u86ffv",
    styles: ".fabric-editor-block-mark[class^=\"fabric-editor-align\"]{clear:none;}.fabric-editor-align-end{text-align:right;}.fabric-editor-align-start{text-align:left;}.fabric-editor-align-center{text-align:center;}.fabric-editor--full-width-mode{.pm-table-container{.code-block, .extension-container, .multiBodiedExtension--container{max-width:100%;}}}"
};
const $8b8a9e34027bcb70$export$1cac2710e369d647 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.mediaSingleView-content-wrap': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`span#${0, $gAARK.CAPTION_PLACEHOLDER_ID}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: 'var(--ak-editor-base-font-size)'
        }
    }
});


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled



const $1d1e174580119dab$export$e5f60e08987c4e73 = {
    MENTION_CONTAINER: 'mentionView-content-wrap'
};






function $d6f1b5d8b6185b26$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/* need to specify dark text colour because personal mentions
(in dark blue) have white text by default */ const $d6f1b5d8b6185b26$var$mentionsSelectedColor = {
    name: "5703k4",
    styles: "color:var(--ds-text-subtle, #505258)"
};
const $d6f1b5d8b6185b26$export$1445f2e2b3a1d9c8 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.${(0, $1d1e174580119dab$export$e5f60e08987c4e73).MENTION_CONTAINER}`]: {
        // TODO: ED-28075 - refactor selection styles to unblock Compiled CSS migration
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`&.${0, $aFUXX.akEditorSelectedNodeClassName} [data-mention-id] > span`]: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$b2937e5c446645ec),
            $d6f1b5d8b6185b26$var$mentionsSelectedColor
        ]
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.danger': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`.${(0, $1d1e174580119dab$export$e5f60e08987c4e73).MENTION_CONTAINER}.${0, $aFUXX.akEditorSelectedNodeClassName}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> span > span > span': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
                boxShadow: `0 0 0 ${(0, $aFUXX.akEditorSelectedBorderSize)}px ${(0, $aFUXX.akEditorDeleteBorder)}`,
                backgroundColor: "var(--ds-background-danger, #FFECEB)"
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`.${(0, $1d1e174580119dab$export$e5f60e08987c4e73).MENTION_CONTAINER} > span > span > span`]: {
            backgroundColor: "var(--ds-background-neutral, #0515240F)",
            color: "var(--ds-text-subtle, #505258)"
        }
    }
});
const $d6f1b5d8b6185b26$export$5fb9b21e3678e9ac = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.editor-mention-primitive': {
        display: 'inline',
        borderRadius: "var(--ds-radius-full, 9999px)",
        cursor: 'pointer',
        padding: '1px 0.3em 1px 0.23em',
        // To match `packages/elements/mention/src/components/Mention/PrimitiveMention.tsx` implementation
        // we match the line height exactly
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: '1.714',
        fontWeight: "var(--ds-font-weight-regular, 400)",
        wordBreak: 'break-word',
        background: "var(--ds-background-neutral, #0515240F)",
        border: '1px solid transparent',
        color: "var(--ds-text-subtle, #505258)",
        '&:hover': {
            background: "var(--ds-background-neutral-hovered, #0B120E24)"
        },
        '&:active': {
            background: "var(--ds-background-neutral-pressed, #080F214A)"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.editor-mention-primitive.mention-restricted': {
        background: 'transparent',
        border: `1px solid ${"var(--ds-border-bold, #7D818A)"}`,
        color: "var(--ds-text, #292A2E)",
        '&:hover': {
            background: 'transparent'
        },
        '&:active': {
            background: 'transparent'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.editor-mention-primitive.mention-self': {
        background: "var(--ds-background-brand-bold, #1868DB)",
        border: '1px solid transparent',
        color: "var(--ds-text-inverse, #FFFFFF)",
        '&:hover': {
            background: "var(--ds-background-brand-bold-hovered, #1558BC)"
        },
        '&:active': {
            background: "var(--ds-background-brand-bold-pressed, #144794)"
        }
    }
});
const $d6f1b5d8b6185b26$export$8697a9554aac2a5a = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.danger': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.editor-mention-primitive': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            boxShadow: `0 0 0 ${(0, $aFUXX.akEditorSelectedBorderSize)}px ${(0, $aFUXX.akEditorDeleteBorder)}`,
            backgroundColor: "var(--ds-background-danger, #FFECEB)"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.${0, $aFUXX.akEditorSelectedNodeClassName}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '> .editor-mention-primitive, > .editor-mention-primitive.mention-self, > .editor-mention-primitive.mention-restricted': // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values,
        [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$b2937e5c446645ec),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a716852a0c5e54d5),
            $d6f1b5d8b6185b26$var$mentionsSelectedColor
        ]
    }
});
const $d6f1b5d8b6185b26$export$13ab2f17ccaf48f6 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.danger': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.editor-mention-primitive': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            boxShadow: `0 0 0 ${(0, $aFUXX.akEditorSelectedBorderSize)}px ${(0, $aFUXX.akEditorDeleteBorder)}`,
            backgroundColor: "var(--ds-background-danger, #FFECEB)"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.${0, $aFUXX.akEditorSelectedNodeClassName}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '> .editor-mention-primitive, > .editor-mention-primitive.mention-self, > .editor-mention-primitive.mention-restricted': // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values,
        [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$b2937e5c446645ec),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a716852a0c5e54d5),
            $d6f1b5d8b6185b26$var$mentionsSelectedColor
        ]
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.${0, $aFUXX.akEditorSelectedNodeClassName}:not(.search-match-block)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '> .editor-mention-primitive, > .editor-mention-primitive.mention-self, > .editor-mention-primitive.mention-restricted': // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values,
        [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0)
        ]
    }
});
const $d6f1b5d8b6185b26$export$1091a37fb36d77e5 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.${0, $aFUXX.akEditorSelectedNodeClassName}:not(.search-match-block).danger`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '> .editor-mention-primitive, > .editor-mention-primitive.mention-self, > .editor-mention-primitive.mention-restricted': // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values,
        [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            (0, $65bb5c5a687b3665$export$57f48b634c3a2512),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$fd4ac125b4ba4c28)
        ]
    }
});


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled



function $9add2684ad964103$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9add2684ad964103$export$8290cf129669d0cb = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-panel': {
            cursor: 'pointer',
            /* Danger when top level node */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger': {
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                backgroundColor: `${"var(--ds-background-danger, #FFECEB)"} !important`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '.ak-editor-panel__icon': {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                    color: `${"var(--ds-icon-danger, #C9372C)"} !important`
                }
            },
            // panelSharedStyles()
            // panelSharedStylesWithoutPrefix()
            borderRadius: "var(--ds-radius-small, 3px)",
            margin: `0.75rem 0 0`,
            paddingTop: "var(--ds-space-100, 8px)",
            paddingRight: "var(--ds-space-200, 16px)",
            paddingBottom: "var(--ds-space-100, 8px)",
            paddingLeft: "var(--ds-space-100, 8px)",
            minWidth: '48px',
            display: 'flex',
            position: 'relative',
            alignItems: 'normal',
            wordBreak: 'break-word',
            // mainDynamicStyles(PanelType.INFO)
            // > getPanelTypeBackground(PanelType.INFO)
            backgroundColor: "var(--ds-background-accent-blue-subtlest, #E9F2FE)",
            color: 'inherit',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.ak-editor-panel__icon': {
                flexShrink: 0,
                height: "var(--ds-space-300, 24px)",
                width: "var(--ds-space-300, 24px)",
                boxSizing: 'content-box',
                paddingRight: "var(--ds-space-100, 8px)",
                textAlign: 'center',
                userSelect: 'none',
                MozUserSelect: 'none',
                WebkitUserSelect: 'none',
                msUserSelect: 'none',
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
                marginTop: '0.1em',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '> span': {
                    verticalAlign: 'middle',
                    display: 'inline-flex'
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '.emoji-common-emoji-sprite': {
                    verticalAlign: '-2px' // -(8*3-20)/2 [px]
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '.emoji-common-emoji-image': {
                    verticalAlign: '-3px',
                    // panelEmojiSpriteVerticalAlignment - 1 [px]
                    /* Vertical align only works for inline-block elements in Firefox */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
                    '@-moz-document url-prefix()': {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                        img: {
                            display: 'inline-block'
                        }
                    }
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.ak-editor-panel__content': {
                margin: `${"var(--ds-space-025, 2px)"} 0 ${"var(--ds-space-025, 2px)"}`,
                flex: '1 0 0',
                /*
        	https://ishadeed.com/article/min-max-css/#setting-min-width-to-zero-with-flexbox
        	The default value for min-width is auto, which is computed to zero.
        	When an element is a flex item, the value of min-width doesn’t compute to zero.
        	The minimum size of a flex item is equal to the size of its contents.
        */ minWidth: 0
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&[data-panel-type="note"]': {
                // mainDynamicStyles(PanelType.NOTE)
                backgroundColor: "var(--ds-background-accent-purple-subtlest, #F8EEFE)",
                color: 'inherit'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&[data-panel-type="tip"]': {
                // mainDynamicStyles(PanelType.TIP)
                backgroundColor: "var(--ds-background-accent-green-subtlest, #DCFFF1)",
                color: 'inherit'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&[data-panel-type="warning"]': {
                // mainDynamicStyles(PanelType.WARNING)
                backgroundColor: "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
                color: 'inherit'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&[data-panel-type="error"]': {
                // mainDynamicStyles(PanelType.ERROR)
                backgroundColor: "var(--ds-background-accent-red-subtlest, #FFECEB)",
                color: 'inherit'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&[data-panel-type="success"]': {
                // mainDynamicStyles(PanelType.SUCCESS)
                backgroundColor: "var(--ds-background-accent-green-subtlest, #DCFFF1)",
                color: 'inherit'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-panel__content': {
            cursor: 'text'
        },
        /* Danger when nested node */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.danger .ak-editor-panel': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&[data-panel-type]': {
                backgroundColor: "var(--ds-blanket-danger, #EF5C4814)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '.ak-editor-panel__icon': {
                    color: "var(--ds-icon-danger, #C9372C)"
                }
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.ak-editor-panel.ak-editor-selected-node:not(.danger)': {
        // getSelectionStyles([SelectionStyle.BoxShadow, SelectionStyle.Blanket]),
        // SelectionStyle.BoxShadow
        boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #1868DB)"}`,
        borderColor: 'transparent',
        // SelectionStyle.Blanket
        position: 'relative',
        // Fixes ED-9263, where emoji or inline card in panel makes selection go outside the panel
        // in Safari. Looks like it's caused by user-select: all in the emoji element
        WebkitUserSelect: 'text',
        '&::before': {
            position: 'absolute',
            content: '""',
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            width: '100%',
            pointerEvents: 'none',
            zIndex: 12,
            // akEditorSmallZIndex
            backgroundColor: "var(--ds-blanket-selected, #388BFF14)"
        },
        // hideNativeSelectionStyles
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&::selection, *::selection': {
            backgroundColor: 'transparent'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&::-moz-selection, *::-moz-selection': {
            backgroundColor: 'transparent'
        }
    }
});
const $9add2684ad964103$export$fb05379f8218158 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-panel': {
            // Support nested panel
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.ak-editor-panel__content .ak-editor-panel': {
                border: `1px solid ${"var(--ds-border, #0B120E24)"}`
            }
        }
    }
});
const $9add2684ad964103$export$1bea98aa89006044 = {
    name: "icrrk4",
    styles: ".ProseMirror{.ak-editor-panel{&.ak-editor-panel__no-icon{padding-right:var(--ds-space-150, 12px);padding-left:var(--ds-space-150, 12px);}}}.ak-editor-content-area.appearance-full-page .ProseMirror{.ak-editor-panel .ak-editor-panel__icon{padding-right:var(--ds-space-150, 12px);}.ak-editor-panel.ak-editor-panel__no-icon{padding-left:var(--ds-space-250, 20px);padding-right:var(--ds-space-250, 20px);}}.ak-editor-content-area .ak-editor-content-area .ProseMirror{.ak-editor-panel .ak-editor-panel__icon{padding-right:var(--ds-space-100, 8px);}.ak-editor-panel.ak-editor-panel__no-icon{padding-right:var(--ds-space-150, 12px);padding-left:var(--ds-space-150, 12px);}}"
};
const $9add2684ad964103$export$59d3d90d4141195 = {
    name: "1rtu9jn",
    styles: ".ProseMirror{.ak-editor-panel{&[data-panel-type=\"info\"]{.ak-editor-panel__icon[data-panel-type=\"info\"]{color:var(--ds-icon-information, #357DE8);}}&[data-panel-type=\"note\"]{.ak-editor-panel__icon[data-panel-type=\"note\"]{color:var(--ds-icon-discovery, #AF59E1);}}&[data-panel-type=\"tip\"]{.ak-editor-panel__icon[data-panel-type=\"tip\"]{color:var(--ds-icon-success, #6A9A23);}}&[data-panel-type=\"warning\"]{.ak-editor-panel__icon[data-panel-type=\"warning\"]{color:var(--ds-icon-warning, #E06C00);}}&[data-panel-type=\"error\"]{.ak-editor-panel__icon[data-panel-type=\"error\"]{color:var(--ds-icon-danger, #C9372C);}}&[data-panel-type=\"success\"]{.ak-editor-panel__icon[data-panel-type=\"success\"]{color:var(--ds-icon-success, #6A9A23);}}}}"
};
const $9add2684ad964103$export$21dc022a1db4e807 = {
    name: "5hfp5c",
    styles: ".panelView-content-wrap{box-sizing:border-box;}"
};
const $9add2684ad964103$export$9addcfe7a096a01d = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        /* Danger when nested node */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.danger .ak-editor-panel': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&[data-panel-type="info"]': {
                backgroundColor: "var(--ds-blanket-danger, #EF5C4814)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '.ak-editor-panel__icon[data-panel-type="info"]': {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                    color: `${"var(--ds-icon-danger, #C9372C)"}`
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&[data-panel-type="note"]': {
                backgroundColor: "var(--ds-blanket-danger, #EF5C4814)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '.ak-editor-panel__icon[data-panel-type="note"]': {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                    color: `${"var(--ds-icon-danger, #C9372C)"}`
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&[data-panel-type="success"]': {
                backgroundColor: "var(--ds-blanket-danger, #EF5C4814)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '.ak-editor-panel__icon[data-panel-type="success"]': {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                    color: `${"var(--ds-icon-danger, #C9372C)"}`
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&[data-panel-type="warning"]': {
                backgroundColor: "var(--ds-blanket-danger, #EF5C4814)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '.ak-editor-panel__icon[data-panel-type="warning"]': {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                    color: `${"var(--ds-icon-danger, #C9372C)"}`
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&[data-panel-type="error"]': {
                backgroundColor: "var(--ds-blanket-danger, #EF5C4814)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '.ak-editor-panel__icon[data-panel-type="error"]': {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                    color: `${"var(--ds-icon-danger, #C9372C)"}`
                }
            }
        }
    }
});


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled



const $b0ef43f6c63956f4$var$blockNodesVerticalMargin = '0.75rem';
const $b0ef43f6c63956f4$var$scaledBlockNodesVerticalMargin = '0.75em';
const $b0ef43f6c63956f4$export$63635a8b56f58eca = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.ProseMirror p': {
        // The `editor.font.body` token is used for the UGC typography theme.
        // We don't use `editorUGCToken('editor.font.body')` here because we want to build this styles statically.
        // See platform/packages/editor/editor-common/src/ugc-tokens/get-editor-ugc-token.tsx
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: 'normal 400 1em/1.714 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        marginTop: $b0ef43f6c63956f4$var$scaledBlockNodesVerticalMargin,
        marginBottom: 0
    }
});
const $b0ef43f6c63956f4$export$3de2f7ce686aadc2 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.ProseMirror p': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '1em',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 1.714,
        fontWeight: "var(--ds-font-weight-regular, 400)",
        marginTop: $b0ef43f6c63956f4$var$scaledBlockNodesVerticalMargin,
        marginBottom: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        letterSpacing: '-0.005em'
    }
});
const $b0ef43f6c63956f4$export$29f6e72d2a83d55a = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.ProseMirror p': {
        // The `editor.font.body` token is used for the UGC typography theme.
        // We don't use `editorUGCToken('editor.font.body')` here because we want to build this styles statically.
        // See platform/packages/editor/editor-common/src/ugc-tokens/get-editor-ugc-token.tsx
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: 'normal 400 1em/1.714 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        marginTop: $b0ef43f6c63956f4$var$blockNodesVerticalMargin,
        marginBottom: 0
    }
});
const $b0ef43f6c63956f4$export$a251c8dae8d8433a = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.ProseMirror p': {
        // The `editor.font.body` token is used for the UGC typography theme.
        // We don't use `editorUGCToken('editor.font.body')` here because we want to build this styles statically.
        // See platform/packages/editor/editor-common/src/ugc-tokens/get-editor-ugc-token.tsx
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: 'normal 400 1em/1.714 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        marginTop: $b0ef43f6c63956f4$var$blockNodesVerticalMargin,
        marginBottom: 0
    }
});
const $b0ef43f6c63956f4$export$855ac5a16d662324 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.ProseMirror p': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '1em',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 1.714,
        fontWeight: "var(--ds-font-weight-regular, 400)",
        marginTop: $b0ef43f6c63956f4$var$blockNodesVerticalMargin,
        marginBottom: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        letterSpacing: '-0.005em'
    }
});


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled



function $56a35bdc54338480$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $56a35bdc54338480$export$56bce713f2cb8aa7 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror span[data-placeholder]': {
        color: "var(--ds-text-subtlest, #6B6E76)",
        display: 'inline'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror span.pm-placeholder': {
        display: 'inline',
        color: "var(--ds-text-subtlest, #6B6E76)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror span.pm-placeholder__text': {
        display: 'inline',
        color: "var(--ds-text-subtlest, #6B6E76)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror span.pm-placeholder.ak-editor-selected-node': {
        // ...backgroundSelectionStyles
        backgroundColor: "var(--ds-background-selected, #E9F2FE)",
        // ...backgroundSelectionStyles -> hideNativeBrowserTextSelectionStyles
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&::selection,*::selection': {
            backgroundColor: 'transparent'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-nested-selectors
        '&::-moz-selection,*::-moz-selection': {
            backgroundColor: 'transparent'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror span.pm-placeholder__text[data-placeholder]::after': {
        color: "var(--ds-text-subtlest, #6B6E76)",
        cursor: 'text',
        content: 'attr(data-placeholder)',
        display: 'inline'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ProseMirror-fake-text-cursor': {
            display: 'inline',
            pointerEvents: 'none',
            position: 'relative'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ProseMirror-fake-text-cursor::after': {
            content: '""',
            display: 'inline',
            top: 0,
            position: 'absolute',
            borderRight: `1px solid ${"var(--ds-border, #0B120E24)"}`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ProseMirror-fake-text-selection': {
            display: 'inline',
            pointerEvents: 'none',
            position: 'relative',
            // Follow the system highlight colour to match native text selection
            backgroundColor: 'Highlight',
            // We should also match the text colour to the system highlight text colour.
            // That way if the system highlight background is dark, the text will still be readable.
            color: 'HighlightText'
        }
    }
});
const $56a35bdc54338480$export$d3bdc0d52bb6c2c8 = {
    name: "1leac1l",
    styles: ".ProseMirror .placeholder-decoration{color:var(--ds-text-subtlest, #6B6E76);width:100%;pointer-events:none;user-select:none;.placeholder-android{pointer-events:none;outline:none;user-select:none;position:absolute;}}"
};
const $56a35bdc54338480$export$ec7b3b2c50356d2e = {
    name: "9a360",
    styles: ".ProseMirror p:has(.placeholder-decoration-hide-overflow){overflow:hidden;white-space:nowrap;text-overflow:ellipsis;}"
};
const $56a35bdc54338480$export$959bd343ec1d44de = {
    name: "25qy8u",
    styles: ".ProseMirror mark[data-type-ahead-query=\"true\"]:has(.placeholder-decoration-wrap){white-space:nowrap;}"
};


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled






function $8ca5e17fea10ef42$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8ca5e17fea10ef42$export$a06160db3520e5a2 = 'resizer-item';
const $8ca5e17fea10ef42$export$c42cdcfd48254bda = 'resizer-hover-zone';
const $8ca5e17fea10ef42$export$10b67c6ff1748bd = 'resizer-is-extended';
const $8ca5e17fea10ef42$export$6afc20f0ff6d041 = 'resizer-handle';
const $8ca5e17fea10ef42$export$a5792d7e2a486d41 = `${$8ca5e17fea10ef42$export$6afc20f0ff6d041}-track`;
const $8ca5e17fea10ef42$export$2201bc1aaee73f36 = `${$8ca5e17fea10ef42$export$6afc20f0ff6d041}-thumb`;
const $8ca5e17fea10ef42$export$97a99610b6f0a178 = `${$8ca5e17fea10ef42$export$6afc20f0ff6d041}-danger`;
const $8ca5e17fea10ef42$export$b5fa87f62ced4967 = 3;
const $8ca5e17fea10ef42$export$b123b2c8a2536d05 = 'resizer-handle-wrapper';
const $8ca5e17fea10ef42$export$ce55ec61aa49b942 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$8ca5e17fea10ef42$export$a06160db3520e5a2}`]: {
        willChange: 'width',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&:hover, &.display-handle': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`& > .${$8ca5e17fea10ef42$export$b123b2c8a2536d05} > .${$8ca5e17fea10ef42$export$6afc20f0ff6d041}`]: {
                visibility: 'visible',
                opacity: 1
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.is-resizing': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`& .${$8ca5e17fea10ef42$export$2201bc1aaee73f36}`]: {
                background: "var(--ds-border-focused, #4688EC)"
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`&.${$8ca5e17fea10ef42$export$97a99610b6f0a178}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`& .${$8ca5e17fea10ef42$export$2201bc1aaee73f36}`]: {
                transition: 'none',
                background: "var(--ds-icon-danger, #C9372C)"
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$8ca5e17fea10ef42$export$6afc20f0ff6d041}`]: {
        display: 'flex',
        visibility: 'hidden',
        opacity: 0,
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: 7,
        transition: 'visibility 0.2s, opacity 0.2s',
        // NOTE: The below style is targeted at the div element added by the tooltip. We don't have any means of injecting styles
        // into the tooltip
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "& div[role='presentation']": {
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: "var(--ds-space-negative-200, -16px)",
            whiteSpace: 'normal'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.left': {
            alignItems: 'flex-start'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.right': {
            alignItems: 'flex-end'
        },
        // Handle Sizing
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.small': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`& .${$8ca5e17fea10ef42$export$2201bc1aaee73f36}`]: {
                height: 43
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.medium': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`& .${$8ca5e17fea10ef42$export$2201bc1aaee73f36}`]: {
                height: 64
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.large': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`& .${$8ca5e17fea10ef42$export$2201bc1aaee73f36}`]: {
                height: 96
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.clamped': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`& .${$8ca5e17fea10ef42$export$2201bc1aaee73f36}`]: {
                height: 'clamp(43px, calc(100% - 32px), 96px)'
            }
        },
        // Handle Alignment
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.sticky': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`& .${$8ca5e17fea10ef42$export$2201bc1aaee73f36}`]: {
                position: 'sticky',
                top: "var(--ds-space-150, 12px)",
                bottom: "var(--ds-space-150, 12px)"
            }
        },
        '&:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`& .${$8ca5e17fea10ef42$export$2201bc1aaee73f36}`]: {
                background: "var(--ds-border-focused, #4688EC)"
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`& .${$8ca5e17fea10ef42$export$a5792d7e2a486d41}`]: {
                visibility: 'visible',
                opacity: 0.5
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$8ca5e17fea10ef42$export$2201bc1aaee73f36}`]: {
        content: "' '",
        display: 'flex',
        width: 3,
        margin: `0 ${"var(--ds-space-025, 2px)"}`,
        height: 64,
        transition: 'background-color 0.2s',
        borderRadius: "var(--ds-radius-medium, 6px)",
        border: 0,
        padding: 0,
        zIndex: 2,
        outline: 'none',
        minHeight: 24,
        background: "var(--ds-border, #0B120E24)",
        '&:hover': {
            cursor: 'col-resize'
        },
        '&:focus': {
            background: "var(--ds-border-selected, #1868DB)",
            '&::after': {
                content: "''",
                position: 'absolute',
                top: "var(--ds-space-negative-050, -4px)",
                right: "var(--ds-space-negative-050, -4px)",
                bottom: "var(--ds-space-negative-050, -4px)",
                left: "var(--ds-space-negative-050, -4px)",
                border: `2px solid ${"var(--ds-border-focused, #4688EC)"}`,
                borderRadius: 'inherit',
                zIndex: -1
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$8ca5e17fea10ef42$export$a5792d7e2a486d41}`]: {
        visibility: 'hidden',
        position: 'absolute',
        width: 7,
        height: 'calc(100% - 40px)',
        borderRadius: "var(--ds-radius-small, 4px)",
        opacity: 0,
        transition: 'background-color 0.2s, visibility 0.2s, opacity 0.2s',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.none': {
            background: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.shadow': {
            background: "var(--ds-background-selected, #E9F2FE)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.full-height': {
            background: "var(--ds-background-selected, #E9F2FE)",
            height: '100%',
            minHeight: 36
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    '.ak-editor-selected-node': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`& .${$8ca5e17fea10ef42$export$2201bc1aaee73f36}`]: {
            background: "var(--ds-border-focused, #4688EC)"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.ak-editor-no-interaction .ak-editor-selected-node .${$8ca5e17fea10ef42$export$6afc20f0ff6d041}:not(:hover) .${$8ca5e17fea10ef42$export$2201bc1aaee73f36}`]: {
        background: "var(--ds-border, #0B120E24)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`&.resizer-hover-zone-cls-fix .${$8ca5e17fea10ef42$export$c42cdcfd48254bda}`]: {
        display: 'flow-root'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$8ca5e17fea10ef42$export$c42cdcfd48254bda}`]: {
        position: 'relative',
        display: 'inline-block',
        width: '100%',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`&.${$8ca5e17fea10ef42$export$10b67c6ff1748bd}`]: {
            padding: `0 ${"var(--ds-space-150, 12px)"}`,
            left: "var(--ds-space-negative-150, -12px)"
        }
    },
    // This below style is here to make sure the image width is correct when nested in a table
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`table .${$8ca5e17fea10ef42$export$c42cdcfd48254bda}, table .${$8ca5e17fea10ef42$export$c42cdcfd48254bda}.${$8ca5e17fea10ef42$export$10b67c6ff1748bd}`]: {
        padding: 'unset',
        left: 'unset'
    }
});
const $8ca5e17fea10ef42$export$21b363e15a3a4b0b = {
    name: "1rqtth7",
    styles: ".pm-breakout-resize-handle-rail-wrapper{display:flex;align-items:center;justify-content:center;height:100%;cursor:col-resize;border-radius:var(--ds-radius-small, 4px);z-index:2;[role=\"presentation\"]{height:100%;width:100%;}.pm-breakout-resize-handle-rail-inside-tooltip{height:100%;}}"
};
const $8ca5e17fea10ef42$export$241444dc11ae22d6 = {
    name: "zqeg2w",
    styles: ".fabric-editor-breakout-mark{&:has([data-prosemirror-node-name=\"layoutSection\"].first-node-in-document){> .pm-breakout-resize-handle-container{height:calc(100% - 8px);}}}"
};
const $8ca5e17fea10ef42$export$62cd5dfd9881f590 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.fabric-editor-breakout-mark': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:has([data-prosemirror-node-name="codeBlock"])': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> .pm-breakout-resize-handle-container--left': {
                left: '-12px'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> .pm-breakout-resize-handle-container--right': {
                right: '-12px'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> .pm-breakout-resize-handle-container': {
                height: 'calc(100% - 12px)'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:has([data-prosemirror-node-name="expand"]), &:has([data-prosemirror-node-name="layoutSection"])': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> .pm-breakout-resize-handle-container--left': {
                left: '-32px'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> .pm-breakout-resize-handle-container--right': {
                right: '-32px'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:has([data-prosemirror-node-name="expand"])': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> .pm-breakout-resize-handle-container': {
                height: 'calc(100% - 4px)'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:has([data-prosemirror-node-name="layoutSection"])': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> .pm-breakout-resize-handle-container': {
                height: 'calc(100% - 8px)'
            }
        },
        // the first node in the document always has margin-top = 0
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:has(.first-node-in-document)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> .pm-breakout-resize-handle-container': {
                height: '100%'
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.pm-breakout-resize-handle-container': {
        position: 'relative',
        alignSelf: 'end',
        gridRow: 1,
        gridColumn: 1,
        height: '100%',
        width: 7
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.pm-breakout-resize-handle-container--left': {
        justifySelf: 'start'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.pm-breakout-resize-handle-container--right': {
        justifySelf: 'end'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.pm-breakout-resize-handle-rail': {
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        cursor: 'col-resize',
        borderRadius: "var(--ds-radius-small, 4px)",
        transition: 'background-color 0.2s, visibility 0.2s, opacity 0.2s',
        zIndex: 2,
        opacity: 0,
        '&:hover': {
            background: "var(--ds-background-selected, #E9F2FE)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.pm-breakout-resize-handle-thumb': {
                background: "var(--ds-border-focused, #4688EC)"
            }
        }
    },
    // same as 'hover' styles above
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.pm-breakout-resize-handle-container--active': {
        background: "var(--ds-background-selected, #E9F2FE)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.pm-breakout-resize-handle-thumb': {
            background: "var(--ds-border-focused, #4688EC)"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.pm-breakout-resize-handle-hit-box': {
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: -20,
        right: -20,
        zIndex: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.pm-breakout-resize-handle-thumb': {
        minWidth: $8ca5e17fea10ef42$export$b5fa87f62ced4967,
        // copied from resizeStyles.clamped
        height: 'clamp(27px, calc(100% - 32px), 96px)',
        background: "var(--ds-border, #0B120E24)",
        borderRadius: "var(--ds-radius-medium, 6px)",
        // sticky styles
        position: 'sticky',
        top: "var(--ds-space-150, 12px)",
        bottom: "var(--ds-space-150, 12px)"
    }
});
const $8ca5e17fea10ef42$export$4f3e1cb10ec03a18 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.fabric-editor-breakout-mark': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:has([data-prosemirror-node-name="codeBlock"])': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> .pm-breakout-resize-handle-container--left': {
                left: '-5px'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> .pm-breakout-resize-handle-container--right': {
                right: '-5px'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> .pm-breakout-resize-handle-container': {
                height: 'calc(100% - 12px)'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:has([data-prosemirror-node-name="expand"]), &:has([data-prosemirror-node-name="layoutSection"])': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> .pm-breakout-resize-handle-container--left': {
                left: '-25px'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> .pm-breakout-resize-handle-container--right': {
                right: '-25px'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:has([data-prosemirror-node-name="expand"])': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> .pm-breakout-resize-handle-container': {
                height: 'calc(100% - 4px)'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:has([data-prosemirror-node-name="layoutSection"])': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> .pm-breakout-resize-handle-container': {
                height: 'calc(100% - 8px)'
            }
        },
        // the first node in the document always has margin-top = 0
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:has(.first-node-in-document)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> .pm-breakout-resize-handle-container': {
                height: '100%'
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.pm-breakout-resize-handle-container': {
        position: 'relative',
        alignSelf: 'end',
        gridRow: 1,
        gridColumn: 1,
        height: '100%',
        width: 7
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.pm-breakout-resize-handle-container--left': {
        justifySelf: 'start'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.pm-breakout-resize-handle-container--right': {
        justifySelf: 'end'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.pm-breakout-resize-handle-rail': {
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        cursor: 'col-resize',
        borderRadius: "var(--ds-radius-small, 4px)",
        transition: 'background-color 0.2s, visibility 0.2s, opacity 0.2s',
        zIndex: 2,
        opacity: 0,
        '&:hover': {
            background: "var(--ds-background-selected, #E9F2FE)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.pm-breakout-resize-handle-thumb': {
                background: "var(--ds-border-focused, #4688EC)"
            }
        }
    },
    // same as 'hover' styles above
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.pm-breakout-resize-handle-container--active': {
        background: "var(--ds-background-selected, #E9F2FE)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.pm-breakout-resize-handle-thumb': {
            background: "var(--ds-border-focused, #4688EC)"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.pm-breakout-resize-handle-hit-box': {
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: -20,
        right: -20,
        zIndex: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.pm-breakout-resize-handle-thumb': {
        minWidth: $8ca5e17fea10ef42$export$b5fa87f62ced4967,
        // copied from resizeStyles.clamped
        height: 'clamp(27px, calc(100% - 32px), 96px)',
        background: "var(--ds-border, #0B120E24)",
        borderRadius: "var(--ds-radius-medium, 6px)",
        // sticky styles
        position: 'sticky',
        top: "var(--ds-space-150, 12px)",
        bottom: "var(--ds-space-150, 12px)"
    }
});
const $8ca5e17fea10ef42$export$2785010673d864e4 = /*#__PURE__*/ (0, $9K4OG.css)({
    /* container editor-area is defined in platform/packages/editor/editor-core/src/ui/Appearance/FullPage/StyledComponents.ts */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`@container editor-area (max-width: ${0, $aFUXX.akEditorFullPageNarrowBreakout}px)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.fabric-editor-breakout-mark': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:has([data-prosemirror-node-name="expand"]), &:has([data-prosemirror-node-name="layoutSection"])': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '> .pm-breakout-resize-handle-container': {
                    opacity: 0,
                    visibility: 'hidden'
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:has([data-prosemirror-node-name="layoutSection"])': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
                [`.${$8ca5e17fea10ef42$export$a06160db3520e5a2}`]: {
                    willChange: 'width',
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                    '&:hover, &.display-handle': {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
                        [`& > .${$8ca5e17fea10ef42$export$b123b2c8a2536d05} > .${$8ca5e17fea10ef42$export$6afc20f0ff6d041}`]: {
                            visibility: 'hidden',
                            opacity: 0
                        }
                    }
                }
            }
        }
    }
});


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled






const $0e823357fa8df654$export$2413e968422424ec = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror hr': {
        border: 'none',
        backgroundColor: "var(--ds-border, #0B120E24)",
        height: '2px',
        borderRadius: '1px',
        // this should use token('radius.full') but cannot since the element has padding which increases its height beyond 2px
        cursor: 'pointer',
        padding: `${"var(--ds-space-050, 4px)"} 0`,
        margin: `${"var(--ds-space-300, 24px)"} 0`,
        backgroundClip: 'content-box'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.ProseMirror hr.${0, $aFUXX.akEditorSelectedNodeClassName}`]: {
        outline: 'none',
        backgroundColor: "var(--ds-border-selected, #1868DB)"
    }
});
const $0e823357fa8df654$export$e425548b5cacd57 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.ProseMirror hr.${0, $aFUXX.akEditorSelectedNodeClassName}.danger`]: {
        backgroundColor: "var(--ds-border-danger, #E2483D)"
    }
});


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
function $887f0254bcb2b3a0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $887f0254bcb2b3a0$export$b2380b18b089518f = {
    name: "18ng4c4",
    styles: "-ms-overflow-style:-ms-autohiding-scrollbar;&::-webkit-scrollbar-corner{display:none;}&::-webkit-scrollbar-thumb{background-color:var(--ds-background-neutral-subtle, #00000000);}&:hover::-webkit-scrollbar-thumb{background-color:var(--ds-background-neutral-bold, #292A2E);border-radius:var(--ds-radius-large, 8px);}&::-webkit-scrollbar-thumb:hover{background-color:var(--ds-background-neutral-bold-hovered, #3B3D42);}"
};






const $14a90d57d6df814c$var$fadeIn = (0, $9K4OG.keyframes)({
    from: {
        opacity: 0,
        transform: 'translateY(16px)'
    },
    to: {
        opacity: 1,
        transform: 'translateY(0)'
    }
});
const $14a90d57d6df814c$export$1629cb32bbba3a7e = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "[aria-label='Selection toolbar']": {
        animationName: $14a90d57d6df814c$var$fadeIn,
        animationDuration: `0.2s`,
        animationTimingFunction: `cubic-bezier(0.6, 0, 0, 1)`
    }
});


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled



const $f08f86940ab6d6a2$export$4735dd2b0fa88aa5 = {
    RIGHT_SHADOW: 'right-shadow',
    LEFT_SHADOW: 'left-shadow'
};
const $f08f86940ab6d6a2$export$1cbe0bb16052178d = {
    SENTINEL_LEFT: 'sentinel-left',
    SENTINEL_RIGHT: 'sentinel-right',
    SHADOW_CONTAINER: 'with-shadow-observer'
};
const $f08f86940ab6d6a2$export$9750a92ac0203c10 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`& .${$f08f86940ab6d6a2$export$4735dd2b0fa88aa5.RIGHT_SHADOW}::before, .${$f08f86940ab6d6a2$export$4735dd2b0fa88aa5.RIGHT_SHADOW}::after, .${$f08f86940ab6d6a2$export$4735dd2b0fa88aa5.LEFT_SHADOW}::before, .${$f08f86940ab6d6a2$export$4735dd2b0fa88aa5.LEFT_SHADOW}::after`]: {
            display: 'none',
            position: 'absolute',
            pointerEvents: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            zIndex: 2,
            width: 8,
            content: "''",
            height: 'calc(100%)'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`& .${$f08f86940ab6d6a2$export$4735dd2b0fa88aa5.RIGHT_SHADOW}, .${$f08f86940ab6d6a2$export$4735dd2b0fa88aa5.LEFT_SHADOW}`]: {
            position: 'relative'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`& .${$f08f86940ab6d6a2$export$4735dd2b0fa88aa5.LEFT_SHADOW}::before`]: {
            background: `linear-gradient(to left, transparent 0, ${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 140% ), linear-gradient( to right, ${"var(--ds-shadow-overflow-perimeter, transparent)"} 0px, transparent 1px)`,
            top: 0,
            left: 0,
            display: 'block'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`& .${$f08f86940ab6d6a2$export$4735dd2b0fa88aa5.RIGHT_SHADOW}::after`]: {
            background: `linear-gradient(to right, transparent 0, ${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 140% ), linear-gradient( to left, ${"var(--ds-shadow-overflow-perimeter, transparent)"} 0px, transparent 1px)`,
            right: 0,
            top: 0,
            display: 'block'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`& .${$f08f86940ab6d6a2$export$1cbe0bb16052178d.SENTINEL_LEFT}`]: {
            height: '100%',
            width: 0,
            minWidth: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`& .${$f08f86940ab6d6a2$export$1cbe0bb16052178d.SENTINEL_RIGHT}`]: {
            height: '100%',
            width: 0,
            minWidth: 0
        }
    }
});


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled







const $535dd5d33c38cc84$export$32f80df830e375f6 = 'datasourceView-content-inner-wrap';
const $535dd5d33c38cc84$export$863ae87a9d233606 = 'card-floating-toolbar--link-picker';
const $535dd5d33c38cc84$export$4ccd31bf665a88f6 = {
    INLINE_CARD_CONTAINER: 'inlineCardView-content-wrap',
    BLOCK_CARD_CONTAINER: 'blockCardView-content-wrap',
    EMBED_CARD_CONTAINER: 'embedCardView-content-wrap',
    DATASOURCE_CONTAINER: 'datasourceView-content-wrap',
    LOADER_WRAPPER: 'loader-wrapper'
};
const $535dd5d33c38cc84$export$f64b12e3fb171ebc = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.INLINE_CARD_CONTAINER}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-inlinecard-button-overlay="icon-wrapper-line-height"] span': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: 0
        }
    }
});
const $535dd5d33c38cc84$export$1fef993256efc96e = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-nested-selectors
    [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.EMBED_CARD_CONTAINER}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`&[data-testid="show-diff-changed-decoration-node"] .${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div::after`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
            boxShadow: `0 0 0 1px var(--diff-decoration-marker-color)`,
            borderColor: 'transparent'
        }
    }
});
const $535dd5d33c38cc84$export$4d8f0e547724198 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-nested-selectors
    [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.EMBED_CARD_CONTAINER}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-nested-selectors
        [`&.show-diff-deleted-node .${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div::after`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
            boxShadow: `0 0 0 1px ${"var(--ds-border-accent-gray, #7D818A)"}`,
            borderColor: 'transparent'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.mediaSingleView-content-wrap.show-diff-deleted-node': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& > div': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
            boxShadow: `0 0 0 1px ${"var(--ds-border-accent-gray, #7D818A)"}`,
            borderRadius: "var(--ds-radius-small, 4px)"
        }
    }
});
const $535dd5d33c38cc84$export$b346a5d6d598424c = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.INLINE_CARD_CONTAINER}`]: {
        maxWidth: 'calc(100% - 20px)',
        verticalAlign: 'top',
        wordBreak: 'break-all',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.card-with-comment': {
            background: "var(--ds-background-accent-yellow-subtler, #F5E989)",
            borderBottom: `2px solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
            boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.card': {
            paddingLeft: "var(--ds-space-025, 2px)",
            paddingRight: "var(--ds-space-025, 2px)",
            paddingTop: "var(--ds-space-100, 0.5em)",
            paddingBottom: "var(--ds-space-100, 0.5em)",
            marginBottom: "var(--ds-space-negative-100, -0.5em)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > a:focus`]: [
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $65bb5c5a687b3665$export$a716852a0c5e54d5)
            ]
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.ak-editor-selected-node .${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > a`]: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a716852a0c5e54d5)
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > a`]: {
            // EDM-1717: box-shadow Safari fix start
            zIndex: 1,
            position: 'relative'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > a`]: {
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`,
                // EDM-1717: box-shadow Safari fix start
                zIndex: 2
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.BLOCK_CARD_CONTAINER}`]: {
        display: 'block',
        margin: '0.75rem 0 0',
        maxWidth: `${760}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.ak-editor-selected-node .${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div`]: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a716852a0c5e54d5),
            {
                borderRadius: "var(--ds-radius-large, 8px)"
            }
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div`]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"} !important`
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.DATASOURCE_CONTAINER}.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.BLOCK_CARD_CONTAINER}`]: {
        maxWidth: '100%',
        display: 'flex',
        justifyContent: 'center',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$535dd5d33c38cc84$export$32f80df830e375f6}`]: {
            cursor: 'pointer',
            backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
            borderRadius: "var(--ds-radius-large, 8px)",
            border: `1px solid ${"var(--ds-border, #0B120E24)"}`,
            overflow: 'hidden'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.ak-editor-selected-node': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$535dd5d33c38cc84$export$32f80df830e375f6}`]: [
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $65bb5c5a687b3665$export$a716852a0c5e54d5),
                {
                    'input::selection': {
                        backgroundColor: "var(--ds-background-selected-hovered, #CFE1FD)"
                    },
                    'input::-moz-selection': {
                        backgroundColor: "var(--ds-background-selected-hovered, #CFE1FD)"
                    }
                }
            ]
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$535dd5d33c38cc84$export$32f80df830e375f6}`]: {
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.EMBED_CARD_CONTAINER}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div`]: {
            cursor: 'pointer',
            '&::after': {
                transition: 'box-shadow 0s'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.ak-editor-selected-node .${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div::after`]: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a716852a0c5e54d5)
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.media-card-frame::after': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"} !important`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                background: `${"var(--ds-background-danger, #FFECEB)"} !important`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.richMedia-resize-handle-right::after, .richMedia-resize-handle-left::after': {
                background: "var(--ds-border-danger, #E2483D)"
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$535dd5d33c38cc84$export$863ae87a9d233606}`]: {
        padding: 0
    }
});
const $535dd5d33c38cc84$export$56d86af0724ad29e = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.INLINE_CARD_CONTAINER}`]: {
        maxWidth: 'calc(100% - 20px)',
        verticalAlign: 'top',
        wordBreak: 'break-all',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.card-with-comment': {
            background: "var(--ds-background-accent-yellow-subtler, #F5E989)",
            borderBottom: `2px solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
            boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.card': {
            paddingLeft: "var(--ds-space-025, 2px)",
            paddingRight: "var(--ds-space-025, 2px)",
            paddingTop: "var(--ds-space-100, 0.5em)",
            paddingBottom: "var(--ds-space-100, 0.5em)",
            marginBottom: "var(--ds-space-negative-100, -0.5em)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > a:focus`]: [
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $65bb5c5a687b3665$export$a716852a0c5e54d5)
            ]
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.ak-editor-selected-node .${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > a`]: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a716852a0c5e54d5)
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.ak-editor-selected-node:not(.search-match-block) .${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > a`]: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0)
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > a`]: {
            // EDM-1717: box-shadow Safari fix start
            zIndex: 1,
            position: 'relative'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > a`]: {
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`,
                // EDM-1717: box-shadow Safari fix start
                zIndex: 2
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.BLOCK_CARD_CONTAINER}`]: {
        display: 'block',
        margin: '0.75rem 0 0',
        maxWidth: `${760}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.ak-editor-selected-node .${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div`]: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a716852a0c5e54d5),
            {
                borderRadius: "var(--ds-radius-large, 8px)"
            }
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div`]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"} !important`
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.DATASOURCE_CONTAINER}.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.BLOCK_CARD_CONTAINER}`]: {
        maxWidth: '100%',
        display: 'flex',
        justifyContent: 'center',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$535dd5d33c38cc84$export$32f80df830e375f6}`]: {
            cursor: 'pointer',
            backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
            borderRadius: "var(--ds-radius-large, 8px)",
            border: `1px solid ${"var(--ds-border, #0B120E24)"}`,
            overflow: 'hidden'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.ak-editor-selected-node': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$535dd5d33c38cc84$export$32f80df830e375f6}`]: [
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $65bb5c5a687b3665$export$a716852a0c5e54d5),
                {
                    'input::selection': {
                        backgroundColor: "var(--ds-background-selected-hovered, #CFE1FD)"
                    },
                    'input::-moz-selection': {
                        backgroundColor: "var(--ds-background-selected-hovered, #CFE1FD)"
                    }
                }
            ]
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$535dd5d33c38cc84$export$32f80df830e375f6}`]: {
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.EMBED_CARD_CONTAINER}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div`]: {
            cursor: 'pointer',
            '&::after': {
                transition: 'box-shadow 0s'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.ak-editor-selected-node .${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div::after`]: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a716852a0c5e54d5)
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.ak-editor-selected-node:not(.search-match-block) .${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div::after`]: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0)
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.media-card-frame::after': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"} !important`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                background: `${"var(--ds-background-danger, #FFECEB)"} !important`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.richMedia-resize-handle-right::after, .richMedia-resize-handle-left::after': {
                background: "var(--ds-border-danger, #E2483D)"
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$535dd5d33c38cc84$export$863ae87a9d233606}`]: {
        padding: 0
    }
});
const $535dd5d33c38cc84$export$42b66ad40efe5bbe = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.INLINE_CARD_CONTAINER}`]: {
        maxWidth: 'calc(100% - 20px)',
        verticalAlign: 'top',
        wordBreak: 'break-all',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.card-with-comment': {
            background: "var(--ds-background-accent-yellow-subtler, #F5E989)",
            borderBottom: `2px solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
            boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.card': {
            paddingLeft: "var(--ds-space-025, 2px)",
            paddingRight: "var(--ds-space-025, 2px)",
            paddingTop: "var(--ds-space-100, 0.5em)",
            paddingBottom: "var(--ds-space-100, 0.5em)",
            marginBottom: "var(--ds-space-negative-100, -0.5em)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > a:focus`]: [
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $65bb5c5a687b3665$export$a716852a0c5e54d5)
            ]
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.ak-editor-selected-node .${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > a`]: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a716852a0c5e54d5)
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.ak-editor-selected-node:not(.search-match-block):not(.danger) .${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > a`]: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0)
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > a`]: {
            // EDM-1717: box-shadow Safari fix start
            zIndex: 1,
            position: 'relative'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > a`]: {
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`,
                // EDM-1717: box-shadow Safari fix start
                zIndex: 2
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.BLOCK_CARD_CONTAINER}`]: {
        display: 'block',
        margin: '0.75rem 0 0',
        maxWidth: `${760}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.ak-editor-selected-node .${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div`]: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a716852a0c5e54d5),
            {
                borderRadius: "var(--ds-radius-large, 8px)"
            }
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div`]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"} !important`
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.DATASOURCE_CONTAINER}.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.BLOCK_CARD_CONTAINER}`]: {
        maxWidth: '100%',
        display: 'flex',
        justifyContent: 'center',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$535dd5d33c38cc84$export$32f80df830e375f6}`]: {
            cursor: 'pointer',
            backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
            borderRadius: "var(--ds-radius-large, 8px)",
            border: `1px solid ${"var(--ds-border, #0B120E24)"}`,
            overflow: 'hidden'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.ak-editor-selected-node': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$535dd5d33c38cc84$export$32f80df830e375f6}`]: [
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $65bb5c5a687b3665$export$a716852a0c5e54d5),
                {
                    'input::selection': {
                        backgroundColor: "var(--ds-background-selected-hovered, #CFE1FD)"
                    },
                    'input::-moz-selection': {
                        backgroundColor: "var(--ds-background-selected-hovered, #CFE1FD)"
                    }
                }
            ]
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$535dd5d33c38cc84$export$32f80df830e375f6}`]: {
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.EMBED_CARD_CONTAINER}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div`]: {
            cursor: 'pointer',
            '&::after': {
                transition: 'box-shadow 0s'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.ak-editor-selected-node .${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div::after`]: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a716852a0c5e54d5)
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.ak-editor-selected-node:not(.search-match-block) .${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div::after`]: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0)
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.media-card-frame::after': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"} !important`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                background: `${"var(--ds-background-danger, #FFECEB)"} !important`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.richMedia-resize-handle-right::after, .richMedia-resize-handle-left::after': {
                background: "var(--ds-border-danger, #E2483D)"
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$535dd5d33c38cc84$export$863ae87a9d233606}`]: {
        padding: 0
    }
});
const $535dd5d33c38cc84$export$fefb174a4d9f4c0 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`@container editor-area (max-width: ${0, $aFUXX.akEditorFullPageNarrowBreakout}px)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-nested-selectors
        [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.EMBED_CARD_CONTAINER}`]: {
            marginTop: "var(--ds-space-150, 0.75rem)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.EMBED_CARD_CONTAINER}.ak-editor-selected-node .${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div`]: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a716852a0c5e54d5),
            {
                borderRadius: "var(--ds-radius-large, 8px)"
            }
        ]
    }
});
const $535dd5d33c38cc84$export$cb0683bb9c4e1322 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.BLOCK_CARD_CONTAINER}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div`]: {
            cursor: 'pointer',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            a: {
                cursor: 'auto'
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.EMBED_CARD_CONTAINER}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            a: {
                cursor: 'auto'
            }
        }
    }
});
const $535dd5d33c38cc84$export$1a87a16059da4299 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.BLOCK_CARD_CONTAINER}:not(.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.DATASOURCE_CONTAINER})`]: {
        // EDM-11991: Fix list plugin adding padding to ADS AvatarGroup
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'ul, ol': {
            paddingLeft: 'inherit'
        }
    }
});


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled



const $8daea92ba3be6a6e$export$79c8c9ad308bbe07 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.pm-table-cell-content-wrap, .pm-table-header-content-wrap, [data-layout-section]': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.statusView-content-wrap': {
            maxWidth: '100%',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '& > span': {
                width: '100%'
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.statusView-content-wrap': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& > span': {
            cursor: 'pointer',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: 0 // Prevent responsive layouts increasing height of container.
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.danger': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.status-lozenge-span > span': {
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
            backgroundColor: 'rgba(255, 189, 173, 0.5)' // akEditorDeleteBackgroundWithOpacity
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.statusView-content-wrap.ak-editor-selected-node': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.status-lozenge-span > span': {
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-neutral, #0515240F)",
        maxWidth: '100%',
        paddingInline: "var(--ds-space-050, 4px)",
        display: 'inline-flex',
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
        borderRadius: "var(--ds-radius-small, 3px)",
        blockSize: 'min-content',
        position: 'static',
        overflow: 'hidden',
        boxSizing: 'border-box',
        appearance: 'none',
        border: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] .lozenge-text': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '11px',
        fontStyle: 'normal',
        fontFamily: "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        fontWeight: "var(--ds-font-weight-bold, 700)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: '16px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        textTransform: 'uppercase',
        whiteSpace: 'nowrap',
        maxWidth: `calc(200px - ${"var(--ds-space-100, 8px)"})`
    }
});
const $8daea92ba3be6a6e$export$7c209f30e9068068 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.statusView-content-wrap': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.ak-editor-selected-node .status-lozenge-span > span': {
            boxShadow: `0 0 0 2px ${"var(--ds-border-selected, #1868DB)"}`
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] .lozenge-text': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        color: '#292A2E'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=neutral] > .lozenge-wrapper': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        backgroundColor: '#DDDEE1'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=purple] > .lozenge-wrapper': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        backgroundColor: '#D8A0F7'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=blue] > .lozenge-wrapper': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        backgroundColor: '#8FB8F6'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=yellow] > .lozenge-wrapper': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        backgroundColor: '#F9C84E'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=red] > .lozenge-wrapper': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        backgroundColor: '#FD9891'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=green] > .lozenge-wrapper': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        backgroundColor: '#B3DF72'
    }
});
const $8daea92ba3be6a6e$export$8b4cca12f7a094c7 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.statusView-content-wrap:not(.search-match-block)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.ak-editor-selected-node .status-lozenge-span > span': {
            boxShadow: `0 0 0 2px ${"var(--ds-border-selected, #1868DB)"}`
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] .lozenge-text': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        color: '#292A2E'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=neutral] > .lozenge-wrapper': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        backgroundColor: '#DDDEE1'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=purple] > .lozenge-wrapper': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        backgroundColor: '#D8A0F7'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=blue] > .lozenge-wrapper': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        backgroundColor: '#8FB8F6'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=yellow] > .lozenge-wrapper': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        backgroundColor: '#F9C84E'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=red] > .lozenge-wrapper': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        backgroundColor: '#FD9891'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=green] > .lozenge-wrapper': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        backgroundColor: '#B3DF72'
    }
});
const $8daea92ba3be6a6e$export$bd58d1bcb934912c = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.statusView-content-wrap:not(.search-match-block)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.ak-editor-selected-node.danger .status-lozenge-span > span': {
            boxShadow: `0 0 0 2px ${"var(--ds-border-danger, #E2483D)"}`
        }
    }
});
const $8daea92ba3be6a6e$export$dc185896d75d4b4 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.statusView-content-wrap': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.ak-editor-selected-node .status-lozenge-span > span': {
            // getSelectionStyles([SelectionStyle.BoxShadow]);
            boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #1868DB)"}`,
            borderColor: 'transparent',
            // hideNativeBrowserTextSelectionStyles
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&::selection, & *::selection': {
                backgroundColor: 'transparent'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&::-moz-selection, & *::-moz-selection': {
                backgroundColor: 'transparent'
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=neutral] .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-neutral, #0515240F)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=neutral] .lozenge-text': {
        color: "var(--ds-text-subtle, #505258)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=purple] .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-discovery, #F8EEFE)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=purple] .lozenge-text': {
        color: "var(--ds-text-discovery, #803FA5)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=blue] .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-information, #E9F2FE)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=blue] .lozenge-text': {
        color: "var(--ds-text-information, #1558BC)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=yellow] .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-warning, #FFF5DB)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=yellow] .lozenge-text': {
        color: "var(--ds-text-warning, #9E4C00)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=red] .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-danger, #FFECEB)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=red] .lozenge-text': {
        color: "var(--ds-text-danger, #AE2E24)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=green] .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-success, #EFFFD6)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=green] .lozenge-text': {
        color: "var(--ds-text-success, #4C6B1F)"
    }
});
const $8daea92ba3be6a6e$export$60b421c3da7a2a99 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.statusView-content-wrap:not(.search-match-block)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.ak-editor-selected-node .status-lozenge-span > span': {
            // getSelectionStyles([SelectionStyle.BoxShadow]);
            boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #1868DB)"}`,
            borderColor: 'transparent',
            // hideNativeBrowserTextSelectionStyles
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&::selection, & *::selection': {
                backgroundColor: 'transparent'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&::-moz-selection, & *::-moz-selection': {
                backgroundColor: 'transparent'
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=neutral] .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-neutral, #0515240F)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=neutral] .lozenge-text': {
        color: "var(--ds-text-subtle, #505258)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=purple] .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-discovery, #F8EEFE)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=purple] .lozenge-text': {
        color: "var(--ds-text-discovery, #803FA5)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=blue] .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-information, #E9F2FE)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=blue] .lozenge-text': {
        color: "var(--ds-text-information, #1558BC)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=yellow] .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-warning, #FFF5DB)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=yellow] .lozenge-text': {
        color: "var(--ds-text-warning, #9E4C00)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=red] .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-danger, #FFECEB)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=red] .lozenge-text': {
        color: "var(--ds-text-danger, #AE2E24)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=green] .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-success, #EFFFD6)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=green] .lozenge-text': {
        color: "var(--ds-text-success, #4C6B1F)"
    }
});


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled




var $e6n00 = parcelRequire("e6n00");




const $7a476f61d60131cb$export$2ef961ae194ff4dc = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`.${(0, $e6n00.SyncBlockSharedCssClassName).prefix}, .${(0, $e6n00.BodiedSyncBlockSharedCssClassName).prefix}`]: {
            position: 'relative',
            cursor: 'pointer',
            /* Danger when top level node */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger': {
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                backgroundColor: `${"var(--ds-background-danger, #FFECEB)"} !important`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '.ak-editor-panel__icon': {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                    color: `${"var(--ds-icon-danger, #C9372C)"} !important`
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
                [`.${(0, $e6n00.SyncBlockLabelSharedCssClassName).labelClassName}`]: {
                    backgroundColor: "var(--ds-background-danger, #FFECEB)",
                    '&::before': {
                        content: '""',
                        position: 'absolute',
                        top: '-1px',
                        left: '-1px',
                        right: '-1px',
                        bottom: '-1px',
                        border: `1px solid ${"var(--ds-border-danger, #E2483D)"}`,
                        borderRadius: "var(--ds-radius-small, 3px)",
                        mask: 'linear-gradient(to bottom, black 55%, transparent 55%)',
                        WebkitMask: 'linear-gradient(to bottom, black 55%, transparent 55%)',
                        pointerEvents: 'none',
                        zIndex: -1
                    }
                }
            },
            borderRadius: "var(--ds-radius-small, 3px)",
            marginTop: "var(--ds-space-150, 12px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            marginRight: `-${(0, $aFUXX.akEditorGutterPadding)}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            marginLeft: `-${(0, $aFUXX.akEditorGutterPadding)}px`,
            marginBottom: 0,
            paddingTop: "var(--ds-space-050, 4px)",
            paddingBottom: "var(--ds-space-050, 4px)",
            color: 'inherit',
            '&:hover': {
                // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
                boxShadow: `0px 0px 0px 1px ${"var(--ds-border, #0B120E24)"}`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            [`.${(0, $e6n00.BodiedSyncBlockSharedCssClassName).content}`]: {
                padding: '0 32px',
                cursor: 'text'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            [`.${(0, $e6n00.SyncBlockSharedCssClassName).renderer}`]: {
                padding: '0 32px'
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.${(0, $e6n00.SyncBlockSharedCssClassName).prefix}.ak-editor-selected-node:not(.danger), .${(0, $e6n00.BodiedSyncBlockSharedCssClassName).prefix}.ak-editor-selected-node:not(.danger)`]: {
        boxShadow: `0 0 0 1px ${"var(--ds-border-focused, #4688EC)"}`,
        backgroundColor: "var(--ds-background-selected, #E9F2FE)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`.${(0, $e6n00.SyncBlockLabelSharedCssClassName).labelClassName}`]: {
            backgroundColor: "var(--ds-background-selected, #E9F2FE)",
            '&::before': {
                content: '""',
                position: 'absolute',
                top: '-1px',
                left: '-1px',
                right: '-1px',
                bottom: '-1px',
                border: `1px solid ${"var(--ds-border-focused, #4688EC)"}`,
                borderRadius: "var(--ds-radius-small, 3px)",
                mask: 'linear-gradient(to bottom, black 55%, transparent 55%)',
                WebkitMask: 'linear-gradient(to bottom, black 55%, transparent 55%)',
                pointerEvents: 'none',
                zIndex: -1
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.${(0, $e6n00.SyncBlockSharedCssClassName).prefix}.ak-editor-selected-node, .${(0, $e6n00.SyncBlockSharedCssClassName).prefix}:hover, .${(0, $e6n00.BodiedSyncBlockSharedCssClassName).prefix}.ak-editor-selected-node, .${(0, $e6n00.BodiedSyncBlockSharedCssClassName).prefix}:hover, .${(0, $e6n00.BodiedSyncBlockSharedCssClassName).prefix}.danger, ${(0, $e6n00.SyncBlockLabelSharedCssClassName).labelClassName}:hover`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`.${(0, $e6n00.SyncBlockLabelSharedCssClassName).labelClassName}`]: {
            opacity: 1,
            visibility: 'visible'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.${(0, $e6n00.SyncBlockSharedCssClassName).prefix}:has(.${(0, $e6n00.SyncBlockSharedCssClassName).error}), .${(0, $e6n00.BodiedSyncBlockSharedCssClassName).prefix}:has(.${(0, $e6n00.SyncBlockSharedCssClassName).error})`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:hover:not(.ak-editor-selected-node)': {
            boxShadow: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.ak-editor-selected-node, &:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            [`.${(0, $e6n00.SyncBlockLabelSharedCssClassName).labelClassName}`]: {
                opacity: 0,
                visibility: 'hidden'
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.${(0, $e6n00.SyncBlockLabelSharedCssClassName).labelClassName}`]: {
        color: "var(--ds-text-subtle, #505258)",
        borderRadius: "var(--ds-radius-small, 3px)",
        position: 'absolute',
        gap: "var(--ds-space-050, 4px)",
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
        opacity: 0,
        visibility: 'hidden',
        paddingLeft: "var(--ds-space-100, 8px)",
        paddingRight: "var(--ds-space-100, 8px)",
        paddingBottom: "var(--ds-space-050, 4px)",
        paddingTop: "var(--ds-space-050, 4px)",
        top: "var(--ds-space-negative-200, -16px)",
        right: "var(--ds-space-150, 12px)",
        backgroundColor: "var(--ds-surface, #FFFFFF)",
        maxWidth: '140px'
    }
});


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled




function $e5ba48b9f959e381$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e5ba48b9f959e381$export$696afa9d8a2fe544 = {
    name: "p382o5",
    styles: ".pm-table-header-content-wrap :not(.fabric-editor-alignment), .pm-table-header-content-wrap :not(p, .fabric-editor-block-mark) + div.fabric-editor-block-mark, .pm-table-cell-content-wrap :not(p, .fabric-editor-block-mark) + div.fabric-editor-block-mark{p:first-of-type{margin-top:0;}}.pm-table-cell-content-wrap .mediaGroupView-content-wrap{clear:both;}"
};
const $e5ba48b9f959e381$export$5dc8ab529dc33316 = {
    name: "mlsake",
    styles: "margin-left:0;margin-right:0"
};
const $e5ba48b9f959e381$export$61a2da566f69d1df = /*#__PURE__*/ (0, $9K4OG.css)({
    // TODO: ED-28075 - refactor array include to unblock Compiled CSS migration
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.ProseMirror .pm-table-wrapper > table`]: [
        $e5ba48b9f959e381$export$5dc8ab529dc33316,
        (0, $887f0254bcb2b3a0$export$b2380b18b089518f)
    ]
});
const $e5ba48b9f959e381$export$d4422e89f15370f2 = {
    name: "1c5wbsb",
    styles: ".ProseMirror .pm-table-wrapper{max-width:100%;overflow-x:auto;width:100%;box-sizing:border-box;}.ProseMirror .pm-table-wrapper.pm-table-wrapper-no-overflow{overflow-x:visible;}.ProseMirror .pm-table-wrapper table{max-width:100%;width:100%;table-layout:fixed;min-width:auto;}"
};
const $e5ba48b9f959e381$export$a12a9c400154a0fb = {
    name: "vkez57",
    styles: ".ProseMirror .pm-table-wrapper{overflow-y:visible;}"
};


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled








function $b92d63900d735dfd$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b92d63900d735dfd$var$akEditorLineHeight = 1.714;
const $b92d63900d735dfd$var$akEditorSelectedNodeClassName = 'ak-editor-selected-node';
const $b92d63900d735dfd$export$a7172b75d403a0e4 = {
    DECISION_CONTAINER: 'decisionItemView-content-wrap',
    TASK_CONTAINER: 'taskItemView-content-wrap',
    //NOTE: value is a selector (data attribute), not a class name
    TASK_LIST_CONTAINER: '[data-node-type="actionList"]',
    TASK_ITEM: 'task-item',
    TASK_CHECKBOX_CONTAINER: 'task-item-checkbox-wrap'
};
const $b92d63900d735dfd$export$df437277fbc8b4f5 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.taskItemView-content-wrap, .${$b92d63900d735dfd$export$a7172b75d403a0e4.DECISION_CONTAINER}`]: {
            position: 'relative',
            minWidth: 48
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$b92d63900d735dfd$export$a7172b75d403a0e4.DECISION_CONTAINER}`]: {
            marginTop: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$b92d63900d735dfd$export$a7172b75d403a0e4.TASK_CONTAINER}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            "span[contenteditable='false']": {
                height: `${$b92d63900d735dfd$var$akEditorLineHeight}em`
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$b92d63900d735dfd$export$a7172b75d403a0e4.TASK_ITEM}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: $b92d63900d735dfd$var$akEditorLineHeight
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    'div[data-task-local-id]': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "span[contenteditable='false']": {
            height: `${$b92d63900d735dfd$var$akEditorLineHeight}em`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "span[contenteditable='false'] + div": {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${$b92d63900d735dfd$var$akEditorLineHeight}em`
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    'div[data-task-list-local-id]': {
        margin: `${"var(--ds-space-150, 12px)"} 0 0 0`,
        // If task item is not first in the list then set margin top to 4px.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'div + div': {
            marginTop: "var(--ds-space-050, 4px)"
        }
    },
    // If task list is not first in the document then set margin top to 4px.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    'div[data-task-list-local-id] div[data-task-list-local-id]': {
        marginTop: "var(--ds-space-050, 4px)",
        marginLeft: "var(--ds-space-300, 24px)"
    },
    // When action list is inside panel
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ak-editor-panel__content': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
        '> div[data-task-list-local-id]:first-child': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            margin: '0 !important'
        }
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
const $b92d63900d735dfd$var$TASKLIST_CONTAINER_MARGIN_DENSE = `max(0px, calc(10px + (var(--ak-editor-base-font-size, ${(0, $aFUXX.akEditorFullPageDefaultFontSize)}px) - ${(0, $aFUXX.akEditorFullPageDenseFontSize)}px) * (2 / 3)))`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
var $b92d63900d735dfd$var$_ref = {
    name: "0",
    styles: ""
};
const $b92d63900d735dfd$export$715995201f735e2d = (baseFontSize)=>{
    if (!baseFontSize || baseFontSize === (0, $aFUXX.akEditorFullPageDefaultFontSize)) return $b92d63900d735dfd$var$_ref;
    return /*#__PURE__*/ (0, $9K4OG.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        '.ProseMirror': {
            // Task lists
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
            [$b92d63900d735dfd$export$a7172b75d403a0e4.TASK_LIST_CONTAINER]: {
                // Task lists: container top margin
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                marginTop: $b92d63900d735dfd$var$TASKLIST_CONTAINER_MARGIN_DENSE
            },
            // Task lists: sibling items and nested lists
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
            [`${$b92d63900d735dfd$export$a7172b75d403a0e4.TASK_LIST_CONTAINER} > * + *`]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
                marginTop: (0, $7ea00528076df401$export$b9f4317d28be80aa)
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
            [`${$b92d63900d735dfd$export$a7172b75d403a0e4.TASK_LIST_CONTAINER} ${$b92d63900d735dfd$export$a7172b75d403a0e4.TASK_LIST_CONTAINER}, .${$b92d63900d735dfd$export$a7172b75d403a0e4.TASK_CONTAINER} .${$b92d63900d735dfd$export$a7172b75d403a0e4.TASK_CONTAINER}`]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
                marginTop: (0, $7ea00528076df401$export$b9f4317d28be80aa)
            }
        }
    });
};
const $b92d63900d735dfd$export$c2f467e1dc47f4f1 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$b92d63900d735dfd$var$akEditorSelectedNodeClassName} > [data-decision-wrapper], ol[data-node-type='decisionList'].${$b92d63900d735dfd$var$akEditorSelectedNodeClassName}`]: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    [
        {
            borderRadius: "var(--ds-radius-small, 4px)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
        (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
        (0, $65bb5c5a687b3665$export$e7c1f2908e268236),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
        (0, $65bb5c5a687b3665$export$a716852a0c5e54d5)
    ],
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.danger': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$b92d63900d735dfd$export$a7172b75d403a0e4.DECISION_CONTAINER}.${$b92d63900d735dfd$var$akEditorSelectedNodeClassName} > div`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`,
            backgroundColor: "var(--ds-blanket-danger, #EF5C4814)",
            '&::after': {
                content: 'none' // reset the Blanket selection style
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="decisionItem"]': {
        listStyleType: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper]': {
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'row',
        margin: `${"var(--ds-space-100, 8px)"} 0 0 0`,
        padding: "var(--ds-space-100, 8px)",
        paddingLeft: "var(--ds-space-150, 12px)",
        borderRadius: "var(--ds-radius-small, 4px)",
        backgroundColor: "var(--ds-background-neutral, #0515240F)",
        position: 'relative'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper] > [data-component="icon"]': {
        flex: '0 0 16px',
        height: '16px',
        width: '16px',
        margin: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-150, 12px)"} 0 0`,
        color: "var(--ds-icon-subtle, #505258)",
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="decisionItem"]:not(:has([data-empty]):not(:has([data-type-ahead]))) > [data-decision-wrapper] > [data-component="icon"]': {
        color: "var(--ds-icon-success, #6A9A23)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper] > [data-component="icon"] > span': {
        display: 'inline-block',
        flexShrink: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography -- Mirroring icon styles
        lineHeight: 1
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper] > [data-component="icon"] > span > svg': {
        overflow: 'hidden',
        pointerEvents: 'none',
        color: 'currentColor',
        verticalAlign: 'bottom'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper] > [data-component="placeholder"]': {
        margin: `0 0 0 calc(${"var(--ds-space-100, 8px)"} * 3.5)`,
        position: 'absolute',
        color: "var(--ds-text-subtlest, #6B6E76)",
        pointerEvents: 'none',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        maxWidth: 'calc(100% - 50px)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="decisionItem"]:not(:has([data-empty]):not(:has([data-type-ahead]))) > [data-decision-wrapper] > [data-component="placeholder"]': {
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper] > [data-component="content"]': {
        margin: 0,
        wordWrap: 'break-word',
        minWidth: 0,
        flex: '1 1 auto'
    }
});
const $b92d63900d735dfd$export$27a4e7e55add38c4 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-nested-selectors
    [`.${$b92d63900d735dfd$var$akEditorSelectedNodeClassName}.danger > [data-decision-wrapper], ol[data-node-type='decisionList'].${$b92d63900d735dfd$var$akEditorSelectedNodeClassName}.danger`]: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [
        (0, $65bb5c5a687b3665$export$fd4ac125b4ba4c28),
        (0, $65bb5c5a687b3665$export$57f48b634c3a2512)
    ]
});
const $b92d63900d735dfd$export$e237513ae3de60b5 = {
    name: "b3ew8y",
    styles: "[data-prosemirror-node-name=\"decisionItem\"] > [data-decision-wrapper] > [data-component=\"icon\"] > span >  svg[data-icon-source=\"legacy\"]{display:none;}[data-prosemirror-node-name=\"decisionItem\"] > [data-decision-wrapper] > [data-component=\"icon\"] > span{box-sizing:border-box;padding-inline-end:var(--ds--button--new-icon-padding-end, 0);padding-inline-start:var(--ds--button--new-icon-padding-start, 0);@media screen and (forced-colors: active){color:canvastext;filter:grayscale(1);}}[data-prosemirror-node-name=\"decisionItem\"] > [data-decision-wrapper] > [data-component=\"icon\"] > span > svg{width:var(--ds-space-300, 24px);height:var(--ds-space-300, 24px);}"
};
const $b92d63900d735dfd$export$921eec0bd8c26b90 = {
    name: "s6v8rd",
    styles: "[data-prosemirror-node-name=\"decisionItem\"] > [data-decision-wrapper] > [data-component=\"icon\"] > span >  svg[data-icon-source=\"refreshed\"]{display:none;}[data-prosemirror-node-name=\"decisionItem\"] > [data-decision-wrapper] > [data-component=\"icon\"] > span{width:32px;height:32px;@media screen and (forced-colors: active){filter:grayscale(1);color:canvastext;fill:canvas;}}[data-prosemirror-node-name=\"decisionItem\"] > [data-decision-wrapper] > [data-component=\"icon\"] > span > svg{max-width:100%;max-height:100%;fill:var(--ds-surface, #FFFFFF);width:32px;height:32px;}"
};
const $b92d63900d735dfd$export$2a9fa9bb25fe40d2 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="taskItem"]': {
        listStyle: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="taskItem"] [data-component="task-item-main"]': {
        display: 'flex',
        flexDirection: 'row',
        position: 'relative'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="taskItem"] [data-component="placeholder"]': {
        position: 'absolute',
        color: "var(--ds-text-subtlest, #6B6E76)",
        margin: `0 0 0 calc(${"var(--ds-space-100, 8px)"} * 3)`,
        pointerEvents: 'none',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        maxWidth: 'calc(100% - 50px)',
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    "[data-prosemirror-node-name='taskItem']:has([data-empty]):not(:has([data-type-ahead])) [data-component='placeholder']": {
        display: 'block'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="taskItem"] [data-component="content"]': {
        margin: 0,
        wordWrap: 'break-word',
        minWidth: 0,
        flex: '1 1 auto'
    },
    // copied styles from packages/design-system/icon/src/components/icon-new.tsx
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="taskItem"] [data-component="checkbox-icon-wrap"]': {
        display: 'inline-block',
        boxSizing: 'border-box',
        flexShrink: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 1,
        paddingInlineEnd: 'var(--ds--button--new-icon-padding-end, 0)',
        paddingInlineStart: 'var(--ds--button--new-icon-padding-start, 0)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="taskItem"] [data-component="checkbox-icon-wrap"] svg': {
        overflow: 'hidden',
        pointerEvents: 'none',
        color: 'currentColor',
        verticalAlign: 'bottom',
        width: "var(--ds-space-200, 16px)",
        height: "var(--ds-space-200, 16px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-node-name="taskItem"] input[type=checkbox]:not(:checked) + span [data-component=checkbox-checked-icon]': {
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-node-name="taskItem"] input[type=checkbox]:not(:checked) + span [data-component=checkbox-unchecked-icon]': {
        display: 'inline'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="taskItem"] input[type=checkbox]:checked + span [data-component=checkbox-checked-icon]': {
        display: 'inline'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="taskItem"] input[type=checkbox]:checked + span [data-component=checkbox-unchecked-icon]': {
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`[data-prosemirror-node-name="taskItem"] .${$b92d63900d735dfd$export$a7172b75d403a0e4.TASK_CHECKBOX_CONTAINER}`]: {
        flex: '0 0 24px',
        width: '24px',
        height: '24px',
        position: 'relative',
        alignSelf: 'start',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "& > input[type='checkbox']": {
            width: '16px',
            height: '16px',
            zIndex: 1,
            cursor: 'pointer',
            outline: 'none',
            margin: 0,
            opacity: 0,
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&[disabled]': {
                cursor: 'default'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '+ span': {
                width: '24px',
                height: '24px',
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '+ span > svg': {
                boxSizing: 'border-box',
                display: 'inline',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                maxWidth: 'unset',
                maxHeight: 'unset',
                position: 'absolute',
                overflow: 'hidden',
                color: "var(--ds-background-input, #FFFFFF)",
                transition: 'color 0.2s ease-in-out, fill 0.2s ease-in-out',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                'path:first-of-type': {
                    visibility: 'hidden'
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                'rect:first-of-type': {
                    stroke: "var(--ds-border-input, #8C8F97)",
                    strokeWidth: 1,
                    transition: 'stroke 0.2s ease-in-out'
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&:hover + span > svg': {
                color: "var(--ds-background-input-hovered, #F8F8F8)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                'rect:first-of-type': {
                    stroke: "var(--ds-border-input, #8C8F97)"
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&:checked:hover + span > svg': {
                color: "var(--ds-background-selected-bold-hovered, #1558BC)",
                fill: "var(--ds-icon-inverse, #FFFFFF)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                'rect:first-of-type': {
                    stroke: "var(--ds-background-selected-bold-hovered, #1558BC)"
                }
            },
            '&:checked': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
                '+ span > svg': {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                    'path:first-of-type': {
                        visibility: 'visible'
                    },
                    color: "var(--ds-background-selected-bold, #1868DB)",
                    fill: "var(--ds-icon-inverse, #FFFFFF)",
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                    'rect:first-of-type': {
                        stroke: "var(--ds-background-selected-bold, #1868DB)"
                    }
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&:active + span > svg': {
                color: "var(--ds-background-input-pressed, #FFFFFF)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                'rect:first-of-type': {
                    stroke: "var(--ds-border, #0B120E24)"
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&:checked:active + span > svg': {
                color: "var(--ds-background-input-pressed, #FFFFFF)",
                fill: "var(--ds-icon-inverse, #FFFFFF)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                'rect:first-of-type': {
                    stroke: "var(--ds-border, #0B120E24)"
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&:disabled + span > svg, &:disabled:hover + span > svg, &:disabled:focus + span > svg, &:disabled:active + span > svg': {
                color: "var(--ds-background-disabled, #17171708)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                'rect:first-of-type': {
                    stroke: "var(--ds-background-disabled, #17171708)"
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&:disabled:checked + span > svg': {
                fill: "var(--ds-icon-disabled, #080F214A)"
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&:focus + span::after': {
                position: 'absolute',
                width: "var(--ds-space-200, 16px)",
                height: "var(--ds-space-200, 16px)",
                border: `2px solid ${"var(--ds-border-focused, #4688EC)"}`,
                borderRadius: "var(--ds-space-050, 4px)",
                content: "''",
                display: 'block',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)'
            }
        }
    }
});
const $b92d63900d735dfd$export$a261a5b04a85ad9c = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="taskItem"], [data-prosemirror-node-name="blockTaskItem"]': {
        listStyle: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="taskItem"] [data-component="task-item-main"], [data-prosemirror-node-name="blockTaskItem"] [data-component="task-item-main"]': {
        display: 'flex',
        flexDirection: 'row',
        position: 'relative'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="taskItem"] [data-component="placeholder"], [data-prosemirror-node-name="blockTaskItem"] [data-component="placeholder"]': {
        position: 'absolute',
        color: "var(--ds-text-subtlest, #6B6E76)",
        margin: `0 0 0 calc(${"var(--ds-space-100, 8px)"} * 3)`,
        pointerEvents: 'none',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        maxWidth: 'calc(100% - 50px)',
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    "[data-prosemirror-node-name='taskItem']:has([data-empty]):not(:has([data-type-ahead])) [data-component='placeholder'], [data-prosemirror-node-name='blockTaskItem']:has([data-empty]):not(:has([data-type-ahead])) [data-component='placeholder']": {
        display: 'block'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="taskItem"] [data-component="content"], [data-prosemirror-node-name="blockTaskItem"] [data-component="content"]': {
        margin: 0,
        wordWrap: 'break-word',
        minWidth: 0,
        flex: '1 1 auto'
    },
    // copied styles from packages/design-system/icon/src/components/icon-new.tsx
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="taskItem"] [data-component="checkbox-icon-wrap"], [data-prosemirror-node-name="blockTaskItem"] [data-component="checkbox-icon-wrap"]': {
        display: 'inline-block',
        boxSizing: 'border-box',
        flexShrink: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 1,
        paddingInlineEnd: 'var(--ds--button--new-icon-padding-end, 0)',
        paddingInlineStart: 'var(--ds--button--new-icon-padding-start, 0)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="taskItem"] [data-component="checkbox-icon-wrap"] svg, [data-prosemirror-node-name="blockTaskItem"] [data-component="checkbox-icon-wrap"] svg': {
        overflow: 'hidden',
        pointerEvents: 'none',
        color: 'currentColor',
        verticalAlign: 'bottom',
        width: "var(--ds-space-200, 16px)",
        height: "var(--ds-space-200, 16px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-node-name="taskItem"] input[type=checkbox]:not(:checked) + span [data-component=checkbox-checked-icon], [data-prosemirror-node-name="blockTaskItem"] input[type=checkbox]:not(:checked) + span [data-component=checkbox-checked-icon]': {
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-node-name="taskItem"] input[type=checkbox]:not(:checked) + span [data-component=checkbox-unchecked-icon], [data-prosemirror-node-name="blockTaskItem"] input[type=checkbox]:not(:checked) + span [data-component=checkbox-unchecked-icon]': {
        display: 'inline'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="taskItem"] input[type=checkbox]:checked + span [data-component=checkbox-checked-icon], [data-prosemirror-node-name="blockTaskItem"] input[type=checkbox]:checked + span [data-component=checkbox-checked-icon]': {
        display: 'inline'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="taskItem"] input[type=checkbox]:checked + span [data-component=checkbox-unchecked-icon], [data-prosemirror-node-name="blockTaskItem"] input[type=checkbox]:checked + span [data-component=checkbox-unchecked-icon]': {
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`[data-prosemirror-node-name="taskItem"] .${$b92d63900d735dfd$export$a7172b75d403a0e4.TASK_CHECKBOX_CONTAINER}, [data-prosemirror-node-name="blockTaskItem"] .${$b92d63900d735dfd$export$a7172b75d403a0e4.TASK_CHECKBOX_CONTAINER}`]: {
        flex: '0 0 24px',
        width: '24px',
        height: '24px',
        position: 'relative',
        alignSelf: 'start',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "& > input[type='checkbox']": {
            width: '16px',
            height: '16px',
            zIndex: 1,
            cursor: 'pointer',
            outline: 'none',
            margin: 0,
            opacity: 0,
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&[disabled]': {
                cursor: 'default'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '+ span': {
                width: '24px',
                height: '24px',
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '+ span > svg': {
                boxSizing: 'border-box',
                display: 'inline',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                maxWidth: 'unset',
                maxHeight: 'unset',
                position: 'absolute',
                overflow: 'hidden',
                color: "var(--ds-background-input, #FFFFFF)",
                transition: 'color 0.2s ease-in-out, fill 0.2s ease-in-out',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                'path:first-of-type': {
                    visibility: 'hidden'
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                'rect:first-of-type': {
                    stroke: "var(--ds-border-input, #8C8F97)",
                    strokeWidth: 1,
                    transition: 'stroke 0.2s ease-in-out'
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&:hover + span > svg': {
                color: "var(--ds-background-input-hovered, #F8F8F8)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                'rect:first-of-type': {
                    stroke: "var(--ds-border-input, #8C8F97)"
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&:checked:hover + span > svg': {
                color: "var(--ds-background-selected-bold-hovered, #1558BC)",
                fill: "var(--ds-icon-inverse, #FFFFFF)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                'rect:first-of-type': {
                    stroke: "var(--ds-background-selected-bold-hovered, #1558BC)"
                }
            },
            '&:checked': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
                '+ span > svg': {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                    'path:first-of-type': {
                        visibility: 'visible'
                    },
                    color: "var(--ds-background-selected-bold, #1868DB)",
                    fill: "var(--ds-icon-inverse, #FFFFFF)",
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                    'rect:first-of-type': {
                        stroke: "var(--ds-background-selected-bold, #1868DB)"
                    }
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&:active + span > svg': {
                color: "var(--ds-background-input-pressed, #FFFFFF)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                'rect:first-of-type': {
                    stroke: "var(--ds-border, #0B120E24)"
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&:checked:active + span > svg': {
                color: "var(--ds-background-input-pressed, #FFFFFF)",
                fill: "var(--ds-icon-inverse, #FFFFFF)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                'rect:first-of-type': {
                    stroke: "var(--ds-border, #0B120E24)"
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&:disabled + span > svg, &:disabled:hover + span > svg, &:disabled:focus + span > svg, &:disabled:active + span > svg': {
                color: "var(--ds-background-disabled, #17171708)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                'rect:first-of-type': {
                    stroke: "var(--ds-background-disabled, #17171708)"
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&:disabled:checked + span > svg': {
                fill: "var(--ds-icon-disabled, #080F214A)"
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&:focus + span::after': {
                position: 'absolute',
                width: "var(--ds-space-200, 16px)",
                height: "var(--ds-space-200, 16px)",
                border: `2px solid ${"var(--ds-border-focused, #4688EC)"}`,
                borderRadius: "var(--ds-space-050, 4px)",
                content: "''",
                display: 'block',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)'
            }
        }
    }
});


/* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ /* eslint-disable @atlaskit/ui-styling-standard/no-exported-styles */ /* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 


function $4287605bd9e53ba0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4287605bd9e53ba0$var$pulseIn = (0, $9K4OG.keyframes)({
    '0%, 100%': {
        transform: 'scaleX(0)',
        opacity: 0
    },
    '10%': {
        transform: 'scaleX(1.4)',
        opacity: 1
    },
    '15%, 85%': {
        transform: 'scaleX(1)',
        opacity: 1
    }
});
const $4287605bd9e53ba0$var$pulseOut = (0, $9K4OG.keyframes)({
    '0%, 90%, 100%': {
        transform: 'scaleX(1)',
        opacity: 1
    },
    '10%, 80%': {
        transform: 'scaleX(0)',
        opacity: 0
    }
});
const $4287605bd9e53ba0$var$pulseInDuringTr = (0, $9K4OG.keyframes)({
    '0%, 95%': {
        transform: 'scaleX(1)',
        opacity: 1
    },
    '100%': {
        transform: 'scaleX(0)',
        opacity: 0
    }
});
const $4287605bd9e53ba0$var$pulseOutDuringTr = (0, $9K4OG.keyframes)({
    '100%': {
        transform: 'scaleX(1)',
        opacity: 1
    },
    '0%, 90%': {
        transform: 'scaleX(0)',
        opacity: 0
    }
});
const $4287605bd9e53ba0$export$3f28e75e37279280 = {
    name: "ig2c5x",
    styles: ".ProseMirror .telepointer{position:relative;transition:opacity 200ms;&.telepointer-selection:not(.inlineNodeView){line-height:1.2;pointer-events:none;user-select:none;}&.telepointer-dim{opacity:0.2;}&.color-0{--telepointer-participant-text-color:var(--ds-text-inverse, #FFFFFF);--telepointer-participant-bg-color:var(--ds-background-accent-red-bolder, #C9372C);}&.color-1{--telepointer-participant-text-color:var(--ds-text-inverse, #FFFFFF);--telepointer-participant-bg-color:var(--ds-background-accent-blue-bolder, #1868DB);}&.color-2{--telepointer-participant-text-color:var(--ds-text-inverse, #FFFFFF);--telepointer-participant-bg-color:var(--ds-background-accent-green-bolder, #1F845A);}&.color-3{--telepointer-participant-text-color:var(--ds-text-inverse, #FFFFFF);--telepointer-participant-bg-color:var(--ds-background-accent-yellow-bolder, #946F00);}&.color-4{--telepointer-participant-text-color:var(--ds-text-inverse, #FFFFFF);--telepointer-participant-bg-color:var(--ds-background-accent-purple-bolder, #964AC0);}&.color-5{--telepointer-participant-text-color:var(--ds-text-inverse, #FFFFFF);--telepointer-participant-bg-color:var(--ds-background-accent-magenta-bolder, #AE4787);}&.color-6{--telepointer-participant-text-color:var(--ds-text-inverse, #FFFFFF);--telepointer-participant-bg-color:var(--ds-background-accent-teal-bolder, #227D9B);}&.color-7{--telepointer-participant-text-color:var(--ds-text-inverse, #FFFFFF);--telepointer-participant-bg-color:var(--ds-background-accent-orange-bolder, #BD5B00);}&.color-8{--telepointer-participant-text-color:var(--ds-text-inverse, #FFFFFF);--telepointer-participant-bg-color:var(--ds-background-accent-lime-bolder, #5B7F24);}&.color-9{--telepointer-participant-text-color:var(--ds-text-inverse, #FFFFFF);--telepointer-participant-bg-color:var(--ds-background-accent-gray-bolder, #6B6E76);}&.color-10{--telepointer-participant-text-color:var(--ds-text-accent-gray-bolder, #1E1F21);--telepointer-participant-bg-color:var(--ds-background-accent-blue-subtle, #669DF1);}&.color-11{--telepointer-participant-text-color:var(--ds-text-accent-gray-bolder, #1E1F21);--telepointer-participant-bg-color:var(--ds-background-accent-red-subtle, #F87168);}&.color-12{--telepointer-participant-text-color:var(--ds-text-accent-gray-bolder, #1E1F21);--telepointer-participant-bg-color:var(--ds-background-accent-orange-subtle, #FCA700);}&.color-13{--telepointer-participant-text-color:var(--ds-text-accent-gray-bolder, #1E1F21);--telepointer-participant-bg-color:var(--ds-background-accent-yellow-subtle, #EED12B);}&.color-14{--telepointer-participant-text-color:var(--ds-text-accent-gray-bolder, #1E1F21);--telepointer-participant-bg-color:var(--ds-background-accent-green-subtle, #4BCE97);}&.color-15{--telepointer-participant-text-color:var(--ds-text-accent-gray-bolder, #1E1F21);--telepointer-participant-bg-color:var(--ds-background-accent-teal-subtle, #6CC3E0);}&.color-16{--telepointer-participant-text-color:var(--ds-text-accent-gray-bolder, #1E1F21);--telepointer-participant-bg-color:var(--ds-background-accent-purple-subtle, #C97CF4);}&.color-17{--telepointer-participant-text-color:var(--ds-text-accent-gray-bolder, #1E1F21);--telepointer-participant-bg-color:var(--ds-background-accent-magenta-subtle, #E774BB);}html:not([data-color-mode=dark]) &{--telepointer-participant-background-first-stop:-850000%;--telepointer-participant-background-second-stop:150000%;}html[data-color-mode=dark] &{--telepointer-participant-background-first-stop:-800000%;--telepointer-participant-background-second-stop:200000%;}&[class*=\"color-\"]{background:linear-gradient(to bottom, var(--telepointer-participant-bg-color) var(--telepointer-participant-background-first-stop), transparent var(--telepointer-participant-background-second-stop));&::after{background-color:var(--telepointer-participant-bg-color);color:var(--telepointer-participant-text-color);border-color:var(--telepointer-participant-bg-color);}}}"
};
const $4287605bd9e53ba0$export$c94087d6ea5127ad = /*#__PURE__*/ (0, $9K4OG.css)({
    '.ProseMirror .telepointer': {
        '&.telepointer-selection-badge': {
            '.telepointer-initial, .telepointer-fullname': {
                position: 'absolute',
                display: 'block',
                userSelect: 'none',
                whiteSpace: 'pre',
                top: -14,
                left: 0,
                font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
                paddingLeft: "var(--ds-space-050, 4px)",
                paddingRight: "var(--ds-space-050, 4px)",
                borderRadius: `0 ${"var(--ds-radius-xsmall, 2px)"} ${"var(--ds-radius-xsmall, 2px)"} 0`
            },
            '.telepointer-initial': {
                opacity: 1,
                transition: 'opacity 0.15s ease-out'
            },
            '.telepointer-fullname': {
                opacity: 0,
                transform: 'scaleX(0)',
                transformOrigin: 'top left',
                transition: 'transform 0.15s ease-out, opacity 0.15s ease-out'
            }
        },
        '&.telepointer-pulse-animate': {
            '.telepointer-initial': {
                animation: `${$4287605bd9e53ba0$var$pulseOut} 2.5s ease-in-out`
            },
            '.telepointer-fullname': {
                animation: `${$4287605bd9e53ba0$var$pulseIn} 2.5s ease-in-out`
            }
        },
        '&.telepointer-pulse-during-tr': {
            '.telepointer-initial': {
                animation: `${$4287605bd9e53ba0$var$pulseOutDuringTr} 7500ms ease-in-out`
            },
            '.telepointer-fullname': {
                animation: `${$4287605bd9e53ba0$var$pulseInDuringTr} 7500ms ease-in-out`
            }
        },
        '&:hover': {
            '.telepointer-initial': {
                opacity: 0,
                transitionDelay: '150ms'
            },
            '.telepointer-fullname': {
                transform: 'scaleX(1)',
                opacity: 1,
                zIndex: 1
            }
        }
    }
});


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
function $d945351f1977281b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d945351f1977281b$export$a518ea5d00002b38 = {
    name: "1nlqh0j",
    styles: ".fabric-text-color-mark{color:var(--custom-palette-color, inherit);}a .fabric-text-color-mark{color:unset;}"
};


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled



const $1fcafd3026b21a26$export$b286500adc7d91cd = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.text-highlight': {
        backgroundColor: "var(--ds-background-accent-blue-subtlest, #E9F2FE)",
        borderBottom: `2px solid ${"var(--ds-background-accent-blue-subtler, #CFE1FD)"}`
    }
});


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled




const $6b97cbd24a9f84ae$export$629043421dcc56e5 = {
    BLOCK_CONTAINER: 'unsupportedBlockView-content-wrap',
    INLINE_CONTAINER: 'unsupportedInlineView-content-wrap'
};
const $6b97cbd24a9f84ae$export$637bcb89343f7ef4 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$6b97cbd24a9f84ae$export$629043421dcc56e5.BLOCK_CONTAINER} > div, .${$6b97cbd24a9f84ae$export$629043421dcc56e5.INLINE_CONTAINER} > span:nth-of-type(2)`]: {
        cursor: 'pointer'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ak-editor-selected-node': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.${$6b97cbd24a9f84ae$export$629043421dcc56e5.BLOCK_CONTAINER} > div, &.${$6b97cbd24a9f84ae$export$629043421dcc56e5.INLINE_CONTAINER} > span:nth-of-type(2)`]: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$b2937e5c446645ec),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$48dd9ca0c16e4625),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a716852a0c5e54d5)
        ]
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.danger': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-selected-node': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`&.${$6b97cbd24a9f84ae$export$629043421dcc56e5.BLOCK_CONTAINER} > div, &.${$6b97cbd24a9f84ae$export$629043421dcc56e5.INLINE_CONTAINER} > span:nth-of-type(2)`]: {
                border: `1px solid ${"var(--ds-border-danger, #E2483D)"}`,
                backgroundColor: "var(--ds-blanket-danger, #EF5C4814)"
            }
        }
    }
});


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
function $c13a16cba860d543$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $c13a16cba860d543$export$2ee83b65ab9fac74 = {
    name: "1e3eb5t",
    styles: ".ProseMirror{word-wrap:break-word;white-space:pre-wrap;}"
};


const $ad78489f7c19358a$var$isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
const $ad78489f7c19358a$var$alignMultipleWrappedImageInLayoutStyles = {
    '.ProseMirror [data-layout-section] [data-layout-column] > div': {
        // apply marginTop to wrapped mediaSingle that has preceding wrapped mediaSingle (even when there's gap cursor in between them)
        // Given the first wrapped mediaSingle in layout has 0 marginTop, this is needed to make sure fellow wrapped mediaSingle align with it horizontally
        '.mediaSingleView-content-wrap[layout^=wrap] + .mediaSingleView-content-wrap[layout^=wrap], .mediaSingleView-content-wrap[layout^=wrap] + .ProseMirror-gapcursor + .mediaSingleView-content-wrap[layout^=wrap]': {
            '.rich-media-item': {
                marginTop: 0
            }
        },
        // Due to the above rule, wrapped mediaSingle (not the first node in layout) that are followed by wrapped mediaSingle should also have 0 marginTop
        // so it's aligned with the following wrapped mediaSingle
        '.mediaSingleView-content-wrap[layout^=wrap]:has( + .mediaSingleView-content-wrap[layout^=wrap])': {
            '.rich-media-item': {
                marginTop: 0
            }
        }
    }
};
const $ad78489f7c19358a$var$firstWrappedMediaStyles = {
    '.ProseMirror': {
        // Remove gap between first wrapped mediaSingle and its fellow wrapped mediaSingle
        "& [layout^='wrap-']:has(+ [layout^='wrap-']), & [layout^='wrap-']:has(+ .ProseMirror-gapcursor + [layout^='wrap-'])": {
            [`& .${0, $gnMzP.richMediaClassName}`]: {
                marginLeft: 0,
                marginRight: 0
            }
        }
    }
};
/**
 * EditorContentStyles is a wrapper component that applies styles to its children
 * based on the provided feature flags, view mode, and other props.
 * It uses Emotion for styling and supports scrollable content.
 *
 * This will be used in near future to replace the current editor content styles from index.tsx
 */ const $ad78489f7c19358a$var$EditorContentContainer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef((props, ref)=>{
    const { className: className, children: children, viewMode: viewMode, isScrollable: isScrollable, appearance: appearance, contentMode: contentMode } = props;
    const theme = (0, $6dGgK.u)();
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    const isFullPage = appearance === 'full-page' || appearance === 'full-width';
    const isComment = appearance === 'comment';
    const baseFontSize = (0, $jTtEd.getBaseFontSize)(appearance, contentMode);
    const style = (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    }) ? {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
        '--ak-editor-base-font-size': `${(0, $aFUXX.editorFontSize)({
            theme: theme
        })}px`
    } : {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
        '--ak-editor-base-font-size': `${(0, $aFUXX.editorFontSize)({
            theme: theme
        })}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
        '--ak-editor--large-gutter-padding': `${(0, $aFUXX.akEditorGutterPaddingDynamic)()}px`
    };
    const browser = (0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $d7ZU3.getBrowserInfo)() : (0, $d7ZU3.browser);
    const allClassNames = [
        className
    ];
    if ((0, $aeAfU.expVal)('platform_editor_resizer_cls_fix', 'isEnabled', false)) allClassNames.push('resizer-hover-zone-cls-fix');
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: allClassNames.join(' '),
        ref: ref,
        css: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $0c8159821f1481e1$export$6a08aa478781aaec),
            // eslint-disable-next-line @atlaskit/platform/no-preconditioning
            (0, $dh538.fg)('platform_editor_controls_increase_full_page_gutter') && (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $0c8159821f1481e1$export$cc6d483a79f2d275) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $0c8159821f1481e1$export$9e26088fca9327a2),
            (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
                exposure: true
            }) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $0c8159821f1481e1$export$23029c6a73ca6b8c),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $c13a16cba860d543$export$2ee83b65ab9fac74),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $e776189f3c3af959$export$fc74cf03693076b4),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $f08f86940ab6d6a2$export$9750a92ac0203c10),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $3b65c10c9ad50286$export$3fc32cdc53f6edeb),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$b8cc3f8fc9e3d56a),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$cc1dcabcf4a29354),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a3d8f4cb8a14da43),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $034503d6cd31c145$export$f21d9f928c6ae322),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $b08ecd070af20ccb$export$f06cff4aa315bcf9),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $56a35bdc54338480$export$56bce713f2cb8aa7),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $56a35bdc54338480$export$d3bdc0d52bb6c2c8),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') && (0, $56a35bdc54338480$export$ec7b3b2c50356d2e),
            (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') && (0, $dh538.fg)('platform_editor_quick_insert_placeholder') && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $56a35bdc54338480$export$959bd343ec1d44de),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $1e5fdc47935572b3$export$4baaed2b257b830),
            (0, $1oCLl.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $dh538.fg)('platform_editor_content_mode_button_mvp') && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $1e5fdc47935572b3$export$921fec04d268c00a),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            !(0, $dh538.fg)('platform_editor_fix_code_block_bg_color_in_macro_2') && (0, $1e5fdc47935572b3$export$107831225ad52bb4),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            !(0, $dh538.fg)('platform_editor_typography_ugc') && (0, $8c084c7e0576e8c1$export$87e0522332cd3719),
            (0, $dh538.fg)('platform_editor_typography_ugc') && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $8c084c7e0576e8c1$export$63adc0ebe3278d31),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $375f45f3b6bd3ab6$export$610a2509037eaf6),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $dh538.fg)('platform_editor_typography_ugc') ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $375f45f3b6bd3ab6$export$36460e974c9904b9) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $375f45f3b6bd3ab6$export$4a8301858e3f950),
            (0, $dh538.fg)('platform_editor_nested_dnd_styles_changes') && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $375f45f3b6bd3ab6$export$13d8dd04b9497c9a),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $9fb7690d6af70e31$export$2029176b06e1b241),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $d945351f1977281b$export$a518ea5d00002b38),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $680457c62c4e856c$export$e4cca17cf56e99d),
            (0, $1oCLl.expValEquals)('platform_editor_text_highlight_padding', 'isEnabled', true) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $680457c62c4e856c$export$a365082c2a191514),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $7ea00528076df401$export$5f95d55c83a3b7bc),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $dh538.fg)('aifc_create_enabled') && (0, $7ea00528076df401$export$b5b1b7a81c86d94e),
            // Condense vertical spacing between list items when content mode dense is active
            (0, $1oCLl.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $dh538.fg)('platform_editor_content_mode_button_mvp') && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $7ea00528076df401$export$dc36e8e603594c1d)(baseFontSize),
            (0, $1oCLl.expValEquals)('cc_editor_ttvc_release_bundle_one', 'listLayoutShiftFix', true) && isFullPage && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $7ea00528076df401$export$3861aadd8944b16f),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $0e823357fa8df654$export$2413e968422424ec),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $dh538.fg)('aifc_create_enabled') && (0, $535dd5d33c38cc84$export$1fef993256efc96e),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $dh538.fg)('platform_editor_ai_aifc_patch_beta_2') && (0, $535dd5d33c38cc84$export$4d8f0e547724198),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $8b8a9e34027bcb70$export$abd2efc27ac7e809),
            (0, $1oCLl.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $dh538.fg)('platform_editor_content_mode_button_mvp') && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $8b8a9e34027bcb70$export$1cac2710e369d647),
            // merge firstWrappedMediaStyles with mediaStyles when clean up platform_editor_fix_media_in_renderer
            (0, $dh538.fg)('platform_editor_fix_media_in_renderer') && $ad78489f7c19358a$var$firstWrappedMediaStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $4287605bd9e53ba0$export$c94087d6ea5127ad),
            /* This needs to be after telepointer styles as some overlapping rules have equal specificity, and so the order is significant */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $4287605bd9e53ba0$export$3f28e75e37279280),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $ba96bd4668ffc758$export$f6b9d90c2745834e),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $9add2684ad964103$export$8290cf129669d0cb),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $9add2684ad964103$export$fb05379f8218158),
            (0, $dh538.fg)('platform_editor_nested_dnd_styles_changes') && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $9add2684ad964103$export$1bea98aa89006044),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $9add2684ad964103$export$59d3d90d4141195),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $d6f1b5d8b6185b26$export$1445f2e2b3a1d9c8),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $b92d63900d735dfd$export$df437277fbc8b4f5),
            // condense vertical spacing between tasks/decisions items when content mode dense is active
            (0, $1oCLl.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $dh538.fg)('platform_editor_content_mode_button_mvp') && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $b92d63900d735dfd$export$715995201f735e2d)(baseFontSize),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $3b9a5370a72c9df5$export$61d0da483c72dda3),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $7a303160bb76f51c$export$e561f1e4e17b129d),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $332bd83257b23222$export$37579fbc35dcc1a9),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $91793a38cb990edb$export$9abdb593a2600bc6)(contentMode),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $35750f0b594d4ce9$export$4bb28258452e3b9a),
            (0, $1oCLl.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $dh538.fg)('platform_editor_content_mode_button_mvp') && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $35750f0b594d4ce9$export$9f08fc5d3959d07e)(baseFontSize),
            (0, $dh538.fg)('platform_editor_nested_dnd_styles_changes') ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $35750f0b594d4ce9$export$26d7f96b2bb98b5b) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $35750f0b594d4ce9$export$4dd1b2c2505a38a),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $dh538.fg)('platform-visual-refresh-icons') && (0, $35750f0b594d4ce9$export$20843fd014d7530c),
            (0, $1oCLl.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $19957a194e4b6622$export$f6e8277f5198ab7b) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $19957a194e4b6622$export$c5ceb9c726010930),
            (0, $1oCLl.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true) && (0, $dh538.fg)('platform_editor_find_codeblock_color_contrast_fix') && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $19957a194e4b6622$export$fae24dca059c5),
            !(0, $1oCLl.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true) && (0, $dh538.fg)('platform_editor_find_codeblock_color_contrast_fix') && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $19957a194e4b6622$export$a5471dc947aff188),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $1fcafd3026b21a26$export$b286500adc7d91cd),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $b92d63900d735dfd$export$c2f467e1dc47f4f1),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_blocktaskitem_node_tenantid', 'isEnabled', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $b92d63900d735dfd$export$a261a5b04a85ad9c) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $b92d63900d735dfd$export$2a9fa9bb25fe40d2),
            (0, $dh538.fg)('platform-visual-refresh-icons') && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $b92d63900d735dfd$export$e237513ae3de60b5),
            !(0, $dh538.fg)('platform-visual-refresh-icons') && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $b92d63900d735dfd$export$921eec0bd8c26b90),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $8daea92ba3be6a6e$export$79c8c9ad308bbe07),
            (0, $dh538.fg)('platform-component-visual-refresh') ? (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_find_and_replace_improvements', 'isEnabled', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $8daea92ba3be6a6e$export$8b4cca12f7a094c7) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $8daea92ba3be6a6e$export$7c209f30e9068068) : (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_find_and_replace_improvements', 'isEnabled', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $8daea92ba3be6a6e$export$60b421c3da7a2a99) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $8daea92ba3be6a6e$export$dc185896d75d4b4),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $e744a1f22573fa53$export$65cde0a0b7e7c1c1),
            (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_find_and_replace_improvements', 'isEnabled', true) ? (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_block_menu', 'isEnabled', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $535dd5d33c38cc84$export$42b66ad40efe5bbe) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $535dd5d33c38cc84$export$56d86af0724ad29e) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $535dd5d33c38cc84$export$b346a5d6d598424c),
            (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_responsiveness', true) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $535dd5d33c38cc84$export$fefb174a4d9f4c0),
            ((0, $dZ8uq.expValEqualsNoExposure)('platform_editor_controls', 'cohort', 'variant1') || (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_linking_exp', true)) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $535dd5d33c38cc84$export$f64b12e3fb171ebc),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $92bd659d1ad36350$export$5a1f57c6600b90f1),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $6b97cbd24a9f84ae$export$637bcb89343f7ef4),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $8ca5e17fea10ef42$export$ce55ec61aa49b942),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $07d5bf3f0b10fce1$export$ce383b8d82e44bf5),
            // merge alignMultipleWrappedImageInLayoutStyles with layoutBaseStyles when clean up platform_editor_fix_media_in_renderer
            (0, $dh538.fg)('platform_editor_fix_media_in_renderer') && $ad78489f7c19358a$var$alignMultipleWrappedImageInLayoutStyles,
            (0, $dZ8uq.expValEqualsNoExposure)('platform_synced_block', 'isEnabled', true) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $7a476f61d60131cb$export$2ef961ae194ff4dc),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $iu6m9.editorExperiment)('advanced_layouts', true) && (0, $07d5bf3f0b10fce1$export$74ce03ae8f7cbe1a),
            (0, $iu6m9.editorExperiment)('advanced_layouts', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $07d5bf3f0b10fce1$export$d9912ef7f698aab8) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $07d5bf3f0b10fce1$export$17d7fe9c8be65e97),
            (0, $iu6m9.editorExperiment)('advanced_layouts', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $07d5bf3f0b10fce1$export$8dd21c7c24132a82) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $07d5bf3f0b10fce1$export$fe39d5414c0135d3),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $iu6m9.editorExperiment)('advanced_layouts', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $07d5bf3f0b10fce1$export$fe59793079ccb11a) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $07d5bf3f0b10fce1$export$cdcbf2d4bffabda6),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $iu6m9.editorExperiment)('advanced_layouts', true) && (0, $07d5bf3f0b10fce1$export$55890fd3e3be7f1b),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $iu6m9.editorExperiment)('advanced_layouts', true) && (0, $07d5bf3f0b10fce1$export$c1454bb6dd8837f5),
            (0, $dh538.fg)('platform_editor_nested_dnd_styles_changes') && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $07d5bf3f0b10fce1$export$4d009f8d3cbd5535),
            (0, $dh538.fg)('platform_editor_nested_dnd_styles_changes') ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $07d5bf3f0b10fce1$export$c60086c81c0ffabf) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $07d5bf3f0b10fce1$export$598dd68f26eb7eff),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $535dd5d33c38cc84$export$cb0683bb9c4e1322),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $535dd5d33c38cc84$export$1a87a16059da4299),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $332bd83257b23222$export$b89fadc5134d50fa),
            (0, $dh538.fg)('platform_editor_typography_ugc') ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $1oCLl.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $dh538.fg)('platform_editor_content_mode_button_mvp') ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $b0ef43f6c63956f4$export$63635a8b56f58eca) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $b0ef43f6c63956f4$export$29f6e72d2a83d55a) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $1oCLl.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $dh538.fg)('platform_editor_content_mode_button_mvp') ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $b0ef43f6c63956f4$export$3de2f7ce686aadc2) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $b0ef43f6c63956f4$export$855ac5a16d662324),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $9be63d8bc680ee45$export$4ea5976125a01ffa),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            browser.safari && (0, $7ea00528076df401$export$dba87c9b43c1033d),
            (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_breakout_resizing', 'isEnabled', true) ? (0, $dh538.fg)('platform_editor_breakout_resizing_width_changes') ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $8ca5e17fea10ef42$export$4f3e1cb10ec03a18) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $8ca5e17fea10ef42$export$62cd5dfd9881f590) : undefined,
            (0, $iu6m9.editorExperiment)('advanced_layouts', true) && (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_breakout_resizing', 'isEnabled', true) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $8ca5e17fea10ef42$export$241444dc11ae22d6),
            (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_breakout_resizing', 'isEnabled', true) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $8ca5e17fea10ef42$export$21b363e15a3a4b0b),
            (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_responsiveness', true) && ((0, $iu6m9.editorExperiment)('advanced_layouts', true) || (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_breakout_resizing', 'isEnabled', true)) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $8ca5e17fea10ef42$export$2785010673d864e4),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $30cdf9ef77478b9f$export$7d2a5652980d3808),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            $ad78489f7c19358a$var$isFirefox && (0, $30cdf9ef77478b9f$export$541b06daf7fd8fce),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            colorMode === 'dark' && (0, $30cdf9ef77478b9f$export$9a2d17c0df63f635),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            colorMode === 'dark' && $ad78489f7c19358a$var$isFirefox && (0, $30cdf9ef77478b9f$export$18b242302a502e32),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            viewMode === 'view' && (0, $07d5bf3f0b10fce1$export$ec8bdd18ecbadae7),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            viewMode === 'view' && (0, $iu6m9.editorExperiment)('advanced_layouts', true) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $07d5bf3f0b10fce1$export$20e6a345585c5c3c),
            viewMode === 'view' && (0, $iu6m9.editorExperiment)('advanced_layouts', false) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $07d5bf3f0b10fce1$export$70038a77af1ac7b5),
            viewMode === 'view' && (0, $iu6m9.editorExperiment)('advanced_layouts', true) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $07d5bf3f0b10fce1$export$203a03d09c37c555),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            isComment && (0, $8ba9ce11757ecee6$export$d6e7bceefcc20e27),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            isComment && (0, $e5ba48b9f959e381$export$61a2da566f69d1df),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            isFullPage && (0, $8478647a8b452658$export$eb88bb4706d67f65),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            isFullPage && (0, $887f0254bcb2b3a0$export$b2380b18b089518f),
            (0, $dh538.fg)('platform_editor_nested_dnd_styles_changes') ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $1e5fdc47935572b3$export$ddc3dd3ba723d1af) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $1e5fdc47935572b3$export$50458a606d5c37d0),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $563563a54a51d8c3$export$2d6e8a1d666d4a60),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $d6f1b5d8b6185b26$export$5fb9b21e3678e9ac),
            (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_find_and_replace_improvements', 'isEnabled', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $d6f1b5d8b6185b26$export$13ab2f17ccaf48f6) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $d6f1b5d8b6185b26$export$8697a9554aac2a5a),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $64073fed169900b9$export$d73b97ac20f33f4),
            // Dense emoji scaling based on base font size
            (0, $1oCLl.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $dh538.fg)('platform_editor_content_mode_button_mvp') && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $64073fed169900b9$export$2a2707475ad11d76)(baseFontSize),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $9add2684ad964103$export$21dc022a1db4e807),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $8b8a9e34027bcb70$export$cbc2f5b7ba4a5b45),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $8b8a9e34027bcb70$export$228abfa0106fa708),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $e5ba48b9f959e381$export$696afa9d8a2fe544),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $e5ba48b9f959e381$export$d4422e89f15370f2),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            !(0, $dh538.fg)('platform_editor_table_container_y_overflow_fix') && (0, $e5ba48b9f959e381$export$a12a9c400154a0fb),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $9be63d8bc680ee45$export$889b949305b162f9),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            !(0, $dh538.fg)('platform-visual-refresh-icons') && (0, $9be63d8bc680ee45$export$e696625219a66da6),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $dh538.fg)('confluence_floating_toolbar_animation') && (0, $14a90d57d6df814c$export$1629cb32bbba3a7e),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $dh538.fg)('platform_editor_vanilla_codebidi_warning') && (0, $80ac58d0463897a9$export$98853831203df33a),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $aeAfU.expValNoExposure)('platform_editor_block_menu', 'isEnabled', true) && [
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $332bd83257b23222$export$f9f3f08b750aaa7d),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $64073fed169900b9$export$df03c70a9b9671c1),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $d6f1b5d8b6185b26$export$1091a37fb36d77e5),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $b92d63900d735dfd$export$27a4e7e55add38c4),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $8daea92ba3be6a6e$export$bd58d1bcb934912c),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $0e823357fa8df654$export$e425548b5cacd57),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $8b8a9e34027bcb70$export$c47a18e5da2466ef),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $9add2684ad964103$export$9addcfe7a096a01d)
            ]
        ],
        "data-editor-scroll-container": isScrollable ? 'true' : undefined,
        "data-testid": "editor-content-container",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        tabIndex: isScrollable ? 0 : undefined,
        role: isScrollable ? 'region' : undefined
    }, children);
});
var $ad78489f7c19358a$export$2e2bcd8739ae039 = $ad78489f7c19358a$var$EditorContentContainer;
module.exports["default"] = $ad78489f7c19358a$export$2e2bcd8739ae039;

});

parcelRegister("6ESsx", function(module, exports) {
const $a4c21b9fb66bf546$export$6d0ce11e3a04da25 = 'ak-editor-annotation';
const $a4c21b9fb66bf546$export$b0aeb22a160e5b4c = {
    focus: `${$a4c21b9fb66bf546$export$6d0ce11e3a04da25}-focus`,
    blur: `${$a4c21b9fb66bf546$export$6d0ce11e3a04da25}-blur`,
    draft: `${$a4c21b9fb66bf546$export$6d0ce11e3a04da25}-draft`,
    hover: `${$a4c21b9fb66bf546$export$6d0ce11e3a04da25}-hover`
};
const $a4c21b9fb66bf546$export$3600479d19dfa7a9 = 'ak-editor-block-annotation';
const $a4c21b9fb66bf546$export$ac15f3ad21fefeac = {
    focus: `${$a4c21b9fb66bf546$export$3600479d19dfa7a9}-focus`,
    blur: `${$a4c21b9fb66bf546$export$3600479d19dfa7a9}-blur`,
    draft: `${$a4c21b9fb66bf546$export$3600479d19dfa7a9}-draft`
};
module.exports["AnnotationSharedClassNames"] = $a4c21b9fb66bf546$export$b0aeb22a160e5b4c;
module.exports["BlockAnnotationSharedClassNames"] = $a4c21b9fb66bf546$export$ac15f3ad21fefeac;

});

parcelRegister("iMS6j", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $76cf05f628aba256$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $76cf05f628aba256$export$e1f541b6d8e35681 = {
    name: "1igsh0u",
    styles: "margin-left:var(--ds-space-negative-100, -8px)"
};
const $76cf05f628aba256$export$2e9dabdcf16aeb54 = {
    name: "s5xdrg",
    styles: "display:flex;align-items:center"
};
const $76cf05f628aba256$var$prefix = 'ak-editor-expand';
const $76cf05f628aba256$export$6ba39aa0ead007b7 = {
    prefix: $76cf05f628aba256$var$prefix,
    expanded: `${$76cf05f628aba256$var$prefix}__expanded`,
    titleContainer: `${$76cf05f628aba256$var$prefix}__title-container`,
    inputContainer: `${$76cf05f628aba256$var$prefix}__input-container`,
    iconContainer: `${$76cf05f628aba256$var$prefix}__icon-container`,
    icon: `${$76cf05f628aba256$var$prefix}__icon`,
    iconButton: `${$76cf05f628aba256$var$prefix}__icon-button`,
    iconSvg: `${$76cf05f628aba256$var$prefix}__icon-svg`,
    titleInput: `${$76cf05f628aba256$var$prefix}__title-input`,
    content: `${$76cf05f628aba256$var$prefix}__content`,
    type: (type)=>`${$76cf05f628aba256$var$prefix}__type-${type}`
};
module.exports["expandIconWrapperStyle"] = $76cf05f628aba256$export$e1f541b6d8e35681;
module.exports["expandIconContainerStyle"] = $76cf05f628aba256$export$2e9dabdcf16aeb54;
module.exports["expandClassNames"] = $76cf05f628aba256$export$6ba39aa0ead007b7;

});

parcelRegister("ieXGd", function(module, exports) {

var $aFUXX = parcelRequire("aFUXX");


var $b38UX = parcelRequire("b38UX");

const $097d317d23b8bcc9$export$fb186b651805ffe4 = (selectionStyles)=>selectionStyles.map((selectionStyle)=>$097d317d23b8bcc9$var$getSelectionStyle(selectionStyle)).concat($097d317d23b8bcc9$export$a716852a0c5e54d5).join('\n');
const $097d317d23b8bcc9$export$a716852a0c5e54d5 = `
  ::selection,*::selection {
    background-color: transparent;
  }
  ::-moz-selection,*::-moz-selection {
    background-color: transparent;
  }
`;
const $097d317d23b8bcc9$var$getSelectionStyle = (style)=>{
    switch(style){
        case (0, $b38UX.SelectionStyle).Border:
            return `
        border: ${0, $aFUXX.akEditorSelectedBorder};

        // Fixes ED-15246: Trello card is visible through a border of a table border
        &::after {
          height: 100%;
          content: '\\00a0';
          background: ${0, $aFUXX.akEditorSelectedBorderColor};
          position: absolute;
          right: -1px;
          top: 0;
          bottom: 0;
          width: 1px;
          border: none;
          display: inline-block;
        }
      `;
        case (0, $b38UX.SelectionStyle).BoxShadow:
            return `
        box-shadow: ${0, $aFUXX.akEditorSelectedBoxShadow};
        border-color: transparent;
        `;
        case (0, $b38UX.SelectionStyle).Background:
            return `background-color: ${"var(--ds-background-selected, #E9F2FE)"};`;
        case (0, $b38UX.SelectionStyle).Blanket:
            return `
        position: relative;

        // Fixes ED-9263, where emoji or inline card in panel makes selection go outside the panel
        // in Safari. Looks like it's caused by user-select: all in the emoji element
        -webkit-user-select: text;

        ::before {
          position: absolute;
          content: '';
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          width: 100%;
          pointer-events: none;
          z-index: ${0, $aFUXX.akEditorSmallZIndex};
          background-color: ${"var(--ds-blanket-selected, #388BFF14)"}
        }`;
        default:
            return '';
    }
};
module.exports["getSelectionStyles"] = $097d317d23b8bcc9$export$fb186b651805ffe4;
module.exports["hideNativeBrowserTextSelectionStyles"] = $097d317d23b8bcc9$export$a716852a0c5e54d5;

});

parcelRegister("b38UX", function(module, exports) {
/**
 * These are generic selection styles for all nodes
 * If you have custom behaviour needed for a node, add that in the plugin's styles
 * file in editor-core
 */ var $5e118ec333d708f7$export$80010201b36a8290 = /*#__PURE__*/ function(SelectionStyle) {
    SelectionStyle[SelectionStyle["Border"] = 0] = "Border";
    SelectionStyle[SelectionStyle["BoxShadow"] = 1] = "BoxShadow";
    SelectionStyle[SelectionStyle["Background"] = 2] = "Background";
    SelectionStyle[SelectionStyle["Blanket"] = 3] = "Blanket";
    return SelectionStyle;
}({});
module.exports["SelectionStyle"] = $5e118ec333d708f7$export$80010201b36a8290;

});

parcelRegister("e6n00", function(module, exports) {
const $e31affe2f363c0cc$var$prefix = 'ak-editor-sync-block';
const $e31affe2f363c0cc$export$84840734cffb342f = {
    prefix: $e31affe2f363c0cc$var$prefix,
    renderer: `${$e31affe2f363c0cc$var$prefix}__renderer`,
    error: `${$e31affe2f363c0cc$var$prefix}__error_state`
};
const $e31affe2f363c0cc$var$bodiedPrefix = 'ak-editor-bodied-sync-block';
const $e31affe2f363c0cc$export$628f41eb22ec9a2 = {
    prefix: $e31affe2f363c0cc$var$bodiedPrefix,
    content: `${$e31affe2f363c0cc$var$bodiedPrefix}__content`
};
const $e31affe2f363c0cc$var$labelClassName = 'ak-editor-sync-block__label';
const $e31affe2f363c0cc$export$f75b6075afbd73af = {
    labelClassName: $e31affe2f363c0cc$var$labelClassName
};
module.exports["SyncBlockSharedCssClassName"] = $e31affe2f363c0cc$export$84840734cffb342f;
module.exports["BodiedSyncBlockSharedCssClassName"] = $e31affe2f363c0cc$export$628f41eb22ec9a2;
module.exports["SyncBlockLabelSharedCssClassName"] = $e31affe2f363c0cc$export$f75b6075afbd73af;

});

parcelRegister("3ae8F", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $a4TK8 = parcelRequire("a4TK8");


var $d925B = parcelRequire("d925B");


var $aeAfU = parcelRequire("aeAfU");








var $hWRJP = parcelRequire("hWRJP");

class $ea497c7b8855fd08$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    hasFallback() {
        return typeof this.props.fallbackComponent !== 'undefined';
    }
    shouldRecover() {
        return this.hasFallback() && this.state.errorCaptured;
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.dispatchAnalyticsEvent) this.props.dispatchAnalyticsEvent({
            action: (0, $d925B.ACTION).EDITOR_CRASHED,
            actionSubject: this.props.component,
            actionSubjectId: this.props.componentId,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
            attributes: {
                error: error,
                errorInfo: errorInfo,
                errorRethrown: !this.hasFallback()
            }
        });
        (0, $hWRJP.logException)(error, {
            location: 'editor-core/ui'
        });
        if (this.hasFallback()) this.setState({
            errorCaptured: true
        });
    }
    render() {
        if (this.shouldRecover()) return this.props.fallbackComponent;
        return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.state = {
            errorCaptured: false
        };
    }
}





function $e83111829c538b72$var$MountPluginHook({ usePluginHook: usePluginHook, editorView: editorView, containerElement: containerElement }) {
    usePluginHook({
        editorView: editorView,
        containerElement: containerElement
    });
    return null;
}
function $e83111829c538b72$export$a9224552b63e3fe8({ pluginHooks: pluginHooks, editorView: editorView, containerElement: containerElement }) {
    if (!editorView) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, pluginHooks?.map((usePluginHook, key)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e83111829c538b72$var$MountPluginHook, {
            // Ignored via go/ees005
            // eslint-disable-next-line react/no-array-index-key
            key: key,
            usePluginHook: usePluginHook,
            editorView: editorView,
            containerElement: containerElement
        })));
}


function $4a2d94567ed6726c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4a2d94567ed6726c$var$pluginsComponentsWrapper = {
    name: "zjik7",
    styles: "display:flex"
};
const $4a2d94567ed6726c$var$PluginSlot = ({ items: items, editorView: editorView, editorActions: editorActions, eventDispatcher: eventDispatcher, providerFactory: providerFactory, appearance: appearance, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, containerElement: containerElement, disabled: disabled, dispatchAnalyticsEvent: dispatchAnalyticsEvent, wrapperElement: wrapperElement, pluginHooks: pluginHooks })=>{
    if (!items && !pluginHooks || !editorView && !(0, $aeAfU.expVal)('platform_editor_hydratable_ui', 'isEnabled', false)) return null;
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $ea497c7b8855fd08$export$e926676385687eaf), {
        component: (0, $d925B.ACTION_SUBJECT).PLUGIN_SLOT,
        fallbackComponent: null
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $e83111829c538b72$export$a9224552b63e3fe8), {
        editorView: editorView,
        pluginHooks: pluginHooks,
        containerElement: containerElement
    }), /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $4a2d94567ed6726c$var$pluginsComponentsWrapper,
        "data-testid": (0, $aeAfU.expVal)('platform_editor_experience_tracking', 'isEnabled', true) ? 'plugins-components-wrapper' : undefined
    }, items?.map((component, key)=>{
        const props = {
            key: key
        };
        const element = component({
            editorView: editorView,
            editorActions: editorActions,
            eventDispatcher: eventDispatcher,
            providerFactory: providerFactory,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            appearance: appearance,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            containerElement: containerElement,
            disabled: disabled,
            wrapperElement: wrapperElement
        });
        return element && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement(element, props);
    })));
};
const $4a2d94567ed6726c$var$PluginSlotComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo($4a2d94567ed6726c$var$PluginSlot, (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8))));
$4a2d94567ed6726c$var$PluginSlotComponent.displayName = 'PluginSlot';
var $4a2d94567ed6726c$export$2e2bcd8739ae039 = $4a2d94567ed6726c$var$PluginSlotComponent;
module.exports["default"] = $4a2d94567ed6726c$export$2e2bcd8739ae039;

});

parcelRegister("4cy2V", function(module, exports) {
const $6c9f12e5c59418a8$export$f454e86f6cef71f4 = (editorAPI, components)=>{
    return {
        components: components ?? editorAPI?.primaryToolbar?.sharedState.currentState()?.components
    };
};
module.exports["getPrimaryToolbarComponents"] = $6c9f12e5c59418a8$export$f454e86f6cef71f4;

});

parcelRegister("1xxAs", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $eTj7Y = parcelRequire("eTj7Y");


var $zMjD6 = parcelRequire("zMjD6");


var $iu6m9 = parcelRequire("iu6m9");


var $4JDbp = parcelRequire("4JDbp");


var $geLSP = parcelRequire("geLSP");





var $dh538 = parcelRequire("dh538");

const $3aec2ffe9f521610$export$1217913212f99c7 = (ref, { skip: skip })=>{
    const [elementWidth, setWidth] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(undefined);
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        if (!skip && ref.current && !(0, $dh538.fg)('platform_editor_prevent_toolbar_width_reflow')) setWidth(Math.round(ref.current.getBoundingClientRect().width));
    }, [
        skip,
        setWidth,
        ref
    ]);
    return elementWidth;
};



var $eUp7e = parcelRequire("eUp7e");










// Toolbar sizes for full page editor a little bit different, because it has more buttons e.g. actions button...
const $bd42a2364528a44b$var$toolbarSizesFullPageNext = [
    {
        width: (0, $zMjD6.ToolbarWidthsFullPageNext).XXL,
        size: (0, $zMjD6.ToolbarSize).XXL
    },
    {
        width: (0, $zMjD6.ToolbarWidthsFullPageNext).XL,
        size: (0, $zMjD6.ToolbarSize).XL
    },
    {
        width: (0, $zMjD6.ToolbarWidthsFullPageNext).L,
        size: (0, $zMjD6.ToolbarSize).L
    },
    {
        width: (0, $zMjD6.ToolbarWidthsFullPageNext).M,
        size: (0, $zMjD6.ToolbarSize).M
    },
    {
        width: (0, $zMjD6.ToolbarWidthsFullPageNext).S,
        size: (0, $zMjD6.ToolbarSize).S
    }
];
// eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
/** @deprecated
 * To be removed as part of ED-25129 in favour of toolbarSizesFullPageNext along with references
 * to platform_editor_toolbar_responsive_fixes feature gate
 */ const $bd42a2364528a44b$var$toolbarSizesFullPage = [
    {
        width: (0, $zMjD6.ToolbarWidthsFullPage).XXL,
        size: (0, $zMjD6.ToolbarSize).XXL
    },
    {
        width: (0, $zMjD6.ToolbarWidthsFullPage).XL,
        size: (0, $zMjD6.ToolbarSize).XL
    },
    {
        width: (0, $zMjD6.ToolbarWidthsFullPage).L,
        size: (0, $zMjD6.ToolbarSize).L
    },
    {
        width: (0, $zMjD6.ToolbarWidthsFullPage).M,
        size: (0, $zMjD6.ToolbarSize).M
    },
    {
        width: (0, $zMjD6.ToolbarWidthsFullPage).S,
        size: (0, $zMjD6.ToolbarSize).S
    }
];
const $bd42a2364528a44b$var$toolbarSizesNext = [
    {
        width: (0, $zMjD6.ToolbarWidthsNext).XXL,
        size: (0, $zMjD6.ToolbarSize).XXL
    },
    {
        width: (0, $zMjD6.ToolbarWidthsNext).XL,
        size: (0, $zMjD6.ToolbarSize).XL
    },
    {
        width: (0, $zMjD6.ToolbarWidthsNext).L,
        size: (0, $zMjD6.ToolbarSize).L
    },
    {
        width: (0, $zMjD6.ToolbarWidthsNext).M,
        size: (0, $zMjD6.ToolbarSize).M
    },
    {
        width: (0, $zMjD6.ToolbarWidthsNext).S,
        size: (0, $zMjD6.ToolbarSize).S
    }
];
// eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
/** @deprecated
 * To be removed as part of ED-25129 in favour of toolbarSizesNext along with references
 * to platform_editor_toolbar_responsive_fixes feature gate
 */ const $bd42a2364528a44b$var$toolbarSizes = [
    {
        width: (0, $zMjD6.ToolbarWidths).XXL,
        size: (0, $zMjD6.ToolbarSize).XXL
    },
    {
        width: (0, $zMjD6.ToolbarWidths).XL,
        size: (0, $zMjD6.ToolbarSize).XL
    },
    {
        width: (0, $zMjD6.ToolbarWidths).L,
        size: (0, $zMjD6.ToolbarSize).L
    },
    {
        width: (0, $zMjD6.ToolbarWidths).M,
        size: (0, $zMjD6.ToolbarSize).M
    },
    {
        width: (0, $zMjD6.ToolbarWidths).S,
        size: (0, $zMjD6.ToolbarSize).S
    }
];
const $bd42a2364528a44b$var$toolbarSizesForAppearance = (appearance)=>(0, $geLSP.isFullPage)(appearance) ? (0, $dh538.fg)('platform_editor_toolbar_responsive_fixes') ? $bd42a2364528a44b$var$toolbarSizesFullPageNext : $bd42a2364528a44b$var$toolbarSizesFullPage : (0, $dh538.fg)('platform_editor_toolbar_responsive_fixes') ? $bd42a2364528a44b$var$toolbarSizesNext : $bd42a2364528a44b$var$toolbarSizes;
const $bd42a2364528a44b$export$df8e48f984163082 = (toolbarSize, appearance)=>{
    return ($bd42a2364528a44b$var$toolbarSizesForAppearance(appearance).find(({ size: size })=>toolbarSize === size) || {
        width: (0, $zMjD6.ToolbarWidths).S
    }).width;
};
const $bd42a2364528a44b$export$886398ab6922a80f = (toolbarWidth, appearance)=>{
    return ($bd42a2364528a44b$var$toolbarSizesForAppearance(appearance).find(({ width: width })=>toolbarWidth > width) || {
        size: (0, $zMjD6.ToolbarSize).XXXS
    }).size;
};


function $4b0c8fc583dabeb9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4b0c8fc583dabeb9$var$toolbar = {
    name: "n48rgu",
    styles: "width:100%;position:relative"
};
const $4b0c8fc583dabeb9$export$6bb21858343ac39d = (props)=>{
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(null);
    const [width, setWidth] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(undefined);
    const elementWidth = (0, $3aec2ffe9f521610$export$1217913212f99c7)(ref, {
        skip: typeof width !== 'undefined'
    });
    const defaultToolbarSize = (0, $eTj7Y.isSSR)() && (0, $geLSP.isFullPage)(props.appearance) ? (0, $zMjD6.ToolbarSize).XXL : undefined;
    const toolbarSize = typeof width === 'undefined' && typeof elementWidth === 'undefined' ? defaultToolbarSize : // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $bd42a2364528a44b$export$886398ab6922a80f)(width || elementWidth, props.appearance);
    const minWidthValue = (0, $42omo.useMemo)(()=>{
        if (props.hasMinWidth) {
            const toolbarWidth = (0, $geLSP.isFullPage)(props.appearance) && props.twoLineEditorToolbar ? (0, $zMjD6.ToolbarSize).S : (0, $zMjD6.ToolbarSize).M;
            return `${(0, $bd42a2364528a44b$export$df8e48f984163082)(toolbarWidth, props.appearance)}px`;
        } else {
            const isPreviewPanelResponsivenessEnabled = (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
                exposure: true
            });
            return isPreviewPanelResponsivenessEnabled ? 'fit-content' : '254px';
        }
    }, [
        props.appearance,
        props.hasMinWidth,
        props.twoLineEditorToolbar
    ]);
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $4b0c8fc583dabeb9$var$toolbar,
        style: {
            minWidth: minWidthValue
        }
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $4JDbp.WidthObserver), {
        setWidth: setWidth
    }), props.editorView && toolbarSize ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, $eUp7e.Toolbar), {
        toolbarSize: toolbarSize,
        items: props.items,
        editorView: props.editorView,
        editorActions: props.editorActions,
        eventDispatcher: props.eventDispatcher,
        providerFactory: props.providerFactory,
        appearance: props.appearance,
        popupsMountPoint: props.popupsMountPoint,
        popupsBoundariesElement: props.popupsBoundariesElement,
        popupsScrollableElement: props.popupsScrollableElement,
        disabled: props.disabled,
        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
        containerElement: props.containerElement,
        hasMinWidth: props.hasMinWidth,
        twoLineEditorToolbar: props.twoLineEditorToolbar
    }) : /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        ref: ref
    }));
};
module.exports["ToolbarWithSizeDetector"] = $4b0c8fc583dabeb9$export$6bb21858343ac39d;

});

parcelRegister("eUp7e", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $eiA8Z = parcelRequire("eiA8Z");


var $gzUv9 = parcelRequire("gzUv9");

var $biAkr = parcelRequire("biAkr");


var $zMjD6 = parcelRequire("zMjD6");


var $b3YrF = parcelRequire("b3YrF");


var $kDB94 = parcelRequire("kDB94");

var $6UWPx = parcelRequire("6UWPx");

var $48SU7 = parcelRequire("48SU7");


var $cf8NL = parcelRequire("cf8NL");


var $dTb09 = parcelRequire("dTb09");


var $1oCLl = parcelRequire("1oCLl");

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $9K4OG = parcelRequire("9K4OG");


var $a4TK8 = parcelRequire("a4TK8");


var $eTj7Y = parcelRequire("eTj7Y");


var $aFUXX = parcelRequire("aFUXX");

const $85ca23d15eecf4ef$var$toolbarComponentsWrapper = /*#__PURE__*/ (0, $9K4OG.css)({
    display: 'flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${0, $aFUXX.akEditorMobileMaxWidth}px)`]: {
        justifyContent: 'space-between'
    }
});
class $85ca23d15eecf4ef$export$7c77e89663c6a665 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    shouldComponentUpdate(nextProps) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(nextProps, this.props);
    }
    render() {
        const { appearance: appearance, editorView: editorView, editorActions: editorActions, eventDispatcher: eventDispatcher, providerFactory: providerFactory, items: items, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, toolbarSize: toolbarSize, disabled: disabled, isToolbarReducedSpacing: isToolbarReducedSpacing, dispatchAnalyticsEvent: dispatchAnalyticsEvent, containerElement: containerElement } = this.props;
        if (!items || !items.length) return null;
        if ((0, $eTj7Y.isSSR)()) // Toolbar in SSR environment is showing collapsed state, which caused layout shift after hydrating to SPA.
        // Hiding toolbar in SSR until the dependency of screen width is resolved in SSR environment.
        return null;
        return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            css: $85ca23d15eecf4ef$var$toolbarComponentsWrapper,
            "data-vc": "toolbar-inner"
        }, items.map((component, key)=>{
            const element = component({
                editorView: editorView,
                editorActions: editorActions,
                eventDispatcher: eventDispatcher,
                providerFactory: providerFactory,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                appearance: appearance,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement,
                disabled: disabled,
                toolbarSize: toolbarSize,
                isToolbarReducedSpacing: isToolbarReducedSpacing,
                containerElement: containerElement,
                isLastItem: key === items.length - 1,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                wrapperElement: null
            });
            return element && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement(element, {
                key: key
            });
        }));
    }
}


const $ba8f28fe8c9d2747$export$4c260019440d418f = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $85ca23d15eecf4ef$export$7c77e89663c6a665), {
        items: props.items,
        editorView: props.editorView,
        editorActions: props.editorActions,
        eventDispatcher: props.eventDispatcher,
        providerFactory: props.providerFactory,
        appearance: props.appearance,
        popupsMountPoint: props.popupsMountPoint,
        popupsBoundariesElement: props.popupsBoundariesElement,
        popupsScrollableElement: props.popupsScrollableElement,
        disabled: props.disabled,
        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
        toolbarSize: props.toolbarSize,
        isToolbarReducedSpacing: props.toolbarSize < (0, $zMjD6.ToolbarSize).XXL,
        containerElement: props.containerElement
    });
};
const $ba8f28fe8c9d2747$var$usePluginState = (0, $dTb09.conditionalHooksFactory)(()=>(0, $1oCLl.expValEquals)('platform_editor_toolbar_aifc_patch_3', 'isEnabled', true), (api)=>{
    return (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'connectivity',
        'editorViewMode',
        'userPreferences'
    ], (state)=>{
        return {
            connectivityStateMode: state.connectivityState?.mode,
            editorViewMode: state.editorViewModeState?.mode,
            editorToolbarDockingPreference: state.userPreferencesState?.preferences?.toolbarDockingPosition
        };
    });
}, (api)=>{
    const connectivityStateMode = (0, $b3YrF.useSharedPluginStateSelector)(api, 'connectivity.mode');
    return {
        connectivityStateMode: connectivityStateMode,
        editorViewMode: undefined,
        editorToolbarDockingPreference: undefined
    };
});
const $ba8f28fe8c9d2747$export$1606f8c5fd0ac145 = ({ toolbar: toolbar, components: components, editorView: editorView, editorAPI: editorAPI, popupsMountPoint: popupsMountPoint, editorAppearance: editorAppearance, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isDisabled: isDisabled })=>{
    const { connectivityStateMode: connectivityStateMode, editorViewMode: editorViewMode, editorToolbarDockingPreference: editorToolbarDockingPreference } = $ba8f28fe8c9d2747$var$usePluginState(editorAPI);
    // remove offline check when patch6Enabled is cleaned up
    const isOffline = connectivityStateMode === 'offline';
    const patch6Enabled = (0, $1oCLl.expValEquals)('platform_editor_toolbar_aifc_patch_6', 'isEnabled', true);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gzUv9.EditorToolbarProvider), {
        editorView: editorView ?? null,
        editorAppearance: editorAppearance,
        editorViewMode: (0, $1oCLl.expValEquals)('platform_editor_toolbar_aifc_patch_4', 'isEnabled', true) ? editorViewMode ?? 'edit' : editorViewMode,
        editorToolbarDockingPreference: editorToolbarDockingPreference,
        isOffline: isOffline
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $biAkr.EditorToolbarUIProvider), {
        api: editorAPI,
        isDisabled: patch6Enabled ? isDisabled : isOffline || isDisabled,
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        fireAnalyticsEvent: (payload)=>{
            editorAPI?.analytics?.actions.fireAnalyticsEvent(payload);
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cf8NL.ToolbarModelRenderer), {
        toolbar: toolbar,
        components: components,
        fallbacks: {
            group: (0, $kDB94.ToolbarButtonGroup),
            section: (0, $48SU7.ToolbarSection),
            menuSection: (0, $6UWPx.ToolbarDropdownItemSection)
        }
    })));
};
module.exports["Toolbar"] = $ba8f28fe8c9d2747$export$4c260019440d418f;
module.exports["ToolbarNext"] = $ba8f28fe8c9d2747$export$1606f8c5fd0ac145;

});

parcelRegister("gzUv9", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $0cf4befb56ebc307$var$EditorToolbarContext = /*#__PURE__*/ (0, $42omo.createContext)({
    editorView: null,
    editorAppearance: undefined,
    editorViewMode: undefined,
    editorToolbarDockingPreference: undefined
});
const $0cf4befb56ebc307$export$d463571cb9040a24 = ()=>{
    const context = (0, $42omo.useContext)($0cf4befb56ebc307$var$EditorToolbarContext);
    if (!context) throw new Error('useEditorToolbar must be used within EditorToolbarContext');
    return context;
};
const $0cf4befb56ebc307$export$847624ff5ecdfe6d = ({ children: children, editorView: editorView, editorAppearance: editorAppearance, editorViewMode: editorViewMode, editorToolbarDockingPreference: editorToolbarDockingPreference, isOffline: isOffline })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0cf4befb56ebc307$var$EditorToolbarContext.Provider, {
        value: {
            editorView: editorView,
            editorAppearance: editorAppearance,
            editorViewMode: editorViewMode,
            editorToolbarDockingPreference: editorToolbarDockingPreference,
            isOffline: isOffline
        }
    }, children);
};
module.exports["useEditorToolbar"] = $0cf4befb56ebc307$export$d463571cb9040a24;
module.exports["EditorToolbarProvider"] = $0cf4befb56ebc307$export$847624ff5ecdfe6d;

});

parcelRegister("biAkr", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8hoW2 = parcelRequire("8hoW2");


var $dh538 = parcelRequire("dh538");

const $f5cc64b6f3991f95$export$54b6b74e939729c = ({ children: children, api: api, isDisabled: isDisabled, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, fireAnalyticsEvent: fireAnalyticsEvent, keyboardNavigation: keyboardNavigation })=>{
    const onDropdownOpenChanged = (0, $42omo.useCallback)(({ isOpen: isOpen, event: event })=>{
        if (!isOpen) {
            if ((0, $dh538.fg)('platform_editor_toolbar_aifc_patch_7')) {
                // Only refocus the editor when the dropdown closes via mouse or programmatic close.
                // When closed via keyboard Escape, keep focus on the trigger for better keyboard UX.
                const isKeyboardEscape = event instanceof KeyboardEvent && event.key === 'Escape';
                const shouldFocusEditor = !isKeyboardEscape;
                if (shouldFocusEditor) // On Dropdown closed, focus is returned to trigger button by default in requestAnimationFrame
                // Hence, `.focus()` should also be called in requestAnimationFrame
                setTimeout(()=>requestAnimationFrame(()=>{
                        api?.core.actions.focus({
                            scrollIntoView: false
                        });
                    }), 1);
            } else // On Dropdown closed, focus is returned to trigger button by default in requestAnimationFrame
            // Hence, `.focus()` should also be called in requestAnimationFrame
            setTimeout(()=>requestAnimationFrame(()=>{
                    api?.core.actions.focus({
                        scrollIntoView: false
                    });
                }), 1);
        }
    }, [
        api
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8hoW2.ToolbarUIProvider), {
        onDropdownOpenChanged: onDropdownOpenChanged,
        preventDefaultOnMouseDown: true,
        isDisabled: isDisabled,
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        fireAnalyticsEvent: fireAnalyticsEvent,
        keyboardNavigation: keyboardNavigation
    }, children);
};
module.exports["EditorToolbarUIProvider"] = $f5cc64b6f3991f95$export$54b6b74e939729c;

});

parcelRegister("8hoW2", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $e7ebf0f9c8a3aecb$var$ToolbarUIContext = /*#__PURE__*/ (0, $42omo.createContext)({
    onDropdownOpenChanged: ()=>{},
    preventDefaultOnMouseDown: false,
    isDisabled: false,
    popupsMountPoint: undefined,
    fireAnalyticsEvent: undefined,
    keyboardNavigation: undefined
});
const $e7ebf0f9c8a3aecb$export$e7063f2520f6adf8 = ()=>{
    const context = (0, $42omo.useContext)($e7ebf0f9c8a3aecb$var$ToolbarUIContext);
    if (!context) throw new Error('useToolbarUI must be used within ToolbarUIContext');
    return context;
};
const $e7ebf0f9c8a3aecb$export$ae8c3f290017c42a = ({ children: children, onDropdownOpenChanged: onDropdownOpenChanged, preventDefaultOnMouseDown: preventDefaultOnMouseDown, isDisabled: isDisabled, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, fireAnalyticsEvent: fireAnalyticsEvent, keyboardNavigation: keyboardNavigation })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)($e7ebf0f9c8a3aecb$var$ToolbarUIContext.Provider, {
        value: {
            onDropdownOpenChanged: onDropdownOpenChanged,
            preventDefaultOnMouseDown: preventDefaultOnMouseDown,
            isDisabled: isDisabled,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            fireAnalyticsEvent: fireAnalyticsEvent,
            keyboardNavigation: keyboardNavigation
        },
        children: children
    });
};
module.exports["useToolbarUI"] = $e7ebf0f9c8a3aecb$export$e7063f2520f6adf8;
module.exports["ToolbarUIProvider"] = $e7ebf0f9c8a3aecb$export$ae8c3f290017c42a;

});

parcelRegister("kDB94", function(module, exports) {
/* ToolbarButtonGroup.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $gdv5Z = parcelRequire("gdv5Z");

const $434d40eb1243ca8a$var$styles = {
    container: "_1e0c1txw",
    firstChild: "_fb2512x7 _t1diidpf _u6eridpf",
    lastChild: "_fb2512x7 _xk07idpf _1jiyidpf",
    firstChildNew: "_19pe12x7 _1qq0idpf _3nesidpf",
    lastChildNew: "_19pe12x7 _15rdidpf _i84vidpf"
};
const $434d40eb1243ca8a$export$89cfa2b8585c6d03 = ({ children: children })=>{
    const items = (0, $42omo.Children).toArray(children);
    const FirstChild = items.at(0);
    const LastChild = items.at(-1);
    const middleChildren = items.slice(1, -1);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $434d40eb1243ca8a$var$styles.container,
        "data-toolbar-component": "button-group",
        children: items.length <= 1 ? children : /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    className: (0, $gMc0m.default)([
                        $434d40eb1243ca8a$var$styles.firstChildNew
                    ]),
                    children: FirstChild
                }),
                middleChildren,
                /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    className: (0, $gMc0m.default)([
                        $434d40eb1243ca8a$var$styles.lastChildNew
                    ]),
                    children: LastChild
                })
            ]
        })
    });
};
module.exports["ToolbarButtonGroup"] = $434d40eb1243ca8a$export$89cfa2b8585c6d03;

});

parcelRegister("6UWPx", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $ahaN7 = parcelRequire("ahaN7");

const $d5fbcc29f1830e26$export$3e60ddf10b9269e3 = ({ children: children, hasSeparator: hasSeparator, title: title, testId: testId })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $ahaN7.default), {
        hasSeparator: hasSeparator,
        title: title,
        "data-toolbar-component": "menu-section",
        testId: testId,
        children: children
    });
};
module.exports["ToolbarDropdownItemSection"] = $d5fbcc29f1830e26$export$3e60ddf10b9269e3;

});

parcelRegister("48SU7", function(module, exports) {
/* ToolbarSection.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");

var $fe6774c5ada59ba1$export$90683802e28416b5 = /*#__PURE__*/ function(SeparatorPosition) {
    SeparatorPosition["START"] = "start";
    SeparatorPosition["END"] = "end";
    return SeparatorPosition;
}({});
const $fe6774c5ada59ba1$var$styles = {
    container: "_zulp1b66 _1e0c1txw _4cvr1h6o"
};
const $fe6774c5ada59ba1$var$separator = null;
const $fe6774c5ada59ba1$var$ToolbarSeparator = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        "data-toolbar-component": "separator",
        role: "separator",
        "aria-orientation": "vertical",
        className: (0, $gMc0m.default)([
            "_195gu2gc _4t3igktf _1bsbt94y _bfhk1l7x"
        ])
    });
};
const $fe6774c5ada59ba1$export$b978f6a1bb31af67 = ({ children: children, testId: testId, hasSeparator: hasSeparator })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($fe6774c5ada59ba1$var$styles.container),
        testId: testId,
        "data-toolbar-component": "section",
        children: [
            hasSeparator === "start" && /*#__PURE__*/ (0, $l998X.jsx)($fe6774c5ada59ba1$var$ToolbarSeparator, {}),
            children,
            hasSeparator === "end" && /*#__PURE__*/ (0, $l998X.jsx)($fe6774c5ada59ba1$var$ToolbarSeparator, {})
        ]
    });
};
module.exports["SeparatorPosition"] = $fe6774c5ada59ba1$export$90683802e28416b5;
module.exports["ToolbarSection"] = $fe6774c5ada59ba1$export$b978f6a1bb31af67;

});

parcelRegister("cf8NL", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");




parcelRequire("42omo");

const $8c4aad5c55711194$export$671f8dfe06a9af10 = (components, parentKey)=>components.filter((component)=>component.parents.some((parent)=>parent.key === parentKey)).sort((a, b)=>(a.parents.find((p)=>p.key === parentKey)?.rank || 0) - (b.parents.find((p)=>p.key === parentKey)?.rank || 0));
const $8c4aad5c55711194$export$7fc4381d95dc76c8 = (props)=>null;
const $8c4aad5c55711194$export$fc1acc9190910d14 = (component)=>{
    return component.type === 'section';
};


const $8ef88d4c8404920a$var$hasParents = (component)=>{
    return component.type !== 'toolbar';
};
const $8ef88d4c8404920a$var$getChildTypesForParent = (parentType)=>{
    switch(parentType){
        case 'toolbar':
            return [
                'section'
            ];
        case 'section':
            return [
                'group'
            ];
        case 'group':
            return [
                'button',
                'menu'
            ];
        case 'menu':
        case 'nested-menu':
            return [
                'menu-section'
            ];
        case 'menu-section':
            return [
                'menu-item',
                'nested-menu'
            ];
        default:
            return [];
    }
};
const $8ef88d4c8404920a$var$getFallbackComponent = (type, fallbacks)=>{
    switch(type){
        case 'group':
            return fallbacks.group;
        case 'menu-section':
            return fallbacks.menuSection;
        case 'section':
            return fallbacks.section;
        default:
            return 0, $8c4aad5c55711194$export$7fc4381d95dc76c8;
    }
};
const $8ef88d4c8404920a$var$ComponentRenderer = ({ component: component, parents: parents, allComponents: allComponents, fallbacks: fallbacks })=>{
    const childTypes = $8ef88d4c8404920a$var$getChildTypesForParent(component.type);
    const children = (0, $8c4aad5c55711194$export$671f8dfe06a9af10)(allComponents.filter((comp)=>childTypes.includes(comp.type)), component.key);
    if ((component.type === 'menu' || component.type === 'group' || component.type === 'nested-menu' || component.type === 'menu-section') && children.length === 0) return null;
    const Component = component.component || $8ef88d4c8404920a$var$getFallbackComponent(component.type, fallbacks);
    const newParents = [
        ...parents,
        {
            key: component.key,
            type: component.type
        }
    ];
    if (children.length === 0) return /*#__PURE__*/ (0, $l998X.jsx)(Component, {
        parents: parents,
        children: null
    });
    return /*#__PURE__*/ (0, $l998X.jsx)(Component, {
        parents: parents,
        children: children.map((child)=>/*#__PURE__*/ (0, $l998X.jsx)($8ef88d4c8404920a$var$ComponentRenderer, {
                component: child,
                parents: newParents,
                allComponents: allComponents,
                fallbacks: fallbacks
            }, child.key))
    });
};
const $8ef88d4c8404920a$export$9ceb2742df82af54 = ({ toolbar: toolbar, components: components, fallbacks: fallbacks })=>{
    const ToolbarComponent = toolbar.component || (0, $8c4aad5c55711194$export$7fc4381d95dc76c8);
    const sections = (0, $8c4aad5c55711194$export$671f8dfe06a9af10)(components.filter((0, $8c4aad5c55711194$export$fc1acc9190910d14)), toolbar.key);
    return /*#__PURE__*/ (0, $l998X.jsx)(ToolbarComponent, {
        children: sections.map((section)=>/*#__PURE__*/ (0, $l998X.jsx)($8ef88d4c8404920a$var$ComponentRenderer, {
                component: section,
                parents: [
                    {
                        key: toolbar.key,
                        type: toolbar.type
                    }
                ],
                allComponents: components.filter($8ef88d4c8404920a$var$hasParents),
                fallbacks: fallbacks
            }, section.key))
    });
};





parcelRequire("42omo");


const $acef07ebc413ee27$var$isGroup = (component)=>{
    return component.type === 'group';
};
const $acef07ebc413ee27$var$isToolbarItem = (component)=>{
    return component.type === 'button' || component.type === 'menu';
};
const $acef07ebc413ee27$var$isToolbarMenuSection = (component)=>{
    return component.type === 'menu-section';
};
const $acef07ebc413ee27$var$isToolbarMenuItem = (component)=>{
    return component.type === 'menu-item' || component.type === 'menu-section';
};
const $acef07ebc413ee27$var$isToolbarMenuItemOrNestedMenu = (component)=>{
    return component.type === 'menu-item' || component.type === 'menu-section' || component.type === 'nested-menu';
};
const $acef07ebc413ee27$var$getSortedChildren = (components, parentKey)=>components.filter((component)=>component.parents.some((parent)=>parent.key === parentKey)).sort((a, b)=>(a.parents.find((p)=>p.key === parentKey)?.rank || 0) - (b.parents.find((p)=>p.key === parentKey)?.rank || 0));
const $acef07ebc413ee27$export$9ceb2742df82af54 = ({ toolbar: toolbar, components: components, fallbacks: fallbacks })=>{
    const sections = $acef07ebc413ee27$var$getSortedChildren(components.filter((0, $8c4aad5c55711194$export$fc1acc9190910d14)), toolbar.key);
    const groups = components.filter($acef07ebc413ee27$var$isGroup);
    const toolbarItems = components.filter($acef07ebc413ee27$var$isToolbarItem);
    const menuSections = components.filter($acef07ebc413ee27$var$isToolbarMenuSection);
    const menuItems = components.filter($acef07ebc413ee27$var$isToolbarMenuItem);
    const menuItemsAndNestedMenus = components.filter($acef07ebc413ee27$var$isToolbarMenuItemOrNestedMenu);
    const renderToolbarItem = ({ item: item, index: index, parents: parents })=>{
        if (item.type === 'menu') {
            const menuComponents = $acef07ebc413ee27$var$getSortedChildren(menuSections, item.key);
            if (menuComponents.length === 0) return null;
            const Menu = item.component || (0, $8c4aad5c55711194$export$7fc4381d95dc76c8);
            return /*#__PURE__*/ (0, $l998X.jsx)(Menu, {
                parents: parents,
                children: menuComponents.map((menuSection)=>{
                    const menuItemsInSection = $acef07ebc413ee27$var$getSortedChildren(menuItemsAndNestedMenus, menuSection.key);
                    const MenuSection = menuSection.component || fallbacks.menuSection;
                    return /*#__PURE__*/ (0, $l998X.jsx)(MenuSection, {
                        parents: [
                            ...parents,
                            {
                                key: item.key,
                                type: item.type
                            }
                        ],
                        children: menuItemsInSection.map((menuItem)=>{
                            if (menuItem.type === 'nested-menu') {
                                const nestedMenuComponents = $acef07ebc413ee27$var$getSortedChildren(menuSections, menuItem.key);
                                const NestedMenu = menuItem.component;
                                return /*#__PURE__*/ (0, $l998X.jsx)(NestedMenu, {
                                    parents: [
                                        ...parents,
                                        {
                                            key: item.key,
                                            type: item.type
                                        },
                                        {
                                            key: menuSection.key,
                                            type: menuSection.type
                                        }
                                    ],
                                    children: nestedMenuComponents.map((nestedMenuSection)=>{
                                        const menuItemsInNestedMenuSection = $acef07ebc413ee27$var$getSortedChildren(menuItems, nestedMenuSection.key);
                                        const NestedMenuSection = nestedMenuSection.component || fallbacks.menuSection;
                                        return /*#__PURE__*/ (0, $l998X.jsx)(NestedMenuSection, {
                                            parents: [
                                                ...parents,
                                                {
                                                    key: item.key,
                                                    type: item.type
                                                },
                                                {
                                                    key: menuSection.key,
                                                    type: menuSection.type
                                                },
                                                {
                                                    key: menuItem.key,
                                                    type: menuItem.type
                                                }
                                            ],
                                            children: menuItemsInNestedMenuSection.map((nestedMenuItem)=>{
                                                const NestedMenuItem = nestedMenuItem.component || (0, $8c4aad5c55711194$export$7fc4381d95dc76c8);
                                                return /*#__PURE__*/ (0, $l998X.jsx)(NestedMenuItem, {
                                                    parents: [
                                                        ...parents,
                                                        {
                                                            key: item.key,
                                                            type: item.type
                                                        },
                                                        {
                                                            key: menuSection.key,
                                                            type: menuSection.type
                                                        },
                                                        {
                                                            key: menuItem.key,
                                                            type: menuItem.type
                                                        },
                                                        {
                                                            key: nestedMenuSection.key,
                                                            type: nestedMenuSection.type
                                                        }
                                                    ]
                                                }, nestedMenuItem.key);
                                            })
                                        }, nestedMenuSection.key);
                                    })
                                }, menuItem.key);
                            }
                            const MenuItem = menuItem.component || (0, $8c4aad5c55711194$export$7fc4381d95dc76c8);
                            return /*#__PURE__*/ (0, $l998X.jsx)(MenuItem, {
                                parents: [
                                    ...parents,
                                    {
                                        key: item.key,
                                        type: item.type
                                    },
                                    {
                                        key: menuSection.key,
                                        type: menuSection.type
                                    }
                                ]
                            }, menuItem.key);
                        })
                    }, menuSection.key);
                })
            }, item.key);
        }
        const Button = item.component || (0, $8c4aad5c55711194$export$7fc4381d95dc76c8);
        return /*#__PURE__*/ (0, $l998X.jsx)(Button, {
            parents: parents
        }, item.key);
    };
    const renderGroup = (group, parents)=>{
        const groupItems = $acef07ebc413ee27$var$getSortedChildren(toolbarItems, group.key);
        if (groupItems.length === 0) return null;
        const Group = group.component || fallbacks.group;
        return /*#__PURE__*/ (0, $l998X.jsx)(Group, {
            parents: parents,
            children: groupItems.map((item, index)=>{
                return renderToolbarItem({
                    item: item,
                    index: index,
                    parents: [
                        ...parents,
                        {
                            key: group.key,
                            type: group.type
                        }
                    ]
                });
            })
        }, group.key);
    };
    const renderSection = (section)=>{
        const sectionGroups = $acef07ebc413ee27$var$getSortedChildren(groups, section.key);
        const Section = section.component || fallbacks.section;
        const parents = [
            {
                key: toolbar.key,
                type: toolbar.type
            }
        ];
        return /*#__PURE__*/ (0, $l998X.jsx)(Section, {
            parents: parents,
            children: sectionGroups.map((group)=>renderGroup(group, [
                    ...parents,
                    {
                        key: section.key,
                        type: section.type
                    }
                ]))
        }, section.key);
    };
    const ToolbarComponent = toolbar.component || (0, $8c4aad5c55711194$export$7fc4381d95dc76c8);
    return /*#__PURE__*/ (0, $l998X.jsx)(ToolbarComponent, {
        children: sections.map(renderSection)
    });
};


const $0f156ffd6dbbb817$export$9ceb2742df82af54 = ({ toolbar: toolbar, components: components, fallbacks: fallbacks })=>{
    if ((0, $dh538.fg)('platform_editor_toolbar_aifc_renderer_rewrite')) return /*#__PURE__*/ (0, $l998X.jsx)((0, $8ef88d4c8404920a$export$9ceb2742df82af54), {
        toolbar: toolbar,
        components: components,
        fallbacks: fallbacks
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $acef07ebc413ee27$export$9ceb2742df82af54), {
        toolbar: toolbar,
        components: components,
        fallbacks: fallbacks
    });
};
module.exports["ToolbarModelRenderer"] = $0f156ffd6dbbb817$export$9ceb2742df82af54;

});

parcelRegister("dTb09", function(module, exports) {
// Shorthand alias for the global cache map key because it's (intentionally) a long name
const $7b24741974f5c34f$var$CACHE_MAP_KEY = '__conditionalHooksFactory_conditionCacheMap_dont_modify_this_manually_unless_you_want_react_to_blow_up';
// Initialize the global cache map once
globalThis[$7b24741974f5c34f$var$CACHE_MAP_KEY] = globalThis[$7b24741974f5c34f$var$CACHE_MAP_KEY] || new WeakMap();
function $7b24741974f5c34f$export$e328888e5cffce88() {
    globalThis[$7b24741974f5c34f$var$CACHE_MAP_KEY] = new WeakMap();
}
function $7b24741974f5c34f$export$691e93bad45e6f07(condition, newHook, oldHook) {
    const hookFn = (...args)=>{
        // call each time so we can track exposures
        const conditionResult = condition();
        const cache = globalThis[$7b24741974f5c34f$var$CACHE_MAP_KEY];
        if (!cache.has(hookFn)) cache.set(hookFn, conditionResult);
        if (cache.get(hookFn)) return newHook(...args);
        else return oldHook(...args);
    };
    return hookFn;
}
module.exports["conditionalHooksFactory"] = $7b24741974f5c34f$export$691e93bad45e6f07;

});

parcelRegister("cPCP8", function(module, exports) {
const $a7f594e2fbd530f1$export$cc1c18c6e6b6ecaf = {
    INLINE_TEXT_TOOLBAR: 'inline-text-toolbar',
    PRIMARY_TOOLBAR: 'primary-toolbar'
};
const $a7f594e2fbd530f1$export$78ec0124ca63fa02 = {
    key: 'ai-section',
    type: 'section'
};
const $a7f594e2fbd530f1$export$124d2ee606ccdfdc = {
    key: 'ai-view-section',
    type: 'section'
};
const $a7f594e2fbd530f1$export$6d5407fbb0bc912e = {
    key: 'ai-section-primary-toolbar',
    type: 'section'
};
const $a7f594e2fbd530f1$export$ea53d97c37cdede3 = {
    key: 'ai-section-full-page-primary-toolbar',
    type: 'section'
};
const $a7f594e2fbd530f1$export$dcbeb7730f347566 = {
    key: 'ai-section-comment-primary-toolbar',
    type: 'section'
};
const $a7f594e2fbd530f1$export$ab61657fb37116be = {
    key: 'rovo-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$b0e50b17917e2523 = {
    key: 'rovo-group-view',
    type: 'group'
};
const $a7f594e2fbd530f1$export$67ae7e5d398cd98 = {
    key: 'rovo-group-primary-toolbar',
    type: 'group'
};
const $a7f594e2fbd530f1$export$393a27a1587c4748 = {
    key: 'rovo-group-display-small',
    type: 'group'
};
const $a7f594e2fbd530f1$export$164a0130b2b649c6 = {
    key: 'improve-writing-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$e7c291289ee98d9 = {
    key: 'improve-writing-button',
    type: 'button'
};
const $a7f594e2fbd530f1$export$50fb6fd780a8da5a = {
    key: 'hero-prompt-button-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$6ea8ae73b826b63e = {
    key: 'hero-prompt-button',
    type: 'button'
};
const $a7f594e2fbd530f1$export$3d823cd1493e8383 = {
    key: 'rovo-hero-button',
    type: 'button'
};
const $a7f594e2fbd530f1$export$bc3c6b8bbdf543d6 = {
    key: 'rovo-write-button-primary-toolbar',
    type: 'button'
};
const $a7f594e2fbd530f1$export$4532eefb6fdb660c = {
    key: 'rovo-menu',
    type: 'menu'
};
const $a7f594e2fbd530f1$export$245b51779748026d = {
    key: 'rovo-menu-display-small',
    type: 'menu'
};
const $a7f594e2fbd530f1$export$f157764a2d8d74e6 = {
    key: 'rovo-prompt-menu-section',
    type: 'menu-section'
};
const $a7f594e2fbd530f1$export$8be015e65f184637 = {
    key: 'rovo-prompt-menu-section-display-small',
    type: 'menu-section'
};
const $a7f594e2fbd530f1$export$c9c5b3ece9aa9724 = {
    key: 'improve-writing-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$1ede5932cecaa59 = {
    key: 'hero-prompt-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$4799f439258ea378 = {
    key: 'make-shorter-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$b82c17edba0c6a9e = {
    key: 'make-longer-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$1356bd5d76f7fc4 = {
    key: 'change-tone-nested-menu',
    type: 'nested-menu'
};
const $a7f594e2fbd530f1$export$ba297ac76e077190 = {
    key: 'spelling-and-grammar-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$86a7882cf39bf1df = {
    key: 'change-tone-default-menu-section',
    type: 'menu-section'
};
const $a7f594e2fbd530f1$export$d868febccc6870c7 = {
    key: 'more-professional-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$4a7c57dd33fc4a14 = {
    key: 'more-casual-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$3758b89123aa4456 = {
    key: 'more-empathetic-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$76118e0d25ac1fef = {
    key: 'translate-nested-menu',
    type: 'nested-menu'
};
const $a7f594e2fbd530f1$export$a526b8293dafd11c = {
    key: 'translate-menu-section',
    type: 'menu-section'
};
const $a7f594e2fbd530f1$export$5836877aa3028c9d = {
    key: 'define-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$92f779590a87713f = {
    key: 'define-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$8bfe594eeaed8635 = {
    key: 'define-button',
    type: 'button'
};
const $a7f594e2fbd530f1$export$46f6ca06869869c = {
    key: 'text-section',
    type: 'section'
};
const $a7f594e2fbd530f1$export$9821adc8accbec40 = {
    key: 'text-section-primary-toolbar',
    type: 'section'
};
const $a7f594e2fbd530f1$export$65db33ca2d38a784 = {
    key: 'text-section-collapsed',
    type: 'section'
};
const $a7f594e2fbd530f1$export$dbb8e55d66b9ce7c = {
    key: 'text-collapsed-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$50e256f5fa0723b1 = {
    key: 'text-collapsed-menu',
    type: 'menu'
};
const $a7f594e2fbd530f1$export$17de14a70389be62 = {
    key: 'text-styles-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$e3c7868e9e7f30f = {
    key: 'text-styles-menu',
    type: 'menu'
};
const $a7f594e2fbd530f1$export$61c471f0e406c6cd = {
    key: 'text-styles-menu-section',
    type: 'menu-section'
};
const $a7f594e2fbd530f1$export$a0d395bab4f77bed = {
    key: 'normal-text-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$2469e8506da598d3 = {
    key: 'heading-1-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$a065aede28a4fa60 = {
    key: 'heading-2-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$85070b7c6d42e3bb = {
    key: 'heading-3-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$e78c2531f67b545f = {
    key: 'heading-4-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$a92294de346392be = {
    key: 'heading-5-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$9c3cdc8e6d51ce82 = {
    key: 'heading-6-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$f4b89f87980eb537 = {
    key: 'block-quote-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$acdcd8bfebadff8e = {
    key: 'text-formatting-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$3efe78988280adb3 = {
    key: 'text-formatting-group-collapsed',
    type: 'group'
};
const $a7f594e2fbd530f1$export$d709b777a6a93241 = {
    key: 'text-formatting-group-inline',
    type: 'group'
};
const $a7f594e2fbd530f1$export$e54b89ebe974229a = {
    key: 'bold-button-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$eb8680bccd13ec29 = {
    key: 'underline-button-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$b1308631b6ed4b3 = {
    key: 'text-formatting-hero-button',
    type: 'button'
};
const $a7f594e2fbd530f1$export$1f2df85e05c78a28 = {
    key: 'text-formatting-hero-button-collapsed',
    type: 'button'
};
const $a7f594e2fbd530f1$export$512cce888b603a21 = {
    key: 'bold-button',
    type: 'button'
};
const $a7f594e2fbd530f1$export$8ba429f81350a9a5 = {
    key: 'underline-button',
    type: 'button'
};
const $a7f594e2fbd530f1$export$6ed8e5719ec9c8ca = {
    key: 'text-formatting-menu',
    type: 'menu'
};
const $a7f594e2fbd530f1$export$8bc14fdbfc88e3d = {
    key: 'bold-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$55cababf49d70434 = {
    key: 'italic-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$74aa4c917d0fb179 = {
    key: 'underline-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$9caef6162846aa5f = {
    key: 'strike-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$33821ea6eceb9d13 = {
    key: 'code-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$ee8cb7d7ef764bfe = {
    key: 'subscript-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$85ead1ec02f87839 = {
    key: 'superscript-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$6f16936b77c05f44 = {
    key: 'text-formatting-menu-section',
    type: 'menu-section'
};
const $a7f594e2fbd530f1$export$2d7a9246359565f = {
    key: 'clear-formatting-menu-section',
    type: 'menu-section'
};
const $a7f594e2fbd530f1$export$2577e452f5468087 = {
    key: 'clear-formatting-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$eb99509879c4d1a6 = {
    key: 'text-color-highlight-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$126ef012ef4d8c5f = {
    key: 'text-color-highlight-menu',
    type: 'menu'
};
const $a7f594e2fbd530f1$export$70638f1e77085913 = {
    key: 'text-color-highlight-menu-section',
    type: 'menu-section'
};
const $a7f594e2fbd530f1$export$ebd1271b08f151b0 = {
    key: 'text-color-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$bae2fe42c2b86102 = {
    key: 'highlight-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$267f9526bd36c2c = {
    key: 'clear-color-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$36cf1d476157a47d = {
    key: 'alignment-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$b9d75d8ec913c411 = {
    key: 'alignment-menu',
    type: 'menu'
};
const $a7f594e2fbd530f1$export$a7d30f7c1c00dd6e = {
    key: 'alignment-menu-section',
    type: 'menu-section'
};
const $a7f594e2fbd530f1$export$fb5e83c02abc1116 = {
    key: 'align-left-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$920b9c1f02074883 = {
    key: 'align-center-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$77c582b2c8fa437c = {
    key: 'align-right-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$cfa2bcff371b7719 = {
    key: 'lists-indentation-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$e24e846ad969dbb4 = {
    key: 'lists-indentation-group-collapsed',
    type: 'group'
};
const $a7f594e2fbd530f1$export$18e3c58ea662f7ad = {
    key: 'lists-indentation-group-inline',
    type: 'group'
};
const $a7f594e2fbd530f1$export$93963c53c29fc835 = {
    key: 'bullet-list-button-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$6c8387a14e0128fe = {
    key: 'bullet-list-button',
    type: 'button'
};
const $a7f594e2fbd530f1$export$f625e29dbd38e447 = {
    key: 'lists-indentation-hero-button-collapsed',
    type: 'button'
};
const $a7f594e2fbd530f1$export$8709d937e93456c5 = {
    key: 'lists-indentation-hero-button',
    type: 'button'
};
const $a7f594e2fbd530f1$export$77b7fc28d250a53f = {
    key: 'lists-indentation-menu',
    type: 'menu'
};
const $a7f594e2fbd530f1$export$21a99ac537934e71 = {
    key: 'lists-indendation-menu-section',
    type: 'menu-section'
};
const $a7f594e2fbd530f1$export$fc39a5dc74747fed = {
    key: 'bullet-list-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$9d64032e4ea1097c = {
    key: 'numbered-list-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$d6bac99c24b8cdfd = {
    key: 'task-list-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$87678574248a0249 = {
    key: 'indent-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$8fc4080aa2f8adc2 = {
    key: 'outdent-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$8be58f85d6f2b208 = {
    key: 'insert-block-section',
    type: 'section'
};
const $a7f594e2fbd530f1$export$a55d93db15cde50c = {
    key: 'code-block-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$22d0f50f2ec2f1a8 = {
    key: 'code-block-button',
    type: 'button'
};
const $a7f594e2fbd530f1$export$6265c903e79c43eb = {
    key: 'task-list-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$9634f504f88ede38 = {
    key: 'task-list-button',
    type: 'button'
};
const $a7f594e2fbd530f1$export$ce4671f9066f5c48 = {
    key: 'media-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$37025ad4bfe1d2aa = {
    key: 'media-button',
    type: 'button'
};
const $a7f594e2fbd530f1$export$f4c921ea7ce3d48a = {
    key: 'mention-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$450b9a588cdf3949 = {
    key: 'mention-button',
    type: 'button'
};
const $a7f594e2fbd530f1$export$6ca7976638436c6 = {
    key: 'emoji-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$a4310034b096a4ad = {
    key: 'emoji-button',
    type: 'button'
};
const $a7f594e2fbd530f1$export$f746b10bd135ebe5 = {
    key: 'layout-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$bc099bce567fd020 = {
    key: 'layout-button',
    type: 'button'
};
const $a7f594e2fbd530f1$export$19b0175d8da45496 = {
    key: 'table-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$c37ae5d099679682 = {
    key: 'table-button',
    type: 'button'
};
const $a7f594e2fbd530f1$export$c796ec87818935d5 = {
    key: 'table-size-picker',
    type: 'button'
};
const $a7f594e2fbd530f1$export$2db6abe323bf312e = {
    key: 'insert-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$2b79c1387bf4ea1b = {
    key: 'insert-button',
    type: 'button'
};
const $a7f594e2fbd530f1$export$1fc1401e9e5d8a = {
    key: 'linking-section',
    type: 'section'
};
const $a7f594e2fbd530f1$export$87f2f2ff3eb62f79 = {
    key: 'linking-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$3d214445dcf942f2 = {
    key: 'linking-button',
    type: 'button'
};
const $a7f594e2fbd530f1$export$8d13eb2ec1e19466 = {
    key: 'synced-block-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$f7a124e17ae9698f = {
    key: 'synced-block-button',
    type: 'button'
};
const $a7f594e2fbd530f1$export$89dfe9d2d4d25c27 = {
    key: 'synced-block-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$796e931612f154e7 = {
    key: 'synced-block-section',
    type: 'menu-section'
};
const $a7f594e2fbd530f1$export$457818231baddd40 = {
    key: 'collab-section',
    type: 'section'
};
const $a7f594e2fbd530f1$export$8978fe8e689744cc = {
    key: 'comment-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$f97beb46382b3388 = {
    key: 'comment-hero-button',
    type: 'button'
};
const $a7f594e2fbd530f1$export$d757fc54a1831d82 = {
    key: 'apps-section',
    type: 'section'
};
const $a7f594e2fbd530f1$export$c3f44bc1025dceb2 = {
    key: 'track-changes-section',
    type: 'section'
};
const $a7f594e2fbd530f1$export$b3d4f2cdc057cba1 = {
    key: 'undo-changes-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$f13c32a4c68c0806 = {
    key: 'undo-button',
    type: 'button'
};
const $a7f594e2fbd530f1$export$e149a5154bb9b44 = {
    key: 'redo-changes-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$1fb249ec6ca34dd0 = {
    key: 'redo-button',
    type: 'button'
};
const $a7f594e2fbd530f1$export$8e3cd3ec14c6efc = {
    key: 'track-changes-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$9cfd2622f07061e0 = {
    key: 'track-changes-button',
    type: 'button'
};
const $a7f594e2fbd530f1$export$cb18e5ae740a3f22 = {
    key: 'overflow-section',
    type: 'section'
};
const $a7f594e2fbd530f1$export$932f82408ad2af53 = {
    key: 'overflow-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$6583eb3a2765795b = {
    key: 'overflow-menu',
    type: 'menu'
};
const $a7f594e2fbd530f1$export$cefae60670d357d0 = {
    key: 'pin-menu-section',
    type: 'menu-section'
};
const $a7f594e2fbd530f1$export$76d22fa71bc28346 = {
    key: 'pin-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$1b5ea0d5074f7d18 = {
    key: 'overflow-section-primary-toolbar',
    type: 'section'
};
const $a7f594e2fbd530f1$export$a481b12c04259be8 = {
    key: 'overflow-group-primary-toolbar',
    type: 'group'
};
const $a7f594e2fbd530f1$export$b0bb124d5687709e = {
    key: 'overflow-menu-primary-toolbar',
    type: 'menu'
};
const $a7f594e2fbd530f1$export$6d497f3df1049a22 = {
    key: 'pin-section',
    type: 'section'
};
const $a7f594e2fbd530f1$export$762436e7516a2365 = {
    key: 'pin-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$cfefbb6355b14379 = {
    key: 'pin-button',
    type: 'button'
};
const $a7f594e2fbd530f1$export$dd76f40d6548a654 = {
    key: 'loom-menu-section',
    type: 'menu-section'
};
const $a7f594e2fbd530f1$export$4ac3fd1884a40118 = {
    key: 'loom-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$debff7788300c3ff = {
    key: 'selection-extension-menu-section',
    type: 'menu-section'
};
module.exports["TOOLBARS"] = $a7f594e2fbd530f1$export$cc1c18c6e6b6ecaf;
module.exports["AI_SECTION"] = $a7f594e2fbd530f1$export$78ec0124ca63fa02;
module.exports["AI_VIEW_SECTION"] = $a7f594e2fbd530f1$export$124d2ee606ccdfdc;
module.exports["AI_SECTION_PRIMARY_TOOLBAR"] = $a7f594e2fbd530f1$export$6d5407fbb0bc912e;
module.exports["AI_SECTION_FULL_PAGE_PRIMARY_TOOLBAR"] = $a7f594e2fbd530f1$export$ea53d97c37cdede3;
module.exports["AI_SECTION_COMMENT_PRIMARY_TOOLBAR"] = $a7f594e2fbd530f1$export$dcbeb7730f347566;
module.exports["ROVO_GROUP"] = $a7f594e2fbd530f1$export$ab61657fb37116be;
module.exports["ROVO_GROUP_VIEW"] = $a7f594e2fbd530f1$export$b0e50b17917e2523;
module.exports["ROVO_GROUP_PRIMARY_TOOLBAR"] = $a7f594e2fbd530f1$export$67ae7e5d398cd98;
module.exports["ROVO_GROUP_DISPLAY_SMALL"] = $a7f594e2fbd530f1$export$393a27a1587c4748;
module.exports["IMPROVE_WRITING_GROUP"] = $a7f594e2fbd530f1$export$164a0130b2b649c6;
module.exports["IMPROVE_WRITING_BUTTON"] = $a7f594e2fbd530f1$export$e7c291289ee98d9;
module.exports["HERO_PROMPT_BUTTON_GROUP"] = $a7f594e2fbd530f1$export$50fb6fd780a8da5a;
module.exports["HERO_PROMPT_BUTTON"] = $a7f594e2fbd530f1$export$6ea8ae73b826b63e;
module.exports["ROVO_HERO_BUTTON"] = $a7f594e2fbd530f1$export$3d823cd1493e8383;
module.exports["ROVO_WRITE_BUTTON_PRIMARY_TOOLBAR"] = $a7f594e2fbd530f1$export$bc3c6b8bbdf543d6;
module.exports["ROVO_MENU"] = $a7f594e2fbd530f1$export$4532eefb6fdb660c;
module.exports["ROVO_MENU_DISPLAY_SMALL"] = $a7f594e2fbd530f1$export$245b51779748026d;
module.exports["ROVO_PROMPT_MENU_SECTION"] = $a7f594e2fbd530f1$export$f157764a2d8d74e6;
module.exports["ROVO_PROMPT_MENU_SECTION_DISPLAY_SMALL"] = $a7f594e2fbd530f1$export$8be015e65f184637;
module.exports["IMPROVE_WRITING_MENU_ITEM"] = $a7f594e2fbd530f1$export$c9c5b3ece9aa9724;
module.exports["HERO_PROMPT_MENU_ITEM"] = $a7f594e2fbd530f1$export$1ede5932cecaa59;
module.exports["MAKE_SHORTER_MENU_ITEM"] = $a7f594e2fbd530f1$export$4799f439258ea378;
module.exports["MAKE_LONGER_MENU_ITEM"] = $a7f594e2fbd530f1$export$b82c17edba0c6a9e;
module.exports["CHANGE_TONE_NESTED_MENU"] = $a7f594e2fbd530f1$export$1356bd5d76f7fc4;
module.exports["SPELLING_AND_GRAMMAR_MENU_ITEM"] = $a7f594e2fbd530f1$export$ba297ac76e077190;
module.exports["CHANGE_TONE_MENU_SECTION"] = $a7f594e2fbd530f1$export$86a7882cf39bf1df;
module.exports["MORE_PROFESSIONAL_MENU_ITEM"] = $a7f594e2fbd530f1$export$d868febccc6870c7;
module.exports["MORE_CASUAL_MENU_ITEM"] = $a7f594e2fbd530f1$export$4a7c57dd33fc4a14;
module.exports["MORE_EMPATHETIC_MENU_ITEM"] = $a7f594e2fbd530f1$export$3758b89123aa4456;
module.exports["TRANSLATE_NESTED_MENU"] = $a7f594e2fbd530f1$export$76118e0d25ac1fef;
module.exports["TRANSLATE_MENU_SECTION"] = $a7f594e2fbd530f1$export$a526b8293dafd11c;
module.exports["DEFINE_MENU_ITEM"] = $a7f594e2fbd530f1$export$5836877aa3028c9d;
module.exports["DEFINE_GROUP"] = $a7f594e2fbd530f1$export$92f779590a87713f;
module.exports["DEFINE_BUTTON"] = $a7f594e2fbd530f1$export$8bfe594eeaed8635;
module.exports["TEXT_SECTION"] = $a7f594e2fbd530f1$export$46f6ca06869869c;
module.exports["TEXT_SECTION_PRIMARY_TOOLBAR"] = $a7f594e2fbd530f1$export$9821adc8accbec40;
module.exports["TEXT_SECTION_COLLAPSED"] = $a7f594e2fbd530f1$export$65db33ca2d38a784;
module.exports["TEXT_COLLAPSED_GROUP"] = $a7f594e2fbd530f1$export$dbb8e55d66b9ce7c;
module.exports["TEXT_COLLAPSED_MENU"] = $a7f594e2fbd530f1$export$50e256f5fa0723b1;
module.exports["TEXT_STYLES_GROUP"] = $a7f594e2fbd530f1$export$17de14a70389be62;
module.exports["TEXT_STYLES_MENU"] = $a7f594e2fbd530f1$export$e3c7868e9e7f30f;
module.exports["TEXT_STYLES_MENU_SECTION"] = $a7f594e2fbd530f1$export$61c471f0e406c6cd;
module.exports["NORMAL_TEXT_MENU_ITEM"] = $a7f594e2fbd530f1$export$a0d395bab4f77bed;
module.exports["HEADING_1_MENU_ITEM"] = $a7f594e2fbd530f1$export$2469e8506da598d3;
module.exports["HEADING_2_MENU_ITEM"] = $a7f594e2fbd530f1$export$a065aede28a4fa60;
module.exports["HEADING_3_MENU_ITEM"] = $a7f594e2fbd530f1$export$85070b7c6d42e3bb;
module.exports["HEADING_4_MENU_ITEM"] = $a7f594e2fbd530f1$export$e78c2531f67b545f;
module.exports["HEADING_5_MENU_ITEM"] = $a7f594e2fbd530f1$export$a92294de346392be;
module.exports["HEADING_6_MENU_ITEM"] = $a7f594e2fbd530f1$export$9c3cdc8e6d51ce82;
module.exports["BLOCK_QUOTE_MENU_ITEM"] = $a7f594e2fbd530f1$export$f4b89f87980eb537;
module.exports["TEXT_FORMATTING_GROUP"] = $a7f594e2fbd530f1$export$acdcd8bfebadff8e;
module.exports["TEXT_FORMATTING_GROUP_COLLAPSED"] = $a7f594e2fbd530f1$export$3efe78988280adb3;
module.exports["TEXT_FORMATTING_GROUP_INLINE"] = $a7f594e2fbd530f1$export$d709b777a6a93241;
module.exports["BOLD_BUTTON_GROUP"] = $a7f594e2fbd530f1$export$e54b89ebe974229a;
module.exports["UNDERLINE_BUTTON_GROUP"] = $a7f594e2fbd530f1$export$eb8680bccd13ec29;
module.exports["TEXT_FORMATTING_HERO_BUTTON"] = $a7f594e2fbd530f1$export$b1308631b6ed4b3;
module.exports["TEXT_FORMATTING_HERO_BUTTON_COLLAPSED"] = $a7f594e2fbd530f1$export$1f2df85e05c78a28;
module.exports["BOLD_BUTTON"] = $a7f594e2fbd530f1$export$512cce888b603a21;
module.exports["UNDERLINE_BUTTON"] = $a7f594e2fbd530f1$export$8ba429f81350a9a5;
module.exports["TEXT_FORMATTING_MENU"] = $a7f594e2fbd530f1$export$6ed8e5719ec9c8ca;
module.exports["BOLD_MENU_ITEM"] = $a7f594e2fbd530f1$export$8bc14fdbfc88e3d;
module.exports["ITALIC_MENU_ITEM"] = $a7f594e2fbd530f1$export$55cababf49d70434;
module.exports["UNDERLINE_MENU_ITEM"] = $a7f594e2fbd530f1$export$74aa4c917d0fb179;
module.exports["STRIKE_MENU_ITEM"] = $a7f594e2fbd530f1$export$9caef6162846aa5f;
module.exports["CODE_MENU_ITEM"] = $a7f594e2fbd530f1$export$33821ea6eceb9d13;
module.exports["SUBSCRIPT_MENU_ITEM"] = $a7f594e2fbd530f1$export$ee8cb7d7ef764bfe;
module.exports["SUPERSCRIPT_MENU_ITEM"] = $a7f594e2fbd530f1$export$85ead1ec02f87839;
module.exports["TEXT_FORMATTING_MENU_SECTION"] = $a7f594e2fbd530f1$export$6f16936b77c05f44;
module.exports["CLEAR_FORMARTTING_MENU_SECTION"] = $a7f594e2fbd530f1$export$2d7a9246359565f;
module.exports["CLEAR_FORMATTING_MENU_ITEM"] = $a7f594e2fbd530f1$export$2577e452f5468087;
module.exports["TEXT_COLOR_HIGHLIGHT_GROUP"] = $a7f594e2fbd530f1$export$eb99509879c4d1a6;
module.exports["TEXT_COLOR_HIGHLIGHT_MENU"] = $a7f594e2fbd530f1$export$126ef012ef4d8c5f;
module.exports["TEXT_COLOR_HIGHLIGHT_MENU_SECTION"] = $a7f594e2fbd530f1$export$70638f1e77085913;
module.exports["TEXT_COLOR_MENU_ITEM"] = $a7f594e2fbd530f1$export$ebd1271b08f151b0;
module.exports["HIGHLIGHT_MENU_ITEM"] = $a7f594e2fbd530f1$export$bae2fe42c2b86102;
module.exports["CLEAR_COLOR_MENU_ITEM"] = $a7f594e2fbd530f1$export$267f9526bd36c2c;
module.exports["ALIGNMENT_GROUP"] = $a7f594e2fbd530f1$export$36cf1d476157a47d;
module.exports["ALIGNMENT_MENU"] = $a7f594e2fbd530f1$export$b9d75d8ec913c411;
module.exports["ALIGNMENT_MENU_SECTION"] = $a7f594e2fbd530f1$export$a7d30f7c1c00dd6e;
module.exports["ALIGN_LEFT_MENU_ITEM"] = $a7f594e2fbd530f1$export$fb5e83c02abc1116;
module.exports["ALIGN_CENTER_MENU_ITEM"] = $a7f594e2fbd530f1$export$920b9c1f02074883;
module.exports["ALIGN_RIGHT_MENU_ITEM"] = $a7f594e2fbd530f1$export$77c582b2c8fa437c;
module.exports["LISTS_INDENTATION_GROUP"] = $a7f594e2fbd530f1$export$cfa2bcff371b7719;
module.exports["LISTS_INDENTATION_GROUP_COLLAPSED"] = $a7f594e2fbd530f1$export$e24e846ad969dbb4;
module.exports["LISTS_INDENTATION_GROUP_INLINE"] = $a7f594e2fbd530f1$export$18e3c58ea662f7ad;
module.exports["BULLETED_LIST_BUTTON_GROUP"] = $a7f594e2fbd530f1$export$93963c53c29fc835;
module.exports["BULLETED_LIST_BUTTON"] = $a7f594e2fbd530f1$export$6c8387a14e0128fe;
module.exports["LISTS_INDENTATION_HERO_BUTTON_COLLAPSED"] = $a7f594e2fbd530f1$export$f625e29dbd38e447;
module.exports["LISTS_INDENTATION_HERO_BUTTON"] = $a7f594e2fbd530f1$export$8709d937e93456c5;
module.exports["LISTS_INDENTATION_MENU"] = $a7f594e2fbd530f1$export$77b7fc28d250a53f;
module.exports["LISTS_INDENTATION_MENU_SECTION"] = $a7f594e2fbd530f1$export$21a99ac537934e71;
module.exports["BULLETED_LIST_MENU_ITEM"] = $a7f594e2fbd530f1$export$fc39a5dc74747fed;
module.exports["NUMBERED_LIST_MENU_ITEM"] = $a7f594e2fbd530f1$export$9d64032e4ea1097c;
module.exports["TASK_LIST_MENU_ITEM"] = $a7f594e2fbd530f1$export$d6bac99c24b8cdfd;
module.exports["INDENT_MENU_ITEM"] = $a7f594e2fbd530f1$export$87678574248a0249;
module.exports["OUTDENT_MENU_ITEM"] = $a7f594e2fbd530f1$export$8fc4080aa2f8adc2;
module.exports["INSERT_BLOCK_SECTION"] = $a7f594e2fbd530f1$export$8be58f85d6f2b208;
module.exports["CODE_BLOCK_GROUP"] = $a7f594e2fbd530f1$export$a55d93db15cde50c;
module.exports["CODE_BLOCK_BUTTON"] = $a7f594e2fbd530f1$export$22d0f50f2ec2f1a8;
module.exports["TASK_LIST_GROUP"] = $a7f594e2fbd530f1$export$6265c903e79c43eb;
module.exports["TASK_LIST_BUTTON"] = $a7f594e2fbd530f1$export$9634f504f88ede38;
module.exports["MEDIA_GROUP"] = $a7f594e2fbd530f1$export$ce4671f9066f5c48;
module.exports["MEDIA_BUTTON"] = $a7f594e2fbd530f1$export$37025ad4bfe1d2aa;
module.exports["MENTION_GROUP"] = $a7f594e2fbd530f1$export$f4c921ea7ce3d48a;
module.exports["MENTION_BUTTON"] = $a7f594e2fbd530f1$export$450b9a588cdf3949;
module.exports["EMOJI_GROUP"] = $a7f594e2fbd530f1$export$6ca7976638436c6;
module.exports["EMOJI_BUTTON"] = $a7f594e2fbd530f1$export$a4310034b096a4ad;
module.exports["LAYOUT_GROUP"] = $a7f594e2fbd530f1$export$f746b10bd135ebe5;
module.exports["LAYOUT_BUTTON"] = $a7f594e2fbd530f1$export$bc099bce567fd020;
module.exports["TABLE_GROUP"] = $a7f594e2fbd530f1$export$19b0175d8da45496;
module.exports["TABLE_BUTTON"] = $a7f594e2fbd530f1$export$c37ae5d099679682;
module.exports["TABLE_SIZE_PICKER"] = $a7f594e2fbd530f1$export$c796ec87818935d5;
module.exports["INSERT_GROUP"] = $a7f594e2fbd530f1$export$2db6abe323bf312e;
module.exports["INSERT_BUTTON"] = $a7f594e2fbd530f1$export$2b79c1387bf4ea1b;
module.exports["LINKING_SECTION"] = $a7f594e2fbd530f1$export$1fc1401e9e5d8a;
module.exports["LINKING_GROUP"] = $a7f594e2fbd530f1$export$87f2f2ff3eb62f79;
module.exports["LINKING_BUTTON"] = $a7f594e2fbd530f1$export$3d214445dcf942f2;
module.exports["SYNCED_BLOCK_GROUP"] = $a7f594e2fbd530f1$export$8d13eb2ec1e19466;
module.exports["SYNCED_BLOCK_BUTTON"] = $a7f594e2fbd530f1$export$f7a124e17ae9698f;
module.exports["SYNCED_BLOCK_ITEM"] = $a7f594e2fbd530f1$export$89dfe9d2d4d25c27;
module.exports["SYNCED_BLOCK_SECTION"] = $a7f594e2fbd530f1$export$796e931612f154e7;
module.exports["COLLAB_SECTION"] = $a7f594e2fbd530f1$export$457818231baddd40;
module.exports["COMMENT_GROUP"] = $a7f594e2fbd530f1$export$8978fe8e689744cc;
module.exports["COMMENT_HERO_BUTTON"] = $a7f594e2fbd530f1$export$f97beb46382b3388;
module.exports["APPS_SECTION"] = $a7f594e2fbd530f1$export$d757fc54a1831d82;
module.exports["TRACK_CHANGES_SECTION"] = $a7f594e2fbd530f1$export$c3f44bc1025dceb2;
module.exports["UNDO_CHANGES_GROUP"] = $a7f594e2fbd530f1$export$b3d4f2cdc057cba1;
module.exports["UNDO_BUTTON"] = $a7f594e2fbd530f1$export$f13c32a4c68c0806;
module.exports["REDO_CHANGES_GROUP"] = $a7f594e2fbd530f1$export$e149a5154bb9b44;
module.exports["REDO_BUTTON"] = $a7f594e2fbd530f1$export$1fb249ec6ca34dd0;
module.exports["TRACK_CHANGES_GROUP"] = $a7f594e2fbd530f1$export$8e3cd3ec14c6efc;
module.exports["TRACK_CHANGES_BUTTON"] = $a7f594e2fbd530f1$export$9cfd2622f07061e0;
module.exports["OVERFLOW_SECTION"] = $a7f594e2fbd530f1$export$cb18e5ae740a3f22;
module.exports["OVERFLOW_GROUP"] = $a7f594e2fbd530f1$export$932f82408ad2af53;
module.exports["OVERFLOW_MENU"] = $a7f594e2fbd530f1$export$6583eb3a2765795b;
module.exports["PIN_MENU_SECTION"] = $a7f594e2fbd530f1$export$cefae60670d357d0;
module.exports["PIN_MENU_ITEM"] = $a7f594e2fbd530f1$export$76d22fa71bc28346;
module.exports["OVERFLOW_SECTION_PRIMARY_TOOLBAR"] = $a7f594e2fbd530f1$export$1b5ea0d5074f7d18;
module.exports["OVERFLOW_GROUP_PRIMARY_TOOLBAR"] = $a7f594e2fbd530f1$export$a481b12c04259be8;
module.exports["OVERFLOW_MENU_PRIMARY_TOOLBAR"] = $a7f594e2fbd530f1$export$b0bb124d5687709e;
module.exports["PIN_SECTION"] = $a7f594e2fbd530f1$export$6d497f3df1049a22;
module.exports["PIN_GROUP"] = $a7f594e2fbd530f1$export$762436e7516a2365;
module.exports["PIN_BUTTON"] = $a7f594e2fbd530f1$export$cfefbb6355b14379;
module.exports["LOOM_MENU_SECTION"] = $a7f594e2fbd530f1$export$dd76f40d6548a654;
module.exports["LOOM_MENU_ITEM"] = $a7f594e2fbd530f1$export$4ac3fd1884a40118;
module.exports["SELECTION_EXTENSION_MENU_SECTION"] = $a7f594e2fbd530f1$export$debff7788300c3ff;

});

parcelRegister("5ZzFz", function(module, exports) {
const $bc040982397de978$export$75279ffd74fef67b = (component)=>{
    return component?.type === 'toolbar';
};
module.exports["isToolbar"] = $bc040982397de978$export$75279ffd74fef67b;

});

parcelRegister("1PKpt", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $eiA8Z = parcelRequire("eiA8Z");


var $dh538 = parcelRequire("dh538");


var $axOCf = parcelRequire("axOCf");


var $3ae8F = parcelRequire("3ae8F");


var $uq7dM = parcelRequire("uq7dM");

function $949a60155d5990f5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $949a60155d5990f5$var$scrollbarStylesNew = {
    name: "18ng4c4",
    styles: "-ms-overflow-style:-ms-autohiding-scrollbar;&::-webkit-scrollbar-corner{display:none;}&::-webkit-scrollbar-thumb{background-color:var(--ds-background-neutral-subtle, #00000000);}&:hover::-webkit-scrollbar-thumb{background-color:var(--ds-background-neutral-bold, #292A2E);border-radius:var(--ds-radius-large, 8px);}&::-webkit-scrollbar-thumb:hover{background-color:var(--ds-background-neutral-bold-hovered, #3B3D42);}"
};
const $949a60155d5990f5$var$chromelessEditorStylesNew = {
    name: "1236vqr",
    styles: "line-height:20px;height:auto;overflow-x:hidden;overflow-y:auto;max-width:inherit;box-sizing:border-box;word-wrap:break-word;div > .ProseMirror{outline:none;white-space:pre-wrap;padding:0;margin:0;& > :last-child{padding-bottom:var(--ds-space-100, 0.5em);}}"
};
const $949a60155d5990f5$var$extraSpaceLastLineFix = {
    name: "1cghcav",
    styles: ".ProseMirror{& > p:last-of-type{margin-bottom:var(--ds-space-0, 0px);}}"
};
class $949a60155d5990f5$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    render() {
        return /*#__PURE__*/ (0, $9K4OG.jsx)($949a60155d5990f5$var$RenderWithPluginState, {
            editorAPI: this.props.editorAPI,
            renderChrome: this.renderChrome
        });
    }
    constructor(...args){
        super(...args);
        this.appearance = 'chromeless';
        this.containerElement = null;
        this.renderChrome = ({ maxContentSize: maxContentSize })=>{
            const { editorDOMElement: editorDOMElement, editorView: editorView, editorActions: editorActions, eventDispatcher: eventDispatcher, providerFactory: providerFactory, contentComponents: contentComponents, customContentComponents: customContentComponents, maxHeight: maxHeight, minHeight: minHeight = 30, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, disabled: disabled, dispatchAnalyticsEvent: dispatchAnalyticsEvent, pluginHooks: pluginHooks, featureFlags: featureFlags } = this.props;
            const maxContentSizeReached = Boolean(maxContentSize?.maxContentSizeReached);
            const editorViewMode = (0, $eiA8Z.useSharedPluginStateWithSelector)(this.props.editorAPI, [
                'editorViewMode'
            ], (states)=>states?.editorViewModeState?.mode);
            return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $uq7dM.default), {
                animate: maxContentSizeReached
            }, /*#__PURE__*/ (0, $9K4OG.jsx)($949a60155d5990f5$export$5ffd32ebea3773c5, {
                maxHeight: maxHeight,
                minHeight: minHeight,
                containerRef: (ref)=>this.containerElement = ref
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $axOCf.default), {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                className: "ak-editor-content-area",
                featureFlags: featureFlags,
                viewMode: editorViewMode,
                appearance: this.appearance
            }, customContentComponents && 'before' in customContentComponents ? customContentComponents.before : customContentComponents, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3ae8F.default), {
                editorView: editorView,
                editorActions: editorActions,
                eventDispatcher: eventDispatcher,
                providerFactory: providerFactory,
                appearance: this.appearance,
                items: contentComponents,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement,
                containerElement: this.containerElement,
                disabled: !!disabled,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                wrapperElement: this.containerElement,
                pluginHooks: pluginHooks
            }), editorDOMElement, customContentComponents && 'after' in customContentComponents ? customContentComponents.after : null)));
        };
    }
}
$949a60155d5990f5$export$2e2bcd8739ae039.displayName = 'ChromelessEditorAppearance';
function $949a60155d5990f5$var$RenderWithPluginState({ renderChrome: renderChrome, editorAPI: editorAPI }) {
    const maxContentSizeReached = (0, $eiA8Z.useSharedPluginStateWithSelector)(editorAPI, [
        'maxContentSize'
    ], (states)=>states?.maxContentSizeState?.maxContentSizeReached);
    const maxContentSize = maxContentSizeReached === undefined ? undefined : {
        maxContentSizeReached: maxContentSizeReached
    };
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, renderChrome({
        maxContentSize: maxContentSize
    }));
}
function $949a60155d5990f5$export$5ffd32ebea3773c5({ maxHeight: maxHeight, minHeight: minHeight, children: children, containerRef: containerRef }) {
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: [
            $949a60155d5990f5$var$chromelessEditorStylesNew,
            $949a60155d5990f5$var$scrollbarStylesNew,
            (0, $dh538.fg)('platform_fix_extra_space_last_line_comment_editor') && $949a60155d5990f5$var$extraSpaceLastLineFix
        ],
        style: {
            maxHeight: maxHeight ? `${maxHeight}px` : undefined,
            minHeight: `${minHeight}px`
        },
        "data-testid": "chromeless-editor",
        id: "chromeless-editor",
        ref: containerRef
    }, children);
}
module.exports["default"] = $949a60155d5990f5$export$2e2bcd8739ae039;

});

parcelRegister("aqrhZ", function(module, exports) {
$parcel$export(module.exports, "lazyForPaint", () => (parcelRequire("96msn")).lazyForPaint);
$parcel$export(module.exports, "lazyAfterPaint", () => (parcelRequire("96msn")).lazyAfterPaint);
$parcel$export(module.exports, "lazy", () => (parcelRequire("96msn")).lazy);
$parcel$export(module.exports, "LazySuspense", () => (parcelRequire("jyd5r")).LazySuspense);
$parcel$export(module.exports, "useLazyPhase", () => (parcelRequire("6y0vU")).useLazyPhase);
parcelRequire("8dgvm");
var $dXZzO = parcelRequire("dXZzO");


var $lhchg = parcelRequire("lhchg");


var $96msn = parcelRequire("96msn");

parcelRequire("1BwGq");
var $jnAB4 = parcelRequire("jnAB4");
var $9uVEz = parcelRequire("9uVEz");

parcelRequire("eow39");
var $jyd5r = parcelRequire("jyd5r");

parcelRequire("ecrVx");
var $6y0vU = parcelRequire("6y0vU");


var $iYRNV = parcelRequire("iYRNV");


});

parcelRegister("aQIfl", function(module, exports) {
const $0209d2ec05e7d0da$export$303f43e55cf1ef2f = (manifest, id)=>{
    if (!manifest.assets[id]) return;
    return manifest.assets[id].map((asset)=>`${manifest.publicPath}${asset}`);
};
module.exports["getAssetUrlsFromId"] = $0209d2ec05e7d0da$export$303f43e55cf1ef2f;

});

parcelRegister("9hDHZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $6c2480da09d16f89$export$2e2bcd8739ae039);
function $6c2480da09d16f89$export$2e2bcd8739ae039(target, object) {
    if (target == null) throw new TypeError('assign requires that input parameter not be null or undefined');
    for(var property in object)if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
    return target;
}

});

parcelRegister("62guz", function(module, exports) {
$parcel$export(module.exports, "default", () => $464fb8f83176ac12$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $464fb8f83176ac12$export$2e2bcd8739ae039(dateLeft, dateRight) {
    (0, $b5utg.default)(2, arguments);
    return (0, $egXhZ.default)(dateLeft).getTime() - (0, $egXhZ.default)(dateRight).getTime();
}

});

parcelRegister("fls5L", function(module, exports) {
var $b2be9bac2e487919$var$roundingMap = {
    ceil: Math.ceil,
    round: Math.round,
    floor: Math.floor,
    trunc: function trunc(value) {
        return value < 0 ? Math.ceil(value) : Math.floor(value);
    } // Math.trunc is not supported by IE
};
var $b2be9bac2e487919$var$defaultRoundingMethod = 'trunc';
function $b2be9bac2e487919$export$b6474a47258c1211(method) {
    return method ? $b2be9bac2e487919$var$roundingMap[method] : $b2be9bac2e487919$var$roundingMap[$b2be9bac2e487919$var$defaultRoundingMethod];
}
module.exports["getRoundingMethod"] = $b2be9bac2e487919$export$b6474a47258c1211;

});

parcelRegister("c3Z6w", function(module, exports) {
$parcel$export(module.exports, "default", () => $8c8529e15839e3e9$export$2e2bcd8739ae039);

var $2h3f7 = parcelRequire("2h3f7");


var $bIrEX = parcelRequire("bIrEX");


var $7HtfM = parcelRequire("7HtfM");


var $eDMGY = parcelRequire("eDMGY");


var $g3Gzi = parcelRequire("g3Gzi");


var $egXhZ = parcelRequire("egXhZ");


var $hG32I = parcelRequire("hG32I");


var $9hDHZ = parcelRequire("9hDHZ");


var $qc9ak = parcelRequire("qc9ak");


var $b5utg = parcelRequire("b5utg");

var $8c8529e15839e3e9$var$MINUTES_IN_DAY = 1440;
var $8c8529e15839e3e9$var$MINUTES_IN_ALMOST_TWO_DAYS = 2520;
var $8c8529e15839e3e9$var$MINUTES_IN_MONTH = 43200;
var $8c8529e15839e3e9$var$MINUTES_IN_TWO_MONTHS = 86400;
function $8c8529e15839e3e9$export$2e2bcd8739ae039(dirtyDate, dirtyBaseDate, options) {
    var _ref, _options$locale;
    (0, $b5utg.default)(2, arguments);
    var defaultOptions = (0, $2h3f7.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $g3Gzi.default);
    if (!locale.formatDistance) throw new RangeError('locale must contain formatDistance property');
    var comparison = (0, $bIrEX.default)(dirtyDate, dirtyBaseDate);
    if (isNaN(comparison)) throw new RangeError('Invalid time value');
    var localizeOptions = (0, $9hDHZ.default)((0, $hG32I.default)(options), {
        addSuffix: Boolean(options === null || options === void 0 ? void 0 : options.addSuffix),
        comparison: comparison
    });
    var dateLeft;
    var dateRight;
    if (comparison > 0) {
        dateLeft = (0, $egXhZ.default)(dirtyBaseDate);
        dateRight = (0, $egXhZ.default)(dirtyDate);
    } else {
        dateLeft = (0, $egXhZ.default)(dirtyDate);
        dateRight = (0, $egXhZ.default)(dirtyBaseDate);
    }
    var seconds = (0, $eDMGY.default)(dateRight, dateLeft);
    var offsetInSeconds = ((0, $qc9ak.default)(dateRight) - (0, $qc9ak.default)(dateLeft)) / 1000;
    var minutes = Math.round((seconds - offsetInSeconds) / 60);
    var months;
    // 0 up to 2 mins
    if (minutes < 2) {
        if (options !== null && options !== void 0 && options.includeSeconds) {
            if (seconds < 5) return locale.formatDistance('lessThanXSeconds', 5, localizeOptions);
            else if (seconds < 10) return locale.formatDistance('lessThanXSeconds', 10, localizeOptions);
            else if (seconds < 20) return locale.formatDistance('lessThanXSeconds', 20, localizeOptions);
            else if (seconds < 40) return locale.formatDistance('halfAMinute', 0, localizeOptions);
            else if (seconds < 60) return locale.formatDistance('lessThanXMinutes', 1, localizeOptions);
            else return locale.formatDistance('xMinutes', 1, localizeOptions);
        } else {
            if (minutes === 0) return locale.formatDistance('lessThanXMinutes', 1, localizeOptions);
            else return locale.formatDistance('xMinutes', minutes, localizeOptions);
        }
    } else if (minutes < 45) return locale.formatDistance('xMinutes', minutes, localizeOptions);
    else if (minutes < 90) return locale.formatDistance('aboutXHours', 1, localizeOptions);
    else if (minutes < $8c8529e15839e3e9$var$MINUTES_IN_DAY) {
        var hours = Math.round(minutes / 60);
        return locale.formatDistance('aboutXHours', hours, localizeOptions);
    // 1 day up to 1.75 days
    } else if (minutes < $8c8529e15839e3e9$var$MINUTES_IN_ALMOST_TWO_DAYS) return locale.formatDistance('xDays', 1, localizeOptions);
    else if (minutes < $8c8529e15839e3e9$var$MINUTES_IN_MONTH) {
        var days = Math.round(minutes / $8c8529e15839e3e9$var$MINUTES_IN_DAY);
        return locale.formatDistance('xDays', days, localizeOptions);
    // 1 month up to 2 months
    } else if (minutes < $8c8529e15839e3e9$var$MINUTES_IN_TWO_MONTHS) {
        months = Math.round(minutes / $8c8529e15839e3e9$var$MINUTES_IN_MONTH);
        return locale.formatDistance('aboutXMonths', months, localizeOptions);
    }
    months = (0, $7HtfM.default)(dateRight, dateLeft);
    // 2 months up to 12 months
    if (months < 12) {
        var nearestMonth = Math.round(minutes / $8c8529e15839e3e9$var$MINUTES_IN_MONTH);
        return locale.formatDistance('xMonths', nearestMonth, localizeOptions);
    // 1 year up to max Date
    } else {
        var monthsSinceStartOfYear = months % 12;
        var years = Math.floor(months / 12);
        // N years up to 1 years 3 months
        if (monthsSinceStartOfYear < 3) return locale.formatDistance('aboutXYears', years, localizeOptions);
        else if (monthsSinceStartOfYear < 9) return locale.formatDistance('overXYears', years, localizeOptions);
        else return locale.formatDistance('almostXYears', years + 1, localizeOptions);
    }
}

});

parcelRegister("eDMGY", function(module, exports) {
$parcel$export(module.exports, "default", () => $aa8a7a6d6e092fc8$export$2e2bcd8739ae039);

var $62guz = parcelRequire("62guz");


var $b5utg = parcelRequire("b5utg");


var $fls5L = parcelRequire("fls5L");

function $aa8a7a6d6e092fc8$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $b5utg.default)(2, arguments);
    var diff = (0, $62guz.default)(dateLeft, dateRight) / 1000;
    return (0, $fls5L.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

});

parcelRegister("hG32I", function(module, exports) {
$parcel$export(module.exports, "default", () => $cde8b8224908a12d$export$2e2bcd8739ae039);

var $9hDHZ = parcelRequire("9hDHZ");

function $cde8b8224908a12d$export$2e2bcd8739ae039(object) {
    return (0, $9hDHZ.default)({}, object);
}

});

parcelRegister("TfRUG", function(module, exports) {
const $789182d0618bed14$export$15a09f5ef055bcfa = '\u200b';
const $789182d0618bed14$export$2b4d00c13dcd3c1f = '\u200d';
module.exports["ZERO_WIDTH_SPACE"] = $789182d0618bed14$export$15a09f5ef055bcfa;
module.exports["ZERO_WIDTH_JOINER"] = $789182d0618bed14$export$2b4d00c13dcd3c1f;

});

parcelRegister("7iE7T", function(module, exports) {

var $h9yJL = parcelRequire("h9yJL");


var $8m4tT = parcelRequire("8m4tT");

const $3b2d37886a4003ec$export$cdc577fd3f583194 = (tr)=>{
    const nodes = [];
    const steps = tr.steps || [];
    steps.forEach((step)=>{
        step.getMap().forEach((oldStart, oldEnd, newStart, newEnd)=>{
            tr.doc.nodesBetween(newStart, Math.min(newEnd, tr.doc.content.size), (node)=>{
                if (!nodes.find((n)=>n === node)) nodes.push(node);
                return false;
            });
        });
    });
    return nodes;
};
const $3b2d37886a4003ec$export$4c39e41e39b3c449 = (node)=>{
    try {
        node.check(); // this will throw an error if the node is invalid
    } catch (error) {
        return false;
    }
    return true;
};
const $3b2d37886a4003ec$export$996213f7c272fc6f = (nodes)=>nodes.every($3b2d37886a4003ec$export$4c39e41e39b3c449);
const $3b2d37886a4003ec$export$26b9f946b448f23e = (node, type)=>type && node && node.type === type;
const $3b2d37886a4003ec$export$d7ae8c533ae18832 = (node, schema)=>$3b2d37886a4003ec$export$26b9f946b448f23e(node, schema.nodes.paragraph);
const $3b2d37886a4003ec$export$1879817ac5c922b7 = (node, schema)=>$3b2d37886a4003ec$export$26b9f946b448f23e(node, schema.nodes.text);
const $3b2d37886a4003ec$export$5dfeda3a9e6fe056 = (node, schema)=>$3b2d37886a4003ec$export$26b9f946b448f23e(node, schema.marks.link);
var $3b2d37886a4003ec$export$a6212ae0c82963af = /*#__PURE__*/ function(SelectedState) {
    SelectedState[SelectedState["selectedInRange"] = 0] = "selectedInRange";
    SelectedState[SelectedState["selectedInside"] = 1] = "selectedInside";
    return SelectedState;
}({});
const $3b2d37886a4003ec$export$5125f50e751e84db = (anchorPosition, headPosition, nodePosition, nodeSize)=>{
    if (typeof nodePosition !== 'number') return null;
    const rangeStart = Math.min(anchorPosition, headPosition);
    const rangeEnd = Math.max(anchorPosition, headPosition);
    const nodeStart = nodePosition;
    const nodeEnd = nodePosition + nodeSize;
    if (anchorPosition === headPosition) return null;
    if (rangeStart <= nodeStart && nodeEnd < rangeEnd || rangeStart < nodeStart && nodeEnd <= rangeEnd) return 0;
    if (nodeStart <= anchorPosition && headPosition <= nodeEnd) return 1;
    return null;
};
const $3b2d37886a4003ec$export$b6e38334b1fb4d1b = (state, fragment, currentAppearance)=>{
    const depth = currentAppearance === 'embed' || currentAppearance === 'block' ? undefined : -1;
    const parent = state.selection.$from.node(depth);
    return parent && parent.type.validContent(fragment);
};
const $3b2d37886a4003ec$export$d6ca4605aefeca32 = (node)=>{
    return [
        'media',
        'mediaInline',
        'mediaGroup',
        'mediaSingle'
    ].includes(node.type.name);
};
const $3b2d37886a4003ec$export$cfaa7840b0c93780 = ($pos, state)=>{
    let nodeBefore = $pos.nodeBefore;
    if (!nodeBefore) {
        const depthOfParent = $pos.depth - 1 || 1;
        const parentNode = (0, $8m4tT.findParentNodeOfType)([
            state.schema.nodes[`${$pos.node(depthOfParent).type.name}`]
        ])(state.selection);
        const resolvedPosOfParentNode = parentNode ? state.tr.doc.resolve(parentNode.pos) : undefined;
        const nodeBeforeParent = resolvedPosOfParentNode && resolvedPosOfParentNode.pos < state.doc.nodeSize ? resolvedPosOfParentNode.nodeBefore : undefined;
        if (nodeBeforeParent) nodeBefore = nodeBeforeParent;
    }
    if (nodeBefore) return [
        'media',
        'mediaInline',
        'mediaGroup',
        'mediaSingle'
    ].includes(nodeBefore.type.name);
    return false;
};
const $3b2d37886a4003ec$var$transformer = new (0, $h9yJL.JSONTransformer)();
function $3b2d37886a4003ec$export$54fd2c36b5cc6731(node) {
    return $3b2d37886a4003ec$var$transformer.encode(node);
}
function $3b2d37886a4003ec$export$3a858d3babd60825(node) {
    return $3b2d37886a4003ec$var$transformer.encodeNode(node);
}
module.exports["isParagraph"] = $3b2d37886a4003ec$export$d7ae8c533ae18832;
module.exports["isText"] = $3b2d37886a4003ec$export$1879817ac5c922b7;
module.exports["isLinkMark"] = $3b2d37886a4003ec$export$5dfeda3a9e6fe056;
module.exports["SelectedState"] = $3b2d37886a4003ec$export$a6212ae0c82963af;
module.exports["isNodeSelectedOrInRange"] = $3b2d37886a4003ec$export$5125f50e751e84db;
module.exports["isSupportedInParent"] = $3b2d37886a4003ec$export$b6e38334b1fb4d1b;
module.exports["isMediaNode"] = $3b2d37886a4003ec$export$d6ca4605aefeca32;
module.exports["isNodeBeforeMediaNode"] = $3b2d37886a4003ec$export$cfaa7840b0c93780;
module.exports["toJSON"] = $3b2d37886a4003ec$export$54fd2c36b5cc6731;
module.exports["nodeToJSON"] = $3b2d37886a4003ec$export$3a858d3babd60825;

});

parcelRegister("2GVu1", function(module, exports) {
/* ToolbarDropdownItem.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $dAYOx = parcelRequire("dAYOx");


var $fVUfS = parcelRequire("fVUfS");


var $1oCLl = parcelRequire("1oCLl");


var $5v3PK = parcelRequire("5v3PK");

const $d0623f38ad0eaa49$var$styles = {
    toolbarDropdownItem: "_11c82smr _18zrutpp _1rjc1b66 _1e0c1txw _kqswh2mm _bfhksm61 _1bsb1osq _1tkezwfg _1ul9eoa3 _syazazsu _1bas12b0 _1ah31i6y",
    enabled: "_irr31dpa _1di6fcek",
    disabled: "_syaz1gmx _80om13gf",
    selected: "_bfhk15s3 _syaz6x5g _irr3ufnl _1di6nozp"
};
const $d0623f38ad0eaa49$var$CustomDropdownMenuItemButton = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, 'data-testid': testId, 'aria-haspopup': ariaHasPopup, 'aria-disabled': ariaDisabled, 'aria-pressed': ariaPressed, 'aria-keyshortcuts': ariaKeyshortcuts, onClick: onClick, tabIndex: tabIndex }, ref)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
        testId: testId,
        xcss: (0, $1Whri.cx)($d0623f38ad0eaa49$var$styles.toolbarDropdownItem, ariaDisabled ? $d0623f38ad0eaa49$var$styles.disabled : ariaPressed ? $d0623f38ad0eaa49$var$styles.selected : $d0623f38ad0eaa49$var$styles.enabled),
        onClick: onClick,
        tabIndex: tabIndex,
        "aria-haspopup": ariaHasPopup,
        "aria-expanded": ariaHasPopup ? ariaPressed ? true : false : undefined,
        "aria-pressed": ariaPressed,
        "aria-disabled": ariaDisabled,
        "aria-keyshortcuts": ariaKeyshortcuts,
        "data-toolbar-component": (0, $1oCLl.expValEquals)('platform_synced_block', 'isEnabled', true) ? 'menu-item' : undefined,
        ref: ref,
        children: children
    }));
const $d0623f38ad0eaa49$export$abcb00136d206988 = ({ onClick: onClick, elemBefore: elemBefore, elemAfter: elemAfter, isSelected: isSelected, children: children, isDisabled: isDisabled, hasNestedDropdownMenu: hasNestedDropdownMenu, triggerRef: triggerRef, shouldTitleWrap: shouldTitleWrap = true, testId: testId, ariaKeyshortcuts: ariaKeyshortcuts, href: href, target: target, rel: rel })=>{
    const parentContext = (0, $5v3PK.useToolbarDropdownMenu)();
    const injectedElemAfter = (()=>{
        if (!/*#__PURE__*/ (0, $42omo.isValidElement)(elemAfter)) return elemAfter;
        const elementProps = elemAfter.props;
        if ('isDisabled' in elementProps) return elemAfter;
        return /*#__PURE__*/ (0, $42omo.cloneElement)(elemAfter, {
            ...elementProps,
            isDisabled: isDisabled
        });
    })();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $dAYOx.default), {
        onClick: (e)=>{
            if (!hasNestedDropdownMenu) parentContext?.closeMenu();
            onClick?.(e);
        },
        elemBefore: elemBefore,
        elemAfter: (0, $1oCLl.expValEquals)('platform_editor_toolbar_aifc_patch_5', 'isEnabled', true) ? injectedElemAfter : elemAfter,
        isSelected: isSelected,
        isDisabled: isDisabled,
        "aria-haspopup": hasNestedDropdownMenu,
        "aria-pressed": isSelected,
        "aria-keyshortcuts": ariaKeyshortcuts,
        ref: triggerRef,
        href: href,
        target: target,
        rel: rel,
        // @ts-ignore -- This `CustomDropdownMenuItemButton` has type conflicts with the `DropdownItem` component in a way that cannot be reconciled (ignored as it fails types in Jira and should in Platform)
        component: href && (0, $1oCLl.expValEquals)('platform_editor_toolbar_migrate_loom', 'isEnabled', true) ? undefined : $d0623f38ad0eaa49$var$CustomDropdownMenuItemButton,
        testId: testId,
        "data-toolbar-component": "menu-item",
        shouldTitleWrap: shouldTitleWrap,
        children: children
    });
};
module.exports["ToolbarDropdownItem"] = $d0623f38ad0eaa49$export$abcb00136d206988;

});

parcelRegister("5v3PK", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $3d7023a12eab06cb$var$ToolbarDropdownMenuContext = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $3d7023a12eab06cb$export$4a532e97cc88ad2f = ()=>{
    return (0, $42omo.useContext)($3d7023a12eab06cb$var$ToolbarDropdownMenuContext);
};
const $3d7023a12eab06cb$export$7baf0d20f25b94dd = ({ children: children, isOpen: isOpen, setIsOpen: setIsOpen })=>{
    const [isOpenInternal, setIsOpenInternal] = (0, $42omo.useState)(false);
    const openMenu = ()=>{
        if (setIsOpen !== undefined) setIsOpen(true);
        else setIsOpenInternal(true);
    };
    const closeMenu = ()=>{
        if (setIsOpen !== undefined) setIsOpen(false);
        else setIsOpenInternal(false);
    };
    const contextValue = {
        openMenu: openMenu,
        closeMenu: closeMenu,
        isOpen: isOpen !== undefined ? isOpen : isOpenInternal
    };
    return /*#__PURE__*/ (0, $l998X.jsx)($3d7023a12eab06cb$var$ToolbarDropdownMenuContext.Provider, {
        value: contextValue,
        children: children
    });
};
module.exports["useToolbarDropdownMenu"] = $3d7023a12eab06cb$export$4a532e97cc88ad2f;
module.exports["ToolbarDropdownMenuProvider"] = $3d7023a12eab06cb$export$7baf0d20f25b94dd;

});

parcelRegister("7ERUE", function(module, exports) {
/* ToolbarButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $fVUfS = parcelRequire("fVUfS");


var $8hoW2 = parcelRequire("8hoW2");

const $ce07609a59c94f1e$var$styles = {
    button: "_zulp12x7 _2rko12b0 _11c82smr _1e0c1txw _bfhksm61 _o5721q9c _4cvr1h6o _1bah1h6o _1tke1f4h _syazazsu _19bvu2gc _u5f3u2gc _1ah3idpf _g0pbkb7n _oh03h2mm",
    enabled: "_irr31dpa _1di6fcek",
    disabled: "_syaz1gmx _80om13gf",
    selected: "_bfhk15s3 _syaz6x5g _irr3ufnl _1di6nozp"
};
const $ce07609a59c94f1e$export$e5c1a33878e86e9e = /*#__PURE__*/ (0, $42omo.forwardRef)(({ iconBefore: iconBefore, children: children, onClick: onClick, isSelected: isSelected, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, 'aria-controls': ariaControls, 'data-ds--level': dataDsLevel, onBlur: onBlur, onFocus: onFocus, testId: testId, id: id, isDisabled: isDisabled, ariaKeyshortcuts: ariaKeyshortcuts, label: label, interactionName: interactionName }, ref)=>{
    const { preventDefaultOnMouseDown: preventDefaultOnMouseDown, isDisabled: ctxDisabled } = (0, $8hoW2.useToolbarUI)();
    const disabled = Boolean(ctxDisabled || isDisabled);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $fVUfS.default), {
        ref: ref,
        xcss: (0, $1Whri.cx)($ce07609a59c94f1e$var$styles.button, disabled ? $ce07609a59c94f1e$var$styles.disabled : isSelected ? $ce07609a59c94f1e$var$styles.selected : $ce07609a59c94f1e$var$styles.enabled),
        "aria-pressed": isSelected,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHasPopup,
        "aria-controls": ariaControls,
        "aria-keyshortcuts": ariaKeyshortcuts,
        "aria-label": label,
        "data-ds--level": dataDsLevel,
        onClick: onClick,
        onBlur: onBlur,
        onFocus: onFocus,
        testId: testId,
        id: id,
        isDisabled: disabled,
        onMouseDown: (event)=>{
            if (preventDefaultOnMouseDown) event.preventDefault();
        },
        "data-toolbar-component": "button",
        interactionName: interactionName,
        children: [
            iconBefore,
            children
        ]
    });
});
module.exports["ToolbarButton"] = $ce07609a59c94f1e$export$e5c1a33878e86e9e;

});

parcelRegister("iIVVb", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $3gadb = parcelRequire("3gadb");

const $769eb2f07aee64ec$export$7293ce116b97b92a = ({ content: content, children: children, position: position = 'top', delay: delay })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: content,
        position: position,
        delay: delay,
        children: children
    });
};
module.exports["ToolbarTooltip"] = $769eb2f07aee64ec$export$7293ce116b97b92a;

});

parcelRegister("azNN5", function(module, exports) {
/** Created by scanning the Wikipedia page for all TLDs and selecting those that are common filenames, along
 * with customer complaints */ const $3c2499649d330fb3$var$tldsToNotAutoLinkify = [
    'name',
    'zip',
    'doc',
    'mov',
    // Ensure common 2 character file extensions aren't linkified without https prefix
    'md',
    // Postscript
    'ps',
    // C++
    'cc',
    // C#
    'cs',
    // f#
    'fs',
    // Go
    'go',
    // JavaScript
    'js',
    // Perl
    'pl',
    // Perl module
    'pm',
    // Python
    'py',
    // Ruby
    'rb',
    // Rust
    'rs',
    // Bash
    'sh',
    // Typescript
    'ts',
    // C#
    'cs',
    // Visual Basic
    'vb'
];
function $3c2499649d330fb3$export$977fe75b90bdd614(url) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const startsWithHttpHttps = /^https?:\/\//.test(url);
    if (startsWithHttpHttps) return true;
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const startsWithWWW = /^www\./.test(url);
    if (startsWithWWW) return true;
    try {
        const hostname = new URL(`https://${url}`).hostname;
        const parts = hostname.split('.');
        const tld = parts.length > 1 ? parts[parts.length - 1] : null;
        if (parts[0] === '') // If the domain is an empty string (ie the link is `.com`), it's invalid, so
        // automatically return true
        return true;
        if (!tld) return true;
        return !$3c2499649d330fb3$var$tldsToNotAutoLinkify.includes(tld);
    } catch (e) {
        return true;
    }
}
function $3c2499649d330fb3$export$e19a09e301eaa6bb(match) {
    return $3c2499649d330fb3$export$977fe75b90bdd614(match.raw);
}
module.exports["shouldAutoLinkifyMatch"] = $3c2499649d330fb3$export$e19a09e301eaa6bb;

});

parcelRegister("21PP6", function(module, exports) {
const $322f4dab81de9e93$export$4fd8ecadd193bea0 = ({ node: node, type: type })=>{
    if (!node.attrs.parameters) return;
    const { macroMetadata: macroMetadata } = node.attrs.parameters;
    if (macroMetadata && macroMetadata.placeholder) {
        let placeholderData;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        macroMetadata.placeholder.forEach((placeholder)=>{
            if (placeholder.type === type && placeholder.data && placeholder.data.url) placeholderData = placeholder.data;
        });
        return placeholderData;
    }
    return;
};
module.exports["getExtensionLozengeData"] = $322f4dab81de9e93$export$4fd8ecadd193bea0;

});

parcelRegister("3Ter7", function(module, exports) {

var $5SAOw = parcelRequire("5SAOw");

function $e6152570db050532$export$7b8536c35e9eb7d2(fragment) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return fragment.content;
}
function $e6152570db050532$export$81fe6b3b714fd0bf(content, callback, parent = null) {
    const children = [];
    for(let i = 0, size = content.childCount; i < size; i++){
        const node = content.child(i);
        const transformed = node.isLeaf ? callback(node, parent, i) : callback(node.copy($e6152570db050532$export$81fe6b3b714fd0bf(node.content, callback, node)), parent, i);
        if (transformed) {
            if (transformed instanceof (0, $5SAOw.Fragment)) children.push(...$e6152570db050532$export$7b8536c35e9eb7d2(transformed));
            else if (Array.isArray(transformed)) children.push(...transformed);
            else children.push(transformed);
        }
    }
    return (0, $5SAOw.Fragment).fromArray(children);
}
function $e6152570db050532$export$d8264570c5933bbf(slice, callback) {
    const fragment = $e6152570db050532$export$81fe6b3b714fd0bf(slice.content, callback);
    return new (0, $5SAOw.Slice)(fragment, slice.openStart, slice.openEnd);
}
function $e6152570db050532$export$c575791007f9dbd1(fragment, callback) {
    const fragmentContent = [];
    for(let i = 0; i < fragment.childCount; i++){
        const child = callback(fragment.child(i), i, fragment);
        if (Array.isArray(child)) fragmentContent.push(...child);
        else fragmentContent.push(child);
    }
    return (0, $5SAOw.Fragment).fromArray(fragmentContent);
}
function $e6152570db050532$export$e0baa27f47733a4a(node, callback) {
    const array = [];
    for(let i = 0; i < node.childCount; i++)array.push(callback(node.child(i), i, node instanceof (0, $5SAOw.Fragment) ? node : node.content));
    return array;
}
const $e6152570db050532$var$findNode = (predicate)=>(slice)=>{
        let foundNode = null;
        slice.content.nodesBetween(0, slice.content.size, (node)=>{
            if (predicate(node)) {
                foundNode = node;
                return false;
            }
            return true;
        });
        return foundNode;
    };
const $e6152570db050532$export$b6ae752d7894ad08 = (predicate)=>(slice)=>{
        return !!$e6152570db050532$var$findNode(predicate)(slice);
    };
module.exports["getFragmentBackingArray"] = $e6152570db050532$export$7b8536c35e9eb7d2;
module.exports["mapFragment"] = $e6152570db050532$export$81fe6b3b714fd0bf;
module.exports["mapSlice"] = $e6152570db050532$export$d8264570c5933bbf;
module.exports["flatmap"] = $e6152570db050532$export$c575791007f9dbd1;
module.exports["mapChildren"] = $e6152570db050532$export$e0baa27f47733a4a;
module.exports["hasNode"] = $e6152570db050532$export$b6ae752d7894ad08;

});

parcelRegister("led7c", function(module, exports) {

var $d925B = parcelRequire("d925B");


var $2T4ch = parcelRequire("2T4ch");

// This was existing logic when converting from ReactNodeView
// our current sampling for this event is not bound by node.type
let $26c28de5be6088e2$var$nodeViewRenderedEventsCounter = 0;
const $26c28de5be6088e2$var$DEFAULT_SAMPLING_RATE = 100;
const $26c28de5be6088e2$var$DEFAULT_SLOW_THRESHOLD = 7;
function $26c28de5be6088e2$export$9838b97af1c61be(view) {
    // Please, do not copy or use this kind of code below
    // @ts-ignore
    const fakePluginKey = {
        key: 'analyticsPlugin$',
        getState: (state)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return state['analyticsPlugin$'];
        }
    };
    const pluginState = fakePluginKey.getState(view.state);
    const nodeViewTracking = pluginState && pluginState.performanceTracking ? pluginState.performanceTracking.nodeViewTracking || {} : {};
    const samplingRate = nodeViewTracking.samplingRate ?? $26c28de5be6088e2$var$DEFAULT_SAMPLING_RATE;
    const slowThreshold = nodeViewTracking.slowThreshold ?? $26c28de5be6088e2$var$DEFAULT_SLOW_THRESHOLD;
    return {
        trackingEnabled: !!nodeViewTracking.enabled,
        samplingRate: samplingRate,
        slowThreshold: slowThreshold
    };
}
function $26c28de5be6088e2$export$2630f5971dfad231({ nodeTypeName: nodeTypeName }) {
    (0, $2T4ch.startMeasure)(`\u{1F989}${nodeTypeName}::ReactNodeView`);
}
function $26c28de5be6088e2$export$dc5a82f0bfc526c3({ nodeTypeName: nodeTypeName, dispatchAnalyticsEvent: dispatchAnalyticsEvent, samplingRate: samplingRate, slowThreshold: slowThreshold }) {
    (0, $2T4ch.stopMeasure)(`\u{1F989}${nodeTypeName}::ReactNodeView`, (duration)=>{
        if (++$26c28de5be6088e2$var$nodeViewRenderedEventsCounter % samplingRate === 0 && duration > slowThreshold) dispatchAnalyticsEvent({
            action: (0, $d925B.ACTION).REACT_NODEVIEW_RENDERED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
            attributes: {
                node: nodeTypeName,
                duration: duration
            }
        });
    });
}
module.exports["getPerformanceOptions"] = $26c28de5be6088e2$export$9838b97af1c61be;
module.exports["startMeasureReactNodeViewRendered"] = $26c28de5be6088e2$export$2630f5971dfad231;
module.exports["stopMeasureReactNodeViewRendered"] = $26c28de5be6088e2$export$dc5a82f0bfc526c3;

});

parcelRegister("b0F8r", function(module, exports) {
// File has been copied to packages/editor/editor-plugin-ai/src/provider/markdown-transformer/utils/hyperlink.ts
// If changes are made to this file, please make the same update in the linked file.

var $jBbIP = parcelRequire("jBbIP");


var $d925B = parcelRequire("d925B");


var $azNN5 = parcelRequire("azNN5");


var $3Ter7 = parcelRequire("3Ter7");

const $c470950df2a38b5d$export$893fccbed37586dd = /([a-zA-Z]:|\\)([^\/:*?<>"|]+\\)?([^\/:*?<>"| ]+(?=\s?))?/gim;
const $c470950df2a38b5d$export$dabcc234035f6703 = /^(\$|{)/;
class $c470950df2a38b5d$export$4490385c12bf3d4 {
    static create() {
        class LinkMatcherRegex {
            exec(str) {
                const stringsBySpace = str.slice(0, str.length - 1).split(' ');
                const lastStringBeforeSpace = stringsBySpace[stringsBySpace.length - 1];
                const isLastStringValid = lastStringBeforeSpace.length > 0;
                if (!str.endsWith(' ') || !isLastStringValid) return null;
                if ($c470950df2a38b5d$export$dabcc234035f6703.test(lastStringBeforeSpace)) return null;
                const links = (0, $jBbIP.linkify).match(lastStringBeforeSpace);
                if (!links || links.length === 0) return null;
                const lastMatch = links[links.length - 1];
                const lastLink = links[links.length - 1];
                lastLink.input = str.substring(lastMatch.index);
                lastLink.length = lastLink.lastIndex - lastLink.index + 1;
                lastLink.index = str.lastIndexOf(lastStringBeforeSpace) + lastMatch.index;
                return lastLink;
            }
        }
        return new LinkMatcherRegex();
    }
}
function $c470950df2a38b5d$export$6535eb414fa2c8b6(url) {
    if (!url) return '';
    if ((0, $jBbIP.isSafeUrl)(url)) return url;
    return (0, $jBbIP.normalizeUrl)(url);
}
function $c470950df2a38b5d$export$5a511fa58fab15e6(schema) {
    return (slice)=>(0, $3Ter7.mapSlice)(slice, (node, parent)=>{
            const isAllowedInParent = !parent || parent.type !== schema.nodes.codeBlock;
            const link = node.type.schema.marks.link;
            if (link === undefined) throw new Error('Link not in schema - unable to linkify content');
            if (isAllowedInParent && node.isText && !link.isInSet(node.marks)) {
                const linkified = [];
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const text = node.text;
                const matches = $c470950df2a38b5d$var$findLinkMatches(text).filter((0, $azNN5.shouldAutoLinkifyMatch));
                let pos = 0;
                const filepaths = $c470950df2a38b5d$export$d37783fe63e2f0fe(text);
                matches.forEach((match)=>{
                    if ($c470950df2a38b5d$export$5e652e74655163e5(match.index, filepaths)) return;
                    if (match.index > 0) linkified.push(node.cut(pos, match.index));
                    linkified.push(node.cut(match.index, match.lastIndex).mark(link.create({
                        href: $c470950df2a38b5d$export$6535eb414fa2c8b6(match.url)
                    }).addToSet(node.marks)));
                    pos = match.lastIndex;
                });
                if (pos < text.length) linkified.push(node.cut(pos));
                return linkified;
            }
            return node;
        });
}
function $c470950df2a38b5d$export$238a6141b3685c21(url) {
    // Remove protocol and www., if either exists
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const withoutProtocol = url.toLowerCase().replace(/^(.*):\/\//, '');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const withoutWWW = withoutProtocol.replace(/^(www\.)/, '');
    // Remove port, fragment, path, query string
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return withoutWWW.replace(/[:\/?#](.*)$/, '');
}
function $c470950df2a38b5d$export$336c6a47b1dfa1bc(url) {
    if (!window || !window.location) return false;
    const currentDomain = window.location.hostname;
    const linkDomain = $c470950df2a38b5d$export$238a6141b3685c21(url);
    return currentDomain === linkDomain;
}
/**
 * Fetch linkify matches from text
 * @param text Input text from a node
 * @returns Array of linkify matches. Returns empty array if text is empty or no matches found;
 */ function $c470950df2a38b5d$var$findLinkMatches(text) {
    if (text === '') return [];
    return (0, $jBbIP.linkify).match(text) || [];
}
const $c470950df2a38b5d$export$d37783fe63e2f0fe = (text, offset = 0)=>{
    // Creation of a copy of the RegExp is necessary as lastIndex is stored on it when we run .exec()
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const localRegExp = new RegExp($c470950df2a38b5d$export$893fccbed37586dd);
    let match;
    const matchesList = [];
    const maxFilepathSize = 260;
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    while((match = localRegExp.exec(text)) !== null){
        const start = match.index + offset;
        let end = localRegExp.lastIndex + offset;
        if (end - start > maxFilepathSize) end = start + maxFilepathSize;
         // We don't care about big strings of text that are pretending to be filepaths!!
        matchesList.push({
            startIndex: start,
            endIndex: end
        });
    }
    return matchesList;
};
const $c470950df2a38b5d$export$5e652e74655163e5 = (linkStart, matchesList)=>{
    for(let i = 0; i < matchesList.length; i++){
        if (linkStart >= matchesList[i].startIndex && linkStart < matchesList[i].endIndex) return true;
    }
    return false;
};
function $c470950df2a38b5d$export$56039faad4eda709(inputMethod, url) {
    return {
        action: (0, $d925B.ACTION).INSERTED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).LINK,
        attributes: {
            inputMethod: inputMethod,
            fromCurrentDomain: $c470950df2a38b5d$export$336c6a47b1dfa1bc(url)
        },
        eventType: (0, $d925B.EVENT_TYPE).TRACK,
        nonPrivacySafeAttributes: {
            linkDomain: $c470950df2a38b5d$export$238a6141b3685c21(url)
        }
    };
}
const $c470950df2a38b5d$export$b7392a423e62dc8c = (from, to)=>(state)=>{
        if (!state.doc.rangeHasMark(from, to, state.schema.marks.link)) {
            const $from = state.doc.resolve(from);
            const $to = state.doc.resolve(to);
            const link = state.schema.marks.link;
            if ($from.parent === $to.parent && $from.parent.isTextblock) {
                if ($from.parent.type.allowsMarkType(link)) {
                    let allowed = true;
                    state.doc.nodesBetween(from, to, (node)=>{
                        const hasInlineCard = node.type === state.schema.nodes.inlineCard;
                        allowed = allowed && !node.marks.some((m)=>m.type.excludes(link)) && !hasInlineCard;
                        return allowed;
                    });
                    return allowed;
                }
            }
        }
        return false;
    };
module.exports["LinkMatcher"] = $c470950df2a38b5d$export$4490385c12bf3d4;
module.exports["normalizeUrl"] = $c470950df2a38b5d$export$6535eb414fa2c8b6;
module.exports["linkifyContent"] = $c470950df2a38b5d$export$5a511fa58fab15e6;
module.exports["findFilepaths"] = $c470950df2a38b5d$export$d37783fe63e2f0fe;
module.exports["isLinkInMatches"] = $c470950df2a38b5d$export$5e652e74655163e5;
module.exports["getLinkDomain"] = $c470950df2a38b5d$export$238a6141b3685c21;
module.exports["isFromCurrentDomain"] = $c470950df2a38b5d$export$336c6a47b1dfa1bc;
module.exports["getLinkCreationAnalyticsEvent"] = $c470950df2a38b5d$export$56039faad4eda709;
module.exports["canLinkBeCreatedInRange"] = $c470950df2a38b5d$export$b7392a423e62dc8c;

});

parcelRegister("3JtSu", function(module, exports) {

var $dDZcC = parcelRequire("dDZcC");


var $1A9t2 = parcelRequire("1A9t2");

const $2ac2e591b1565c3c$export$46a7f65963d82cf5 = (doc)=>{
    const pageElementCounts = {
        elements: {},
        textFormats: {},
        macros: {},
        unexpectedElements: {}
    };
    (0, $1A9t2.reduce)(doc, (acc, node)=>{
        if (node.type === 'text') {
            if (node.marks) node.marks.forEach((mark)=>{
                const markType = mark.type;
                acc.textFormats[markType] = (acc.textFormats[markType] ?? 0) + 1;
            });
            acc.elements[node.type] = (acc.elements[node.type] ?? 0) + 1;
        } else if (node.type === 'extension' || node.type === 'inlineExtension' || node.type === 'bodiedExtension' || node.type === 'multiBodiedExtension' || node.type === 'extensionFrame') {
            if ('attrs' in node && node.attrs && 'extensionKey' in node.attrs && node.attrs.extensionKey) {
                let extensionKey = node.attrs.extensionKey;
                // If there is a nested table extension
                if ((0, $dDZcC.isNestedTableExtension)(node)) {
                    if ('parameters' in node.attrs && node.attrs.parameters && 'adf' in node.attrs.parameters) {
                        // Check to see if the ADF contains a nested table
                        const adfString = node.attrs.parameters.adf;
                        const adf = JSON.parse(adfString);
                        if (adfString.includes('{"type":"table"')) {
                            if ($2ac2e591b1565c3c$var$getHasNestedTable(adf)) acc.unexpectedElements['tablesNestedMoreThanOnce'] = (acc.unexpectedElements['tablesNestedMoreThanOnce'] ?? 0) + 1;
                        }
                    }
                }
                // If macros extensionKey has <UUID>/<UUID>/static/ prepended to it, remove the prefix
                if (extensionKey.includes('/static/')) {
                    const extensionKeyParts = extensionKey.split('/');
                    extensionKey = extensionKeyParts[extensionKeyParts.length - 1];
                }
                acc.macros[extensionKey] = (acc.macros[extensionKey] ?? 0) + 1;
            }
        } else acc.elements[node.type] = (acc.elements[node.type] ?? 0) + 1;
        return acc;
    }, pageElementCounts);
    return pageElementCounts;
};
/**
 * Return true is the JSON document contains a table nested within a table
 */ const $2ac2e591b1565c3c$var$getHasNestedTable = (node)=>{
    return (0, $1A9t2.reduce)(node, (hasNestedTable, node)=>{
        if (hasNestedTable) return hasNestedTable;
        if (node.type === 'table') {
            // The first node that we pass into the reduce function is a table node, and we need to ignore it
            let foundFirstTable = false;
            return (0, $1A9t2.reduce)(node, (hasNestedTable, node)=>{
                if (hasNestedTable) return hasNestedTable;
                if (node.type === 'table' && foundFirstTable) return true;
                else if (node.type === 'table') foundFirstTable = true;
                return hasNestedTable;
            }, false);
        }
        return hasNestedTable;
    }, false);
};
module.exports["getPageElementCounts"] = $2ac2e591b1565c3c$export$46a7f65963d82cf5;

});

parcelRegister("7fmpI", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $d925B = parcelRequire("d925B");


var $hWRJP = parcelRequire("hWRJP");

class $5aeffb90025ca075$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    hasFallback() {
        return typeof this.props.fallbackComponent !== 'undefined';
    }
    shouldRecover() {
        return this.hasFallback() && this.state.errorCaptured;
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.dispatchAnalyticsEvent) this.props.dispatchAnalyticsEvent({
            action: (0, $d925B.ACTION).EDITOR_CRASHED,
            actionSubject: this.props.component,
            actionSubjectId: this.props.componentId,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
            attributes: {
                error: error,
                errorInfo: errorInfo,
                errorRethrown: !this.hasFallback()
            }
        });
        (0, $hWRJP.logException)(error, {
            location: 'editor-common'
        });
        if (this.hasFallback()) this.setState({
            errorCaptured: true
        });
    }
    render() {
        if (this.shouldRecover()) return this.props.fallbackComponent;
        return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.state = {
            errorCaptured: false
        };
    }
}
module.exports["ErrorBoundary"] = $5aeffb90025ca075$export$e926676385687eaf;

});

parcelRegister("lcPXp", function(module, exports) {
function $f70305999585f159$var$fromHex(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace("#", "").match(/.{2}/g);
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a], 16);
    switch(e){
        case "rgb":
            return {
                r: n[0],
                g: n[1],
                b: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                r: n[0],
                g: n[1],
                b: n[2]
            });
    }
}
function $f70305999585f159$var$fromRgb(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "hex":
            return 1 == (g = Math.round(n.r).toString(16)).length && (g = "0" + g), 1 == (y = Math.round(n.g).toString(16)).length && (y = "0" + y), 1 == (_ = Math.round(n.b).toString(16)).length && (_ = "0" + _), "#" + g + y + _;
        case "cssrgb":
            return "rgb(" + Math.round(n.r) + "," + Math.round(n.g) + "," + Math.round(n.b) + ")";
        case "hsl":
            var a = [
                g = n.r / 255,
                y = n.g / 255,
                _ = n.b / 255
            ].sort(), i = (a[0] + a[2]) / 2 * 100;
            return a[0] == a[2] ? (b = 0, d = 0) : (b = i >= 50 ? (a[2] - a[0]) / (2 - a[2] - a[0]) * 100 : (a[2] - a[0]) / (a[2] + a[0]) * 100, (d = a[2] == g ? (y - _) / (a[2] - a[0]) * 60 : a[2] == y ? 60 * (2 + (_ - g) / (a[2] - a[0])) : 60 * (4 + (g - y) / (a[2] - a[0]))) < 0 ? d += 360 : d > 360 && (d %= 360)), {
                h: d,
                s: b,
                l: i
            };
        case "csshsl":
            var c = o.convert({
                conversions: t,
                helpers: s
            }, "hsl", n);
            return "hsl(" + Math.round(c.h) + "," + Math.round(c.s) + "%," + Math.round(c.l) + "%)";
        case "cmyk":
            var u = n.r / 255, l = n.g / 255, h = n.b / 255, v = 1 - Math.max(u, l, h);
            if (1 != v) var p = (1 - u - v) / (1 - v), f = (1 - l - v) / (1 - v), m = (1 - h - v) / (1 - v);
            else var p = 0, f = 0, m = 0;
            return {
                c: p,
                m: f,
                y: m,
                k: v
            };
        case "hsv":
            var d, b, g = n.r / 255, y = n.g / 255, _ = n.b / 255, M = Math.min(g, y, _), Y = Math.max(g, y, _), L = Y - M, X = Y;
            if (0 == L) d = 0, b = 0;
            else {
                b = L / Y;
                var Z = ((Y - g) / 6 + L / 2) / L, R = ((Y - y) / 6 + L / 2) / L, w = ((Y - _) / 6 + L / 2) / L;
                g == Y ? d = w - R : y == Y ? d = 1 / 3 + Z - w : _ == Y && (d = 2 / 3 + R - Z), d < 0 && (d += 1), d > 1 && (d -= 1);
            }
            return {
                h: 360 * d,
                s: 100 * b,
                v: 100 * X
            };
        case "yiq":
            var m = n.r / 255 * .299 + n.g / 255 * .587 + n.b / 255 * .114, C = n.r / 255 * .596 + n.g / 255 * -0.274 + n.b / 255 * -0.322, x = n.r / 255 * .211 + n.g / 255 * -0.523 + n.b / 255 * .312;
            return C = s.bounded(C, [
                -0.5957,
                .5957
            ]), x = s.bounded(x, [
                -0.5226,
                .5226
            ]), {
                y: m,
                i: C,
                q: x
            };
        case "XYZ":
            var A = [
                n.r,
                n.g,
                n.b
            ].map(function(r) {
                return r / 255;
            }).map(function(r) {
                return r <= .04045 ? r / 12.92 : Math.pow((r + .055) / 1.055, 2.4);
            }), S = s.getTransform("SRGB_XYZ").map(function(r) {
                return A.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            }).map(function(r) {
                return 100 * r;
            }), O = $f70305999585f159$var$slicedToArray(S, 3);
            return {
                X: O[0],
                Y: O[1],
                Z: O[2]
            };
        case "lms":
        case "cielab":
        case "cieluv":
        case "xyY":
            var I = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, I);
        case "cielch":
            var j = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cieluv", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, j);
        case "hsluv":
            var D = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cielch", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, D);
    }
}
function $f70305999585f159$var$fromCssRgb(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace(/((rgb\(|\))|[\s]*)/g, "").split(",");
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a]);
    switch(e){
        case "rgb":
            return {
                r: n[0],
                g: n[1],
                b: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                r: n[0],
                g: n[1],
                b: n[2]
            });
    }
}
function $f70305999585f159$var$fromHsl(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            if (0 == n.s) {
                var a = n.l / 100 * 255;
                return {
                    r: a,
                    g: a,
                    b: a
                };
            }
            var i, c, u;
            i = n.l >= 50 ? n.l / 100 + n.s / 100 - n.l / 100 * (n.s / 100) : n.l / 100 * (1 + n.s / 100), c = n.l / 100 * 2 - i;
            var l, h, v, p = ((u = n.h / 360) + .333) % 1, f = u, m = s.negMod(u - .333, 1);
            return l = 6 * p < 1 ? c + 6 * (i - c) * p : 2 * p < 1 ? i : 3 * p < 2 ? c + 6 * (.666 - p) * (i - c) : c, h = 6 * f < 1 ? c + 6 * (i - c) * f : 2 * f < 1 ? i : 3 * f < 2 ? c + 6 * (.666 - f) * (i - c) : c, v = 6 * m < 1 ? c + 6 * (i - c) * m : 2 * m < 1 ? i : 3 * m < 2 ? c + 6 * (.666 - m) * (i - c) : c, l < 0 && (l = 0), h < 0 && (h = 0), v < 0 && (v = 0), {
                r: 255 * l,
                g: 255 * h,
                b: 255 * v
            };
        case "csshsl":
            return "hsl(" + Math.round(n.h) + "," + Math.round(n.s) + "%," + Math.round(n.l) + "%)";
        case "hsv":
            n.s = n.s / 100, n.l = n.l / 100;
            var d = n.s * (n.l < .5 ? n.l : 1 - n.l);
            return {
                h: n.h,
                s: 100 * (2 * d / (n.l + d)),
                v: 100 * (n.l + d)
            };
        default:
            var b = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, b);
    }
}
function $f70305999585f159$var$fromCssHsl(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace(/(hsl\(|\)|%|[\s]*)/g, "").split(",");
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a]);
    switch(e){
        case "hsl":
            return {
                h: n[0],
                s: n[1],
                l: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                h: n[0],
                s: n[1],
                l: n[2]
            });
    }
}
function $f70305999585f159$var$fromHsv(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            var a, i, c;
            n.h = n.h / 360, n.s = n.s / 100, n.v = n.v / 100;
            var u = 6 * n.h;
            6 == u && (u = 0);
            var l, h, v, p = Math.round(u), f = n.v * (1 - n.s), m = n.v * (1 - n.s * (u - p)), d = n.v * (1 - n.s * (1 - (u - p)));
            return 0 == p ? (l = n.v, h = d, v = f) : 1 == p ? (l = m, h = n.v, v = f) : 2 == p ? (l = f, h = n.v, v = d) : 3 == p ? (l = f, h = m, v = n.v) : 4 == p ? (l = d, h = f, v = n.v) : (l = n.v, h = f, v = m), a = 255 * l, i = 255 * h, c = 255 * v, {
                r: a,
                g: i,
                b: c
            };
        case "hsl":
            n.h = n.h / 360, n.s = n.s / 100, n.v = n.v / 100;
            return {
                h: 360 * n.h,
                s: 100 * ((2 - n.s) * n.v < 1 ? n.s * n.v / ((2 - n.s) * n.v) : n.s * n.v / (2 - (2 - n.s) * n.v)),
                l: 100 * ((2 - n.s) * n.v / 2)
            };
        default:
            var b = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, b);
    }
}
function $f70305999585f159$var$fromCmyk(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            return {
                r: a = 255 * (1 - n.c) * (1 - n.k),
                g: i = 255 * (1 - n.m) * (1 - n.k),
                b: c = 255 * (1 - n.y) * (1 - n.k)
            };
        case "cssrgb":
            var a = 255 * (1 - n.c) * (1 - n.k), i = 255 * (1 - n.m) * (1 - n.k), c = 255 * (1 - n.y) * (1 - n.k);
            return "rgb(" + Math.round(a) + "," + Math.round(i) + "," + Math.round(c) + ")";
        default:
            var u = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, u);
    }
}
function $f70305999585f159$var$fromYiq(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(n.i = s.bounded(n.i, [
        -0.5957,
        .5957
    ]), n.q = s.bounded(n.q, [
        -0.5226,
        .5226
    ]), e){
        case "rgb":
            var a = 255 * (n.y + .956 * n.i + .621 * n.q), i = 255 * (n.y + -0.272 * n.i + -0.647 * n.q), c = 255 * (n.y + -1.106 * n.i + -1.703 * n.q);
            return a = s.bounded(a, [
                0,
                255
            ]), i = s.bounded(i, [
                0,
                255
            ]), c = s.bounded(c, [
                0,
                255
            ]), {
                r: a,
                g: i,
                b: c
            };
        default:
            var u = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, u);
    }
}
function $f70305999585f159$var$fromXYZ(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers, a = s.getIlluminant("D65");
    switch(e){
        case "rgb":
            var i = [
                n.X,
                n.Y,
                n.Z
            ].map(function(r) {
                return r / 100;
            }), c = s.getTransform("INVERSE_SRGB_XYZ").map(function(r) {
                return i.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            }).map(function(r) {
                return r <= .0031308 ? 12.92 * r : 1.055 * Math.pow(r, 1 / 2.4) - .055;
            }).map(function(r) {
                return 255 * r;
            }), u = $f70305999585f159$var$slicedToArray(c, 3), l = u[0], h = u[1], v = u[2];
            return s.boundedRgb({
                r: l,
                g: h,
                b: v
            });
        case "lms":
            var p = [
                n.X,
                n.Y,
                n.Z
            ].map(function(r) {
                return r / 100;
            }), f = s.getTransform("BRADFORD").map(function(r) {
                return p.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            });
            return {
                rho: f[0],
                gamma: f[1],
                beta: f[2]
            };
        case "cielab":
            var m = n.X / a.X, d = n.Y / a.Y, b = n.Z / a.Z, g = function(r) {
                return r > .008856 ? s.cbrt(r) : (903.3 * r + 16) / 116;
            }, y = g(m), _ = g(d);
            return {
                L: 116 * _ - 16,
                a: 500 * (y - _),
                b: 200 * (_ - g(b))
            };
        case "cieluv":
            var M = n.Y / a.Y, Y = M > .008856 ? 116 * s.cbrt(M) - 16 : 903.3 * M, L = function(r) {
                return 4 * r.X / (r.X + 15 * r.Y + 3 * r.Z);
            }, X = function(r) {
                return 9 * r.Y / (r.X + 15 * r.Y + 3 * r.Z);
            };
            return {
                L: Y,
                u: 13 * Y * (L(n) - L(a)),
                v: 13 * Y * (X(n) - X(a))
            };
        case "xyY":
            return {
                x: n.X / (n.X + n.Y + n.Z),
                y: n.Y / (n.X + n.Y + n.Z),
                Y: n.Y
            };
        default:
            var Z = s.boundedRgb(o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n));
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, Z);
    }
}
function $f70305999585f159$var$fromxyY(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = n.Y / n.y * n.x, i = n.Y / n.y * (1 - n.x - n.y);
            return {
                X: a,
                Y: n.Y,
                Z: i
            };
        default:
            var c = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, c);
    }
}
function $f70305999585f159$var$fromLms(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = [
                n.rho,
                n.gamma,
                n.beta
            ], i = s.getTransform("INVERSE_BRADFORD").map(function(r) {
                return a.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            });
            return {
                X: 100 * i[0],
                Y: 100 * i[1],
                Z: 100 * i[2]
            };
        default:
            var c = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, c);
    }
}
function $f70305999585f159$var$fromCieLab(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = s.getIlluminant("D65"), i = (n.L + 16) / 116, c = n.a / 500 + i, u = i - n.b / 200, l = function(r) {
                return Math.pow(r, 3) > .008856 ? Math.pow(r, 3) : (116 * r - 16) / 903.3;
            }, h = l(c), v = l(u), p = n.L > 903.3 * .008856 ? Math.pow(i, 3) : n.L / 903.3;
            return {
                X: h * a.X,
                Y: p * a.Y,
                Z: v * a.Z
            };
        default:
            var f = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, f);
    }
}
function $f70305999585f159$var$fromCieLuv(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = s.getIlluminant("D65"), i = function(r) {
                return 4 * r.X / (r.X + 15 * r.Y + 3 * r.Z);
            }(a), c = function(r) {
                return 9 * r.Y / (r.X + 15 * r.Y + 3 * r.Z);
            }(a), u = 1 / 3 * (52 * n.L / (n.u + 13 * n.L * i) - 1), l = n.L > 903.3 * .008856 ? Math.pow((n.L + 16) / 116, 3) : n.L / 903.3, h = -5 * l, v = (l * (39 * n.L / (n.v + 13 * n.L * c) - 5) - h) / (u - -1 / 3);
            return {
                X: 100 * v,
                Y: 100 * l,
                Z: 100 * (v * u + h)
            };
        case "cielch":
            var p = Math.sqrt(Math.pow(n.u, 2) + Math.pow(n.v, 2)), f = Math.atan2(n.v, n.u);
            return f < 0 && (f += 2 * Math.PI), f = s.toDeg(f), {
                L: n.L,
                C: p,
                h: f
            };
        default:
            var m = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, m);
    }
}
function $f70305999585f159$var$fromCieLch(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "cieluv":
            var a = s.toRad(n.h), i = n.C * Math.cos(a), c = n.C * Math.sin(a);
            return {
                L: n.L,
                u: i,
                v: c
            };
        case "hsluv":
            if (n.L > 99.9999999) return {
                hu: n.h,
                s: 0,
                l: 100
            };
            if (n.L < 1e-8) return {
                hu: n.h,
                s: 0,
                l: 0
            };
            for(var u = (n.L + 16) / 1560896, l = u > .008856 ? u : n.L / 903.3, h = s.getTransform("INVERSE_SRGB_XYZ"), v = [], p = 0; p < 3; p++)for(var f = h[p][0], m = h[p][1], d = h[p][2], b = 0; b < 2; b++){
                var g = (284517 * f - 94839 * d) * l, y = (838422 * d + 769860 * m + 731718 * f) * n.L * l - 769860 * b * n.L, _ = (632260 * d - 126452 * m) * l + 126452 * b;
                v.push({
                    m: g / _,
                    b: y / _
                });
            }
            var M = Number.MAX_VALUE, Y = s.toRad(n.h);
            v.forEach(function(r) {
                var e = r.b / (Math.sin(Y) - r.m * Math.cos(Y));
                e >= 0 && (M = Math.min(M, e));
            });
            var L = M;
            return {
                hu: n.h,
                s: n.C / L * 100,
                l: n.L
            };
        default:
            var X = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cieluv", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, X);
    }
}
function $f70305999585f159$var$fromCieLch$1(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "cielch":
            if (n.L > 99.9999999) return {
                L: 100,
                C: 0,
                h: n.hu
            };
            if (n.L < 1e-8) return {
                L: 0,
                C: 0,
                h: n.hu
            };
            for(var a = (n.l + 16) / 1560896, i = a > .008856 ? a : n.l / 903.3, c = s.getTransform("INVERSE_SRGB_XYZ"), u = [], l = 0; l < 3; l++)for(var h = c[l][0], v = c[l][1], p = c[l][2], f = 0; f < 2; f++){
                var m = (284517 * h - 94839 * p) * i, d = (838422 * p + 769860 * v + 731718 * h) * n.l * i - 769860 * f * n.l, b = (632260 * p - 126452 * v) * i + 126452 * f;
                u.push({
                    m: m / b,
                    b: d / b
                });
            }
            var g = Number.MAX_VALUE, y = s.toRad(n.hu);
            u.forEach(function(r) {
                var e = r.b / (Math.sin(y) - r.m * Math.cos(y));
                e >= 0 && (g = Math.min(g, e));
            });
            var _ = g;
            return {
                L: n.l,
                C: _ / 100 * n.s,
                h: n.hu
            };
        default:
            var M = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cielch", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, M);
    }
}
function $f70305999585f159$var$contains(r, e) {
    return Object.keys(r).every(function(r) {
        return -1 !== e.indexOf(r);
    });
}
function $f70305999585f159$var$adapt(r, e, n, t) {
    var o = r.operations.convert(r, "XYZ", e), s = r.operations.convert(r, "lms", n);
    if (t) a = r.operations.convert(r, "lms", t);
    else var a = r.operations.convert(r, "lms", r.helpers.getIlluminant("D65"));
    var i = r.helpers.getTransform("BRADFORD"), c = r.helpers.getTransform("INVERSE_BRADFORD"), u = [
        [
            s.rho / a.rho,
            0,
            0
        ],
        [
            0,
            s.gamma / a.gamma,
            0
        ],
        [
            0,
            0,
            s.beta / a.beta
        ]
    ], l = r.helpers.matrixMultiply(c, u), h = r.helpers.matrixMultiply(l, i), v = [
        [
            o.X
        ],
        [
            o.Y
        ],
        [
            o.Z
        ]
    ], p = r.helpers.matrixMultiply(h, v), f = {
        X: p[0][0],
        Y: p[1][0],
        Z: p[2][0]
    };
    return r.helpers.ready(r, f);
}
function $f70305999585f159$var$adjacent(r, e, n, t) {
    for(var o = r.operations.convert(r, "hsl", t), s = [
        {
            h: o.h,
            s: o.s,
            l: o.l
        }
    ], a = 0; a < n - 1; a++)o.h = r.helpers.negMod(o.h + e, 360), s.push({
        h: o.h,
        s: o.s,
        l: o.l
    });
    return r.helpers.ready(r, s);
}
function $f70305999585f159$var$brightness(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.l += e, t.l < 0 ? t.l = 0 : t.l > 100 && (t.l = 100), r.helpers.ready(r, t);
}
function $f70305999585f159$var$complementary(r, e) {
    var n = r.operations.convert(r, "hsl", e);
    return n.h = (n.h + 180) % 360, r.helpers.ready(r, n);
}
function $f70305999585f159$var$contrast(r, e, n) {
    var t = r.operations.convert(r, "rgb", n);
    return t.r = 255 * ((t.r / 255 - .5) * e + .5), t.r < 0 ? t.r = 0 : t.r > 255 && (t.r = 255), t.g = 255 * ((t.g / 255 - .5) * e + .5), t.g < 0 ? t.g = 0 : t.g > 255 && (t.g = 255), t.b = 255 * ((t.b / 255 - .5) * e + .5), t.b < 0 ? t.b = 0 : t.b > 255 && (t.b = 255), r.helpers.ready(r, t);
}
function $f70305999585f159$var$contrastRatio(r, e) {
    var n = r.operations.convert(r, "rgb", e);
    return n = (299 * n.r + 587 * n.g + 114 * n.b) / 1e3 >= 128 ? {
        r: 0,
        g: 0,
        b: 0
    } : {
        r: 255,
        g: 255,
        b: 255
    }, r.helpers.ready(r, n);
}
function $f70305999585f159$var$convert(r, e, n) {
    if (Object.keys(r.conversions).indexOf(e) > -1) {
        n.colour ? n = n.colour : n.colours && (n = n.colours);
        var t = r.helpers.determineMode(n);
        return t != e ? r.conversions[t].convert(r, e, n) : n;
    }
    return r.helpers.ready(r, e);
}
function $f70305999585f159$var$difference(r, e, n, t, o) {
    t = t || 1, o = o || 1;
    var s = r.operations.convert(r, "cielab", e), a = r.operations.convert(r, "cielab", n), i = Math.sqrt(Math.pow(s.a, 2) + Math.pow(s.b, 2)), c = i - Math.sqrt(Math.pow(a.a, 2) + Math.pow(a.b, 2)), u = s.L - a.L, l = s.a - a.a, h = s.b - a.b, v = Math.sqrt(Math.pow(l, 2) + Math.pow(h, 2) - Math.pow(c, 2)), p = s.L < 16 ? .511 : .040975 * s.L / (1.01765 * s.L), f = .0638 * i / (1.0131 * i), m = Math.atan2(s.b, s.a), d = m >= 0 ? m : m + 360, b = 164 <= d && d <= 345 ? .56 + Math.abs(.2 * Math.cos(r.helpers.toRad(d + 168))) : .36 + Math.abs(.4 * Math.cos(r.helpers.toRad(d + 35))), g = Math.pow(i, 4) / (Math.pow(i, 4) + 1900), y = f * (g * b + 1 - g), _ = Math.pow(u / (t * p), 2);
    return Math.sqrt(_ + _ + _);
}
function $f70305999585f159$var$fade(r, e, n, t) {
    var o = r.operations.convert(r, "rgb", n), s = r.operations.convert(r, "rgb", t), a = [
        o
    ];
    e -= 1;
    for(var i = (s.r - o.r) / e, c = (s.g - o.g) / e, u = (s.b - o.b) / e, l = {
        r: o.r,
        g: o.g,
        b: o.b
    }, h = 0; h < e - 1; h++)l.r = r.helpers.slopeMod(l.r + i, 255), l.g = r.helpers.slopeMod(l.g + c, 255), l.b = r.helpers.slopeMod(l.b + u, 255), a.push({
        r: l.r,
        g: l.g,
        b: l.b
    });
    return a.push(s), r.helpers.ready(r, a);
}
function $f70305999585f159$var$greyscale(r, e) {
    var n = r.operations.convert(r, "rgb", e), t = (n.r + n.g + n.b) / 3;
    return n = {
        r: t,
        g: t,
        b: t
    }, r.helpers.ready(r, n);
}
function $f70305999585f159$var$hue(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.h = r.helpers.negMod(t.h + e, 360), r.helpers.ready(r, t);
}
function $f70305999585f159$var$invert(r, e) {
    var n = r.operations.convert(r, "rgb", e);
    return n.r = r.helpers.negMod(255 - n.r, 255), n.g = r.helpers.negMod(255 - n.g, 255), n.b = r.helpers.negMod(255 - n.b, 255), r.helpers.ready(r, n);
}
function $f70305999585f159$var$invertLightness(r, e) {
    var n = r.operations.convert(r, "hsl", e);
    return n.l = 100 - n.l, r.helpers.ready(r, n);
}
function $f70305999585f159$var$mid(r, e, n) {
    var t = r.operations.convert(r, "hsl", e), o = r.operations.convert(r, "hsl", n), s = {
        h: (t.h + o.h) / 2,
        s: (t.s + o.s) / 2,
        l: (t.l + o.l) / 2
    };
    return r.helpers.ready(r, s);
}
function $f70305999585f159$var$multiply(r, e, n) {
    var t = r.operations.convert(r, "hsl", e), o = r.operations.convert(r, "hsl", n), s = {
        h: t.h,
        s: t.s,
        l: t.l / 100 * (o.l / 100) * 100
    };
    return s.l = s.l > 100 ? 100 : s.l, s.l = s.l < 0 ? 0 : s.l, r.helpers.ready(r, s);
}
function $f70305999585f159$var$saturation(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.s += e, t.s < 0 ? t.s = 0 : t.s > 100 && (t.s = 100), r.helpers.ready(r, t);
}
function $f70305999585f159$var$sepia(r, e) {
    var n = r.operations.convert(r, "rgb", e), t = {};
    return t.r = .393 * n.r + .769 * n.g + .189 * n.b, t.g = .349 * n.r + .686 * n.g + .168 * n.b, t.b = .272 * n.r + .534 * n.g + .131 * n.b, r.helpers.ready(r, t);
}
function $f70305999585f159$var$shade(r, e, n) {
    var t = r.operations.convert(r, "hsv", n);
    return t.v += e, t.v < 0 ? t.v = 0 : t.v > 100 && (t.v = 100), r.helpers.ready(r, t);
}
function $f70305999585f159$var$temperature(r, e) {
    var n = r.operations.convert(r, "xyY", e), t = (n.x - .332) / (n.y - .1858);
    return -449 * Math.pow(t, 3) + 3525 * Math.pow(t, 2) - 6823.3 * t + 5520.33;
}
function $f70305999585f159$var$tetrad(r, e) {
    for(var n = r.operations.convert(r, "hsl", e), t = [
        {
            h: n.h,
            s: n.s,
            l: n.l
        }
    ], o = 0; o < 3; o++)n.h = (n.h + 90) % 360, t.push({
        h: n.h,
        s: n.s,
        l: n.l
    });
    return r.helpers.ready(r, t);
}
function $f70305999585f159$var$triad(r, e) {
    for(var n = r.operations.convert(r, "hsl", e), t = [
        {
            h: n.h,
            s: n.s,
            l: n.l
        }
    ], o = 0; o < 2; o++)n.h = (n.h + 120) % 360, t.push({
        h: n.h,
        s: n.s,
        l: n.l
    });
    return r.helpers.ready(r, t);
}
var $f70305999585f159$var$fromHex_1 = $f70305999585f159$var$fromHex, $f70305999585f159$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(r) {
    return typeof r;
} : function(r) {
    return r && "function" == typeof Symbol && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
}, $f70305999585f159$var$slicedToArray = function() {
    function r(r, e) {
        var n = [], t = !0, o = !1, s = void 0;
        try {
            for(var a, i = r[Symbol.iterator](); !(t = (a = i.next()).done) && (n.push(a.value), !e || n.length !== e); t = !0);
        } catch (r) {
            o = !0, s = r;
        } finally{
            try {
                !t && i.return && i.return();
            } finally{
                if (o) throw s;
            }
        }
        return n;
    }
    return function(e, n) {
        if (Array.isArray(e)) return e;
        if (Symbol.iterator in Object(e)) return r(e, n);
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}(), $f70305999585f159$var$toConsumableArray = function(r) {
    if (Array.isArray(r)) {
        for(var e = 0, n = Array(r.length); e < r.length; e++)n[e] = r[e];
        return n;
    }
    return Array.from(r);
}, $f70305999585f159$var$fromRgb_1 = $f70305999585f159$var$fromRgb, $f70305999585f159$var$fromCssRgb_1 = $f70305999585f159$var$fromCssRgb, $f70305999585f159$var$fromHsl_1 = $f70305999585f159$var$fromHsl, $f70305999585f159$var$fromCssHsl_1 = $f70305999585f159$var$fromCssHsl, $f70305999585f159$var$fromHsv_1 = $f70305999585f159$var$fromHsv, $f70305999585f159$var$fromCmyk_1 = $f70305999585f159$var$fromCmyk, $f70305999585f159$var$fromYiq_1 = $f70305999585f159$var$fromYiq, $f70305999585f159$var$fromXYZ_1 = $f70305999585f159$var$fromXYZ, $f70305999585f159$var$fromxyY_1 = $f70305999585f159$var$fromxyY, $f70305999585f159$var$fromLms_1 = $f70305999585f159$var$fromLms, $f70305999585f159$var$fromCieLab_1 = $f70305999585f159$var$fromCieLab, $f70305999585f159$var$fromCieLuv_1 = $f70305999585f159$var$fromCieLuv, $f70305999585f159$var$fromCieLch_1 = $f70305999585f159$var$fromCieLch, $f70305999585f159$var$fromHsluv = $f70305999585f159$var$fromCieLch$1, $f70305999585f159$var$index = {
    hex: {
        test: function(r) {
            return "string" == typeof r && "#" === r.slice(0, 1);
        },
        convert: $f70305999585f159$var$fromHex_1
    },
    rgb: {
        test: function(r) {
            return $f70305999585f159$var$contains(r, [
                "r",
                "g",
                "b"
            ]);
        },
        convert: $f70305999585f159$var$fromRgb_1
    },
    cssrgb: {
        test: function(r) {
            return "string" == typeof r && "rgb(" === r.slice(0, 4);
        },
        convert: $f70305999585f159$var$fromCssRgb_1
    },
    hsl: {
        test: function(r) {
            return $f70305999585f159$var$contains(r, [
                "h",
                "s",
                "l"
            ]);
        },
        convert: $f70305999585f159$var$fromHsl_1
    },
    csshsl: {
        test: function(r) {
            return "string" == typeof r && "hsl(" === r.slice(0, 4);
        },
        convert: $f70305999585f159$var$fromCssHsl_1
    },
    hsv: {
        test: function(r) {
            return $f70305999585f159$var$contains(r, [
                "h",
                "s",
                "v"
            ]);
        },
        convert: $f70305999585f159$var$fromHsv_1
    },
    cmyk: {
        test: function(r) {
            return $f70305999585f159$var$contains(r, [
                "c",
                "m",
                "y",
                "k"
            ]);
        },
        convert: $f70305999585f159$var$fromCmyk_1
    },
    yiq: {
        test: function(r) {
            return $f70305999585f159$var$contains(r, [
                "y",
                "i",
                "q"
            ]);
        },
        convert: $f70305999585f159$var$fromYiq_1
    },
    XYZ: {
        test: function(r) {
            return $f70305999585f159$var$contains(r, [
                "X",
                "Y",
                "Z"
            ]);
        },
        convert: $f70305999585f159$var$fromXYZ_1
    },
    xyY: {
        test: function(r) {
            return $f70305999585f159$var$contains(r, [
                "x",
                "y",
                "Y"
            ]);
        },
        convert: $f70305999585f159$var$fromxyY_1
    },
    lms: {
        test: function(r) {
            return $f70305999585f159$var$contains(r, [
                "rho",
                "gamma",
                "beta"
            ]);
        },
        convert: $f70305999585f159$var$fromLms_1
    },
    cielab: {
        test: function(r) {
            return $f70305999585f159$var$contains(r, [
                "L",
                "a",
                "b"
            ]);
        },
        convert: $f70305999585f159$var$fromCieLab_1
    },
    cieluv: {
        test: function(r) {
            return $f70305999585f159$var$contains(r, [
                "L",
                "u",
                "v"
            ]);
        },
        convert: $f70305999585f159$var$fromCieLuv_1
    },
    cielch: {
        test: function(r) {
            return $f70305999585f159$var$contains(r, [
                "L",
                "C",
                "h"
            ]);
        },
        convert: $f70305999585f159$var$fromCieLch_1
    },
    hsluv: {
        test: function(r) {
            return $f70305999585f159$var$contains(r, [
                "hu",
                "s",
                "l"
            ]);
        },
        convert: $f70305999585f159$var$fromHsluv
    }
}, $f70305999585f159$var$adapt_1 = $f70305999585f159$var$adapt, $f70305999585f159$var$adjacent_1 = $f70305999585f159$var$adjacent, $f70305999585f159$var$brightness_1 = $f70305999585f159$var$brightness, $f70305999585f159$var$complementary_1 = $f70305999585f159$var$complementary, $f70305999585f159$var$contrast_1 = $f70305999585f159$var$contrast, $f70305999585f159$var$contrastRatio_1 = $f70305999585f159$var$contrastRatio, $f70305999585f159$var$convert_1 = $f70305999585f159$var$convert, $f70305999585f159$var$difference_1 = $f70305999585f159$var$difference, $f70305999585f159$var$fade_1 = $f70305999585f159$var$fade, $f70305999585f159$var$greyscale_1 = $f70305999585f159$var$greyscale, $f70305999585f159$var$hue_1 = $f70305999585f159$var$hue, $f70305999585f159$var$invert_1 = $f70305999585f159$var$invert, $f70305999585f159$var$invertLightness_1 = $f70305999585f159$var$invertLightness, $f70305999585f159$var$mid_1 = $f70305999585f159$var$mid, $f70305999585f159$var$multiply_1 = $f70305999585f159$var$multiply, $f70305999585f159$var$saturation_1 = $f70305999585f159$var$saturation, $f70305999585f159$var$sepia_1 = $f70305999585f159$var$sepia, $f70305999585f159$var$shade_1 = $f70305999585f159$var$shade, $f70305999585f159$var$temperature_1 = $f70305999585f159$var$temperature, $f70305999585f159$var$tetrad_1 = $f70305999585f159$var$tetrad, $f70305999585f159$var$triad_1 = $f70305999585f159$var$triad, $f70305999585f159$var$index$2 = {
    adapt: $f70305999585f159$var$adapt_1,
    adjacent: $f70305999585f159$var$adjacent_1,
    brightness: $f70305999585f159$var$brightness_1,
    complementary: $f70305999585f159$var$complementary_1,
    contrast: $f70305999585f159$var$contrast_1,
    contrastRatio: $f70305999585f159$var$contrastRatio_1,
    convert: $f70305999585f159$var$convert_1,
    difference: $f70305999585f159$var$difference_1,
    fade: $f70305999585f159$var$fade_1,
    greyscale: $f70305999585f159$var$greyscale_1,
    hue: $f70305999585f159$var$hue_1,
    invert: $f70305999585f159$var$invert_1,
    invertLightness: $f70305999585f159$var$invertLightness_1,
    mid: $f70305999585f159$var$mid_1,
    multiply: $f70305999585f159$var$multiply_1,
    saturation: $f70305999585f159$var$saturation_1,
    sepia: $f70305999585f159$var$sepia_1,
    shade: $f70305999585f159$var$shade_1,
    temperature: $f70305999585f159$var$temperature_1,
    tetrad: $f70305999585f159$var$tetrad_1,
    triad: $f70305999585f159$var$triad_1
}, $f70305999585f159$var$constants = {
    ILLUMINANTS: {
        A: {
            X: 1.0985 * 100,
            Y: 100,
            Z: 35.585
        },
        B: {
            X: 99.072,
            Y: 100,
            Z: 85.223
        },
        C: {
            X: 98.074,
            Y: 100,
            Z: 118.232
        },
        D50: {
            X: 96.422,
            Y: 100,
            Z: 82.521
        },
        D55: {
            X: 95.682,
            Y: 100,
            Z: 92.149
        },
        D65: {
            X: 95.047,
            Y: 100,
            Z: 108.883
        },
        D75: {
            X: 94.972,
            Y: 100,
            Z: 122.638
        },
        E: {
            X: 100,
            Y: 100,
            Z: 100
        },
        F2: {
            X: .99186 * 100,
            Y: 100,
            Z: 67.393
        },
        F7: {
            X: 95.041,
            Y: 100,
            Z: 108.747
        },
        F11: {
            X: 1.00962 * 100,
            Y: 100,
            Z: 64.35
        }
    },
    TRANSFORMS: {
        BRADFORD: [
            [
                .8951,
                .2664,
                -0.1614
            ],
            [
                -0.7502,
                1.7135,
                .0367
            ],
            [
                .0389,
                -0.0685,
                1.0296
            ]
        ],
        INVERSE_BRADFORD: [
            [
                .9869929,
                -0.1470543,
                .1599627
            ],
            [
                .4323053,
                .5183603,
                .0492912
            ],
            [
                -0.0085287,
                .0400428,
                .9684867
            ]
        ],
        SRGB_XYZ: [
            [
                .4124,
                .3576,
                .1805
            ],
            [
                .2126,
                .7152,
                .0722
            ],
            [
                .0193,
                .1192,
                .9505
            ]
        ],
        INVERSE_SRGB_XYZ: [
            [
                3.2406,
                -1.5372,
                -0.4986
            ],
            [
                -0.9689,
                1.8758,
                .0415
            ],
            [
                .0557,
                -0.204,
                1.057
            ]
        ]
    }
}, $f70305999585f159$var$api = function(r, e, n) {
    var t = Object.keys(r.operations).reduce(function(e, t) {
        var o = r.operations[t];
        return e[t] = function() {
            for(var e = arguments.length, t = Array(e), s = 0; s < e; s++)t[s] = arguments[s];
            var a = t.slice(0).map(function(r) {
                return "object" === (void 0 === r ? "undefined" : $f70305999585f159$var$_typeof(r)) ? Object.assign({}, r) : r;
            });
            if (n && n.colours) return function e(n) {
                var t = n.map(function(n) {
                    if (Array.isArray(n)) {
                        var t = e(n);
                        return t.colours || t.colour;
                    }
                    var s = o.apply(void 0, [
                        r
                    ].concat($f70305999585f159$var$toConsumableArray(a), [
                        n
                    ]));
                    return "object" === (void 0 === s ? "undefined" : $f70305999585f159$var$_typeof(s)) ? s.colours || s.colour : s;
                });
                return "number" != typeof t[0] ? r.helpers.ready(r, t) : t;
            }(n.colours);
            return o.apply(void 0, [
                r
            ].concat($f70305999585f159$var$toConsumableArray(a), [
                n ? n.colour : void 0
            ]));
        }, e;
    }, {});
    return n || (t = Object.assign(t, e)), t;
}, $f70305999585f159$var$api_1 = $f70305999585f159$var$api, $f70305999585f159$var$helpers = {
    getIlluminant: function(r) {
        return $f70305999585f159$var$constants.ILLUMINANTS[r];
    },
    getTransform: function(r) {
        return $f70305999585f159$var$constants.TRANSFORMS[r];
    },
    matrixMultiply: function(r, e) {
        for(var n = [], t = 0; t < r.length; t++){
            n[t] = [];
            for(var o = 0; o < e[0].length; o++){
                for(var s = 0, a = 0; a < r[0].length; a++)s += r[t][a] * e[a][o];
                n[t][o] = s;
            }
        }
        return n;
    },
    cbrt: function(r) {
        if (Math.cbrt) return Math.cbrt(r);
        var e = Math.pow(Math.abs(r), 1 / 3);
        return r < 0 ? -e : e;
    },
    toRad: function(r) {
        return r * (Math.PI / 180);
    },
    toDeg: function(r) {
        return r * (180 / Math.PI);
    },
    negMod: function(r, e) {
        return (r % e + e) % e;
    },
    slopeMod: function(r) {
        function e(e, n) {
            return r.apply(this, arguments);
        }
        return e.toString = function() {
            return r.toString();
        }, e;
    }(function(r, e) {
        return r > 2 * e ? slopeMod(r - 2 * e, e) : r > e ? 2 * e - r : r < 0 ? slopeMod(r + 2 * e, e) : r;
    }),
    bounded: function(r, e) {
        return r < e[0] ? r = e[0] : r > e[1] && (r = e[1]), r;
    },
    boundedRgb: function(r) {
        var e = this, n = function(r) {
            return e.bounded(r, [
                0,
                255
            ]);
        };
        return {
            r: n(r.r),
            g: n(r.g),
            b: n(r.b)
        };
    },
    determineMode: function(r) {
        for(var e in $f70305999585f159$var$index)if ($f70305999585f159$var$index.hasOwnProperty(e) && $f70305999585f159$var$index[e].test(r)) return e;
        return null;
    },
    ready: function(r, e) {
        var n = r.conversions, t = r.operations, o = r.helpers, s = {};
        switch(Object.prototype.toString.call(e)){
            case "[object Object]":
            case "[object String]":
                s.colour = e;
                for(var a in n)n.hasOwnProperty(a) && function(r) {
                    Object.defineProperty(s, r, {
                        get: function() {
                            o.determineMode(e);
                            return t.convert({
                                conversions: n,
                                operations: t,
                                helpers: o
                            }, r, e);
                        },
                        enumerable: !0
                    });
                }(a);
                return s = Object.assign(s, $f70305999585f159$var$api_1({
                    conversions: n,
                    operations: t,
                    helpers: o
                }, $f70305999585f159$var$constants, s));
            case "[object Array]":
                s.colours = e;
                for(var i in n)n.hasOwnProperty(i) && function(r) {
                    Object.defineProperty(s, r, {
                        get: function() {
                            return function e(s) {
                                return s.map(function(s) {
                                    return Array.isArray(s) ? e(s) : t.convert({
                                        conversions: n,
                                        operations: t,
                                        helpers: o
                                    }, r, s);
                                });
                            }(e);
                        },
                        enumerable: !0
                    });
                }(i);
                return s = Object.assign(s, $f70305999585f159$var$api_1({
                    conversions: n,
                    operations: t,
                    helpers: o
                }, $f70305999585f159$var$constants, s));
            default:
                return null;
        }
    }
}, $f70305999585f159$var$helpers_1 = $f70305999585f159$var$helpers, $f70305999585f159$var$dependencies = {
    conversions: $f70305999585f159$var$index,
    operations: $f70305999585f159$var$index$2,
    helpers: $f70305999585f159$var$helpers_1
}, $f70305999585f159$var$entry = $f70305999585f159$var$api_1($f70305999585f159$var$dependencies, $f70305999585f159$var$constants);
var $f70305999585f159$export$2e2bcd8739ae039 = $f70305999585f159$var$entry;
module.exports["default"] = $f70305999585f159$export$2e2bcd8739ae039;

});

parcelRegister("44jjU", function(module, exports) {

var $5SAOw = parcelRequire("5SAOw");


var $aXG5V = parcelRequire("aXG5V");
parcelRequire("2eY6H");


const $2f6685b41384ceb2$export$954e3f6aa93d9ba3 = 'editor-linking-meta';
const $2f6685b41384ceb2$export$2774298c489a128f = 'editor-linking-meta-invert';
class $2f6685b41384ceb2$export$40e33c9d27895078 extends (0, $aXG5V.Step) {
    getMetadata() {
        return this.metadata;
    }
    /**
   * Generate new undo/redo analytics event when step is inverted
   */ invert() {
        /**
     * Omit sourceEvent in history
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { sourceEvent: sourceEvent, ...metadata } = this.metadata;
        return new $2f6685b41384ceb2$export$40e33c9d27895078(this.pos, metadata, true);
    }
    // Should make no modifications to the doc
    apply(doc) {
        return (0, $aXG5V.StepResult).ok(doc);
    }
    map(mapping) {
        let newPos = this.pos;
        if (typeof newPos === 'number') newPos = mapping.map(newPos);
        // Return the same events, this step will never be removed
        return new $2f6685b41384ceb2$export$40e33c9d27895078(newPos, this.metadata, this.isInverted);
    }
    getMap() {
        return new (0, $aXG5V.StepMap)([
            this.pos || 0,
            0,
            0
        ]);
    }
    // Return null to avoid merging events
    merge() {
        return null;
    }
    toJSON() {
        // When serialized we should create a noop Replace step
        return {
            stepType: 'replace',
            from: 0,
            to: 0
        };
    }
    static fromJSON() {
        // This is a "local custom step" once serialized
        // we need to transform it in a no-operation action
        return new (0, $aXG5V.ReplaceStep)(0, 0, (0, $5SAOw.Slice).empty);
    }
    constructor(pos, metadata, isInverted = false){
        super();
        this.pos = pos;
        this.metadata = metadata;
        this.isInverted = isInverted;
    }
}
/** Register this step with Prosemirror */ (0, $aXG5V.Step).jsonID($2f6685b41384ceb2$export$954e3f6aa93d9ba3, $2f6685b41384ceb2$export$40e33c9d27895078);
module.exports["LinkMetaStep"] = $2f6685b41384ceb2$export$40e33c9d27895078;

});

parcelRegister("kfZYI", function(module, exports) {

var $aK8Ra = parcelRequire("aK8Ra");




const $91e3fc913980c88d$export$cfd430a73d68f4bc = {
    confluence: 'confluence.atlassian.com',
    design: 'design.atlassian.com',
    extranet: 'extranet.atlassian.com',
    go: 'go.atlassian.com',
    my: 'my.atlassian.com',
    surveys: 'surveys.atlassian.com',
    'wac-cdn': 'wac-cdn.atlassian.com',
    integrations: 'integrations.atlassian.com',
    permalink: 'permalink.atlassian.com',
    support: 'support.atlassian.com'
};
const $91e3fc913980c88d$export$4723232b625f823e = {
    id: {
        [(0, $aK8Ra.COMMERCIAL)]: {
            [(0, $aK8Ra.PRODUCTION)]: 'id.atlassian.com',
            [(0, $aK8Ra.STAGING)]: 'id.stg.internal.atlassian.com',
            [(0, $aK8Ra.DEV)]: 'id.dev.internal.atlassian.com'
        },
        [(0, $aK8Ra.FEDRAMP_MODERATE)]: {
            [(0, $aK8Ra.PRODUCTION)]: 'id.atlassian-us-gov-mod.com',
            [(0, $aK8Ra.STAGING)]: 'id.stg.atlassian-us-gov-mod.com'
        }
    }
};



var $T9xHm = parcelRequire("T9xHm");




const $0bd88ba85420b9b2$export$5860df3acd1ee020 = {
    [(0, $aK8Ra.COMMERCIAL)]: [
        'home',
        'start',
        'id',
        'api',
        'admin',
        'auth',
        'bitbucket'
    ]
};
const $0bd88ba85420b9b2$export$c6366754aee43afa = {
    [(0, $aK8Ra.COMMERCIAL)]: [
        'packages'
    ]
};
const $0bd88ba85420b9b2$export$ad1f7afdb45ad83 = {
    [(0, $aK8Ra.COMMERCIAL)]: {
        isolatedCloudReservedNameDomain: (subdomain, isolatedCloudDomain)=>`${subdomain}.${isolatedCloudDomain}`,
        isolatedCloudAtlDomain: (subdomain, isolatedCloudDomain)=>`${subdomain}.atl.${isolatedCloudDomain}`,
        isolatedCloudVanityDomain: (subdomain, isolatedCloudDomain)=>`${subdomain}.services.${isolatedCloudDomain}`
    }
};
const $0bd88ba85420b9b2$export$c3b4bc58a05128d6 = {
    [(0, $aK8Ra.COMMERCIAL)]: {
        defaultDomainEnding: (subdomain, envType)=>{
            switch(envType){
                case 0, $aK8Ra.PRODUCTION:
                    return `${subdomain}.atlassian.com`;
                case 0, $aK8Ra.STAGING:
                    return `${subdomain}.stg.atlassian.com`;
                case 0, $aK8Ra.DEV:
                    return `${subdomain}.dev.atlassian.com`;
                default:
                    console.warn(`Cannot get non-isolated commercial domain for provided environment, ${envType} is unsupported`);
                    return '';
            }
        }
    },
    [(0, $aK8Ra.FEDRAMP_MODERATE)]: {
        defaultDomainEnding: (subdomain, envType)=>{
            switch(envType){
                case 0, $aK8Ra.PRODUCTION:
                    return `${subdomain}.atlassian-us-gov-mod.com`;
                case 0, $aK8Ra.STAGING:
                    return `${subdomain}.stg.atlassian-us-gov-mod.com`;
                default:
                    console.warn(`Cannot get fedramp-moderate domain for provided environment, ${envType} is unsupported`);
                    return '';
            }
        }
    }
};


function $73605056572cb2af$export$3f82b86ecb947bf0(subdomain, envType) {
    const currentCloudEnvironment = (0, $T9xHm.cloudEnvironment)();
    if (currentCloudEnvironment === undefined) return undefined;
    if (currentCloudEnvironment.type === 'isolated-cloud') {
        const domain = (0, $T9xHm.isolatedCloudDomain)();
        if (domain === undefined) return undefined;
        return $73605056572cb2af$var$getDomainForIsolatedCloud(subdomain, (0, $aK8Ra.COMMERCIAL), domain);
    }
    return $73605056572cb2af$var$getDomainForNonIsolatedCloud(subdomain, currentCloudEnvironment.perimeter, envType);
}
/**
 * Gets the full Isolated Cloud domain
 * Returns undefined only if ic_domain cannot be determined from the atl-ctx cookies
 * Defaults to returning the vanity name pattern
 * @param subdomain - The Atlassian experience subdomain
 * @param perimeter - The Isolated Cloud perimeter to get the domain for
 * @param isolatedCloudDomain - The IC domain (ex. "company.atlassian-isolated.net")
 * @returns The full domain associated with the subdomain in a specific IC
 */ function $73605056572cb2af$var$getDomainForIsolatedCloud(subdomain, perimeter, isolatedCloudDomain) {
    const domainMappings = (0, $0bd88ba85420b9b2$export$ad1f7afdb45ad83)[perimeter];
    if ((0, $0bd88ba85420b9b2$export$5860df3acd1ee020)[perimeter].includes(subdomain)) return domainMappings.isolatedCloudReservedNameDomain(subdomain, isolatedCloudDomain);
    if ((0, $0bd88ba85420b9b2$export$c6366754aee43afa)[perimeter].includes(subdomain)) return domainMappings.isolatedCloudAtlDomain(subdomain, isolatedCloudDomain);
    return domainMappings.isolatedCloudVanityDomain(subdomain, isolatedCloudDomain);
}
/**
 * Gets the full domain in an non-Isolated Cloud perimeter
 *
 * @param subdomain - The Atlassian experience subdomain
 * @param perimeter - The non-isolated cloud perimeter to get the domain for
 * @param The environment to get the domain for ('dev', 'staging', or 'prod'). When in Isolated Cloud, the same value will be returned for all env types.
 * @returns The full domain associated with the subdomain for the given perimeter and environment
 */ function $73605056572cb2af$var$getDomainForNonIsolatedCloud(subdomain, perimeter, envType) {
    // First, check if the subdomain is associated with a global domain
    if ((0, $91e3fc913980c88d$export$cfd430a73d68f4bc)[subdomain]) return (0, $91e3fc913980c88d$export$cfd430a73d68f4bc)[subdomain];
    // Second, check if the subdomain is associated with a full domain override (ex. a domain that uses a different pattern in other perimeters/environments)
    const override = (0, $91e3fc913980c88d$export$4723232b625f823e)[subdomain]?.[perimeter]?.[envType];
    if (override) return override;
    // Use default domain ending for the given perimeter
    const domainMappings = (0, $0bd88ba85420b9b2$export$c3b4bc58a05128d6)[perimeter];
    return domainMappings.defaultDomainEnding(subdomain, envType);
}
function $73605056572cb2af$export$c162de1e7fecc908(subdomain, envType) {
    const domain = $73605056572cb2af$export$3f82b86ecb947bf0(subdomain, envType);
    if (!domain) {
        console.warn(`Domain could not be determined for requested subdomain: ${subdomain}`);
        return undefined;
    }
    return `${globalThis.location.protocol}//${domain}`;
}
module.exports["getUrlForDomainInContext"] = $73605056572cb2af$export$c162de1e7fecc908;

});

parcelRegister("2Yzoe", function(module, exports) {
'use strict';

module.exports = (parcelRequire("dHtQv"));

});

parcelRegister("dHtQv", function(module, exports) {
// Main parser class
'use strict';

var $hslaz = parcelRequire("hslaz");

var $99cd002251279291$exports = {};
$parcel$export($99cd002251279291$exports, "parseLinkLabel", () => $99cd002251279291$export$2a2c8612930e58d0, (v) => $99cd002251279291$export$2a2c8612930e58d0 = v);
$parcel$export($99cd002251279291$exports, "parseLinkDestination", () => $99cd002251279291$export$22bd24080f95f2b3, (v) => $99cd002251279291$export$22bd24080f95f2b3 = v);
$parcel$export($99cd002251279291$exports, "parseLinkTitle", () => $99cd002251279291$export$89650c5477a69db9, (v) => $99cd002251279291$export$89650c5477a69db9 = v);
// Just a shortcut for bulk export
var $99cd002251279291$export$2a2c8612930e58d0;
var $99cd002251279291$export$22bd24080f95f2b3;
var $99cd002251279291$export$89650c5477a69db9;
'use strict';

$99cd002251279291$export$2a2c8612930e58d0 = (parcelRequire("3jcVo"));

$99cd002251279291$export$22bd24080f95f2b3 = (parcelRequire("bwZH2"));

$99cd002251279291$export$89650c5477a69db9 = (parcelRequire("jcH1A"));


var $18c610ba39de573b$exports = {};
/**
 * class Renderer
 *
 * Generates HTML from parsed token stream. Each instance has independent
 * copy of rules. Those can be rewritten with ease. Also, you can add new
 * rules if you create plugin and adds new token types.
 **/ 'use strict';



var $18c610ba39de573b$require$assign = $hslaz.assign;



var $18c610ba39de573b$require$unescapeAll = $hslaz.unescapeAll;



var $18c610ba39de573b$require$escapeHtml = $hslaz.escapeHtml;
////////////////////////////////////////////////////////////////////////////////
var $18c610ba39de573b$var$default_rules = {};
$18c610ba39de573b$var$default_rules.code_inline = function(tokens, idx, options, env, slf) {
    var token = tokens[idx];
    return '<code' + slf.renderAttrs(token) + '>' + $18c610ba39de573b$require$escapeHtml(token.content) + '</code>';
};
$18c610ba39de573b$var$default_rules.code_block = function(tokens, idx, options, env, slf) {
    var token = tokens[idx];
    return '<pre' + slf.renderAttrs(token) + '><code>' + $18c610ba39de573b$require$escapeHtml(tokens[idx].content) + '</code></pre>\n';
};
$18c610ba39de573b$var$default_rules.fence = function(tokens, idx, options, env, slf) {
    var token = tokens[idx], info = token.info ? $18c610ba39de573b$require$unescapeAll(token.info).trim() : '', langName = '', langAttrs = '', highlighted, i, arr, tmpAttrs, tmpToken;
    if (info) {
        arr = info.split(/(\s+)/g);
        langName = arr[0];
        langAttrs = arr.slice(2).join('');
    }
    if (options.highlight) highlighted = options.highlight(token.content, langName, langAttrs) || $18c610ba39de573b$require$escapeHtml(token.content);
    else highlighted = $18c610ba39de573b$require$escapeHtml(token.content);
    if (highlighted.indexOf('<pre') === 0) return highlighted + '\n';
    // If language exists, inject class gently, without modifying original token.
    // May be, one day we will add .deepClone() for token and simplify this part, but
    // now we prefer to keep things local.
    if (info) {
        i = token.attrIndex('class');
        tmpAttrs = token.attrs ? token.attrs.slice() : [];
        if (i < 0) tmpAttrs.push([
            'class',
            options.langPrefix + langName
        ]);
        else {
            tmpAttrs[i] = tmpAttrs[i].slice();
            tmpAttrs[i][1] += ' ' + options.langPrefix + langName;
        }
        // Fake token just to render attributes
        tmpToken = {
            attrs: tmpAttrs
        };
        return '<pre><code' + slf.renderAttrs(tmpToken) + '>' + highlighted + '</code></pre>\n';
    }
    return '<pre><code' + slf.renderAttrs(token) + '>' + highlighted + '</code></pre>\n';
};
$18c610ba39de573b$var$default_rules.image = function(tokens, idx, options, env, slf) {
    var token = tokens[idx];
    // "alt" attr MUST be set, even if empty. Because it's mandatory and
    // should be placed on proper position for tests.
    //
    // Replace content with actual value
    token.attrs[token.attrIndex('alt')][1] = slf.renderInlineAsText(token.children, options, env);
    return slf.renderToken(tokens, idx, options);
};
$18c610ba39de573b$var$default_rules.hardbreak = function(tokens, idx, options /*, env */ ) {
    return options.xhtmlOut ? '<br />\n' : '<br>\n';
};
$18c610ba39de573b$var$default_rules.softbreak = function(tokens, idx, options /*, env */ ) {
    return options.breaks ? options.xhtmlOut ? '<br />\n' : '<br>\n' : '\n';
};
$18c610ba39de573b$var$default_rules.text = function(tokens, idx /*, options, env */ ) {
    return $18c610ba39de573b$require$escapeHtml(tokens[idx].content);
};
$18c610ba39de573b$var$default_rules.html_block = function(tokens, idx /*, options, env */ ) {
    return tokens[idx].content;
};
$18c610ba39de573b$var$default_rules.html_inline = function(tokens, idx /*, options, env */ ) {
    return tokens[idx].content;
};
/**
 * new Renderer()
 *
 * Creates new [[Renderer]] instance and fill [[Renderer#rules]] with defaults.
 **/ function $18c610ba39de573b$var$Renderer() {
    /**
   * Renderer#rules -> Object
   *
   * Contains render rules for tokens. Can be updated and extended.
   *
   * ##### Example
   *
   * ```javascript
   * var md = require('markdown-it')();
   *
   * md.renderer.rules.strong_open  = function () { return '<b>'; };
   * md.renderer.rules.strong_close = function () { return '</b>'; };
   *
   * var result = md.renderInline(...);
   * ```
   *
   * Each rule is called as independent static function with fixed signature:
   *
   * ```javascript
   * function my_token_render(tokens, idx, options, env, renderer) {
   *   // ...
   *   return renderedHTML;
   * }
   * ```
   *
   * See [source code](https://github.com/markdown-it/markdown-it/blob/master/lib/renderer.js)
   * for more details and examples.
   **/ this.rules = $18c610ba39de573b$require$assign({}, $18c610ba39de573b$var$default_rules);
}
/**
 * Renderer.renderAttrs(token) -> String
 *
 * Render token attributes to string.
 **/ $18c610ba39de573b$var$Renderer.prototype.renderAttrs = function renderAttrs(token) {
    var i, l, result;
    if (!token.attrs) return '';
    result = '';
    for(i = 0, l = token.attrs.length; i < l; i++)result += ' ' + $18c610ba39de573b$require$escapeHtml(token.attrs[i][0]) + '="' + $18c610ba39de573b$require$escapeHtml(token.attrs[i][1]) + '"';
    return result;
};
/**
 * Renderer.renderToken(tokens, idx, options) -> String
 * - tokens (Array): list of tokens
 * - idx (Numbed): token index to render
 * - options (Object): params of parser instance
 *
 * Default token renderer. Can be overriden by custom function
 * in [[Renderer#rules]].
 **/ $18c610ba39de573b$var$Renderer.prototype.renderToken = function renderToken(tokens, idx, options) {
    var nextToken, result = '', needLf = false, token = tokens[idx];
    // Tight list paragraphs
    if (token.hidden) return '';
    // Insert a newline between hidden paragraph and subsequent opening
    // block-level tag.
    //
    // For example, here we should insert a newline before blockquote:
    //  - a
    //    >
    //
    if (token.block && token.nesting !== -1 && idx && tokens[idx - 1].hidden) result += '\n';
    // Add token name, e.g. `<img`
    result += (token.nesting === -1 ? '</' : '<') + token.tag;
    // Encode attributes, e.g. `<img src="foo"`
    result += this.renderAttrs(token);
    // Add a slash for self-closing tags, e.g. `<img src="foo" /`
    if (token.nesting === 0 && options.xhtmlOut) result += ' /';
    // Check if we need to add a newline after this tag
    if (token.block) {
        needLf = true;
        if (token.nesting === 1) {
            if (idx + 1 < tokens.length) {
                nextToken = tokens[idx + 1];
                if (nextToken.type === 'inline' || nextToken.hidden) // Block-level tag containing an inline tag.
                //
                needLf = false;
                else if (nextToken.nesting === -1 && nextToken.tag === token.tag) // Opening tag + closing tag of the same type. E.g. `<li></li>`.
                //
                needLf = false;
            }
        }
    }
    result += needLf ? '>\n' : '>';
    return result;
};
/**
 * Renderer.renderInline(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * The same as [[Renderer.render]], but for single token of `inline` type.
 **/ $18c610ba39de573b$var$Renderer.prototype.renderInline = function(tokens, options, env) {
    var type, result = '', rules = this.rules;
    for(var i = 0, len = tokens.length; i < len; i++){
        type = tokens[i].type;
        if (typeof rules[type] !== 'undefined') result += rules[type](tokens, i, options, env, this);
        else result += this.renderToken(tokens, i, options);
    }
    return result;
};
/** internal
 * Renderer.renderInlineAsText(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * Special kludge for image `alt` attributes to conform CommonMark spec.
 * Don't try to use it! Spec requires to show `alt` content with stripped markup,
 * instead of simple escaping.
 **/ $18c610ba39de573b$var$Renderer.prototype.renderInlineAsText = function(tokens, options, env) {
    var result = '';
    for(var i = 0, len = tokens.length; i < len; i++){
        if (tokens[i].type === 'text') result += tokens[i].content;
        else if (tokens[i].type === 'image') result += this.renderInlineAsText(tokens[i].children, options, env);
        else if (tokens[i].type === 'softbreak') result += '\n';
    }
    return result;
};
/**
 * Renderer.render(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * Takes token stream and generates HTML. Probably, you will never need to call
 * this method directly.
 **/ $18c610ba39de573b$var$Renderer.prototype.render = function(tokens, options, env) {
    var i, len, type, result = '', rules = this.rules;
    for(i = 0, len = tokens.length; i < len; i++){
        type = tokens[i].type;
        if (type === 'inline') result += this.renderInline(tokens[i].children, options, env);
        else if (typeof rules[type] !== 'undefined') result += rules[type](tokens, i, options, env, this);
        else result += this.renderToken(tokens, i, options, env);
    }
    return result;
};
$18c610ba39de573b$exports = $18c610ba39de573b$var$Renderer;


var $eb2feabf2fa54b7e$exports = {};
/** internal
 * class Core
 *
 * Top-level rules executor. Glues block/inline parsers and does intermediate
 * transformations.
 **/ 'use strict';
var $78e5a879766d03a8$exports = {};
/**
 * class Ruler
 *
 * Helper class, used by [[MarkdownIt#core]], [[MarkdownIt#block]] and
 * [[MarkdownIt#inline]] to manage sequences of functions (rules):
 *
 * - keep rules in defined order
 * - assign the name to each rule
 * - enable/disable rules
 * - add/replace rules
 * - allow assign rules to additional named chains (in the same)
 * - cacheing lists of active rules
 *
 * You will not need use this class directly until write plugins. For simple
 * rules control use [[MarkdownIt.disable]], [[MarkdownIt.enable]] and
 * [[MarkdownIt.use]].
 **/ 'use strict';
/**
 * new Ruler()
 **/ function $78e5a879766d03a8$var$Ruler() {
    // List of added rules. Each element is:
    //
    // {
    //   name: XXX,
    //   enabled: Boolean,
    //   fn: Function(),
    //   alt: [ name2, name3 ]
    // }
    //
    this.__rules__ = [];
    // Cached rule chains.
    //
    // First level - chain name, '' for default.
    // Second level - diginal anchor for fast filtering by charcodes.
    //
    this.__cache__ = null;
}
////////////////////////////////////////////////////////////////////////////////
// Helper methods, should not be used directly
// Find rule index by name
//
$78e5a879766d03a8$var$Ruler.prototype.__find__ = function(name) {
    for(var i = 0; i < this.__rules__.length; i++){
        if (this.__rules__[i].name === name) return i;
    }
    return -1;
};
// Build rules lookup cache
//
$78e5a879766d03a8$var$Ruler.prototype.__compile__ = function() {
    var self = this;
    var chains = [
        ''
    ];
    // collect unique names
    self.__rules__.forEach(function(rule) {
        if (!rule.enabled) return;
        rule.alt.forEach(function(altName) {
            if (chains.indexOf(altName) < 0) chains.push(altName);
        });
    });
    self.__cache__ = {};
    chains.forEach(function(chain) {
        self.__cache__[chain] = [];
        self.__rules__.forEach(function(rule) {
            if (!rule.enabled) return;
            if (chain && rule.alt.indexOf(chain) < 0) return;
            self.__cache__[chain].push(rule.fn);
        });
    });
};
/**
 * Ruler.at(name, fn [, options])
 * - name (String): rule name to replace.
 * - fn (Function): new rule function.
 * - options (Object): new rule options (not mandatory).
 *
 * Replace rule by name with new function & options. Throws error if name not
 * found.
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * Replace existing typographer replacement rule with new one:
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.core.ruler.at('replacements', function replace(state) {
 *   //...
 * });
 * ```
 **/ $78e5a879766d03a8$var$Ruler.prototype.at = function(name, fn, options) {
    var index = this.__find__(name);
    var opt = options || {};
    if (index === -1) throw new Error('Parser rule not found: ' + name);
    this.__rules__[index].fn = fn;
    this.__rules__[index].alt = opt.alt || [];
    this.__cache__ = null;
};
/**
 * Ruler.before(beforeName, ruleName, fn [, options])
 * - beforeName (String): new rule will be added before this one.
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Add new rule to chain before one with given name. See also
 * [[Ruler.after]], [[Ruler.push]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.block.ruler.before('paragraph', 'my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $78e5a879766d03a8$var$Ruler.prototype.before = function(beforeName, ruleName, fn, options) {
    var index = this.__find__(beforeName);
    var opt = options || {};
    if (index === -1) throw new Error('Parser rule not found: ' + beforeName);
    this.__rules__.splice(index, 0, {
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.after(afterName, ruleName, fn [, options])
 * - afterName (String): new rule will be added after this one.
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Add new rule to chain after one with given name. See also
 * [[Ruler.before]], [[Ruler.push]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.inline.ruler.after('text', 'my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $78e5a879766d03a8$var$Ruler.prototype.after = function(afterName, ruleName, fn, options) {
    var index = this.__find__(afterName);
    var opt = options || {};
    if (index === -1) throw new Error('Parser rule not found: ' + afterName);
    this.__rules__.splice(index + 1, 0, {
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.push(ruleName, fn [, options])
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Push new rule to the end of chain. See also
 * [[Ruler.before]], [[Ruler.after]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.core.ruler.push('my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $78e5a879766d03a8$var$Ruler.prototype.push = function(ruleName, fn, options) {
    var opt = options || {};
    this.__rules__.push({
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.enable(list [, ignoreInvalid]) -> Array
 * - list (String|Array): list of rule names to enable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable rules with given names. If any rule name not found - throw Error.
 * Errors can be disabled by second param.
 *
 * Returns list of found rule names (if no exception happened).
 *
 * See also [[Ruler.disable]], [[Ruler.enableOnly]].
 **/ $78e5a879766d03a8$var$Ruler.prototype.enable = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    var result = [];
    // Search by name and enable
    list.forEach(function(name) {
        var idx = this.__find__(name);
        if (idx < 0) {
            if (ignoreInvalid) return;
            throw new Error('Rules manager: invalid rule name ' + name);
        }
        this.__rules__[idx].enabled = true;
        result.push(name);
    }, this);
    this.__cache__ = null;
    return result;
};
/**
 * Ruler.enableOnly(list [, ignoreInvalid])
 * - list (String|Array): list of rule names to enable (whitelist).
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable rules with given names, and disable everything else. If any rule name
 * not found - throw Error. Errors can be disabled by second param.
 *
 * See also [[Ruler.disable]], [[Ruler.enable]].
 **/ $78e5a879766d03a8$var$Ruler.prototype.enableOnly = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    this.__rules__.forEach(function(rule) {
        rule.enabled = false;
    });
    this.enable(list, ignoreInvalid);
};
/**
 * Ruler.disable(list [, ignoreInvalid]) -> Array
 * - list (String|Array): list of rule names to disable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Disable rules with given names. If any rule name not found - throw Error.
 * Errors can be disabled by second param.
 *
 * Returns list of found rule names (if no exception happened).
 *
 * See also [[Ruler.enable]], [[Ruler.enableOnly]].
 **/ $78e5a879766d03a8$var$Ruler.prototype.disable = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    var result = [];
    // Search by name and disable
    list.forEach(function(name) {
        var idx = this.__find__(name);
        if (idx < 0) {
            if (ignoreInvalid) return;
            throw new Error('Rules manager: invalid rule name ' + name);
        }
        this.__rules__[idx].enabled = false;
        result.push(name);
    }, this);
    this.__cache__ = null;
    return result;
};
/**
 * Ruler.getRules(chainName) -> Array
 *
 * Return array of active functions (rules) for given chain name. It analyzes
 * rules configuration, compiles caches if not exists and returns result.
 *
 * Default chain name is `''` (empty string). It can't be skipped. That's
 * done intentionally, to keep signature monomorphic for high speed.
 **/ $78e5a879766d03a8$var$Ruler.prototype.getRules = function(chainName) {
    if (this.__cache__ === null) this.__compile__();
    // Chain can be empty, if rules disabled. But we still have to return Array.
    return this.__cache__[chainName] || [];
};
$78e5a879766d03a8$exports = $78e5a879766d03a8$var$Ruler;









var $eb2feabf2fa54b7e$var$_rules = [
    [
        'normalize',
        (parcelRequire("6oHAz"))
    ],
    [
        'block',
        (parcelRequire("1whli"))
    ],
    [
        'inline',
        (parcelRequire("da9wI"))
    ],
    [
        'linkify',
        (parcelRequire("aNcTG"))
    ],
    [
        'replacements',
        (parcelRequire("h6nFy"))
    ],
    [
        'smartquotes',
        (parcelRequire("eNEJu"))
    ],
    // `text_join` finds `text_special` tokens (for escape sequences)
    // and joins them with the rest of the text
    [
        'text_join',
        (parcelRequire("3CceH"))
    ]
];
/**
 * new Core()
 **/ function $eb2feabf2fa54b7e$var$Core() {
    /**
   * Core#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of core rules.
   **/ this.ruler = new $78e5a879766d03a8$exports();
    for(var i = 0; i < $eb2feabf2fa54b7e$var$_rules.length; i++)this.ruler.push($eb2feabf2fa54b7e$var$_rules[i][0], $eb2feabf2fa54b7e$var$_rules[i][1]);
}
/**
 * Core.process(state)
 *
 * Executes core chain rules.
 **/ $eb2feabf2fa54b7e$var$Core.prototype.process = function(state) {
    var i, l, rules;
    rules = this.ruler.getRules('');
    for(i = 0, l = rules.length; i < l; i++)rules[i](state);
};

$eb2feabf2fa54b7e$var$Core.prototype.State = (parcelRequire("hnyQ8"));
$eb2feabf2fa54b7e$exports = $eb2feabf2fa54b7e$var$Core;


var $cae99bdef980d477$exports = {};
/** internal
 * class ParserBlock
 *
 * Block-level tokenizer.
 **/ 'use strict';












var $cae99bdef980d477$var$_rules = [
    // First 2 params - rule name & source. Secondary array - list of rules,
    // which can be terminated by this one.
    [
        'table',
        (parcelRequire("i2Iv8")),
        [
            'paragraph',
            'reference'
        ]
    ],
    [
        'code',
        (parcelRequire("hnPBV"))
    ],
    [
        'fence',
        (parcelRequire("3GuRa")),
        [
            'paragraph',
            'reference',
            'blockquote',
            'list'
        ]
    ],
    [
        'blockquote',
        (parcelRequire("79tnV")),
        [
            'paragraph',
            'reference',
            'blockquote',
            'list'
        ]
    ],
    [
        'hr',
        (parcelRequire("keEbn")),
        [
            'paragraph',
            'reference',
            'blockquote',
            'list'
        ]
    ],
    [
        'list',
        (parcelRequire("9Flpb")),
        [
            'paragraph',
            'reference',
            'blockquote'
        ]
    ],
    [
        'reference',
        (parcelRequire("dabWb"))
    ],
    [
        'html_block',
        (parcelRequire("55Egx")),
        [
            'paragraph',
            'reference',
            'blockquote'
        ]
    ],
    [
        'heading',
        (parcelRequire("9Dg2w")),
        [
            'paragraph',
            'reference',
            'blockquote'
        ]
    ],
    [
        'lheading',
        (parcelRequire("JBg9j"))
    ],
    [
        'paragraph',
        (parcelRequire("15GMD"))
    ]
];
/**
 * new ParserBlock()
 **/ function $cae99bdef980d477$var$ParserBlock() {
    /**
   * ParserBlock#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of block rules.
   **/ this.ruler = new $78e5a879766d03a8$exports();
    for(var i = 0; i < $cae99bdef980d477$var$_rules.length; i++)this.ruler.push($cae99bdef980d477$var$_rules[i][0], $cae99bdef980d477$var$_rules[i][1], {
        alt: ($cae99bdef980d477$var$_rules[i][2] || []).slice()
    });
}
// Generate tokens for input range
//
$cae99bdef980d477$var$ParserBlock.prototype.tokenize = function(state, startLine, endLine) {
    var ok, i, prevLine, rules = this.ruler.getRules(''), len = rules.length, line = startLine, hasEmptyLines = false, maxNesting = state.md.options.maxNesting;
    while(line < endLine){
        state.line = line = state.skipEmptyLines(line);
        if (line >= endLine) break;
        // Termination condition for nested calls.
        // Nested calls currently used for blockquotes & lists
        if (state.sCount[line] < state.blkIndent) break;
        // If nesting level exceeded - skip tail to the end. That's not ordinary
        // situation and we should not care about content.
        if (state.level >= maxNesting) {
            state.line = endLine;
            break;
        }
        // Try all possible rules.
        // On success, rule should:
        //
        // - update `state.line`
        // - update `state.tokens`
        // - return true
        prevLine = state.line;
        for(i = 0; i < len; i++){
            ok = rules[i](state, line, endLine, false);
            if (ok) {
                if (prevLine >= state.line) throw new Error("block rule didn't increment state.line");
                break;
            }
        }
        // this can only happen if user disables paragraph rule
        if (!ok) throw new Error('none of the block rules matched');
        // set state.tight if we had an empty line before current tag
        // i.e. latest empty line should not count
        state.tight = !hasEmptyLines;
        // paragraph might "eat" one newline after it in nested lists
        if (state.isEmpty(state.line - 1)) hasEmptyLines = true;
        line = state.line;
        if (line < endLine && state.isEmpty(line)) {
            hasEmptyLines = true;
            line++;
            state.line = line;
        }
    }
};
/**
 * ParserBlock.parse(str, md, env, outTokens)
 *
 * Process input string and push block tokens into `outTokens`
 **/ $cae99bdef980d477$var$ParserBlock.prototype.parse = function(src, md, env, outTokens) {
    var state;
    if (!src) return;
    state = new this.State(src, md, env, outTokens);
    this.tokenize(state, state.line, state.lineMax);
};

$cae99bdef980d477$var$ParserBlock.prototype.State = (parcelRequire("6eyHE"));
$cae99bdef980d477$exports = $cae99bdef980d477$var$ParserBlock;


var $d17fba15107d07ca$exports = {};
/** internal
 * class ParserInline
 *
 * Tokenizes paragraph content.
 **/ 'use strict';













////////////////////////////////////////////////////////////////////////////////
// Parser rules
var $d17fba15107d07ca$var$_rules = [
    [
        'text',
        (parcelRequire("1U2TG"))
    ],
    [
        'linkify',
        (parcelRequire("lqNlw"))
    ],
    [
        'newline',
        (parcelRequire("iek5k"))
    ],
    [
        'escape',
        (parcelRequire("8Nqk1"))
    ],
    [
        'backticks',
        (parcelRequire("dPP48"))
    ],
    [
        'strikethrough',
        (parcelRequire("45axw")).tokenize
    ],
    [
        'emphasis',
        (parcelRequire("dPUa6")).tokenize
    ],
    [
        'link',
        (parcelRequire("hpf7X"))
    ],
    [
        'image',
        (parcelRequire("gTmYV"))
    ],
    [
        'autolink',
        (parcelRequire("cog6S"))
    ],
    [
        'html_inline',
        (parcelRequire("jaoOi"))
    ],
    [
        'entity',
        (parcelRequire("fdC2o"))
    ]
];




// `rule2` ruleset was created specifically for emphasis/strikethrough
// post-processing and may be changed in the future.
//
// Don't use this for anything except pairs (plugins working with `balance_pairs`).
//
var $d17fba15107d07ca$var$_rules2 = [
    [
        'balance_pairs',
        (parcelRequire("ddn2p"))
    ],
    [
        'strikethrough',
        (parcelRequire("45axw")).postProcess
    ],
    [
        'emphasis',
        (parcelRequire("dPUa6")).postProcess
    ],
    // rules for pairs separate '**' into its own text tokens, which may be left unused,
    // rule below merges unused segments back with the rest of the text
    [
        'fragments_join',
        (parcelRequire("eXNML"))
    ]
];
/**
 * new ParserInline()
 **/ function $d17fba15107d07ca$var$ParserInline() {
    var i;
    /**
   * ParserInline#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of inline rules.
   **/ this.ruler = new $78e5a879766d03a8$exports();
    for(i = 0; i < $d17fba15107d07ca$var$_rules.length; i++)this.ruler.push($d17fba15107d07ca$var$_rules[i][0], $d17fba15107d07ca$var$_rules[i][1]);
    /**
   * ParserInline#ruler2 -> Ruler
   *
   * [[Ruler]] instance. Second ruler used for post-processing
   * (e.g. in emphasis-like rules).
   **/ this.ruler2 = new $78e5a879766d03a8$exports();
    for(i = 0; i < $d17fba15107d07ca$var$_rules2.length; i++)this.ruler2.push($d17fba15107d07ca$var$_rules2[i][0], $d17fba15107d07ca$var$_rules2[i][1]);
}
// Skip single token by running all rules in validation mode;
// returns `true` if any rule reported success
//
$d17fba15107d07ca$var$ParserInline.prototype.skipToken = function(state) {
    var ok, i, pos = state.pos, rules = this.ruler.getRules(''), len = rules.length, maxNesting = state.md.options.maxNesting, cache = state.cache;
    if (typeof cache[pos] !== 'undefined') {
        state.pos = cache[pos];
        return;
    }
    if (state.level < maxNesting) for(i = 0; i < len; i++){
        // Increment state.level and decrement it later to limit recursion.
        // It's harmless to do here, because no tokens are created. But ideally,
        // we'd need a separate private state variable for this purpose.
        //
        state.level++;
        ok = rules[i](state, true);
        state.level--;
        if (ok) {
            if (pos >= state.pos) throw new Error("inline rule didn't increment state.pos");
            break;
        }
    }
    else // Too much nesting, just skip until the end of the paragraph.
    //
    // NOTE: this will cause links to behave incorrectly in the following case,
    //       when an amount of `[` is exactly equal to `maxNesting + 1`:
    //
    //       [[[[[[[[[[[[[[[[[[[[[foo]()
    //
    // TODO: remove this workaround when CM standard will allow nested links
    //       (we can replace it by preventing links from being parsed in
    //       validation mode)
    //
    state.pos = state.posMax;
    if (!ok) state.pos++;
    cache[pos] = state.pos;
};
// Generate tokens for input range
//
$d17fba15107d07ca$var$ParserInline.prototype.tokenize = function(state) {
    var ok, i, prevPos, rules = this.ruler.getRules(''), len = rules.length, end = state.posMax, maxNesting = state.md.options.maxNesting;
    while(state.pos < end){
        // Try all possible rules.
        // On success, rule should:
        //
        // - update `state.pos`
        // - update `state.tokens`
        // - return true
        prevPos = state.pos;
        if (state.level < maxNesting) for(i = 0; i < len; i++){
            ok = rules[i](state, false);
            if (ok) {
                if (prevPos >= state.pos) throw new Error("inline rule didn't increment state.pos");
                break;
            }
        }
        if (ok) {
            if (state.pos >= end) break;
            continue;
        }
        state.pending += state.src[state.pos++];
    }
    if (state.pending) state.pushPending();
};
/**
 * ParserInline.parse(str, md, env, outTokens)
 *
 * Process input string and push inline tokens into `outTokens`
 **/ $d17fba15107d07ca$var$ParserInline.prototype.parse = function(str, md, env, outTokens) {
    var i, rules, len;
    var state = new this.State(str, md, env, outTokens);
    this.tokenize(state);
    rules = this.ruler2.getRules('');
    len = rules.length;
    for(i = 0; i < len; i++)rules[i](state);
};

$d17fba15107d07ca$var$ParserInline.prototype.State = (parcelRequire("ib9ax"));
$d17fba15107d07ca$exports = $d17fba15107d07ca$var$ParserInline;


var $d87414f9b6cb2182$exports = {};
'use strict';
////////////////////////////////////////////////////////////////////////////////
// Helpers
// Merge objects
//
function $d87414f9b6cb2182$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $d87414f9b6cb2182$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $d87414f9b6cb2182$var$isString(obj) {
    return $d87414f9b6cb2182$var$_class(obj) === '[object String]';
}
function $d87414f9b6cb2182$var$isObject(obj) {
    return $d87414f9b6cb2182$var$_class(obj) === '[object Object]';
}
function $d87414f9b6cb2182$var$isRegExp(obj) {
    return $d87414f9b6cb2182$var$_class(obj) === '[object RegExp]';
}
function $d87414f9b6cb2182$var$isFunction(obj) {
    return $d87414f9b6cb2182$var$_class(obj) === '[object Function]';
}
function $d87414f9b6cb2182$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
}
////////////////////////////////////////////////////////////////////////////////
var $d87414f9b6cb2182$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $d87414f9b6cb2182$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        return acc || $d87414f9b6cb2182$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
var $d87414f9b6cb2182$var$defaultSchemas = {
    'http:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp('^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i');
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    'https:': 'http:',
    'ftp:': 'http:',
    '//': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp('^' + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ':') return 0;
                if (pos >= 3 && text[pos - 3] === '/') return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    'mailto:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp('^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i');
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
/*eslint-disable max-len*/ // RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var $d87414f9b6cb2182$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var $d87414f9b6cb2182$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
/*eslint-enable max-len*/ ////////////////////////////////////////////////////////////////////////////////
function $d87414f9b6cb2182$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = '';
}
function $d87414f9b6cb2182$var$createValidator(re) {
    return function(text, pos) {
        var tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $d87414f9b6cb2182$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}

// Schemas compiler. Build regexps.
//
function $d87414f9b6cb2182$var$compile(self) {
    // Load & clone RE patterns.
    var re = self.re = (parcelRequire("aA4uz"))(self.__opts__);
    // Define dynamic patterns
    var tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($d87414f9b6cb2182$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join('|');
    function untpl(tpl) {
        return tpl.replace('%TLDS%', re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
    //
    // Compile each schema
    //
    var aliases = [];
    self.__compiled__ = {}; // Reset compiled data
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        var val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        var compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($d87414f9b6cb2182$var$isObject(val)) {
            if ($d87414f9b6cb2182$var$isRegExp(val.validate)) compiled.validate = $d87414f9b6cb2182$var$createValidator(val.validate);
            else if ($d87414f9b6cb2182$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($d87414f9b6cb2182$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $d87414f9b6cb2182$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($d87414f9b6cb2182$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[''] = {
        validate: null,
        normalize: $d87414f9b6cb2182$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    var slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($d87414f9b6cb2182$var$escapeRE).join('|');
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
    self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');
    self.re.schema_at_start = RegExp('^' + self.re.schema_search.source, 'i');
    self.re.pretest = RegExp('(' + self.re.schema_test.source + ')|(' + self.re.host_fuzzy_test.source + ')|@', 'i');
    //
    // Cleanup
    //
    $d87414f9b6cb2182$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $d87414f9b6cb2182$var$Match(self, shift) {
    var start = self.__index__, end = self.__last_index__, text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $d87414f9b6cb2182$var$createMatch(self, shift) {
    var match = new $d87414f9b6cb2182$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $d87414f9b6cb2182$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $d87414f9b6cb2182$var$LinkifyIt)) return new $d87414f9b6cb2182$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($d87414f9b6cb2182$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $d87414f9b6cb2182$var$assign({}, $d87414f9b6cb2182$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1; // Next scan position
    this.__schema__ = '';
    this.__text_cache__ = '';
    this.__schemas__ = $d87414f9b6cb2182$var$assign({}, $d87414f9b6cb2182$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $d87414f9b6cb2182$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $d87414f9b6cb2182$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $d87414f9b6cb2182$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $d87414f9b6cb2182$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $d87414f9b6cb2182$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $d87414f9b6cb2182$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $d87414f9b6cb2182$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    var m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = '';
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
        // guess schemaless emails
        at_pos = text.indexOf('@');
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = 'mailto:';
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $d87414f9b6cb2182$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $d87414f9b6cb2182$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $d87414f9b6cb2182$var$LinkifyIt.prototype.match = function match(text) {
    var shift = 0, result = [];
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($d87414f9b6cb2182$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    var tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($d87414f9b6cb2182$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/**
 * LinkifyIt#matchAtStart(text) -> Match|null
 *
 * Returns fully-formed (not fuzzy) link if it starts at the beginning
 * of the string, and null otherwise.
 **/ $d87414f9b6cb2182$var$LinkifyIt.prototype.matchAtStart = function matchAtStart(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return null;
    var m = this.re.schema_at_start.exec(text);
    if (!m) return null;
    var len = this.testSchemaAt(text, m[2], m[0].length);
    if (!len) return null;
    this.__schema__ = m[2];
    this.__index__ = m.index + m[1].length;
    this.__last_index__ = m.index + m[0].length + len;
    return $d87414f9b6cb2182$var$createMatch(this, 0);
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $d87414f9b6cb2182$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $d87414f9b6cb2182$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $d87414f9b6cb2182$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $d87414f9b6cb2182$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = 'http://' + match.url;
    if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = 'mailto:' + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $d87414f9b6cb2182$var$LinkifyIt.prototype.onCompile = function onCompile() {};
$d87414f9b6cb2182$exports = $d87414f9b6cb2182$var$LinkifyIt;



var $kYaO1 = parcelRequire("kYaO1");

var $fed2ac37d7e96805$exports = {};
'use strict';
/** Highest positive signed 32-bit float value */ const $fed2ac37d7e96805$var$maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
/** Bootstring parameters */ const $fed2ac37d7e96805$var$base = 36;
const $fed2ac37d7e96805$var$tMin = 1;
const $fed2ac37d7e96805$var$tMax = 26;
const $fed2ac37d7e96805$var$skew = 38;
const $fed2ac37d7e96805$var$damp = 700;
const $fed2ac37d7e96805$var$initialBias = 72;
const $fed2ac37d7e96805$var$initialN = 128; // 0x80
const $fed2ac37d7e96805$var$delimiter = '-'; // '\x2D'
/** Regular expressions */ const $fed2ac37d7e96805$var$regexPunycode = /^xn--/;
const $fed2ac37d7e96805$var$regexNonASCII = /[^\0-\x7F]/; // Note: U+007F DEL is excluded too.
const $fed2ac37d7e96805$var$regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
/** Error messages */ const $fed2ac37d7e96805$var$errors = {
    'overflow': 'Overflow: input needs wider integers to process',
    'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
    'invalid-input': 'Invalid input'
};
/** Convenience shortcuts */ const $fed2ac37d7e96805$var$baseMinusTMin = $fed2ac37d7e96805$var$base - $fed2ac37d7e96805$var$tMin;
const $fed2ac37d7e96805$var$floor = Math.floor;
const $fed2ac37d7e96805$var$stringFromCharCode = String.fromCharCode;
/*--------------------------------------------------------------------------*/ /**
 * A generic error utility function.
 * @private
 * @param {String} type The error type.
 * @returns {Error} Throws a `RangeError` with the applicable error message.
 */ function $fed2ac37d7e96805$var$error(type) {
    throw new RangeError($fed2ac37d7e96805$var$errors[type]);
}
/**
 * A generic `Array#map` utility function.
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} callback The function that gets called for every array
 * item.
 * @returns {Array} A new array of values returned by the callback function.
 */ function $fed2ac37d7e96805$var$map(array, callback) {
    const result = [];
    let length = array.length;
    while(length--)result[length] = callback(array[length]);
    return result;
}
/**
 * A simple `Array#map`-like wrapper to work with domain name strings or email
 * addresses.
 * @private
 * @param {String} domain The domain name or email address.
 * @param {Function} callback The function that gets called for every
 * character.
 * @returns {String} A new string of characters returned by the callback
 * function.
 */ function $fed2ac37d7e96805$var$mapDomain(domain, callback) {
    const parts = domain.split('@');
    let result = '';
    if (parts.length > 1) {
        // In email addresses, only the domain name should be punycoded. Leave
        // the local part (i.e. everything up to `@`) intact.
        result = parts[0] + '@';
        domain = parts[1];
    }
    // Avoid `split(regex)` for IE8 compatibility. See #17.
    domain = domain.replace($fed2ac37d7e96805$var$regexSeparators, '\x2E');
    const labels = domain.split('.');
    const encoded = $fed2ac37d7e96805$var$map(labels, callback).join('.');
    return result + encoded;
}
/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 * @see `punycode.ucs2.encode`
 * @see <https://mathiasbynens.be/notes/javascript-encoding>
 * @memberOf punycode.ucs2
 * @name decode
 * @param {String} string The Unicode input string (UCS-2).
 * @returns {Array} The new array of code points.
 */ function $fed2ac37d7e96805$var$ucs2decode(string) {
    const output = [];
    let counter = 0;
    const length = string.length;
    while(counter < length){
        const value = string.charCodeAt(counter++);
        if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
            // It's a high surrogate, and there is a next character.
            const extra = string.charCodeAt(counter++);
            if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
            else {
                // It's an unmatched surrogate; only append this code unit, in case the
                // next code unit is the high surrogate of a surrogate pair.
                output.push(value);
                counter--;
            }
        } else output.push(value);
    }
    return output;
}
/**
 * Creates a string based on an array of numeric code points.
 * @see `punycode.ucs2.decode`
 * @memberOf punycode.ucs2
 * @name encode
 * @param {Array} codePoints The array of numeric code points.
 * @returns {String} The new Unicode string (UCS-2).
 */ const $fed2ac37d7e96805$var$ucs2encode = (codePoints)=>String.fromCodePoint(...codePoints);
/**
 * Converts a basic code point into a digit/integer.
 * @see `digitToBasic()`
 * @private
 * @param {Number} codePoint The basic numeric code point value.
 * @returns {Number} The numeric value of a basic code point (for use in
 * representing integers) in the range `0` to `base - 1`, or `base` if
 * the code point does not represent a value.
 */ const $fed2ac37d7e96805$var$basicToDigit = function(codePoint) {
    if (codePoint >= 0x30 && codePoint < 0x3A) return 26 + (codePoint - 0x30);
    if (codePoint >= 0x41 && codePoint < 0x5B) return codePoint - 0x41;
    if (codePoint >= 0x61 && codePoint < 0x7B) return codePoint - 0x61;
    return $fed2ac37d7e96805$var$base;
};
/**
 * Converts a digit/integer into a basic code point.
 * @see `basicToDigit()`
 * @private
 * @param {Number} digit The numeric value of a basic code point.
 * @returns {Number} The basic code point whose value (when used for
 * representing integers) is `digit`, which needs to be in the range
 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
 * used; else, the lowercase form is used. The behavior is undefined
 * if `flag` is non-zero and `digit` has no uppercase form.
 */ const $fed2ac37d7e96805$var$digitToBasic = function(digit, flag) {
    //  0..25 map to ASCII a..z or A..Z
    // 26..35 map to ASCII 0..9
    return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
};
/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 * @private
 */ const $fed2ac37d7e96805$var$adapt = function(delta, numPoints, firstTime) {
    let k = 0;
    delta = firstTime ? $fed2ac37d7e96805$var$floor(delta / $fed2ac37d7e96805$var$damp) : delta >> 1;
    delta += $fed2ac37d7e96805$var$floor(delta / numPoints);
    for(; delta > $fed2ac37d7e96805$var$baseMinusTMin * $fed2ac37d7e96805$var$tMax >> 1; k += $fed2ac37d7e96805$var$base)delta = $fed2ac37d7e96805$var$floor(delta / $fed2ac37d7e96805$var$baseMinusTMin);
    return $fed2ac37d7e96805$var$floor(k + ($fed2ac37d7e96805$var$baseMinusTMin + 1) * delta / (delta + $fed2ac37d7e96805$var$skew));
};
/**
 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
 * symbols.
 * @memberOf punycode
 * @param {String} input The Punycode string of ASCII-only symbols.
 * @returns {String} The resulting string of Unicode symbols.
 */ const $fed2ac37d7e96805$var$decode = function(input) {
    // Don't use UCS-2.
    const output = [];
    const inputLength = input.length;
    let i = 0;
    let n = $fed2ac37d7e96805$var$initialN;
    let bias = $fed2ac37d7e96805$var$initialBias;
    // Handle the basic code points: let `basic` be the number of input code
    // points before the last delimiter, or `0` if there is none, then copy
    // the first basic code points to the output.
    let basic = input.lastIndexOf($fed2ac37d7e96805$var$delimiter);
    if (basic < 0) basic = 0;
    for(let j = 0; j < basic; ++j){
        // if it's not a basic code point
        if (input.charCodeAt(j) >= 0x80) $fed2ac37d7e96805$var$error('not-basic');
        output.push(input.charCodeAt(j));
    }
    // Main decoding loop: start just after the last delimiter if any basic code
    // points were copied; start at the beginning otherwise.
    for(let index = basic > 0 ? basic + 1 : 0; index < inputLength;){
        // `index` is the index of the next character to be consumed.
        // Decode a generalized variable-length integer into `delta`,
        // which gets added to `i`. The overflow checking is easier
        // if we increase `i` as we go, then subtract off its starting
        // value at the end to obtain `delta`.
        const oldi = i;
        for(let w = 1, k = $fed2ac37d7e96805$var$base;; k += $fed2ac37d7e96805$var$base){
            if (index >= inputLength) $fed2ac37d7e96805$var$error('invalid-input');
            const digit = $fed2ac37d7e96805$var$basicToDigit(input.charCodeAt(index++));
            if (digit >= $fed2ac37d7e96805$var$base) $fed2ac37d7e96805$var$error('invalid-input');
            if (digit > $fed2ac37d7e96805$var$floor(($fed2ac37d7e96805$var$maxInt - i) / w)) $fed2ac37d7e96805$var$error('overflow');
            i += digit * w;
            const t = k <= bias ? $fed2ac37d7e96805$var$tMin : k >= bias + $fed2ac37d7e96805$var$tMax ? $fed2ac37d7e96805$var$tMax : k - bias;
            if (digit < t) break;
            const baseMinusT = $fed2ac37d7e96805$var$base - t;
            if (w > $fed2ac37d7e96805$var$floor($fed2ac37d7e96805$var$maxInt / baseMinusT)) $fed2ac37d7e96805$var$error('overflow');
            w *= baseMinusT;
        }
        const out = output.length + 1;
        bias = $fed2ac37d7e96805$var$adapt(i - oldi, out, oldi == 0);
        // `i` was supposed to wrap around from `out` to `0`,
        // incrementing `n` each time, so we'll fix that now:
        if ($fed2ac37d7e96805$var$floor(i / out) > $fed2ac37d7e96805$var$maxInt - n) $fed2ac37d7e96805$var$error('overflow');
        n += $fed2ac37d7e96805$var$floor(i / out);
        i %= out;
        // Insert `n` at position `i` of the output.
        output.splice(i++, 0, n);
    }
    return String.fromCodePoint(...output);
};
/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 * @memberOf punycode
 * @param {String} input The string of Unicode symbols.
 * @returns {String} The resulting Punycode string of ASCII-only symbols.
 */ const $fed2ac37d7e96805$var$encode = function(input) {
    const output = [];
    // Convert the input in UCS-2 to an array of Unicode code points.
    input = $fed2ac37d7e96805$var$ucs2decode(input);
    // Cache the length.
    const inputLength = input.length;
    // Initialize the state.
    let n = $fed2ac37d7e96805$var$initialN;
    let delta = 0;
    let bias = $fed2ac37d7e96805$var$initialBias;
    // Handle the basic code points.
    for (const currentValue of input)if (currentValue < 0x80) output.push($fed2ac37d7e96805$var$stringFromCharCode(currentValue));
    const basicLength = output.length;
    let handledCPCount = basicLength;
    // `handledCPCount` is the number of code points that have been handled;
    // `basicLength` is the number of basic code points.
    // Finish the basic string with a delimiter unless it's empty.
    if (basicLength) output.push($fed2ac37d7e96805$var$delimiter);
    // Main encoding loop:
    while(handledCPCount < inputLength){
        // All non-basic code points < n have been handled already. Find the next
        // larger one:
        let m = $fed2ac37d7e96805$var$maxInt;
        for (const currentValue of input)if (currentValue >= n && currentValue < m) m = currentValue;
        // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
        // but guard against overflow.
        const handledCPCountPlusOne = handledCPCount + 1;
        if (m - n > $fed2ac37d7e96805$var$floor(($fed2ac37d7e96805$var$maxInt - delta) / handledCPCountPlusOne)) $fed2ac37d7e96805$var$error('overflow');
        delta += (m - n) * handledCPCountPlusOne;
        n = m;
        for (const currentValue of input){
            if (currentValue < n && ++delta > $fed2ac37d7e96805$var$maxInt) $fed2ac37d7e96805$var$error('overflow');
            if (currentValue === n) {
                // Represent delta as a generalized variable-length integer.
                let q = delta;
                for(let k = $fed2ac37d7e96805$var$base;; k += $fed2ac37d7e96805$var$base){
                    const t = k <= bias ? $fed2ac37d7e96805$var$tMin : k >= bias + $fed2ac37d7e96805$var$tMax ? $fed2ac37d7e96805$var$tMax : k - bias;
                    if (q < t) break;
                    const qMinusT = q - t;
                    const baseMinusT = $fed2ac37d7e96805$var$base - t;
                    output.push($fed2ac37d7e96805$var$stringFromCharCode($fed2ac37d7e96805$var$digitToBasic(t + qMinusT % baseMinusT, 0)));
                    q = $fed2ac37d7e96805$var$floor(qMinusT / baseMinusT);
                }
                output.push($fed2ac37d7e96805$var$stringFromCharCode($fed2ac37d7e96805$var$digitToBasic(q, 0)));
                bias = $fed2ac37d7e96805$var$adapt(delta, handledCPCountPlusOne, handledCPCount === basicLength);
                delta = 0;
                ++handledCPCount;
            }
        }
        ++delta;
        ++n;
    }
    return output.join('');
};
/**
 * Converts a Punycode string representing a domain name or an email address
 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
 * it doesn't matter if you call it on a string that has already been
 * converted to Unicode.
 * @memberOf punycode
 * @param {String} input The Punycoded domain name or email address to
 * convert to Unicode.
 * @returns {String} The Unicode representation of the given Punycode
 * string.
 */ const $fed2ac37d7e96805$var$toUnicode = function(input) {
    return $fed2ac37d7e96805$var$mapDomain(input, function(string) {
        return $fed2ac37d7e96805$var$regexPunycode.test(string) ? $fed2ac37d7e96805$var$decode(string.slice(4).toLowerCase()) : string;
    });
};
/**
 * Converts a Unicode string representing a domain name or an email address to
 * Punycode. Only the non-ASCII parts of the domain name will be converted,
 * i.e. it doesn't matter if you call it with a domain that's already in
 * ASCII.
 * @memberOf punycode
 * @param {String} input The domain name or email address to convert, as a
 * Unicode string.
 * @returns {String} The Punycode representation of the given domain name or
 * email address.
 */ const $fed2ac37d7e96805$var$toASCII = function(input) {
    return $fed2ac37d7e96805$var$mapDomain(input, function(string) {
        return $fed2ac37d7e96805$var$regexNonASCII.test(string) ? 'xn--' + $fed2ac37d7e96805$var$encode(string) : string;
    });
};
/*--------------------------------------------------------------------------*/ /** Define the public API */ const $fed2ac37d7e96805$var$punycode = {
    /**
	 * A string representing the current Punycode.js version number.
	 * @memberOf punycode
	 * @type String
	 */ 'version': '2.3.1',
    /**
	 * An object of methods to convert from JavaScript's internal character
	 * representation (UCS-2) to Unicode code points, and back.
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode
	 * @type Object
	 */ 'ucs2': {
        'decode': $fed2ac37d7e96805$var$ucs2decode,
        'encode': $fed2ac37d7e96805$var$ucs2encode
    },
    'decode': $fed2ac37d7e96805$var$decode,
    'encode': $fed2ac37d7e96805$var$encode,
    'toASCII': $fed2ac37d7e96805$var$toASCII,
    'toUnicode': $fed2ac37d7e96805$var$toUnicode
};
$fed2ac37d7e96805$exports = $fed2ac37d7e96805$var$punycode;





var $9f967144311cb96c$var$config = {
    default: (parcelRequire("j7DYH")),
    zero: (parcelRequire("ad45r")),
    commonmark: (parcelRequire("4teFe"))
};
////////////////////////////////////////////////////////////////////////////////
//
// This validator can prohibit more than really needed to prevent XSS. It's a
// tradeoff to keep code simple and to be secure by default.
//
// If you need different setup - override validator method as you wish. Or
// replace it with dummy function and use external sanitizer.
//
var $9f967144311cb96c$var$BAD_PROTO_RE = /^(vbscript|javascript|file|data):/;
var $9f967144311cb96c$var$GOOD_DATA_RE = /^data:image\/(gif|png|jpeg|webp);/;
function $9f967144311cb96c$var$validateLink(url) {
    // url should be normalized at this point, and existing entities are decoded
    var str = url.trim().toLowerCase();
    return $9f967144311cb96c$var$BAD_PROTO_RE.test(str) ? $9f967144311cb96c$var$GOOD_DATA_RE.test(str) ? true : false : true;
}
////////////////////////////////////////////////////////////////////////////////
var $9f967144311cb96c$var$RECODE_HOSTNAME_FOR = [
    'http:',
    'https:',
    'mailto:'
];
function $9f967144311cb96c$var$normalizeLink(url) {
    var parsed = $kYaO1.parse(url, true);
    if (parsed.hostname) {
        // Encode hostnames in urls like:
        // `http://host/`, `https://host/`, `mailto:user@host`, `//host/`
        //
        // We don't encode unknown schemas, because it's likely that we encode
        // something we shouldn't (e.g. `skype:name` treated as `skype:host`)
        //
        if (!parsed.protocol || $9f967144311cb96c$var$RECODE_HOSTNAME_FOR.indexOf(parsed.protocol) >= 0) try {
            parsed.hostname = $fed2ac37d7e96805$exports.toASCII(parsed.hostname);
        } catch (er) {}
    }
    return $kYaO1.encode($kYaO1.format(parsed));
}
function $9f967144311cb96c$var$normalizeLinkText(url) {
    var parsed = $kYaO1.parse(url, true);
    if (parsed.hostname) {
        // Encode hostnames in urls like:
        // `http://host/`, `https://host/`, `mailto:user@host`, `//host/`
        //
        // We don't encode unknown schemas, because it's likely that we encode
        // something we shouldn't (e.g. `skype:name` treated as `skype:host`)
        //
        if (!parsed.protocol || $9f967144311cb96c$var$RECODE_HOSTNAME_FOR.indexOf(parsed.protocol) >= 0) try {
            parsed.hostname = $fed2ac37d7e96805$exports.toUnicode(parsed.hostname);
        } catch (er) {}
    }
    // add '%' to exclude list because of https://github.com/markdown-it/markdown-it/issues/720
    return $kYaO1.decode($kYaO1.format(parsed), $kYaO1.decode.defaultChars + '%');
}
/**
 * class MarkdownIt
 *
 * Main parser/renderer class.
 *
 * ##### Usage
 *
 * ```javascript
 * // node.js, "classic" way:
 * var MarkdownIt = require('markdown-it'),
 *     md = new MarkdownIt();
 * var result = md.render('# markdown-it rulezz!');
 *
 * // node.js, the same, but with sugar:
 * var md = require('markdown-it')();
 * var result = md.render('# markdown-it rulezz!');
 *
 * // browser without AMD, added to "window" on script load
 * // Note, there are no dash.
 * var md = window.markdownit();
 * var result = md.render('# markdown-it rulezz!');
 * ```
 *
 * Single line rendering, without paragraph wrap:
 *
 * ```javascript
 * var md = require('markdown-it')();
 * var result = md.renderInline('__markdown-it__ rulezz!');
 * ```
 **/ /**
 * new MarkdownIt([presetName, options])
 * - presetName (String): optional, `commonmark` / `zero`
 * - options (Object)
 *
 * Creates parser instanse with given config. Can be called without `new`.
 *
 * ##### presetName
 *
 * MarkdownIt provides named presets as a convenience to quickly
 * enable/disable active syntax rules and options for common use cases.
 *
 * - ["commonmark"](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/commonmark.js) -
 *   configures parser to strict [CommonMark](http://commonmark.org/) mode.
 * - [default](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/default.js) -
 *   similar to GFM, used when no preset name given. Enables all available rules,
 *   but still without html, typographer & autolinker.
 * - ["zero"](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/zero.js) -
 *   all rules disabled. Useful to quickly setup your config via `.enable()`.
 *   For example, when you need only `bold` and `italic` markup and nothing else.
 *
 * ##### options:
 *
 * - __html__ - `false`. Set `true` to enable HTML tags in source. Be careful!
 *   That's not safe! You may need external sanitizer to protect output from XSS.
 *   It's better to extend features via plugins, instead of enabling HTML.
 * - __xhtmlOut__ - `false`. Set `true` to add '/' when closing single tags
 *   (`<br />`). This is needed only for full CommonMark compatibility. In real
 *   world you will need HTML output.
 * - __breaks__ - `false`. Set `true` to convert `\n` in paragraphs into `<br>`.
 * - __langPrefix__ - `language-`. CSS language class prefix for fenced blocks.
 *   Can be useful for external highlighters.
 * - __linkify__ - `false`. Set `true` to autoconvert URL-like text to links.
 * - __typographer__  - `false`. Set `true` to enable [some language-neutral
 *   replacement](https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/replacements.js) +
 *   quotes beautification (smartquotes).
 * - __quotes__ - `“”‘’`, String or Array. Double + single quotes replacement
 *   pairs, when typographer enabled and smartquotes on. For example, you can
 *   use `'«»„“'` for Russian, `'„“‚‘'` for German, and
 *   `['«\xA0', '\xA0»', '‹\xA0', '\xA0›']` for French (including nbsp).
 * - __highlight__ - `null`. Highlighter function for fenced code blocks.
 *   Highlighter `function (str, lang)` should return escaped HTML. It can also
 *   return empty string if the source was not changed and should be escaped
 *   externaly. If result starts with <pre... internal wrapper is skipped.
 *
 * ##### Example
 *
 * ```javascript
 * // commonmark mode
 * var md = require('markdown-it')('commonmark');
 *
 * // default mode
 * var md = require('markdown-it')();
 *
 * // enable everything
 * var md = require('markdown-it')({
 *   html: true,
 *   linkify: true,
 *   typographer: true
 * });
 * ```
 *
 * ##### Syntax highlighting
 *
 * ```js
 * var hljs = require('highlight.js') // https://highlightjs.org/
 *
 * var md = require('markdown-it')({
 *   highlight: function (str, lang) {
 *     if (lang && hljs.getLanguage(lang)) {
 *       try {
 *         return hljs.highlight(str, { language: lang, ignoreIllegals: true }).value;
 *       } catch (__) {}
 *     }
 *
 *     return ''; // use external default escaping
 *   }
 * });
 * ```
 *
 * Or with full wrapper override (if you need assign class to `<pre>`):
 *
 * ```javascript
 * var hljs = require('highlight.js') // https://highlightjs.org/
 *
 * // Actual default values
 * var md = require('markdown-it')({
 *   highlight: function (str, lang) {
 *     if (lang && hljs.getLanguage(lang)) {
 *       try {
 *         return '<pre class="hljs"><code>' +
 *                hljs.highlight(str, { language: lang, ignoreIllegals: true }).value +
 *                '</code></pre>';
 *       } catch (__) {}
 *     }
 *
 *     return '<pre class="hljs"><code>' + md.utils.escapeHtml(str) + '</code></pre>';
 *   }
 * });
 * ```
 *
 **/ function $9f967144311cb96c$var$MarkdownIt(presetName, options) {
    if (!(this instanceof $9f967144311cb96c$var$MarkdownIt)) return new $9f967144311cb96c$var$MarkdownIt(presetName, options);
    if (!options) {
        if (!$hslaz.isString(presetName)) {
            options = presetName || {};
            presetName = 'default';
        }
    }
    /**
   * MarkdownIt#inline -> ParserInline
   *
   * Instance of [[ParserInline]]. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.inline = new $d17fba15107d07ca$exports();
    /**
   * MarkdownIt#block -> ParserBlock
   *
   * Instance of [[ParserBlock]]. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.block = new $cae99bdef980d477$exports();
    /**
   * MarkdownIt#core -> Core
   *
   * Instance of [[Core]] chain executor. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.core = new $eb2feabf2fa54b7e$exports();
    /**
   * MarkdownIt#renderer -> Renderer
   *
   * Instance of [[Renderer]]. Use it to modify output look. Or to add rendering
   * rules for new token types, generated by plugins.
   *
   * ##### Example
   *
   * ```javascript
   * var md = require('markdown-it')();
   *
   * function myToken(tokens, idx, options, env, self) {
   *   //...
   *   return result;
   * };
   *
   * md.renderer.rules['my_token'] = myToken
   * ```
   *
   * See [[Renderer]] docs and [source code](https://github.com/markdown-it/markdown-it/blob/master/lib/renderer.js).
   **/ this.renderer = new $18c610ba39de573b$exports();
    /**
   * MarkdownIt#linkify -> LinkifyIt
   *
   * [linkify-it](https://github.com/markdown-it/linkify-it) instance.
   * Used by [linkify](https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/linkify.js)
   * rule.
   **/ this.linkify = new $d87414f9b6cb2182$exports();
    /**
   * MarkdownIt#validateLink(url) -> Boolean
   *
   * Link validation function. CommonMark allows too much in links. By default
   * we disable `javascript:`, `vbscript:`, `file:` schemas, and almost all `data:...` schemas
   * except some embedded image types.
   *
   * You can change this behaviour:
   *
   * ```javascript
   * var md = require('markdown-it')();
   * // enable everything
   * md.validateLink = function () { return true; }
   * ```
   **/ this.validateLink = $9f967144311cb96c$var$validateLink;
    /**
   * MarkdownIt#normalizeLink(url) -> String
   *
   * Function used to encode link url to a machine-readable format,
   * which includes url-encoding, punycode, etc.
   **/ this.normalizeLink = $9f967144311cb96c$var$normalizeLink;
    /**
   * MarkdownIt#normalizeLinkText(url) -> String
   *
   * Function used to decode link url to a human-readable format`
   **/ this.normalizeLinkText = $9f967144311cb96c$var$normalizeLinkText;
    // Expose utils & helpers for easy acces from plugins
    /**
   * MarkdownIt#utils -> utils
   *
   * Assorted utility functions, useful to write plugins. See details
   * [here](https://github.com/markdown-it/markdown-it/blob/master/lib/common/utils.js).
   **/ this.utils = $hslaz;
    /**
   * MarkdownIt#helpers -> helpers
   *
   * Link components parser functions, useful to write plugins. See details
   * [here](https://github.com/markdown-it/markdown-it/blob/master/lib/helpers).
   **/ this.helpers = $hslaz.assign({}, $99cd002251279291$exports);
    this.options = {};
    this.configure(presetName);
    if (options) this.set(options);
}
/** chainable
 * MarkdownIt.set(options)
 *
 * Set parser options (in the same format as in constructor). Probably, you
 * will never need it, but you can change options after constructor call.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')()
 *             .set({ html: true, breaks: true })
 *             .set({ typographer, true });
 * ```
 *
 * __Note:__ To achieve the best possible performance, don't modify a
 * `markdown-it` instance options on the fly. If you need multiple configurations
 * it's best to create multiple instances and initialize each with separate
 * config.
 **/ $9f967144311cb96c$var$MarkdownIt.prototype.set = function(options) {
    $hslaz.assign(this.options, options);
    return this;
};
/** chainable, internal
 * MarkdownIt.configure(presets)
 *
 * Batch load of all options and compenent settings. This is internal method,
 * and you probably will not need it. But if you will - see available presets
 * and data structure [here](https://github.com/markdown-it/markdown-it/tree/master/lib/presets)
 *
 * We strongly recommend to use presets instead of direct config loads. That
 * will give better compatibility with next versions.
 **/ $9f967144311cb96c$var$MarkdownIt.prototype.configure = function(presets) {
    var self = this, presetName;
    if ($hslaz.isString(presets)) {
        presetName = presets;
        presets = $9f967144311cb96c$var$config[presetName];
        if (!presets) throw new Error('Wrong `markdown-it` preset "' + presetName + '", check name');
    }
    if (!presets) throw new Error('Wrong `markdown-it` preset, can\'t be empty');
    if (presets.options) self.set(presets.options);
    if (presets.components) Object.keys(presets.components).forEach(function(name) {
        if (presets.components[name].rules) self[name].ruler.enableOnly(presets.components[name].rules);
        if (presets.components[name].rules2) self[name].ruler2.enableOnly(presets.components[name].rules2);
    });
    return this;
};
/** chainable
 * MarkdownIt.enable(list, ignoreInvalid)
 * - list (String|Array): rule name or list of rule names to enable
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable list or rules. It will automatically find appropriate components,
 * containing rules with given names. If rule not found, and `ignoreInvalid`
 * not set - throws exception.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')()
 *             .enable(['sub', 'sup'])
 *             .disable('smartquotes');
 * ```
 **/ $9f967144311cb96c$var$MarkdownIt.prototype.enable = function(list, ignoreInvalid) {
    var result = [];
    if (!Array.isArray(list)) list = [
        list
    ];
    [
        'core',
        'block',
        'inline'
    ].forEach(function(chain) {
        result = result.concat(this[chain].ruler.enable(list, true));
    }, this);
    result = result.concat(this.inline.ruler2.enable(list, true));
    var missed = list.filter(function(name) {
        return result.indexOf(name) < 0;
    });
    if (missed.length && !ignoreInvalid) throw new Error('MarkdownIt. Failed to enable unknown rule(s): ' + missed);
    return this;
};
/** chainable
 * MarkdownIt.disable(list, ignoreInvalid)
 * - list (String|Array): rule name or list of rule names to disable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * The same as [[MarkdownIt.enable]], but turn specified rules off.
 **/ $9f967144311cb96c$var$MarkdownIt.prototype.disable = function(list, ignoreInvalid) {
    var result = [];
    if (!Array.isArray(list)) list = [
        list
    ];
    [
        'core',
        'block',
        'inline'
    ].forEach(function(chain) {
        result = result.concat(this[chain].ruler.disable(list, true));
    }, this);
    result = result.concat(this.inline.ruler2.disable(list, true));
    var missed = list.filter(function(name) {
        return result.indexOf(name) < 0;
    });
    if (missed.length && !ignoreInvalid) throw new Error('MarkdownIt. Failed to disable unknown rule(s): ' + missed);
    return this;
};
/** chainable
 * MarkdownIt.use(plugin, params)
 *
 * Load specified plugin with given params into current parser instance.
 * It's just a sugar to call `plugin(md, params)` with curring.
 *
 * ##### Example
 *
 * ```javascript
 * var iterator = require('markdown-it-for-inline');
 * var md = require('markdown-it')()
 *             .use(iterator, 'foo_replace', 'text', function (tokens, idx) {
 *               tokens[idx].content = tokens[idx].content.replace(/foo/g, 'bar');
 *             });
 * ```
 **/ $9f967144311cb96c$var$MarkdownIt.prototype.use = function(plugin /*, params, ... */ ) {
    var args = [
        this
    ].concat(Array.prototype.slice.call(arguments, 1));
    plugin.apply(plugin, args);
    return this;
};
/** internal
 * MarkdownIt.parse(src, env) -> Array
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Parse input string and return list of block tokens (special token type
 * "inline" will contain list of inline tokens). You should not call this
 * method directly, until you write custom renderer (for example, to produce
 * AST).
 *
 * `env` is used to pass data between "distributed" rules and return additional
 * metadata like reference info, needed for the renderer. It also can be used to
 * inject data in specific cases. Usually, you will be ok to pass `{}`,
 * and then pass updated object to renderer.
 **/ $9f967144311cb96c$var$MarkdownIt.prototype.parse = function(src, env) {
    if (typeof src !== 'string') throw new Error('Input data should be a String');
    var state = new this.core.State(src, this, env);
    this.core.process(state);
    return state.tokens;
};
/**
 * MarkdownIt.render(src [, env]) -> String
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Render markdown string into html. It does all magic for you :).
 *
 * `env` can be used to inject additional metadata (`{}` by default).
 * But you will not need it with high probability. See also comment
 * in [[MarkdownIt.parse]].
 **/ $9f967144311cb96c$var$MarkdownIt.prototype.render = function(src, env) {
    env = env || {};
    return this.renderer.render(this.parse(src, env), this.options, env);
};
/** internal
 * MarkdownIt.parseInline(src, env) -> Array
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * The same as [[MarkdownIt.parse]] but skip all block rules. It returns the
 * block tokens list with the single `inline` element, containing parsed inline
 * tokens in `children` property. Also updates `env` object.
 **/ $9f967144311cb96c$var$MarkdownIt.prototype.parseInline = function(src, env) {
    var state = new this.core.State(src, this, env);
    state.inlineMode = true;
    this.core.process(state);
    return state.tokens;
};
/**
 * MarkdownIt.renderInline(src [, env]) -> String
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Similar to [[MarkdownIt.render]] but for single paragraph content. Result
 * will NOT be wrapped into `<p>` tags.
 **/ $9f967144311cb96c$var$MarkdownIt.prototype.renderInline = function(src, env) {
    env = env || {};
    return this.renderer.render(this.parseInline(src, env), this.options, env);
};
module.exports = $9f967144311cb96c$var$MarkdownIt;

});

parcelRegister("hxrg0", function(module, exports) {
module.exports = JSON.parse('{"Aacute":"\xc1","aacute":"\xe1","Abreve":"\u0102","abreve":"\u0103","ac":"\u223E","acd":"\u223F","acE":"\u223E\u0333","Acirc":"\xc2","acirc":"\xe2","acute":"\xb4","Acy":"\u0410","acy":"\u0430","AElig":"\xc6","aelig":"\xe6","af":"\u2061","Afr":"\uD835\uDD04","afr":"\uD835\uDD1E","Agrave":"\xc0","agrave":"\xe0","alefsym":"\u2135","aleph":"\u2135","Alpha":"\u0391","alpha":"\u03B1","Amacr":"\u0100","amacr":"\u0101","amalg":"\u2A3F","amp":"&","AMP":"&","andand":"\u2A55","And":"\u2A53","and":"\u2227","andd":"\u2A5C","andslope":"\u2A58","andv":"\u2A5A","ang":"\u2220","ange":"\u29A4","angle":"\u2220","angmsdaa":"\u29A8","angmsdab":"\u29A9","angmsdac":"\u29AA","angmsdad":"\u29AB","angmsdae":"\u29AC","angmsdaf":"\u29AD","angmsdag":"\u29AE","angmsdah":"\u29AF","angmsd":"\u2221","angrt":"\u221F","angrtvb":"\u22BE","angrtvbd":"\u299D","angsph":"\u2222","angst":"\xc5","angzarr":"\u237C","Aogon":"\u0104","aogon":"\u0105","Aopf":"\uD835\uDD38","aopf":"\uD835\uDD52","apacir":"\u2A6F","ap":"\u2248","apE":"\u2A70","ape":"\u224A","apid":"\u224B","apos":"\'","ApplyFunction":"\u2061","approx":"\u2248","approxeq":"\u224A","Aring":"\xc5","aring":"\xe5","Ascr":"\uD835\uDC9C","ascr":"\uD835\uDCB6","Assign":"\u2254","ast":"*","asymp":"\u2248","asympeq":"\u224D","Atilde":"\xc3","atilde":"\xe3","Auml":"\xc4","auml":"\xe4","awconint":"\u2233","awint":"\u2A11","backcong":"\u224C","backepsilon":"\u03F6","backprime":"\u2035","backsim":"\u223D","backsimeq":"\u22CD","Backslash":"\u2216","Barv":"\u2AE7","barvee":"\u22BD","barwed":"\u2305","Barwed":"\u2306","barwedge":"\u2305","bbrk":"\u23B5","bbrktbrk":"\u23B6","bcong":"\u224C","Bcy":"\u0411","bcy":"\u0431","bdquo":"\u201E","becaus":"\u2235","because":"\u2235","Because":"\u2235","bemptyv":"\u29B0","bepsi":"\u03F6","bernou":"\u212C","Bernoullis":"\u212C","Beta":"\u0392","beta":"\u03B2","beth":"\u2136","between":"\u226C","Bfr":"\uD835\uDD05","bfr":"\uD835\uDD1F","bigcap":"\u22C2","bigcirc":"\u25EF","bigcup":"\u22C3","bigodot":"\u2A00","bigoplus":"\u2A01","bigotimes":"\u2A02","bigsqcup":"\u2A06","bigstar":"\u2605","bigtriangledown":"\u25BD","bigtriangleup":"\u25B3","biguplus":"\u2A04","bigvee":"\u22C1","bigwedge":"\u22C0","bkarow":"\u290D","blacklozenge":"\u29EB","blacksquare":"\u25AA","blacktriangle":"\u25B4","blacktriangledown":"\u25BE","blacktriangleleft":"\u25C2","blacktriangleright":"\u25B8","blank":"\u2423","blk12":"\u2592","blk14":"\u2591","blk34":"\u2593","block":"\u2588","bne":"=\u20E5","bnequiv":"\u2261\u20E5","bNot":"\u2AED","bnot":"\u2310","Bopf":"\uD835\uDD39","bopf":"\uD835\uDD53","bot":"\u22A5","bottom":"\u22A5","bowtie":"\u22C8","boxbox":"\u29C9","boxdl":"\u2510","boxdL":"\u2555","boxDl":"\u2556","boxDL":"\u2557","boxdr":"\u250C","boxdR":"\u2552","boxDr":"\u2553","boxDR":"\u2554","boxh":"\u2500","boxH":"\u2550","boxhd":"\u252C","boxHd":"\u2564","boxhD":"\u2565","boxHD":"\u2566","boxhu":"\u2534","boxHu":"\u2567","boxhU":"\u2568","boxHU":"\u2569","boxminus":"\u229F","boxplus":"\u229E","boxtimes":"\u22A0","boxul":"\u2518","boxuL":"\u255B","boxUl":"\u255C","boxUL":"\u255D","boxur":"\u2514","boxuR":"\u2558","boxUr":"\u2559","boxUR":"\u255A","boxv":"\u2502","boxV":"\u2551","boxvh":"\u253C","boxvH":"\u256A","boxVh":"\u256B","boxVH":"\u256C","boxvl":"\u2524","boxvL":"\u2561","boxVl":"\u2562","boxVL":"\u2563","boxvr":"\u251C","boxvR":"\u255E","boxVr":"\u255F","boxVR":"\u2560","bprime":"\u2035","breve":"\u02D8","Breve":"\u02D8","brvbar":"\xa6","bscr":"\uD835\uDCB7","Bscr":"\u212C","bsemi":"\u204F","bsim":"\u223D","bsime":"\u22CD","bsolb":"\u29C5","bsol":"\\\\","bsolhsub":"\u27C8","bull":"\u2022","bullet":"\u2022","bump":"\u224E","bumpE":"\u2AAE","bumpe":"\u224F","Bumpeq":"\u224E","bumpeq":"\u224F","Cacute":"\u0106","cacute":"\u0107","capand":"\u2A44","capbrcup":"\u2A49","capcap":"\u2A4B","cap":"\u2229","Cap":"\u22D2","capcup":"\u2A47","capdot":"\u2A40","CapitalDifferentialD":"\u2145","caps":"\u2229\uFE00","caret":"\u2041","caron":"\u02C7","Cayleys":"\u212D","ccaps":"\u2A4D","Ccaron":"\u010C","ccaron":"\u010D","Ccedil":"\xc7","ccedil":"\xe7","Ccirc":"\u0108","ccirc":"\u0109","Cconint":"\u2230","ccups":"\u2A4C","ccupssm":"\u2A50","Cdot":"\u010A","cdot":"\u010B","cedil":"\xb8","Cedilla":"\xb8","cemptyv":"\u29B2","cent":"\xa2","centerdot":"\xb7","CenterDot":"\xb7","cfr":"\uD835\uDD20","Cfr":"\u212D","CHcy":"\u0427","chcy":"\u0447","check":"\u2713","checkmark":"\u2713","Chi":"\u03A7","chi":"\u03C7","circ":"\u02C6","circeq":"\u2257","circlearrowleft":"\u21BA","circlearrowright":"\u21BB","circledast":"\u229B","circledcirc":"\u229A","circleddash":"\u229D","CircleDot":"\u2299","circledR":"\xae","circledS":"\u24C8","CircleMinus":"\u2296","CirclePlus":"\u2295","CircleTimes":"\u2297","cir":"\u25CB","cirE":"\u29C3","cire":"\u2257","cirfnint":"\u2A10","cirmid":"\u2AEF","cirscir":"\u29C2","ClockwiseContourIntegral":"\u2232","CloseCurlyDoubleQuote":"\u201D","CloseCurlyQuote":"\u2019","clubs":"\u2663","clubsuit":"\u2663","colon":":","Colon":"\u2237","Colone":"\u2A74","colone":"\u2254","coloneq":"\u2254","comma":",","commat":"@","comp":"\u2201","compfn":"\u2218","complement":"\u2201","complexes":"\u2102","cong":"\u2245","congdot":"\u2A6D","Congruent":"\u2261","conint":"\u222E","Conint":"\u222F","ContourIntegral":"\u222E","copf":"\uD835\uDD54","Copf":"\u2102","coprod":"\u2210","Coproduct":"\u2210","copy":"\xa9","COPY":"\xa9","copysr":"\u2117","CounterClockwiseContourIntegral":"\u2233","crarr":"\u21B5","cross":"\u2717","Cross":"\u2A2F","Cscr":"\uD835\uDC9E","cscr":"\uD835\uDCB8","csub":"\u2ACF","csube":"\u2AD1","csup":"\u2AD0","csupe":"\u2AD2","ctdot":"\u22EF","cudarrl":"\u2938","cudarrr":"\u2935","cuepr":"\u22DE","cuesc":"\u22DF","cularr":"\u21B6","cularrp":"\u293D","cupbrcap":"\u2A48","cupcap":"\u2A46","CupCap":"\u224D","cup":"\u222A","Cup":"\u22D3","cupcup":"\u2A4A","cupdot":"\u228D","cupor":"\u2A45","cups":"\u222A\uFE00","curarr":"\u21B7","curarrm":"\u293C","curlyeqprec":"\u22DE","curlyeqsucc":"\u22DF","curlyvee":"\u22CE","curlywedge":"\u22CF","curren":"\xa4","curvearrowleft":"\u21B6","curvearrowright":"\u21B7","cuvee":"\u22CE","cuwed":"\u22CF","cwconint":"\u2232","cwint":"\u2231","cylcty":"\u232D","dagger":"\u2020","Dagger":"\u2021","daleth":"\u2138","darr":"\u2193","Darr":"\u21A1","dArr":"\u21D3","dash":"\u2010","Dashv":"\u2AE4","dashv":"\u22A3","dbkarow":"\u290F","dblac":"\u02DD","Dcaron":"\u010E","dcaron":"\u010F","Dcy":"\u0414","dcy":"\u0434","ddagger":"\u2021","ddarr":"\u21CA","DD":"\u2145","dd":"\u2146","DDotrahd":"\u2911","ddotseq":"\u2A77","deg":"\xb0","Del":"\u2207","Delta":"\u0394","delta":"\u03B4","demptyv":"\u29B1","dfisht":"\u297F","Dfr":"\uD835\uDD07","dfr":"\uD835\uDD21","dHar":"\u2965","dharl":"\u21C3","dharr":"\u21C2","DiacriticalAcute":"\xb4","DiacriticalDot":"\u02D9","DiacriticalDoubleAcute":"\u02DD","DiacriticalGrave":"`","DiacriticalTilde":"\u02DC","diam":"\u22C4","diamond":"\u22C4","Diamond":"\u22C4","diamondsuit":"\u2666","diams":"\u2666","die":"\xa8","DifferentialD":"\u2146","digamma":"\u03DD","disin":"\u22F2","div":"\xf7","divide":"\xf7","divideontimes":"\u22C7","divonx":"\u22C7","DJcy":"\u0402","djcy":"\u0452","dlcorn":"\u231E","dlcrop":"\u230D","dollar":"$","Dopf":"\uD835\uDD3B","dopf":"\uD835\uDD55","Dot":"\xa8","dot":"\u02D9","DotDot":"\u20DC","doteq":"\u2250","doteqdot":"\u2251","DotEqual":"\u2250","dotminus":"\u2238","dotplus":"\u2214","dotsquare":"\u22A1","doublebarwedge":"\u2306","DoubleContourIntegral":"\u222F","DoubleDot":"\xa8","DoubleDownArrow":"\u21D3","DoubleLeftArrow":"\u21D0","DoubleLeftRightArrow":"\u21D4","DoubleLeftTee":"\u2AE4","DoubleLongLeftArrow":"\u27F8","DoubleLongLeftRightArrow":"\u27FA","DoubleLongRightArrow":"\u27F9","DoubleRightArrow":"\u21D2","DoubleRightTee":"\u22A8","DoubleUpArrow":"\u21D1","DoubleUpDownArrow":"\u21D5","DoubleVerticalBar":"\u2225","DownArrowBar":"\u2913","downarrow":"\u2193","DownArrow":"\u2193","Downarrow":"\u21D3","DownArrowUpArrow":"\u21F5","DownBreve":"\u0311","downdownarrows":"\u21CA","downharpoonleft":"\u21C3","downharpoonright":"\u21C2","DownLeftRightVector":"\u2950","DownLeftTeeVector":"\u295E","DownLeftVectorBar":"\u2956","DownLeftVector":"\u21BD","DownRightTeeVector":"\u295F","DownRightVectorBar":"\u2957","DownRightVector":"\u21C1","DownTeeArrow":"\u21A7","DownTee":"\u22A4","drbkarow":"\u2910","drcorn":"\u231F","drcrop":"\u230C","Dscr":"\uD835\uDC9F","dscr":"\uD835\uDCB9","DScy":"\u0405","dscy":"\u0455","dsol":"\u29F6","Dstrok":"\u0110","dstrok":"\u0111","dtdot":"\u22F1","dtri":"\u25BF","dtrif":"\u25BE","duarr":"\u21F5","duhar":"\u296F","dwangle":"\u29A6","DZcy":"\u040F","dzcy":"\u045F","dzigrarr":"\u27FF","Eacute":"\xc9","eacute":"\xe9","easter":"\u2A6E","Ecaron":"\u011A","ecaron":"\u011B","Ecirc":"\xca","ecirc":"\xea","ecir":"\u2256","ecolon":"\u2255","Ecy":"\u042D","ecy":"\u044D","eDDot":"\u2A77","Edot":"\u0116","edot":"\u0117","eDot":"\u2251","ee":"\u2147","efDot":"\u2252","Efr":"\uD835\uDD08","efr":"\uD835\uDD22","eg":"\u2A9A","Egrave":"\xc8","egrave":"\xe8","egs":"\u2A96","egsdot":"\u2A98","el":"\u2A99","Element":"\u2208","elinters":"\u23E7","ell":"\u2113","els":"\u2A95","elsdot":"\u2A97","Emacr":"\u0112","emacr":"\u0113","empty":"\u2205","emptyset":"\u2205","EmptySmallSquare":"\u25FB","emptyv":"\u2205","EmptyVerySmallSquare":"\u25AB","emsp13":"\u2004","emsp14":"\u2005","emsp":"\u2003","ENG":"\u014A","eng":"\u014B","ensp":"\u2002","Eogon":"\u0118","eogon":"\u0119","Eopf":"\uD835\uDD3C","eopf":"\uD835\uDD56","epar":"\u22D5","eparsl":"\u29E3","eplus":"\u2A71","epsi":"\u03B5","Epsilon":"\u0395","epsilon":"\u03B5","epsiv":"\u03F5","eqcirc":"\u2256","eqcolon":"\u2255","eqsim":"\u2242","eqslantgtr":"\u2A96","eqslantless":"\u2A95","Equal":"\u2A75","equals":"=","EqualTilde":"\u2242","equest":"\u225F","Equilibrium":"\u21CC","equiv":"\u2261","equivDD":"\u2A78","eqvparsl":"\u29E5","erarr":"\u2971","erDot":"\u2253","escr":"\u212F","Escr":"\u2130","esdot":"\u2250","Esim":"\u2A73","esim":"\u2242","Eta":"\u0397","eta":"\u03B7","ETH":"\xd0","eth":"\xf0","Euml":"\xcb","euml":"\xeb","euro":"\u20AC","excl":"!","exist":"\u2203","Exists":"\u2203","expectation":"\u2130","exponentiale":"\u2147","ExponentialE":"\u2147","fallingdotseq":"\u2252","Fcy":"\u0424","fcy":"\u0444","female":"\u2640","ffilig":"\uFB03","fflig":"\uFB00","ffllig":"\uFB04","Ffr":"\uD835\uDD09","ffr":"\uD835\uDD23","filig":"\uFB01","FilledSmallSquare":"\u25FC","FilledVerySmallSquare":"\u25AA","fjlig":"fj","flat":"\u266D","fllig":"\uFB02","fltns":"\u25B1","fnof":"\u0192","Fopf":"\uD835\uDD3D","fopf":"\uD835\uDD57","forall":"\u2200","ForAll":"\u2200","fork":"\u22D4","forkv":"\u2AD9","Fouriertrf":"\u2131","fpartint":"\u2A0D","frac12":"\xbd","frac13":"\u2153","frac14":"\xbc","frac15":"\u2155","frac16":"\u2159","frac18":"\u215B","frac23":"\u2154","frac25":"\u2156","frac34":"\xbe","frac35":"\u2157","frac38":"\u215C","frac45":"\u2158","frac56":"\u215A","frac58":"\u215D","frac78":"\u215E","frasl":"\u2044","frown":"\u2322","fscr":"\uD835\uDCBB","Fscr":"\u2131","gacute":"\u01F5","Gamma":"\u0393","gamma":"\u03B3","Gammad":"\u03DC","gammad":"\u03DD","gap":"\u2A86","Gbreve":"\u011E","gbreve":"\u011F","Gcedil":"\u0122","Gcirc":"\u011C","gcirc":"\u011D","Gcy":"\u0413","gcy":"\u0433","Gdot":"\u0120","gdot":"\u0121","ge":"\u2265","gE":"\u2267","gEl":"\u2A8C","gel":"\u22DB","geq":"\u2265","geqq":"\u2267","geqslant":"\u2A7E","gescc":"\u2AA9","ges":"\u2A7E","gesdot":"\u2A80","gesdoto":"\u2A82","gesdotol":"\u2A84","gesl":"\u22DB\uFE00","gesles":"\u2A94","Gfr":"\uD835\uDD0A","gfr":"\uD835\uDD24","gg":"\u226B","Gg":"\u22D9","ggg":"\u22D9","gimel":"\u2137","GJcy":"\u0403","gjcy":"\u0453","gla":"\u2AA5","gl":"\u2277","glE":"\u2A92","glj":"\u2AA4","gnap":"\u2A8A","gnapprox":"\u2A8A","gne":"\u2A88","gnE":"\u2269","gneq":"\u2A88","gneqq":"\u2269","gnsim":"\u22E7","Gopf":"\uD835\uDD3E","gopf":"\uD835\uDD58","grave":"`","GreaterEqual":"\u2265","GreaterEqualLess":"\u22DB","GreaterFullEqual":"\u2267","GreaterGreater":"\u2AA2","GreaterLess":"\u2277","GreaterSlantEqual":"\u2A7E","GreaterTilde":"\u2273","Gscr":"\uD835\uDCA2","gscr":"\u210A","gsim":"\u2273","gsime":"\u2A8E","gsiml":"\u2A90","gtcc":"\u2AA7","gtcir":"\u2A7A","gt":">","GT":">","Gt":"\u226B","gtdot":"\u22D7","gtlPar":"\u2995","gtquest":"\u2A7C","gtrapprox":"\u2A86","gtrarr":"\u2978","gtrdot":"\u22D7","gtreqless":"\u22DB","gtreqqless":"\u2A8C","gtrless":"\u2277","gtrsim":"\u2273","gvertneqq":"\u2269\uFE00","gvnE":"\u2269\uFE00","Hacek":"\u02C7","hairsp":"\u200A","half":"\xbd","hamilt":"\u210B","HARDcy":"\u042A","hardcy":"\u044A","harrcir":"\u2948","harr":"\u2194","hArr":"\u21D4","harrw":"\u21AD","Hat":"^","hbar":"\u210F","Hcirc":"\u0124","hcirc":"\u0125","hearts":"\u2665","heartsuit":"\u2665","hellip":"\u2026","hercon":"\u22B9","hfr":"\uD835\uDD25","Hfr":"\u210C","HilbertSpace":"\u210B","hksearow":"\u2925","hkswarow":"\u2926","hoarr":"\u21FF","homtht":"\u223B","hookleftarrow":"\u21A9","hookrightarrow":"\u21AA","hopf":"\uD835\uDD59","Hopf":"\u210D","horbar":"\u2015","HorizontalLine":"\u2500","hscr":"\uD835\uDCBD","Hscr":"\u210B","hslash":"\u210F","Hstrok":"\u0126","hstrok":"\u0127","HumpDownHump":"\u224E","HumpEqual":"\u224F","hybull":"\u2043","hyphen":"\u2010","Iacute":"\xcd","iacute":"\xed","ic":"\u2063","Icirc":"\xce","icirc":"\xee","Icy":"\u0418","icy":"\u0438","Idot":"\u0130","IEcy":"\u0415","iecy":"\u0435","iexcl":"\xa1","iff":"\u21D4","ifr":"\uD835\uDD26","Ifr":"\u2111","Igrave":"\xcc","igrave":"\xec","ii":"\u2148","iiiint":"\u2A0C","iiint":"\u222D","iinfin":"\u29DC","iiota":"\u2129","IJlig":"\u0132","ijlig":"\u0133","Imacr":"\u012A","imacr":"\u012B","image":"\u2111","ImaginaryI":"\u2148","imagline":"\u2110","imagpart":"\u2111","imath":"\u0131","Im":"\u2111","imof":"\u22B7","imped":"\u01B5","Implies":"\u21D2","incare":"\u2105","in":"\u2208","infin":"\u221E","infintie":"\u29DD","inodot":"\u0131","intcal":"\u22BA","int":"\u222B","Int":"\u222C","integers":"\u2124","Integral":"\u222B","intercal":"\u22BA","Intersection":"\u22C2","intlarhk":"\u2A17","intprod":"\u2A3C","InvisibleComma":"\u2063","InvisibleTimes":"\u2062","IOcy":"\u0401","iocy":"\u0451","Iogon":"\u012E","iogon":"\u012F","Iopf":"\uD835\uDD40","iopf":"\uD835\uDD5A","Iota":"\u0399","iota":"\u03B9","iprod":"\u2A3C","iquest":"\xbf","iscr":"\uD835\uDCBE","Iscr":"\u2110","isin":"\u2208","isindot":"\u22F5","isinE":"\u22F9","isins":"\u22F4","isinsv":"\u22F3","isinv":"\u2208","it":"\u2062","Itilde":"\u0128","itilde":"\u0129","Iukcy":"\u0406","iukcy":"\u0456","Iuml":"\xcf","iuml":"\xef","Jcirc":"\u0134","jcirc":"\u0135","Jcy":"\u0419","jcy":"\u0439","Jfr":"\uD835\uDD0D","jfr":"\uD835\uDD27","jmath":"\u0237","Jopf":"\uD835\uDD41","jopf":"\uD835\uDD5B","Jscr":"\uD835\uDCA5","jscr":"\uD835\uDCBF","Jsercy":"\u0408","jsercy":"\u0458","Jukcy":"\u0404","jukcy":"\u0454","Kappa":"\u039A","kappa":"\u03BA","kappav":"\u03F0","Kcedil":"\u0136","kcedil":"\u0137","Kcy":"\u041A","kcy":"\u043A","Kfr":"\uD835\uDD0E","kfr":"\uD835\uDD28","kgreen":"\u0138","KHcy":"\u0425","khcy":"\u0445","KJcy":"\u040C","kjcy":"\u045C","Kopf":"\uD835\uDD42","kopf":"\uD835\uDD5C","Kscr":"\uD835\uDCA6","kscr":"\uD835\uDCC0","lAarr":"\u21DA","Lacute":"\u0139","lacute":"\u013A","laemptyv":"\u29B4","lagran":"\u2112","Lambda":"\u039B","lambda":"\u03BB","lang":"\u27E8","Lang":"\u27EA","langd":"\u2991","langle":"\u27E8","lap":"\u2A85","Laplacetrf":"\u2112","laquo":"\xab","larrb":"\u21E4","larrbfs":"\u291F","larr":"\u2190","Larr":"\u219E","lArr":"\u21D0","larrfs":"\u291D","larrhk":"\u21A9","larrlp":"\u21AB","larrpl":"\u2939","larrsim":"\u2973","larrtl":"\u21A2","latail":"\u2919","lAtail":"\u291B","lat":"\u2AAB","late":"\u2AAD","lates":"\u2AAD\uFE00","lbarr":"\u290C","lBarr":"\u290E","lbbrk":"\u2772","lbrace":"{","lbrack":"[","lbrke":"\u298B","lbrksld":"\u298F","lbrkslu":"\u298D","Lcaron":"\u013D","lcaron":"\u013E","Lcedil":"\u013B","lcedil":"\u013C","lceil":"\u2308","lcub":"{","Lcy":"\u041B","lcy":"\u043B","ldca":"\u2936","ldquo":"\u201C","ldquor":"\u201E","ldrdhar":"\u2967","ldrushar":"\u294B","ldsh":"\u21B2","le":"\u2264","lE":"\u2266","LeftAngleBracket":"\u27E8","LeftArrowBar":"\u21E4","leftarrow":"\u2190","LeftArrow":"\u2190","Leftarrow":"\u21D0","LeftArrowRightArrow":"\u21C6","leftarrowtail":"\u21A2","LeftCeiling":"\u2308","LeftDoubleBracket":"\u27E6","LeftDownTeeVector":"\u2961","LeftDownVectorBar":"\u2959","LeftDownVector":"\u21C3","LeftFloor":"\u230A","leftharpoondown":"\u21BD","leftharpoonup":"\u21BC","leftleftarrows":"\u21C7","leftrightarrow":"\u2194","LeftRightArrow":"\u2194","Leftrightarrow":"\u21D4","leftrightarrows":"\u21C6","leftrightharpoons":"\u21CB","leftrightsquigarrow":"\u21AD","LeftRightVector":"\u294E","LeftTeeArrow":"\u21A4","LeftTee":"\u22A3","LeftTeeVector":"\u295A","leftthreetimes":"\u22CB","LeftTriangleBar":"\u29CF","LeftTriangle":"\u22B2","LeftTriangleEqual":"\u22B4","LeftUpDownVector":"\u2951","LeftUpTeeVector":"\u2960","LeftUpVectorBar":"\u2958","LeftUpVector":"\u21BF","LeftVectorBar":"\u2952","LeftVector":"\u21BC","lEg":"\u2A8B","leg":"\u22DA","leq":"\u2264","leqq":"\u2266","leqslant":"\u2A7D","lescc":"\u2AA8","les":"\u2A7D","lesdot":"\u2A7F","lesdoto":"\u2A81","lesdotor":"\u2A83","lesg":"\u22DA\uFE00","lesges":"\u2A93","lessapprox":"\u2A85","lessdot":"\u22D6","lesseqgtr":"\u22DA","lesseqqgtr":"\u2A8B","LessEqualGreater":"\u22DA","LessFullEqual":"\u2266","LessGreater":"\u2276","lessgtr":"\u2276","LessLess":"\u2AA1","lesssim":"\u2272","LessSlantEqual":"\u2A7D","LessTilde":"\u2272","lfisht":"\u297C","lfloor":"\u230A","Lfr":"\uD835\uDD0F","lfr":"\uD835\uDD29","lg":"\u2276","lgE":"\u2A91","lHar":"\u2962","lhard":"\u21BD","lharu":"\u21BC","lharul":"\u296A","lhblk":"\u2584","LJcy":"\u0409","ljcy":"\u0459","llarr":"\u21C7","ll":"\u226A","Ll":"\u22D8","llcorner":"\u231E","Lleftarrow":"\u21DA","llhard":"\u296B","lltri":"\u25FA","Lmidot":"\u013F","lmidot":"\u0140","lmoustache":"\u23B0","lmoust":"\u23B0","lnap":"\u2A89","lnapprox":"\u2A89","lne":"\u2A87","lnE":"\u2268","lneq":"\u2A87","lneqq":"\u2268","lnsim":"\u22E6","loang":"\u27EC","loarr":"\u21FD","lobrk":"\u27E6","longleftarrow":"\u27F5","LongLeftArrow":"\u27F5","Longleftarrow":"\u27F8","longleftrightarrow":"\u27F7","LongLeftRightArrow":"\u27F7","Longleftrightarrow":"\u27FA","longmapsto":"\u27FC","longrightarrow":"\u27F6","LongRightArrow":"\u27F6","Longrightarrow":"\u27F9","looparrowleft":"\u21AB","looparrowright":"\u21AC","lopar":"\u2985","Lopf":"\uD835\uDD43","lopf":"\uD835\uDD5D","loplus":"\u2A2D","lotimes":"\u2A34","lowast":"\u2217","lowbar":"_","LowerLeftArrow":"\u2199","LowerRightArrow":"\u2198","loz":"\u25CA","lozenge":"\u25CA","lozf":"\u29EB","lpar":"(","lparlt":"\u2993","lrarr":"\u21C6","lrcorner":"\u231F","lrhar":"\u21CB","lrhard":"\u296D","lrm":"\u200E","lrtri":"\u22BF","lsaquo":"\u2039","lscr":"\uD835\uDCC1","Lscr":"\u2112","lsh":"\u21B0","Lsh":"\u21B0","lsim":"\u2272","lsime":"\u2A8D","lsimg":"\u2A8F","lsqb":"[","lsquo":"\u2018","lsquor":"\u201A","Lstrok":"\u0141","lstrok":"\u0142","ltcc":"\u2AA6","ltcir":"\u2A79","lt":"<","LT":"<","Lt":"\u226A","ltdot":"\u22D6","lthree":"\u22CB","ltimes":"\u22C9","ltlarr":"\u2976","ltquest":"\u2A7B","ltri":"\u25C3","ltrie":"\u22B4","ltrif":"\u25C2","ltrPar":"\u2996","lurdshar":"\u294A","luruhar":"\u2966","lvertneqq":"\u2268\uFE00","lvnE":"\u2268\uFE00","macr":"\xaf","male":"\u2642","malt":"\u2720","maltese":"\u2720","Map":"\u2905","map":"\u21A6","mapsto":"\u21A6","mapstodown":"\u21A7","mapstoleft":"\u21A4","mapstoup":"\u21A5","marker":"\u25AE","mcomma":"\u2A29","Mcy":"\u041C","mcy":"\u043C","mdash":"\u2014","mDDot":"\u223A","measuredangle":"\u2221","MediumSpace":"\u205F","Mellintrf":"\u2133","Mfr":"\uD835\uDD10","mfr":"\uD835\uDD2A","mho":"\u2127","micro":"\xb5","midast":"*","midcir":"\u2AF0","mid":"\u2223","middot":"\xb7","minusb":"\u229F","minus":"\u2212","minusd":"\u2238","minusdu":"\u2A2A","MinusPlus":"\u2213","mlcp":"\u2ADB","mldr":"\u2026","mnplus":"\u2213","models":"\u22A7","Mopf":"\uD835\uDD44","mopf":"\uD835\uDD5E","mp":"\u2213","mscr":"\uD835\uDCC2","Mscr":"\u2133","mstpos":"\u223E","Mu":"\u039C","mu":"\u03BC","multimap":"\u22B8","mumap":"\u22B8","nabla":"\u2207","Nacute":"\u0143","nacute":"\u0144","nang":"\u2220\u20D2","nap":"\u2249","napE":"\u2A70\u0338","napid":"\u224B\u0338","napos":"\u0149","napprox":"\u2249","natural":"\u266E","naturals":"\u2115","natur":"\u266E","nbsp":"\xa0","nbump":"\u224E\u0338","nbumpe":"\u224F\u0338","ncap":"\u2A43","Ncaron":"\u0147","ncaron":"\u0148","Ncedil":"\u0145","ncedil":"\u0146","ncong":"\u2247","ncongdot":"\u2A6D\u0338","ncup":"\u2A42","Ncy":"\u041D","ncy":"\u043D","ndash":"\u2013","nearhk":"\u2924","nearr":"\u2197","neArr":"\u21D7","nearrow":"\u2197","ne":"\u2260","nedot":"\u2250\u0338","NegativeMediumSpace":"\u200B","NegativeThickSpace":"\u200B","NegativeThinSpace":"\u200B","NegativeVeryThinSpace":"\u200B","nequiv":"\u2262","nesear":"\u2928","nesim":"\u2242\u0338","NestedGreaterGreater":"\u226B","NestedLessLess":"\u226A","NewLine":"\\n","nexist":"\u2204","nexists":"\u2204","Nfr":"\uD835\uDD11","nfr":"\uD835\uDD2B","ngE":"\u2267\u0338","nge":"\u2271","ngeq":"\u2271","ngeqq":"\u2267\u0338","ngeqslant":"\u2A7E\u0338","nges":"\u2A7E\u0338","nGg":"\u22D9\u0338","ngsim":"\u2275","nGt":"\u226B\u20D2","ngt":"\u226F","ngtr":"\u226F","nGtv":"\u226B\u0338","nharr":"\u21AE","nhArr":"\u21CE","nhpar":"\u2AF2","ni":"\u220B","nis":"\u22FC","nisd":"\u22FA","niv":"\u220B","NJcy":"\u040A","njcy":"\u045A","nlarr":"\u219A","nlArr":"\u21CD","nldr":"\u2025","nlE":"\u2266\u0338","nle":"\u2270","nleftarrow":"\u219A","nLeftarrow":"\u21CD","nleftrightarrow":"\u21AE","nLeftrightarrow":"\u21CE","nleq":"\u2270","nleqq":"\u2266\u0338","nleqslant":"\u2A7D\u0338","nles":"\u2A7D\u0338","nless":"\u226E","nLl":"\u22D8\u0338","nlsim":"\u2274","nLt":"\u226A\u20D2","nlt":"\u226E","nltri":"\u22EA","nltrie":"\u22EC","nLtv":"\u226A\u0338","nmid":"\u2224","NoBreak":"\u2060","NonBreakingSpace":"\xa0","nopf":"\uD835\uDD5F","Nopf":"\u2115","Not":"\u2AEC","not":"\xac","NotCongruent":"\u2262","NotCupCap":"\u226D","NotDoubleVerticalBar":"\u2226","NotElement":"\u2209","NotEqual":"\u2260","NotEqualTilde":"\u2242\u0338","NotExists":"\u2204","NotGreater":"\u226F","NotGreaterEqual":"\u2271","NotGreaterFullEqual":"\u2267\u0338","NotGreaterGreater":"\u226B\u0338","NotGreaterLess":"\u2279","NotGreaterSlantEqual":"\u2A7E\u0338","NotGreaterTilde":"\u2275","NotHumpDownHump":"\u224E\u0338","NotHumpEqual":"\u224F\u0338","notin":"\u2209","notindot":"\u22F5\u0338","notinE":"\u22F9\u0338","notinva":"\u2209","notinvb":"\u22F7","notinvc":"\u22F6","NotLeftTriangleBar":"\u29CF\u0338","NotLeftTriangle":"\u22EA","NotLeftTriangleEqual":"\u22EC","NotLess":"\u226E","NotLessEqual":"\u2270","NotLessGreater":"\u2278","NotLessLess":"\u226A\u0338","NotLessSlantEqual":"\u2A7D\u0338","NotLessTilde":"\u2274","NotNestedGreaterGreater":"\u2AA2\u0338","NotNestedLessLess":"\u2AA1\u0338","notni":"\u220C","notniva":"\u220C","notnivb":"\u22FE","notnivc":"\u22FD","NotPrecedes":"\u2280","NotPrecedesEqual":"\u2AAF\u0338","NotPrecedesSlantEqual":"\u22E0","NotReverseElement":"\u220C","NotRightTriangleBar":"\u29D0\u0338","NotRightTriangle":"\u22EB","NotRightTriangleEqual":"\u22ED","NotSquareSubset":"\u228F\u0338","NotSquareSubsetEqual":"\u22E2","NotSquareSuperset":"\u2290\u0338","NotSquareSupersetEqual":"\u22E3","NotSubset":"\u2282\u20D2","NotSubsetEqual":"\u2288","NotSucceeds":"\u2281","NotSucceedsEqual":"\u2AB0\u0338","NotSucceedsSlantEqual":"\u22E1","NotSucceedsTilde":"\u227F\u0338","NotSuperset":"\u2283\u20D2","NotSupersetEqual":"\u2289","NotTilde":"\u2241","NotTildeEqual":"\u2244","NotTildeFullEqual":"\u2247","NotTildeTilde":"\u2249","NotVerticalBar":"\u2224","nparallel":"\u2226","npar":"\u2226","nparsl":"\u2AFD\u20E5","npart":"\u2202\u0338","npolint":"\u2A14","npr":"\u2280","nprcue":"\u22E0","nprec":"\u2280","npreceq":"\u2AAF\u0338","npre":"\u2AAF\u0338","nrarrc":"\u2933\u0338","nrarr":"\u219B","nrArr":"\u21CF","nrarrw":"\u219D\u0338","nrightarrow":"\u219B","nRightarrow":"\u21CF","nrtri":"\u22EB","nrtrie":"\u22ED","nsc":"\u2281","nsccue":"\u22E1","nsce":"\u2AB0\u0338","Nscr":"\uD835\uDCA9","nscr":"\uD835\uDCC3","nshortmid":"\u2224","nshortparallel":"\u2226","nsim":"\u2241","nsime":"\u2244","nsimeq":"\u2244","nsmid":"\u2224","nspar":"\u2226","nsqsube":"\u22E2","nsqsupe":"\u22E3","nsub":"\u2284","nsubE":"\u2AC5\u0338","nsube":"\u2288","nsubset":"\u2282\u20D2","nsubseteq":"\u2288","nsubseteqq":"\u2AC5\u0338","nsucc":"\u2281","nsucceq":"\u2AB0\u0338","nsup":"\u2285","nsupE":"\u2AC6\u0338","nsupe":"\u2289","nsupset":"\u2283\u20D2","nsupseteq":"\u2289","nsupseteqq":"\u2AC6\u0338","ntgl":"\u2279","Ntilde":"\xd1","ntilde":"\xf1","ntlg":"\u2278","ntriangleleft":"\u22EA","ntrianglelefteq":"\u22EC","ntriangleright":"\u22EB","ntrianglerighteq":"\u22ED","Nu":"\u039D","nu":"\u03BD","num":"#","numero":"\u2116","numsp":"\u2007","nvap":"\u224D\u20D2","nvdash":"\u22AC","nvDash":"\u22AD","nVdash":"\u22AE","nVDash":"\u22AF","nvge":"\u2265\u20D2","nvgt":">\u20D2","nvHarr":"\u2904","nvinfin":"\u29DE","nvlArr":"\u2902","nvle":"\u2264\u20D2","nvlt":"<\u20D2","nvltrie":"\u22B4\u20D2","nvrArr":"\u2903","nvrtrie":"\u22B5\u20D2","nvsim":"\u223C\u20D2","nwarhk":"\u2923","nwarr":"\u2196","nwArr":"\u21D6","nwarrow":"\u2196","nwnear":"\u2927","Oacute":"\xd3","oacute":"\xf3","oast":"\u229B","Ocirc":"\xd4","ocirc":"\xf4","ocir":"\u229A","Ocy":"\u041E","ocy":"\u043E","odash":"\u229D","Odblac":"\u0150","odblac":"\u0151","odiv":"\u2A38","odot":"\u2299","odsold":"\u29BC","OElig":"\u0152","oelig":"\u0153","ofcir":"\u29BF","Ofr":"\uD835\uDD12","ofr":"\uD835\uDD2C","ogon":"\u02DB","Ograve":"\xd2","ograve":"\xf2","ogt":"\u29C1","ohbar":"\u29B5","ohm":"\u03A9","oint":"\u222E","olarr":"\u21BA","olcir":"\u29BE","olcross":"\u29BB","oline":"\u203E","olt":"\u29C0","Omacr":"\u014C","omacr":"\u014D","Omega":"\u03A9","omega":"\u03C9","Omicron":"\u039F","omicron":"\u03BF","omid":"\u29B6","ominus":"\u2296","Oopf":"\uD835\uDD46","oopf":"\uD835\uDD60","opar":"\u29B7","OpenCurlyDoubleQuote":"\u201C","OpenCurlyQuote":"\u2018","operp":"\u29B9","oplus":"\u2295","orarr":"\u21BB","Or":"\u2A54","or":"\u2228","ord":"\u2A5D","order":"\u2134","orderof":"\u2134","ordf":"\xaa","ordm":"\xba","origof":"\u22B6","oror":"\u2A56","orslope":"\u2A57","orv":"\u2A5B","oS":"\u24C8","Oscr":"\uD835\uDCAA","oscr":"\u2134","Oslash":"\xd8","oslash":"\xf8","osol":"\u2298","Otilde":"\xd5","otilde":"\xf5","otimesas":"\u2A36","Otimes":"\u2A37","otimes":"\u2297","Ouml":"\xd6","ouml":"\xf6","ovbar":"\u233D","OverBar":"\u203E","OverBrace":"\u23DE","OverBracket":"\u23B4","OverParenthesis":"\u23DC","para":"\xb6","parallel":"\u2225","par":"\u2225","parsim":"\u2AF3","parsl":"\u2AFD","part":"\u2202","PartialD":"\u2202","Pcy":"\u041F","pcy":"\u043F","percnt":"%","period":".","permil":"\u2030","perp":"\u22A5","pertenk":"\u2031","Pfr":"\uD835\uDD13","pfr":"\uD835\uDD2D","Phi":"\u03A6","phi":"\u03C6","phiv":"\u03D5","phmmat":"\u2133","phone":"\u260E","Pi":"\u03A0","pi":"\u03C0","pitchfork":"\u22D4","piv":"\u03D6","planck":"\u210F","planckh":"\u210E","plankv":"\u210F","plusacir":"\u2A23","plusb":"\u229E","pluscir":"\u2A22","plus":"+","plusdo":"\u2214","plusdu":"\u2A25","pluse":"\u2A72","PlusMinus":"\xb1","plusmn":"\xb1","plussim":"\u2A26","plustwo":"\u2A27","pm":"\xb1","Poincareplane":"\u210C","pointint":"\u2A15","popf":"\uD835\uDD61","Popf":"\u2119","pound":"\xa3","prap":"\u2AB7","Pr":"\u2ABB","pr":"\u227A","prcue":"\u227C","precapprox":"\u2AB7","prec":"\u227A","preccurlyeq":"\u227C","Precedes":"\u227A","PrecedesEqual":"\u2AAF","PrecedesSlantEqual":"\u227C","PrecedesTilde":"\u227E","preceq":"\u2AAF","precnapprox":"\u2AB9","precneqq":"\u2AB5","precnsim":"\u22E8","pre":"\u2AAF","prE":"\u2AB3","precsim":"\u227E","prime":"\u2032","Prime":"\u2033","primes":"\u2119","prnap":"\u2AB9","prnE":"\u2AB5","prnsim":"\u22E8","prod":"\u220F","Product":"\u220F","profalar":"\u232E","profline":"\u2312","profsurf":"\u2313","prop":"\u221D","Proportional":"\u221D","Proportion":"\u2237","propto":"\u221D","prsim":"\u227E","prurel":"\u22B0","Pscr":"\uD835\uDCAB","pscr":"\uD835\uDCC5","Psi":"\u03A8","psi":"\u03C8","puncsp":"\u2008","Qfr":"\uD835\uDD14","qfr":"\uD835\uDD2E","qint":"\u2A0C","qopf":"\uD835\uDD62","Qopf":"\u211A","qprime":"\u2057","Qscr":"\uD835\uDCAC","qscr":"\uD835\uDCC6","quaternions":"\u210D","quatint":"\u2A16","quest":"?","questeq":"\u225F","quot":"\\"","QUOT":"\\"","rAarr":"\u21DB","race":"\u223D\u0331","Racute":"\u0154","racute":"\u0155","radic":"\u221A","raemptyv":"\u29B3","rang":"\u27E9","Rang":"\u27EB","rangd":"\u2992","range":"\u29A5","rangle":"\u27E9","raquo":"\xbb","rarrap":"\u2975","rarrb":"\u21E5","rarrbfs":"\u2920","rarrc":"\u2933","rarr":"\u2192","Rarr":"\u21A0","rArr":"\u21D2","rarrfs":"\u291E","rarrhk":"\u21AA","rarrlp":"\u21AC","rarrpl":"\u2945","rarrsim":"\u2974","Rarrtl":"\u2916","rarrtl":"\u21A3","rarrw":"\u219D","ratail":"\u291A","rAtail":"\u291C","ratio":"\u2236","rationals":"\u211A","rbarr":"\u290D","rBarr":"\u290F","RBarr":"\u2910","rbbrk":"\u2773","rbrace":"}","rbrack":"]","rbrke":"\u298C","rbrksld":"\u298E","rbrkslu":"\u2990","Rcaron":"\u0158","rcaron":"\u0159","Rcedil":"\u0156","rcedil":"\u0157","rceil":"\u2309","rcub":"}","Rcy":"\u0420","rcy":"\u0440","rdca":"\u2937","rdldhar":"\u2969","rdquo":"\u201D","rdquor":"\u201D","rdsh":"\u21B3","real":"\u211C","realine":"\u211B","realpart":"\u211C","reals":"\u211D","Re":"\u211C","rect":"\u25AD","reg":"\xae","REG":"\xae","ReverseElement":"\u220B","ReverseEquilibrium":"\u21CB","ReverseUpEquilibrium":"\u296F","rfisht":"\u297D","rfloor":"\u230B","rfr":"\uD835\uDD2F","Rfr":"\u211C","rHar":"\u2964","rhard":"\u21C1","rharu":"\u21C0","rharul":"\u296C","Rho":"\u03A1","rho":"\u03C1","rhov":"\u03F1","RightAngleBracket":"\u27E9","RightArrowBar":"\u21E5","rightarrow":"\u2192","RightArrow":"\u2192","Rightarrow":"\u21D2","RightArrowLeftArrow":"\u21C4","rightarrowtail":"\u21A3","RightCeiling":"\u2309","RightDoubleBracket":"\u27E7","RightDownTeeVector":"\u295D","RightDownVectorBar":"\u2955","RightDownVector":"\u21C2","RightFloor":"\u230B","rightharpoondown":"\u21C1","rightharpoonup":"\u21C0","rightleftarrows":"\u21C4","rightleftharpoons":"\u21CC","rightrightarrows":"\u21C9","rightsquigarrow":"\u219D","RightTeeArrow":"\u21A6","RightTee":"\u22A2","RightTeeVector":"\u295B","rightthreetimes":"\u22CC","RightTriangleBar":"\u29D0","RightTriangle":"\u22B3","RightTriangleEqual":"\u22B5","RightUpDownVector":"\u294F","RightUpTeeVector":"\u295C","RightUpVectorBar":"\u2954","RightUpVector":"\u21BE","RightVectorBar":"\u2953","RightVector":"\u21C0","ring":"\u02DA","risingdotseq":"\u2253","rlarr":"\u21C4","rlhar":"\u21CC","rlm":"\u200F","rmoustache":"\u23B1","rmoust":"\u23B1","rnmid":"\u2AEE","roang":"\u27ED","roarr":"\u21FE","robrk":"\u27E7","ropar":"\u2986","ropf":"\uD835\uDD63","Ropf":"\u211D","roplus":"\u2A2E","rotimes":"\u2A35","RoundImplies":"\u2970","rpar":")","rpargt":"\u2994","rppolint":"\u2A12","rrarr":"\u21C9","Rrightarrow":"\u21DB","rsaquo":"\u203A","rscr":"\uD835\uDCC7","Rscr":"\u211B","rsh":"\u21B1","Rsh":"\u21B1","rsqb":"]","rsquo":"\u2019","rsquor":"\u2019","rthree":"\u22CC","rtimes":"\u22CA","rtri":"\u25B9","rtrie":"\u22B5","rtrif":"\u25B8","rtriltri":"\u29CE","RuleDelayed":"\u29F4","ruluhar":"\u2968","rx":"\u211E","Sacute":"\u015A","sacute":"\u015B","sbquo":"\u201A","scap":"\u2AB8","Scaron":"\u0160","scaron":"\u0161","Sc":"\u2ABC","sc":"\u227B","sccue":"\u227D","sce":"\u2AB0","scE":"\u2AB4","Scedil":"\u015E","scedil":"\u015F","Scirc":"\u015C","scirc":"\u015D","scnap":"\u2ABA","scnE":"\u2AB6","scnsim":"\u22E9","scpolint":"\u2A13","scsim":"\u227F","Scy":"\u0421","scy":"\u0441","sdotb":"\u22A1","sdot":"\u22C5","sdote":"\u2A66","searhk":"\u2925","searr":"\u2198","seArr":"\u21D8","searrow":"\u2198","sect":"\xa7","semi":";","seswar":"\u2929","setminus":"\u2216","setmn":"\u2216","sext":"\u2736","Sfr":"\uD835\uDD16","sfr":"\uD835\uDD30","sfrown":"\u2322","sharp":"\u266F","SHCHcy":"\u0429","shchcy":"\u0449","SHcy":"\u0428","shcy":"\u0448","ShortDownArrow":"\u2193","ShortLeftArrow":"\u2190","shortmid":"\u2223","shortparallel":"\u2225","ShortRightArrow":"\u2192","ShortUpArrow":"\u2191","shy":"\xad","Sigma":"\u03A3","sigma":"\u03C3","sigmaf":"\u03C2","sigmav":"\u03C2","sim":"\u223C","simdot":"\u2A6A","sime":"\u2243","simeq":"\u2243","simg":"\u2A9E","simgE":"\u2AA0","siml":"\u2A9D","simlE":"\u2A9F","simne":"\u2246","simplus":"\u2A24","simrarr":"\u2972","slarr":"\u2190","SmallCircle":"\u2218","smallsetminus":"\u2216","smashp":"\u2A33","smeparsl":"\u29E4","smid":"\u2223","smile":"\u2323","smt":"\u2AAA","smte":"\u2AAC","smtes":"\u2AAC\uFE00","SOFTcy":"\u042C","softcy":"\u044C","solbar":"\u233F","solb":"\u29C4","sol":"/","Sopf":"\uD835\uDD4A","sopf":"\uD835\uDD64","spades":"\u2660","spadesuit":"\u2660","spar":"\u2225","sqcap":"\u2293","sqcaps":"\u2293\uFE00","sqcup":"\u2294","sqcups":"\u2294\uFE00","Sqrt":"\u221A","sqsub":"\u228F","sqsube":"\u2291","sqsubset":"\u228F","sqsubseteq":"\u2291","sqsup":"\u2290","sqsupe":"\u2292","sqsupset":"\u2290","sqsupseteq":"\u2292","square":"\u25A1","Square":"\u25A1","SquareIntersection":"\u2293","SquareSubset":"\u228F","SquareSubsetEqual":"\u2291","SquareSuperset":"\u2290","SquareSupersetEqual":"\u2292","SquareUnion":"\u2294","squarf":"\u25AA","squ":"\u25A1","squf":"\u25AA","srarr":"\u2192","Sscr":"\uD835\uDCAE","sscr":"\uD835\uDCC8","ssetmn":"\u2216","ssmile":"\u2323","sstarf":"\u22C6","Star":"\u22C6","star":"\u2606","starf":"\u2605","straightepsilon":"\u03F5","straightphi":"\u03D5","strns":"\xaf","sub":"\u2282","Sub":"\u22D0","subdot":"\u2ABD","subE":"\u2AC5","sube":"\u2286","subedot":"\u2AC3","submult":"\u2AC1","subnE":"\u2ACB","subne":"\u228A","subplus":"\u2ABF","subrarr":"\u2979","subset":"\u2282","Subset":"\u22D0","subseteq":"\u2286","subseteqq":"\u2AC5","SubsetEqual":"\u2286","subsetneq":"\u228A","subsetneqq":"\u2ACB","subsim":"\u2AC7","subsub":"\u2AD5","subsup":"\u2AD3","succapprox":"\u2AB8","succ":"\u227B","succcurlyeq":"\u227D","Succeeds":"\u227B","SucceedsEqual":"\u2AB0","SucceedsSlantEqual":"\u227D","SucceedsTilde":"\u227F","succeq":"\u2AB0","succnapprox":"\u2ABA","succneqq":"\u2AB6","succnsim":"\u22E9","succsim":"\u227F","SuchThat":"\u220B","sum":"\u2211","Sum":"\u2211","sung":"\u266A","sup1":"\xb9","sup2":"\xb2","sup3":"\xb3","sup":"\u2283","Sup":"\u22D1","supdot":"\u2ABE","supdsub":"\u2AD8","supE":"\u2AC6","supe":"\u2287","supedot":"\u2AC4","Superset":"\u2283","SupersetEqual":"\u2287","suphsol":"\u27C9","suphsub":"\u2AD7","suplarr":"\u297B","supmult":"\u2AC2","supnE":"\u2ACC","supne":"\u228B","supplus":"\u2AC0","supset":"\u2283","Supset":"\u22D1","supseteq":"\u2287","supseteqq":"\u2AC6","supsetneq":"\u228B","supsetneqq":"\u2ACC","supsim":"\u2AC8","supsub":"\u2AD4","supsup":"\u2AD6","swarhk":"\u2926","swarr":"\u2199","swArr":"\u21D9","swarrow":"\u2199","swnwar":"\u292A","szlig":"\xdf","Tab":"\\t","target":"\u2316","Tau":"\u03A4","tau":"\u03C4","tbrk":"\u23B4","Tcaron":"\u0164","tcaron":"\u0165","Tcedil":"\u0162","tcedil":"\u0163","Tcy":"\u0422","tcy":"\u0442","tdot":"\u20DB","telrec":"\u2315","Tfr":"\uD835\uDD17","tfr":"\uD835\uDD31","there4":"\u2234","therefore":"\u2234","Therefore":"\u2234","Theta":"\u0398","theta":"\u03B8","thetasym":"\u03D1","thetav":"\u03D1","thickapprox":"\u2248","thicksim":"\u223C","ThickSpace":"\u205F\u200A","ThinSpace":"\u2009","thinsp":"\u2009","thkap":"\u2248","thksim":"\u223C","THORN":"\xde","thorn":"\xfe","tilde":"\u02DC","Tilde":"\u223C","TildeEqual":"\u2243","TildeFullEqual":"\u2245","TildeTilde":"\u2248","timesbar":"\u2A31","timesb":"\u22A0","times":"\xd7","timesd":"\u2A30","tint":"\u222D","toea":"\u2928","topbot":"\u2336","topcir":"\u2AF1","top":"\u22A4","Topf":"\uD835\uDD4B","topf":"\uD835\uDD65","topfork":"\u2ADA","tosa":"\u2929","tprime":"\u2034","trade":"\u2122","TRADE":"\u2122","triangle":"\u25B5","triangledown":"\u25BF","triangleleft":"\u25C3","trianglelefteq":"\u22B4","triangleq":"\u225C","triangleright":"\u25B9","trianglerighteq":"\u22B5","tridot":"\u25EC","trie":"\u225C","triminus":"\u2A3A","TripleDot":"\u20DB","triplus":"\u2A39","trisb":"\u29CD","tritime":"\u2A3B","trpezium":"\u23E2","Tscr":"\uD835\uDCAF","tscr":"\uD835\uDCC9","TScy":"\u0426","tscy":"\u0446","TSHcy":"\u040B","tshcy":"\u045B","Tstrok":"\u0166","tstrok":"\u0167","twixt":"\u226C","twoheadleftarrow":"\u219E","twoheadrightarrow":"\u21A0","Uacute":"\xda","uacute":"\xfa","uarr":"\u2191","Uarr":"\u219F","uArr":"\u21D1","Uarrocir":"\u2949","Ubrcy":"\u040E","ubrcy":"\u045E","Ubreve":"\u016C","ubreve":"\u016D","Ucirc":"\xdb","ucirc":"\xfb","Ucy":"\u0423","ucy":"\u0443","udarr":"\u21C5","Udblac":"\u0170","udblac":"\u0171","udhar":"\u296E","ufisht":"\u297E","Ufr":"\uD835\uDD18","ufr":"\uD835\uDD32","Ugrave":"\xd9","ugrave":"\xf9","uHar":"\u2963","uharl":"\u21BF","uharr":"\u21BE","uhblk":"\u2580","ulcorn":"\u231C","ulcorner":"\u231C","ulcrop":"\u230F","ultri":"\u25F8","Umacr":"\u016A","umacr":"\u016B","uml":"\xa8","UnderBar":"_","UnderBrace":"\u23DF","UnderBracket":"\u23B5","UnderParenthesis":"\u23DD","Union":"\u22C3","UnionPlus":"\u228E","Uogon":"\u0172","uogon":"\u0173","Uopf":"\uD835\uDD4C","uopf":"\uD835\uDD66","UpArrowBar":"\u2912","uparrow":"\u2191","UpArrow":"\u2191","Uparrow":"\u21D1","UpArrowDownArrow":"\u21C5","updownarrow":"\u2195","UpDownArrow":"\u2195","Updownarrow":"\u21D5","UpEquilibrium":"\u296E","upharpoonleft":"\u21BF","upharpoonright":"\u21BE","uplus":"\u228E","UpperLeftArrow":"\u2196","UpperRightArrow":"\u2197","upsi":"\u03C5","Upsi":"\u03D2","upsih":"\u03D2","Upsilon":"\u03A5","upsilon":"\u03C5","UpTeeArrow":"\u21A5","UpTee":"\u22A5","upuparrows":"\u21C8","urcorn":"\u231D","urcorner":"\u231D","urcrop":"\u230E","Uring":"\u016E","uring":"\u016F","urtri":"\u25F9","Uscr":"\uD835\uDCB0","uscr":"\uD835\uDCCA","utdot":"\u22F0","Utilde":"\u0168","utilde":"\u0169","utri":"\u25B5","utrif":"\u25B4","uuarr":"\u21C8","Uuml":"\xdc","uuml":"\xfc","uwangle":"\u29A7","vangrt":"\u299C","varepsilon":"\u03F5","varkappa":"\u03F0","varnothing":"\u2205","varphi":"\u03D5","varpi":"\u03D6","varpropto":"\u221D","varr":"\u2195","vArr":"\u21D5","varrho":"\u03F1","varsigma":"\u03C2","varsubsetneq":"\u228A\uFE00","varsubsetneqq":"\u2ACB\uFE00","varsupsetneq":"\u228B\uFE00","varsupsetneqq":"\u2ACC\uFE00","vartheta":"\u03D1","vartriangleleft":"\u22B2","vartriangleright":"\u22B3","vBar":"\u2AE8","Vbar":"\u2AEB","vBarv":"\u2AE9","Vcy":"\u0412","vcy":"\u0432","vdash":"\u22A2","vDash":"\u22A8","Vdash":"\u22A9","VDash":"\u22AB","Vdashl":"\u2AE6","veebar":"\u22BB","vee":"\u2228","Vee":"\u22C1","veeeq":"\u225A","vellip":"\u22EE","verbar":"|","Verbar":"\u2016","vert":"|","Vert":"\u2016","VerticalBar":"\u2223","VerticalLine":"|","VerticalSeparator":"\u2758","VerticalTilde":"\u2240","VeryThinSpace":"\u200A","Vfr":"\uD835\uDD19","vfr":"\uD835\uDD33","vltri":"\u22B2","vnsub":"\u2282\u20D2","vnsup":"\u2283\u20D2","Vopf":"\uD835\uDD4D","vopf":"\uD835\uDD67","vprop":"\u221D","vrtri":"\u22B3","Vscr":"\uD835\uDCB1","vscr":"\uD835\uDCCB","vsubnE":"\u2ACB\uFE00","vsubne":"\u228A\uFE00","vsupnE":"\u2ACC\uFE00","vsupne":"\u228B\uFE00","Vvdash":"\u22AA","vzigzag":"\u299A","Wcirc":"\u0174","wcirc":"\u0175","wedbar":"\u2A5F","wedge":"\u2227","Wedge":"\u22C0","wedgeq":"\u2259","weierp":"\u2118","Wfr":"\uD835\uDD1A","wfr":"\uD835\uDD34","Wopf":"\uD835\uDD4E","wopf":"\uD835\uDD68","wp":"\u2118","wr":"\u2240","wreath":"\u2240","Wscr":"\uD835\uDCB2","wscr":"\uD835\uDCCC","xcap":"\u22C2","xcirc":"\u25EF","xcup":"\u22C3","xdtri":"\u25BD","Xfr":"\uD835\uDD1B","xfr":"\uD835\uDD35","xharr":"\u27F7","xhArr":"\u27FA","Xi":"\u039E","xi":"\u03BE","xlarr":"\u27F5","xlArr":"\u27F8","xmap":"\u27FC","xnis":"\u22FB","xodot":"\u2A00","Xopf":"\uD835\uDD4F","xopf":"\uD835\uDD69","xoplus":"\u2A01","xotime":"\u2A02","xrarr":"\u27F6","xrArr":"\u27F9","Xscr":"\uD835\uDCB3","xscr":"\uD835\uDCCD","xsqcup":"\u2A06","xuplus":"\u2A04","xutri":"\u25B3","xvee":"\u22C1","xwedge":"\u22C0","Yacute":"\xdd","yacute":"\xfd","YAcy":"\u042F","yacy":"\u044F","Ycirc":"\u0176","ycirc":"\u0177","Ycy":"\u042B","ycy":"\u044B","yen":"\xa5","Yfr":"\uD835\uDD1C","yfr":"\uD835\uDD36","YIcy":"\u0407","yicy":"\u0457","Yopf":"\uD835\uDD50","yopf":"\uD835\uDD6A","Yscr":"\uD835\uDCB4","yscr":"\uD835\uDCCE","YUcy":"\u042E","yucy":"\u044E","yuml":"\xff","Yuml":"\u0178","Zacute":"\u0179","zacute":"\u017A","Zcaron":"\u017D","zcaron":"\u017E","Zcy":"\u0417","zcy":"\u0437","Zdot":"\u017B","zdot":"\u017C","zeetrf":"\u2128","ZeroWidthSpace":"\u200B","Zeta":"\u0396","zeta":"\u03B6","zfr":"\uD835\uDD37","Zfr":"\u2128","ZHcy":"\u0416","zhcy":"\u0436","zigrarr":"\u21DD","zopf":"\uD835\uDD6B","Zopf":"\u2124","Zscr":"\uD835\uDCB5","zscr":"\uD835\uDCCF","zwj":"\u200D","zwnj":"\u200C"}');

});

parcelRegister("kYaO1", function(module, exports) {
$parcel$export(module.exports, "encode", () => $f441cb06ef4295f8$export$c564cdbbe6da493, (v) => $f441cb06ef4295f8$export$c564cdbbe6da493 = v);
$parcel$export(module.exports, "decode", () => $f441cb06ef4295f8$export$2f872c0f2117be69, (v) => $f441cb06ef4295f8$export$2f872c0f2117be69 = v);
$parcel$export(module.exports, "format", () => $f441cb06ef4295f8$export$d9468344d3651243, (v) => $f441cb06ef4295f8$export$d9468344d3651243 = v);
$parcel$export(module.exports, "parse", () => $f441cb06ef4295f8$export$98e6a39c04603d36, (v) => $f441cb06ef4295f8$export$98e6a39c04603d36 = v);
var $f441cb06ef4295f8$export$c564cdbbe6da493;
var $f441cb06ef4295f8$export$2f872c0f2117be69;
var $f441cb06ef4295f8$export$d9468344d3651243;
var $f441cb06ef4295f8$export$98e6a39c04603d36;
'use strict';

$f441cb06ef4295f8$export$c564cdbbe6da493 = (parcelRequire("g8pux"));

$f441cb06ef4295f8$export$2f872c0f2117be69 = (parcelRequire("5UTI8"));

$f441cb06ef4295f8$export$d9468344d3651243 = (parcelRequire("aouNV"));

$f441cb06ef4295f8$export$98e6a39c04603d36 = (parcelRequire("23Ep7"));

});

parcelRegister("g8pux", function(module, exports) {
'use strict';
var $030804d1b3b5c167$var$encodeCache = {};
// Create a lookup array where anything but characters in `chars` string
// and alphanumeric chars is percent-encoded.
//
function $030804d1b3b5c167$var$getEncodeCache(exclude) {
    var i, ch, cache = $030804d1b3b5c167$var$encodeCache[exclude];
    if (cache) return cache;
    cache = $030804d1b3b5c167$var$encodeCache[exclude] = [];
    for(i = 0; i < 128; i++){
        ch = String.fromCharCode(i);
        if (/^[0-9a-z]$/i.test(ch)) // always allow unencoded alphanumeric characters
        cache.push(ch);
        else cache.push('%' + ('0' + i.toString(16).toUpperCase()).slice(-2));
    }
    for(i = 0; i < exclude.length; i++)cache[exclude.charCodeAt(i)] = exclude[i];
    return cache;
}
// Encode unsafe characters with percent-encoding, skipping already
// encoded sequences.
//
//  - string       - string to encode
//  - exclude      - list of characters to ignore (in addition to a-zA-Z0-9)
//  - keepEscaped  - don't encode '%' in a correct escape sequence (default: true)
//
function $030804d1b3b5c167$var$encode(string, exclude, keepEscaped) {
    var i, l, code, nextCode, cache, result = '';
    if (typeof exclude !== 'string') {
        // encode(string, keepEscaped)
        keepEscaped = exclude;
        exclude = $030804d1b3b5c167$var$encode.defaultChars;
    }
    if (typeof keepEscaped === 'undefined') keepEscaped = true;
    cache = $030804d1b3b5c167$var$getEncodeCache(exclude);
    for(i = 0, l = string.length; i < l; i++){
        code = string.charCodeAt(i);
        if (keepEscaped && code === 0x25 /* % */  && i + 2 < l) {
            if (/^[0-9a-f]{2}$/i.test(string.slice(i + 1, i + 3))) {
                result += string.slice(i, i + 3);
                i += 2;
                continue;
            }
        }
        if (code < 128) {
            result += cache[code];
            continue;
        }
        if (code >= 0xD800 && code <= 0xDFFF) {
            if (code >= 0xD800 && code <= 0xDBFF && i + 1 < l) {
                nextCode = string.charCodeAt(i + 1);
                if (nextCode >= 0xDC00 && nextCode <= 0xDFFF) {
                    result += encodeURIComponent(string[i] + string[i + 1]);
                    i++;
                    continue;
                }
            }
            result += '%EF%BF%BD';
            continue;
        }
        result += encodeURIComponent(string[i]);
    }
    return result;
}
$030804d1b3b5c167$var$encode.defaultChars = ";/?:@&=+$,-_.!~*'()#";
$030804d1b3b5c167$var$encode.componentChars = "-_.!~*'()";
module.exports = $030804d1b3b5c167$var$encode;

});

parcelRegister("5UTI8", function(module, exports) {
'use strict';
/* eslint-disable no-bitwise */ var $44ed65b596ebc5d8$var$decodeCache = {};
function $44ed65b596ebc5d8$var$getDecodeCache(exclude) {
    var i, ch, cache = $44ed65b596ebc5d8$var$decodeCache[exclude];
    if (cache) return cache;
    cache = $44ed65b596ebc5d8$var$decodeCache[exclude] = [];
    for(i = 0; i < 128; i++){
        ch = String.fromCharCode(i);
        cache.push(ch);
    }
    for(i = 0; i < exclude.length; i++){
        ch = exclude.charCodeAt(i);
        cache[ch] = '%' + ('0' + ch.toString(16).toUpperCase()).slice(-2);
    }
    return cache;
}
// Decode percent-encoded string.
//
function $44ed65b596ebc5d8$var$decode(string, exclude) {
    var cache;
    if (typeof exclude !== 'string') exclude = $44ed65b596ebc5d8$var$decode.defaultChars;
    cache = $44ed65b596ebc5d8$var$getDecodeCache(exclude);
    return string.replace(/(%[a-f0-9]{2})+/gi, function(seq) {
        var i, l, b1, b2, b3, b4, chr, result = '';
        for(i = 0, l = seq.length; i < l; i += 3){
            b1 = parseInt(seq.slice(i + 1, i + 3), 16);
            if (b1 < 0x80) {
                result += cache[b1];
                continue;
            }
            if ((b1 & 0xE0) === 0xC0 && i + 3 < l) {
                // 110xxxxx 10xxxxxx
                b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                if ((b2 & 0xC0) === 0x80) {
                    chr = b1 << 6 & 0x7C0 | b2 & 0x3F;
                    if (chr < 0x80) result += '\ufffd\ufffd';
                    else result += String.fromCharCode(chr);
                    i += 3;
                    continue;
                }
            }
            if ((b1 & 0xF0) === 0xE0 && i + 6 < l) {
                // 1110xxxx 10xxxxxx 10xxxxxx
                b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                b3 = parseInt(seq.slice(i + 7, i + 9), 16);
                if ((b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80) {
                    chr = b1 << 12 & 0xF000 | b2 << 6 & 0xFC0 | b3 & 0x3F;
                    if (chr < 0x800 || chr >= 0xD800 && chr <= 0xDFFF) result += '\ufffd\ufffd\ufffd';
                    else result += String.fromCharCode(chr);
                    i += 6;
                    continue;
                }
            }
            if ((b1 & 0xF8) === 0xF0 && i + 9 < l) {
                // 111110xx 10xxxxxx 10xxxxxx 10xxxxxx
                b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                b3 = parseInt(seq.slice(i + 7, i + 9), 16);
                b4 = parseInt(seq.slice(i + 10, i + 12), 16);
                if ((b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80 && (b4 & 0xC0) === 0x80) {
                    chr = b1 << 18 & 0x1C0000 | b2 << 12 & 0x3F000 | b3 << 6 & 0xFC0 | b4 & 0x3F;
                    if (chr < 0x10000 || chr > 0x10FFFF) result += '\ufffd\ufffd\ufffd\ufffd';
                    else {
                        chr -= 0x10000;
                        result += String.fromCharCode(0xD800 + (chr >> 10), 0xDC00 + (chr & 0x3FF));
                    }
                    i += 9;
                    continue;
                }
            }
            result += '\ufffd';
        }
        return result;
    });
}
$44ed65b596ebc5d8$var$decode.defaultChars = ';/?:@&=+$,#';
$44ed65b596ebc5d8$var$decode.componentChars = '';
module.exports = $44ed65b596ebc5d8$var$decode;

});

parcelRegister("aouNV", function(module, exports) {
'use strict';
module.exports = function format(url) {
    var result = '';
    result += url.protocol || '';
    result += url.slashes ? '//' : '';
    result += url.auth ? url.auth + '@' : '';
    if (url.hostname && url.hostname.indexOf(':') !== -1) // ipv6 address
    result += '[' + url.hostname + ']';
    else result += url.hostname || '';
    result += url.port ? ':' + url.port : '';
    result += url.pathname || '';
    result += url.search || '';
    result += url.hash || '';
    return result;
};

});

parcelRegister("23Ep7", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
//
// Changes from joyent/node:
//
// 1. No leading slash in paths,
//    e.g. in `url.parse('http://foo?bar')` pathname is ``, not `/`
//
// 2. Backslashes are not replaced with slashes,
//    so `http:\\example.org\` is treated like a relative path
//
// 3. Trailing colon is treated like a part of the path,
//    i.e. in `http://example.org:foo` pathname is `:foo`
//
// 4. Nothing is URL-encoded in the resulting object,
//    (in joyent/node some chars in auth and paths are encoded)
//
// 5. `url.parse()` does not have `parseQueryString` argument
//
// 6. Removed extraneous result properties: `host`, `path`, `query`, etc.,
//    which can be constructed using other parts of the url.
//
function $17fb3400fe673da8$var$Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.pathname = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
// define these here so at least they only have to be
// compiled once on the first module load.
var $17fb3400fe673da8$var$protocolPattern = /^([a-z0-9.+-]+:)/i, $17fb3400fe673da8$var$portPattern = /:[0-9]*$/, // Special case for a simple path URL
$17fb3400fe673da8$var$simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/, // RFC 2396: characters reserved for delimiting URLs.
// We actually just auto-escape these.
$17fb3400fe673da8$var$delims = [
    '<',
    '>',
    '"',
    '`',
    ' ',
    '\r',
    '\n',
    '\t'
], // RFC 2396: characters not allowed for various reasons.
$17fb3400fe673da8$var$unwise = [
    '{',
    '}',
    '|',
    '\\',
    '^',
    '`'
].concat($17fb3400fe673da8$var$delims), // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
$17fb3400fe673da8$var$autoEscape = [
    '\''
].concat($17fb3400fe673da8$var$unwise), // Characters that are never ever allowed in a hostname.
// Note that any invalid chars are also handled, but these
// are the ones that are *expected* to be seen, so we fast-path
// them.
$17fb3400fe673da8$var$nonHostChars = [
    '%',
    '/',
    '?',
    ';',
    '#'
].concat($17fb3400fe673da8$var$autoEscape), $17fb3400fe673da8$var$hostEndingChars = [
    '/',
    '?',
    '#'
], $17fb3400fe673da8$var$hostnameMaxLen = 255, $17fb3400fe673da8$var$hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/, $17fb3400fe673da8$var$hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, // protocols that can allow "unsafe" and "unwise" chars.
/* eslint-disable no-script-url */ // protocols that never have a hostname.
$17fb3400fe673da8$var$hostlessProtocol = {
    'javascript': true,
    'javascript:': true
}, // protocols that always contain a // bit.
$17fb3400fe673da8$var$slashedProtocol = {
    'http': true,
    'https': true,
    'ftp': true,
    'gopher': true,
    'file': true,
    'http:': true,
    'https:': true,
    'ftp:': true,
    'gopher:': true,
    'file:': true
};
/* eslint-enable no-script-url */ function $17fb3400fe673da8$var$urlParse(url, slashesDenoteHost) {
    if (url && url instanceof $17fb3400fe673da8$var$Url) return url;
    var u = new $17fb3400fe673da8$var$Url();
    u.parse(url, slashesDenoteHost);
    return u;
}
$17fb3400fe673da8$var$Url.prototype.parse = function(url, slashesDenoteHost) {
    var i, l, lowerProto, hec, slashes, rest = url;
    // trim before proceeding.
    // This is to support parse stuff like "  http://foo.com  \n"
    rest = rest.trim();
    if (!slashesDenoteHost && url.split('#').length === 1) {
        // Try fast path regexp
        var simplePath = $17fb3400fe673da8$var$simplePathPattern.exec(rest);
        if (simplePath) {
            this.pathname = simplePath[1];
            if (simplePath[2]) this.search = simplePath[2];
            return this;
        }
    }
    var proto = $17fb3400fe673da8$var$protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        lowerProto = proto.toLowerCase();
        this.protocol = proto;
        rest = rest.substr(proto.length);
    }
    // figure out if it's got a host
    // user@server is *always* interpreted as a hostname, and url
    // resolution will treat //foo/bar as host=foo,path=bar because that's
    // how the browser resolves relative URLs.
    if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
        slashes = rest.substr(0, 2) === '//';
        if (slashes && !(proto && $17fb3400fe673da8$var$hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!$17fb3400fe673da8$var$hostlessProtocol[proto] && (slashes || proto && !$17fb3400fe673da8$var$slashedProtocol[proto])) {
        // there's a hostname.
        // the first instance of /, ?, ;, or # ends the host.
        //
        // If there is an @ in the hostname, then non-host chars *are* allowed
        // to the left of the last @ sign, unless some host-ending character
        // comes *before* the @-sign.
        // URLs are obnoxious.
        //
        // ex:
        // http://a@b@c/ => user:a@b host:c
        // http://a@b?@c => user:a host:c path:/?@c
        // v0.12 TODO(isaacs): This is not quite how Chrome does things.
        // Review our test case against browsers more comprehensively.
        // find the first instance of any hostEndingChars
        var hostEnd = -1;
        for(i = 0; i < $17fb3400fe673da8$var$hostEndingChars.length; i++){
            hec = rest.indexOf($17fb3400fe673da8$var$hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // at this point, either we have an explicit point where the
        // auth portion cannot go past, or the last @ char is the decider.
        var auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf('@');
        else // atSign must be in auth portion.
        // http://a@b/c@d => host:b auth:a path:/c@d
        atSign = rest.lastIndexOf('@', hostEnd);
        // Now we have a portion which is definitely the auth.
        // Pull that off.
        if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = auth;
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(i = 0; i < $17fb3400fe673da8$var$nonHostChars.length; i++){
            hec = rest.indexOf($17fb3400fe673da8$var$nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        if (rest[hostEnd - 1] === ':') hostEnd--;
        var host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost(host);
        // we've indicated that there is a hostname,
        // so even if it's empty, it has to be present.
        this.hostname = this.hostname || '';
        // if hostname begins with [ and ends with ]
        // assume that it's an IPv6 address.
        var ipv6Hostname = this.hostname[0] === '[' && this.hostname[this.hostname.length - 1] === ']';
        // validate a little.
        if (!ipv6Hostname) {
            var hostparts = this.hostname.split(/\./);
            for(i = 0, l = hostparts.length; i < l; i++){
                var part = hostparts[i];
                if (!part) continue;
                if (!part.match($17fb3400fe673da8$var$hostnamePartPattern)) {
                    var newpart = '';
                    for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) // we replace non-ASCII char with a temporary placeholder
                    // we need this to make sure size of hostname is not
                    // broken by replacing non-ASCII by nothing
                    newpart += 'x';
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match($17fb3400fe673da8$var$hostnamePartPattern)) {
                        var validParts = hostparts.slice(0, i);
                        var notHost = hostparts.slice(i + 1);
                        var bit = part.match($17fb3400fe673da8$var$hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = notHost.join('.') + rest;
                        this.hostname = validParts.join('.');
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > $17fb3400fe673da8$var$hostnameMaxLen) this.hostname = '';
        // strip [ and ] from the hostname
        // the host field still retains them, though
        if (ipv6Hostname) this.hostname = this.hostname.substr(1, this.hostname.length - 2);
    }
    // chop off from the tail first.
    var hash = rest.indexOf('#');
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    var qm = rest.indexOf('?');
    if (qm !== -1) {
        this.search = rest.substr(qm);
        rest = rest.slice(0, qm);
    }
    if (rest) this.pathname = rest;
    if ($17fb3400fe673da8$var$slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = '';
    return this;
};
$17fb3400fe673da8$var$Url.prototype.parseHost = function(host) {
    var port = $17fb3400fe673da8$var$portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ':') this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};
module.exports = $17fb3400fe673da8$var$urlParse;

});

parcelRegister("bx7Sb", function(module, exports) {
$parcel$export(module.exports, "Any", () => $8658e22d9bf36744$export$b24b633b1364b94b, (v) => $8658e22d9bf36744$export$b24b633b1364b94b = v);
$parcel$export(module.exports, "Cc", () => $8658e22d9bf36744$export$15dafbac7aec8a57, (v) => $8658e22d9bf36744$export$15dafbac7aec8a57 = v);
$parcel$export(module.exports, "Cf", () => $8658e22d9bf36744$export$239cff0cce87eb56, (v) => $8658e22d9bf36744$export$239cff0cce87eb56 = v);
$parcel$export(module.exports, "P", () => $8658e22d9bf36744$export$56c0d5a1e737357d, (v) => $8658e22d9bf36744$export$56c0d5a1e737357d = v);
$parcel$export(module.exports, "Z", () => $8658e22d9bf36744$export$dc98b0b04f4c7758, (v) => $8658e22d9bf36744$export$dc98b0b04f4c7758 = v);
var $8658e22d9bf36744$export$b24b633b1364b94b;
var $8658e22d9bf36744$export$15dafbac7aec8a57;
var $8658e22d9bf36744$export$239cff0cce87eb56;
var $8658e22d9bf36744$export$56c0d5a1e737357d;
var $8658e22d9bf36744$export$dc98b0b04f4c7758;
'use strict';

$8658e22d9bf36744$export$b24b633b1364b94b = (parcelRequire("6gKKW"));

$8658e22d9bf36744$export$15dafbac7aec8a57 = (parcelRequire("7wkNx"));

$8658e22d9bf36744$export$239cff0cce87eb56 = (parcelRequire("9UqiH"));

$8658e22d9bf36744$export$56c0d5a1e737357d = (parcelRequire("eSMp5"));

$8658e22d9bf36744$export$dc98b0b04f4c7758 = (parcelRequire("4QTDX"));

});

parcelRegister("9UqiH", function(module, exports) {
module.exports = /[\xAD\u0600-\u0605\u061C\u06DD\u070F\u08E2\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFFF9-\uFFFB]|\uD804[\uDCBD\uDCCD]|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]/;

});

parcelRegister("3jcVo", function(module, exports) {
// Parse link label
//
// this function assumes that first character ("[") already matches;
// returns the end of the label
//
'use strict';
module.exports = function parseLinkLabel(state, start, disableNested) {
    var level, found, marker, prevPos, labelEnd = -1, max = state.posMax, oldPos = state.pos;
    state.pos = start + 1;
    level = 1;
    while(state.pos < max){
        marker = state.src.charCodeAt(state.pos);
        if (marker === 0x5D /* ] */ ) {
            level--;
            if (level === 0) {
                found = true;
                break;
            }
        }
        prevPos = state.pos;
        state.md.inline.skipToken(state);
        if (marker === 0x5B /* [ */ ) {
            if (prevPos === state.pos - 1) // increase level if we find text `[`, which is not a part of any token
            level++;
            else if (disableNested) {
                state.pos = oldPos;
                return -1;
            }
        }
    }
    if (found) labelEnd = state.pos;
    // restore old state
    state.pos = oldPos;
    return labelEnd;
};

});

parcelRegister("bwZH2", function(module, exports) {
// Parse link destination
//
'use strict';

var $hslaz = parcelRequire("hslaz");

var $865289d78f708787$require$unescapeAll = $hslaz.unescapeAll;
module.exports = function parseLinkDestination(str, start, max) {
    var code, level, pos = start, result = {
        ok: false,
        pos: 0,
        lines: 0,
        str: ''
    };
    if (str.charCodeAt(pos) === 0x3C /* < */ ) {
        pos++;
        while(pos < max){
            code = str.charCodeAt(pos);
            if (code === 0x0A /* \n */ ) return result;
            if (code === 0x3C /* < */ ) return result;
            if (code === 0x3E /* > */ ) {
                result.pos = pos + 1;
                result.str = $865289d78f708787$require$unescapeAll(str.slice(start + 1, pos));
                result.ok = true;
                return result;
            }
            if (code === 0x5C /* \ */  && pos + 1 < max) {
                pos += 2;
                continue;
            }
            pos++;
        }
        // no closing '>'
        return result;
    }
    // this should be ... } else { ... branch
    level = 0;
    while(pos < max){
        code = str.charCodeAt(pos);
        if (code === 0x20) break;
        // ascii control characters
        if (code < 0x20 || code === 0x7F) break;
        if (code === 0x5C /* \ */  && pos + 1 < max) {
            if (str.charCodeAt(pos + 1) === 0x20) break;
            pos += 2;
            continue;
        }
        if (code === 0x28 /* ( */ ) {
            level++;
            if (level > 32) return result;
        }
        if (code === 0x29 /* ) */ ) {
            if (level === 0) break;
            level--;
        }
        pos++;
    }
    if (start === pos) return result;
    if (level !== 0) return result;
    result.str = $865289d78f708787$require$unescapeAll(str.slice(start, pos));
    result.pos = pos;
    result.ok = true;
    return result;
};

});

parcelRegister("jcH1A", function(module, exports) {
// Parse link title
//
'use strict';

var $hslaz = parcelRequire("hslaz");

var $dfb083184215ac18$require$unescapeAll = $hslaz.unescapeAll;
module.exports = function parseLinkTitle(str, start, max) {
    var code, marker, lines = 0, pos = start, result = {
        ok: false,
        pos: 0,
        lines: 0,
        str: ''
    };
    if (pos >= max) return result;
    marker = str.charCodeAt(pos);
    if (marker !== 0x22 /* " */  && marker !== 0x27 /* ' */  && marker !== 0x28 /* ( */ ) return result;
    pos++;
    // if opening marker is "(", switch it to closing marker ")"
    if (marker === 0x28) marker = 0x29;
    while(pos < max){
        code = str.charCodeAt(pos);
        if (code === marker) {
            result.pos = pos + 1;
            result.lines = lines;
            result.str = $dfb083184215ac18$require$unescapeAll(str.slice(start + 1, pos));
            result.ok = true;
            return result;
        } else if (code === 0x28 /* ( */  && marker === 0x29 /* ) */ ) return result;
        else if (code === 0x0A) lines++;
        else if (code === 0x5C /* \ */  && pos + 1 < max) {
            pos++;
            if (str.charCodeAt(pos) === 0x0A) lines++;
        }
        pos++;
    }
    return result;
};

});

parcelRegister("6oHAz", function(module, exports) {
// Normalize input string
'use strict';
// https://spec.commonmark.org/0.29/#line-ending
var $4a86cbd41bb5092e$var$NEWLINES_RE = /\r\n?|\n/g;
var $4a86cbd41bb5092e$var$NULL_RE = /\0/g;
module.exports = function normalize(state) {
    var str;
    // Normalize newlines
    str = state.src.replace($4a86cbd41bb5092e$var$NEWLINES_RE, '\n');
    // Replace NULL characters
    str = str.replace($4a86cbd41bb5092e$var$NULL_RE, '\uFFFD');
    state.src = str;
};

});

parcelRegister("1whli", function(module, exports) {
'use strict';
module.exports = function block(state) {
    var token;
    if (state.inlineMode) {
        token = new state.Token('inline', '', 0);
        token.content = state.src;
        token.map = [
            0,
            1
        ];
        token.children = [];
        state.tokens.push(token);
    } else state.md.block.parse(state.src, state.md, state.env, state.tokens);
};

});

parcelRegister("da9wI", function(module, exports) {
'use strict';
module.exports = function inline(state) {
    var tokens = state.tokens, tok, i, l;
    // Parse inlines
    for(i = 0, l = tokens.length; i < l; i++){
        tok = tokens[i];
        if (tok.type === 'inline') state.md.inline.parse(tok.content, state.md, state.env, tok.children);
    }
};

});

parcelRegister("aNcTG", function(module, exports) {
// Replace link-like texts with link nodes.
//
// Currently restricted by `md.validateLink()` to http/https/ftp
//
'use strict';

var $hslaz = parcelRequire("hslaz");

var $7db87c12fec24755$require$arrayReplaceAt = $hslaz.arrayReplaceAt;
function $7db87c12fec24755$var$isLinkOpen(str) {
    return /^<a[>\s]/i.test(str);
}
function $7db87c12fec24755$var$isLinkClose(str) {
    return /^<\/a\s*>/i.test(str);
}
module.exports = function linkify(state) {
    var i, j, l, tokens, token, currentToken, nodes, ln, text, pos, lastPos, level, htmlLinkLevel, url, fullUrl, urlText, blockTokens = state.tokens, links;
    if (!state.md.options.linkify) return;
    for(j = 0, l = blockTokens.length; j < l; j++){
        if (blockTokens[j].type !== 'inline' || !state.md.linkify.pretest(blockTokens[j].content)) continue;
        tokens = blockTokens[j].children;
        htmlLinkLevel = 0;
        // We scan from the end, to keep position when new tags added.
        // Use reversed logic in links start/end match
        for(i = tokens.length - 1; i >= 0; i--){
            currentToken = tokens[i];
            // Skip content of markdown links
            if (currentToken.type === 'link_close') {
                i--;
                while(tokens[i].level !== currentToken.level && tokens[i].type !== 'link_open')i--;
                continue;
            }
            // Skip content of html tag links
            if (currentToken.type === 'html_inline') {
                if ($7db87c12fec24755$var$isLinkOpen(currentToken.content) && htmlLinkLevel > 0) htmlLinkLevel--;
                if ($7db87c12fec24755$var$isLinkClose(currentToken.content)) htmlLinkLevel++;
            }
            if (htmlLinkLevel > 0) continue;
            if (currentToken.type === 'text' && state.md.linkify.test(currentToken.content)) {
                text = currentToken.content;
                links = state.md.linkify.match(text);
                // Now split string to nodes
                nodes = [];
                level = currentToken.level;
                lastPos = 0;
                // forbid escape sequence at the start of the string,
                // this avoids http\://example.com/ from being linkified as
                // http:<a href="//example.com/">//example.com/</a>
                if (links.length > 0 && links[0].index === 0 && i > 0 && tokens[i - 1].type === 'text_special') links = links.slice(1);
                for(ln = 0; ln < links.length; ln++){
                    url = links[ln].url;
                    fullUrl = state.md.normalizeLink(url);
                    if (!state.md.validateLink(fullUrl)) continue;
                    urlText = links[ln].text;
                    // Linkifier might send raw hostnames like "example.com", where url
                    // starts with domain name. So we prepend http:// in those cases,
                    // and remove it afterwards.
                    //
                    if (!links[ln].schema) urlText = state.md.normalizeLinkText('http://' + urlText).replace(/^http:\/\//, '');
                    else if (links[ln].schema === 'mailto:' && !/^mailto:/i.test(urlText)) urlText = state.md.normalizeLinkText('mailto:' + urlText).replace(/^mailto:/, '');
                    else urlText = state.md.normalizeLinkText(urlText);
                    pos = links[ln].index;
                    if (pos > lastPos) {
                        token = new state.Token('text', '', 0);
                        token.content = text.slice(lastPos, pos);
                        token.level = level;
                        nodes.push(token);
                    }
                    token = new state.Token('link_open', 'a', 1);
                    token.attrs = [
                        [
                            'href',
                            fullUrl
                        ]
                    ];
                    token.level = level++;
                    token.markup = 'linkify';
                    token.info = 'auto';
                    nodes.push(token);
                    token = new state.Token('text', '', 0);
                    token.content = urlText;
                    token.level = level;
                    nodes.push(token);
                    token = new state.Token('link_close', 'a', -1);
                    token.level = --level;
                    token.markup = 'linkify';
                    token.info = 'auto';
                    nodes.push(token);
                    lastPos = links[ln].lastIndex;
                }
                if (lastPos < text.length) {
                    token = new state.Token('text', '', 0);
                    token.content = text.slice(lastPos);
                    token.level = level;
                    nodes.push(token);
                }
                // replace current node
                blockTokens[j].children = tokens = $7db87c12fec24755$require$arrayReplaceAt(tokens, i, nodes);
            }
        }
    }
};

});

parcelRegister("h6nFy", function(module, exports) {
// Simple typographic replacements
//
// (c) (C) → ©
// (tm) (TM) → ™
// (r) (R) → ®
// +- → ±
// ... → … (also ?.... → ?.., !.... → !..)
// ???????? → ???, !!!!! → !!!, `,,` → `,`
// -- → &ndash;, --- → &mdash;
//
'use strict';
// TODO:
// - fractionals 1/2, 1/4, 3/4 -> ½, ¼, ¾
// - multiplications 2 x 4 -> 2 × 4
var $c7355b6702b9362e$var$RARE_RE = /\+-|\.\.|\?\?\?\?|!!!!|,,|--/;
// Workaround for phantomjs - need regex without /g flag,
// or root check will fail every second time
var $c7355b6702b9362e$var$SCOPED_ABBR_TEST_RE = /\((c|tm|r)\)/i;
var $c7355b6702b9362e$var$SCOPED_ABBR_RE = /\((c|tm|r)\)/ig;
var $c7355b6702b9362e$var$SCOPED_ABBR = {
    c: "\xa9",
    r: "\xae",
    tm: "\u2122"
};
function $c7355b6702b9362e$var$replaceFn(match, name) {
    return $c7355b6702b9362e$var$SCOPED_ABBR[name.toLowerCase()];
}
function $c7355b6702b9362e$var$replace_scoped(inlineTokens) {
    var i, token, inside_autolink = 0;
    for(i = inlineTokens.length - 1; i >= 0; i--){
        token = inlineTokens[i];
        if (token.type === 'text' && !inside_autolink) token.content = token.content.replace($c7355b6702b9362e$var$SCOPED_ABBR_RE, $c7355b6702b9362e$var$replaceFn);
        if (token.type === 'link_open' && token.info === 'auto') inside_autolink--;
        if (token.type === 'link_close' && token.info === 'auto') inside_autolink++;
    }
}
function $c7355b6702b9362e$var$replace_rare(inlineTokens) {
    var i, token, inside_autolink = 0;
    for(i = inlineTokens.length - 1; i >= 0; i--){
        token = inlineTokens[i];
        if (token.type === 'text' && !inside_autolink) {
            if ($c7355b6702b9362e$var$RARE_RE.test(token.content)) token.content = token.content.replace(/\+-/g, "\xb1")// .., ..., ....... -> …
            // but ?..... & !..... -> ?.. & !..
            .replace(/\.{2,}/g, "\u2026").replace(/([?!])…/g, '$1..').replace(/([?!]){4,}/g, '$1$1$1').replace(/,{2,}/g, ',')// em-dash
            .replace(/(^|[^-])---(?=[^-]|$)/mg, '$1\u2014')// en-dash
            .replace(/(^|\s)--(?=\s|$)/mg, '$1\u2013').replace(/(^|[^-\s])--(?=[^-\s]|$)/mg, '$1\u2013');
        }
        if (token.type === 'link_open' && token.info === 'auto') inside_autolink--;
        if (token.type === 'link_close' && token.info === 'auto') inside_autolink++;
    }
}
module.exports = function replace(state) {
    var blkIdx;
    if (!state.md.options.typographer) return;
    for(blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--){
        if (state.tokens[blkIdx].type !== 'inline') continue;
        if ($c7355b6702b9362e$var$SCOPED_ABBR_TEST_RE.test(state.tokens[blkIdx].content)) $c7355b6702b9362e$var$replace_scoped(state.tokens[blkIdx].children);
        if ($c7355b6702b9362e$var$RARE_RE.test(state.tokens[blkIdx].content)) $c7355b6702b9362e$var$replace_rare(state.tokens[blkIdx].children);
    }
};

});

parcelRegister("eNEJu", function(module, exports) {
// Convert straight quotation marks to typographic ones
//
'use strict';

var $hslaz = parcelRequire("hslaz");

var $ac653cf8fad0a277$require$isWhiteSpace = $hslaz.isWhiteSpace;



var $ac653cf8fad0a277$require$isPunctChar = $hslaz.isPunctChar;



var $ac653cf8fad0a277$require$isMdAsciiPunct = $hslaz.isMdAsciiPunct;
var $ac653cf8fad0a277$var$QUOTE_TEST_RE = /['"]/;
var $ac653cf8fad0a277$var$QUOTE_RE = /['"]/g;
var $ac653cf8fad0a277$var$APOSTROPHE = '\u2019'; /* ’ */ 
function $ac653cf8fad0a277$var$replaceAt(str, index, ch) {
    return str.slice(0, index) + ch + str.slice(index + 1);
}
function $ac653cf8fad0a277$var$process_inlines(tokens, state) {
    var i, token, text, t, pos, max, thisLevel, item, lastChar, nextChar, isLastPunctChar, isNextPunctChar, isLastWhiteSpace, isNextWhiteSpace, canOpen, canClose, j, isSingle, stack, openQuote, closeQuote;
    stack = [];
    for(i = 0; i < tokens.length; i++){
        token = tokens[i];
        thisLevel = tokens[i].level;
        for(j = stack.length - 1; j >= 0; j--){
            if (stack[j].level <= thisLevel) break;
        }
        stack.length = j + 1;
        if (token.type !== 'text') continue;
        text = token.content;
        pos = 0;
        max = text.length;
        /*eslint no-labels:0,block-scoped-var:0*/ OUTER: while(pos < max){
            $ac653cf8fad0a277$var$QUOTE_RE.lastIndex = pos;
            t = $ac653cf8fad0a277$var$QUOTE_RE.exec(text);
            if (!t) break;
            canOpen = canClose = true;
            pos = t.index + 1;
            isSingle = t[0] === "'";
            // Find previous character,
            // default to space if it's the beginning of the line
            //
            lastChar = 0x20;
            if (t.index - 1 >= 0) lastChar = text.charCodeAt(t.index - 1);
            else for(j = i - 1; j >= 0; j--){
                if (tokens[j].type === 'softbreak' || tokens[j].type === 'hardbreak') break; // lastChar defaults to 0x20
                if (!tokens[j].content) continue; // should skip all tokens except 'text', 'html_inline' or 'code_inline'
                lastChar = tokens[j].content.charCodeAt(tokens[j].content.length - 1);
                break;
            }
            // Find next character,
            // default to space if it's the end of the line
            //
            nextChar = 0x20;
            if (pos < max) nextChar = text.charCodeAt(pos);
            else for(j = i + 1; j < tokens.length; j++){
                if (tokens[j].type === 'softbreak' || tokens[j].type === 'hardbreak') break; // nextChar defaults to 0x20
                if (!tokens[j].content) continue; // should skip all tokens except 'text', 'html_inline' or 'code_inline'
                nextChar = tokens[j].content.charCodeAt(0);
                break;
            }
            isLastPunctChar = $ac653cf8fad0a277$require$isMdAsciiPunct(lastChar) || $ac653cf8fad0a277$require$isPunctChar(String.fromCharCode(lastChar));
            isNextPunctChar = $ac653cf8fad0a277$require$isMdAsciiPunct(nextChar) || $ac653cf8fad0a277$require$isPunctChar(String.fromCharCode(nextChar));
            isLastWhiteSpace = $ac653cf8fad0a277$require$isWhiteSpace(lastChar);
            isNextWhiteSpace = $ac653cf8fad0a277$require$isWhiteSpace(nextChar);
            if (isNextWhiteSpace) canOpen = false;
            else if (isNextPunctChar) {
                if (!(isLastWhiteSpace || isLastPunctChar)) canOpen = false;
            }
            if (isLastWhiteSpace) canClose = false;
            else if (isLastPunctChar) {
                if (!(isNextWhiteSpace || isNextPunctChar)) canClose = false;
            }
            if (nextChar === 0x22 /* " */  && t[0] === '"') {
                if (lastChar >= 0x30 /* 0 */  && lastChar <= 0x39 /* 9 */ ) // special case: 1"" - count first quote as an inch
                canClose = canOpen = false;
            }
            if (canOpen && canClose) {
                // Replace quotes in the middle of punctuation sequence, but not
                // in the middle of the words, i.e.:
                //
                // 1. foo " bar " baz - not replaced
                // 2. foo-"-bar-"-baz - replaced
                // 3. foo"bar"baz     - not replaced
                //
                canOpen = isLastPunctChar;
                canClose = isNextPunctChar;
            }
            if (!canOpen && !canClose) {
                // middle of word
                if (isSingle) token.content = $ac653cf8fad0a277$var$replaceAt(token.content, t.index, $ac653cf8fad0a277$var$APOSTROPHE);
                continue;
            }
            if (canClose) // this could be a closing quote, rewind the stack to get a match
            for(j = stack.length - 1; j >= 0; j--){
                item = stack[j];
                if (stack[j].level < thisLevel) break;
                if (item.single === isSingle && stack[j].level === thisLevel) {
                    item = stack[j];
                    if (isSingle) {
                        openQuote = state.md.options.quotes[2];
                        closeQuote = state.md.options.quotes[3];
                    } else {
                        openQuote = state.md.options.quotes[0];
                        closeQuote = state.md.options.quotes[1];
                    }
                    // replace token.content *before* tokens[item.token].content,
                    // because, if they are pointing at the same token, replaceAt
                    // could mess up indices when quote length != 1
                    token.content = $ac653cf8fad0a277$var$replaceAt(token.content, t.index, closeQuote);
                    tokens[item.token].content = $ac653cf8fad0a277$var$replaceAt(tokens[item.token].content, item.pos, openQuote);
                    pos += closeQuote.length - 1;
                    if (item.token === i) pos += openQuote.length - 1;
                    text = token.content;
                    max = text.length;
                    stack.length = j;
                    continue OUTER;
                }
            }
            if (canOpen) stack.push({
                token: i,
                pos: t.index,
                single: isSingle,
                level: thisLevel
            });
            else if (canClose && isSingle) token.content = $ac653cf8fad0a277$var$replaceAt(token.content, t.index, $ac653cf8fad0a277$var$APOSTROPHE);
        }
    }
}
module.exports = function smartquotes(state) {
    /*eslint max-depth:0*/ var blkIdx;
    if (!state.md.options.typographer) return;
    for(blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--){
        if (state.tokens[blkIdx].type !== 'inline' || !$ac653cf8fad0a277$var$QUOTE_TEST_RE.test(state.tokens[blkIdx].content)) continue;
        $ac653cf8fad0a277$var$process_inlines(state.tokens[blkIdx].children, state);
    }
};

});

parcelRegister("3CceH", function(module, exports) {
// Join raw text tokens with the rest of the text
//
// This is set as a separate rule to provide an opportunity for plugins
// to run text replacements after text join, but before escape join.
//
// For example, `\:)` shouldn't be replaced with an emoji.
//
'use strict';
module.exports = function text_join(state) {
    var j, l, tokens, curr, max, last, blockTokens = state.tokens;
    for(j = 0, l = blockTokens.length; j < l; j++){
        if (blockTokens[j].type !== 'inline') continue;
        tokens = blockTokens[j].children;
        max = tokens.length;
        for(curr = 0; curr < max; curr++)if (tokens[curr].type === 'text_special') tokens[curr].type = 'text';
        for(curr = last = 0; curr < max; curr++)if (tokens[curr].type === 'text' && curr + 1 < max && tokens[curr + 1].type === 'text') // collapse two adjacent text nodes
        tokens[curr + 1].content = tokens[curr].content + tokens[curr + 1].content;
        else {
            if (curr !== last) tokens[last] = tokens[curr];
            last++;
        }
        if (curr !== last) tokens.length = last;
    }
};

});

parcelRegister("hnyQ8", function(module, exports) {
// Core state object
//
'use strict';

var $flZnN = parcelRequire("flZnN");

function $ca6f9c20f90c9f4e$var$StateCore(src, md, env) {
    this.src = src;
    this.env = env;
    this.tokens = [];
    this.inlineMode = false;
    this.md = md; // link to parser instance
}
// re-export Token class to use in core rules
$ca6f9c20f90c9f4e$var$StateCore.prototype.Token = $flZnN;
module.exports = $ca6f9c20f90c9f4e$var$StateCore;

});

parcelRegister("i2Iv8", function(module, exports) {
// GFM table, https://github.github.com/gfm/#tables-extension-
'use strict';

var $hslaz = parcelRequire("hslaz");

var $d22aeee7779518c4$require$isSpace = $hslaz.isSpace;
function $d22aeee7779518c4$var$getLine(state, line) {
    var pos = state.bMarks[line] + state.tShift[line], max = state.eMarks[line];
    return state.src.slice(pos, max);
}
function $d22aeee7779518c4$var$escapedSplit(str) {
    var result = [], pos = 0, max = str.length, ch, isEscaped = false, lastPos = 0, current = '';
    ch = str.charCodeAt(pos);
    while(pos < max){
        if (ch === 0x7c /* | */ ) {
            if (!isEscaped) {
                // pipe separating cells, '|'
                result.push(current + str.substring(lastPos, pos));
                current = '';
                lastPos = pos + 1;
            } else {
                // escaped pipe, '\|'
                current += str.substring(lastPos, pos - 1);
                lastPos = pos;
            }
        }
        isEscaped = ch === 0x5c /* \ */ ;
        pos++;
        ch = str.charCodeAt(pos);
    }
    result.push(current + str.substring(lastPos));
    return result;
}
module.exports = function table(state, startLine, endLine, silent) {
    var ch, lineText, pos, i, l, nextLine, columns, columnCount, token, aligns, t, tableLines, tbodyLines, oldParentType, terminate, terminatorRules, firstCh, secondCh;
    // should have at least two lines
    if (startLine + 2 > endLine) return false;
    nextLine = startLine + 1;
    if (state.sCount[nextLine] < state.blkIndent) return false;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[nextLine] - state.blkIndent >= 4) return false;
    // first character of the second line should be '|', '-', ':',
    // and no other characters are allowed but spaces;
    // basically, this is the equivalent of /^[-:|][-:|\s]*$/ regexp
    pos = state.bMarks[nextLine] + state.tShift[nextLine];
    if (pos >= state.eMarks[nextLine]) return false;
    firstCh = state.src.charCodeAt(pos++);
    if (firstCh !== 0x7C /* | */  && firstCh !== 0x2D /* - */  && firstCh !== 0x3A /* : */ ) return false;
    if (pos >= state.eMarks[nextLine]) return false;
    secondCh = state.src.charCodeAt(pos++);
    if (secondCh !== 0x7C /* | */  && secondCh !== 0x2D /* - */  && secondCh !== 0x3A /* : */  && !$d22aeee7779518c4$require$isSpace(secondCh)) return false;
    // if first character is '-', then second character must not be a space
    // (due to parsing ambiguity with list)
    if (firstCh === 0x2D /* - */  && $d22aeee7779518c4$require$isSpace(secondCh)) return false;
    while(pos < state.eMarks[nextLine]){
        ch = state.src.charCodeAt(pos);
        if (ch !== 0x7C /* | */  && ch !== 0x2D /* - */  && ch !== 0x3A /* : */  && !$d22aeee7779518c4$require$isSpace(ch)) return false;
        pos++;
    }
    lineText = $d22aeee7779518c4$var$getLine(state, startLine + 1);
    columns = lineText.split('|');
    aligns = [];
    for(i = 0; i < columns.length; i++){
        t = columns[i].trim();
        if (!t) {
            // allow empty columns before and after table, but not in between columns;
            // e.g. allow ` |---| `, disallow ` ---||--- `
            if (i === 0 || i === columns.length - 1) continue;
            else return false;
        }
        if (!/^:?-+:?$/.test(t)) return false;
        if (t.charCodeAt(t.length - 1) === 0x3A /* : */ ) aligns.push(t.charCodeAt(0) === 0x3A /* : */  ? 'center' : 'right');
        else if (t.charCodeAt(0) === 0x3A /* : */ ) aligns.push('left');
        else aligns.push('');
    }
    lineText = $d22aeee7779518c4$var$getLine(state, startLine).trim();
    if (lineText.indexOf('|') === -1) return false;
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    columns = $d22aeee7779518c4$var$escapedSplit(lineText);
    if (columns.length && columns[0] === '') columns.shift();
    if (columns.length && columns[columns.length - 1] === '') columns.pop();
    // header row will define an amount of columns in the entire table,
    // and align row should be exactly the same (the rest of the rows can differ)
    columnCount = columns.length;
    if (columnCount === 0 || columnCount !== aligns.length) return false;
    if (silent) return true;
    oldParentType = state.parentType;
    state.parentType = 'table';
    // use 'blockquote' lists for termination because it's
    // the most similar to tables
    terminatorRules = state.md.block.ruler.getRules('blockquote');
    token = state.push('table_open', 'table', 1);
    token.map = tableLines = [
        startLine,
        0
    ];
    token = state.push('thead_open', 'thead', 1);
    token.map = [
        startLine,
        startLine + 1
    ];
    token = state.push('tr_open', 'tr', 1);
    token.map = [
        startLine,
        startLine + 1
    ];
    for(i = 0; i < columns.length; i++){
        token = state.push('th_open', 'th', 1);
        if (aligns[i]) token.attrs = [
            [
                'style',
                'text-align:' + aligns[i]
            ]
        ];
        token = state.push('inline', '', 0);
        token.content = columns[i].trim();
        token.children = [];
        token = state.push('th_close', 'th', -1);
    }
    token = state.push('tr_close', 'tr', -1);
    token = state.push('thead_close', 'thead', -1);
    for(nextLine = startLine + 2; nextLine < endLine; nextLine++){
        if (state.sCount[nextLine] < state.blkIndent) break;
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
        lineText = $d22aeee7779518c4$var$getLine(state, nextLine).trim();
        if (!lineText) break;
        if (state.sCount[nextLine] - state.blkIndent >= 4) break;
        columns = $d22aeee7779518c4$var$escapedSplit(lineText);
        if (columns.length && columns[0] === '') columns.shift();
        if (columns.length && columns[columns.length - 1] === '') columns.pop();
        if (nextLine === startLine + 2) {
            token = state.push('tbody_open', 'tbody', 1);
            token.map = tbodyLines = [
                startLine + 2,
                0
            ];
        }
        token = state.push('tr_open', 'tr', 1);
        token.map = [
            nextLine,
            nextLine + 1
        ];
        for(i = 0; i < columnCount; i++){
            token = state.push('td_open', 'td', 1);
            if (aligns[i]) token.attrs = [
                [
                    'style',
                    'text-align:' + aligns[i]
                ]
            ];
            token = state.push('inline', '', 0);
            token.content = columns[i] ? columns[i].trim() : '';
            token.children = [];
            token = state.push('td_close', 'td', -1);
        }
        token = state.push('tr_close', 'tr', -1);
    }
    if (tbodyLines) {
        token = state.push('tbody_close', 'tbody', -1);
        tbodyLines[1] = nextLine;
    }
    token = state.push('table_close', 'table', -1);
    tableLines[1] = nextLine;
    state.parentType = oldParentType;
    state.line = nextLine;
    return true;
};

});

parcelRegister("hnPBV", function(module, exports) {
// Code block (4 spaces padded)
'use strict';
module.exports = function code(state, startLine, endLine /*, silent*/ ) {
    var nextLine, last, token;
    if (state.sCount[startLine] - state.blkIndent < 4) return false;
    last = nextLine = startLine + 1;
    while(nextLine < endLine){
        if (state.isEmpty(nextLine)) {
            nextLine++;
            continue;
        }
        if (state.sCount[nextLine] - state.blkIndent >= 4) {
            nextLine++;
            last = nextLine;
            continue;
        }
        break;
    }
    state.line = last;
    token = state.push('code_block', 'code', 0);
    token.content = state.getLines(startLine, last, 4 + state.blkIndent, false) + '\n';
    token.map = [
        startLine,
        state.line
    ];
    return true;
};

});

parcelRegister("3GuRa", function(module, exports) {
// fences (``` lang, ~~~ lang)
'use strict';
module.exports = function fence(state, startLine, endLine, silent) {
    var marker, len, params, nextLine, mem, token, markup, haveEndMarker = false, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (pos + 3 > max) return false;
    marker = state.src.charCodeAt(pos);
    if (marker !== 0x7E /* ~ */  && marker !== 0x60 /* ` */ ) return false;
    // scan marker length
    mem = pos;
    pos = state.skipChars(pos, marker);
    len = pos - mem;
    if (len < 3) return false;
    markup = state.src.slice(mem, pos);
    params = state.src.slice(pos, max);
    if (marker === 0x60 /* ` */ ) {
        if (params.indexOf(String.fromCharCode(marker)) >= 0) return false;
    }
    // Since start is found, we can report success here in validation mode
    if (silent) return true;
    // search end of block
    nextLine = startLine;
    for(;;){
        nextLine++;
        if (nextLine >= endLine) break;
        pos = mem = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        if (pos < max && state.sCount[nextLine] < state.blkIndent) break;
        if (state.src.charCodeAt(pos) !== marker) continue;
        if (state.sCount[nextLine] - state.blkIndent >= 4) continue;
        pos = state.skipChars(pos, marker);
        // closing code fence must be at least as long as the opening one
        if (pos - mem < len) continue;
        // make sure tail has spaces only
        pos = state.skipSpaces(pos);
        if (pos < max) continue;
        haveEndMarker = true;
        break;
    }
    // If a fence has heading spaces, they should be removed from its inner block
    len = state.sCount[startLine];
    state.line = nextLine + (haveEndMarker ? 1 : 0);
    token = state.push('fence', 'code', 0);
    token.info = params;
    token.content = state.getLines(startLine + 1, nextLine, len, true);
    token.markup = markup;
    token.map = [
        startLine,
        state.line
    ];
    return true;
};

});

parcelRegister("79tnV", function(module, exports) {
// Block quotes
'use strict';

var $hslaz = parcelRequire("hslaz");

var $53502ae8d81188c9$require$isSpace = $hslaz.isSpace;
module.exports = function blockquote(state, startLine, endLine, silent) {
    var adjustTab, ch, i, initial, l, lastLineEmpty, lines, nextLine, offset, oldBMarks, oldBSCount, oldIndent, oldParentType, oldSCount, oldTShift, spaceAfterMarker, terminate, terminatorRules, token, isOutdented, oldLineMax = state.lineMax, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    // check the block quote marker
    if (state.src.charCodeAt(pos) !== 0x3E /* > */ ) return false;
    // we know that it's going to be a valid blockquote,
    // so no point trying to find the end of it in silent mode
    if (silent) return true;
    oldBMarks = [];
    oldBSCount = [];
    oldSCount = [];
    oldTShift = [];
    terminatorRules = state.md.block.ruler.getRules('blockquote');
    oldParentType = state.parentType;
    state.parentType = 'blockquote';
    // Search the end of the block
    //
    // Block ends with either:
    //  1. an empty line outside:
    //     ```
    //     > test
    //
    //     ```
    //  2. an empty line inside:
    //     ```
    //     >
    //     test
    //     ```
    //  3. another tag:
    //     ```
    //     > test
    //      - - -
    //     ```
    for(nextLine = startLine; nextLine < endLine; nextLine++){
        // check if it's outdented, i.e. it's inside list item and indented
        // less than said list item:
        //
        // ```
        // 1. anything
        //    > current blockquote
        // 2. checking this line
        // ```
        isOutdented = state.sCount[nextLine] < state.blkIndent;
        pos = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        if (pos >= max) break;
        if (state.src.charCodeAt(pos++) === 0x3E /* > */  && !isOutdented) {
            // This line is inside the blockquote.
            // set offset past spaces and ">"
            initial = state.sCount[nextLine] + 1;
            // skip one optional space after '>'
            if (state.src.charCodeAt(pos) === 0x20 /* space */ ) {
                // ' >   test '
                //     ^ -- position start of line here:
                pos++;
                initial++;
                adjustTab = false;
                spaceAfterMarker = true;
            } else if (state.src.charCodeAt(pos) === 0x09 /* tab */ ) {
                spaceAfterMarker = true;
                if ((state.bsCount[nextLine] + initial) % 4 === 3) {
                    // '  >\t  test '
                    //       ^ -- position start of line here (tab has width===1)
                    pos++;
                    initial++;
                    adjustTab = false;
                } else // ' >\t  test '
                //    ^ -- position start of line here + shift bsCount slightly
                //         to make extra space appear
                adjustTab = true;
            } else spaceAfterMarker = false;
            offset = initial;
            oldBMarks.push(state.bMarks[nextLine]);
            state.bMarks[nextLine] = pos;
            while(pos < max){
                ch = state.src.charCodeAt(pos);
                if ($53502ae8d81188c9$require$isSpace(ch)) {
                    if (ch === 0x09) offset += 4 - (offset + state.bsCount[nextLine] + (adjustTab ? 1 : 0)) % 4;
                    else offset++;
                } else break;
                pos++;
            }
            lastLineEmpty = pos >= max;
            oldBSCount.push(state.bsCount[nextLine]);
            state.bsCount[nextLine] = state.sCount[nextLine] + 1 + (spaceAfterMarker ? 1 : 0);
            oldSCount.push(state.sCount[nextLine]);
            state.sCount[nextLine] = offset - initial;
            oldTShift.push(state.tShift[nextLine]);
            state.tShift[nextLine] = pos - state.bMarks[nextLine];
            continue;
        }
        // Case 2: line is not inside the blockquote, and the last line was empty.
        if (lastLineEmpty) break;
        // Case 3: another tag found.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) {
            // Quirk to enforce "hard termination mode" for paragraphs;
            // normally if you call `tokenize(state, startLine, nextLine)`,
            // paragraphs will look below nextLine for paragraph continuation,
            // but if blockquote is terminated by another tag, they shouldn't
            state.lineMax = nextLine;
            if (state.blkIndent !== 0) {
                // state.blkIndent was non-zero, we now set it to zero,
                // so we need to re-calculate all offsets to appear as
                // if indent wasn't changed
                oldBMarks.push(state.bMarks[nextLine]);
                oldBSCount.push(state.bsCount[nextLine]);
                oldTShift.push(state.tShift[nextLine]);
                oldSCount.push(state.sCount[nextLine]);
                state.sCount[nextLine] -= state.blkIndent;
            }
            break;
        }
        oldBMarks.push(state.bMarks[nextLine]);
        oldBSCount.push(state.bsCount[nextLine]);
        oldTShift.push(state.tShift[nextLine]);
        oldSCount.push(state.sCount[nextLine]);
        // A negative indentation means that this is a paragraph continuation
        //
        state.sCount[nextLine] = -1;
    }
    oldIndent = state.blkIndent;
    state.blkIndent = 0;
    token = state.push('blockquote_open', 'blockquote', 1);
    token.markup = '>';
    token.map = lines = [
        startLine,
        0
    ];
    state.md.block.tokenize(state, startLine, nextLine);
    token = state.push('blockquote_close', 'blockquote', -1);
    token.markup = '>';
    state.lineMax = oldLineMax;
    state.parentType = oldParentType;
    lines[1] = state.line;
    // Restore original tShift; this might not be necessary since the parser
    // has already been here, but just to make sure we can do that.
    for(i = 0; i < oldTShift.length; i++){
        state.bMarks[i + startLine] = oldBMarks[i];
        state.tShift[i + startLine] = oldTShift[i];
        state.sCount[i + startLine] = oldSCount[i];
        state.bsCount[i + startLine] = oldBSCount[i];
    }
    state.blkIndent = oldIndent;
    return true;
};

});

parcelRegister("keEbn", function(module, exports) {
// Horizontal rule
'use strict';

var $hslaz = parcelRequire("hslaz");

var $ebb448de11020ca1$require$isSpace = $hslaz.isSpace;
module.exports = function hr(state, startLine, endLine, silent) {
    var marker, cnt, ch, token, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    marker = state.src.charCodeAt(pos++);
    // Check hr marker
    if (marker !== 0x2A /* * */  && marker !== 0x2D /* - */  && marker !== 0x5F /* _ */ ) return false;
    // markers can be mixed with spaces, but there should be at least 3 of them
    cnt = 1;
    while(pos < max){
        ch = state.src.charCodeAt(pos++);
        if (ch !== marker && !$ebb448de11020ca1$require$isSpace(ch)) return false;
        if (ch === marker) cnt++;
    }
    if (cnt < 3) return false;
    if (silent) return true;
    state.line = startLine + 1;
    token = state.push('hr', 'hr', 0);
    token.map = [
        startLine,
        state.line
    ];
    token.markup = Array(cnt + 1).join(String.fromCharCode(marker));
    return true;
};

});

parcelRegister("9Flpb", function(module, exports) {
// Lists
'use strict';

var $hslaz = parcelRequire("hslaz");

var $70988c00697c25f3$require$isSpace = $hslaz.isSpace;
// Search `[-+*][\n ]`, returns next pos after marker on success
// or -1 on fail.
function $70988c00697c25f3$var$skipBulletListMarker(state, startLine) {
    var marker, pos, max, ch;
    pos = state.bMarks[startLine] + state.tShift[startLine];
    max = state.eMarks[startLine];
    marker = state.src.charCodeAt(pos++);
    // Check bullet
    if (marker !== 0x2A /* * */  && marker !== 0x2D /* - */  && marker !== 0x2B /* + */ ) return -1;
    if (pos < max) {
        ch = state.src.charCodeAt(pos);
        if (!$70988c00697c25f3$require$isSpace(ch)) // " -test " - is not a list item
        return -1;
    }
    return pos;
}
// Search `\d+[.)][\n ]`, returns next pos after marker on success
// or -1 on fail.
function $70988c00697c25f3$var$skipOrderedListMarker(state, startLine) {
    var ch, start = state.bMarks[startLine] + state.tShift[startLine], pos = start, max = state.eMarks[startLine];
    // List marker should have at least 2 chars (digit + dot)
    if (pos + 1 >= max) return -1;
    ch = state.src.charCodeAt(pos++);
    if (ch < 0x30 /* 0 */  || ch > 0x39 /* 9 */ ) return -1;
    for(;;){
        // EOL -> fail
        if (pos >= max) return -1;
        ch = state.src.charCodeAt(pos++);
        if (ch >= 0x30 /* 0 */  && ch <= 0x39 /* 9 */ ) {
            // List marker should have no more than 9 digits
            // (prevents integer overflow in browsers)
            if (pos - start >= 10) return -1;
            continue;
        }
        // found valid marker
        if (ch === 0x29 /* ) */  || ch === 0x2e /* . */ ) break;
        return -1;
    }
    if (pos < max) {
        ch = state.src.charCodeAt(pos);
        if (!$70988c00697c25f3$require$isSpace(ch)) // " 1.test " - is not a list item
        return -1;
    }
    return pos;
}
function $70988c00697c25f3$var$markTightParagraphs(state, idx) {
    var i, l, level = state.level + 2;
    for(i = idx + 2, l = state.tokens.length - 2; i < l; i++)if (state.tokens[i].level === level && state.tokens[i].type === 'paragraph_open') {
        state.tokens[i + 2].hidden = true;
        state.tokens[i].hidden = true;
        i += 2;
    }
}
module.exports = function list(state, startLine, endLine, silent) {
    var ch, contentStart, i, indent, indentAfterMarker, initial, isOrdered, itemLines, l, listLines, listTokIdx, markerCharCode, markerValue, max, offset, oldListIndent, oldParentType, oldSCount, oldTShift, oldTight, pos, posAfterMarker, prevEmptyEnd, start, terminate, terminatorRules, token, nextLine = startLine, isTerminatingParagraph = false, tight = true;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[nextLine] - state.blkIndent >= 4) return false;
    // Special case:
    //  - item 1
    //   - item 2
    //    - item 3
    //     - item 4
    //      - this one is a paragraph continuation
    if (state.listIndent >= 0 && state.sCount[nextLine] - state.listIndent >= 4 && state.sCount[nextLine] < state.blkIndent) return false;
    // limit conditions when list can interrupt
    // a paragraph (validation mode only)
    if (silent && state.parentType === 'paragraph') // Next list item should still terminate previous list item;
    //
    // This code can fail if plugins use blkIndent as well as lists,
    // but I hope the spec gets fixed long before that happens.
    //
    {
        if (state.sCount[nextLine] >= state.blkIndent) isTerminatingParagraph = true;
    }
    // Detect list type and position after marker
    if ((posAfterMarker = $70988c00697c25f3$var$skipOrderedListMarker(state, nextLine)) >= 0) {
        isOrdered = true;
        start = state.bMarks[nextLine] + state.tShift[nextLine];
        markerValue = Number(state.src.slice(start, posAfterMarker - 1));
        // If we're starting a new ordered list right after
        // a paragraph, it should start with 1.
        if (isTerminatingParagraph && markerValue !== 1) return false;
    } else if ((posAfterMarker = $70988c00697c25f3$var$skipBulletListMarker(state, nextLine)) >= 0) isOrdered = false;
    else return false;
    // If we're starting a new unordered list right after
    // a paragraph, first line should not be empty.
    if (isTerminatingParagraph) {
        if (state.skipSpaces(posAfterMarker) >= state.eMarks[nextLine]) return false;
    }
    // For validation mode we can terminate immediately
    if (silent) return true;
    // We should terminate list on style change. Remember first one to compare.
    markerCharCode = state.src.charCodeAt(posAfterMarker - 1);
    // Start list
    listTokIdx = state.tokens.length;
    if (isOrdered) {
        token = state.push('ordered_list_open', 'ol', 1);
        if (markerValue !== 1) token.attrs = [
            [
                'start',
                markerValue
            ]
        ];
    } else token = state.push('bullet_list_open', 'ul', 1);
    token.map = listLines = [
        nextLine,
        0
    ];
    token.markup = String.fromCharCode(markerCharCode);
    //
    // Iterate list items
    //
    prevEmptyEnd = false;
    terminatorRules = state.md.block.ruler.getRules('list');
    oldParentType = state.parentType;
    state.parentType = 'list';
    while(nextLine < endLine){
        pos = posAfterMarker;
        max = state.eMarks[nextLine];
        initial = offset = state.sCount[nextLine] + posAfterMarker - (state.bMarks[nextLine] + state.tShift[nextLine]);
        while(pos < max){
            ch = state.src.charCodeAt(pos);
            if (ch === 0x09) offset += 4 - (offset + state.bsCount[nextLine]) % 4;
            else if (ch === 0x20) offset++;
            else break;
            pos++;
        }
        contentStart = pos;
        if (contentStart >= max) // trimming space in "-    \n  3" case, indent is 1 here
        indentAfterMarker = 1;
        else indentAfterMarker = offset - initial;
        // If we have more than 4 spaces, the indent is 1
        // (the rest is just indented code block)
        if (indentAfterMarker > 4) indentAfterMarker = 1;
        // "  -  test"
        //  ^^^^^ - calculating total length of this thing
        indent = initial + indentAfterMarker;
        // Run subparser & write tokens
        token = state.push('list_item_open', 'li', 1);
        token.markup = String.fromCharCode(markerCharCode);
        token.map = itemLines = [
            nextLine,
            0
        ];
        if (isOrdered) token.info = state.src.slice(start, posAfterMarker - 1);
        // change current state, then restore it after parser subcall
        oldTight = state.tight;
        oldTShift = state.tShift[nextLine];
        oldSCount = state.sCount[nextLine];
        //  - example list
        // ^ listIndent position will be here
        //   ^ blkIndent position will be here
        //
        oldListIndent = state.listIndent;
        state.listIndent = state.blkIndent;
        state.blkIndent = indent;
        state.tight = true;
        state.tShift[nextLine] = contentStart - state.bMarks[nextLine];
        state.sCount[nextLine] = offset;
        if (contentStart >= max && state.isEmpty(nextLine + 1)) // workaround for this case
        // (list item is empty, list terminates before "foo"):
        // ~~~~~~~~
        //   -
        //
        //     foo
        // ~~~~~~~~
        state.line = Math.min(state.line + 2, endLine);
        else state.md.block.tokenize(state, nextLine, endLine, true);
        // If any of list item is tight, mark list as tight
        if (!state.tight || prevEmptyEnd) tight = false;
        // Item become loose if finish with empty line,
        // but we should filter last element, because it means list finish
        prevEmptyEnd = state.line - nextLine > 1 && state.isEmpty(state.line - 1);
        state.blkIndent = state.listIndent;
        state.listIndent = oldListIndent;
        state.tShift[nextLine] = oldTShift;
        state.sCount[nextLine] = oldSCount;
        state.tight = oldTight;
        token = state.push('list_item_close', 'li', -1);
        token.markup = String.fromCharCode(markerCharCode);
        nextLine = state.line;
        itemLines[1] = nextLine;
        if (nextLine >= endLine) break;
        //
        // Try to check if list is terminated or continued.
        //
        if (state.sCount[nextLine] < state.blkIndent) break;
        // if it's indented more than 3 spaces, it should be a code block
        if (state.sCount[nextLine] - state.blkIndent >= 4) break;
        // fail if terminating block found
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
        // fail if list has another type
        if (isOrdered) {
            posAfterMarker = $70988c00697c25f3$var$skipOrderedListMarker(state, nextLine);
            if (posAfterMarker < 0) break;
            start = state.bMarks[nextLine] + state.tShift[nextLine];
        } else {
            posAfterMarker = $70988c00697c25f3$var$skipBulletListMarker(state, nextLine);
            if (posAfterMarker < 0) break;
        }
        if (markerCharCode !== state.src.charCodeAt(posAfterMarker - 1)) break;
    }
    // Finalize list
    if (isOrdered) token = state.push('ordered_list_close', 'ol', -1);
    else token = state.push('bullet_list_close', 'ul', -1);
    token.markup = String.fromCharCode(markerCharCode);
    listLines[1] = nextLine;
    state.line = nextLine;
    state.parentType = oldParentType;
    // mark paragraphs tight if needed
    if (tight) $70988c00697c25f3$var$markTightParagraphs(state, listTokIdx);
    return true;
};

});

parcelRegister("dabWb", function(module, exports) {
'use strict';

var $hslaz = parcelRequire("hslaz");

var $9955780ed064193a$require$normalizeReference = $hslaz.normalizeReference;



var $9955780ed064193a$require$isSpace = $hslaz.isSpace;
module.exports = function reference(state, startLine, _endLine, silent) {
    var ch, destEndPos, destEndLineNo, endLine, href, i, l, label, labelEnd, oldParentType, res, start, str, terminate, terminatorRules, title, lines = 0, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine], nextLine = startLine + 1;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (state.src.charCodeAt(pos) !== 0x5B /* [ */ ) return false;
    // Simple check to quickly interrupt scan on [link](url) at the start of line.
    // Can be useful on practice: https://github.com/markdown-it/markdown-it/issues/54
    while(++pos < max)if (state.src.charCodeAt(pos) === 0x5D /* ] */  && state.src.charCodeAt(pos - 1) !== 0x5C /* \ */ ) {
        if (pos + 1 === max) return false;
        if (state.src.charCodeAt(pos + 1) !== 0x3A /* : */ ) return false;
        break;
    }
    endLine = state.lineMax;
    // jump line-by-line until empty one or EOF
    terminatorRules = state.md.block.ruler.getRules('reference');
    oldParentType = state.parentType;
    state.parentType = 'reference';
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    str = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    max = str.length;
    for(pos = 1; pos < max; pos++){
        ch = str.charCodeAt(pos);
        if (ch === 0x5B /* [ */ ) return false;
        else if (ch === 0x5D /* ] */ ) {
            labelEnd = pos;
            break;
        } else if (ch === 0x0A /* \n */ ) lines++;
        else if (ch === 0x5C /* \ */ ) {
            pos++;
            if (pos < max && str.charCodeAt(pos) === 0x0A) lines++;
        }
    }
    if (labelEnd < 0 || str.charCodeAt(labelEnd + 1) !== 0x3A /* : */ ) return false;
    // [label]:   destination   'title'
    //         ^^^ skip optional whitespace here
    for(pos = labelEnd + 2; pos < max; pos++){
        ch = str.charCodeAt(pos);
        if (ch === 0x0A) lines++;
        else if ($9955780ed064193a$require$isSpace(ch)) ;
        else break;
    }
    // [label]:   destination   'title'
    //            ^^^^^^^^^^^ parse this
    res = state.md.helpers.parseLinkDestination(str, pos, max);
    if (!res.ok) return false;
    href = state.md.normalizeLink(res.str);
    if (!state.md.validateLink(href)) return false;
    pos = res.pos;
    lines += res.lines;
    // save cursor state, we could require to rollback later
    destEndPos = pos;
    destEndLineNo = lines;
    // [label]:   destination   'title'
    //                       ^^^ skipping those spaces
    start = pos;
    for(; pos < max; pos++){
        ch = str.charCodeAt(pos);
        if (ch === 0x0A) lines++;
        else if ($9955780ed064193a$require$isSpace(ch)) ;
        else break;
    }
    // [label]:   destination   'title'
    //                          ^^^^^^^ parse this
    res = state.md.helpers.parseLinkTitle(str, pos, max);
    if (pos < max && start !== pos && res.ok) {
        title = res.str;
        pos = res.pos;
        lines += res.lines;
    } else {
        title = '';
        pos = destEndPos;
        lines = destEndLineNo;
    }
    // skip trailing spaces until the rest of the line
    while(pos < max){
        ch = str.charCodeAt(pos);
        if (!$9955780ed064193a$require$isSpace(ch)) break;
        pos++;
    }
    if (pos < max && str.charCodeAt(pos) !== 0x0A) {
        if (title) {
            // garbage at the end of the line after title,
            // but it could still be a valid reference if we roll back
            title = '';
            pos = destEndPos;
            lines = destEndLineNo;
            while(pos < max){
                ch = str.charCodeAt(pos);
                if (!$9955780ed064193a$require$isSpace(ch)) break;
                pos++;
            }
        }
    }
    if (pos < max && str.charCodeAt(pos) !== 0x0A) // garbage at the end of the line
    return false;
    label = $9955780ed064193a$require$normalizeReference(str.slice(1, labelEnd));
    if (!label) // CommonMark 0.20 disallows empty labels
    return false;
    // Reference can not terminate anything. This check is for safety only.
    /*istanbul ignore if*/ if (silent) return true;
    if (typeof state.env.references === 'undefined') state.env.references = {};
    if (typeof state.env.references[label] === 'undefined') state.env.references[label] = {
        title: title,
        href: href
    };
    state.parentType = oldParentType;
    state.line = startLine + lines + 1;
    return true;
};

});

parcelRegister("55Egx", function(module, exports) {
// HTML block
'use strict';
var $d4267c6d729a0e24$exports = {};
// List of valid html blocks names, accorting to commonmark spec
// http://jgm.github.io/CommonMark/spec.html#html-blocks
'use strict';
$d4267c6d729a0e24$exports = [
    'address',
    'article',
    'aside',
    'base',
    'basefont',
    'blockquote',
    'body',
    'caption',
    'center',
    'col',
    'colgroup',
    'dd',
    'details',
    'dialog',
    'dir',
    'div',
    'dl',
    'dt',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'frame',
    'frameset',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hr',
    'html',
    'iframe',
    'legend',
    'li',
    'link',
    'main',
    'menu',
    'menuitem',
    'nav',
    'noframes',
    'ol',
    'optgroup',
    'option',
    'p',
    'param',
    'section',
    'source',
    'summary',
    'table',
    'tbody',
    'td',
    'tfoot',
    'th',
    'thead',
    'title',
    'tr',
    'track',
    'ul'
];



var $dgyOV = parcelRequire("dgyOV");

var $3b4ca754d15deb34$require$HTML_OPEN_CLOSE_TAG_RE = $dgyOV.HTML_OPEN_CLOSE_TAG_RE;
// An array of opening and corresponding closing sequences for html tags,
// last argument defines whether it can terminate a paragraph or not
//
var $3b4ca754d15deb34$var$HTML_SEQUENCES = [
    [
        /^<(script|pre|style|textarea)(?=(\s|>|$))/i,
        /<\/(script|pre|style|textarea)>/i,
        true
    ],
    [
        /^<!--/,
        /-->/,
        true
    ],
    [
        /^<\?/,
        /\?>/,
        true
    ],
    [
        /^<![A-Z]/,
        />/,
        true
    ],
    [
        /^<!\[CDATA\[/,
        /\]\]>/,
        true
    ],
    [
        new RegExp('^</?(' + $d4267c6d729a0e24$exports.join('|') + ')(?=(\\s|/?>|$))', 'i'),
        /^$/,
        true
    ],
    [
        new RegExp($3b4ca754d15deb34$require$HTML_OPEN_CLOSE_TAG_RE.source + '\\s*$'),
        /^$/,
        false
    ]
];
module.exports = function html_block(state, startLine, endLine, silent) {
    var i, nextLine, token, lineText, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (!state.md.options.html) return false;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */ ) return false;
    lineText = state.src.slice(pos, max);
    for(i = 0; i < $3b4ca754d15deb34$var$HTML_SEQUENCES.length; i++){
        if ($3b4ca754d15deb34$var$HTML_SEQUENCES[i][0].test(lineText)) break;
    }
    if (i === $3b4ca754d15deb34$var$HTML_SEQUENCES.length) return false;
    if (silent) // true if this sequence can be a terminator, false otherwise
    return $3b4ca754d15deb34$var$HTML_SEQUENCES[i][2];
    nextLine = startLine + 1;
    // If we are here - we detected HTML block.
    // Let's roll down till block end.
    if (!$3b4ca754d15deb34$var$HTML_SEQUENCES[i][1].test(lineText)) for(; nextLine < endLine; nextLine++){
        if (state.sCount[nextLine] < state.blkIndent) break;
        pos = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        lineText = state.src.slice(pos, max);
        if ($3b4ca754d15deb34$var$HTML_SEQUENCES[i][1].test(lineText)) {
            if (lineText.length !== 0) nextLine++;
            break;
        }
    }
    state.line = nextLine;
    token = state.push('html_block', '', 0);
    token.map = [
        startLine,
        nextLine
    ];
    token.content = state.getLines(startLine, nextLine, state.blkIndent, true);
    return true;
};

});

parcelRegister("9Dg2w", function(module, exports) {
// heading (#, ##, ...)
'use strict';

var $hslaz = parcelRequire("hslaz");

var $703432bd8385f5a8$require$isSpace = $hslaz.isSpace;
module.exports = function heading(state, startLine, endLine, silent) {
    var ch, level, tmp, token, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    ch = state.src.charCodeAt(pos);
    if (ch !== 0x23 /* # */  || pos >= max) return false;
    // count heading level
    level = 1;
    ch = state.src.charCodeAt(++pos);
    while(ch === 0x23 /* # */  && pos < max && level <= 6){
        level++;
        ch = state.src.charCodeAt(++pos);
    }
    if (level > 6 || pos < max && !$703432bd8385f5a8$require$isSpace(ch)) return false;
    if (silent) return true;
    // Let's cut tails like '    ###  ' from the end of string
    max = state.skipSpacesBack(max, pos);
    tmp = state.skipCharsBack(max, 0x23, pos); // #
    if (tmp > pos && $703432bd8385f5a8$require$isSpace(state.src.charCodeAt(tmp - 1))) max = tmp;
    state.line = startLine + 1;
    token = state.push('heading_open', 'h' + String(level), 1);
    token.markup = '########'.slice(0, level);
    token.map = [
        startLine,
        state.line
    ];
    token = state.push('inline', '', 0);
    token.content = state.src.slice(pos, max).trim();
    token.map = [
        startLine,
        state.line
    ];
    token.children = [];
    token = state.push('heading_close', 'h' + String(level), -1);
    token.markup = '########'.slice(0, level);
    return true;
};

});

parcelRegister("JBg9j", function(module, exports) {
// lheading (---, ===)
'use strict';
module.exports = function lheading(state, startLine, endLine /*, silent*/ ) {
    var content, terminate, i, l, token, pos, max, level, marker, nextLine = startLine + 1, oldParentType, terminatorRules = state.md.block.ruler.getRules('paragraph');
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    oldParentType = state.parentType;
    state.parentType = 'paragraph'; // use paragraph to match terminatorRules
    // jump line-by-line until empty one or EOF
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        //
        // Check for underline in setext header
        //
        if (state.sCount[nextLine] >= state.blkIndent) {
            pos = state.bMarks[nextLine] + state.tShift[nextLine];
            max = state.eMarks[nextLine];
            if (pos < max) {
                marker = state.src.charCodeAt(pos);
                if (marker === 0x2D /* - */  || marker === 0x3D /* = */ ) {
                    pos = state.skipChars(pos, marker);
                    pos = state.skipSpaces(pos);
                    if (pos >= max) {
                        level = marker === 0x3D /* = */  ? 1 : 2;
                        break;
                    }
                }
            }
        }
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    if (!level) // Didn't find valid underline
    return false;
    content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    state.line = nextLine + 1;
    token = state.push('heading_open', 'h' + String(level), 1);
    token.markup = String.fromCharCode(marker);
    token.map = [
        startLine,
        state.line
    ];
    token = state.push('inline', '', 0);
    token.content = content;
    token.map = [
        startLine,
        state.line - 1
    ];
    token.children = [];
    token = state.push('heading_close', 'h' + String(level), -1);
    token.markup = String.fromCharCode(marker);
    state.parentType = oldParentType;
    return true;
};

});

parcelRegister("15GMD", function(module, exports) {
// Paragraph
'use strict';
module.exports = function paragraph(state, startLine, endLine) {
    var content, terminate, i, l, token, oldParentType, nextLine = startLine + 1, terminatorRules = state.md.block.ruler.getRules('paragraph');
    oldParentType = state.parentType;
    state.parentType = 'paragraph';
    // jump line-by-line until empty one or EOF
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    state.line = nextLine;
    token = state.push('paragraph_open', 'p', 1);
    token.map = [
        startLine,
        state.line
    ];
    token = state.push('inline', '', 0);
    token.content = content;
    token.map = [
        startLine,
        state.line
    ];
    token.children = [];
    token = state.push('paragraph_close', 'p', -1);
    state.parentType = oldParentType;
    return true;
};

});

parcelRegister("6eyHE", function(module, exports) {
// Parser state class
'use strict';

var $flZnN = parcelRequire("flZnN");


var $hslaz = parcelRequire("hslaz");

var $489ef82a8db12637$require$isSpace = $hslaz.isSpace;
function $489ef82a8db12637$var$StateBlock(src, md, env, tokens) {
    var ch, s, start, pos, len, indent, offset, indent_found;
    this.src = src;
    // link to parser instance
    this.md = md;
    this.env = env;
    //
    // Internal state vartiables
    //
    this.tokens = tokens;
    this.bMarks = []; // line begin offsets for fast jumps
    this.eMarks = []; // line end offsets for fast jumps
    this.tShift = []; // offsets of the first non-space characters (tabs not expanded)
    this.sCount = []; // indents for each line (tabs expanded)
    // An amount of virtual spaces (tabs expanded) between beginning
    // of each line (bMarks) and real beginning of that line.
    //
    // It exists only as a hack because blockquotes override bMarks
    // losing information in the process.
    //
    // It's used only when expanding tabs, you can think about it as
    // an initial tab length, e.g. bsCount=21 applied to string `\t123`
    // means first tab should be expanded to 4-21%4 === 3 spaces.
    //
    this.bsCount = [];
    // block parser variables
    this.blkIndent = 0; // required block content indent (for example, if we are
    // inside a list, it would be positioned after list marker)
    this.line = 0; // line index in src
    this.lineMax = 0; // lines count
    this.tight = false; // loose/tight mode for lists
    this.ddIndent = -1; // indent of the current dd block (-1 if there isn't any)
    this.listIndent = -1; // indent of the current list block (-1 if there isn't any)
    // can be 'blockquote', 'list', 'root', 'paragraph' or 'reference'
    // used in lists to determine if they interrupt a paragraph
    this.parentType = 'root';
    this.level = 0;
    // renderer
    this.result = '';
    // Create caches
    // Generate markers.
    s = this.src;
    indent_found = false;
    for(start = pos = indent = offset = 0, len = s.length; pos < len; pos++){
        ch = s.charCodeAt(pos);
        if (!indent_found) {
            if ($489ef82a8db12637$require$isSpace(ch)) {
                indent++;
                if (ch === 0x09) offset += 4 - offset % 4;
                else offset++;
                continue;
            } else indent_found = true;
        }
        if (ch === 0x0A || pos === len - 1) {
            if (ch !== 0x0A) pos++;
            this.bMarks.push(start);
            this.eMarks.push(pos);
            this.tShift.push(indent);
            this.sCount.push(offset);
            this.bsCount.push(0);
            indent_found = false;
            indent = 0;
            offset = 0;
            start = pos + 1;
        }
    }
    // Push fake entry to simplify cache bounds checks
    this.bMarks.push(s.length);
    this.eMarks.push(s.length);
    this.tShift.push(0);
    this.sCount.push(0);
    this.bsCount.push(0);
    this.lineMax = this.bMarks.length - 1; // don't count last fake line
}
// Push new token to "stream".
//
$489ef82a8db12637$var$StateBlock.prototype.push = function(type, tag, nesting) {
    var token = new $flZnN(type, tag, nesting);
    token.block = true;
    if (nesting < 0) this.level--; // closing tag
    token.level = this.level;
    if (nesting > 0) this.level++; // opening tag
    this.tokens.push(token);
    return token;
};
$489ef82a8db12637$var$StateBlock.prototype.isEmpty = function isEmpty(line) {
    return this.bMarks[line] + this.tShift[line] >= this.eMarks[line];
};
$489ef82a8db12637$var$StateBlock.prototype.skipEmptyLines = function skipEmptyLines(from) {
    for(var max = this.lineMax; from < max; from++){
        if (this.bMarks[from] + this.tShift[from] < this.eMarks[from]) break;
    }
    return from;
};
// Skip spaces from given position.
$489ef82a8db12637$var$StateBlock.prototype.skipSpaces = function skipSpaces(pos) {
    var ch;
    for(var max = this.src.length; pos < max; pos++){
        ch = this.src.charCodeAt(pos);
        if (!$489ef82a8db12637$require$isSpace(ch)) break;
    }
    return pos;
};
// Skip spaces from given position in reverse.
$489ef82a8db12637$var$StateBlock.prototype.skipSpacesBack = function skipSpacesBack(pos, min) {
    if (pos <= min) return pos;
    while(pos > min){
        if (!$489ef82a8db12637$require$isSpace(this.src.charCodeAt(--pos))) return pos + 1;
    }
    return pos;
};
// Skip char codes from given position
$489ef82a8db12637$var$StateBlock.prototype.skipChars = function skipChars(pos, code) {
    for(var max = this.src.length; pos < max; pos++){
        if (this.src.charCodeAt(pos) !== code) break;
    }
    return pos;
};
// Skip char codes reverse from given position - 1
$489ef82a8db12637$var$StateBlock.prototype.skipCharsBack = function skipCharsBack(pos, code, min) {
    if (pos <= min) return pos;
    while(pos > min){
        if (code !== this.src.charCodeAt(--pos)) return pos + 1;
    }
    return pos;
};
// cut lines range from source.
$489ef82a8db12637$var$StateBlock.prototype.getLines = function getLines(begin, end, indent, keepLastLF) {
    var i, lineIndent, ch, first, last, queue, lineStart, line = begin;
    if (begin >= end) return '';
    queue = new Array(end - begin);
    for(i = 0; line < end; line++, i++){
        lineIndent = 0;
        lineStart = first = this.bMarks[line];
        if (line + 1 < end || keepLastLF) // No need for bounds check because we have fake entry on tail.
        last = this.eMarks[line] + 1;
        else last = this.eMarks[line];
        while(first < last && lineIndent < indent){
            ch = this.src.charCodeAt(first);
            if ($489ef82a8db12637$require$isSpace(ch)) {
                if (ch === 0x09) lineIndent += 4 - (lineIndent + this.bsCount[line]) % 4;
                else lineIndent++;
            } else if (first - lineStart < this.tShift[line]) // patched tShift masked characters to look like spaces (blockquotes, list markers)
            lineIndent++;
            else break;
            first++;
        }
        if (lineIndent > indent) // partially expanding tabs in code blocks, e.g '\t\tfoobar'
        // with indent=2 becomes '  \tfoobar'
        queue[i] = new Array(lineIndent - indent + 1).join(' ') + this.src.slice(first, last);
        else queue[i] = this.src.slice(first, last);
    }
    return queue.join('');
};
// re-export Token class to use in block rules
$489ef82a8db12637$var$StateBlock.prototype.Token = $flZnN;
module.exports = $489ef82a8db12637$var$StateBlock;

});

parcelRegister("1U2TG", function(module, exports) {
// Skip text characters for text token, place those to pending buffer
// and increment current pos
'use strict';
// Rule to skip pure text
// '{}$%@~+=:' reserved for extentions
// !, ", #, $, %, &, ', (, ), *, +, ,, -, ., /, :, ;, <, =, >, ?, @, [, \, ], ^, _, `, {, |, }, or ~
// !!!! Don't confuse with "Markdown ASCII Punctuation" chars
// http://spec.commonmark.org/0.15/#ascii-punctuation-character
function $162d44bcf2210f80$var$isTerminatorChar(ch) {
    switch(ch){
        case 0x0A /* \n */ :
        case 0x21 /* ! */ :
        case 0x23 /* # */ :
        case 0x24 /* $ */ :
        case 0x25 /* % */ :
        case 0x26 /* & */ :
        case 0x2A /* * */ :
        case 0x2B /* + */ :
        case 0x2D /* - */ :
        case 0x3A /* : */ :
        case 0x3C /* < */ :
        case 0x3D /* = */ :
        case 0x3E /* > */ :
        case 0x40 /* @ */ :
        case 0x5B /* [ */ :
        case 0x5C /* \ */ :
        case 0x5D /* ] */ :
        case 0x5E /* ^ */ :
        case 0x5F /* _ */ :
        case 0x60 /* ` */ :
        case 0x7B /* { */ :
        case 0x7D /* } */ :
        case 0x7E /* ~ */ :
            return true;
        default:
            return false;
    }
}
module.exports = function text(state, silent) {
    var pos = state.pos;
    while(pos < state.posMax && !$162d44bcf2210f80$var$isTerminatorChar(state.src.charCodeAt(pos)))pos++;
    if (pos === state.pos) return false;
    if (!silent) state.pending += state.src.slice(state.pos, pos);
    state.pos = pos;
    return true;
}; // Alternative implementation, for memory.
 //
 // It costs 10% of performance, but allows extend terminators list, if place it
 // to `ParcerInline` property. Probably, will switch to it sometime, such
 // flexibility required.
 /*
var TERMINATOR_RE = /[\n!#$%&*+\-:<=>@[\\\]^_`{}~]/;

module.exports = function text(state, silent) {
  var pos = state.pos,
      idx = state.src.slice(pos).search(TERMINATOR_RE);

  // first char is terminator -> empty text
  if (idx === 0) { return false; }

  // no terminator -> text till end of string
  if (idx < 0) {
    if (!silent) { state.pending += state.src.slice(pos); }
    state.pos = state.src.length;
    return true;
  }

  if (!silent) { state.pending += state.src.slice(pos, pos + idx); }

  state.pos += idx;

  return true;
};*/ 

});

parcelRegister("lqNlw", function(module, exports) {
// Process links like https://example.org/
'use strict';
// RFC3986: scheme = ALPHA *( ALPHA / DIGIT / "+" / "-" / "." )
var $f9a24dc6ed71c1cf$var$SCHEME_RE = /(?:^|[^a-z0-9.+-])([a-z][a-z0-9.+-]*)$/i;
module.exports = function linkify(state, silent) {
    var pos, max, match, proto, link, url, fullUrl, token;
    if (!state.md.options.linkify) return false;
    if (state.linkLevel > 0) return false;
    pos = state.pos;
    max = state.posMax;
    if (pos + 3 > max) return false;
    if (state.src.charCodeAt(pos) !== 0x3A /* : */ ) return false;
    if (state.src.charCodeAt(pos + 1) !== 0x2F /* / */ ) return false;
    if (state.src.charCodeAt(pos + 2) !== 0x2F /* / */ ) return false;
    match = state.pending.match($f9a24dc6ed71c1cf$var$SCHEME_RE);
    if (!match) return false;
    proto = match[1];
    link = state.md.linkify.matchAtStart(state.src.slice(pos - proto.length));
    if (!link) return false;
    url = link.url;
    // invalid link, but still detected by linkify somehow;
    // need to check to prevent infinite loop below
    if (url.length <= proto.length) return false;
    // disallow '*' at the end of the link (conflicts with emphasis)
    url = url.replace(/\*+$/, '');
    fullUrl = state.md.normalizeLink(url);
    if (!state.md.validateLink(fullUrl)) return false;
    if (!silent) {
        state.pending = state.pending.slice(0, -proto.length);
        token = state.push('link_open', 'a', 1);
        token.attrs = [
            [
                'href',
                fullUrl
            ]
        ];
        token.markup = 'linkify';
        token.info = 'auto';
        token = state.push('text', '', 0);
        token.content = state.md.normalizeLinkText(url);
        token = state.push('link_close', 'a', -1);
        token.markup = 'linkify';
        token.info = 'auto';
    }
    state.pos += url.length - proto.length;
    return true;
};

});

parcelRegister("iek5k", function(module, exports) {
// Proceess '\n'
'use strict';

var $hslaz = parcelRequire("hslaz");

var $d4591d407ff4291e$require$isSpace = $hslaz.isSpace;
module.exports = function newline(state, silent) {
    var pmax, max, ws, pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x0A /* \n */ ) return false;
    pmax = state.pending.length - 1;
    max = state.posMax;
    // '  \n' -> hardbreak
    // Lookup in pending chars is bad practice! Don't copy to other rules!
    // Pending string is stored in concat mode, indexed lookups will cause
    // convertion to flat mode.
    if (!silent) {
        if (pmax >= 0 && state.pending.charCodeAt(pmax) === 0x20) {
            if (pmax >= 1 && state.pending.charCodeAt(pmax - 1) === 0x20) {
                // Find whitespaces tail of pending chars.
                ws = pmax - 1;
                while(ws >= 1 && state.pending.charCodeAt(ws - 1) === 0x20)ws--;
                state.pending = state.pending.slice(0, ws);
                state.push('hardbreak', 'br', 0);
            } else {
                state.pending = state.pending.slice(0, -1);
                state.push('softbreak', 'br', 0);
            }
        } else state.push('softbreak', 'br', 0);
    }
    pos++;
    // skip heading spaces for next line
    while(pos < max && $d4591d407ff4291e$require$isSpace(state.src.charCodeAt(pos)))pos++;
    state.pos = pos;
    return true;
};

});

parcelRegister("8Nqk1", function(module, exports) {
// Process escaped chars and hardbreaks
'use strict';

var $hslaz = parcelRequire("hslaz");

var $667751518864ee40$require$isSpace = $hslaz.isSpace;
var $667751518864ee40$var$ESCAPED = [];
for(var $667751518864ee40$var$i = 0; $667751518864ee40$var$i < 256; $667751518864ee40$var$i++)$667751518864ee40$var$ESCAPED.push(0);
'\\!"#$%&\'()*+,./:;<=>?@[]^_`{|}~-'.split('').forEach(function(ch) {
    $667751518864ee40$var$ESCAPED[ch.charCodeAt(0)] = 1;
});
module.exports = function escape(state, silent) {
    var ch1, ch2, origStr, escapedStr, token, pos = state.pos, max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x5C /* \ */ ) return false;
    pos++;
    // '\' at the end of the inline block
    if (pos >= max) return false;
    ch1 = state.src.charCodeAt(pos);
    if (ch1 === 0x0A) {
        if (!silent) state.push('hardbreak', 'br', 0);
        pos++;
        // skip leading whitespaces from next line
        while(pos < max){
            ch1 = state.src.charCodeAt(pos);
            if (!$667751518864ee40$require$isSpace(ch1)) break;
            pos++;
        }
        state.pos = pos;
        return true;
    }
    escapedStr = state.src[pos];
    if (ch1 >= 0xD800 && ch1 <= 0xDBFF && pos + 1 < max) {
        ch2 = state.src.charCodeAt(pos + 1);
        if (ch2 >= 0xDC00 && ch2 <= 0xDFFF) {
            escapedStr += state.src[pos + 1];
            pos++;
        }
    }
    origStr = '\\' + escapedStr;
    if (!silent) {
        token = state.push('text_special', '', 0);
        if (ch1 < 256 && $667751518864ee40$var$ESCAPED[ch1] !== 0) token.content = escapedStr;
        else token.content = origStr;
        token.markup = origStr;
        token.info = 'escape';
    }
    state.pos = pos + 1;
    return true;
};

});

parcelRegister("dPP48", function(module, exports) {
// Parse backticks
'use strict';
module.exports = function backtick(state, silent) {
    var start, max, marker, token, matchStart, matchEnd, openerLength, closerLength, pos = state.pos, ch = state.src.charCodeAt(pos);
    if (ch !== 0x60 /* ` */ ) return false;
    start = pos;
    pos++;
    max = state.posMax;
    // scan marker length
    while(pos < max && state.src.charCodeAt(pos) === 0x60 /* ` */ )pos++;
    marker = state.src.slice(start, pos);
    openerLength = marker.length;
    if (state.backticksScanned && (state.backticks[openerLength] || 0) <= start) {
        if (!silent) state.pending += marker;
        state.pos += openerLength;
        return true;
    }
    matchEnd = pos;
    // Nothing found in the cache, scan until the end of the line (or until marker is found)
    while((matchStart = state.src.indexOf('`', matchEnd)) !== -1){
        matchEnd = matchStart + 1;
        // scan marker length
        while(matchEnd < max && state.src.charCodeAt(matchEnd) === 0x60 /* ` */ )matchEnd++;
        closerLength = matchEnd - matchStart;
        if (closerLength === openerLength) {
            // Found matching closer length.
            if (!silent) {
                token = state.push('code_inline', 'code', 0);
                token.markup = marker;
                token.content = state.src.slice(pos, matchStart).replace(/\n/g, ' ').replace(/^ (.+) $/, '$1');
            }
            state.pos = matchEnd;
            return true;
        }
        // Some different length found, put it in cache as upper limit of where closer can be found
        state.backticks[closerLength] = matchStart;
    }
    // Scanned through the end, didn't find anything
    state.backticksScanned = true;
    if (!silent) state.pending += marker;
    state.pos += openerLength;
    return true;
};

});

parcelRegister("45axw", function(module, exports) {
$parcel$export(module.exports, "tokenize", () => $2f8fce09eee1cd09$export$660b2ee2d4fb4eff, (v) => $2f8fce09eee1cd09$export$660b2ee2d4fb4eff = v);
$parcel$export(module.exports, "postProcess", () => $2f8fce09eee1cd09$export$7b804a0e0ce836d9, (v) => $2f8fce09eee1cd09$export$7b804a0e0ce836d9 = v);
// ~~strike through~~
//
// Insert each marker as a separate text token, and add it to delimiter list
//
var $2f8fce09eee1cd09$export$660b2ee2d4fb4eff;
// Walk through delimiter list and replace text tokens with tags
//
var $2f8fce09eee1cd09$export$7b804a0e0ce836d9;
'use strict';
$2f8fce09eee1cd09$export$660b2ee2d4fb4eff = function strikethrough(state, silent) {
    var i, scanned, token, len, ch, start = state.pos, marker = state.src.charCodeAt(start);
    if (silent) return false;
    if (marker !== 0x7E /* ~ */ ) return false;
    scanned = state.scanDelims(state.pos, true);
    len = scanned.length;
    ch = String.fromCharCode(marker);
    if (len < 2) return false;
    if (len % 2) {
        token = state.push('text', '', 0);
        token.content = ch;
        len--;
    }
    for(i = 0; i < len; i += 2){
        token = state.push('text', '', 0);
        token.content = ch + ch;
        state.delimiters.push({
            marker: marker,
            length: 0,
            token: state.tokens.length - 1,
            end: -1,
            open: scanned.can_open,
            close: scanned.can_close
        });
    }
    state.pos += scanned.length;
    return true;
};
function $2f8fce09eee1cd09$var$postProcess(state, delimiters) {
    var i, j, startDelim, endDelim, token, loneMarkers = [], max = delimiters.length;
    for(i = 0; i < max; i++){
        startDelim = delimiters[i];
        if (startDelim.marker !== 0x7E /* ~ */ ) continue;
        if (startDelim.end === -1) continue;
        endDelim = delimiters[startDelim.end];
        token = state.tokens[startDelim.token];
        token.type = 's_open';
        token.tag = 's';
        token.nesting = 1;
        token.markup = '~~';
        token.content = '';
        token = state.tokens[endDelim.token];
        token.type = 's_close';
        token.tag = 's';
        token.nesting = -1;
        token.markup = '~~';
        token.content = '';
        if (state.tokens[endDelim.token - 1].type === 'text' && state.tokens[endDelim.token - 1].content === '~') loneMarkers.push(endDelim.token - 1);
    }
    // If a marker sequence has an odd number of characters, it's splitted
    // like this: `~~~~~` -> `~` + `~~` + `~~`, leaving one marker at the
    // start of the sequence.
    //
    // So, we have to move all those markers after subsequent s_close tags.
    //
    while(loneMarkers.length){
        i = loneMarkers.pop();
        j = i + 1;
        while(j < state.tokens.length && state.tokens[j].type === 's_close')j++;
        j--;
        if (i !== j) {
            token = state.tokens[j];
            state.tokens[j] = state.tokens[i];
            state.tokens[i] = token;
        }
    }
}
$2f8fce09eee1cd09$export$7b804a0e0ce836d9 = function strikethrough(state) {
    var curr, tokens_meta = state.tokens_meta, max = state.tokens_meta.length;
    $2f8fce09eee1cd09$var$postProcess(state, state.delimiters);
    for(curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $2f8fce09eee1cd09$var$postProcess(state, tokens_meta[curr].delimiters);
};

});

parcelRegister("dPUa6", function(module, exports) {
$parcel$export(module.exports, "tokenize", () => $a12b9a62937f3652$export$660b2ee2d4fb4eff, (v) => $a12b9a62937f3652$export$660b2ee2d4fb4eff = v);
$parcel$export(module.exports, "postProcess", () => $a12b9a62937f3652$export$7b804a0e0ce836d9, (v) => $a12b9a62937f3652$export$7b804a0e0ce836d9 = v);
// Process *this* and _that_
//
// Insert each marker as a separate text token, and add it to delimiter list
//
var $a12b9a62937f3652$export$660b2ee2d4fb4eff;
// Walk through delimiter list and replace text tokens with tags
//
var $a12b9a62937f3652$export$7b804a0e0ce836d9;
'use strict';
$a12b9a62937f3652$export$660b2ee2d4fb4eff = function emphasis(state, silent) {
    var i, scanned, token, start = state.pos, marker = state.src.charCodeAt(start);
    if (silent) return false;
    if (marker !== 0x5F /* _ */  && marker !== 0x2A /* * */ ) return false;
    scanned = state.scanDelims(state.pos, marker === 0x2A);
    for(i = 0; i < scanned.length; i++){
        token = state.push('text', '', 0);
        token.content = String.fromCharCode(marker);
        state.delimiters.push({
            // Char code of the starting marker (number).
            //
            marker: marker,
            // Total length of these series of delimiters.
            //
            length: scanned.length,
            // A position of the token this delimiter corresponds to.
            //
            token: state.tokens.length - 1,
            // If this delimiter is matched as a valid opener, `end` will be
            // equal to its position, otherwise it's `-1`.
            //
            end: -1,
            // Boolean flags that determine if this delimiter could open or close
            // an emphasis.
            //
            open: scanned.can_open,
            close: scanned.can_close
        });
    }
    state.pos += scanned.length;
    return true;
};
function $a12b9a62937f3652$var$postProcess(state, delimiters) {
    var i, startDelim, endDelim, token, ch, isStrong, max = delimiters.length;
    for(i = max - 1; i >= 0; i--){
        startDelim = delimiters[i];
        if (startDelim.marker !== 0x5F /* _ */  && startDelim.marker !== 0x2A /* * */ ) continue;
        // Process only opening markers
        if (startDelim.end === -1) continue;
        endDelim = delimiters[startDelim.end];
        // If the previous delimiter has the same marker and is adjacent to this one,
        // merge those into one strong delimiter.
        //
        // `<em><em>whatever</em></em>` -> `<strong>whatever</strong>`
        //
        isStrong = i > 0 && delimiters[i - 1].end === startDelim.end + 1 && // check that first two markers match and adjacent
        delimiters[i - 1].marker === startDelim.marker && delimiters[i - 1].token === startDelim.token - 1 && // check that last two markers are adjacent (we can safely assume they match)
        delimiters[startDelim.end + 1].token === endDelim.token + 1;
        ch = String.fromCharCode(startDelim.marker);
        token = state.tokens[startDelim.token];
        token.type = isStrong ? 'strong_open' : 'em_open';
        token.tag = isStrong ? 'strong' : 'em';
        token.nesting = 1;
        token.markup = isStrong ? ch + ch : ch;
        token.content = '';
        token = state.tokens[endDelim.token];
        token.type = isStrong ? 'strong_close' : 'em_close';
        token.tag = isStrong ? 'strong' : 'em';
        token.nesting = -1;
        token.markup = isStrong ? ch + ch : ch;
        token.content = '';
        if (isStrong) {
            state.tokens[delimiters[i - 1].token].content = '';
            state.tokens[delimiters[startDelim.end + 1].token].content = '';
            i--;
        }
    }
}
$a12b9a62937f3652$export$7b804a0e0ce836d9 = function emphasis(state) {
    var curr, tokens_meta = state.tokens_meta, max = state.tokens_meta.length;
    $a12b9a62937f3652$var$postProcess(state, state.delimiters);
    for(curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $a12b9a62937f3652$var$postProcess(state, tokens_meta[curr].delimiters);
};

});

parcelRegister("hpf7X", function(module, exports) {
// Process [link](<to> "stuff")
'use strict';

var $hslaz = parcelRequire("hslaz");

var $cac0816fb5efefbd$require$normalizeReference = $hslaz.normalizeReference;



var $cac0816fb5efefbd$require$isSpace = $hslaz.isSpace;
module.exports = function link(state, silent) {
    var attrs, code, label, labelEnd, labelStart, pos, res, ref, token, href = '', title = '', oldPos = state.pos, max = state.posMax, start = state.pos, parseReference = true;
    if (state.src.charCodeAt(state.pos) !== 0x5B /* [ */ ) return false;
    labelStart = state.pos + 1;
    labelEnd = state.md.helpers.parseLinkLabel(state, state.pos, true);
    // parser failed to find ']', so it's not a valid link
    if (labelEnd < 0) return false;
    pos = labelEnd + 1;
    if (pos < max && state.src.charCodeAt(pos) === 0x28 /* ( */ ) {
        //
        // Inline link
        //
        // might have found a valid shortcut link, disable reference parsing
        parseReference = false;
        // [link](  <href>  "title"  )
        //        ^^ skipping these spaces
        pos++;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!$cac0816fb5efefbd$require$isSpace(code) && code !== 0x0A) break;
        }
        if (pos >= max) return false;
        // [link](  <href>  "title"  )
        //          ^^^^^^ parsing link destination
        start = pos;
        res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
        if (res.ok) {
            href = state.md.normalizeLink(res.str);
            if (state.md.validateLink(href)) pos = res.pos;
            else href = '';
            // [link](  <href>  "title"  )
            //                ^^ skipping these spaces
            start = pos;
            for(; pos < max; pos++){
                code = state.src.charCodeAt(pos);
                if (!$cac0816fb5efefbd$require$isSpace(code) && code !== 0x0A) break;
            }
            // [link](  <href>  "title"  )
            //                  ^^^^^^^ parsing link title
            res = state.md.helpers.parseLinkTitle(state.src, pos, state.posMax);
            if (pos < max && start !== pos && res.ok) {
                title = res.str;
                pos = res.pos;
                // [link](  <href>  "title"  )
                //                         ^^ skipping these spaces
                for(; pos < max; pos++){
                    code = state.src.charCodeAt(pos);
                    if (!$cac0816fb5efefbd$require$isSpace(code) && code !== 0x0A) break;
                }
            }
        }
        if (pos >= max || state.src.charCodeAt(pos) !== 0x29 /* ) */ ) // parsing a valid shortcut link failed, fallback to reference
        parseReference = true;
        pos++;
    }
    if (parseReference) {
        //
        // Link reference
        //
        if (typeof state.env.references === 'undefined') return false;
        if (pos < max && state.src.charCodeAt(pos) === 0x5B /* [ */ ) {
            start = pos + 1;
            pos = state.md.helpers.parseLinkLabel(state, pos);
            if (pos >= 0) label = state.src.slice(start, pos++);
            else pos = labelEnd + 1;
        } else pos = labelEnd + 1;
        // covers label === '' and label === undefined
        // (collapsed reference link and shortcut reference link respectively)
        if (!label) label = state.src.slice(labelStart, labelEnd);
        ref = state.env.references[$cac0816fb5efefbd$require$normalizeReference(label)];
        if (!ref) {
            state.pos = oldPos;
            return false;
        }
        href = ref.href;
        title = ref.title;
    }
    //
    // We found the end of the link, and know for a fact it's a valid link;
    // so all that's left to do is to call tokenizer.
    //
    if (!silent) {
        state.pos = labelStart;
        state.posMax = labelEnd;
        token = state.push('link_open', 'a', 1);
        token.attrs = attrs = [
            [
                'href',
                href
            ]
        ];
        if (title) attrs.push([
            'title',
            title
        ]);
        state.linkLevel++;
        state.md.inline.tokenize(state);
        state.linkLevel--;
        token = state.push('link_close', 'a', -1);
    }
    state.pos = pos;
    state.posMax = max;
    return true;
};

});

parcelRegister("gTmYV", function(module, exports) {
// Process ![image](<src> "title")
'use strict';

var $hslaz = parcelRequire("hslaz");

var $c4c39c1a0853eb44$require$normalizeReference = $hslaz.normalizeReference;



var $c4c39c1a0853eb44$require$isSpace = $hslaz.isSpace;
module.exports = function image(state, silent) {
    var attrs, code, content, label, labelEnd, labelStart, pos, ref, res, title, token, tokens, start, href = '', oldPos = state.pos, max = state.posMax;
    if (state.src.charCodeAt(state.pos) !== 0x21 /* ! */ ) return false;
    if (state.src.charCodeAt(state.pos + 1) !== 0x5B /* [ */ ) return false;
    labelStart = state.pos + 2;
    labelEnd = state.md.helpers.parseLinkLabel(state, state.pos + 1, false);
    // parser failed to find ']', so it's not a valid link
    if (labelEnd < 0) return false;
    pos = labelEnd + 1;
    if (pos < max && state.src.charCodeAt(pos) === 0x28 /* ( */ ) {
        //
        // Inline link
        //
        // [link](  <href>  "title"  )
        //        ^^ skipping these spaces
        pos++;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!$c4c39c1a0853eb44$require$isSpace(code) && code !== 0x0A) break;
        }
        if (pos >= max) return false;
        // [link](  <href>  "title"  )
        //          ^^^^^^ parsing link destination
        start = pos;
        res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
        if (res.ok) {
            href = state.md.normalizeLink(res.str);
            if (state.md.validateLink(href)) pos = res.pos;
            else href = '';
        }
        // [link](  <href>  "title"  )
        //                ^^ skipping these spaces
        start = pos;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!$c4c39c1a0853eb44$require$isSpace(code) && code !== 0x0A) break;
        }
        // [link](  <href>  "title"  )
        //                  ^^^^^^^ parsing link title
        res = state.md.helpers.parseLinkTitle(state.src, pos, state.posMax);
        if (pos < max && start !== pos && res.ok) {
            title = res.str;
            pos = res.pos;
            // [link](  <href>  "title"  )
            //                         ^^ skipping these spaces
            for(; pos < max; pos++){
                code = state.src.charCodeAt(pos);
                if (!$c4c39c1a0853eb44$require$isSpace(code) && code !== 0x0A) break;
            }
        } else title = '';
        if (pos >= max || state.src.charCodeAt(pos) !== 0x29 /* ) */ ) {
            state.pos = oldPos;
            return false;
        }
        pos++;
    } else {
        //
        // Link reference
        //
        if (typeof state.env.references === 'undefined') return false;
        if (pos < max && state.src.charCodeAt(pos) === 0x5B /* [ */ ) {
            start = pos + 1;
            pos = state.md.helpers.parseLinkLabel(state, pos);
            if (pos >= 0) label = state.src.slice(start, pos++);
            else pos = labelEnd + 1;
        } else pos = labelEnd + 1;
        // covers label === '' and label === undefined
        // (collapsed reference link and shortcut reference link respectively)
        if (!label) label = state.src.slice(labelStart, labelEnd);
        ref = state.env.references[$c4c39c1a0853eb44$require$normalizeReference(label)];
        if (!ref) {
            state.pos = oldPos;
            return false;
        }
        href = ref.href;
        title = ref.title;
    }
    //
    // We found the end of the link, and know for a fact it's a valid link;
    // so all that's left to do is to call tokenizer.
    //
    if (!silent) {
        content = state.src.slice(labelStart, labelEnd);
        state.md.inline.parse(content, state.md, state.env, tokens = []);
        token = state.push('image', 'img', 0);
        token.attrs = attrs = [
            [
                'src',
                href
            ],
            [
                'alt',
                ''
            ]
        ];
        token.children = tokens;
        token.content = content;
        if (title) attrs.push([
            'title',
            title
        ]);
    }
    state.pos = pos;
    state.posMax = max;
    return true;
};

});

parcelRegister("cog6S", function(module, exports) {
// Process autolinks '<protocol:...>'
'use strict';
/*eslint max-len:0*/ var $90543901d9b0dca4$var$EMAIL_RE = /^([a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)$/;
var $90543901d9b0dca4$var$AUTOLINK_RE = /^([a-zA-Z][a-zA-Z0-9+.\-]{1,31}):([^<>\x00-\x20]*)$/;
module.exports = function autolink(state, silent) {
    var url, fullUrl, token, ch, start, max, pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */ ) return false;
    start = state.pos;
    max = state.posMax;
    for(;;){
        if (++pos >= max) return false;
        ch = state.src.charCodeAt(pos);
        if (ch === 0x3C /* < */ ) return false;
        if (ch === 0x3E /* > */ ) break;
    }
    url = state.src.slice(start + 1, pos);
    if ($90543901d9b0dca4$var$AUTOLINK_RE.test(url)) {
        fullUrl = state.md.normalizeLink(url);
        if (!state.md.validateLink(fullUrl)) return false;
        if (!silent) {
            token = state.push('link_open', 'a', 1);
            token.attrs = [
                [
                    'href',
                    fullUrl
                ]
            ];
            token.markup = 'autolink';
            token.info = 'auto';
            token = state.push('text', '', 0);
            token.content = state.md.normalizeLinkText(url);
            token = state.push('link_close', 'a', -1);
            token.markup = 'autolink';
            token.info = 'auto';
        }
        state.pos += url.length + 2;
        return true;
    }
    if ($90543901d9b0dca4$var$EMAIL_RE.test(url)) {
        fullUrl = state.md.normalizeLink('mailto:' + url);
        if (!state.md.validateLink(fullUrl)) return false;
        if (!silent) {
            token = state.push('link_open', 'a', 1);
            token.attrs = [
                [
                    'href',
                    fullUrl
                ]
            ];
            token.markup = 'autolink';
            token.info = 'auto';
            token = state.push('text', '', 0);
            token.content = state.md.normalizeLinkText(url);
            token = state.push('link_close', 'a', -1);
            token.markup = 'autolink';
            token.info = 'auto';
        }
        state.pos += url.length + 2;
        return true;
    }
    return false;
};

});

parcelRegister("jaoOi", function(module, exports) {
// Process html tags
'use strict';

var $dgyOV = parcelRequire("dgyOV");

var $0399d78560af78c7$require$HTML_TAG_RE = $dgyOV.HTML_TAG_RE;
function $0399d78560af78c7$var$isLinkOpen(str) {
    return /^<a[>\s]/i.test(str);
}
function $0399d78560af78c7$var$isLinkClose(str) {
    return /^<\/a\s*>/i.test(str);
}
function $0399d78560af78c7$var$isLetter(ch) {
    /*eslint no-bitwise:0*/ var lc = ch | 0x20; // to lower case
    return lc >= 0x61 /* a */  && lc <= 0x7a /* z */ ;
}
module.exports = function html_inline(state, silent) {
    var ch, match, max, token, pos = state.pos;
    if (!state.md.options.html) return false;
    // Check start
    max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */  || pos + 2 >= max) return false;
    // Quick fail on second char
    ch = state.src.charCodeAt(pos + 1);
    if (ch !== 0x21 /* ! */  && ch !== 0x3F /* ? */  && ch !== 0x2F /* / */  && !$0399d78560af78c7$var$isLetter(ch)) return false;
    match = state.src.slice(pos).match($0399d78560af78c7$require$HTML_TAG_RE);
    if (!match) return false;
    if (!silent) {
        token = state.push('html_inline', '', 0);
        token.content = match[0];
        if ($0399d78560af78c7$var$isLinkOpen(token.content)) state.linkLevel++;
        if ($0399d78560af78c7$var$isLinkClose(token.content)) state.linkLevel--;
    }
    state.pos += match[0].length;
    return true;
};

});

parcelRegister("fdC2o", function(module, exports) {
// Process html entity - &#123;, &#xAF;, &quot;, ...
'use strict';

var $7j3pV = parcelRequire("7j3pV");


var $hslaz = parcelRequire("hslaz");

var $b14593671b7e14fd$require$has = $hslaz.has;



var $b14593671b7e14fd$require$isValidEntityCode = $hslaz.isValidEntityCode;



var $b14593671b7e14fd$require$fromCodePoint = $hslaz.fromCodePoint;
var $b14593671b7e14fd$var$DIGITAL_RE = /^&#((?:x[a-f0-9]{1,6}|[0-9]{1,7}));/i;
var $b14593671b7e14fd$var$NAMED_RE = /^&([a-z][a-z0-9]{1,31});/i;
module.exports = function entity(state, silent) {
    var ch, code, match, token, pos = state.pos, max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x26 /* & */ ) return false;
    if (pos + 1 >= max) return false;
    ch = state.src.charCodeAt(pos + 1);
    if (ch === 0x23 /* # */ ) {
        match = state.src.slice(pos).match($b14593671b7e14fd$var$DIGITAL_RE);
        if (match) {
            if (!silent) {
                code = match[1][0].toLowerCase() === 'x' ? parseInt(match[1].slice(1), 16) : parseInt(match[1], 10);
                token = state.push('text_special', '', 0);
                token.content = $b14593671b7e14fd$require$isValidEntityCode(code) ? $b14593671b7e14fd$require$fromCodePoint(code) : $b14593671b7e14fd$require$fromCodePoint(0xFFFD);
                token.markup = match[0];
                token.info = 'entity';
            }
            state.pos += match[0].length;
            return true;
        }
    } else {
        match = state.src.slice(pos).match($b14593671b7e14fd$var$NAMED_RE);
        if (match) {
            if ($b14593671b7e14fd$require$has($7j3pV, match[1])) {
                if (!silent) {
                    token = state.push('text_special', '', 0);
                    token.content = $7j3pV[match[1]];
                    token.markup = match[0];
                    token.info = 'entity';
                }
                state.pos += match[0].length;
                return true;
            }
        }
    }
    return false;
};

});

parcelRegister("ddn2p", function(module, exports) {
// For each opening emphasis-like marker find a matching closing one
//
'use strict';
function $99ee5c1e43454010$var$processDelimiters(delimiters) {
    var closerIdx, openerIdx, closer, opener, minOpenerIdx, newMinOpenerIdx, isOddMatch, lastJump, openersBottom = {}, max = delimiters.length;
    if (!max) return;
    // headerIdx is the first delimiter of the current (where closer is) delimiter run
    var headerIdx = 0;
    var lastTokenIdx = -2; // needs any value lower than -1
    var jumps = [];
    for(closerIdx = 0; closerIdx < max; closerIdx++){
        closer = delimiters[closerIdx];
        jumps.push(0);
        // markers belong to same delimiter run if:
        //  - they have adjacent tokens
        //  - AND markers are the same
        //
        if (delimiters[headerIdx].marker !== closer.marker || lastTokenIdx !== closer.token - 1) headerIdx = closerIdx;
        lastTokenIdx = closer.token;
        // Length is only used for emphasis-specific "rule of 3",
        // if it's not defined (in strikethrough or 3rd party plugins),
        // we can default it to 0 to disable those checks.
        //
        closer.length = closer.length || 0;
        if (!closer.close) continue;
        // Previously calculated lower bounds (previous fails)
        // for each marker, each delimiter length modulo 3,
        // and for whether this closer can be an opener;
        // https://github.com/commonmark/cmark/commit/34250e12ccebdc6372b8b49c44fab57c72443460
        if (!openersBottom.hasOwnProperty(closer.marker)) openersBottom[closer.marker] = [
            -1,
            -1,
            -1,
            -1,
            -1,
            -1
        ];
        minOpenerIdx = openersBottom[closer.marker][(closer.open ? 3 : 0) + closer.length % 3];
        openerIdx = headerIdx - jumps[headerIdx] - 1;
        newMinOpenerIdx = openerIdx;
        for(; openerIdx > minOpenerIdx; openerIdx -= jumps[openerIdx] + 1){
            opener = delimiters[openerIdx];
            if (opener.marker !== closer.marker) continue;
            if (opener.open && opener.end < 0) {
                isOddMatch = false;
                // from spec:
                //
                // If one of the delimiters can both open and close emphasis, then the
                // sum of the lengths of the delimiter runs containing the opening and
                // closing delimiters must not be a multiple of 3 unless both lengths
                // are multiples of 3.
                //
                if (opener.close || closer.open) {
                    if ((opener.length + closer.length) % 3 === 0) {
                        if (opener.length % 3 !== 0 || closer.length % 3 !== 0) isOddMatch = true;
                    }
                }
                if (!isOddMatch) {
                    // If previous delimiter cannot be an opener, we can safely skip
                    // the entire sequence in future checks. This is required to make
                    // sure algorithm has linear complexity (see *_*_*_*_*_... case).
                    //
                    lastJump = openerIdx > 0 && !delimiters[openerIdx - 1].open ? jumps[openerIdx - 1] + 1 : 0;
                    jumps[closerIdx] = closerIdx - openerIdx + lastJump;
                    jumps[openerIdx] = lastJump;
                    closer.open = false;
                    opener.end = closerIdx;
                    opener.close = false;
                    newMinOpenerIdx = -1;
                    // treat next token as start of run,
                    // it optimizes skips in **<...>**a**<...>** pathological case
                    lastTokenIdx = -2;
                    break;
                }
            }
        }
        if (newMinOpenerIdx !== -1) // If match for this delimiter run failed, we want to set lower bound for
        // future lookups. This is required to make sure algorithm has linear
        // complexity.
        //
        // See details here:
        // https://github.com/commonmark/cmark/issues/178#issuecomment-270417442
        //
        openersBottom[closer.marker][(closer.open ? 3 : 0) + (closer.length || 0) % 3] = newMinOpenerIdx;
    }
}
module.exports = function link_pairs(state) {
    var curr, tokens_meta = state.tokens_meta, max = state.tokens_meta.length;
    $99ee5c1e43454010$var$processDelimiters(state.delimiters);
    for(curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $99ee5c1e43454010$var$processDelimiters(tokens_meta[curr].delimiters);
};

});

parcelRegister("eXNML", function(module, exports) {
// Clean up tokens after emphasis and strikethrough postprocessing:
// merge adjacent text nodes into one and re-calculate all token levels
//
// This is necessary because initially emphasis delimiter markers (*, _, ~)
// are treated as their own separate text tokens. Then emphasis rule either
// leaves them as text (needed to merge with adjacent text) or turns them
// into opening/closing tags (which messes up levels inside).
//
'use strict';
module.exports = function fragments_join(state) {
    var curr, last, level = 0, tokens = state.tokens, max = state.tokens.length;
    for(curr = last = 0; curr < max; curr++){
        // re-calculate levels after emphasis/strikethrough turns some text nodes
        // into opening/closing tags
        if (tokens[curr].nesting < 0) level--; // closing tag
        tokens[curr].level = level;
        if (tokens[curr].nesting > 0) level++; // opening tag
        if (tokens[curr].type === 'text' && curr + 1 < max && tokens[curr + 1].type === 'text') // collapse two adjacent text nodes
        tokens[curr + 1].content = tokens[curr].content + tokens[curr + 1].content;
        else {
            if (curr !== last) tokens[last] = tokens[curr];
            last++;
        }
    }
    if (curr !== last) tokens.length = last;
};

});

parcelRegister("ib9ax", function(module, exports) {
// Inline parser state
'use strict';

var $flZnN = parcelRequire("flZnN");


var $hslaz = parcelRequire("hslaz");

var $d3c05dd90ff363ac$require$isWhiteSpace = $hslaz.isWhiteSpace;



var $d3c05dd90ff363ac$require$isPunctChar = $hslaz.isPunctChar;



var $d3c05dd90ff363ac$require$isMdAsciiPunct = $hslaz.isMdAsciiPunct;
function $d3c05dd90ff363ac$var$StateInline(src, md, env, outTokens) {
    this.src = src;
    this.env = env;
    this.md = md;
    this.tokens = outTokens;
    this.tokens_meta = Array(outTokens.length);
    this.pos = 0;
    this.posMax = this.src.length;
    this.level = 0;
    this.pending = '';
    this.pendingLevel = 0;
    // Stores { start: end } pairs. Useful for backtrack
    // optimization of pairs parse (emphasis, strikes).
    this.cache = {};
    // List of emphasis-like delimiters for current tag
    this.delimiters = [];
    // Stack of delimiter lists for upper level tags
    this._prev_delimiters = [];
    // backtick length => last seen position
    this.backticks = {};
    this.backticksScanned = false;
    // Counter used to disable inline linkify-it execution
    // inside <a> and markdown links
    this.linkLevel = 0;
}
// Flush pending text
//
$d3c05dd90ff363ac$var$StateInline.prototype.pushPending = function() {
    var token = new $flZnN('text', '', 0);
    token.content = this.pending;
    token.level = this.pendingLevel;
    this.tokens.push(token);
    this.pending = '';
    return token;
};
// Push new token to "stream".
// If pending text exists - flush it as text token
//
$d3c05dd90ff363ac$var$StateInline.prototype.push = function(type, tag, nesting) {
    if (this.pending) this.pushPending();
    var token = new $flZnN(type, tag, nesting);
    var token_meta = null;
    if (nesting < 0) {
        // closing tag
        this.level--;
        this.delimiters = this._prev_delimiters.pop();
    }
    token.level = this.level;
    if (nesting > 0) {
        // opening tag
        this.level++;
        this._prev_delimiters.push(this.delimiters);
        this.delimiters = [];
        token_meta = {
            delimiters: this.delimiters
        };
    }
    this.pendingLevel = this.level;
    this.tokens.push(token);
    this.tokens_meta.push(token_meta);
    return token;
};
// Scan a sequence of emphasis-like markers, and determine whether
// it can start an emphasis sequence or end an emphasis sequence.
//
//  - start - position to scan from (it should point at a valid marker);
//  - canSplitWord - determine if these markers can be found inside a word
//
$d3c05dd90ff363ac$var$StateInline.prototype.scanDelims = function(start, canSplitWord) {
    var pos = start, lastChar, nextChar, count, can_open, can_close, isLastWhiteSpace, isLastPunctChar, isNextWhiteSpace, isNextPunctChar, left_flanking = true, right_flanking = true, max = this.posMax, marker = this.src.charCodeAt(start);
    // treat beginning of the line as a whitespace
    lastChar = start > 0 ? this.src.charCodeAt(start - 1) : 0x20;
    while(pos < max && this.src.charCodeAt(pos) === marker)pos++;
    count = pos - start;
    // treat end of the line as a whitespace
    nextChar = pos < max ? this.src.charCodeAt(pos) : 0x20;
    isLastPunctChar = $d3c05dd90ff363ac$require$isMdAsciiPunct(lastChar) || $d3c05dd90ff363ac$require$isPunctChar(String.fromCharCode(lastChar));
    isNextPunctChar = $d3c05dd90ff363ac$require$isMdAsciiPunct(nextChar) || $d3c05dd90ff363ac$require$isPunctChar(String.fromCharCode(nextChar));
    isLastWhiteSpace = $d3c05dd90ff363ac$require$isWhiteSpace(lastChar);
    isNextWhiteSpace = $d3c05dd90ff363ac$require$isWhiteSpace(nextChar);
    if (isNextWhiteSpace) left_flanking = false;
    else if (isNextPunctChar) {
        if (!(isLastWhiteSpace || isLastPunctChar)) left_flanking = false;
    }
    if (isLastWhiteSpace) right_flanking = false;
    else if (isLastPunctChar) {
        if (!(isNextWhiteSpace || isNextPunctChar)) right_flanking = false;
    }
    if (!canSplitWord) {
        can_open = left_flanking && (!right_flanking || isLastPunctChar);
        can_close = right_flanking && (!left_flanking || isNextPunctChar);
    } else {
        can_open = left_flanking;
        can_close = right_flanking;
    }
    return {
        can_open: can_open,
        can_close: can_close,
        length: count
    };
};
// re-export Token class to use in block rules
$d3c05dd90ff363ac$var$StateInline.prototype.Token = $flZnN;
module.exports = $d3c05dd90ff363ac$var$StateInline;

});

parcelRegister("aA4uz", function(module, exports) {
'use strict';




module.exports = function(opts) {
    var re = {};
    opts = opts || {};
    // Use direct extract instead of `regenerate` to reduse browserified size
    re.src_Any = (parcelRequire("6gKKW")).source;
    re.src_Cc = (parcelRequire("7wkNx")).source;
    re.src_Z = (parcelRequire("4QTDX")).source;
    re.src_P = (parcelRequire("eSMp5")).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join('|');
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join('|');
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    var text_separators = '[><\uff5c]';
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    ////////////////////////////////////////////////////////////////////////////////
    re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';
    re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
    re.src_host_terminator = '(?=$|' + text_separators + '|' + re.src_ZPCc + ')' + '(?!' + (opts['---'] ? '-(?!--)|' : '-|') + '_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-;]).|' + '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' + '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' + '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + '|[-])|' + // allow `I'm_king` if no pair found
    '\\.{2,}[a-zA-Z0-9%/&]|' + // google has many dots in "google search" links (#66, #81).
    // github has ... in commit range links,
    // Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // - params separator
    // until more examples found.
    '\\.(?!' + re.src_ZCc + '|[.]|$)|' + (opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
     : '\\-+|') + ',(?!' + re.src_ZCc + '|$)|' + // allow `,,,` in paths
    ';(?!' + re.src_ZCc + '|$)|' + // allow `;` if not followed by space-like char
    '\\!+(?!' + re.src_ZCc + '|[!]|$)|' + // allow `!!!` in paths, but not at the end
    '\\?(?!' + re.src_ZCc + '|[?]|$)' + ')+' + '|\\/' + ')?';
    // Allow anything in markdown spec, forbid quote (") at the first position
    // because emails enclosed in quotes are far more common
    re.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*';
    re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    '(?:' + re.src_xn + '|' + re.src_pseudo_letter + '{1,63}' + ')';
    re.src_domain = '(?:' + re.src_xn + '|' + '(?:' + re.src_pseudo_letter + ')' + '|' + '(?:' + re.src_pseudo_letter + '(?:-|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' + ')';
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ')\\.)*' + re.src_domain /*_root*/  + ')' + ')';
    re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' + ')';
    re.tpl_host_no_ip_fuzzy = '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    ////////////////////////////////////////////////////////////////////////////////
    // Main rules
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = 'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
    re.tpl_email_fuzzy = '(^|' + text_separators + '|"|\\(|' + re.src_ZCc + ')' + '(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
    return re;
};

});

parcelRegister("j7DYH", function(module, exports) {
// markdown-it default options
'use strict';
module.exports = {
    options: {
        html: false,
        xhtmlOut: false,
        breaks: false,
        langPrefix: 'language-',
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: '\u201c\u201d\u2018\u2019',
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        maxNesting: 100 // Internal protection, recursion limit
    },
    components: {
        core: {},
        block: {},
        inline: {}
    }
};

});

parcelRegister("ad45r", function(module, exports) {
// "Zero" preset, with nothing enabled. Useful for manual configuring of simple
// modes. For example, to parse bold/italic only.
'use strict';
module.exports = {
    options: {
        html: false,
        xhtmlOut: false,
        breaks: false,
        langPrefix: 'language-',
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: '\u201c\u201d\u2018\u2019',
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        maxNesting: 20 // Internal protection, recursion limit
    },
    components: {
        core: {
            rules: [
                'normalize',
                'block',
                'inline',
                'text_join'
            ]
        },
        block: {
            rules: [
                'paragraph'
            ]
        },
        inline: {
            rules: [
                'text'
            ],
            rules2: [
                'balance_pairs',
                'fragments_join'
            ]
        }
    }
};

});

parcelRegister("4teFe", function(module, exports) {
// Commonmark default options
'use strict';
module.exports = {
    options: {
        html: true,
        xhtmlOut: true,
        breaks: false,
        langPrefix: 'language-',
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: '\u201c\u201d\u2018\u2019',
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        maxNesting: 20 // Internal protection, recursion limit
    },
    components: {
        core: {
            rules: [
                'normalize',
                'block',
                'inline',
                'text_join'
            ]
        },
        block: {
            rules: [
                'blockquote',
                'code',
                'fence',
                'heading',
                'hr',
                'html_block',
                'lheading',
                'list',
                'reference',
                'paragraph'
            ]
        },
        inline: {
            rules: [
                'autolink',
                'backticks',
                'emphasis',
                'entity',
                'escape',
                'html_inline',
                'image',
                'link',
                'newline',
                'text'
            ],
            rules2: [
                'balance_pairs',
                'emphasis',
                'fragments_join'
            ]
        }
    }
};

});

parcelRegister("aRZzN", function(module, exports) {

var $1UrkW = parcelRequire("1UrkW");


var $2Yzoe = parcelRequire("2Yzoe");


var $csam1 = parcelRequire("csam1");


var $42JDa = parcelRequire("42JDa");

function $54a839e4270a9473$var$createRule() {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const regx = /!\[([^\]]*)\]\(([^)]*?)\s*(?:"([^")]*)"\s*)?\)/g;
    const validParentTokens = [
        'th_open',
        'td_open',
        'list_item_open',
        'blockquote_open'
    ];
    /**
	 * This function looks for strings that matches ![description](url) inside Inline-tokens.
	 * It will then split the Inline-token with content before and after the image, example:
	 *
	 * Input (tokens):
	 *   paragraph_open
	 *   inline - content: Hello ![](image.jpg) World!
	 *   paragraph_close
	 * Output (tokens):
	 *   paragraph_open
	 *   inline - content: Hello
	 *   paragraph_close
	 *   media_single_open
	 *   media
	 *   media_single_close
	 *   paragraph_open
	 *   inline - content: World!
	 *   paragraph_close
	 *
	 * This is applied before the inline content is parsed, to ensure that the formatting of
	 * remaining inline content (bold, links, etc.) is kept intact!
	 */ return function media(State) {
        const getUrl = (str)=>{
            const res = State.md.helpers.parseLinkDestination(str, str.indexOf('(') + 1, str.length);
            if (res.ok) {
                const href = State.md.normalizeLink(res.str);
                if (State.md.validateLink(href)) return href;
            }
            return '';
        };
        const createMediaTokens = (url, alt = '')=>{
            const mediaSingleOpen = new State.Token('media_single_open', '', 1);
            const media = new State.Token('media', '', 0);
            media.attrs = [
                [
                    'url',
                    getUrl(url)
                ],
                [
                    'type',
                    'external'
                ],
                [
                    'alt',
                    alt
                ]
            ];
            const mediaSingleClose = new State.Token('media_single_close', '', -1);
            return [
                mediaSingleOpen,
                media,
                mediaSingleClose
            ];
        };
        const createInlineTokens = (str, openingTokens, closingTokens)=>{
            if (!str || str.length === 0) return [];
            const inlineBefore = new State.Token('inline', '', 1);
            inlineBefore.content = str;
            inlineBefore.children = [];
            return [
                ...openingTokens,
                inlineBefore,
                ...closingTokens
            ];
        };
        let processedTokens = [];
        const newTokens = State.tokens.reduce((tokens, token, i, arr)=>{
            const matchAll = Array.from(token.content.matchAll(regx));
            if (token.type === 'inline' && matchAll.length) {
                const openingTokens = [];
                let cursor = i - 1;
                let previousToken = arr[cursor];
                let subTree = [];
                while(previousToken && previousToken.level > 0 && validParentTokens.indexOf(previousToken.type) === -1){
                    openingTokens.unshift(previousToken);
                    cursor--;
                    previousToken = arr[cursor];
                }
                if (validParentTokens.indexOf(previousToken.type) === -1) openingTokens.unshift(previousToken);
                else cursor++;
                const closingTokens = openingTokens.map((token)=>new State.Token(token.type.replace('_open', '_close'), token.tag, -1)).reverse();
                let inlineContentStack = token.content;
                matchAll.forEach((match)=>{
                    const [matchString, alt, url] = match;
                    const start = inlineContentStack.indexOf(matchString);
                    const contentBefore = inlineContentStack.substr(0, start);
                    inlineContentStack = inlineContentStack.substr(start + matchString.length);
                    subTree = [
                        ...subTree,
                        ...createInlineTokens(contentBefore, openingTokens, closingTokens),
                        ...createMediaTokens(url, alt)
                    ];
                });
                if (inlineContentStack.length) subTree = [
                    ...subTree,
                    ...createInlineTokens(inlineContentStack, openingTokens, closingTokens)
                ];
                processedTokens = [
                    ...processedTokens,
                    ...closingTokens.map((c)=>c.type)
                ];
                tokens = [
                    ...tokens.slice(0, cursor),
                    ...subTree
                ];
            } else if (processedTokens.indexOf(token.type) !== -1) // Ignore token if it's already processed
            processedTokens.splice(processedTokens.indexOf(token.type), 1);
            else tokens.push(token);
            return tokens;
        }, []);
        State.tokens = newTokens;
        return true;
    };
}
const $54a839e4270a9473$export$c8dcbd316b71f8cf = (md)=>{
    md.core.ruler.before('inline', 'media', $54a839e4270a9473$var$createRule());
};


// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $70b3fb435fbd97a9$var$filterMdToPmSchemaMapping(schema, map) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return Object.keys(map).reduce((newMap, key)=>{
        const value = map[key];
        const block = value.block || value.node;
        const mark = value.mark;
        if (block && schema.nodes[block] || mark && schema.marks[mark]) newMap[key] = value;
        return newMap;
    }, {});
}
const $70b3fb435fbd97a9$var$pmSchemaToMdMapping = {
    nodes: {
        blockquote: 'blockquote',
        paragraph: 'paragraph',
        rule: 'hr',
        // lheading (---, ===)
        heading: [
            'heading',
            'lheading'
        ],
        codeBlock: [
            'code',
            'fence'
        ],
        listItem: 'list',
        image: 'image'
    },
    marks: {
        em: 'emphasis',
        strong: 'text',
        link: [
            'link',
            'autolink',
            'reference',
            'linkify'
        ],
        strike: 'strikethrough',
        code: 'backticks'
    }
};
const $70b3fb435fbd97a9$var$mdToPmMapping = {
    blockquote: {
        block: 'blockquote'
    },
    paragraph: {
        block: 'paragraph'
    },
    em: {
        mark: 'em'
    },
    strong: {
        mark: 'strong'
    },
    link: {
        mark: 'link',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: (tok)=>({
                href: tok.attrGet('href'),
                title: tok.attrGet('title') || null
            })
    },
    hr: {
        node: 'rule'
    },
    heading: {
        block: 'heading',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: (tok)=>({
                level: +tok.tag.slice(1)
            })
    },
    softbreak: {
        node: 'hardBreak'
    },
    hardbreak: {
        node: 'hardBreak'
    },
    code_block: {
        block: 'codeBlock'
    },
    list_item: {
        block: 'listItem'
    },
    bullet_list: {
        block: 'bulletList'
    },
    ordered_list: {
        block: 'orderedList',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: (tok)=>({
                order: typeof tok.attrGet('start') === 'number' ? tok.attrGet('start') : 1
            })
    },
    code_inline: {
        mark: 'code'
    },
    fence: {
        block: 'codeBlock',
        // we trim any whitespaces around language definition
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: (tok)=>({
                language: tok.info && tok.info.trim() || null
            })
    },
    media_single: {
        block: 'mediaSingle',
        attrs: ()=>({})
    },
    media: {
        node: 'media',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: (tok)=>{
            return {
                url: tok.attrGet('url'),
                alt: tok.attrGet('alt'),
                type: 'external'
            };
        }
    },
    emoji: {
        node: 'emoji',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: (tok)=>({
                shortName: `:${tok.markup}:`,
                text: tok.content
            })
    },
    table: {
        block: 'table'
    },
    tr: {
        block: 'tableRow'
    },
    th: {
        block: 'tableHeader'
    },
    td: {
        block: 'tableCell'
    },
    s: {
        mark: 'strike'
    },
    task_list: {
        block: 'taskList'
    },
    task_item: {
        block: 'taskItem',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: (tok)=>({
                state: tok.meta
            })
    }
};
const $70b3fb435fbd97a9$var$md = (0, (/*@__PURE__*/$parcel$interopDefault($2Yzoe)))('zero', {
    html: false
});
$70b3fb435fbd97a9$var$md.enable([
    // Process html entity - &#123;, &#xAF;, &quot;, ...
    'entity',
    // Process escaped chars and hardbreaks
    'escape'
]);
class $70b3fb435fbd97a9$export$267fd7ead7cc4561 {
    encode(_node) {
        throw new Error('This is not implemented yet');
    }
    parse(content) {
        return this.markdownParser.parse(content);
    }
    constructor(schema = (0, $1UrkW.defaultSchema), tokenizer = $70b3fb435fbd97a9$var$md){
        this.markdownParser = void 0;
        // Enable markdown plugins based on schema
        [
            'nodes',
            'marks'
        ].forEach((key)=>{
            for(const idx in $70b3fb435fbd97a9$var$pmSchemaToMdMapping[key])if (schema[key][idx]) tokenizer.enable($70b3fb435fbd97a9$var$pmSchemaToMdMapping[key][idx]);
        });
        if (schema.nodes.table) tokenizer.use((0, $csam1.markdownItTable));
        if (schema.nodes.media && schema.nodes.mediaSingle) tokenizer.use((0, $54a839e4270a9473$export$c8dcbd316b71f8cf));
        this.markdownParser = new (0, $42JDa.MarkdownParser)(schema, tokenizer, $70b3fb435fbd97a9$var$filterMdToPmSchemaMapping(schema, $70b3fb435fbd97a9$var$mdToPmMapping));
    }
}
module.exports["MarkdownTransformer"] = $70b3fb435fbd97a9$export$267fd7ead7cc4561;

});

parcelRegister("csam1", function(module, exports) {
var $8f615118f6fafb3b$exports = {};
// Copied from https://github.com/markdown-it/markdown-it/blob/master/lib/rules_block/table.js
function $8f615118f6fafb3b$var$isSpace(code) {
    switch(code){
        case 0x09:
        case 0x20:
            return true;
    }
    return false;
}
function $8f615118f6fafb3b$var$getLine(state, line) {
    var pos = state.bMarks[line] + state.blkIndent, max = state.eMarks[line];
    return state.src.substr(pos, max - pos);
}
function $8f615118f6fafb3b$var$escapedSplit(str) {
    var result = [], pos = 0, max = str.length, ch, escapes = 0, lastPos = 0, backTicked = false, lastBackTick = 0;
    ch = str.charCodeAt(pos);
    while(pos < max){
        if (ch === 0x60 /* ` */ ) {
            if (backTicked) {
                // make \` close code sequence, but not open it;
                // the reason is: `\` is correct code block
                backTicked = false;
                lastBackTick = pos;
            } else if (escapes % 2 === 0) {
                backTicked = true;
                lastBackTick = pos;
            }
        } else if (ch === 0x7c /* | */  && escapes % 2 === 0 && !backTicked) {
            result.push(str.substring(lastPos, pos));
            lastPos = pos + 1;
        }
        if (ch === 0x5c /* \ */ ) escapes++;
        else escapes = 0;
        pos++;
        // If there was an un-closed backtick, go back to just after
        // the last backtick, but as if it was a normal character
        if (pos === max && backTicked) {
            backTicked = false;
            pos = lastBackTick + 1;
        }
        ch = str.charCodeAt(pos);
    }
    result.push(str.substring(lastPos));
    return result;
}
$8f615118f6fafb3b$exports = function table(state, startLine, endLine, silent) {
    var ch, lineText, pos, i, nextLine, columns, columnCount, token, aligns, t, tableLines, tbodyLines;
    // should have at least two lines
    if (startLine + 2 > endLine) return false;
    nextLine = startLine + 1;
    if (state.sCount[nextLine] < state.blkIndent) return false;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[nextLine] - state.blkIndent >= 4) return false;
    // first character of the second line should be '|', '-', ':',
    // and no other characters are allowed but spaces;
    // basically, this is the equivalent of /^[-:|][-:|\s]*$/ regexp
    pos = state.bMarks[nextLine] + state.tShift[nextLine];
    if (pos >= state.eMarks[nextLine]) return false;
    ch = state.src.charCodeAt(pos++);
    if (ch !== 0x7c /* | */  && ch !== 0x2d /* - */  && ch !== 0x3a /* : */ ) return false;
    while(pos < state.eMarks[nextLine]){
        ch = state.src.charCodeAt(pos);
        if (ch !== 0x7c /* | */  && ch !== 0x2d /* - */  && ch !== 0x3a /* : */  && !$8f615118f6fafb3b$var$isSpace(ch)) return false;
        pos++;
    }
    lineText = $8f615118f6fafb3b$var$getLine(state, startLine + 1);
    columns = lineText.split('|');
    aligns = [];
    for(i = 0; i < columns.length; i++){
        t = columns[i].trim();
        if (!t) {
            // allow empty columns before and after table, but not in between columns;
            // e.g. allow ` |---| `, disallow ` ---||--- `
            if (i === 0 || i === columns.length - 1) continue;
            else return false;
        }
        if (!/^:?-+:?$/.test(t)) return false;
        if (t.charCodeAt(t.length - 1) === 0x3a /* : */ ) aligns.push(t.charCodeAt(0) === 0x3a /* : */  ? 'center' : 'right');
        else if (t.charCodeAt(0) === 0x3a /* : */ ) aligns.push('left');
        else aligns.push('');
    }
    lineText = $8f615118f6fafb3b$var$getLine(state, startLine).trim();
    if (lineText.indexOf('|') === -1) return false;
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    columns = $8f615118f6fafb3b$var$escapedSplit(lineText.replace(/^\||\|$/g, ''));
    // header row will define an amount of columns in the entire table,
    // and align row shouldn't be smaller than that (the rest of the rows can)
    columnCount = columns.length;
    if (columnCount > aligns.length) return false;
    if (silent) return true;
    token = state.push('table_open', 'table', 1);
    token.map = tableLines = [
        startLine,
        0
    ];
    // token     = state.push('thead_open', 'thead', 1);
    // token.map = [ startLine, startLine + 1 ];
    token = state.push('tr_open', 'tr', 1);
    token.map = [
        startLine,
        startLine + 1
    ];
    for(i = 0; i < columns.length; i++){
        token = state.push('th_open', 'th', 1);
        token.map = [
            startLine,
            startLine + 1
        ];
        if (aligns[i]) token.attrs = [
            [
                'style',
                'text-align:' + aligns[i]
            ]
        ];
        token = state.push('paragraph_open', 'p', 1);
        token = state.push('inline', '', 0);
        token.content = columns[i].trim();
        token.map = [
            startLine,
            startLine + 1
        ];
        token.children = [];
        token = state.push('paragraph_close', 'p', -1);
        token = state.push('th_close', 'th', -1);
    }
    token = state.push('tr_close', 'tr', -1);
    // token     = state.push('thead_close', 'thead', -1);
    // token     = state.push('tbody_open', 'tbody', 1);
    token.map = tbodyLines = [
        startLine + 2,
        0
    ];
    var oldLineMax = state.lineMax;
    for(nextLine = startLine + 2; nextLine < endLine; nextLine++){
        if (state.sCount[nextLine] < state.blkIndent) break;
        lineText = $8f615118f6fafb3b$var$getLine(state, nextLine).trim();
        if (lineText.indexOf('|') === -1) break;
        if (state.sCount[nextLine] - state.blkIndent >= 4) break;
        columns = $8f615118f6fafb3b$var$escapedSplit(lineText.replace(/^\||\|$/g, ''));
        token = state.push('tr_open', 'tr', 1);
        for(var _i = 0, offset = 1; _i < columns.length; _i++){
            token = state.push('td_open', 'td', 1);
            if (aligns[_i]) token.attrs = [
                [
                    'style',
                    'text-align:' + aligns[_i]
                ]
            ];
            // https://github.com/markdown-it/markdown-it/blob/e6f19eab4204122e85e4a342e0c1c8486ff40c2d/lib/rules_block/state_block.js#L25
            // bMarks => line begin offsets for fast jumps
            // eMarks => line end offsets for fast jumps
            // tShift => offsets of the first non-space characters (tabs not expanded)
            // sCount => indents for each line (tabs expanded)
            // Move bMarks when first char is ' ' for > to work
            var shift = columns[_i][0] === ' ' || /^(\d+\.|\*|-)$/.test(columns[_i].trim()) ? 1 : 0;
            state.bMarks[nextLine] += offset + shift;
            offset = (columns[_i] || '').length + (shift ? 0 : 1);
            state.eMarks[nextLine] = state.bMarks[nextLine] + offset - 1;
            state.lineMax = 1;
            state.md.block.tokenize(state, nextLine, nextLine + 1);
            token = state.push('td_close', 'td', -1);
        }
        token = state.push('tr_close', 'tr', -1);
    }
    // token = state.push('tbody_close', 'tbody', -1);
    state.lineMax = oldLineMax;
    token = state.push('table_close', 'table', -1);
    tableLines[1] = tbodyLines[1] = nextLine;
    state.line = nextLine;
    return true;
};


var $911021aadcbe4f7e$export$26a6b72a65821214 = function markdownItTable(md, options) {
    md.block.ruler.before('paragraph', 'table', (0, (/*@__PURE__*/$parcel$interopDefault($8f615118f6fafb3b$exports))), {
        alt: [
            'paragraph',
            'reference'
        ]
    });
};
module.exports["markdownItTable"] = $911021aadcbe4f7e$export$26a6b72a65821214;

});

parcelRegister("42JDa", function(module, exports) {

var $5SAOw = parcelRequire("5SAOw");


var $2Yzoe = parcelRequire("2Yzoe");

/**
Document schema for the data model used by CommonMark.
*/ const $2f1abea25e652257$export$4902baddc787debb = new (0, $5SAOw.Schema)({
    nodes: {
        doc: {
            content: "block+"
        },
        paragraph: {
            content: "inline*",
            group: "block",
            parseDOM: [
                {
                    tag: "p"
                }
            ],
            toDOM () {
                return [
                    "p",
                    0
                ];
            }
        },
        blockquote: {
            content: "block+",
            group: "block",
            parseDOM: [
                {
                    tag: "blockquote"
                }
            ],
            toDOM () {
                return [
                    "blockquote",
                    0
                ];
            }
        },
        horizontal_rule: {
            group: "block",
            parseDOM: [
                {
                    tag: "hr"
                }
            ],
            toDOM () {
                return [
                    "div",
                    [
                        "hr"
                    ]
                ];
            }
        },
        heading: {
            attrs: {
                level: {
                    default: 1
                }
            },
            content: "(text | image)*",
            group: "block",
            defining: true,
            parseDOM: [
                {
                    tag: "h1",
                    attrs: {
                        level: 1
                    }
                },
                {
                    tag: "h2",
                    attrs: {
                        level: 2
                    }
                },
                {
                    tag: "h3",
                    attrs: {
                        level: 3
                    }
                },
                {
                    tag: "h4",
                    attrs: {
                        level: 4
                    }
                },
                {
                    tag: "h5",
                    attrs: {
                        level: 5
                    }
                },
                {
                    tag: "h6",
                    attrs: {
                        level: 6
                    }
                }
            ],
            toDOM (node) {
                return [
                    "h" + node.attrs.level,
                    0
                ];
            }
        },
        code_block: {
            content: "text*",
            group: "block",
            code: true,
            defining: true,
            marks: "",
            attrs: {
                params: {
                    default: ""
                }
            },
            parseDOM: [
                {
                    tag: "pre",
                    preserveWhitespace: "full",
                    getAttrs: (node)=>({
                            params: node.getAttribute("data-params") || ""
                        })
                }
            ],
            toDOM (node) {
                return [
                    "pre",
                    node.attrs.params ? {
                        "data-params": node.attrs.params
                    } : {},
                    [
                        "code",
                        0
                    ]
                ];
            }
        },
        ordered_list: {
            content: "list_item+",
            group: "block",
            attrs: {
                order: {
                    default: 1
                },
                tight: {
                    default: false
                }
            },
            parseDOM: [
                {
                    tag: "ol",
                    getAttrs (dom) {
                        return {
                            order: dom.hasAttribute("start") ? +dom.getAttribute("start") : 1,
                            tight: dom.hasAttribute("data-tight")
                        };
                    }
                }
            ],
            toDOM (node) {
                return [
                    "ol",
                    {
                        start: node.attrs.order == 1 ? null : node.attrs.order,
                        "data-tight": node.attrs.tight ? "true" : null
                    },
                    0
                ];
            }
        },
        bullet_list: {
            content: "list_item+",
            group: "block",
            attrs: {
                tight: {
                    default: false
                }
            },
            parseDOM: [
                {
                    tag: "ul",
                    getAttrs: (dom)=>({
                            tight: dom.hasAttribute("data-tight")
                        })
                }
            ],
            toDOM (node) {
                return [
                    "ul",
                    {
                        "data-tight": node.attrs.tight ? "true" : null
                    },
                    0
                ];
            }
        },
        list_item: {
            content: "block+",
            defining: true,
            parseDOM: [
                {
                    tag: "li"
                }
            ],
            toDOM () {
                return [
                    "li",
                    0
                ];
            }
        },
        text: {
            group: "inline"
        },
        image: {
            inline: true,
            attrs: {
                src: {},
                alt: {
                    default: null
                },
                title: {
                    default: null
                }
            },
            group: "inline",
            draggable: true,
            parseDOM: [
                {
                    tag: "img[src]",
                    getAttrs (dom) {
                        return {
                            src: dom.getAttribute("src"),
                            title: dom.getAttribute("title"),
                            alt: dom.getAttribute("alt")
                        };
                    }
                }
            ],
            toDOM (node) {
                return [
                    "img",
                    node.attrs
                ];
            }
        },
        hard_break: {
            inline: true,
            group: "inline",
            selectable: false,
            parseDOM: [
                {
                    tag: "br"
                }
            ],
            toDOM () {
                return [
                    "br"
                ];
            }
        }
    },
    marks: {
        em: {
            parseDOM: [
                {
                    tag: "i"
                },
                {
                    tag: "em"
                },
                {
                    style: "font-style=italic"
                },
                {
                    style: "font-style=normal",
                    clearMark: (m)=>m.type.name == "em"
                }
            ],
            toDOM () {
                return [
                    "em"
                ];
            }
        },
        strong: {
            parseDOM: [
                {
                    tag: "strong"
                },
                {
                    tag: "b",
                    getAttrs: (node)=>node.style.fontWeight != "normal" && null
                },
                {
                    style: "font-weight=400",
                    clearMark: (m)=>m.type.name == "strong"
                },
                {
                    style: "font-weight",
                    getAttrs: (value)=>/^(bold(er)?|[5-9]\d{2,})$/.test(value) && null
                }
            ],
            toDOM () {
                return [
                    "strong"
                ];
            }
        },
        link: {
            attrs: {
                href: {},
                title: {
                    default: null
                }
            },
            inclusive: false,
            parseDOM: [
                {
                    tag: "a[href]",
                    getAttrs (dom) {
                        return {
                            href: dom.getAttribute("href"),
                            title: dom.getAttribute("title")
                        };
                    }
                }
            ],
            toDOM (node) {
                return [
                    "a",
                    node.attrs
                ];
            }
        },
        code: {
            parseDOM: [
                {
                    tag: "code"
                }
            ],
            toDOM () {
                return [
                    "code"
                ];
            }
        }
    }
});
// @ts-ignore
function $2f1abea25e652257$var$maybeMerge(a, b) {
    if (a.isText && b.isText && (0, $5SAOw.Mark).sameSet(a.marks, b.marks)) return a.withText(a.text + b.text);
}
// Object used to track the context of a running parse.
class $2f1abea25e652257$var$MarkdownParseState {
    top() {
        return this.stack[this.stack.length - 1];
    }
    push(elt) {
        if (this.stack.length) this.top().content.push(elt);
    }
    // Adds the given text to the current position in the document,
    // using the current marks as styling.
    addText(text) {
        if (!text) return;
        let top = this.top(), nodes = top.content, last = nodes[nodes.length - 1];
        let node = this.schema.text(text, top.marks), merged;
        if (last && (merged = $2f1abea25e652257$var$maybeMerge(last, node))) nodes[nodes.length - 1] = merged;
        else nodes.push(node);
    }
    // Adds the given mark to the set of active marks.
    openMark(mark) {
        let top = this.top();
        top.marks = mark.addToSet(top.marks);
    }
    // Removes the given mark from the set of active marks.
    closeMark(mark) {
        let top = this.top();
        top.marks = mark.removeFromSet(top.marks);
    }
    parseTokens(toks) {
        for(let i = 0; i < toks.length; i++){
            let tok = toks[i];
            let handler = this.tokenHandlers[tok.type];
            if (!handler) throw new Error("Token type `" + tok.type + "` not supported by Markdown parser");
            handler(this, tok, toks, i);
        }
    }
    // Add a node at the current position.
    addNode(type, attrs, content) {
        let top = this.top();
        let node = type.createAndFill(attrs, content, top ? top.marks : []);
        if (!node) return null;
        this.push(node);
        return node;
    }
    // Wrap subsequent content in a node of the given type.
    openNode(type, attrs) {
        this.stack.push({
            type: type,
            attrs: attrs,
            content: [],
            marks: (0, $5SAOw.Mark).none
        });
    }
    // Close and return the node that is currently on top of the stack.
    closeNode() {
        let info = this.stack.pop();
        return this.addNode(info.type, info.attrs, info.content);
    }
    constructor(schema, tokenHandlers){
        this.schema = schema;
        this.tokenHandlers = tokenHandlers;
        this.stack = [
            {
                type: schema.topNodeType,
                attrs: null,
                content: [],
                marks: (0, $5SAOw.Mark).none
            }
        ];
    }
}
function $2f1abea25e652257$var$attrs(spec, token, tokens, i) {
    if (spec.getAttrs) return spec.getAttrs(token, tokens, i);
    else if (spec.attrs instanceof Function) return spec.attrs(token);
    else return spec.attrs;
}
// Code content is represented as a single token with a `content`
// property in Markdown-it.
function $2f1abea25e652257$var$noCloseToken(spec, type) {
    return spec.noCloseToken || type == "code_inline" || type == "code_block" || type == "fence";
}
function $2f1abea25e652257$var$withoutTrailingNewline(str) {
    return str[str.length - 1] == "\n" ? str.slice(0, str.length - 1) : str;
}
function $2f1abea25e652257$var$noOp() {}
function $2f1abea25e652257$var$tokenHandlers(schema, tokens) {
    let handlers = Object.create(null);
    for(let type in tokens){
        let spec = tokens[type];
        if (spec.block) {
            let nodeType = schema.nodeType(spec.block);
            if ($2f1abea25e652257$var$noCloseToken(spec, type)) handlers[type] = (state, tok, tokens, i)=>{
                state.openNode(nodeType, $2f1abea25e652257$var$attrs(spec, tok, tokens, i));
                state.addText($2f1abea25e652257$var$withoutTrailingNewline(tok.content));
                state.closeNode();
            };
            else {
                handlers[type + "_open"] = (state, tok, tokens, i)=>state.openNode(nodeType, $2f1abea25e652257$var$attrs(spec, tok, tokens, i));
                handlers[type + "_close"] = (state)=>state.closeNode();
            }
        } else if (spec.node) {
            let nodeType = schema.nodeType(spec.node);
            handlers[type] = (state, tok, tokens, i)=>state.addNode(nodeType, $2f1abea25e652257$var$attrs(spec, tok, tokens, i));
        } else if (spec.mark) {
            let markType = schema.marks[spec.mark];
            if ($2f1abea25e652257$var$noCloseToken(spec, type)) handlers[type] = (state, tok, tokens, i)=>{
                state.openMark(markType.create($2f1abea25e652257$var$attrs(spec, tok, tokens, i)));
                state.addText($2f1abea25e652257$var$withoutTrailingNewline(tok.content));
                state.closeMark(markType);
            };
            else {
                handlers[type + "_open"] = (state, tok, tokens, i)=>state.openMark(markType.create($2f1abea25e652257$var$attrs(spec, tok, tokens, i)));
                handlers[type + "_close"] = (state)=>state.closeMark(markType);
            }
        } else if (spec.ignore) {
            if ($2f1abea25e652257$var$noCloseToken(spec, type)) handlers[type] = $2f1abea25e652257$var$noOp;
            else {
                handlers[type + "_open"] = $2f1abea25e652257$var$noOp;
                handlers[type + "_close"] = $2f1abea25e652257$var$noOp;
            }
        } else throw new RangeError("Unrecognized parsing spec " + JSON.stringify(spec));
    }
    handlers.text = (state, tok)=>state.addText(tok.content);
    handlers.inline = (state, tok)=>state.parseTokens(tok.children);
    handlers.softbreak = handlers.softbreak || ((state)=>state.addText(" "));
    return handlers;
}
/**
A configuration of a Markdown parser. Such a parser uses
[markdown-it](https://github.com/markdown-it/markdown-it) to
tokenize a file, and then runs the custom rules it is given over
the tokens to create a ProseMirror document tree.
*/ class $2f1abea25e652257$export$a64f782182dea128 {
    /**
    Parse a string as [CommonMark](http://commonmark.org/) markup,
    and create a ProseMirror document as prescribed by this parser's
    rules.
    
    The second argument, when given, is passed through to the
    [Markdown
    parser](https://markdown-it.github.io/markdown-it/#MarkdownIt.parse).
    */ parse(text, markdownEnv = {}) {
        let state = new $2f1abea25e652257$var$MarkdownParseState(this.schema, this.tokenHandlers), doc;
        state.parseTokens(this.tokenizer.parse(text, markdownEnv));
        do doc = state.closeNode();
        while (state.stack.length);
        return doc || this.schema.topNodeType.createAndFill();
    }
    /**
    Create a parser with the given configuration. You can configure
    the markdown-it parser to parse the dialect you want, and provide
    a description of the ProseMirror entities those tokens map to in
    the `tokens` object, which maps token names to descriptions of
    what to do with them. Such a description is an object, and may
    have the following properties:
    */ constructor(/**
    The parser's document schema.
    */ schema, /**
    This parser's markdown-it tokenizer.
    */ tokenizer, /**
    The value of the `tokens` object used to construct this
    parser. Can be useful to copy and modify to base other parsers
    on.
    */ tokens){
        this.schema = schema;
        this.tokenizer = tokenizer;
        this.tokens = tokens;
        this.tokenHandlers = $2f1abea25e652257$var$tokenHandlers(schema, tokens);
    }
}
function $2f1abea25e652257$var$listIsTight(tokens, i) {
    while(++i < tokens.length)if (tokens[i].type != "list_item_open") return tokens[i].hidden;
    return false;
}
/**
A parser parsing unextended [CommonMark](http://commonmark.org/),
without inline HTML, and producing a document in the basic schema.
*/ const $2f1abea25e652257$export$7517583227ad0cb8 = new $2f1abea25e652257$export$a64f782182dea128($2f1abea25e652257$export$4902baddc787debb, (0, (/*@__PURE__*/$parcel$interopDefault($2Yzoe)))("commonmark", {
    html: false
}), {
    blockquote: {
        block: "blockquote"
    },
    paragraph: {
        block: "paragraph"
    },
    list_item: {
        block: "list_item"
    },
    bullet_list: {
        block: "bullet_list",
        getAttrs: (_, tokens, i)=>({
                tight: $2f1abea25e652257$var$listIsTight(tokens, i)
            })
    },
    ordered_list: {
        block: "ordered_list",
        getAttrs: (tok, tokens, i)=>({
                order: +tok.attrGet("start") || 1,
                tight: $2f1abea25e652257$var$listIsTight(tokens, i)
            })
    },
    heading: {
        block: "heading",
        getAttrs: (tok)=>({
                level: +tok.tag.slice(1)
            })
    },
    code_block: {
        block: "code_block",
        noCloseToken: true
    },
    fence: {
        block: "code_block",
        getAttrs: (tok)=>({
                params: tok.info || ""
            }),
        noCloseToken: true
    },
    hr: {
        node: "horizontal_rule"
    },
    image: {
        node: "image",
        getAttrs: (tok)=>({
                src: tok.attrGet("src"),
                title: tok.attrGet("title") || null,
                alt: tok.children[0] && tok.children[0].content || null
            })
    },
    hardbreak: {
        node: "hard_break"
    },
    em: {
        mark: "em"
    },
    strong: {
        mark: "strong"
    },
    link: {
        mark: "link",
        getAttrs: (tok)=>({
                href: tok.attrGet("href"),
                title: tok.attrGet("title") || null
            })
    },
    code_inline: {
        mark: "code",
        noCloseToken: true
    }
});
const $2f1abea25e652257$var$blankMark = {
    open: "",
    close: "",
    mixable: true
};
/**
A specification for serializing a ProseMirror document as
Markdown/CommonMark text.
*/ class $2f1abea25e652257$export$ae9f6f04acb6c60c {
    /**
    Serialize the content of the given node to
    [CommonMark](http://commonmark.org/).
    */ serialize(content, options = {}) {
        options = Object.assign({}, this.options, options);
        let state = new $2f1abea25e652257$export$61055fa707e69319(this.nodes, this.marks, options);
        state.renderContent(content);
        return state.out;
    }
    /**
    Construct a serializer with the given configuration. The `nodes`
    object should map node names in a given schema to function that
    take a serializer state and such a node, and serialize the node.
    */ constructor(/**
    The node serializer functions for this serializer.
    */ nodes, /**
    The mark serializer info.
    */ marks, options = {}){
        this.nodes = nodes;
        this.marks = marks;
        this.options = options;
    }
}
/**
A serializer for the [basic schema](https://prosemirror.net/docs/ref/#schema).
*/ const $2f1abea25e652257$export$f996452ca6e9a0ae = new $2f1abea25e652257$export$ae9f6f04acb6c60c({
    blockquote (state, node) {
        state.wrapBlock("> ", null, node, ()=>state.renderContent(node));
    },
    code_block (state, node) {
        // Make sure the front matter fences are longer than any dash sequence within it
        const backticks = node.textContent.match(/`{3,}/gm);
        const fence = backticks ? backticks.sort().slice(-1)[0] + "`" : "```";
        state.write(fence + (node.attrs.params || "") + "\n");
        state.text(node.textContent, false);
        // Add a newline to the current content before adding closing marker
        state.write("\n");
        state.write(fence);
        state.closeBlock(node);
    },
    heading (state, node) {
        state.write(state.repeat("#", node.attrs.level) + " ");
        state.renderInline(node, false);
        state.closeBlock(node);
    },
    horizontal_rule (state, node) {
        state.write(node.attrs.markup || "---");
        state.closeBlock(node);
    },
    bullet_list (state, node) {
        state.renderList(node, "  ", ()=>(node.attrs.bullet || "*") + " ");
    },
    ordered_list (state, node) {
        let start = node.attrs.order || 1;
        let maxW = String(start + node.childCount - 1).length;
        let space = state.repeat(" ", maxW + 2);
        state.renderList(node, space, (i)=>{
            let nStr = String(start + i);
            return state.repeat(" ", maxW - nStr.length) + nStr + ". ";
        });
    },
    list_item (state, node) {
        state.renderContent(node);
    },
    paragraph (state, node) {
        state.renderInline(node);
        state.closeBlock(node);
    },
    image (state, node) {
        state.write("![" + state.esc(node.attrs.alt || "") + "](" + node.attrs.src.replace(/[\(\)]/g, "\\$&") + (node.attrs.title ? ' "' + node.attrs.title.replace(/"/g, '\\"') + '"' : "") + ")");
    },
    hard_break (state, node, parent, index) {
        for(let i = index + 1; i < parent.childCount; i++)if (parent.child(i).type != node.type) {
            state.write("\\\n");
            return;
        }
    },
    text (state, node) {
        state.text(node.text, !state.inAutolink);
    }
}, {
    em: {
        open: "*",
        close: "*",
        mixable: true,
        expelEnclosingWhitespace: true
    },
    strong: {
        open: "**",
        close: "**",
        mixable: true,
        expelEnclosingWhitespace: true
    },
    link: {
        open (state, mark, parent, index) {
            state.inAutolink = $2f1abea25e652257$var$isPlainURL(mark, parent, index);
            return state.inAutolink ? "<" : "[";
        },
        close (state, mark, parent, index) {
            let { inAutolink: inAutolink } = state;
            state.inAutolink = undefined;
            return inAutolink ? ">" : "](" + mark.attrs.href.replace(/[\(\)"]/g, "\\$&") + (mark.attrs.title ? ` "${mark.attrs.title.replace(/"/g, '\\"')}"` : "") + ")";
        },
        mixable: true
    },
    code: {
        open (_state, _mark, parent, index) {
            return $2f1abea25e652257$var$backticksFor(parent.child(index), -1);
        },
        close (_state, _mark, parent, index) {
            return $2f1abea25e652257$var$backticksFor(parent.child(index - 1), 1);
        },
        escape: false
    }
});
function $2f1abea25e652257$var$backticksFor(node, side) {
    let ticks = /`+/g, m, len = 0;
    if (node.isText) while(m = ticks.exec(node.text))len = Math.max(len, m[0].length);
    let result = len > 0 && side > 0 ? " `" : "`";
    for(let i = 0; i < len; i++)result += "`";
    if (len > 0 && side < 0) result += " ";
    return result;
}
function $2f1abea25e652257$var$isPlainURL(link, parent, index) {
    if (link.attrs.title || !/^\w+:/.test(link.attrs.href)) return false;
    let content = parent.child(index);
    if (!content.isText || content.text != link.attrs.href || content.marks[content.marks.length - 1] != link) return false;
    return index == parent.childCount - 1 || !link.isInSet(parent.child(index + 1).marks);
}
/**
This is an object used to track state and expose
methods related to markdown serialization. Instances are passed to
node and mark serialization methods (see `toMarkdown`).
*/ class $2f1abea25e652257$export$61055fa707e69319 {
    /**
    @internal
    */ flushClose(size = 2) {
        if (this.closed) {
            if (!this.atBlank()) this.out += "\n";
            if (size > 1) {
                let delimMin = this.delim;
                let trim = /\s+$/.exec(delimMin);
                if (trim) delimMin = delimMin.slice(0, delimMin.length - trim[0].length);
                for(let i = 1; i < size; i++)this.out += delimMin + "\n";
            }
            this.closed = null;
        }
    }
    /**
    @internal
    */ getMark(name) {
        let info = this.marks[name];
        if (!info) {
            if (this.options.strict !== false) throw new Error(`Mark type \`${name}\` not supported by Markdown renderer`);
            info = $2f1abea25e652257$var$blankMark;
        }
        return info;
    }
    /**
    Render a block, prefixing each line with `delim`, and the first
    line in `firstDelim`. `node` should be the node that is closed at
    the end of the block, and `f` is a function that renders the
    content of the block.
    */ wrapBlock(delim, firstDelim, node, f) {
        let old = this.delim;
        this.write(firstDelim != null ? firstDelim : delim);
        this.delim += delim;
        f();
        this.delim = old;
        this.closeBlock(node);
    }
    /**
    @internal
    */ atBlank() {
        return /(^|\n)$/.test(this.out);
    }
    /**
    Ensure the current content ends with a newline.
    */ ensureNewLine() {
        if (!this.atBlank()) this.out += "\n";
    }
    /**
    Prepare the state for writing output (closing closed paragraphs,
    adding delimiters, and so on), and then optionally add content
    (unescaped) to the output.
    */ write(content) {
        this.flushClose();
        if (this.delim && this.atBlank()) this.out += this.delim;
        if (content) this.out += content;
    }
    /**
    Close the block for the given node.
    */ closeBlock(node) {
        this.closed = node;
    }
    /**
    Add the given text to the document. When escape is not `false`,
    it will be escaped.
    */ text(text, escape = true) {
        let lines = text.split("\n");
        for(let i = 0; i < lines.length; i++){
            this.write();
            // Escape exclamation marks in front of links
            if (!escape && lines[i][0] == "[" && /(^|[^\\])\!$/.test(this.out)) this.out = this.out.slice(0, this.out.length - 1) + "\\!";
            this.out += escape ? this.esc(lines[i], this.atBlockStart) : lines[i];
            if (i != lines.length - 1) this.out += "\n";
        }
    }
    /**
    Render the given node as a block.
    */ render(node, parent, index) {
        if (this.nodes[node.type.name]) this.nodes[node.type.name](this, node, parent, index);
        else {
            if (this.options.strict !== false) throw new Error("Token type `" + node.type.name + "` not supported by Markdown renderer");
            else if (!node.type.isLeaf) {
                if (node.type.inlineContent) this.renderInline(node);
                else this.renderContent(node);
                if (node.isBlock) this.closeBlock(node);
            }
        }
    }
    /**
    Render the contents of `parent` as block nodes.
    */ renderContent(parent) {
        parent.forEach((node, _, i)=>this.render(node, parent, i));
    }
    /**
    Render the contents of `parent` as inline content.
    */ renderInline(parent, fromBlockStart = true) {
        this.atBlockStart = fromBlockStart;
        let active = [], trailing = "";
        let progress = (node, offset, index)=>{
            let marks = node ? node.marks : [];
            // Remove marks from `hard_break` that are the last node inside
            // that mark to prevent parser edge cases with new lines just
            // before closing marks.
            if (node && node.type.name === this.options.hardBreakNodeName) marks = marks.filter((m)=>{
                if (index + 1 == parent.childCount) return false;
                let next = parent.child(index + 1);
                return m.isInSet(next.marks) && (!next.isText || /\S/.test(next.text));
            });
            let leading = trailing;
            trailing = "";
            // If whitespace has to be expelled from the node, adjust
            // leading and trailing accordingly.
            if (node && node.isText && marks.some((mark)=>{
                let info = this.getMark(mark.type.name);
                return info && info.expelEnclosingWhitespace && !mark.isInSet(active);
            })) {
                let [_, lead, rest] = /^(\s*)(.*)$/m.exec(node.text);
                if (lead) {
                    leading += lead;
                    node = rest ? node.withText(rest) : null;
                    if (!node) marks = active;
                }
            }
            if (node && node.isText && marks.some((mark)=>{
                let info = this.getMark(mark.type.name);
                return info && info.expelEnclosingWhitespace && (index == parent.childCount - 1 || !mark.isInSet(parent.child(index + 1).marks));
            })) {
                let [_, rest, trail] = /^(.*?)(\s*)$/m.exec(node.text);
                if (trail) {
                    trailing = trail;
                    node = rest ? node.withText(rest) : null;
                    if (!node) marks = active;
                }
            }
            let inner = marks.length ? marks[marks.length - 1] : null;
            let noEsc = inner && this.getMark(inner.type.name).escape === false;
            let len = marks.length - (noEsc ? 1 : 0);
            // Try to reorder 'mixable' marks, such as em and strong, which
            // in Markdown may be opened and closed in different order, so
            // that order of the marks for the token matches the order in
            // active.
            outer: for(let i = 0; i < len; i++){
                let mark = marks[i];
                if (!this.getMark(mark.type.name).mixable) break;
                for(let j = 0; j < active.length; j++){
                    let other = active[j];
                    if (!this.getMark(other.type.name).mixable) break;
                    if (mark.eq(other)) {
                        if (i > j) marks = marks.slice(0, j).concat(mark).concat(marks.slice(j, i)).concat(marks.slice(i + 1, len));
                        else if (j > i) marks = marks.slice(0, i).concat(marks.slice(i + 1, j)).concat(mark).concat(marks.slice(j, len));
                        continue outer;
                    }
                }
            }
            // Find the prefix of the mark set that didn't change
            let keep = 0;
            while(keep < Math.min(active.length, len) && marks[keep].eq(active[keep]))++keep;
            // Close the marks that need to be closed
            while(keep < active.length)this.text(this.markString(active.pop(), false, parent, index), false);
            // Output any previously expelled trailing whitespace outside the marks
            if (leading) this.text(leading);
            // Open the marks that need to be opened
            if (node) {
                while(active.length < len){
                    let add = marks[active.length];
                    active.push(add);
                    this.text(this.markString(add, true, parent, index), false);
                    this.atBlockStart = false;
                }
                // Render the node. Special case code marks, since their content
                // may not be escaped.
                if (noEsc && node.isText) this.text(this.markString(inner, true, parent, index) + node.text + this.markString(inner, false, parent, index + 1), false);
                else this.render(node, parent, index);
                this.atBlockStart = false;
            }
            // After the first non-empty text node is rendered, the end of output
            // is no longer at block start.
            //
            // FIXME: If a non-text node writes something to the output for this
            // block, the end of output is also no longer at block start. But how
            // can we detect that?
            if ((node === null || node === void 0 ? void 0 : node.isText) && node.nodeSize > 0) this.atBlockStart = false;
        };
        parent.forEach(progress);
        progress(null, 0, parent.childCount);
        this.atBlockStart = false;
    }
    /**
    Render a node's content as a list. `delim` should be the extra
    indentation added to all lines except the first in an item,
    `firstDelim` is a function going from an item index to a
    delimiter for the first line of the item.
    */ renderList(node, delim, firstDelim) {
        if (this.closed && this.closed.type == node.type) this.flushClose(3);
        else if (this.inTightList) this.flushClose(1);
        let isTight = typeof node.attrs.tight != "undefined" ? node.attrs.tight : this.options.tightLists;
        let prevTight = this.inTightList;
        this.inTightList = isTight;
        node.forEach((child, _, i)=>{
            if (i && isTight) this.flushClose(1);
            this.wrapBlock(delim, firstDelim(i), node, ()=>this.render(child, node, i));
        });
        this.inTightList = prevTight;
    }
    /**
    Escape the given string so that it can safely appear in Markdown
    content. If `startOfLine` is true, also escape characters that
    have special meaning only at the start of the line.
    */ esc(str, startOfLine = false) {
        str = str.replace(/[`*\\~\[\]_]/g, (m, i)=>m == "_" && i > 0 && i + 1 < str.length && str[i - 1].match(/\w/) && str[i + 1].match(/\w/) ? m : "\\" + m);
        if (startOfLine) str = str.replace(/^(\+[ ]|[\-*>])/, "\\$&").replace(/^(\s*)(#{1,6})(\s|$)/, '$1\\$2$3').replace(/^(\s*\d+)\.\s/, "$1\\. ");
        if (this.options.escapeExtraCharacters) str = str.replace(this.options.escapeExtraCharacters, "\\$&");
        return str;
    }
    /**
    @internal
    */ quote(str) {
        let wrap = str.indexOf('"') == -1 ? '""' : str.indexOf("'") == -1 ? "''" : "()";
        return wrap[0] + str + wrap[1];
    }
    /**
    Repeat the given string `n` times.
    */ repeat(str, n) {
        let out = "";
        for(let i = 0; i < n; i++)out += str;
        return out;
    }
    /**
    Get the markdown string for a given opening or closing mark.
    */ markString(mark, open, parent, index) {
        let info = this.getMark(mark.type.name);
        let value = open ? info.open : info.close;
        return typeof value == "string" ? value : value(this, mark, parent, index);
    }
    /**
    Get leading and trailing whitespace from a string. Values of
    leading or trailing property of the return object will be undefined
    if there is no match.
    */ getEnclosingWhitespace(text) {
        return {
            leading: (text.match(/^(\s+)/) || [
                undefined
            ])[0],
            trailing: (text.match(/(\s+)$/) || [
                undefined
            ])[0]
        };
    }
    /**
    @internal
    */ constructor(/**
    @internal
    */ nodes, /**
    @internal
    */ marks, /**
    The options passed to the serializer.
    */ options){
        this.nodes = nodes;
        this.marks = marks;
        this.options = options;
        /**
        @internal
        */ this.delim = "";
        /**
        @internal
        */ this.out = "";
        /**
        @internal
        */ this.closed = null;
        /**
        @internal
        */ this.inAutolink = undefined;
        /**
        @internal
        */ this.atBlockStart = false;
        /**
        @internal
        */ this.inTightList = false;
        if (typeof this.options.tightLists == "undefined") this.options.tightLists = false;
        if (typeof this.options.hardBreakNodeName == "undefined") this.options.hardBreakNodeName = "hard_break";
    }
}
module.exports["MarkdownParser"] = $2f1abea25e652257$export$a64f782182dea128;
module.exports["MarkdownSerializerState"] = $2f1abea25e652257$export$61055fa707e69319;

});

parcelRegister("c4jUA", function(module, exports) {

var $3BqCC = parcelRequire("3BqCC");


var $4U5Tv = parcelRequire("4U5Tv");


var $ehlgT = parcelRequire("ehlgT");

/* Built-in method references for those with the same name as other `lodash` methods. */ var $8c954dc8baefb0c1$var$nativeCeil = Math.ceil, $8c954dc8baefb0c1$var$nativeMax = Math.max;
/**
 * Creates an array of elements split into groups the length of `size`.
 * If `array` can't be split evenly, the final chunk will be the remaining
 * elements.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to process.
 * @param {number} [size=1] The length of each chunk
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the new array of chunks.
 * @example
 *
 * _.chunk(['a', 'b', 'c', 'd'], 2);
 * // => [['a', 'b'], ['c', 'd']]
 *
 * _.chunk(['a', 'b', 'c', 'd'], 3);
 * // => [['a', 'b', 'c'], ['d']]
 */ function $8c954dc8baefb0c1$var$chunk(array, size, guard) {
    if (guard ? $4U5Tv(array, size, guard) : size === undefined) size = 1;
    else size = $8c954dc8baefb0c1$var$nativeMax($ehlgT(size), 0);
    var length = array == null ? 0 : array.length;
    if (!length || size < 1) return [];
    var index = 0, resIndex = 0, result = Array($8c954dc8baefb0c1$var$nativeCeil(length / size));
    while(index < length)result[resIndex++] = $3BqCC(array, index, index += size);
    return result;
}
module.exports = $8c954dc8baefb0c1$var$chunk;

});

parcelRegister("aCXDM", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
function $7bcbb766a0cbdbe5$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $7bcbb766a0cbdbe5$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $7bcbb766a0cbdbe5$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $7bcbb766a0cbdbe5$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $7bcbb766a0cbdbe5$export$2e2bcd8739ae039 = $7bcbb766a0cbdbe5$export$4f5d2d50c9deca37;
module.exports["clsx"] = $7bcbb766a0cbdbe5$export$4f5d2d50c9deca37;
module.exports["default"] = $7bcbb766a0cbdbe5$export$2e2bcd8739ae039;

});

parcelRegister("3fvfu", function(module, exports) {
const $443f0fc151c7533d$export$cee224b5de4d6d66 = 'https://www.atlassian.com/#Confluence';
const $443f0fc151c7533d$export$f654d825189934a7 = 'https://www.atlassian.com/#Jira';
const $443f0fc151c7533d$export$84a73a0383f58180 = 'JiraTask';
const $443f0fc151c7533d$export$c6c83963a9378a67 = 'JiraSubTask';
const $443f0fc151c7533d$export$58af3c426c111a6d = 'JiraStory';
const $443f0fc151c7533d$export$ac9898a63417219e = 'JiraBug';
const $443f0fc151c7533d$export$54db5e3fb12e39cd = 'JiraEpic';
const $443f0fc151c7533d$export$2f54a5a217202c85 = 'JiraIncident';
const $443f0fc151c7533d$export$d097371052bfc411 = 'JiraServiceRequest';
const $443f0fc151c7533d$export$efd9452ad16c6676 = 'JiraChange';
const $443f0fc151c7533d$export$2e7e70abb5d81f67 = 'JiraProblem';
const $443f0fc151c7533d$export$ce25cfc40b280dbc = 'JiraCustomTaskType';
module.exports["CONFLUENCE_GENERATOR_ID"] = $443f0fc151c7533d$export$cee224b5de4d6d66;
module.exports["JIRA_GENERATOR_ID"] = $443f0fc151c7533d$export$f654d825189934a7;

});

parcelRegister("iAg3T", function(module, exports) {

var $bCTuz = parcelRequire("bCTuz");

const $d8780c55f82b5b77$var$name = 'confluenceJiraIssue';
const $d8780c55f82b5b77$export$daf889beb5092f95 = (0, $bCTuz.confluenceJiraIssue)({
    parseDOM: [
        {
            tag: `span[data-node-type="${$d8780c55f82b5b77$var$name}"]`,
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    issueKey: dom.textContent,
                    macroId: dom.dataset && dom.dataset.macroId,
                    schemaVersion: dom.dataset && dom.dataset.schemaVersion,
                    server: dom.dataset && dom.dataset.server,
                    serverId: dom.dataset && dom.dataset.serverId
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': $d8780c55f82b5b77$var$name,
            'data-macro-id': node.attrs.macroId,
            'data-schema-version': node.attrs.schemaVersion,
            'data-server': node.attrs.server,
            'data-server-id': node.attrs.serverId,
            'data-jira-issue': node.attrs.issueKey
        };
        return [
            'span',
            attrs,
            node.attrs.issueKey
        ];
    }
});
module.exports["confluenceJiraIssue"] = $d8780c55f82b5b77$export$daf889beb5092f95;

});

parcelRegister("hOedk", function(module, exports) {

var $bCTuz = parcelRequire("bCTuz");

const $cf7221cdebbbc0e5$export$5c452ff88e35e47d = (0, $bCTuz.image)({
    parseDOM: [
        {
            tag: 'img[src^="data:image/"]',
            ignore: true
        },
        {
            tag: 'img[src]',
            getAttrs (domNode) {
                const dom = domNode;
                return {
                    src: dom.getAttribute('src'),
                    alt: dom.getAttribute('alt'),
                    title: dom.getAttribute('title')
                };
            }
        }
    ],
    toDOM (node) {
        return [
            'img',
            node.attrs
        ];
    }
});
module.exports["image"] = $cf7221cdebbbc0e5$export$5c452ff88e35e47d;

});

parcelRegister("9bakv", function(module, exports) {
$parcel$export(module.exports, "default", () => $6aed2763502d0c53$export$2e2bcd8739ae039);
const $6aed2763502d0c53$var$name = 'unknownBlock';
var $6aed2763502d0c53$export$2e2bcd8739ae039 = {
    group: 'block',
    content: 'inline+',
    marks: '_',
    toDOM () {
        return [
            'div',
            {
                'data-node-type': $6aed2763502d0c53$var$name
            },
            0
        ];
    },
    parseDOM: [
        {
            tag: `div[data-node-type="${$6aed2763502d0c53$var$name}"]`
        }
    ]
};

});

parcelRegister("cHf7l", function(module, exports) {
const $93e53a37cb340d7d$export$d5f21755dc782a4a = (name)=>{
    return !!name && [
        'default',
        'wide',
        'full-width'
    ].includes(name);
};
const $93e53a37cb340d7d$export$1765e2758fc47004 = (dom, isInline = false)=>{
    const extensionType = dom.getAttribute('data-extension-type');
    const extensionKey = dom.getAttribute('data-extension-key');
    if (!extensionType || !extensionKey) return false;
    const attrs = {
        extensionType: extensionType,
        extensionKey: extensionKey,
        text: dom.getAttribute('data-text') || undefined,
        parameters: JSON.parse(dom.getAttribute('data-parameters') || '{}'),
        localId: dom.getAttribute('data-local-id') || undefined
    };
    if (!isInline) {
        const rawLayout = dom.getAttribute('data-layout');
        attrs.layout = $93e53a37cb340d7d$export$d5f21755dc782a4a(rawLayout) ? rawLayout : 'default';
    }
    return attrs;
};
module.exports["getExtensionAttrs"] = $93e53a37cb340d7d$export$1765e2758fc47004;

});

parcelRegister("bxopY", function(module, exports) {

var $c6GJD = parcelRequire("c6GJD");

function $8665b7aaf777bfbc$export$bad3c41dd33cb4bc(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    return hexColor ? $8665b7aaf777bfbc$export$aa000893c5e2b9c2[hexColor.toUpperCase()] : undefined;
}
const $8665b7aaf777bfbc$export$aa000893c5e2b9c2 = {
    /** gray - subtle */ '#091E4224': 'var(--ds-border, #091E4224)',
    /** gray */ '#758195': 'var(--ds-border-bold, #758195)',
    /** gray - bold */ '#172B4D': 'var(--ds-text, #172B4D)'
};
function $8665b7aaf777bfbc$export$9c2f408d391feb93(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    return hexColor ? $8665b7aaf777bfbc$export$57fa5089caad992[hexColor.toUpperCase()] : undefined;
}
const $8665b7aaf777bfbc$export$57fa5089caad992 = {
    /** blue - light */ '#B3D4FF': 'var(--ds-background-accent-blue-subtler, #B3D4FF)',
    /** blue - medium */ '#4C9AFF': 'var(--ds-icon-accent-blue, #4C9AFF)',
    /** blue - strong */ '#0747A6': 'var(--ds-text-accent-blue, #0747A6)',
    /** teal - light */ '#B3F5FF': 'var(--ds-background-accent-teal-subtler, #B3F5FF)',
    /** teal - medium */ '#00B8D9': 'var(--ds-icon-accent-teal, #00B8D9)',
    /** teal - strong */ '#008DA6': 'var(--ds-text-accent-teal, #008DA6)',
    /** green - light */ '#ABF5D1': 'var(--ds-background-accent-green-subtler, #ABF5D1)',
    /** green - medium */ '#36B37E': 'var(--ds-icon-accent-green, #36B37E)',
    /** green - strong */ '#006644': 'var(--ds-text-accent-green, #006644)',
    /** yellowOrange - light */ '#FFF0B3': 'var(--ds-background-accent-yellow-subtler, #FFF0B3)',
    /** yellowOrange - medium */ '#FFC400': 'var(--ds-background-accent-orange-subtle, #FFC400)',
    /** yellowOrange - strong */ '#FF991F': 'var(--ds-icon-accent-orange, #FF991F)',
    /** red - light */ '#FFBDAD': 'var(--ds-background-accent-red-subtler, #FFBDAD)',
    /** red - medium */ '#FF5630': 'var(--ds-icon-accent-red, #FF5630)',
    /** red - strong */ '#BF2600': 'var(--ds-text-accent-red, #BF2600)',
    /** purple - light */ '#EAE6FF': 'var(--ds-background-accent-purple-subtler, #EAE6FF)',
    /** purple - medium */ '#6554C0': 'var(--ds-icon-accent-purple, #6554C0)',
    /** purple - strong */ '#403294': 'var(--ds-text-accent-purple, #403294)',
    /** whiteGray - light */ '#FFFFFF': 'var(--ds-text-inverse, #FFFFFF)',
    /** whiteGray - medium */ '#97A0AF': 'var(--ds-icon-accent-gray, #97A0AF)',
    /** whiteGray - strong */ '#172B4D': 'var(--ds-text, #172B4D)'
};
function $8665b7aaf777bfbc$export$8b58ff1b36bb75e0(hexColor) {
    if ((0, $c6GJD.default).getExperimentValue('platform_editor_add_orange_highlight_color', 'cohort', 'control') !== 'test') $8665b7aaf777bfbc$export$12a518ff137dd389['#FEDEC8'] = 'var(--ds-background-accent-yellow-subtler, #F8E6A0)';
    // Ts ignore was used to allow use of conditional return type
    // (preferring better type on consumption over safety in implementation)
    return hexColor ? $8665b7aaf777bfbc$export$12a518ff137dd389[hexColor.toUpperCase()] : undefined;
}
const $8665b7aaf777bfbc$export$12a518ff137dd389 = {
    /** Gray - light */ '#DCDFE4': 'var(--ds-background-accent-gray-subtler, #DCDFE4)',
    /** Teal - light */ '#C6EDFB': 'var(--ds-background-accent-teal-subtler, #C6EDFB)',
    /** Lime - light */ '#D3F1A7': 'var(--ds-background-accent-lime-subtler, #D3F1A7)',
    /** Yellow - light */ '#F8E6A0': 'var(--ds-background-accent-yellow-subtler, #F8E6A0)',
    /** Orange - light */ '#FEDEC8': 'var(--ds-background-accent-orange-subtler, #FEDEC8)',
    /** Magenta - light */ '#FDD0EC': 'var(--ds-background-accent-magenta-subtler, #FDD0EC)',
    /** Purple - light */ '#DFD8FD': 'var(--ds-background-accent-purple-subtler, #DFD8FD)'
};
function $8665b7aaf777bfbc$export$a270511a0e7fd61a(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    const tokenData = hexColor ? $8665b7aaf777bfbc$export$2462741d70e6a62f[hexColor.toUpperCase()] : undefined;
    return tokenData ? tokenData.getValue(hexColor) : undefined;
}
const $8665b7aaf777bfbc$export$2462741d70e6a62f = {
    /** blue - light */ '#DEEBFF': {
        getValue: ()=>'#DEEBFF',
        token: 'var(--ds-background-accent-blue-subtlest, #DEEBFF)'
    },
    /** blue - medium */ '#B3D4FF': {
        getValue: ()=>'#B3D4FF',
        token: 'var(--ds-background-accent-blue-subtler, #B3D4FF)'
    },
    /** blue - strong */ '#4C9AFF': {
        getValue: ()=>'#4C9AFF',
        token: 'var(--ds-background-accent-blue-subtle, #4C9AFF)'
    },
    /** teal - light */ '#E6FCFF': {
        getValue: ()=>'#E6FCFF',
        token: 'var(--ds-background-accent-teal-subtlest, #E6FCFF)'
    },
    /** teal - medium */ '#B3F5FF': {
        getValue: ()=>'#B3F5FF',
        token: 'var(--ds-background-accent-teal-subtler, #B3F5FF)'
    },
    /** teal - strong */ '#79E2F2': {
        getValue: ()=>'#79E2F2',
        token: 'var(--ds-background-accent-teal-subtle, #79E2F2)'
    },
    /** green - light */ '#E3FCEF': {
        getValue: ()=>'#E3FCEF',
        token: 'var(--ds-background-accent-green-subtlest, #E3FCEF)'
    },
    /** green - medium */ '#ABF5D1': {
        getValue: ()=>'#ABF5D1',
        token: 'var(--ds-background-accent-green-subtler, #ABF5D1)'
    },
    /** green - strong */ '#57D9A3': {
        getValue: ()=>'#57D9A3',
        token: 'var(--ds-background-accent-green-subtle, #57D9A3)'
    },
    /** yellowOrange - light */ '#FFFAE6': {
        getValue: ()=>'#FFFAE6',
        token: 'var(--ds-background-accent-yellow-subtlest, #FFFAE6)'
    },
    /** yellowOrange - medium */ '#FFF0B3': {
        getValue: ()=>'#FFF0B3',
        token: 'var(--ds-background-accent-yellow-subtler, #FFF0B3)'
    },
    /** yellowOrange - strong */ '#FFC400': {
        getValue: ()=>'#FFC400',
        token: 'var(--ds-background-accent-orange-subtle, #FFC400)'
    },
    /** red - light */ '#FFEBE6': {
        getValue: ()=>'#FFEBE6',
        token: 'var(--ds-background-accent-red-subtlest, #FFEBE6)'
    },
    /** red - medium */ '#FFBDAD': {
        getValue: ()=>'#FFBDAD',
        token: 'var(--ds-background-accent-red-subtler, #FFBDAD)'
    },
    /** red - strong */ '#FF8F73': {
        getValue: ()=>'#FF8F73',
        token: 'var(--ds-background-accent-red-subtle, #FF8F73)'
    },
    /** purple - light */ '#EAE6FF': {
        getValue: ()=>'#EAE6FF',
        token: 'var(--ds-background-accent-purple-subtlest, #EAE6FF)'
    },
    /** purple - medium */ '#C0B6F2': {
        getValue: ()=>'#C0B6F2',
        token: 'var(--ds-background-accent-purple-subtler, #C0B6F2)'
    },
    /** purple - strong */ '#998DD9': {
        getValue: ()=>'#998DD9',
        token: 'var(--ds-background-accent-purple-subtle, #998DD9)'
    },
    /** whiteGray - light */ '#FFFFFF': {
        getValue: ()=>'#FFFFFF',
        token: 'var(--ds-surface, #FFFFFF)'
    },
    /** whiteGray - medium */ '#F4F5F7': {
        getValue: ()=>'#F4F5F7',
        token: 'var(--ds-background-accent-gray-subtlest, #F4F5F7)'
    },
    /** whiteGray - strong */ '#B3BAC5': {
        getValue: ()=>'#B3BAC5',
        token: 'var(--ds-background-accent-gray-subtle, #B3BAC5)'
    }
};
module.exports["hexToEditorBorderPaletteColor"] = $8665b7aaf777bfbc$export$bad3c41dd33cb4bc;
module.exports["hexToEditorTextPaletteColor"] = $8665b7aaf777bfbc$export$9c2f408d391feb93;
module.exports["hexToEditorTextBackgroundPaletteColor"] = $8665b7aaf777bfbc$export$8b58ff1b36bb75e0;
module.exports["hexToEditorBackgroundPaletteRawValue"] = $8665b7aaf777bfbc$export$a270511a0e7fd61a;

});

parcelRegister("bAH9E", function(module, exports) {
// https://en.wikipedia.org/wiki/HCL_color_space
// https://en.wikipedia.org/wiki/CIE_1931_color_space#CIE_xy_chromaticity_diagram_and_the_CIE_xyY_color_space
// https://en.wikipedia.org/wiki/CIELAB_color_space
const $87048821df3afb68$var$clamp = (i, min, max)=>Math.round(Math.min(Math.max(i, min), max));
const $87048821df3afb68$var$expandShorthandHex = (input)=>input.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b)=>r + r + g + g + b + b);
const $87048821df3afb68$var$rgbFromHex = (input)=>{
    const fullHex = $87048821df3afb68$var$expandShorthandHex(input);
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(fullHex);
    return result === null ? null : {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    };
};
const $87048821df3afb68$var$rgbToHex = ({ r: r, g: g, b: b })=>{
    const convertComponent = (c)=>{
        const cBase16 = c.toString(16);
        return cBase16.length === 1 ? `0${cBase16}` : cBase16;
    };
    return `#${convertComponent(r)}${convertComponent(g)}${convertComponent(b)}`;
};
const $87048821df3afb68$var$rgbToXyz = (rgb)=>{
    const convertRgbComponent = (c)=>c > 0.04045 ? Math.pow((c + 0.055) / 1.055, 2.4) : c / 12.92;
    const convertXyzComponent = (c)=>c > 0.008856452 ? Math.pow(c, 1 / 3) : c / 0.12841855 + 0.137931034;
    const r = convertRgbComponent(rgb.r / 255);
    const g = convertRgbComponent(rgb.g / 255);
    const b = convertRgbComponent(rgb.b / 255);
    return {
        x: convertXyzComponent((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / 0.95047),
        y: convertXyzComponent(0.2126729 * r + 0.7151522 * g + 0.072175 * b),
        z: convertXyzComponent((0.0193339 * r + 0.119192 * g + 0.9503041 * b) / 1.08883)
    };
};
const $87048821df3afb68$var$xyzToLab = ({ x: x, y: y, z: z })=>({
        l: Math.max(116 * y - 16, 0),
        a: 500 * (x - y),
        b: 200 * (y - z)
    });
const $87048821df3afb68$var$labToLch = ({ l: l, a: a, b: b })=>{
    let h = (Math.atan2(b, a) * (180 / Math.PI) + 360) % 360;
    const c = Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2));
    if (Math.round(c * 10000) === 0) h = Number.NaN;
    return {
        l: l,
        c: c,
        h: h
    };
};
const $87048821df3afb68$var$lchToLab = ({ l: l, c: c, h: h })=>{
    const convertH = Number.isNaN(h) ? 0 : h * (Math.PI / 180);
    return {
        l: l,
        a: Math.cos(convertH) * c,
        b: Math.sin(convertH) * c
    };
};
const $87048821df3afb68$var$labToXyz = ({ l: l, a: a, b: b })=>{
    const convertComponent = (c)=>c > 0.206896552 ? Math.pow(c, 3) : 0.12841855 * (c - 0.137931034);
    const y = (l + 16) / 116;
    const x = a / 500 + y;
    const z = y - b / 200;
    return {
        x: convertComponent(x) * 0.95047,
        y: convertComponent(y),
        z: convertComponent(z) * 1.08883
    };
};
const $87048821df3afb68$var$xyzToRgb = ({ x: x, y: y, z: z })=>{
    const convertComponent = (c)=>255 * (c <= 0.00304 ? 12.92 * c : 1.055 * Math.pow(c, 1 / 2.4) - 0.055);
    return {
        r: $87048821df3afb68$var$clamp(convertComponent(3.2404542 * x - 1.5371385 * y - 0.4985314 * z), 0, 255),
        g: $87048821df3afb68$var$clamp(convertComponent(-0.969266 * x + 1.8760108 * y + 0.041556 * z), 0, 255),
        b: $87048821df3afb68$var$clamp(convertComponent(0.0556434 * x - 0.2040259 * y + 1.0572252 * z), 0, 255)
    };
};
const $87048821df3afb68$var$rgbToLch = (rgb)=>$87048821df3afb68$var$labToLch($87048821df3afb68$var$xyzToLab($87048821df3afb68$var$rgbToXyz(rgb)));
const $87048821df3afb68$var$lchToRgb = (lch)=>$87048821df3afb68$var$xyzToRgb($87048821df3afb68$var$labToXyz($87048821df3afb68$var$lchToLab(lch)));
const $87048821df3afb68$export$313b8a8fcb34c3b8 = (color, newPercent)=>{
    const rgb = $87048821df3afb68$var$rgbFromHex(color);
    if (rgb === null) return color;
    // LCH (rather than HSL) gives the best results here as the L component in LCH is based on human color perception
    const lch = $87048821df3afb68$var$rgbToLch(rgb);
    lch.l = $87048821df3afb68$var$clamp(newPercent, 0, 100);
    return $87048821df3afb68$var$rgbToHex($87048821df3afb68$var$lchToRgb(lch));
};
const $87048821df3afb68$var$getLightness = (color)=>{
    const rgb = $87048821df3afb68$var$rgbFromHex(color);
    if (rgb === null) return 0;
    const lch = $87048821df3afb68$var$rgbToLch(rgb);
    return lch.l;
};
const $87048821df3afb68$export$a5065c3b8aacaf99 = (currentBackgroundColor)=>{
    const lightness = $87048821df3afb68$var$getLightness(currentBackgroundColor);
    const newLightness = Math.abs(100 - lightness);
    return $87048821df3afb68$export$313b8a8fcb34c3b8(currentBackgroundColor, newLightness).toUpperCase();
};
module.exports["getDarkModeLCHColor"] = $87048821df3afb68$export$a5065c3b8aacaf99;

});

parcelRegister("filql", function(module, exports) {
const $b22927c6c2dfcf87$export$c296e2d4365c37a5 = (maybeNode)=>maybeNode instanceof Node && maybeNode.nodeType === Node.ELEMENT_NODE;
module.exports["isDOMElement"] = $b22927c6c2dfcf87$export$c296e2d4365c37a5;

});

parcelRegister("2jkq1", function(module, exports) {
$parcel$export(module.exports, "default", () => $8cb6dda2f8b04521$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $1zav4 = parcelRequire("1zav4");


var $2CQVV = parcelRequire("2CQVV");


var $frt7o = parcelRequire("frt7o");

var $bWRlG = parcelRequire("bWRlG");


var $dh538 = parcelRequire("dh538");


var $cN8vw = parcelRequire("cN8vw");

var $caYZ2 = parcelRequire("caYZ2");

var $d4WtM = parcelRequire("d4WtM");


var $2QYOD = parcelRequire("2QYOD");


var $aFUXX = parcelRequire("aFUXX");


var $6fQl1 = parcelRequire("6fQl1");


var $iu6m9 = parcelRequire("iu6m9");


var $1zvWv = parcelRequire("1zvWv");


var $iKFPk = parcelRequire("iKFPk");


var $bZfVt = parcelRequire("bZfVt");

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");








var $6fnsQ = parcelRequire("6fnsQ");










parcelRequire("42omo");













/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $bBvs5 = parcelRequire("bBvs5");

const $a5ed469e3634fc57$export$90335b3ff08f335 = ()=>(0, $bBvs5.useRendererContext)()?.featureFlags;









var $1oCLl = parcelRequire("1oCLl");

// we allow scaling down column widths by no more than 30%
// this intends to reduce unwanted scrolling in the Renderer in these scenarios:
// User A creates a table with column widths → User B views it on a smaller screen
// User A creates a table with column widths → User A views it with reduced viewport space (eg. Confluence sidebar is open)
const $90b28d79aa634748$var$MAX_SCALING_PERCENT = 0.3;
const $90b28d79aa634748$var$MAX_SCALING_PERCENT_TABLES_WITH_FIXED_COLUMN_WIDTHS_OPTION = 0.4;
const $90b28d79aa634748$var$isTableColumnResized = (columnWidths)=>{
    const filteredWidths = columnWidths.filter((width)=>width !== 0);
    return !!filteredWidths.length;
};
const $90b28d79aa634748$var$fixColumnWidth = ({ columnWidth: columnWidth, zeroWidthColumnsCount: zeroWidthColumnsCount, scaleDownPercent: scaleDownPercent })=>{
    if (columnWidth === 0) return columnWidth;
    // If the tables total width (including no zero widths col or cols without width) is less than the current layout
    // We scale up the columns to meet the minimum of the table layout.
    if (zeroWidthColumnsCount === 0 && scaleDownPercent) return Math.max(Math.floor((1 - scaleDownPercent) * columnWidth), (0, $1zav4.tableCellMinWidth));
    return Math.max(// We need to take tableCellBorderWidth, to avoid unnecessary overflow.
    columnWidth - (0, $1zav4.tableCellBorderWidth), zeroWidthColumnsCount ? (0, $aFUXX.akEditorTableLegacyCellMinWidth) : (0, $1zav4.tableCellMinWidth));
};
const $90b28d79aa634748$var$calcScalePercent = ({ renderWidth: renderWidth, tableWidth: tableWidth, maxScale: maxScale, isNumberColumnEnabled: isNumberColumnEnabled })=>{
    const noNumColumnScalePercent = renderWidth / tableWidth;
    // when numbered column is enabled, we need to calculate the scale percent without the akEditorTableNumberColumnWidth
    // As numbered column width is not scaled down
    const numColumnScalePercent = (renderWidth - (0, $aFUXX.akEditorTableNumberColumnWidth)) / (tableWidth - (0, $aFUXX.akEditorTableNumberColumnWidth));
    const diffPercent = 1 - noNumColumnScalePercent;
    return diffPercent < maxScale ? isNumberColumnEnabled ? 1 - numColumnScalePercent : diffPercent : maxScale;
};
const $90b28d79aa634748$export$2d9bdaa5b8cd99f0 = (columnWidths)=>columnWidths.reduce((prev, curr)=>curr + prev, 0);
const $90b28d79aa634748$var$renderScaleDownColgroup = (props)=>{
    const { columnWidths: columnWidths, isNumberColumnEnabled: isNumberColumnEnabled, renderWidth: renderWidth, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isInsideOfTable: isInsideOfTable, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, isTableScalingEnabled: isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled: isTableFixedColumnWidthsOptionEnabled, allowTableResizing: allowTableResizing, isTopLevelRenderer: isTopLevelRenderer } = props;
    if (!columnWidths || columnWidths.every((width)=>width === 0) && (0, $dh538.fg)('platform_editor_numbered_column_in_include')) return [];
    const tableColumnResized = $90b28d79aa634748$var$isTableColumnResized(columnWidths);
    const noOfColumns = columnWidths.length;
    let targetWidths;
    // This is a fix for ED-23259
    // Some extensions (for ex: Page Properties or Excerpt) do not renderer tables directly inside themselves. They use ReactRenderer.
    // So if we add a check like isInsideExtension (similar to exising isInsideBlockNode), it will fail, and to the only way to learn
    // if the table is rendered inside another node, is to check if the Renderer itself is nested.
    const isRendererNested = isTopLevelRenderer === false;
    // appearance == comment && allowTableResizing && !tableNode?.attrs.width, means it is a comment
    // appearance == comment && !allowTableResizing && !tableNode?.attrs.width, means it is a inline comment
    // When comment and inline comment table width inherits from the parent container, we want tableContainerWidth === renderWidth
    // Tables with numbered columns inside of extensions cannot use the renderWidth when it is 0. In this case, it should
    // explicitly use the width coming from the table node as the final table container width.
    const tableContainerWidth = rendererAppearance === 'comment' && !tableNode?.attrs.width || isRendererNested && (!(0, $dh538.fg)('platform_fix_nested_num_column_scaling') || !isNumberColumnEnabled) ? renderWidth : (0, $6fQl1.getTableContainerWidth)(tableNode);
    if (allowTableResizing && !isInsideOfBlockNode && !isInsideOfTable && !isinsideMultiBodiedExtension && !tableColumnResized) {
        // when no columns are resized, each column should have equal width, equals to tableWidth / noOfColumns
        const tableWidth = (isNumberColumnEnabled ? tableContainerWidth - (0, $aFUXX.akEditorTableNumberColumnWidth) : tableContainerWidth) - 1;
        const defaultColumnWidth = tableWidth / noOfColumns;
        targetWidths = new Array(noOfColumns).fill(defaultColumnWidth);
    } else if (!tableColumnResized) return null;
    const sumOfColumns = $90b28d79aa634748$export$2d9bdaa5b8cd99f0(columnWidths);
    // tables in the wild may be smaller than table container width (col resizing bugs, created before custom widths etc.)
    // this causes issues with num column scaling as we add a new table column in renderer
    const isTableSmallerThanContainer = sumOfColumns < tableContainerWidth - 1;
    const forceScaleForNumColumn = isTableScalingEnabled && isNumberColumnEnabled && tableColumnResized;
    // when table resized and number column is enabled, we need to scale down the table in render
    if (forceScaleForNumColumn) {
        const calculatedTableContainerWidth = rendererAppearance === 'comment' ? sumOfColumns : tableContainerWidth;
        const scalePercentage = +((calculatedTableContainerWidth - (0, $aFUXX.akEditorTableNumberColumnWidth)) / calculatedTableContainerWidth);
        const targetMaxWidth = calculatedTableContainerWidth - (0, $aFUXX.akEditorTableNumberColumnWidth);
        let totalWidthAfterScale = 0;
        const newScaledTargetWidths = columnWidths.map((width)=>{
            // we need to scale each column UP, to ensure total width of table matches table container
            const patchedWidth = isTableSmallerThanContainer ? width / sumOfColumns * (calculatedTableContainerWidth - 1) : width;
            const newWidth = Math.floor(patchedWidth * scalePercentage);
            totalWidthAfterScale += newWidth;
            return newWidth;
        });
        const diff = targetMaxWidth - totalWidthAfterScale;
        targetWidths = newScaledTargetWidths;
        if (diff > 0 || diff < 0 && Math.abs(diff) < (0, $1zav4.tableCellMinWidth)) {
            let updated = false;
            targetWidths = targetWidths.map((width)=>{
                if (!updated && width + diff > (0, $1zav4.tableCellMinWidth)) {
                    updated = true;
                    width += diff;
                }
                return width;
            });
        }
    }
    targetWidths = targetWidths || columnWidths;
    // @see ED-6056
    const maxTableWidth = renderWidth < tableContainerWidth ? renderWidth : tableContainerWidth;
    let tableWidth = isNumberColumnEnabled ? (0, $aFUXX.akEditorTableNumberColumnWidth) : 0;
    let minTableWidth = tableWidth;
    let zeroWidthColumnsCount = 0;
    targetWidths.forEach((width)=>{
        if (width) tableWidth += Math.ceil(width);
        else zeroWidthColumnsCount += 1;
        minTableWidth += Math.ceil(width) || (0, $aFUXX.akEditorTableLegacyCellMinWidth);
    });
    let cellMinWidth = 0;
    let scaleDownPercent = 0;
    const isTableScalingWithFixedColumnWidthsOptionEnabled = isTableScalingEnabled && isTableFixedColumnWidthsOptionEnabled;
    const isTableWidthFixed = isTableScalingWithFixedColumnWidthsOptionEnabled && props.tableNode?.attrs.displayMode === 'fixed';
    const maxScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled || isTableScalingEnabled && rendererAppearance === 'comment' ? $90b28d79aa634748$var$MAX_SCALING_PERCENT_TABLES_WITH_FIXED_COLUMN_WIDTHS_OPTION : $90b28d79aa634748$var$MAX_SCALING_PERCENT;
    // fixes migration tables with zero-width columns
    if (zeroWidthColumnsCount > 0) {
        if (minTableWidth > maxTableWidth) {
            const minWidth = Math.ceil((maxTableWidth - tableWidth) / zeroWidthColumnsCount);
            cellMinWidth = minWidth < (0, $aFUXX.akEditorTableLegacyCellMinWidth) ? (0, $aFUXX.akEditorTableLegacyCellMinWidth) : minWidth;
        }
    } else if (renderWidth < tableWidth && !isTableWidthFixed) {
        const shouldTable100ScaleDown = rendererAppearance === 'comment' && allowTableResizing && !tableNode?.attrs.width;
        scaleDownPercent = $90b28d79aa634748$var$calcScalePercent({
            renderWidth: renderWidth,
            tableWidth: tableWidth,
            maxScale: (0, $dh538.fg)('platform-ssr-table-resize') ? maxScalingPercent : shouldTable100ScaleDown ? 1 : maxScalingPercent,
            isNumberColumnEnabled: isNumberColumnEnabled
        });
    }
    if (isNumberColumnEnabled && (tableWidth < maxTableWidth || maxTableWidth === 0) && (0, $1oCLl.expValEquals)('editor_prevent_numbered_column_too_big_jira_1', 'isEnabled', true)) {
        const fixedColWidths = targetWidths.map((width)=>$90b28d79aa634748$var$fixColumnWidth({
                columnWidth: width,
                zeroWidthColumnsCount: zeroWidthColumnsCount,
                scaleDownPercent: scaleDownPercent
            }) || cellMinWidth);
        const sumFixedColumnWidths = $90b28d79aa634748$export$2d9bdaa5b8cd99f0(fixedColWidths);
        return fixedColWidths.map((colWidth)=>{
            const width = Math.max(colWidth, cellMinWidth);
            if (colWidth > (0, $aFUXX.akEditorTableCellMinWidth)) // To make sure the numbered column isn't scaled, use
            // percentages for the other columns.
            // Calculate the percentage based on the sum of the fixed column widths
            return {
                width: `${width / sumFixedColumnWidths * 100}%`
            };
            else {
                // If the column is equal to or less than the minimum cell width, we need to return a fixed pixel width.
                // This is to prevent columns being scaled below the minimum cell width.
                const style = width ? {
                    width: `${width}px`
                } : {};
                return style;
            }
        });
    }
    /**
	 * When cleaning up editor_prevent_numbered_column_too_big_jira_1 experiment,
	 * resuse the fixedColWidths const to avoid code duplication.
	 */ return targetWidths.map((colWidth)=>{
        const width = $90b28d79aa634748$var$fixColumnWidth({
            columnWidth: colWidth,
            zeroWidthColumnsCount: zeroWidthColumnsCount,
            scaleDownPercent: scaleDownPercent
        }) || cellMinWidth;
        const style = width ? {
            width: `${width}px`
        } : {};
        return style;
    });
};
const $90b28d79aa634748$export$89efc2d0ceeaa030 = (props)=>{
    const { isTopLevelRenderer: isTopLevelRenderer } = (0, $bBvs5.useRendererContext)();
    const { columnWidths: columnWidths, isNumberColumnEnabled: isNumberColumnEnabled } = props;
    const flags = (0, $a5ed469e3634fc57$export$90335b3ff08f335)();
    if (!columnWidths) return null;
    const colStyles = $90b28d79aa634748$var$renderScaleDownColgroup({
        ...props,
        isTopLevelRenderer: isTopLevelRenderer,
        isTableScalingEnabled: props.rendererAppearance === 'full-page' || props.rendererAppearance === 'full-width' || props.rendererAppearance === 'comment' && (0, $iu6m9.editorExperiment)('support_table_in_comment', true, {
            exposure: true
        }) || props.rendererAppearance === 'comment' && (0, $iu6m9.editorExperiment)('support_table_in_comment_jira', true, {
            exposure: true
        }),
        isTableFixedColumnWidthsOptionEnabled: !!(flags && 'tableWithFixedColumnWidthsOption' in flags && flags.tableWithFixedColumnWidthsOption) && (props.rendererAppearance === 'full-page' || props.rendererAppearance === 'full-width')
    });
    if (!colStyles) return null;
    return /*#__PURE__*/ (0, $l998X.jsxs)("colgroup", {
        children: [
            isNumberColumnEnabled && /*#__PURE__*/ (0, $l998X.jsx)("col", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                style: {
                    width: (0, $aFUXX.akEditorTableNumberColumnWidth)
                },
                "data-test-id": 'num'
            }),
            colStyles.map((style, idx)=>// Ignored via go/ees005
                // eslint-disable-next-line react/no-array-index-key, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, $l998X.jsx)("col", {
                    style: style
                }, idx))
        ]
    });
};











const $f71f60011122dddb$export$54ec01a60f47d33d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(({ innerRef: innerRef, isNumberColumnEnabled: isNumberColumnEnabled, columnWidths: columnWidths, layout: layout, renderWidth: renderWidth, children: children, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isInsideOfTable: isInsideOfTable, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, allowTableResizing: allowTableResizing, isPresentational: isPresentational, fixTableSSRResizing: fixTableSSRResizing = false })=>{
    let tableWidth = tableNode ? (0, $6fQl1.getTableContainerWidth)(tableNode) : (0, $aFUXX.akEditorDefaultLayoutWidth);
    let tableColumnWidths = columnWidths;
    if (rendererAppearance === 'comment' && allowTableResizing && tableNode && !tableNode.attrs?.width) tableWidth = 'inherit';
    if (rendererAppearance === 'comment' && !allowTableResizing) // in the case we have css container stylings,
    // we don't need to calculate width here as this
    // is done via css
    {
        if (!(0, $dh538.fg)('platform-ssr-table-resize')) tableWidth = renderWidth;
    }
    // for columns that are evenly distributed, do not return `colgroup` since existing table containerQuery
    // scales up the columns width. This ensures columns always have 42px.
    if (rendererAppearance === 'comment') // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    {
        if ((0, $dh538.fg)('platform-ssr-table-resize') && (0, $dh538.fg)('platform_table_number_column')) tableColumnWidths = columnWidths && (0, $90b28d79aa634748$export$2d9bdaa5b8cd99f0)(columnWidths) ? columnWidths : undefined;
    }
    const tableLayout = tableNode?.attrs.layout;
    const tableDisplayMode = tableNode?.attrs.displayMode;
    return /*#__PURE__*/ (0, $l998X.jsxs)("table", {
        ...(0, $dh538.fg)('platform_renderer_isPresentational') && {
            role: isPresentational ? 'presentation' : undefined
        },
        "data-testid": "renderer-table",
        "data-number-column": isNumberColumnEnabled,
        "data-table-width": tableWidth,
        "data-layout": tableLayout,
        "data-table-display-mode": tableDisplayMode,
        ref: innerRef,
        style: {
            marginTop: fixTableSSRResizing ? '0px' : ''
        },
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $90b28d79aa634748$export$89efc2d0ceeaa030), {
                columnWidths: tableColumnWidths,
                layout: layout,
                isNumberColumnEnabled: isNumberColumnEnabled,
                renderWidth: renderWidth,
                tableNode: tableNode,
                rendererAppearance: rendererAppearance,
                isInsideOfBlockNode: isInsideOfBlockNode,
                isInsideOfTable: isInsideOfTable,
                isinsideMultiBodiedExtension: isinsideMultiBodiedExtension,
                allowTableResizing: allowTableResizing
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("tbody", {
                children: children
            })
        ]
    });
});





function $5b4b0ffc2cc8f5f6$export$40e12ce8e0a76b0c(children, propsToInject) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.toArray(children).map((child)=>{
        // Cannot add a prop to an invalid element, so just return the child
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(child)) return child;
        // Recursive call if child has nested children
        if (child.props.children) child = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement(child, {
            children: $5b4b0ffc2cc8f5f6$export$40e12ce8e0a76b0c(child.props.children, propsToInject)
        });
        // Add props to react child node
        return (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement(child, propsToInject);
    });
}


function $a9ad1d399ee36b19$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a9ad1d399ee36b19$export$3de6413b528017ca = 8;
const $a9ad1d399ee36b19$var$modeSpecficStyles = {
    none: {
        name: "eivff4",
        styles: "display:none"
    },
    stick: {
        name: "duudsh",
        styles: "position:fixed"
    },
    'pin-bottom': {
        name: "a4hmbt",
        styles: "position:absolute"
    }
};
// refactored based on fixedTableDivStaticStyles
// TODO: DSP-4123 - Quality ticket
const $a9ad1d399ee36b19$var$fixedTableDivStaticStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    zIndex: 'var(--ak-renderer-sticky-header-zindex)',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $1zav4.TableSharedCssClassName).TABLE_CONTAINER}, & .${(0, $1zav4.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        marginTop: 0,
        marginBottom: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        tr: {
            background: "var(--ds-surface, white)"
        }
    },
    borderTop: `${$a9ad1d399ee36b19$export$3de6413b528017ca}px solid ${"var(--ds-surface, white)"}`,
    background: "var(--ds-surface-overlay, white)",
    boxShadow: `0 6px 4px -4px ${`var(--ds-shadow-overflow-perimeter, ${(0, $6fnsQ.N40A)})`}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    "div[data-expanded='false'] &": {
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $1zav4.TableSharedCssClassName).TABLE_CONTAINER}.is-sticky.right-shadow::after, & .${(0, $1zav4.TableSharedCssClassName).TABLE_CONTAINER}.is-sticky.left-shadow::before`]: {
        top: '0px',
        height: '100%'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "&.fixed-table-div-custom-table-resizing[mode='stick']": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: 'var(--ak-renderer-sticky-header-zindex)'
    }
});
const $a9ad1d399ee36b19$var$FixedTableDiv = (props)=>{
    const { top: top, wrapperWidth: wrapperWidth, mode: mode, allowTableResizing: allowTableResizing } = props;
    let stickyHeaderZIndex;
    if (allowTableResizing) stickyHeaderZIndex = 13;
    else stickyHeaderZIndex = (0, $aFUXX.akEditorStickyHeaderZIndex);
    const attrs = {
        mode: mode
    };
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        ...attrs,
        "data-testid": "sticky-table-fixed",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: allowTableResizing ? 'fixed-table-div-custom-table-resizing' : '',
        css: [
            $a9ad1d399ee36b19$var$fixedTableDivStaticStyles,
            $a9ad1d399ee36b19$var$modeSpecficStyles?.[mode]
        ],
        style: {
            '--ak-renderer-sticky-header-zindex': stickyHeaderZIndex,
            width: `${wrapperWidth}px`,
            top: typeof top === 'number' ? `${top}px` : undefined
        }
    }, props.children);
};
const $a9ad1d399ee36b19$export$fd9654fc359d55a3 = ({ top: top, left: left, mode: mode, shadowClassNames: shadowClassNames, innerRef: innerRef, wrapperWidth: wrapperWidth, tableWidth: tableWidth, isNumberColumnEnabled: isNumberColumnEnabled, layout: layout, children: children, columnWidths: columnWidths, renderWidth: renderWidth, rowHeight: rowHeight, tableNode: tableNode, rendererAppearance: rendererAppearance, allowTableResizing: allowTableResizing, fixTableSSRResizing: fixTableSSRResizing = false })=>{
    let styles;
    /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ if (allowTableResizing) styles = /*#__PURE__*/ (0, $9K4OG.css)({
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        top: mode === 'pin-bottom' ? top : undefined,
        position: 'absolute'
    });
    else styles = /*#__PURE__*/ (0, $9K4OG.css)({
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        left: left && left < 0 ? left : undefined,
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        top: mode === 'pin-bottom' ? top : undefined,
        position: 'relative'
    });
    /* eslint-enable @atlaskit/design-system/ensure-design-token-usage */ return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: styles
    }, /*#__PURE__*/ (0, $9K4OG.jsx)($a9ad1d399ee36b19$var$FixedTableDiv, {
        top: mode === 'stick' ? top : undefined,
        mode: rowHeight > 300 ? 'none' : mode,
        wrapperWidth: wrapperWidth,
        allowTableResizing: allowTableResizing
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${(0, $1zav4.TableSharedCssClassName).TABLE_CONTAINER} is-sticky ${shadowClassNames || ''}`,
        "data-layout": layout,
        style: {
            width: tableWidth,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            marginBottom: fixTableSSRResizing ? 0 : ''
        }
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        ref: innerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${(0, $1zav4.TableSharedCssClassName).TABLE_STICKY_WRAPPER}`,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $f71f60011122dddb$export$54ec01a60f47d33d), {
        columnWidths: columnWidths,
        layout: layout,
        isNumberColumnEnabled: isNumberColumnEnabled,
        renderWidth: renderWidth,
        tableNode: tableNode,
        rendererAppearance: rendererAppearance,
        fixTableSSRResizing: fixTableSSRResizing
    }, /**
               * @see https://product-fabric.atlassian.net/browse/ED-10235
               * We pass prop 'invisible' to our table's children nodes meaning
               * they exist inside of the 'invisible' duplicated table component that
               * enables sticky headers.
               */ (0, $5b4b0ffc2cc8f5f6$export$40e12ce8e0a76b0c)(children, {
        invisible: true
    })))))));
};
/**
 * Traverse DOM Tree upwards looking for table parents with "overflow: scroll".
 * @param table
 * @param defaultScrollRootId
 * @example
 */ function $a9ad1d399ee36b19$var$findHorizontalOverflowScrollParent(table, defaultScrollRootId) {
    let parent = table;
    if (!parent) return null;
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    while(parent = parent.parentElement){
        // IE11 on Window 8 doesn't show styles from CSS when accessing through element.style property.
        const style = window.getComputedStyle(parent);
        if (style.overflow === 'scroll' || style.overflowY === 'scroll') return parent;
        if (!!defaultScrollRootId && parent.id === defaultScrollRootId) // If a defaultScrollRootId was specified and we reached the element with this id without finding a closer
        // scroll parent, use this element as the scroll parent
        return parent;
    }
    return null;
}
class $a9ad1d399ee36b19$export$e97bc6692974bd0b {
    /**
   *
   * @param el
   * @param defaultScrollRootId
   * @example
   */ static fromElement(el, defaultScrollRootId) {
        return new $a9ad1d399ee36b19$export$e97bc6692974bd0b($a9ad1d399ee36b19$var$findHorizontalOverflowScrollParent(el, defaultScrollRootId) || window);
    }
    /**
   *
   */ get isElement() {
        return this.ref instanceof HTMLElement;
    }
    /**
   *
   */ get id() {
        if (this.ref instanceof HTMLElement) return this.ref.id;
        return '';
    }
    /**
   *
   */ get top() {
        if (this.ref instanceof HTMLElement) return this.ref.getBoundingClientRect().top;
        return 0;
    }
    /**
   *
   * @param type
   * @param cb
   * @param {...any} args
   * @example
   */ // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    addEventListener(type, cb, ...args) {
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.ref.addEventListener(type, cb, ...args);
    }
    /**
   *
   * @param type
   * @param cb
   * @param {...any} args
   * @example
   */ // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    removeEventListener(type, cb, ...args) {
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.ref.removeEventListener(type, cb, ...args);
    }
    constructor(ref){
        this.ref = ref;
        this.ref = ref;
    }
}



const $32a0d933940b97cc$export$c0112b8340d4924b = (appearance)=>appearance === 'full-width';
const $32a0d933940b97cc$export$a64737a81cde10b4 = (appearance)=>appearance === 'full-page';
const $32a0d933940b97cc$export$f77d2ff45b2c53ed = (appearance)=>appearance === 'comment';
const $32a0d933940b97cc$export$33331a99fac775a1 = (appearance)=>$32a0d933940b97cc$export$a64737a81cde10b4(appearance) || $32a0d933940b97cc$export$c0112b8340d4924b(appearance);








class $f6f7c885cc4b0838$export$8c072780619cfc83 {
    dispose() {
        if (this.stickyScrollbarContainerElement) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.stickyScrollbarContainerElement.removeEventListener('scroll', this.handleScroll);
        this.deleteIntersectionObserver();
    }
    scrollLeft(left) {
        if (this.stickyScrollbarContainerElement) this.stickyScrollbarContainerElement.scrollLeft = left;
    }
    init() {
        if (!this.wrapper) return;
        const scrollbarContainers = this.wrapper.parentElement?.querySelectorAll(`.${(0, $1zav4.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER}`);
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.stickyScrollbarContainerElement = (0, $dh538.fg)('platform_editor_querySelector_fix_table_renderer') ? scrollbarContainers?.item(scrollbarContainers.length - 1) : this.wrapper.parentElement?.querySelector(`.${(0, $1zav4.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER}`);
        if (this.stickyScrollbarContainerElement) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.stickyScrollbarContainerElement.addEventListener('scroll', this.handleScroll, {
            passive: true
        });
        this.createIntersectionObserver();
    }
    createIntersectionObserver() {
        this.rendererScrollableElement = window.document;
        if (!this.rendererScrollableElement || !this.wrapper) return;
        this.intersectionObserver = new IntersectionObserver((entries, _)=>{
            if (!this.stickyScrollbarContainerElement) return;
            entries.forEach((entry)=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const target = entry.target;
                if (target.classList.contains((0, $1zav4.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM)) this.sentinelBottomCallback(entry);
                if (target.classList.contains((0, $1zav4.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP)) this.sentinelTopCallback(entry);
            });
        }, {
            root: this.rendererScrollableElement
        });
        const bottomSentinels = this.wrapper?.parentElement?.getElementsByClassName((0, $1zav4.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM);
        this.sentinels.bottom = (0, $dh538.fg)('platform_editor_querySelector_fix_table_renderer') ? // eslint-disable-next-line @atlaskit/editor/no-as-casting
        bottomSentinels?.item(bottomSentinels.length - 1) : // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.wrapper?.parentElement?.getElementsByClassName((0, $1zav4.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM)?.item(0);
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.sentinels.top = this.wrapper?.parentElement?.getElementsByClassName((0, $1zav4.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP)?.item(0);
        [
            this.sentinels.bottom,
            this.sentinels.top
        ].forEach((el)=>// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            this.intersectionObserver.observe(el));
    }
    deleteIntersectionObserver() {
        if (this.intersectionObserver) {
            if (this.sentinels.bottom) this.intersectionObserver.unobserve(this.sentinels.bottom);
            this.intersectionObserver.disconnect();
        }
    }
    sentinelBottomCallback(entry) {
        const sentinelIsAboveScrollArea = entry.boundingClientRect.top < (entry.rootBounds?.top || 0);
        this.bottomSentinelState = sentinelIsAboveScrollArea ? 'above' : entry.isIntersecting ? 'visible' : 'below';
        this.toggle();
    }
    sentinelTopCallback(entry) {
        const sentinelIsBelowScrollArea = (entry.rootBounds?.bottom || 0) < entry.boundingClientRect.top;
        this.topSentinelState = sentinelIsBelowScrollArea ? 'below' : entry.isIntersecting ? 'visible' : 'above';
        this.toggle();
    }
    toggle() {
        if ((this.topSentinelState === 'visible' || this.topSentinelState === 'above') && this.bottomSentinelState === 'below') this.show();
        else this.hide();
    }
    hide() {
        if (this.stickyScrollbarContainerElement && this.stickyScrollbarContainerElement.style.visibility !== 'hidden') this.stickyScrollbarContainerElement.style.visibility = 'hidden';
    }
    show() {
        if (this.stickyScrollbarContainerElement && this.stickyScrollbarContainerElement.style.visibility !== 'visible') this.stickyScrollbarContainerElement.style.visibility = 'visible';
    }
    constructor(wrapper){
        this.wrapper = void 0;
        this.rendererScrollableElement = void 0;
        this.intersectionObserver = void 0;
        this.stickyScrollbarContainerElement = void 0;
        this.sentinels = {};
        this.topSentinelState = void 0;
        this.bottomSentinelState = void 0;
        this.handleScroll = (event)=>{
            if (!this.stickyScrollbarContainerElement || !this.wrapper || event.target !== this.stickyScrollbarContainerElement) return;
            this.wrapper.scrollLeft = this.stickyScrollbarContainerElement.scrollLeft;
        };
        this.wrapper = wrapper;
        this.init();
    }
}


/* eslint-disable @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/enforce-style-prop, @repo/internal/react/no-class-components */ 








































const $24d26e13c81033f3$var$stickyContainerBaseStyles = {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    height: "var(--ds-space-250, 20px)",
    // MAX_BROWSER_SCROLLBAR_HEIGHT
    // Follow editor to hide by default so it does not show empty gap in SSR
    // https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/platform/packages/editor/editor-plugin-table/src/nodeviews/TableComponent.tsx#957
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    display: 'block',
    width: '100%'
};
const $24d26e13c81033f3$var$stickyContainerAdditionalStyles = {
    visibility: 'hidden',
    overflowX: 'auto',
    position: 'sticky',
    bottom: "var(--ds-space-0, 0px)",
    zIndex: 1
};
const $24d26e13c81033f3$export$eec82c0a93aa66d9 = (appearance)=>(0, $32a0d933940b97cc$export$33331a99fac775a1)(appearance) || (0, $32a0d933940b97cc$export$f77d2ff45b2c53ed)(appearance) && (0, $iu6m9.editorExperiment)('support_table_in_comment', true, {
        exposure: true
    });
const $24d26e13c81033f3$export$bdb2dadcb04aad50 = (appearance)=>(0, $32a0d933940b97cc$export$33331a99fac775a1)(appearance) && (0, $iu6m9.editorExperiment)('platform_renderer_table_sticky_scrollbar', true, {
        exposure: true
    });
const $24d26e13c81033f3$export$334894231c46c1a5 = (children, tableNode, smartCardStorage, tableOrderStatus)=>{
    if (!tableOrderStatus || tableOrderStatus.order === (0, $2QYOD.SortOrder).NO_ORDER) return children;
    const { order: order, columnIndex: columnIndex } = tableOrderStatus;
    const compareNodesInOrder = (0, $d4WtM.createCompareNodes)({
        getInlineCardTextFromStore (attrs) {
            const { url: url } = attrs;
            if (!url) return null;
            return smartCardStorage.get(url) || null;
        }
    }, order);
    const tableArray = (0, $caYZ2.convertProsemirrorTableNodeToArrayOfRows)(tableNode);
    const tableArrayWithChildren = tableArray.map((rowNodes, index)=>({
            rowNodes: rowNodes,
            rowReact: children[index]
        }));
    const headerRow = tableArrayWithChildren.shift();
    const sortedTable = tableArrayWithChildren.sort((rowA, rowB)=>compareNodesInOrder(rowA.rowNodes[columnIndex], rowB.rowNodes[columnIndex]));
    if (headerRow) sortedTable.unshift(headerRow);
    return sortedTable.map((elem)=>elem.rowReact);
};
const $24d26e13c81033f3$export$42f5658c8e0092da = (row)=>{
    let hasRowspan = false;
    row.forEach((cell)=>hasRowspan = hasRowspan || cell.attrs.rowspan > 1);
    return hasRowspan;
};
const $24d26e13c81033f3$export$f422245984b0eda7 = (refElement)=>{
    return Math.round(refElement.getBoundingClientRect().top);
};
const $24d26e13c81033f3$export$7c141112f3c89f11 = (scrollTop, tableTop, tableBottom, rowHeight)=>tableTop <= scrollTop && !(tableBottom - rowHeight <= scrollTop);
const $24d26e13c81033f3$export$89f3188e1adc30d5 = (scrollTop, tableBottom, rowHeight)=>tableBottom - rowHeight <= scrollTop && !(tableBottom < scrollTop);
const $24d26e13c81033f3$export$100baa0f10804e6e = (rows, tableOrderStatus, onSorting)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.map(rows, (row, index)=>{
        if (index === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.only(row), {
            tableOrderStatus: tableOrderStatus,
            onSorting: onSorting
        });
        return row;
    });
};
const $24d26e13c81033f3$export$28daf78feed5098c = (rows)=>{
    if (!rows.length) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const { children: children } = rows[0].props;
    if (!children.length) return false;
    if (children.length === 1) return children[0].type === (0, $iKFPk.TableHeader);
    return children.every((node)=>node.type === (0, $iKFPk.TableHeader));
};
const $24d26e13c81033f3$export$940095e914312886 = (node, children)=>{
    return $24d26e13c81033f3$export$28daf78feed5098c(children) && node && node.firstChild && !$24d26e13c81033f3$export$42f5658c8e0092da(node.firstChild);
};
class $24d26e13c81033f3$export$f2c3aea42b2a048f extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    /**
   *
   * @example
   */ componentDidMount() {
        this.resizeObserver = new ResizeObserver(this.applyResizerChange);
        if (this.wrapperRef.current) this.resizeObserver.observe(this.wrapperRef.current);
        if (this.stickyHeaderRef.current) this.resizeObserver.observe(this.stickyHeaderRef.current);
        if (this.props.stickyHeaders) {
            this.overflowParent = (0, $a9ad1d399ee36b19$export$e97bc6692974bd0b).fromElement(this.tableRef.current, this.props.stickyHeaders?.defaultScrollRootId_DO_NOT_USE);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.addEventListener('scroll', this.onScroll);
        }
        if (this.wrapperRef.current && $24d26e13c81033f3$export$bdb2dadcb04aad50(this.props.rendererAppearance)) this.stickyScrollbar = new (0, $f6f7c885cc4b0838$export$8c072780619cfc83)(this.wrapperRef.current);
    }
    /**
   *
   * @param prevProps
   * @param prevState
   * @example
   */ componentDidUpdate(prevProps, prevState) {
        // toggling sticky headers visiblity
        if (this.props.stickyHeaders && !this.overflowParent) this.overflowParent = (0, $a9ad1d399ee36b19$export$e97bc6692974bd0b).fromElement(this.tableRef.current, this.props.stickyHeaders?.defaultScrollRootId_DO_NOT_USE);
        else if (!this.props.stickyHeaders && this.overflowParent) {
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.removeEventListener('scroll', this.onScroll);
            this.overflowParent = null;
        }
        // offsetTop might have changed, re-position sticky header
        if (this.props.stickyHeaders !== prevProps.stickyHeaders) this.updateSticky();
        // sync horizontal scroll in floating div when toggling modes
        if (prevState.stickyMode !== this.state.stickyMode) this.onWrapperScrolled();
    }
    /**
   *
   */ get pinTop() {
        if (!this.tableRef.current || !this.stickyHeaderRef.current) return;
        return this.tableRef.current.offsetHeight - this.stickyHeaderRef.current.offsetHeight + (0, $1zav4.tableMarginTop) - (0, $a9ad1d399ee36b19$export$3de6413b528017ca);
    }
    /**
   *
   */ get shouldAddOverflowParentOffsetTop_DO_NOT_USE() {
        // IF the StickyHeaderConfig specifies that the default scroll root offsetTop should be added
        // AND the StickyHeaderConfig specifies a default scroll root id
        // AND the OverflowParent is the corresponding element
        // THEN we should add the OverflowParent offset top (RETURN TRUE)
        return this.props.stickyHeaders && !!this.props.stickyHeaders.shouldAddDefaultScrollRootOffsetTop_DO_NOT_USE && !!this.props.stickyHeaders.defaultScrollRootId_DO_NOT_USE && this.overflowParent && this.overflowParent.id === this.props.stickyHeaders.defaultScrollRootId_DO_NOT_USE;
    }
    /**
   *
   */ get stickyTop() {
        switch(this.state.stickyMode){
            case 'pin-bottom':
                return this.pinTop;
            case 'stick':
                const offsetTop = this.props.stickyHeaders && this.props.stickyHeaders.offsetTop;
                if (typeof offsetTop === 'number' && this.shouldAddOverflowParentOffsetTop_DO_NOT_USE) {
                    const overflowParentOffsetTop = this.overflowParent ? this.overflowParent.top : 0;
                    return offsetTop + overflowParentOffsetTop;
                } else return offsetTop;
            default:
                return undefined;
        }
    }
    /**
   *
   * @example
   */ render() {
        const { isNumberColumnEnabled: isNumberColumnEnabled, layout: layout, columnWidths: columnWidths, stickyHeaders: stickyHeaders, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isInsideOfTable: isInsideOfTable, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, allowTableAlignment: allowTableAlignment, allowTableResizing: allowTableResizing, isPresentational: isPresentational } = this.props;
        const { stickyMode: stickyMode } = this.state;
        const lineLengthFixedWidth = (0, $aFUXX.akEditorDefaultLayoutWidth);
        let updatedLayout;
        const fullPageRendererWidthCSS = (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
            exposure: true
        }) ? 'calc(100cqw - var(--ak-renderer--full-page-gutter) * 2)' : `100cqw - ${0, $1zvWv.FullPagePadding}px * 2`;
        const renderWidthCSS = rendererAppearance === 'full-page' ? fullPageRendererWidthCSS : `100cqw`;
        const calcDefaultLayoutWidthByAppearance = (rendererAppearance, tableNode)=>{
            if (rendererAppearance === 'full-width' && !tableNode?.attrs.width) return `min(${0, $aFUXX.akEditorFullWidthLayoutWidth}px, ${renderWidthCSS})`;
            else if (rendererAppearance === 'comment' && allowTableResizing && !tableNode?.attrs.width) return renderWidthCSS;
            else {
                // custom width, or width mapped to breakpoint
                const tableContainerWidth = (0, $6fQl1.getTableContainerWidth)(tableNode);
                return `min(${tableContainerWidth}px, ${renderWidthCSS})`;
            }
        };
        const tableWidthCSS = calcDefaultLayoutWidthByAppearance(rendererAppearance, tableNode);
        // Logic for table alignment in renderer
        const isTableAlignStart = tableNode && tableNode.attrs && tableNode.attrs.layout === 'align-start' && allowTableAlignment;
        const fullWidthLineLengthCSS = `min(${(0, $aFUXX.akEditorFullWidthLayoutWidth)}px, ${renderWidthCSS})`;
        const isCommentAppearanceAndTableAlignmentEnabled = (0, $32a0d933940b97cc$export$f77d2ff45b2c53ed)(rendererAppearance) && allowTableAlignment;
        const lineLengthCSS = (0, $32a0d933940b97cc$export$c0112b8340d4924b)(rendererAppearance) ? fullWidthLineLengthCSS : isCommentAppearanceAndTableAlignmentEnabled ? renderWidthCSS : `${lineLengthFixedWidth}px`;
        const tableWidthNew = (0, $6fQl1.getTableContainerWidth)(tableNode);
        const shouldCalculateLeftForAlignment = !isInsideOfBlockNode && !isInsideOfTable && isTableAlignStart && ((0, $32a0d933940b97cc$export$a64737a81cde10b4)(rendererAppearance) && tableWidthNew <= lineLengthFixedWidth || (0, $32a0d933940b97cc$export$c0112b8340d4924b)(rendererAppearance) || isCommentAppearanceAndTableAlignmentEnabled);
        let leftCSS;
        if (shouldCalculateLeftForAlignment) leftCSS = `(${tableWidthCSS} - ${lineLengthCSS}) / 2`;
        if (!shouldCalculateLeftForAlignment && (0, $32a0d933940b97cc$export$a64737a81cde10b4)(rendererAppearance)) // Note tableWidthCSS here is the renderer width
        // When the screen is super wide we want table to break out.
        // However if screen is smaller than 760px. We want table align to left.
        leftCSS = `min(0px, ${lineLengthCSS} - ${tableWidthCSS}) / 2`;
        const children = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.toArray(this.props.children);
        // Historically, tables in the full-width renderer had their layout set to 'default' which is deceiving.
        // This check caters for those tables and helps with SSR logic
        const isFullWidth = !tableNode?.attrs.width && rendererAppearance === 'full-width' && layout !== 'full-width';
        if (isFullWidth) updatedLayout = 'full-width';
        else if (tableNode?.attrs.width) updatedLayout = 'custom';
        else updatedLayout = layout;
        let finalTableContainerWidth = allowTableResizing ? tableWidthNew : 'inherit';
        // We can only use CSS to determine the width when we have a known width in container.
        // When appearance is full-page, full-width or comment we use CSS based width calculation.
        // Otherwise it's fixed table width (customized width) or inherit.
        if (rendererAppearance === 'full-page' || rendererAppearance === 'full-width') finalTableContainerWidth = allowTableResizing ? `calc(${tableWidthCSS})` : 'inherit';
        if (rendererAppearance === 'comment' && allowTableResizing && !allowTableAlignment) // If table alignment is disabled and table width is akEditorDefaultLayoutWidth = 760,
        // it is most likely a table created before "Support Table in Comments" FF was enabled
        // and we would see a bug ED-24795. A table created before "Support Table in Comments",
        // should inhirit the width of the renderer container.
        // !NOTE: it a table resized to 760 is copied from 'full-page' editor and pasted in comment editor
        // where (allowTableResizing && !allowTableAlignment), the table will loose 760px width.
        finalTableContainerWidth = tableNode?.attrs.width && tableNode?.attrs.width !== (0, $aFUXX.akEditorDefaultLayoutWidth) ? `calc(${tableWidthCSS})` : 'inherit';
        if (rendererAppearance === 'comment' && allowTableResizing && allowTableAlignment) // If table alignment is enabled and layout is not 'align-start' or 'center', we are loading a table that was
        // created before "Support Table in Comments" FF was enabled. So the table should have the same width as renderer container
        // instead of 760 that was set on tableNode when the table had been published.
        finalTableContainerWidth = (tableNode?.attrs.layout === 'align-start' || tableNode?.attrs.layout === 'center') && tableNode?.attrs.width ? `calc(${tableWidthCSS})` : 'inherit';
        const style = {
            width: finalTableContainerWidth,
            left: leftCSS ? `calc(${leftCSS})` : undefined,
            marginLeft: shouldCalculateLeftForAlignment && leftCSS !== undefined ? `calc(-1 * (${leftCSS}))` : undefined
        };
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
            children: /*#__PURE__*/ (0, $l998X.jsxs)("div", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: `${(0, $1zav4.TableSharedCssClassName).TABLE_CONTAINER} ${this.props.shadowClassNames || ''}`,
                "data-layout": updatedLayout,
                "data-testid": "table-container",
                ref: this.props.handleRef,
                style: style,
                children: [
                    $24d26e13c81033f3$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $1zav4.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP,
                        "data-testid": "sticky-scrollbar-sentinel-top"
                    }),
                    stickyHeaders && tableNode && $24d26e13c81033f3$export$940095e914312886(tableNode, children) && /*#__PURE__*/ (0, $l998X.jsx)((0, $a9ad1d399ee36b19$export$fd9654fc359d55a3), {
                        isNumberColumnEnabled: isNumberColumnEnabled,
                        tableWidth: "inherit",
                        renderWidth: 0,
                        layout: layout,
                        handleRef: this.props.handleRef,
                        shadowClassNames: this.props.shadowClassNames,
                        top: this.stickyTop,
                        mode: stickyMode,
                        innerRef: this.stickyWrapperRef,
                        wrapperWidth: this.state.wrapperWidth,
                        columnWidths: columnWidths,
                        rowHeight: this.state.headerRowHeight,
                        tableNode: tableNode,
                        rendererAppearance: rendererAppearance,
                        allowTableResizing: allowTableResizing,
                        fixTableSSRResizing: true,
                        children: [
                            children && children[0]
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $1zav4.TableSharedCssClassName).TABLE_NODE_WRAPPER,
                        ref: this.wrapperRef,
                        "data-number-column": tableNode?.attrs.isNumberColumnEnabled,
                        "data-layout": tableNode?.attrs.layout,
                        "data-autosize": tableNode?.attrs.__autoSize,
                        "data-table-local-id": tableNode?.attrs.localId,
                        "data-table-width": tableNode?.attrs.width,
                        "data-vc": "table-node-wrapper",
                        onScroll: this.props.stickyHeaders && this.onWrapperScrolled,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $f71f60011122dddb$export$54ec01a60f47d33d), {
                            innerRef: this.tableRef,
                            columnWidths: columnWidths,
                            layout: layout,
                            renderWidth: 0,
                            isNumberColumnEnabled: isNumberColumnEnabled,
                            tableNode: tableNode,
                            rendererAppearance: rendererAppearance,
                            isInsideOfBlockNode: isInsideOfBlockNode,
                            isInsideOfTable: isInsideOfTable,
                            isinsideMultiBodiedExtension: isinsideMultiBodiedExtension,
                            allowTableResizing: allowTableResizing,
                            isPresentational: isPresentational,
                            children: this.grabFirstRowRef(children)
                        })
                    }),
                    $24d26e13c81033f3$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: `${(0, $1zav4.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER}${(0, $dh538.fg)('confluence_frontend_table_scrollbar_ttvc_fix') ? '-view-page' : ''}`,
                        ref: this.stickyScrollbarRef,
                        "data-vc": "table-sticky-scrollbar-container",
                        style: (0, $dh538.fg)('confluence_frontend_table_scrollbar_ttvc_fix') ? {
                            ...$24d26e13c81033f3$var$stickyContainerBaseStyles,
                            ...$24d26e13c81033f3$var$stickyContainerAdditionalStyles
                        } : $24d26e13c81033f3$var$stickyContainerBaseStyles,
                        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
                            style: {
                                width: (0, $dh538.fg)('confluence_frontend_table_scrollbar_ttvc_fix') ? '100%' : this.tableRef.current?.clientWidth,
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                height: '100%'
                            }
                        })
                    }),
                    $24d26e13c81033f3$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $1zav4.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM,
                        "data-testid": "sticky-scrollbar-sentinel-bottom"
                    })
                ]
            })
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            stickyMode: 'none',
            wrapperWidth: 0,
            headerRowHeight: 0
        };
        this.tableRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef();
        this.stickyHeaderRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef();
        this.stickyScrollbarRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef();
        // used for sync scroll + copying wrapper width to sticky header
        this.stickyWrapperRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef();
        this.wrapperRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef();
        this.stickyScrollbar = void 0;
        this.nextFrame = void 0;
        this.overflowParent = null;
        this.updatedLayout = 'custom';
        this.resizeObserver = null;
        this.applyResizerChange = (entries)=>{
            let wrapperWidth = this.state.wrapperWidth;
            let headerRowHeight = this.state.headerRowHeight;
            for (const entry of entries){
                if (entry.target === this.wrapperRef.current) wrapperWidth = entry.contentRect.width;
                else if (entry.target === this.stickyHeaderRef.current) headerRowHeight = Math.round(entry.contentRect.height);
            }
            if (headerRowHeight !== this.state.headerRowHeight || wrapperWidth !== this.state.wrapperWidth) this.setState({
                wrapperWidth: wrapperWidth,
                headerRowHeight: headerRowHeight
            });
        };
        this.componentWillUnmount = ()=>{
            if (this.overflowParent) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.removeEventListener('scroll', this.onScroll);
            if (this.nextFrame) cancelAnimationFrame(this.nextFrame);
            if (this.resizeObserver) this.resizeObserver.disconnect();
            if (this.stickyScrollbar) this.stickyScrollbar.dispose();
        };
        this.getScrollTop = ()=>{
            const { stickyHeaders: stickyHeaders } = this.props;
            const offsetTop = stickyHeaders && stickyHeaders.offsetTop || 0;
            return (this.overflowParent ? this.overflowParent.top : 0) + offsetTop;
        };
        this.updateSticky = ()=>{
            const tableElem = this.tableRef.current;
            const refElem = this.stickyHeaderRef.current;
            if (!tableElem || !refElem) return;
            const scrollTop = this.getScrollTop() + (0, $a9ad1d399ee36b19$export$3de6413b528017ca);
            const tableTop = $24d26e13c81033f3$export$f422245984b0eda7(tableElem);
            const tableBottom = tableTop + tableElem.clientHeight;
            const shouldSticky = $24d26e13c81033f3$export$7c141112f3c89f11(scrollTop, tableTop, tableBottom, refElem.clientHeight);
            const shouldPin = $24d26e13c81033f3$export$89f3188e1adc30d5(scrollTop, tableBottom, refElem.clientHeight);
            let stickyMode = 'none';
            if (shouldPin) stickyMode = 'pin-bottom';
            else if (shouldSticky) stickyMode = 'stick';
            if (this.state.stickyMode !== stickyMode) this.setState({
                stickyMode: stickyMode
            });
            this.nextFrame = undefined;
        };
        this.onScroll = ()=>{
            if (!this.nextFrame) this.nextFrame = requestAnimationFrame(this.updateSticky);
        };
        this.onWrapperScrolled = ()=>{
            if (!this.wrapperRef.current || !this.stickyWrapperRef.current) return;
            this.stickyWrapperRef.current.scrollLeft = this.wrapperRef.current.scrollLeft;
            if (this.stickyScrollbarRef.current) this.stickyScrollbarRef.current.scrollLeft = this.wrapperRef.current.scrollLeft;
        };
        this.grabFirstRowRef = (children)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.map(children || false, (child, idx)=>{
                if (idx === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement(child, {
                    innerRef: this.stickyHeaderRef
                });
                return child;
            });
        };
    }
}
class $24d26e13c81033f3$export$827f89182557f335 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    /**
   *
   * @example
   */ render() {
        const { children: children } = this.props;
        if (!children) return null;
        const childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.toArray(children);
        const orderedChildren = (0, $cN8vw.compose)(this.addNumberColumnIndexes, this.addSortableColumn)(childrenArray);
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, $l998X.jsx)($24d26e13c81033f3$export$f2c3aea42b2a048f, {
            ...this.props,
            children: orderedChildren
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            tableOrderStatus: undefined
        };
        // adds sortable + re-orders children
        this.addSortableColumn = (childrenArray)=>{
            const { tableNode: tableNode, allowColumnSorting: allowColumnSorting, smartCardStorage: smartCardStorage } = this.props;
            const { tableOrderStatus: tableOrderStatus } = this.state;
            if (allowColumnSorting && $24d26e13c81033f3$export$28daf78feed5098c(childrenArray) && tableNode && !(0, $caYZ2.hasMergedCell)(tableNode)) return $24d26e13c81033f3$export$100baa0f10804e6e($24d26e13c81033f3$export$334894231c46c1a5(childrenArray, tableNode, smartCardStorage, tableOrderStatus), tableOrderStatus, this.changeSortOrder);
            return childrenArray;
        };
        this.changeSortOrder = (columnIndex, sortOrder)=>{
            this.setState({
                tableOrderStatus: {
                    columnIndex: columnIndex,
                    order: sortOrder
                }
            });
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.addNumberColumnIndexes = (rows)=>{
            const { isNumberColumnEnabled: isNumberColumnEnabled } = this.props;
            const headerRowEnabled = $24d26e13c81033f3$export$28daf78feed5098c(rows);
            return (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.map(rows, (row, index)=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.only(row), {
                    isNumberColumnEnabled: isNumberColumnEnabled,
                    index: headerRowEnabled ? index === 0 ? '' : index : index + 1
                });
            });
        };
    }
}


const $8cb6dda2f8b04521$export$eec82c0a93aa66d9 = (appearance)=>(0, $32a0d933940b97cc$export$33331a99fac775a1)(appearance) || (0, $32a0d933940b97cc$export$f77d2ff45b2c53ed)(appearance) && (0, $iu6m9.editorExperiment)('support_table_in_comment', true, {
        exposure: true
    });
const $8cb6dda2f8b04521$export$bdb2dadcb04aad50 = (appearance)=>(0, $32a0d933940b97cc$export$33331a99fac775a1)(appearance) && (0, $iu6m9.editorExperiment)('platform_renderer_table_sticky_scrollbar', true, {
        exposure: true
    });
const $8cb6dda2f8b04521$export$334894231c46c1a5 = (children, tableNode, smartCardStorage, tableOrderStatus)=>{
    if (!tableOrderStatus || tableOrderStatus.order === (0, $2QYOD.SortOrder).NO_ORDER) return children;
    const { order: order, columnIndex: columnIndex } = tableOrderStatus;
    const compareNodesInOrder = (0, $d4WtM.createCompareNodes)({
        getInlineCardTextFromStore (attrs) {
            const { url: url } = attrs;
            if (!url) return null;
            return smartCardStorage.get(url) || null;
        }
    }, order);
    const tableArray = (0, $caYZ2.convertProsemirrorTableNodeToArrayOfRows)(tableNode);
    const tableArrayWithChildren = tableArray.map((rowNodes, index)=>({
            rowNodes: rowNodes,
            rowReact: children[index]
        }));
    const headerRow = tableArrayWithChildren.shift();
    const sortedTable = tableArrayWithChildren.sort((rowA, rowB)=>compareNodesInOrder(rowA.rowNodes[columnIndex], rowB.rowNodes[columnIndex]));
    if (headerRow) sortedTable.unshift(headerRow);
    return sortedTable.map((elem)=>elem.rowReact);
};
const $8cb6dda2f8b04521$export$42f5658c8e0092da = (row)=>{
    let hasRowspan = false;
    row.forEach((cell)=>hasRowspan = hasRowspan || cell.attrs.rowspan > 1);
    return hasRowspan;
};
const $8cb6dda2f8b04521$export$f422245984b0eda7 = (refElement)=>{
    return Math.round(refElement.getBoundingClientRect().top);
};
const $8cb6dda2f8b04521$export$7c141112f3c89f11 = (scrollTop, tableTop, tableBottom, rowHeight)=>tableTop <= scrollTop && !(tableBottom - rowHeight <= scrollTop);
const $8cb6dda2f8b04521$export$89f3188e1adc30d5 = (scrollTop, tableBottom, rowHeight)=>tableBottom - rowHeight <= scrollTop && !(tableBottom < scrollTop);
const $8cb6dda2f8b04521$export$100baa0f10804e6e = (rows, tableOrderStatus, onSorting)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.map(rows, (row, index)=>{
        if (index === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.only(row), {
            tableOrderStatus: tableOrderStatus,
            onSorting: onSorting
        });
        return row;
    });
};
const $8cb6dda2f8b04521$export$28daf78feed5098c = (rows)=>{
    if (!rows.length) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const { children: children } = rows[0].props;
    if (!children.length) return false;
    if (children.length === 1) return children[0].type === (0, $iKFPk.TableHeader);
    return children.every((node)=>node.type === (0, $iKFPk.TableHeader));
};
/**
 * This TableWrapper component was created to make sure that the aria-label can be
 * internationalized without needing to add `intl` to the TableContainer.
 *
 * @param {TableWrapperProps} root0 - The props object.
 * @param {React.ReactNode} root0.children - The table content to render inside the wrapper.
 * @param {React.RefObject<HTMLDivElement>} root0.wrapperRef - Ref to the wrapper div element.
 * @param {(() => void) | undefined} root0.onScroll - Optional scroll event handler.
 * @param {StickyHeaderConfig | undefined} root0.stickyHeaders - Optional sticky header configuration.
 * @returns The rendered table wrapper component.
 * @example
 * <TableWrapper wrapperRef={ref} onScroll={handleScroll} stickyHeaders={config}>
 *   <Table>...</Table>
 * </TableWrapper>
 */ const $8cb6dda2f8b04521$var$TableWrapper = ({ children: children, wrapperRef: wrapperRef, onScroll: onScroll, stickyHeaders: stickyHeaders })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $1zav4.TableSharedCssClassName).TABLE_NODE_WRAPPER,
        ref: wrapperRef,
        onScroll: stickyHeaders ? onScroll : undefined,
        // Adding tabIndex here because this is a scrollable container and it needs to be focusable so keyboard users can scroll it.
        // eslint-disable-next-line @atlassian/a11y/no-noninteractive-tabindex
        tabIndex: 0,
        role: "region",
        "aria-label": formatMessage((0, $2CQVV.messages).tableScrollRegion),
        children: children
    });
};
const $8cb6dda2f8b04521$export$940095e914312886 = (node, children)=>{
    return $8cb6dda2f8b04521$export$28daf78feed5098c(children) && node && node.firstChild && !$8cb6dda2f8b04521$export$42f5658c8e0092da(node.firstChild);
};
class $8cb6dda2f8b04521$export$f2c3aea42b2a048f extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    /**
   *
   * @example
   */ componentDidMount() {
        this.resizeObserver = new ResizeObserver(this.applyResizerChange);
        if (this.wrapperRef.current) this.resizeObserver.observe(this.wrapperRef.current);
        if (this.stickyHeaderRef.current) this.resizeObserver.observe(this.stickyHeaderRef.current);
        if (this.props.stickyHeaders) {
            this.overflowParent = (0, $a9ad1d399ee36b19$export$e97bc6692974bd0b).fromElement(this.tableRef.current, this.props.stickyHeaders?.defaultScrollRootId_DO_NOT_USE);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.addEventListener('scroll', this.onScroll);
        }
        if (this.wrapperRef.current && $8cb6dda2f8b04521$export$bdb2dadcb04aad50(this.props.rendererAppearance)) this.stickyScrollbar = new (0, $f6f7c885cc4b0838$export$8c072780619cfc83)(this.wrapperRef.current);
    }
    /**
   *
   * @param prevProps
   * @param prevState
   * @example
   */ componentDidUpdate(prevProps, prevState) {
        // toggling sticky headers visiblity
        if (this.props.stickyHeaders && !this.overflowParent) this.overflowParent = (0, $a9ad1d399ee36b19$export$e97bc6692974bd0b).fromElement(this.tableRef.current, this.props.stickyHeaders?.defaultScrollRootId_DO_NOT_USE);
        else if (!this.props.stickyHeaders && this.overflowParent) {
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.removeEventListener('scroll', this.onScroll);
            this.overflowParent = null;
        }
        // offsetTop might have changed, re-position sticky header
        if (this.props.stickyHeaders !== prevProps.stickyHeaders) this.updateSticky();
        // sync horizontal scroll in floating div when toggling modes
        if (prevState.stickyMode !== this.state.stickyMode) this.onWrapperScrolled();
    }
    /**
   *
   */ get pinTop() {
        if (!this.tableRef.current || !this.stickyHeaderRef.current) return;
        return this.tableRef.current.offsetHeight - this.stickyHeaderRef.current.offsetHeight + (0, $1zav4.tableMarginTop) - (0, $a9ad1d399ee36b19$export$3de6413b528017ca);
    }
    /**
   *
   */ get shouldAddOverflowParentOffsetTop_DO_NOT_USE() {
        // IF the StickyHeaderConfig specifies that the default scroll root offsetTop should be added
        // AND the StickyHeaderConfig specifies a default scroll root id
        // AND the OverflowParent is the corresponding element
        // THEN we should add the OverflowParent offset top (RETURN TRUE)
        return this.props.stickyHeaders && !!this.props.stickyHeaders.shouldAddDefaultScrollRootOffsetTop_DO_NOT_USE && !!this.props.stickyHeaders.defaultScrollRootId_DO_NOT_USE && this.overflowParent && this.overflowParent.id === this.props.stickyHeaders.defaultScrollRootId_DO_NOT_USE;
    }
    /**
   *
   */ get stickyTop() {
        switch(this.state.stickyMode){
            case 'pin-bottom':
                return this.pinTop;
            case 'stick':
                const offsetTop = this.props.stickyHeaders && this.props.stickyHeaders.offsetTop;
                if (typeof offsetTop === 'number' && this.shouldAddOverflowParentOffsetTop_DO_NOT_USE) {
                    const overflowParentOffsetTop = this.overflowParent ? this.overflowParent.top : 0;
                    return offsetTop + overflowParentOffsetTop;
                } else return offsetTop;
            default:
                return undefined;
        }
    }
    /**
   *
   * @example
   */ render() {
        const { isNumberColumnEnabled: isNumberColumnEnabled, layout: layout, renderWidth: renderWidth, columnWidths: columnWidths, stickyHeaders: stickyHeaders, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isInsideOfTable: isInsideOfTable, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, allowTableAlignment: allowTableAlignment, allowTableResizing: allowTableResizing, isPresentational: isPresentational } = this.props;
        const { stickyMode: stickyMode } = this.state;
        const lineLengthFixedWidth = (0, $aFUXX.akEditorDefaultLayoutWidth);
        let left;
        let updatedLayout;
        // The tableWidth and left offset logic below must stay aligned with the `breakout-ssr.tsx` logic
        // Please consider changes below carefully to not negatively impact SSR
        // `renderWidth` cannot be depended on during SSR
        const isRenderWidthValid = !!renderWidth && renderWidth > 0;
        const fullPageRendererWidthCSS = (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
            exposure: true
        }) ? 'calc(100cqw - var(--ak-renderer--full-page-gutter) * 2)' : `100cqw - ${0, $1zvWv.FullPagePadding}px * 2`;
        const renderWidthCSS = rendererAppearance === 'full-page' ? fullPageRendererWidthCSS : `100cqw`;
        const calcDefaultLayoutWidthByAppearance = (rendererAppearance, tableNode)=>{
            if (rendererAppearance === 'full-width' && !tableNode?.attrs.width) return [
                isRenderWidthValid ? Math.min((0, $aFUXX.akEditorFullWidthLayoutWidth), renderWidth) : (0, $aFUXX.akEditorFullWidthLayoutWidth),
                `min(${(0, $aFUXX.akEditorFullWidthLayoutWidth)}px, ${renderWidthCSS})`
            ];
            else if (rendererAppearance === 'comment' && allowTableResizing && !tableNode?.attrs.width) {
                const tableContainerWidth = (0, $6fQl1.getTableContainerWidth)(tableNode);
                return [
                    isRenderWidthValid ? renderWidth : tableContainerWidth,
                    renderWidthCSS
                ];
            } else {
                // custom width, or width mapped to breakpoint
                const tableContainerWidth = (0, $6fQl1.getTableContainerWidth)(tableNode);
                return [
                    isRenderWidthValid ? Math.min(tableContainerWidth, renderWidth) : tableContainerWidth,
                    `min(${tableContainerWidth}px, ${renderWidthCSS})`
                ];
            }
        };
        const [tableWidth, tableWidthCSS] = calcDefaultLayoutWidthByAppearance(rendererAppearance, tableNode);
        // Logic for table alignment in renderer
        const isTableAlignStart = tableNode && tableNode.attrs && tableNode.attrs.layout === 'align-start' && allowTableAlignment;
        const fullWidthLineLength = isRenderWidthValid ? Math.min((0, $aFUXX.akEditorFullWidthLayoutWidth), renderWidth) : (0, $aFUXX.akEditorFullWidthLayoutWidth);
        const fullWidthLineLengthCSS = `min(${(0, $aFUXX.akEditorFullWidthLayoutWidth)}px, ${renderWidthCSS})`;
        const commentLineLength = isRenderWidthValid ? renderWidth : lineLengthFixedWidth;
        const isCommentAppearanceAndTableAlignmentEnabled = (0, $32a0d933940b97cc$export$f77d2ff45b2c53ed)(rendererAppearance) && allowTableAlignment;
        const lineLength = (0, $32a0d933940b97cc$export$c0112b8340d4924b)(rendererAppearance) ? fullWidthLineLength : isCommentAppearanceAndTableAlignmentEnabled ? commentLineLength : lineLengthFixedWidth;
        const lineLengthCSS = (0, $32a0d933940b97cc$export$c0112b8340d4924b)(rendererAppearance) ? fullWidthLineLengthCSS : isCommentAppearanceAndTableAlignmentEnabled ? renderWidthCSS : `${lineLengthFixedWidth}px`;
        // Setting fixTableSSRResizing to false while FG logic is true in tableNew
        const fixTableSSRResizing = false;
        const tableWidthNew = fixTableSSRResizing ? (0, $6fQl1.getTableContainerWidth)(tableNode) : tableWidth;
        const shouldCalculateLeftForAlignment = !isInsideOfBlockNode && !isInsideOfTable && isTableAlignStart && ((0, $32a0d933940b97cc$export$a64737a81cde10b4)(rendererAppearance) && tableWidthNew <= lineLengthFixedWidth || (0, $32a0d933940b97cc$export$c0112b8340d4924b)(rendererAppearance) || isCommentAppearanceAndTableAlignmentEnabled);
        let leftCSS;
        if (shouldCalculateLeftForAlignment) {
            left = (tableWidth - lineLength) / 2;
            leftCSS = `(${tableWidthCSS} - ${lineLengthCSS}) / 2`;
        }
        if (fixTableSSRResizing) {
            if (!shouldCalculateLeftForAlignment && (0, $32a0d933940b97cc$export$a64737a81cde10b4)(rendererAppearance)) // Note tableWidthCSS here is the renderer width
            // When the screen is super wide we want table to break out.
            // However if screen is smaller than 760px. We want table align to left.
            leftCSS = `min(0px, ${lineLengthCSS} - ${tableWidthCSS}) / 2`;
        } else if (!shouldCalculateLeftForAlignment && (0, $32a0d933940b97cc$export$a64737a81cde10b4)(rendererAppearance) && tableWidthNew > lineLengthFixedWidth) left = lineLengthFixedWidth / 2 - tableWidth / 2;
        const children = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.toArray(this.props.children);
        // Historically, tables in the full-width renderer had their layout set to 'default' which is deceiving.
        // This check caters for those tables and helps with SSR logic
        const isFullWidth = !tableNode?.attrs.width && rendererAppearance === 'full-width' && layout !== 'full-width';
        if (isFullWidth) updatedLayout = 'full-width';
        else if (tableNode?.attrs.width) updatedLayout = 'custom';
        else updatedLayout = layout;
        let finalTableContainerWidth = allowTableResizing ? tableWidthNew : 'inherit';
        // We can only use CSS to determine the width when we have a known width in container.
        // When appearance is full-page, full-width or comment we use CSS based width calculation.
        // Otherwise it's fixed table width (customized width) or inherit.
        if ((rendererAppearance === 'full-page' || rendererAppearance === 'full-width') && fixTableSSRResizing) finalTableContainerWidth = allowTableResizing ? `calc(${tableWidthCSS})` : 'inherit';
        if (rendererAppearance === 'comment' && allowTableResizing && !allowTableAlignment) // If table alignment is disabled and table width is akEditorDefaultLayoutWidth = 760,
        // it is most likely a table created before "Support Table in Comments" FF was enabled
        // and we would see a bug ED-24795. A table created before "Support Table in Comments",
        // should inhirit the width of the renderer container.
        // !NOTE: it a table resized to 760 is copied from 'full-page' editor and pasted in comment editor
        // where (allowTableResizing && !allowTableAlignment), the table will loose 760px width.
        finalTableContainerWidth = tableNode?.attrs.width && tableNode?.attrs.width !== (0, $aFUXX.akEditorDefaultLayoutWidth) ? fixTableSSRResizing ? `calc(${tableWidthCSS})` : tableWidth : 'inherit';
        if (rendererAppearance === 'comment' && allowTableResizing && allowTableAlignment) // If table alignment is enabled and layout is not 'align-start' or 'center', we are loading a table that was
        // created before "Support Table in Comments" FF was enabled. So the table should have the same width as renderer container
        // instead of 760 that was set on tableNode when the table had been published.
        finalTableContainerWidth = (tableNode?.attrs.layout === 'align-start' || tableNode?.attrs.layout === 'center') && tableNode?.attrs.width ? fixTableSSRResizing ? `calc(${tableWidthCSS})` : tableWidth : 'inherit';
        let style;
        if (fixTableSSRResizing) style = {
            width: finalTableContainerWidth,
            left: leftCSS ? `calc(${leftCSS})` : undefined,
            marginLeft: shouldCalculateLeftForAlignment && leftCSS !== undefined ? `calc(-1 * (${leftCSS}))` : undefined
        };
        else style = {
            width: finalTableContainerWidth,
            left: left,
            marginLeft: shouldCalculateLeftForAlignment && left !== undefined ? -left : undefined
        };
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
            children: /*#__PURE__*/ (0, $l998X.jsxs)("div", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: `${(0, $1zav4.TableSharedCssClassName).TABLE_CONTAINER} ${this.props.shadowClassNames || ''}`,
                "data-layout": updatedLayout,
                ref: this.props.handleRef,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: style,
                children: [
                    $8cb6dda2f8b04521$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $1zav4.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP,
                        "data-testid": "sticky-scrollbar-sentinel-top"
                    }),
                    stickyHeaders && $8cb6dda2f8b04521$export$940095e914312886(tableNode, children) && /*#__PURE__*/ (0, $l998X.jsx)((0, $a9ad1d399ee36b19$export$fd9654fc359d55a3), {
                        isNumberColumnEnabled: isNumberColumnEnabled,
                        tableWidth: tableWidth,
                        layout: layout,
                        renderWidth: renderWidth,
                        handleRef: this.props.handleRef,
                        shadowClassNames: this.props.shadowClassNames,
                        top: this.stickyTop,
                        mode: stickyMode,
                        innerRef: this.stickyWrapperRef,
                        wrapperWidth: this.state.wrapperWidth,
                        columnWidths: columnWidths,
                        rowHeight: this.state.headerRowHeight,
                        tableNode: tableNode,
                        rendererAppearance: rendererAppearance,
                        allowTableResizing: allowTableResizing,
                        children: [
                            children && children[0]
                        ]
                    }),
                    (0, $dh538.fg)('editor_enghealth_focusable_scrollable_tables') ? /*#__PURE__*/ (0, $l998X.jsx)($8cb6dda2f8b04521$var$TableWrapper, {
                        wrapperRef: this.wrapperRef,
                        onScroll: this.props.stickyHeaders ? this.onWrapperScrolled : undefined,
                        stickyHeaders: stickyHeaders,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $f71f60011122dddb$export$54ec01a60f47d33d), {
                            innerRef: this.tableRef,
                            columnWidths: columnWidths,
                            layout: layout,
                            isNumberColumnEnabled: isNumberColumnEnabled,
                            renderWidth: renderWidth,
                            tableNode: tableNode,
                            rendererAppearance: rendererAppearance,
                            isInsideOfBlockNode: isInsideOfBlockNode,
                            isInsideOfTable: isInsideOfTable,
                            isinsideMultiBodiedExtension: isinsideMultiBodiedExtension,
                            allowTableResizing: allowTableResizing,
                            isPresentational: isPresentational,
                            children: this.grabFirstRowRef(children)
                        })
                    }) : /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $1zav4.TableSharedCssClassName).TABLE_NODE_WRAPPER,
                        ref: this.wrapperRef,
                        onScroll: this.props.stickyHeaders && this.onWrapperScrolled,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $f71f60011122dddb$export$54ec01a60f47d33d), {
                            innerRef: this.tableRef,
                            columnWidths: columnWidths,
                            layout: layout,
                            isNumberColumnEnabled: isNumberColumnEnabled,
                            renderWidth: renderWidth,
                            tableNode: tableNode,
                            rendererAppearance: rendererAppearance,
                            isInsideOfBlockNode: isInsideOfBlockNode,
                            isInsideOfTable: isInsideOfTable,
                            isinsideMultiBodiedExtension: isinsideMultiBodiedExtension,
                            allowTableResizing: allowTableResizing,
                            isPresentational: isPresentational,
                            children: this.grabFirstRowRef(children)
                        })
                    }),
                    $8cb6dda2f8b04521$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $1zav4.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER,
                        ref: this.stickyScrollbarRef,
                        style: {
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                            height: "var(--ds-space-250, 20px)",
                            // MAX_BROWSER_SCROLLBAR_HEIGHT
                            // Follow editor to hide by default so it does not show empty gap in SSR
                            // https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/platform/packages/editor/editor-plugin-table/src/nodeviews/TableComponent.tsx#957
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                            display: fixTableSSRResizing ? 'none' : 'block',
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                            width: '100%'
                        },
                        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
                            style: {
                                width: this.tableRef.current?.clientWidth,
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                height: '100%'
                            }
                        })
                    }),
                    $8cb6dda2f8b04521$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $1zav4.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM,
                        "data-testid": "sticky-scrollbar-sentinel-bottom"
                    })
                ]
            })
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            stickyMode: 'none',
            wrapperWidth: 0,
            headerRowHeight: 0
        };
        this.tableRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef();
        this.stickyHeaderRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef();
        this.stickyScrollbarRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef();
        // used for sync scroll + copying wrapper width to sticky header
        this.stickyWrapperRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef();
        this.wrapperRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef();
        this.stickyScrollbar = void 0;
        this.nextFrame = void 0;
        this.overflowParent = null;
        this.resizeObserver = null;
        this.applyResizerChange = (entries)=>{
            let wrapperWidth = this.state.wrapperWidth;
            let headerRowHeight = this.state.headerRowHeight;
            for (const entry of entries){
                if (entry.target === this.wrapperRef.current) wrapperWidth = entry.contentRect.width;
                else if (entry.target === this.stickyHeaderRef.current) headerRowHeight = Math.round(entry.contentRect.height);
            }
            if (headerRowHeight !== this.state.headerRowHeight || wrapperWidth !== this.state.wrapperWidth) this.setState({
                wrapperWidth: wrapperWidth,
                headerRowHeight: headerRowHeight
            });
        };
        this.componentWillUnmount = ()=>{
            if (this.overflowParent) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.removeEventListener('scroll', this.onScroll);
            if (this.nextFrame) cancelAnimationFrame(this.nextFrame);
            if (this.resizeObserver) this.resizeObserver.disconnect();
            if (this.stickyScrollbar) this.stickyScrollbar.dispose();
        };
        this.getScrollTop = ()=>{
            const { stickyHeaders: stickyHeaders } = this.props;
            const offsetTop = stickyHeaders && stickyHeaders.offsetTop || 0;
            return (this.overflowParent ? this.overflowParent.top : 0) + offsetTop;
        };
        this.updateSticky = ()=>{
            const tableElem = this.tableRef.current;
            const refElem = this.stickyHeaderRef.current;
            if (!tableElem || !refElem) return;
            const scrollTop = this.getScrollTop() + (0, $a9ad1d399ee36b19$export$3de6413b528017ca);
            const tableTop = $8cb6dda2f8b04521$export$f422245984b0eda7(tableElem);
            const tableBottom = tableTop + tableElem.clientHeight;
            const shouldSticky = $8cb6dda2f8b04521$export$7c141112f3c89f11(scrollTop, tableTop, tableBottom, refElem.clientHeight);
            const shouldPin = $8cb6dda2f8b04521$export$89f3188e1adc30d5(scrollTop, tableBottom, refElem.clientHeight);
            let stickyMode = 'none';
            if (shouldPin) stickyMode = 'pin-bottom';
            else if (shouldSticky) stickyMode = 'stick';
            if (this.state.stickyMode !== stickyMode) this.setState({
                stickyMode: stickyMode
            });
            this.nextFrame = undefined;
        };
        this.onScroll = ()=>{
            if (!this.nextFrame) this.nextFrame = requestAnimationFrame(this.updateSticky);
        };
        this.onWrapperScrolled = ()=>{
            if (!this.wrapperRef.current || !this.stickyWrapperRef.current) return;
            this.stickyWrapperRef.current.scrollLeft = this.wrapperRef.current.scrollLeft;
            if (this.stickyScrollbarRef.current) this.stickyScrollbarRef.current.scrollLeft = this.wrapperRef.current.scrollLeft;
        };
        this.grabFirstRowRef = (children)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.map(children || false, (child, idx)=>{
                if (idx === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement(child, {
                    innerRef: this.stickyHeaderRef
                });
                return child;
            });
        };
    }
}
class $8cb6dda2f8b04521$export$91e0997fd3f75d56 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    /**
   *
   * @example
   */ render() {
        const { children: children } = this.props;
        if (!children) return null;
        const childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.toArray(children);
        const orderedChildren = (0, $cN8vw.compose)(this.addNumberColumnIndexes, this.addSortableColumn)(childrenArray);
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, $l998X.jsx)($8cb6dda2f8b04521$export$f2c3aea42b2a048f, {
            ...this.props,
            children: orderedChildren
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            tableOrderStatus: undefined
        };
        // adds sortable + re-orders children
        this.addSortableColumn = (childrenArray)=>{
            const { tableNode: tableNode, allowColumnSorting: allowColumnSorting, smartCardStorage: smartCardStorage } = this.props;
            const { tableOrderStatus: tableOrderStatus } = this.state;
            if (allowColumnSorting && $8cb6dda2f8b04521$export$28daf78feed5098c(childrenArray) && tableNode && !(0, $caYZ2.hasMergedCell)(tableNode)) return $8cb6dda2f8b04521$export$100baa0f10804e6e($8cb6dda2f8b04521$export$334894231c46c1a5(childrenArray, tableNode, smartCardStorage, tableOrderStatus), tableOrderStatus, this.changeSortOrder);
            return childrenArray;
        };
        this.changeSortOrder = (columnIndex, sortOrder)=>{
            this.setState({
                tableOrderStatus: {
                    columnIndex: columnIndex,
                    order: sortOrder
                }
            });
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.addNumberColumnIndexes = (rows)=>{
            const { isNumberColumnEnabled: isNumberColumnEnabled } = this.props;
            const headerRowEnabled = $8cb6dda2f8b04521$export$28daf78feed5098c(rows);
            return (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.map(rows, (row, index)=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.only(row), {
                    isNumberColumnEnabled: isNumberColumnEnabled,
                    index: headerRowEnabled ? index === 0 ? '' : index : index + 1
                });
            });
        };
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8cb6dda2f8b04521$var$TableWithShadowsAndContainerStyles = (0, $frt7o.default)((0, $24d26e13c81033f3$export$827f89182557f335), {
    /**
   * The :scope is in reference to table container and we are selecting only
   * direct children that match the table node wrapper selector, not their
   * descendants.
   */ overflowSelector: `:scope > .${(0, $1zav4.TableSharedCssClassName).TABLE_NODE_WRAPPER}`,
    useShadowObserver: true
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8cb6dda2f8b04521$var$TableWithShadows = (0, $frt7o.default)($8cb6dda2f8b04521$export$91e0997fd3f75d56, {
    /**
   * The :scope is in reference to table container and we are selecting only
   * direct children that match the table node wrapper selector, not their
   * descendants.
   */ overflowSelector: `:scope > .${(0, $1zav4.TableSharedCssClassName).TABLE_NODE_WRAPPER}`,
    useShadowObserver: true
});
const $8cb6dda2f8b04521$var$TableWithWidth = (props)=>{
    if ((0, $dh538.fg)('platform-ssr-table-resize')) {
        const colWidthsSum = props.columnWidths?.reduce((total, val)=>total + val, 0) || 0;
        if (colWidthsSum || props.allowTableResizing) // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, $l998X.jsx)($8cb6dda2f8b04521$var$TableWithShadowsAndContainerStyles, {
            ...props
        });
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $24d26e13c81033f3$export$827f89182557f335), {
            ...props
        });
    } else return /*#__PURE__*/ (0, $l998X.jsx)((0, $bWRlG.WidthConsumer), {
        children: ({ width: width })=>{
            const renderWidth = props.rendererAppearance === 'full-page' ? width - (0, $1zvWv.FullPagePadding) * 2 : width;
            const colWidthsSum = props.columnWidths?.reduce((total, val)=>total + val, 0) || 0;
            if (colWidthsSum || props.allowTableResizing) // Ignored via go/ees005
            // eslint-disable-next-line react/jsx-props-no-spreading
            return /*#__PURE__*/ (0, $l998X.jsx)($8cb6dda2f8b04521$var$TableWithShadows, {
                renderWidth: renderWidth,
                ...props
            });
            // there should not be a case when colWidthsSum is 0 and table is in overflow state - so no need to render shadows in this case
            return /*#__PURE__*/ (0, $l998X.jsx)($8cb6dda2f8b04521$export$91e0997fd3f75d56, {
                renderWidth: renderWidth,
                ...props
            });
        }
    });
};
var $8cb6dda2f8b04521$export$2e2bcd8739ae039 = (0, $bZfVt.withSmartCardStorage)($8cb6dda2f8b04521$var$TableWithWidth);
module.exports["isTableResizingEnabled"] = $8cb6dda2f8b04521$export$eec82c0a93aa66d9;
module.exports["isStickyScrollbarEnabled"] = $8cb6dda2f8b04521$export$bdb2dadcb04aad50;

});

parcelRegister("2Ed9T", function(module, exports) {

var $52wl7 = parcelRequire("52wl7");


var $iOvMY = parcelRequire("iOvMY");


var $bT49y = parcelRequire("bT49y");

/** Used to compose unicode capture groups. */ var $1ed9863c2ebfed04$var$rsApos = "['\u2019]";
/** Used to match apostrophes. */ var $1ed9863c2ebfed04$var$reApos = RegExp($1ed9863c2ebfed04$var$rsApos, 'g');
/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */ function $1ed9863c2ebfed04$var$createCompounder(callback) {
    return function(string) {
        return $52wl7($bT49y($iOvMY(string).replace($1ed9863c2ebfed04$var$reApos, '')), callback, '');
    };
}
module.exports = $1ed9863c2ebfed04$var$createCompounder;

});

parcelRegister("iNqGB", function(module, exports) {
function $44e243c4cf2c5688$export$7aa7587d1ce9583c(allowHeadingAnchorLinks) {
    // If it's a boolean or undefined, then we don't support nesting.
    if (!allowHeadingAnchorLinks || typeof allowHeadingAnchorLinks === 'boolean') return false;
    const { allowNestedHeaderLinks: allowNestedHeaderLinks } = allowHeadingAnchorLinks;
    // Explicit cast to a boolean to cover scenario where it's undefined.
    return !!allowNestedHeaderLinks;
}
function $44e243c4cf2c5688$export$acb253d79d72af92(allowHeadingAnchorLinks) {
    if (!$44e243c4cf2c5688$export$7aa7587d1ce9583c(allowHeadingAnchorLinks)) return undefined;
    return allowHeadingAnchorLinks.activeHeadingId;
}
module.exports["isNestedHeaderLinksEnabled"] = $44e243c4cf2c5688$export$7aa7587d1ce9583c;
module.exports["getActiveHeadingId"] = $44e243c4cf2c5688$export$acb253d79d72af92;

});

parcelRegister("GH4gU", function(module, exports) {
$parcel$export(module.exports, "default", () => $37d44366a8af079c$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gmMgo = parcelRequire("gmMgo");


var $lwZHY = parcelRequire("lwZHY");


var $7Rcde = parcelRequire("7Rcde");

const $37d44366a8af079c$export$86390c02c110ec2f = (mark)=>{
    return mark && mark.type && mark.type.name === 'code';
};
function $37d44366a8af079c$export$7cea6ffa7022e85f(props) {
    const codeBidiWarningLabel = props.intl.formatMessage((0, $7Rcde.codeBidiWarningMessages).label);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lwZHY.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "code",
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: props.codeBidiWarningTooltipEnabled,
        ...props.dataAttributes,
        children: props.children
    });
}
var $37d44366a8af079c$export$2e2bcd8739ae039 = (0, $gmMgo.default)($37d44366a8af079c$export$7cea6ffa7022e85f);
module.exports["isCodeMark"] = $37d44366a8af079c$export$86390c02c110ec2f;

});

parcelRegister("hMQQ9", function(module, exports) {
$parcel$export(module.exports, "default", () => $eaea92635c0e0d50$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

function $eaea92635c0e0d50$export$2e2bcd8739ae039(props) {
    // ignore the eslint warning Text primitive does not support dataAttributes
    // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading, @atlaskit/design-system/use-primitives-text
    return /*#__PURE__*/ (0, $l998X.jsx)("em", {
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("g5cj9", function(module, exports) {
$parcel$export(module.exports, "default", () => $0a08d476a56fd0b1$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $6fnsQ = parcelRequire("6fnsQ");


var $b7FrM = parcelRequire("b7FrM");


var $59U23 = parcelRequire("59U23");


var $d925B = parcelRequire("d925B");


var $hn4RR = parcelRequire("hn4RR");


var $bYRk6 = parcelRequire("bYRk6");

const $0a08d476a56fd0b1$var$anchorStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    color: `var(--ds-link, ${(0, $6fnsQ.B400)})`,
    '&:hover': {
        color: `var(--ds-link, ${(0, $6fnsQ.B300)})`,
        textDecoration: 'underline'
    },
    '&:active': {
        color: `var(--ds-link-pressed, ${(0, $6fnsQ.B500)})`
    }
});
function $0a08d476a56fd0b1$export$2e2bcd8739ae039(props) {
    const { href: href, target: target, eventHandlers: eventHandlers, fireAnalyticsEvent: fireAnalyticsEvent, isMediaLink: isMediaLink, dataAttributes: dataAttributes } = props;
    const anchorProps = {
        href: href,
        target: target,
        title: href
    };
    if (target === '_blank') anchorProps.rel = 'noreferrer noopener';
    const handler = (0, $b7FrM.getEventHandler)(eventHandlers, 'link');
    if (isMediaLink) return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, props.children);
    const analyticsData = {
        attributes: {
            location: 'renderer'
        },
        // Below is added for the future implementation of Linking Platform namespaced analytic context
        location: 'renderer'
    };
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $bYRk6.default), {
        data: analyticsData
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $hn4RR.default), {
        css: $0a08d476a56fd0b1$var$anchorStyles,
        onClick: (e)=>{
            if (fireAnalyticsEvent) fireAnalyticsEvent({
                action: (0, $d925B.ACTION).VISITED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).LINK,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                attributes: {
                    platform: (0, $59U23.PLATFORM).WEB,
                    mode: (0, $59U23.MODE).RENDERER
                }
            });
            if (handler) handler(e, href);
        },
        ...anchorProps,
        ...dataAttributes,
        isLinkComponent: true,
        enableResolve: true
    }, props.children));
}

});

parcelRegister("jyYl7", function(module, exports) {
$parcel$export(module.exports, "default", () => $91cd5902b10cc40d$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

function $91cd5902b10cc40d$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        ...props.dataAttributes,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            textDecoration: 'line-through'
        },
        children: props.children
    });
}

});

parcelRegister("cHFH7", function(module, exports) {
$parcel$export(module.exports, "default", () => $dfc5c059d1a31794$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

function $dfc5c059d1a31794$export$2e2bcd8739ae039(props) {
    // ignore the eslint warning Text primitive does not support dataAttributes
    // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading, @atlaskit/design-system/use-primitives-text
    return /*#__PURE__*/ (0, $l998X.jsx)("strong", {
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("2KFEz", function(module, exports) {
$parcel$export(module.exports, "default", () => $5be0c346e0e6a7c7$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

const $5be0c346e0e6a7c7$var$isSub = (type)=>{
    return type === 'sub';
};
function $5be0c346e0e6a7c7$export$2e2bcd8739ae039(props) {
    if ($5be0c346e0e6a7c7$var$isSub(props.type)) // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $l998X.jsx)("sub", {
        ...props.dataAttributes,
        children: props.children
    });
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $l998X.jsx)("sup", {
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("6wVZ8", function(module, exports) {
$parcel$export(module.exports, "default", () => $e65feb0aaa1b4075$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $bAH9E = parcelRequire("bAH9E");


var $iS6Uy = parcelRequire("iS6Uy");


var $cOrQJ = parcelRequire("cOrQJ");

function $e65feb0aaa1b4075$export$2e2bcd8739ae039(props) {
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    // Note -- while there is no way to create custom colors using default tooling
    // the editor does supported ad hoc color values -- and there may be content
    // which has been migrated or created via apis which use such values.
    let paletteColorValue;
    /**
   * The Editor persists custom text colors when content has been migrated from the old editor, or created via
   * apis.
   *
   * This behaviour predates the introduction of dark mode.
   *
   * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
   *
   * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
   *
   * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
   * how we detect text colors copied from external editor sources. Where we load the background color from a
   * seperate attribute (data-text-custom-color), instead of the inline style.
   *
   * See the following document for more details on this behaviour
   * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
   */ const tokenColor = (0, $iS6Uy.hexToEditorTextPaletteColor)(props.color);
    if (tokenColor) paletteColorValue = (0, $iS6Uy.hexToEditorTextPaletteColor)(props.color) || props.color;
    else if (colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
    paletteColorValue = (0, $bAH9E.getDarkModeLCHColor)(props.color);
    else // if we are in light mode, we can just set the color
    paletteColorValue = props.color;
    const style = (0, $42omo.useMemo)(()=>({
            ['--custom-palette-color']: paletteColorValue
        }), [
        paletteColorValue
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        ...props.dataAttributes,
        "data-text-custom-color": props.color,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-text-color-mark",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        children: props.children
    });
}

});

parcelRegister("4XjCW", function(module, exports) {
$parcel$export(module.exports, "default", () => $477b09df0a03f691$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $bAH9E = parcelRequire("bAH9E");


var $bWiTS = parcelRequire("bWiTS");


var $cOrQJ = parcelRequire("cOrQJ");


var $1oCLl = parcelRequire("1oCLl");

function $477b09df0a03f691$export$2e2bcd8739ae039(props) {
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    let paletteColorValue;
    /**
   * Documents can contain custom colors when content has been migrated from the old editor, or created via APIs.
   *
   * This behaviour predates the introduction of dark mode.
   *
   * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
   *
   * This introduces inversion of the presentation of the custom text background colors when the user is in dark mode.
   *
   * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
   * how we detect text background colors copied from external editor sources. Where we load the background color from a
   * separate attribute (data-background-custom-color), instead of the inline style.
   *
   * See the following document for more details on this behaviour
   * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
   */ const tokenColor = (0, $bWiTS.hexToEditorTextBackgroundPaletteColor)(props.color);
    if (tokenColor) paletteColorValue = tokenColor;
    else if (colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
    paletteColorValue = (0, $bAH9E.getDarkModeLCHColor)(props.color);
    else // if we are in light mode, we can just set the color
    paletteColorValue = props.color;
    const style = (0, $42omo.useMemo)(()=>({
            ['--custom-palette-color']: paletteColorValue
        }), [
        paletteColorValue
    ]);
    if (props.isStandalone && (0, $1oCLl.expValEquals)('platform_editor_text_highlight_padding', 'isEnabled', true)) return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        "data-block-mark": props.dataAttributes['data-block-mark'],
        "data-renderer-mark": props.dataAttributes['data-renderer-mark'],
        "data-background-custom-color": props.color,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-background-color-mark",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        children: /*#__PURE__*/ (0, $l998X.jsx)("span", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "background-color-padding-left background-color-padding-right",
            children: props.children
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        ...props.dataAttributes,
        "data-background-custom-color": props.color,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-background-color-mark",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        children: props.children
    });
}

});

parcelRegister("6ObvC", function(module, exports) {
$parcel$export(module.exports, "default", () => $94828f1f255f279b$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

function $94828f1f255f279b$export$2e2bcd8739ae039(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $l998X.jsx)("u", {
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("hJ84o", function(module, exports) {
$parcel$export(module.exports, "default", () => $c3ec42e144727e1e$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");


var $aFUXX = parcelRequire("aFUXX");


var $iu6m9 = parcelRequire("iu6m9");


var $1oCLl = parcelRequire("1oCLl");

const $c3ec42e144727e1e$var$wrapperStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `${(0, $aFUXX.blockNodesVerticalMargin)} 0`,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
    marginLeft: '50%',
    transform: 'translateX(-50%)'
});
const $c3ec42e144727e1e$var$getWidth = (width, mode)=>{
    if ((0, $iu6m9.editorExperiment)('advanced_layouts', true) && width) return `min(${width}px, var(--ak-editor--breakout-container-without-gutter-width))`;
    else {
        if (mode === 'full-width') {
            if ((0, $1oCLl.expValEquals)('platform_editor_renderer_breakout_fix', 'isEnabled', true)) return `min(${0, $aFUXX.akEditorFullWidthLayoutWidth}px, var(--ak-editor--breakout-container-without-gutter-width))`;
            return `max(${0, $aFUXX.akEditorDefaultLayoutWidth}px, min(${0, $aFUXX.akEditorFullWidthLayoutWidth}px, var(--ak-editor--breakout-container-without-gutter-width)))`;
        }
        if (mode === 'wide') return `min(var(--ak-editor--breakout-wide-layout-width), var(--ak-editor--breakout-container-without-gutter-width))`;
    }
};
function $c3ec42e144727e1e$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $c3ec42e144727e1e$var$wrapperStyles,
        "data-mode": props.mode,
        ...(0, $iu6m9.editorExperiment)('advanced_layouts', true) && {
            'data-has-width': !!props.width,
            'data-width': props.width
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            width: $c3ec42e144727e1e$var$getWidth('width' in props ? props.width : null, props.mode)
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-editor-breakout-mark fabric-editor-block-mark"
    }, props.children);
}

});

parcelRegister("9DaqG", function(module, exports) {
$parcel$export(module.exports, "default", () => $624960bf79edb235$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

function $624960bf79edb235$export$2e2bcd8739ae039(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("gwCgB", function(module, exports) {
$parcel$export(module.exports, "default", () => $fb8a383b3d03d76f$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

function $fb8a383b3d03d76f$export$2e2bcd8739ae039(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("118BP", function(module, exports) {
$parcel$export(module.exports, "default", () => $0bcfe8463d12ab19$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

function $0bcfe8463d12ab19$export$2e2bcd8739ae039(props) {
    const WrapperElement = props.isInline ? 'span' : 'div';
    return /*#__PURE__*/ (0, $l998X.jsx)(WrapperElement, {
        "data-source": props.sources ? JSON.stringify(props.sources) : undefined,
        "data-mark-type": "dataConsumer",
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("a6ktG", function(module, exports) {
$parcel$export(module.exports, "default", () => $0cff835241e99f05$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

function $0cff835241e99f05$export$2e2bcd8739ae039(props) {
    const WrapperElement = props.isInline ? 'span' : 'div';
    return /*#__PURE__*/ (0, $l998X.jsx)(WrapperElement, {
        "data-localId": props.localId,
        "data-name": props.name,
        "data-mark-type": "fragment",
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("5UG0R", function(module, exports) {
$parcel$export(module.exports, "default", () => $3be8fe9cdede03f9$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");

function $3be8fe9cdede03f9$export$2e2bcd8739ae039(props) {
    const borderColor = props.color ?? '';
    const borderSize = props.size ?? 0;
    return /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        "data-color": borderColor,
        "data-size": borderSize,
        "data-mark-type": "border"
    }, props.children);
}

});

parcelRegister("8FDtv", function(module, exports) {
$parcel$export(module.exports, "default", () => $ce0be8c2097fd490$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

function $ce0be8c2097fd490$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $l998X.jsx)("blockquote", {
        "data-local-id": props.localId,
        children: props.children
    });
}

});

parcelRegister("bHs3B", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $k8515 = parcelRequire("k8515");


var $fZRom = parcelRequire("fZRom");


var $5VmpF = parcelRequire("5VmpF");


var $gi5bC = parcelRequire("gi5bC");


var $d925B = parcelRequire("d925B");


var $d7o2V = parcelRequire("d7o2V");


var $iZq0X = parcelRequire("iZq0X");

const $10ef4e12f0998137$var$BodiedExtension = (props)=>{
    const { children: children, layout: layout = 'default', path: path = [], extensionKey: extensionKey, extensionType: extensionType, parameters: parameters, extensionViewportSizes: extensionViewportSizes, localId: localId } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const removeOverflow = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.toArray(children)// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .map((child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(child) ? child.props.nodeType === 'table' : false).every(Boolean);
    const validationContextValue = (0, $42omo.useMemo)(()=>({
            allowNestedTables: true
        }), []);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fZRom.ErrorBoundary), {
        component: (0, $gi5bC.ACTION_SUBJECT).RENDERER,
        componentId: (0, $d925B.ACTION_SUBJECT_ID).EXTENSION_BODIED,
        createAnalyticsEvent: createAnalyticsEvent,
        additionalInfo: `${extensionType}: ${extensionKey} `,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $d7o2V.AnnotationsPositionContext).Provider, {
            value: {
                startPos: props.startPos + 1
            },
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iZq0X.ValidationContextProvider), {
                value: validationContextValue,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5VmpF.default), {
                    ...props,
                    type: "bodiedExtension",
                    children: ({ result: result })=>{
                        try {
                            if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(result)) // Return the content directly if it's a valid JSX.Element
                            return (0, $k8515.renderExtension)(result, layout, {
                                isTopLevel: path.length < 1
                            }, removeOverflow, parameters?.extensionId, extensionViewportSizes, undefined, localId);
                        } catch (e) {
                        /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
                        // Always return default content if anything goes wrong
                        return (0, $k8515.renderExtension)(children, layout, {
                            isTopLevel: path.length < 1
                        }, removeOverflow, parameters?.extensionId, extensionViewportSizes, undefined, localId);
                    }
                })
            })
        })
    });
};
var $10ef4e12f0998137$export$2e2bcd8739ae039 = $10ef4e12f0998137$var$BodiedExtension;
module.exports["default"] = $10ef4e12f0998137$export$2e2bcd8739ae039;

});

parcelRegister("k8515", function(module, exports) {
$parcel$export(module.exports, "default", () => $eb61561689376623$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $5VmpF = parcelRequire("5VmpF");


var $frt7o = parcelRequire("frt7o");

var $bWRlG = parcelRequire("bWRlG");


var $fJNzZ = parcelRequire("fJNzZ");


var $jVL42 = parcelRequire("jVL42");

const $eb61561689376623$var$viewportSizes = [
    'small',
    'medium',
    'default',
    'large',
    'xlarge'
];
// Mirrors sizes from https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/platform/packages/forge/xen-editor-provider/src/render/renderers/ForgeUIExtension.tsx
const $eb61561689376623$var$macroHeights = {
    small: '112px',
    medium: '262px',
    default: '262px',
    large: '524px',
    xlarge: '1048px'
};
const $eb61561689376623$var$getViewportSize = (extensionId, extensionViewportSizes)=>{
    if (!Array.isArray(extensionViewportSizes) || !extensionId) return;
    const extension = extensionViewportSizes.find((extension)=>extension.extensionId === extensionId);
    if (extension) {
        const viewportSize = extension.viewportSize && $eb61561689376623$var$viewportSizes.includes(extension.viewportSize) ? extension.viewportSize : 'default';
        return $eb61561689376623$var$macroHeights[viewportSize];
    }
};
const $eb61561689376623$export$b7482bdc8aff85e4 = (content, layout, options = {}, removeOverflow, extensionId, extensionViewportSizes, nodeHeight, localId)=>{
    const overflowContainerClass = !removeOverflow ? (0, $jVL42.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER : '';
    // by default, we assume the extension is at top level, (direct child of doc node)
    const { isTopLevel: isTopLevel = true } = options || {};
    const centerAlignClass = isTopLevel && [
        'wide',
        'full-width'
    ].includes(layout) ? (0, $jVL42.RendererCssClassName).EXTENSION_CENTER_ALIGN : '';
    /**
   * To reduce cumulative layout shift, we check installed manifest values (viewportSize) for Forge and extension node parameters
   * for Connect (legacy). As Connect is being phased out, we want Forge to also start to store its expected height
   * in node parameters, especially for dynamic content macros. LegacyMacroStyledElements implements logic similar to here
   * as the extension handler in CFE for legacy macros and Connect.
   */ const viewportSize = $eb61561689376623$var$getViewportSize(extensionId, extensionViewportSizes);
    const extensionHeight = nodeHeight || viewportSize;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $bWRlG.WidthConsumer), {
        children: ({ width: width })=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
                ref: options.handleRef,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: `${(0, $jVL42.RendererCssClassName).EXTENSION} ${options.shadowClassNames} ${centerAlignClass}`,
                style: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    width: isTopLevel ? (0, $fJNzZ.calcBreakoutWidth)(layout, width) : '100%',
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    minHeight: `${extensionHeight}px`
                },
                "data-layout": layout,
                "data-local-id": localId,
                children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    className: overflowContainerClass,
                    children: content
                })
            })
    });
};
const $eb61561689376623$var$Extension = (props)=>{
    const { text: text, layout: layout = 'default', handleRef: handleRef, shadowClassNames: shadowClassNames, path: path = [], extensionViewportSizes: extensionViewportSizes, parameters: parameters, nodeHeight: nodeHeight, localId: localId } = props;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $5VmpF.default), {
        ...props,
        type: "extension",
        children: ({ result: result })=>{
            try {
                // Return the result directly if it's a valid JSX.Element
                if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(result)) return $eb61561689376623$export$b7482bdc8aff85e4(result, layout, {
                    isTopLevel: path.length < 1,
                    handleRef: handleRef,
                    shadowClassNames: shadowClassNames
                }, undefined, parameters?.extensionId, extensionViewportSizes, nodeHeight, localId);
            } catch (e) {
            /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
            // Always return default content if anything goes wrong
            return $eb61561689376623$export$b7482bdc8aff85e4(text || 'extension', layout, {
                isTopLevel: path.length < 1,
                handleRef: handleRef,
                shadowClassNames: shadowClassNames
            }, undefined, parameters?.extensionId, extensionViewportSizes, nodeHeight, localId);
        }
    });
};
var $eb61561689376623$export$2e2bcd8739ae039 = (0, $frt7o.default)($eb61561689376623$var$Extension, {
    overflowSelector: `.${(0, $jVL42.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`
});
module.exports["renderExtension"] = $eb61561689376623$export$b7482bdc8aff85e4;

});

parcelRegister("jVL42", function(module, exports) {
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
const $ade5271c9bbd1338$var$clPrefix = 'ak-renderer-';
const $ade5271c9bbd1338$export$91f3bbbf974496e2 = {
    DOCUMENT: `${$ade5271c9bbd1338$var$clPrefix}document`,
    EXTENSION: `${$ade5271c9bbd1338$var$clPrefix}extension`,
    EXTENSION_CENTER_ALIGN: `${$ade5271c9bbd1338$var$clPrefix}extension-center-align`,
    EXTENSION_OVERFLOW_CONTAINER: `${$ade5271c9bbd1338$var$clPrefix}extension-overflow-container`,
    NUMBER_COLUMN: `${$ade5271c9bbd1338$var$clPrefix}table-number-column`,
    SORTABLE_COLUMN_WRAPPER: `${$ade5271c9bbd1338$var$clPrefix}tableHeader-sortable-column__wrapper`,
    SORTABLE_COLUMN: `${$ade5271c9bbd1338$var$clPrefix}tableHeader-sortable-column`,
    SORTABLE_COLUMN_ICON_WRAPPER: `${$ade5271c9bbd1338$var$clPrefix}tableHeader-sorting-icon__wrapper`,
    SORTABLE_COLUMN_NO_ORDER: `${$ade5271c9bbd1338$var$clPrefix}tableHeader-sorting-icon__no-order`
};
module.exports["RendererCssClassName"] = $ade5271c9bbd1338$export$91f3bbbf974496e2;

});

parcelRegister("1acNj", function(module, exports) {
/* eslint-disable @atlaskit/design-system/prefer-primitives, @atlaskit/design-system/consistent-css-prop-usage */ /**
 * @jsxRuntime classic
 * @jsx jsx
 * @jsxFrag
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");


var $42omo = parcelRequire("42omo");


var $bWRlG = parcelRequire("bWRlG");


var $jVL42 = parcelRequire("jVL42");


var $fJNzZ = parcelRequire("fJNzZ");




const $412f9b1c55f8103a$export$3c7139d93ecb4f1f = ({ updateActiveChild: updateActiveChild, children: children, allowBodiedOverride: allowBodiedOverride, childrenContainer: childrenContainer })=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>{
        return {
            changeActive (index) {
                if (!Number.isInteger(index)) return false;
                updateActiveChild(index);
                return true;
            },
            addChild () {
                return false;
            },
            getChildrenCount () {
                return children && Array.isArray(children) ? children.length : 0;
            },
            removeChild (_index) {
                return false;
            },
            updateParameters (_parameters) {
                return false;
            },
            getChildren () {
                return [];
            },
            getChildrenContainer () {
                return allowBodiedOverride ? childrenContainer : null;
            }
        };
    }, [
        updateActiveChild,
        children,
        allowBodiedOverride,
        childrenContainer
    ]);
};






var $2XqLN = parcelRequire("2XqLN");


var $heH5c = parcelRequire("heH5c");


var $6mbqi = parcelRequire("6mbqi");

const $f289f2207b4baf8b$export$e55394818db35473 = ({ extensionType: extensionType, extensionKey: extensionKey })=>{
    const isMounted = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(true);
    const localGetNodeRenderer = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>(0, $2XqLN.default)((0, $heH5c.getNodeRenderer)), []);
    const [provider, setProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const [privateProps, setPrivateProps] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState();
    const providerPromise = (0, $6mbqi.useProvider)('extensionProvider');
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        if (providerPromise) providerPromise.then((p)=>{
            if (isMounted.current) setProvider(p);
            return (0, $heH5c.getExtensionModuleNodePrivateProps)(p, extensionType, extensionKey);
        }).then((pr)=>{
            if (isMounted.current) setPrivateProps(pr);
        });
    }, [
        providerPromise,
        extensionType,
        extensionKey
    ]);
    const NodeRenderer = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>{
        if (!provider) return null;
        return localGetNodeRenderer(provider, extensionType, extensionKey);
    }, [
        provider,
        extensionType,
        extensionKey,
        localGetNodeRenderer
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>{
        if (!provider || !NodeRenderer || !privateProps) return {
            extensionContext: null,
            loading: true
        };
        return {
            extensionContext: {
                NodeRenderer: NodeRenderer,
                privateProps: privateProps
            },
            loading: false
        };
    }, [
        provider,
        NodeRenderer,
        privateProps
    ]);
};


function $001e619277309332$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $001e619277309332$var$containerStyles = {
    name: "utcqjk",
    styles: "&:first-child > .ak-renderer-extension{margin-top:0;}"
};
const $001e619277309332$var$MultiBodiedExtensionChildrenContainer = ({ children: children })=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)("article", {
        "data-testid": "multiBodiedExtension--frames"
    }, children);
};
const $001e619277309332$var$MultiBodiedExtensionNavigation = ({ children: children })=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)("nav", {
        "data-testid": "multiBodiedExtension-navigation"
    }, children);
};
const $001e619277309332$var$MultiBodiedExtensionWrapper = ({ width: width, path: path, layout: layout, children: children })=>{
    const isTopLevel = path.length < 1;
    const centerAlignClass = isTopLevel && [
        'wide',
        'full-width'
    ].includes(layout) ? (0, $jVL42.RendererCssClassName).EXTENSION_CENTER_ALIGN : '';
    // This hierarchy is copied from regular extension (see extension.tsx)
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${(0, $jVL42.RendererCssClassName).EXTENSION} ${centerAlignClass}`,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            width: isTopLevel ? (0, $fJNzZ.calcBreakoutWidth)(layout, width) : '100%'
        },
        "data-layout": layout,
        "data-testid": "multiBodiedExtension--wrapper"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: `${(0, $jVL42.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`
    }, children));
};
const $001e619277309332$var$MultiBodiedExtension = (props)=>{
    const { children: children, layout: layout = 'default', path: path = [], parameters: parameters, extensionType: extensionType, extensionKey: extensionKey, content: content, marks: marks, localId: localId } = props;
    const [activeChildIndex, setActiveChildIndex] = (0, $42omo.useState)(0);
    const { loading: loading, extensionContext: extensionContext } = (0, $f289f2207b4baf8b$export$e55394818db35473)({
        extensionType: extensionType,
        extensionKey: extensionKey
    });
    const actions = (0, $412f9b1c55f8103a$export$3c7139d93ecb4f1f)({
        updateActiveChild: setActiveChildIndex,
        children: children,
        childrenContainer: /*#__PURE__*/ (0, $9K4OG.jsx)($001e619277309332$var$MultiBodiedExtensionChildrenContainer, null, children),
        allowBodiedOverride: extensionContext?.privateProps?.__allowBodiedOverride
    });
    const renderContent = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback(()=>{
        if (loading || !extensionContext) return null;
        const { NodeRenderer: NodeRenderer, privateProps: privateProps } = extensionContext;
        const fragmentLocalId = marks?.find((m)=>m.type.name === 'fragment')?.attrs?.localId;
        const node = {
            type: 'multiBodiedExtension',
            extensionKey: extensionKey,
            extensionType: extensionType,
            parameters: parameters,
            content: content,
            localId: localId,
            fragmentLocalId: fragmentLocalId
        };
        if (privateProps.__allowBodiedOverride) return /*#__PURE__*/ (0, $9K4OG.jsx)(NodeRenderer, {
            node: node,
            actions: actions
        });
        else return /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, $9K4OG.jsx)($001e619277309332$var$MultiBodiedExtensionNavigation, null, /*#__PURE__*/ (0, $9K4OG.jsx)(NodeRenderer, {
            node: node,
            actions: actions
        })), /*#__PURE__*/ (0, $9K4OG.jsx)($001e619277309332$var$MultiBodiedExtensionChildrenContainer, null, children));
    }, [
        loading,
        extensionContext,
        marks,
        extensionKey,
        extensionType,
        parameters,
        content,
        localId,
        actions,
        children
    ]);
    // make the frame visible
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    const containerActiveFrameStyles = /*#__PURE__*/ (0, $9K4OG.css)("& [data-extension-frame='true']:nth-of-type(", activeChildIndex + 1, "){display:block;}");
    return /*#__PURE__*/ (0, $9K4OG.jsx)("section", {
        css: [
            $001e619277309332$var$containerStyles,
            containerActiveFrameStyles
        ],
        "data-testid": "multiBodiedExtension--container",
        "data-multiBodiedExtension-container": true,
        "data-active-child-index": activeChildIndex,
        "data-layout": layout,
        "data-local-id": localId
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $bWRlG.WidthConsumer), null, ({ width: width })=>/*#__PURE__*/ (0, $9K4OG.jsx)($001e619277309332$var$MultiBodiedExtensionWrapper, {
            layout: layout,
            width: width,
            path: path
        }, renderContent())));
};
var $001e619277309332$export$2e2bcd8739ae039 = $001e619277309332$var$MultiBodiedExtension;
module.exports["default"] = $001e619277309332$export$2e2bcd8739ae039;

});

parcelRegister("l5RsK", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");


var $dh538 = parcelRequire("dh538");

function $ef229c57415fc2fe$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ef229c57415fc2fe$var$containerCSSOld = {
    name: "1e1nv5z",
    styles: "min-height:100px;flex-basis:100%"
};
const $ef229c57415fc2fe$var$containerCSSNew = /*#__PURE__*/ (0, $9K4OG.css)({
    padding: `${"var(--ds-space-100, 8px)"}`,
    minHeight: '100px',
    // by default all frames are hidden, this style is overridden in multiBodiedExtensions for active frame
    display: 'none'
});
const $ef229c57415fc2fe$var$ExtensionFrame = (props)=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: [
            (0, $dh538.fg)('platform_editor_multi_body_extension_extensibility') ? $ef229c57415fc2fe$var$containerCSSNew : $ef229c57415fc2fe$var$containerCSSOld
        ],
        "data-extension-frame": "true"
    }, props.children);
};
var $ef229c57415fc2fe$export$2e2bcd8739ae039 = $ef229c57415fc2fe$var$ExtensionFrame;
module.exports["default"] = $ef229c57415fc2fe$export$2e2bcd8739ae039;

});

parcelRegister("4aPtv", function(module, exports) {
$parcel$export(module.exports, "default", () => $6a60824ddd9f14a5$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $76Qef = parcelRequire("76Qef");


var $drJ23 = parcelRequire("drJ23");

function $6a60824ddd9f14a5$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $l998X.jsx)("ul", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $76Qef.bulletListSelector).substr(1),
        "data-local-id": props.localId,
        "data-indent-level": props.path ? (0, $drJ23.getListIndentLevel)(props.path) : 1,
        children: props.children
    });
}

});

parcelRegister("8jc2v", function(module, exports) {
$parcel$export(module.exports, "default", () => $61eb98cf96d6d9e9$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $jVL42 = parcelRequire("jVL42");


var $d925B = parcelRequire("d925B");


var $42omo = parcelRequire("42omo");


var $6uN0A = parcelRequire("6uN0A");

class $6ae1df30d2a89e31$export$6e6724d89f27411 {
    eq(selection) {
        if (!selection) return false;
        if (this.range && selection.range) {
            const startMatches = this.range?.compareBoundaryPoints(Range.START_TO_START, selection.range) === 0;
            const endMatches = this.range?.compareBoundaryPoints(Range.END_TO_END, selection.range) === 0;
            return startMatches && endMatches;
        }
        return this.type === 'None' && selection.type === 'None';
    }
    inside(el) {
        return el.contains(this.range?.commonAncestorContainer ?? null);
    }
    select(el) {
        const range = document.createRange();
        range.selectNodeContents(el);
        const selection = window.getSelection();
        if (selection) {
            selection.removeAllRanges();
            selection.addRange(range);
        }
        return $6ae1df30d2a89e31$export$6e6724d89f27411.fromWindow();
    }
    static fromWindow(win = window) {
        return new $6ae1df30d2a89e31$export$6e6724d89f27411(win.getSelection());
    }
    constructor(selection){
        this.type = void 0;
        this.range = void 0;
        this.type = selection ? selection.type : 'None';
        if (selection && this.type !== 'None') this.range = selection.getRangeAt(0);
    }
}


const $24fdc3f18020be27$export$98871b245ee25215 = ()=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext((0, $6uN0A.default));
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(null);
    const clicked = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(false);
    const caught = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef();
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const mac = typeof navigator !== 'undefined' ? /Mac/.test(navigator.platform) : false;
    const onKeyDown = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((e)=>{
        const el = ref.current;
        if (!el) return;
        const modKey = mac ? e.metaKey : e.ctrlKey;
        if (!modKey || e.code !== 'KeyA' || e.shiftKey) return;
        const elementSelection = (0, $6ae1df30d2a89e31$export$6e6724d89f27411).fromWindow();
        const isInput = e.target?.matches?.('input');
        if (elementSelection.eq(caught.current) || isInput) {
            fireAnalyticsEvent({
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                action: (0, $d925B.ACTION).SELECT_ALL_ESCAPED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).RENDERER
            });
            return;
        }
        if (elementSelection.inside(el) || elementSelection.type === 'None' && clicked.current) {
            fireAnalyticsEvent({
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                action: (0, $d925B.ACTION).SELECT_ALL_CAUGHT,
                actionSubject: (0, $d925B.ACTION_SUBJECT).RENDERER
            });
            e.preventDefault();
            caught.current = elementSelection.select(el);
        }
    }, [
        mac,
        ref,
        fireAnalyticsEvent,
        clicked,
        caught
    ]);
    const onClick = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((e)=>{
        clicked.current = ref.current?.contains(e.target) ?? false;
    }, [
        ref,
        clicked
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.addEventListener('keydown', onKeyDown);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.addEventListener('click', onClick);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            window.removeEventListener('keydown', onKeyDown);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            window.removeEventListener('click', onClick);
        };
    }, [
        onKeyDown,
        onClick
    ]);
    return ref;
};


function $61eb98cf96d6d9e9$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $jVL42.RendererCssClassName).DOCUMENT,
        children: props.children
    });
}
function $61eb98cf96d6d9e9$export$41121a410ca2f650(props) {
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        ref: (0, $24fdc3f18020be27$export$98871b245ee25215)(),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $jVL42.RendererCssClassName).DOCUMENT,
        children: props.children
    });
}
module.exports["DocWithSelectAllTrap"] = $61eb98cf96d6d9e9$export$41121a410ca2f650;

});

parcelRegister("8dFG8", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

const $502b94a4b5302811$var$HardBreak = ({ forceNewLine: forceNewLine = false })=>{
    // To display an empty line using Shift+Enter, ProseMirror inserts a
    // double <br>. The second <br> is not part of the document, it's just
    // there to make browsers behave properly. The forceNewLine prop in this
    // component replicates this behaviour. If the last child node is a
    // hardBreak, it will also insert a double <br>.
    if (forceNewLine) return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("br", {}),
            /*#__PURE__*/ (0, $l998X.jsx)("br", {})
        ]
    });
    return /*#__PURE__*/ (0, $l998X.jsx)("br", {});
};
var $502b94a4b5302811$export$2e2bcd8739ae039 = $502b94a4b5302811$var$HardBreak;
module.exports["default"] = $502b94a4b5302811$export$2e2bcd8739ae039;

});

parcelRegister("9IIii", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $6F6hl = parcelRequire("6F6hl");


var $4u5NT = parcelRequire("4u5NT");


var $d925B = parcelRequire("d925B");


var $6uN0A = parcelRequire("6uN0A");


var $kIphX = parcelRequire("kIphX");


var $3HdsG = parcelRequire("3HdsG");

const $af6844859e3a51a3$var$getCurrentUrlWithHash = (hash = '')=>{
    const url = new URL(window.location.href);
    url.search = ''; // clear any query params so that the page will correctly scroll to the anchor
    url.hash = encodeURIComponent(hash);
    return url.href;
};
function $af6844859e3a51a3$var$hasRightAlignmentMark(marks) {
    if (!marks || !marks.length) return false;
    return marks.some((mark)=>mark.type.name === 'alignment' && mark.attrs.align === 'end');
}
function $af6844859e3a51a3$var$WrappedHeadingAnchor({ enableNestedHeaderLinks: enableNestedHeaderLinks, level: level, headingId: headingId, hideFromScreenReader: hideFromScreenReader }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6uN0A.default).Consumer, {
        children: ({ fireAnalyticsEvent: fireAnalyticsEvent })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3HdsG.default), {
                enableNestedHeaderLinks: enableNestedHeaderLinks,
                level: level,
                onCopyText: ()=>{
                    fireAnalyticsEvent({
                        action: (0, $d925B.ACTION).CLICKED,
                        actionSubject: (0, $d925B.ACTION_SUBJECT).BUTTON,
                        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).HEADING_ANCHOR_LINK,
                        eventType: (0, $d925B.EVENT_TYPE).UI
                    });
                    return (0, $kIphX.copyTextToClipboard)($af6844859e3a51a3$var$getCurrentUrlWithHash(headingId));
                },
                hideFromScreenReader: hideFromScreenReader,
                headingId: headingId
            })
    });
}
function $af6844859e3a51a3$var$Heading(props) {
    const { headingId: headingId, dataAttributes: dataAttributes, allowHeadingAnchorLinks: allowHeadingAnchorLinks, marks: marks, invisible: invisible, localId: localId } = props;
    const HX = `h${props.level}`;
    const mouseEntered = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(false);
    const showAnchorLink = !!props.showAnchorLink;
    const isRightAligned = $af6844859e3a51a3$var$hasRightAlignmentMark(marks);
    const enableNestedHeaderLinks = allowHeadingAnchorLinks && allowHeadingAnchorLinks.allowNestedHeaderLinks;
    const headingIdToUse = invisible ? undefined : headingId;
    const mouseEnterHandler = ()=>{
        if (showAnchorLink && !mouseEntered.current) {
            // Abort TTVC calculation when the mouse hovers over heading. Hovering over
            // heading render heading anchor and inline comment buttons. These user-induced
            // DOM changes are valid reasons to abort the TTVC calculation.
            (0, $4u5NT.abortAll)('new_interaction');
            mouseEntered.current = true;
        }
    };
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)(HX, {
                id: headingIdToUse,
                "data-local-id": localId,
                "data-renderer-start-pos": dataAttributes['data-renderer-start-pos'],
                onMouseEnter: mouseEnterHandler,
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                    children: [
                        showAnchorLink && headingId && isRightAligned && /*#__PURE__*/ (0, $l998X.jsx)($af6844859e3a51a3$var$WrappedHeadingAnchor, {
                            level: props.level,
                            enableNestedHeaderLinks: enableNestedHeaderLinks,
                            headingId: headingId,
                            hideFromScreenReader: true
                        }),
                        props.children,
                        showAnchorLink && headingId && !isRightAligned && /*#__PURE__*/ (0, $l998X.jsx)($af6844859e3a51a3$var$WrappedHeadingAnchor, {
                            level: props.level,
                            enableNestedHeaderLinks: enableNestedHeaderLinks,
                            headingId: headingId,
                            hideFromScreenReader: true
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6F6hl.default), {
                testId: "visually-hidden-heading-anchor",
                children: showAnchorLink && headingId && /*#__PURE__*/ (0, $l998X.jsx)($af6844859e3a51a3$var$WrappedHeadingAnchor, {
                    level: props.level,
                    enableNestedHeaderLinks: enableNestedHeaderLinks,
                    headingId: headingId
                })
            })
        ]
    });
}
var $af6844859e3a51a3$export$2e2bcd8739ae039 = $af6844859e3a51a3$var$Heading;
module.exports["default"] = $af6844859e3a51a3$export$2e2bcd8739ae039;

});

parcelRegister("AXP6M", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $5VmpF = parcelRequire("5VmpF");

const $7ae9d43d02a0afce$var$InlineExtension = (props)=>{
    const { text: text } = props;
    return(// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $l998X.jsx)((0, $5VmpF.default), {
        ...props,
        type: "inlineExtension",
        children: ({ result: result })=>{
            try {
                // Return the result directly if it's a valid JSX.Element
                if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(result)) return /*#__PURE__*/ (0, $l998X.jsx)("span", {
                    children: result
                });
            } catch (e) {
            /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
            // Always return default content if anything goes wrong
            return /*#__PURE__*/ (0, $l998X.jsx)("span", {
                children: text || 'inlineExtension'
            });
        }
    }));
};
var $7ae9d43d02a0afce$export$2e2bcd8739ae039 = $7ae9d43d02a0afce$var$InlineExtension;
module.exports["default"] = $7ae9d43d02a0afce$export$2e2bcd8739ae039;

});

parcelRegister("iPgHB", function(module, exports) {
$parcel$export(module.exports, "default", () => $3e32ab0c2bcbe4a4$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $iu6m9 = parcelRequire("iu6m9");

function $3e32ab0c2bcbe4a4$export$2e2bcd8739ae039(props) {
    return (0, $iu6m9.editorExperiment)('advanced_layouts', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: "layout-section-container",
        "data-local-id": props.localId,
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            "data-layout-section": true,
            "data-layout-columns": props?.content?.length,
            children: props.children
        })
    }) : /*#__PURE__*/ (0, $l998X.jsx)("div", {
        "data-layout-section": true,
        "data-local-id": props.localId,
        children: props.children
    });
}

});

parcelRegister("gaxtd", function(module, exports) {
$parcel$export(module.exports, "default", () => $7119b81e1329ee77$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $bWRlG = parcelRequire("bWRlG");


var $dh538 = parcelRequire("dh538");

function $7119b81e1329ee77$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// localized styles, was from clearNextSiblingMarginTopStyle in @atlaskit/editor-common/ui
const $7119b81e1329ee77$var$clearNextSiblingMarginTopStyle = {
    name: "1f3w791",
    styles: "& + *{margin-top:0 !important;}"
};
const $7119b81e1329ee77$var$multipleWrappedImagesStyle = {
    name: "y2yz5o",
    styles: "& [class*=\"image-wrap-\"] + [class*=\"image-wrap-\"], & [class*=\"image-wrap-\"]:has( + [class*=\"image-wrap-\"]){margin-top:0;}"
};
// localized styles, was from clearNextSiblingBlockMarkMarginTopStyle in @atlaskit/editor-common/ui
const $7119b81e1329ee77$var$clearNextSiblingBlockMarkMarginTopStyle = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`+ .fabric-editor-block-mark > p,
	  + .fabric-editor-block-mark > h1,
	  + .fabric-editor-block-mark > h2,
	  + .fabric-editor-block-mark > h3,
	  + .fabric-editor-block-mark > h4,
	  + .fabric-editor-block-mark > h5,
	  + .fabric-editor-block-mark > h6
	`]: {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginTop: '0 !important'
    }
});
function $7119b81e1329ee77$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        "data-layout-column": true,
        "data-column-width": props.width,
        style: {
            flexBasis: `${props.width}%`
        },
        css: (0, $dh538.fg)('platform_editor_fix_media_in_renderer') && $7119b81e1329ee77$var$multipleWrappedImagesStyle
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $bWRlG.WidthProvider), null, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: [
            $7119b81e1329ee77$var$clearNextSiblingMarginTopStyle,
            $7119b81e1329ee77$var$clearNextSiblingBlockMarkMarginTopStyle
        ]
    }), props.children));
}

});

parcelRegister("2y2LK", function(module, exports) {
$parcel$export(module.exports, "default", () => $d550833e818bebdd$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

function $d550833e818bebdd$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $l998X.jsx)("li", {
        children: props.children
    });
}

});

parcelRegister("e3xiQ", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $48Use = parcelRequire("48Use");

const $60e49dc64205ce7a$var$RenderCaption = ({ children: children, dataAttributes: dataAttributes })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $48Use.default), {
        hasContent: true,
        dataAttributes: dataAttributes,
        children: children
    });
};
var $60e49dc64205ce7a$export$2e2bcd8739ae039 = $60e49dc64205ce7a$var$RenderCaption;
module.exports["default"] = $60e49dc64205ce7a$export$2e2bcd8739ae039;

});

parcelRegister("iKbB3", function(module, exports) {
$parcel$export(module.exports, "default", () => $380dd188db062d07$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $bOKwh = parcelRequire("bOKwh");


var $4mSjx = parcelRequire("4mSjx");


var $irKZA = parcelRequire("irKZA");


var $drJ23 = parcelRequire("drJ23");

function $380dd188db062d07$export$2e2bcd8739ae039(props) {
    const extraProps = {};
    const itemCounterDigitsSize = (0, $irKZA.getItemCounterDigitsSize)({
        order: props.order,
        itemsCount: props?.content?.length
    });
    if (itemCounterDigitsSize && itemCounterDigitsSize > 1) extraProps.style = (0, $4mSjx.getOrderedListInlineStyles)(itemCounterDigitsSize, 'object');
    if (props.order !== undefined) extraProps.start = (0, $irKZA.resolveOrder)(props.order);
    return /*#__PURE__*/ (0, $l998X.jsx)("ol", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bOKwh.orderedListSelector).substr(1),
        "data-local-id": props.localId,
        "data-indent-level": props.path ? (0, $drJ23.getListIndentLevel)(props.path) : 1,
        start: props.start,
        ...extraProps,
        children: props.children
    });
}

});

parcelRegister("4AYMa", function(module, exports) {
$parcel$export(module.exports, "default", () => $c5d919d33f5d798a$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");





var $42omo = parcelRequire("42omo");

function $08993800855619e3$export$2e2bcd8739ae039(props) {
    const { children: children } = props;
    const childCount = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.toArray(children).length;
    if (!childCount) return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: "\xa0"
    });
    return children;
}


function $c5d919d33f5d798a$export$2e2bcd8739ae039({ children: children, dataAttributes: dataAttributes, localId: localId }) {
    return(// ignore the eslint warning Text primitive does not support dataAttributes
    // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading, @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, $l998X.jsx)("p", {
        ...dataAttributes,
        "data-local-id": localId,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $08993800855619e3$export$2e2bcd8739ae039), {
            children: children
        })
    }));
}

});

parcelRegister("12YDi", function(module, exports) {
$parcel$export(module.exports, "default", () => $120764912de8ad63$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

function $120764912de8ad63$export$2e2bcd8739ae039(props) {
    if (props.allowPlaceholderText) return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        "data-placeholder": `${props.text}`,
        children: props.text
    });
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {});
}

});

parcelRegister("40qpT", function(module, exports) {
$parcel$export(module.exports, "default", () => $5ea7ab564e9f0cf2$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

function $5ea7ab564e9f0cf2$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $l998X.jsx)("hr", {
        role: "presentation"
    });
}

});

parcelRegister("iKFPk", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $bAH9E = parcelRequire("bAH9E");

var $ivrsj = parcelRequire("ivrsj");


var $cOrQJ = parcelRequire("cOrQJ");


var $2QYOD = parcelRequire("2QYOD");


var $6icEc = parcelRequire("6icEc");


var $7f6CO = parcelRequire("7f6CO");


var $59U23 = parcelRequire("59U23");


var $d925B = parcelRequire("d925B");


var $jVL42 = parcelRequire("jVL42");


var $8C5kA = parcelRequire("8C5kA");


var $3kBFe = parcelRequire("3kBFe");

const $22c24c997e66799c$var$IgnoreSorting = [
    'LABEL',
    'INPUT'
];
const $22c24c997e66799c$var$nextStatusOrder = (currentSortOrder)=>{
    switch(currentSortOrder){
        case (0, $2QYOD.SortOrder).NO_ORDER:
            return (0, $2QYOD.SortOrder).ASC;
        case (0, $2QYOD.SortOrder).ASC:
            return (0, $2QYOD.SortOrder).DESC;
        case (0, $2QYOD.SortOrder).DESC:
            return (0, $2QYOD.SortOrder).NO_ORDER;
    }
    return (0, $2QYOD.SortOrder).NO_ORDER;
};
const $22c24c997e66799c$var$getSortOrderLabel = (intl, currentSortOrder)=>{
    const { noneSortingLabel: noneSortingLabel, ascSortingLabel: ascSortingLabel, descSortingLabel: descSortingLabel } = (0, $3kBFe.tableCellMessages);
    switch(currentSortOrder){
        case (0, $2QYOD.SortOrder).NO_ORDER:
            return intl.formatMessage(noneSortingLabel);
        case (0, $2QYOD.SortOrder).ASC:
            return intl.formatMessage(ascSortingLabel);
        case (0, $2QYOD.SortOrder).DESC:
            return intl.formatMessage(descSortingLabel);
        default:
            return intl.formatMessage(noneSortingLabel);
    }
};
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $22c24c997e66799c$var$getDataAttributes = (colwidth, background)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const attrs = {};
    if (colwidth) attrs['data-colwidth'] = colwidth.join(',');
    /**
   * Storing hex code in data-cell-background because
   *  we want to have DST token (css variable) or
   *  DST token value (value (hex code) of css variable) in
   *  inline style to correct render table cell background
   *  based on selected theme.
   * Currently we rely on background color hex code stored in
   *  inline style.
   * Because of that when we copy and paste table, we end up
   *  having DST token or DST token value in ADF instead of
   *  original hex code which we map to DST token.
   * So, introducing data-cell-background.
   * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
   */ if (background) attrs['data-cell-background'] = background;
    return attrs;
};
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $22c24c997e66799c$var$cssVariablePattern = /^var\(--.*\)$/;
const $22c24c997e66799c$var$getStyle = ({ background: background, colGroupWidth: colGroupWidth, offsetTop: offsetTop, colorMode: colorMode })=>{
    const style = {};
    if (background && // ignore setting inline styles if ds neutral token is detected
    !background.includes('--ds-background-neutral')) {
        /**
     * The Editor supports users pasting content from external sources with custom table cell backgrounds and having those
     * backgrounds persisted.
     *
     * This feature predates the introduction of dark mode.
     *
     * Without the inversion logic below, tokenised content (ie. text), can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom background color when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect table cell background colors copied from external editor sources. Where we load the background color from a
     * seperate attribute (data-cell-background), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2892247168/Unsupported+custom+table+cell+background+colors+in+dark+theme+Editor+Job+Story
     */ const tokenColor = (0, $6icEc.hexToEditorBackgroundPaletteRawValue)(background);
        if (tokenColor) style.backgroundColor = tokenColor;
        else if (/**
     * There was previously a bug in dark mode where we would attempt to invert
     * a design token in `getDarkModeLCHColor` causing issues.
     * If it's a design token we should return it as is.
     */ $22c24c997e66799c$var$cssVariablePattern.test(background)) style.backgroundColor = background;
        else // if we have a custom color, we need to check if we are in dark mode
        if (colorMode === 'dark') // if we are in dark mode, we need to invert the color
        style.backgroundColor = (0, $bAH9E.getDarkModeLCHColor)(background);
        else // if we are in light mode, we can just set the color
        style.backgroundColor = background;
    }
    if (colGroupWidth) {
        style.width = colGroupWidth;
        style.minWidth = colGroupWidth;
    }
    if (offsetTop !== undefined) style.top = offsetTop;
    return style;
};
const $22c24c997e66799c$var$getWithCellProps = (WrapperComponent)=>{
    return function WithCellProps(props) {
        const { colorMode: colorMode } = (0, $cOrQJ.default)();
        const { children: children, className: className, onClick: onClick, colwidth: colwidth, colGroupWidth: colGroupWidth, rowspan: rowspan, colspan: colspan, background: background, offsetTop: offsetTop, ariaSort: ariaSort } = props;
        // This is used to set the background color of the cell
        // to a dark mode color in mobile dark mode
        const colorName = background ? (0, $ivrsj.tableBackgroundColorPalette).get(background) : '';
        return /*#__PURE__*/ (0, $l998X.jsx)(WrapperComponent, {
            rowSpan: rowspan,
            colSpan: colspan,
            // Note: When content from a renderer is pasted into an editor
            // the background color is not taken from the inline style.
            // Instead it is taken from the data-cell-background attribute
            // (added via getDataAttributes below).
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: $22c24c997e66799c$var$getStyle({
                background: background,
                colGroupWidth: colGroupWidth,
                offsetTop: offsetTop,
                colorMode: colorMode
            }),
            colorname: colorName,
            onClick: onClick,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ...$22c24c997e66799c$var$getDataAttributes(colwidth, background),
            "aria-sort": ariaSort,
            children: children
        });
    };
};
const $22c24c997e66799c$var$TH = $22c24c997e66799c$var$getWithCellProps('th');
const $22c24c997e66799c$export$cfca40ca5c56a38e = (WrapperComponent)=>{
    return function THWithSortableColumn(props) {
        const intl = (0, $8C5kA.default)();
        const { allowColumnSorting: allowColumnSorting, onSorting: onSorting, children: children, sortOrdered: sortOrdered, isHeaderRow: isHeaderRow } = props;
        const sortOrderedClassName = sortOrdered === (0, $2QYOD.SortOrder).NO_ORDER ? (0, $jVL42.RendererCssClassName).SORTABLE_COLUMN_NO_ORDER : '';
        if (!allowColumnSorting || !isHeaderRow) // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, $l998X.jsx)(WrapperComponent, {
            ...props
        });
        return /*#__PURE__*/ (0, $l998X.jsx)(WrapperComponent, {
            ...props,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $jVL42.RendererCssClassName).SORTABLE_COLUMN_WRAPPER,
            ariaSort: $22c24c997e66799c$var$getSortOrderLabel(intl, sortOrdered),
            children: /*#__PURE__*/ (0, $l998X.jsxs)("div", {
                className: (0, $jVL42.RendererCssClassName).SORTABLE_COLUMN,
                children: [
                    children,
                    /*#__PURE__*/ (0, $l998X.jsx)("figure", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: `${(0, $jVL42.RendererCssClassName).SORTABLE_COLUMN_ICON_WRAPPER} ${sortOrderedClassName}`,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7f6CO.default), {
                            isSortingAllowed: !!onSorting,
                            sortOrdered: sortOrdered,
                            onClick: sort,
                            onKeyDown: onKeyPress
                        })
                    })
                ]
            })
        });
        function onKeyPress(event) {
            const keys = [
                ' ',
                'Enter',
                'Spacebar'
            ];
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            const { tagName: tagName } = event.target;
            // trigger sorting if space or enter are clicked but not when in an input field (template variables)
            if (keys.includes(event.key) && !$22c24c997e66799c$var$IgnoreSorting.includes(tagName)) {
                event.preventDefault();
                sort();
            }
        }
        function sort() {
            const { fireAnalyticsEvent: fireAnalyticsEvent, onSorting: onSorting, columnIndex: columnIndex, sortOrdered: sortOrdered } = props;
            if (onSorting && columnIndex != null) {
                const sortOrder = $22c24c997e66799c$var$nextStatusOrder(sortOrdered);
                onSorting(columnIndex, sortOrder);
                fireAnalyticsEvent && fireAnalyticsEvent({
                    action: (0, $d925B.ACTION).SORT_COLUMN,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
                    attributes: {
                        platform: (0, $59U23.PLATFORM).WEB,
                        mode: (0, $59U23.MODE).RENDERER,
                        columnIndex: columnIndex,
                        sortOrder: sortOrder
                    },
                    eventType: (0, $d925B.EVENT_TYPE).TRACK
                });
            } else fireAnalyticsEvent && fireAnalyticsEvent({
                action: (0, $d925B.ACTION).SORT_COLUMN_NOT_ALLOWED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
                attributes: {
                    platform: (0, $59U23.PLATFORM).WEB,
                    mode: (0, $59U23.MODE).RENDERER
                },
                eventType: (0, $d925B.EVENT_TYPE).TRACK
            });
        }
    };
};
const $22c24c997e66799c$export$f850895b287ef28e = $22c24c997e66799c$export$cfca40ca5c56a38e($22c24c997e66799c$var$TH);
const $22c24c997e66799c$var$TD = $22c24c997e66799c$var$getWithCellProps('td');
const $22c24c997e66799c$export$1e4baea7053fc0e3 = $22c24c997e66799c$var$TD;
module.exports["TableHeader"] = $22c24c997e66799c$export$f850895b287ef28e;
module.exports["TableCell"] = $22c24c997e66799c$export$1e4baea7053fc0e3;

});

parcelRegister("a78Ri", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $cN8vw = parcelRequire("cN8vw");


var $2QYOD = parcelRequire("2QYOD");


var $jVL42 = parcelRequire("jVL42");

class $f7e5733ad19fb3c4$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    render() {
        const { children: children, innerRef: innerRef } = this.props;
        const childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.toArray(children);
        return /*#__PURE__*/ (0, $l998X.jsxs)("tr", {
            ref: innerRef,
            children: [
                this.props.isNumberColumnEnabled && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, $l998X.jsx)("td", {
                    className: (0, $jVL42.RendererCssClassName).NUMBER_COLUMN,
                    children: this.props.index
                }),
                (0, $cN8vw.compose)(this.addSortableColumn, this.addColGroupWidth)(childrenArray)
            ]
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            colGroupWidths: []
        };
        this.addSortableColumn = (childrenArray)=>{
            const { allowColumnSorting: allowColumnSorting, index: rowIndex } = this.props;
            const isHeaderRow = !rowIndex;
            if (allowColumnSorting && isHeaderRow) childrenArray = childrenArray.map((child, index)=>{
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(child)) {
                    const { tableOrderStatus: tableOrderStatus } = this.props;
                    let sortOrdered = (0, $2QYOD.SortOrder).NO_ORDER;
                    if (tableOrderStatus) sortOrdered = index === tableOrderStatus.columnIndex ? tableOrderStatus.order : (0, $2QYOD.SortOrder).NO_ORDER;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement(child, {
                        columnIndex: index,
                        onSorting: this.props.onSorting,
                        sortOrdered: sortOrdered,
                        isHeaderRow: isHeaderRow
                    });
                }
            });
            return childrenArray;
        };
        this.addColGroupWidth = (childrenArray)=>{
            if (this.state.colGroupWidths?.length) childrenArray = childrenArray.map((child, index)=>{
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement(child, {
                    colGroupWidth: this.state.colGroupWidths[index]
                });
            });
            return childrenArray;
        };
    }
}
module.exports["default"] = $f7e5733ad19fb3c4$export$2e2bcd8739ae039;

});

parcelRegister("cCNNZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $8295e31785de4f76$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

function $8295e31785de4f76$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: "UnknownBlock",
        children: props.children
    });
}

});

parcelRegister("iCOwP", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $c789bfafac09dd18$export$32ec96484dd3ba39 = (0, $cgtv4.defineMessages)({
    unsupportedInlineContent: {
        id: "fabric.editor.unsupportedInlineContent",
        defaultMessage: "Unsupported content"
    },
    unsupportedBlockContent: {
        id: "fabric.editor.unsupportedBlockContent",
        defaultMessage: "This editor does not support displaying this content"
    },
    unsupportedContentTooltip: {
        id: "fabric.editor.unsupportedContentTooltip",
        defaultMessage: "Content is not available in this editor, this will be preserved when you edit and save"
    }
});
module.exports["unsupportedContentMessages"] = $c789bfafac09dd18$export$32ec96484dd3ba39;

});

parcelRegister("1QdLR", function(module, exports) {
function $0688bb6895de1706$export$d4ded51d0f0bd2df(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
message, prefix, node, intl) {
    const defaultLocale = 'en';
    let canTranslateToLocale = true;
    const locale = intl ? intl.locale : defaultLocale;
    let finalMessage = message.defaultMessage;
    if (node && locale.startsWith(defaultLocale)) {
        const { originalValue: originalValue } = node.attrs;
        if (originalValue.text || originalValue.attrs && originalValue.attrs.text) {
            finalMessage = originalValue.text ? originalValue.text : originalValue.attrs.text;
            canTranslateToLocale = false;
        } else if (originalValue.type) {
            finalMessage = `${prefix} ${originalValue.type}`;
            canTranslateToLocale = false;
        }
    }
    if (intl && canTranslateToLocale) return intl.formatMessage(message);
    return finalMessage;
}
module.exports["getUnsupportedContent"] = $0688bb6895de1706$export$d4ded51d0f0bd2df;

});

parcelRegister("fp8V7", function(module, exports) {
var $6610dd290dab91d5$export$ebeea2fe2e93862e = /*#__PURE__*/ function(ShadowKeys) {
    ShadowKeys["SHOW_LEFT_SHADOW"] = "showLeftShadow";
    ShadowKeys["SHOW_RIGHT_SHADOW"] = "showRightShadow";
    return ShadowKeys;
}({});
const $6610dd290dab91d5$export$1cbe0bb16052178d = {
    SENTINEL_LEFT: 'sentinel-left',
    SENTINEL_RIGHT: 'sentinel-right',
    SHADOW_CONTAINER: 'with-shadow-observer'
};
const $6610dd290dab91d5$var$requestIdleCallback = (fn)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return window.requestIdleCallback ? // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.requestIdleCallback(fn) : window.requestAnimationFrame(fn);
};
const $6610dd290dab91d5$var$cancelIdleCallback = (id)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return window.cancelIdleCallback ? // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.cancelIdleCallback(id) : window.cancelAnimationFrame(id);
};
class $6610dd290dab91d5$export$51a5b28e4fb2dba2 {
    dispose() {
        if (this.intersectionObserver) {
            this.intersectionObserver.disconnect();
            this.intersectionObserver = undefined;
            this.requestCallbackId && $6610dd290dab91d5$var$cancelIdleCallback(this.requestCallbackId);
        }
    }
    constructor({ scrollContainer: scrollContainer, onUpdateShadows: onUpdateShadows }){
        this.intersectionObserver = void 0;
        this.scrollContainer = void 0;
        this.onUpdateShadows = void 0;
        this.sentinels = {};
        this.requestCallbackId = void 0;
        this.shadowStates = {
            ["showLeftShadow"]: false,
            ["showRightShadow"]: false
        };
        this.init = ()=>{
            if (!this.scrollContainer || this.intersectionObserver) return;
            this.sentinels.right = document.createElement('div');
            this.sentinels.right.classList.add($6610dd290dab91d5$export$1cbe0bb16052178d.SENTINEL_RIGHT);
            this.scrollContainer.appendChild(this.sentinels.right);
            this.sentinels.left = document.createElement('div');
            this.sentinels.left.classList.add($6610dd290dab91d5$export$1cbe0bb16052178d.SENTINEL_LEFT);
            this.scrollContainer.prepend(this.sentinels.left);
            this.intersectionObserver = new IntersectionObserver((entries, _)=>{
                entries.forEach(this.onIntersect);
            }, {
                root: this.scrollContainer,
                rootMargin: '1px'
            });
            this.intersectionObserver.observe(this.sentinels.left);
            this.intersectionObserver.observe(this.sentinels.right);
        };
        this.onIntersect = (entry)=>{
            this.requestCallbackId = $6610dd290dab91d5$var$requestIdleCallback(()=>{
                if (entry.target.classList.contains($6610dd290dab91d5$export$1cbe0bb16052178d.SENTINEL_LEFT)) this.shadowStates["showLeftShadow"] = !entry.isIntersecting;
                if (entry.target.classList.contains($6610dd290dab91d5$export$1cbe0bb16052178d.SENTINEL_RIGHT)) this.shadowStates["showRightShadow"] = !entry.isIntersecting;
                this.onUpdateShadows(this.shadowStates);
            });
        };
        this.scrollContainer = scrollContainer;
        this.onUpdateShadows = onUpdateShadows;
        this.init();
    }
}
module.exports["shadowObserverClassNames"] = $6610dd290dab91d5$export$1cbe0bb16052178d;
module.exports["ShadowObserver"] = $6610dd290dab91d5$export$51a5b28e4fb2dba2;

});

parcelRegister("4BBKV", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6dGgK = parcelRequire("6dGgK");


var $aFUXX = parcelRequire("aFUXX");


var $bWRlG = parcelRequire("bWRlG");

function $194645e6da8b5697$export$b5ccf4d25d2c5af1(breakpoint) {
    switch(breakpoint){
        case 'M':
        case 'L':
            return 760;
        default:
            return 680;
    }
}
function $194645e6da8b5697$export$3de34996b814f0f0({ baseFontSize: baseFontSize, children: children }) {
    const memoizedTheme = (0, $42omo.useMemo)(()=>({
            baseFontSize: baseFontSize || 14,
            layoutMaxWidth: (0, $aFUXX.akEditorDefaultLayoutWidth)
        }), [
        baseFontSize
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6dGgK.a), {
        theme: memoizedTheme
    }, children);
}
function $194645e6da8b5697$export$a1a213d350ca51ca({ children: children, baseFontSize: baseFontSize }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bWRlG.WidthConsumer), null, ({ breakpoint: breakpoint })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($194645e6da8b5697$export$3de34996b814f0f0, {
            breakpoint: breakpoint,
            baseFontSize: baseFontSize
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children)));
}
module.exports["mapBreakpointToLayoutMaxWidth"] = $194645e6da8b5697$export$b5ccf4d25d2c5af1;
module.exports["BaseTheme"] = $194645e6da8b5697$export$a1a213d350ca51ca;

});

parcelRegister("jSHzw", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $e3kjM = parcelRequire("e3kjM");


var $21K7m = parcelRequire("21K7m");


var $lspPP = parcelRequire("lspPP");

const $83d34ca77d432476$var$initState = {
    isDrafting: false,
    draftId: undefined,
    draftMarkRef: undefined,
    draftActionResult: undefined,
    annotations: {},
    currentSelectedAnnotationId: undefined,
    currentSelectedMarkRef: undefined,
    currentHoveredAnnotationId: undefined
};
const $83d34ca77d432476$var$AnnotationManagerStateContext = /*#__PURE__*/ (0, $42omo.createContext)($83d34ca77d432476$var$initState);
const $83d34ca77d432476$var$AnnotationManagerDispatchContext = /*#__PURE__*/ (0, $42omo.createContext)({
    annotationManager: undefined,
    dispatch: ()=>{}
});
function $83d34ca77d432476$var$reducer(state, action) {
    switch(action.type){
        case 'reset':
            return {
                ...state,
                ...$83d34ca77d432476$var$initState
            };
        case 'loadAnnotation':
            {
                const currentIds = Object.keys(state.annotations);
                const uids = Array.from(new Set(currentIds.concat(action.data.map((a)=>a.id))));
                const updates = [];
                for (const id of uids){
                    const loadedAnnotation = action.data.find((a)=>a.id === id);
                    if (!loadedAnnotation && state.annotations[id]?.markState === (0, $e3kjM.AnnotationMarkStates).ACTIVE) {
                        // If the annotation is not in the loaded data, we need to remove it from the state. However,
                        // rather then removing it, we will set the mark state to resolved. This is to align it better with
                        // how the editor works.
                        updates.push({
                            id: id,
                            markState: (0, $e3kjM.AnnotationMarkStates).RESOLVED
                        });
                        continue;
                    }
                    if (!!loadedAnnotation?.markState && state.annotations[id]?.markState !== loadedAnnotation.markState) {
                        updates.push({
                            id: id,
                            markState: loadedAnnotation.markState
                        });
                        continue;
                    }
                }
                if (updates.length > 0) return {
                    ...state,
                    annotations: updates.reduce((nextAnnotations, update)=>{
                        return {
                            ...nextAnnotations,
                            [update.id]: {
                                ...nextAnnotations[update.id],
                                ...update
                            }
                        };
                    }, state.annotations)
                };
                return state;
            }
        case 'updateAnnotation':
            {
                const current = state.annotations[action.data.id];
                const { id: id, selected: selected, hovered: hovered, markState: markState = current?.markState } = action.data;
                const updates = [];
                // If the annotation is not currently in the state, we need to add it to the state.
                if (!current) updates.push({
                    id: id,
                    markState: markState ?? (0, $e3kjM.AnnotationMarkStates).ACTIVE
                });
                // The goal of the following is to enforce a single selection and a single hover state across all annotations.
                let nextSelectedId = state.currentSelectedAnnotationId;
                if (selected && nextSelectedId !== id) nextSelectedId = id;
                // If the annotation is currently selected and it's being unselected, we need to remove it from the
                // current selected annotation id.
                if (selected === false && nextSelectedId === id) nextSelectedId = undefined;
                let nextHoveredId = state.currentHoveredAnnotationId;
                if (hovered && nextHoveredId !== id) nextHoveredId = id;
                // If the annotation is currently hovered and it's being unhovered, we need to remove it from the
                // current hovered annotation id.
                if (hovered === false && nextHoveredId === id) nextHoveredId = undefined;
                // If the annotations mark state is not the same as the current mark state, we need to update it.
                if (current?.markState !== markState) {
                    updates.push({
                        id: id,
                        markState: markState ?? (0, $e3kjM.AnnotationMarkStates).ACTIVE
                    });
                    // If the annotation is currently selected and it's being resolved, then we need to remove it from the
                    // current selected annotation id also.
                    if (markState === (0, $e3kjM.AnnotationMarkStates).RESOLVED && nextSelectedId === id) nextSelectedId = undefined;
                }
                if (updates.length > 0 || nextSelectedId !== state.currentSelectedAnnotationId || nextHoveredId !== state.currentHoveredAnnotationId) return {
                    ...state,
                    currentSelectedAnnotationId: nextSelectedId,
                    currentHoveredAnnotationId: nextHoveredId,
                    annotations: updates.reduce((nextAnnotations, update)=>{
                        return {
                            ...nextAnnotations,
                            [update.id]: {
                                ...nextAnnotations[update.id],
                                ...update
                            }
                        };
                    }, state.annotations)
                };
                return state;
            }
        case 'resetSelectedAnnotation':
            if (state.currentSelectedAnnotationId !== undefined) return {
                ...state,
                currentSelectedAnnotationId: undefined,
                currentSelectedMarkRef: undefined
            };
            return state;
        case 'resetHoveredAnnotation':
            if (state.currentHoveredAnnotationId !== undefined) return {
                ...state,
                currentHoveredAnnotationId: undefined
            };
            return state;
        case 'setDrafting':
            if (state.isDrafting !== action.data.isDrafting || state.draftId !== action.data.draftId || state.draftActionResult !== action.data.draftActionResult) // XXX: When a draft is open the current selected annotation should no longer be selected. We need
            // to decide what is better UX,
            // 1 - do we want to deselct the selected annotation on draft open, if so then when draft is closed the s
            // selected annotation will not come back
            // 2 - do we want to still allow the selected annotation to be selected when draft is open, however the underlying
            // mark style just shows the annotation as not selected when a draft is active. Then when a draft closes
            // we can reopen the previous selected annotation.
            return {
                ...state,
                isDrafting: action.data.isDrafting,
                draftId: action.data.draftId,
                draftActionResult: action.data.draftActionResult
            };
            return state;
        case 'setDraftMarkRef':
            if (state.draftMarkRef !== action.data.draftMarkRef) return {
                ...state,
                draftMarkRef: action.data.draftMarkRef
            };
            return state;
        case 'setSelectedMarkRef':
            if (state.currentSelectedMarkRef !== action.data.markRef) return {
                ...state,
                currentSelectedMarkRef: action.data.markRef
            };
            return state;
    }
}
const $83d34ca77d432476$export$f21fb05766361bb3 = ({ children: children, annotationManager: annotationManager, updateSubscriber: updateSubscriber })=>{
    const [state, dispatch] = (0, $42omo.useReducer)($83d34ca77d432476$var$reducer, $83d34ca77d432476$var$initState);
    const actionContext = (0, $42omo.useContext)((0, $lspPP.RendererContext));
    (0, $42omo.useEffect)(()=>{
        const getDraft = ()=>{
            if (!state.isDrafting || !state.draftActionResult || !state.draftMarkRef || !state.draftId) return {
                success: false,
                reason: 'draft-not-started'
            };
            return {
                success: true,
                inlineNodeTypes: state.draftActionResult.inlineNodeTypes ?? [],
                targetElement: state.draftMarkRef,
                actionResult: {
                    step: state.draftActionResult.step,
                    doc: state.draftActionResult.doc,
                    inlineNodeTypes: state.draftActionResult.inlineNodeTypes,
                    targetNodeType: state.draftActionResult.targetNodeType,
                    originalSelection: state.draftActionResult.originalSelection,
                    numMatches: state.draftActionResult.numMatches,
                    matchIndex: state.draftActionResult.matchIndex,
                    pos: state.draftActionResult.pos
                }
            };
        };
        annotationManager?.hook('getDraft', getDraft);
        return ()=>{
            annotationManager?.unhook('getDraft', getDraft);
        };
    }, [
        annotationManager,
        state.draftId,
        state.isDrafting,
        state.draftMarkRef,
        state.draftActionResult
    ]);
    // We need to watch for the draft mark element to exist, so we can inform any listeners that the draft has been started
    // and give them a reference to the element
    (0, $42omo.useEffect)(()=>{
        if (state.isDrafting && state.draftId && state.draftMarkRef && state.draftActionResult) annotationManager?.emit({
            name: 'draftAnnotationStarted',
            data: {
                inlineNodeTypes: state.draftActionResult.inlineNodeTypes ?? [],
                targetElement: state.draftMarkRef,
                actionResult: {
                    step: state.draftActionResult.step,
                    doc: state.draftActionResult.doc,
                    inlineNodeTypes: state.draftActionResult.inlineNodeTypes,
                    targetNodeType: state.draftActionResult.targetNodeType,
                    originalSelection: state.draftActionResult.originalSelection,
                    numMatches: state.draftActionResult.numMatches,
                    matchIndex: state.draftActionResult.matchIndex,
                    pos: state.draftActionResult.pos
                }
            }
        });
    }, [
        annotationManager,
        state.draftId,
        state.isDrafting,
        state.draftMarkRef,
        state.draftActionResult
    ]);
    (0, $42omo.useEffect)(()=>{
        const setIsAnnotationSelected = (id, isSelected)=>{
            if (state.isDrafting) return {
                success: false,
                reason: 'draft-in-progress'
            };
            if (!state.annotations?.[id]) return {
                success: false,
                reason: 'id-not-valid'
            };
            // the annotation is currently not selected and is being selected
            if (id !== state.currentSelectedAnnotationId && isSelected) {
                dispatch({
                    type: 'updateAnnotation',
                    data: {
                        id: id,
                        selected: true
                    }
                });
                dispatch({
                    type: 'setSelectedMarkRef',
                    data: {
                        markRef: document.getElementById(id) || undefined
                    }
                });
            } else if (id === state.currentSelectedAnnotationId && !isSelected) dispatch({
                type: 'resetSelectedAnnotation'
            });
            return {
                success: true,
                isSelected: isSelected
            };
        };
        annotationManager?.hook('setIsAnnotationSelected', setIsAnnotationSelected);
        return ()=>{
            annotationManager?.unhook('setIsAnnotationSelected', setIsAnnotationSelected);
        };
    }, [
        annotationManager,
        state.isDrafting,
        state.annotations,
        state.currentSelectedAnnotationId,
        state.currentSelectedMarkRef
    ]);
    const prevSelectedAnnotationId = (0, $42omo.useRef)(undefined);
    (0, $42omo.useEffect)(()=>{
        if (prevSelectedAnnotationId.current) annotationManager?.emit({
            name: 'annotationSelectionChanged',
            data: {
                annotationId: prevSelectedAnnotationId.current,
                isSelected: false,
                inlineNodeTypes: []
            }
        });
        prevSelectedAnnotationId.current = state.currentSelectedAnnotationId;
    }, [
        state.currentSelectedAnnotationId,
        annotationManager
    ]);
    (0, $42omo.useEffect)(()=>{
        if (state.currentSelectedAnnotationId && state.currentSelectedMarkRef && state.currentSelectedMarkRef.id === state.currentSelectedAnnotationId) annotationManager?.emit({
            name: 'annotationSelectionChanged',
            data: {
                annotationId: state.currentSelectedAnnotationId,
                isSelected: true,
                inlineNodeTypes: []
            }
        });
    }, [
        annotationManager,
        state.currentSelectedAnnotationId,
        state.currentSelectedMarkRef
    ]);
    (0, $42omo.useEffect)(()=>{
        const setIsAnnotationHovered = (id, isHovered)=>{
            if (!state.annotations?.[id]) return {
                success: false,
                reason: 'id-not-valid'
            };
            dispatch({
                type: 'updateAnnotation',
                data: {
                    id: id,
                    hovered: isHovered
                }
            });
            return {
                success: true,
                isHovered: isHovered
            };
        };
        annotationManager?.hook('setIsAnnotationHovered', setIsAnnotationHovered);
        return ()=>{
            annotationManager?.unhook('setIsAnnotationHovered', setIsAnnotationHovered);
        };
    }, [
        annotationManager,
        state.annotations
    ]);
    (0, $42omo.useEffect)(()=>{
        const clearAnnotation = (id)=>{
            if (!state.annotations?.[id]) return {
                success: false,
                reason: 'id-not-valid'
            };
            const result = actionContext.deleteAnnotation(id, (0, $e3kjM.AnnotationTypes).INLINE_COMMENT);
            if (!result) return {
                success: false,
                reason: 'clear-failed'
            };
            const { step: step, doc: doc } = result;
            return {
                success: true,
                actionResult: {
                    step: step,
                    doc: doc
                }
            };
        };
        annotationManager?.hook('clearAnnotation', clearAnnotation);
        return ()=>{
            annotationManager?.unhook('clearAnnotation', clearAnnotation);
        };
    }, [
        annotationManager,
        state.annotations,
        actionContext
    ]);
    /**
	 * This is a temporary solution to ensure that the annotation manager state is in sync with the
	 * old updateSubscriber. The updateSubscriber will eventually be deprecated and the state will be managed
	 * by the annotation manager itself.
	 */ (0, $42omo.useEffect)(()=>{
        const onSetAnnotationState = (payload)=>{
            if (!payload) return;
            Object.values(payload).forEach((annotation)=>{
                if (annotation.id && annotation.annotationType === (0, $e3kjM.AnnotationTypes).INLINE_COMMENT) dispatch({
                    type: 'updateAnnotation',
                    data: {
                        id: annotation.id,
                        markState: annotation.state ?? undefined
                    }
                });
            });
        };
        const onAnnotationSelected = (payload)=>{
            dispatch({
                type: 'updateAnnotation',
                data: {
                    id: payload.annotationId,
                    selected: true
                }
            });
        };
        const onAnnotationHovered = (payload)=>{
            dispatch({
                type: 'updateAnnotation',
                data: {
                    id: payload.annotationId,
                    hovered: true
                }
            });
        };
        const onAnnotationSelectedRemoved = ()=>{
            dispatch({
                type: 'resetSelectedAnnotation'
            });
        };
        const onAnnotationHoveredRemoved = ()=>{
            dispatch({
                type: 'resetHoveredAnnotation'
            });
        };
        const onAnnotationClick = ({ annotationIds: annotationIds, eventTarget: eventTarget, eventTargetType: eventTargetType, viewMethod: viewMethod })=>{
            dispatch({
                type: 'updateAnnotation',
                data: {
                    id: annotationIds[0],
                    selected: true
                }
            });
            dispatch({
                type: 'setSelectedMarkRef',
                data: {
                    markRef: eventTarget
                }
            });
        };
        const onAnnotationDeselect = ()=>{
            dispatch({
                type: 'resetSelectedAnnotation'
            });
        };
        updateSubscriber?.on((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_STATE, onSetAnnotationState);
        updateSubscriber?.on((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, onAnnotationSelected);
        updateSubscriber?.on((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, onAnnotationHovered);
        updateSubscriber?.on((0, $21K7m.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, onAnnotationSelectedRemoved);
        updateSubscriber?.on((0, $21K7m.AnnotationUpdateEvent).REMOVE_ANNOTATION_HOVERED, onAnnotationHoveredRemoved);
        updateSubscriber?.on((0, $21K7m.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, onAnnotationClick);
        updateSubscriber?.on((0, $21K7m.AnnotationUpdateEvent).DESELECT_ANNOTATIONS, onAnnotationDeselect);
        return ()=>{
            updateSubscriber?.off((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_STATE, onSetAnnotationState);
            updateSubscriber?.off((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, onAnnotationSelected);
            updateSubscriber?.off((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, onAnnotationHovered);
            updateSubscriber?.off((0, $21K7m.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, onAnnotationSelectedRemoved);
            updateSubscriber?.off((0, $21K7m.AnnotationUpdateEvent).REMOVE_ANNOTATION_HOVERED, onAnnotationHoveredRemoved);
            updateSubscriber?.off((0, $21K7m.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, onAnnotationClick);
            updateSubscriber?.off((0, $21K7m.AnnotationUpdateEvent).DESELECT_ANNOTATIONS, onAnnotationDeselect);
        };
    }, [
        updateSubscriber
    ]);
    const dispatchData = (0, $42omo.useMemo)(()=>({
            annotationManager: annotationManager,
            dispatch: dispatch
        }), [
        annotationManager,
        dispatch
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($83d34ca77d432476$var$AnnotationManagerStateContext.Provider, {
        value: state,
        children: /*#__PURE__*/ (0, $l998X.jsx)($83d34ca77d432476$var$AnnotationManagerDispatchContext.Provider, {
            value: dispatchData,
            children: children
        })
    });
};
const $83d34ca77d432476$export$654a1fb45487f838 = ()=>{
    return (0, $42omo.useContext)($83d34ca77d432476$var$AnnotationManagerStateContext);
};
const $83d34ca77d432476$export$12cbbb89fb7702d0 = ()=>{
    return (0, $42omo.useContext)($83d34ca77d432476$var$AnnotationManagerDispatchContext);
};
module.exports["AnnotationManagerProvider"] = $83d34ca77d432476$export$f21fb05766361bb3;
module.exports["useAnnotationManagerState"] = $83d34ca77d432476$export$654a1fb45487f838;
module.exports["useAnnotationManagerDispatch"] = $83d34ca77d432476$export$12cbbb89fb7702d0;

});

parcelRegister("jZG1P", function(module, exports) {
const $5f034ae8d7da98e3$export$15d6ddc168d35719 = ({ from: from, to: to })=>{
    return {
        ['data-annotation-draft-mark']: true,
        ['data-draft-start-at']: from,
        ['data-draft-end-at']: to
    };
};
const $5f034ae8d7da98e3$var$buildDataAttributesQuery = (pos)=>{
    const a = $5f034ae8d7da98e3$export$15d6ddc168d35719(pos);
    return Object.entries(a).map(([k, v])=>`[${k}="${v}"]`).join('');
};
const $5f034ae8d7da98e3$export$e14699d956e87e73 = (pos)=>{
    const sel = window.getSelection();
    if (!sel) return false;
    const draftNodes = document.querySelectorAll($5f034ae8d7da98e3$var$buildDataAttributesQuery(pos));
    if (!draftNodes || draftNodes.length === 0) return false;
    sel.removeAllRanges();
    const range = document.createRange();
    range.setStart(draftNodes[0], 0);
    range.setEndAfter(draftNodes[draftNodes.length - 1]);
    sel.addRange(range);
    return true;
};
module.exports["dataAttributes"] = $5f034ae8d7da98e3$export$15d6ddc168d35719;
module.exports["updateWindowSelectionAroundDraft"] = $5f034ae8d7da98e3$export$e14699d956e87e73;

});

parcelRegister("djzd2", function(module, exports) {

var $bYZ53 = parcelRequire("bYZ53");


var $dh538 = parcelRequire("dh538");

function $981298672e79c67e$export$b0ea72d31617ccea({ actions: actions, pos: pos }) {
    if (!(0, $dh538.fg)('editor_inline_comments_on_inline_nodes')) return undefined;
    const { doc: doc } = actions;
    if (!pos || !doc) return undefined;
    const inlineNodeNames = (0, $bYZ53.getRangeInlineNodeNames)({
        doc: doc,
        pos: pos
    });
    return inlineNodeNames;
}
function $981298672e79c67e$export$1726c23d64498b6({ actions: actions, pos: pos }) {
    if (!(0, $dh538.fg)('cc_comments_log_draft_annotation_ancestor_nodes')) return undefined;
    const { doc: doc } = actions;
    if (!pos || !doc) return undefined;
    const ancestorNodeNames = (0, $bYZ53.getRangeAncestorNodeNames)({
        doc: doc,
        pos: pos
    });
    return ancestorNodeNames;
}
module.exports["getRendererRangeInlineNodeNames"] = $981298672e79c67e$export$b0ea72d31617ccea;
module.exports["getRendererRangeAncestorNodeNames"] = $981298672e79c67e$export$1726c23d64498b6;

});

parcelRegister("3kBFe", function(module, exports) {
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $cgtv4 = parcelRequire("cgtv4");

const $ff40fa5e20831b0c$export$74bada844422036d = (0, $cgtv4.defineMessages)({
    copyHeadingLinkToClipboard: {
        id: "fabric.editor.headingLink.copyAnchorLink",
        defaultMessage: "Copy link to heading"
    },
    copiedHeadingLinkToClipboard: {
        id: "fabric.editor.headingLink.copied",
        defaultMessage: "Copied!"
    },
    failedToCopyHeadingLink: {
        id: "fabric.editor.headingLink.failedToCopy",
        defaultMessage: "Copy failed"
    },
    copyAriaLabel: {
        id: "fabric.editor.headingLink.copyAriaLabel",
        defaultMessage: "Copy"
    }
});
const $ff40fa5e20831b0c$export$c79ebc36348824d1 = (0, $cgtv4.defineMessages)({
    noneSortingLabel: {
        id: "fabric.editor.headingLink.noneSortingLabel",
        defaultMessage: "none"
    },
    ascSortingLabel: {
        id: "fabric.editor.headingLink.ascSortingLabel",
        defaultMessage: "ascending"
    },
    descSortingLabel: {
        id: "fabric.editor.headingLink.descSortingLabel",
        defaultMessage: "descending"
    }
});
const $ff40fa5e20831b0c$export$9f52c375a6ef34fc = (0, $cgtv4.defineMessages)({
    contentRendererInlineCommentMarkerStart: {
        id: "fabric.editor.inlineComment.marker.start",
        defaultMessage: "inline comment start"
    },
    contentRendererInlineCommentMarkerEnd: {
        id: "fabric.editor.inlineComment.marker.end",
        defaultMessage: "inline comment end"
    }
});
module.exports["headingAnchorLinkMessages"] = $ff40fa5e20831b0c$export$74bada844422036d;
module.exports["tableCellMessages"] = $ff40fa5e20831b0c$export$c79ebc36348824d1;
module.exports["inlineCommentMessages"] = $ff40fa5e20831b0c$export$9f52c375a6ef34fc;

});

parcelRegister("1lzbj", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $21K7m = parcelRequire("21K7m");


var $e3kjM = parcelRequire("e3kjM");


var $d925B = parcelRequire("d925B");


var $k7eoe = parcelRequire("k7eoe");


var $jSHzw = parcelRequire("jSHzw");

const $bf54d68c492d222f$export$95f9f9045e92d283 = ({ type: type, updateSubscriber: updateSubscriber })=>{
    const [states, setStates] = (0, $42omo.useState)({});
    const { annotationManager: annotationManager, dispatch: dispatch } = (0, $jSHzw.useAnnotationManagerDispatch)();
    const { annotations: annotations } = (0, $jSHzw.useAnnotationManagerState)();
    const isAnnotationManagerEnabled = !!annotationManager;
    (0, $42omo.useLayoutEffect)(()=>{
        if (!updateSubscriber) return;
        const cb = (payload)=>{
            if (!payload) return;
            const nextStates = Object.values(payload).reduce((acc, curr)=>{
                if (curr.id && curr.annotationType === type) {
                    // Check for empty state to prevent additional renders
                    const isEmpty = curr.state === null || curr.state === undefined;
                    return {
                        ...acc,
                        [curr.id]: !isEmpty ? curr.state : states[curr.id]
                    };
                }
                return acc;
            }, {});
            setStates({
                ...states,
                ...nextStates
            });
        };
        if (!isAnnotationManagerEnabled) {
            updateSubscriber.on((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_STATE, cb);
            return ()=>{
                updateSubscriber.off((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_STATE, cb);
            };
        }
    }, [
        states,
        type,
        updateSubscriber,
        dispatch,
        isAnnotationManagerEnabled
    ]);
    const annotationMarkStates = (0, $42omo.useMemo)(()=>{
        return Object.values(annotations).reduce((acc, curr)=>{
            return {
                ...acc,
                [curr.id]: curr.markState
            };
        }, {});
    }, [
        annotations
    ]);
    if (isAnnotationManagerEnabled) return annotationMarkStates;
    else return states;
};
const $bf54d68c492d222f$export$48f5d7f6702be07c = ({ id: id, updateSubscriber: updateSubscriber })=>{
    const [hasFocus, setHasFocus] = (0, $42omo.useState)(false);
    const [isHovered, setIsHovered] = (0, $42omo.useState)(false);
    const { currentSelectedAnnotationId: currentSelectedAnnotationId, currentHoveredAnnotationId: currentHoveredAnnotationId } = (0, $jSHzw.useAnnotationManagerState)();
    const { annotationManager: annotationManager } = (0, $jSHzw.useAnnotationManagerDispatch)();
    const isAnnotationManagerEnabled = !!annotationManager;
    (0, $42omo.useLayoutEffect)(()=>{
        if (!updateSubscriber) return;
        const cb = (payload)=>{
            setHasFocus(payload && payload.annotationId === id);
        };
        const callbackForHoveredAnnotation = (payload)=>{
            setIsHovered(payload && payload.annotationId === id);
        };
        const removeFocus = ()=>{
            setHasFocus(false);
        };
        const removeHoverEffect = ()=>{
            setIsHovered(false);
        };
        if (!isAnnotationManagerEnabled) {
            updateSubscriber.on((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, cb);
            updateSubscriber.on((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, callbackForHoveredAnnotation);
            updateSubscriber.on((0, $21K7m.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, removeFocus);
            updateSubscriber.on((0, $21K7m.AnnotationUpdateEvent).REMOVE_ANNOTATION_HOVERED, removeHoverEffect);
            return ()=>{
                updateSubscriber.off((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, cb);
                updateSubscriber.off((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, callbackForHoveredAnnotation);
                updateSubscriber.off((0, $21K7m.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, removeFocus);
                updateSubscriber.off((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, removeHoverEffect);
            };
        }
    }, [
        id,
        updateSubscriber,
        isAnnotationManagerEnabled
    ]);
    if (isAnnotationManagerEnabled) return {
        hasFocus: currentSelectedAnnotationId === id,
        isHovered: currentHoveredAnnotationId === id
    };
    else return {
        hasFocus: hasFocus,
        isHovered: isHovered
    };
};
const $bf54d68c492d222f$var$NO_ANNOTATION_SELECTED = {
    annotations: [],
    clickElementTarget: undefined
};
const $bf54d68c492d222f$export$26cf539704e444c1 = (props)=>{
    const [annotationClickEvent, setAnnotationClickEvent] = (0, $42omo.useState)(null);
    const { updateSubscriber: updateSubscriber, createAnalyticsEvent: createAnalyticsEvent, isNestedRender: isNestedRender } = props;
    const { annotationManager: annotationManager } = (0, $jSHzw.useAnnotationManagerDispatch)();
    const isAnnotationManagerEnabled = !!annotationManager;
    const { currentSelectedAnnotationId: currentSelectedAnnotationId, currentSelectedMarkRef: currentSelectedMarkRef } = (0, $jSHzw.useAnnotationManagerState)();
    const selectedAnnotation = (0, $42omo.useMemo)(()=>{
        return currentSelectedAnnotationId && currentSelectedMarkRef && currentSelectedMarkRef.id === currentSelectedAnnotationId ? {
            annotations: [
                {
                    id: currentSelectedAnnotationId,
                    type: (0, $e3kjM.AnnotationTypes).INLINE_COMMENT
                }
            ],
            clickElementTarget: currentSelectedMarkRef
        } : // When creating a new annotation, currentSelectedAnnotationId and currentSelectedMarkRef will be set one after another,
        // if this isn't a const, it will cause useMemo to return two different "empty" objects and causes infinite re-renders.
        $bf54d68c492d222f$var$NO_ANNOTATION_SELECTED;
    }, [
        currentSelectedAnnotationId,
        currentSelectedMarkRef
    ]);
    (0, $42omo.useLayoutEffect)(()=>{
        if (!updateSubscriber || isNestedRender) return;
        const clickCb = ({ annotationIds: annotationIds, eventTarget: eventTarget, eventTargetType: eventTargetType, viewMethod: viewMethod })=>{
            const annotationsByType = annotationIds.filter((id)=>!!id).map((id)=>({
                    id: id,
                    type: (0, $e3kjM.AnnotationTypes).INLINE_COMMENT
                }));
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $d925B.ACTION).VIEWED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                attributes: {
                    overlap: annotationsByType.length || 0,
                    targetNodeType: eventTargetType,
                    method: viewMethod
                }
            }).fire((0, $k7eoe.FabricChannel).editor);
            setAnnotationClickEvent({
                annotations: annotationsByType,
                clickElementTarget: eventTarget
            });
        };
        const deselectCb = ()=>{
            setAnnotationClickEvent({
                annotations: [],
                clickElementTarget: undefined
            });
        };
        if (!isAnnotationManagerEnabled) {
            updateSubscriber.on((0, $21K7m.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, clickCb);
            updateSubscriber.on((0, $21K7m.AnnotationUpdateEvent).DESELECT_ANNOTATIONS, deselectCb);
            return ()=>{
                updateSubscriber.off((0, $21K7m.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, clickCb);
                updateSubscriber.off((0, $21K7m.AnnotationUpdateEvent).DESELECT_ANNOTATIONS, deselectCb);
            };
        }
    }, [
        updateSubscriber,
        createAnalyticsEvent,
        isNestedRender,
        isAnnotationManagerEnabled
    ]);
    if (isAnnotationManagerEnabled) return isNestedRender ? null : selectedAnnotation;
    else return annotationClickEvent;
};
module.exports["useAnnotationStateByTypeEvent"] = $bf54d68c492d222f$export$95f9f9045e92d283;
module.exports["useHasFocusEvent"] = $bf54d68c492d222f$export$48f5d7f6702be07c;
module.exports["useAnnotationClickEvent"] = $bf54d68c492d222f$export$26cf539704e444c1;

});

parcelRegister("IcpgS", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $fcecf936ee660f14$export$6a26b015ac619737 = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $fcecf936ee660f14$export$aafe46a36ef535ba = /*#__PURE__*/ (0, $42omo.createContext)({});
module.exports["ProvidersContext"] = $fcecf936ee660f14$export$6a26b015ac619737;
module.exports["InlineCommentsStateContext"] = $fcecf936ee660f14$export$aafe46a36ef535ba;

});

parcelRegister("uvNb9", function(module, exports) {
class $2c5766e42a4da15d$export$145273558d58e0ac extends Error {
    constructor(message, type){
        super(message), this.message = message, this.type = type;
        this.name = 'AuthError';
        this.type = type;
        this.message = message;
    }
}
module.exports["AuthError"] = $2c5766e42a4da15d$export$145273558d58e0ac;

});

parcelRegister("1Qaul", function(module, exports) {

var $1A9t2 = parcelRequire("1A9t2");

function $c1722af477a6914e$export$1daf15cbaf649dad(adfDocument) {
    return (0, $1A9t2.reduce)(adfDocument, (acc, node)=>{
        acc[node.type] = (acc[node.type] || 0) + 1;
        return acc;
    }, {});
}
module.exports["countNodes"] = $c1722af477a6914e$export$1daf15cbaf649dad;

});

parcelRegister("kPuBV", function(module, exports) {
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");

const $b1b93f863d38edeb$export$c5c1e4f4640336fb = ({ leftCoverWidth: leftCoverWidth, rightCoverWidth: rightCoverWidth })=>{
    const width = "var(--ds-space-100, 8px)";
    const leftCoverWidthResolved = leftCoverWidth || width;
    const rightCoverWidthResolved = rightCoverWidth || width;
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    return /*#__PURE__*/ (0, $9K4OG.css)();
};
module.exports["overflowShadow"] = $b1b93f863d38edeb$export$c5c1e4f4640336fb;

});

parcelRegister("kckFS", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1e2E5 = parcelRequire("1e2E5");

const $f91595f582fbd74b$export$c7ef921528e1d279 = '<IntlProvider> needs to exist in the component ancestry';
const $f91595f582fbd74b$var$isMissingIntlProviderInAncestryError = (err)=>err?.toString()?.includes('<IntlProvider> needs to exist in the component ancestry');
class $f91595f582fbd74b$export$7df0749115d18d19 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    componentDidCatch(error, errorInfo) {
        // if missing IntlProvider in ancestry, we setup a fallback IntlProvider ourselves
        if ($f91595f582fbd74b$var$isMissingIntlProviderInAncestryError(error)) this.setState({
            missingIntlProviderInAncestry: true
        });
        else // else we re-propagate the non-react-intl-next error
        throw error;
    }
    render() {
        if (this.state.missingIntlProviderInAncestry) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1e2E5.default), {
            locale: "en"
        }, this.props.children);
        return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.state = {
            missingIntlProviderInAncestry: false
        };
    }
}
module.exports["IntlErrorBoundary"] = $f91595f582fbd74b$export$7df0749115d18d19;

});

parcelRegister("1LHXq", function(module, exports) {

var $6jPem = parcelRequire("6jPem");

const $509946b00b1dc655$export$6528700f3fa2fe2a = (adf)=>{
    let isTransformed = false;
    const transformedAdf = (0, $6jPem.traverse)(adf, {
        mediaSingle: (node)=>{
            if (!node.marks || !node.content || node.content[0]?.type !== 'media') return node;
            let linkMark = null;
            node.marks.forEach((mark, i)=>{
                if (mark.type === 'link') {
                    linkMark = mark;
                    node.marks?.splice(i, 1);
                    isTransformed = true;
                }
            });
            if (node.marks.length === 0) delete node.marks;
            if (linkMark) {
                const mediaNode = node.content[0];
                // only add link mark if media node doesnt already have one
                if (mediaNode.marks?.every((mark)=>mark.type !== 'link')) mediaNode.marks.push(linkMark);
                else if (!mediaNode.marks) mediaNode.marks = [
                    linkMark
                ];
            }
            return node;
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};
module.exports["transformMediaLinkMarks"] = $509946b00b1dc655$export$6528700f3fa2fe2a;

});

parcelRegister("9HtP4", function(module, exports) {
$parcel$export(module.exports, "default", () => $1e1d16a2959b92a8$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

function $1e1d16a2959b92a8$export$2e2bcd8739ae039(callback) {
    const hasRun = (0, $42omo.useRef)(false);
    if (!hasRun.current) {
        callback();
        hasRun.current = true;
    }
}

});

parcelRegister("2oRGU", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jSnXV = parcelRequire("jSnXV");


var $d925B = parcelRequire("d925B");


var $h9Yad = parcelRequire("h9Yad");

function $7292b2eba851ae1a$export$fe16de086fea1f5f(props) {
    const debouncedHandleAnalyticsEvent = (0, $42omo.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(props.handleAnalyticsEvent, 500), [
        props.handleAnalyticsEvent
    ]);
    (0, $h9Yad.useComponentRenderTracking)({
        onRender: ({ renderCount: renderCount, propsDifference: propsDifference })=>{
            if (!renderCount) return;
            debouncedHandleAnalyticsEvent({
                payload: {
                    action: props.action,
                    actionSubject: props.actionSubject,
                    attributes: {
                        count: renderCount,
                        propsDifference: propsDifference
                    },
                    eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
                }
            });
        },
        propsDiffingOptions: {
            enabled: true,
            props: props.componentProps,
            propsToIgnore: props.propsToIgnore,
            useShallow: props.useShallow
        },
        zeroBasedCount: true
    });
    return null;
}
module.exports["RenderTracking"] = $7292b2eba851ae1a$export$fe16de086fea1f5f;

});

parcelRegister("jQdRj", function(module, exports) {
function $e71d9fbdb75d4701$export$daf54fed04c8fb77(nodes, supportedMarks) {
    const nodeNames = Object.keys(nodes);
    nodeNames.forEach((nodeKey)=>{
        const nodeSpec = {
            ...nodes[nodeKey]
        };
        if (nodeSpec.marks && nodeSpec.marks !== '_') nodeSpec.marks = nodeSpec.marks.split(' ').filter((mark)=>!!supportedMarks[mark]).join(' ');
        if (nodeSpec.content) nodeSpec.content = $e71d9fbdb75d4701$var$sanitizeNodeSpecContent(nodes, nodeSpec.content);
        nodes[nodeKey] = nodeSpec;
    });
    return nodes;
}
function $e71d9fbdb75d4701$var$sanitizeNodeSpecContent(nodes, rawContent) {
    const content = rawContent.replace(/\W/g, ' ');
    const contentKeys = content.split(' ');
    const unsupportedContentKeys = contentKeys.filter((contentKey)=>!$e71d9fbdb75d4701$var$isContentSupported(nodes, contentKey));
    return unsupportedContentKeys.reduce((newContent, nodeName)=>$e71d9fbdb75d4701$var$sanitizedContent(newContent, nodeName), rawContent);
}
function $e71d9fbdb75d4701$var$sanitizedContent(content, invalidContent) {
    if (!invalidContent.length) return content || '';
    if (!content || !content.match(/\w/)) return '';
    const pattern = `(${invalidContent}((\\s)*\\|)+)|((\\|(\\s)*)+${invalidContent}(\\+|\\*)?)|(${invalidContent}$)|(${invalidContent}(\\+|\\*))`;
    return content.replace(new RegExp(pattern, 'g'), '').replace('  ', ' ').trim();
}
function $e71d9fbdb75d4701$var$isContentSupported(nodes, contentKey) {
    const nodeKeys = Object.keys(nodes);
    // content is with valid node
    if (nodeKeys.indexOf(contentKey) > -1) return true;
    // content is with valid group
    for(const supportedKey in nodes){
        const nodeSpec = nodes[supportedKey];
        if (nodeSpec && nodeSpec.group === contentKey) return true;
    }
    return false;
}
module.exports["sanitizeNodes"] = $e71d9fbdb75d4701$export$daf54fed04c8fb77;

});

parcelRegister("iScNA", function(module, exports) {
$parcel$export(module.exports, "default", () => $72ae74dae40b2182$export$2e2bcd8739ae039);

var $80xRs = parcelRequire("80xRs");

const $72ae74dae40b2182$var$flatten = (arr)=>[].concat(...arr);
var /**
 * Allow to run methods from the given provider interface across all providers seamlessly.
 * Handles promise racing and discards rejected promises safely.
 */ $72ae74dae40b2182$export$2e2bcd8739ae039 = (providers)=>{
    if (providers.length === 0) throw new Error('At least one provider must be provided');
    const getFulfilledProviders = async ()=>{
        const results = await (0, $80xRs.waitForAllPromises)(providers.map((result)=>Promise.resolve(result)));
        return (0, $80xRs.getOnlyFulfilled)(results);
    };
    const runInAllProviders = async (mapFunction)=>{
        return (await getFulfilledProviders()).map((provider)=>mapFunction(provider));
    };
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const createCallback = (methodName, args)=>(provider)=>{
            const method = provider[methodName];
            if (typeof method === 'function') return method.apply(provider, args);
            throw new Error(`"${String(methodName)}" isn't a function of the provider`);
        };
    /**
	 * Run a method from the provider which expects to return a single item
	 * @param methodName
	 * @param args
	 */ // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const invokeSingle = async (methodName, args)=>{
        const callback = createCallback(methodName, args);
        return (0, $80xRs.waitForFirstFulfilledPromise)(await runInAllProviders(callback));
    };
    /**
	 * Run a method in the provider which expectes to return a list of items
	 * @param methodName
	 * @param args
	 */ // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const invokeList = async (methodName, args)=>{
        const callback = createCallback(methodName, args);
        const results = await (0, $80xRs.waitForAllPromises)(await runInAllProviders(callback));
        const fulfilledResults = (0, $80xRs.getOnlyFulfilled)(results);
        return $72ae74dae40b2182$var$flatten(fulfilledResults).filter((result)=>result);
    };
    return {
        invokeSingle: invokeSingle,
        invokeList: invokeList
    };
};

});

parcelRegister("jTtEd", function(module, exports) {

var $aFUXX = parcelRequire("aFUXX");


var $1oCLl = parcelRequire("1oCLl");

function $8e2fd2af7fc541b0$export$8e2864079bc476bd(appearance, contentMode) {
    if ((0, $1oCLl.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test')) {
        if (contentMode === ((0, $1oCLl.expValEquals)('confluence_content_mode_replace_dense_with_compact', 'cohort', 'test') ? 'compact' : 'dense')) return 0, $aFUXX.akEditorFullPageDenseFontSize;
    }
    if (appearance === undefined) return 0, $aFUXX.akEditorFullPageDefaultFontSize;
    return ![
        'comment',
        'chromeless'
    ].includes(appearance) ? (0, $aFUXX.akEditorFullPageDefaultFontSize) : undefined;
}
module.exports["getBaseFontSize"] = $8e2fd2af7fc541b0$export$8e2864079bc476bd;

});

parcelRegister("uq7dM", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");

const $b70de66aa381d38d$var$pulseBackground = (0, $9K4OG.keyframes)({
    '50%': {
        backgroundColor: "var(--ds-blanket-danger, #EF5C4814)"
    }
});
const $b70de66aa381d38d$var$pulseBackgroundReverse = (0, $9K4OG.keyframes)({
    '0%': {
        backgroundColor: "var(--ds-blanket-danger, #EF5C4814)"
    },
    '50%': {
        backgroundColor: 'auto'
    },
    '100%': {
        backgroundColor: "var(--ds-blanket-danger, #EF5C4814)"
    }
});
const $b70de66aa381d38d$var$flashWrapper = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.-flash > div': {
        animationName: $b70de66aa381d38d$var$pulseBackgroundReverse,
        animationDuration: '0.25s',
        animationTimingFunction: 'ease-in-out'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > div': {
        animation: "'none'"
    }
});
const $b70de66aa381d38d$var$flashWrapperAnimated = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`${$b70de66aa381d38d$var$flashWrapper} & > div`]: {
        animationName: $b70de66aa381d38d$var$pulseBackground,
        animationDuration: '0.25s',
        animationTimingFunction: 'ease-in-out'
    }
});
class $b70de66aa381d38d$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    render() {
        const { animate: animate, children: children } = this.props;
        this.toggle = animate && !this.toggle;
        return(// eslint-disable-next-line @atlaskit/design-system/prefer-primitives
        /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            css: animate ? $b70de66aa381d38d$var$flashWrapperAnimated : $b70de66aa381d38d$var$flashWrapper,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: this.toggle ? '-flash' : ''
        }, children));
    }
    constructor(...args){
        super(...args);
        this.toggle = false;
    }
}
module.exports["default"] = $b70de66aa381d38d$export$2e2bcd8739ae039;

});

parcelRegister("8dgvm", function(module, exports) {
$parcel$export(module.exports, "MODE", () => (parcelRequire("dXZzO")).MODE);

var $dXZzO = parcelRequire("dXZzO");

const $5fac572772fbabda$var$DEFAULT_CROSS_ORIGIN = undefined;
const $5fac572772fbabda$var$DEFAULT_MANIFEST = {
    publicPath: '/',
    assets: {}
};
const $5fac572772fbabda$var$DEFAULT_MODE = (0, $dXZzO.MODE).HYDRATE;
const $5fac572772fbabda$var$DEFAULT_RETRY = 2;
const $5fac572772fbabda$var$config = {
    crossOrigin: $5fac572772fbabda$var$DEFAULT_CROSS_ORIGIN,
    manifest: $5fac572772fbabda$var$DEFAULT_MANIFEST,
    mode: $5fac572772fbabda$var$DEFAULT_MODE,
    retry: $5fac572772fbabda$var$DEFAULT_RETRY
};
const $5fac572772fbabda$export$44487a86467333c3 = ()=>$5fac572772fbabda$var$config;
const $5fac572772fbabda$export$940a7873bb071df8 = (nextConfig)=>{
    var _nextConfig$crossOrig, _nextConfig$manifest, _nextConfig$mode, _nextConfig$retry;
    $5fac572772fbabda$var$config.crossOrigin = (_nextConfig$crossOrig = nextConfig.crossOrigin) != null ? _nextConfig$crossOrig : $5fac572772fbabda$var$DEFAULT_CROSS_ORIGIN;
    $5fac572772fbabda$var$config.manifest = (_nextConfig$manifest = nextConfig.manifest) != null ? _nextConfig$manifest : $5fac572772fbabda$var$DEFAULT_MANIFEST;
    $5fac572772fbabda$var$config.mode = (_nextConfig$mode = nextConfig.mode) != null ? _nextConfig$mode : $5fac572772fbabda$var$DEFAULT_MODE;
    $5fac572772fbabda$var$config.retry = (_nextConfig$retry = nextConfig.retry) != null ? _nextConfig$retry : $5fac572772fbabda$var$DEFAULT_RETRY;
};
module.exports["getConfig"] = $5fac572772fbabda$export$44487a86467333c3;
module.exports["setConfig"] = $5fac572772fbabda$export$940a7873bb071df8;

});

parcelRegister("lhchg", function(module, exports) {

var $8dgvm = parcelRequire("8dgvm");
var $dXZzO = parcelRequire("dXZzO");


var $euF6Z = parcelRequire("euF6Z");

const $612c3fc5c2a28c4f$export$c42217d53a7ebafb = (fromEl, id)=>{
    const fragment = document.createElement('div');
    let el = fromEl;
    while(el = el.nextSibling){
        if (el.dataset && el.dataset.lazyEnd === id) break;
        // cloneNode is 50% faster than outerHTML/textContent
        fragment.appendChild(el.cloneNode(true));
    }
    return Array.from(fragment.childNodes);
};


const $267b431587227d50$export$c69443129766a7fc = (fromEl, id)=>{
    const result = [];
    let el = fromEl;
    while(el = el.nextSibling){
        if (el.dataset && el.dataset.lazyEnd === id) break;
        result.push(el);
    }
    return result;
};


const $5f0e6c234ea4c71a$export$bb44f104e3c54dae = ()=>{
    const markers = document.querySelectorAll('input[data-lazy-begin]');
    const { mode: mode } = (0, $8dgvm.getConfig)();
    for(let i = 0, j = markers.length; i < j; i += 1){
        const el = markers[i];
        const { lazyBegin: lazyBegin } = el.dataset || {};
        const value = mode === (0, $dXZzO.MODE).RENDER ? (0, $612c3fc5c2a28c4f$export$c42217d53a7ebafb)(markers[i], lazyBegin) : (0, $267b431587227d50$export$c69443129766a7fc)(markers[i], lazyBegin);
        if ((0, $euF6Z.COLLECTED).has(lazyBegin)) (0, $euF6Z.COLLECTED).get(lazyBegin).push(value);
        else (0, $euF6Z.COLLECTED).set(lazyBegin, [
            value
        ]);
    }
};





parcelRequire("ecrVx");
var $4CMiD = parcelRequire("4CMiD");
var $6y0vU = parcelRequire("6y0vU");


var $27zaj = parcelRequire("27zaj");

const $f7d4b5876658b264$export$33c5f161e1d4706 = {
    init: (config)=>{
        (0, $8dgvm.setConfig)(config);
        (0, $4CMiD.LISTENERS).length = 0;
        (0, $6y0vU.setCurrent)(0);
        if (!(0, $27zaj.isNodeEnvironment)()) (0, $5f0e6c234ea4c71a$export$bb44f104e3c54dae)();
    }
};

});

parcelRegister("96msn", function(module, exports) {

var $aQIfl = parcelRequire("aQIfl");


var $8dgvm = parcelRequire("8dgvm");


var $euF6Z = parcelRequire("euF6Z");


var $27zaj = parcelRequire("27zaj");
var $7zmsS = parcelRequire("7zmsS");


var $k001K = parcelRequire("k001K");


var $42omo = parcelRequire("42omo");


var $dXZzO = parcelRequire("dXZzO");




parcelRequire("1BwGq");
var $9uVEz = parcelRequire("9uVEz");

parcelRequire("ecrVx");
var $6y0vU = parcelRequire("6y0vU");

parcelRequire("eow39");
var $h5RZ7 = parcelRequire("h5RZ7");





var $fLvpO = parcelRequire("fLvpO");




function $67fe80fcd34326f0$var$isLinkPrefetch(el) {
    return el.tagName === 'LINK' && el.rel === 'prefetch';
}
const $67fe80fcd34326f0$var$usePlaceholderRender = (resolveId, content)=>{
    const hydrationRef = (0, $42omo.useRef)(null);
    const { current: ssrDomNodes } = (0, $42omo.useRef)(content || []);
    (0, $42omo.useLayoutEffect)(()=>{
        const element = hydrationRef.current;
        const { parentNode: parentNode } = element || {};
        if (parentNode && !parentNode.contains(ssrDomNodes[0])) ssrDomNodes.reverse().forEach((node)=>{
            // this fixes an issue with Chrome that re-triggers and cancels prefetch
            // when node is appended again, making network panel quite noisy
            if ($67fe80fcd34326f0$var$isLinkPrefetch(node)) node.rel = '';
            parentNode.insertBefore(node, element.nextSibling);
        });
        return ()=>{
            ssrDomNodes.forEach((node)=>{
                var _node$parentNode;
                return (_node$parentNode = node.parentNode) == null ? void 0 : _node$parentNode.removeChild(node);
            });
        };
    // [hydrationRef.current, ssrDomNodes] are expected to be stable
    // with the second one never changing by design and the first one changing after first render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return hydrationRef;
};
const $67fe80fcd34326f0$export$d55db778a3e1446b = ({ id: id, content: content })=>{
    const placeholderRef = $67fe80fcd34326f0$var$usePlaceholderRender(id, content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("input", {
        type: "hidden",
        "data-lazy-begin": id,
        ref: placeholderRef
    });
};








function $b1695c2d5acdcbdf$var$_extends() {
    $b1695c2d5acdcbdf$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b1695c2d5acdcbdf$var$_extends.apply(this, arguments);
}
const $b1695c2d5acdcbdf$export$ca5b8fbc835d95e4 = ({ id: id, content: content })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("input", {
        type: "hidden",
        "data-lazy-begin": id
    }), content.map((el, i)=>{
        const { tagName: tagName = '', childNodes: childNodes = [], attributes: attributes = [] } = el;
        const props = Array.from(attributes).reduce((0, $27zaj.attrToProp), {
            key: String(i)
        });
        // text node
        if (!tagName) return /*#__PURE__*/ (0, $42omo.createElement)((0, $42omo.Fragment), props, el.textContent);
        // childless tag
        if (!childNodes.length) return /*#__PURE__*/ (0, $42omo.createElement)(tagName.toLowerCase(), props);
        // tag with content
        return /*#__PURE__*/ (0, $42omo.createElement)(tagName.toLowerCase(), $b1695c2d5acdcbdf$var$_extends({}, props, {
            dangerouslySetInnerHTML: {
                __html: ''
            },
            suppressHydrationWarning: true
        }));
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("input", {
        type: "hidden",
        "data-lazy-end": id
    }));
};






var $jLShN = parcelRequire("jLShN");











var $iYRNV = parcelRequire("iYRNV");







function $141e4ec3ad408220$export$6610512821c8a4ce(href, rel) {
    var _document$head;
    // Skip if already preloaded, prefetched, or loaded
    if (document.querySelector(`link[href="${href}"]`) || document.querySelector(`script[src="${href}"]`)) return 0, $jLShN.noopCleanup;
    const { crossOrigin: crossOrigin } = (0, $8dgvm.getConfig)();
    const link = document.createElement('link');
    link.rel = rel;
    link.as = 'script';
    if (crossOrigin) link.crossOrigin = crossOrigin;
    link.href = href;
    const profiler = (0, $iYRNV.GlobalReactLooselyLazyProfiler).current;
    let removableListener = null;
    if (profiler) {
        const eventInfo = {
            identifier: href
        };
        const listener = ()=>{
            link.removeEventListener('onload', listener);
            removableListener = null;
            profiler.onLoadComplete(eventInfo);
        };
        link.addEventListener('onload', listener);
        removableListener = listener;
        profiler.onLoadStart(eventInfo);
    }
    (_document$head = document.head) == null || _document$head.appendChild(link);
    return ()=>{
        // Remove the link if it is still in the document head
        if (link.parentNode === document.head) {
            var _document$head2;
            (_document$head2 = document.head) == null || _document$head2.removeChild(link);
        }
        if (removableListener) link.removeEventListener('onload', removableListener);
    };
}





function $12cc564e7e862135$export$3af04dbcb01bad4d({ moduleId: moduleId, rel: rel }) {
    const { manifest: manifest } = (0, $8dgvm.getConfig)();
    const assets = (0, $aQIfl.getAssetUrlsFromId)(manifest, moduleId);
    if (!assets) throw new Error('Unsupported preload strategy');
    const cleanupLinkTags = assets.map((url)=>(0, $141e4ec3ad408220$export$6610512821c8a4ce)(url, rel));
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
const $12cc564e7e862135$var$fakePromise = {
    then: ()=>$12cc564e7e862135$var$fakePromise,
    catch: ()=>$12cc564e7e862135$var$fakePromise,
    finally: ()=>$12cc564e7e862135$var$fakePromise
};
function $12cc564e7e862135$export$1046fd6a49d5e7a({ loader: loader, rel: rel }) {
    if (typeof __webpack_require__ === 'undefined' || typeof __webpack_get_script_filename__ === 'undefined') throw new Error('Unsupported preload strategy');
    // Replace requireEnsure to create link tags instead of scripts
    const requireEnsure = __webpack_require__.e;
    const cleanupLinkTags = [];
    __webpack_require__.e = function requirePreload(chunkId) {
        const href = __webpack_get_script_filename__(chunkId);
        cleanupLinkTags.push((0, $141e4ec3ad408220$export$6610512821c8a4ce)(href, rel));
        return $12cc564e7e862135$var$fakePromise;
    };
    try {
        loader();
    } catch (err) {
    // Ignore any errors
    }
    // Restore real webpack require ensure
    __webpack_require__.e = requireEnsure;
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
function $12cc564e7e862135$export$eb05139fa4dcf992({ loader: loader }) {
    loader();
    return 0, $jLShN.noopCleanup;
}
function $12cc564e7e862135$export$25bad4aa00c45355({ loader: loader, moduleId: moduleId, priority: priority }) {
    var _GlobalReactLooselyLa;
    if ((0, $27zaj.isNodeEnvironment)()) return 0, $jLShN.noopCleanup;
    (_GlobalReactLooselyLa = (0, $iYRNV.GlobalReactLooselyLazyProfiler).current) == null || _GlobalReactLooselyLa.onPreload(moduleId, priority);
    const rel = priority === (0, $k001K.PRIORITY).HIGH ? 'preload' : 'prefetch';
    const preloadStrategies = [
        $12cc564e7e862135$export$3af04dbcb01bad4d,
        $12cc564e7e862135$export$1046fd6a49d5e7a,
        $12cc564e7e862135$export$eb05139fa4dcf992
    ];
    for (const strategy of preloadStrategies)try {
        return strategy({
            loader: loader,
            moduleId: moduleId,
            rel: rel
        });
    } catch (_) {
    // Try next strategy...
    }
    return 0, $jLShN.noopCleanup;
}








function $2434146821c65301$export$368b4214baeb914c({ context: context, load: load, onValue: onValue }) {
    const { subscribe: subscribe, currentValue: currentValue } = (0, $42omo.useContext)(context);
    (0, $42omo.useMemo)(()=>{
        let unsubscribe = null;
        const check = ()=>{
            const done = onValue(currentValue());
            if (done) load();
            if (done && unsubscribe) unsubscribe();
            return done;
        };
        unsubscribe = !check() ? subscribe(check) : null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}


function $10bfa415480e5081$export$6898b5504b58699a({ defer: defer, deferred: deferred, dataLazyId: dataLazyId, moduleId: moduleId }) {
    const { requestIdleCallback: requestIdleCallback = setTimeout } = window;
    const ResolvedLazy = /*#__PURE__*/ (0, $42omo.lazy)(()=>deferred.promise);
    return (props)=>{
        // use a single piece of state to hold info about progress or eventually
        // throw an error. We do change it via direct mutation as re-renders
        // break Suspense in React 18, making it lose hydration state
        const [status, bubbleError] = (0, $42omo.useState)(()=>({
                noWait: undefined,
                phase: defer === (0, $euF6Z.PHASE).AFTER_PAINT ? false : true,
                preloaded: defer === (0, $euF6Z.PHASE).AFTER_PAINT ? false : true,
                started: false
            }));
        const profiler = (0, $42omo.useContext)((0, $iYRNV.ProfilerContext)).current;
        const load = ()=>{
            if (status.started || !status.phase || !status.noWait) return;
            status.started = true;
            let onResolve;
            if (profiler) {
                const eventInfo = {
                    identifier: moduleId
                };
                onResolve = ()=>{
                    profiler.onLoadComplete(eventInfo);
                };
                profiler.onLoadStart(eventInfo);
            }
            const result = deferred.start().catch((err)=>{
                // Throw the error within the component lifecycle
                // refer to https://github.com/facebook/react/issues/11409
                bubbleError(()=>{
                    throw (0, $fLvpO.createLoaderError)(err);
                });
            });
            if (onResolve) result.then(onResolve);
        };
        // Subscribe to LazyWait context, triggering load when until is true
        (0, $2434146821c65301$export$368b4214baeb914c)({
            context: (0, $9uVEz.WaitContext),
            load: load,
            onValue: (v)=>status.noWait = v === 1
        });
        if (defer === (0, $euF6Z.PHASE).AFTER_PAINT) {
            // Subscribe to LazyPhase context, triggering load when own phase starts
            (0, $2434146821c65301$export$368b4214baeb914c)({
                context: (0, $6y0vU.LazyPhaseContext),
                load: load,
                onValue: (v)=>status.phase = v >= defer
            });
            // Schedule preloading as will be needed soon
            (0, $42omo.useMemo)(()=>{
                if (!status.preloaded) {
                    status.preloaded = true;
                    requestIdleCallback(()=>{
                        if (status.started) return;
                        (0, $12cc564e7e862135$export$25bad4aa00c45355)({
                            loader: deferred.preload,
                            moduleId: moduleId,
                            priority: (0, $k001K.PRIORITY).LOW
                        });
                    });
                }
            }, [
                status
            ]);
        }
        const { setFallback: setFallback } = (0, $42omo.useContext)((0, $h5RZ7.LazySuspenseContext));
        (0, $42omo.useMemo)(()=>{
            // find SSR content (or fallbacks) wrapped in inputs based on lazyId
            const content = ((0, $euF6Z.COLLECTED).get(dataLazyId) || []).shift();
            if (!content) return;
            // override Suspense fallback with magic input wrappers
            const component = (0, $8dgvm.getConfig)().mode === (0, $dXZzO.MODE).RENDER ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $67fe80fcd34326f0$export$d55db778a3e1446b), {
                id: dataLazyId,
                content: content
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b1695c2d5acdcbdf$export$ca5b8fbc835d95e4), {
                id: dataLazyId,
                content: content
            });
            setFallback(component);
        }, [
            setFallback
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ResolvedLazy, props);
    };
}














parcelRequire("eow39");








function $1bac06d947c9671a$var$load(moduleId, loader) {
    try {
        return (0, $27zaj.getExport)(loader());
    } catch (err) {
        throw (0, $fLvpO.createLoaderError)(err);
    }
}
function $1bac06d947c9671a$export$eb2e4b04351cdd9e({ dataLazyId: dataLazyId, defer: defer, loader: loader, moduleId: moduleId, ssr: ssr }) {
    return (props)=>{
        var _getAssetUrlsFromId;
        const Resolved = ssr ? $1bac06d947c9671a$var$load(moduleId, loader) : null;
        const { fallback: fallback } = (0, $42omo.useContext)((0, $h5RZ7.LazySuspenseContext));
        const { crossOrigin: crossOrigin, manifest: manifest } = (0, $8dgvm.getConfig)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("input", {
            type: "hidden",
            "data-lazy-begin": dataLazyId
        }), defer !== (0, $euF6Z.PHASE).LAZY && ((_getAssetUrlsFromId = (0, $aQIfl.getAssetUrlsFromId)(manifest, moduleId)) == null ? void 0 : _getAssetUrlsFromId.map((url)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("link", {
                key: url,
                rel: defer === (0, $euF6Z.PHASE).PAINT ? 'preload' : 'prefetch',
                href: url,
                crossOrigin: crossOrigin,
                as: "script"
            }))), Resolved ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Resolved, props) : fallback, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("input", {
            type: "hidden",
            "data-lazy-end": dataLazyId
        }));
    };
}


const $7b4dfb9d7bf38586$export$e673efccd97e4223 = ({ loader: loader, preload: preload })=>{
    let resolve;
    const deferred = {
        promise: new Promise((res)=>{
            resolve = (m)=>{
                let withDefault;
                deferred.result = m;
                if (!m.default) withDefault = {
                    default: m
                };
                res(withDefault ? withDefault : m);
            };
        }),
        result: undefined,
        preload: function(_preload) {
            function preload() {
                return _preload.apply(this, arguments);
            }
            preload.toString = function() {
                return _preload.toString();
            };
            return preload;
        }(()=>{
            if (deferred.result) return;
            preload().then((m)=>{
                deferred.result = m;
            }).catch(()=>{
            // Do nothing...
            });
        }),
        start: ()=>{
            if (deferred.result) {
                resolve(deferred.result);
                return Promise.resolve();
            }
            // Make a new loader request when none have started or resolved yet
            return loader().then(resolve);
        }
    };
    return deferred;
};



const $12a2c288067cec34$var$calculateDelay = (context, policy)=>{
    const { attempt: attempt } = context;
    const { delay: delay, factor: factor } = policy;
    const retryAttempt = attempt - 1;
    // Do not use a delay on the first retry, or when the configured delay is 0
    if (retryAttempt === 1 || delay === 0) return 0;
    // Linear factor, like: https://github.com/Polly-Contrib/Polly.Contrib.WaitAndRetry#wait-and-retry-with-linear-back-off
    const add = factor * delay;
    return delay + add * (retryAttempt - 2);
};
const $12a2c288067cec34$var$sleep = (delay)=>new Promise((resolve)=>setTimeout(resolve, delay));
const $12a2c288067cec34$var$getPolicy = (configuration)=>{
    var _configuration$delay, _configuration$factor, _configuration$maxAtt;
    return {
        delay: Math.max(0, (_configuration$delay = configuration.delay) != null ? _configuration$delay : 0),
        factor: Math.max(0, (_configuration$factor = configuration.factor) != null ? _configuration$factor : 0),
        maxAttempts: Math.max(0, (_configuration$maxAtt = configuration.maxAttempts) != null ? _configuration$maxAtt : 0)
    };
};
function $12a2c288067cec34$export$9369b12211e1fce4(retryable, policyConfiguration = {}) {
    const policy = $12a2c288067cec34$var$getPolicy(policyConfiguration);
    const { maxAttempts: maxAttempts } = policy;
    const context = {
        attempt: 1,
        attemptsRemaining: maxAttempts
    };
    const onError = async (err)=>{
        if (context.attemptsRemaining === 0) throw err;
        context.attempt += 1;
        context.attemptsRemaining -= 1;
        const delay = $12a2c288067cec34$var$calculateDelay(context, policy);
        if (delay) await $12a2c288067cec34$var$sleep(delay);
        return retryable().catch(onError);
    };
    return retryable().catch(onError);
}





function $6a061803acf54fcf$var$_extends() {
    $6a061803acf54fcf$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6a061803acf54fcf$var$_extends.apply(this, arguments);
}
function $6a061803acf54fcf$var$lazyProxy(_loader, { defer: defer = (0, $euF6Z.PHASE).PAINT, moduleId: moduleId = '', ssr: ssr = true } = {}) {
    const isServer = (0, $27zaj.isNodeEnvironment)();
    const dataLazyId = (0, $7zmsS.default)(moduleId);
    const LazyInternal = isServer ? (0, $1bac06d947c9671a$export$eb2e4b04351cdd9e)({
        dataLazyId: dataLazyId,
        defer: defer,
        loader: _loader,
        moduleId: moduleId,
        ssr: ssr
    }) : (0, $10bfa415480e5081$export$6898b5504b58699a)({
        dataLazyId: dataLazyId,
        defer: defer,
        // We separate the preload from the retryable request, as we do not want the preload to contribute to retry
        // attempts, when the the loader fallback is used
        deferred: (0, $7b4dfb9d7bf38586$export$e673efccd97e4223)({
            loader: ()=>{
                const { retry: maxAttempts } = (0, $8dgvm.getConfig)();
                return (0, $12a2c288067cec34$export$9369b12211e1fce4)(_loader, {
                    delay: (0, $k001K.RETRY_DELAY),
                    factor: (0, $k001K.RETRY_FACTOR),
                    maxAttempts: maxAttempts
                });
            },
            preload: _loader
        }),
        moduleId: moduleId
    });
    LazyInternal.displayName = `Lazy(${(0, $27zaj.displayNameFromId)(moduleId)})`;
    /**
   * Allows getting module chunks urls
   */ const getAssetUrls = ()=>{
        const { manifest: manifest } = (0, $8dgvm.getConfig)();
        return (0, $aQIfl.getAssetUrlsFromId)(manifest, moduleId);
    };
    /**
   * Allows imperatively preload/ prefetch the module chunk asset
   */ const preload = (priority)=>{
        const p = priority != null ? priority : defer === (0, $euF6Z.PHASE).PAINT ? (0, $k001K.PRIORITY).HIGH : (0, $k001K.PRIORITY).LOW;
        return (0, $12cc564e7e862135$export$25bad4aa00c45355)({
            loader: _loader,
            moduleId: moduleId,
            priority: p
        });
    };
    return Object.assign(LazyInternal, {
        getAssetUrls: getAssetUrls,
        preload: preload
    });
}
const $6a061803acf54fcf$export$93ca5d3f8675ae4c = {
    lazyForPaint: {
        ssr: true,
        defer: (0, $euF6Z.PHASE).PAINT
    },
    lazyAfterPaint: {
        ssr: true,
        defer: (0, $euF6Z.PHASE).AFTER_PAINT
    },
    lazy: {
        ssr: false,
        defer: (0, $euF6Z.PHASE).LAZY
    }
};
function $6a061803acf54fcf$export$c952e5f94576010e(loader, opts) {
    return $6a061803acf54fcf$var$lazyProxy(loader, $6a061803acf54fcf$var$_extends({}, $6a061803acf54fcf$export$93ca5d3f8675ae4c.lazyForPaint, opts || {}));
}
function $6a061803acf54fcf$export$291dd592399bdafa(loader, opts) {
    return $6a061803acf54fcf$var$lazyProxy(loader, $6a061803acf54fcf$var$_extends({}, $6a061803acf54fcf$export$93ca5d3f8675ae4c.lazyAfterPaint, opts || {}));
}
function $6a061803acf54fcf$export$488013bae63b21da(loader, opts) {
    return $6a061803acf54fcf$var$lazyProxy(loader, $6a061803acf54fcf$var$_extends({}, $6a061803acf54fcf$export$93ca5d3f8675ae4c.lazy, opts || {}));
}
module.exports["lazyForPaint"] = $6a061803acf54fcf$export$c952e5f94576010e;
module.exports["lazyAfterPaint"] = $6a061803acf54fcf$export$291dd592399bdafa;
module.exports["lazy"] = $6a061803acf54fcf$export$488013bae63b21da;

});

parcelRegister("1BwGq", function(module, exports) {
$parcel$export(module.exports, "WaitContext", () => (parcelRequire("9uVEz")).WaitContext);

var $9uVEz = parcelRequire("9uVEz");


var $jnAB4 = parcelRequire("jnAB4");


});

parcelRegister("eow39", function(module, exports) {
$parcel$export(module.exports, "LazySuspense", () => (parcelRequire("jyd5r")).LazySuspense);
$parcel$export(module.exports, "LazySuspenseContext", () => (parcelRequire("h5RZ7")).LazySuspenseContext);

var $jyd5r = parcelRequire("jyd5r");


var $h5RZ7 = parcelRequire("h5RZ7");


});

parcelRegister("ecrVx", function(module, exports) {
$parcel$export(module.exports, "LazyPhaseContext", () => (parcelRequire("6y0vU")).LazyPhaseContext);
$parcel$export(module.exports, "setCurrent", () => (parcelRequire("6y0vU")).setCurrent);
$parcel$export(module.exports, "useLazyPhase", () => (parcelRequire("6y0vU")).useLazyPhase);
$parcel$export(module.exports, "LISTENERS", () => (parcelRequire("4CMiD")).LISTENERS);

var $6y0vU = parcelRequire("6y0vU");


var $4CMiD = parcelRequire("4CMiD");


var $ilgZx = parcelRequire("ilgZx");


});

parcelRegister("iYRNV", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $dd1790f807a46380$export$e2d53c0cbedd2710 = {
    current: null
};
const $dd1790f807a46380$export$8146ab57a3f7a7cb = /*#__PURE__*/ (0, $42omo.createContext)($dd1790f807a46380$export$e2d53c0cbedd2710);
module.exports["GlobalReactLooselyLazyProfiler"] = $dd1790f807a46380$export$e2d53c0cbedd2710;
module.exports["ProfilerContext"] = $dd1790f807a46380$export$8146ab57a3f7a7cb;

});

parcelRegister("hslaz", function(module, exports) {
$parcel$export(module.exports, "lib", () => $cb5578fef35f05de$export$16c08b91f883959a, (v) => $cb5578fef35f05de$export$16c08b91f883959a = v);
$parcel$export(module.exports, "assign", () => $cb5578fef35f05de$export$e6e34fd1f2686227, (v) => $cb5578fef35f05de$export$e6e34fd1f2686227 = v);
$parcel$export(module.exports, "isString", () => $cb5578fef35f05de$export$844ec244b1367d54, (v) => $cb5578fef35f05de$export$844ec244b1367d54 = v);
$parcel$export(module.exports, "has", () => $cb5578fef35f05de$export$a4f4bb6b1453fff5, (v) => $cb5578fef35f05de$export$a4f4bb6b1453fff5 = v);
$parcel$export(module.exports, "unescapeMd", () => $cb5578fef35f05de$export$5ccde1ea0c14bb03, (v) => $cb5578fef35f05de$export$5ccde1ea0c14bb03 = v);
$parcel$export(module.exports, "unescapeAll", () => $cb5578fef35f05de$export$db8a17c6655f7e2c, (v) => $cb5578fef35f05de$export$db8a17c6655f7e2c = v);
$parcel$export(module.exports, "isValidEntityCode", () => $cb5578fef35f05de$export$644a8f5b13b2a36d, (v) => $cb5578fef35f05de$export$644a8f5b13b2a36d = v);
$parcel$export(module.exports, "fromCodePoint", () => $cb5578fef35f05de$export$73bfc63873071f74, (v) => $cb5578fef35f05de$export$73bfc63873071f74 = v);
$parcel$export(module.exports, "escapeHtml", () => $cb5578fef35f05de$export$4cf11838cdc2a8a8, (v) => $cb5578fef35f05de$export$4cf11838cdc2a8a8 = v);
$parcel$export(module.exports, "arrayReplaceAt", () => $cb5578fef35f05de$export$f78478f71955b6bc, (v) => $cb5578fef35f05de$export$f78478f71955b6bc = v);
$parcel$export(module.exports, "isSpace", () => $cb5578fef35f05de$export$1d5ccafae59b4926, (v) => $cb5578fef35f05de$export$1d5ccafae59b4926 = v);
$parcel$export(module.exports, "isWhiteSpace", () => $cb5578fef35f05de$export$3c52dd84024ae72c, (v) => $cb5578fef35f05de$export$3c52dd84024ae72c = v);
$parcel$export(module.exports, "isMdAsciiPunct", () => $cb5578fef35f05de$export$829a0d33ae4e744, (v) => $cb5578fef35f05de$export$829a0d33ae4e744 = v);
$parcel$export(module.exports, "isPunctChar", () => $cb5578fef35f05de$export$4888a643af800fc1, (v) => $cb5578fef35f05de$export$4888a643af800fc1 = v);
$parcel$export(module.exports, "escapeRE", () => $cb5578fef35f05de$export$bc616c8f7dc20d5d, (v) => $cb5578fef35f05de$export$bc616c8f7dc20d5d = v);
$parcel$export(module.exports, "normalizeReference", () => $cb5578fef35f05de$export$20ef46802c8744b, (v) => $cb5578fef35f05de$export$20ef46802c8744b = v);
// Utilities
//
////////////////////////////////////////////////////////////////////////////////
// Re-export libraries commonly used in both markdown-it and its plugins,
// so plugins won't have to depend on them explicitly, which reduces their
// bundled size (e.g. a browser build).
//
var $cb5578fef35f05de$export$16c08b91f883959a;
var $cb5578fef35f05de$export$e6e34fd1f2686227;
var $cb5578fef35f05de$export$844ec244b1367d54;
var $cb5578fef35f05de$export$a4f4bb6b1453fff5;
var $cb5578fef35f05de$export$5ccde1ea0c14bb03;
var $cb5578fef35f05de$export$db8a17c6655f7e2c;
var $cb5578fef35f05de$export$644a8f5b13b2a36d;
var $cb5578fef35f05de$export$73bfc63873071f74;
// exports.replaceEntities     = replaceEntities;
var $cb5578fef35f05de$export$4cf11838cdc2a8a8;
var $cb5578fef35f05de$export$f78478f71955b6bc;
var $cb5578fef35f05de$export$1d5ccafae59b4926;
var $cb5578fef35f05de$export$3c52dd84024ae72c;
var $cb5578fef35f05de$export$829a0d33ae4e744;
var $cb5578fef35f05de$export$4888a643af800fc1;
var $cb5578fef35f05de$export$bc616c8f7dc20d5d;
var $cb5578fef35f05de$export$20ef46802c8744b;
'use strict';
function $cb5578fef35f05de$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $cb5578fef35f05de$var$isString(obj) {
    return $cb5578fef35f05de$var$_class(obj) === '[object String]';
}
var $cb5578fef35f05de$var$_hasOwnProperty = Object.prototype.hasOwnProperty;
function $cb5578fef35f05de$var$has(object, key) {
    return $cb5578fef35f05de$var$_hasOwnProperty.call(object, key);
}
// Merge objects
//
function $cb5578fef35f05de$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        if (typeof source !== 'object') throw new TypeError(source + 'must be object');
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
// Remove element from array and put another array at those position.
// Useful for some operations with tokens
function $cb5578fef35f05de$var$arrayReplaceAt(src, pos, newElements) {
    return [].concat(src.slice(0, pos), newElements, src.slice(pos + 1));
}
////////////////////////////////////////////////////////////////////////////////
function $cb5578fef35f05de$var$isValidEntityCode(c) {
    /*eslint no-bitwise:0*/ // broken sequence
    if (c >= 0xD800 && c <= 0xDFFF) return false;
    // never used
    if (c >= 0xFDD0 && c <= 0xFDEF) return false;
    if ((c & 0xFFFF) === 0xFFFF || (c & 0xFFFF) === 0xFFFE) return false;
    // control codes
    if (c >= 0x00 && c <= 0x08) return false;
    if (c === 0x0B) return false;
    if (c >= 0x0E && c <= 0x1F) return false;
    if (c >= 0x7F && c <= 0x9F) return false;
    // out of range
    if (c > 0x10FFFF) return false;
    return true;
}
function $cb5578fef35f05de$var$fromCodePoint(c) {
    /*eslint no-bitwise:0*/ if (c > 0xffff) {
        c -= 0x10000;
        var surrogate1 = 0xd800 + (c >> 10), surrogate2 = 0xdc00 + (c & 0x3ff);
        return String.fromCharCode(surrogate1, surrogate2);
    }
    return String.fromCharCode(c);
}
var $cb5578fef35f05de$var$UNESCAPE_MD_RE = /\\([!"#$%&'()*+,\-.\/:;<=>?@[\\\]^_`{|}~])/g;
var $cb5578fef35f05de$var$ENTITY_RE = /&([a-z#][a-z0-9]{1,31});/gi;
var $cb5578fef35f05de$var$UNESCAPE_ALL_RE = new RegExp($cb5578fef35f05de$var$UNESCAPE_MD_RE.source + '|' + $cb5578fef35f05de$var$ENTITY_RE.source, 'gi');
var $cb5578fef35f05de$var$DIGITAL_ENTITY_TEST_RE = /^#((?:x[a-f0-9]{1,8}|[0-9]{1,8}))$/i;

var $7j3pV = parcelRequire("7j3pV");

function $cb5578fef35f05de$var$replaceEntityPattern(match, name) {
    var code;
    if ($cb5578fef35f05de$var$has($7j3pV, name)) return $7j3pV[name];
    if (name.charCodeAt(0) === 0x23 /* # */  && $cb5578fef35f05de$var$DIGITAL_ENTITY_TEST_RE.test(name)) {
        code = name[1].toLowerCase() === 'x' ? parseInt(name.slice(2), 16) : parseInt(name.slice(1), 10);
        if ($cb5578fef35f05de$var$isValidEntityCode(code)) return $cb5578fef35f05de$var$fromCodePoint(code);
    }
    return match;
}
/*function replaceEntities(str) {
  if (str.indexOf('&') < 0) { return str; }

  return str.replace(ENTITY_RE, replaceEntityPattern);
}*/ function $cb5578fef35f05de$var$unescapeMd(str) {
    if (str.indexOf('\\') < 0) return str;
    return str.replace($cb5578fef35f05de$var$UNESCAPE_MD_RE, '$1');
}
function $cb5578fef35f05de$var$unescapeAll(str) {
    if (str.indexOf('\\') < 0 && str.indexOf('&') < 0) return str;
    return str.replace($cb5578fef35f05de$var$UNESCAPE_ALL_RE, function(match, escaped, entity) {
        if (escaped) return escaped;
        return $cb5578fef35f05de$var$replaceEntityPattern(match, entity);
    });
}
////////////////////////////////////////////////////////////////////////////////
var $cb5578fef35f05de$var$HTML_ESCAPE_TEST_RE = /[&<>"]/;
var $cb5578fef35f05de$var$HTML_ESCAPE_REPLACE_RE = /[&<>"]/g;
var $cb5578fef35f05de$var$HTML_REPLACEMENTS = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;'
};
function $cb5578fef35f05de$var$replaceUnsafeChar(ch) {
    return $cb5578fef35f05de$var$HTML_REPLACEMENTS[ch];
}
function $cb5578fef35f05de$var$escapeHtml(str) {
    if ($cb5578fef35f05de$var$HTML_ESCAPE_TEST_RE.test(str)) return str.replace($cb5578fef35f05de$var$HTML_ESCAPE_REPLACE_RE, $cb5578fef35f05de$var$replaceUnsafeChar);
    return str;
}
////////////////////////////////////////////////////////////////////////////////
var $cb5578fef35f05de$var$REGEXP_ESCAPE_RE = /[.?*+^$[\]\\(){}|-]/g;
function $cb5578fef35f05de$var$escapeRE(str) {
    return str.replace($cb5578fef35f05de$var$REGEXP_ESCAPE_RE, '\\$&');
}
////////////////////////////////////////////////////////////////////////////////
function $cb5578fef35f05de$var$isSpace(code) {
    switch(code){
        case 0x09:
        case 0x20:
            return true;
    }
    return false;
}
// Zs (unicode class) || [\t\f\v\r\n]
function $cb5578fef35f05de$var$isWhiteSpace(code) {
    if (code >= 0x2000 && code <= 0x200A) return true;
    switch(code){
        case 0x09:
        case 0x0A:
        case 0x0B:
        case 0x0C:
        case 0x0D:
        case 0x20:
        case 0xA0:
        case 0x1680:
        case 0x202F:
        case 0x205F:
        case 0x3000:
            return true;
    }
    return false;
}

var $eSMp5 = parcelRequire("eSMp5");

// Currently without astral characters support.
function $cb5578fef35f05de$var$isPunctChar(ch) {
    return $eSMp5.test(ch);
}
// Markdown ASCII punctuation characters.
//
// !, ", #, $, %, &, ', (, ), *, +, ,, -, ., /, :, ;, <, =, >, ?, @, [, \, ], ^, _, `, {, |, }, or ~
// http://spec.commonmark.org/0.15/#ascii-punctuation-character
//
// Don't confuse with unicode punctuation !!! It lacks some chars in ascii range.
//
function $cb5578fef35f05de$var$isMdAsciiPunct(ch) {
    switch(ch){
        case 0x21 /* ! */ :
        case 0x22 /* " */ :
        case 0x23 /* # */ :
        case 0x24 /* $ */ :
        case 0x25 /* % */ :
        case 0x26 /* & */ :
        case 0x27 /* ' */ :
        case 0x28 /* ( */ :
        case 0x29 /* ) */ :
        case 0x2A /* * */ :
        case 0x2B /* + */ :
        case 0x2C /* , */ :
        case 0x2D /* - */ :
        case 0x2E /* . */ :
        case 0x2F /* / */ :
        case 0x3A /* : */ :
        case 0x3B /* ; */ :
        case 0x3C /* < */ :
        case 0x3D /* = */ :
        case 0x3E /* > */ :
        case 0x3F /* ? */ :
        case 0x40 /* @ */ :
        case 0x5B /* [ */ :
        case 0x5C /* \ */ :
        case 0x5D /* ] */ :
        case 0x5E /* ^ */ :
        case 0x5F /* _ */ :
        case 0x60 /* ` */ :
        case 0x7B /* { */ :
        case 0x7C /* | */ :
        case 0x7D /* } */ :
        case 0x7E /* ~ */ :
            return true;
        default:
            return false;
    }
}
// Hepler to unify [reference labels].
//
function $cb5578fef35f05de$var$normalizeReference(str) {
    // Trim and collapse whitespace
    //
    str = str.trim().replace(/\s+/g, ' ');
    // In node v10 'ẞ'.toLowerCase() === 'Ṿ', which is presumed to be a bug
    // fixed in v12 (couldn't find any details).
    //
    // So treat this one as a special case
    // (remove this when node v10 is no longer supported).
    //
    if ("\u1E9E".toLowerCase() === "\u1E7E") str = str.replace(/ẞ/g, "\xdf");
    // .toLowerCase().toUpperCase() should get rid of all differences
    // between letter variants.
    //
    // Simple .toLowerCase() doesn't normalize 125 code points correctly,
    // and .toUpperCase doesn't normalize 6 of them (list of exceptions:
    // İ, ϴ, ẞ, Ω, K, Å - those are already uppercased, but have differently
    // uppercased versions).
    //
    // Here's an example showing how it happens. Lets take greek letter omega:
    // uppercase U+0398 (Θ), U+03f4 (ϴ) and lowercase U+03b8 (θ), U+03d1 (ϑ)
    //
    // Unicode entries:
    // 0398;GREEK CAPITAL LETTER THETA;Lu;0;L;;;;;N;;;;03B8;
    // 03B8;GREEK SMALL LETTER THETA;Ll;0;L;;;;;N;;;0398;;0398
    // 03D1;GREEK THETA SYMBOL;Ll;0;L;<compat> 03B8;;;;N;GREEK SMALL LETTER SCRIPT THETA;;0398;;0398
    // 03F4;GREEK CAPITAL THETA SYMBOL;Lu;0;L;<compat> 0398;;;;N;;;;03B8;
    //
    // Case-insensitive comparison should treat all of them as equivalent.
    //
    // But .toLowerCase() doesn't change ϑ (it's already lowercase),
    // and .toUpperCase() doesn't change ϴ (already uppercase).
    //
    // Applying first lower then upper case normalizes any character:
    // '\u0398\u03f4\u03b8\u03d1'.toLowerCase().toUpperCase() === '\u0398\u0398\u0398\u0398'
    //
    // Note: this is equivalent to unicode case folding; unicode normalization
    // is a different step that is not required here.
    //
    // Final result should be uppercased, because it's later stored in an object
    // (this avoid a conflict with Object.prototype members,
    // most notably, `__proto__`)
    //
    return str.toLowerCase().toUpperCase();
}
$cb5578fef35f05de$export$16c08b91f883959a = {};

$cb5578fef35f05de$export$16c08b91f883959a.mdurl = (parcelRequire("kYaO1"));

$cb5578fef35f05de$export$16c08b91f883959a.ucmicro = (parcelRequire("bx7Sb"));
$cb5578fef35f05de$export$e6e34fd1f2686227 = $cb5578fef35f05de$var$assign;
$cb5578fef35f05de$export$844ec244b1367d54 = $cb5578fef35f05de$var$isString;
$cb5578fef35f05de$export$a4f4bb6b1453fff5 = $cb5578fef35f05de$var$has;
$cb5578fef35f05de$export$5ccde1ea0c14bb03 = $cb5578fef35f05de$var$unescapeMd;
$cb5578fef35f05de$export$db8a17c6655f7e2c = $cb5578fef35f05de$var$unescapeAll;
$cb5578fef35f05de$export$644a8f5b13b2a36d = $cb5578fef35f05de$var$isValidEntityCode;
$cb5578fef35f05de$export$73bfc63873071f74 = $cb5578fef35f05de$var$fromCodePoint;
$cb5578fef35f05de$export$4cf11838cdc2a8a8 = $cb5578fef35f05de$var$escapeHtml;
$cb5578fef35f05de$export$f78478f71955b6bc = $cb5578fef35f05de$var$arrayReplaceAt;
$cb5578fef35f05de$export$1d5ccafae59b4926 = $cb5578fef35f05de$var$isSpace;
$cb5578fef35f05de$export$3c52dd84024ae72c = $cb5578fef35f05de$var$isWhiteSpace;
$cb5578fef35f05de$export$829a0d33ae4e744 = $cb5578fef35f05de$var$isMdAsciiPunct;
$cb5578fef35f05de$export$4888a643af800fc1 = $cb5578fef35f05de$var$isPunctChar;
$cb5578fef35f05de$export$bc616c8f7dc20d5d = $cb5578fef35f05de$var$escapeRE;
$cb5578fef35f05de$export$20ef46802c8744b = $cb5578fef35f05de$var$normalizeReference;

});

parcelRegister("flZnN", function(module, exports) {
// Token class
'use strict';
/**
 * class Token
 **/ /**
 * new Token(type, tag, nesting)
 *
 * Create new token and fill passed properties.
 **/ function $b2d86e83f9686c86$var$Token(type, tag, nesting) {
    /**
   * Token#type -> String
   *
   * Type of the token (string, e.g. "paragraph_open")
   **/ this.type = type;
    /**
   * Token#tag -> String
   *
   * html tag name, e.g. "p"
   **/ this.tag = tag;
    /**
   * Token#attrs -> Array
   *
   * Html attributes. Format: `[ [ name1, value1 ], [ name2, value2 ] ]`
   **/ this.attrs = null;
    /**
   * Token#map -> Array
   *
   * Source map info. Format: `[ line_begin, line_end ]`
   **/ this.map = null;
    /**
   * Token#nesting -> Number
   *
   * Level change (number in {-1, 0, 1} set), where:
   *
   * -  `1` means the tag is opening
   * -  `0` means the tag is self-closing
   * - `-1` means the tag is closing
   **/ this.nesting = nesting;
    /**
   * Token#level -> Number
   *
   * nesting level, the same as `state.level`
   **/ this.level = 0;
    /**
   * Token#children -> Array
   *
   * An array of child nodes (inline and img tokens)
   **/ this.children = null;
    /**
   * Token#content -> String
   *
   * In a case of self-closing tag (code, html, fence, etc.),
   * it has contents of this tag.
   **/ this.content = '';
    /**
   * Token#markup -> String
   *
   * '*' or '_' for emphasis, fence string for fence, etc.
   **/ this.markup = '';
    /**
   * Token#info -> String
   *
   * Additional information:
   *
   * - Info string for "fence" tokens
   * - The value "auto" for autolink "link_open" and "link_close" tokens
   * - The string value of the item marker for ordered-list "list_item_open" tokens
   **/ this.info = '';
    /**
   * Token#meta -> Object
   *
   * A place for plugins to store an arbitrary data
   **/ this.meta = null;
    /**
   * Token#block -> Boolean
   *
   * True for block-level tokens, false for inline tokens.
   * Used in renderer to calculate line breaks
   **/ this.block = false;
    /**
   * Token#hidden -> Boolean
   *
   * If it's true, ignore this element when rendering. Used for tight lists
   * to hide paragraphs.
   **/ this.hidden = false;
}
/**
 * Token.attrIndex(name) -> Number
 *
 * Search attribute index by name.
 **/ $b2d86e83f9686c86$var$Token.prototype.attrIndex = function attrIndex(name) {
    var attrs, i, len;
    if (!this.attrs) return -1;
    attrs = this.attrs;
    for(i = 0, len = attrs.length; i < len; i++){
        if (attrs[i][0] === name) return i;
    }
    return -1;
};
/**
 * Token.attrPush(attrData)
 *
 * Add `[ name, value ]` attribute to list. Init attrs if necessary
 **/ $b2d86e83f9686c86$var$Token.prototype.attrPush = function attrPush(attrData) {
    if (this.attrs) this.attrs.push(attrData);
    else this.attrs = [
        attrData
    ];
};
/**
 * Token.attrSet(name, value)
 *
 * Set `name` attribute to `value`. Override old value if exists.
 **/ $b2d86e83f9686c86$var$Token.prototype.attrSet = function attrSet(name, value) {
    var idx = this.attrIndex(name), attrData = [
        name,
        value
    ];
    if (idx < 0) this.attrPush(attrData);
    else this.attrs[idx] = attrData;
};
/**
 * Token.attrGet(name)
 *
 * Get the value of attribute `name`, or null if it does not exist.
 **/ $b2d86e83f9686c86$var$Token.prototype.attrGet = function attrGet(name) {
    var idx = this.attrIndex(name), value = null;
    if (idx >= 0) value = this.attrs[idx][1];
    return value;
};
/**
 * Token.attrJoin(name, value)
 *
 * Join value to existing attribute via space. Or create new attribute if not
 * exists. Useful to operate with token classes.
 **/ $b2d86e83f9686c86$var$Token.prototype.attrJoin = function attrJoin(name, value) {
    var idx = this.attrIndex(name);
    if (idx < 0) this.attrPush([
        name,
        value
    ]);
    else this.attrs[idx][1] = this.attrs[idx][1] + ' ' + value;
};
module.exports = $b2d86e83f9686c86$var$Token;

});

parcelRegister("dgyOV", function(module, exports) {
$parcel$export(module.exports, "HTML_TAG_RE", () => $9a87c79b003d7609$export$6db61d2c3a16e419, (v) => $9a87c79b003d7609$export$6db61d2c3a16e419 = v);
$parcel$export(module.exports, "HTML_OPEN_CLOSE_TAG_RE", () => $9a87c79b003d7609$export$cd48660d06f74639, (v) => $9a87c79b003d7609$export$cd48660d06f74639 = v);
// Regexps to match html elements
var $9a87c79b003d7609$export$6db61d2c3a16e419;
var $9a87c79b003d7609$export$cd48660d06f74639;
'use strict';
var $9a87c79b003d7609$var$attr_name = '[a-zA-Z_:][a-zA-Z0-9:._-]*';
var $9a87c79b003d7609$var$unquoted = '[^"\'=<>`\\x00-\\x20]+';
var $9a87c79b003d7609$var$single_quoted = "'[^']*'";
var $9a87c79b003d7609$var$double_quoted = '"[^"]*"';
var $9a87c79b003d7609$var$attr_value = '(?:' + $9a87c79b003d7609$var$unquoted + '|' + $9a87c79b003d7609$var$single_quoted + '|' + $9a87c79b003d7609$var$double_quoted + ')';
var $9a87c79b003d7609$var$attribute = '(?:\\s+' + $9a87c79b003d7609$var$attr_name + '(?:\\s*=\\s*' + $9a87c79b003d7609$var$attr_value + ')?)';
var $9a87c79b003d7609$var$open_tag = '<[A-Za-z][A-Za-z0-9\\-]*' + $9a87c79b003d7609$var$attribute + '*\\s*\\/?>';
var $9a87c79b003d7609$var$close_tag = '<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>';
var $9a87c79b003d7609$var$comment = '<!---->|<!--(?:-?[^>-])(?:-?[^-])*-->';
var $9a87c79b003d7609$var$processing = '<[?][\\s\\S]*?[?]>';
var $9a87c79b003d7609$var$declaration = '<![A-Z]+\\s+[^>]*>';
var $9a87c79b003d7609$var$cdata = '<!\\[CDATA\\[[\\s\\S]*?\\]\\]>';
var $9a87c79b003d7609$var$HTML_TAG_RE = new RegExp('^(?:' + $9a87c79b003d7609$var$open_tag + '|' + $9a87c79b003d7609$var$close_tag + '|' + $9a87c79b003d7609$var$comment + '|' + $9a87c79b003d7609$var$processing + '|' + $9a87c79b003d7609$var$declaration + '|' + $9a87c79b003d7609$var$cdata + ')');
var $9a87c79b003d7609$var$HTML_OPEN_CLOSE_TAG_RE = new RegExp('^(?:' + $9a87c79b003d7609$var$open_tag + '|' + $9a87c79b003d7609$var$close_tag + ')');
$9a87c79b003d7609$export$6db61d2c3a16e419 = $9a87c79b003d7609$var$HTML_TAG_RE;
$9a87c79b003d7609$export$cd48660d06f74639 = $9a87c79b003d7609$var$HTML_OPEN_CLOSE_TAG_RE;

});

parcelRegister("bBvs5", function(module, exports) {
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $42omo = parcelRequire("42omo");

const $e8c8dd4eecc10576$var$RendererContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({});
const $e8c8dd4eecc10576$export$a906432540ed7ed8 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext($e8c8dd4eecc10576$var$RendererContext);
const $e8c8dd4eecc10576$export$ca5df47902194781 = $e8c8dd4eecc10576$var$RendererContext.Provider;
module.exports["useRendererContext"] = $e8c8dd4eecc10576$export$a906432540ed7ed8;
module.exports["RendererContextProvider"] = $e8c8dd4eecc10576$export$ca5df47902194781;

});

parcelRegister("bT49y", function(module, exports) {

var $011qA = parcelRequire("011qA");


var $1Xhyy = parcelRequire("1Xhyy");


var $fPVB6 = parcelRequire("fPVB6");


var $heRFI = parcelRequire("heRFI");

/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */ function $8a780d7d3205113e$var$words(string, pattern, guard) {
    string = $fPVB6(string);
    pattern = guard ? undefined : pattern;
    if (pattern === undefined) return $1Xhyy(string) ? $heRFI(string) : $011qA(string);
    return string.match(pattern) || [];
}
module.exports = $8a780d7d3205113e$var$words;

});

parcelRegister("3HdsG", function(module, exports) {
$parcel$export(module.exports, "default", () => $ba5ac32bd70f8fda$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $gmMgo = parcelRequire("gmMgo");


var $8Q3VW = parcelRequire("8Q3VW");


var $3gadb = parcelRequire("3gadb");


var $3kBFe = parcelRequire("3kBFe");

function $ba5ac32bd70f8fda$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ba5ac32bd70f8fda$export$3c9cedc52604835d = 'heading-anchor-wrapper';
const $ba5ac32bd70f8fda$var$CopyAnchorWrapperWithRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef((props, ref)=>{
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        ...rest,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $ba5ac32bd70f8fda$export$3c9cedc52604835d,
        ref: ref
    }, children);
});
const $ba5ac32bd70f8fda$var$copyAnchorButtonStyles = {
    name: "x4slh0",
    styles: "display:inline;outline:none;background-color:transparent;border:none;color:var(--ds-icon, #292A2E);cursor:pointer;right:0"
};
// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
class $ba5ac32bd70f8fda$var$HeadingAnchor extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    componentDidMount() {
        this.resetMessage();
    }
    render() {
        const { tooltipMessage: tooltipMessage } = this.state;
        if (tooltipMessage) // We set the key to the message to ensure it remounts when the message
        // changes, so that it correctly repositions.
        // @see https://ecosystem.atlassian.net/projects/AK/queues/issue/AK-6548
        return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3gadb.default), {
            // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
            tag: $ba5ac32bd70f8fda$var$CopyAnchorWrapperWithRef,
            content: tooltipMessage,
            position: "top",
            delay: 0,
            key: tooltipMessage
        }, this.renderAnchorButton());
        return this.renderAnchorButton();
    }
    constructor(...args){
        super(...args);
        this.state = {
            tooltipMessage: '',
            isClicked: false
        };
        this.setTooltipState = (message, isClicked = false)=>{
            this.setState({
                // TODO: ED-14403 - investigate why this does not translate
                tooltipMessage: this.props.intl.formatMessage(message),
                isClicked: isClicked
            });
        };
        this.getCopyAriaLabel = ()=>{
            const { copyAriaLabel: copyAriaLabel } = (0, $3kBFe.headingAnchorLinkMessages);
            return this.props.intl.formatMessage(copyAriaLabel);
        };
        this.copyToClipboard = async (event)=>{
            const { copiedHeadingLinkToClipboard: copiedHeadingLinkToClipboard, failedToCopyHeadingLink: failedToCopyHeadingLink } = (0, $3kBFe.headingAnchorLinkMessages);
            event.stopPropagation();
            try {
                await this.props.onCopyText();
                this.setTooltipState(copiedHeadingLinkToClipboard, true);
            } catch (e) {
                this.setTooltipState(failedToCopyHeadingLink);
            }
        };
        this.resetMessage = ()=>{
            this.setTooltipState((0, $3kBFe.headingAnchorLinkMessages).copyHeadingLinkToClipboard);
        };
        this.renderAnchorButton = ()=>{
            const { hideFromScreenReader: hideFromScreenReader = false, headingId: headingId } = this.props;
            return /*#__PURE__*/ (0, $9K4OG.jsx)("button", {
                "data-testid": "anchor-button",
                css: $ba5ac32bd70f8fda$var$copyAnchorButtonStyles,
                // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
                onMouseLeave: this.resetMessage,
                onClick: this.copyToClipboard,
                "aria-hidden": hideFromScreenReader,
                tabIndex: hideFromScreenReader ? undefined : -1,
                "aria-label": hideFromScreenReader ? undefined : this.state.tooltipMessage,
                "aria-labelledby": hideFromScreenReader ? undefined : headingId,
                type: "button"
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8Q3VW))), {
                label: this.getCopyAriaLabel(),
                LEGACY_size: this.props.level > 3 ? 'small' : 'medium',
                color: this.state.isClicked ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon-subtle, #505258)"
            }));
        };
    }
}
var $ba5ac32bd70f8fda$export$2e2bcd8739ae039 = (0, $gmMgo.default)($ba5ac32bd70f8fda$var$HeadingAnchor);
module.exports["HeadingAnchorWrapperClassName"] = $ba5ac32bd70f8fda$export$3c9cedc52604835d;

});

parcelRegister("drJ23", function(module, exports) {
function $67762bf75d20c8f0$export$75aa84e85754623e(path) {
    let count = 1;
    path.forEach((node)=>{
        if (node.type.name === 'bulletList' || node.type.name === 'orderedList') count++;
    });
    return count;
}
module.exports["getListIndentLevel"] = $67762bf75d20c8f0$export$75aa84e85754623e;

});

parcelRegister("80xRs", function(module, exports) {
var $56266f841bff4619$export$7103a54af3e45080 = /*#__PURE__*/ function(ResultStatus) {
    ResultStatus["FULFILLED"] = "fulfilled";
    ResultStatus["FAILED"] = "failed";
    return ResultStatus;
}({});
const $56266f841bff4619$var$isFullfilled = (result)=>result.status === "fulfilled";
const $56266f841bff4619$var$markFullfilled = (value)=>({
        status: "fulfilled",
        value: value
    });
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $56266f841bff4619$var$markRejected = (error)=>({
        status: "failed",
        reason: error
    });
const $56266f841bff4619$export$b43fdcffd84b7b0f = (promises)=>{
    return Promise.all(promises.map((result)=>result.then($56266f841bff4619$var$markFullfilled).catch($56266f841bff4619$var$markRejected)));
};
const $56266f841bff4619$export$cb8861b0e3f3dd6f = (promises)=>{
    const rejectReasons = [];
    return new Promise((resolve, reject)=>{
        promises.forEach((promise)=>promise.then((value)=>{
                if (typeof value === 'undefined' || value === null) throw new Error(`Result was not found but the method didn't reject/throw. Please ensure that it doesn't return null or undefined.`);
                resolve(value);
            }).catch((reason)=>{
                rejectReasons.push(reason);
                if (rejectReasons.length === promises.length) reject(reason);
            }));
    });
};
const $56266f841bff4619$export$b7581cbf0e22e36b = (results)=>results.filter($56266f841bff4619$var$isFullfilled).map((result)=>result.value);
module.exports["waitForAllPromises"] = $56266f841bff4619$export$b43fdcffd84b7b0f;
module.exports["waitForFirstFulfilledPromise"] = $56266f841bff4619$export$cb8861b0e3f3dd6f;
module.exports["getOnlyFulfilled"] = $56266f841bff4619$export$b7581cbf0e22e36b;

});

parcelRegister("dXZzO", function(module, exports) {
const $a2b08cde192cf1ec$export$e48589d9e4824227 = {
    RENDER: 'RENDER',
    HYDRATE: 'HYDRATE'
};
module.exports["MODE"] = $a2b08cde192cf1ec$export$e48589d9e4824227;

});

parcelRegister("7zmsS", function(module, exports) {
$parcel$export(module.exports, "default", () => $582d3a4d2ad75f69$export$2e2bcd8739ae039);
/* eslint-disable */ // murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function $582d3a4d2ad75f69$export$2e2bcd8739ae039(str) {
    var l = str.length, h = l ^ l, i = 0, k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return (h >>> 0).toString(36);
}

});

parcelRegister("euF6Z", function(module, exports) {
const $a8d3c1fdc5de2df2$export$2cc7a2eaaea7809f = {
    PAINT: 0,
    AFTER_PAINT: 1,
    LAZY: 2
};
const $a8d3c1fdc5de2df2$export$4831ef3968ea94ef = new Map();
module.exports["PHASE"] = $a8d3c1fdc5de2df2$export$2cc7a2eaaea7809f;
module.exports["COLLECTED"] = $a8d3c1fdc5de2df2$export$4831ef3968ea94ef;

});

parcelRegister("27zaj", function(module, exports) {
$parcel$export(module.exports, "hash", () => (parcelRequire("7zmsS")).default);

var $7zmsS = parcelRequire("7zmsS");

const $18b7834f7092bd86$export$d4c07b1daf44a7f = (m)=>'default' in m ? m.default : m;
const $18b7834f7092bd86$export$4429f98ef60d2d87 = (id)=>{
    const fName = id.split('/').slice(-3).join('/');
    return fName || 'Component';
};
const $18b7834f7092bd86$export$283635c04a02cc36 = ()=>{
    if (typeof window === "undefined" || window.name === 'nodejs') return true;
    return globalThis !== globalThis.window;
};
function $18b7834f7092bd86$export$62bf630d0de3d781(props, attr) {
    switch(attr.name){
        case 'style':
            break;
        case 'class':
            props.className = attr.value;
            break;
        case 'crossorigin':
            props.crossOrigin = attr.value;
            break;
        default:
            props[attr.name] = attr.value;
    }
    return props;
}
module.exports["getExport"] = $18b7834f7092bd86$export$d4c07b1daf44a7f;
module.exports["displayNameFromId"] = $18b7834f7092bd86$export$4429f98ef60d2d87;
module.exports["isNodeEnvironment"] = $18b7834f7092bd86$export$283635c04a02cc36;
module.exports["attrToProp"] = $18b7834f7092bd86$export$62bf630d0de3d781;

});

parcelRegister("k001K", function(module, exports) {
const $e8f3d428f2749473$export$bb34f3538ba26c7e = {
    HIGH: 0,
    LOW: 2
};
const $e8f3d428f2749473$export$a339266ad71b2447 = 300;
const $e8f3d428f2749473$export$ba64c908e55507fe = 1;
module.exports["PRIORITY"] = $e8f3d428f2749473$export$bb34f3538ba26c7e;
module.exports["RETRY_DELAY"] = $e8f3d428f2749473$export$a339266ad71b2447;
module.exports["RETRY_FACTOR"] = $e8f3d428f2749473$export$ba64c908e55507fe;

});

parcelRegister("fLvpO", function(module, exports) {
const $b7a39d38ff5e8305$export$6aa69c1258005366 = Symbol.for('react-loosely-lazy/loader-error');
const $b7a39d38ff5e8305$export$c73a6a6f0bf7d425 = (error)=>{
    if (typeof error === 'object') // @ts-expect-error Explicitly untyped
    return Object.assign(error, {
        [$b7a39d38ff5e8305$export$6aa69c1258005366]: true
    });
    return error;
};
const $b7a39d38ff5e8305$export$16a03aca4a3508b4 = (error)=>Object.getOwnPropertySymbols(error).includes($b7a39d38ff5e8305$export$6aa69c1258005366);
module.exports["createLoaderError"] = $b7a39d38ff5e8305$export$c73a6a6f0bf7d425;

});

parcelRegister("9uVEz", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jLShN = parcelRequire("jLShN");

const $6ea3a326e6c1ad89$export$9ba3fe09d15de47b = /*#__PURE__*/ (0, $42omo.createContext)({
    subscribe: ()=>(0, $jLShN.noopCleanup),
    currentValue: ()=>1
});
module.exports["WaitContext"] = $6ea3a326e6c1ad89$export$9ba3fe09d15de47b;

});

parcelRegister("jnAB4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9uVEz = parcelRequire("9uVEz");

const $e1bc8db03d394dff$export$7bf6cf03fd32cddb = ({ until: until, children: children })=>{
    const closestWait = (0, $42omo.useContext)((0, $9uVEz.WaitContext));
    const value = (0, $42omo.useRef)(until && closestWait.currentValue() ? 1 : 0);
    const subscribers = (0, $42omo.useRef)(new Set());
    const api = (0, $42omo.useRef)({
        subscribe: (subscriber)=>{
            subscribers.current.add(subscriber);
            return ()=>{
                subscribers.current.delete(subscriber);
            };
        },
        currentValue: ()=>value.current
    });
    (0, $42omo.useEffect)(()=>{
        // Notify subscribers when until prop or closest until value changes
        const notify = ()=>{
            value.current = closestWait.currentValue() && until ? 1 : 0;
            subscribers.current.forEach((subscriber)=>subscriber());
        };
        notify();
        return closestWait.subscribe(notify);
    }, [
        closestWait,
        until
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9uVEz.WaitContext).Provider, {
        value: api.current
    }, children);
};

});

parcelRegister("jyd5r", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $27zaj = parcelRequire("27zaj");


var $h5RZ7 = parcelRequire("h5RZ7");

class $e3bb580fd9a2f323$export$256c542058532d6f extends (0, $42omo.Component) {
    componentDidMount() {
        this.mounted = true;
    }
    renderFallback(outsideSuspense) {
        const { DynamicFallback: DynamicFallback } = this;
        // Use render prop component to allow switch to hydration fallback
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(DynamicFallback, {
            outsideSuspense: outsideSuspense
        }, (fallback)=>fallback);
    }
    renderServer() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $h5RZ7.LazySuspenseContext).Provider, {
            value: this.state
        }, this.props.children);
    }
    renderClient() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $h5RZ7.LazySuspenseContext).Provider, {
            value: this.state
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: this.renderFallback(false)
        }, this.props.children), (!this.mounted || this.hydrationFallback) && this.renderFallback(true));
    }
    render() {
        return (0, $27zaj.isNodeEnvironment)() ? this.renderServer() : this.renderClient();
    }
    constructor(props){
        super(props);
        this.state = {
            // Used on server to render fallback down the tree
            fallback: this.props.fallback,
            // Used on client to replace fallback with magic input
            setFallback: (fallback)=>{
                if (this.hydrationFallback === fallback) return;
                this.hydrationFallback = fallback;
                // Schedule an update so we force switch from the sibling tree
                // back to the suspense boundary
                if (this.mounted) this.forceUpdate();
            }
        };
        this.hydrationFallback = null;
        this.mounted = false;
        this.DynamicFallback = ({ children: children, outsideSuspense: outsideSuspense })=>{
            // eslint-disable-next-line react-hooks/rules-of-hooks
            (0, $42omo.useLayoutEffect)(()=>{
                return ()=>{
                    // the effect cleanup is called by the Suspense boundary itself
                    // when both Lazy AND the eventual promises thrown are done
                    // so Suspense will re-render with actual content and we remove
                    // the hydration fallback at the same time
                    if (!outsideSuspense) this.state.setFallback(null);
                };
            }, [
                outsideSuspense
            ]);
            return outsideSuspense ? children(this.hydrationFallback ? this.hydrationFallback : null) : children(this.hydrationFallback ? null : this.props.fallback);
        };
        this.DynamicFallback.displayName = 'DynamicFallback';
    }
}
module.exports["LazySuspense"] = $e3bb580fd9a2f323$export$256c542058532d6f;

});

parcelRegister("h5RZ7", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $c71cc793aab4db4d$export$c33990e84065970c = /*#__PURE__*/ (0, $42omo.createContext)({
    fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null),
    setFallback: ()=>{
        console.warn('Missing <LooselySuspense /> boundary');
    }
});
module.exports["LazySuspenseContext"] = $c71cc793aab4db4d$export$c33990e84065970c;

});

parcelRegister("6y0vU", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $euF6Z = parcelRequire("euF6Z");


var $4CMiD = parcelRequire("4CMiD");


var $ilgZx = parcelRequire("ilgZx");

let $4c46510d73a23c1f$var$CURRENT_PHASE = (0, $euF6Z.PHASE).PAINT;
const $4c46510d73a23c1f$export$5f80f094fd31fffd = (phase)=>{
    $4c46510d73a23c1f$var$CURRENT_PHASE = phase;
    (0, $4CMiD.LISTENERS).slice(0).forEach((listener)=>listener(phase));
};
const $4c46510d73a23c1f$export$5a25eca35e5debcb = /*#__PURE__*/ (0, $42omo.createContext)({
    subscribe: (0, $ilgZx.createSubscribe)((0, $4CMiD.LISTENERS)),
    currentValue: ()=>$4c46510d73a23c1f$var$CURRENT_PHASE,
    api: {
        startNextPhase: ()=>{
            $4c46510d73a23c1f$export$5f80f094fd31fffd((0, $euF6Z.PHASE).AFTER_PAINT);
        },
        resetPhase: ()=>$4c46510d73a23c1f$export$5f80f094fd31fffd((0, $euF6Z.PHASE).PAINT)
    }
});
const $4c46510d73a23c1f$export$1dc361b277327f88 = ()=>{
    const v = (0, $42omo.useContext)($4c46510d73a23c1f$export$5a25eca35e5debcb);
    return v.api;
};
module.exports["setCurrent"] = $4c46510d73a23c1f$export$5f80f094fd31fffd;
module.exports["LazyPhaseContext"] = $4c46510d73a23c1f$export$5a25eca35e5debcb;
module.exports["useLazyPhase"] = $4c46510d73a23c1f$export$1dc361b277327f88;

});

parcelRegister("4CMiD", function(module, exports) {
const $35e02d56e6163baa$export$81b9c458a026d68f = [];
module.exports["LISTENERS"] = $35e02d56e6163baa$export$81b9c458a026d68f;

});

parcelRegister("ilgZx", function(module, exports) {
const $d5a75e5021e4308a$export$364097d812234b3f = (listeners)=>(listener)=>{
        listeners.push(listener);
        return ()=>{
            const index = listeners.indexOf(listener);
            if (index !== -1) listeners.splice(index, 1);
        };
    };
module.exports["createSubscribe"] = $d5a75e5021e4308a$export$364097d812234b3f;

});

parcelRegister("7j3pV", function(module, exports) {
// HTML5 entities map: { name -> utf16string }
//
'use strict';

/*eslint quotes:0*/ module.exports = (parcelRequire("hxrg0"));

});

parcelRegister("011qA", function(module, exports) {
/** Used to match words composed of alphanumeric characters. */ var $003133aba52e1295$var$reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $003133aba52e1295$var$asciiWords(string) {
    return string.match($003133aba52e1295$var$reAsciiWord) || [];
}
module.exports = $003133aba52e1295$var$asciiWords;

});

parcelRegister("1Xhyy", function(module, exports) {
/** Used to detect strings that need a more robust regexp to match words. */ var $16c8eb795c50bf79$var$reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */ function $16c8eb795c50bf79$var$hasUnicodeWord(string) {
    return $16c8eb795c50bf79$var$reHasUnicodeWord.test(string);
}
module.exports = $16c8eb795c50bf79$var$hasUnicodeWord;

});

parcelRegister("heRFI", function(module, exports) {
/** Used to compose unicode character classes. */ var $c8cd609b21904ab0$var$rsAstralRange = '\\ud800-\\udfff', $c8cd609b21904ab0$var$rsComboMarksRange = '\\u0300-\\u036f', $c8cd609b21904ab0$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $c8cd609b21904ab0$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $c8cd609b21904ab0$var$rsComboRange = $c8cd609b21904ab0$var$rsComboMarksRange + $c8cd609b21904ab0$var$reComboHalfMarksRange + $c8cd609b21904ab0$var$rsComboSymbolsRange, $c8cd609b21904ab0$var$rsDingbatRange = '\\u2700-\\u27bf', $c8cd609b21904ab0$var$rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', $c8cd609b21904ab0$var$rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', $c8cd609b21904ab0$var$rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', $c8cd609b21904ab0$var$rsPunctuationRange = '\\u2000-\\u206f', $c8cd609b21904ab0$var$rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', $c8cd609b21904ab0$var$rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', $c8cd609b21904ab0$var$rsVarRange = '\\ufe0e\\ufe0f', $c8cd609b21904ab0$var$rsBreakRange = $c8cd609b21904ab0$var$rsMathOpRange + $c8cd609b21904ab0$var$rsNonCharRange + $c8cd609b21904ab0$var$rsPunctuationRange + $c8cd609b21904ab0$var$rsSpaceRange;
/** Used to compose unicode capture groups. */ var $c8cd609b21904ab0$var$rsApos = "['\u2019]", $c8cd609b21904ab0$var$rsBreak = '[' + $c8cd609b21904ab0$var$rsBreakRange + ']', $c8cd609b21904ab0$var$rsCombo = '[' + $c8cd609b21904ab0$var$rsComboRange + ']', $c8cd609b21904ab0$var$rsDigits = '\\d+', $c8cd609b21904ab0$var$rsDingbat = '[' + $c8cd609b21904ab0$var$rsDingbatRange + ']', $c8cd609b21904ab0$var$rsLower = '[' + $c8cd609b21904ab0$var$rsLowerRange + ']', $c8cd609b21904ab0$var$rsMisc = '[^' + $c8cd609b21904ab0$var$rsAstralRange + $c8cd609b21904ab0$var$rsBreakRange + $c8cd609b21904ab0$var$rsDigits + $c8cd609b21904ab0$var$rsDingbatRange + $c8cd609b21904ab0$var$rsLowerRange + $c8cd609b21904ab0$var$rsUpperRange + ']', $c8cd609b21904ab0$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $c8cd609b21904ab0$var$rsModifier = '(?:' + $c8cd609b21904ab0$var$rsCombo + '|' + $c8cd609b21904ab0$var$rsFitz + ')', $c8cd609b21904ab0$var$rsNonAstral = '[^' + $c8cd609b21904ab0$var$rsAstralRange + ']', $c8cd609b21904ab0$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $c8cd609b21904ab0$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $c8cd609b21904ab0$var$rsUpper = '[' + $c8cd609b21904ab0$var$rsUpperRange + ']', $c8cd609b21904ab0$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $c8cd609b21904ab0$var$rsMiscLower = '(?:' + $c8cd609b21904ab0$var$rsLower + '|' + $c8cd609b21904ab0$var$rsMisc + ')', $c8cd609b21904ab0$var$rsMiscUpper = '(?:' + $c8cd609b21904ab0$var$rsUpper + '|' + $c8cd609b21904ab0$var$rsMisc + ')', $c8cd609b21904ab0$var$rsOptContrLower = '(?:' + $c8cd609b21904ab0$var$rsApos + '(?:d|ll|m|re|s|t|ve))?', $c8cd609b21904ab0$var$rsOptContrUpper = '(?:' + $c8cd609b21904ab0$var$rsApos + '(?:D|LL|M|RE|S|T|VE))?', $c8cd609b21904ab0$var$reOptMod = $c8cd609b21904ab0$var$rsModifier + '?', $c8cd609b21904ab0$var$rsOptVar = '[' + $c8cd609b21904ab0$var$rsVarRange + ']?', $c8cd609b21904ab0$var$rsOptJoin = '(?:' + $c8cd609b21904ab0$var$rsZWJ + '(?:' + [
    $c8cd609b21904ab0$var$rsNonAstral,
    $c8cd609b21904ab0$var$rsRegional,
    $c8cd609b21904ab0$var$rsSurrPair
].join('|') + ')' + $c8cd609b21904ab0$var$rsOptVar + $c8cd609b21904ab0$var$reOptMod + ')*', $c8cd609b21904ab0$var$rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', $c8cd609b21904ab0$var$rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', $c8cd609b21904ab0$var$rsSeq = $c8cd609b21904ab0$var$rsOptVar + $c8cd609b21904ab0$var$reOptMod + $c8cd609b21904ab0$var$rsOptJoin, $c8cd609b21904ab0$var$rsEmoji = '(?:' + [
    $c8cd609b21904ab0$var$rsDingbat,
    $c8cd609b21904ab0$var$rsRegional,
    $c8cd609b21904ab0$var$rsSurrPair
].join('|') + ')' + $c8cd609b21904ab0$var$rsSeq;
/** Used to match complex or compound words. */ var $c8cd609b21904ab0$var$reUnicodeWord = RegExp([
    $c8cd609b21904ab0$var$rsUpper + '?' + $c8cd609b21904ab0$var$rsLower + '+' + $c8cd609b21904ab0$var$rsOptContrLower + '(?=' + [
        $c8cd609b21904ab0$var$rsBreak,
        $c8cd609b21904ab0$var$rsUpper,
        '$'
    ].join('|') + ')',
    $c8cd609b21904ab0$var$rsMiscUpper + '+' + $c8cd609b21904ab0$var$rsOptContrUpper + '(?=' + [
        $c8cd609b21904ab0$var$rsBreak,
        $c8cd609b21904ab0$var$rsUpper + $c8cd609b21904ab0$var$rsMiscLower,
        '$'
    ].join('|') + ')',
    $c8cd609b21904ab0$var$rsUpper + '?' + $c8cd609b21904ab0$var$rsMiscLower + '+' + $c8cd609b21904ab0$var$rsOptContrLower,
    $c8cd609b21904ab0$var$rsUpper + '+' + $c8cd609b21904ab0$var$rsOptContrUpper,
    $c8cd609b21904ab0$var$rsOrdUpper,
    $c8cd609b21904ab0$var$rsOrdLower,
    $c8cd609b21904ab0$var$rsDigits,
    $c8cd609b21904ab0$var$rsEmoji
].join('|'), 'g');
/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $c8cd609b21904ab0$var$unicodeWords(string) {
    return string.match($c8cd609b21904ab0$var$reUnicodeWord) || [];
}
module.exports = $c8cd609b21904ab0$var$unicodeWords;

});

parcelRegister("jLShN", function(module, exports) {
const $e64c8432c5ffa90e$export$276c7dbda7675aec = ()=>{
// Nothing to cleanup...
};
module.exports["noopCleanup"] = $e64c8432c5ffa90e$export$276c7dbda7675aec;

});


$parcel$global.rlb("c5uOY")
//# sourceMappingURL=simpleHasher.a53327ea.js.map
